var Bo = Object.defineProperty;
var Uo = (h, e, t) => e in h ? Bo(h, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : h[e] = t;
var _e = (h, e, t) => Uo(h, typeof e != "symbol" ? e + "" : e, t);
class w {
  static _CheckLimit(e, t) {
    let i = w._LogLimitOutputs[e];
    return i ? i.current++ : (i = { limit: t, current: 1 }, w._LogLimitOutputs[e] = i), i.current <= i.limit;
  }
  static _GenerateLimitMessage(e, t = 1) {
    var i;
    const s = w._LogLimitOutputs[e];
    if (!s || !w.MessageLimitReached)
      return;
    const r = this._Levels[t];
    s.current === s.limit && w[r.name](w.MessageLimitReached.replace(/%LIMIT%/g, "" + s.limit).replace(/%TYPE%/g, (i = r.name) !== null && i !== void 0 ? i : ""));
  }
  static _AddLogEntry(e) {
    w._LogCache = e + w._LogCache, w.OnNewCacheEntry && w.OnNewCacheEntry(e);
  }
  static _FormatMessage(e) {
    const t = (s) => s < 10 ? "0" + s : "" + s, i = /* @__PURE__ */ new Date();
    return "[" + t(i.getHours()) + ":" + t(i.getMinutes()) + ":" + t(i.getSeconds()) + "]: " + e;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static _LogDisabled(e, t) {
  }
  static _LogEnabled(e = 1, t, i) {
    if (i !== void 0 && !w._CheckLimit(t, i))
      return;
    const s = w._FormatMessage(t), r = this._Levels[e];
    r.logFunc && r.logFunc("BJS - " + s);
    const n = `<div style='color:${r.color}'>${s}</div><br>`;
    w._AddLogEntry(n), w._GenerateLimitMessage(t, e);
  }
  /**
   * Gets current log cache (list of logs)
   */
  static get LogCache() {
    return w._LogCache;
  }
  /**
   * Clears the log cache
   */
  static ClearLogCache() {
    w._LogCache = "", w._LogLimitOutputs = {}, w.errorsCount = 0;
  }
  /**
   * Sets the current log level (MessageLogLevel / WarningLogLevel / ErrorLogLevel)
   */
  static set LogLevels(e) {
    w.Log = w._LogDisabled, w.Warn = w._LogDisabled, w.Error = w._LogDisabled, [w.MessageLogLevel, w.WarningLogLevel, w.ErrorLogLevel].forEach((t) => {
      if ((e & t) === t) {
        const i = this._Levels[t];
        w[i.name] = w._LogEnabled.bind(w, t);
      }
    });
  }
}
w.NoneLogLevel = 0;
w.MessageLogLevel = 1;
w.WarningLogLevel = 2;
w.ErrorLogLevel = 4;
w.AllLogLevel = 7;
w.MessageLimitReached = "Too many %TYPE%s (%LIMIT%), no more %TYPE%s will be reported for this message.";
w._LogCache = "";
w._LogLimitOutputs = {};
w._Levels = [
  {},
  { color: "white", logFunc: console.log, name: "Log" },
  { color: "orange", logFunc: console.warn, name: "Warn" },
  {},
  { color: "red", logFunc: console.error, name: "Error" }
];
w.errorsCount = 0;
w.Log = w._LogEnabled.bind(w, w.MessageLogLevel);
w.Warn = w._LogEnabled.bind(w, w.WarningLogLevel);
w.Error = w._LogEnabled.bind(w, w.ErrorLogLevel);
function E(h, e, t, i) {
  var s = arguments.length, r = s < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, t) : i, n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r = Reflect.decorate(h, e, t, i);
  else for (var a = h.length - 1; a >= 0; a--) (n = h[a]) && (r = (s < 3 ? n(r) : s > 3 ? n(e, t, r) : n(e, t)) || r);
  return s > 3 && r && Object.defineProperty(e, t, r), r;
}
class Gi {
  /**
   * Evaluate a query
   * @param query defines the query to evaluate
   * @param evaluateCallback defines the callback used to filter result
   * @returns true if the query matches
   */
  static Eval(e, t) {
    return e.match(/\([^()]*\)/g) ? e = e.replace(/\([^()]*\)/g, (i) => (i = i.slice(1, i.length - 1), Gi._HandleParenthesisContent(i, t))) : e = Gi._HandleParenthesisContent(e, t), e === "true" ? !0 : e === "false" ? !1 : Gi.Eval(e, t);
  }
  static _HandleParenthesisContent(e, t) {
    t = t || ((r) => r === "true");
    let i;
    const s = e.split("||");
    for (const r in s)
      if (Object.prototype.hasOwnProperty.call(s, r)) {
        let n = Gi._SimplifyNegation(s[r].trim());
        const a = n.split("&&");
        if (a.length > 1)
          for (let o = 0; o < a.length; ++o) {
            const l = Gi._SimplifyNegation(a[o].trim());
            if (l !== "true" && l !== "false" ? l[0] === "!" ? i = !t(l.substring(1)) : i = t(l) : i = l === "true", !i) {
              n = "false";
              break;
            }
          }
        if (i || n === "true") {
          i = !0;
          break;
        }
        n !== "true" && n !== "false" ? n[0] === "!" ? i = !t(n.substring(1)) : i = t(n) : i = n === "true";
      }
    return i ? "true" : "false";
  }
  static _SimplifyNegation(e) {
    return e = e.replace(/^[\s!]+/, (t) => (t = t.replace(/[\s]/g, () => ""), t.length % 2 ? "!" : "")), e = e.trim(), e === "!true" ? e = "false" : e === "!false" && (e = "true"), e;
  }
}
class Ee {
  /**
   * Adds support for tags on the given object
   * @param obj defines the object to use
   */
  static EnableFor(e) {
    e._tags = e._tags || {}, e.hasTags = () => Ee.HasTags(e), e.addTags = (t) => Ee.AddTagsTo(e, t), e.removeTags = (t) => Ee.RemoveTagsFrom(e, t), e.matchesTagsQuery = (t) => Ee.MatchesQuery(e, t);
  }
  /**
   * Removes tags support
   * @param obj defines the object to use
   */
  static DisableFor(e) {
    delete e._tags, delete e.hasTags, delete e.addTags, delete e.removeTags, delete e.matchesTagsQuery;
  }
  /**
   * Gets a boolean indicating if the given object has tags
   * @param obj defines the object to use
   * @returns a boolean
   */
  static HasTags(e) {
    if (!e._tags)
      return !1;
    const t = e._tags;
    for (const i in t)
      if (Object.prototype.hasOwnProperty.call(t, i))
        return !0;
    return !1;
  }
  /**
   * Gets the tags available on a given object
   * @param obj defines the object to use
   * @param asString defines if the tags must be returned as a string instead of an array of strings
   * @returns the tags
   */
  static GetTags(e, t = !0) {
    if (!e._tags)
      return null;
    if (t) {
      const i = [];
      for (const s in e._tags)
        Object.prototype.hasOwnProperty.call(e._tags, s) && e._tags[s] === !0 && i.push(s);
      return i.join(" ");
    } else
      return e._tags;
  }
  /**
   * Adds tags to an object
   * @param obj defines the object to use
   * @param tagsString defines the tag string. The tags 'true' and 'false' are reserved and cannot be used as tags.
   * A tag cannot start with '||', '&&', and '!'. It cannot contain whitespaces
   */
  static AddTagsTo(e, t) {
    if (!t || typeof t != "string")
      return;
    t.split(" ").forEach(function(s) {
      Ee._AddTagTo(e, s);
    });
  }
  /**
   * @internal
   */
  static _AddTagTo(e, t) {
    t = t.trim(), !(t === "" || t === "true" || t === "false") && (t.match(/[\s]/) || t.match(/^([!]|([|]|[&]){2})/) || (Ee.EnableFor(e), e._tags[t] = !0));
  }
  /**
   * Removes specific tags from a specific object
   * @param obj defines the object to use
   * @param tagsString defines the tags to remove
   */
  static RemoveTagsFrom(e, t) {
    if (!Ee.HasTags(e))
      return;
    const i = t.split(" ");
    for (const s in i)
      Ee._RemoveTagFrom(e, i[s]);
  }
  /**
   * @internal
   */
  static _RemoveTagFrom(e, t) {
    delete e._tags[t];
  }
  /**
   * Defines if tags hosted on an object match a given query
   * @param obj defines the object to use
   * @param tagsQuery defines the tag query
   * @returns a boolean
   */
  static MatchesQuery(e, t) {
    return t === void 0 ? !0 : t === "" ? Ee.HasTags(e) : Gi.Eval(t, (i) => Ee.HasTags(e) && e._tags[i]);
  }
}
class J {
  /**
   * Boolean : true if the absolute difference between a and b is lower than epsilon (default = 1.401298E-45)
   * @param a number
   * @param b number
   * @param epsilon (default = 1.401298E-45)
   * @returns true if the absolute difference between a and b is lower than epsilon (default = 1.401298E-45)
   */
  static WithinEpsilon(e, t, i = 1401298e-51) {
    return Math.abs(e - t) <= i;
  }
  /**
   * Returns a string : the upper case translation of the number i to hexadecimal.
   * @param i number
   * @returns the upper case translation of the number i to hexadecimal.
   */
  static ToHex(e) {
    const t = e.toString(16);
    return e <= 15 ? ("0" + t).toUpperCase() : t.toUpperCase();
  }
  /**
   * Returns -1 if value is negative and +1 is value is positive.
   * @param value the value
   * @returns the value itself if it's equal to zero.
   */
  static Sign(e) {
    return e = +e, e === 0 || isNaN(e) ? e : e > 0 ? 1 : -1;
  }
  /**
   * Returns the value itself if it's between min and max.
   * Returns min if the value is lower than min.
   * Returns max if the value is greater than max.
   * @param value the value to clmap
   * @param min the min value to clamp to (default: 0)
   * @param max the max value to clamp to (default: 1)
   * @returns the clamped value
   */
  static Clamp(e, t = 0, i = 1) {
    return Math.min(i, Math.max(t, e));
  }
  /**
   * the log2 of value.
   * @param value the value to compute log2 of
   * @returns the log2 of value.
   */
  static Log2(e) {
    return Math.log(e) * Math.LOG2E;
  }
  /**
   * the floor part of a log2 value.
   * @param value the value to compute log2 of
   * @returns the log2 of value.
   */
  static ILog2(e) {
    if (Math.log2)
      return Math.floor(Math.log2(e));
    if (e < 0)
      return NaN;
    if (e === 0)
      return -1 / 0;
    let t = 0;
    if (e < 1) {
      for (; e < 1; )
        t++, e = e * 2;
      t = -t;
    } else if (e > 1)
      for (; e > 1; )
        t++, e = Math.floor(e / 2);
    return t;
  }
  /**
   * Loops the value, so that it is never larger than length and never smaller than 0.
   *
   * This is similar to the modulo operator but it works with floating point numbers.
   * For example, using 3.0 for t and 2.5 for length, the result would be 0.5.
   * With t = 5 and length = 2.5, the result would be 0.0.
   * Note, however, that the behaviour is not defined for negative numbers as it is for the modulo operator
   * @param value the value
   * @param length the length
   * @returns the looped value
   */
  static Repeat(e, t) {
    return e - Math.floor(e / t) * t;
  }
  /**
   * Normalize the value between 0.0 and 1.0 using min and max values
   * @param value value to normalize
   * @param min max to normalize between
   * @param max min to normalize between
   * @returns the normalized value
   */
  static Normalize(e, t, i) {
    return (e - t) / (i - t);
  }
  /**
   * Denormalize the value from 0.0 and 1.0 using min and max values
   * @param normalized value to denormalize
   * @param min max to denormalize between
   * @param max min to denormalize between
   * @returns the denormalized value
   */
  static Denormalize(e, t, i) {
    return e * (i - t) + t;
  }
  /**
   * Calculates the shortest difference between two given angles given in degrees.
   * @param current current angle in degrees
   * @param target target angle in degrees
   * @returns the delta
   */
  static DeltaAngle(e, t) {
    let i = J.Repeat(t - e, 360);
    return i > 180 && (i -= 360), i;
  }
  /**
   * PingPongs the value t, so that it is never larger than length and never smaller than 0.
   * @param tx value
   * @param length length
   * @returns The returned value will move back and forth between 0 and length
   */
  static PingPong(e, t) {
    const i = J.Repeat(e, t * 2);
    return t - Math.abs(i - t);
  }
  /**
   * Interpolates between min and max with smoothing at the limits.
   *
   * This function interpolates between min and max in a similar way to Lerp. However, the interpolation will gradually speed up
   * from the start and slow down toward the end. This is useful for creating natural-looking animation, fading and other transitions.
   * @param from from
   * @param to to
   * @param tx value
   * @returns the smooth stepped value
   */
  static SmoothStep(e, t, i) {
    let s = J.Clamp(i);
    return s = -2 * s * s * s + 3 * s * s, t * s + e * (1 - s);
  }
  /**
   * Moves a value current towards target.
   *
   * This is essentially the same as Mathf.Lerp but instead the function will ensure that the speed never exceeds maxDelta.
   * Negative values of maxDelta pushes the value away from target.
   * @param current current value
   * @param target target value
   * @param maxDelta max distance to move
   * @returns resulting value
   */
  static MoveTowards(e, t, i) {
    let s = 0;
    return Math.abs(t - e) <= i ? s = t : s = e + J.Sign(t - e) * i, s;
  }
  /**
   * Same as MoveTowards but makes sure the values interpolate correctly when they wrap around 360 degrees.
   *
   * Variables current and target are assumed to be in degrees. For optimization reasons, negative values of maxDelta
   *  are not supported and may cause oscillation. To push current away from a target angle, add 180 to that angle instead.
   * @param current current value
   * @param target target value
   * @param maxDelta max distance to move
   * @returns resulting angle
   */
  static MoveTowardsAngle(e, t, i) {
    const s = J.DeltaAngle(e, t);
    let r = 0;
    return -i < s && s < i ? r = t : (t = e + s, r = J.MoveTowards(e, t, i)), r;
  }
  /**
   * Creates a new scalar with values linearly interpolated of "amount" between the start scalar and the end scalar.
   * @param start start value
   * @param end target value
   * @param amount amount to lerp between
   * @returns the lerped value
   */
  static Lerp(e, t, i) {
    return e + (t - e) * i;
  }
  /**
   * Same as Lerp but makes sure the values interpolate correctly when they wrap around 360 degrees.
   * The parameter t is clamped to the range [0, 1]. Variables a and b are assumed to be in degrees.
   * @param start start value
   * @param end target value
   * @param amount amount to lerp between
   * @returns the lerped value
   */
  static LerpAngle(e, t, i) {
    let s = J.Repeat(t - e, 360);
    return s > 180 && (s -= 360), e + s * J.Clamp(i);
  }
  /**
   * Calculates the linear parameter t that produces the interpolant value within the range [a, b].
   * @param a start value
   * @param b target value
   * @param value value between a and b
   * @returns the inverseLerp value
   */
  static InverseLerp(e, t, i) {
    let s = 0;
    return e != t ? s = J.Clamp((i - e) / (t - e)) : s = 0, s;
  }
  /**
   * Returns a new scalar located for "amount" (float) on the Hermite spline defined by the scalars "value1", "value3", "tangent1", "tangent2".
   * @see http://mathworld.wolfram.com/HermitePolynomial.html
   * @param value1 defines the first control point
   * @param tangent1 defines the first tangent
   * @param value2 defines the second control point
   * @param tangent2 defines the second tangent
   * @param amount defines the amount on the interpolation spline (between 0 and 1)
   * @returns hermite result
   */
  static Hermite(e, t, i, s, r) {
    const n = r * r, a = r * n, o = 2 * a - 3 * n + 1, l = -2 * a + 3 * n, c = a - 2 * n + r, u = a - n;
    return e * o + i * l + t * c + s * u;
  }
  /**
   * Returns a new scalar which is the 1st derivative of the Hermite spline defined by the scalars "value1", "value2", "tangent1", "tangent2".
   * @param value1 defines the first control point
   * @param tangent1 defines the first tangent
   * @param value2 defines the second control point
   * @param tangent2 defines the second tangent
   * @param time define where the derivative must be done
   * @returns 1st derivative
   */
  static Hermite1stDerivative(e, t, i, s, r) {
    const n = r * r;
    return (n - r) * 6 * e + (3 * n - 4 * r + 1) * t + (-n + r) * 6 * i + (3 * n - 2 * r) * s;
  }
  /**
   * Returns a random float number between and min and max values
   * @param min min value of random
   * @param max max value of random
   * @returns random value
   */
  static RandomRange(e, t) {
    return e === t ? e : Math.random() * (t - e) + e;
  }
  /**
   * This function returns percentage of a number in a given range.
   *
   * RangeToPercent(40,20,60) will return 0.5 (50%)
   * RangeToPercent(34,0,100) will return 0.34 (34%)
   * @param number to convert to percentage
   * @param min min range
   * @param max max range
   * @returns the percentage
   */
  static RangeToPercent(e, t, i) {
    return (e - t) / (i - t);
  }
  /**
   * This function returns number that corresponds to the percentage in a given range.
   *
   * PercentToRange(0.34,0,100) will return 34.
   * @param percent to convert to number
   * @param min min range
   * @param max max range
   * @returns the number
   */
  static PercentToRange(e, t, i) {
    return (i - t) * e + t;
  }
  /**
   * Returns the angle converted to equivalent value between -Math.PI and Math.PI radians.
   * @param angle The angle to normalize in radian.
   * @returns The converted angle.
   */
  static NormalizeRadians(e) {
    return e -= J.TwoPi * Math.floor((e + Math.PI) / J.TwoPi), e;
  }
  /**
   * Returns the highest common factor of two integers.
   * @param a first parameter
   * @param b second parameter
   * @returns HCF of a and b
   */
  static HCF(e, t) {
    const i = e % t;
    return i === 0 ? t : J.HCF(t, i);
  }
}
J.TwoPi = Math.PI * 2;
const ur = 1 / 2.2, dr = 2.2, pe = 1e-3;
class ot {
  /**
   * Returns an array of the given size filled with elements built from the given constructor and the parameters.
   * @param size the number of element to construct and put in the array.
   * @param itemBuilder a callback responsible for creating new instance of item. Called once per array entry.
   * @returns a new array filled with new objects.
   */
  static BuildArray(e, t) {
    const i = [];
    for (let s = 0; s < e; ++s)
      i.push(t());
    return i;
  }
  /**
   * Returns a tuple of the given size filled with elements built from the given constructor and the parameters.
   * @param size he number of element to construct and put in the tuple.
   * @param itemBuilder a callback responsible for creating new instance of item. Called once per tuple entry.
   * @returns a new tuple filled with new objects.
   */
  static BuildTuple(e, t) {
    return ot.BuildArray(e, t);
  }
}
function ko(h, e, t) {
  const i = h[e];
  if (typeof i != "function")
    return null;
  const s = function() {
    const r = h.length, n = s.previous.apply(h, arguments);
    return t(e, r), n;
  };
  return i.next = s, s.previous = i, h[e] = s, () => {
    const r = s.previous;
    if (!r)
      return;
    const n = s.next;
    n ? (r.next = n, n.previous = r) : (r.next = void 0, h[e] = r), s.next = void 0, s.previous = void 0;
  };
}
const Vo = ["push", "splice", "pop", "shift", "unshift"];
function Ra(h, e) {
  const t = Vo.map((i) => ko(h, i, e));
  return () => {
    t.forEach((i) => {
      i == null || i();
    });
  };
}
const Ia = {};
function Xe(h, e) {
  Ia[h] = e;
}
function si(h) {
  return Ia[h];
}
class ht {
  /**
   * @internal
   */
  static SetMatrixPrecision(e) {
    if (ht.MatrixTrackPrecisionChange = !1, e && !ht.MatrixUse64Bits && ht.MatrixTrackedMatrices)
      for (let t = 0; t < ht.MatrixTrackedMatrices.length; ++t) {
        const i = ht.MatrixTrackedMatrices[t], s = i._m;
        i._m = new Array(16);
        for (let r = 0; r < 16; ++r)
          i._m[r] = s[r];
      }
    ht.MatrixUse64Bits = e, ht.MatrixCurrentType = ht.MatrixUse64Bits ? Array : Float32Array, ht.MatrixTrackedMatrices = null;
  }
}
ht.MatrixUse64Bits = !1;
ht.MatrixTrackPrecisionChange = !0;
ht.MatrixCurrentType = Float32Array;
ht.MatrixTrackedMatrices = [];
class Wo {
  /**
   * Create a new EventState
   * @param mask defines the mask associated with this state
   * @param skipNextObservers defines a flag which will instruct the observable to skip following observers when set to true
   * @param target defines the original target of the state
   * @param currentTarget defines the current target of the state
   */
  constructor(e, t = !1, i, s) {
    this.initialize(e, t, i, s);
  }
  /**
   * Initialize the current event state
   * @param mask defines the mask associated with this state
   * @param skipNextObservers defines a flag which will instruct the observable to skip following observers when set to true
   * @param target defines the original target of the state
   * @param currentTarget defines the current target of the state
   * @returns the current event state
   */
  initialize(e, t = !1, i, s) {
    return this.mask = e, this.skipNextObservers = t, this.target = i, this.currentTarget = s, this;
  }
}
class zo {
  /**
   * Creates a new observer
   * @param callback defines the callback to call when the observer is notified
   * @param mask defines the mask of the observer (used to filter notifications)
   * @param scope defines the current scope used to restore the JS context
   */
  constructor(e, t, i = null) {
    this.callback = e, this.mask = t, this.scope = i, this._willBeUnregistered = !1, this.unregisterOnNextCall = !1, this._remove = null;
  }
  /**
   * Remove the observer from its observable
   * This can be used instead of using the observable's remove function.
   */
  remove() {
    this._remove && this._remove();
  }
}
class N {
  /**
   * Create an observable from a Promise.
   * @param promise a promise to observe for fulfillment.
   * @param onErrorObservable an observable to notify if a promise was rejected.
   * @returns the new Observable
   */
  static FromPromise(e, t) {
    const i = new N();
    return e.then((s) => {
      i.notifyObservers(s);
    }).catch((s) => {
      if (t)
        t.notifyObservers(s);
      else
        throw s;
    }), i;
  }
  /**
   * Gets the list of observers
   * Note that observers that were recently deleted may still be present in the list because they are only really deleted on the next javascript tick!
   */
  get observers() {
    return this._observers;
  }
  /**
   * Creates a new observable
   * @param onObserverAdded defines a callback to call when a new observer is added
   * @param notifyIfTriggered If set to true the observable will notify when an observer was added if the observable was already triggered.
   */
  constructor(e, t = !1) {
    this.notifyIfTriggered = t, this._observers = new Array(), this._numObserversMarkedAsDeleted = 0, this._hasNotified = !1, this._eventState = new Wo(0), e && (this._onObserverAdded = e);
  }
  /**
   * Create a new Observer with the specified callback
   * @param callback the callback that will be executed for that Observer
   * @param mask the mask used to filter observers
   * @param insertFirst if true the callback will be inserted at the first position, hence executed before the others ones. If false (default behavior) the callback will be inserted at the last position, executed after all the others already present.
   * @param scope optional scope for the callback to be called from
   * @param unregisterOnFirstCall defines if the observer as to be unregistered after the next notification
   * @returns the new observer created for the callback
   */
  add(e, t = -1, i = !1, s = null, r = !1) {
    if (!e)
      return null;
    const n = new zo(e, t, s);
    return n.unregisterOnNextCall = r, i ? this._observers.unshift(n) : this._observers.push(n), this._onObserverAdded && this._onObserverAdded(n), this._hasNotified && this.notifyIfTriggered && this._lastNotifiedValue !== void 0 && this.notifyObserver(n, this._lastNotifiedValue), n._remove = () => {
      this.remove(n);
    }, n;
  }
  /**
   * Create a new Observer with the specified callback and unregisters after the next notification
   * @param callback the callback that will be executed for that Observer
   * @returns the new observer created for the callback
   */
  addOnce(e) {
    return this.add(e, void 0, void 0, void 0, !0);
  }
  /**
   * Remove an Observer from the Observable object
   * @param observer the instance of the Observer to remove
   * @returns false if it doesn't belong to this Observable
   */
  remove(e) {
    return e ? (e._remove = null, this._observers.indexOf(e) !== -1 ? (this._deferUnregister(e), !0) : !1) : !1;
  }
  /**
   * Remove a callback from the Observable object
   * @param callback the callback to remove
   * @param scope optional scope. If used only the callbacks with this scope will be removed
   * @returns false if it doesn't belong to this Observable
   */
  removeCallback(e, t) {
    for (let i = 0; i < this._observers.length; i++) {
      const s = this._observers[i];
      if (!s._willBeUnregistered && s.callback === e && (!t || t === s.scope))
        return this._deferUnregister(s), !0;
    }
    return !1;
  }
  /**
   * @internal
   */
  _deferUnregister(e) {
    e._willBeUnregistered || (this._numObserversMarkedAsDeleted++, e.unregisterOnNextCall = !1, e._willBeUnregistered = !0, setTimeout(() => {
      this._remove(e);
    }, 0));
  }
  // This should only be called when not iterating over _observers to avoid callback skipping.
  // Removes an observer from the _observer Array.
  _remove(e, t = !0) {
    if (!e)
      return !1;
    const i = this._observers.indexOf(e);
    return i !== -1 ? (t && this._numObserversMarkedAsDeleted--, this._observers.splice(i, 1), !0) : !1;
  }
  /**
   * Moves the observable to the top of the observer list making it get called first when notified
   * @param observer the observer to move
   */
  makeObserverTopPriority(e) {
    this._remove(e, !1), this._observers.unshift(e);
  }
  /**
   * Moves the observable to the bottom of the observer list making it get called last when notified
   * @param observer the observer to move
   */
  makeObserverBottomPriority(e) {
    this._remove(e, !1), this._observers.push(e);
  }
  /**
   * Notify all Observers by calling their respective callback with the given data
   * Will return true if all observers were executed, false if an observer set skipNextObservers to true, then prevent the subsequent ones to execute
   * @param eventData defines the data to send to all observers
   * @param mask defines the mask of the current notification (observers with incompatible mask (ie mask & observer.mask === 0) will not be notified)
   * @param target defines the original target of the state
   * @param currentTarget defines the current target of the state
   * @param userInfo defines any user info to send to observers
   * @returns false if the complete observer chain was not processed (because one observer set the skipNextObservers to true)
   */
  notifyObservers(e, t = -1, i, s, r) {
    if (this.notifyIfTriggered && (this._hasNotified = !0, this._lastNotifiedValue = e), !this._observers.length)
      return !0;
    const n = this._eventState;
    n.mask = t, n.target = i, n.currentTarget = s, n.skipNextObservers = !1, n.lastReturnValue = e, n.userInfo = r;
    for (const a of this._observers)
      if (!a._willBeUnregistered && (a.mask & t && (a.unregisterOnNextCall && this._deferUnregister(a), a.scope ? n.lastReturnValue = a.callback.apply(a.scope, [e, n]) : n.lastReturnValue = a.callback(e, n)), n.skipNextObservers))
        return !1;
    return !0;
  }
  /**
   * Notify a specific observer
   * @param observer defines the observer to notify
   * @param eventData defines the data to be sent to each callback
   * @param mask is used to filter observers defaults to -1
   */
  notifyObserver(e, t, i = -1) {
    if (this.notifyIfTriggered && (this._hasNotified = !0, this._lastNotifiedValue = t), e._willBeUnregistered)
      return;
    const s = this._eventState;
    s.mask = i, s.skipNextObservers = !1, e.unregisterOnNextCall && this._deferUnregister(e), e.callback(t, s);
  }
  /**
   * Gets a boolean indicating if the observable has at least one observer
   * @returns true is the Observable has at least one Observer registered
   */
  hasObservers() {
    return this._observers.length - this._numObserversMarkedAsDeleted > 0;
  }
  /**
   * Clear the list of observers
   */
  clear() {
    for (; this._observers.length; ) {
      const e = this._observers.pop();
      e && (e._remove = null);
    }
    this._onObserverAdded = null, this._numObserversMarkedAsDeleted = 0, this.cleanLastNotifiedState();
  }
  /**
   * Clean the last notified state - both the internal last value and the has-notified flag
   */
  cleanLastNotifiedState() {
    this._hasNotified = !1, this._lastNotifiedValue = void 0;
  }
  /**
   * Clone the current observable
   * @returns a new observable
   */
  clone() {
    const e = new N();
    return e._observers = this._observers.slice(0), e;
  }
  /**
   * Does this observable handles observer registered with a given mask
   * @param mask defines the mask to be tested
   * @returns whether or not one observer registered with the given mask is handled
   **/
  hasSpecificMask(e = -1) {
    for (const t of this._observers)
      if (t.mask & e || t.mask === e)
        return !0;
    return !1;
  }
}
class de {
  /**
   * Gets the latest created engine
   */
  static get LastCreatedEngine() {
    return this.Instances.length === 0 ? null : this.Instances[this.Instances.length - 1];
  }
  /**
   * Gets the latest created scene
   */
  static get LastCreatedScene() {
    return this._LastCreatedScene;
  }
}
de.Instances = new Array();
de.OnEnginesDisposedObservable = new N();
de._LastCreatedScene = null;
de.UseFallbackTexture = !0;
de.FallbackTexture = "";
const Bt = (h) => parseInt(h.toString().replace(/\W/g, ""));
class ue {
  /**
   * Creates a new Vector2 from the given x and y coordinates
   * @param x defines the first coordinate
   * @param y defines the second coordinate
   */
  constructor(e = 0, t = 0) {
    this.x = e, this.y = t;
  }
  /**
   * Gets a string with the Vector2 coordinates
   * @returns a string with the Vector2 coordinates
   */
  toString() {
    return `{X: ${this.x} Y: ${this.y}}`;
  }
  /**
   * Gets class name
   * @returns the string "Vector2"
   */
  getClassName() {
    return "Vector2";
  }
  /**
   * Gets current vector hash code
   * @returns the Vector2 hash code as a number
   */
  getHashCode() {
    const e = Bt(this.x), t = Bt(this.y);
    let i = e;
    return i = i * 397 ^ t, i;
  }
  // Operators
  /**
   * Sets the Vector2 coordinates in the given array or Float32Array from the given index.
   * Example Playground https://playground.babylonjs.com/#QYBWV4#15
   * @param array defines the source array
   * @param index defines the offset in source array
   * @returns the current Vector2
   */
  toArray(e, t = 0) {
    return e[t] = this.x, e[t + 1] = this.y, this;
  }
  /**
   * Update the current vector from an array
   * Example Playground https://playground.babylonjs.com/#QYBWV4#39
   * @param array defines the destination array
   * @param index defines the offset in the destination array
   * @returns the current Vector2
   */
  fromArray(e, t = 0) {
    return ue.FromArrayToRef(e, t, this), this;
  }
  /**
   * Copy the current vector to an array
   * Example Playground https://playground.babylonjs.com/#QYBWV4#40
   * @returns a new array with 2 elements: the Vector2 coordinates.
   */
  asArray() {
    const e = new Array();
    return this.toArray(e, 0), e;
  }
  /**
   * Sets the Vector2 coordinates with the given Vector2 coordinates
   * Example Playground https://playground.babylonjs.com/#QYBWV4#24
   * @param source defines the source Vector2
   * @returns the current updated Vector2
   */
  copyFrom(e) {
    return this.x = e.x, this.y = e.y, this;
  }
  /**
   * Sets the Vector2 coordinates with the given floats
   * Example Playground https://playground.babylonjs.com/#QYBWV4#25
   * @param x defines the first coordinate
   * @param y defines the second coordinate
   * @returns the current updated Vector2
   */
  copyFromFloats(e, t) {
    return this.x = e, this.y = t, this;
  }
  /**
   * Sets the Vector2 coordinates with the given floats
   * Example Playground https://playground.babylonjs.com/#QYBWV4#62
   * @param x defines the first coordinate
   * @param y defines the second coordinate
   * @returns the current updated Vector2
   */
  set(e, t) {
    return this.copyFromFloats(e, t);
  }
  /**
   * Add another vector with the current one
   * Example Playground https://playground.babylonjs.com/#QYBWV4#11
   * @param otherVector defines the other vector
   * @returns a new Vector2 set with the addition of the current Vector2 and the given one coordinates
   */
  add(e) {
    return new this.constructor(this.x + e.x, this.y + e.y);
  }
  /**
   * Sets the "result" coordinates with the addition of the current Vector2 and the given one coordinates
   * Example Playground https://playground.babylonjs.com/#QYBWV4#12
   * @param otherVector defines the other vector
   * @param result defines the target vector
   * @returns result input
   */
  addToRef(e, t) {
    return t.x = this.x + e.x, t.y = this.y + e.y, t;
  }
  /**
   * Set the Vector2 coordinates by adding the given Vector2 coordinates
   * Example Playground https://playground.babylonjs.com/#QYBWV4#13
   * @param otherVector defines the other vector
   * @returns the current updated Vector2
   */
  addInPlace(e) {
    return this.x += e.x, this.y += e.y, this;
  }
  /**
   * Gets a new Vector2 by adding the current Vector2 coordinates to the given Vector3 x, y coordinates
   * Example Playground https://playground.babylonjs.com/#QYBWV4#14
   * @param otherVector defines the other vector
   * @returns a new Vector2
   */
  addVector3(e) {
    return new this.constructor(this.x + e.x, this.y + e.y);
  }
  /**
   * Gets a new Vector2 set with the subtracted coordinates of the given one from the current Vector2
   * Example Playground https://playground.babylonjs.com/#QYBWV4#61
   * @param otherVector defines the other vector
   * @returns a new Vector2
   */
  subtract(e) {
    return new this.constructor(this.x - e.x, this.y - e.y);
  }
  /**
   * Sets the "result" coordinates with the subtraction of the given one from the current Vector2 coordinates.
   * Example Playground https://playground.babylonjs.com/#QYBWV4#63
   * @param otherVector defines the other vector
   * @param result defines the target vector
   * @returns result input
   */
  subtractToRef(e, t) {
    return t.x = this.x - e.x, t.y = this.y - e.y, t;
  }
  /**
   * Sets the current Vector2 coordinates by subtracting from it the given one coordinates
   * Example Playground https://playground.babylonjs.com/#QYBWV4#88
   * @param otherVector defines the other vector
   * @returns the current updated Vector2
   */
  subtractInPlace(e) {
    return this.x -= e.x, this.y -= e.y, this;
  }
  /**
   * Multiplies in place the current Vector2 coordinates by the given ones
   * Example Playground https://playground.babylonjs.com/#QYBWV4#43
   * @param otherVector defines the other vector
   * @returns the current updated Vector2
   */
  multiplyInPlace(e) {
    return this.x *= e.x, this.y *= e.y, this;
  }
  /**
   * Returns a new Vector2 set with the multiplication of the current Vector2 and the given one coordinates
   * Example Playground https://playground.babylonjs.com/#QYBWV4#42
   * @param otherVector defines the other vector
   * @returns a new Vector2
   */
  multiply(e) {
    return new this.constructor(this.x * e.x, this.y * e.y);
  }
  /**
   * Sets "result" coordinates with the multiplication of the current Vector2 and the given one coordinates
   * Example Playground https://playground.babylonjs.com/#QYBWV4#44
   * @param otherVector defines the other vector
   * @param result defines the target vector
   * @returns result input
   */
  multiplyToRef(e, t) {
    return t.x = this.x * e.x, t.y = this.y * e.y, t;
  }
  /**
   * Gets a new Vector2 set with the Vector2 coordinates multiplied by the given floats
   * Example Playground https://playground.babylonjs.com/#QYBWV4#89
   * @param x defines the first coordinate
   * @param y defines the second coordinate
   * @returns a new Vector2
   */
  multiplyByFloats(e, t) {
    return new this.constructor(this.x * e, this.y * t);
  }
  /**
   * Returns a new Vector2 set with the Vector2 coordinates divided by the given one coordinates
   * Example Playground https://playground.babylonjs.com/#QYBWV4#27
   * @param otherVector defines the other vector
   * @returns a new Vector2
   */
  divide(e) {
    return new this.constructor(this.x / e.x, this.y / e.y);
  }
  /**
   * Sets the "result" coordinates with the Vector2 divided by the given one coordinates
   * Example Playground https://playground.babylonjs.com/#QYBWV4#30
   * @param otherVector defines the other vector
   * @param result defines the target vector
   * @returns result input
   */
  divideToRef(e, t) {
    return t.x = this.x / e.x, t.y = this.y / e.y, t;
  }
  /**
   * Divides the current Vector2 coordinates by the given ones
   * Example Playground https://playground.babylonjs.com/#QYBWV4#28
   * @param otherVector defines the other vector
   * @returns the current updated Vector2
   */
  divideInPlace(e) {
    return this.divideToRef(e, this);
  }
  /**
   * Gets a new Vector2 with current Vector2 negated coordinates
   * Example Playground https://playground.babylonjs.com/#QYBWV4#22
   * @returns a new Vector2
   */
  negate() {
    return new this.constructor(-this.x, -this.y);
  }
  /**
   * Negate this vector in place
   * Example Playground https://playground.babylonjs.com/#QYBWV4#23
   * @returns this
   */
  negateInPlace() {
    return this.x *= -1, this.y *= -1, this;
  }
  /**
   * Negate the current Vector2 and stores the result in the given vector "result" coordinates
   * Example Playground https://playground.babylonjs.com/#QYBWV4#41
   * @param result defines the Vector3 object where to store the result
   * @returns the result
   */
  negateToRef(e) {
    return e.copyFromFloats(this.x * -1, this.y * -1);
  }
  /**
   * Multiply the Vector2 coordinates by
   * Example Playground https://playground.babylonjs.com/#QYBWV4#59
   * @param scale defines the scaling factor
   * @returns the current updated Vector2
   */
  scaleInPlace(e) {
    return this.x *= e, this.y *= e, this;
  }
  /**
   * Returns a new Vector2 scaled by "scale" from the current Vector2
   * Example Playground https://playground.babylonjs.com/#QYBWV4#52
   * @param scale defines the scaling factor
   * @returns a new Vector2
   */
  scale(e) {
    const t = new this.constructor(0, 0);
    return this.scaleToRef(e, t), t;
  }
  /**
   * Scale the current Vector2 values by a factor to a given Vector2
   * Example Playground https://playground.babylonjs.com/#QYBWV4#57
   * @param scale defines the scale factor
   * @param result defines the Vector2 object where to store the result
   * @returns result input
   */
  scaleToRef(e, t) {
    return t.x = this.x * e, t.y = this.y * e, t;
  }
  /**
   * Scale the current Vector2 values by a factor and add the result to a given Vector2
   * Example Playground https://playground.babylonjs.com/#QYBWV4#58
   * @param scale defines the scale factor
   * @param result defines the Vector2 object where to store the result
   * @returns result input
   */
  scaleAndAddToRef(e, t) {
    return t.x += this.x * e, t.y += this.y * e, t;
  }
  /**
   * Gets a boolean if two vectors are equals
   * Example Playground https://playground.babylonjs.com/#QYBWV4#31
   * @param otherVector defines the other vector
   * @returns true if the given vector coordinates strictly equal the current Vector2 ones
   */
  equals(e) {
    return e && this.x === e.x && this.y === e.y;
  }
  /**
   * Gets a boolean if two vectors are equals (using an epsilon value)
   * Example Playground https://playground.babylonjs.com/#QYBWV4#32
   * @param otherVector defines the other vector
   * @param epsilon defines the minimal distance to consider equality
   * @returns true if the given vector coordinates are close to the current ones by a distance of epsilon.
   */
  equalsWithEpsilon(e, t = pe) {
    return e && J.WithinEpsilon(this.x, e.x, t) && J.WithinEpsilon(this.y, e.y, t);
  }
  /**
   * Gets a new Vector2 from current Vector2 floored values
   * Example Playground https://playground.babylonjs.com/#QYBWV4#35
   * eg (1.2, 2.31) returns (1, 2)
   * @returns a new Vector2
   */
  floor() {
    return new this.constructor(Math.floor(this.x), Math.floor(this.y));
  }
  /**
   * Gets a new Vector2 from current Vector2 fractional values
   * Example Playground https://playground.babylonjs.com/#QYBWV4#34
   * eg (1.2, 2.31) returns (0.2, 0.31)
   * @returns a new Vector2
   */
  fract() {
    return new this.constructor(this.x - Math.floor(this.x), this.y - Math.floor(this.y));
  }
  /**
   * Rotate the current vector into a given result vector
   * Example Playground https://playground.babylonjs.com/#QYBWV4#49
   * @param angle defines the rotation angle
   * @param result defines the result vector where to store the rotated vector
   * @returns result input
   */
  rotateToRef(e, t) {
    const i = Math.cos(e), s = Math.sin(e), r = i * this.x - s * this.y, n = s * this.x + i * this.y;
    return t.x = r, t.y = n, t;
  }
  // Properties
  /**
   * Gets the length of the vector
   * @returns the vector length (float)
   */
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }
  /**
   * Gets the vector squared length
   * @returns the vector squared length (float)
   */
  lengthSquared() {
    return this.x * this.x + this.y * this.y;
  }
  // Methods
  /**
   * Normalize the vector
   * Example Playground https://playground.babylonjs.com/#QYBWV4#48
   * @returns the current updated Vector2
   */
  normalize() {
    return ue.NormalizeToRef(this, this), this;
  }
  /**
   * Gets a new Vector2 copied from the Vector2
   * Example Playground https://playground.babylonjs.com/#QYBWV4#20
   * @returns a new Vector2
   */
  clone() {
    return new this.constructor(this.x, this.y);
  }
  // Statics
  /**
   * Gets a new Vector2(0, 0)
   * @returns a new Vector2
   */
  static Zero() {
    return new ue(0, 0);
  }
  /**
   * Gets a new Vector2(1, 1)
   * @returns a new Vector2
   */
  static One() {
    return new ue(1, 1);
  }
  /**
   * Returns a new Vector2 with random values between min and max
   * @param min the minimum random value
   * @param max the maximum random value
   * @returns a Vector2 with random values between min and max
   */
  static Random(e = 0, t = 1) {
    return new ue(J.RandomRange(e, t), J.RandomRange(e, t));
  }
  /**
   * Gets a zero Vector2 that must not be updated
   */
  static get ZeroReadOnly() {
    return ue._ZeroReadOnly;
  }
  /**
   * Gets a new Vector2 set from the given index element of the given array
   * Example Playground https://playground.babylonjs.com/#QYBWV4#79
   * @param array defines the data source
   * @param offset defines the offset in the data source
   * @returns a new Vector2
   */
  static FromArray(e, t = 0) {
    return new ue(e[t], e[t + 1]);
  }
  /**
   * Sets "result" from the given index element of the given array
   * Example Playground https://playground.babylonjs.com/#QYBWV4#80
   * @param array defines the data source
   * @param offset defines the offset in the data source
   * @param result defines the target vector
   * @returns result input
   */
  static FromArrayToRef(e, t, i) {
    return i.x = e[t], i.y = e[t + 1], i;
  }
  /**
   * Gets a new Vector2 located for "amount" (float) on the CatmullRom spline defined by the given four Vector2
   * Example Playground https://playground.babylonjs.com/#QYBWV4#65
   * @param value1 defines 1st point of control
   * @param value2 defines 2nd point of control
   * @param value3 defines 3rd point of control
   * @param value4 defines 4th point of control
   * @param amount defines the interpolation factor
   * @returns a new Vector2
   */
  static CatmullRom(e, t, i, s, r) {
    const n = r * r, a = r * n, o = 0.5 * (2 * t.x + (-e.x + i.x) * r + (2 * e.x - 5 * t.x + 4 * i.x - s.x) * n + (-e.x + 3 * t.x - 3 * i.x + s.x) * a), l = 0.5 * (2 * t.y + (-e.y + i.y) * r + (2 * e.y - 5 * t.y + 4 * i.y - s.y) * n + (-e.y + 3 * t.y - 3 * i.y + s.y) * a);
    return new e.constructor(o, l);
  }
  /**
   * Returns a new Vector2 set with same the coordinates than "value" ones if the vector "value" is in the square defined by "min" and "max".
   * If a coordinate of "value" is lower than "min" coordinates, the returned Vector2 is given this "min" coordinate.
   * If a coordinate of "value" is greater than "max" coordinates, the returned Vector2 is given this "max" coordinate
   * Example Playground https://playground.babylonjs.com/#QYBWV4#76
   * @param value defines the value to clamp
   * @param min defines the lower limit
   * @param max defines the upper limit
   * @returns a new Vector2
   */
  static Clamp(e, t, i) {
    let s = e.x;
    s = s > i.x ? i.x : s, s = s < t.x ? t.x : s;
    let r = e.y;
    return r = r > i.y ? i.y : r, r = r < t.y ? t.y : r, new e.constructor(s, r);
  }
  /**
   * Returns a new Vector2 located for "amount" (float) on the Hermite spline defined by the vectors "value1", "value2", "tangent1", "tangent2"
   * Example Playground https://playground.babylonjs.com/#QYBWV4#81
   * @param value1 defines the 1st control point
   * @param tangent1 defines the outgoing tangent
   * @param value2 defines the 2nd control point
   * @param tangent2 defines the incoming tangent
   * @param amount defines the interpolation factor
   * @returns a new Vector2
   */
  static Hermite(e, t, i, s, r) {
    const n = r * r, a = r * n, o = 2 * a - 3 * n + 1, l = -2 * a + 3 * n, c = a - 2 * n + r, u = a - n, d = e.x * o + i.x * l + t.x * c + s.x * u, f = e.y * o + i.y * l + t.y * c + s.y * u;
    return new e.constructor(d, f);
  }
  /**
   * Returns a new Vector2 which is the 1st derivative of the Hermite spline defined by the vectors "value1", "value2", "tangent1", "tangent2".
   * Example Playground https://playground.babylonjs.com/#QYBWV4#82
   * @param value1 defines the first control point
   * @param tangent1 defines the first tangent
   * @param value2 defines the second control point
   * @param tangent2 defines the second tangent
   * @param time define where the derivative must be done
   * @returns 1st derivative
   */
  static Hermite1stDerivative(e, t, i, s, r) {
    const n = new e.constructor();
    return this.Hermite1stDerivativeToRef(e, t, i, s, r, n), n;
  }
  /**
   * Returns a new Vector2 which is the 1st derivative of the Hermite spline defined by the vectors "value1", "value2", "tangent1", "tangent2".
   * Example Playground https://playground.babylonjs.com/#QYBWV4#83
   * @param value1 defines the first control point
   * @param tangent1 defines the first tangent
   * @param value2 defines the second control point
   * @param tangent2 defines the second tangent
   * @param time define where the derivative must be done
   * @param result define where the derivative will be stored
   * @returns result input
   */
  static Hermite1stDerivativeToRef(e, t, i, s, r, n) {
    const a = r * r;
    return n.x = (a - r) * 6 * e.x + (3 * a - 4 * r + 1) * t.x + (-a + r) * 6 * i.x + (3 * a - 2 * r) * s.x, n.y = (a - r) * 6 * e.y + (3 * a - 4 * r + 1) * t.y + (-a + r) * 6 * i.y + (3 * a - 2 * r) * s.y, n;
  }
  /**
   * Returns a new Vector2 located for "amount" (float) on the linear interpolation between the vector "start" adn the vector "end".
   * Example Playground https://playground.babylonjs.com/#QYBWV4#84
   * @param start defines the start vector
   * @param end defines the end vector
   * @param amount defines the interpolation factor
   * @returns a new Vector2
   */
  static Lerp(e, t, i) {
    const s = e.x + (t.x - e.x) * i, r = e.y + (t.y - e.y) * i;
    return new e.constructor(s, r);
  }
  /**
   * Gets the dot product of the vector "left" and the vector "right"
   * Example Playground https://playground.babylonjs.com/#QYBWV4#90
   * @param left defines first vector
   * @param right defines second vector
   * @returns the dot product (float)
   */
  static Dot(e, t) {
    return e.x * t.x + e.y * t.y;
  }
  /**
   * Returns a new Vector2 equal to the normalized given vector
   * Example Playground https://playground.babylonjs.com/#QYBWV4#46
   * @param vector defines the vector to normalize
   * @returns a new Vector2
   */
  static Normalize(e) {
    const t = new e.constructor();
    return this.NormalizeToRef(e, t), t;
  }
  /**
   * Normalize a given vector into a second one
   * Example Playground https://playground.babylonjs.com/#QYBWV4#50
   * @param vector defines the vector to normalize
   * @param result defines the vector where to store the result
   * @returns result input
   */
  static NormalizeToRef(e, t) {
    const i = e.length();
    return i === 0 || (t.x = e.x / i, t.y = e.y / i), t;
  }
  /**
   * Gets a new Vector2 set with the minimal coordinate values from the "left" and "right" vectors
   * Example Playground https://playground.babylonjs.com/#QYBWV4#86
   * @param left defines 1st vector
   * @param right defines 2nd vector
   * @returns a new Vector2
   */
  static Minimize(e, t) {
    const i = e.x < t.x ? e.x : t.x, s = e.y < t.y ? e.y : t.y;
    return new e.constructor(i, s);
  }
  /**
   * Gets a new Vector2 set with the maximal coordinate values from the "left" and "right" vectors
   * Example Playground https://playground.babylonjs.com/#QYBWV4#86
   * @param left defines 1st vector
   * @param right defines 2nd vector
   * @returns a new Vector2
   */
  static Maximize(e, t) {
    const i = e.x > t.x ? e.x : t.x, s = e.y > t.y ? e.y : t.y;
    return new e.constructor(i, s);
  }
  /**
   * Gets a new Vector2 set with the transformed coordinates of the given vector by the given transformation matrix
   * Example Playground https://playground.babylonjs.com/#QYBWV4#17
   * @param vector defines the vector to transform
   * @param transformation defines the matrix to apply
   * @returns a new Vector2
   */
  static Transform(e, t) {
    const i = new e.constructor();
    return ue.TransformToRef(e, t, i), i;
  }
  /**
   * Transforms the given vector coordinates by the given transformation matrix and stores the result in the vector "result" coordinates
   * Example Playground https://playground.babylonjs.com/#QYBWV4#19
   * @param vector defines the vector to transform
   * @param transformation defines the matrix to apply
   * @param result defines the target vector
   * @returns result input
   */
  static TransformToRef(e, t, i) {
    const s = t.m, r = e.x * s[0] + e.y * s[4] + s[12], n = e.x * s[1] + e.y * s[5] + s[13];
    return i.x = r, i.y = n, i;
  }
  /**
   * Determines if a given vector is included in a triangle
   * Example Playground https://playground.babylonjs.com/#QYBWV4#87
   * @param p defines the vector to test
   * @param p0 defines 1st triangle point
   * @param p1 defines 2nd triangle point
   * @param p2 defines 3rd triangle point
   * @returns true if the point "p" is in the triangle defined by the vectors "p0", "p1", "p2"
   */
  static PointInTriangle(e, t, i, s) {
    const r = 0.5 * (-i.y * s.x + t.y * (-i.x + s.x) + t.x * (i.y - s.y) + i.x * s.y), n = r < 0 ? -1 : 1, a = (t.y * s.x - t.x * s.y + (s.y - t.y) * e.x + (t.x - s.x) * e.y) * n, o = (t.x * i.y - t.y * i.x + (t.y - i.y) * e.x + (i.x - t.x) * e.y) * n;
    return a > 0 && o > 0 && a + o < 2 * r * n;
  }
  /**
   * Gets the distance between the vectors "value1" and "value2"
   * Example Playground https://playground.babylonjs.com/#QYBWV4#71
   * @param value1 defines first vector
   * @param value2 defines second vector
   * @returns the distance between vectors
   */
  static Distance(e, t) {
    return Math.sqrt(ue.DistanceSquared(e, t));
  }
  /**
   * Returns the squared distance between the vectors "value1" and "value2"
   * Example Playground https://playground.babylonjs.com/#QYBWV4#72
   * @param value1 defines first vector
   * @param value2 defines second vector
   * @returns the squared distance between vectors
   */
  static DistanceSquared(e, t) {
    const i = e.x - t.x, s = e.y - t.y;
    return i * i + s * s;
  }
  /**
   * Gets a new Vector2 located at the center of the vectors "value1" and "value2"
   * Example Playground https://playground.babylonjs.com/#QYBWV4#86
   * Example Playground https://playground.babylonjs.com/#QYBWV4#66
   * @param value1 defines first vector
   * @param value2 defines second vector
   * @returns a new Vector2
   */
  static Center(e, t) {
    const i = new e.constructor();
    return ue.CenterToRef(e, t, i);
  }
  /**
   * Gets the center of the vectors "value1" and "value2" and stores the result in the vector "ref"
   * Example Playground https://playground.babylonjs.com/#QYBWV4#66
   * @param value1 defines first vector
   * @param value2 defines second vector
   * @param ref defines third vector
   * @returns ref
   */
  static CenterToRef(e, t, i) {
    return i.copyFromFloats((e.x + t.x) / 2, (e.y + t.y) / 2);
  }
  /**
   * Gets the shortest distance (float) between the point "p" and the segment defined by the two points "segA" and "segB".
   * Example Playground https://playground.babylonjs.com/#QYBWV4#77
   * @param p defines the middle point
   * @param segA defines one point of the segment
   * @param segB defines the other point of the segment
   * @returns the shortest distance
   */
  static DistanceOfPointFromSegment(e, t, i) {
    const s = ue.DistanceSquared(t, i);
    if (s === 0)
      return ue.Distance(e, t);
    const r = i.subtract(t), n = Math.max(0, Math.min(1, ue.Dot(e.subtract(t), r) / s)), a = t.add(r.multiplyByFloats(n, n));
    return ue.Distance(e, a);
  }
}
ue._ZeroReadOnly = ue.Zero();
class p {
  /** Gets or sets the x coordinate */
  get x() {
    return this._x;
  }
  set x(e) {
    this._x = e, this._isDirty = !0;
  }
  /** Gets or sets the y coordinate */
  get y() {
    return this._y;
  }
  set y(e) {
    this._y = e, this._isDirty = !0;
  }
  /** Gets or sets the z coordinate */
  get z() {
    return this._z;
  }
  set z(e) {
    this._z = e, this._isDirty = !0;
  }
  /**
   * Creates a new Vector3 object from the given x, y, z (floats) coordinates.
   * @param x defines the first coordinates (on X axis)
   * @param y defines the second coordinates (on Y axis)
   * @param z defines the third coordinates (on Z axis)
   */
  constructor(e = 0, t = 0, i = 0) {
    this._isDirty = !0, this._x = e, this._y = t, this._z = i;
  }
  /**
   * Creates a string representation of the Vector3
   * Example Playground https://playground.babylonjs.com/#R1F8YU#67
   * @returns a string with the Vector3 coordinates.
   */
  toString() {
    return `{X: ${this._x} Y: ${this._y} Z: ${this._z}}`;
  }
  /**
   * Gets the class name
   * @returns the string "Vector3"
   */
  getClassName() {
    return "Vector3";
  }
  /**
   * Creates the Vector3 hash code
   * @returns a number which tends to be unique between Vector3 instances
   */
  getHashCode() {
    const e = Bt(this._x), t = Bt(this._y), i = Bt(this._z);
    let s = e;
    return s = s * 397 ^ t, s = s * 397 ^ i, s;
  }
  // Operators
  /**
   * Creates an array containing three elements : the coordinates of the Vector3
   * Example Playground https://playground.babylonjs.com/#R1F8YU#10
   * @returns a new array of numbers
   */
  asArray() {
    const e = [];
    return this.toArray(e, 0), e;
  }
  /**
   * Populates the given array or Float32Array from the given index with the successive coordinates of the Vector3
   * Example Playground https://playground.babylonjs.com/#R1F8YU#65
   * @param array defines the destination array
   * @param index defines the offset in the destination array
   * @returns the current Vector3
   */
  toArray(e, t = 0) {
    return e[t] = this._x, e[t + 1] = this._y, e[t + 2] = this._z, this;
  }
  /**
   * Update the current vector from an array
   * Example Playground https://playground.babylonjs.com/#R1F8YU#24
   * @param array defines the destination array
   * @param index defines the offset in the destination array
   * @returns the current Vector3
   */
  fromArray(e, t = 0) {
    return p.FromArrayToRef(e, t, this), this;
  }
  /**
   * Converts the current Vector3 into a quaternion (considering that the Vector3 contains Euler angles representation of a rotation)
   * Example Playground https://playground.babylonjs.com/#R1F8YU#66
   * @returns a new Quaternion object, computed from the Vector3 coordinates
   */
  toQuaternion() {
    return U.RotationYawPitchRoll(this._y, this._x, this._z);
  }
  /**
   * Adds the given vector to the current Vector3
   * Example Playground https://playground.babylonjs.com/#R1F8YU#4
   * @param otherVector defines the second operand
   * @returns the current updated Vector3
   */
  addInPlace(e) {
    return this.addInPlaceFromFloats(e._x, e._y, e._z);
  }
  /**
   * Adds the given coordinates to the current Vector3
   * Example Playground https://playground.babylonjs.com/#R1F8YU#5
   * @param x defines the x coordinate of the operand
   * @param y defines the y coordinate of the operand
   * @param z defines the z coordinate of the operand
   * @returns the current updated Vector3
   */
  addInPlaceFromFloats(e, t, i) {
    return this._x += e, this._y += t, this._z += i, this._isDirty = !0, this;
  }
  /**
   * Gets a new Vector3, result of the addition the current Vector3 and the given vector
   * Example Playground https://playground.babylonjs.com/#R1F8YU#3
   * @param otherVector defines the second operand
   * @returns the resulting Vector3
   */
  add(e) {
    return new this.constructor(this._x + e._x, this._y + e._y, this._z + e._z);
  }
  /**
   * Adds the current Vector3 to the given one and stores the result in the vector "result"
   * Example Playground https://playground.babylonjs.com/#R1F8YU#6
   * @param otherVector defines the second operand
   * @param result defines the Vector3 object where to store the result
   * @returns the result
   */
  addToRef(e, t) {
    return t.copyFromFloats(this._x + e._x, this._y + e._y, this._z + e._z);
  }
  /**
   * Subtract the given vector from the current Vector3
   * Example Playground https://playground.babylonjs.com/#R1F8YU#61
   * @param otherVector defines the second operand
   * @returns the current updated Vector3
   */
  subtractInPlace(e) {
    return this._x -= e._x, this._y -= e._y, this._z -= e._z, this._isDirty = !0, this;
  }
  /**
   * Returns a new Vector3, result of the subtraction of the given vector from the current Vector3
   * Example Playground https://playground.babylonjs.com/#R1F8YU#60
   * @param otherVector defines the second operand
   * @returns the resulting Vector3
   */
  subtract(e) {
    return new this.constructor(this._x - e._x, this._y - e._y, this._z - e._z);
  }
  /**
   * Subtracts the given vector from the current Vector3 and stores the result in the vector "result".
   * Example Playground https://playground.babylonjs.com/#R1F8YU#63
   * @param otherVector defines the second operand
   * @param result defines the Vector3 object where to store the result
   * @returns the result
   */
  subtractToRef(e, t) {
    return this.subtractFromFloatsToRef(e._x, e._y, e._z, t);
  }
  /**
   * Returns a new Vector3 set with the subtraction of the given floats from the current Vector3 coordinates
   * Example Playground https://playground.babylonjs.com/#R1F8YU#62
   * @param x defines the x coordinate of the operand
   * @param y defines the y coordinate of the operand
   * @param z defines the z coordinate of the operand
   * @returns the resulting Vector3
   */
  subtractFromFloats(e, t, i) {
    return new this.constructor(this._x - e, this._y - t, this._z - i);
  }
  /**
   * Subtracts the given floats from the current Vector3 coordinates and set the given vector "result" with this result
   * Example Playground https://playground.babylonjs.com/#R1F8YU#64
   * @param x defines the x coordinate of the operand
   * @param y defines the y coordinate of the operand
   * @param z defines the z coordinate of the operand
   * @param result defines the Vector3 object where to store the result
   * @returns the result
   */
  subtractFromFloatsToRef(e, t, i, s) {
    return s.copyFromFloats(this._x - e, this._y - t, this._z - i);
  }
  /**
   * Gets a new Vector3 set with the current Vector3 negated coordinates
   * Example Playground https://playground.babylonjs.com/#R1F8YU#35
   * @returns a new Vector3
   */
  negate() {
    return new this.constructor(-this._x, -this._y, -this._z);
  }
  /**
   * Negate this vector in place
   * Example Playground https://playground.babylonjs.com/#R1F8YU#36
   * @returns this
   */
  negateInPlace() {
    return this._x *= -1, this._y *= -1, this._z *= -1, this._isDirty = !0, this;
  }
  /**
   * Negate the current Vector3 and stores the result in the given vector "result" coordinates
   * Example Playground https://playground.babylonjs.com/#R1F8YU#37
   * @param result defines the Vector3 object where to store the result
   * @returns the result
   */
  negateToRef(e) {
    return e.copyFromFloats(this._x * -1, this._y * -1, this._z * -1);
  }
  /**
   * Multiplies the Vector3 coordinates by the float "scale"
   * Example Playground https://playground.babylonjs.com/#R1F8YU#56
   * @param scale defines the multiplier factor
   * @returns the current updated Vector3
   */
  scaleInPlace(e) {
    return this._x *= e, this._y *= e, this._z *= e, this._isDirty = !0, this;
  }
  /**
   * Returns a new Vector3 set with the current Vector3 coordinates multiplied by the float "scale"
   * Example Playground https://playground.babylonjs.com/#R1F8YU#53
   * @param scale defines the multiplier factor
   * @returns a new Vector3
   */
  scale(e) {
    return new this.constructor(this._x * e, this._y * e, this._z * e);
  }
  /**
   * Multiplies the current Vector3 coordinates by the float "scale" and stores the result in the given vector "result" coordinates
   * Example Playground https://playground.babylonjs.com/#R1F8YU#57
   * @param scale defines the multiplier factor
   * @param result defines the Vector3 object where to store the result
   * @returns the result
   */
  scaleToRef(e, t) {
    return t.copyFromFloats(this._x * e, this._y * e, this._z * e);
  }
  /**
   * Creates a vector normal (perpendicular) to the current Vector3 and stores the result in the given vector
   * Out of the infinite possibilities the normal chosen is the one formed by rotating the current vector
   * 90 degrees about an axis which lies perpendicular to the current vector
   * and its projection on the xz plane. In the case of a current vector in the xz plane
   * the normal is calculated to be along the y axis.
   * Example Playground https://playground.babylonjs.com/#R1F8YU#230
   * Example Playground https://playground.babylonjs.com/#R1F8YU#231
   * @param result defines the Vector3 object where to store the resultant normal
   * returns the result
   */
  getNormalToRef(e) {
    const t = this.length();
    let i = Math.acos(this.y / t);
    const s = Math.atan2(this.z, this.x);
    i > Math.PI / 2 ? i -= Math.PI / 2 : i += Math.PI / 2;
    const r = t * Math.sin(i) * Math.cos(s), n = t * Math.cos(i), a = t * Math.sin(i) * Math.sin(s);
    return e.set(r, n, a), e;
  }
  /**
   * Rotates the vector using the given unit quaternion and stores the new vector in result
   * Example Playground https://playground.babylonjs.com/#R1F8YU#9
   * @param q the unit quaternion representing the rotation
   * @param result the output vector
   * @returns the result
   */
  applyRotationQuaternionToRef(e, t) {
    const i = this._x, s = this._y, r = this._z, n = e._x, a = e._y, o = e._z, l = e._w, c = 2 * (a * r - o * s), u = 2 * (o * i - n * r), d = 2 * (n * s - a * i);
    return t._x = i + l * c + a * d - o * u, t._y = s + l * u + o * c - n * d, t._z = r + l * d + n * u - a * c, t._isDirty = !0, t;
  }
  /**
   * Rotates the vector in place using the given unit quaternion
   * Example Playground https://playground.babylonjs.com/#R1F8YU#8
   * @param q the unit quaternion representing the rotation
   * @returns the current updated Vector3
   */
  applyRotationQuaternionInPlace(e) {
    return this.applyRotationQuaternionToRef(e, this);
  }
  /**
   * Rotates the vector using the given unit quaternion and returns the new vector
   * Example Playground https://playground.babylonjs.com/#R1F8YU#7
   * @param q the unit quaternion representing the rotation
   * @returns a new Vector3
   */
  applyRotationQuaternion(e) {
    return this.applyRotationQuaternionToRef(e, new this.constructor());
  }
  /**
   * Scale the current Vector3 values by a factor and add the result to a given Vector3
   * Example Playground https://playground.babylonjs.com/#R1F8YU#55
   * @param scale defines the scale factor
   * @param result defines the Vector3 object where to store the result
   * @returns result input
   */
  scaleAndAddToRef(e, t) {
    return t.addInPlaceFromFloats(this._x * e, this._y * e, this._z * e);
  }
  /**
   * Projects the current point Vector3 to a plane along a ray starting from a specified origin and passing through the current point Vector3.
   * Example Playground https://playground.babylonjs.com/#R1F8YU#48
   * @param plane defines the plane to project to
   * @param origin defines the origin of the projection ray
   * @returns the projected vector3
   */
  projectOnPlane(e, t) {
    const i = new this.constructor();
    return this.projectOnPlaneToRef(e, t, i), i;
  }
  /**
   * Projects the current point Vector3 to a plane along a ray starting from a specified origin and passing through the current point Vector3.
   * Example Playground https://playground.babylonjs.com/#R1F8YU#49
   * @param plane defines the plane to project to
   * @param origin defines the origin of the projection ray
   * @param result defines the Vector3 where to store the result
   * @returns result input
   */
  projectOnPlaneToRef(e, t, i) {
    const s = e.normal, r = e.d, n = te.Vector3[0];
    this.subtractToRef(t, n), n.normalize();
    const a = p.Dot(n, s);
    if (Math.abs(a) < Math.pow(10, -10))
      i.setAll(1 / 0);
    else {
      const o = -(p.Dot(t, s) + r) / a, l = n.scaleInPlace(o);
      t.addToRef(l, i);
    }
    return i;
  }
  /**
   * Returns true if the current Vector3 and the given vector coordinates are strictly equal
   * Example Playground https://playground.babylonjs.com/#R1F8YU#19
   * @param otherVector defines the second operand
   * @returns true if both vectors are equals
   */
  equals(e) {
    return e && this._x === e._x && this._y === e._y && this._z === e._z;
  }
  /**
   * Returns true if the current Vector3 and the given vector coordinates are distant less than epsilon
   * Example Playground https://playground.babylonjs.com/#R1F8YU#21
   * @param otherVector defines the second operand
   * @param epsilon defines the minimal distance to define values as equals
   * @returns true if both vectors are distant less than epsilon
   */
  equalsWithEpsilon(e, t = pe) {
    return e && J.WithinEpsilon(this._x, e._x, t) && J.WithinEpsilon(this._y, e._y, t) && J.WithinEpsilon(this._z, e._z, t);
  }
  /**
   * Returns true if the current Vector3 coordinates equals the given floats
   * Example Playground https://playground.babylonjs.com/#R1F8YU#20
   * @param x defines the x coordinate of the operand
   * @param y defines the y coordinate of the operand
   * @param z defines the z coordinate of the operand
   * @returns true if both vectors are equal
   */
  equalsToFloats(e, t, i) {
    return this._x === e && this._y === t && this._z === i;
  }
  /**
   * Multiplies the current Vector3 coordinates by the given ones
   * Example Playground https://playground.babylonjs.com/#R1F8YU#32
   * @param otherVector defines the second operand
   * @returns the current updated Vector3
   */
  multiplyInPlace(e) {
    return this._x *= e._x, this._y *= e._y, this._z *= e._z, this._isDirty = !0, this;
  }
  /**
   * Returns a new Vector3, result of the multiplication of the current Vector3 by the given vector
   * Example Playground https://playground.babylonjs.com/#R1F8YU#31
   * @param otherVector defines the second operand
   * @returns the new Vector3
   */
  multiply(e) {
    return this.multiplyByFloats(e._x, e._y, e._z);
  }
  /**
   * Multiplies the current Vector3 by the given one and stores the result in the given vector "result"
   * Example Playground https://playground.babylonjs.com/#R1F8YU#33
   * @param otherVector defines the second operand
   * @param result defines the Vector3 object where to store the result
   * @returns the result
   */
  multiplyToRef(e, t) {
    return t.copyFromFloats(this._x * e._x, this._y * e._y, this._z * e._z);
  }
  /**
   * Returns a new Vector3 set with the result of the multiplication of the current Vector3 coordinates by the given floats
   * Example Playground https://playground.babylonjs.com/#R1F8YU#34
   * @param x defines the x coordinate of the operand
   * @param y defines the y coordinate of the operand
   * @param z defines the z coordinate of the operand
   * @returns the new Vector3
   */
  multiplyByFloats(e, t, i) {
    return new this.constructor(this._x * e, this._y * t, this._z * i);
  }
  /**
   * Returns a new Vector3 set with the result of the division of the current Vector3 coordinates by the given ones
   * Example Playground https://playground.babylonjs.com/#R1F8YU#16
   * @param otherVector defines the second operand
   * @returns the new Vector3
   */
  divide(e) {
    return new this.constructor(this._x / e._x, this._y / e._y, this._z / e._z);
  }
  /**
   * Divides the current Vector3 coordinates by the given ones and stores the result in the given vector "result"
   * Example Playground https://playground.babylonjs.com/#R1F8YU#18
   * @param otherVector defines the second operand
   * @param result defines the Vector3 object where to store the result
   * @returns the result
   */
  divideToRef(e, t) {
    return t.copyFromFloats(this._x / e._x, this._y / e._y, this._z / e._z);
  }
  /**
   * Divides the current Vector3 coordinates by the given ones.
   * Example Playground https://playground.babylonjs.com/#R1F8YU#17
   * @param otherVector defines the second operand
   * @returns the current updated Vector3
   */
  divideInPlace(e) {
    return this.divideToRef(e, this);
  }
  /**
   * Updates the current Vector3 with the minimal coordinate values between its and the given vector ones
   * Example Playground https://playground.babylonjs.com/#R1F8YU#29
   * @param other defines the second operand
   * @returns the current updated Vector3
   */
  minimizeInPlace(e) {
    return this.minimizeInPlaceFromFloats(e._x, e._y, e._z);
  }
  /**
   * Updates the current Vector3 with the maximal coordinate values between its and the given vector ones.
   * Example Playground https://playground.babylonjs.com/#R1F8YU#27
   * @param other defines the second operand
   * @returns the current updated Vector3
   */
  maximizeInPlace(e) {
    return this.maximizeInPlaceFromFloats(e._x, e._y, e._z);
  }
  /**
   * Updates the current Vector3 with the minimal coordinate values between its and the given coordinates
   * Example Playground https://playground.babylonjs.com/#R1F8YU#30
   * @param x defines the x coordinate of the operand
   * @param y defines the y coordinate of the operand
   * @param z defines the z coordinate of the operand
   * @returns the current updated Vector3
   */
  minimizeInPlaceFromFloats(e, t, i) {
    return e < this._x && (this.x = e), t < this._y && (this.y = t), i < this._z && (this.z = i), this;
  }
  /**
   * Updates the current Vector3 with the maximal coordinate values between its and the given coordinates.
   * Example Playground https://playground.babylonjs.com/#R1F8YU#28
   * @param x defines the x coordinate of the operand
   * @param y defines the y coordinate of the operand
   * @param z defines the z coordinate of the operand
   * @returns the current updated Vector3
   */
  maximizeInPlaceFromFloats(e, t, i) {
    return e > this._x && (this.x = e), t > this._y && (this.y = t), i > this._z && (this.z = i), this;
  }
  /**
   * Due to float precision, scale of a mesh could be uniform but float values are off by a small fraction
   * Check if is non uniform within a certain amount of decimal places to account for this
   * @param epsilon the amount the values can differ
   * @returns if the the vector is non uniform to a certain number of decimal places
   */
  isNonUniformWithinEpsilon(e) {
    const t = Math.abs(this._x), i = Math.abs(this._y);
    if (!J.WithinEpsilon(t, i, e))
      return !0;
    const s = Math.abs(this._z);
    return !J.WithinEpsilon(t, s, e) || !J.WithinEpsilon(i, s, e);
  }
  /**
   * Gets a boolean indicating that the vector is non uniform meaning x, y or z are not all the same
   */
  get isNonUniform() {
    const e = Math.abs(this._x), t = Math.abs(this._y);
    if (e !== t)
      return !0;
    const i = Math.abs(this._z);
    return e !== i;
  }
  /**
   * Gets a new Vector3 from current Vector3 floored values
   * Example Playground https://playground.babylonjs.com/#R1F8YU#22
   * @returns a new Vector3
   */
  floor() {
    return new this.constructor(Math.floor(this._x), Math.floor(this._y), Math.floor(this._z));
  }
  /**
   * Gets a new Vector3 from current Vector3 fractional values
   * Example Playground https://playground.babylonjs.com/#R1F8YU#23
   * @returns a new Vector3
   */
  fract() {
    return new this.constructor(this._x - Math.floor(this._x), this._y - Math.floor(this._y), this._z - Math.floor(this._z));
  }
  // Properties
  /**
   * Gets the length of the Vector3
   * Example Playground https://playground.babylonjs.com/#R1F8YU#25
   * @returns the length of the Vector3
   */
  length() {
    return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z);
  }
  /**
   * Gets the squared length of the Vector3
   * Example Playground https://playground.babylonjs.com/#R1F8YU#26
   * @returns squared length of the Vector3
   */
  lengthSquared() {
    return this._x * this._x + this._y * this._y + this._z * this._z;
  }
  /**
   * Gets a boolean indicating if the vector contains a zero in one of its components
   * Example Playground https://playground.babylonjs.com/#R1F8YU#1
   */
  get hasAZeroComponent() {
    return this._x * this._y * this._z === 0;
  }
  /**
   * Normalize the current Vector3.
   * Please note that this is an in place operation.
   * Example Playground https://playground.babylonjs.com/#R1F8YU#122
   * @returns the current updated Vector3
   */
  normalize() {
    return this.normalizeFromLength(this.length());
  }
  /**
   * Reorders the x y z properties of the vector in place
   * Example Playground https://playground.babylonjs.com/#R1F8YU#44
   * @param order new ordering of the properties (eg. for vector 1,2,3 with "ZYX" will produce 3,2,1)
   * @returns the current updated vector
   */
  reorderInPlace(e) {
    return e = e.toLowerCase(), e === "xyz" ? this : (te.Vector3[0].copyFrom(this), ["x", "y", "z"].forEach((t, i) => {
      this[t] = te.Vector3[0][e[i]];
    }), this);
  }
  /**
   * Rotates the vector around 0,0,0 by a quaternion
   * Example Playground https://playground.babylonjs.com/#R1F8YU#47
   * @param quaternion the rotation quaternion
   * @param result vector to store the result
   * @returns the resulting vector
   */
  rotateByQuaternionToRef(e, t) {
    return e.toRotationMatrix(te.Matrix[0]), p.TransformCoordinatesToRef(this, te.Matrix[0], t), t;
  }
  /**
   * Rotates a vector around a given point
   * Example Playground https://playground.babylonjs.com/#R1F8YU#46
   * @param quaternion the rotation quaternion
   * @param point the point to rotate around
   * @param result vector to store the result
   * @returns the resulting vector
   */
  rotateByQuaternionAroundPointToRef(e, t, i) {
    return this.subtractToRef(t, te.Vector3[0]), te.Vector3[0].rotateByQuaternionToRef(e, te.Vector3[0]), t.addToRef(te.Vector3[0], i), i;
  }
  /**
   * Returns a new Vector3 as the cross product of the current vector and the "other" one
   * The cross product is then orthogonal to both current and "other"
   * Example Playground https://playground.babylonjs.com/#R1F8YU#14
   * @param other defines the right operand
   * @returns the cross product
   */
  cross(e) {
    const t = new this.constructor();
    return p.CrossToRef(this, e, t);
  }
  /**
   * Normalize the current Vector3 with the given input length.
   * Please note that this is an in place operation.
   * Example Playground https://playground.babylonjs.com/#R1F8YU#123
   * @param len the length of the vector
   * @returns the current updated Vector3
   */
  normalizeFromLength(e) {
    return e === 0 || e === 1 ? this : this.scaleInPlace(1 / e);
  }
  /**
   * Normalize the current Vector3 to a new vector
   * Example Playground https://playground.babylonjs.com/#R1F8YU#124
   * @returns the new Vector3
   */
  normalizeToNew() {
    const e = new this.constructor(0, 0, 0);
    return this.normalizeToRef(e), e;
  }
  /**
   * Normalize the current Vector3 to the reference
   * Example Playground https://playground.babylonjs.com/#R1F8YU#125
   * @param reference define the Vector3 to update
   * @returns the updated Vector3
   */
  normalizeToRef(e) {
    const t = this.length();
    return t === 0 || t === 1 ? e.copyFromFloats(this._x, this._y, this._z) : this.scaleToRef(1 / t, e);
  }
  /**
   * Creates a new Vector3 copied from the current Vector3
   * Example Playground https://playground.babylonjs.com/#R1F8YU#11
   * @returns the new Vector3
   */
  clone() {
    return new this.constructor(this._x, this._y, this._z);
  }
  /**
   * Copies the given vector coordinates to the current Vector3 ones
   * Example Playground https://playground.babylonjs.com/#R1F8YU#12
   * @param source defines the source Vector3
   * @returns the current updated Vector3
   */
  copyFrom(e) {
    return this.copyFromFloats(e._x, e._y, e._z);
  }
  /**
   * Copies the given floats to the current Vector3 coordinates
   * Example Playground https://playground.babylonjs.com/#R1F8YU#13
   * @param x defines the x coordinate of the operand
   * @param y defines the y coordinate of the operand
   * @param z defines the z coordinate of the operand
   * @returns the current updated Vector3
   */
  copyFromFloats(e, t, i) {
    return this._x = e, this._y = t, this._z = i, this._isDirty = !0, this;
  }
  /**
   * Copies the given floats to the current Vector3 coordinates
   * Example Playground https://playground.babylonjs.com/#R1F8YU#58
   * @param x defines the x coordinate of the operand
   * @param y defines the y coordinate of the operand
   * @param z defines the z coordinate of the operand
   * @returns the current updated Vector3
   */
  set(e, t, i) {
    return this.copyFromFloats(e, t, i);
  }
  /**
   * Copies the given float to the current Vector3 coordinates
   * Example Playground https://playground.babylonjs.com/#R1F8YU#59
   * @param v defines the x, y and z coordinates of the operand
   * @returns the current updated Vector3
   */
  setAll(e) {
    return this._x = this._y = this._z = e, this._isDirty = !0, this;
  }
  // Statics
  /**
   * Get the clip factor between two vectors
   * Example Playground https://playground.babylonjs.com/#R1F8YU#126
   * @param vector0 defines the first operand
   * @param vector1 defines the second operand
   * @param axis defines the axis to use
   * @param size defines the size along the axis
   * @returns the clip factor
   */
  static GetClipFactor(e, t, i, s) {
    const r = p.Dot(e, i) - s, n = p.Dot(t, i) - s;
    return r / (r - n);
  }
  /**
   * Get angle between two vectors
   * Example Playground https://playground.babylonjs.com/#R1F8YU#86
   * @param vector0 the starting point
   * @param vector1 the ending point
   * @param normal direction of the normal
   * @returns the angle between vector0 and vector1
   */
  static GetAngleBetweenVectors(e, t, i) {
    const s = e.normalizeToRef(te.Vector3[1]), r = t.normalizeToRef(te.Vector3[2]);
    let n = p.Dot(s, r);
    n = J.Clamp(n, -1, 1);
    const a = Math.acos(n), o = te.Vector3[3];
    return p.CrossToRef(s, r, o), p.Dot(o, i) > 0 ? isNaN(a) ? 0 : a : isNaN(a) ? -Math.PI : -Math.acos(n);
  }
  /**
   * Get angle between two vectors projected on a plane
   * Example Playground https://playground.babylonjs.com/#R1F8YU#87
   * Expectation compute time: 0.01 ms (median) and 0.02 ms (percentile 95%)
   * @param vector0 angle between vector0 and vector1
   * @param vector1 angle between vector0 and vector1
   * @param normal Normal of the projection plane
   * @returns the angle in radians (float) between vector0 and vector1 projected on the plane with the specified normal
   */
  static GetAngleBetweenVectorsOnPlane(e, t, i) {
    te.Vector3[0].copyFrom(e);
    const s = te.Vector3[0];
    te.Vector3[1].copyFrom(t);
    const r = te.Vector3[1];
    te.Vector3[2].copyFrom(i);
    const n = te.Vector3[2], a = te.Vector3[3], o = te.Vector3[4];
    s.normalize(), r.normalize(), n.normalize(), p.CrossToRef(n, s, a), p.CrossToRef(a, n, o);
    const l = Math.atan2(p.Dot(r, a), p.Dot(r, o));
    return J.NormalizeRadians(l);
  }
  /**
   * Gets the rotation that aligns the roll axis (Y) to the line joining the start point to the target point and stores it in the ref Vector3
   * Example PG https://playground.babylonjs.com/#R1F8YU#189
   * @param start the starting point
   * @param target the target point
   * @param ref the vector3 to store the result
   * @returns ref in the form (pitch, yaw, 0)
   */
  static PitchYawRollToMoveBetweenPointsToRef(e, t, i) {
    const s = C.Vector3[0];
    return t.subtractToRef(e, s), i._y = Math.atan2(s.x, s.z) || 0, i._x = Math.atan2(Math.sqrt(s.x ** 2 + s.z ** 2), s.y) || 0, i._z = 0, i._isDirty = !0, i;
  }
  /**
   * Gets the rotation that aligns the roll axis (Y) to the line joining the start point to the target point
   * Example PG https://playground.babylonjs.com/#R1F8YU#188
   * @param start the starting point
   * @param target the target point
   * @returns the rotation in the form (pitch, yaw, 0)
   */
  static PitchYawRollToMoveBetweenPoints(e, t) {
    const i = p.Zero();
    return p.PitchYawRollToMoveBetweenPointsToRef(e, t, i);
  }
  /**
   * Slerp between two vectors. See also `SmoothToRef`
   * Slerp is a spherical linear interpolation
   * giving a slow in and out effect
   * Example Playground 1 https://playground.babylonjs.com/#R1F8YU#108
   * Example Playground 2 https://playground.babylonjs.com/#R1F8YU#109
   * @param vector0 Start vector
   * @param vector1 End vector
   * @param slerp amount (will be clamped between 0 and 1)
   * @param result The slerped vector
   */
  static SlerpToRef(e, t, i, s) {
    i = J.Clamp(i, 0, 1);
    const r = te.Vector3[0], n = te.Vector3[1];
    r.copyFrom(e);
    const a = r.length();
    r.normalizeFromLength(a), n.copyFrom(t);
    const o = n.length();
    n.normalizeFromLength(o);
    const l = p.Dot(r, n);
    let c, u;
    if (l < 1 - pe) {
      const d = Math.acos(l), f = 1 / Math.sin(d);
      c = Math.sin((1 - i) * d) * f, u = Math.sin(i * d) * f;
    } else
      c = 1 - i, u = i;
    return r.scaleInPlace(c), n.scaleInPlace(u), s.copyFrom(r).addInPlace(n), s.scaleInPlace(J.Lerp(a, o, i)), s;
  }
  /**
   * Smooth interpolation between two vectors using Slerp
   * Example Playground https://playground.babylonjs.com/#R1F8YU#110
   * @param source source vector
   * @param goal goal vector
   * @param deltaTime current interpolation frame
   * @param lerpTime total interpolation time
   * @param result the smoothed vector
   */
  static SmoothToRef(e, t, i, s, r) {
    return p.SlerpToRef(e, t, s === 0 ? 1 : i / s, r), r;
  }
  /**
   * Returns a new Vector3 set from the index "offset" of the given array
   * Example Playground https://playground.babylonjs.com/#R1F8YU#83
   * @param array defines the source array
   * @param offset defines the offset in the source array
   * @returns the new Vector3
   */
  static FromArray(e, t = 0) {
    return new p(e[t], e[t + 1], e[t + 2]);
  }
  /**
   * Returns a new Vector3 set from the index "offset" of the given Float32Array
   * @param array defines the source array
   * @param offset defines the offset in the source array
   * @returns the new Vector3
   * @deprecated Please use FromArray instead.
   */
  static FromFloatArray(e, t) {
    return p.FromArray(e, t);
  }
  /**
   * Sets the given vector "result" with the element values from the index "offset" of the given array
   * Example Playground https://playground.babylonjs.com/#R1F8YU#84
   * @param array defines the source array
   * @param offset defines the offset in the source array
   * @param result defines the Vector3 where to store the result
   * @returns result input
   */
  static FromArrayToRef(e, t, i) {
    return i._x = e[t], i._y = e[t + 1], i._z = e[t + 2], i._isDirty = !0, i;
  }
  /**
   * Sets the given vector "result" with the element values from the index "offset" of the given Float32Array
   * @param array defines the source array
   * @param offset defines the offset in the source array
   * @param result defines the Vector3 where to store the result
   * @deprecated Please use FromArrayToRef instead.
   */
  static FromFloatArrayToRef(e, t, i) {
    return p.FromArrayToRef(e, t, i);
  }
  /**
   * Sets the given vector "result" with the given floats.
   * Example Playground https://playground.babylonjs.com/#R1F8YU#85
   * @param x defines the x coordinate of the source
   * @param y defines the y coordinate of the source
   * @param z defines the z coordinate of the source
   * @param result defines the Vector3 where to store the result
   */
  static FromFloatsToRef(e, t, i, s) {
    return s.copyFromFloats(e, t, i), s;
  }
  /**
   * Returns a new Vector3 set to (0.0, 0.0, 0.0)
   * @returns a new empty Vector3
   */
  static Zero() {
    return new p(0, 0, 0);
  }
  /**
   * Returns a new Vector3 set to (1.0, 1.0, 1.0)
   * @returns a new Vector3
   */
  static One() {
    return new p(1, 1, 1);
  }
  /**
   * Returns a new Vector3 set to (0.0, 1.0, 0.0)
   * Example Playground https://playground.babylonjs.com/#R1F8YU#71
   * @returns a new up Vector3
   */
  static Up() {
    return new p(0, 1, 0);
  }
  /**
   * Gets an up Vector3 that must not be updated
   */
  static get UpReadOnly() {
    return p._UpReadOnly;
  }
  /**
   * Gets a down Vector3 that must not be updated
   */
  static get DownReadOnly() {
    return p._DownReadOnly;
  }
  /**
   * Gets a right Vector3 that must not be updated
   */
  static get RightReadOnly() {
    return p._RightReadOnly;
  }
  /**
   * Gets a left Vector3 that must not be updated
   */
  static get LeftReadOnly() {
    return p._LeftReadOnly;
  }
  /**
   * Gets a forward Vector3 that must not be updated
   */
  static get LeftHandedForwardReadOnly() {
    return p._LeftHandedForwardReadOnly;
  }
  /**
   * Gets a forward Vector3 that must not be updated
   */
  static get RightHandedForwardReadOnly() {
    return p._RightHandedForwardReadOnly;
  }
  /**
   * Gets a backward Vector3 that must not be updated
   */
  static get LeftHandedBackwardReadOnly() {
    return p._LeftHandedBackwardReadOnly;
  }
  /**
   * Gets a backward Vector3 that must not be updated
   */
  static get RightHandedBackwardReadOnly() {
    return p._RightHandedBackwardReadOnly;
  }
  /**
   * Gets a zero Vector3 that must not be updated
   */
  static get ZeroReadOnly() {
    return p._ZeroReadOnly;
  }
  /**
   * Gets a one Vector3 that must not be updated
   */
  static get OneReadOnly() {
    return p._OneReadOnly;
  }
  /**
   * Returns a new Vector3 set to (0.0, -1.0, 0.0)
   * Example Playground https://playground.babylonjs.com/#R1F8YU#71
   * @returns a new down Vector3
   */
  static Down() {
    return new p(0, -1, 0);
  }
  /**
   * Returns a new Vector3 set to (0.0, 0.0, 1.0)
   * Example Playground https://playground.babylonjs.com/#R1F8YU#71
   * @param rightHandedSystem is the scene right-handed (negative z)
   * @returns a new forward Vector3
   */
  static Forward(e = !1) {
    return new p(0, 0, e ? -1 : 1);
  }
  /**
   * Returns a new Vector3 set to (0.0, 0.0, -1.0)
   * Example Playground https://playground.babylonjs.com/#R1F8YU#71
   * @param rightHandedSystem is the scene right-handed (negative-z)
   * @returns a new Backward Vector3
   */
  static Backward(e = !1) {
    return new p(0, 0, e ? 1 : -1);
  }
  /**
   * Returns a new Vector3 set to (1.0, 0.0, 0.0)
   * Example Playground https://playground.babylonjs.com/#R1F8YU#71
   * @returns a new right Vector3
   */
  static Right() {
    return new p(1, 0, 0);
  }
  /**
   * Returns a new Vector3 set to (-1.0, 0.0, 0.0)
   * Example Playground https://playground.babylonjs.com/#R1F8YU#71
   * @returns a new left Vector3
   */
  static Left() {
    return new p(-1, 0, 0);
  }
  /**
   * Returns a new Vector3 with random values between min and max
   * @param min the minimum random value
   * @param max the maximum random value
   * @returns a Vector3 with random values between min and max
   */
  static Random(e = 0, t = 1) {
    return new p(J.RandomRange(e, t), J.RandomRange(e, t), J.RandomRange(e, t));
  }
  /**
   * Returns a new Vector3 set with the result of the transformation by the given matrix of the given vector.
   * This method computes transformed coordinates only, not transformed direction vectors (ie. it takes translation in account)
   * Example Playground https://playground.babylonjs.com/#R1F8YU#111
   * @param vector defines the Vector3 to transform
   * @param transformation defines the transformation matrix
   * @returns the transformed Vector3
   */
  static TransformCoordinates(e, t) {
    const i = p.Zero();
    return p.TransformCoordinatesToRef(e, t, i), i;
  }
  /**
   * Sets the given vector "result" coordinates with the result of the transformation by the given matrix of the given vector
   * This method computes transformed coordinates only, not transformed direction vectors (ie. it takes translation in account)
   * Example Playground https://playground.babylonjs.com/#R1F8YU#113
   * @param vector defines the Vector3 to transform
   * @param transformation defines the transformation matrix
   * @param result defines the Vector3 where to store the result
   * @returns result input
   */
  static TransformCoordinatesToRef(e, t, i) {
    return p.TransformCoordinatesFromFloatsToRef(e._x, e._y, e._z, t, i), i;
  }
  /**
   * Sets the given vector "result" coordinates with the result of the transformation by the given matrix of the given floats (x, y, z)
   * This method computes transformed coordinates only, not transformed direction vectors
   * Example Playground https://playground.babylonjs.com/#R1F8YU#115
   * @param x define the x coordinate of the source vector
   * @param y define the y coordinate of the source vector
   * @param z define the z coordinate of the source vector
   * @param transformation defines the transformation matrix
   * @param result defines the Vector3 where to store the result
   * @returns result input
   */
  static TransformCoordinatesFromFloatsToRef(e, t, i, s, r) {
    const n = s.m, a = e * n[0] + t * n[4] + i * n[8] + n[12], o = e * n[1] + t * n[5] + i * n[9] + n[13], l = e * n[2] + t * n[6] + i * n[10] + n[14], c = 1 / (e * n[3] + t * n[7] + i * n[11] + n[15]);
    return r._x = a * c, r._y = o * c, r._z = l * c, r._isDirty = !0, r;
  }
  /**
   * Returns a new Vector3 set with the result of the normal transformation by the given matrix of the given vector
   * This methods computes transformed normalized direction vectors only (ie. it does not apply translation)
   * Example Playground https://playground.babylonjs.com/#R1F8YU#112
   * @param vector defines the Vector3 to transform
   * @param transformation defines the transformation matrix
   * @returns the new Vector3
   */
  static TransformNormal(e, t) {
    const i = p.Zero();
    return p.TransformNormalToRef(e, t, i), i;
  }
  /**
   * Sets the given vector "result" with the result of the normal transformation by the given matrix of the given vector
   * This methods computes transformed normalized direction vectors only (ie. it does not apply translation)
   * Example Playground https://playground.babylonjs.com/#R1F8YU#114
   * @param vector defines the Vector3 to transform
   * @param transformation defines the transformation matrix
   * @param result defines the Vector3 where to store the result
   * @returns result input
   */
  static TransformNormalToRef(e, t, i) {
    return this.TransformNormalFromFloatsToRef(e._x, e._y, e._z, t, i), i;
  }
  /**
   * Sets the given vector "result" with the result of the normal transformation by the given matrix of the given floats (x, y, z)
   * This methods computes transformed normalized direction vectors only (ie. it does not apply translation)
   * Example Playground https://playground.babylonjs.com/#R1F8YU#116
   * @param x define the x coordinate of the source vector
   * @param y define the y coordinate of the source vector
   * @param z define the z coordinate of the source vector
   * @param transformation defines the transformation matrix
   * @param result defines the Vector3 where to store the result
   * @returns result input
   */
  static TransformNormalFromFloatsToRef(e, t, i, s, r) {
    const n = s.m;
    return r._x = e * n[0] + t * n[4] + i * n[8], r._y = e * n[1] + t * n[5] + i * n[9], r._z = e * n[2] + t * n[6] + i * n[10], r._isDirty = !0, r;
  }
  /**
   * Returns a new Vector3 located for "amount" on the CatmullRom interpolation spline defined by the vectors "value1", "value2", "value3", "value4"
   * Example Playground https://playground.babylonjs.com/#R1F8YU#69
   * @param value1 defines the first control point
   * @param value2 defines the second control point
   * @param value3 defines the third control point
   * @param value4 defines the fourth control point
   * @param amount defines the amount on the spline to use
   * @returns the new Vector3
   */
  static CatmullRom(e, t, i, s, r) {
    const n = r * r, a = r * n, o = 0.5 * (2 * t._x + (-e._x + i._x) * r + (2 * e._x - 5 * t._x + 4 * i._x - s._x) * n + (-e._x + 3 * t._x - 3 * i._x + s._x) * a), l = 0.5 * (2 * t._y + (-e._y + i._y) * r + (2 * e._y - 5 * t._y + 4 * i._y - s._y) * n + (-e._y + 3 * t._y - 3 * i._y + s._y) * a), c = 0.5 * (2 * t._z + (-e._z + i._z) * r + (2 * e._z - 5 * t._z + 4 * i._z - s._z) * n + (-e._z + 3 * t._z - 3 * i._z + s._z) * a);
    return new e.constructor(o, l, c);
  }
  /**
   * Returns a new Vector3 set with the coordinates of "value", if the vector "value" is in the cube defined by the vectors "min" and "max"
   * If a coordinate value of "value" is lower than one of the "min" coordinate, then this "value" coordinate is set with the "min" one
   * If a coordinate value of "value" is greater than one of the "max" coordinate, then this "value" coordinate is set with the "max" one
   * Example Playground https://playground.babylonjs.com/#R1F8YU#76
   * @param value defines the current value
   * @param min defines the lower range value
   * @param max defines the upper range value
   * @returns the new Vector3
   */
  static Clamp(e, t, i) {
    const s = new e.constructor();
    return p.ClampToRef(e, t, i, s), s;
  }
  /**
   * Sets the given vector "result" with the coordinates of "value", if the vector "value" is in the cube defined by the vectors "min" and "max"
   * If a coordinate value of "value" is lower than one of the "min" coordinate, then this "value" coordinate is set with the "min" one
   * If a coordinate value of "value" is greater than one of the "max" coordinate, then this "value" coordinate is set with the "max" one
   * Example Playground https://playground.babylonjs.com/#R1F8YU#77
   * @param value defines the current value
   * @param min defines the lower range value
   * @param max defines the upper range value
   * @param result defines the Vector3 where to store the result
   * @returns result input
   */
  static ClampToRef(e, t, i, s) {
    let r = e._x;
    r = r > i._x ? i._x : r, r = r < t._x ? t._x : r;
    let n = e._y;
    n = n > i._y ? i._y : n, n = n < t._y ? t._y : n;
    let a = e._z;
    return a = a > i._z ? i._z : a, a = a < t._z ? t._z : a, s.copyFromFloats(r, n, a), s;
  }
  /**
   * Checks if a given vector is inside a specific range
   * Example Playground https://playground.babylonjs.com/#R1F8YU#75
   * @param v defines the vector to test
   * @param min defines the minimum range
   * @param max defines the maximum range
   */
  static CheckExtends(e, t, i) {
    t.minimizeInPlace(e), i.maximizeInPlace(e);
  }
  /**
   * Returns a new Vector3 located for "amount" (float) on the Hermite interpolation spline defined by the vectors "value1", "tangent1", "value2", "tangent2"
   * Example Playground https://playground.babylonjs.com/#R1F8YU#89
   * @param value1 defines the first control point
   * @param tangent1 defines the first tangent vector
   * @param value2 defines the second control point
   * @param tangent2 defines the second tangent vector
   * @param amount defines the amount on the interpolation spline (between 0 and 1)
   * @returns the new Vector3
   */
  static Hermite(e, t, i, s, r) {
    const n = r * r, a = r * n, o = 2 * a - 3 * n + 1, l = -2 * a + 3 * n, c = a - 2 * n + r, u = a - n, d = e._x * o + i._x * l + t._x * c + s._x * u, f = e._y * o + i._y * l + t._y * c + s._y * u, _ = e._z * o + i._z * l + t._z * c + s._z * u;
    return new e.constructor(d, f, _);
  }
  /**
   * Returns a new Vector3 which is the 1st derivative of the Hermite spline defined by the vectors "value1", "value2", "tangent1", "tangent2".
   * Example Playground https://playground.babylonjs.com/#R1F8YU#90
   * @param value1 defines the first control point
   * @param tangent1 defines the first tangent
   * @param value2 defines the second control point
   * @param tangent2 defines the second tangent
   * @param time define where the derivative must be done
   * @returns 1st derivative
   */
  static Hermite1stDerivative(e, t, i, s, r) {
    const n = new e.constructor();
    return this.Hermite1stDerivativeToRef(e, t, i, s, r, n), n;
  }
  /**
   * Update a Vector3 with the 1st derivative of the Hermite spline defined by the vectors "value1", "value2", "tangent1", "tangent2".
   * Example Playground https://playground.babylonjs.com/#R1F8YU#91
   * @param value1 defines the first control point
   * @param tangent1 defines the first tangent
   * @param value2 defines the second control point
   * @param tangent2 defines the second tangent
   * @param time define where the derivative must be done
   * @param result define where to store the derivative
   * @returns result input
   */
  static Hermite1stDerivativeToRef(e, t, i, s, r, n) {
    const a = r * r;
    return n._x = (a - r) * 6 * e._x + (3 * a - 4 * r + 1) * t._x + (-a + r) * 6 * i._x + (3 * a - 2 * r) * s._x, n._y = (a - r) * 6 * e._y + (3 * a - 4 * r + 1) * t._y + (-a + r) * 6 * i._y + (3 * a - 2 * r) * s._y, n._z = (a - r) * 6 * e._z + (3 * a - 4 * r + 1) * t._z + (-a + r) * 6 * i._z + (3 * a - 2 * r) * s._z, n._isDirty = !0, n;
  }
  /**
   * Returns a new Vector3 located for "amount" (float) on the linear interpolation between the vectors "start" and "end"
   * Example Playground https://playground.babylonjs.com/#R1F8YU#95
   * @param start defines the start value
   * @param end defines the end value
   * @param amount max defines amount between both (between 0 and 1)
   * @returns the new Vector3
   */
  static Lerp(e, t, i) {
    const s = new e.constructor(0, 0, 0);
    return p.LerpToRef(e, t, i, s), s;
  }
  /**
   * Sets the given vector "result" with the result of the linear interpolation from the vector "start" for "amount" to the vector "end"
   * Example Playground https://playground.babylonjs.com/#R1F8YU#93
   * @param start defines the start value
   * @param end defines the end value
   * @param amount max defines amount between both (between 0 and 1)
   * @param result defines the Vector3 where to store the result
   * @returns result input
   */
  static LerpToRef(e, t, i, s) {
    return s._x = e._x + (t._x - e._x) * i, s._y = e._y + (t._y - e._y) * i, s._z = e._z + (t._z - e._z) * i, s._isDirty = !0, s;
  }
  /**
   * Returns the dot product (float) between the vectors "left" and "right"
   * Example Playground https://playground.babylonjs.com/#R1F8YU#82
   * @param left defines the left operand
   * @param right defines the right operand
   * @returns the dot product
   */
  static Dot(e, t) {
    return e._x * t._x + e._y * t._y + e._z * t._z;
  }
  /**
   * Returns a new Vector3 as the cross product of the vectors "left" and "right"
   * The cross product is then orthogonal to both "left" and "right"
   * Example Playground https://playground.babylonjs.com/#R1F8YU#15
   * @param left defines the left operand
   * @param right defines the right operand
   * @returns the cross product
   */
  static Cross(e, t) {
    const i = new e.constructor();
    return p.CrossToRef(e, t, i), i;
  }
  /**
   * Sets the given vector "result" with the cross product of "left" and "right"
   * The cross product is then orthogonal to both "left" and "right"
   * Example Playground https://playground.babylonjs.com/#R1F8YU#78
   * @param left defines the left operand
   * @param right defines the right operand
   * @param result defines the Vector3 where to store the result
   * @returns result input
   */
  static CrossToRef(e, t, i) {
    const s = e._y * t._z - e._z * t._y, r = e._z * t._x - e._x * t._z, n = e._x * t._y - e._y * t._x;
    return i.copyFromFloats(s, r, n), i;
  }
  /**
   * Returns a new Vector3 as the normalization of the given vector
   * Example Playground https://playground.babylonjs.com/#R1F8YU#98
   * @param vector defines the Vector3 to normalize
   * @returns the new Vector3
   */
  static Normalize(e) {
    const t = p.Zero();
    return p.NormalizeToRef(e, t), t;
  }
  /**
   * Sets the given vector "result" with the normalization of the given first vector
   * Example Playground https://playground.babylonjs.com/#R1F8YU#98
   * @param vector defines the Vector3 to normalize
   * @param result defines the Vector3 where to store the result
   * @returns result input
   */
  static NormalizeToRef(e, t) {
    return e.normalizeToRef(t), t;
  }
  /**
   * Project a Vector3 onto screen space
   * Example Playground https://playground.babylonjs.com/#R1F8YU#101
   * @param vector defines the Vector3 to project
   * @param world defines the world matrix to use
   * @param transform defines the transform (view x projection) matrix to use
   * @param viewport defines the screen viewport to use
   * @returns the new Vector3
   */
  static Project(e, t, i, s) {
    const r = new e.constructor();
    return p.ProjectToRef(e, t, i, s, r), r;
  }
  /**
   * Project a Vector3 onto screen space to reference
   * Example Playground https://playground.babylonjs.com/#R1F8YU#102
   * @param vector defines the Vector3 to project
   * @param world defines the world matrix to use
   * @param transform defines the transform (view x projection) matrix to use
   * @param viewport defines the screen viewport to use
   * @param result the vector in which the screen space will be stored
   * @returns result input
   */
  static ProjectToRef(e, t, i, s, r) {
    const n = s.width, a = s.height, o = s.x, l = s.y, c = te.Matrix[1];
    I.FromValuesToRef(n / 2, 0, 0, 0, 0, -a / 2, 0, 0, 0, 0, 0.5, 0, o + n / 2, a / 2 + l, 0.5, 1, c);
    const u = te.Matrix[0];
    return t.multiplyToRef(i, u), u.multiplyToRef(c, u), p.TransformCoordinatesToRef(e, u, r), r;
  }
  /**
   * Reflects a vector off the plane defined by a normalized normal
   * @param inDirection defines the vector direction
   * @param normal defines the normal - Must be normalized
   * @returns the resulting vector
   */
  static Reflect(e, t) {
    return this.ReflectToRef(e, t, new p());
  }
  /**
   * Reflects a vector off the plane defined by a normalized normal to reference
   * @param inDirection defines the vector direction
   * @param normal defines the normal - Must be normalized
   * @param result defines the Vector3 where to store the result
   * @returns the resulting vector
   */
  static ReflectToRef(e, t, i) {
    const s = C.Vector3[0];
    return s.copyFrom(t).scaleInPlace(2 * p.Dot(e, t)), i.copyFrom(e).subtractInPlace(s);
  }
  /**
   * @internal
   */
  static _UnprojectFromInvertedMatrixToRef(e, t, i) {
    p.TransformCoordinatesToRef(e, t, i);
    const s = t.m, r = e._x * s[3] + e._y * s[7] + e._z * s[11] + s[15];
    return J.WithinEpsilon(r, 1) && i.scaleInPlace(1 / r), i;
  }
  /**
   * Unproject from screen space to object space
   * Example Playground https://playground.babylonjs.com/#R1F8YU#121
   * @param source defines the screen space Vector3 to use
   * @param viewportWidth defines the current width of the viewport
   * @param viewportHeight defines the current height of the viewport
   * @param world defines the world matrix to use (can be set to Identity to go to world space)
   * @param transform defines the transform (view x projection) matrix to use
   * @returns the new Vector3
   */
  static UnprojectFromTransform(e, t, i, s, r) {
    return this.Unproject(e, t, i, s, r, I.IdentityReadOnly);
  }
  /**
   * Unproject from screen space to object space
   * Example Playground https://playground.babylonjs.com/#R1F8YU#117
   * @param source defines the screen space Vector3 to use
   * @param viewportWidth defines the current width of the viewport
   * @param viewportHeight defines the current height of the viewport
   * @param world defines the world matrix to use (can be set to Identity to go to world space)
   * @param view defines the view matrix to use
   * @param projection defines the projection matrix to use
   * @returns the new Vector3
   */
  static Unproject(e, t, i, s, r, n) {
    const a = new e.constructor();
    return p.UnprojectToRef(e, t, i, s, r, n, a), a;
  }
  /**
   * Unproject from screen space to object space
   * Example Playground https://playground.babylonjs.com/#R1F8YU#119
   * @param source defines the screen space Vector3 to use
   * @param viewportWidth defines the current width of the viewport
   * @param viewportHeight defines the current height of the viewport
   * @param world defines the world matrix to use (can be set to Identity to go to world space)
   * @param view defines the view matrix to use
   * @param projection defines the projection matrix to use
   * @param result defines the Vector3 where to store the result
   * @returns result input
   */
  static UnprojectToRef(e, t, i, s, r, n, a) {
    return p.UnprojectFloatsToRef(e._x, e._y, e._z, t, i, s, r, n, a), a;
  }
  /**
   * Unproject from screen space to object space
   * Example Playground https://playground.babylonjs.com/#R1F8YU#120
   * @param sourceX defines the screen space x coordinate to use
   * @param sourceY defines the screen space y coordinate to use
   * @param sourceZ defines the screen space z coordinate to use
   * @param viewportWidth defines the current width of the viewport
   * @param viewportHeight defines the current height of the viewport
   * @param world defines the world matrix to use (can be set to Identity to go to world space)
   * @param view defines the view matrix to use
   * @param projection defines the projection matrix to use
   * @param result defines the Vector3 where to store the result
   * @returns result input
   */
  static UnprojectFloatsToRef(e, t, i, s, r, n, a, o, l) {
    var c;
    const u = te.Matrix[0];
    n.multiplyToRef(a, u), u.multiplyToRef(o, u), u.invert();
    const d = te.Vector3[0];
    return d.x = e / s * 2 - 1, d.y = -(t / r * 2 - 1), !((c = de.LastCreatedEngine) === null || c === void 0) && c.isNDCHalfZRange ? d.z = i : d.z = 2 * i - 1, p._UnprojectFromInvertedMatrixToRef(d, u, l), l;
  }
  /**
   * Gets the minimal coordinate values between two Vector3
   * Example Playground https://playground.babylonjs.com/#R1F8YU#97
   * @param left defines the first operand
   * @param right defines the second operand
   * @returns the new Vector3
   */
  static Minimize(e, t) {
    const i = new e.constructor();
    return i.copyFrom(e), i.minimizeInPlace(t), i;
  }
  /**
   * Gets the maximal coordinate values between two Vector3
   * Example Playground https://playground.babylonjs.com/#R1F8YU#96
   * @param left defines the first operand
   * @param right defines the second operand
   * @returns the new Vector3
   */
  static Maximize(e, t) {
    const i = new e.constructor();
    return i.copyFrom(e), i.maximizeInPlace(t), i;
  }
  /**
   * Returns the distance between the vectors "value1" and "value2"
   * Example Playground https://playground.babylonjs.com/#R1F8YU#81
   * @param value1 defines the first operand
   * @param value2 defines the second operand
   * @returns the distance
   */
  static Distance(e, t) {
    return Math.sqrt(p.DistanceSquared(e, t));
  }
  /**
   * Returns the squared distance between the vectors "value1" and "value2"
   * Example Playground https://playground.babylonjs.com/#R1F8YU#80
   * @param value1 defines the first operand
   * @param value2 defines the second operand
   * @returns the squared distance
   */
  static DistanceSquared(e, t) {
    const i = e._x - t._x, s = e._y - t._y, r = e._z - t._z;
    return i * i + s * s + r * r;
  }
  /**
   * Projects "vector" on the triangle determined by its extremities "p0", "p1" and "p2", stores the result in "ref"
   * and returns the distance to the projected point.
   * Example Playground https://playground.babylonjs.com/#R1F8YU#104
   * From http://citeseerx.ist.psu.edu/viewdoc/download?doi=10.1.1.104.4264&rep=rep1&type=pdf
   *
   * @param vector the vector to get distance from
   * @param p0 extremity of the triangle
   * @param p1 extremity of the triangle
   * @param p2 extremity of the triangle
   * @param ref variable to store the result to
   * @returns The distance between "ref" and "vector"
   */
  static ProjectOnTriangleToRef(e, t, i, s, r) {
    const n = te.Vector3[0], a = te.Vector3[1], o = te.Vector3[2], l = te.Vector3[3], c = te.Vector3[4];
    i.subtractToRef(t, n), s.subtractToRef(t, a), s.subtractToRef(i, o);
    const u = n.length(), d = a.length(), f = o.length();
    if (u < pe || d < pe || f < pe)
      return r.copyFrom(t), p.Distance(e, t);
    e.subtractToRef(t, c), p.CrossToRef(n, a, l);
    const _ = l.length();
    if (_ < pe)
      return r.copyFrom(t), p.Distance(e, t);
    l.normalizeFromLength(_);
    let g = c.length();
    if (g < pe)
      return r.copyFrom(t), 0;
    c.normalizeFromLength(g);
    const m = p.Dot(l, c), y = te.Vector3[5], x = te.Vector3[6];
    y.copyFrom(l).scaleInPlace(-g * m), x.copyFrom(e).addInPlace(y);
    const A = te.Vector3[4], T = te.Vector3[5], M = te.Vector3[7], b = te.Vector3[8];
    A.copyFrom(n).scaleInPlace(1 / u), b.copyFrom(a).scaleInPlace(1 / d), A.addInPlace(b).scaleInPlace(-1), T.copyFrom(n).scaleInPlace(-1 / u), b.copyFrom(o).scaleInPlace(1 / f), T.addInPlace(b).scaleInPlace(-1), M.copyFrom(o).scaleInPlace(-1 / f), b.copyFrom(a).scaleInPlace(-1 / d), M.addInPlace(b).scaleInPlace(-1);
    const S = te.Vector3[9];
    let P;
    S.copyFrom(x).subtractInPlace(t), p.CrossToRef(A, S, b), P = p.Dot(b, l);
    const D = P;
    S.copyFrom(x).subtractInPlace(i), p.CrossToRef(T, S, b), P = p.Dot(b, l);
    const O = P;
    S.copyFrom(x).subtractInPlace(s), p.CrossToRef(M, S, b), P = p.Dot(b, l);
    const X = P, k = te.Vector3[10];
    let Y, se;
    D > 0 && O < 0 ? (k.copyFrom(n), Y = t, se = i) : O > 0 && X < 0 ? (k.copyFrom(o), Y = i, se = s) : (k.copyFrom(a).scaleInPlace(-1), Y = s, se = t);
    const Te = te.Vector3[9], ve = te.Vector3[4];
    if (Y.subtractToRef(x, b), se.subtractToRef(x, Te), p.CrossToRef(b, Te, ve), !(p.Dot(ve, l) < 0))
      return r.copyFrom(x), Math.abs(g * m);
    const Ne = te.Vector3[5];
    p.CrossToRef(k, ve, Ne), Ne.normalize();
    const ke = te.Vector3[9];
    ke.copyFrom(Y).subtractInPlace(x);
    const Se = ke.length();
    if (Se < pe)
      return r.copyFrom(Y), p.Distance(e, Y);
    ke.normalizeFromLength(Se);
    const Be = p.Dot(Ne, ke), Me = te.Vector3[7];
    Me.copyFrom(x).addInPlace(Ne.scaleInPlace(Se * Be)), b.copyFrom(Me).subtractInPlace(Y), g = k.length(), k.normalizeFromLength(g);
    let je = p.Dot(b, k) / Math.max(g, pe);
    return je = J.Clamp(je, 0, 1), Me.copyFrom(Y).addInPlace(k.scaleInPlace(je * g)), r.copyFrom(Me), p.Distance(e, Me);
  }
  /**
   * Returns a new Vector3 located at the center between "value1" and "value2"
   * Example Playground https://playground.babylonjs.com/#R1F8YU#72
   * @param value1 defines the first operand
   * @param value2 defines the second operand
   * @returns the new Vector3
   */
  static Center(e, t) {
    return p.CenterToRef(e, t, p.Zero());
  }
  /**
   * Gets the center of the vectors "value1" and "value2" and stores the result in the vector "ref"
   * Example Playground https://playground.babylonjs.com/#R1F8YU#73
   * @param value1 defines first vector
   * @param value2 defines second vector
   * @param ref defines third vector
   * @returns ref
   */
  static CenterToRef(e, t, i) {
    return i.copyFromFloats((e._x + t._x) / 2, (e._y + t._y) / 2, (e._z + t._z) / 2);
  }
  /**
   * Given three orthogonal normalized left-handed oriented Vector3 axis in space (target system),
   * RotationFromAxis() returns the rotation Euler angles (ex : rotation.x, rotation.y, rotation.z) to apply
   * to something in order to rotate it from its local system to the given target system
   * Note: axis1, axis2 and axis3 are normalized during this operation
   * Example Playground https://playground.babylonjs.com/#R1F8YU#106
   * @param axis1 defines the first axis
   * @param axis2 defines the second axis
   * @param axis3 defines the third axis
   * @returns a new Vector3
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/center_origin/target_align
   */
  static RotationFromAxis(e, t, i) {
    const s = new e.constructor();
    return p.RotationFromAxisToRef(e, t, i, s), s;
  }
  /**
   * The same than RotationFromAxis but updates the given ref Vector3 parameter instead of returning a new Vector3
   * Example Playground https://playground.babylonjs.com/#R1F8YU#107
   * @param axis1 defines the first axis
   * @param axis2 defines the second axis
   * @param axis3 defines the third axis
   * @param ref defines the Vector3 where to store the result
   * @returns result input
   */
  static RotationFromAxisToRef(e, t, i, s) {
    const r = te.Quaternion[0];
    return U.RotationQuaternionFromAxisToRef(e, t, i, r), r.toEulerAnglesToRef(s), s;
  }
}
p._UpReadOnly = p.Up();
p._DownReadOnly = p.Down();
p._LeftHandedForwardReadOnly = p.Forward(!1);
p._RightHandedForwardReadOnly = p.Forward(!0);
p._LeftHandedBackwardReadOnly = p.Backward(!1);
p._RightHandedBackwardReadOnly = p.Backward(!0);
p._RightReadOnly = p.Right();
p._LeftReadOnly = p.Left();
p._ZeroReadOnly = p.Zero();
p._OneReadOnly = p.One();
class ze {
  /**
   * Creates a Vector4 object from the given floats.
   * @param x x value of the vector
   * @param y y value of the vector
   * @param z z value of the vector
   * @param w w value of the vector
   */
  constructor(e = 0, t = 0, i = 0, s = 0) {
    this.x = e, this.y = t, this.z = i, this.w = s;
  }
  /**
   * Returns the string with the Vector4 coordinates.
   * @returns a string containing all the vector values
   */
  toString() {
    return `{X: ${this.x} Y: ${this.y} Z: ${this.z} W: ${this.w}}`;
  }
  /**
   * Returns the string "Vector4".
   * @returns "Vector4"
   */
  getClassName() {
    return "Vector4";
  }
  /**
   * Returns the Vector4 hash code.
   * @returns a unique hash code
   */
  getHashCode() {
    const e = Bt(this.x), t = Bt(this.y), i = Bt(this.z), s = Bt(this.w);
    let r = e;
    return r = r * 397 ^ t, r = r * 397 ^ i, r = r * 397 ^ s, r;
  }
  // Operators
  /**
   * Returns a new array populated with 4 elements : the Vector4 coordinates.
   * @returns the resulting array
   */
  asArray() {
    const e = new Array();
    return this.toArray(e, 0), e;
  }
  /**
   * Populates the given array from the given index with the Vector4 coordinates.
   * @param array array to populate
   * @param index index of the array to start at (default: 0)
   * @returns the Vector4.
   */
  toArray(e, t) {
    return t === void 0 && (t = 0), e[t] = this.x, e[t + 1] = this.y, e[t + 2] = this.z, e[t + 3] = this.w, this;
  }
  /**
   * Update the current vector from an array
   * @param array defines the destination array
   * @param index defines the offset in the destination array
   * @returns the current Vector3
   */
  fromArray(e, t = 0) {
    return ze.FromArrayToRef(e, t, this), this;
  }
  /**
   * Adds the given vector to the current Vector4.
   * @param otherVector the vector to add
   * @returns the updated Vector4.
   */
  addInPlace(e) {
    return this.x += e.x, this.y += e.y, this.z += e.z, this.w += e.w, this;
  }
  /**
   * Returns a new Vector4 as the result of the addition of the current Vector4 and the given one.
   * @param otherVector the vector to add
   * @returns the resulting vector
   */
  add(e) {
    return new this.constructor(this.x + e.x, this.y + e.y, this.z + e.z, this.w + e.w);
  }
  /**
   * Updates the given vector "result" with the result of the addition of the current Vector4 and the given one.
   * @param otherVector the vector to add
   * @param result the vector to store the result
   * @returns result input
   */
  addToRef(e, t) {
    return t.x = this.x + e.x, t.y = this.y + e.y, t.z = this.z + e.z, t.w = this.w + e.w, t;
  }
  /**
   * Subtract in place the given vector from the current Vector4.
   * @param otherVector the vector to subtract
   * @returns the updated Vector4.
   */
  subtractInPlace(e) {
    return this.x -= e.x, this.y -= e.y, this.z -= e.z, this.w -= e.w, this;
  }
  /**
   * Returns a new Vector4 with the result of the subtraction of the given vector from the current Vector4.
   * @param otherVector the vector to add
   * @returns the new vector with the result
   */
  subtract(e) {
    return new this.constructor(this.x - e.x, this.y - e.y, this.z - e.z, this.w - e.w);
  }
  /**
   * Sets the given vector "result" with the result of the subtraction of the given vector from the current Vector4.
   * @param otherVector the vector to subtract
   * @param result the vector to store the result
   * @returns result input
   */
  subtractToRef(e, t) {
    return t.x = this.x - e.x, t.y = this.y - e.y, t.z = this.z - e.z, t.w = this.w - e.w, t;
  }
  /**
   * Returns a new Vector4 set with the result of the subtraction of the given floats from the current Vector4 coordinates.
   */
  /**
   * Returns a new Vector4 set with the result of the subtraction of the given floats from the current Vector4 coordinates.
   * @param x value to subtract
   * @param y value to subtract
   * @param z value to subtract
   * @param w value to subtract
   * @returns new vector containing the result
   */
  subtractFromFloats(e, t, i, s) {
    return new this.constructor(this.x - e, this.y - t, this.z - i, this.w - s);
  }
  /**
   * Sets the given vector "result" set with the result of the subtraction of the given floats from the current Vector4 coordinates.
   * @param x value to subtract
   * @param y value to subtract
   * @param z value to subtract
   * @param w value to subtract
   * @param result the vector to store the result in
   * @returns result input
   */
  subtractFromFloatsToRef(e, t, i, s, r) {
    return r.x = this.x - e, r.y = this.y - t, r.z = this.z - i, r.w = this.w - s, r;
  }
  /**
   * Returns a new Vector4 set with the current Vector4 negated coordinates.
   * @returns a new vector with the negated values
   */
  negate() {
    return new this.constructor(-this.x, -this.y, -this.z, -this.w);
  }
  /**
   * Negate this vector in place
   * @returns this
   */
  negateInPlace() {
    return this.x *= -1, this.y *= -1, this.z *= -1, this.w *= -1, this;
  }
  /**
   * Negate the current Vector4 and stores the result in the given vector "result" coordinates
   * @param result defines the Vector3 object where to store the result
   * @returns the result
   */
  negateToRef(e) {
    return e.copyFromFloats(this.x * -1, this.y * -1, this.z * -1, this.w * -1);
  }
  /**
   * Multiplies the current Vector4 coordinates by scale (float).
   * @param scale the number to scale with
   * @returns the updated Vector4.
   */
  scaleInPlace(e) {
    return this.x *= e, this.y *= e, this.z *= e, this.w *= e, this;
  }
  /**
   * Returns a new Vector4 set with the current Vector4 coordinates multiplied by scale (float).
   * @param scale the number to scale with
   * @returns a new vector with the result
   */
  scale(e) {
    return new this.constructor(this.x * e, this.y * e, this.z * e, this.w * e);
  }
  /**
   * Sets the given vector "result" with the current Vector4 coordinates multiplied by scale (float).
   * @param scale the number to scale with
   * @param result a vector to store the result in
   * @returns result input
   */
  scaleToRef(e, t) {
    return t.x = this.x * e, t.y = this.y * e, t.z = this.z * e, t.w = this.w * e, t;
  }
  /**
   * Scale the current Vector4 values by a factor and add the result to a given Vector4
   * @param scale defines the scale factor
   * @param result defines the Vector4 object where to store the result
   * @returns result input
   */
  scaleAndAddToRef(e, t) {
    return t.x += this.x * e, t.y += this.y * e, t.z += this.z * e, t.w += this.w * e, t;
  }
  /**
   * Boolean : True if the current Vector4 coordinates are stricly equal to the given ones.
   * @param otherVector the vector to compare against
   * @returns true if they are equal
   */
  equals(e) {
    return e && this.x === e.x && this.y === e.y && this.z === e.z && this.w === e.w;
  }
  /**
   * Boolean : True if the current Vector4 coordinates are each beneath the distance "epsilon" from the given vector ones.
   * @param otherVector vector to compare against
   * @param epsilon (Default: very small number)
   * @returns true if they are equal
   */
  equalsWithEpsilon(e, t = pe) {
    return e && J.WithinEpsilon(this.x, e.x, t) && J.WithinEpsilon(this.y, e.y, t) && J.WithinEpsilon(this.z, e.z, t) && J.WithinEpsilon(this.w, e.w, t);
  }
  /**
   * Boolean : True if the given floats are strictly equal to the current Vector4 coordinates.
   * @param x x value to compare against
   * @param y y value to compare against
   * @param z z value to compare against
   * @param w w value to compare against
   * @returns true if equal
   */
  equalsToFloats(e, t, i, s) {
    return this.x === e && this.y === t && this.z === i && this.w === s;
  }
  /**
   * Multiplies in place the current Vector4 by the given one.
   * @param otherVector vector to multiple with
   * @returns the updated Vector4.
   */
  multiplyInPlace(e) {
    return this.x *= e.x, this.y *= e.y, this.z *= e.z, this.w *= e.w, this;
  }
  /**
   * Returns a new Vector4 set with the multiplication result of the current Vector4 and the given one.
   * @param otherVector vector to multiple with
   * @returns resulting new vector
   */
  multiply(e) {
    return new this.constructor(this.x * e.x, this.y * e.y, this.z * e.z, this.w * e.w);
  }
  /**
   * Updates the given vector "result" with the multiplication result of the current Vector4 and the given one.
   * @param otherVector vector to multiple with
   * @param result vector to store the result
   * @returns result input
   */
  multiplyToRef(e, t) {
    return t.x = this.x * e.x, t.y = this.y * e.y, t.z = this.z * e.z, t.w = this.w * e.w, t;
  }
  /**
   * Returns a new Vector4 set with the multiplication result of the given floats and the current Vector4 coordinates.
   * @param x x value multiply with
   * @param y y value multiply with
   * @param z z value multiply with
   * @param w w value multiply with
   * @returns resulting new vector
   */
  multiplyByFloats(e, t, i, s) {
    return new this.constructor(this.x * e, this.y * t, this.z * i, this.w * s);
  }
  /**
   * Returns a new Vector4 set with the division result of the current Vector4 by the given one.
   * @param otherVector vector to devide with
   * @returns resulting new vector
   */
  divide(e) {
    return new this.constructor(this.x / e.x, this.y / e.y, this.z / e.z, this.w / e.w);
  }
  /**
   * Updates the given vector "result" with the division result of the current Vector4 by the given one.
   * @param otherVector vector to devide with
   * @param result vector to store the result
   * @returns result input
   */
  divideToRef(e, t) {
    return t.x = this.x / e.x, t.y = this.y / e.y, t.z = this.z / e.z, t.w = this.w / e.w, t;
  }
  /**
   * Divides the current Vector3 coordinates by the given ones.
   * @param otherVector vector to devide with
   * @returns the updated Vector3.
   */
  divideInPlace(e) {
    return this.divideToRef(e, this);
  }
  /**
   * Updates the Vector4 coordinates with the minimum values between its own and the given vector ones
   * @param other defines the second operand
   * @returns the current updated Vector4
   */
  minimizeInPlace(e) {
    return e.x < this.x && (this.x = e.x), e.y < this.y && (this.y = e.y), e.z < this.z && (this.z = e.z), e.w < this.w && (this.w = e.w), this;
  }
  /**
   * Updates the Vector4 coordinates with the maximum values between its own and the given vector ones
   * @param other defines the second operand
   * @returns the current updated Vector4
   */
  maximizeInPlace(e) {
    return e.x > this.x && (this.x = e.x), e.y > this.y && (this.y = e.y), e.z > this.z && (this.z = e.z), e.w > this.w && (this.w = e.w), this;
  }
  /**
   * Gets a new Vector4 from current Vector4 floored values
   * @returns a new Vector4
   */
  floor() {
    return new this.constructor(Math.floor(this.x), Math.floor(this.y), Math.floor(this.z), Math.floor(this.w));
  }
  /**
   * Gets a new Vector4 from current Vector4 fractional values
   * @returns a new Vector4
   */
  fract() {
    return new this.constructor(this.x - Math.floor(this.x), this.y - Math.floor(this.y), this.z - Math.floor(this.z), this.w - Math.floor(this.w));
  }
  // Properties
  /**
   * Returns the Vector4 length (float).
   * @returns the length
   */
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
  }
  /**
   * Returns the Vector4 squared length (float).
   * @returns the length squared
   */
  lengthSquared() {
    return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
  }
  // Methods
  /**
   * Normalizes in place the Vector4.
   * @returns the updated Vector4.
   */
  normalize() {
    const e = this.length();
    return e === 0 ? this : this.scaleInPlace(1 / e);
  }
  /**
   * Returns a new Vector3 from the Vector4 (x, y, z) coordinates.
   * @returns this converted to a new vector3
   */
  toVector3() {
    return new p(this.x, this.y, this.z);
  }
  /**
   * Returns a new Vector4 copied from the current one.
   * @returns the new cloned vector
   */
  clone() {
    return new this.constructor(this.x, this.y, this.z, this.w);
  }
  /**
   * Updates the current Vector4 with the given one coordinates.
   * @param source the source vector to copy from
   * @returns the updated Vector4.
   */
  copyFrom(e) {
    return this.x = e.x, this.y = e.y, this.z = e.z, this.w = e.w, this;
  }
  /**
   * Updates the current Vector4 coordinates with the given floats.
   * @param x float to copy from
   * @param y float to copy from
   * @param z float to copy from
   * @param w float to copy from
   * @returns the updated Vector4.
   */
  copyFromFloats(e, t, i, s) {
    return this.x = e, this.y = t, this.z = i, this.w = s, this;
  }
  /**
   * Updates the current Vector4 coordinates with the given floats.
   * @param x float to set from
   * @param y float to set from
   * @param z float to set from
   * @param w float to set from
   * @returns the updated Vector4.
   */
  set(e, t, i, s) {
    return this.copyFromFloats(e, t, i, s);
  }
  /**
   * Copies the given float to the current Vector3 coordinates
   * @param v defines the x, y, z and w coordinates of the operand
   * @returns the current updated Vector3
   */
  setAll(e) {
    return this.x = this.y = this.z = this.w = e, this;
  }
  // Statics
  /**
   * Returns a new Vector4 set from the starting index of the given array.
   * @param array the array to pull values from
   * @param offset the offset into the array to start at
   * @returns the new vector
   */
  static FromArray(e, t) {
    return t || (t = 0), new ze(e[t], e[t + 1], e[t + 2], e[t + 3]);
  }
  /**
   * Updates the given vector "result" from the starting index of the given array.
   * @param array the array to pull values from
   * @param offset the offset into the array to start at
   * @param result the vector to store the result in
   * @returns result input
   */
  static FromArrayToRef(e, t, i) {
    return i.x = e[t], i.y = e[t + 1], i.z = e[t + 2], i.w = e[t + 3], i;
  }
  /**
   * Updates the given vector "result" from the starting index of the given Float32Array.
   * @param array the array to pull values from
   * @param offset the offset into the array to start at
   * @param result the vector to store the result in
   * @returns result input
   */
  static FromFloatArrayToRef(e, t, i) {
    return ze.FromArrayToRef(e, t, i), i;
  }
  /**
   * Updates the given vector "result" coordinates from the given floats.
   * @param x float to set from
   * @param y float to set from
   * @param z float to set from
   * @param w float to set from
   * @param result the vector to the floats in
   * @returns result input
   */
  static FromFloatsToRef(e, t, i, s, r) {
    return r.x = e, r.y = t, r.z = i, r.w = s, r;
  }
  /**
   * Returns a new Vector4 set to (0.0, 0.0, 0.0, 0.0)
   * @returns the new vector
   */
  static Zero() {
    return new ze(0, 0, 0, 0);
  }
  /**
   * Returns a new Vector4 set to (1.0, 1.0, 1.0, 1.0)
   * @returns the new vector
   */
  static One() {
    return new ze(1, 1, 1, 1);
  }
  /**
   * Returns a new Vector4 with random values between min and max
   * @param min the minimum random value
   * @param max the maximum random value
   * @returns a Vector4 with random values between min and max
   */
  static Random(e = 0, t = 1) {
    return new ze(J.RandomRange(e, t), J.RandomRange(e, t), J.RandomRange(e, t), J.RandomRange(e, t));
  }
  /**
   * Gets a zero Vector4 that must not be updated
   */
  static get ZeroReadOnly() {
    return ze._ZeroReadOnly;
  }
  /**
   * Returns a new normalized Vector4 from the given one.
   * @param vector the vector to normalize
   * @returns the vector
   */
  static Normalize(e) {
    const t = ze.Zero();
    return ze.NormalizeToRef(e, t), t;
  }
  /**
   * Updates the given vector "result" from the normalization of the given one.
   * @param vector the vector to normalize
   * @param result the vector to store the result in
   * @returns result input
   */
  static NormalizeToRef(e, t) {
    return t.copyFrom(e), t.normalize(), t;
  }
  /**
   * Returns a vector with the minimum values from the left and right vectors
   * @param left left vector to minimize
   * @param right right vector to minimize
   * @returns a new vector with the minimum of the left and right vector values
   */
  static Minimize(e, t) {
    const i = new e.constructor();
    return i.copyFrom(e), i.minimizeInPlace(t), i;
  }
  /**
   * Returns a vector with the maximum values from the left and right vectors
   * @param left left vector to maximize
   * @param right right vector to maximize
   * @returns a new vector with the maximum of the left and right vector values
   */
  static Maximize(e, t) {
    const i = new e.constructor();
    return i.copyFrom(e), i.maximizeInPlace(t), i;
  }
  /**
   * Returns the distance (float) between the vectors "value1" and "value2".
   * @param value1 value to calulate the distance between
   * @param value2 value to calulate the distance between
   * @returns the distance between the two vectors
   */
  static Distance(e, t) {
    return Math.sqrt(ze.DistanceSquared(e, t));
  }
  /**
   * Returns the squared distance (float) between the vectors "value1" and "value2".
   * @param value1 value to calulate the distance between
   * @param value2 value to calulate the distance between
   * @returns the distance between the two vectors squared
   */
  static DistanceSquared(e, t) {
    const i = e.x - t.x, s = e.y - t.y, r = e.z - t.z, n = e.w - t.w;
    return i * i + s * s + r * r + n * n;
  }
  /**
   * Returns a new Vector4 located at the center between the vectors "value1" and "value2".
   * @param value1 value to calulate the center between
   * @param value2 value to calulate the center between
   * @returns the center between the two vectors
   */
  static Center(e, t) {
    return ze.CenterToRef(e, t, ze.Zero());
  }
  /**
   * Gets the center of the vectors "value1" and "value2" and stores the result in the vector "ref"
   * @param value1 defines first vector
   * @param value2 defines second vector
   * @param ref defines third vector
   * @returns ref
   */
  static CenterToRef(e, t, i) {
    return i.copyFromFloats((e.x + t.x) / 2, (e.y + t.y) / 2, (e.z + t.z) / 2, (e.w + t.w) / 2);
  }
  /**
   * Returns a new Vector4 set with the result of the transformation by the given matrix of the given vector.
   * This method computes tranformed coordinates only, not transformed direction vectors (ie. it takes translation in account)
   * The difference with Vector3.TransformCoordinates is that the w component is not used to divide the other coordinates but is returned in the w coordinate instead
   * @param vector defines the Vector3 to transform
   * @param transformation defines the transformation matrix
   * @returns the transformed Vector4
   */
  static TransformCoordinates(e, t) {
    const i = ze.Zero();
    return ze.TransformCoordinatesToRef(e, t, i), i;
  }
  /**
   * Sets the given vector "result" coordinates with the result of the transformation by the given matrix of the given vector
   * This method computes tranformed coordinates only, not transformed direction vectors (ie. it takes translation in account)
   * The difference with Vector3.TransformCoordinatesToRef is that the w component is not used to divide the other coordinates but is returned in the w coordinate instead
   * @param vector defines the Vector3 to transform
   * @param transformation defines the transformation matrix
   * @param result defines the Vector4 where to store the result
   * @returns result input
   */
  static TransformCoordinatesToRef(e, t, i) {
    return ze.TransformCoordinatesFromFloatsToRef(e._x, e._y, e._z, t, i), i;
  }
  /**
   * Sets the given vector "result" coordinates with the result of the transformation by the given matrix of the given floats (x, y, z)
   * This method computes tranformed coordinates only, not transformed direction vectors
   * The difference with Vector3.TransformCoordinatesFromFloatsToRef is that the w component is not used to divide the other coordinates but is returned in the w coordinate instead
   * @param x define the x coordinate of the source vector
   * @param y define the y coordinate of the source vector
   * @param z define the z coordinate of the source vector
   * @param transformation defines the transformation matrix
   * @param result defines the Vector4 where to store the result
   * @returns result input
   */
  static TransformCoordinatesFromFloatsToRef(e, t, i, s, r) {
    const n = s.m, a = e * n[0] + t * n[4] + i * n[8] + n[12], o = e * n[1] + t * n[5] + i * n[9] + n[13], l = e * n[2] + t * n[6] + i * n[10] + n[14], c = e * n[3] + t * n[7] + i * n[11] + n[15];
    return r.x = a, r.y = o, r.z = l, r.w = c, r;
  }
  /**
   * Returns a new Vector4 set with the result of the normal transformation by the given matrix of the given vector.
   * This methods computes transformed normalized direction vectors only.
   * @param vector the vector to transform
   * @param transformation the transformation matrix to apply
   * @returns the new vector
   */
  static TransformNormal(e, t) {
    const i = new e.constructor();
    return ze.TransformNormalToRef(e, t, i), i;
  }
  /**
   * Sets the given vector "result" with the result of the normal transformation by the given matrix of the given vector.
   * This methods computes transformed normalized direction vectors only.
   * @param vector the vector to transform
   * @param transformation the transformation matrix to apply
   * @param result the vector to store the result in
   * @returns result input
   */
  static TransformNormalToRef(e, t, i) {
    const s = t.m, r = e.x * s[0] + e.y * s[4] + e.z * s[8], n = e.x * s[1] + e.y * s[5] + e.z * s[9], a = e.x * s[2] + e.y * s[6] + e.z * s[10];
    return i.x = r, i.y = n, i.z = a, i.w = e.w, i;
  }
  /**
   * Sets the given vector "result" with the result of the normal transformation by the given matrix of the given floats (x, y, z, w).
   * This methods computes transformed normalized direction vectors only.
   * @param x value to transform
   * @param y value to transform
   * @param z value to transform
   * @param w value to transform
   * @param transformation the transformation matrix to apply
   * @param result the vector to store the results in
   * @returns result input
   */
  static TransformNormalFromFloatsToRef(e, t, i, s, r, n) {
    const a = r.m;
    return n.x = e * a[0] + t * a[4] + i * a[8], n.y = e * a[1] + t * a[5] + i * a[9], n.z = e * a[2] + t * a[6] + i * a[10], n.w = s, n;
  }
  /**
   * Creates a new Vector4 from a Vector3
   * @param source defines the source data
   * @param w defines the 4th component (default is 0)
   * @returns a new Vector4
   */
  static FromVector3(e, t = 0) {
    return new ze(e._x, e._y, e._z, t);
  }
}
ze._ZeroReadOnly = ze.Zero();
class U {
  /** Gets or sets the x coordinate */
  get x() {
    return this._x;
  }
  set x(e) {
    this._x = e, this._isDirty = !0;
  }
  /** Gets or sets the y coordinate */
  get y() {
    return this._y;
  }
  set y(e) {
    this._y = e, this._isDirty = !0;
  }
  /** Gets or sets the z coordinate */
  get z() {
    return this._z;
  }
  set z(e) {
    this._z = e, this._isDirty = !0;
  }
  /** Gets or sets the w coordinate */
  get w() {
    return this._w;
  }
  set w(e) {
    this._w = e, this._isDirty = !0;
  }
  /**
   * Creates a new Quaternion from the given floats
   * @param x defines the first component (0 by default)
   * @param y defines the second component (0 by default)
   * @param z defines the third component (0 by default)
   * @param w defines the fourth component (1.0 by default)
   */
  constructor(e = 0, t = 0, i = 0, s = 1) {
    this._isDirty = !0, this._x = e, this._y = t, this._z = i, this._w = s;
  }
  /**
   * Gets a string representation for the current quaternion
   * @returns a string with the Quaternion coordinates
   */
  toString() {
    return `{X: ${this._x} Y: ${this._y} Z: ${this._z} W: ${this._w}}`;
  }
  /**
   * Gets the class name of the quaternion
   * @returns the string "Quaternion"
   */
  getClassName() {
    return "Quaternion";
  }
  /**
   * Gets a hash code for this quaternion
   * @returns the quaternion hash code
   */
  getHashCode() {
    const e = Bt(this._x), t = Bt(this._y), i = Bt(this._z), s = Bt(this._w);
    let r = e;
    return r = r * 397 ^ t, r = r * 397 ^ i, r = r * 397 ^ s, r;
  }
  /**
   * Copy the quaternion to an array
   * Example Playground https://playground.babylonjs.com/#L49EJ7#13
   * @returns a new array populated with 4 elements from the quaternion coordinates
   */
  asArray() {
    return [this._x, this._y, this._z, this._w];
  }
  /**
   * Stores from the starting index in the given array the Quaternion successive values
   * Example Playground https://playground.babylonjs.com/#L49EJ7#59
   * @param array defines the array where to store the x,y,z,w components
   * @param index defines an optional index in the target array to define where to start storing values
   * @returns the current Quaternion object
   */
  toArray(e, t = 0) {
    return e[t] = this._x, e[t + 1] = this._y, e[t + 2] = this._z, e[t + 3] = this._w, this;
  }
  /**
   * Check if two quaternions are equals
   * Example Playground https://playground.babylonjs.com/#L49EJ7#38
   * @param otherQuaternion defines the second operand
   * @returns true if the current quaternion and the given one coordinates are strictly equals
   */
  equals(e) {
    return e && this._x === e._x && this._y === e._y && this._z === e._z && this._w === e._w;
  }
  /**
   * Gets a boolean if two quaternions are equals (using an epsilon value)
   * Example Playground https://playground.babylonjs.com/#L49EJ7#37
   * @param otherQuaternion defines the other quaternion
   * @param epsilon defines the minimal distance to consider equality
   * @returns true if the given quaternion coordinates are close to the current ones by a distance of epsilon.
   */
  equalsWithEpsilon(e, t = pe) {
    return e && J.WithinEpsilon(this._x, e._x, t) && J.WithinEpsilon(this._y, e._y, t) && J.WithinEpsilon(this._z, e._z, t) && J.WithinEpsilon(this._w, e._w, t);
  }
  /**
   * Clone the current quaternion
   * Example Playground https://playground.babylonjs.com/#L49EJ7#12
   * @returns a new quaternion copied from the current one
   */
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._w);
  }
  /**
   * Copy a quaternion to the current one
   * Example Playground https://playground.babylonjs.com/#L49EJ7#86
   * @param other defines the other quaternion
   * @returns the updated current quaternion
   */
  copyFrom(e) {
    return this._x = e._x, this._y = e._y, this._z = e._z, this._w = e._w, this._isDirty = !0, this;
  }
  /**
   * Updates the current quaternion with the given float coordinates
   * Example Playground https://playground.babylonjs.com/#L49EJ7#87
   * @param x defines the x coordinate
   * @param y defines the y coordinate
   * @param z defines the z coordinate
   * @param w defines the w coordinate
   * @returns the updated current quaternion
   */
  copyFromFloats(e, t, i, s) {
    return this._x = e, this._y = t, this._z = i, this._w = s, this._isDirty = !0, this;
  }
  /**
   * Updates the current quaternion from the given float coordinates
   * Example Playground https://playground.babylonjs.com/#L49EJ7#56
   * @param x defines the x coordinate
   * @param y defines the y coordinate
   * @param z defines the z coordinate
   * @param w defines the w coordinate
   * @returns the updated current quaternion
   */
  set(e, t, i, s) {
    return this.copyFromFloats(e, t, i, s);
  }
  /**
   * Adds two quaternions
   * Example Playground https://playground.babylonjs.com/#L49EJ7#10
   * @param other defines the second operand
   * @returns a new quaternion as the addition result of the given one and the current quaternion
   */
  add(e) {
    return new this.constructor(this._x + e._x, this._y + e._y, this._z + e._z, this._w + e._w);
  }
  /**
   * Add a quaternion to the current one
   * Example Playground https://playground.babylonjs.com/#L49EJ7#11
   * @param other defines the quaternion to add
   * @returns the current quaternion
   */
  addInPlace(e) {
    return this._x += e._x, this._y += e._y, this._z += e._z, this._w += e._w, this._isDirty = !0, this;
  }
  /**
   * Subtract two quaternions
   * Example Playground https://playground.babylonjs.com/#L49EJ7#57
   * @param other defines the second operand
   * @returns a new quaternion as the subtraction result of the given one from the current one
   */
  subtract(e) {
    return new this.constructor(this._x - e._x, this._y - e._y, this._z - e._z, this._w - e._w);
  }
  /**
   * Subtract a quaternion to the current one
   * Example Playground https://playground.babylonjs.com/#L49EJ7#58
   * @param other defines the quaternion to subtract
   * @returns the current quaternion
   */
  subtractInPlace(e) {
    return this._x -= e._x, this._y -= e._y, this._z -= e._z, this._w -= e._w, this._isDirty = !0, this;
  }
  /**
   * Multiplies the current quaternion by a scale factor
   * Example Playground https://playground.babylonjs.com/#L49EJ7#88
   * @param value defines the scale factor
   * @returns a new quaternion set by multiplying the current quaternion coordinates by the float "scale"
   */
  scale(e) {
    return new this.constructor(this._x * e, this._y * e, this._z * e, this._w * e);
  }
  /**
   * Scale the current quaternion values by a factor and stores the result to a given quaternion
   * Example Playground https://playground.babylonjs.com/#L49EJ7#89
   * @param scale defines the scale factor
   * @param result defines the Quaternion object where to store the result
   * @returns result input
   */
  scaleToRef(e, t) {
    return t._x = this._x * e, t._y = this._y * e, t._z = this._z * e, t._w = this._w * e, t._isDirty = !0, t;
  }
  /**
   * Multiplies in place the current quaternion by a scale factor
   * Example Playground https://playground.babylonjs.com/#L49EJ7#90
   * @param value defines the scale factor
   * @returns the current modified quaternion
   */
  scaleInPlace(e) {
    return this._x *= e, this._y *= e, this._z *= e, this._w *= e, this._isDirty = !0, this;
  }
  /**
   * Scale the current quaternion values by a factor and add the result to a given quaternion
   * Example Playground https://playground.babylonjs.com/#L49EJ7#91
   * @param scale defines the scale factor
   * @param result defines the Quaternion object where to store the result
   * @returns result input
   */
  scaleAndAddToRef(e, t) {
    return t._x += this._x * e, t._y += this._y * e, t._z += this._z * e, t._w += this._w * e, t._isDirty = !0, t;
  }
  /**
   * Multiplies two quaternions
   * Example Playground https://playground.babylonjs.com/#L49EJ7#43
   * @param q1 defines the second operand
   * @returns a new quaternion set as the multiplication result of the current one with the given one "q1"
   */
  multiply(e) {
    const t = new this.constructor(0, 0, 0, 1);
    return this.multiplyToRef(e, t), t;
  }
  /**
   * Sets the given "result" as the the multiplication result of the current one with the given one "q1"
   * Example Playground https://playground.babylonjs.com/#L49EJ7#45
   * @param q1 defines the second operand
   * @param result defines the target quaternion
   * @returns the current quaternion
   */
  multiplyToRef(e, t) {
    const i = this._x * e._w + this._y * e._z - this._z * e._y + this._w * e._x, s = -this._x * e._z + this._y * e._w + this._z * e._x + this._w * e._y, r = this._x * e._y - this._y * e._x + this._z * e._w + this._w * e._z, n = -this._x * e._x - this._y * e._y - this._z * e._z + this._w * e._w;
    return t.copyFromFloats(i, s, r, n), t;
  }
  /**
   * Updates the current quaternion with the multiplication of itself with the given one "q1"
   * Example Playground https://playground.babylonjs.com/#L49EJ7#46
   * @param q1 defines the second operand
   * @returns the currentupdated quaternion
   */
  multiplyInPlace(e) {
    return this.multiplyToRef(e, this), this;
  }
  /**
   * Conjugates the current quaternion and stores the result in the given quaternion
   * Example Playground https://playground.babylonjs.com/#L49EJ7#81
   * @param ref defines the target quaternion
   * @returns result input
   */
  conjugateToRef(e) {
    return e.copyFromFloats(-this._x, -this._y, -this._z, this._w), e;
  }
  /**
   * Conjugates in place the current quaternion
   * Example Playground https://playground.babylonjs.com/#L49EJ7#82
   * @returns the current updated quaternion
   */
  conjugateInPlace() {
    return this._x *= -1, this._y *= -1, this._z *= -1, this._isDirty = !0, this;
  }
  /**
   * Conjugates (1-q) the current quaternion
   * Example Playground https://playground.babylonjs.com/#L49EJ7#83
   * @returns a new quaternion
   */
  conjugate() {
    return new this.constructor(-this._x, -this._y, -this._z, this._w);
  }
  /**
   * Returns the inverse of the current quaternion
   * Example Playground https://playground.babylonjs.com/#L49EJ7#84
   * @returns a new quaternion
   */
  invert() {
    const e = this.conjugate(), t = this.lengthSquared();
    return t == 0 || t == 1 || e.scaleInPlace(1 / t), e;
  }
  /**
   * Invert in place the current quaternion
   * Example Playground https://playground.babylonjs.com/#L49EJ7#85
   * @returns this quaternion
   */
  invertInPlace() {
    this.conjugateInPlace();
    const e = this.lengthSquared();
    return e == 0 || e == 1 ? this : (this.scaleInPlace(1 / e), this);
  }
  /**
   * Gets squared length of current quaternion
   * Example Playground https://playground.babylonjs.com/#L49EJ7#29
   * @returns the quaternion length (float)
   */
  lengthSquared() {
    return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
  }
  /**
   * Gets length of current quaternion
   * Example Playground https://playground.babylonjs.com/#L49EJ7#28
   * @returns the quaternion length (float)
   */
  length() {
    return Math.sqrt(this.lengthSquared());
  }
  /**
   * Normalize in place the current quaternion
   * Example Playground https://playground.babylonjs.com/#L49EJ7#54
   * @returns the current updated quaternion
   */
  normalize() {
    const e = this.length();
    if (e === 0)
      return this;
    const t = 1 / e;
    return this.scaleInPlace(t), this;
  }
  /**
   * Normalize a copy of the current quaternion
   * Example Playground https://playground.babylonjs.com/#L49EJ7#55
   * @returns the normalized quaternion
   */
  normalizeToNew() {
    const e = this.length();
    if (e === 0)
      return this.clone();
    const t = 1 / e;
    return this.scale(t);
  }
  /**
   * Returns a new Vector3 set with the Euler angles translated from the current quaternion
   * Example Playground https://playground.babylonjs.com/#L49EJ7#32
   * @returns a new Vector3 containing the Euler angles
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/center_origin/rotation_conventions
   */
  toEulerAngles() {
    const e = p.Zero();
    return this.toEulerAnglesToRef(e), e;
  }
  /**
   * Sets the given vector3 "result" with the Euler angles translated from the current quaternion
   * Example Playground https://playground.babylonjs.com/#L49EJ7#31
   * @param result defines the vector which will be filled with the Euler angles
   * @returns result input
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/center_origin/rotation_conventions
   */
  toEulerAnglesToRef(e) {
    const t = this._z, i = this._x, s = this._y, r = this._w, n = s * t - i * r, a = 0.4999999;
    if (n < -a)
      e._y = 2 * Math.atan2(s, r), e._x = Math.PI / 2, e._z = 0, e._isDirty = !0;
    else if (n > a)
      e._y = 2 * Math.atan2(s, r), e._x = -Math.PI / 2, e._z = 0, e._isDirty = !0;
    else {
      const o = r * r, l = t * t, c = i * i, u = s * s;
      e._z = Math.atan2(2 * (i * s + t * r), -l - c + u + o), e._x = Math.asin(-2 * n), e._y = Math.atan2(2 * (t * i + s * r), l - c - u + o), e._isDirty = !0;
    }
    return e;
  }
  /**
   * Updates the given rotation matrix with the current quaternion values
   * Example Playground https://playground.babylonjs.com/#L49EJ7#67
   * @param result defines the target matrix
   * @returns the current unchanged quaternion
   */
  toRotationMatrix(e) {
    return I.FromQuaternionToRef(this, e), e;
  }
  /**
   * Updates the current quaternion from the given rotation matrix values
   * Example Playground https://playground.babylonjs.com/#L49EJ7#41
   * @param matrix defines the source matrix
   * @returns the current updated quaternion
   */
  fromRotationMatrix(e) {
    return U.FromRotationMatrixToRef(e, this), this;
  }
  // Statics
  /**
   * Creates a new quaternion from a rotation matrix
   * Example Playground https://playground.babylonjs.com/#L49EJ7#101
   * @param matrix defines the source matrix
   * @returns a new quaternion created from the given rotation matrix values
   */
  static FromRotationMatrix(e) {
    const t = new U();
    return U.FromRotationMatrixToRef(e, t), t;
  }
  /**
   * Updates the given quaternion with the given rotation matrix values
   * Example Playground https://playground.babylonjs.com/#L49EJ7#102
   * @param matrix defines the source matrix
   * @param result defines the target quaternion
   * @returns result input
   */
  static FromRotationMatrixToRef(e, t) {
    const i = e.m, s = i[0], r = i[4], n = i[8], a = i[1], o = i[5], l = i[9], c = i[2], u = i[6], d = i[10], f = s + o + d;
    let _;
    return f > 0 ? (_ = 0.5 / Math.sqrt(f + 1), t._w = 0.25 / _, t._x = (u - l) * _, t._y = (n - c) * _, t._z = (a - r) * _, t._isDirty = !0) : s > o && s > d ? (_ = 2 * Math.sqrt(1 + s - o - d), t._w = (u - l) / _, t._x = 0.25 * _, t._y = (r + a) / _, t._z = (n + c) / _, t._isDirty = !0) : o > d ? (_ = 2 * Math.sqrt(1 + o - s - d), t._w = (n - c) / _, t._x = (r + a) / _, t._y = 0.25 * _, t._z = (l + u) / _, t._isDirty = !0) : (_ = 2 * Math.sqrt(1 + d - s - o), t._w = (a - r) / _, t._x = (n + c) / _, t._y = (l + u) / _, t._z = 0.25 * _, t._isDirty = !0), t;
  }
  /**
   * Returns the dot product (float) between the quaternions "left" and "right"
   * Example Playground https://playground.babylonjs.com/#L49EJ7#61
   * @param left defines the left operand
   * @param right defines the right operand
   * @returns the dot product
   */
  static Dot(e, t) {
    return e._x * t._x + e._y * t._y + e._z * t._z + e._w * t._w;
  }
  /**
   * Checks if the orientations of two rotation quaternions are close to each other
   * Example Playground https://playground.babylonjs.com/#L49EJ7#60
   * @param quat0 defines the first quaternion to check
   * @param quat1 defines the second quaternion to check
   * @param epsilon defines closeness, 0 same orientation, 1 PI apart, default 0.1
   * @returns true if the two quaternions are close to each other within epsilon
   */
  static AreClose(e, t, i = 0.1) {
    const s = U.Dot(e, t);
    return 1 - s * s <= i;
  }
  /**
   * Smooth interpolation between two quaternions using Slerp
   * Example Playground https://playground.babylonjs.com/#L49EJ7#93
   * @param source source quaternion
   * @param goal goal quaternion
   * @param deltaTime current interpolation frame
   * @param lerpTime total interpolation time
   * @param result the smoothed quaternion
   */
  static SmoothToRef(e, t, i, s, r) {
    let n = s === 0 ? 1 : i / s;
    return n = J.Clamp(n, 0, 1), U.SlerpToRef(e, t, n, r), r;
  }
  /**
   * Creates an empty quaternion
   * @returns a new quaternion set to (0.0, 0.0, 0.0)
   */
  static Zero() {
    return new U(0, 0, 0, 0);
  }
  /**
   * Inverse a given quaternion
   * Example Playground https://playground.babylonjs.com/#L49EJ7#103
   * @param q defines the source quaternion
   * @returns a new quaternion as the inverted current quaternion
   */
  static Inverse(e) {
    return new e.constructor(-e._x, -e._y, -e._z, e._w);
  }
  /**
   * Inverse a given quaternion
   * Example Playground https://playground.babylonjs.com/#L49EJ7#104
   * @param q defines the source quaternion
   * @param result the quaternion the result will be stored in
   * @returns the result quaternion
   */
  static InverseToRef(e, t) {
    return t.set(-e._x, -e._y, -e._z, e._w), t;
  }
  /**
   * Creates an identity quaternion
   * @returns the identity quaternion
   */
  static Identity() {
    return new U(0, 0, 0, 1);
  }
  /**
   * Gets a boolean indicating if the given quaternion is identity
   * @param quaternion defines the quaternion to check
   * @returns true if the quaternion is identity
   */
  static IsIdentity(e) {
    return e && e._x === 0 && e._y === 0 && e._z === 0 && e._w === 1;
  }
  /**
   * Creates a quaternion from a rotation around an axis
   * Example Playground https://playground.babylonjs.com/#L49EJ7#72
   * @param axis defines the axis to use
   * @param angle defines the angle to use
   * @returns a new quaternion created from the given axis (Vector3) and angle in radians (float)
   */
  static RotationAxis(e, t) {
    return U.RotationAxisToRef(e, t, new U());
  }
  /**
   * Creates a rotation around an axis and stores it into the given quaternion
   * Example Playground https://playground.babylonjs.com/#L49EJ7#73
   * @param axis defines the axis to use
   * @param angle defines the angle to use
   * @param result defines the target quaternion
   * @returns the target quaternion
   */
  static RotationAxisToRef(e, t, i) {
    const s = Math.sin(t / 2);
    return e.normalize(), i._w = Math.cos(t / 2), i._x = e._x * s, i._y = e._y * s, i._z = e._z * s, i._isDirty = !0, i;
  }
  /**
   * Creates a new quaternion from data stored into an array
   * Example Playground https://playground.babylonjs.com/#L49EJ7#63
   * @param array defines the data source
   * @param offset defines the offset in the source array where the data starts
   * @returns a new quaternion
   */
  static FromArray(e, t) {
    return t || (t = 0), new U(e[t], e[t + 1], e[t + 2], e[t + 3]);
  }
  /**
   * Updates the given quaternion "result" from the starting index of the given array.
   * Example Playground https://playground.babylonjs.com/#L49EJ7#64
   * @param array the array to pull values from
   * @param offset the offset into the array to start at
   * @param result the quaternion to store the result in
   * @returns result input
   */
  static FromArrayToRef(e, t, i) {
    return i._x = e[t], i._y = e[t + 1], i._z = e[t + 2], i._w = e[t + 3], i._isDirty = !0, i;
  }
  /**
   * Create a quaternion from Euler rotation angles
   * Example Playground https://playground.babylonjs.com/#L49EJ7#33
   * @param x Pitch
   * @param y Yaw
   * @param z Roll
   * @returns the new Quaternion
   */
  static FromEulerAngles(e, t, i) {
    const s = new U();
    return U.RotationYawPitchRollToRef(t, e, i, s), s;
  }
  /**
   * Updates a quaternion from Euler rotation angles
   * Example Playground https://playground.babylonjs.com/#L49EJ7#34
   * @param x Pitch
   * @param y Yaw
   * @param z Roll
   * @param result the quaternion to store the result
   * @returns the updated quaternion
   */
  static FromEulerAnglesToRef(e, t, i, s) {
    return U.RotationYawPitchRollToRef(t, e, i, s), s;
  }
  /**
   * Create a quaternion from Euler rotation vector
   * Example Playground https://playground.babylonjs.com/#L49EJ7#35
   * @param vec the Euler vector (x Pitch, y Yaw, z Roll)
   * @returns the new Quaternion
   */
  static FromEulerVector(e) {
    const t = new U();
    return U.RotationYawPitchRollToRef(e._y, e._x, e._z, t), t;
  }
  /**
   * Updates a quaternion from Euler rotation vector
   * Example Playground https://playground.babylonjs.com/#L49EJ7#36
   * @param vec the Euler vector (x Pitch, y Yaw, z Roll)
   * @param result the quaternion to store the result
   * @returns the updated quaternion
   */
  static FromEulerVectorToRef(e, t) {
    return U.RotationYawPitchRollToRef(e._y, e._x, e._z, t), t;
  }
  /**
   * Updates a quaternion so that it rotates vector vecFrom to vector vecTo
   * Example Playground - https://playground.babylonjs.com/#L49EJ7#70
   * @param vecFrom defines the direction vector from which to rotate
   * @param vecTo defines the direction vector to which to rotate
   * @param result the quaternion to store the result
   * @param epsilon defines the minimal dot value to define vecs as opposite. Default: `BABYLON.Epsilon`
   * @returns the updated quaternion
   */
  static FromUnitVectorsToRef(e, t, i, s = pe) {
    const r = p.Dot(e, t) + 1;
    return r < s ? Math.abs(e.x) > Math.abs(e.z) ? i.set(-e.y, e.x, 0, 0) : i.set(0, -e.z, e.y, 0) : (p.CrossToRef(e, t, C.Vector3[0]), i.set(C.Vector3[0].x, C.Vector3[0].y, C.Vector3[0].z, r)), i.normalize();
  }
  /**
   * Creates a new quaternion from the given Euler float angles (y, x, z)
   * Example Playground https://playground.babylonjs.com/#L49EJ7#77
   * @param yaw defines the rotation around Y axis
   * @param pitch defines the rotation around X axis
   * @param roll defines the rotation around Z axis
   * @returns the new quaternion
   */
  static RotationYawPitchRoll(e, t, i) {
    const s = new U();
    return U.RotationYawPitchRollToRef(e, t, i, s), s;
  }
  /**
   * Creates a new rotation from the given Euler float angles (y, x, z) and stores it in the target quaternion
   * Example Playground https://playground.babylonjs.com/#L49EJ7#78
   * @param yaw defines the rotation around Y axis
   * @param pitch defines the rotation around X axis
   * @param roll defines the rotation around Z axis
   * @param result defines the target quaternion
   * @returns result input
   */
  static RotationYawPitchRollToRef(e, t, i, s) {
    const r = i * 0.5, n = t * 0.5, a = e * 0.5, o = Math.sin(r), l = Math.cos(r), c = Math.sin(n), u = Math.cos(n), d = Math.sin(a), f = Math.cos(a);
    return s._x = f * c * l + d * u * o, s._y = d * u * l - f * c * o, s._z = f * u * o - d * c * l, s._w = f * u * l + d * c * o, s._isDirty = !0, s;
  }
  /**
   * Creates a new quaternion from the given Euler float angles expressed in z-x-z orientation
   * Example Playground https://playground.babylonjs.com/#L49EJ7#68
   * @param alpha defines the rotation around first axis
   * @param beta defines the rotation around second axis
   * @param gamma defines the rotation around third axis
   * @returns the new quaternion
   */
  static RotationAlphaBetaGamma(e, t, i) {
    const s = new U();
    return U.RotationAlphaBetaGammaToRef(e, t, i, s), s;
  }
  /**
   * Creates a new quaternion from the given Euler float angles expressed in z-x-z orientation and stores it in the target quaternion
   * Example Playground https://playground.babylonjs.com/#L49EJ7#69
   * @param alpha defines the rotation around first axis
   * @param beta defines the rotation around second axis
   * @param gamma defines the rotation around third axis
   * @param result defines the target quaternion
   * @returns result input
   */
  static RotationAlphaBetaGammaToRef(e, t, i, s) {
    const r = (i + e) * 0.5, n = (i - e) * 0.5, a = t * 0.5;
    return s._x = Math.cos(n) * Math.sin(a), s._y = Math.sin(n) * Math.sin(a), s._z = Math.sin(r) * Math.cos(a), s._w = Math.cos(r) * Math.cos(a), s._isDirty = !0, s;
  }
  /**
   * Creates a new quaternion containing the rotation value to reach the target (axis1, axis2, axis3) orientation as a rotated XYZ system (axis1, axis2 and axis3 are normalized during this operation)
   * Example Playground https://playground.babylonjs.com/#L49EJ7#75
   * @param axis1 defines the first axis
   * @param axis2 defines the second axis
   * @param axis3 defines the third axis
   * @returns the new quaternion
   */
  static RotationQuaternionFromAxis(e, t, i) {
    const s = new U(0, 0, 0, 0);
    return U.RotationQuaternionFromAxisToRef(e, t, i, s), s;
  }
  /**
   * Creates a rotation value to reach the target (axis1, axis2, axis3) orientation as a rotated XYZ system (axis1, axis2 and axis3 are normalized during this operation) and stores it in the target quaternion
   * Example Playground https://playground.babylonjs.com/#L49EJ7#76
   * @param axis1 defines the first axis
   * @param axis2 defines the second axis
   * @param axis3 defines the third axis
   * @param ref defines the target quaternion
   * @returns result input
   */
  static RotationQuaternionFromAxisToRef(e, t, i, s) {
    const r = te.Matrix[0];
    return I.FromXYZAxesToRef(e.normalize(), t.normalize(), i.normalize(), r), U.FromRotationMatrixToRef(r, s), s;
  }
  /**
   * Creates a new rotation value to orient an object to look towards the given forward direction, the up direction being oriented like "up".
   * This function works in left handed mode
   * Example Playground https://playground.babylonjs.com/#L49EJ7#96
   * @param forward defines the forward direction - Must be normalized and orthogonal to up.
   * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
   * @returns A new quaternion oriented toward the specified forward and up.
   */
  static FromLookDirectionLH(e, t) {
    const i = new U();
    return U.FromLookDirectionLHToRef(e, t, i), i;
  }
  /**
   * Creates a new rotation value to orient an object to look towards the given forward direction with the up direction being oriented like "up", and stores it in the target quaternion.
   * This function works in left handed mode
   * Example Playground https://playground.babylonjs.com/#L49EJ7#97
   * @param forward defines the forward direction - Must be normalized and orthogonal to up.
   * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
   * @param ref defines the target quaternion.
   * @returns result input
   */
  static FromLookDirectionLHToRef(e, t, i) {
    const s = te.Matrix[0];
    return I.LookDirectionLHToRef(e, t, s), U.FromRotationMatrixToRef(s, i), i;
  }
  /**
   * Creates a new rotation value to orient an object to look towards the given forward direction, the up direction being oriented like "up".
   * This function works in right handed mode
   * Example Playground https://playground.babylonjs.com/#L49EJ7#98
   * @param forward defines the forward direction - Must be normalized and orthogonal to up.
   * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
   * @returns A new quaternion oriented toward the specified forward and up.
   */
  static FromLookDirectionRH(e, t) {
    const i = new U();
    return U.FromLookDirectionRHToRef(e, t, i), i;
  }
  /**
   * Creates a new rotation value to orient an object to look towards the given forward direction with the up direction being oriented like "up", and stores it in the target quaternion.
   * This function works in right handed mode
   * Example Playground https://playground.babylonjs.com/#L49EJ7#105
   * @param forward defines the forward direction - Must be normalized and orthogonal to up.
   * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
   * @param ref defines the target quaternion.
   * @returns result input
   */
  static FromLookDirectionRHToRef(e, t, i) {
    const s = te.Matrix[0];
    return I.LookDirectionRHToRef(e, t, s), U.FromRotationMatrixToRef(s, i);
  }
  /**
   * Interpolates between two quaternions
   * Example Playground https://playground.babylonjs.com/#L49EJ7#79
   * @param left defines first quaternion
   * @param right defines second quaternion
   * @param amount defines the gradient to use
   * @returns the new interpolated quaternion
   */
  static Slerp(e, t, i) {
    const s = U.Identity();
    return U.SlerpToRef(e, t, i, s), s;
  }
  /**
   * Interpolates between two quaternions and stores it into a target quaternion
   * Example Playground https://playground.babylonjs.com/#L49EJ7#92
   * @param left defines first quaternion
   * @param right defines second quaternion
   * @param amount defines the gradient to use
   * @param result defines the target quaternion
   * @returns result input
   */
  static SlerpToRef(e, t, i, s) {
    let r, n, a = e._x * t._x + e._y * t._y + e._z * t._z + e._w * t._w, o = !1;
    if (a < 0 && (o = !0, a = -a), a > 0.999999)
      n = 1 - i, r = o ? -i : i;
    else {
      const l = Math.acos(a), c = 1 / Math.sin(l);
      n = Math.sin((1 - i) * l) * c, r = o ? -Math.sin(i * l) * c : Math.sin(i * l) * c;
    }
    return s._x = n * e._x + r * t._x, s._y = n * e._y + r * t._y, s._z = n * e._z + r * t._z, s._w = n * e._w + r * t._w, s._isDirty = !0, s;
  }
  /**
   * Interpolate between two quaternions using Hermite interpolation
   * Example Playground https://playground.babylonjs.com/#L49EJ7#47
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/drawCurves#hermite-quaternion-spline
   * @param value1 defines first quaternion
   * @param tangent1 defines the incoming tangent
   * @param value2 defines second quaternion
   * @param tangent2 defines the outgoing tangent
   * @param amount defines the target quaternion
   * @returns the new interpolated quaternion
   */
  static Hermite(e, t, i, s, r) {
    const n = r * r, a = r * n, o = 2 * a - 3 * n + 1, l = -2 * a + 3 * n, c = a - 2 * n + r, u = a - n, d = e._x * o + i._x * l + t._x * c + s._x * u, f = e._y * o + i._y * l + t._y * c + s._y * u, _ = e._z * o + i._z * l + t._z * c + s._z * u, g = e._w * o + i._w * l + t._w * c + s._w * u;
    return new e.constructor(d, f, _, g);
  }
  /**
   * Returns a new Quaternion which is the 1st derivative of the Hermite spline defined by the quaternions "value1", "value2", "tangent1", "tangent2".
   * Example Playground https://playground.babylonjs.com/#L49EJ7#48
   * @param value1 defines the first control point
   * @param tangent1 defines the first tangent
   * @param value2 defines the second control point
   * @param tangent2 defines the second tangent
   * @param time define where the derivative must be done
   * @returns 1st derivative
   */
  static Hermite1stDerivative(e, t, i, s, r) {
    const n = new e.constructor();
    return this.Hermite1stDerivativeToRef(e, t, i, s, r, n), n;
  }
  /**
   * Update a Quaternion with the 1st derivative of the Hermite spline defined by the quaternions "value1", "value2", "tangent1", "tangent2".
   * Example Playground https://playground.babylonjs.com/#L49EJ7#49
   * @param value1 defines the first control point
   * @param tangent1 defines the first tangent
   * @param value2 defines the second control point
   * @param tangent2 defines the second tangent
   * @param time define where the derivative must be done
   * @param result define where to store the derivative
   * @returns result input
   */
  static Hermite1stDerivativeToRef(e, t, i, s, r, n) {
    const a = r * r;
    return n._x = (a - r) * 6 * e._x + (3 * a - 4 * r + 1) * t._x + (-a + r) * 6 * i._x + (3 * a - 2 * r) * s._x, n._y = (a - r) * 6 * e._y + (3 * a - 4 * r + 1) * t._y + (-a + r) * 6 * i._y + (3 * a - 2 * r) * s._y, n._z = (a - r) * 6 * e._z + (3 * a - 4 * r + 1) * t._z + (-a + r) * 6 * i._z + (3 * a - 2 * r) * s._z, n._w = (a - r) * 6 * e._w + (3 * a - 4 * r + 1) * t._w + (-a + r) * 6 * i._w + (3 * a - 2 * r) * s._w, n._isDirty = !0, n;
  }
}
class I {
  /**
   * Gets the precision of matrix computations
   */
  static get Use64Bits() {
    return ht.MatrixUse64Bits;
  }
  /**
   * Gets the internal data of the matrix
   */
  get m() {
    return this._m;
  }
  /**
   * Update the updateFlag to indicate that the matrix has been updated
   */
  markAsUpdated() {
    this.updateFlag = I._UpdateFlagSeed++, this._isIdentity = !1, this._isIdentity3x2 = !1, this._isIdentityDirty = !0, this._isIdentity3x2Dirty = !0;
  }
  _updateIdentityStatus(e, t = !1, i = !1, s = !0) {
    this._isIdentity = e, this._isIdentity3x2 = e || i, this._isIdentityDirty = this._isIdentity ? !1 : t, this._isIdentity3x2Dirty = this._isIdentity3x2 ? !1 : s;
  }
  /**
   * Creates an empty matrix (filled with zeros)
   */
  constructor() {
    this._isIdentity = !1, this._isIdentityDirty = !0, this._isIdentity3x2 = !0, this._isIdentity3x2Dirty = !0, this.updateFlag = -1, ht.MatrixTrackPrecisionChange && ht.MatrixTrackedMatrices.push(this), this._m = new ht.MatrixCurrentType(16), this.markAsUpdated();
  }
  // Properties
  /**
   * Check if the current matrix is identity
   * @returns true is the matrix is the identity matrix
   */
  isIdentity() {
    if (this._isIdentityDirty) {
      this._isIdentityDirty = !1;
      const e = this._m;
      this._isIdentity = e[0] === 1 && e[1] === 0 && e[2] === 0 && e[3] === 0 && e[4] === 0 && e[5] === 1 && e[6] === 0 && e[7] === 0 && e[8] === 0 && e[9] === 0 && e[10] === 1 && e[11] === 0 && e[12] === 0 && e[13] === 0 && e[14] === 0 && e[15] === 1;
    }
    return this._isIdentity;
  }
  /**
   * Check if the current matrix is identity as a texture matrix (3x2 store in 4x4)
   * @returns true is the matrix is the identity matrix
   */
  isIdentityAs3x2() {
    return this._isIdentity3x2Dirty && (this._isIdentity3x2Dirty = !1, this._m[0] !== 1 || this._m[5] !== 1 || this._m[15] !== 1 ? this._isIdentity3x2 = !1 : this._m[1] !== 0 || this._m[2] !== 0 || this._m[3] !== 0 || this._m[4] !== 0 || this._m[6] !== 0 || this._m[7] !== 0 || this._m[8] !== 0 || this._m[9] !== 0 || this._m[10] !== 0 || this._m[11] !== 0 || this._m[12] !== 0 || this._m[13] !== 0 || this._m[14] !== 0 ? this._isIdentity3x2 = !1 : this._isIdentity3x2 = !0), this._isIdentity3x2;
  }
  /**
   * Gets the determinant of the matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#34
   * @returns the matrix determinant
   */
  determinant() {
    if (this._isIdentity === !0)
      return 1;
    const e = this._m, t = e[0], i = e[1], s = e[2], r = e[3], n = e[4], a = e[5], o = e[6], l = e[7], c = e[8], u = e[9], d = e[10], f = e[11], _ = e[12], g = e[13], m = e[14], y = e[15], x = d * y - m * f, A = u * y - g * f, T = u * m - g * d, M = c * y - _ * f, b = c * m - d * _, S = c * g - _ * u, P = +(a * x - o * A + l * T), D = -(n * x - o * M + l * b), O = +(n * A - a * M + l * S), X = -(n * T - a * b + o * S);
    return t * P + i * D + s * O + r * X;
  }
  // Methods
  /**
   * Returns the matrix as a Float32Array or Array<number>
   * Example Playground - https://playground.babylonjs.com/#AV9X17#49
   * @returns the matrix underlying array
   */
  toArray() {
    return this._m;
  }
  /**
   * Returns the matrix as a Float32Array or Array<number>
   * Example Playground - https://playground.babylonjs.com/#AV9X17#114
   * @returns the matrix underlying array.
   */
  asArray() {
    return this._m;
  }
  /**
   * Inverts the current matrix in place
   * Example Playground - https://playground.babylonjs.com/#AV9X17#118
   * @returns the current inverted matrix
   */
  invert() {
    return this.invertToRef(this), this;
  }
  /**
   * Sets all the matrix elements to zero
   * @returns the current matrix
   */
  reset() {
    return I.FromValuesToRef(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, this), this._updateIdentityStatus(!1), this;
  }
  /**
   * Adds the current matrix with a second one
   * Example Playground - https://playground.babylonjs.com/#AV9X17#44
   * @param other defines the matrix to add
   * @returns a new matrix as the addition of the current matrix and the given one
   */
  add(e) {
    const t = new this.constructor();
    return this.addToRef(e, t), t;
  }
  /**
   * Sets the given matrix "result" to the addition of the current matrix and the given one
   * Example Playground - https://playground.babylonjs.com/#AV9X17#45
   * @param other defines the matrix to add
   * @param result defines the target matrix
   * @returns result input
   */
  addToRef(e, t) {
    const i = this._m, s = t._m, r = e.m;
    for (let n = 0; n < 16; n++)
      s[n] = i[n] + r[n];
    return t.markAsUpdated(), t;
  }
  /**
   * Adds in place the given matrix to the current matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#46
   * @param other defines the second operand
   * @returns the current updated matrix
   */
  addToSelf(e) {
    const t = this._m, i = e.m;
    for (let s = 0; s < 16; s++)
      t[s] += i[s];
    return this.markAsUpdated(), this;
  }
  /**
   * Sets the given matrix to the current inverted Matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#119
   * @param other defines the target matrix
   * @returns result input
   */
  invertToRef(e) {
    if (this._isIdentity === !0)
      return I.IdentityToRef(e), e;
    const t = this._m, i = t[0], s = t[1], r = t[2], n = t[3], a = t[4], o = t[5], l = t[6], c = t[7], u = t[8], d = t[9], f = t[10], _ = t[11], g = t[12], m = t[13], y = t[14], x = t[15], A = f * x - y * _, T = d * x - m * _, M = d * y - m * f, b = u * x - g * _, S = u * y - f * g, P = u * m - g * d, D = +(o * A - l * T + c * M), O = -(a * A - l * b + c * S), X = +(a * T - o * b + c * P), k = -(a * M - o * S + l * P), Y = i * D + s * O + r * X + n * k;
    if (Y === 0)
      return e.copyFrom(this), e;
    const se = 1 / Y, Te = l * x - y * c, ve = o * x - m * c, Oe = o * y - m * l, Ne = a * x - g * c, ke = a * y - g * l, Se = a * m - g * o, Be = l * _ - f * c, Me = o * _ - d * c, je = o * f - d * l, Rt = a * _ - u * c, oi = a * f - u * l, Mt = a * d - u * o, it = -(s * A - r * T + n * M), Xt = +(i * A - r * b + n * S), xt = -(i * T - s * b + n * P), Ht = +(i * M - s * S + r * P), Fe = +(s * Te - r * ve + n * Oe), ce = -(i * Te - r * Ne + n * ke), tt = +(i * ve - s * Ne + n * Se), Ot = -(i * Oe - s * ke + r * Se), ft = -(s * Be - r * Me + n * je), It = +(i * Be - r * Rt + n * oi), kr = -(i * Me - s * Rt + n * Mt), bs = +(i * je - s * oi + r * Mt);
    return I.FromValuesToRef(D * se, it * se, Fe * se, ft * se, O * se, Xt * se, ce * se, It * se, X * se, xt * se, tt * se, kr * se, k * se, Ht * se, Ot * se, bs * se, e), e;
  }
  /**
   * add a value at the specified position in the current Matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#47
   * @param index the index of the value within the matrix. between 0 and 15.
   * @param value the value to be added
   * @returns the current updated matrix
   */
  addAtIndex(e, t) {
    return this._m[e] += t, this.markAsUpdated(), this;
  }
  /**
   * mutiply the specified position in the current Matrix by a value
   * @param index the index of the value within the matrix. between 0 and 15.
   * @param value the value to be added
   * @returns the current updated matrix
   */
  multiplyAtIndex(e, t) {
    return this._m[e] *= t, this.markAsUpdated(), this;
  }
  /**
   * Inserts the translation vector (using 3 floats) in the current matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#120
   * @param x defines the 1st component of the translation
   * @param y defines the 2nd component of the translation
   * @param z defines the 3rd component of the translation
   * @returns the current updated matrix
   */
  setTranslationFromFloats(e, t, i) {
    return this._m[12] = e, this._m[13] = t, this._m[14] = i, this.markAsUpdated(), this;
  }
  /**
   * Adds the translation vector (using 3 floats) in the current matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#20
   * Example Playground - https://playground.babylonjs.com/#AV9X17#48
   * @param x defines the 1st component of the translation
   * @param y defines the 2nd component of the translation
   * @param z defines the 3rd component of the translation
   * @returns the current updated matrix
   */
  addTranslationFromFloats(e, t, i) {
    return this._m[12] += e, this._m[13] += t, this._m[14] += i, this.markAsUpdated(), this;
  }
  /**
   * Inserts the translation vector in the current matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#121
   * @param vector3 defines the translation to insert
   * @returns the current updated matrix
   */
  setTranslation(e) {
    return this.setTranslationFromFloats(e._x, e._y, e._z);
  }
  /**
   * Gets the translation value of the current matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#122
   * @returns a new Vector3 as the extracted translation from the matrix
   */
  getTranslation() {
    return new p(this._m[12], this._m[13], this._m[14]);
  }
  /**
   * Fill a Vector3 with the extracted translation from the matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#123
   * @param result defines the Vector3 where to store the translation
   * @returns the current matrix
   */
  getTranslationToRef(e) {
    return e.x = this._m[12], e.y = this._m[13], e.z = this._m[14], e;
  }
  /**
   * Remove rotation and scaling part from the matrix
   * @returns the updated matrix
   */
  removeRotationAndScaling() {
    const e = this.m;
    return I.FromValuesToRef(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, e[12], e[13], e[14], e[15], this), this._updateIdentityStatus(e[12] === 0 && e[13] === 0 && e[14] === 0 && e[15] === 1), this;
  }
  /**
   * Multiply two matrices
   * Example Playground - https://playground.babylonjs.com/#AV9X17#15
   * A.multiply(B) means apply B to A so result is B x A
   * @param other defines the second operand
   * @returns a new matrix set with the multiplication result of the current Matrix and the given one
   */
  multiply(e) {
    const t = new this.constructor();
    return this.multiplyToRef(e, t), t;
  }
  /**
   * Copy the current matrix from the given one
   * Example Playground - https://playground.babylonjs.com/#AV9X17#21
   * @param other defines the source matrix
   * @returns the current updated matrix
   */
  copyFrom(e) {
    e.copyToArray(this._m);
    const t = e;
    return this.updateFlag = t.updateFlag, this._updateIdentityStatus(t._isIdentity, t._isIdentityDirty, t._isIdentity3x2, t._isIdentity3x2Dirty), this;
  }
  /**
   * Populates the given array from the starting index with the current matrix values
   * @param array defines the target array
   * @param offset defines the offset in the target array where to start storing values
   * @returns the current matrix
   */
  copyToArray(e, t = 0) {
    const i = this._m;
    return e[t] = i[0], e[t + 1] = i[1], e[t + 2] = i[2], e[t + 3] = i[3], e[t + 4] = i[4], e[t + 5] = i[5], e[t + 6] = i[6], e[t + 7] = i[7], e[t + 8] = i[8], e[t + 9] = i[9], e[t + 10] = i[10], e[t + 11] = i[11], e[t + 12] = i[12], e[t + 13] = i[13], e[t + 14] = i[14], e[t + 15] = i[15], this;
  }
  /**
   * Sets the given matrix "result" with the multiplication result of the current Matrix and the given one
   * A.multiplyToRef(B, R) means apply B to A and store in R and R = B x A
   * Example Playground - https://playground.babylonjs.com/#AV9X17#16
   * @param other defines the second operand
   * @param result defines the matrix where to store the multiplication
   * @returns result input
   */
  multiplyToRef(e, t) {
    return this._isIdentity ? (t.copyFrom(e), t) : e._isIdentity ? (t.copyFrom(this), t) : (this.multiplyToArray(e, t._m, 0), t.markAsUpdated(), t);
  }
  /**
   * Sets the Float32Array "result" from the given index "offset" with the multiplication of the current matrix and the given one
   * @param other defines the second operand
   * @param result defines the array where to store the multiplication
   * @param offset defines the offset in the target array where to start storing values
   * @returns the current matrix
   */
  multiplyToArray(e, t, i) {
    const s = this._m, r = e.m, n = s[0], a = s[1], o = s[2], l = s[3], c = s[4], u = s[5], d = s[6], f = s[7], _ = s[8], g = s[9], m = s[10], y = s[11], x = s[12], A = s[13], T = s[14], M = s[15], b = r[0], S = r[1], P = r[2], D = r[3], O = r[4], X = r[5], k = r[6], Y = r[7], se = r[8], Te = r[9], ve = r[10], Oe = r[11], Ne = r[12], ke = r[13], Se = r[14], Be = r[15];
    return t[i] = n * b + a * O + o * se + l * Ne, t[i + 1] = n * S + a * X + o * Te + l * ke, t[i + 2] = n * P + a * k + o * ve + l * Se, t[i + 3] = n * D + a * Y + o * Oe + l * Be, t[i + 4] = c * b + u * O + d * se + f * Ne, t[i + 5] = c * S + u * X + d * Te + f * ke, t[i + 6] = c * P + u * k + d * ve + f * Se, t[i + 7] = c * D + u * Y + d * Oe + f * Be, t[i + 8] = _ * b + g * O + m * se + y * Ne, t[i + 9] = _ * S + g * X + m * Te + y * ke, t[i + 10] = _ * P + g * k + m * ve + y * Se, t[i + 11] = _ * D + g * Y + m * Oe + y * Be, t[i + 12] = x * b + A * O + T * se + M * Ne, t[i + 13] = x * S + A * X + T * Te + M * ke, t[i + 14] = x * P + A * k + T * ve + M * Se, t[i + 15] = x * D + A * Y + T * Oe + M * Be, this;
  }
  /**
   * Check equality between this matrix and a second one
   * @param value defines the second matrix to compare
   * @returns true is the current matrix and the given one values are strictly equal
   */
  equals(e) {
    const t = e;
    if (!t)
      return !1;
    if ((this._isIdentity || t._isIdentity) && !this._isIdentityDirty && !t._isIdentityDirty)
      return this._isIdentity && t._isIdentity;
    const i = this.m, s = t.m;
    return i[0] === s[0] && i[1] === s[1] && i[2] === s[2] && i[3] === s[3] && i[4] === s[4] && i[5] === s[5] && i[6] === s[6] && i[7] === s[7] && i[8] === s[8] && i[9] === s[9] && i[10] === s[10] && i[11] === s[11] && i[12] === s[12] && i[13] === s[13] && i[14] === s[14] && i[15] === s[15];
  }
  /**
   * Clone the current matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#18
   * @returns a new matrix from the current matrix
   */
  clone() {
    const e = new this.constructor();
    return e.copyFrom(this), e;
  }
  /**
   * Returns the name of the current matrix class
   * @returns the string "Matrix"
   */
  getClassName() {
    return "Matrix";
  }
  /**
   * Gets the hash code of the current matrix
   * @returns the hash code
   */
  getHashCode() {
    let e = Bt(this._m[0]);
    for (let t = 1; t < 16; t++)
      e = e * 397 ^ Bt(this._m[t]);
    return e;
  }
  /**
   * Decomposes the current Matrix into a translation, rotation and scaling components of the provided node
   * Example Playground - https://playground.babylonjs.com/#AV9X17#13
   * @param node the node to decompose the matrix to
   * @returns true if operation was successful
   */
  decomposeToTransformNode(e) {
    return e.rotationQuaternion = e.rotationQuaternion || new U(), this.decompose(e.scaling, e.rotationQuaternion, e.position);
  }
  /**
   * Decomposes the current Matrix into a translation, rotation and scaling components
   * Example Playground - https://playground.babylonjs.com/#AV9X17#12
   * @param scale defines the scale vector3 given as a reference to update
   * @param rotation defines the rotation quaternion given as a reference to update
   * @param translation defines the translation vector3 given as a reference to update
   * @param preserveScalingNode Use scaling sign coming from this node. Otherwise scaling sign might change.
   * @returns true if operation was successful
   */
  decompose(e, t, i, s) {
    if (this._isIdentity)
      return i && i.setAll(0), e && e.setAll(1), t && t.copyFromFloats(0, 0, 0, 1), !0;
    const r = this._m;
    if (i && i.copyFromFloats(r[12], r[13], r[14]), e = e || te.Vector3[0], e.x = Math.sqrt(r[0] * r[0] + r[1] * r[1] + r[2] * r[2]), e.y = Math.sqrt(r[4] * r[4] + r[5] * r[5] + r[6] * r[6]), e.z = Math.sqrt(r[8] * r[8] + r[9] * r[9] + r[10] * r[10]), s) {
      const n = s.scaling.x < 0 ? -1 : 1, a = s.scaling.y < 0 ? -1 : 1, o = s.scaling.z < 0 ? -1 : 1;
      e.x *= n, e.y *= a, e.z *= o;
    } else
      this.determinant() <= 0 && (e.y *= -1);
    if (e._x === 0 || e._y === 0 || e._z === 0)
      return t && t.copyFromFloats(0, 0, 0, 1), !1;
    if (t) {
      const n = 1 / e._x, a = 1 / e._y, o = 1 / e._z;
      I.FromValuesToRef(r[0] * n, r[1] * n, r[2] * n, 0, r[4] * a, r[5] * a, r[6] * a, 0, r[8] * o, r[9] * o, r[10] * o, 0, 0, 0, 0, 1, te.Matrix[0]), U.FromRotationMatrixToRef(te.Matrix[0], t);
    }
    return !0;
  }
  /**
   * Gets specific row of the matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#36
   * @param index defines the number of the row to get
   * @returns the index-th row of the current matrix as a new Vector4
   */
  getRow(e) {
    if (e < 0 || e > 3)
      return null;
    const t = e * 4;
    return new ze(this._m[t + 0], this._m[t + 1], this._m[t + 2], this._m[t + 3]);
  }
  /**
   * Gets specific row of the matrix to ref
   * Example Playground - https://playground.babylonjs.com/#AV9X17#36
   * @param index defines the number of the row to get
   * @param rowVector vector to store the index-th row of the current matrix
   * @returns result input
   */
  getRowToRef(e, t) {
    if (e >= 0 && e < 3) {
      const i = e * 4;
      t.x = this._m[i + 0], t.y = this._m[i + 1], t.z = this._m[i + 2], t.w = this._m[i + 3];
    }
    return t;
  }
  /**
   * Sets the index-th row of the current matrix to the vector4 values
   * Example Playground - https://playground.babylonjs.com/#AV9X17#36
   * @param index defines the number of the row to set
   * @param row defines the target vector4
   * @returns the updated current matrix
   */
  setRow(e, t) {
    return this.setRowFromFloats(e, t.x, t.y, t.z, t.w);
  }
  /**
   * Compute the transpose of the matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#40
   * @returns the new transposed matrix
   */
  transpose() {
    const e = new this.constructor();
    return I.TransposeToRef(this, e), e;
  }
  /**
   * Compute the transpose of the matrix and store it in a given matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#41
   * @param result defines the target matrix
   * @returns result input
   */
  transposeToRef(e) {
    return I.TransposeToRef(this, e), e;
  }
  /**
   * Sets the index-th row of the current matrix with the given 4 x float values
   * Example Playground - https://playground.babylonjs.com/#AV9X17#36
   * @param index defines the row index
   * @param x defines the x component to set
   * @param y defines the y component to set
   * @param z defines the z component to set
   * @param w defines the w component to set
   * @returns the updated current matrix
   */
  setRowFromFloats(e, t, i, s, r) {
    if (e < 0 || e > 3)
      return this;
    const n = e * 4;
    return this._m[n + 0] = t, this._m[n + 1] = i, this._m[n + 2] = s, this._m[n + 3] = r, this.markAsUpdated(), this;
  }
  /**
   * Compute a new matrix set with the current matrix values multiplied by scale (float)
   * @param scale defines the scale factor
   * @returns a new matrix
   */
  scale(e) {
    const t = new this.constructor();
    return this.scaleToRef(e, t), t;
  }
  /**
   * Scale the current matrix values by a factor to a given result matrix
   * @param scale defines the scale factor
   * @param result defines the matrix to store the result
   * @returns result input
   */
  scaleToRef(e, t) {
    for (let i = 0; i < 16; i++)
      t._m[i] = this._m[i] * e;
    return t.markAsUpdated(), t;
  }
  /**
   * Scale the current matrix values by a factor and add the result to a given matrix
   * @param scale defines the scale factor
   * @param result defines the Matrix to store the result
   * @returns result input
   */
  scaleAndAddToRef(e, t) {
    for (let i = 0; i < 16; i++)
      t._m[i] += this._m[i] * e;
    return t.markAsUpdated(), t;
  }
  /**
   * Writes to the given matrix a normal matrix, computed from this one (using values from identity matrix for fourth row and column).
   * Example Playground - https://playground.babylonjs.com/#AV9X17#17
   * @param ref matrix to store the result
   */
  toNormalMatrix(e) {
    const t = te.Matrix[0];
    this.invertToRef(t), t.transposeToRef(e);
    const i = e._m;
    return I.FromValuesToRef(i[0], i[1], i[2], 0, i[4], i[5], i[6], 0, i[8], i[9], i[10], 0, 0, 0, 0, 1, e), e;
  }
  /**
   * Gets only rotation part of the current matrix
   * @returns a new matrix sets to the extracted rotation matrix from the current one
   */
  getRotationMatrix() {
    const e = new this.constructor();
    return this.getRotationMatrixToRef(e), e;
  }
  /**
   * Extracts the rotation matrix from the current one and sets it as the given "result"
   * @param result defines the target matrix to store data to
   * @returns result input
   */
  getRotationMatrixToRef(e) {
    const t = te.Vector3[0];
    if (!this.decompose(t))
      return I.IdentityToRef(e), e;
    const i = this._m, s = 1 / t._x, r = 1 / t._y, n = 1 / t._z;
    return I.FromValuesToRef(i[0] * s, i[1] * s, i[2] * s, 0, i[4] * r, i[5] * r, i[6] * r, 0, i[8] * n, i[9] * n, i[10] * n, 0, 0, 0, 0, 1, e), e;
  }
  /**
   * Toggles model matrix from being right handed to left handed in place and vice versa
   */
  toggleModelMatrixHandInPlace() {
    const e = this._m;
    return e[2] *= -1, e[6] *= -1, e[8] *= -1, e[9] *= -1, e[14] *= -1, this.markAsUpdated(), this;
  }
  /**
   * Toggles projection matrix from being right handed to left handed in place and vice versa
   */
  toggleProjectionMatrixHandInPlace() {
    const e = this._m;
    return e[8] *= -1, e[9] *= -1, e[10] *= -1, e[11] *= -1, this.markAsUpdated(), this;
  }
  // Statics
  /**
   * Creates a matrix from an array
   * Example Playground - https://playground.babylonjs.com/#AV9X17#42
   * @param array defines the source array
   * @param offset defines an offset in the source array
   * @returns a new Matrix set from the starting index of the given array
   */
  static FromArray(e, t = 0) {
    const i = new I();
    return I.FromArrayToRef(e, t, i), i;
  }
  /**
   * Copy the content of an array into a given matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#43
   * @param array defines the source array
   * @param offset defines an offset in the source array
   * @param result defines the target matrix
   * @returns result input
   */
  static FromArrayToRef(e, t, i) {
    for (let s = 0; s < 16; s++)
      i._m[s] = e[s + t];
    return i.markAsUpdated(), i;
  }
  /**
   * Stores an array into a matrix after having multiplied each component by a given factor
   * Example Playground - https://playground.babylonjs.com/#AV9X17#50
   * @param array defines the source array
   * @param offset defines the offset in the source array
   * @param scale defines the scaling factor
   * @param result defines the target matrix
   * @returns result input
   */
  static FromFloat32ArrayToRefScaled(e, t, i, s) {
    for (let r = 0; r < 16; r++)
      s._m[r] = e[r + t] * i;
    return s.markAsUpdated(), s;
  }
  /**
   * Gets an identity matrix that must not be updated
   */
  static get IdentityReadOnly() {
    return I._IdentityReadOnly;
  }
  /**
   * Stores a list of values (16) inside a given matrix
   * @param initialM11 defines 1st value of 1st row
   * @param initialM12 defines 2nd value of 1st row
   * @param initialM13 defines 3rd value of 1st row
   * @param initialM14 defines 4th value of 1st row
   * @param initialM21 defines 1st value of 2nd row
   * @param initialM22 defines 2nd value of 2nd row
   * @param initialM23 defines 3rd value of 2nd row
   * @param initialM24 defines 4th value of 2nd row
   * @param initialM31 defines 1st value of 3rd row
   * @param initialM32 defines 2nd value of 3rd row
   * @param initialM33 defines 3rd value of 3rd row
   * @param initialM34 defines 4th value of 3rd row
   * @param initialM41 defines 1st value of 4th row
   * @param initialM42 defines 2nd value of 4th row
   * @param initialM43 defines 3rd value of 4th row
   * @param initialM44 defines 4th value of 4th row
   * @param result defines the target matrix
   * @returns result input
   */
  static FromValuesToRef(e, t, i, s, r, n, a, o, l, c, u, d, f, _, g, m, y) {
    const x = y._m;
    x[0] = e, x[1] = t, x[2] = i, x[3] = s, x[4] = r, x[5] = n, x[6] = a, x[7] = o, x[8] = l, x[9] = c, x[10] = u, x[11] = d, x[12] = f, x[13] = _, x[14] = g, x[15] = m, y.markAsUpdated();
  }
  /**
   * Creates new matrix from a list of values (16)
   * @param initialM11 defines 1st value of 1st row
   * @param initialM12 defines 2nd value of 1st row
   * @param initialM13 defines 3rd value of 1st row
   * @param initialM14 defines 4th value of 1st row
   * @param initialM21 defines 1st value of 2nd row
   * @param initialM22 defines 2nd value of 2nd row
   * @param initialM23 defines 3rd value of 2nd row
   * @param initialM24 defines 4th value of 2nd row
   * @param initialM31 defines 1st value of 3rd row
   * @param initialM32 defines 2nd value of 3rd row
   * @param initialM33 defines 3rd value of 3rd row
   * @param initialM34 defines 4th value of 3rd row
   * @param initialM41 defines 1st value of 4th row
   * @param initialM42 defines 2nd value of 4th row
   * @param initialM43 defines 3rd value of 4th row
   * @param initialM44 defines 4th value of 4th row
   * @returns the new matrix
   */
  static FromValues(e, t, i, s, r, n, a, o, l, c, u, d, f, _, g, m) {
    const y = new I(), x = y._m;
    return x[0] = e, x[1] = t, x[2] = i, x[3] = s, x[4] = r, x[5] = n, x[6] = a, x[7] = o, x[8] = l, x[9] = c, x[10] = u, x[11] = d, x[12] = f, x[13] = _, x[14] = g, x[15] = m, y.markAsUpdated(), y;
  }
  /**
   * Creates a new matrix composed by merging scale (vector3), rotation (quaternion) and translation (vector3)
   * Example Playground - https://playground.babylonjs.com/#AV9X17#24
   * @param scale defines the scale vector3
   * @param rotation defines the rotation quaternion
   * @param translation defines the translation vector3
   * @returns a new matrix
   */
  static Compose(e, t, i) {
    const s = new I();
    return I.ComposeToRef(e, t, i, s), s;
  }
  /**
   * Sets a matrix to a value composed by merging scale (vector3), rotation (quaternion) and translation (vector3)
   * Example Playground - https://playground.babylonjs.com/#AV9X17#25
   * @param scale defines the scale vector3
   * @param rotation defines the rotation quaternion
   * @param translation defines the translation vector3
   * @param result defines the target matrix
   * @returns result input
   */
  static ComposeToRef(e, t, i, s) {
    const r = s._m, n = t._x, a = t._y, o = t._z, l = t._w, c = n + n, u = a + a, d = o + o, f = n * c, _ = n * u, g = n * d, m = a * u, y = a * d, x = o * d, A = l * c, T = l * u, M = l * d, b = e._x, S = e._y, P = e._z;
    return r[0] = (1 - (m + x)) * b, r[1] = (_ + M) * b, r[2] = (g - T) * b, r[3] = 0, r[4] = (_ - M) * S, r[5] = (1 - (f + x)) * S, r[6] = (y + A) * S, r[7] = 0, r[8] = (g + T) * P, r[9] = (y - A) * P, r[10] = (1 - (f + m)) * P, r[11] = 0, r[12] = i._x, r[13] = i._y, r[14] = i._z, r[15] = 1, s.markAsUpdated(), s;
  }
  /**
   * Creates a new identity matrix
   * @returns a new identity matrix
   */
  static Identity() {
    const e = I.FromValues(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    return e._updateIdentityStatus(!0), e;
  }
  /**
   * Creates a new identity matrix and stores the result in a given matrix
   * @param result defines the target matrix
   * @returns result input
   */
  static IdentityToRef(e) {
    return I.FromValuesToRef(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, e), e._updateIdentityStatus(!0), e;
  }
  /**
   * Creates a new zero matrix
   * @returns a new zero matrix
   */
  static Zero() {
    const e = I.FromValues(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    return e._updateIdentityStatus(!1), e;
  }
  /**
   * Creates a new rotation matrix for "angle" radians around the X axis
   * Example Playground - https://playground.babylonjs.com/#AV9X17#97
   * @param angle defines the angle (in radians) to use
   * @returns the new matrix
   */
  static RotationX(e) {
    const t = new I();
    return I.RotationXToRef(e, t), t;
  }
  /**
   * Creates a new matrix as the invert of a given matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#124
   * @param source defines the source matrix
   * @returns the new matrix
   */
  static Invert(e) {
    const t = new e.constructor();
    return e.invertToRef(t), t;
  }
  /**
   * Creates a new rotation matrix for "angle" radians around the X axis and stores it in a given matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#98
   * @param angle defines the angle (in radians) to use
   * @param result defines the target matrix
   * @returns result input
   */
  static RotationXToRef(e, t) {
    const i = Math.sin(e), s = Math.cos(e);
    return I.FromValuesToRef(1, 0, 0, 0, 0, s, i, 0, 0, -i, s, 0, 0, 0, 0, 1, t), t._updateIdentityStatus(s === 1 && i === 0), t;
  }
  /**
   * Creates a new rotation matrix for "angle" radians around the Y axis
   * Example Playground - https://playground.babylonjs.com/#AV9X17#99
   * @param angle defines the angle (in radians) to use
   * @returns the new matrix
   */
  static RotationY(e) {
    const t = new I();
    return I.RotationYToRef(e, t), t;
  }
  /**
   * Creates a new rotation matrix for "angle" radians around the Y axis and stores it in a given matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#100
   * @param angle defines the angle (in radians) to use
   * @param result defines the target matrix
   * @returns result input
   */
  static RotationYToRef(e, t) {
    const i = Math.sin(e), s = Math.cos(e);
    return I.FromValuesToRef(s, 0, -i, 0, 0, 1, 0, 0, i, 0, s, 0, 0, 0, 0, 1, t), t._updateIdentityStatus(s === 1 && i === 0), t;
  }
  /**
   * Creates a new rotation matrix for "angle" radians around the Z axis
   * Example Playground - https://playground.babylonjs.com/#AV9X17#101
   * @param angle defines the angle (in radians) to use
   * @returns the new matrix
   */
  static RotationZ(e) {
    const t = new I();
    return I.RotationZToRef(e, t), t;
  }
  /**
   * Creates a new rotation matrix for "angle" radians around the Z axis and stores it in a given matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#102
   * @param angle defines the angle (in radians) to use
   * @param result defines the target matrix
   * @returns result input
   */
  static RotationZToRef(e, t) {
    const i = Math.sin(e), s = Math.cos(e);
    return I.FromValuesToRef(s, i, 0, 0, -i, s, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, t), t._updateIdentityStatus(s === 1 && i === 0), t;
  }
  /**
   * Creates a new rotation matrix for "angle" radians around the given axis
   * Example Playground - https://playground.babylonjs.com/#AV9X17#96
   * @param axis defines the axis to use
   * @param angle defines the angle (in radians) to use
   * @returns the new matrix
   */
  static RotationAxis(e, t) {
    const i = new I();
    return I.RotationAxisToRef(e, t, i), i;
  }
  /**
   * Creates a new rotation matrix for "angle" radians around the given axis and stores it in a given matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#94
   * @param axis defines the axis to use
   * @param angle defines the angle (in radians) to use
   * @param result defines the target matrix
   * @returns result input
   */
  static RotationAxisToRef(e, t, i) {
    const s = Math.sin(-t), r = Math.cos(-t), n = 1 - r;
    e.normalize();
    const a = i._m;
    return a[0] = e._x * e._x * n + r, a[1] = e._x * e._y * n - e._z * s, a[2] = e._x * e._z * n + e._y * s, a[3] = 0, a[4] = e._y * e._x * n + e._z * s, a[5] = e._y * e._y * n + r, a[6] = e._y * e._z * n - e._x * s, a[7] = 0, a[8] = e._z * e._x * n - e._y * s, a[9] = e._z * e._y * n + e._x * s, a[10] = e._z * e._z * n + r, a[11] = 0, a[12] = 0, a[13] = 0, a[14] = 0, a[15] = 1, i.markAsUpdated(), i;
  }
  /**
   * Takes normalised vectors and returns a rotation matrix to align "from" with "to".
   * Taken from http://www.iquilezles.org/www/articles/noacos/noacos.htm
   * Example Playground - https://playground.babylonjs.com/#AV9X17#93
   * @param from defines the vector to align
   * @param to defines the vector to align to
   * @param result defines the target matrix
   * @returns result input
   */
  static RotationAlignToRef(e, t, i) {
    const s = p.Dot(t, e), r = i._m;
    if (s < -1 + pe)
      r[0] = -1, r[1] = 0, r[2] = 0, r[3] = 0, r[4] = 0, r[5] = -1, r[6] = 0, r[7] = 0, r[8] = 0, r[9] = 0, r[10] = 1, r[11] = 0;
    else {
      const n = p.Cross(t, e), a = 1 / (1 + s);
      r[0] = n._x * n._x * a + s, r[1] = n._y * n._x * a - n._z, r[2] = n._z * n._x * a + n._y, r[3] = 0, r[4] = n._x * n._y * a + n._z, r[5] = n._y * n._y * a + s, r[6] = n._z * n._y * a - n._x, r[7] = 0, r[8] = n._x * n._z * a - n._y, r[9] = n._y * n._z * a + n._x, r[10] = n._z * n._z * a + s, r[11] = 0;
    }
    return r[12] = 0, r[13] = 0, r[14] = 0, r[15] = 1, i.markAsUpdated(), i;
  }
  /**
   * Creates a rotation matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#103
   * Example Playground - https://playground.babylonjs.com/#AV9X17#105
   * @param yaw defines the yaw angle in radians (Y axis)
   * @param pitch defines the pitch angle in radians (X axis)
   * @param roll defines the roll angle in radians (Z axis)
   * @returns the new rotation matrix
   */
  static RotationYawPitchRoll(e, t, i) {
    const s = new I();
    return I.RotationYawPitchRollToRef(e, t, i, s), s;
  }
  /**
   * Creates a rotation matrix and stores it in a given matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#104
   * @param yaw defines the yaw angle in radians (Y axis)
   * @param pitch defines the pitch angle in radians (X axis)
   * @param roll defines the roll angle in radians (Z axis)
   * @param result defines the target matrix
   * @returns result input
   */
  static RotationYawPitchRollToRef(e, t, i, s) {
    return U.RotationYawPitchRollToRef(e, t, i, te.Quaternion[0]), te.Quaternion[0].toRotationMatrix(s), s;
  }
  /**
   * Creates a scaling matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#107
   * @param x defines the scale factor on X axis
   * @param y defines the scale factor on Y axis
   * @param z defines the scale factor on Z axis
   * @returns the new matrix
   */
  static Scaling(e, t, i) {
    const s = new I();
    return I.ScalingToRef(e, t, i, s), s;
  }
  /**
   * Creates a scaling matrix and stores it in a given matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#108
   * @param x defines the scale factor on X axis
   * @param y defines the scale factor on Y axis
   * @param z defines the scale factor on Z axis
   * @param result defines the target matrix
   * @returns result input
   */
  static ScalingToRef(e, t, i, s) {
    return I.FromValuesToRef(e, 0, 0, 0, 0, t, 0, 0, 0, 0, i, 0, 0, 0, 0, 1, s), s._updateIdentityStatus(e === 1 && t === 1 && i === 1), s;
  }
  /**
   * Creates a translation matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#109
   * @param x defines the translation on X axis
   * @param y defines the translation on Y axis
   * @param z defines the translationon Z axis
   * @returns the new matrix
   */
  static Translation(e, t, i) {
    const s = new I();
    return I.TranslationToRef(e, t, i, s), s;
  }
  /**
   * Creates a translation matrix and stores it in a given matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#110
   * @param x defines the translation on X axis
   * @param y defines the translation on Y axis
   * @param z defines the translationon Z axis
   * @param result defines the target matrix
   * @returns result input
   */
  static TranslationToRef(e, t, i, s) {
    return I.FromValuesToRef(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, e, t, i, 1, s), s._updateIdentityStatus(e === 0 && t === 0 && i === 0), s;
  }
  /**
   * Returns a new Matrix whose values are the interpolated values for "gradient" (float) between the ones of the matrices "startValue" and "endValue".
   * Example Playground - https://playground.babylonjs.com/#AV9X17#55
   * @param startValue defines the start value
   * @param endValue defines the end value
   * @param gradient defines the gradient factor
   * @returns the new matrix
   */
  static Lerp(e, t, i) {
    const s = new e.constructor();
    return I.LerpToRef(e, t, i, s), s;
  }
  /**
   * Set the given matrix "result" as the interpolated values for "gradient" (float) between the ones of the matrices "startValue" and "endValue".
   * Example Playground - https://playground.babylonjs.com/#AV9X17#54
   * @param startValue defines the start value
   * @param endValue defines the end value
   * @param gradient defines the gradient factor
   * @param result defines the Matrix object where to store data
   * @returns result input
   */
  static LerpToRef(e, t, i, s) {
    const r = s._m, n = e.m, a = t.m;
    for (let o = 0; o < 16; o++)
      r[o] = n[o] * (1 - i) + a[o] * i;
    return s.markAsUpdated(), s;
  }
  /**
   * Builds a new matrix whose values are computed by:
   * * decomposing the the "startValue" and "endValue" matrices into their respective scale, rotation and translation matrices
   * * interpolating for "gradient" (float) the values between each of these decomposed matrices between the start and the end
   * * recomposing a new matrix from these 3 interpolated scale, rotation and translation matrices
   * Example Playground - https://playground.babylonjs.com/#AV9X17#22
   * Example Playground - https://playground.babylonjs.com/#AV9X17#51
   * @param startValue defines the first matrix
   * @param endValue defines the second matrix
   * @param gradient defines the gradient between the two matrices
   * @returns the new matrix
   */
  static DecomposeLerp(e, t, i) {
    const s = new e.constructor();
    return I.DecomposeLerpToRef(e, t, i, s), s;
  }
  /**
   * Update a matrix to values which are computed by:
   * * decomposing the the "startValue" and "endValue" matrices into their respective scale, rotation and translation matrices
   * * interpolating for "gradient" (float) the values between each of these decomposed matrices between the start and the end
   * * recomposing a new matrix from these 3 interpolated scale, rotation and translation matrices
   * Example Playground - https://playground.babylonjs.com/#AV9X17#23
   * Example Playground - https://playground.babylonjs.com/#AV9X17#53
   * @param startValue defines the first matrix
   * @param endValue defines the second matrix
   * @param gradient defines the gradient between the two matrices
   * @param result defines the target matrix
   * @returns result input
   */
  static DecomposeLerpToRef(e, t, i, s) {
    const r = te.Vector3[0], n = te.Quaternion[0], a = te.Vector3[1];
    e.decompose(r, n, a);
    const o = te.Vector3[2], l = te.Quaternion[1], c = te.Vector3[3];
    t.decompose(o, l, c);
    const u = te.Vector3[4];
    p.LerpToRef(r, o, i, u);
    const d = te.Quaternion[2];
    U.SlerpToRef(n, l, i, d);
    const f = te.Vector3[5];
    return p.LerpToRef(a, c, i, f), I.ComposeToRef(u, d, f, s), s;
  }
  /**
   * Creates a new matrix that transforms vertices from world space to camera space. It takes three vectors as arguments that together describe the position and orientation of the camera.
   * This function generates a matrix suitable for a left handed coordinate system
   * Example Playground - https://playground.babylonjs.com/#AV9X17#58
   * Example Playground - https://playground.babylonjs.com/#AV9X17#59
   * @param eye defines the final position of the entity
   * @param target defines where the entity should look at
   * @param up defines the up vector for the entity
   * @returns the new matrix
   */
  static LookAtLH(e, t, i) {
    const s = new I();
    return I.LookAtLHToRef(e, t, i, s), s;
  }
  /**
   * Sets the given "result" Matrix to a matrix that transforms vertices from world space to camera space. It takes three vectors as arguments that together describe the position and orientation of the camera.
   * This function generates a matrix suitable for a left handed coordinate system
   * Example Playground - https://playground.babylonjs.com/#AV9X17#60
   * Example Playground - https://playground.babylonjs.com/#AV9X17#61
   * @param eye defines the final position of the entity
   * @param target defines where the entity should look at
   * @param up defines the up vector for the entity
   * @param result defines the target matrix
   * @returns result input
   */
  static LookAtLHToRef(e, t, i, s) {
    const r = te.Vector3[0], n = te.Vector3[1], a = te.Vector3[2];
    t.subtractToRef(e, a), a.normalize(), p.CrossToRef(i, a, r);
    const o = r.lengthSquared();
    o === 0 ? r.x = 1 : r.normalizeFromLength(Math.sqrt(o)), p.CrossToRef(a, r, n), n.normalize();
    const l = -p.Dot(r, e), c = -p.Dot(n, e), u = -p.Dot(a, e);
    I.FromValuesToRef(r._x, n._x, a._x, 0, r._y, n._y, a._y, 0, r._z, n._z, a._z, 0, l, c, u, 1, s);
  }
  /**
   * Creates a new matrix that transforms vertices from world space to camera space. It takes three vectors as arguments that together describe the position and orientation of the camera.
   * This function generates a matrix suitable for a right handed coordinate system
   * Example Playground - https://playground.babylonjs.com/#AV9X17#62
   * Example Playground - https://playground.babylonjs.com/#AV9X17#63
   * @param eye defines the final position of the entity
   * @param target defines where the entity should look at
   * @param up defines the up vector for the entity
   * @returns the new matrix
   */
  static LookAtRH(e, t, i) {
    const s = new I();
    return I.LookAtRHToRef(e, t, i, s), s;
  }
  /**
   * Sets the given "result" Matrix to a matrix that transforms vertices from world space to camera space. It takes three vectors as arguments that together describe the position and orientation of the camera.
   * This function generates a matrix suitable for a right handed coordinate system
   * Example Playground - https://playground.babylonjs.com/#AV9X17#64
   * Example Playground - https://playground.babylonjs.com/#AV9X17#65
   * @param eye defines the final position of the entity
   * @param target defines where the entity should look at
   * @param up defines the up vector for the entity
   * @param result defines the target matrix
   * @returns result input
   */
  static LookAtRHToRef(e, t, i, s) {
    const r = te.Vector3[0], n = te.Vector3[1], a = te.Vector3[2];
    e.subtractToRef(t, a), a.normalize(), p.CrossToRef(i, a, r);
    const o = r.lengthSquared();
    o === 0 ? r.x = 1 : r.normalizeFromLength(Math.sqrt(o)), p.CrossToRef(a, r, n), n.normalize();
    const l = -p.Dot(r, e), c = -p.Dot(n, e), u = -p.Dot(a, e);
    return I.FromValuesToRef(r._x, n._x, a._x, 0, r._y, n._y, a._y, 0, r._z, n._z, a._z, 0, l, c, u, 1, s), s;
  }
  /**
   * Creates a new matrix that transforms vertices from world space to camera space. It takes two vectors as arguments that together describe the orientation of the camera. The position is assumed to be at the origin (0,0,0)
   * This function generates a matrix suitable for a left handed coordinate system
   * Example Playground - https://playground.babylonjs.com/#AV9X17#66
   * @param forward defines the forward direction - Must be normalized and orthogonal to up.
   * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
   * @returns the new matrix
   */
  static LookDirectionLH(e, t) {
    const i = new I();
    return I.LookDirectionLHToRef(e, t, i), i;
  }
  /**
   * Sets the given "result" Matrix to a matrix that transforms vertices from world space to camera space. It takes two vectors as arguments that together describe the orientation of the camera. The position is assumed to be at the origin (0,0,0)
   * This function generates a matrix suitable for a left handed coordinate system
   * Example Playground - https://playground.babylonjs.com/#AV9X17#67
   * @param forward defines the forward direction - Must be normalized and orthogonal to up.
   * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
   * @param result defines the target matrix
   * @returns result input
   */
  static LookDirectionLHToRef(e, t, i) {
    const s = te.Vector3[0];
    s.copyFrom(e), s.scaleInPlace(-1);
    const r = te.Vector3[1];
    return p.CrossToRef(t, s, r), I.FromValuesToRef(r._x, r._y, r._z, 0, t._x, t._y, t._z, 0, s._x, s._y, s._z, 0, 0, 0, 0, 1, i), i;
  }
  /**
   * Creates a new matrix that transforms vertices from world space to camera space. It takes two vectors as arguments that together describe the orientation of the camera. The position is assumed to be at the origin (0,0,0)
   * This function generates a matrix suitable for a right handed coordinate system
   * Example Playground - https://playground.babylonjs.com/#AV9X17#68
   * @param forward defines the forward direction - Must be normalized and orthogonal to up.
   * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
   * @returns the new matrix
   */
  static LookDirectionRH(e, t) {
    const i = new I();
    return I.LookDirectionRHToRef(e, t, i), i;
  }
  /**
   * Sets the given "result" Matrix to a matrix that transforms vertices from world space to camera space. It takes two vectors as arguments that together describe the orientation of the camera. The position is assumed to be at the origin (0,0,0)
   * This function generates a matrix suitable for a right handed coordinate system
   * Example Playground - https://playground.babylonjs.com/#AV9X17#69
   * @param forward defines the forward direction - Must be normalized and orthogonal to up.
   * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
   * @param result defines the target matrix
   * @returns result input
   */
  static LookDirectionRHToRef(e, t, i) {
    const s = te.Vector3[2];
    return p.CrossToRef(t, e, s), I.FromValuesToRef(s._x, s._y, s._z, 0, t._x, t._y, t._z, 0, e._x, e._y, e._z, 0, 0, 0, 0, 1, i), i;
  }
  /**
   * Create a left-handed orthographic projection matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#70
   * @param width defines the viewport width
   * @param height defines the viewport height
   * @param znear defines the near clip plane
   * @param zfar defines the far clip plane
   * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
   * @returns a new matrix as a left-handed orthographic projection matrix
   */
  static OrthoLH(e, t, i, s, r) {
    const n = new I();
    return I.OrthoLHToRef(e, t, i, s, n, r), n;
  }
  /**
   * Store a left-handed orthographic projection to a given matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#71
   * @param width defines the viewport width
   * @param height defines the viewport height
   * @param znear defines the near clip plane
   * @param zfar defines the far clip plane
   * @param result defines the target matrix
   * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
   * @returns result input
   */
  static OrthoLHToRef(e, t, i, s, r, n) {
    const a = i, o = s, l = 2 / e, c = 2 / t, u = 2 / (o - a), d = -(o + a) / (o - a);
    return I.FromValuesToRef(l, 0, 0, 0, 0, c, 0, 0, 0, 0, u, 0, 0, 0, d, 1, r), n && r.multiplyToRef(Di, r), r._updateIdentityStatus(l === 1 && c === 1 && u === 1 && d === 0), r;
  }
  /**
   * Create a left-handed orthographic projection matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#72
   * @param left defines the viewport left coordinate
   * @param right defines the viewport right coordinate
   * @param bottom defines the viewport bottom coordinate
   * @param top defines the viewport top coordinate
   * @param znear defines the near clip plane
   * @param zfar defines the far clip plane
   * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
   * @returns a new matrix as a left-handed orthographic projection matrix
   */
  static OrthoOffCenterLH(e, t, i, s, r, n, a) {
    const o = new I();
    return I.OrthoOffCenterLHToRef(e, t, i, s, r, n, o, a), o;
  }
  /**
   * Stores a left-handed orthographic projection into a given matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#73
   * @param left defines the viewport left coordinate
   * @param right defines the viewport right coordinate
   * @param bottom defines the viewport bottom coordinate
   * @param top defines the viewport top coordinate
   * @param znear defines the near clip plane
   * @param zfar defines the far clip plane
   * @param result defines the target matrix
   * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
   * @returns result input
   */
  static OrthoOffCenterLHToRef(e, t, i, s, r, n, a, o) {
    const l = r, c = n, u = 2 / (t - e), d = 2 / (s - i), f = 2 / (c - l), _ = -(c + l) / (c - l), g = (e + t) / (e - t), m = (s + i) / (i - s);
    return I.FromValuesToRef(u, 0, 0, 0, 0, d, 0, 0, 0, 0, f, 0, g, m, _, 1, a), o && a.multiplyToRef(Di, a), a.markAsUpdated(), a;
  }
  /**
   * Creates a right-handed orthographic projection matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#76
   * @param left defines the viewport left coordinate
   * @param right defines the viewport right coordinate
   * @param bottom defines the viewport bottom coordinate
   * @param top defines the viewport top coordinate
   * @param znear defines the near clip plane
   * @param zfar defines the far clip plane
   * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
   * @returns a new matrix as a right-handed orthographic projection matrix
   */
  static OrthoOffCenterRH(e, t, i, s, r, n, a) {
    const o = new I();
    return I.OrthoOffCenterRHToRef(e, t, i, s, r, n, o, a), o;
  }
  /**
   * Stores a right-handed orthographic projection into a given matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#77
   * @param left defines the viewport left coordinate
   * @param right defines the viewport right coordinate
   * @param bottom defines the viewport bottom coordinate
   * @param top defines the viewport top coordinate
   * @param znear defines the near clip plane
   * @param zfar defines the far clip plane
   * @param result defines the target matrix
   * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
   * @returns result input
   */
  static OrthoOffCenterRHToRef(e, t, i, s, r, n, a, o) {
    return I.OrthoOffCenterLHToRef(e, t, i, s, r, n, a, o), a._m[10] *= -1, a;
  }
  /**
   * Creates a left-handed perspective projection matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#85
   * @param width defines the viewport width
   * @param height defines the viewport height
   * @param znear defines the near clip plane
   * @param zfar defines the far clip plane
   * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
   * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
   * @returns a new matrix as a left-handed perspective projection matrix
   */
  static PerspectiveLH(e, t, i, s, r, n = 0) {
    const a = new I(), o = i, l = s, c = 2 * o / e, u = 2 * o / t, d = (l + o) / (l - o), f = -2 * l * o / (l - o), _ = Math.tan(n);
    return I.FromValuesToRef(c, 0, 0, 0, 0, u, 0, _, 0, 0, d, 1, 0, 0, f, 0, a), r && a.multiplyToRef(Di, a), a._updateIdentityStatus(!1), a;
  }
  /**
   * Creates a left-handed perspective projection matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#78
   * @param fov defines the horizontal field of view
   * @param aspect defines the aspect ratio
   * @param znear defines the near clip plane
   * @param zfar defines the far clip plane. If 0, assume we are in "infinite zfar" mode
   * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
   * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
   * @param reverseDepthBufferMode true to indicate that we are in a reverse depth buffer mode (meaning znear and zfar have been inverted when calling the function)
   * @returns a new matrix as a left-handed perspective projection matrix
   */
  static PerspectiveFovLH(e, t, i, s, r, n = 0, a = !1) {
    const o = new I();
    return I.PerspectiveFovLHToRef(e, t, i, s, o, !0, r, n, a), o;
  }
  /**
   * Stores a left-handed perspective projection into a given matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#81
   * @param fov defines the horizontal field of view
   * @param aspect defines the aspect ratio
   * @param znear defines the near clip plane
   * @param zfar defines the far clip plane. If 0, assume we are in "infinite zfar" mode
   * @param result defines the target matrix
   * @param isVerticalFovFixed defines it the fov is vertically fixed (default) or horizontally
   * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
   * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
   * @param reverseDepthBufferMode true to indicate that we are in a reverse depth buffer mode (meaning znear and zfar have been inverted when calling the function)
   * @returns result input
   */
  static PerspectiveFovLHToRef(e, t, i, s, r, n = !0, a, o = 0, l = !1) {
    const c = i, u = s, d = 1 / Math.tan(e * 0.5), f = n ? d / t : d, _ = n ? d : d * t, g = l && c === 0 ? -1 : u !== 0 ? (u + c) / (u - c) : 1, m = l && c === 0 ? 2 * u : u !== 0 ? -2 * u * c / (u - c) : -2 * c, y = Math.tan(o);
    return I.FromValuesToRef(f, 0, 0, 0, 0, _, 0, y, 0, 0, g, 1, 0, 0, m, 0, r), a && r.multiplyToRef(Di, r), r._updateIdentityStatus(!1), r;
  }
  /**
   * Stores a left-handed perspective projection into a given matrix with depth reversed
   * Example Playground - https://playground.babylonjs.com/#AV9X17#89
   * @param fov defines the horizontal field of view
   * @param aspect defines the aspect ratio
   * @param znear defines the near clip plane
   * @param zfar not used as infinity is used as far clip
   * @param result defines the target matrix
   * @param isVerticalFovFixed defines it the fov is vertically fixed (default) or horizontally
   * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
   * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
   * @returns result input
   */
  static PerspectiveFovReverseLHToRef(e, t, i, s, r, n = !0, a, o = 0) {
    const l = 1 / Math.tan(e * 0.5), c = n ? l / t : l, u = n ? l : l * t, d = Math.tan(o);
    return I.FromValuesToRef(c, 0, 0, 0, 0, u, 0, d, 0, 0, -i, 1, 0, 0, 1, 0, r), a && r.multiplyToRef(Di, r), r._updateIdentityStatus(!1), r;
  }
  /**
   * Creates a right-handed perspective projection matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#83
   * @param fov defines the horizontal field of view
   * @param aspect defines the aspect ratio
   * @param znear defines the near clip plane
   * @param zfar defines the far clip plane. If 0, assume we are in "infinite zfar" mode
   * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
   * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
   * @param reverseDepthBufferMode true to indicate that we are in a reverse depth buffer mode (meaning znear and zfar have been inverted when calling the function)
   * @returns a new matrix as a right-handed perspective projection matrix
   */
  static PerspectiveFovRH(e, t, i, s, r, n = 0, a = !1) {
    const o = new I();
    return I.PerspectiveFovRHToRef(e, t, i, s, o, !0, r, n, a), o;
  }
  /**
   * Stores a right-handed perspective projection into a given matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#84
   * @param fov defines the horizontal field of view
   * @param aspect defines the aspect ratio
   * @param znear defines the near clip plane
   * @param zfar defines the far clip plane. If 0, assume we are in "infinite zfar" mode
   * @param result defines the target matrix
   * @param isVerticalFovFixed defines it the fov is vertically fixed (default) or horizontally
   * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
   * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
   * @param reverseDepthBufferMode true to indicate that we are in a reverse depth buffer mode (meaning znear and zfar have been inverted when calling the function)
   * @returns result input
   */
  static PerspectiveFovRHToRef(e, t, i, s, r, n = !0, a, o = 0, l = !1) {
    const c = i, u = s, d = 1 / Math.tan(e * 0.5), f = n ? d / t : d, _ = n ? d : d * t, g = l && c === 0 ? 1 : u !== 0 ? -(u + c) / (u - c) : -1, m = l && c === 0 ? 2 * u : u !== 0 ? -2 * u * c / (u - c) : -2 * c, y = Math.tan(o);
    return I.FromValuesToRef(f, 0, 0, 0, 0, _, 0, y, 0, 0, g, -1, 0, 0, m, 0, r), a && r.multiplyToRef(Di, r), r._updateIdentityStatus(!1), r;
  }
  /**
   * Stores a right-handed perspective projection into a given matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#90
   * @param fov defines the horizontal field of view
   * @param aspect defines the aspect ratio
   * @param znear defines the near clip plane
   * @param zfar not used as infinity is used as far clip
   * @param result defines the target matrix
   * @param isVerticalFovFixed defines it the fov is vertically fixed (default) or horizontally
   * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
   * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
   * @returns result input
   */
  static PerspectiveFovReverseRHToRef(e, t, i, s, r, n = !0, a, o = 0) {
    const l = 1 / Math.tan(e * 0.5), c = n ? l / t : l, u = n ? l : l * t, d = Math.tan(o);
    return I.FromValuesToRef(c, 0, 0, 0, 0, u, 0, d, 0, 0, -i, -1, 0, 0, -1, 0, r), a && r.multiplyToRef(Di, r), r._updateIdentityStatus(!1), r;
  }
  /**
   * Stores a perspective projection for WebVR info a given matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#92
   * @param fov defines the field of view
   * @param fov.upDegrees
   * @param fov.downDegrees
   * @param fov.leftDegrees
   * @param fov.rightDegrees
   * @param znear defines the near clip plane
   * @param zfar defines the far clip plane
   * @param result defines the target matrix
   * @param rightHanded defines if the matrix must be in right-handed mode (false by default)
   * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
   * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
   * @returns result input
   */
  static PerspectiveFovWebVRToRef(e, t, i, s, r = !1, n, a = 0) {
    const o = r ? -1 : 1, l = Math.tan(e.upDegrees * Math.PI / 180), c = Math.tan(e.downDegrees * Math.PI / 180), u = Math.tan(e.leftDegrees * Math.PI / 180), d = Math.tan(e.rightDegrees * Math.PI / 180), f = 2 / (u + d), _ = 2 / (l + c), g = Math.tan(a), m = s._m;
    return m[0] = f, m[1] = m[2] = m[3] = m[4] = 0, m[5] = _, m[6] = 0, m[7] = g, m[8] = (u - d) * f * 0.5, m[9] = -((l - c) * _ * 0.5), m[10] = -i / (t - i), m[11] = 1 * o, m[12] = m[13] = m[15] = 0, m[14] = -(2 * i * t) / (i - t), n && s.multiplyToRef(Di, s), s.markAsUpdated(), s;
  }
  /**
   * Computes a complete transformation matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#113
   * @param viewport defines the viewport to use
   * @param world defines the world matrix
   * @param view defines the view matrix
   * @param projection defines the projection matrix
   * @param zmin defines the near clip plane
   * @param zmax defines the far clip plane
   * @returns the transformation matrix
   */
  static GetFinalMatrix(e, t, i, s, r, n) {
    const a = e.width, o = e.height, l = e.x, c = e.y, u = I.FromValues(a / 2, 0, 0, 0, 0, -o / 2, 0, 0, 0, 0, n - r, 0, l + a / 2, o / 2 + c, r, 1), d = new t.constructor();
    return t.multiplyToRef(i, d), d.multiplyToRef(s, d), d.multiplyToRef(u, d);
  }
  /**
   * Extracts a 2x2 matrix from a given matrix and store the result in a Float32Array
   * @param matrix defines the matrix to use
   * @returns a new Float32Array array with 4 elements : the 2x2 matrix extracted from the given matrix
   */
  static GetAsMatrix2x2(e) {
    const t = e.m, i = [t[0], t[1], t[4], t[5]];
    return ht.MatrixUse64Bits ? i : new Float32Array(i);
  }
  /**
   * Extracts a 3x3 matrix from a given matrix and store the result in a Float32Array
   * @param matrix defines the matrix to use
   * @returns a new Float32Array array with 9 elements : the 3x3 matrix extracted from the given matrix
   */
  static GetAsMatrix3x3(e) {
    const t = e.m, i = [t[0], t[1], t[2], t[4], t[5], t[6], t[8], t[9], t[10]];
    return ht.MatrixUse64Bits ? i : new Float32Array(i);
  }
  /**
   * Compute the transpose of a given matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#111
   * @param matrix defines the matrix to transpose
   * @returns the new matrix
   */
  static Transpose(e) {
    const t = new e.constructor();
    return I.TransposeToRef(e, t), t;
  }
  /**
   * Compute the transpose of a matrix and store it in a target matrix
   * Example Playground - https://playground.babylonjs.com/#AV9X17#112
   * @param matrix defines the matrix to transpose
   * @param result defines the target matrix
   * @returns result input
   */
  static TransposeToRef(e, t) {
    const i = t._m, s = e.m;
    return i[0] = s[0], i[1] = s[4], i[2] = s[8], i[3] = s[12], i[4] = s[1], i[5] = s[5], i[6] = s[9], i[7] = s[13], i[8] = s[2], i[9] = s[6], i[10] = s[10], i[11] = s[14], i[12] = s[3], i[13] = s[7], i[14] = s[11], i[15] = s[15], t.markAsUpdated(), t._updateIdentityStatus(e._isIdentity, e._isIdentityDirty), t;
  }
  /**
   * Computes a reflection matrix from a plane
   * Example Playground - https://playground.babylonjs.com/#AV9X17#87
   * @param plane defines the reflection plane
   * @returns a new matrix
   */
  static Reflection(e) {
    const t = new I();
    return I.ReflectionToRef(e, t), t;
  }
  /**
   * Computes a reflection matrix from a plane
   * Example Playground - https://playground.babylonjs.com/#AV9X17#88
   * @param plane defines the reflection plane
   * @param result defines the target matrix
   * @returns result input
   */
  static ReflectionToRef(e, t) {
    e.normalize();
    const i = e.normal.x, s = e.normal.y, r = e.normal.z, n = -2 * i, a = -2 * s, o = -2 * r;
    return I.FromValuesToRef(n * i + 1, a * i, o * i, 0, n * s, a * s + 1, o * s, 0, n * r, a * r, o * r + 1, 0, n * e.d, a * e.d, o * e.d, 1, t), t;
  }
  /**
   * Sets the given matrix as a rotation matrix composed from the 3 left handed axes
   * @param xaxis defines the value of the 1st axis
   * @param yaxis defines the value of the 2nd axis
   * @param zaxis defines the value of the 3rd axis
   * @param result defines the target matrix
   * @returns result input
   */
  static FromXYZAxesToRef(e, t, i, s) {
    return I.FromValuesToRef(e._x, e._y, e._z, 0, t._x, t._y, t._z, 0, i._x, i._y, i._z, 0, 0, 0, 0, 1, s), s;
  }
  /**
   * Creates a rotation matrix from a quaternion and stores it in a target matrix
   * @param quat defines the quaternion to use
   * @param result defines the target matrix
   * @returns result input
   */
  static FromQuaternionToRef(e, t) {
    const i = e._x * e._x, s = e._y * e._y, r = e._z * e._z, n = e._x * e._y, a = e._z * e._w, o = e._z * e._x, l = e._y * e._w, c = e._y * e._z, u = e._x * e._w;
    return t._m[0] = 1 - 2 * (s + r), t._m[1] = 2 * (n + a), t._m[2] = 2 * (o - l), t._m[3] = 0, t._m[4] = 2 * (n - a), t._m[5] = 1 - 2 * (r + i), t._m[6] = 2 * (c + u), t._m[7] = 0, t._m[8] = 2 * (o + l), t._m[9] = 2 * (c - u), t._m[10] = 1 - 2 * (s + i), t._m[11] = 0, t._m[12] = 0, t._m[13] = 0, t._m[14] = 0, t._m[15] = 1, t.markAsUpdated(), t;
  }
}
I._UpdateFlagSeed = 0;
I._IdentityReadOnly = I.Identity();
class te {
}
te.Vector3 = ot.BuildTuple(11, p.Zero);
te.Matrix = ot.BuildTuple(2, I.Identity);
te.Quaternion = ot.BuildTuple(3, U.Zero);
class C {
}
C.Vector2 = ot.BuildTuple(3, ue.Zero);
C.Vector3 = ot.BuildTuple(13, p.Zero);
C.Vector4 = ot.BuildTuple(3, ze.Zero);
C.Quaternion = ot.BuildTuple(2, U.Zero);
C.Matrix = ot.BuildTuple(8, I.Identity);
Xe("BABYLON.Vector2", ue);
Xe("BABYLON.Vector3", p);
Xe("BABYLON.Vector4", ze);
Xe("BABYLON.Matrix", I);
const Di = I.FromValues(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0.5, 0, 0, 0, 0.5, 1);
function he(h) {
  return `${h} needs to be imported before as it contains a side-effect required by your code.`;
}
function ls(h) {
  return Math.pow(h, dr);
}
function hs(h) {
  return h <= 0.04045 ? 0.0773993808 * h : Math.pow(0.947867299 * (h + 0.055), 2.4);
}
function cs(h) {
  return Math.pow(h, ur);
}
function us(h) {
  return h <= 31308e-7 ? 12.92 * h : 1.055 * Math.pow(h, 0.41666) - 0.055;
}
class ie {
  /**
   * Creates a new Color3 object from red, green, blue values, all between 0 and 1
   * @param r defines the red component (between 0 and 1, default is 0)
   * @param g defines the green component (between 0 and 1, default is 0)
   * @param b defines the blue component (between 0 and 1, default is 0)
   */
  constructor(e = 0, t = 0, i = 0) {
    this.r = e, this.g = t, this.b = i;
  }
  /**
   * Creates a string with the Color3 current values
   * @returns the string representation of the Color3 object
   */
  toString() {
    return "{R: " + this.r + " G:" + this.g + " B:" + this.b + "}";
  }
  /**
   * Returns the string "Color3"
   * @returns "Color3"
   */
  getClassName() {
    return "Color3";
  }
  /**
   * Compute the Color3 hash code
   * @returns an unique number that can be used to hash Color3 objects
   */
  getHashCode() {
    let e = this.r * 255 | 0;
    return e = e * 397 ^ (this.g * 255 | 0), e = e * 397 ^ (this.b * 255 | 0), e;
  }
  // Operators
  /**
   * Stores in the given array from the given starting index the red, green, blue values as successive elements
   * @param array defines the array where to store the r,g,b components
   * @param index defines an optional index in the target array to define where to start storing values
   * @returns the current Color3 object
   */
  toArray(e, t = 0) {
    return e[t] = this.r, e[t + 1] = this.g, e[t + 2] = this.b, this;
  }
  /**
   * Update the current color with values stored in an array from the starting index of the given array
   * @param array defines the source array
   * @param offset defines an offset in the source array
   * @returns the current Color3 object
   */
  fromArray(e, t = 0) {
    return ie.FromArrayToRef(e, t, this), this;
  }
  /**
   * Returns a new Color4 object from the current Color3 and the given alpha
   * @param alpha defines the alpha component on the new Color4 object (default is 1)
   * @returns a new Color4 object
   */
  toColor4(e = 1) {
    return new ye(this.r, this.g, this.b, e);
  }
  /**
   * Returns a new array populated with 3 numeric elements : red, green and blue values
   * @returns the new array
   */
  asArray() {
    return [this.r, this.g, this.b];
  }
  /**
   * Returns the luminance value
   * @returns a float value
   */
  toLuminance() {
    return this.r * 0.3 + this.g * 0.59 + this.b * 0.11;
  }
  /**
   * Multiply each Color3 rgb values by the given Color3 rgb values in a new Color3 object
   * @param otherColor defines the second operand
   * @returns the new Color3 object
   */
  multiply(e) {
    return new ie(this.r * e.r, this.g * e.g, this.b * e.b);
  }
  /**
   * Multiply the rgb values of the Color3 and the given Color3 and stores the result in the object "result"
   * @param otherColor defines the second operand
   * @param result defines the Color3 object where to store the result
   * @returns the current Color3
   */
  multiplyToRef(e, t) {
    return t.r = this.r * e.r, t.g = this.g * e.g, t.b = this.b * e.b, this;
  }
  /**
   * Determines equality between Color3 objects
   * @param otherColor defines the second operand
   * @returns true if the rgb values are equal to the given ones
   */
  equals(e) {
    return e && this.r === e.r && this.g === e.g && this.b === e.b;
  }
  /**
   * Determines equality between the current Color3 object and a set of r,b,g values
   * @param r defines the red component to check
   * @param g defines the green component to check
   * @param b defines the blue component to check
   * @returns true if the rgb values are equal to the given ones
   */
  equalsFloats(e, t, i) {
    return this.r === e && this.g === t && this.b === i;
  }
  /**
   * Creates a new Color3 with the current Color3 values multiplied by scale
   * @param scale defines the scaling factor to apply
   * @returns a new Color3 object
   */
  scale(e) {
    return new ie(this.r * e, this.g * e, this.b * e);
  }
  /**
   * Multiplies the Color3 values by the float "scale"
   * @param scale defines the scaling factor to apply
   * @returns the current updated Color3
   */
  scaleInPlace(e) {
    return this.r *= e, this.g *= e, this.b *= e, this;
  }
  /**
   * Multiplies the rgb values by scale and stores the result into "result"
   * @param scale defines the scaling factor
   * @param result defines the Color3 object where to store the result
   * @returns the unmodified current Color3
   */
  scaleToRef(e, t) {
    return t.r = this.r * e, t.g = this.g * e, t.b = this.b * e, this;
  }
  /**
   * Scale the current Color3 values by a factor and add the result to a given Color3
   * @param scale defines the scale factor
   * @param result defines color to store the result into
   * @returns the unmodified current Color3
   */
  scaleAndAddToRef(e, t) {
    return t.r += this.r * e, t.g += this.g * e, t.b += this.b * e, this;
  }
  /**
   * Clamps the rgb values by the min and max values and stores the result into "result"
   * @param min defines minimum clamping value (default is 0)
   * @param max defines maximum clamping value (default is 1)
   * @param result defines color to store the result into
   * @returns the original Color3
   */
  clampToRef(e = 0, t = 1, i) {
    return i.r = J.Clamp(this.r, e, t), i.g = J.Clamp(this.g, e, t), i.b = J.Clamp(this.b, e, t), this;
  }
  /**
   * Creates a new Color3 set with the added values of the current Color3 and of the given one
   * @param otherColor defines the second operand
   * @returns the new Color3
   */
  add(e) {
    return new ie(this.r + e.r, this.g + e.g, this.b + e.b);
  }
  /**
   * Stores the result of the addition of the current Color3 and given one rgb values into "result"
   * @param otherColor defines the second operand
   * @param result defines Color3 object to store the result into
   * @returns the unmodified current Color3
   */
  addToRef(e, t) {
    return t.r = this.r + e.r, t.g = this.g + e.g, t.b = this.b + e.b, this;
  }
  /**
   * Returns a new Color3 set with the subtracted values of the given one from the current Color3
   * @param otherColor defines the second operand
   * @returns the new Color3
   */
  subtract(e) {
    return new ie(this.r - e.r, this.g - e.g, this.b - e.b);
  }
  /**
   * Stores the result of the subtraction of given one from the current Color3 rgb values into "result"
   * @param otherColor defines the second operand
   * @param result defines Color3 object to store the result into
   * @returns the unmodified current Color3
   */
  subtractToRef(e, t) {
    return t.r = this.r - e.r, t.g = this.g - e.g, t.b = this.b - e.b, this;
  }
  /**
   * Copy the current object
   * @returns a new Color3 copied the current one
   */
  clone() {
    return new ie(this.r, this.g, this.b);
  }
  /**
   * Copies the rgb values from the source in the current Color3
   * @param source defines the source Color3 object
   * @returns the updated Color3 object
   */
  copyFrom(e) {
    return this.r = e.r, this.g = e.g, this.b = e.b, this;
  }
  /**
   * Updates the Color3 rgb values from the given floats
   * @param r defines the red component to read from
   * @param g defines the green component to read from
   * @param b defines the blue component to read from
   * @returns the current Color3 object
   */
  copyFromFloats(e, t, i) {
    return this.r = e, this.g = t, this.b = i, this;
  }
  /**
   * Updates the Color3 rgb values from the given floats
   * @param r defines the red component to read from
   * @param g defines the green component to read from
   * @param b defines the blue component to read from
   * @returns the current Color3 object
   */
  set(e, t, i) {
    return this.copyFromFloats(e, t, i);
  }
  /**
   * Compute the Color3 hexadecimal code as a string
   * @returns a string containing the hexadecimal representation of the Color3 object
   */
  toHexString() {
    const e = Math.round(this.r * 255), t = Math.round(this.g * 255), i = Math.round(this.b * 255);
    return "#" + J.ToHex(e) + J.ToHex(t) + J.ToHex(i);
  }
  /**
   * Converts current color in rgb space to HSV values
   * @returns a new color3 representing the HSV values
   */
  toHSV() {
    const e = new ie();
    return this.toHSVToRef(e), e;
  }
  /**
   * Converts current color in rgb space to HSV values
   * @param result defines the Color3 where to store the HSV values
   */
  toHSVToRef(e) {
    const t = this.r, i = this.g, s = this.b, r = Math.max(t, i, s), n = Math.min(t, i, s);
    let a = 0, o = 0;
    const l = r, c = r - n;
    r !== 0 && (o = c / r), r != n && (r == t ? (a = (i - s) / c, i < s && (a += 6)) : r == i ? a = (s - t) / c + 2 : r == s && (a = (t - i) / c + 4), a *= 60), e.r = a, e.g = o, e.b = l;
  }
  /**
   * Computes a new Color3 converted from the current one to linear space
   * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
   * @returns a new Color3 object
   */
  toLinearSpace(e = !1) {
    const t = new ie();
    return this.toLinearSpaceToRef(t, e), t;
  }
  /**
   * Converts the Color3 values to linear space and stores the result in "convertedColor"
   * @param convertedColor defines the Color3 object where to store the linear space version
   * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
   * @returns the unmodified Color3
   */
  toLinearSpaceToRef(e, t = !1) {
    return t ? (e.r = hs(this.r), e.g = hs(this.g), e.b = hs(this.b)) : (e.r = ls(this.r), e.g = ls(this.g), e.b = ls(this.b)), this;
  }
  /**
   * Computes a new Color3 converted from the current one to gamma space
   * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
   * @returns a new Color3 object
   */
  toGammaSpace(e = !1) {
    const t = new ie();
    return this.toGammaSpaceToRef(t, e), t;
  }
  /**
   * Converts the Color3 values to gamma space and stores the result in "convertedColor"
   * @param convertedColor defines the Color3 object where to store the gamma space version
   * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
   * @returns the unmodified Color3
   */
  toGammaSpaceToRef(e, t = !1) {
    return t ? (e.r = us(this.r), e.g = us(this.g), e.b = us(this.b)) : (e.r = cs(this.r), e.g = cs(this.g), e.b = cs(this.b)), this;
  }
  /**
   * Converts Hue, saturation and value to a Color3 (RGB)
   * @param hue defines the hue (value between 0 and 360)
   * @param saturation defines the saturation (value between 0 and 1)
   * @param value defines the value (value between 0 and 1)
   * @param result defines the Color3 where to store the RGB values
   */
  static HSVtoRGBToRef(e, t, i, s) {
    const r = i * t, n = e / 60, a = r * (1 - Math.abs(n % 2 - 1));
    let o = 0, l = 0, c = 0;
    n >= 0 && n <= 1 ? (o = r, l = a) : n >= 1 && n <= 2 ? (o = a, l = r) : n >= 2 && n <= 3 ? (l = r, c = a) : n >= 3 && n <= 4 ? (l = a, c = r) : n >= 4 && n <= 5 ? (o = a, c = r) : n >= 5 && n <= 6 && (o = r, c = a);
    const u = i - r;
    s.set(o + u, l + u, c + u);
  }
  /**
   * Converts Hue, saturation and value to a new Color3 (RGB)
   * @param hue defines the hue (value between 0 and 360)
   * @param saturation defines the saturation (value between 0 and 1)
   * @param value defines the value (value between 0 and 1)
   * @returns a new Color3 object
   */
  static FromHSV(e, t, i) {
    const s = new ie(0, 0, 0);
    return ie.HSVtoRGBToRef(e, t, i, s), s;
  }
  /**
   * Creates a new Color3 from the string containing valid hexadecimal values
   * @param hex defines a string containing valid hexadecimal values
   * @returns a new Color3 object
   */
  static FromHexString(e) {
    if (e.substring(0, 1) !== "#" || e.length !== 7)
      return new ie(0, 0, 0);
    const t = parseInt(e.substring(1, 3), 16), i = parseInt(e.substring(3, 5), 16), s = parseInt(e.substring(5, 7), 16);
    return ie.FromInts(t, i, s);
  }
  /**
   * Creates a new Color3 from the starting index of the given array
   * @param array defines the source array
   * @param offset defines an offset in the source array
   * @returns a new Color3 object
   */
  static FromArray(e, t = 0) {
    return new ie(e[t], e[t + 1], e[t + 2]);
  }
  /**
   * Creates a new Color3 from the starting index element of the given array
   * @param array defines the source array to read from
   * @param offset defines the offset in the source array
   * @param result defines the target Color3 object
   */
  static FromArrayToRef(e, t = 0, i) {
    i.r = e[t], i.g = e[t + 1], i.b = e[t + 2];
  }
  /**
   * Creates a new Color3 from integer values (< 256)
   * @param r defines the red component to read from (value between 0 and 255)
   * @param g defines the green component to read from (value between 0 and 255)
   * @param b defines the blue component to read from (value between 0 and 255)
   * @returns a new Color3 object
   */
  static FromInts(e, t, i) {
    return new ie(e / 255, t / 255, i / 255);
  }
  /**
   * Creates a new Color3 with values linearly interpolated of "amount" between the start Color3 and the end Color3
   * @param start defines the start Color3 value
   * @param end defines the end Color3 value
   * @param amount defines the gradient value between start and end
   * @returns a new Color3 object
   */
  static Lerp(e, t, i) {
    const s = new ie(0, 0, 0);
    return ie.LerpToRef(e, t, i, s), s;
  }
  /**
   * Creates a new Color3 with values linearly interpolated of "amount" between the start Color3 and the end Color3
   * @param left defines the start value
   * @param right defines the end value
   * @param amount defines the gradient factor
   * @param result defines the Color3 object where to store the result
   */
  static LerpToRef(e, t, i, s) {
    s.r = e.r + (t.r - e.r) * i, s.g = e.g + (t.g - e.g) * i, s.b = e.b + (t.b - e.b) * i;
  }
  /**
   * Returns a new Color3 located for "amount" (float) on the Hermite interpolation spline defined by the vectors "value1", "tangent1", "value2", "tangent2"
   * @param value1 defines the first control point
   * @param tangent1 defines the first tangent Color3
   * @param value2 defines the second control point
   * @param tangent2 defines the second tangent Color3
   * @param amount defines the amount on the interpolation spline (between 0 and 1)
   * @returns the new Color3
   */
  static Hermite(e, t, i, s, r) {
    const n = r * r, a = r * n, o = 2 * a - 3 * n + 1, l = -2 * a + 3 * n, c = a - 2 * n + r, u = a - n, d = e.r * o + i.r * l + t.r * c + s.r * u, f = e.g * o + i.g * l + t.g * c + s.g * u, _ = e.b * o + i.b * l + t.b * c + s.b * u;
    return new ie(d, f, _);
  }
  /**
   * Returns a new Color3 which is the 1st derivative of the Hermite spline defined by the colors "value1", "value2", "tangent1", "tangent2".
   * @param value1 defines the first control point
   * @param tangent1 defines the first tangent
   * @param value2 defines the second control point
   * @param tangent2 defines the second tangent
   * @param time define where the derivative must be done
   * @returns 1st derivative
   */
  static Hermite1stDerivative(e, t, i, s, r) {
    const n = ie.Black();
    return this.Hermite1stDerivativeToRef(e, t, i, s, r, n), n;
  }
  /**
   * Returns a new Color3 which is the 1st derivative of the Hermite spline defined by the colors "value1", "value2", "tangent1", "tangent2".
   * @param value1 defines the first control point
   * @param tangent1 defines the first tangent
   * @param value2 defines the second control point
   * @param tangent2 defines the second tangent
   * @param time define where the derivative must be done
   * @param result define where to store the derivative
   */
  static Hermite1stDerivativeToRef(e, t, i, s, r, n) {
    const a = r * r;
    n.r = (a - r) * 6 * e.r + (3 * a - 4 * r + 1) * t.r + (-a + r) * 6 * i.r + (3 * a - 2 * r) * s.r, n.g = (a - r) * 6 * e.g + (3 * a - 4 * r + 1) * t.g + (-a + r) * 6 * i.g + (3 * a - 2 * r) * s.g, n.b = (a - r) * 6 * e.b + (3 * a - 4 * r + 1) * t.b + (-a + r) * 6 * i.b + (3 * a - 2 * r) * s.b;
  }
  /**
   * Returns a Color3 value containing a red color
   * @returns a new Color3 object
   */
  static Red() {
    return new ie(1, 0, 0);
  }
  /**
   * Returns a Color3 value containing a green color
   * @returns a new Color3 object
   */
  static Green() {
    return new ie(0, 1, 0);
  }
  /**
   * Returns a Color3 value containing a blue color
   * @returns a new Color3 object
   */
  static Blue() {
    return new ie(0, 0, 1);
  }
  /**
   * Returns a Color3 value containing a black color
   * @returns a new Color3 object
   */
  static Black() {
    return new ie(0, 0, 0);
  }
  /**
   * Gets a Color3 value containing a black color that must not be updated
   */
  static get BlackReadOnly() {
    return ie._BlackReadOnly;
  }
  /**
   * Returns a Color3 value containing a white color
   * @returns a new Color3 object
   */
  static White() {
    return new ie(1, 1, 1);
  }
  /**
   * Returns a Color3 value containing a purple color
   * @returns a new Color3 object
   */
  static Purple() {
    return new ie(0.5, 0, 0.5);
  }
  /**
   * Returns a Color3 value containing a magenta color
   * @returns a new Color3 object
   */
  static Magenta() {
    return new ie(1, 0, 1);
  }
  /**
   * Returns a Color3 value containing a yellow color
   * @returns a new Color3 object
   */
  static Yellow() {
    return new ie(1, 1, 0);
  }
  /**
   * Returns a Color3 value containing a gray color
   * @returns a new Color3 object
   */
  static Gray() {
    return new ie(0.5, 0.5, 0.5);
  }
  /**
   * Returns a Color3 value containing a teal color
   * @returns a new Color3 object
   */
  static Teal() {
    return new ie(0, 1, 1);
  }
  /**
   * Returns a Color3 value containing a random color
   * @returns a new Color3 object
   */
  static Random() {
    return new ie(Math.random(), Math.random(), Math.random());
  }
}
ie._BlackReadOnly = ie.Black();
class ye {
  /**
   * Creates a new Color4 object from red, green, blue values, all between 0 and 1
   * @param r defines the red component (between 0 and 1, default is 0)
   * @param g defines the green component (between 0 and 1, default is 0)
   * @param b defines the blue component (between 0 and 1, default is 0)
   * @param a defines the alpha component (between 0 and 1, default is 1)
   */
  constructor(e = 0, t = 0, i = 0, s = 1) {
    this.r = e, this.g = t, this.b = i, this.a = s;
  }
  // Operators
  /**
   * Adds in place the given Color4 values to the current Color4 object
   * @param right defines the second operand
   * @returns the current updated Color4 object
   */
  addInPlace(e) {
    return this.r += e.r, this.g += e.g, this.b += e.b, this.a += e.a, this;
  }
  /**
   * Creates a new array populated with 4 numeric elements : red, green, blue, alpha values
   * @returns the new array
   */
  asArray() {
    return [this.r, this.g, this.b, this.a];
  }
  /**
   * Stores from the starting index in the given array the Color4 successive values
   * @param array defines the array where to store the r,g,b components
   * @param index defines an optional index in the target array to define where to start storing values
   * @returns the current Color4 object
   */
  toArray(e, t = 0) {
    return e[t] = this.r, e[t + 1] = this.g, e[t + 2] = this.b, e[t + 3] = this.a, this;
  }
  /**
   * Update the current color with values stored in an array from the starting index of the given array
   * @param array defines the source array
   * @param offset defines an offset in the source array
   * @returns the current Color4 object
   */
  fromArray(e, t = 0) {
    return ye.FromArrayToRef(e, t, this), this;
  }
  /**
   * Determines equality between Color4 objects
   * @param otherColor defines the second operand
   * @returns true if the rgba values are equal to the given ones
   */
  equals(e) {
    return e && this.r === e.r && this.g === e.g && this.b === e.b && this.a === e.a;
  }
  /**
   * Creates a new Color4 set with the added values of the current Color4 and of the given one
   * @param right defines the second operand
   * @returns a new Color4 object
   */
  add(e) {
    return new ye(this.r + e.r, this.g + e.g, this.b + e.b, this.a + e.a);
  }
  /**
   * Creates a new Color4 set with the subtracted values of the given one from the current Color4
   * @param right defines the second operand
   * @returns a new Color4 object
   */
  subtract(e) {
    return new ye(this.r - e.r, this.g - e.g, this.b - e.b, this.a - e.a);
  }
  /**
   * Subtracts the given ones from the current Color4 values and stores the results in "result"
   * @param right defines the second operand
   * @param result defines the Color4 object where to store the result
   * @returns the current Color4 object
   */
  subtractToRef(e, t) {
    return t.r = this.r - e.r, t.g = this.g - e.g, t.b = this.b - e.b, t.a = this.a - e.a, this;
  }
  /**
   * Creates a new Color4 with the current Color4 values multiplied by scale
   * @param scale defines the scaling factor to apply
   * @returns a new Color4 object
   */
  scale(e) {
    return new ye(this.r * e, this.g * e, this.b * e, this.a * e);
  }
  /**
   * Multiplies the Color4 values by the float "scale"
   * @param scale defines the scaling factor to apply
   * @returns the current updated Color4
   */
  scaleInPlace(e) {
    return this.r *= e, this.g *= e, this.b *= e, this.a *= e, this;
  }
  /**
   * Multiplies the current Color4 values by scale and stores the result in "result"
   * @param scale defines the scaling factor to apply
   * @param result defines the Color4 object where to store the result
   * @returns the current unmodified Color4
   */
  scaleToRef(e, t) {
    return t.r = this.r * e, t.g = this.g * e, t.b = this.b * e, t.a = this.a * e, this;
  }
  /**
   * Scale the current Color4 values by a factor and add the result to a given Color4
   * @param scale defines the scale factor
   * @param result defines the Color4 object where to store the result
   * @returns the unmodified current Color4
   */
  scaleAndAddToRef(e, t) {
    return t.r += this.r * e, t.g += this.g * e, t.b += this.b * e, t.a += this.a * e, this;
  }
  /**
   * Clamps the rgb values by the min and max values and stores the result into "result"
   * @param min defines minimum clamping value (default is 0)
   * @param max defines maximum clamping value (default is 1)
   * @param result defines color to store the result into.
   * @returns the current Color4
   */
  clampToRef(e = 0, t = 1, i) {
    return i.r = J.Clamp(this.r, e, t), i.g = J.Clamp(this.g, e, t), i.b = J.Clamp(this.b, e, t), i.a = J.Clamp(this.a, e, t), this;
  }
  /**
   * Multiply an Color4 value by another and return a new Color4 object
   * @param color defines the Color4 value to multiply by
   * @returns a new Color4 object
   */
  multiply(e) {
    return new ye(this.r * e.r, this.g * e.g, this.b * e.b, this.a * e.a);
  }
  /**
   * Multiply a Color4 value by another and push the result in a reference value
   * @param color defines the Color4 value to multiply by
   * @param result defines the Color4 to fill the result in
   * @returns the result Color4
   */
  multiplyToRef(e, t) {
    return t.r = this.r * e.r, t.g = this.g * e.g, t.b = this.b * e.b, t.a = this.a * e.a, t;
  }
  /**
   * Creates a string with the Color4 current values
   * @returns the string representation of the Color4 object
   */
  toString() {
    return "{R: " + this.r + " G:" + this.g + " B:" + this.b + " A:" + this.a + "}";
  }
  /**
   * Returns the string "Color4"
   * @returns "Color4"
   */
  getClassName() {
    return "Color4";
  }
  /**
   * Compute the Color4 hash code
   * @returns an unique number that can be used to hash Color4 objects
   */
  getHashCode() {
    let e = this.r * 255 | 0;
    return e = e * 397 ^ (this.g * 255 | 0), e = e * 397 ^ (this.b * 255 | 0), e = e * 397 ^ (this.a * 255 | 0), e;
  }
  /**
   * Creates a new Color4 copied from the current one
   * @returns a new Color4 object
   */
  clone() {
    return new ye(this.r, this.g, this.b, this.a);
  }
  /**
   * Copies the given Color4 values into the current one
   * @param source defines the source Color4 object
   * @returns the current updated Color4 object
   */
  copyFrom(e) {
    return this.r = e.r, this.g = e.g, this.b = e.b, this.a = e.a, this;
  }
  /**
   * Copies the given float values into the current one
   * @param r defines the red component to read from
   * @param g defines the green component to read from
   * @param b defines the blue component to read from
   * @param a defines the alpha component to read from
   * @returns the current updated Color4 object
   */
  copyFromFloats(e, t, i, s) {
    return this.r = e, this.g = t, this.b = i, this.a = s, this;
  }
  /**
   * Copies the given float values into the current one
   * @param r defines the red component to read from
   * @param g defines the green component to read from
   * @param b defines the blue component to read from
   * @param a defines the alpha component to read from
   * @returns the current updated Color4 object
   */
  set(e, t, i, s) {
    return this.copyFromFloats(e, t, i, s);
  }
  /**
   * Compute the Color4 hexadecimal code as a string
   * @param returnAsColor3 defines if the string should only contains RGB values (off by default)
   * @returns a string containing the hexadecimal representation of the Color4 object
   */
  toHexString(e = !1) {
    const t = Math.round(this.r * 255), i = Math.round(this.g * 255), s = Math.round(this.b * 255);
    if (e)
      return "#" + J.ToHex(t) + J.ToHex(i) + J.ToHex(s);
    const r = Math.round(this.a * 255);
    return "#" + J.ToHex(t) + J.ToHex(i) + J.ToHex(s) + J.ToHex(r);
  }
  /**
   * Computes a new Color4 converted from the current one to linear space
   * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
   * @returns a new Color4 object
   */
  toLinearSpace(e = !1) {
    const t = new ye();
    return this.toLinearSpaceToRef(t, e), t;
  }
  /**
   * Converts the Color4 values to linear space and stores the result in "convertedColor"
   * @param convertedColor defines the Color4 object where to store the linear space version
   * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
   * @returns the unmodified Color4
   */
  toLinearSpaceToRef(e, t = !1) {
    return t ? (e.r = hs(this.r), e.g = hs(this.g), e.b = hs(this.b)) : (e.r = ls(this.r), e.g = ls(this.g), e.b = ls(this.b)), e.a = this.a, this;
  }
  /**
   * Computes a new Color4 converted from the current one to gamma space
   * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
   * @returns a new Color4 object
   */
  toGammaSpace(e = !1) {
    const t = new ye();
    return this.toGammaSpaceToRef(t, e), t;
  }
  /**
   * Converts the Color4 values to gamma space and stores the result in "convertedColor"
   * @param convertedColor defines the Color4 object where to store the gamma space version
   * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
   * @returns the unmodified Color4
   */
  toGammaSpaceToRef(e, t = !1) {
    return t ? (e.r = us(this.r), e.g = us(this.g), e.b = us(this.b)) : (e.r = cs(this.r), e.g = cs(this.g), e.b = cs(this.b)), e.a = this.a, this;
  }
  // Statics
  /**
   * Creates a new Color4 from the string containing valid hexadecimal values.
   *
   * A valid hex string is either in the format #RRGGBB or #RRGGBBAA.
   *
   * When a hex string without alpha is passed, the resulting Color4 has
   * its alpha value set to 1.0.
   *
   * An invalid string results in a Color with all its channels set to 0.0,
   * i.e. "transparent black".
   *
   * @param hex defines a string containing valid hexadecimal values
   * @returns a new Color4 object
   */
  static FromHexString(e) {
    if (e.substring(0, 1) !== "#" || e.length !== 9 && e.length !== 7)
      return new ye(0, 0, 0, 0);
    const t = parseInt(e.substring(1, 3), 16), i = parseInt(e.substring(3, 5), 16), s = parseInt(e.substring(5, 7), 16), r = e.length === 9 ? parseInt(e.substring(7, 9), 16) : 255;
    return ye.FromInts(t, i, s, r);
  }
  /**
   * Creates a new Color4 object set with the linearly interpolated values of "amount" between the left Color4 object and the right Color4 object
   * @param left defines the start value
   * @param right defines the end value
   * @param amount defines the gradient factor
   * @returns a new Color4 object
   */
  static Lerp(e, t, i) {
    const s = new ye(0, 0, 0, 0);
    return ye.LerpToRef(e, t, i, s), s;
  }
  /**
   * Set the given "result" with the linearly interpolated values of "amount" between the left Color4 object and the right Color4 object
   * @param left defines the start value
   * @param right defines the end value
   * @param amount defines the gradient factor
   * @param result defines the Color4 object where to store data
   */
  static LerpToRef(e, t, i, s) {
    s.r = e.r + (t.r - e.r) * i, s.g = e.g + (t.g - e.g) * i, s.b = e.b + (t.b - e.b) * i, s.a = e.a + (t.a - e.a) * i;
  }
  /**
   * Interpolate between two Color4 using Hermite interpolation
   * @param value1 defines first Color4
   * @param tangent1 defines the incoming tangent
   * @param value2 defines second Color4
   * @param tangent2 defines the outgoing tangent
   * @param amount defines the target Color4
   * @returns the new interpolated Color4
   */
  static Hermite(e, t, i, s, r) {
    const n = r * r, a = r * n, o = 2 * a - 3 * n + 1, l = -2 * a + 3 * n, c = a - 2 * n + r, u = a - n, d = e.r * o + i.r * l + t.r * c + s.r * u, f = e.g * o + i.g * l + t.g * c + s.g * u, _ = e.b * o + i.b * l + t.b * c + s.b * u, g = e.a * o + i.a * l + t.a * c + s.a * u;
    return new ye(d, f, _, g);
  }
  /**
   * Returns a new Color4 which is the 1st derivative of the Hermite spline defined by the colors "value1", "value2", "tangent1", "tangent2".
   * @param value1 defines the first control point
   * @param tangent1 defines the first tangent
   * @param value2 defines the second control point
   * @param tangent2 defines the second tangent
   * @param time define where the derivative must be done
   * @returns 1st derivative
   */
  static Hermite1stDerivative(e, t, i, s, r) {
    const n = new ye();
    return this.Hermite1stDerivativeToRef(e, t, i, s, r, n), n;
  }
  /**
   * Update a Color4 with the 1st derivative of the Hermite spline defined by the colors "value1", "value2", "tangent1", "tangent2".
   * @param value1 defines the first control point
   * @param tangent1 defines the first tangent
   * @param value2 defines the second control point
   * @param tangent2 defines the second tangent
   * @param time define where the derivative must be done
   * @param result define where to store the derivative
   */
  static Hermite1stDerivativeToRef(e, t, i, s, r, n) {
    const a = r * r;
    n.r = (a - r) * 6 * e.r + (3 * a - 4 * r + 1) * t.r + (-a + r) * 6 * i.r + (3 * a - 2 * r) * s.r, n.g = (a - r) * 6 * e.g + (3 * a - 4 * r + 1) * t.g + (-a + r) * 6 * i.g + (3 * a - 2 * r) * s.g, n.b = (a - r) * 6 * e.b + (3 * a - 4 * r + 1) * t.b + (-a + r) * 6 * i.b + (3 * a - 2 * r) * s.b, n.a = (a - r) * 6 * e.a + (3 * a - 4 * r + 1) * t.a + (-a + r) * 6 * i.a + (3 * a - 2 * r) * s.a;
  }
  /**
   * Creates a new Color4 from a Color3 and an alpha value
   * @param color3 defines the source Color3 to read from
   * @param alpha defines the alpha component (1.0 by default)
   * @returns a new Color4 object
   */
  static FromColor3(e, t = 1) {
    return new ye(e.r, e.g, e.b, t);
  }
  /**
   * Creates a new Color4 from the starting index element of the given array
   * @param array defines the source array to read from
   * @param offset defines the offset in the source array
   * @returns a new Color4 object
   */
  static FromArray(e, t = 0) {
    return new ye(e[t], e[t + 1], e[t + 2], e[t + 3]);
  }
  /**
   * Creates a new Color4 from the starting index element of the given array
   * @param array defines the source array to read from
   * @param offset defines the offset in the source array
   * @param result defines the target Color4 object
   */
  static FromArrayToRef(e, t = 0, i) {
    i.r = e[t], i.g = e[t + 1], i.b = e[t + 2], i.a = e[t + 3];
  }
  /**
   * Creates a new Color3 from integer values (< 256)
   * @param r defines the red component to read from (value between 0 and 255)
   * @param g defines the green component to read from (value between 0 and 255)
   * @param b defines the blue component to read from (value between 0 and 255)
   * @param a defines the alpha component to read from (value between 0 and 255)
   * @returns a new Color3 object
   */
  static FromInts(e, t, i, s) {
    return new ye(e / 255, t / 255, i / 255, s / 255);
  }
  /**
   * Check the content of a given array and convert it to an array containing RGBA data
   * If the original array was already containing count * 4 values then it is returned directly
   * @param colors defines the array to check
   * @param count defines the number of RGBA data to expect
   * @returns an array containing count * 4 values (RGBA)
   */
  static CheckColors4(e, t) {
    if (e.length === t * 3) {
      const i = [];
      for (let s = 0; s < e.length; s += 3) {
        const r = s / 3 * 4;
        i[r] = e[s], i[r + 1] = e[s + 1], i[r + 2] = e[s + 2], i[r + 3] = 1;
      }
      return i;
    }
    return e;
  }
}
class ns {
}
ns.Color3 = ot.BuildArray(3, ie.Black);
ns.Color4 = ot.BuildArray(3, () => new ye(0, 0, 0, 0));
Xe("BABYLON.Color3", ie);
Xe("BABYLON.Color4", ye);
const fr = {}, sr = {}, Gn = function(h, e, t, i = {}) {
  const s = h();
  Ee && Ee.HasTags(e) && Ee.AddTagsTo(s, Ee.GetTags(e, !0));
  const r = tn(s), n = {};
  for (const a in r) {
    const o = r[a], l = e[a], c = o.type;
    if (l != null && (a !== "uniqueId" || le.AllowLoadingUniqueId))
      switch (c) {
        case 0:
        case 6:
        case 11:
          s[a] = l;
          break;
        case 1:
          i.cloneTexturesOnlyOnce && n[l.uniqueId] ? s[a] = n[l.uniqueId] : (s[a] = t || l.isRenderTarget ? l : l.clone(), n[l.uniqueId] = s[a]);
          break;
        case 2:
        case 3:
        case 4:
        case 5:
        case 7:
        case 10:
        case 12:
          s[a] = t ? l : l.clone();
          break;
      }
  }
  return s;
};
function Go(h) {
  const e = h.getClassName();
  return fr[e] || (fr[e] = {}), fr[e];
}
function tn(h) {
  const e = h.getClassName();
  if (sr[e])
    return sr[e];
  sr[e] = {};
  const t = sr[e];
  let i = h, s = e;
  for (; s; ) {
    const r = fr[s];
    for (const o in r)
      t[o] = r[o];
    let n, a = !1;
    do {
      if (n = Object.getPrototypeOf(i), !n.getClassName) {
        a = !0;
        break;
      }
      if (n.getClassName() !== s)
        break;
      i = n;
    } while (n);
    if (a)
      break;
    s = n.getClassName(), i = n;
  }
  return t;
}
function ri(h, e) {
  return (t, i) => {
    const s = Go(t);
    s[i] || (s[i] = { type: h, sourceName: e });
  };
}
function Xo(h, e = null) {
  return (t, i) => {
    const s = e || "_" + i;
    Object.defineProperty(t, i, {
      get: function() {
        return this[s];
      },
      set: function(r) {
        typeof this.equals == "function" && this.equals(r) || this[s] !== r && (this[s] = r, t[h].apply(this));
      },
      enumerable: !0,
      configurable: !0
    });
  };
}
function Le(h, e = null) {
  return Xo(h, e);
}
function R(h) {
  return ri(0, h);
}
function Jt(h) {
  return ri(1, h);
}
function Ji(h) {
  return ri(2, h);
}
function qs(h) {
  return ri(3, h);
}
function Ho(h) {
  return ri(4, h);
}
function wt(h) {
  return ri(5, h);
}
function Sn(h) {
  return ri(6, h);
}
function Ko(h) {
  return ri(7, h);
}
function Pa(h) {
  return ri(8, h);
}
function Yo(h) {
  return ri(10, h);
}
function Ca(h) {
  return ri(12, h);
}
class le {
  /**
   * Appends the serialized animations from the source animations
   * @param source Source containing the animations
   * @param destination Target to store the animations
   */
  static AppendSerializedAnimations(e, t) {
    if (e.animations) {
      t.animations = [];
      for (let i = 0; i < e.animations.length; i++) {
        const s = e.animations[i];
        t.animations.push(s.serialize());
      }
    }
  }
  /**
   * Static function used to serialized a specific entity
   * @param entity defines the entity to serialize
   * @param serializationObject defines the optional target object where serialization data will be stored
   * @returns a JSON compatible object representing the serialization of the entity
   */
  static Serialize(e, t) {
    t || (t = {}), Ee && (t.tags = Ee.GetTags(e));
    const i = tn(e);
    for (const s in i) {
      const r = i[s], n = r.sourceName || s, a = r.type, o = e[s];
      if (o != null && (s !== "uniqueId" || le.AllowLoadingUniqueId))
        switch (a) {
          case 0:
            t[n] = o;
            break;
          case 1:
            t[n] = o.serialize();
            break;
          case 2:
            t[n] = o.asArray();
            break;
          case 3:
            t[n] = o.serialize();
            break;
          case 4:
            t[n] = o.asArray();
            break;
          case 5:
            t[n] = o.asArray();
            break;
          case 6:
            t[n] = o.id;
            break;
          case 7:
            t[n] = o.serialize();
            break;
          case 8:
            t[n] = o.asArray();
            break;
          case 9:
            t[n] = o.serialize();
            break;
          case 10:
            t[n] = o.asArray();
            break;
          case 11:
            t[n] = o.id;
            break;
          case 12:
            t[n] = o.asArray();
            break;
        }
    }
    return t;
  }
  /**
   * Given a source json and a destination object in a scene, this function will parse the source and will try to apply its content to the destination object
   * @param source the source json data
   * @param destination the destination object
   * @param scene the scene where the object is
   * @param rootUrl root url to use to load assets
   */
  static ParseProperties(e, t, i, s) {
    s || (s = "");
    const r = tn(t);
    for (const n in r) {
      const a = r[n], o = e[a.sourceName || n], l = a.type;
      if (o != null && (n !== "uniqueId" || le.AllowLoadingUniqueId)) {
        const c = t;
        switch (l) {
          case 0:
            c[n] = o;
            break;
          case 1:
            i && (c[n] = le._TextureParser(o, i, s));
            break;
          case 2:
            c[n] = ie.FromArray(o);
            break;
          case 3:
            c[n] = le._FresnelParametersParser(o);
            break;
          case 4:
            c[n] = ue.FromArray(o);
            break;
          case 5:
            c[n] = p.FromArray(o);
            break;
          case 6:
            i && (c[n] = i.getLastMeshById(o));
            break;
          case 7:
            c[n] = le._ColorCurvesParser(o);
            break;
          case 8:
            c[n] = ye.FromArray(o);
            break;
          case 9:
            c[n] = le._ImageProcessingConfigurationParser(o);
            break;
          case 10:
            c[n] = U.FromArray(o);
            break;
          case 11:
            i && (c[n] = i.getCameraById(o));
            break;
          case 12:
            c[n] = I.FromArray(o);
            break;
        }
      }
    }
  }
  /**
   * Creates a new entity from a serialization data object
   * @param creationFunction defines a function used to instanciated the new entity
   * @param source defines the source serialization data
   * @param scene defines the hosting scene
   * @param rootUrl defines the root url for resources
   * @returns a new entity
   */
  static Parse(e, t, i, s = null) {
    const r = e();
    return Ee && Ee.AddTagsTo(r, t.tags), le.ParseProperties(t, r, i, s), r;
  }
  /**
   * Clones an object
   * @param creationFunction defines the function used to instanciate the new object
   * @param source defines the source object
   * @returns the cloned object
   */
  static Clone(e, t, i = {}) {
    return Gn(e, t, !1, i);
  }
  /**
   * Instanciates a new object based on a source one (some data will be shared between both object)
   * @param creationFunction defines the function used to instanciate the new object
   * @param source defines the source object
   * @returns the new object
   */
  static Instanciate(e, t) {
    return Gn(e, t, !0);
  }
}
le.AllowLoadingUniqueId = !1;
le._ImageProcessingConfigurationParser = (h) => {
  throw he("ImageProcessingConfiguration");
};
le._FresnelParametersParser = (h) => {
  throw he("FresnelParameters");
};
le._ColorCurvesParser = (h) => {
  throw he("ColorCurves");
};
le._TextureParser = (h, e, t) => {
  throw he("Texture");
};
function Ui(h, e, t, i) {
  const s = t.value;
  t.value = (...r) => {
    let n = s;
    if (typeof _native < "u" && _native[e]) {
      const a = _native[e];
      i ? n = (...o) => i(...o) ? a(...o) : s(...o) : n = a;
    }
    return h[e] = n, n(...r);
  };
}
Ui.filter = function(h) {
  return (e, t, i) => Ui(e, t, i, h);
};
class At {
  /**
   * Instantiates a Smart Array.
   * @param capacity defines the default capacity of the array.
   */
  constructor(e) {
    this.length = 0, this.data = new Array(e), this._id = At._GlobalId++;
  }
  /**
   * Pushes a value at the end of the active data.
   * @param value defines the object to push in the array.
   */
  push(e) {
    this.data[this.length++] = e, this.length > this.data.length && (this.data.length *= 2);
  }
  /**
   * Iterates over the active data and apply the lambda to them.
   * @param func defines the action to apply on each value.
   */
  forEach(e) {
    for (let t = 0; t < this.length; t++)
      e(this.data[t]);
  }
  /**
   * Sorts the full sets of data.
   * @param compareFn defines the comparison function to apply.
   */
  sort(e) {
    this.data.sort(e);
  }
  /**
   * Resets the active data to an empty array.
   */
  reset() {
    this.length = 0;
  }
  /**
   * Releases all the data from the array as well as the array.
   */
  dispose() {
    this.reset(), this.data && (this.data.length = 0);
  }
  /**
   * Concats the active data with a given array.
   * @param array defines the data to concatenate with.
   */
  concat(e) {
    if (e.length !== 0) {
      this.length + e.length > this.data.length && (this.data.length = (this.length + e.length) * 2);
      for (let t = 0; t < e.length; t++)
        this.data[this.length++] = (e.data || e)[t];
    }
  }
  /**
   * Returns the position of a value in the active data.
   * @param value defines the value to find the index for
   * @returns the index if found in the active data otherwise -1
   */
  indexOf(e) {
    const t = this.data.indexOf(e);
    return t >= this.length ? -1 : t;
  }
  /**
   * Returns whether an element is part of the active data.
   * @param value defines the value to look for
   * @returns true if found in the active data otherwise false
   */
  contains(e) {
    return this.indexOf(e) !== -1;
  }
}
At._GlobalId = 0;
class Wi extends At {
  constructor() {
    super(...arguments), this._duplicateId = 0;
  }
  /**
   * Pushes a value at the end of the active data.
   * THIS DOES NOT PREVENT DUPPLICATE DATA
   * @param value defines the object to push in the array.
   */
  push(e) {
    super.push(e), e.__smartArrayFlags || (e.__smartArrayFlags = {}), e.__smartArrayFlags[this._id] = this._duplicateId;
  }
  /**
   * Pushes a value at the end of the active data.
   * If the data is already present, it won t be added again
   * @param value defines the object to push in the array.
   * @returns true if added false if it was already present
   */
  pushNoDuplicate(e) {
    return e.__smartArrayFlags && e.__smartArrayFlags[this._id] === this._duplicateId ? !1 : (this.push(e), !0);
  }
  /**
   * Resets the active data to an empty array.
   */
  reset() {
    super.reset(), this._duplicateId++;
  }
  /**
   * Concats the active data with a given array.
   * This ensures no duplicate will be present in the result.
   * @param array defines the data to concatenate with.
   */
  concatWithNoDuplicate(e) {
    if (e.length !== 0) {
      this.length + e.length > this.data.length && (this.data.length = (this.length + e.length) * 2);
      for (let t = 0; t < e.length; t++) {
        const i = (e.data || e)[t];
        this.pushNoDuplicate(i);
      }
    }
  }
}
function _t() {
  return typeof window < "u";
}
function _r() {
  return typeof navigator < "u";
}
function Rs() {
  return typeof document < "u";
}
function Da(h) {
  let e = "", t = h.firstChild;
  for (; t; )
    t.nodeType === 3 && (e += t.textContent), t = t.nextSibling;
  return e;
}
const Xn = (h, e) => !h || h.getClassName && h.getClassName() === "Mesh" ? null : h.getClassName && (h.getClassName() === "SubMesh" || h.getClassName() === "PhysicsBody") ? h.clone(e) : h.clone ? h.clone() : Array.isArray(h) ? h.slice() : null;
function qo(h) {
  const e = [];
  do
    Object.getOwnPropertyNames(h).forEach(function(t) {
      e.indexOf(t) === -1 && e.push(t);
    });
  while (h = Object.getPrototypeOf(h));
  return e;
}
class js {
  /**
   * Tries to copy an object by duplicating every property
   * @param source defines the source object
   * @param destination defines the target object
   * @param doNotCopyList defines a list of properties to avoid
   * @param mustCopyList defines a list of properties to copy (even if they start with _)
   */
  static DeepCopy(e, t, i, s) {
    const r = qo(e);
    for (const n of r) {
      if (n[0] === "_" && (!s || s.indexOf(n) === -1) || n.endsWith("Observable") || i && i.indexOf(n) !== -1)
        continue;
      const a = e[n], o = typeof a;
      if (o !== "function")
        try {
          if (o === "object")
            if (a instanceof Uint8Array)
              t[n] = Uint8Array.from(a);
            else if (a instanceof Array) {
              if (t[n] = [], a.length > 0)
                if (typeof a[0] == "object")
                  for (let l = 0; l < a.length; l++) {
                    const c = Xn(a[l], t);
                    t[n].indexOf(c) === -1 && t[n].push(c);
                  }
                else
                  t[n] = a.slice(0);
            } else
              t[n] = Xn(a, t);
          else
            t[n] = a;
        } catch (l) {
          w.Warn(l.message);
        }
    }
  }
}
class Kt {
  /**
   * Gets either window.performance.now() if supported or Date.now() else
   */
  static get Now() {
    return _t() && window.performance && window.performance.now ? window.performance.now() : Date.now();
  }
}
function jo() {
  return typeof _native < "u" && _native.XMLHttpRequest ? new _native.XMLHttpRequest() : new XMLHttpRequest();
}
class mt {
  constructor() {
    this._xhr = jo(), this._requestURL = "";
  }
  _injectCustomRequestHeaders() {
    if (!this._shouldSkipRequestModifications(this._requestURL))
      for (const e in mt.CustomRequestHeaders) {
        const t = mt.CustomRequestHeaders[e];
        t && this._xhr.setRequestHeader(e, t);
      }
  }
  _shouldSkipRequestModifications(e) {
    return mt.SkipRequestModificationForBabylonCDN && (e.includes("preview.babylonjs.com") || e.includes("cdn.babylonjs.com"));
  }
  /**
   * Gets or sets a function to be called when loading progress changes
   */
  get onprogress() {
    return this._xhr.onprogress;
  }
  set onprogress(e) {
    this._xhr.onprogress = e;
  }
  /**
   * Returns client's state
   */
  get readyState() {
    return this._xhr.readyState;
  }
  /**
   * Returns client's status
   */
  get status() {
    return this._xhr.status;
  }
  /**
   * Returns client's status as a text
   */
  get statusText() {
    return this._xhr.statusText;
  }
  /**
   * Returns client's response
   */
  get response() {
    return this._xhr.response;
  }
  /**
   * Returns client's response url
   */
  get responseURL() {
    return this._xhr.responseURL;
  }
  /**
   * Returns client's response as text
   */
  get responseText() {
    return this._xhr.responseText;
  }
  /**
   * Gets or sets the expected response type
   */
  get responseType() {
    return this._xhr.responseType;
  }
  set responseType(e) {
    this._xhr.responseType = e;
  }
  /**
   * Gets or sets the timeout value in milliseconds
   */
  get timeout() {
    return this._xhr.timeout;
  }
  set timeout(e) {
    this._xhr.timeout = e;
  }
  addEventListener(e, t, i) {
    this._xhr.addEventListener(e, t, i);
  }
  removeEventListener(e, t, i) {
    this._xhr.removeEventListener(e, t, i);
  }
  /**
   * Cancels any network activity
   */
  abort() {
    this._xhr.abort();
  }
  /**
   * Initiates the request. The optional argument provides the request body. The argument is ignored if request method is GET or HEAD
   * @param body defines an optional request body
   */
  send(e) {
    mt.CustomRequestHeaders && this._injectCustomRequestHeaders(), this._xhr.send(e);
  }
  /**
   * Sets the request method, request URL
   * @param method defines the method to use (GET, POST, etc..)
   * @param url defines the url to connect with
   */
  open(e, t) {
    for (const i of mt.CustomRequestModifiers) {
      if (this._shouldSkipRequestModifications(t))
        return;
      i(this._xhr, t);
    }
    return t = t.replace("file:http:", "http:"), t = t.replace("file:https:", "https:"), this._requestURL = t, this._xhr.open(e, t, !0);
  }
  /**
   * Sets the value of a request header.
   * @param name The name of the header whose value is to be set
   * @param value The value to set as the body of the header
   */
  setRequestHeader(e, t) {
    this._xhr.setRequestHeader(e, t);
  }
  /**
   * Get the string containing the text of a particular header's value.
   * @param name The name of the header
   * @returns The string containing the text of the given header name
   */
  getResponseHeader(e) {
    return this._xhr.getResponseHeader(e);
  }
}
mt.CustomRequestHeaders = {};
mt.CustomRequestModifiers = new Array();
mt.SkipRequestModificationForBabylonCDN = !0;
class Is {
}
Is.FilesToLoad = {};
class Zo {
  /**
   * Function used to defines an exponential back off strategy
   * @param maxRetries defines the maximum number of retries (3 by default)
   * @param baseInterval defines the interval between retries
   * @returns the strategy function to use
   */
  static ExponentialBackoff(e = 3, t = 500) {
    return (i, s, r) => s.status !== 0 || r >= e || i.indexOf("file:") !== -1 ? -1 : Math.pow(2, r) * t;
  }
}
class ps extends Error {
}
ps._setPrototypeOf = Object.setPrototypeOf || ((h, e) => (h.__proto__ = e, h));
const Yi = {
  // Mesh errors 0-999
  /** Invalid or empty mesh vertex positions. */
  MeshInvalidPositionsError: 0,
  // Texture errors 1000-1999
  /** Unsupported texture found. */
  UnsupportedTextureError: 1e3,
  // GLTFLoader errors 2000-2999
  /** Unexpected magic number found in GLTF file header. */
  GLTFLoaderUnexpectedMagicError: 2e3,
  // SceneLoader errors 3000-3999
  /** SceneLoader generic error code. Ideally wraps the inner exception. */
  SceneLoaderError: 3e3,
  // File related errors 4000-4999
  /** Load file error */
  LoadFileError: 4e3,
  /** Request file error */
  RequestFileError: 4001,
  /** Read file error */
  ReadFileError: 4002
};
class Ei extends ps {
  /**
   * Creates a new RuntimeError
   * @param message defines the message of the error
   * @param errorCode the error code
   * @param innerError the error that caused the outer error
   */
  constructor(e, t, i) {
    super(e), this.errorCode = t, this.innerError = i, this.name = "RuntimeError", ps._setPrototypeOf(this, Ei.prototype);
  }
}
const wa = (h) => {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  let t = "", i, s, r, n, a, o, l, c = 0;
  const u = ArrayBuffer.isView(h) ? new Uint8Array(h.buffer, h.byteOffset, h.byteLength) : new Uint8Array(h);
  for (; c < u.length; )
    i = u[c++], s = c < u.length ? u[c++] : Number.NaN, r = c < u.length ? u[c++] : Number.NaN, n = i >> 2, a = (i & 3) << 4 | s >> 4, o = (s & 15) << 2 | r >> 6, l = r & 63, isNaN(s) ? o = l = 64 : isNaN(r) && (l = 64), t += e.charAt(n) + e.charAt(a) + e.charAt(o) + e.charAt(l);
  return t;
}, Oa = (h) => atob(h), Qo = (h) => {
  const e = Oa(h), t = e.length, i = new Uint8Array(new ArrayBuffer(t));
  for (let s = 0; s < t; s++)
    i[s] = e.charCodeAt(s);
  return i.buffer;
}, $o = "attribute", Jo = "varying";
class Ps {
  constructor() {
    this.children = [];
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  isValid(e) {
    return !0;
  }
  process(e, t) {
    var i, s, r, n, a, o, l;
    let c = "";
    if (this.line) {
      let u = this.line;
      const d = t.processor;
      if (d) {
        d.lineProcessor && (u = d.lineProcessor(u, t.isFragment, t.processingContext));
        const f = (s = (i = t.processor) === null || i === void 0 ? void 0 : i.attributeKeywordName) !== null && s !== void 0 ? s : $o, _ = t.isFragment && (!((r = t.processor) === null || r === void 0) && r.varyingFragmentKeywordName) ? (n = t.processor) === null || n === void 0 ? void 0 : n.varyingFragmentKeywordName : !t.isFragment && (!((a = t.processor) === null || a === void 0) && a.varyingVertexKeywordName) ? (o = t.processor) === null || o === void 0 ? void 0 : o.varyingVertexKeywordName : Jo;
        !t.isFragment && d.attributeProcessor && this.line.startsWith(f) ? u = d.attributeProcessor(this.line, e, t.processingContext) : d.varyingProcessor && (!((l = d.varyingCheck) === null || l === void 0) && l.call(d, this.line, t.isFragment) || !d.varyingCheck && this.line.startsWith(_)) ? u = d.varyingProcessor(this.line, t.isFragment, e, t.processingContext) : d.uniformProcessor && d.uniformRegexp && d.uniformRegexp.test(this.line) ? t.lookForClosingBracketForUniformBuffer || (u = d.uniformProcessor(this.line, t.isFragment, e, t.processingContext)) : d.uniformBufferProcessor && d.uniformBufferRegexp && d.uniformBufferRegexp.test(this.line) ? t.lookForClosingBracketForUniformBuffer || (u = d.uniformBufferProcessor(this.line, t.isFragment, t.processingContext), t.lookForClosingBracketForUniformBuffer = !0) : d.textureProcessor && d.textureRegexp && d.textureRegexp.test(this.line) ? u = d.textureProcessor(this.line, t.isFragment, e, t.processingContext) : (d.uniformProcessor || d.uniformBufferProcessor) && this.line.startsWith("uniform") && !t.lookForClosingBracketForUniformBuffer && (/uniform\s+(?:(?:highp)?|(?:lowp)?)\s*(\S+)\s+(\S+)\s*;/.test(this.line) ? d.uniformProcessor && (u = d.uniformProcessor(this.line, t.isFragment, e, t.processingContext)) : d.uniformBufferProcessor && (u = d.uniformBufferProcessor(this.line, t.isFragment, t.processingContext), t.lookForClosingBracketForUniformBuffer = !0)), t.lookForClosingBracketForUniformBuffer && this.line.indexOf("}") !== -1 && (t.lookForClosingBracketForUniformBuffer = !1, d.endOfUniformBufferProcessor && (u = d.endOfUniformBufferProcessor(this.line, t.isFragment, t.processingContext)));
      }
      c += u + `
`;
    }
    return this.children.forEach((u) => {
      c += u.process(e, t);
    }), this.additionalDefineKey && (e[this.additionalDefineKey] = this.additionalDefineValue || "true"), c;
  }
}
class el {
  constructor() {
    this._lines = [];
  }
  get currentLine() {
    return this._lines[this.lineIndex];
  }
  get canRead() {
    return this.lineIndex < this._lines.length - 1;
  }
  set lines(e) {
    this._lines.length = 0;
    for (const t of e) {
      if (!t || t === "\r")
        continue;
      if (t[0] === "#") {
        this._lines.push(t);
        continue;
      }
      const i = t.trim();
      if (!i)
        continue;
      if (i.startsWith("//")) {
        this._lines.push(t);
        continue;
      }
      const s = i.indexOf(";");
      if (s === -1)
        this._lines.push(i);
      else if (s === i.length - 1)
        i.length > 1 && this._lines.push(i);
      else {
        const r = t.split(";");
        for (let n = 0; n < r.length; n++) {
          let a = r[n];
          a && (a = a.trim(), a && this._lines.push(a + (n !== r.length - 1 ? ";" : "")));
        }
      }
    }
  }
}
class Vr extends Ps {
  process(e, t) {
    for (let i = 0; i < this.children.length; i++) {
      const s = this.children[i];
      if (s.isValid(e))
        return s.process(e, t);
    }
    return "";
  }
}
class tl extends Ps {
  isValid(e) {
    return this.testExpression.isTrue(e);
  }
}
class $e {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  isTrue(e) {
    return !0;
  }
  static postfixToInfix(e) {
    const t = [];
    for (const i of e)
      if ($e._OperatorPriority[i] === void 0)
        t.push(i);
      else {
        const s = t[t.length - 1], r = t[t.length - 2];
        t.length -= 2, t.push(`(${r}${i}${s})`);
      }
    return t[t.length - 1];
  }
  /**
   * Converts an infix expression to a postfix expression.
   *
   * This method is used to transform infix expressions, which are more human-readable,
   * into postfix expressions, also known as Reverse Polish Notation (RPN), that can be
   * evaluated more efficiently by a computer. The conversion is based on the operator
   * priority defined in _OperatorPriority.
   *
   * The function employs a stack-based algorithm for the conversion and caches the result
   * to improve performance. The cache keeps track of each converted expression's access time
   * to manage the cache size and optimize memory usage. When the cache size exceeds a specified
   * limit, the least recently accessed items in the cache are deleted.
   *
   * The cache mechanism is particularly helpful for shader compilation, where the same infix
   * expressions might be encountered repeatedly, hence the caching can speed up the process.
   *
   * @param infix - The infix expression to be converted.
   * @returns The postfix expression as an array of strings.
   */
  static infixToPostfix(e) {
    const t = $e._InfixToPostfixCache.get(e);
    if (t)
      return t.accessTime = Date.now(), t.result;
    if (!e.includes("&&") && !e.includes("||") && !e.includes(")") && !e.includes("("))
      return [e];
    const i = [];
    let s = -1;
    const r = () => {
      c = c.trim(), c !== "" && (i.push(c), c = "");
    }, n = (u) => {
      s < $e._Stack.length - 1 && ($e._Stack[++s] = u);
    }, a = () => $e._Stack[s], o = () => s === -1 ? "!!INVALID EXPRESSION!!" : $e._Stack[s--];
    let l = 0, c = "";
    for (; l < e.length; ) {
      const u = e.charAt(l), d = l < e.length - 1 ? e.substr(l, 2) : "";
      if (u === "(")
        c = "", n(u);
      else if (u === ")") {
        for (r(); s !== -1 && a() !== "("; )
          i.push(o());
        o();
      } else if ($e._OperatorPriority[d] > 1) {
        for (r(); s !== -1 && $e._OperatorPriority[a()] >= $e._OperatorPriority[d]; )
          i.push(o());
        n(d), l++;
      } else
        c += u;
      l++;
    }
    for (r(); s !== -1; )
      a() === "(" ? o() : i.push(o());
    return $e._InfixToPostfixCache.size >= $e.InfixToPostfixCacheLimitSize && $e.ClearCache(), $e._InfixToPostfixCache.set(e, { result: i, accessTime: Date.now() }), i;
  }
  static ClearCache() {
    const e = Array.from($e._InfixToPostfixCache.entries()).sort((t, i) => t[1].accessTime - i[1].accessTime);
    for (let t = 0; t < $e.InfixToPostfixCacheCleanupSize; t++)
      $e._InfixToPostfixCache.delete(e[t][0]);
  }
}
$e.InfixToPostfixCacheLimitSize = 5e4;
$e.InfixToPostfixCacheCleanupSize = 25e3;
$e._InfixToPostfixCache = /* @__PURE__ */ new Map();
$e._OperatorPriority = {
  ")": 0,
  "(": 1,
  "||": 2,
  "&&": 3
};
$e._Stack = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""];
class rr extends $e {
  constructor(e, t = !1) {
    super(), this.define = e, this.not = t;
  }
  isTrue(e) {
    let t = e[this.define] !== void 0;
    return this.not && (t = !t), t;
  }
}
class il extends $e {
  isTrue(e) {
    return this.leftOperand.isTrue(e) || this.rightOperand.isTrue(e);
  }
}
class sl extends $e {
  isTrue(e) {
    return this.leftOperand.isTrue(e) && this.rightOperand.isTrue(e);
  }
}
class rl extends $e {
  constructor(e, t, i) {
    super(), this.define = e, this.operand = t, this.testValue = i;
  }
  isTrue(e) {
    let t = e[this.define];
    t === void 0 && (t = this.define);
    let i = !1;
    const s = parseInt(t), r = parseInt(this.testValue);
    switch (this.operand) {
      case ">":
        i = s > r;
        break;
      case "<":
        i = s < r;
        break;
      case "<=":
        i = s <= r;
        break;
      case ">=":
        i = s >= r;
        break;
      case "==":
        i = s === r;
        break;
      case "!=":
        i = s !== r;
        break;
    }
    return i;
  }
}
var dt;
(function(h) {
  h[h.GLSL = 0] = "GLSL", h[h.WGSL = 1] = "WGSL";
})(dt || (dt = {}));
const nl = /defined\s*?\((.+?)\)/g, Wr = /defined\s*?\[(.+?)\]/g, al = /#include\s?<(.+)>(\((.*)\))*(\[(.*)\])*/g, ol = /__decl__/, Hn = /light\{X\}.(\w*)/g, Kn = /\{X\}/g, nr = [];
class hi {
  static Initialize(e) {
    e.processor && e.processor.initializeShaders && e.processor.initializeShaders(e.processingContext);
  }
  static Process(e, t, i, s) {
    var r;
    !((r = t.processor) === null || r === void 0) && r.preProcessShaderCode && (e = t.processor.preProcessShaderCode(e, t.isFragment)), this._ProcessIncludes(e, t, (n) => {
      t.processCodeAfterIncludes && (n = t.processCodeAfterIncludes(t.isFragment ? "fragment" : "vertex", n));
      const a = this._ProcessShaderConversion(n, t, s);
      i(a, n);
    });
  }
  static PreProcess(e, t, i, s) {
    var r;
    !((r = t.processor) === null || r === void 0) && r.preProcessShaderCode && (e = t.processor.preProcessShaderCode(e, t.isFragment)), this._ProcessIncludes(e, t, (n) => {
      t.processCodeAfterIncludes && (n = t.processCodeAfterIncludes(t.isFragment ? "fragment" : "vertex", n));
      const a = this._ApplyPreProcessing(n, t, s);
      i(a, n);
    });
  }
  static Finalize(e, t, i) {
    return !i.processor || !i.processor.finalizeShaders ? { vertexCode: e, fragmentCode: t } : i.processor.finalizeShaders(e, t, i.processingContext);
  }
  static _ProcessPrecision(e, t) {
    var i;
    if (!((i = t.processor) === null || i === void 0) && i.noPrecision)
      return e;
    const s = t.shouldUseHighPrecisionShader;
    return e.indexOf("precision highp float") === -1 ? s ? e = `precision highp float;
` + e : e = `precision mediump float;
` + e : s || (e = e.replace("precision highp float", "precision mediump float")), e;
  }
  static _ExtractOperation(e) {
    const i = /defined\((.+)\)/.exec(e);
    if (i && i.length)
      return new rr(i[1].trim(), e[0] === "!");
    const s = ["==", "!=", ">=", "<=", "<", ">"];
    let r = "", n = 0;
    for (r of s)
      if (n = e.indexOf(r), n > -1)
        break;
    if (n === -1)
      return new rr(e);
    const a = e.substring(0, n).trim(), o = e.substring(n + r.length).trim();
    return new rl(a, r, o);
  }
  static _BuildSubExpression(e) {
    e = e.replace(nl, "defined[$1]");
    const t = $e.infixToPostfix(e), i = [];
    for (const r of t)
      if (r !== "||" && r !== "&&")
        i.push(r);
      else if (i.length >= 2) {
        let n = i[i.length - 1], a = i[i.length - 2];
        i.length -= 2;
        const o = r == "&&" ? new sl() : new il();
        typeof n == "string" && (n = n.replace(Wr, "defined($1)")), typeof a == "string" && (a = a.replace(Wr, "defined($1)")), o.leftOperand = typeof a == "string" ? this._ExtractOperation(a) : a, o.rightOperand = typeof n == "string" ? this._ExtractOperation(n) : n, i.push(o);
      }
    let s = i[i.length - 1];
    return typeof s == "string" && (s = s.replace(Wr, "defined($1)")), typeof s == "string" ? this._ExtractOperation(s) : s;
  }
  static _BuildExpression(e, t) {
    const i = new tl(), s = e.substring(0, t);
    let r = e.substring(t);
    return r = r.substring(0, (r.indexOf("//") + 1 || r.length + 1) - 1).trim(), s === "#ifdef" ? i.testExpression = new rr(r) : s === "#ifndef" ? i.testExpression = new rr(r, !0) : i.testExpression = this._BuildSubExpression(r), i;
  }
  static _MoveCursorWithinIf(e, t, i) {
    let s = e.currentLine;
    for (; this._MoveCursor(e, i); ) {
      s = e.currentLine;
      const r = s.substring(0, 5).toLowerCase();
      if (r === "#else") {
        const n = new Ps();
        t.children.push(n), this._MoveCursor(e, n);
        return;
      } else if (r === "#elif") {
        const n = this._BuildExpression(s, 5);
        t.children.push(n), i = n;
      }
    }
  }
  static _MoveCursor(e, t) {
    for (; e.canRead; ) {
      e.lineIndex++;
      const i = e.currentLine;
      if (i.indexOf("#") >= 0) {
        const r = hi._MoveCursorRegex.exec(i);
        if (r && r.length) {
          switch (r[0]) {
            case "#ifdef": {
              const a = new Vr();
              t.children.push(a);
              const o = this._BuildExpression(i, 6);
              a.children.push(o), this._MoveCursorWithinIf(e, a, o);
              break;
            }
            case "#else":
            case "#elif":
              return !0;
            case "#endif":
              return !1;
            case "#ifndef": {
              const a = new Vr();
              t.children.push(a);
              const o = this._BuildExpression(i, 7);
              a.children.push(o), this._MoveCursorWithinIf(e, a, o);
              break;
            }
            case "#if": {
              const a = new Vr(), o = this._BuildExpression(i, 3);
              t.children.push(a), a.children.push(o), this._MoveCursorWithinIf(e, a, o);
              break;
            }
          }
          continue;
        }
      }
      const s = new Ps();
      if (s.line = i, t.children.push(s), i[0] === "#" && i[1] === "d") {
        const r = i.replace(";", "").split(" ");
        s.additionalDefineKey = r[1], r.length === 3 && (s.additionalDefineValue = r[2]);
      }
    }
    return !1;
  }
  static _EvaluatePreProcessors(e, t, i) {
    const s = new Ps(), r = new el();
    return r.lineIndex = -1, r.lines = e.split(`
`), this._MoveCursor(r, s), s.process(t, i);
  }
  static _PreparePreProcessors(e, t) {
    var i;
    const s = e.defines, r = {};
    for (const n of s) {
      const o = n.replace("#define", "").replace(";", "").trim().split(" ");
      r[o[0]] = o.length > 1 ? o[1] : "";
    }
    return ((i = e.processor) === null || i === void 0 ? void 0 : i.shaderLanguage) === dt.GLSL && (r.GL_ES = "true"), r.__VERSION__ = e.version, r[e.platformName] = "true", t._getGlobalDefines(r), r;
  }
  static _ProcessShaderConversion(e, t, i) {
    let s = this._ProcessPrecision(e, t);
    if (!t.processor || t.processor.shaderLanguage === dt.GLSL && s.indexOf("#version 3") !== -1 && (s = s.replace("#version 300 es", ""), !t.processor.parseGLES3))
      return s;
    const r = t.defines, n = this._PreparePreProcessors(t, i);
    return t.processor.preProcessor && (s = t.processor.preProcessor(s, r, t.isFragment, t.processingContext)), s = this._EvaluatePreProcessors(s, n, t), t.processor.postProcessor && (s = t.processor.postProcessor(s, r, t.isFragment, t.processingContext, i)), i._features.needShaderCodeInlining && (s = i.inlineShaderCode(s)), s;
  }
  static _ApplyPreProcessing(e, t, i) {
    var s, r;
    let n = e;
    const a = t.defines, o = this._PreparePreProcessors(t, i);
    return !((s = t.processor) === null || s === void 0) && s.preProcessor && (n = t.processor.preProcessor(n, a, t.isFragment, t.processingContext)), n = this._EvaluatePreProcessors(n, o, t), !((r = t.processor) === null || r === void 0) && r.postProcessor && (n = t.processor.postProcessor(n, a, t.isFragment, t.processingContext, i)), i._features.needShaderCodeInlining && (n = i.inlineShaderCode(n)), n;
  }
  /** @internal */
  static _ProcessIncludes(e, t, i) {
    nr.length = 0;
    let s;
    for (; (s = al.exec(e)) !== null; )
      nr.push(s);
    let r = String(e), n = [e], a = !1;
    for (const o of nr) {
      let l = o[1];
      if (l.indexOf("__decl__") !== -1 && (l = l.replace(ol, ""), t.supportsUniformBuffers && (l = l.replace("Vertex", "Ubo").replace("Fragment", "Ubo")), l = l + "Declaration"), t.includesShadersStore[l]) {
        let c = t.includesShadersStore[l];
        if (o[2]) {
          const d = o[3].split(",");
          for (let f = 0; f < d.length; f += 2) {
            const _ = new RegExp(d[f], "g"), g = d[f + 1];
            c = c.replace(_, g);
          }
        }
        if (o[4]) {
          const d = o[5];
          if (d.indexOf("..") !== -1) {
            const f = d.split(".."), _ = parseInt(f[0]);
            let g = parseInt(f[1]), m = c.slice(0);
            c = "", isNaN(g) && (g = t.indexParameters[f[1]]);
            for (let y = _; y < g; y++)
              t.supportsUniformBuffers || (m = m.replace(Hn, (x, A) => A + "{X}")), c += m.replace(Kn, y.toString()) + `
`;
          } else
            t.supportsUniformBuffers || (c = c.replace(Hn, (f, _) => _ + "{X}")), c = c.replace(Kn, d);
        }
        const u = [];
        for (const d of n) {
          const f = d.split(o[0]);
          for (let _ = 0; _ < f.length - 1; _++)
            u.push(f[_]), u.push(c);
          u.push(f[f.length - 1]);
        }
        n = u, a = a || c.indexOf("#include<") >= 0 || c.indexOf("#include <") >= 0;
      } else {
        const c = t.shadersRepository + "ShadersInclude/" + l + ".fx";
        hi._FileToolsLoadFile(c, (u) => {
          t.includesShadersStore[l] = u, this._ProcessIncludes(n.join(""), t, i);
        });
        return;
      }
    }
    nr.length = 0, r = n.join(""), a ? this._ProcessIncludes(r.toString(), t, i) : i(r);
  }
  /**
   * Loads a file from a url
   * @param url url to load
   * @param onSuccess callback called when the file successfully loads
   * @param onProgress callback called while file is loading (if the server supports this mode)
   * @param offlineProvider defines the offline provider for caching
   * @param useArrayBuffer defines a boolean indicating that date must be returned as ArrayBuffer
   * @param onError callback called when the file fails to load
   * @returns a file request object
   * @internal
   */
  static _FileToolsLoadFile(e, t, i, s, r, n) {
    throw he("FileTools");
  }
}
hi._MoveCursorRegex = /(#ifdef)|(#else)|(#elif)|(#endif)|(#ifndef)|(#if)/;
class G {
  /**
   * Gets the shaders repository path for a given shader language
   * @param shaderLanguage the shader language
   * @returns the path to the shaders repository
   */
  static GetShadersRepository(e = dt.GLSL) {
    return e === dt.GLSL ? G.ShadersRepository : G.ShadersRepositoryWGSL;
  }
  /**
   * Gets the shaders store of a given shader language
   * @param shaderLanguage the shader language
   * @returns the shaders store
   */
  static GetShadersStore(e = dt.GLSL) {
    return e === dt.GLSL ? G.ShadersStore : G.ShadersStoreWGSL;
  }
  /**
   * Gets the include shaders store of a given shader language
   * @param shaderLanguage the shader language
   * @returns the include shaders store
   */
  static GetIncludesShadersStore(e = dt.GLSL) {
    return e === dt.GLSL ? G.IncludesShadersStore : G.IncludesShadersStoreWGSL;
  }
}
G.ShadersRepository = "src/Shaders/";
G.ShadersStore = {};
G.IncludesShadersStore = {};
G.ShadersRepositoryWGSL = "src/ShadersWGSL/";
G.ShadersStoreWGSL = {};
G.IncludesShadersStoreWGSL = {};
class yt {
  /**
   * Gets or sets the relative url used to load shaders if using the engine in non-minified mode
   */
  static get ShadersRepository() {
    return G.ShadersRepository;
  }
  static set ShadersRepository(e) {
    G.ShadersRepository = e;
  }
  /**
   * Observable that will be called when effect is bound.
   */
  get onBindObservable() {
    return this._onBindObservable || (this._onBindObservable = new N()), this._onBindObservable;
  }
  /**
   * Instantiates an effect.
   * An effect can be used to create/manage/execute vertex and fragment shaders.
   * @param baseName Name of the effect.
   * @param attributesNamesOrOptions List of attribute names that will be passed to the shader or set of all options to create the effect.
   * @param uniformsNamesOrEngine List of uniform variable names that will be passed to the shader or the engine that will be used to render effect.
   * @param samplers List of sampler variables that will be passed to the shader.
   * @param engine Engine to be used to render the effect
   * @param defines Define statements to be added to the shader.
   * @param fallbacks Possible fallbacks for this effect to improve performance when needed.
   * @param onCompiled Callback that will be called when the shader is compiled.
   * @param onError Callback that will be called if an error occurs during shader compilation.
   * @param indexParameters Parameters to be used with Babylons include syntax to iterate over an array (eg. {lights: 10})
   * @param key Effect Key identifying uniquely compiled shader variants
   * @param shaderLanguage the language the shader is written in (default: GLSL)
   */
  constructor(e, t, i, s = null, r, n = null, a = null, o = null, l = null, c, u = "", d = dt.GLSL) {
    var f, _, g;
    this.name = null, this.defines = "", this.onCompiled = null, this.onError = null, this.onBind = null, this.uniqueId = 0, this.onCompileObservable = new N(), this.onErrorObservable = new N(), this._onBindObservable = null, this._wasPreviouslyReady = !1, this._forceRebindOnNextCall = !1, this._wasPreviouslyUsingInstances = null, this._isDisposed = !1, this._bonesComputationForcedToCPU = !1, this._uniformBuffersNames = {}, this._multiTarget = !1, this._samplers = {}, this._isReady = !1, this._compilationError = "", this._allFallbacksProcessed = !1, this._uniforms = {}, this._key = "", this._fallbacks = null, this._vertexSourceCodeOverride = "", this._fragmentSourceCodeOverride = "", this._transformFeedbackVaryings = null, this._pipelineContext = null, this._vertexSourceCode = "", this._fragmentSourceCode = "", this._vertexSourceCodeBeforeMigration = "", this._fragmentSourceCodeBeforeMigration = "", this._rawVertexSourceCode = "", this._rawFragmentSourceCode = "", this.name = e, this._key = u;
    let m, y = null;
    if (t.attributes) {
      const P = t;
      if (this._engine = i, this._attributesNames = P.attributes, this._uniformsNames = P.uniformsNames.concat(P.samplers), this._samplerList = P.samplers.slice(), this.defines = P.defines, this.onError = P.onError, this.onCompiled = P.onCompiled, this._fallbacks = P.fallbacks, this._indexParameters = P.indexParameters, this._transformFeedbackVaryings = P.transformFeedbackVaryings || null, this._multiTarget = !!P.multiTarget, this._shaderLanguage = (f = P.shaderLanguage) !== null && f !== void 0 ? f : dt.GLSL, P.uniformBuffersNames) {
        this._uniformBuffersNamesList = P.uniformBuffersNames.slice();
        for (let D = 0; D < P.uniformBuffersNames.length; D++)
          this._uniformBuffersNames[P.uniformBuffersNames[D]] = D;
      }
      y = (_ = P.processFinalCode) !== null && _ !== void 0 ? _ : null, m = (g = P.processCodeAfterIncludes) !== null && g !== void 0 ? g : void 0;
    } else
      this._engine = r, this.defines = n ?? "", this._uniformsNames = i.concat(s), this._samplerList = s ? s.slice() : [], this._attributesNames = t, this._uniformBuffersNamesList = [], this._shaderLanguage = d, this.onError = l, this.onCompiled = o, this._indexParameters = c, this._fallbacks = a;
    this._attributeLocationByName = {}, this.uniqueId = yt._UniqueIdSeed++;
    let x, A;
    const T = _t() ? this._engine.getHostDocument() : null;
    e.vertexSource ? x = "source:" + e.vertexSource : e.vertexElement ? (x = T ? T.getElementById(e.vertexElement) : null, x || (x = e.vertexElement)) : x = e.vertex || e, e.fragmentSource ? A = "source:" + e.fragmentSource : e.fragmentElement ? (A = T ? T.getElementById(e.fragmentElement) : null, A || (A = e.fragmentElement)) : A = e.fragment || e, this._processingContext = this._engine._getShaderProcessingContext(this._shaderLanguage);
    let M = {
      defines: this.defines.split(`
`),
      indexParameters: this._indexParameters,
      isFragment: !1,
      shouldUseHighPrecisionShader: this._engine._shouldUseHighPrecisionShader,
      processor: this._engine._getShaderProcessor(this._shaderLanguage),
      supportsUniformBuffers: this._engine.supportsUniformBuffers,
      shadersRepository: G.GetShadersRepository(this._shaderLanguage),
      includesShadersStore: G.GetIncludesShadersStore(this._shaderLanguage),
      version: (this._engine.version * 100).toString(),
      platformName: this._engine.shaderPlatformName,
      processingContext: this._processingContext,
      isNDCHalfZRange: this._engine.isNDCHalfZRange,
      useReverseDepthBuffer: this._engine.useReverseDepthBuffer,
      processCodeAfterIncludes: m
    };
    const b = [void 0, void 0], S = () => {
      if (b[0] && b[1]) {
        M.isFragment = !0;
        const [P, D] = b;
        hi.Process(D, M, (O, X) => {
          this._fragmentSourceCodeBeforeMigration = X, y && (O = y("fragment", O));
          const k = hi.Finalize(P, O, M);
          M = null, this._useFinalCode(k.vertexCode, k.fragmentCode, e);
        }, this._engine);
      }
    };
    this._loadShader(x, "Vertex", "", (P) => {
      hi.Initialize(M), hi.Process(P, M, (D, O) => {
        this._rawVertexSourceCode = P, this._vertexSourceCodeBeforeMigration = O, y && (D = y("vertex", D)), b[0] = D, S();
      }, this._engine);
    }), this._loadShader(A, "Fragment", "Pixel", (P) => {
      this._rawFragmentSourceCode = P, b[1] = P, S();
    });
  }
  _useFinalCode(e, t, i) {
    if (i) {
      const s = i.vertexElement || i.vertex || i.spectorName || i, r = i.fragmentElement || i.fragment || i.spectorName || i;
      this._vertexSourceCode = (this._shaderLanguage === dt.WGSL ? "//" : "") + "#define SHADER_NAME vertex:" + s + `
` + e, this._fragmentSourceCode = (this._shaderLanguage === dt.WGSL ? "//" : "") + "#define SHADER_NAME fragment:" + r + `
` + t;
    } else
      this._vertexSourceCode = e, this._fragmentSourceCode = t;
    this._prepareEffect();
  }
  /**
   * Unique key for this effect
   */
  get key() {
    return this._key;
  }
  /**
   * If the effect has been compiled and prepared.
   * @returns if the effect is compiled and prepared.
   */
  isReady() {
    try {
      return this._isReadyInternal();
    } catch {
      return !1;
    }
  }
  _isReadyInternal() {
    return this._isReady ? !0 : this._pipelineContext ? this._pipelineContext.isReady : !1;
  }
  /**
   * The engine the effect was initialized with.
   * @returns the engine.
   */
  getEngine() {
    return this._engine;
  }
  /**
   * The pipeline context for this effect
   * @returns the associated pipeline context
   */
  getPipelineContext() {
    return this._pipelineContext;
  }
  /**
   * The set of names of attribute variables for the shader.
   * @returns An array of attribute names.
   */
  getAttributesNames() {
    return this._attributesNames;
  }
  /**
   * Returns the attribute at the given index.
   * @param index The index of the attribute.
   * @returns The location of the attribute.
   */
  getAttributeLocation(e) {
    return this._attributes[e];
  }
  /**
   * Returns the attribute based on the name of the variable.
   * @param name of the attribute to look up.
   * @returns the attribute location.
   */
  getAttributeLocationByName(e) {
    return this._attributeLocationByName[e];
  }
  /**
   * The number of attributes.
   * @returns the number of attributes.
   */
  getAttributesCount() {
    return this._attributes.length;
  }
  /**
   * Gets the index of a uniform variable.
   * @param uniformName of the uniform to look up.
   * @returns the index.
   */
  getUniformIndex(e) {
    return this._uniformsNames.indexOf(e);
  }
  /**
   * Returns the attribute based on the name of the variable.
   * @param uniformName of the uniform to look up.
   * @returns the location of the uniform.
   */
  getUniform(e) {
    return this._uniforms[e];
  }
  /**
   * Returns an array of sampler variable names
   * @returns The array of sampler variable names.
   */
  getSamplers() {
    return this._samplerList;
  }
  /**
   * Returns an array of uniform variable names
   * @returns The array of uniform variable names.
   */
  getUniformNames() {
    return this._uniformsNames;
  }
  /**
   * Returns an array of uniform buffer variable names
   * @returns The array of uniform buffer variable names.
   */
  getUniformBuffersNames() {
    return this._uniformBuffersNamesList;
  }
  /**
   * Returns the index parameters used to create the effect
   * @returns The index parameters object
   */
  getIndexParameters() {
    return this._indexParameters;
  }
  /**
   * The error from the last compilation.
   * @returns the error string.
   */
  getCompilationError() {
    return this._compilationError;
  }
  /**
   * Gets a boolean indicating that all fallbacks were used during compilation
   * @returns true if all fallbacks were used
   */
  allFallbacksProcessed() {
    return this._allFallbacksProcessed;
  }
  /**
   * Adds a callback to the onCompiled observable and call the callback immediately if already ready.
   * @param func The callback to be used.
   */
  executeWhenCompiled(e) {
    if (this.isReady()) {
      e(this);
      return;
    }
    this.onCompileObservable.add((t) => {
      e(t);
    }), (!this._pipelineContext || this._pipelineContext.isAsync) && setTimeout(() => {
      this._checkIsReady(null);
    }, 16);
  }
  _checkIsReady(e) {
    try {
      if (this._isReadyInternal())
        return;
    } catch (t) {
      this._processCompilationErrors(t, e);
      return;
    }
    this._isDisposed || setTimeout(() => {
      this._checkIsReady(e);
    }, 16);
  }
  _loadShader(e, t, i, s) {
    if (typeof HTMLElement < "u" && e instanceof HTMLElement) {
      const a = Da(e);
      s(a);
      return;
    }
    if (e.substr(0, 7) === "source:") {
      s(e.substr(7));
      return;
    }
    if (e.substr(0, 7) === "base64:") {
      const a = window.atob(e.substr(7));
      s(a);
      return;
    }
    const r = G.GetShadersStore(this._shaderLanguage);
    if (r[e + t + "Shader"]) {
      s(r[e + t + "Shader"]);
      return;
    }
    if (i && r[e + i + "Shader"]) {
      s(r[e + i + "Shader"]);
      return;
    }
    let n;
    e[0] === "." || e[0] === "/" || e.indexOf("http") > -1 ? n = e : n = G.GetShadersRepository(this._shaderLanguage) + e, this._engine._loadFile(n + "." + t.toLowerCase() + ".fx", s);
  }
  /**
   * Gets the vertex shader source code of this effect
   * This is the final source code that will be compiled, after all the processing has been done (pre-processing applied, code injection/replacement, etc)
   */
  get vertexSourceCode() {
    var e, t;
    return this._vertexSourceCodeOverride && this._fragmentSourceCodeOverride ? this._vertexSourceCodeOverride : (t = (e = this._pipelineContext) === null || e === void 0 ? void 0 : e._getVertexShaderCode()) !== null && t !== void 0 ? t : this._vertexSourceCode;
  }
  /**
   * Gets the fragment shader source code of this effect
   * This is the final source code that will be compiled, after all the processing has been done (pre-processing applied, code injection/replacement, etc)
   */
  get fragmentSourceCode() {
    var e, t;
    return this._vertexSourceCodeOverride && this._fragmentSourceCodeOverride ? this._fragmentSourceCodeOverride : (t = (e = this._pipelineContext) === null || e === void 0 ? void 0 : e._getFragmentShaderCode()) !== null && t !== void 0 ? t : this._fragmentSourceCode;
  }
  /**
   * Gets the vertex shader source code before migration.
   * This is the source code after the include directives have been replaced by their contents but before the code is migrated, i.e. before ShaderProcess._ProcessShaderConversion is executed.
   * This method is, among other things, responsible for parsing #if/#define directives as well as converting GLES2 syntax to GLES3 (in the case of WebGL).
   */
  get vertexSourceCodeBeforeMigration() {
    return this._vertexSourceCodeBeforeMigration;
  }
  /**
   * Gets the fragment shader source code before migration.
   * This is the source code after the include directives have been replaced by their contents but before the code is migrated, i.e. before ShaderProcess._ProcessShaderConversion is executed.
   * This method is, among other things, responsible for parsing #if/#define directives as well as converting GLES2 syntax to GLES3 (in the case of WebGL).
   */
  get fragmentSourceCodeBeforeMigration() {
    return this._fragmentSourceCodeBeforeMigration;
  }
  /**
   * Gets the vertex shader source code before it has been modified by any processing
   */
  get rawVertexSourceCode() {
    return this._rawVertexSourceCode;
  }
  /**
   * Gets the fragment shader source code before it has been modified by any processing
   */
  get rawFragmentSourceCode() {
    return this._rawFragmentSourceCode;
  }
  /**
   * Recompiles the webGL program
   * @param vertexSourceCode The source code for the vertex shader.
   * @param fragmentSourceCode The source code for the fragment shader.
   * @param onCompiled Callback called when completed.
   * @param onError Callback called on error.
   * @internal
   */
  _rebuildProgram(e, t, i, s) {
    this._isReady = !1, this._vertexSourceCodeOverride = e, this._fragmentSourceCodeOverride = t, this.onError = (r, n) => {
      s && s(n);
    }, this.onCompiled = () => {
      const r = this.getEngine().scenes;
      if (r)
        for (let n = 0; n < r.length; n++)
          r[n].markAllMaterialsAsDirty(63);
      this._pipelineContext._handlesSpectorRebuildCallback(i);
    }, this._fallbacks = null, this._prepareEffect();
  }
  /**
   * Prepares the effect
   * @internal
   */
  _prepareEffect() {
    const e = this._attributesNames, t = this.defines, i = this._pipelineContext;
    this._isReady = !1;
    try {
      const s = this._engine;
      this._pipelineContext = s.createPipelineContext(this._processingContext), this._pipelineContext._name = this._key;
      const r = this._rebuildProgram.bind(this);
      this._vertexSourceCodeOverride && this._fragmentSourceCodeOverride ? s._preparePipelineContext(this._pipelineContext, this._vertexSourceCodeOverride, this._fragmentSourceCodeOverride, !0, this._rawVertexSourceCode, this._rawFragmentSourceCode, r, null, this._transformFeedbackVaryings, this._key) : s._preparePipelineContext(this._pipelineContext, this._vertexSourceCode, this._fragmentSourceCode, !1, this._rawVertexSourceCode, this._rawFragmentSourceCode, r, t, this._transformFeedbackVaryings, this._key), s._executeWhenRenderingStateIsCompiled(this._pipelineContext, () => {
        if (this._attributes = [], this._pipelineContext._fillEffectInformation(this, this._uniformBuffersNames, this._uniformsNames, this._uniforms, this._samplerList, this._samplers, e, this._attributes), e)
          for (let n = 0; n < e.length; n++) {
            const a = e[n];
            this._attributeLocationByName[a] = this._attributes[n];
          }
        s.bindSamplers(this), this._compilationError = "", this._isReady = !0, this.onCompiled && this.onCompiled(this), this.onCompileObservable.notifyObservers(this), this.onCompileObservable.clear(), this._fallbacks && this._fallbacks.unBindMesh(), i && this.getEngine()._deletePipelineContext(i);
      }), this._pipelineContext.isAsync && this._checkIsReady(i);
    } catch (s) {
      this._processCompilationErrors(s, i);
    }
  }
  _getShaderCodeAndErrorLine(e, t, i) {
    const s = i ? /FRAGMENT SHADER ERROR: 0:(\d+?):/ : /VERTEX SHADER ERROR: 0:(\d+?):/;
    let r = null;
    if (t && e) {
      const n = t.match(s);
      if (n && n.length === 2) {
        const a = parseInt(n[1]), o = e.split(`
`, -1);
        o.length >= a && (r = `Offending line [${a}] in ${i ? "fragment" : "vertex"} code: ${o[a - 1]}`);
      }
    }
    return [e, r];
  }
  _processCompilationErrors(e, t = null) {
    var i, s, r;
    this._compilationError = e.message;
    const n = this._attributesNames, a = this._fallbacks;
    if (w.Error("Unable to compile effect:"), w.Error("Uniforms: " + this._uniformsNames.map(function(l) {
      return " " + l;
    })), w.Error("Attributes: " + n.map(function(l) {
      return " " + l;
    })), w.Error(`Defines:
` + this.defines), yt.LogShaderCodeOnCompilationError) {
      let l = null, c = null, u = null;
      !((i = this._pipelineContext) === null || i === void 0) && i._getVertexShaderCode() && ([u, l] = this._getShaderCodeAndErrorLine(this._pipelineContext._getVertexShaderCode(), this._compilationError, !1), u && (w.Error("Vertex code:"), w.Error(u))), !((s = this._pipelineContext) === null || s === void 0) && s._getFragmentShaderCode() && ([u, c] = this._getShaderCodeAndErrorLine((r = this._pipelineContext) === null || r === void 0 ? void 0 : r._getFragmentShaderCode(), this._compilationError, !0), u && (w.Error("Fragment code:"), w.Error(u))), l && w.Error(l), c && w.Error(c);
    }
    w.Error("Error: " + this._compilationError);
    const o = () => {
      this.onError && this.onError(this, this._compilationError), this.onErrorObservable.notifyObservers(this);
    };
    t && (this._pipelineContext = t, this._isReady = !0, o()), a ? (this._pipelineContext = null, a.hasMoreFallbacks ? (this._allFallbacksProcessed = !1, w.Error("Trying next fallback."), this.defines = a.reduce(this.defines, this), this._prepareEffect()) : (this._allFallbacksProcessed = !0, o(), this.onErrorObservable.clear(), this._fallbacks && this._fallbacks.unBindMesh())) : (this._allFallbacksProcessed = !0, t || o());
  }
  /**
   * Checks if the effect is supported. (Must be called after compilation)
   */
  get isSupported() {
    return this._compilationError === "";
  }
  /**
   * Binds a texture to the engine to be used as output of the shader.
   * @param channel Name of the output variable.
   * @param texture Texture to bind.
   * @internal
   */
  _bindTexture(e, t) {
    this._engine._bindTexture(this._samplers[e], t, e);
  }
  /**
   * Sets a texture on the engine to be used in the shader.
   * @param channel Name of the sampler variable.
   * @param texture Texture to set.
   */
  setTexture(e, t) {
    this._engine.setTexture(this._samplers[e], this._uniforms[e], t, e);
  }
  /**
   * Sets a depth stencil texture from a render target on the engine to be used in the shader.
   * @param channel Name of the sampler variable.
   * @param texture Texture to set.
   */
  setDepthStencilTexture(e, t) {
    this._engine.setDepthStencilTexture(this._samplers[e], this._uniforms[e], t, e);
  }
  /**
   * Sets an array of textures on the engine to be used in the shader.
   * @param channel Name of the variable.
   * @param textures Textures to set.
   */
  setTextureArray(e, t) {
    const i = e + "Ex";
    if (this._samplerList.indexOf(i + "0") === -1) {
      const s = this._samplerList.indexOf(e);
      for (let n = 1; n < t.length; n++) {
        const a = i + (n - 1).toString();
        this._samplerList.splice(s + n, 0, a);
      }
      let r = 0;
      for (const n of this._samplerList)
        this._samplers[n] = r, r += 1;
    }
    this._engine.setTextureArray(this._samplers[e], this._uniforms[e], t, e);
  }
  /**
   * Sets a texture to be the input of the specified post process. (To use the output, pass in the next post process in the pipeline)
   * @param channel Name of the sampler variable.
   * @param postProcess Post process to get the input texture from.
   */
  setTextureFromPostProcess(e, t) {
    this._engine.setTextureFromPostProcess(this._samplers[e], t, e);
  }
  /**
   * (Warning! setTextureFromPostProcessOutput may be desired instead)
   * Sets the input texture of the passed in post process to be input of this effect. (To use the output of the passed in post process use setTextureFromPostProcessOutput)
   * @param channel Name of the sampler variable.
   * @param postProcess Post process to get the output texture from.
   */
  setTextureFromPostProcessOutput(e, t) {
    this._engine.setTextureFromPostProcessOutput(this._samplers[e], t, e);
  }
  /**
   * Binds a buffer to a uniform.
   * @param buffer Buffer to bind.
   * @param name Name of the uniform variable to bind to.
   */
  bindUniformBuffer(e, t) {
    const i = this._uniformBuffersNames[t];
    i === void 0 || yt._BaseCache[i] === e && this._engine._features.useUBOBindingCache || (yt._BaseCache[i] = e, this._engine.bindUniformBufferBase(e, i, t));
  }
  /**
   * Binds block to a uniform.
   * @param blockName Name of the block to bind.
   * @param index Index to bind.
   */
  bindUniformBlock(e, t) {
    this._engine.bindUniformBlock(this._pipelineContext, e, t);
  }
  /**
   * Sets an integer value on a uniform variable.
   * @param uniformName Name of the variable.
   * @param value Value to be set.
   * @returns this effect.
   */
  setInt(e, t) {
    return this._pipelineContext.setInt(e, t), this;
  }
  /**
   * Sets an int2 value on a uniform variable.
   * @param uniformName Name of the variable.
   * @param x First int in int2.
   * @param y Second int in int2.
   * @returns this effect.
   */
  setInt2(e, t, i) {
    return this._pipelineContext.setInt2(e, t, i), this;
  }
  /**
   * Sets an int3 value on a uniform variable.
   * @param uniformName Name of the variable.
   * @param x First int in int3.
   * @param y Second int in int3.
   * @param z Third int in int3.
   * @returns this effect.
   */
  setInt3(e, t, i, s) {
    return this._pipelineContext.setInt3(e, t, i, s), this;
  }
  /**
   * Sets an int4 value on a uniform variable.
   * @param uniformName Name of the variable.
   * @param x First int in int4.
   * @param y Second int in int4.
   * @param z Third int in int4.
   * @param w Fourth int in int4.
   * @returns this effect.
   */
  setInt4(e, t, i, s, r) {
    return this._pipelineContext.setInt4(e, t, i, s, r), this;
  }
  /**
   * Sets an int array on a uniform variable.
   * @param uniformName Name of the variable.
   * @param array array to be set.
   * @returns this effect.
   */
  setIntArray(e, t) {
    return this._pipelineContext.setIntArray(e, t), this;
  }
  /**
   * Sets an int array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
   * @param uniformName Name of the variable.
   * @param array array to be set.
   * @returns this effect.
   */
  setIntArray2(e, t) {
    return this._pipelineContext.setIntArray2(e, t), this;
  }
  /**
   * Sets an int array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
   * @param uniformName Name of the variable.
   * @param array array to be set.
   * @returns this effect.
   */
  setIntArray3(e, t) {
    return this._pipelineContext.setIntArray3(e, t), this;
  }
  /**
   * Sets an int array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
   * @param uniformName Name of the variable.
   * @param array array to be set.
   * @returns this effect.
   */
  setIntArray4(e, t) {
    return this._pipelineContext.setIntArray4(e, t), this;
  }
  /**
   * Sets an unsigned integer value on a uniform variable.
   * @param uniformName Name of the variable.
   * @param value Value to be set.
   * @returns this effect.
   */
  setUInt(e, t) {
    return this._pipelineContext.setInt(e, t), this;
  }
  /**
   * Sets an unsigned int2 value on a uniform variable.
   * @param uniformName Name of the variable.
   * @param x First unsigned int in uint2.
   * @param y Second unsigned int in uint2.
   * @returns this effect.
   */
  setUInt2(e, t, i) {
    return this._pipelineContext.setInt2(e, t, i), this;
  }
  /**
   * Sets an unsigned int3 value on a uniform variable.
   * @param uniformName Name of the variable.
   * @param x First unsigned int in uint3.
   * @param y Second unsigned int in uint3.
   * @param z Third unsigned int in uint3.
   * @returns this effect.
   */
  setUInt3(e, t, i, s) {
    return this._pipelineContext.setInt3(e, t, i, s), this;
  }
  /**
   * Sets an unsigned int4 value on a uniform variable.
   * @param uniformName Name of the variable.
   * @param x First unsigned int in uint4.
   * @param y Second unsigned int in uint4.
   * @param z Third unsigned int in uint4.
   * @param w Fourth unsigned int in uint4.
   * @returns this effect.
   */
  setUInt4(e, t, i, s, r) {
    return this._pipelineContext.setInt4(e, t, i, s, r), this;
  }
  /**
   * Sets an unsigned int array on a uniform variable.
   * @param uniformName Name of the variable.
   * @param array array to be set.
   * @returns this effect.
   */
  setUIntArray(e, t) {
    return this._pipelineContext.setUIntArray(e, t), this;
  }
  /**
   * Sets an unsigned int array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
   * @param uniformName Name of the variable.
   * @param array array to be set.
   * @returns this effect.
   */
  setUIntArray2(e, t) {
    return this._pipelineContext.setUIntArray2(e, t), this;
  }
  /**
   * Sets an unsigned int array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
   * @param uniformName Name of the variable.
   * @param array array to be set.
   * @returns this effect.
   */
  setUIntArray3(e, t) {
    return this._pipelineContext.setUIntArray3(e, t), this;
  }
  /**
   * Sets an unsigned int array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
   * @param uniformName Name of the variable.
   * @param array array to be set.
   * @returns this effect.
   */
  setUIntArray4(e, t) {
    return this._pipelineContext.setUIntArray4(e, t), this;
  }
  /**
   * Sets an float array on a uniform variable.
   * @param uniformName Name of the variable.
   * @param array array to be set.
   * @returns this effect.
   */
  setFloatArray(e, t) {
    return this._pipelineContext.setArray(e, t), this;
  }
  /**
   * Sets an float array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
   * @param uniformName Name of the variable.
   * @param array array to be set.
   * @returns this effect.
   */
  setFloatArray2(e, t) {
    return this._pipelineContext.setArray2(e, t), this;
  }
  /**
   * Sets an float array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
   * @param uniformName Name of the variable.
   * @param array array to be set.
   * @returns this effect.
   */
  setFloatArray3(e, t) {
    return this._pipelineContext.setArray3(e, t), this;
  }
  /**
   * Sets an float array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
   * @param uniformName Name of the variable.
   * @param array array to be set.
   * @returns this effect.
   */
  setFloatArray4(e, t) {
    return this._pipelineContext.setArray4(e, t), this;
  }
  /**
   * Sets an array on a uniform variable.
   * @param uniformName Name of the variable.
   * @param array array to be set.
   * @returns this effect.
   */
  setArray(e, t) {
    return this._pipelineContext.setArray(e, t), this;
  }
  /**
   * Sets an array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
   * @param uniformName Name of the variable.
   * @param array array to be set.
   * @returns this effect.
   */
  setArray2(e, t) {
    return this._pipelineContext.setArray2(e, t), this;
  }
  /**
   * Sets an array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
   * @param uniformName Name of the variable.
   * @param array array to be set.
   * @returns this effect.
   */
  setArray3(e, t) {
    return this._pipelineContext.setArray3(e, t), this;
  }
  /**
   * Sets an array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
   * @param uniformName Name of the variable.
   * @param array array to be set.
   * @returns this effect.
   */
  setArray4(e, t) {
    return this._pipelineContext.setArray4(e, t), this;
  }
  /**
   * Sets matrices on a uniform variable.
   * @param uniformName Name of the variable.
   * @param matrices matrices to be set.
   * @returns this effect.
   */
  setMatrices(e, t) {
    return this._pipelineContext.setMatrices(e, t), this;
  }
  /**
   * Sets matrix on a uniform variable.
   * @param uniformName Name of the variable.
   * @param matrix matrix to be set.
   * @returns this effect.
   */
  setMatrix(e, t) {
    return this._pipelineContext.setMatrix(e, t), this;
  }
  /**
   * Sets a 3x3 matrix on a uniform variable. (Specified as [1,2,3,4,5,6,7,8,9] will result in [1,2,3][4,5,6][7,8,9] matrix)
   * @param uniformName Name of the variable.
   * @param matrix matrix to be set.
   * @returns this effect.
   */
  setMatrix3x3(e, t) {
    return this._pipelineContext.setMatrix3x3(e, t), this;
  }
  /**
   * Sets a 2x2 matrix on a uniform variable. (Specified as [1,2,3,4] will result in [1,2][3,4] matrix)
   * @param uniformName Name of the variable.
   * @param matrix matrix to be set.
   * @returns this effect.
   */
  setMatrix2x2(e, t) {
    return this._pipelineContext.setMatrix2x2(e, t), this;
  }
  /**
   * Sets a float on a uniform variable.
   * @param uniformName Name of the variable.
   * @param value value to be set.
   * @returns this effect.
   */
  setFloat(e, t) {
    return this._pipelineContext.setFloat(e, t), this;
  }
  /**
   * Sets a boolean on a uniform variable.
   * @param uniformName Name of the variable.
   * @param bool value to be set.
   * @returns this effect.
   */
  setBool(e, t) {
    return this._pipelineContext.setInt(e, t ? 1 : 0), this;
  }
  /**
   * Sets a Vector2 on a uniform variable.
   * @param uniformName Name of the variable.
   * @param vector2 vector2 to be set.
   * @returns this effect.
   */
  setVector2(e, t) {
    return this._pipelineContext.setVector2(e, t), this;
  }
  /**
   * Sets a float2 on a uniform variable.
   * @param uniformName Name of the variable.
   * @param x First float in float2.
   * @param y Second float in float2.
   * @returns this effect.
   */
  setFloat2(e, t, i) {
    return this._pipelineContext.setFloat2(e, t, i), this;
  }
  /**
   * Sets a Vector3 on a uniform variable.
   * @param uniformName Name of the variable.
   * @param vector3 Value to be set.
   * @returns this effect.
   */
  setVector3(e, t) {
    return this._pipelineContext.setVector3(e, t), this;
  }
  /**
   * Sets a float3 on a uniform variable.
   * @param uniformName Name of the variable.
   * @param x First float in float3.
   * @param y Second float in float3.
   * @param z Third float in float3.
   * @returns this effect.
   */
  setFloat3(e, t, i, s) {
    return this._pipelineContext.setFloat3(e, t, i, s), this;
  }
  /**
   * Sets a Vector4 on a uniform variable.
   * @param uniformName Name of the variable.
   * @param vector4 Value to be set.
   * @returns this effect.
   */
  setVector4(e, t) {
    return this._pipelineContext.setVector4(e, t), this;
  }
  /**
   * Sets a Quaternion on a uniform variable.
   * @param uniformName Name of the variable.
   * @param quaternion Value to be set.
   * @returns this effect.
   */
  setQuaternion(e, t) {
    return this._pipelineContext.setQuaternion(e, t), this;
  }
  /**
   * Sets a float4 on a uniform variable.
   * @param uniformName Name of the variable.
   * @param x First float in float4.
   * @param y Second float in float4.
   * @param z Third float in float4.
   * @param w Fourth float in float4.
   * @returns this effect.
   */
  setFloat4(e, t, i, s, r) {
    return this._pipelineContext.setFloat4(e, t, i, s, r), this;
  }
  /**
   * Sets a Color3 on a uniform variable.
   * @param uniformName Name of the variable.
   * @param color3 Value to be set.
   * @returns this effect.
   */
  setColor3(e, t) {
    return this._pipelineContext.setColor3(e, t), this;
  }
  /**
   * Sets a Color4 on a uniform variable.
   * @param uniformName Name of the variable.
   * @param color3 Value to be set.
   * @param alpha Alpha value to be set.
   * @returns this effect.
   */
  setColor4(e, t, i) {
    return this._pipelineContext.setColor4(e, t, i), this;
  }
  /**
   * Sets a Color4 on a uniform variable
   * @param uniformName defines the name of the variable
   * @param color4 defines the value to be set
   * @returns this effect.
   */
  setDirectColor4(e, t) {
    return this._pipelineContext.setDirectColor4(e, t), this;
  }
  /**
   * Release all associated resources.
   **/
  dispose() {
    this._pipelineContext && this._pipelineContext.dispose(), this._engine._releaseEffect(this), this._isDisposed = !0;
  }
  /**
   * This function will add a new shader to the shader store
   * @param name the name of the shader
   * @param pixelShader optional pixel shader content
   * @param vertexShader optional vertex shader content
   * @param shaderLanguage the language the shader is written in (default: GLSL)
   */
  static RegisterShader(e, t, i, s = dt.GLSL) {
    t && (G.GetShadersStore(s)[`${e}PixelShader`] = t), i && (G.GetShadersStore(s)[`${e}VertexShader`] = i);
  }
  /**
   * Resets the cache of effects.
   */
  static ResetCache() {
    yt._BaseCache = {};
  }
}
yt.LogShaderCodeOnCompilationError = !0;
yt._UniqueIdSeed = 0;
yt._BaseCache = {};
yt.ShadersStore = G.ShadersStore;
yt.IncludesShadersStore = G.IncludesShadersStore;
class ll {
  /**
   * Initializes the state.
   * @param reset
   */
  constructor(e = !0) {
    this._isDepthTestDirty = !1, this._isDepthMaskDirty = !1, this._isDepthFuncDirty = !1, this._isCullFaceDirty = !1, this._isCullDirty = !1, this._isZOffsetDirty = !1, this._isFrontFaceDirty = !1, e && this.reset();
  }
  get isDirty() {
    return this._isDepthFuncDirty || this._isDepthTestDirty || this._isDepthMaskDirty || this._isCullFaceDirty || this._isCullDirty || this._isZOffsetDirty || this._isFrontFaceDirty;
  }
  get zOffset() {
    return this._zOffset;
  }
  set zOffset(e) {
    this._zOffset !== e && (this._zOffset = e, this._isZOffsetDirty = !0);
  }
  get zOffsetUnits() {
    return this._zOffsetUnits;
  }
  set zOffsetUnits(e) {
    this._zOffsetUnits !== e && (this._zOffsetUnits = e, this._isZOffsetDirty = !0);
  }
  get cullFace() {
    return this._cullFace;
  }
  set cullFace(e) {
    this._cullFace !== e && (this._cullFace = e, this._isCullFaceDirty = !0);
  }
  get cull() {
    return this._cull;
  }
  set cull(e) {
    this._cull !== e && (this._cull = e, this._isCullDirty = !0);
  }
  get depthFunc() {
    return this._depthFunc;
  }
  set depthFunc(e) {
    this._depthFunc !== e && (this._depthFunc = e, this._isDepthFuncDirty = !0);
  }
  get depthMask() {
    return this._depthMask;
  }
  set depthMask(e) {
    this._depthMask !== e && (this._depthMask = e, this._isDepthMaskDirty = !0);
  }
  get depthTest() {
    return this._depthTest;
  }
  set depthTest(e) {
    this._depthTest !== e && (this._depthTest = e, this._isDepthTestDirty = !0);
  }
  get frontFace() {
    return this._frontFace;
  }
  set frontFace(e) {
    this._frontFace !== e && (this._frontFace = e, this._isFrontFaceDirty = !0);
  }
  reset() {
    this._depthMask = !0, this._depthTest = !0, this._depthFunc = null, this._cullFace = null, this._cull = null, this._zOffset = 0, this._zOffsetUnits = 0, this._frontFace = null, this._isDepthTestDirty = !0, this._isDepthMaskDirty = !0, this._isDepthFuncDirty = !1, this._isCullFaceDirty = !1, this._isCullDirty = !1, this._isZOffsetDirty = !0, this._isFrontFaceDirty = !1;
  }
  apply(e) {
    this.isDirty && (this._isCullDirty && (this.cull ? e.enable(e.CULL_FACE) : e.disable(e.CULL_FACE), this._isCullDirty = !1), this._isCullFaceDirty && (e.cullFace(this.cullFace), this._isCullFaceDirty = !1), this._isDepthMaskDirty && (e.depthMask(this.depthMask), this._isDepthMaskDirty = !1), this._isDepthTestDirty && (this.depthTest ? e.enable(e.DEPTH_TEST) : e.disable(e.DEPTH_TEST), this._isDepthTestDirty = !1), this._isDepthFuncDirty && (e.depthFunc(this.depthFunc), this._isDepthFuncDirty = !1), this._isZOffsetDirty && (this.zOffset || this.zOffsetUnits ? (e.enable(e.POLYGON_OFFSET_FILL), e.polygonOffset(this.zOffset, this.zOffsetUnits)) : e.disable(e.POLYGON_OFFSET_FILL), this._isZOffsetDirty = !1), this._isFrontFaceDirty && (e.frontFace(this.frontFace), this._isFrontFaceDirty = !1));
  }
}
class vi {
  constructor() {
    this.reset();
  }
  reset() {
    this.enabled = !1, this.mask = 255, this.func = vi.ALWAYS, this.funcRef = 1, this.funcMask = 255, this.opStencilFail = vi.KEEP, this.opDepthFail = vi.KEEP, this.opStencilDepthPass = vi.REPLACE;
  }
  get stencilFunc() {
    return this.func;
  }
  set stencilFunc(e) {
    this.func = e;
  }
  get stencilFuncRef() {
    return this.funcRef;
  }
  set stencilFuncRef(e) {
    this.funcRef = e;
  }
  get stencilFuncMask() {
    return this.funcMask;
  }
  set stencilFuncMask(e) {
    this.funcMask = e;
  }
  get stencilOpStencilFail() {
    return this.opStencilFail;
  }
  set stencilOpStencilFail(e) {
    this.opStencilFail = e;
  }
  get stencilOpDepthFail() {
    return this.opDepthFail;
  }
  set stencilOpDepthFail(e) {
    this.opDepthFail = e;
  }
  get stencilOpStencilDepthPass() {
    return this.opStencilDepthPass;
  }
  set stencilOpStencilDepthPass(e) {
    this.opStencilDepthPass = e;
  }
  get stencilMask() {
    return this.mask;
  }
  set stencilMask(e) {
    this.mask = e;
  }
  get stencilTest() {
    return this.enabled;
  }
  set stencilTest(e) {
    this.enabled = e;
  }
}
vi.ALWAYS = 519;
vi.KEEP = 7680;
vi.REPLACE = 7681;
class hl {
  /**
   * Initializes the state.
   */
  constructor() {
    this._blendFunctionParameters = new Array(4), this._blendEquationParameters = new Array(2), this._blendConstants = new Array(4), this._isBlendConstantsDirty = !1, this._alphaBlend = !1, this._isAlphaBlendDirty = !1, this._isBlendFunctionParametersDirty = !1, this._isBlendEquationParametersDirty = !1, this.reset();
  }
  get isDirty() {
    return this._isAlphaBlendDirty || this._isBlendFunctionParametersDirty || this._isBlendEquationParametersDirty;
  }
  get alphaBlend() {
    return this._alphaBlend;
  }
  set alphaBlend(e) {
    this._alphaBlend !== e && (this._alphaBlend = e, this._isAlphaBlendDirty = !0);
  }
  setAlphaBlendConstants(e, t, i, s) {
    this._blendConstants[0] === e && this._blendConstants[1] === t && this._blendConstants[2] === i && this._blendConstants[3] === s || (this._blendConstants[0] = e, this._blendConstants[1] = t, this._blendConstants[2] = i, this._blendConstants[3] = s, this._isBlendConstantsDirty = !0);
  }
  setAlphaBlendFunctionParameters(e, t, i, s) {
    this._blendFunctionParameters[0] === e && this._blendFunctionParameters[1] === t && this._blendFunctionParameters[2] === i && this._blendFunctionParameters[3] === s || (this._blendFunctionParameters[0] = e, this._blendFunctionParameters[1] = t, this._blendFunctionParameters[2] = i, this._blendFunctionParameters[3] = s, this._isBlendFunctionParametersDirty = !0);
  }
  setAlphaEquationParameters(e, t) {
    this._blendEquationParameters[0] === e && this._blendEquationParameters[1] === t || (this._blendEquationParameters[0] = e, this._blendEquationParameters[1] = t, this._isBlendEquationParametersDirty = !0);
  }
  reset() {
    this._alphaBlend = !1, this._blendFunctionParameters[0] = null, this._blendFunctionParameters[1] = null, this._blendFunctionParameters[2] = null, this._blendFunctionParameters[3] = null, this._blendEquationParameters[0] = null, this._blendEquationParameters[1] = null, this._blendConstants[0] = null, this._blendConstants[1] = null, this._blendConstants[2] = null, this._blendConstants[3] = null, this._isAlphaBlendDirty = !0, this._isBlendFunctionParametersDirty = !1, this._isBlendEquationParametersDirty = !1, this._isBlendConstantsDirty = !1;
  }
  apply(e) {
    this.isDirty && (this._isAlphaBlendDirty && (this._alphaBlend ? e.enable(e.BLEND) : e.disable(e.BLEND), this._isAlphaBlendDirty = !1), this._isBlendFunctionParametersDirty && (e.blendFuncSeparate(this._blendFunctionParameters[0], this._blendFunctionParameters[1], this._blendFunctionParameters[2], this._blendFunctionParameters[3]), this._isBlendFunctionParametersDirty = !1), this._isBlendEquationParametersDirty && (e.blendEquationSeparate(this._blendEquationParameters[0], this._blendEquationParameters[1]), this._isBlendEquationParametersDirty = !1), this._isBlendConstantsDirty && (e.blendColor(this._blendConstants[0], this._blendConstants[1], this._blendConstants[2], this._blendConstants[3]), this._isBlendConstantsDirty = !1));
  }
}
class cl {
  /**
   * | Value | Type               | Description |
   * | ----- | ------------------ | ----------- |
   * | 0     | CLAMP_ADDRESSMODE  |             |
   * | 1     | WRAP_ADDRESSMODE   |             |
   * | 2     | MIRROR_ADDRESSMODE |             |
   */
  get wrapU() {
    return this._cachedWrapU;
  }
  set wrapU(e) {
    this._cachedWrapU = e;
  }
  /**
   * | Value | Type               | Description |
   * | ----- | ------------------ | ----------- |
   * | 0     | CLAMP_ADDRESSMODE  |             |
   * | 1     | WRAP_ADDRESSMODE   |             |
   * | 2     | MIRROR_ADDRESSMODE |             |
   */
  get wrapV() {
    return this._cachedWrapV;
  }
  set wrapV(e) {
    this._cachedWrapV = e;
  }
  /**
   * | Value | Type               | Description |
   * | ----- | ------------------ | ----------- |
   * | 0     | CLAMP_ADDRESSMODE  |             |
   * | 1     | WRAP_ADDRESSMODE   |             |
   * | 2     | MIRROR_ADDRESSMODE |             |
   */
  get wrapR() {
    return this._cachedWrapR;
  }
  set wrapR(e) {
    this._cachedWrapR = e;
  }
  /**
   * With compliant hardware and browser (supporting anisotropic filtering)
   * this defines the level of anisotropic filtering in the texture.
   * The higher the better but the slower.
   */
  get anisotropicFilteringLevel() {
    return this._cachedAnisotropicFilteringLevel;
  }
  set anisotropicFilteringLevel(e) {
    this._cachedAnisotropicFilteringLevel = e;
  }
  /**
   * Gets or sets the comparison function (513, 514, etc). Set 0 to not use a comparison function
   */
  get comparisonFunction() {
    return this._comparisonFunction;
  }
  set comparisonFunction(e) {
    this._comparisonFunction = e;
  }
  /**
   * Indicates to use the mip maps (if available on the texture).
   * Thanks to this flag, you can instruct the sampler to not sample the mipmaps even if they exist (and if the sampling mode is set to a value that normally samples the mipmaps!)
   */
  get useMipMaps() {
    return this._useMipMaps;
  }
  set useMipMaps(e) {
    this._useMipMaps = e;
  }
  /**
   * Creates a Sampler instance
   */
  constructor() {
    this.samplingMode = -1, this._useMipMaps = !0, this._cachedWrapU = null, this._cachedWrapV = null, this._cachedWrapR = null, this._cachedAnisotropicFilteringLevel = null, this._comparisonFunction = 0;
  }
  /**
   * Sets all the parameters of the sampler
   * @param wrapU u address mode (default: TEXTURE_WRAP_ADDRESSMODE)
   * @param wrapV v address mode (default: TEXTURE_WRAP_ADDRESSMODE)
   * @param wrapR r address mode (default: TEXTURE_WRAP_ADDRESSMODE)
   * @param anisotropicFilteringLevel anisotropic level (default: 1)
   * @param samplingMode sampling mode (default: 2)
   * @param comparisonFunction comparison function (default: 0 - no comparison function)
   * @returns the current sampler instance
   */
  setParameters(e = 1, t = 1, i = 1, s = 1, r = 2, n = 0) {
    return this._cachedWrapU = e, this._cachedWrapV = t, this._cachedWrapR = i, this._cachedAnisotropicFilteringLevel = s, this.samplingMode = r, this._comparisonFunction = n, this;
  }
  /**
   * Compares this sampler with another one
   * @param other sampler to compare with
   * @returns true if the samplers have the same parametres, else false
   */
  compareSampler(e) {
    return this._cachedWrapU === e._cachedWrapU && this._cachedWrapV === e._cachedWrapV && this._cachedWrapR === e._cachedWrapR && this._cachedAnisotropicFilteringLevel === e._cachedAnisotropicFilteringLevel && this.samplingMode === e.samplingMode && this._comparisonFunction === e._comparisonFunction && this._useMipMaps === e._useMipMaps;
  }
}
var Ze;
(function(h) {
  h[h.Unknown = 0] = "Unknown", h[h.Url = 1] = "Url", h[h.Temp = 2] = "Temp", h[h.Raw = 3] = "Raw", h[h.Dynamic = 4] = "Dynamic", h[h.RenderTarget = 5] = "RenderTarget", h[h.MultiRenderTarget = 6] = "MultiRenderTarget", h[h.Cube = 7] = "Cube", h[h.CubeRaw = 8] = "CubeRaw", h[h.CubePrefiltered = 9] = "CubePrefiltered", h[h.Raw3D = 10] = "Raw3D", h[h.Raw2DArray = 11] = "Raw2DArray", h[h.DepthStencil = 12] = "DepthStencil", h[h.CubeRawRGBD = 13] = "CubeRawRGBD", h[h.Depth = 14] = "Depth";
})(Ze || (Ze = {}));
class zt extends cl {
  /**
   * Gets a boolean indicating if the texture uses mipmaps
   * TODO implements useMipMaps as a separate setting from generateMipMaps
   */
  get useMipMaps() {
    return this.generateMipMaps;
  }
  set useMipMaps(e) {
    this.generateMipMaps = e;
  }
  /** Gets the unique id of the internal texture */
  get uniqueId() {
    return this._uniqueId;
  }
  /** @internal */
  _setUniqueId(e) {
    this._uniqueId = e;
  }
  /**
   * Gets the Engine the texture belongs to.
   * @returns The babylon engine
   */
  getEngine() {
    return this._engine;
  }
  /**
   * Gets the data source type of the texture
   */
  get source() {
    return this._source;
  }
  /**
   * Creates a new InternalTexture
   * @param engine defines the engine to use
   * @param source defines the type of data that will be used
   * @param delayAllocation if the texture allocation should be delayed (default: false)
   */
  constructor(e, t, i = !1) {
    super(), this.isReady = !1, this.isCube = !1, this.is3D = !1, this.is2DArray = !1, this.isMultiview = !1, this.url = "", this.generateMipMaps = !1, this.samples = 0, this.type = -1, this.format = -1, this.onLoadedObservable = new N(), this.onErrorObservable = new N(), this.onRebuildCallback = null, this.width = 0, this.height = 0, this.depth = 0, this.baseWidth = 0, this.baseHeight = 0, this.baseDepth = 0, this.invertY = !1, this._invertVScale = !1, this._associatedChannel = -1, this._source = Ze.Unknown, this._buffer = null, this._bufferView = null, this._bufferViewArray = null, this._bufferViewArrayArray = null, this._size = 0, this._extension = "", this._files = null, this._workingCanvas = null, this._workingContext = null, this._cachedCoordinatesMode = null, this._isDisabled = !1, this._compression = null, this._sphericalPolynomial = null, this._sphericalPolynomialPromise = null, this._sphericalPolynomialComputed = !1, this._lodGenerationScale = 0, this._lodGenerationOffset = 0, this._useSRGBBuffer = !1, this._lodTextureHigh = null, this._lodTextureMid = null, this._lodTextureLow = null, this._isRGBD = !1, this._linearSpecularLOD = !1, this._irradianceTexture = null, this._hardwareTexture = null, this._maxLodLevel = null, this._references = 1, this._gammaSpace = null, this._engine = e, this._source = t, this._uniqueId = zt._Counter++, i || (this._hardwareTexture = e._createHardwareTexture());
  }
  /**
   * Increments the number of references (ie. the number of Texture that point to it)
   */
  incrementReferences() {
    this._references++;
  }
  /**
   * Change the size of the texture (not the size of the content)
   * @param width defines the new width
   * @param height defines the new height
   * @param depth defines the new depth (1 by default)
   */
  updateSize(e, t, i = 1) {
    this._engine.updateTextureDimensions(this, e, t, i), this.width = e, this.height = t, this.depth = i, this.baseWidth = e, this.baseHeight = t, this.baseDepth = i, this._size = e * t * i;
  }
  /** @internal */
  _rebuild() {
    var e;
    if (this.isReady = !1, this._cachedCoordinatesMode = null, this._cachedWrapU = null, this._cachedWrapV = null, this._cachedWrapR = null, this._cachedAnisotropicFilteringLevel = null, this.onRebuildCallback) {
      const i = this.onRebuildCallback(this), s = (r) => {
        r._swapAndDie(this, !1), this.isReady = i.isReady;
      };
      i.isAsync ? i.proxy.then(s) : s(i.proxy);
      return;
    }
    let t;
    switch (this.source) {
      case Ze.Temp:
        break;
      case Ze.Url:
        t = this._engine.createTexture(
          (e = this._originalUrl) !== null && e !== void 0 ? e : this.url,
          !this.generateMipMaps,
          this.invertY,
          null,
          this.samplingMode,
          // Do not use Proxy here as it could be fully synchronous
          // and proxy would be undefined.
          (i) => {
            i._swapAndDie(this, !1), this.isReady = !0;
          },
          null,
          this._buffer,
          void 0,
          this.format,
          this._extension,
          void 0,
          void 0,
          void 0,
          this._useSRGBBuffer
        );
        return;
      case Ze.Raw:
        t = this._engine.createRawTexture(this._bufferView, this.baseWidth, this.baseHeight, this.format, this.generateMipMaps, this.invertY, this.samplingMode, this._compression, this.type, void 0, this._useSRGBBuffer), t._swapAndDie(this, !1), this.isReady = !0;
        break;
      case Ze.Raw3D:
        t = this._engine.createRawTexture3D(this._bufferView, this.baseWidth, this.baseHeight, this.baseDepth, this.format, this.generateMipMaps, this.invertY, this.samplingMode, this._compression, this.type), t._swapAndDie(this, !1), this.isReady = !0;
        break;
      case Ze.Raw2DArray:
        t = this._engine.createRawTexture2DArray(this._bufferView, this.baseWidth, this.baseHeight, this.baseDepth, this.format, this.generateMipMaps, this.invertY, this.samplingMode, this._compression, this.type), t._swapAndDie(this, !1), this.isReady = !0;
        break;
      case Ze.Dynamic:
        t = this._engine.createDynamicTexture(this.baseWidth, this.baseHeight, this.generateMipMaps, this.samplingMode), t._swapAndDie(this, !1), this._engine.updateDynamicTexture(this, this._engine.getRenderingCanvas(), this.invertY, void 0, void 0, !0);
        break;
      case Ze.Cube:
        t = this._engine.createCubeTexture(this.url, null, this._files, !this.generateMipMaps, () => {
          t._swapAndDie(this, !1), this.isReady = !0;
        }, null, this.format, this._extension, !1, 0, 0, null, void 0, this._useSRGBBuffer);
        return;
      case Ze.CubeRaw:
        t = this._engine.createRawCubeTexture(this._bufferViewArray, this.width, this.format, this.type, this.generateMipMaps, this.invertY, this.samplingMode, this._compression), t._swapAndDie(this, !1), this.isReady = !0;
        break;
      case Ze.CubeRawRGBD:
        return;
      case Ze.CubePrefiltered:
        t = this._engine.createPrefilteredCubeTexture(this.url, null, this._lodGenerationScale, this._lodGenerationOffset, (i) => {
          i && i._swapAndDie(this, !1), this.isReady = !0;
        }, null, this.format, this._extension), t._sphericalPolynomial = this._sphericalPolynomial;
        return;
    }
  }
  /**
   * @internal
   */
  _swapAndDie(e, t = !0) {
    var i;
    (i = this._hardwareTexture) === null || i === void 0 || i.setUsage(e._source, this.generateMipMaps, this.isCube, this.width, this.height), e._hardwareTexture = this._hardwareTexture, t && (e._isRGBD = this._isRGBD), this._lodTextureHigh && (e._lodTextureHigh && e._lodTextureHigh.dispose(), e._lodTextureHigh = this._lodTextureHigh), this._lodTextureMid && (e._lodTextureMid && e._lodTextureMid.dispose(), e._lodTextureMid = this._lodTextureMid), this._lodTextureLow && (e._lodTextureLow && e._lodTextureLow.dispose(), e._lodTextureLow = this._lodTextureLow), this._irradianceTexture && (e._irradianceTexture && e._irradianceTexture.dispose(), e._irradianceTexture = this._irradianceTexture);
    const s = this._engine.getLoadedTexturesCache();
    let r = s.indexOf(this);
    r !== -1 && s.splice(r, 1), r = s.indexOf(e), r === -1 && s.push(e);
  }
  /**
   * Dispose the current allocated resources
   */
  dispose() {
    this._references--, this.onLoadedObservable.clear(), this.onErrorObservable.clear(), this._references === 0 && (this._engine._releaseTexture(this), this._hardwareTexture = null);
  }
}
zt._Counter = 0;
class ul {
  constructor() {
    this.shaderLanguage = dt.GLSL;
  }
  postProcessor(e, t, i, s, r) {
    if (!r.getCaps().drawBuffersExtension) {
      const n = /#extension.+GL_EXT_draw_buffers.+(enable|require)/g;
      e = e.replace(n, "");
    }
    return e;
  }
}
const dl = /(flat\s)?\s*varying\s*.*/;
class fl {
  constructor() {
    this.shaderLanguage = dt.GLSL;
  }
  attributeProcessor(e) {
    return e.replace("attribute", "in");
  }
  varyingCheck(e, t) {
    return dl.test(e);
  }
  varyingProcessor(e, t) {
    return e.replace("varying", t ? "in" : "out");
  }
  postProcessor(e, t, i) {
    const s = e.search(/#extension.+GL_EXT_draw_buffers.+require/) !== -1, r = /#extension.+(GL_OVR_multiview2|GL_OES_standard_derivatives|GL_EXT_shader_texture_lod|GL_EXT_frag_depth|GL_EXT_draw_buffers).+(enable|require)/g;
    if (e = e.replace(r, ""), e = e.replace(/texture2D\s*\(/g, "texture("), i) {
      const n = e.search(/layout *\(location *= *0\) *out/g) !== -1;
      e = e.replace(/texture2DLodEXT\s*\(/g, "textureLod("), e = e.replace(/textureCubeLodEXT\s*\(/g, "textureLod("), e = e.replace(/textureCube\s*\(/g, "texture("), e = e.replace(/gl_FragDepthEXT/g, "gl_FragDepth"), e = e.replace(/gl_FragColor/g, "glFragColor"), e = e.replace(/gl_FragData/g, "glFragData"), e = e.replace(/void\s+?main\s*\(/g, (s || n ? "" : `layout(location = 0) out vec4 glFragColor;
`) + "void main(");
    } else if (t.indexOf("#define MULTIVIEW") !== -1)
      return `#extension GL_OVR_multiview2 : require
layout (num_views = 2) in;
` + e;
    return e;
  }
}
class Zs {
  /**
   * Gets the underlying buffer
   */
  get underlyingResource() {
    return null;
  }
  /**
   * Constructs the buffer
   */
  constructor() {
    this.references = 0, this.capacity = 0, this.is32Bits = !1, this.uniqueId = Zs._Counter++;
  }
}
Zs._Counter = 0;
class Ls extends Zs {
  constructor(e) {
    super(), this._buffer = e;
  }
  get underlyingResource() {
    return this._buffer;
  }
}
class _l {
  constructor() {
    this._valueCache = {}, this.vertexCompilationError = null, this.fragmentCompilationError = null, this.programLinkError = null, this.programValidationError = null, this._isDisposed = !1;
  }
  get isAsync() {
    return this.isParallelCompiled;
  }
  get isReady() {
    return this.program ? this.isParallelCompiled ? this.engine._isRenderingStateCompiled(this) : !0 : !1;
  }
  _handlesSpectorRebuildCallback(e) {
    e && this.program && e(this.program);
  }
  _fillEffectInformation(e, t, i, s, r, n, a, o) {
    const l = this.engine;
    if (l.supportsUniformBuffers)
      for (const d in t)
        e.bindUniformBlock(d, t[d]);
    this.engine.getUniforms(this, i).forEach((d, f) => {
      s[i[f]] = d;
    }), this._uniforms = s;
    let u;
    for (u = 0; u < r.length; u++)
      e.getUniform(r[u]) == null && (r.splice(u, 1), u--);
    r.forEach((d, f) => {
      n[d] = f;
    });
    for (const d of l.getAttributes(this, a))
      o.push(d);
  }
  /**
   * Release all associated resources.
   **/
  dispose() {
    this._uniforms = {}, this._isDisposed = !0;
  }
  /**
   * @internal
   */
  _cacheMatrix(e, t) {
    const i = this._valueCache[e], s = t.updateFlag;
    return i !== void 0 && i === s ? !1 : (this._valueCache[e] = s, !0);
  }
  /**
   * @internal
   */
  _cacheFloat2(e, t, i) {
    let s = this._valueCache[e];
    if (!s || s.length !== 2)
      return s = [t, i], this._valueCache[e] = s, !0;
    let r = !1;
    return s[0] !== t && (s[0] = t, r = !0), s[1] !== i && (s[1] = i, r = !0), r;
  }
  /**
   * @internal
   */
  _cacheFloat3(e, t, i, s) {
    let r = this._valueCache[e];
    if (!r || r.length !== 3)
      return r = [t, i, s], this._valueCache[e] = r, !0;
    let n = !1;
    return r[0] !== t && (r[0] = t, n = !0), r[1] !== i && (r[1] = i, n = !0), r[2] !== s && (r[2] = s, n = !0), n;
  }
  /**
   * @internal
   */
  _cacheFloat4(e, t, i, s, r) {
    let n = this._valueCache[e];
    if (!n || n.length !== 4)
      return n = [t, i, s, r], this._valueCache[e] = n, !0;
    let a = !1;
    return n[0] !== t && (n[0] = t, a = !0), n[1] !== i && (n[1] = i, a = !0), n[2] !== s && (n[2] = s, a = !0), n[3] !== r && (n[3] = r, a = !0), a;
  }
  /**
   * Sets an integer value on a uniform variable.
   * @param uniformName Name of the variable.
   * @param value Value to be set.
   */
  setInt(e, t) {
    const i = this._valueCache[e];
    i !== void 0 && i === t || this.engine.setInt(this._uniforms[e], t) && (this._valueCache[e] = t);
  }
  /**
   * Sets a int2 on a uniform variable.
   * @param uniformName Name of the variable.
   * @param x First int in int2.
   * @param y Second int in int2.
   */
  setInt2(e, t, i) {
    this._cacheFloat2(e, t, i) && (this.engine.setInt2(this._uniforms[e], t, i) || (this._valueCache[e] = null));
  }
  /**
   * Sets a int3 on a uniform variable.
   * @param uniformName Name of the variable.
   * @param x First int in int3.
   * @param y Second int in int3.
   * @param z Third int in int3.
   */
  setInt3(e, t, i, s) {
    this._cacheFloat3(e, t, i, s) && (this.engine.setInt3(this._uniforms[e], t, i, s) || (this._valueCache[e] = null));
  }
  /**
   * Sets a int4 on a uniform variable.
   * @param uniformName Name of the variable.
   * @param x First int in int4.
   * @param y Second int in int4.
   * @param z Third int in int4.
   * @param w Fourth int in int4.
   */
  setInt4(e, t, i, s, r) {
    this._cacheFloat4(e, t, i, s, r) && (this.engine.setInt4(this._uniforms[e], t, i, s, r) || (this._valueCache[e] = null));
  }
  /**
   * Sets an int array on a uniform variable.
   * @param uniformName Name of the variable.
   * @param array array to be set.
   */
  setIntArray(e, t) {
    this._valueCache[e] = null, this.engine.setIntArray(this._uniforms[e], t);
  }
  /**
   * Sets an int array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
   * @param uniformName Name of the variable.
   * @param array array to be set.
   */
  setIntArray2(e, t) {
    this._valueCache[e] = null, this.engine.setIntArray2(this._uniforms[e], t);
  }
  /**
   * Sets an int array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
   * @param uniformName Name of the variable.
   * @param array array to be set.
   */
  setIntArray3(e, t) {
    this._valueCache[e] = null, this.engine.setIntArray3(this._uniforms[e], t);
  }
  /**
   * Sets an int array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
   * @param uniformName Name of the variable.
   * @param array array to be set.
   */
  setIntArray4(e, t) {
    this._valueCache[e] = null, this.engine.setIntArray4(this._uniforms[e], t);
  }
  /**
   * Sets an unsigned integer value on a uniform variable.
   * @param uniformName Name of the variable.
   * @param value Value to be set.
   */
  setUInt(e, t) {
    const i = this._valueCache[e];
    i !== void 0 && i === t || this.engine.setUInt(this._uniforms[e], t) && (this._valueCache[e] = t);
  }
  /**
   * Sets an unsigned int2 value on a uniform variable.
   * @param uniformName Name of the variable.
   * @param x First unsigned int in uint2.
   * @param y Second unsigned int in uint2.
   */
  setUInt2(e, t, i) {
    this._cacheFloat2(e, t, i) && (this.engine.setUInt2(this._uniforms[e], t, i) || (this._valueCache[e] = null));
  }
  /**
   * Sets an unsigned int3 value on a uniform variable.
   * @param uniformName Name of the variable.
   * @param x First unsigned int in uint3.
   * @param y Second unsigned int in uint3.
   * @param z Third unsigned int in uint3.
   */
  setUInt3(e, t, i, s) {
    this._cacheFloat3(e, t, i, s) && (this.engine.setUInt3(this._uniforms[e], t, i, s) || (this._valueCache[e] = null));
  }
  /**
   * Sets an unsigned int4 value on a uniform variable.
   * @param uniformName Name of the variable.
   * @param x First unsigned int in uint4.
   * @param y Second unsigned int in uint4.
   * @param z Third unsigned int in uint4.
   * @param w Fourth unsigned int in uint4.
   */
  setUInt4(e, t, i, s, r) {
    this._cacheFloat4(e, t, i, s, r) && (this.engine.setUInt4(this._uniforms[e], t, i, s, r) || (this._valueCache[e] = null));
  }
  /**
   * Sets an unsigned int array on a uniform variable.
   * @param uniformName Name of the variable.
   * @param array array to be set.
   */
  setUIntArray(e, t) {
    this._valueCache[e] = null, this.engine.setUIntArray(this._uniforms[e], t);
  }
  /**
   * Sets an unsigned int array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
   * @param uniformName Name of the variable.
   * @param array array to be set.
   */
  setUIntArray2(e, t) {
    this._valueCache[e] = null, this.engine.setUIntArray2(this._uniforms[e], t);
  }
  /**
   * Sets an unsigned int array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
   * @param uniformName Name of the variable.
   * @param array array to be set.
   */
  setUIntArray3(e, t) {
    this._valueCache[e] = null, this.engine.setUIntArray3(this._uniforms[e], t);
  }
  /**
   * Sets an unsigned int array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
   * @param uniformName Name of the variable.
   * @param array array to be set.
   */
  setUIntArray4(e, t) {
    this._valueCache[e] = null, this.engine.setUIntArray4(this._uniforms[e], t);
  }
  /**
   * Sets an array on a uniform variable.
   * @param uniformName Name of the variable.
   * @param array array to be set.
   */
  setArray(e, t) {
    this._valueCache[e] = null, this.engine.setArray(this._uniforms[e], t);
  }
  /**
   * Sets an array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
   * @param uniformName Name of the variable.
   * @param array array to be set.
   */
  setArray2(e, t) {
    this._valueCache[e] = null, this.engine.setArray2(this._uniforms[e], t);
  }
  /**
   * Sets an array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
   * @param uniformName Name of the variable.
   * @param array array to be set.
   * @returns this effect.
   */
  setArray3(e, t) {
    this._valueCache[e] = null, this.engine.setArray3(this._uniforms[e], t);
  }
  /**
   * Sets an array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
   * @param uniformName Name of the variable.
   * @param array array to be set.
   */
  setArray4(e, t) {
    this._valueCache[e] = null, this.engine.setArray4(this._uniforms[e], t);
  }
  /**
   * Sets matrices on a uniform variable.
   * @param uniformName Name of the variable.
   * @param matrices matrices to be set.
   */
  setMatrices(e, t) {
    t && (this._valueCache[e] = null, this.engine.setMatrices(this._uniforms[e], t));
  }
  /**
   * Sets matrix on a uniform variable.
   * @param uniformName Name of the variable.
   * @param matrix matrix to be set.
   */
  setMatrix(e, t) {
    this._cacheMatrix(e, t) && (this.engine.setMatrices(this._uniforms[e], t.toArray()) || (this._valueCache[e] = null));
  }
  /**
   * Sets a 3x3 matrix on a uniform variable. (Specified as [1,2,3,4,5,6,7,8,9] will result in [1,2,3][4,5,6][7,8,9] matrix)
   * @param uniformName Name of the variable.
   * @param matrix matrix to be set.
   */
  setMatrix3x3(e, t) {
    this._valueCache[e] = null, this.engine.setMatrix3x3(this._uniforms[e], t);
  }
  /**
   * Sets a 2x2 matrix on a uniform variable. (Specified as [1,2,3,4] will result in [1,2][3,4] matrix)
   * @param uniformName Name of the variable.
   * @param matrix matrix to be set.
   */
  setMatrix2x2(e, t) {
    this._valueCache[e] = null, this.engine.setMatrix2x2(this._uniforms[e], t);
  }
  /**
   * Sets a float on a uniform variable.
   * @param uniformName Name of the variable.
   * @param value value to be set.
   * @returns this effect.
   */
  setFloat(e, t) {
    const i = this._valueCache[e];
    i !== void 0 && i === t || this.engine.setFloat(this._uniforms[e], t) && (this._valueCache[e] = t);
  }
  /**
   * Sets a Vector2 on a uniform variable.
   * @param uniformName Name of the variable.
   * @param vector2 vector2 to be set.
   */
  setVector2(e, t) {
    this._cacheFloat2(e, t.x, t.y) && (this.engine.setFloat2(this._uniforms[e], t.x, t.y) || (this._valueCache[e] = null));
  }
  /**
   * Sets a float2 on a uniform variable.
   * @param uniformName Name of the variable.
   * @param x First float in float2.
   * @param y Second float in float2.
   */
  setFloat2(e, t, i) {
    this._cacheFloat2(e, t, i) && (this.engine.setFloat2(this._uniforms[e], t, i) || (this._valueCache[e] = null));
  }
  /**
   * Sets a Vector3 on a uniform variable.
   * @param uniformName Name of the variable.
   * @param vector3 Value to be set.
   */
  setVector3(e, t) {
    this._cacheFloat3(e, t.x, t.y, t.z) && (this.engine.setFloat3(this._uniforms[e], t.x, t.y, t.z) || (this._valueCache[e] = null));
  }
  /**
   * Sets a float3 on a uniform variable.
   * @param uniformName Name of the variable.
   * @param x First float in float3.
   * @param y Second float in float3.
   * @param z Third float in float3.
   */
  setFloat3(e, t, i, s) {
    this._cacheFloat3(e, t, i, s) && (this.engine.setFloat3(this._uniforms[e], t, i, s) || (this._valueCache[e] = null));
  }
  /**
   * Sets a Vector4 on a uniform variable.
   * @param uniformName Name of the variable.
   * @param vector4 Value to be set.
   */
  setVector4(e, t) {
    this._cacheFloat4(e, t.x, t.y, t.z, t.w) && (this.engine.setFloat4(this._uniforms[e], t.x, t.y, t.z, t.w) || (this._valueCache[e] = null));
  }
  /**
   * Sets a Quaternion on a uniform variable.
   * @param uniformName Name of the variable.
   * @param quaternion Value to be set.
   */
  setQuaternion(e, t) {
    this._cacheFloat4(e, t.x, t.y, t.z, t.w) && (this.engine.setFloat4(this._uniforms[e], t.x, t.y, t.z, t.w) || (this._valueCache[e] = null));
  }
  /**
   * Sets a float4 on a uniform variable.
   * @param uniformName Name of the variable.
   * @param x First float in float4.
   * @param y Second float in float4.
   * @param z Third float in float4.
   * @param w Fourth float in float4.
   * @returns this effect.
   */
  setFloat4(e, t, i, s, r) {
    this._cacheFloat4(e, t, i, s, r) && (this.engine.setFloat4(this._uniforms[e], t, i, s, r) || (this._valueCache[e] = null));
  }
  /**
   * Sets a Color3 on a uniform variable.
   * @param uniformName Name of the variable.
   * @param color3 Value to be set.
   */
  setColor3(e, t) {
    this._cacheFloat3(e, t.r, t.g, t.b) && (this.engine.setFloat3(this._uniforms[e], t.r, t.g, t.b) || (this._valueCache[e] = null));
  }
  /**
   * Sets a Color4 on a uniform variable.
   * @param uniformName Name of the variable.
   * @param color3 Value to be set.
   * @param alpha Alpha value to be set.
   */
  setColor4(e, t, i) {
    this._cacheFloat4(e, t.r, t.g, t.b, i) && (this.engine.setFloat4(this._uniforms[e], t.r, t.g, t.b, i) || (this._valueCache[e] = null));
  }
  /**
   * Sets a Color4 on a uniform variable
   * @param uniformName defines the name of the variable
   * @param color4 defines the value to be set
   */
  setDirectColor4(e, t) {
    this._cacheFloat4(e, t.r, t.g, t.b, t.a) && (this.engine.setFloat4(this._uniforms[e], t.r, t.g, t.b, t.a) || (this._valueCache[e] = null));
  }
  _getVertexShaderCode() {
    return this.vertexShader ? this.engine._getShaderSource(this.vertexShader) : null;
  }
  _getFragmentShaderCode() {
    return this.fragmentShader ? this.engine._getShaderSource(this.fragmentShader) : null;
  }
}
class Fa {
  get underlyingResource() {
    return this._webGLTexture;
  }
  constructor(e = null, t) {
    if (this._MSAARenderBuffers = null, this._context = t, !e && (e = t.createTexture(), !e))
      throw new Error("Unable to create webGL texture");
    this.set(e);
  }
  setUsage() {
  }
  set(e) {
    this._webGLTexture = e;
  }
  reset() {
    this._webGLTexture = null, this._MSAARenderBuffers = null;
  }
  addMSAARenderBuffer(e) {
    this._MSAARenderBuffers || (this._MSAARenderBuffers = []), this._MSAARenderBuffers.push(e);
  }
  releaseMSAARenderBuffers() {
    if (this._MSAARenderBuffers) {
      for (const e of this._MSAARenderBuffers)
        this._context.deleteRenderbuffer(e);
      this._MSAARenderBuffers = null;
    }
  }
  release() {
    this.releaseMSAARenderBuffers(), this._webGLTexture && this._context.deleteTexture(this._webGLTexture), this.reset();
  }
}
class xi {
  static IsWrapper(e) {
    return e.getPipelineContext === void 0;
  }
  static GetEffect(e) {
    return e.getPipelineContext === void 0 ? e.effect : e;
  }
  constructor(e, t = !0) {
    this.effect = null, this.defines = null, this.drawContext = e.createDrawContext(), t && (this.materialContext = e.createMaterialContext());
  }
  setEffect(e, t, i = !0) {
    var s;
    this.effect = e, t !== void 0 && (this.defines = t), i && ((s = this.drawContext) === null || s === void 0 || s.reset());
  }
  dispose() {
    var e;
    (e = this.drawContext) === null || e === void 0 || e.dispose();
  }
}
class pl {
  get isDirty() {
    return this._isStencilTestDirty || this._isStencilMaskDirty || this._isStencilFuncDirty || this._isStencilOpDirty;
  }
  get func() {
    return this._func;
  }
  set func(e) {
    this._func !== e && (this._func = e, this._isStencilFuncDirty = !0);
  }
  get funcRef() {
    return this._funcRef;
  }
  set funcRef(e) {
    this._funcRef !== e && (this._funcRef = e, this._isStencilFuncDirty = !0);
  }
  get funcMask() {
    return this._funcMask;
  }
  set funcMask(e) {
    this._funcMask !== e && (this._funcMask = e, this._isStencilFuncDirty = !0);
  }
  get opStencilFail() {
    return this._opStencilFail;
  }
  set opStencilFail(e) {
    this._opStencilFail !== e && (this._opStencilFail = e, this._isStencilOpDirty = !0);
  }
  get opDepthFail() {
    return this._opDepthFail;
  }
  set opDepthFail(e) {
    this._opDepthFail !== e && (this._opDepthFail = e, this._isStencilOpDirty = !0);
  }
  get opStencilDepthPass() {
    return this._opStencilDepthPass;
  }
  set opStencilDepthPass(e) {
    this._opStencilDepthPass !== e && (this._opStencilDepthPass = e, this._isStencilOpDirty = !0);
  }
  get mask() {
    return this._mask;
  }
  set mask(e) {
    this._mask !== e && (this._mask = e, this._isStencilMaskDirty = !0);
  }
  get enabled() {
    return this._enabled;
  }
  set enabled(e) {
    this._enabled !== e && (this._enabled = e, this._isStencilTestDirty = !0);
  }
  constructor(e = !0) {
    this._isStencilTestDirty = !1, this._isStencilMaskDirty = !1, this._isStencilFuncDirty = !1, this._isStencilOpDirty = !1, this.useStencilGlobalOnly = !1, e && this.reset();
  }
  reset() {
    var e;
    this.stencilMaterial = void 0, (e = this.stencilGlobal) === null || e === void 0 || e.reset(), this._isStencilTestDirty = !0, this._isStencilMaskDirty = !0, this._isStencilFuncDirty = !0, this._isStencilOpDirty = !0;
  }
  apply(e) {
    var t;
    if (!e)
      return;
    const i = !this.useStencilGlobalOnly && !!(!((t = this.stencilMaterial) === null || t === void 0) && t.enabled);
    this.enabled = i ? this.stencilMaterial.enabled : this.stencilGlobal.enabled, this.func = i ? this.stencilMaterial.func : this.stencilGlobal.func, this.funcRef = i ? this.stencilMaterial.funcRef : this.stencilGlobal.funcRef, this.funcMask = i ? this.stencilMaterial.funcMask : this.stencilGlobal.funcMask, this.opStencilFail = i ? this.stencilMaterial.opStencilFail : this.stencilGlobal.opStencilFail, this.opDepthFail = i ? this.stencilMaterial.opDepthFail : this.stencilGlobal.opDepthFail, this.opStencilDepthPass = i ? this.stencilMaterial.opStencilDepthPass : this.stencilGlobal.opStencilDepthPass, this.mask = i ? this.stencilMaterial.mask : this.stencilGlobal.mask, this.isDirty && (this._isStencilTestDirty && (this.enabled ? e.enable(e.STENCIL_TEST) : e.disable(e.STENCIL_TEST), this._isStencilTestDirty = !1), this._isStencilMaskDirty && (e.stencilMask(this.mask), this._isStencilMaskDirty = !1), this._isStencilFuncDirty && (e.stencilFunc(this.func, this.funcRef, this.funcMask), this._isStencilFuncDirty = !1), this._isStencilOpDirty && (e.stencilOp(this.opStencilFail, this.opDepthFail, this.opStencilDepthPass), this._isStencilOpDirty = !1));
  }
}
class gl {
}
class Z {
  /**
   * Returns the current npm package of the sdk
   */
  // Not mixed with Version for tooling purpose.
  static get NpmPackage() {
    return "babylonjs@6.17.0";
  }
  /**
   * Returns the current version of the framework
   */
  static get Version() {
    return "6.17.0";
  }
  /**
   * Returns a string describing the current engine
   */
  get description() {
    let e = this.name + this.webGLVersion;
    return this._caps.parallelShaderCompile && (e += " - Parallel shader compilation"), e;
  }
  /**
   * Gets or sets the name of the engine
   */
  get name() {
    return this._name;
  }
  set name(e) {
    this._name = e;
  }
  /**
   * Returns the version of the engine
   */
  get version() {
    return this._webGLVersion;
  }
  get isDisposed() {
    return this._isDisposed;
  }
  /**
   * Gets or sets the relative url used to load shaders if using the engine in non-minified mode
   */
  static get ShadersRepository() {
    return yt.ShadersRepository;
  }
  static set ShadersRepository(e) {
    yt.ShadersRepository = e;
  }
  /**
   * @internal
   */
  _getShaderProcessor(e) {
    return this._shaderProcessor;
  }
  /**
   * Gets or sets a boolean indicating if depth buffer should be reverse, going from far to near.
   * This can provide greater z depth for distant objects.
   */
  get useReverseDepthBuffer() {
    return this._useReverseDepthBuffer;
  }
  set useReverseDepthBuffer(e) {
    e !== this._useReverseDepthBuffer && (this._useReverseDepthBuffer = e, e ? this._depthCullingState.depthFunc = 518 : this._depthCullingState.depthFunc = 515);
  }
  /**
   * Gets the current frame id
   */
  get frameId() {
    return this._frameId;
  }
  /**
   * Gets a boolean indicating that the engine supports uniform buffers
   * @see https://doc.babylonjs.com/setup/support/webGL2#uniform-buffer-objets
   */
  get supportsUniformBuffers() {
    return this.webGLVersion > 1 && !this.disableUniformBuffers;
  }
  /**
   * Gets the options used for engine creation
   * @returns EngineOptions object
   */
  getCreationOptions() {
    return this._creationOptions;
  }
  /** @internal */
  get _shouldUseHighPrecisionShader() {
    return !!(this._caps.highPrecisionShaderSupported && this._highPrecisionShadersAllowed);
  }
  /**
   * Gets a boolean indicating that only power of 2 textures are supported
   * Please note that you can still use non power of 2 textures but in this case the engine will forcefully convert them
   */
  get needPOTTextures() {
    return this._webGLVersion < 2 || this.forcePOTTextures;
  }
  /**
   * Gets the list of current active render loop functions
   * @returns an array with the current render loop functions
   */
  get activeRenderLoops() {
    return this._activeRenderLoops;
  }
  /**
   * Gets or sets a boolean indicating if resources should be retained to be able to handle context lost events
   * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimize_your_scene#handling-webgl-context-lost
   */
  get doNotHandleContextLost() {
    return this._doNotHandleContextLost;
  }
  set doNotHandleContextLost(e) {
    this._doNotHandleContextLost = e;
  }
  get _supportsHardwareTextureRescaling() {
    return !1;
  }
  /**
   * sets the object from which width and height will be taken from when getting render width and height
   * Will fallback to the gl object
   * @param dimensions the framebuffer width and height that will be used.
   */
  set framebufferDimensionsObject(e) {
    this._framebufferDimensionsObject = e;
  }
  /**
   * Gets the current viewport
   */
  get currentViewport() {
    return this._cachedViewport;
  }
  /**
   * Gets the default empty texture
   */
  get emptyTexture() {
    return this._emptyTexture || (this._emptyTexture = this.createRawTexture(new Uint8Array(4), 1, 1, 5, !1, !1, 1)), this._emptyTexture;
  }
  /**
   * Gets the default empty 3D texture
   */
  get emptyTexture3D() {
    return this._emptyTexture3D || (this._emptyTexture3D = this.createRawTexture3D(new Uint8Array(4), 1, 1, 1, 5, !1, !1, 1)), this._emptyTexture3D;
  }
  /**
   * Gets the default empty 2D array texture
   */
  get emptyTexture2DArray() {
    return this._emptyTexture2DArray || (this._emptyTexture2DArray = this.createRawTexture2DArray(new Uint8Array(4), 1, 1, 1, 5, !1, !1, 1)), this._emptyTexture2DArray;
  }
  /**
   * Gets the default empty cube texture
   */
  get emptyCubeTexture() {
    if (!this._emptyCubeTexture) {
      const e = new Uint8Array(4), t = [e, e, e, e, e, e];
      this._emptyCubeTexture = this.createRawCubeTexture(t, 1, 5, 0, !1, !1, 1);
    }
    return this._emptyCubeTexture;
  }
  /**
   * Gets a boolean indicating if the engine runs in WebGPU or not.
   */
  get isWebGPU() {
    return this._isWebGPU;
  }
  /**
   * Gets the shader platform name used by the effects.
   */
  get shaderPlatformName() {
    return this._shaderPlatformName;
  }
  /**
   * Enables or disables the snapshot rendering mode
   * Note that the WebGL engine does not support snapshot rendering so setting the value won't have any effect for this engine
   */
  get snapshotRendering() {
    return !1;
  }
  set snapshotRendering(e) {
  }
  /**
   * Gets or sets the snapshot rendering mode
   */
  get snapshotRenderingMode() {
    return this._snapshotRenderingMode;
  }
  set snapshotRenderingMode(e) {
    this._snapshotRenderingMode = e;
  }
  /**
   * Creates a new snapshot at the next frame using the current snapshotRenderingMode
   */
  snapshotRenderingReset() {
    this.snapshotRendering = !1;
  }
  static _CreateCanvas(e, t) {
    if (typeof document > "u")
      return new OffscreenCanvas(e, t);
    const i = document.createElement("canvas");
    return i.width = e, i.height = t, i;
  }
  /**
   * Create a canvas. This method is overridden by other engines
   * @param width width
   * @param height height
   * @returns ICanvas interface
   */
  createCanvas(e, t) {
    return Z._CreateCanvas(e, t);
  }
  /**
   * Create an image to use with canvas
   * @returns IImage interface
   */
  createCanvasImage() {
    return document.createElement("img");
  }
  /**
   * Creates a new engine
   * @param canvasOrContext defines the canvas or WebGL context to use for rendering. If you provide a WebGL context, Babylon.js will not hook events on the canvas (like pointers, keyboards, etc...) so no event observables will be available. This is mostly used when Babylon.js is used as a plugin on a system which already used the WebGL context
   * @param antialias defines enable antialiasing (default: false)
   * @param options defines further options to be sent to the getContext() function
   * @param adaptToDeviceRatio defines whether to adapt to the device's viewport characteristics (default: false)
   */
  constructor(e, t, i, s) {
    var r, n, a, o, l, c, u, d, f, _, g;
    this._name = "WebGL", this._isDisposed = !1, this.forcePOTTextures = !1, this.isFullscreen = !1, this.cullBackFaces = null, this.renderEvenInBackground = !0, this.preventCacheWipeBetweenFrames = !1, this.validateShaderPrograms = !1, this._useReverseDepthBuffer = !1, this.isNDCHalfZRange = !1, this.hasOriginBottomLeft = !0, this.disableUniformBuffers = !1, this.onDisposeObservable = new N(), this._frameId = 0, this._uniformBuffers = new Array(), this._storageBuffers = new Array(), this._webGLVersion = 1, this._windowIsBackground = !1, this._highPrecisionShadersAllowed = !0, this._badOS = !1, this._badDesktopOS = !1, this._renderingQueueLaunched = !1, this._activeRenderLoops = new Array(), this.onContextLostObservable = new N(), this.onContextRestoredObservable = new N(), this._contextWasLost = !1, this._doNotHandleContextLost = !1, this.disableVertexArrayObjects = !1, this._colorWrite = !0, this._colorWriteChanged = !0, this._depthCullingState = new ll(), this._stencilStateComposer = new pl(), this._stencilState = new vi(), this._alphaState = new hl(), this._alphaMode = 1, this._alphaEquation = 0, this._internalTexturesCache = new Array(), this._renderTargetWrapperCache = new Array(), this._activeChannel = 0, this._currentTextureChannel = -1, this._boundTexturesCache = {}, this._compiledEffects = {}, this._vertexAttribArraysEnabled = [], this._uintIndicesCurrentlySet = !1, this._currentBoundBuffer = new Array(), this._currentFramebuffer = null, this._dummyFramebuffer = null, this._currentBufferPointers = new Array(), this._currentInstanceLocations = new Array(), this._currentInstanceBuffers = new Array(), this._vaoRecordInProgress = !1, this._mustWipeVertexAttributes = !1, this._nextFreeTextureSlots = new Array(), this._maxSimultaneousTextures = 0, this._maxMSAASamplesOverride = null, this._activeRequests = new Array(), this.adaptToDeviceRatio = !1, this._lastDevicePixelRatio = 1, this._transformTextureUrl = null, this.hostInformation = {
      isMobile: !1
    }, this.premultipliedAlpha = !0, this.onBeforeTextureInitObservable = new N(), this._isWebGPU = !1, this._snapshotRenderingMode = 0, this._viewportCached = { x: 0, y: 0, z: 0, w: 0 }, this._unpackFlipYCached = null, this.enableUnpackFlipYCached = !0, this._boundUniforms = {}, this.startTime = Kt.Now;
    let m = null;
    i = i || {}, this._creationOptions = i, this.adaptToDeviceRatio = s ?? !1, this._stencilStateComposer.stencilGlobal = this._stencilState, ht.SetMatrixPrecision(!!i.useHighPrecisionMatrix), i.antialias = t ?? i.antialias, i.deterministicLockstep = (r = i.deterministicLockstep) !== null && r !== void 0 ? r : !1, i.lockstepMaxSteps = (n = i.lockstepMaxSteps) !== null && n !== void 0 ? n : 4, i.timeStep = (a = i.timeStep) !== null && a !== void 0 ? a : 1 / 60, i.audioEngine = (o = i.audioEngine) !== null && o !== void 0 ? o : !0, i.stencil = (l = i.stencil) !== null && l !== void 0 ? l : !0, this._audioContext = (u = (c = i.audioEngineOptions) === null || c === void 0 ? void 0 : c.audioContext) !== null && u !== void 0 ? u : null, this._audioDestination = (f = (d = i.audioEngineOptions) === null || d === void 0 ? void 0 : d.audioDestination) !== null && f !== void 0 ? f : null, this.premultipliedAlpha = (_ = i.premultipliedAlpha) !== null && _ !== void 0 ? _ : !0, this.useExactSrgbConversions = (g = i.useExactSrgbConversions) !== null && g !== void 0 ? g : !1, this._doNotHandleContextLost = !!i.doNotHandleContextLost, this._isStencilEnable = !!i.stencil, s = s || i.adaptToDeviceRatio || !1;
    const y = _t() && window.devicePixelRatio || 1, x = i.limitDeviceRatio || y;
    if (this._hardwareScalingLevel = s ? 1 / Math.min(x, y) : 1, this._lastDevicePixelRatio = y, !e)
      return;
    if (e.getContext) {
      if (m = e, this._renderingCanvas = m, i.preserveDrawingBuffer === void 0 && (i.preserveDrawingBuffer = !1), i.xrCompatible === void 0 && (i.xrCompatible = !0), navigator && navigator.userAgent) {
        this._setupMobileChecks();
        const T = navigator.userAgent;
        for (const M of Z.ExceptionList) {
          const b = M.key, S = M.targets;
          if (new RegExp(b).test(T)) {
            if (M.capture && M.captureConstraint) {
              const D = M.capture, O = M.captureConstraint, k = new RegExp(D).exec(T);
              if (k && k.length > 0 && parseInt(k[k.length - 1]) >= O)
                continue;
            }
            for (const D of S)
              switch (D) {
                case "uniformBuffer":
                  this.disableUniformBuffers = !0;
                  break;
                case "vao":
                  this.disableVertexArrayObjects = !0;
                  break;
                case "antialias":
                  i.antialias = !1;
                  break;
                case "maxMSAASamples":
                  this._maxMSAASamplesOverride = 1;
                  break;
              }
          }
        }
      }
      if (this._doNotHandleContextLost || (this._onContextLost = (T) => {
        T.preventDefault(), this._contextWasLost = !0, w.Warn("WebGL context lost."), this.onContextLostObservable.notifyObservers(this);
      }, this._onContextRestored = () => {
        this._restoreEngineAfterContextLost(this._initGLContext.bind(this));
      }, m.addEventListener("webglcontextlost", this._onContextLost, !1), m.addEventListener("webglcontextrestored", this._onContextRestored, !1), i.powerPreference = i.powerPreference || "high-performance"), this._badDesktopOS = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), this._badDesktopOS && (i.xrCompatible = !1), !i.disableWebGL2Support)
        try {
          this._gl = m.getContext("webgl2", i) || m.getContext("experimental-webgl2", i), this._gl && (this._webGLVersion = 2, this._shaderPlatformName = "WEBGL2", this._gl.deleteQuery || (this._webGLVersion = 1, this._shaderPlatformName = "WEBGL1"));
        } catch {
        }
      if (!this._gl) {
        if (!m)
          throw new Error("The provided canvas is null or undefined.");
        try {
          this._gl = m.getContext("webgl", i) || m.getContext("experimental-webgl", i);
        } catch {
          throw new Error("WebGL not supported");
        }
      }
      if (!this._gl)
        throw new Error("WebGL not supported");
    } else {
      this._gl = e, this._renderingCanvas = this._gl.canvas, this._gl.renderbufferStorageMultisample ? (this._webGLVersion = 2, this._shaderPlatformName = "WEBGL2") : this._shaderPlatformName = "WEBGL1";
      const T = this._gl.getContextAttributes();
      T && (i.stencil = T.stencil);
    }
    this._gl.pixelStorei(this._gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, this._gl.NONE), i.useHighPrecisionFloats !== void 0 && (this._highPrecisionShadersAllowed = i.useHighPrecisionFloats), this.resize(), this._initGLContext(), this._initFeatures();
    for (let T = 0; T < this._caps.maxVertexAttribs; T++)
      this._currentBufferPointers[T] = new gl();
    this._shaderProcessor = this.webGLVersion > 1 ? new fl() : new ul(), this._badOS = /iPad/i.test(navigator.userAgent) || /iPhone/i.test(navigator.userAgent);
    const A = `Babylon.js v${Z.Version}`;
    console.log(A + ` - ${this.description}`), this._renderingCanvas && this._renderingCanvas.setAttribute && this._renderingCanvas.setAttribute("data-engine", A);
  }
  _setupMobileChecks() {
    navigator && navigator.userAgent && (this._checkForMobile = () => {
      const e = navigator.userAgent;
      this.hostInformation.isMobile = e.indexOf("Mobile") !== -1 || // Needed for iOS 13+ detection on iPad (inspired by solution from https://stackoverflow.com/questions/9038625/detect-if-device-is-ios)
      e.indexOf("Mac") !== -1 && Rs() && "ontouchend" in document;
    }, this._checkForMobile(), _t() && window.addEventListener("resize", this._checkForMobile));
  }
  _restoreEngineAfterContextLost(e) {
    setTimeout(async () => {
      var t;
      this._dummyFramebuffer = null;
      const i = this._depthCullingState.depthTest, s = this._depthCullingState.depthFunc, r = this._depthCullingState.depthMask, n = this._stencilState.stencilTest;
      await e(), this.wipeCaches(!0), this._rebuildEffects(), (t = this._rebuildComputeEffects) === null || t === void 0 || t.call(this), this._rebuildBuffers(), this._rebuildInternalTextures(), this._rebuildRenderTargetWrappers(), this.wipeCaches(!0), this._depthCullingState.depthTest = i, this._depthCullingState.depthFunc = s, this._depthCullingState.depthMask = r, this._stencilState.stencilTest = n, w.Warn(this.name + " context successfully restored."), this.onContextRestoredObservable.notifyObservers(this), this._contextWasLost = !1;
    }, 0);
  }
  /**
   * Shared initialization across engines types.
   * @param canvas The canvas associated with this instance of the engine.
   */
  _sharedInit(e) {
    this._renderingCanvas = e;
  }
  /**
   * @internal
   */
  _getShaderProcessingContext(e) {
    return null;
  }
  _rebuildInternalTextures() {
    const e = this._internalTexturesCache.slice();
    for (const t of e)
      t._rebuild();
  }
  _rebuildRenderTargetWrappers() {
    const e = this._renderTargetWrapperCache.slice();
    for (const t of e)
      t._rebuild();
  }
  _rebuildEffects() {
    for (const e in this._compiledEffects) {
      const t = this._compiledEffects[e];
      t._pipelineContext = null, t._wasPreviouslyReady = !1, t._prepareEffect();
    }
    yt.ResetCache();
  }
  /**
   * Gets a boolean indicating if all created effects are ready
   * @returns true if all effects are ready
   */
  areAllEffectsReady() {
    for (const e in this._compiledEffects)
      if (!this._compiledEffects[e].isReady())
        return !1;
    return !0;
  }
  _rebuildBuffers() {
    for (const e of this._uniformBuffers)
      e._rebuild();
    for (const e of this._storageBuffers)
      e._rebuild();
  }
  _initGLContext() {
    var e;
    this._caps = {
      maxTexturesImageUnits: this._gl.getParameter(this._gl.MAX_TEXTURE_IMAGE_UNITS),
      maxCombinedTexturesImageUnits: this._gl.getParameter(this._gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS),
      maxVertexTextureImageUnits: this._gl.getParameter(this._gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS),
      maxTextureSize: this._gl.getParameter(this._gl.MAX_TEXTURE_SIZE),
      maxSamples: this._webGLVersion > 1 ? this._gl.getParameter(this._gl.MAX_SAMPLES) : 1,
      maxCubemapTextureSize: this._gl.getParameter(this._gl.MAX_CUBE_MAP_TEXTURE_SIZE),
      maxRenderTextureSize: this._gl.getParameter(this._gl.MAX_RENDERBUFFER_SIZE),
      maxVertexAttribs: this._gl.getParameter(this._gl.MAX_VERTEX_ATTRIBS),
      maxVaryingVectors: this._gl.getParameter(this._gl.MAX_VARYING_VECTORS),
      maxFragmentUniformVectors: this._gl.getParameter(this._gl.MAX_FRAGMENT_UNIFORM_VECTORS),
      maxVertexUniformVectors: this._gl.getParameter(this._gl.MAX_VERTEX_UNIFORM_VECTORS),
      parallelShaderCompile: this._gl.getExtension("KHR_parallel_shader_compile") || void 0,
      standardDerivatives: this._webGLVersion > 1 || this._gl.getExtension("OES_standard_derivatives") !== null,
      maxAnisotropy: 1,
      astc: this._gl.getExtension("WEBGL_compressed_texture_astc") || this._gl.getExtension("WEBKIT_WEBGL_compressed_texture_astc"),
      bptc: this._gl.getExtension("EXT_texture_compression_bptc") || this._gl.getExtension("WEBKIT_EXT_texture_compression_bptc"),
      s3tc: this._gl.getExtension("WEBGL_compressed_texture_s3tc") || this._gl.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc"),
      // eslint-disable-next-line @typescript-eslint/naming-convention
      s3tc_srgb: this._gl.getExtension("WEBGL_compressed_texture_s3tc_srgb") || this._gl.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc_srgb"),
      pvrtc: this._gl.getExtension("WEBGL_compressed_texture_pvrtc") || this._gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc"),
      etc1: this._gl.getExtension("WEBGL_compressed_texture_etc1") || this._gl.getExtension("WEBKIT_WEBGL_compressed_texture_etc1"),
      etc2: this._gl.getExtension("WEBGL_compressed_texture_etc") || this._gl.getExtension("WEBKIT_WEBGL_compressed_texture_etc") || this._gl.getExtension("WEBGL_compressed_texture_es3_0"),
      textureAnisotropicFilterExtension: this._gl.getExtension("EXT_texture_filter_anisotropic") || this._gl.getExtension("WEBKIT_EXT_texture_filter_anisotropic") || this._gl.getExtension("MOZ_EXT_texture_filter_anisotropic"),
      uintIndices: this._webGLVersion > 1 || this._gl.getExtension("OES_element_index_uint") !== null,
      fragmentDepthSupported: this._webGLVersion > 1 || this._gl.getExtension("EXT_frag_depth") !== null,
      highPrecisionShaderSupported: !1,
      timerQuery: this._gl.getExtension("EXT_disjoint_timer_query_webgl2") || this._gl.getExtension("EXT_disjoint_timer_query"),
      supportOcclusionQuery: this._webGLVersion > 1,
      canUseTimestampForTimerQuery: !1,
      drawBuffersExtension: !1,
      maxMSAASamples: 1,
      colorBufferFloat: !!(this._webGLVersion > 1 && this._gl.getExtension("EXT_color_buffer_float")),
      colorBufferHalfFloat: !!(this._webGLVersion > 1 && this._gl.getExtension("EXT_color_buffer_half_float")),
      textureFloat: !!(this._webGLVersion > 1 || this._gl.getExtension("OES_texture_float")),
      textureHalfFloat: !!(this._webGLVersion > 1 || this._gl.getExtension("OES_texture_half_float")),
      textureHalfFloatRender: !1,
      textureFloatLinearFiltering: !1,
      textureFloatRender: !1,
      textureHalfFloatLinearFiltering: !1,
      vertexArrayObject: !1,
      instancedArrays: !1,
      textureLOD: !!(this._webGLVersion > 1 || this._gl.getExtension("EXT_shader_texture_lod")),
      texelFetch: this._webGLVersion !== 1,
      blendMinMax: !1,
      multiview: this._gl.getExtension("OVR_multiview2"),
      oculusMultiview: this._gl.getExtension("OCULUS_multiview"),
      depthTextureExtension: !1,
      canUseGLInstanceID: this._webGLVersion > 1,
      canUseGLVertexID: this._webGLVersion > 1,
      supportComputeShaders: !1,
      supportSRGBBuffers: !1,
      supportTransformFeedbacks: this._webGLVersion > 1,
      textureMaxLevel: this._webGLVersion > 1,
      texture2DArrayMaxLayerCount: this._webGLVersion > 1 ? this._gl.getParameter(this._gl.MAX_ARRAY_TEXTURE_LAYERS) : 128,
      disableMorphTargetTexture: !1
    }, this._glVersion = this._gl.getParameter(this._gl.VERSION);
    const t = this._gl.getExtension("WEBGL_debug_renderer_info");
    if (t != null && (this._glRenderer = this._gl.getParameter(t.UNMASKED_RENDERER_WEBGL), this._glVendor = this._gl.getParameter(t.UNMASKED_VENDOR_WEBGL)), this._glVendor || (this._glVendor = this._gl.getParameter(this._gl.VENDOR) || "Unknown vendor"), this._glRenderer || (this._glRenderer = this._gl.getParameter(this._gl.RENDERER) || "Unknown renderer"), this._gl.HALF_FLOAT_OES !== 36193 && (this._gl.HALF_FLOAT_OES = 36193), this._gl.RGBA16F !== 34842 && (this._gl.RGBA16F = 34842), this._gl.RGBA32F !== 34836 && (this._gl.RGBA32F = 34836), this._gl.DEPTH24_STENCIL8 !== 35056 && (this._gl.DEPTH24_STENCIL8 = 35056), this._caps.timerQuery && (this._webGLVersion === 1 && (this._gl.getQuery = this._caps.timerQuery.getQueryEXT.bind(this._caps.timerQuery)), this._caps.canUseTimestampForTimerQuery = ((e = this._gl.getQuery(this._caps.timerQuery.TIMESTAMP_EXT, this._caps.timerQuery.QUERY_COUNTER_BITS_EXT)) !== null && e !== void 0 ? e : 0) > 0), this._caps.maxAnisotropy = this._caps.textureAnisotropicFilterExtension ? this._gl.getParameter(this._caps.textureAnisotropicFilterExtension.MAX_TEXTURE_MAX_ANISOTROPY_EXT) : 0, this._caps.textureFloatLinearFiltering = !!(this._caps.textureFloat && this._gl.getExtension("OES_texture_float_linear")), this._caps.textureFloatRender = !!(this._caps.textureFloat && this._canRenderToFloatFramebuffer()), this._caps.textureHalfFloatLinearFiltering = !!(this._webGLVersion > 1 || this._caps.textureHalfFloat && this._gl.getExtension("OES_texture_half_float_linear")), this._caps.astc && (this._gl.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR = this._caps.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR), this._caps.bptc && (this._gl.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT = this._caps.bptc.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT), this._caps.s3tc_srgb && (this._gl.COMPRESSED_SRGB_S3TC_DXT1_EXT = this._caps.s3tc_srgb.COMPRESSED_SRGB_S3TC_DXT1_EXT, this._gl.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT = this._caps.s3tc_srgb.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT, this._gl.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT = this._caps.s3tc_srgb.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT), this._caps.etc2 && (this._gl.COMPRESSED_SRGB8_ETC2 = this._caps.etc2.COMPRESSED_SRGB8_ETC2, this._gl.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC = this._caps.etc2.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC), this._webGLVersion > 1 && this._gl.HALF_FLOAT_OES !== 5131 && (this._gl.HALF_FLOAT_OES = 5131), this._caps.textureHalfFloatRender = this._caps.textureHalfFloat && this._canRenderToHalfFloatFramebuffer(), this._webGLVersion > 1)
      this._caps.drawBuffersExtension = !0, this._caps.maxMSAASamples = this._maxMSAASamplesOverride !== null ? this._maxMSAASamplesOverride : this._gl.getParameter(this._gl.MAX_SAMPLES);
    else {
      const i = this._gl.getExtension("WEBGL_draw_buffers");
      if (i !== null) {
        this._caps.drawBuffersExtension = !0, this._gl.drawBuffers = i.drawBuffersWEBGL.bind(i), this._gl.DRAW_FRAMEBUFFER = this._gl.FRAMEBUFFER;
        for (let s = 0; s < 16; s++)
          this._gl["COLOR_ATTACHMENT" + s + "_WEBGL"] = i["COLOR_ATTACHMENT" + s + "_WEBGL"];
      }
    }
    if (this._webGLVersion > 1)
      this._caps.depthTextureExtension = !0;
    else {
      const i = this._gl.getExtension("WEBGL_depth_texture");
      i != null && (this._caps.depthTextureExtension = !0, this._gl.UNSIGNED_INT_24_8 = i.UNSIGNED_INT_24_8_WEBGL);
    }
    if (this.disableVertexArrayObjects)
      this._caps.vertexArrayObject = !1;
    else if (this._webGLVersion > 1)
      this._caps.vertexArrayObject = !0;
    else {
      const i = this._gl.getExtension("OES_vertex_array_object");
      i != null && (this._caps.vertexArrayObject = !0, this._gl.createVertexArray = i.createVertexArrayOES.bind(i), this._gl.bindVertexArray = i.bindVertexArrayOES.bind(i), this._gl.deleteVertexArray = i.deleteVertexArrayOES.bind(i));
    }
    if (this._webGLVersion > 1)
      this._caps.instancedArrays = !0;
    else {
      const i = this._gl.getExtension("ANGLE_instanced_arrays");
      i != null ? (this._caps.instancedArrays = !0, this._gl.drawArraysInstanced = i.drawArraysInstancedANGLE.bind(i), this._gl.drawElementsInstanced = i.drawElementsInstancedANGLE.bind(i), this._gl.vertexAttribDivisor = i.vertexAttribDivisorANGLE.bind(i)) : this._caps.instancedArrays = !1;
    }
    if (this._gl.getShaderPrecisionFormat) {
      const i = this._gl.getShaderPrecisionFormat(this._gl.VERTEX_SHADER, this._gl.HIGH_FLOAT), s = this._gl.getShaderPrecisionFormat(this._gl.FRAGMENT_SHADER, this._gl.HIGH_FLOAT);
      i && s && (this._caps.highPrecisionShaderSupported = i.precision !== 0 && s.precision !== 0);
    }
    if (this._webGLVersion > 1)
      this._caps.blendMinMax = !0;
    else {
      const i = this._gl.getExtension("EXT_blend_minmax");
      i != null && (this._caps.blendMinMax = !0, this._gl.MAX = i.MAX_EXT, this._gl.MIN = i.MIN_EXT);
    }
    if (!this._caps.supportSRGBBuffers) {
      if (this._webGLVersion > 1)
        this._caps.supportSRGBBuffers = !0, this._glSRGBExtensionValues = {
          SRGB: WebGL2RenderingContext.SRGB,
          SRGB8: WebGL2RenderingContext.SRGB8,
          SRGB8_ALPHA8: WebGL2RenderingContext.SRGB8_ALPHA8
        };
      else {
        const i = this._gl.getExtension("EXT_sRGB");
        i != null && (this._caps.supportSRGBBuffers = !0, this._glSRGBExtensionValues = {
          SRGB: i.SRGB_EXT,
          SRGB8: i.SRGB_ALPHA_EXT,
          SRGB8_ALPHA8: i.SRGB_ALPHA_EXT
        });
      }
      this._caps.supportSRGBBuffers = this._caps.supportSRGBBuffers && !!(this._creationOptions && this._creationOptions.forceSRGBBufferSupportState);
    }
    this._depthCullingState.depthTest = !0, this._depthCullingState.depthFunc = this._gl.LEQUAL, this._depthCullingState.depthMask = !0, this._maxSimultaneousTextures = this._caps.maxCombinedTexturesImageUnits;
    for (let i = 0; i < this._maxSimultaneousTextures; i++)
      this._nextFreeTextureSlots.push(i);
    this._glRenderer === "Mali-G72" && (this._caps.disableMorphTargetTexture = !0);
  }
  _initFeatures() {
    this._features = {
      forceBitmapOverHTMLImageElement: !1,
      supportRenderAndCopyToLodForFloatTextures: this._webGLVersion !== 1,
      supportDepthStencilTexture: this._webGLVersion !== 1,
      supportShadowSamplers: this._webGLVersion !== 1,
      uniformBufferHardCheckMatrix: !1,
      allowTexturePrefiltering: this._webGLVersion !== 1,
      trackUbosInFrame: !1,
      checkUbosContentBeforeUpload: !1,
      supportCSM: this._webGLVersion !== 1,
      basisNeedsPOT: this._webGLVersion === 1,
      support3DTextures: this._webGLVersion !== 1,
      needTypeSuffixInShaderConstants: this._webGLVersion !== 1,
      supportMSAA: this._webGLVersion !== 1,
      supportSSAO2: this._webGLVersion !== 1,
      supportExtendedTextureFormats: this._webGLVersion !== 1,
      supportSwitchCaseInShader: this._webGLVersion !== 1,
      supportSyncTextureRead: !0,
      needsInvertingBitmap: !0,
      useUBOBindingCache: !0,
      needShaderCodeInlining: !1,
      needToAlwaysBindUniformBuffers: !1,
      supportRenderPasses: !1,
      supportSpriteInstancing: !0,
      _collectUbosUpdatedInFrame: !1
    };
  }
  /**
   * Gets version of the current webGL context
   * Keep it for back compat - use version instead
   */
  get webGLVersion() {
    return this._webGLVersion;
  }
  /**
   * Gets a string identifying the name of the class
   * @returns "Engine" string
   */
  getClassName() {
    return "ThinEngine";
  }
  /**
   * Returns true if the stencil buffer has been enabled through the creation option of the context.
   */
  get isStencilEnable() {
    return this._isStencilEnable;
  }
  /** @internal */
  _prepareWorkingCanvas() {
    if (this._workingCanvas)
      return;
    this._workingCanvas = this.createCanvas(1, 1);
    const e = this._workingCanvas.getContext("2d");
    e && (this._workingContext = e);
  }
  /**
   * Reset the texture cache to empty state
   */
  resetTextureCache() {
    for (const e in this._boundTexturesCache)
      Object.prototype.hasOwnProperty.call(this._boundTexturesCache, e) && (this._boundTexturesCache[e] = null);
    this._currentTextureChannel = -1;
  }
  /**
   * Gets an object containing information about the current engine context
   * @returns an object containing the vendor, the renderer and the version of the current engine context
   */
  getInfo() {
    return this.getGlInfo();
  }
  /**
   * Gets an object containing information about the current webGL context
   * @returns an object containing the vendor, the renderer and the version of the current webGL context
   */
  getGlInfo() {
    return {
      vendor: this._glVendor,
      renderer: this._glRenderer,
      version: this._glVersion
    };
  }
  /**
   * Defines the hardware scaling level.
   * By default the hardware scaling level is computed from the window device ratio.
   * if level = 1 then the engine will render at the exact resolution of the canvas. If level = 0.5 then the engine will render at twice the size of the canvas.
   * @param level defines the level to use
   */
  setHardwareScalingLevel(e) {
    this._hardwareScalingLevel = e, this.resize();
  }
  /**
   * Gets the current hardware scaling level.
   * By default the hardware scaling level is computed from the window device ratio.
   * if level = 1 then the engine will render at the exact resolution of the canvas. If level = 0.5 then the engine will render at twice the size of the canvas.
   * @returns a number indicating the current hardware scaling level
   */
  getHardwareScalingLevel() {
    return this._hardwareScalingLevel;
  }
  /**
   * Gets the list of loaded textures
   * @returns an array containing all loaded textures
   */
  getLoadedTexturesCache() {
    return this._internalTexturesCache;
  }
  /**
   * Gets the object containing all engine capabilities
   * @returns the EngineCapabilities object
   */
  getCaps() {
    return this._caps;
  }
  /**
   * stop executing a render loop function and remove it from the execution array
   * @param renderFunction defines the function to be removed. If not provided all functions will be removed.
   */
  stopRenderLoop(e) {
    if (!e) {
      this._activeRenderLoops.length = 0, this._cancelFrame();
      return;
    }
    const t = this._activeRenderLoops.indexOf(e);
    t >= 0 && (this._activeRenderLoops.splice(t, 1), this._activeRenderLoops.length == 0 && this._cancelFrame());
  }
  _cancelFrame() {
    if (this._renderingQueueLaunched && this._frameHandler) {
      if (this._renderingQueueLaunched = !1, _t()) {
        const { cancelAnimationFrame: e } = this.getHostWindow() || window;
        if (typeof e == "function")
          return e(this._frameHandler);
      } else if (typeof cancelAnimationFrame == "function")
        return cancelAnimationFrame(this._frameHandler);
      return clearTimeout(this._frameHandler);
    }
  }
  /** @internal */
  _renderLoop() {
    if (!this._contextWasLost) {
      let e = !0;
      if ((this._isDisposed || !this.renderEvenInBackground && this._windowIsBackground) && (e = !1), e) {
        this.beginFrame();
        for (let t = 0; t < this._activeRenderLoops.length; t++) {
          const i = this._activeRenderLoops[t];
          i();
        }
        this.endFrame();
      }
    }
    this._activeRenderLoops.length > 0 ? this._frameHandler = this._queueNewFrame(this._boundRenderFunction, this.getHostWindow()) : this._renderingQueueLaunched = !1;
  }
  /**
   * Gets the HTML canvas attached with the current webGL context
   * @returns a HTML canvas
   */
  getRenderingCanvas() {
    return this._renderingCanvas;
  }
  /**
   * Gets the audio context specified in engine initialization options
   * @returns an Audio Context
   */
  getAudioContext() {
    return this._audioContext;
  }
  /**
   * Gets the audio destination specified in engine initialization options
   * @returns an audio destination node
   */
  getAudioDestination() {
    return this._audioDestination;
  }
  /**
   * Gets host window
   * @returns the host window object
   */
  getHostWindow() {
    return _t() ? this._renderingCanvas && this._renderingCanvas.ownerDocument && this._renderingCanvas.ownerDocument.defaultView ? this._renderingCanvas.ownerDocument.defaultView : window : null;
  }
  /**
   * Gets the current render width
   * @param useScreen defines if screen size must be used (or the current render target if any)
   * @returns a number defining the current render width
   */
  getRenderWidth(e = !1) {
    return !e && this._currentRenderTarget ? this._currentRenderTarget.width : this._framebufferDimensionsObject ? this._framebufferDimensionsObject.framebufferWidth : this._gl.drawingBufferWidth;
  }
  /**
   * Gets the current render height
   * @param useScreen defines if screen size must be used (or the current render target if any)
   * @returns a number defining the current render height
   */
  getRenderHeight(e = !1) {
    return !e && this._currentRenderTarget ? this._currentRenderTarget.height : this._framebufferDimensionsObject ? this._framebufferDimensionsObject.framebufferHeight : this._gl.drawingBufferHeight;
  }
  /**
   * Can be used to override the current requestAnimationFrame requester.
   * @internal
   */
  _queueNewFrame(e, t) {
    return Z.QueueNewFrame(e, t);
  }
  /**
   * Register and execute a render loop. The engine can have more than one render function
   * @param renderFunction defines the function to continuously execute
   */
  runRenderLoop(e) {
    this._activeRenderLoops.indexOf(e) === -1 && (this._activeRenderLoops.push(e), this._renderingQueueLaunched || (this._renderingQueueLaunched = !0, this._boundRenderFunction = this._renderLoop.bind(this), this._frameHandler = this._queueNewFrame(this._boundRenderFunction, this.getHostWindow())));
  }
  /**
   * Clear the current render buffer or the current render target (if any is set up)
   * @param color defines the color to use
   * @param backBuffer defines if the back buffer must be cleared
   * @param depth defines if the depth buffer must be cleared
   * @param stencil defines if the stencil buffer must be cleared
   */
  clear(e, t, i, s = !1) {
    var r, n;
    const a = this.stencilStateComposer.useStencilGlobalOnly;
    this.stencilStateComposer.useStencilGlobalOnly = !0, this.applyStates(), this.stencilStateComposer.useStencilGlobalOnly = a;
    let o = 0;
    if (t && e) {
      let l = !0;
      if (this._currentRenderTarget) {
        const c = (r = this._currentRenderTarget.texture) === null || r === void 0 ? void 0 : r.format;
        if (c === 8 || c === 9 || c === 10 || c === 11) {
          const u = (n = this._currentRenderTarget.texture) === null || n === void 0 ? void 0 : n.type;
          u === 7 || u === 5 ? (Z._TempClearColorUint32[0] = e.r * 255, Z._TempClearColorUint32[1] = e.g * 255, Z._TempClearColorUint32[2] = e.b * 255, Z._TempClearColorUint32[3] = e.a * 255, this._gl.clearBufferuiv(this._gl.COLOR, 0, Z._TempClearColorUint32), l = !1) : (Z._TempClearColorInt32[0] = e.r * 255, Z._TempClearColorInt32[1] = e.g * 255, Z._TempClearColorInt32[2] = e.b * 255, Z._TempClearColorInt32[3] = e.a * 255, this._gl.clearBufferiv(this._gl.COLOR, 0, Z._TempClearColorInt32), l = !1);
        }
      }
      l && (this._gl.clearColor(e.r, e.g, e.b, e.a !== void 0 ? e.a : 1), o |= this._gl.COLOR_BUFFER_BIT);
    }
    i && (this.useReverseDepthBuffer ? (this._depthCullingState.depthFunc = this._gl.GEQUAL, this._gl.clearDepth(0)) : this._gl.clearDepth(1), o |= this._gl.DEPTH_BUFFER_BIT), s && (this._gl.clearStencil(0), o |= this._gl.STENCIL_BUFFER_BIT), this._gl.clear(o);
  }
  /**
   * @internal
   */
  _viewport(e, t, i, s) {
    (e !== this._viewportCached.x || t !== this._viewportCached.y || i !== this._viewportCached.z || s !== this._viewportCached.w) && (this._viewportCached.x = e, this._viewportCached.y = t, this._viewportCached.z = i, this._viewportCached.w = s, this._gl.viewport(e, t, i, s));
  }
  /**
   * Set the WebGL's viewport
   * @param viewport defines the viewport element to be used
   * @param requiredWidth defines the width required for rendering. If not provided the rendering canvas' width is used
   * @param requiredHeight defines the height required for rendering. If not provided the rendering canvas' height is used
   */
  setViewport(e, t, i) {
    const s = t || this.getRenderWidth(), r = i || this.getRenderHeight(), n = e.x || 0, a = e.y || 0;
    this._cachedViewport = e, this._viewport(n * s, a * r, s * e.width, r * e.height);
  }
  /**
   * Begin a new frame
   */
  beginFrame() {
  }
  /**
   * Enf the current frame
   */
  endFrame() {
    this._badOS && this.flushFramebuffer(), this._frameId++;
  }
  /**
   * Resize the view according to the canvas' size
   * @param forceSetSize true to force setting the sizes of the underlying canvas
   */
  resize(e = !1) {
    let t, i;
    if (this.adaptToDeviceRatio) {
      const s = _t() && window.devicePixelRatio || 1, r = this._lastDevicePixelRatio / s;
      this._lastDevicePixelRatio = s, this._hardwareScalingLevel *= r;
    }
    if (_t() && Rs())
      if (this._renderingCanvas) {
        const s = this._renderingCanvas.getBoundingClientRect ? this._renderingCanvas.getBoundingClientRect() : {
          // fallback to last solution in case the function doesn't exist
          width: this._renderingCanvas.width * this._hardwareScalingLevel,
          height: this._renderingCanvas.height * this._hardwareScalingLevel
        };
        t = this._renderingCanvas.clientWidth || s.width || this._renderingCanvas.width || 100, i = this._renderingCanvas.clientHeight || s.height || this._renderingCanvas.height || 100;
      } else
        t = window.innerWidth, i = window.innerHeight;
    else
      t = this._renderingCanvas ? this._renderingCanvas.width : 100, i = this._renderingCanvas ? this._renderingCanvas.height : 100;
    this.setSize(t / this._hardwareScalingLevel, i / this._hardwareScalingLevel, e);
  }
  /**
   * Force a specific size of the canvas
   * @param width defines the new canvas' width
   * @param height defines the new canvas' height
   * @param forceSetSize true to force setting the sizes of the underlying canvas
   * @returns true if the size was changed
   */
  setSize(e, t, i = !1) {
    return !this._renderingCanvas || (e = e | 0, t = t | 0, !i && this._renderingCanvas.width === e && this._renderingCanvas.height === t) ? !1 : (this._renderingCanvas.width = e, this._renderingCanvas.height = t, !0);
  }
  /**
   * Binds the frame buffer to the specified texture.
   * @param rtWrapper The render target wrapper to render to
   * @param faceIndex The face of the texture to render to in case of cube texture and if the render target wrapper is not a multi render target
   * @param requiredWidth The width of the target to render to
   * @param requiredHeight The height of the target to render to
   * @param forceFullscreenViewport Forces the viewport to be the entire texture/screen if true
   * @param lodLevel Defines the lod level to bind to the frame buffer
   * @param layer Defines the 2d array index to bind to the frame buffer if the render target wrapper is not a multi render target
   */
  bindFramebuffer(e, t = 0, i, s, r, n = 0, a = 0) {
    var o, l, c, u, d;
    const f = e;
    this._currentRenderTarget && this.unBindFramebuffer(this._currentRenderTarget), this._currentRenderTarget = e, this._bindUnboundFramebuffer(f._MSAAFramebuffer ? f._MSAAFramebuffer : f._framebuffer);
    const _ = this._gl;
    e.isMulti || (e.is2DArray ? _.framebufferTextureLayer(_.FRAMEBUFFER, _.COLOR_ATTACHMENT0, (o = e.texture._hardwareTexture) === null || o === void 0 ? void 0 : o.underlyingResource, n, a) : e.isCube && _.framebufferTexture2D(_.FRAMEBUFFER, _.COLOR_ATTACHMENT0, _.TEXTURE_CUBE_MAP_POSITIVE_X + t, (l = e.texture._hardwareTexture) === null || l === void 0 ? void 0 : l.underlyingResource, n));
    const g = e._depthStencilTexture;
    if (g) {
      const m = e._depthStencilTextureWithStencil ? _.DEPTH_STENCIL_ATTACHMENT : _.DEPTH_ATTACHMENT;
      e.is2DArray ? _.framebufferTextureLayer(_.FRAMEBUFFER, m, (c = g._hardwareTexture) === null || c === void 0 ? void 0 : c.underlyingResource, n, a) : e.isCube ? _.framebufferTexture2D(_.FRAMEBUFFER, m, _.TEXTURE_CUBE_MAP_POSITIVE_X + t, (u = g._hardwareTexture) === null || u === void 0 ? void 0 : u.underlyingResource, n) : _.framebufferTexture2D(_.FRAMEBUFFER, m, _.TEXTURE_2D, (d = g._hardwareTexture) === null || d === void 0 ? void 0 : d.underlyingResource, n);
    }
    this._cachedViewport && !r ? this.setViewport(this._cachedViewport, i, s) : (i || (i = e.width, n && (i = i / Math.pow(2, n))), s || (s = e.height, n && (s = s / Math.pow(2, n))), this._viewport(0, 0, i, s)), this.wipeCaches();
  }
  /**
   * Set various states to the webGL context
   * @param culling defines culling state: true to enable culling, false to disable it
   * @param zOffset defines the value to apply to zOffset (0 by default)
   * @param force defines if states must be applied even if cache is up to date
   * @param reverseSide defines if culling must be reversed (CCW if false, CW if true)
   * @param cullBackFaces true to cull back faces, false to cull front faces (if culling is enabled)
   * @param stencil stencil states to set
   * @param zOffsetUnits defines the value to apply to zOffsetUnits (0 by default)
   */
  setState(e, t = 0, i, s = !1, r, n, a = 0) {
    var o, l;
    (this._depthCullingState.cull !== e || i) && (this._depthCullingState.cull = e);
    const c = !((l = (o = this.cullBackFaces) !== null && o !== void 0 ? o : r) !== null && l !== void 0) || l ? this._gl.BACK : this._gl.FRONT;
    (this._depthCullingState.cullFace !== c || i) && (this._depthCullingState.cullFace = c), this.setZOffset(t), this.setZOffsetUnits(a);
    const u = s ? this._gl.CW : this._gl.CCW;
    (this._depthCullingState.frontFace !== u || i) && (this._depthCullingState.frontFace = u), this._stencilStateComposer.stencilMaterial = n;
  }
  /**
   * Gets a boolean indicating if depth testing is enabled
   * @returns the current state
   */
  getDepthBuffer() {
    return this._depthCullingState.depthTest;
  }
  /**
   * Enable or disable depth buffering
   * @param enable defines the state to set
   */
  setDepthBuffer(e) {
    this._depthCullingState.depthTest = e;
  }
  /**
   * Set the z offset Factor to apply to current rendering
   * @param value defines the offset to apply
   */
  setZOffset(e) {
    this._depthCullingState.zOffset = this.useReverseDepthBuffer ? -e : e;
  }
  /**
   * Gets the current value of the zOffset Factor
   * @returns the current zOffset Factor state
   */
  getZOffset() {
    const e = this._depthCullingState.zOffset;
    return this.useReverseDepthBuffer ? -e : e;
  }
  /**
   * Set the z offset Units to apply to current rendering
   * @param value defines the offset to apply
   */
  setZOffsetUnits(e) {
    this._depthCullingState.zOffsetUnits = this.useReverseDepthBuffer ? -e : e;
  }
  /**
   * Gets the current value of the zOffset Units
   * @returns the current zOffset Units state
   */
  getZOffsetUnits() {
    const e = this._depthCullingState.zOffsetUnits;
    return this.useReverseDepthBuffer ? -e : e;
  }
  /**
   * @internal
   */
  _bindUnboundFramebuffer(e) {
    this._currentFramebuffer !== e && (this._gl.bindFramebuffer(this._gl.FRAMEBUFFER, e), this._currentFramebuffer = e);
  }
  /** @internal */
  _currentFrameBufferIsDefaultFrameBuffer() {
    return this._currentFramebuffer === null;
  }
  /**
   * Generates the mipmaps for a texture
   * @param texture texture to generate the mipmaps for
   */
  generateMipmaps(e) {
    this._bindTextureDirectly(this._gl.TEXTURE_2D, e, !0), this._gl.generateMipmap(this._gl.TEXTURE_2D), this._bindTextureDirectly(this._gl.TEXTURE_2D, null);
  }
  /**
   * Unbind the current render target texture from the webGL context
   * @param texture defines the render target wrapper to unbind
   * @param disableGenerateMipMaps defines a boolean indicating that mipmaps must not be generated
   * @param onBeforeUnbind defines a function which will be called before the effective unbind
   */
  unBindFramebuffer(e, t = !1, i) {
    var s;
    const r = e;
    this._currentRenderTarget = null;
    const n = this._gl;
    if (r._MSAAFramebuffer) {
      if (e.isMulti) {
        this.unBindMultiColorAttachmentFramebuffer(e, t, i);
        return;
      }
      n.bindFramebuffer(n.READ_FRAMEBUFFER, r._MSAAFramebuffer), n.bindFramebuffer(n.DRAW_FRAMEBUFFER, r._framebuffer), n.blitFramebuffer(0, 0, e.width, e.height, 0, 0, e.width, e.height, n.COLOR_BUFFER_BIT, n.NEAREST);
    }
    !((s = e.texture) === null || s === void 0) && s.generateMipMaps && !t && !e.isCube && this.generateMipmaps(e.texture), i && (r._MSAAFramebuffer && this._bindUnboundFramebuffer(r._framebuffer), i()), this._bindUnboundFramebuffer(null);
  }
  /**
   * Force a webGL flush (ie. a flush of all waiting webGL commands)
   */
  flushFramebuffer() {
    this._gl.flush();
  }
  /**
   * Unbind the current render target and bind the default framebuffer
   */
  restoreDefaultFramebuffer() {
    this._currentRenderTarget ? this.unBindFramebuffer(this._currentRenderTarget) : this._bindUnboundFramebuffer(null), this._cachedViewport && this.setViewport(this._cachedViewport), this.wipeCaches();
  }
  // VBOs
  /** @internal */
  _resetVertexBufferBinding() {
    this.bindArrayBuffer(null), this._cachedVertexBuffers = null;
  }
  /**
   * Creates a vertex buffer
   * @param data the data for the vertex buffer
   * @returns the new WebGL static buffer
   */
  createVertexBuffer(e) {
    return this._createVertexBuffer(e, this._gl.STATIC_DRAW);
  }
  _createVertexBuffer(e, t) {
    const i = this._gl.createBuffer();
    if (!i)
      throw new Error("Unable to create vertex buffer");
    const s = new Ls(i);
    return this.bindArrayBuffer(s), e instanceof Array ? this._gl.bufferData(this._gl.ARRAY_BUFFER, new Float32Array(e), t) : this._gl.bufferData(this._gl.ARRAY_BUFFER, e, t), this._resetVertexBufferBinding(), s.references = 1, s;
  }
  /**
   * Creates a dynamic vertex buffer
   * @param data the data for the dynamic vertex buffer
   * @returns the new WebGL dynamic buffer
   */
  createDynamicVertexBuffer(e) {
    return this._createVertexBuffer(e, this._gl.DYNAMIC_DRAW);
  }
  _resetIndexBufferBinding() {
    this.bindIndexBuffer(null), this._cachedIndexBuffer = null;
  }
  /**
   * Creates a new index buffer
   * @param indices defines the content of the index buffer
   * @param updatable defines if the index buffer must be updatable
   * @returns a new webGL buffer
   */
  createIndexBuffer(e, t) {
    const i = this._gl.createBuffer(), s = new Ls(i);
    if (!i)
      throw new Error("Unable to create index buffer");
    this.bindIndexBuffer(s);
    const r = this._normalizeIndexData(e);
    return this._gl.bufferData(this._gl.ELEMENT_ARRAY_BUFFER, r, t ? this._gl.DYNAMIC_DRAW : this._gl.STATIC_DRAW), this._resetIndexBufferBinding(), s.references = 1, s.is32Bits = r.BYTES_PER_ELEMENT === 4, s;
  }
  _normalizeIndexData(e) {
    if (e.BYTES_PER_ELEMENT === 2)
      return e;
    if (this._caps.uintIndices) {
      if (e instanceof Uint32Array)
        return e;
      for (let i = 0; i < e.length; i++)
        if (e[i] >= 65535)
          return new Uint32Array(e);
      return new Uint16Array(e);
    }
    return new Uint16Array(e);
  }
  /**
   * Bind a webGL buffer to the webGL context
   * @param buffer defines the buffer to bind
   */
  bindArrayBuffer(e) {
    this._vaoRecordInProgress || this._unbindVertexArrayObject(), this._bindBuffer(e, this._gl.ARRAY_BUFFER);
  }
  /**
   * Bind a specific block at a given index in a specific shader program
   * @param pipelineContext defines the pipeline context to use
   * @param blockName defines the block name
   * @param index defines the index where to bind the block
   */
  bindUniformBlock(e, t, i) {
    const s = e.program, r = this._gl.getUniformBlockIndex(s, t);
    this._gl.uniformBlockBinding(s, r, i);
  }
  // eslint-disable-next-line @typescript-eslint/naming-convention
  bindIndexBuffer(e) {
    this._vaoRecordInProgress || this._unbindVertexArrayObject(), this._bindBuffer(e, this._gl.ELEMENT_ARRAY_BUFFER);
  }
  _bindBuffer(e, t) {
    (this._vaoRecordInProgress || this._currentBoundBuffer[t] !== e) && (this._gl.bindBuffer(t, e ? e.underlyingResource : null), this._currentBoundBuffer[t] = e);
  }
  /**
   * update the bound buffer with the given data
   * @param data defines the data to update
   */
  updateArrayBuffer(e) {
    this._gl.bufferSubData(this._gl.ARRAY_BUFFER, 0, e);
  }
  _vertexAttribPointer(e, t, i, s, r, n, a) {
    const o = this._currentBufferPointers[t];
    if (!o)
      return;
    let l = !1;
    o.active ? (o.buffer !== e && (o.buffer = e, l = !0), o.size !== i && (o.size = i, l = !0), o.type !== s && (o.type = s, l = !0), o.normalized !== r && (o.normalized = r, l = !0), o.stride !== n && (o.stride = n, l = !0), o.offset !== a && (o.offset = a, l = !0)) : (l = !0, o.active = !0, o.index = t, o.size = i, o.type = s, o.normalized = r, o.stride = n, o.offset = a, o.buffer = e), (l || this._vaoRecordInProgress) && (this.bindArrayBuffer(e), s === this._gl.UNSIGNED_INT || s === this._gl.INT ? this._gl.vertexAttribIPointer(t, i, s, n, a) : this._gl.vertexAttribPointer(t, i, s, r, n, a));
  }
  /**
   * @internal
   */
  _bindIndexBufferWithCache(e) {
    e != null && this._cachedIndexBuffer !== e && (this._cachedIndexBuffer = e, this.bindIndexBuffer(e), this._uintIndicesCurrentlySet = e.is32Bits);
  }
  _bindVertexBuffersAttributes(e, t, i) {
    const s = t.getAttributesNames();
    this._vaoRecordInProgress || this._unbindVertexArrayObject(), this.unbindAllAttributes();
    for (let r = 0; r < s.length; r++) {
      const n = t.getAttributeLocation(r);
      if (n >= 0) {
        const a = s[r];
        let o = null;
        if (i && (o = i[a]), o || (o = e[a]), !o)
          continue;
        this._gl.enableVertexAttribArray(n), this._vaoRecordInProgress || (this._vertexAttribArraysEnabled[n] = !0);
        const l = o.getBuffer();
        l && (this._vertexAttribPointer(l, n, o.getSize(), o.type, o.normalized, o.byteStride, o.byteOffset), o.getIsInstanced() && (this._gl.vertexAttribDivisor(n, o.getInstanceDivisor()), this._vaoRecordInProgress || (this._currentInstanceLocations.push(n), this._currentInstanceBuffers.push(l))));
      }
    }
  }
  /**
   * Records a vertex array object
   * @see https://doc.babylonjs.com/setup/support/webGL2#vertex-array-objects
   * @param vertexBuffers defines the list of vertex buffers to store
   * @param indexBuffer defines the index buffer to store
   * @param effect defines the effect to store
   * @param overrideVertexBuffers defines optional list of avertex buffers that overrides the entries in vertexBuffers
   * @returns the new vertex array object
   */
  recordVertexArrayObject(e, t, i, s) {
    const r = this._gl.createVertexArray();
    if (!r)
      throw new Error("Unable to create VAO");
    return this._vaoRecordInProgress = !0, this._gl.bindVertexArray(r), this._mustWipeVertexAttributes = !0, this._bindVertexBuffersAttributes(e, i, s), this.bindIndexBuffer(t), this._vaoRecordInProgress = !1, this._gl.bindVertexArray(null), r;
  }
  /**
   * Bind a specific vertex array object
   * @see https://doc.babylonjs.com/setup/support/webGL2#vertex-array-objects
   * @param vertexArrayObject defines the vertex array object to bind
   * @param indexBuffer defines the index buffer to bind
   */
  bindVertexArrayObject(e, t) {
    this._cachedVertexArrayObject !== e && (this._cachedVertexArrayObject = e, this._gl.bindVertexArray(e), this._cachedVertexBuffers = null, this._cachedIndexBuffer = null, this._uintIndicesCurrentlySet = t != null && t.is32Bits, this._mustWipeVertexAttributes = !0);
  }
  /**
   * Bind webGl buffers directly to the webGL context
   * @param vertexBuffer defines the vertex buffer to bind
   * @param indexBuffer defines the index buffer to bind
   * @param vertexDeclaration defines the vertex declaration to use with the vertex buffer
   * @param vertexStrideSize defines the vertex stride of the vertex buffer
   * @param effect defines the effect associated with the vertex buffer
   */
  bindBuffersDirectly(e, t, i, s, r) {
    if (this._cachedVertexBuffers !== e || this._cachedEffectForVertexBuffers !== r) {
      this._cachedVertexBuffers = e, this._cachedEffectForVertexBuffers = r;
      const n = r.getAttributesCount();
      this._unbindVertexArrayObject(), this.unbindAllAttributes();
      let a = 0;
      for (let o = 0; o < n; o++)
        if (o < i.length) {
          const l = r.getAttributeLocation(o);
          l >= 0 && (this._gl.enableVertexAttribArray(l), this._vertexAttribArraysEnabled[l] = !0, this._vertexAttribPointer(e, l, i[o], this._gl.FLOAT, !1, s, a)), a += i[o] * 4;
        }
    }
    this._bindIndexBufferWithCache(t);
  }
  _unbindVertexArrayObject() {
    this._cachedVertexArrayObject && (this._cachedVertexArrayObject = null, this._gl.bindVertexArray(null));
  }
  /**
   * Bind a list of vertex buffers to the webGL context
   * @param vertexBuffers defines the list of vertex buffers to bind
   * @param indexBuffer defines the index buffer to bind
   * @param effect defines the effect associated with the vertex buffers
   * @param overrideVertexBuffers defines optional list of avertex buffers that overrides the entries in vertexBuffers
   */
  bindBuffers(e, t, i, s) {
    (this._cachedVertexBuffers !== e || this._cachedEffectForVertexBuffers !== i) && (this._cachedVertexBuffers = e, this._cachedEffectForVertexBuffers = i, this._bindVertexBuffersAttributes(e, i, s)), this._bindIndexBufferWithCache(t);
  }
  /**
   * Unbind all instance attributes
   */
  unbindInstanceAttributes() {
    let e;
    for (let t = 0, i = this._currentInstanceLocations.length; t < i; t++) {
      const s = this._currentInstanceBuffers[t];
      e != s && s.references && (e = s, this.bindArrayBuffer(s));
      const r = this._currentInstanceLocations[t];
      this._gl.vertexAttribDivisor(r, 0);
    }
    this._currentInstanceBuffers.length = 0, this._currentInstanceLocations.length = 0;
  }
  /**
   * Release and free the memory of a vertex array object
   * @param vao defines the vertex array object to delete
   */
  releaseVertexArrayObject(e) {
    this._gl.deleteVertexArray(e);
  }
  /**
   * @internal
   */
  _releaseBuffer(e) {
    return e.references--, e.references === 0 ? (this._deleteBuffer(e), !0) : !1;
  }
  _deleteBuffer(e) {
    this._gl.deleteBuffer(e.underlyingResource);
  }
  /**
   * Update the content of a webGL buffer used with instantiation and bind it to the webGL context
   * @param instancesBuffer defines the webGL buffer to update and bind
   * @param data defines the data to store in the buffer
   * @param offsetLocations defines the offsets or attributes information used to determine where data must be stored in the buffer
   */
  updateAndBindInstancesBuffer(e, t, i) {
    if (this.bindArrayBuffer(e), t && this._gl.bufferSubData(this._gl.ARRAY_BUFFER, 0, t), i[0].index !== void 0)
      this.bindInstancesBuffer(e, i, !0);
    else
      for (let s = 0; s < 4; s++) {
        const r = i[s];
        this._vertexAttribArraysEnabled[r] || (this._gl.enableVertexAttribArray(r), this._vertexAttribArraysEnabled[r] = !0), this._vertexAttribPointer(e, r, 4, this._gl.FLOAT, !1, 64, s * 16), this._gl.vertexAttribDivisor(r, 1), this._currentInstanceLocations.push(r), this._currentInstanceBuffers.push(e);
      }
  }
  /**
   * Bind the content of a webGL buffer used with instantiation
   * @param instancesBuffer defines the webGL buffer to bind
   * @param attributesInfo defines the offsets or attributes information used to determine where data must be stored in the buffer
   * @param computeStride defines Whether to compute the strides from the info or use the default 0
   */
  bindInstancesBuffer(e, t, i = !0) {
    this.bindArrayBuffer(e);
    let s = 0;
    if (i)
      for (let r = 0; r < t.length; r++) {
        const n = t[r];
        s += n.attributeSize * 4;
      }
    for (let r = 0; r < t.length; r++) {
      const n = t[r];
      n.index === void 0 && (n.index = this._currentEffect.getAttributeLocationByName(n.attributeName)), !(n.index < 0) && (this._vertexAttribArraysEnabled[n.index] || (this._gl.enableVertexAttribArray(n.index), this._vertexAttribArraysEnabled[n.index] = !0), this._vertexAttribPointer(e, n.index, n.attributeSize, n.attributeType || this._gl.FLOAT, n.normalized || !1, s, n.offset), this._gl.vertexAttribDivisor(n.index, n.divisor === void 0 ? 1 : n.divisor), this._currentInstanceLocations.push(n.index), this._currentInstanceBuffers.push(e));
    }
  }
  /**
   * Disable the instance attribute corresponding to the name in parameter
   * @param name defines the name of the attribute to disable
   */
  disableInstanceAttributeByName(e) {
    if (!this._currentEffect)
      return;
    const t = this._currentEffect.getAttributeLocationByName(e);
    this.disableInstanceAttribute(t);
  }
  /**
   * Disable the instance attribute corresponding to the location in parameter
   * @param attributeLocation defines the attribute location of the attribute to disable
   */
  disableInstanceAttribute(e) {
    let t = !1, i;
    for (; (i = this._currentInstanceLocations.indexOf(e)) !== -1; )
      this._currentInstanceLocations.splice(i, 1), this._currentInstanceBuffers.splice(i, 1), t = !0, i = this._currentInstanceLocations.indexOf(e);
    t && (this._gl.vertexAttribDivisor(e, 0), this.disableAttributeByIndex(e));
  }
  /**
   * Disable the attribute corresponding to the location in parameter
   * @param attributeLocation defines the attribute location of the attribute to disable
   */
  disableAttributeByIndex(e) {
    this._gl.disableVertexAttribArray(e), this._vertexAttribArraysEnabled[e] = !1, this._currentBufferPointers[e].active = !1;
  }
  /**
   * Send a draw order
   * @param useTriangles defines if triangles must be used to draw (else wireframe will be used)
   * @param indexStart defines the starting index
   * @param indexCount defines the number of index to draw
   * @param instancesCount defines the number of instances to draw (if instantiation is enabled)
   */
  draw(e, t, i, s) {
    this.drawElementsType(e ? 0 : 1, t, i, s);
  }
  /**
   * Draw a list of points
   * @param verticesStart defines the index of first vertex to draw
   * @param verticesCount defines the count of vertices to draw
   * @param instancesCount defines the number of instances to draw (if instantiation is enabled)
   */
  drawPointClouds(e, t, i) {
    this.drawArraysType(2, e, t, i);
  }
  /**
   * Draw a list of unindexed primitives
   * @param useTriangles defines if triangles must be used to draw (else wireframe will be used)
   * @param verticesStart defines the index of first vertex to draw
   * @param verticesCount defines the count of vertices to draw
   * @param instancesCount defines the number of instances to draw (if instantiation is enabled)
   */
  drawUnIndexed(e, t, i, s) {
    this.drawArraysType(e ? 0 : 1, t, i, s);
  }
  /**
   * Draw a list of indexed primitives
   * @param fillMode defines the primitive to use
   * @param indexStart defines the starting index
   * @param indexCount defines the number of index to draw
   * @param instancesCount defines the number of instances to draw (if instantiation is enabled)
   */
  drawElementsType(e, t, i, s) {
    this.applyStates(), this._reportDrawCall();
    const r = this._drawMode(e), n = this._uintIndicesCurrentlySet ? this._gl.UNSIGNED_INT : this._gl.UNSIGNED_SHORT, a = this._uintIndicesCurrentlySet ? 4 : 2;
    s ? this._gl.drawElementsInstanced(r, i, n, t * a, s) : this._gl.drawElements(r, i, n, t * a);
  }
  /**
   * Draw a list of unindexed primitives
   * @param fillMode defines the primitive to use
   * @param verticesStart defines the index of first vertex to draw
   * @param verticesCount defines the count of vertices to draw
   * @param instancesCount defines the number of instances to draw (if instantiation is enabled)
   */
  drawArraysType(e, t, i, s) {
    this.applyStates(), this._reportDrawCall();
    const r = this._drawMode(e);
    s ? this._gl.drawArraysInstanced(r, t, i, s) : this._gl.drawArrays(r, t, i);
  }
  _drawMode(e) {
    switch (e) {
      case 0:
        return this._gl.TRIANGLES;
      case 2:
        return this._gl.POINTS;
      case 1:
        return this._gl.LINES;
      case 3:
        return this._gl.POINTS;
      case 4:
        return this._gl.LINES;
      case 5:
        return this._gl.LINE_LOOP;
      case 6:
        return this._gl.LINE_STRIP;
      case 7:
        return this._gl.TRIANGLE_STRIP;
      case 8:
        return this._gl.TRIANGLE_FAN;
      default:
        return this._gl.TRIANGLES;
    }
  }
  /** @internal */
  _reportDrawCall() {
  }
  // Shaders
  /**
   * @internal
   */
  _releaseEffect(e) {
    this._compiledEffects[e._key] && delete this._compiledEffects[e._key];
    const t = e.getPipelineContext();
    t && this._deletePipelineContext(t);
  }
  /**
   * @internal
   */
  _deletePipelineContext(e) {
    const t = e;
    t && t.program && (t.program.__SPECTOR_rebuildProgram = null, this._gl.deleteProgram(t.program));
  }
  /** @internal */
  _getGlobalDefines(e) {
    if (e) {
      this.isNDCHalfZRange ? e.IS_NDC_HALF_ZRANGE = "" : delete e.IS_NDC_HALF_ZRANGE, this.useReverseDepthBuffer ? e.USE_REVERSE_DEPTHBUFFER = "" : delete e.USE_REVERSE_DEPTHBUFFER, this.useExactSrgbConversions ? e.USE_EXACT_SRGB_CONVERSIONS = "" : delete e.USE_EXACT_SRGB_CONVERSIONS;
      return;
    } else {
      let t = "";
      return this.isNDCHalfZRange && (t += "#define IS_NDC_HALF_ZRANGE"), this.useReverseDepthBuffer && (t && (t += `
`), t += "#define USE_REVERSE_DEPTHBUFFER"), this.useExactSrgbConversions && (t && (t += `
`), t += "#define USE_EXACT_SRGB_CONVERSIONS"), t;
    }
  }
  /**
   * Create a new effect (used to store vertex/fragment shaders)
   * @param baseName defines the base name of the effect (The name of file without .fragment.fx or .vertex.fx)
   * @param attributesNamesOrOptions defines either a list of attribute names or an IEffectCreationOptions object
   * @param uniformsNamesOrEngine defines either a list of uniform names or the engine to use
   * @param samplers defines an array of string used to represent textures
   * @param defines defines the string containing the defines to use to compile the shaders
   * @param fallbacks defines the list of potential fallbacks to use if shader compilation fails
   * @param onCompiled defines a function to call when the effect creation is successful
   * @param onError defines a function to call when the effect creation has failed
   * @param indexParameters defines an object containing the index values to use to compile shaders (like the maximum number of simultaneous lights)
   * @param shaderLanguage the language the shader is written in (default: GLSL)
   * @returns the new Effect
   */
  createEffect(e, t, i, s, r, n, a, o, l, c = dt.GLSL) {
    var u;
    const d = e.vertexElement || e.vertex || e.vertexToken || e.vertexSource || e, f = e.fragmentElement || e.fragment || e.fragmentToken || e.fragmentSource || e, _ = this._getGlobalDefines();
    let g = (u = r ?? t.defines) !== null && u !== void 0 ? u : "";
    _ && (g += _);
    const m = d + "+" + f + "@" + g;
    if (this._compiledEffects[m]) {
      const x = this._compiledEffects[m];
      return a && x.isReady() && a(x), x;
    }
    const y = new yt(e, t, i, s, this, r, n, a, o, l, m, c);
    return this._compiledEffects[m] = y, y;
  }
  // eslint-disable-next-line @typescript-eslint/naming-convention
  static _ConcatenateShader(e, t, i = "") {
    return i + (t ? t + `
` : "") + e;
  }
  _compileShader(e, t, i, s) {
    return this._compileRawShader(Z._ConcatenateShader(e, i, s), t);
  }
  _compileRawShader(e, t) {
    const i = this._gl, s = i.createShader(t === "vertex" ? i.VERTEX_SHADER : i.FRAGMENT_SHADER);
    if (!s) {
      let r = i.NO_ERROR, n = i.NO_ERROR;
      for (; (n = i.getError()) !== i.NO_ERROR; )
        r = n;
      throw new Error(`Something went wrong while creating a gl ${t} shader object. gl error=${r}, gl isContextLost=${i.isContextLost()}, _contextWasLost=${this._contextWasLost}`);
    }
    return i.shaderSource(s, e), i.compileShader(s), s;
  }
  /**
   * @internal
   */
  _getShaderSource(e) {
    return this._gl.getShaderSource(e);
  }
  /**
   * Directly creates a webGL program
   * @param pipelineContext  defines the pipeline context to attach to
   * @param vertexCode defines the vertex shader code to use
   * @param fragmentCode defines the fragment shader code to use
   * @param context defines the webGL context to use (if not set, the current one will be used)
   * @param transformFeedbackVaryings defines the list of transform feedback varyings to use
   * @returns the new webGL program
   */
  createRawShaderProgram(e, t, i, s, r = null) {
    s = s || this._gl;
    const n = this._compileRawShader(t, "vertex"), a = this._compileRawShader(i, "fragment");
    return this._createShaderProgram(e, n, a, s, r);
  }
  /**
   * Creates a webGL program
   * @param pipelineContext  defines the pipeline context to attach to
   * @param vertexCode  defines the vertex shader code to use
   * @param fragmentCode defines the fragment shader code to use
   * @param defines defines the string containing the defines to use to compile the shaders
   * @param context defines the webGL context to use (if not set, the current one will be used)
   * @param transformFeedbackVaryings defines the list of transform feedback varyings to use
   * @returns the new webGL program
   */
  createShaderProgram(e, t, i, s, r, n = null) {
    r = r || this._gl;
    const a = this._webGLVersion > 1 ? `#version 300 es
#define WEBGL2 
` : "", o = this._compileShader(t, "vertex", s, a), l = this._compileShader(i, "fragment", s, a);
    return this._createShaderProgram(e, o, l, r, n);
  }
  /**
   * Inline functions in shader code that are marked to be inlined
   * @param code code to inline
   * @returns inlined code
   */
  inlineShaderCode(e) {
    return e;
  }
  /**
   * Creates a new pipeline context
   * @param shaderProcessingContext defines the shader processing context used during the processing if available
   * @returns the new pipeline
   */
  createPipelineContext(e) {
    const t = new _l();
    return t.engine = this, this._caps.parallelShaderCompile && (t.isParallelCompiled = !0), t;
  }
  /**
   * Creates a new material context
   * @returns the new context
   */
  createMaterialContext() {
  }
  /**
   * Creates a new draw context
   * @returns the new context
   */
  createDrawContext() {
  }
  _createShaderProgram(e, t, i, s, r = null) {
    const n = s.createProgram();
    if (e.program = n, !n)
      throw new Error("Unable to create program");
    return s.attachShader(n, t), s.attachShader(n, i), s.linkProgram(n), e.context = s, e.vertexShader = t, e.fragmentShader = i, e.isParallelCompiled || this._finalizePipelineContext(e), n;
  }
  _finalizePipelineContext(e) {
    const t = e.context, i = e.vertexShader, s = e.fragmentShader, r = e.program;
    if (!t.getProgramParameter(r, t.LINK_STATUS)) {
      if (!this._gl.getShaderParameter(i, this._gl.COMPILE_STATUS)) {
        const o = this._gl.getShaderInfoLog(i);
        if (o)
          throw e.vertexCompilationError = o, new Error("VERTEX SHADER " + o);
      }
      if (!this._gl.getShaderParameter(s, this._gl.COMPILE_STATUS)) {
        const o = this._gl.getShaderInfoLog(s);
        if (o)
          throw e.fragmentCompilationError = o, new Error("FRAGMENT SHADER " + o);
      }
      const a = t.getProgramInfoLog(r);
      if (a)
        throw e.programLinkError = a, new Error(a);
    }
    if (this.validateShaderPrograms && (t.validateProgram(r), !t.getProgramParameter(r, t.VALIDATE_STATUS))) {
      const o = t.getProgramInfoLog(r);
      if (o)
        throw e.programValidationError = o, new Error(o);
    }
    t.deleteShader(i), t.deleteShader(s), e.vertexShader = void 0, e.fragmentShader = void 0, e.onCompiled && (e.onCompiled(), e.onCompiled = void 0);
  }
  /**
   * @internal
   */
  _preparePipelineContext(e, t, i, s, r, n, a, o, l, c) {
    const u = e;
    s ? u.program = this.createRawShaderProgram(u, t, i, void 0, l) : u.program = this.createShaderProgram(u, t, i, o, void 0, l), u.program.__SPECTOR_rebuildProgram = a;
  }
  /**
   * @internal
   */
  _isRenderingStateCompiled(e) {
    const t = e;
    return this._isDisposed || t._isDisposed ? !1 : this._gl.getProgramParameter(t.program, this._caps.parallelShaderCompile.COMPLETION_STATUS_KHR) ? (this._finalizePipelineContext(t), !0) : !1;
  }
  /**
   * @internal
   */
  _executeWhenRenderingStateIsCompiled(e, t) {
    const i = e;
    if (!i.isParallelCompiled) {
      t();
      return;
    }
    const s = i.onCompiled;
    s ? i.onCompiled = () => {
      s(), t();
    } : i.onCompiled = t;
  }
  /**
   * Gets the list of webGL uniform locations associated with a specific program based on a list of uniform names
   * @param pipelineContext defines the pipeline context to use
   * @param uniformsNames defines the list of uniform names
   * @returns an array of webGL uniform locations
   */
  getUniforms(e, t) {
    const i = new Array(), s = e;
    for (let r = 0; r < t.length; r++)
      i.push(this._gl.getUniformLocation(s.program, t[r]));
    return i;
  }
  /**
   * Gets the list of active attributes for a given webGL program
   * @param pipelineContext defines the pipeline context to use
   * @param attributesNames defines the list of attribute names to get
   * @returns an array of indices indicating the offset of each attribute
   */
  getAttributes(e, t) {
    const i = [], s = e;
    for (let r = 0; r < t.length; r++)
      try {
        i.push(this._gl.getAttribLocation(s.program, t[r]));
      } catch {
        i.push(-1);
      }
    return i;
  }
  /**
   * Activates an effect, making it the current one (ie. the one used for rendering)
   * @param effect defines the effect to activate
   */
  enableEffect(e) {
    e = e !== null && xi.IsWrapper(e) ? e.effect : e, !(!e || e === this._currentEffect) && (this._stencilStateComposer.stencilMaterial = void 0, e = e, this.bindSamplers(e), this._currentEffect = e, e.onBind && e.onBind(e), e._onBindObservable && e._onBindObservable.notifyObservers(e));
  }
  /**
   * Set the value of an uniform to a number (int)
   * @param uniform defines the webGL uniform location where to store the value
   * @param value defines the int number to store
   * @returns true if the value was set
   */
  setInt(e, t) {
    return e ? (this._gl.uniform1i(e, t), !0) : !1;
  }
  /**
   * Set the value of an uniform to a int2
   * @param uniform defines the webGL uniform location where to store the value
   * @param x defines the 1st component of the value
   * @param y defines the 2nd component of the value
   * @returns true if the value was set
   */
  setInt2(e, t, i) {
    return e ? (this._gl.uniform2i(e, t, i), !0) : !1;
  }
  /**
   * Set the value of an uniform to a int3
   * @param uniform defines the webGL uniform location where to store the value
   * @param x defines the 1st component of the value
   * @param y defines the 2nd component of the value
   * @param z defines the 3rd component of the value
   * @returns true if the value was set
   */
  setInt3(e, t, i, s) {
    return e ? (this._gl.uniform3i(e, t, i, s), !0) : !1;
  }
  /**
   * Set the value of an uniform to a int4
   * @param uniform defines the webGL uniform location where to store the value
   * @param x defines the 1st component of the value
   * @param y defines the 2nd component of the value
   * @param z defines the 3rd component of the value
   * @param w defines the 4th component of the value
   * @returns true if the value was set
   */
  setInt4(e, t, i, s, r) {
    return e ? (this._gl.uniform4i(e, t, i, s, r), !0) : !1;
  }
  /**
   * Set the value of an uniform to an array of int32
   * @param uniform defines the webGL uniform location where to store the value
   * @param array defines the array of int32 to store
   * @returns true if the value was set
   */
  setIntArray(e, t) {
    return e ? (this._gl.uniform1iv(e, t), !0) : !1;
  }
  /**
   * Set the value of an uniform to an array of int32 (stored as vec2)
   * @param uniform defines the webGL uniform location where to store the value
   * @param array defines the array of int32 to store
   * @returns true if the value was set
   */
  setIntArray2(e, t) {
    return !e || t.length % 2 !== 0 ? !1 : (this._gl.uniform2iv(e, t), !0);
  }
  /**
   * Set the value of an uniform to an array of int32 (stored as vec3)
   * @param uniform defines the webGL uniform location where to store the value
   * @param array defines the array of int32 to store
   * @returns true if the value was set
   */
  setIntArray3(e, t) {
    return !e || t.length % 3 !== 0 ? !1 : (this._gl.uniform3iv(e, t), !0);
  }
  /**
   * Set the value of an uniform to an array of int32 (stored as vec4)
   * @param uniform defines the webGL uniform location where to store the value
   * @param array defines the array of int32 to store
   * @returns true if the value was set
   */
  setIntArray4(e, t) {
    return !e || t.length % 4 !== 0 ? !1 : (this._gl.uniform4iv(e, t), !0);
  }
  /**
   * Set the value of an uniform to a number (unsigned int)
   * @param uniform defines the webGL uniform location where to store the value
   * @param value defines the unsigned int number to store
   * @returns true if the value was set
   */
  setUInt(e, t) {
    return e ? (this._gl.uniform1ui(e, t), !0) : !1;
  }
  /**
   * Set the value of an uniform to a unsigned int2
   * @param uniform defines the webGL uniform location where to store the value
   * @param x defines the 1st component of the value
   * @param y defines the 2nd component of the value
   * @returns true if the value was set
   */
  setUInt2(e, t, i) {
    return e ? (this._gl.uniform2ui(e, t, i), !0) : !1;
  }
  /**
   * Set the value of an uniform to a unsigned int3
   * @param uniform defines the webGL uniform location where to store the value
   * @param x defines the 1st component of the value
   * @param y defines the 2nd component of the value
   * @param z defines the 3rd component of the value
   * @returns true if the value was set
   */
  setUInt3(e, t, i, s) {
    return e ? (this._gl.uniform3ui(e, t, i, s), !0) : !1;
  }
  /**
   * Set the value of an uniform to a unsigned int4
   * @param uniform defines the webGL uniform location where to store the value
   * @param x defines the 1st component of the value
   * @param y defines the 2nd component of the value
   * @param z defines the 3rd component of the value
   * @param w defines the 4th component of the value
   * @returns true if the value was set
   */
  setUInt4(e, t, i, s, r) {
    return e ? (this._gl.uniform4ui(e, t, i, s, r), !0) : !1;
  }
  /**
   * Set the value of an uniform to an array of unsigned int32
   * @param uniform defines the webGL uniform location where to store the value
   * @param array defines the array of unsigned int32 to store
   * @returns true if the value was set
   */
  setUIntArray(e, t) {
    return e ? (this._gl.uniform1uiv(e, t), !0) : !1;
  }
  /**
   * Set the value of an uniform to an array of unsigned int32 (stored as vec2)
   * @param uniform defines the webGL uniform location where to store the value
   * @param array defines the array of unsigned int32 to store
   * @returns true if the value was set
   */
  setUIntArray2(e, t) {
    return !e || t.length % 2 !== 0 ? !1 : (this._gl.uniform2uiv(e, t), !0);
  }
  /**
   * Set the value of an uniform to an array of unsigned int32 (stored as vec3)
   * @param uniform defines the webGL uniform location where to store the value
   * @param array defines the array of unsigned int32 to store
   * @returns true if the value was set
   */
  setUIntArray3(e, t) {
    return !e || t.length % 3 !== 0 ? !1 : (this._gl.uniform3uiv(e, t), !0);
  }
  /**
   * Set the value of an uniform to an array of unsigned int32 (stored as vec4)
   * @param uniform defines the webGL uniform location where to store the value
   * @param array defines the array of unsigned int32 to store
   * @returns true if the value was set
   */
  setUIntArray4(e, t) {
    return !e || t.length % 4 !== 0 ? !1 : (this._gl.uniform4uiv(e, t), !0);
  }
  /**
   * Set the value of an uniform to an array of number
   * @param uniform defines the webGL uniform location where to store the value
   * @param array defines the array of number to store
   * @returns true if the value was set
   */
  setArray(e, t) {
    return !e || t.length < 1 ? !1 : (this._gl.uniform1fv(e, t), !0);
  }
  /**
   * Set the value of an uniform to an array of number (stored as vec2)
   * @param uniform defines the webGL uniform location where to store the value
   * @param array defines the array of number to store
   * @returns true if the value was set
   */
  setArray2(e, t) {
    return !e || t.length % 2 !== 0 ? !1 : (this._gl.uniform2fv(e, t), !0);
  }
  /**
   * Set the value of an uniform to an array of number (stored as vec3)
   * @param uniform defines the webGL uniform location where to store the value
   * @param array defines the array of number to store
   * @returns true if the value was set
   */
  setArray3(e, t) {
    return !e || t.length % 3 !== 0 ? !1 : (this._gl.uniform3fv(e, t), !0);
  }
  /**
   * Set the value of an uniform to an array of number (stored as vec4)
   * @param uniform defines the webGL uniform location where to store the value
   * @param array defines the array of number to store
   * @returns true if the value was set
   */
  setArray4(e, t) {
    return !e || t.length % 4 !== 0 ? !1 : (this._gl.uniform4fv(e, t), !0);
  }
  /**
   * Set the value of an uniform to an array of float32 (stored as matrices)
   * @param uniform defines the webGL uniform location where to store the value
   * @param matrices defines the array of float32 to store
   * @returns true if the value was set
   */
  setMatrices(e, t) {
    return e ? (this._gl.uniformMatrix4fv(e, !1, t), !0) : !1;
  }
  /**
   * Set the value of an uniform to a matrix (3x3)
   * @param uniform defines the webGL uniform location where to store the value
   * @param matrix defines the Float32Array representing the 3x3 matrix to store
   * @returns true if the value was set
   */
  setMatrix3x3(e, t) {
    return e ? (this._gl.uniformMatrix3fv(e, !1, t), !0) : !1;
  }
  /**
   * Set the value of an uniform to a matrix (2x2)
   * @param uniform defines the webGL uniform location where to store the value
   * @param matrix defines the Float32Array representing the 2x2 matrix to store
   * @returns true if the value was set
   */
  setMatrix2x2(e, t) {
    return e ? (this._gl.uniformMatrix2fv(e, !1, t), !0) : !1;
  }
  /**
   * Set the value of an uniform to a number (float)
   * @param uniform defines the webGL uniform location where to store the value
   * @param value defines the float number to store
   * @returns true if the value was transferred
   */
  setFloat(e, t) {
    return e ? (this._gl.uniform1f(e, t), !0) : !1;
  }
  /**
   * Set the value of an uniform to a vec2
   * @param uniform defines the webGL uniform location where to store the value
   * @param x defines the 1st component of the value
   * @param y defines the 2nd component of the value
   * @returns true if the value was set
   */
  setFloat2(e, t, i) {
    return e ? (this._gl.uniform2f(e, t, i), !0) : !1;
  }
  /**
   * Set the value of an uniform to a vec3
   * @param uniform defines the webGL uniform location where to store the value
   * @param x defines the 1st component of the value
   * @param y defines the 2nd component of the value
   * @param z defines the 3rd component of the value
   * @returns true if the value was set
   */
  setFloat3(e, t, i, s) {
    return e ? (this._gl.uniform3f(e, t, i, s), !0) : !1;
  }
  /**
   * Set the value of an uniform to a vec4
   * @param uniform defines the webGL uniform location where to store the value
   * @param x defines the 1st component of the value
   * @param y defines the 2nd component of the value
   * @param z defines the 3rd component of the value
   * @param w defines the 4th component of the value
   * @returns true if the value was set
   */
  setFloat4(e, t, i, s, r) {
    return e ? (this._gl.uniform4f(e, t, i, s, r), !0) : !1;
  }
  // States
  /**
   * Apply all cached states (depth, culling, stencil and alpha)
   */
  applyStates() {
    if (this._depthCullingState.apply(this._gl), this._stencilStateComposer.apply(this._gl), this._alphaState.apply(this._gl), this._colorWriteChanged) {
      this._colorWriteChanged = !1;
      const e = this._colorWrite;
      this._gl.colorMask(e, e, e, e);
    }
  }
  /**
   * Enable or disable color writing
   * @param enable defines the state to set
   */
  setColorWrite(e) {
    e !== this._colorWrite && (this._colorWriteChanged = !0, this._colorWrite = e);
  }
  /**
   * Gets a boolean indicating if color writing is enabled
   * @returns the current color writing state
   */
  getColorWrite() {
    return this._colorWrite;
  }
  /**
   * Gets the depth culling state manager
   */
  get depthCullingState() {
    return this._depthCullingState;
  }
  /**
   * Gets the alpha state manager
   */
  get alphaState() {
    return this._alphaState;
  }
  /**
   * Gets the stencil state manager
   */
  get stencilState() {
    return this._stencilState;
  }
  /**
   * Gets the stencil state composer
   */
  get stencilStateComposer() {
    return this._stencilStateComposer;
  }
  // Textures
  /**
   * Clears the list of texture accessible through engine.
   * This can help preventing texture load conflict due to name collision.
   */
  clearInternalTexturesCache() {
    this._internalTexturesCache.length = 0;
  }
  /**
   * Force the entire cache to be cleared
   * You should not have to use this function unless your engine needs to share the webGL context with another engine
   * @param bruteForce defines a boolean to force clearing ALL caches (including stencil, detoh and alpha states)
   */
  wipeCaches(e) {
    this.preventCacheWipeBetweenFrames && !e || (this._currentEffect = null, this._viewportCached.x = 0, this._viewportCached.y = 0, this._viewportCached.z = 0, this._viewportCached.w = 0, this._unbindVertexArrayObject(), e && (this._currentProgram = null, this.resetTextureCache(), this._stencilStateComposer.reset(), this._depthCullingState.reset(), this._depthCullingState.depthFunc = this._gl.LEQUAL, this._alphaState.reset(), this._alphaMode = 1, this._alphaEquation = 0, this._colorWrite = !0, this._colorWriteChanged = !0, this._unpackFlipYCached = null, this._gl.pixelStorei(this._gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, this._gl.NONE), this._gl.pixelStorei(this._gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, 0), this._mustWipeVertexAttributes = !0, this.unbindAllAttributes()), this._resetVertexBufferBinding(), this._cachedIndexBuffer = null, this._cachedEffectForVertexBuffers = null, this.bindIndexBuffer(null));
  }
  /**
   * @internal
   */
  _getSamplingParameters(e, t) {
    const i = this._gl;
    let s = i.NEAREST, r = i.NEAREST;
    switch (e) {
      case 11:
        s = i.LINEAR, t ? r = i.LINEAR_MIPMAP_NEAREST : r = i.LINEAR;
        break;
      case 3:
        s = i.LINEAR, t ? r = i.LINEAR_MIPMAP_LINEAR : r = i.LINEAR;
        break;
      case 8:
        s = i.NEAREST, t ? r = i.NEAREST_MIPMAP_LINEAR : r = i.NEAREST;
        break;
      case 4:
        s = i.NEAREST, t ? r = i.NEAREST_MIPMAP_NEAREST : r = i.NEAREST;
        break;
      case 5:
        s = i.NEAREST, t ? r = i.LINEAR_MIPMAP_NEAREST : r = i.LINEAR;
        break;
      case 6:
        s = i.NEAREST, t ? r = i.LINEAR_MIPMAP_LINEAR : r = i.LINEAR;
        break;
      case 7:
        s = i.NEAREST, r = i.LINEAR;
        break;
      case 1:
        s = i.NEAREST, r = i.NEAREST;
        break;
      case 9:
        s = i.LINEAR, t ? r = i.NEAREST_MIPMAP_NEAREST : r = i.NEAREST;
        break;
      case 10:
        s = i.LINEAR, t ? r = i.NEAREST_MIPMAP_LINEAR : r = i.NEAREST;
        break;
      case 2:
        s = i.LINEAR, r = i.LINEAR;
        break;
      case 12:
        s = i.LINEAR, r = i.NEAREST;
        break;
    }
    return {
      min: r,
      mag: s
    };
  }
  /** @internal */
  _createTexture() {
    const e = this._gl.createTexture();
    if (!e)
      throw new Error("Unable to create texture");
    return e;
  }
  /** @internal */
  _createHardwareTexture() {
    return new Fa(this._createTexture(), this._gl);
  }
  /**
   * Creates an internal texture without binding it to a framebuffer
   * @internal
   * @param size defines the size of the texture
   * @param options defines the options used to create the texture
   * @param delayGPUTextureCreation true to delay the texture creation the first time it is really needed. false to create it right away
   * @param source source type of the texture
   * @returns a new internal texture
   */
  _createInternalTexture(e, t, i = !0, s = Ze.Unknown) {
    var r;
    let n = !1, a = 0, o = 3, l = 5, c = !1, u = 1, d;
    t !== void 0 && typeof t == "object" ? (n = !!t.generateMipMaps, a = t.type === void 0 ? 0 : t.type, o = t.samplingMode === void 0 ? 3 : t.samplingMode, l = t.format === void 0 ? 5 : t.format, c = t.useSRGBBuffer === void 0 ? !1 : t.useSRGBBuffer, u = (r = t.samples) !== null && r !== void 0 ? r : 1, d = t.label) : n = !!t, c && (c = this._caps.supportSRGBBuffers && (this.webGLVersion > 1 || this.isWebGPU)), (a === 1 && !this._caps.textureFloatLinearFiltering || a === 2 && !this._caps.textureHalfFloatLinearFiltering) && (o = 1), a === 1 && !this._caps.textureFloat && (a = 0, w.Warn("Float textures are not supported. Type forced to TEXTURETYPE_UNSIGNED_BYTE"));
    const f = this._gl, _ = new zt(this, s), g = e.width || e, m = e.height || e, y = e.layers || 0, x = this._getSamplingParameters(o, n), A = y !== 0 ? f.TEXTURE_2D_ARRAY : f.TEXTURE_2D, T = this._getRGBABufferInternalSizedFormat(a, l, c), M = this._getInternalFormat(l), b = this._getWebGLTextureType(a);
    return this._bindTextureDirectly(A, _), y !== 0 ? (_.is2DArray = !0, f.texImage3D(A, 0, T, g, m, y, 0, M, b, null)) : f.texImage2D(A, 0, T, g, m, 0, M, b, null), f.texParameteri(A, f.TEXTURE_MAG_FILTER, x.mag), f.texParameteri(A, f.TEXTURE_MIN_FILTER, x.min), f.texParameteri(A, f.TEXTURE_WRAP_S, f.CLAMP_TO_EDGE), f.texParameteri(A, f.TEXTURE_WRAP_T, f.CLAMP_TO_EDGE), n && this._gl.generateMipmap(A), this._bindTextureDirectly(A, null), _._useSRGBBuffer = c, _.baseWidth = g, _.baseHeight = m, _.width = g, _.height = m, _.depth = y, _.isReady = !0, _.samples = u, _.generateMipMaps = n, _.samplingMode = o, _.type = a, _.format = l, _.label = d, this._internalTexturesCache.push(_), _;
  }
  /**
   * @internal
   */
  _getUseSRGBBuffer(e, t) {
    return e && this._caps.supportSRGBBuffers && (this.webGLVersion > 1 || this.isWebGPU || t);
  }
  _createTextureBase(e, t, i, s, r = 3, n = null, a = null, o, l, c = null, u = null, d = null, f = null, _, g, m) {
    e = e || "";
    const y = e.substr(0, 5) === "data:", x = e.substr(0, 5) === "blob:", A = y && e.indexOf(";base64,") !== -1, T = u || new zt(this, Ze.Url);
    T !== u && (T.label = e.substring(0, 60));
    const M = e;
    this._transformTextureUrl && !A && !u && !c && (e = this._transformTextureUrl(e)), M !== e && (T._originalUrl = M);
    const b = e.lastIndexOf(".");
    let S = f || (b > -1 ? e.substring(b).toLowerCase() : ""), P = null;
    S.indexOf("?") > -1 && (S = S.split("?")[0]);
    for (const k of Z._TextureLoaders)
      if (k.canLoad(S, _)) {
        P = k;
        break;
      }
    s && s.addPendingData(T), T.url = e, T.generateMipMaps = !t, T.samplingMode = r, T.invertY = i, T._useSRGBBuffer = this._getUseSRGBBuffer(!!m, t), this._doNotHandleContextLost || (T._buffer = c);
    let O = null;
    n && !u && (O = T.onLoadedObservable.add(n)), u || this._internalTexturesCache.push(T);
    const X = (k, Y) => {
      s && s.removePendingData(T), e === M ? (O && T.onLoadedObservable.remove(O), de.UseFallbackTexture && this._createTextureBase(de.FallbackTexture, t, T.invertY, s, r, null, a, o, l, c, T), k = (k || "Unknown error") + (de.UseFallbackTexture ? " - Fallback texture was used" : ""), T.onErrorObservable.notifyObservers({ message: k, exception: Y }), a && a(k, Y)) : (w.Warn(`Failed to load ${e}, falling back to ${M}`), this._createTextureBase(M, t, T.invertY, s, r, n, a, o, l, c, T, d, f, _, g, m));
    };
    if (P) {
      const k = (Y) => {
        P.loadData(Y, T, (se, Te, ve, Oe, Ne, ke) => {
          ke ? X("TextureLoader failed to load data") : o(T, S, s, { width: se, height: Te }, T.invertY, !ve, Oe, () => (Ne(), !1), r);
        }, g);
      };
      c ? c instanceof ArrayBuffer ? k(new Uint8Array(c)) : ArrayBuffer.isView(c) ? k(c) : a && a("Unable to load: only ArrayBuffer or ArrayBufferView is supported", null) : this._loadFile(e, (Y) => k(new Uint8Array(Y)), void 0, s ? s.offlineProvider : void 0, !0, (Y, se) => {
        X("Unable to load " + (Y && Y.responseURL, se));
      });
    } else {
      const k = (Y) => {
        x && !this._doNotHandleContextLost && (T._buffer = Y), o(T, S, s, Y, T.invertY, t, !1, l, r);
      };
      !y || A ? c && (typeof c.decoding == "string" || c.close) ? k(c) : Z._FileToolsLoadImage(e, k, X, s ? s.offlineProvider : null, _, T.invertY && this._features.needsInvertingBitmap ? { imageOrientation: "flipY" } : void 0) : typeof c == "string" || c instanceof ArrayBuffer || ArrayBuffer.isView(c) || c instanceof Blob ? Z._FileToolsLoadImage(c, k, X, s ? s.offlineProvider : null, _, T.invertY && this._features.needsInvertingBitmap ? { imageOrientation: "flipY" } : void 0) : c && k(c);
    }
    return T;
  }
  /**
   * Usually called from Texture.ts.
   * Passed information to create a WebGLTexture
   * @param url defines a value which contains one of the following:
   * * A conventional http URL, e.g. 'http://...' or 'file://...'
   * * A base64 string of in-line texture data, e.g. 'data:image/jpg;base64,/...'
   * * An indicator that data being passed using the buffer parameter, e.g. 'data:mytexture.jpg'
   * @param noMipmap defines a boolean indicating that no mipmaps shall be generated.  Ignored for compressed textures.  They must be in the file
   * @param invertY when true, image is flipped when loaded.  You probably want true. Certain compressed textures may invert this if their default is inverted (eg. ktx)
   * @param scene needed for loading to the correct scene
   * @param samplingMode mode with should be used sample / access the texture (Default: Texture.TRILINEAR_SAMPLINGMODE)
   * @param onLoad optional callback to be called upon successful completion
   * @param onError optional callback to be called upon failure
   * @param buffer a source of a file previously fetched as either a base64 string, an ArrayBuffer (compressed or image format), HTMLImageElement (image format), or a Blob
   * @param fallback an internal argument in case the function must be called again, due to etc1 not having alpha capabilities
   * @param format internal format.  Default: RGB when extension is '.jpg' else RGBA.  Ignored for compressed textures
   * @param forcedExtension defines the extension to use to pick the right loader
   * @param mimeType defines an optional mime type
   * @param loaderOptions options to be passed to the loader
   * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
   * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
   * @returns a InternalTexture for assignment back into BABYLON.Texture
   */
  createTexture(e, t, i, s, r = 3, n = null, a = null, o = null, l = null, c = null, u = null, d, f, _, g) {
    return this._createTextureBase(e, t, i, s, r, n, a, this._prepareWebGLTexture.bind(this), (m, y, x, A, T, M) => {
      const b = this._gl, S = x.width === m && x.height === y, P = c ? this._getInternalFormat(c, T._useSRGBBuffer) : A === ".jpg" && !T._useSRGBBuffer ? b.RGB : T._useSRGBBuffer ? this._glSRGBExtensionValues.SRGB8_ALPHA8 : b.RGBA;
      let D = c ? this._getInternalFormat(c) : A === ".jpg" && !T._useSRGBBuffer ? b.RGB : b.RGBA;
      if (T._useSRGBBuffer && this.webGLVersion === 1 && (D = P), S)
        return b.texImage2D(b.TEXTURE_2D, 0, P, D, b.UNSIGNED_BYTE, x), !1;
      const O = this._caps.maxTextureSize;
      if (x.width > O || x.height > O || !this._supportsHardwareTextureRescaling)
        return this._prepareWorkingCanvas(), !this._workingCanvas || !this._workingContext || (this._workingCanvas.width = m, this._workingCanvas.height = y, this._workingContext.drawImage(x, 0, 0, x.width, x.height, 0, 0, m, y), b.texImage2D(b.TEXTURE_2D, 0, P, D, b.UNSIGNED_BYTE, this._workingCanvas), T.width = m, T.height = y), !1;
      {
        const X = new zt(this, Ze.Temp);
        this._bindTextureDirectly(b.TEXTURE_2D, X, !0), b.texImage2D(b.TEXTURE_2D, 0, P, D, b.UNSIGNED_BYTE, x), this._rescaleTexture(X, T, s, P, () => {
          this._releaseTexture(X), this._bindTextureDirectly(b.TEXTURE_2D, T, !0), M();
        });
      }
      return !0;
    }, o, l, c, u, d, f, g);
  }
  /**
   * Loads an image as an HTMLImageElement.
   * @param input url string, ArrayBuffer, or Blob to load
   * @param onLoad callback called when the image successfully loads
   * @param onError callback called when the image fails to load
   * @param offlineProvider offline provider for caching
   * @param mimeType optional mime type
   * @param imageBitmapOptions optional the options to use when creating an ImageBitmap
   * @returns the HTMLImageElement of the loaded image
   * @internal
   */
  static _FileToolsLoadImage(e, t, i, s, r, n) {
    throw he("FileTools");
  }
  /**
   * @internal
   */
  _rescaleTexture(e, t, i, s, r) {
  }
  /**
   * Creates a raw texture
   * @param data defines the data to store in the texture
   * @param width defines the width of the texture
   * @param height defines the height of the texture
   * @param format defines the format of the data
   * @param generateMipMaps defines if the engine should generate the mip levels
   * @param invertY defines if data must be stored with Y axis inverted
   * @param samplingMode defines the required sampling mode (Texture.NEAREST_SAMPLINGMODE by default)
   * @param compression defines the compression used (null by default)
   * @param type defines the type fo the data (Engine.TEXTURETYPE_UNSIGNED_INT by default)
   * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
   * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
   * @returns the raw texture inside an InternalTexture
   */
  createRawTexture(e, t, i, s, r, n, a, o = null, l = 0, c = 0, u = !1) {
    throw he("Engine.RawTexture");
  }
  /**
   * Creates a new raw cube texture
   * @param data defines the array of data to use to create each face
   * @param size defines the size of the textures
   * @param format defines the format of the data
   * @param type defines the type of the data (like Engine.TEXTURETYPE_UNSIGNED_INT)
   * @param generateMipMaps  defines if the engine should generate the mip levels
   * @param invertY defines if data must be stored with Y axis inverted
   * @param samplingMode defines the required sampling mode (like Texture.NEAREST_SAMPLINGMODE)
   * @param compression defines the compression used (null by default)
   * @returns the cube texture as an InternalTexture
   */
  createRawCubeTexture(e, t, i, s, r, n, a, o = null) {
    throw he("Engine.RawTexture");
  }
  /**
   * Creates a new raw 3D texture
   * @param data defines the data used to create the texture
   * @param width defines the width of the texture
   * @param height defines the height of the texture
   * @param depth defines the depth of the texture
   * @param format defines the format of the texture
   * @param generateMipMaps defines if the engine must generate mip levels
   * @param invertY defines if data must be stored with Y axis inverted
   * @param samplingMode defines the required sampling mode (like Texture.NEAREST_SAMPLINGMODE)
   * @param compression defines the compressed used (can be null)
   * @param textureType defines the compressed used (can be null)
   * @returns a new raw 3D texture (stored in an InternalTexture)
   */
  createRawTexture3D(e, t, i, s, r, n, a, o, l = null, c = 0) {
    throw he("Engine.RawTexture");
  }
  /**
   * Creates a new raw 2D array texture
   * @param data defines the data used to create the texture
   * @param width defines the width of the texture
   * @param height defines the height of the texture
   * @param depth defines the number of layers of the texture
   * @param format defines the format of the texture
   * @param generateMipMaps defines if the engine must generate mip levels
   * @param invertY defines if data must be stored with Y axis inverted
   * @param samplingMode defines the required sampling mode (like Texture.NEAREST_SAMPLINGMODE)
   * @param compression defines the compressed used (can be null)
   * @param textureType defines the compressed used (can be null)
   * @returns a new raw 2D array texture (stored in an InternalTexture)
   */
  createRawTexture2DArray(e, t, i, s, r, n, a, o, l = null, c = 0) {
    throw he("Engine.RawTexture");
  }
  /**
   * @internal
   */
  _unpackFlipY(e) {
    this._unpackFlipYCached !== e && (this._gl.pixelStorei(this._gl.UNPACK_FLIP_Y_WEBGL, e ? 1 : 0), this.enableUnpackFlipYCached && (this._unpackFlipYCached = e));
  }
  /** @internal */
  _getUnpackAlignement() {
    return this._gl.getParameter(this._gl.UNPACK_ALIGNMENT);
  }
  _getTextureTarget(e) {
    return e.isCube ? this._gl.TEXTURE_CUBE_MAP : e.is3D ? this._gl.TEXTURE_3D : e.is2DArray || e.isMultiview ? this._gl.TEXTURE_2D_ARRAY : this._gl.TEXTURE_2D;
  }
  /**
   * Update the sampling mode of a given texture
   * @param samplingMode defines the required sampling mode
   * @param texture defines the texture to update
   * @param generateMipMaps defines whether to generate mipmaps for the texture
   */
  updateTextureSamplingMode(e, t, i = !1) {
    const s = this._getTextureTarget(t), r = this._getSamplingParameters(e, t.useMipMaps || i);
    this._setTextureParameterInteger(s, this._gl.TEXTURE_MAG_FILTER, r.mag, t), this._setTextureParameterInteger(s, this._gl.TEXTURE_MIN_FILTER, r.min), i && (t.generateMipMaps = !0, this._gl.generateMipmap(s)), this._bindTextureDirectly(s, null), t.samplingMode = e;
  }
  /**
   * Update the dimensions of a texture
   * @param texture texture to update
   * @param width new width of the texture
   * @param height new height of the texture
   * @param depth new depth of the texture
   */
  updateTextureDimensions(e, t, i, s = 1) {
  }
  /**
   * Update the sampling mode of a given texture
   * @param texture defines the texture to update
   * @param wrapU defines the texture wrap mode of the u coordinates
   * @param wrapV defines the texture wrap mode of the v coordinates
   * @param wrapR defines the texture wrap mode of the r coordinates
   */
  updateTextureWrappingMode(e, t, i = null, s = null) {
    const r = this._getTextureTarget(e);
    t !== null && (this._setTextureParameterInteger(r, this._gl.TEXTURE_WRAP_S, this._getTextureWrapMode(t), e), e._cachedWrapU = t), i !== null && (this._setTextureParameterInteger(r, this._gl.TEXTURE_WRAP_T, this._getTextureWrapMode(i), e), e._cachedWrapV = i), (e.is2DArray || e.is3D) && s !== null && (this._setTextureParameterInteger(r, this._gl.TEXTURE_WRAP_R, this._getTextureWrapMode(s), e), e._cachedWrapR = s), this._bindTextureDirectly(r, null);
  }
  /**
   * @internal
   */
  _setupDepthStencilTexture(e, t, i, s, r, n = 1) {
    const a = t.width || t, o = t.height || t, l = t.layers || 0;
    e.baseWidth = a, e.baseHeight = o, e.width = a, e.height = o, e.is2DArray = l > 0, e.depth = l, e.isReady = !0, e.samples = n, e.generateMipMaps = !1, e.samplingMode = s ? 2 : 1, e.type = 0, e._comparisonFunction = r;
    const c = this._gl, u = this._getTextureTarget(e), d = this._getSamplingParameters(e.samplingMode, !1);
    c.texParameteri(u, c.TEXTURE_MAG_FILTER, d.mag), c.texParameteri(u, c.TEXTURE_MIN_FILTER, d.min), c.texParameteri(u, c.TEXTURE_WRAP_S, c.CLAMP_TO_EDGE), c.texParameteri(u, c.TEXTURE_WRAP_T, c.CLAMP_TO_EDGE), this.webGLVersion > 1 && (r === 0 ? (c.texParameteri(u, c.TEXTURE_COMPARE_FUNC, 515), c.texParameteri(u, c.TEXTURE_COMPARE_MODE, c.NONE)) : (c.texParameteri(u, c.TEXTURE_COMPARE_FUNC, r), c.texParameteri(u, c.TEXTURE_COMPARE_MODE, c.COMPARE_REF_TO_TEXTURE)));
  }
  /**
   * @internal
   */
  _uploadCompressedDataToTextureDirectly(e, t, i, s, r, n = 0, a = 0) {
    const o = this._gl;
    let l = o.TEXTURE_2D;
    if (e.isCube && (l = o.TEXTURE_CUBE_MAP_POSITIVE_X + n), e._useSRGBBuffer)
      switch (t) {
        case 37492:
        case 36196:
          this._caps.etc2 ? t = o.COMPRESSED_SRGB8_ETC2 : e._useSRGBBuffer = !1;
          break;
        case 37496:
          this._caps.etc2 ? t = o.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : e._useSRGBBuffer = !1;
          break;
        case 36492:
          t = o.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT;
          break;
        case 37808:
          t = o.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR;
          break;
        case 33776:
          this._caps.s3tc_srgb ? t = o.COMPRESSED_SRGB_S3TC_DXT1_EXT : e._useSRGBBuffer = !1;
          break;
        case 33777:
          this._caps.s3tc_srgb ? t = o.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT : e._useSRGBBuffer = !1;
          break;
        case 33779:
          this._caps.s3tc_srgb ? t = o.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT : e._useSRGBBuffer = !1;
          break;
        default:
          e._useSRGBBuffer = !1;
          break;
      }
    this._gl.compressedTexImage2D(l, a, t, i, s, 0, r);
  }
  /**
   * @internal
   */
  _uploadDataToTextureDirectly(e, t, i = 0, s = 0, r, n = !1) {
    const a = this._gl, o = this._getWebGLTextureType(e.type), l = this._getInternalFormat(e.format), c = r === void 0 ? this._getRGBABufferInternalSizedFormat(e.type, e.format, e._useSRGBBuffer) : this._getInternalFormat(r, e._useSRGBBuffer);
    this._unpackFlipY(e.invertY);
    let u = a.TEXTURE_2D;
    e.isCube && (u = a.TEXTURE_CUBE_MAP_POSITIVE_X + i);
    const d = Math.round(Math.log(e.width) * Math.LOG2E), f = Math.round(Math.log(e.height) * Math.LOG2E), _ = n ? e.width : Math.pow(2, Math.max(d - s, 0)), g = n ? e.height : Math.pow(2, Math.max(f - s, 0));
    a.texImage2D(u, s, c, _, g, 0, l, o, t);
  }
  /**
   * Update a portion of an internal texture
   * @param texture defines the texture to update
   * @param imageData defines the data to store into the texture
   * @param xOffset defines the x coordinates of the update rectangle
   * @param yOffset defines the y coordinates of the update rectangle
   * @param width defines the width of the update rectangle
   * @param height defines the height of the update rectangle
   * @param faceIndex defines the face index if texture is a cube (0 by default)
   * @param lod defines the lod level to update (0 by default)
   * @param generateMipMaps defines whether to generate mipmaps or not
   */
  updateTextureData(e, t, i, s, r, n, a = 0, o = 0, l = !1) {
    const c = this._gl, u = this._getWebGLTextureType(e.type), d = this._getInternalFormat(e.format);
    this._unpackFlipY(e.invertY);
    let f = c.TEXTURE_2D, _ = c.TEXTURE_2D;
    e.isCube && (_ = c.TEXTURE_CUBE_MAP_POSITIVE_X + a, f = c.TEXTURE_CUBE_MAP), this._bindTextureDirectly(f, e, !0), c.texSubImage2D(_, o, i, s, r, n, d, u, t), l && this._gl.generateMipmap(_), this._bindTextureDirectly(f, null);
  }
  /**
   * @internal
   */
  _uploadArrayBufferViewToTexture(e, t, i = 0, s = 0) {
    const r = this._gl, n = e.isCube ? r.TEXTURE_CUBE_MAP : r.TEXTURE_2D;
    this._bindTextureDirectly(n, e, !0), this._uploadDataToTextureDirectly(e, t, i, s), this._bindTextureDirectly(n, null, !0);
  }
  _prepareWebGLTextureContinuation(e, t, i, s, r) {
    const n = this._gl;
    if (!n)
      return;
    const a = this._getSamplingParameters(r, !i);
    n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, a.mag), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, a.min), !i && !s && n.generateMipmap(n.TEXTURE_2D), this._bindTextureDirectly(n.TEXTURE_2D, null), t && t.removePendingData(e), e.onLoadedObservable.notifyObservers(e), e.onLoadedObservable.clear();
  }
  _prepareWebGLTexture(e, t, i, s, r, n, a, o, l = 3) {
    const c = this.getCaps().maxTextureSize, u = Math.min(c, this.needPOTTextures ? Z.GetExponentOfTwo(s.width, c) : s.width), d = Math.min(c, this.needPOTTextures ? Z.GetExponentOfTwo(s.height, c) : s.height), f = this._gl;
    if (f) {
      if (!e._hardwareTexture) {
        i && i.removePendingData(e);
        return;
      }
      this._bindTextureDirectly(f.TEXTURE_2D, e, !0), this._unpackFlipY(r === void 0 ? !0 : !!r), e.baseWidth = s.width, e.baseHeight = s.height, e.width = u, e.height = d, e.isReady = !0, !o(u, d, s, t, e, () => {
        this._prepareWebGLTextureContinuation(e, i, n, a, l);
      }) && this._prepareWebGLTextureContinuation(e, i, n, a, l);
    }
  }
  /**
   * @internal
   */
  _setupFramebufferDepthAttachments(e, t, i, s, r = 1) {
    const n = this._gl;
    if (e && t)
      return this._createRenderBuffer(i, s, r, n.DEPTH_STENCIL, n.DEPTH24_STENCIL8, n.DEPTH_STENCIL_ATTACHMENT);
    if (t) {
      let a = n.DEPTH_COMPONENT16;
      return this._webGLVersion > 1 && (a = n.DEPTH_COMPONENT32F), this._createRenderBuffer(i, s, r, a, a, n.DEPTH_ATTACHMENT);
    }
    return e ? this._createRenderBuffer(i, s, r, n.STENCIL_INDEX8, n.STENCIL_INDEX8, n.STENCIL_ATTACHMENT) : null;
  }
  /**
   * @internal
   */
  _createRenderBuffer(e, t, i, s, r, n, a = !0) {
    const l = this._gl.createRenderbuffer();
    return this._updateRenderBuffer(l, e, t, i, s, r, n, a);
  }
  _updateRenderBuffer(e, t, i, s, r, n, a, o = !0) {
    const l = this._gl;
    return l.bindRenderbuffer(l.RENDERBUFFER, e), s > 1 && l.renderbufferStorageMultisample ? l.renderbufferStorageMultisample(l.RENDERBUFFER, s, n, t, i) : l.renderbufferStorage(l.RENDERBUFFER, r, t, i), l.framebufferRenderbuffer(l.FRAMEBUFFER, a, l.RENDERBUFFER, e), o && l.bindRenderbuffer(l.RENDERBUFFER, null), e;
  }
  /**
   * @internal
   */
  _releaseTexture(e) {
    var t;
    this._deleteTexture((t = e._hardwareTexture) === null || t === void 0 ? void 0 : t.underlyingResource), this.unbindAllTextures();
    const i = this._internalTexturesCache.indexOf(e);
    i !== -1 && this._internalTexturesCache.splice(i, 1), e._lodTextureHigh && e._lodTextureHigh.dispose(), e._lodTextureMid && e._lodTextureMid.dispose(), e._lodTextureLow && e._lodTextureLow.dispose(), e._irradianceTexture && e._irradianceTexture.dispose();
  }
  /**
   * @internal
   */
  _releaseRenderTargetWrapper(e) {
    const t = this._renderTargetWrapperCache.indexOf(e);
    t !== -1 && this._renderTargetWrapperCache.splice(t, 1);
  }
  _deleteTexture(e) {
    e && this._gl.deleteTexture(e);
  }
  _setProgram(e) {
    this._currentProgram !== e && (this._gl.useProgram(e), this._currentProgram = e);
  }
  /**
   * Binds an effect to the webGL context
   * @param effect defines the effect to bind
   */
  bindSamplers(e) {
    const t = e.getPipelineContext();
    this._setProgram(t.program);
    const i = e.getSamplers();
    for (let s = 0; s < i.length; s++) {
      const r = e.getUniform(i[s]);
      r && (this._boundUniforms[s] = r);
    }
    this._currentEffect = null;
  }
  _activateCurrentTexture() {
    this._currentTextureChannel !== this._activeChannel && (this._gl.activeTexture(this._gl.TEXTURE0 + this._activeChannel), this._currentTextureChannel = this._activeChannel);
  }
  /**
   * @internal
   */
  _bindTextureDirectly(e, t, i = !1, s = !1) {
    var r, n;
    let a = !1;
    const o = t && t._associatedChannel > -1;
    if (i && o && (this._activeChannel = t._associatedChannel), this._boundTexturesCache[this._activeChannel] !== t || s) {
      if (this._activateCurrentTexture(), t && t.isMultiview)
        throw console.error(e, t), "_bindTextureDirectly called with a multiview texture!";
      this._gl.bindTexture(e, (n = (r = t == null ? void 0 : t._hardwareTexture) === null || r === void 0 ? void 0 : r.underlyingResource) !== null && n !== void 0 ? n : null), this._boundTexturesCache[this._activeChannel] = t, t && (t._associatedChannel = this._activeChannel);
    } else i && (a = !0, this._activateCurrentTexture());
    return o && !i && this._bindSamplerUniformToChannel(t._associatedChannel, this._activeChannel), a;
  }
  /**
   * @internal
   */
  _bindTexture(e, t, i) {
    if (e === void 0)
      return;
    t && (t._associatedChannel = e), this._activeChannel = e;
    const s = t ? this._getTextureTarget(t) : this._gl.TEXTURE_2D;
    this._bindTextureDirectly(s, t);
  }
  /**
   * Unbind all textures from the webGL context
   */
  unbindAllTextures() {
    for (let e = 0; e < this._maxSimultaneousTextures; e++)
      this._activeChannel = e, this._bindTextureDirectly(this._gl.TEXTURE_2D, null), this._bindTextureDirectly(this._gl.TEXTURE_CUBE_MAP, null), this.webGLVersion > 1 && (this._bindTextureDirectly(this._gl.TEXTURE_3D, null), this._bindTextureDirectly(this._gl.TEXTURE_2D_ARRAY, null));
  }
  /**
   * Sets a texture to the according uniform.
   * @param channel The texture channel
   * @param uniform The uniform to set
   * @param texture The texture to apply
   * @param name The name of the uniform in the effect
   */
  setTexture(e, t, i, s) {
    e !== void 0 && (t && (this._boundUniforms[e] = t), this._setTexture(e, i));
  }
  _bindSamplerUniformToChannel(e, t) {
    const i = this._boundUniforms[e];
    !i || i._currentState === t || (this._gl.uniform1i(i, t), i._currentState = t);
  }
  _getTextureWrapMode(e) {
    switch (e) {
      case 1:
        return this._gl.REPEAT;
      case 0:
        return this._gl.CLAMP_TO_EDGE;
      case 2:
        return this._gl.MIRRORED_REPEAT;
    }
    return this._gl.REPEAT;
  }
  _setTexture(e, t, i = !1, s = !1, r = "") {
    if (!t)
      return this._boundTexturesCache[e] != null && (this._activeChannel = e, this._bindTextureDirectly(this._gl.TEXTURE_2D, null), this._bindTextureDirectly(this._gl.TEXTURE_CUBE_MAP, null), this.webGLVersion > 1 && (this._bindTextureDirectly(this._gl.TEXTURE_3D, null), this._bindTextureDirectly(this._gl.TEXTURE_2D_ARRAY, null))), !1;
    if (t.video) {
      this._activeChannel = e;
      const l = t.getInternalTexture();
      l && (l._associatedChannel = e), t.update();
    } else if (t.delayLoadState === 4)
      return t.delayLoad(), !1;
    let n;
    s ? n = t.depthStencilTexture : t.isReady() ? n = t.getInternalTexture() : t.isCube ? n = this.emptyCubeTexture : t.is3D ? n = this.emptyTexture3D : t.is2DArray ? n = this.emptyTexture2DArray : n = this.emptyTexture, !i && n && (n._associatedChannel = e);
    let a = !0;
    this._boundTexturesCache[e] === n && (i || this._bindSamplerUniformToChannel(n._associatedChannel, e), a = !1), this._activeChannel = e;
    const o = this._getTextureTarget(n);
    if (a && this._bindTextureDirectly(o, n, i), n && !n.isMultiview) {
      if (n.isCube && n._cachedCoordinatesMode !== t.coordinatesMode) {
        n._cachedCoordinatesMode = t.coordinatesMode;
        const l = t.coordinatesMode !== 3 && t.coordinatesMode !== 5 ? 1 : 0;
        t.wrapU = l, t.wrapV = l;
      }
      n._cachedWrapU !== t.wrapU && (n._cachedWrapU = t.wrapU, this._setTextureParameterInteger(o, this._gl.TEXTURE_WRAP_S, this._getTextureWrapMode(t.wrapU), n)), n._cachedWrapV !== t.wrapV && (n._cachedWrapV = t.wrapV, this._setTextureParameterInteger(o, this._gl.TEXTURE_WRAP_T, this._getTextureWrapMode(t.wrapV), n)), n.is3D && n._cachedWrapR !== t.wrapR && (n._cachedWrapR = t.wrapR, this._setTextureParameterInteger(o, this._gl.TEXTURE_WRAP_R, this._getTextureWrapMode(t.wrapR), n)), this._setAnisotropicLevel(o, n, t.anisotropicFilteringLevel);
    }
    return !0;
  }
  /**
   * Sets an array of texture to the webGL context
   * @param channel defines the channel where the texture array must be set
   * @param uniform defines the associated uniform location
   * @param textures defines the array of textures to bind
   * @param name name of the channel
   */
  setTextureArray(e, t, i, s) {
    if (!(e === void 0 || !t)) {
      (!this._textureUnits || this._textureUnits.length !== i.length) && (this._textureUnits = new Int32Array(i.length));
      for (let r = 0; r < i.length; r++) {
        const n = i[r].getInternalTexture();
        n ? (this._textureUnits[r] = e + r, n._associatedChannel = e + r) : this._textureUnits[r] = -1;
      }
      this._gl.uniform1iv(t, this._textureUnits);
      for (let r = 0; r < i.length; r++)
        this._setTexture(this._textureUnits[r], i[r], !0);
    }
  }
  /**
   * @internal
   */
  _setAnisotropicLevel(e, t, i) {
    const s = this._caps.textureAnisotropicFilterExtension;
    t.samplingMode !== 11 && t.samplingMode !== 3 && t.samplingMode !== 2 && (i = 1), s && t._cachedAnisotropicFilteringLevel !== i && (this._setTextureParameterFloat(e, s.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(i, this._caps.maxAnisotropy), t), t._cachedAnisotropicFilteringLevel = i);
  }
  _setTextureParameterFloat(e, t, i, s) {
    this._bindTextureDirectly(e, s, !0, !0), this._gl.texParameterf(e, t, i);
  }
  _setTextureParameterInteger(e, t, i, s) {
    s && this._bindTextureDirectly(e, s, !0, !0), this._gl.texParameteri(e, t, i);
  }
  /**
   * Unbind all vertex attributes from the webGL context
   */
  unbindAllAttributes() {
    if (this._mustWipeVertexAttributes) {
      this._mustWipeVertexAttributes = !1;
      for (let e = 0; e < this._caps.maxVertexAttribs; e++)
        this.disableAttributeByIndex(e);
      return;
    }
    for (let e = 0, t = this._vertexAttribArraysEnabled.length; e < t; e++)
      e >= this._caps.maxVertexAttribs || !this._vertexAttribArraysEnabled[e] || this.disableAttributeByIndex(e);
  }
  /**
   * Force the engine to release all cached effects. This means that next effect compilation will have to be done completely even if a similar effect was already compiled
   */
  releaseEffects() {
    for (const e in this._compiledEffects) {
      const t = this._compiledEffects[e].getPipelineContext();
      this._deletePipelineContext(t);
    }
    this._compiledEffects = {};
  }
  /**
   * Dispose and release all associated resources
   */
  dispose() {
    var e;
    this._isDisposed = !0, this.stopRenderLoop(), this.onBeforeTextureInitObservable && this.onBeforeTextureInitObservable.clear(), this._emptyTexture && (this._releaseTexture(this._emptyTexture), this._emptyTexture = null), this._emptyCubeTexture && (this._releaseTexture(this._emptyCubeTexture), this._emptyCubeTexture = null), this._dummyFramebuffer && this._gl.deleteFramebuffer(this._dummyFramebuffer), this.releaseEffects(), (e = this.releaseComputeEffects) === null || e === void 0 || e.call(this), this.unbindAllAttributes(), this._boundUniforms = {}, _t() && this._renderingCanvas && (this._doNotHandleContextLost || (this._renderingCanvas.removeEventListener("webglcontextlost", this._onContextLost), this._renderingCanvas.removeEventListener("webglcontextrestored", this._onContextRestored)), window.removeEventListener("resize", this._checkForMobile)), this._workingCanvas = null, this._workingContext = null, this._currentBufferPointers.length = 0, this._renderingCanvas = null, this._currentProgram = null, this._boundRenderFunction = null, yt.ResetCache();
    for (const t of this._activeRequests)
      t.abort();
    this.onDisposeObservable.notifyObservers(this), this.onDisposeObservable.clear();
  }
  /**
   * Attach a new callback raised when context lost event is fired
   * @param callback defines the callback to call
   */
  attachContextLostEvent(e) {
    this._renderingCanvas && this._renderingCanvas.addEventListener("webglcontextlost", e, !1);
  }
  /**
   * Attach a new callback raised when context restored event is fired
   * @param callback defines the callback to call
   */
  attachContextRestoredEvent(e) {
    this._renderingCanvas && this._renderingCanvas.addEventListener("webglcontextrestored", e, !1);
  }
  /**
   * Get the current error code of the webGL context
   * @returns the error code
   * @see https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/getError
   */
  getError() {
    return this._gl.getError();
  }
  _canRenderToFloatFramebuffer() {
    return this._webGLVersion > 1 ? this._caps.colorBufferFloat : this._canRenderToFramebuffer(1);
  }
  _canRenderToHalfFloatFramebuffer() {
    return this._webGLVersion > 1 ? this._caps.colorBufferFloat : this._canRenderToFramebuffer(2);
  }
  // Thank you : http://stackoverflow.com/questions/28827511/webgl-ios-render-to-floating-point-texture
  _canRenderToFramebuffer(e) {
    const t = this._gl;
    for (; t.getError() !== t.NO_ERROR; )
      ;
    let i = !0;
    const s = t.createTexture();
    t.bindTexture(t.TEXTURE_2D, s), t.texImage2D(t.TEXTURE_2D, 0, this._getRGBABufferInternalSizedFormat(e), 1, 1, 0, t.RGBA, this._getWebGLTextureType(e), null), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.NEAREST), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.NEAREST);
    const r = t.createFramebuffer();
    t.bindFramebuffer(t.FRAMEBUFFER, r), t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, s, 0);
    const n = t.checkFramebufferStatus(t.FRAMEBUFFER);
    if (i = i && n === t.FRAMEBUFFER_COMPLETE, i = i && t.getError() === t.NO_ERROR, i && (t.clear(t.COLOR_BUFFER_BIT), i = i && t.getError() === t.NO_ERROR), i) {
      t.bindFramebuffer(t.FRAMEBUFFER, null);
      const a = t.RGBA, o = t.UNSIGNED_BYTE, l = new Uint8Array(4);
      t.readPixels(0, 0, 1, 1, a, o, l), i = i && t.getError() === t.NO_ERROR;
    }
    for (t.deleteTexture(s), t.deleteFramebuffer(r), t.bindFramebuffer(t.FRAMEBUFFER, null); !i && t.getError() !== t.NO_ERROR; )
      ;
    return i;
  }
  /**
   * @internal
   */
  _getWebGLTextureType(e) {
    if (this._webGLVersion === 1) {
      switch (e) {
        case 1:
          return this._gl.FLOAT;
        case 2:
          return this._gl.HALF_FLOAT_OES;
        case 0:
          return this._gl.UNSIGNED_BYTE;
        case 8:
          return this._gl.UNSIGNED_SHORT_4_4_4_4;
        case 9:
          return this._gl.UNSIGNED_SHORT_5_5_5_1;
        case 10:
          return this._gl.UNSIGNED_SHORT_5_6_5;
      }
      return this._gl.UNSIGNED_BYTE;
    }
    switch (e) {
      case 3:
        return this._gl.BYTE;
      case 0:
        return this._gl.UNSIGNED_BYTE;
      case 4:
        return this._gl.SHORT;
      case 5:
        return this._gl.UNSIGNED_SHORT;
      case 6:
        return this._gl.INT;
      case 7:
        return this._gl.UNSIGNED_INT;
      case 1:
        return this._gl.FLOAT;
      case 2:
        return this._gl.HALF_FLOAT;
      case 8:
        return this._gl.UNSIGNED_SHORT_4_4_4_4;
      case 9:
        return this._gl.UNSIGNED_SHORT_5_5_5_1;
      case 10:
        return this._gl.UNSIGNED_SHORT_5_6_5;
      case 11:
        return this._gl.UNSIGNED_INT_2_10_10_10_REV;
      case 12:
        return this._gl.UNSIGNED_INT_24_8;
      case 13:
        return this._gl.UNSIGNED_INT_10F_11F_11F_REV;
      case 14:
        return this._gl.UNSIGNED_INT_5_9_9_9_REV;
      case 15:
        return this._gl.FLOAT_32_UNSIGNED_INT_24_8_REV;
    }
    return this._gl.UNSIGNED_BYTE;
  }
  /**
   * @internal
   */
  _getInternalFormat(e, t = !1) {
    let i = t ? this._glSRGBExtensionValues.SRGB8_ALPHA8 : this._gl.RGBA;
    switch (e) {
      case 0:
        i = this._gl.ALPHA;
        break;
      case 1:
        i = this._gl.LUMINANCE;
        break;
      case 2:
        i = this._gl.LUMINANCE_ALPHA;
        break;
      case 6:
        i = this._gl.RED;
        break;
      case 7:
        i = this._gl.RG;
        break;
      case 4:
        i = t ? this._glSRGBExtensionValues.SRGB : this._gl.RGB;
        break;
      case 5:
        i = t ? this._glSRGBExtensionValues.SRGB8_ALPHA8 : this._gl.RGBA;
        break;
    }
    if (this._webGLVersion > 1)
      switch (e) {
        case 8:
          i = this._gl.RED_INTEGER;
          break;
        case 9:
          i = this._gl.RG_INTEGER;
          break;
        case 10:
          i = this._gl.RGB_INTEGER;
          break;
        case 11:
          i = this._gl.RGBA_INTEGER;
          break;
      }
    return i;
  }
  /**
   * @internal
   */
  _getRGBABufferInternalSizedFormat(e, t, i = !1) {
    if (this._webGLVersion === 1) {
      if (t !== void 0)
        switch (t) {
          case 0:
            return this._gl.ALPHA;
          case 1:
            return this._gl.LUMINANCE;
          case 2:
            return this._gl.LUMINANCE_ALPHA;
          case 4:
            return i ? this._glSRGBExtensionValues.SRGB : this._gl.RGB;
        }
      return this._gl.RGBA;
    }
    switch (e) {
      case 3:
        switch (t) {
          case 6:
            return this._gl.R8_SNORM;
          case 7:
            return this._gl.RG8_SNORM;
          case 4:
            return this._gl.RGB8_SNORM;
          case 8:
            return this._gl.R8I;
          case 9:
            return this._gl.RG8I;
          case 10:
            return this._gl.RGB8I;
          case 11:
            return this._gl.RGBA8I;
          default:
            return this._gl.RGBA8_SNORM;
        }
      case 0:
        switch (t) {
          case 6:
            return this._gl.R8;
          case 7:
            return this._gl.RG8;
          case 4:
            return i ? this._glSRGBExtensionValues.SRGB8 : this._gl.RGB8;
          case 5:
            return i ? this._glSRGBExtensionValues.SRGB8_ALPHA8 : this._gl.RGBA8;
          case 8:
            return this._gl.R8UI;
          case 9:
            return this._gl.RG8UI;
          case 10:
            return this._gl.RGB8UI;
          case 11:
            return this._gl.RGBA8UI;
          case 0:
            return this._gl.ALPHA;
          case 1:
            return this._gl.LUMINANCE;
          case 2:
            return this._gl.LUMINANCE_ALPHA;
          default:
            return this._gl.RGBA8;
        }
      case 4:
        switch (t) {
          case 8:
            return this._gl.R16I;
          case 9:
            return this._gl.RG16I;
          case 10:
            return this._gl.RGB16I;
          case 11:
            return this._gl.RGBA16I;
          default:
            return this._gl.RGBA16I;
        }
      case 5:
        switch (t) {
          case 8:
            return this._gl.R16UI;
          case 9:
            return this._gl.RG16UI;
          case 10:
            return this._gl.RGB16UI;
          case 11:
            return this._gl.RGBA16UI;
          default:
            return this._gl.RGBA16UI;
        }
      case 6:
        switch (t) {
          case 8:
            return this._gl.R32I;
          case 9:
            return this._gl.RG32I;
          case 10:
            return this._gl.RGB32I;
          case 11:
            return this._gl.RGBA32I;
          default:
            return this._gl.RGBA32I;
        }
      case 7:
        switch (t) {
          case 8:
            return this._gl.R32UI;
          case 9:
            return this._gl.RG32UI;
          case 10:
            return this._gl.RGB32UI;
          case 11:
            return this._gl.RGBA32UI;
          default:
            return this._gl.RGBA32UI;
        }
      case 1:
        switch (t) {
          case 6:
            return this._gl.R32F;
          case 7:
            return this._gl.RG32F;
          case 4:
            return this._gl.RGB32F;
          case 5:
            return this._gl.RGBA32F;
          default:
            return this._gl.RGBA32F;
        }
      case 2:
        switch (t) {
          case 6:
            return this._gl.R16F;
          case 7:
            return this._gl.RG16F;
          case 4:
            return this._gl.RGB16F;
          case 5:
            return this._gl.RGBA16F;
          default:
            return this._gl.RGBA16F;
        }
      case 10:
        return this._gl.RGB565;
      case 13:
        return this._gl.R11F_G11F_B10F;
      case 14:
        return this._gl.RGB9_E5;
      case 8:
        return this._gl.RGBA4;
      case 9:
        return this._gl.RGB5_A1;
      case 11:
        switch (t) {
          case 5:
            return this._gl.RGB10_A2;
          case 11:
            return this._gl.RGB10_A2UI;
          default:
            return this._gl.RGB10_A2;
        }
    }
    return i ? this._glSRGBExtensionValues.SRGB8_ALPHA8 : this._gl.RGBA8;
  }
  /**
   * @internal
   */
  _getRGBAMultiSampleBufferFormat(e, t = 5) {
    switch (e) {
      case 1:
        switch (t) {
          case 6:
            return this._gl.R32F;
          default:
            return this._gl.RGBA32F;
        }
      case 2:
        switch (t) {
          case 6:
            return this._gl.R16F;
          default:
            return this._gl.RGBA16F;
        }
    }
    return this._gl.RGBA8;
  }
  /**
   * @internal
   */
  _loadFile(e, t, i, s, r, n) {
    const a = Z._FileToolsLoadFile(e, t, i, s, r, n);
    return this._activeRequests.push(a), a.onCompleteObservable.add((o) => {
      this._activeRequests.splice(this._activeRequests.indexOf(o), 1);
    }), a;
  }
  /**
   * Loads a file from a url
   * @param url url to load
   * @param onSuccess callback called when the file successfully loads
   * @param onProgress callback called while file is loading (if the server supports this mode)
   * @param offlineProvider defines the offline provider for caching
   * @param useArrayBuffer defines a boolean indicating that date must be returned as ArrayBuffer
   * @param onError callback called when the file fails to load
   * @returns a file request object
   * @internal
   */
  static _FileToolsLoadFile(e, t, i, s, r, n) {
    throw he("FileTools");
  }
  /**
   * Reads pixels from the current frame buffer. Please note that this function can be slow
   * @param x defines the x coordinate of the rectangle where pixels must be read
   * @param y defines the y coordinate of the rectangle where pixels must be read
   * @param width defines the width of the rectangle where pixels must be read
   * @param height defines the height of the rectangle where pixels must be read
   * @param hasAlpha defines whether the output should have alpha or not (defaults to true)
   * @param flushRenderer true to flush the renderer from the pending commands before reading the pixels
   * @returns a ArrayBufferView promise (Uint8Array) containing RGBA colors
   */
  readPixels(e, t, i, s, r = !0, n = !0) {
    const a = r ? 4 : 3, o = r ? this._gl.RGBA : this._gl.RGB, l = new Uint8Array(s * i * a);
    return n && this.flushFramebuffer(), this._gl.readPixels(e, t, i, s, o, this._gl.UNSIGNED_BYTE, l), Promise.resolve(l);
  }
  /**
   * Gets a Promise<boolean> indicating if the engine can be instantiated (ie. if a webGL context can be found)
   */
  static get IsSupportedAsync() {
    return Promise.resolve(this.isSupported());
  }
  /**
   * Gets a boolean indicating if the engine can be instantiated (ie. if a webGL context can be found)
   */
  static get IsSupported() {
    return this.isSupported();
  }
  /**
   * Gets a boolean indicating if the engine can be instantiated (ie. if a webGL context can be found)
   * @returns true if the engine can be created
   * @ignorenaming
   */
  // eslint-disable-next-line @typescript-eslint/naming-convention
  static isSupported() {
    if (this._HasMajorPerformanceCaveat !== null)
      return !this._HasMajorPerformanceCaveat;
    if (this._IsSupported === null)
      try {
        const e = this._CreateCanvas(1, 1), t = e.getContext("webgl") || e.getContext("experimental-webgl");
        this._IsSupported = t != null && !!window.WebGLRenderingContext;
      } catch {
        this._IsSupported = !1;
      }
    return this._IsSupported;
  }
  /**
   * Gets a boolean indicating if the engine can be instantiated on a performant device (ie. if a webGL context can be found and it does not use a slow implementation)
   */
  static get HasMajorPerformanceCaveat() {
    if (this._HasMajorPerformanceCaveat === null)
      try {
        const e = this._CreateCanvas(1, 1), t = e.getContext("webgl", { failIfMajorPerformanceCaveat: !0 }) || e.getContext("experimental-webgl", { failIfMajorPerformanceCaveat: !0 });
        this._HasMajorPerformanceCaveat = !t;
      } catch {
        this._HasMajorPerformanceCaveat = !1;
      }
    return this._HasMajorPerformanceCaveat;
  }
  /**
   * Find the next highest power of two.
   * @param x Number to start search from.
   * @returns Next highest power of two.
   */
  static CeilingPOT(e) {
    return e--, e |= e >> 1, e |= e >> 2, e |= e >> 4, e |= e >> 8, e |= e >> 16, e++, e;
  }
  /**
   * Find the next lowest power of two.
   * @param x Number to start search from.
   * @returns Next lowest power of two.
   */
  static FloorPOT(e) {
    return e = e | e >> 1, e = e | e >> 2, e = e | e >> 4, e = e | e >> 8, e = e | e >> 16, e - (e >> 1);
  }
  /**
   * Find the nearest power of two.
   * @param x Number to start search from.
   * @returns Next nearest power of two.
   */
  static NearestPOT(e) {
    const t = Z.CeilingPOT(e), i = Z.FloorPOT(e);
    return t - e > e - i ? i : t;
  }
  /**
   * Get the closest exponent of two
   * @param value defines the value to approximate
   * @param max defines the maximum value to return
   * @param mode defines how to define the closest value
   * @returns closest exponent of two of the given value
   */
  static GetExponentOfTwo(e, t, i = 2) {
    let s;
    switch (i) {
      case 1:
        s = Z.FloorPOT(e);
        break;
      case 2:
        s = Z.NearestPOT(e);
        break;
      case 3:
      default:
        s = Z.CeilingPOT(e);
        break;
    }
    return Math.min(s, t);
  }
  /**
   * Queue a new function into the requested animation frame pool (ie. this function will be executed by the browser (or the javascript engine) for the next frame)
   * @param func - the function to be called
   * @param requester - the object that will request the next frame. Falls back to window.
   * @returns frame number
   */
  static QueueNewFrame(e, t) {
    if (_t()) {
      const { requestAnimationFrame: i } = t || window;
      if (typeof i == "function")
        return i(e);
    } else if (typeof requestAnimationFrame == "function")
      return requestAnimationFrame(e);
    return setTimeout(e, 16);
  }
  /**
   * Gets host document
   * @returns the host document object
   */
  getHostDocument() {
    return this._renderingCanvas && this._renderingCanvas.ownerDocument ? this._renderingCanvas.ownerDocument : Rs() ? document : null;
  }
}
Z._TempClearColorUint32 = new Uint32Array(4);
Z._TempClearColorInt32 = new Int32Array(4);
Z.ExceptionList = [
  { key: "Chrome/63.0", capture: "63\\.0\\.3239\\.(\\d+)", captureConstraint: 108, targets: ["uniformBuffer"] },
  { key: "Firefox/58", capture: null, captureConstraint: null, targets: ["uniformBuffer"] },
  { key: "Firefox/59", capture: null, captureConstraint: null, targets: ["uniformBuffer"] },
  { key: "Chrome/72.+?Mobile", capture: null, captureConstraint: null, targets: ["vao"] },
  { key: "Chrome/73.+?Mobile", capture: null, captureConstraint: null, targets: ["vao"] },
  { key: "Chrome/74.+?Mobile", capture: null, captureConstraint: null, targets: ["vao"] },
  { key: "Mac OS.+Chrome/71", capture: null, captureConstraint: null, targets: ["vao"] },
  { key: "Mac OS.+Chrome/72", capture: null, captureConstraint: null, targets: ["vao"] },
  { key: "Mac OS.+Chrome", capture: null, captureConstraint: null, targets: ["uniformBuffer"] },
  // desktop osx safari 15.4
  { key: ".*AppleWebKit.*(15.4).*Safari", capture: null, captureConstraint: null, targets: ["antialias", "maxMSAASamples"] },
  // mobile browsers using safari 15.4 on ios
  { key: ".*(15.4).*AppleWebKit.*Safari", capture: null, captureConstraint: null, targets: ["antialias", "maxMSAASamples"] }
];
Z._TextureLoaders = [];
Z.CollisionsEpsilon = 1e-3;
Z._IsSupported = null;
Z._HasMajorPerformanceCaveat = null;
class xr {
  /**
   * Polyfill for setImmediate
   * @param action defines the action to execute after the current execution block
   */
  static SetImmediate(e) {
    _t() && window.setImmediate ? window.setImmediate(e) : setTimeout(e, 1);
  }
}
const La = new RegExp(/^data:([^,]+\/[^,]+)?;base64,/i);
class br extends Ei {
  /**
   * Creates a new LoadFileError
   * @param message defines the message of the error
   * @param object defines the optional web request
   */
  constructor(e, t) {
    super(e, Yi.LoadFileError), this.name = "LoadFileError", ps._setPrototypeOf(this, br.prototype), t instanceof mt ? this.request = t : this.file = t;
  }
}
class Tr extends Ei {
  /**
   * Creates a new LoadFileError
   * @param message defines the message of the error
   * @param request defines the optional web request
   */
  constructor(e, t) {
    super(e, Yi.RequestFileError), this.request = t, this.name = "RequestFileError", ps._setPrototypeOf(this, Tr.prototype);
  }
}
class Rn extends Ei {
  /**
   * Creates a new ReadFileError
   * @param message defines the message of the error
   * @param file defines the optional file
   */
  constructor(e, t) {
    super(e, Yi.ReadFileError), this.file = t, this.name = "ReadFileError", ps._setPrototypeOf(this, Rn.prototype);
  }
}
const pt = {
  /**
   * Gets or sets the retry strategy to apply when an error happens while loading an asset.
   * When defining this function, return the wait time before trying again or return -1 to
   * stop retrying and error out.
   */
  DefaultRetryStrategy: Zo.ExponentialBackoff(),
  /**
   * Gets or sets the base URL to use to load assets
   */
  BaseUrl: "",
  /**
   * Default behaviour for cors in the application.
   * It can be a string if the expected behavior is identical in the entire app.
   * Or a callback to be able to set it per url or on a group of them (in case of Video source for instance)
   */
  CorsBehavior: "anonymous",
  /**
   * Gets or sets a function used to pre-process url before using them to load assets
   * @param url
   */
  PreprocessUrl: (h) => h
}, Na = (h) => (h = h.replace(/#/gm, "%23"), h), In = (h, e) => {
  if (!(h && h.indexOf("data:") === 0) && pt.CorsBehavior)
    if (typeof pt.CorsBehavior == "string" || pt.CorsBehavior instanceof String)
      e.crossOrigin = pt.CorsBehavior;
    else {
      const t = pt.CorsBehavior(h);
      t && (e.crossOrigin = t);
    }
}, Pr = (h, e, t, i, s = "", r) => {
  var n;
  let a, o = !1;
  h instanceof ArrayBuffer || ArrayBuffer.isView(h) ? typeof Blob < "u" && typeof URL < "u" ? (a = URL.createObjectURL(new Blob([h], { type: s })), o = !0) : a = `data:${s};base64,` + wa(h) : h instanceof Blob ? (a = URL.createObjectURL(h), o = !0) : (a = Na(h), a = pt.PreprocessUrl(h));
  const l = de.LastCreatedEngine, c = (b) => {
    if (t) {
      const S = a || h.toString();
      t(`Error while trying to load image: ${S.indexOf("http") === 0 || S.length <= 128 ? S : S.slice(0, 128) + "..."}`, b);
    }
  };
  if (typeof Image > "u" || (n = l == null ? void 0 : l._features.forceBitmapOverHTMLImageElement) !== null && n !== void 0 && n)
    return ki(a, (b) => {
      l.createImageBitmap(new Blob([b], { type: s }), Object.assign({ premultiplyAlpha: "none" }, r)).then((S) => {
        e(S), o && URL.revokeObjectURL(a);
      }).catch((S) => {
        t && t("Error while trying to load image: " + h, S);
      });
    }, void 0, i || void 0, !0, (b, S) => {
      c(S);
    }), null;
  const u = new Image();
  In(a, u);
  const d = [], f = () => {
    d.forEach((b) => {
      b.target.addEventListener(b.name, b.handler);
    });
  }, _ = () => {
    d.forEach((b) => {
      b.target.removeEventListener(b.name, b.handler);
    }), d.length = 0;
  }, g = () => {
    _(), e(u), o && u.src && URL.revokeObjectURL(u.src);
  }, m = (b) => {
    _(), c(b), o && u.src && URL.revokeObjectURL(u.src);
  }, y = (b) => {
    if (b.blockedURI !== u.src)
      return;
    _();
    const S = new Error(`CSP violation of policy ${b.effectiveDirective} ${b.blockedURI}. Current policy is ${b.originalPolicy}`);
    de.UseFallbackTexture = !1, c(S), o && u.src && URL.revokeObjectURL(u.src), u.src = "";
  };
  d.push({ target: u, name: "load", handler: g }), d.push({ target: u, name: "error", handler: m }), d.push({ target: document, name: "securitypolicyviolation", handler: y }), f();
  const x = a.substring(0, 5) === "blob:", A = a.substring(0, 5) === "data:", T = () => {
    x || A ? u.src = a : ki(a, (b, S, P) => {
      const D = !s && P ? P : s, O = new Blob([b], { type: D }), X = URL.createObjectURL(O);
      o = !0, u.src = X;
    }, void 0, i || void 0, !0, (b, S) => {
      c(S);
    });
  }, M = () => {
    i && i.loadImage(a, u);
  };
  if (!x && !A && i && i.enableTexturesOffline)
    i.open(M, T);
  else {
    if (a.indexOf("file:") !== -1) {
      const b = decodeURIComponent(a.substring(5).toLowerCase());
      if (Is.FilesToLoad[b] && typeof URL < "u") {
        try {
          let S;
          try {
            S = URL.createObjectURL(Is.FilesToLoad[b]);
          } catch {
            S = URL.createObjectURL(Is.FilesToLoad[b]);
          }
          u.src = S, o = !0;
        } catch {
          u.src = "";
        }
        return u;
      }
    }
    T();
  }
  return u;
}, Ns = (h, e, t, i, s) => {
  const r = new FileReader(), n = {
    onCompleteObservable: new N(),
    abort: () => r.abort()
  };
  return r.onloadend = () => n.onCompleteObservable.notifyObservers(n), s && (r.onerror = () => {
    s(new Rn(`Unable to read ${h.name}`, h));
  }), r.onload = (a) => {
    e(a.target.result);
  }, t && (r.onprogress = t), i ? r.readAsArrayBuffer(h) : r.readAsText(h), n;
}, ki = (h, e, t, i, s, r, n) => {
  if (h.name)
    return Ns(h, e, t, s, r ? (c) => {
      r(void 0, c);
    } : void 0);
  const a = h;
  if (a.indexOf("file:") !== -1) {
    let c = decodeURIComponent(a.substring(5).toLowerCase());
    c.indexOf("./") === 0 && (c = c.substring(2));
    const u = Is.FilesToLoad[c];
    if (u)
      return Ns(u, e, t, s, r ? (d) => r(void 0, new br(d.message, d.file)) : void 0);
  }
  const { match: o, type: l } = ml(a);
  if (o) {
    const c = {
      onCompleteObservable: new N(),
      abort: () => () => {
      }
    };
    try {
      const u = s ? Dn(a) : Ua(a);
      e(u, void 0, l);
    } catch (u) {
      r ? r(void 0, u) : w.Error(u.message || "Failed to parse the Data URL");
    }
    return xr.SetImmediate(() => {
      c.onCompleteObservable.notifyObservers(c);
    }), c;
  }
  return Pn(a, (c, u) => {
    e(c, u == null ? void 0 : u.responseURL, u == null ? void 0 : u.getResponseHeader("content-type"));
  }, t, i, s, r ? (c) => {
    r(c.request, new br(c.message, c.request));
  } : void 0, n);
}, Pn = (h, e, t, i, s, r, n) => {
  h = Na(h), h = pt.PreprocessUrl(h);
  const a = pt.BaseUrl + h;
  let o = !1;
  const l = {
    onCompleteObservable: new N(),
    abort: () => o = !0
  }, c = () => {
    let u = new mt(), d = null, f;
    const _ = () => {
      u && (t && u.removeEventListener("progress", t), f && u.removeEventListener("readystatechange", f), u.removeEventListener("loadend", g));
    };
    let g = () => {
      _(), l.onCompleteObservable.notifyObservers(l), l.onCompleteObservable.clear(), t = void 0, f = null, g = null, r = void 0, n = void 0, e = void 0;
    };
    l.abort = () => {
      o = !0, g && g(), u && u.readyState !== (XMLHttpRequest.DONE || 4) && u.abort(), d !== null && (clearTimeout(d), d = null), u = null;
    };
    const m = (x) => {
      const A = x.message || "Unknown error";
      r && u ? r(new Tr(A, u)) : w.Error(A);
    }, y = (x) => {
      if (u) {
        if (u.open("GET", a), n)
          try {
            n(u);
          } catch (A) {
            m(A);
            return;
          }
        s && (u.responseType = "arraybuffer"), t && u.addEventListener("progress", t), g && u.addEventListener("loadend", g), f = () => {
          if (!(o || !u) && u.readyState === (XMLHttpRequest.DONE || 4)) {
            if (f && u.removeEventListener("readystatechange", f), u.status >= 200 && u.status < 300 || u.status === 0 && (!_t() || Ba())) {
              try {
                e && e(s ? u.response : u.responseText, u);
              } catch (M) {
                m(M);
              }
              return;
            }
            const A = pt.DefaultRetryStrategy;
            if (A) {
              const M = A(a, u, x);
              if (M !== -1) {
                _(), u = new mt(), d = setTimeout(() => y(x + 1), M);
                return;
              }
            }
            const T = new Tr("Error status: " + u.status + " " + u.statusText + " - Unable to load " + a, u);
            r && r(T);
          }
        }, u.addEventListener("readystatechange", f), u.send();
      }
    };
    y(0);
  };
  if (i && i.enableSceneOffline) {
    const u = (f) => {
      f && f.status > 400 ? r && r(f) : c();
    }, d = () => {
      i && i.loadFile(pt.BaseUrl + h, (f) => {
        !o && e && e(f), l.onCompleteObservable.notifyObservers(l);
      }, t ? (f) => {
        !o && t && t(f);
      } : void 0, u, s);
    };
    i.open(d, u);
  } else
    c();
  return l;
}, Ba = () => typeof location < "u" && location.protocol === "file:", Cn = (h) => La.test(h), ml = (h) => {
  const e = La.exec(h);
  return e === null || e.length === 0 ? { match: !1, type: "" } : { match: !0, type: e[0].replace("data:", "").replace("base64,", "") };
};
function Dn(h) {
  return Qo(h.split(",")[1]);
}
const Ua = (h) => Oa(h.split(",")[1]), yl = () => {
  Z._FileToolsLoadImage = Pr, Z._FileToolsLoadFile = ki, hi._FileToolsLoadFile = ki;
};
yl();
let Ts;
const vl = (h, e, t, i, s, r, n, a, o, l) => {
  Ts = {
    DecodeBase64UrlToBinary: h,
    DecodeBase64UrlToString: e,
    DefaultRetryStrategy: t.DefaultRetryStrategy,
    BaseUrl: t.BaseUrl,
    CorsBehavior: t.CorsBehavior,
    PreprocessUrl: t.PreprocessUrl,
    IsBase64DataUrl: i,
    IsFileURL: s,
    LoadFile: r,
    LoadImage: n,
    ReadFile: a,
    RequestFile: o,
    SetCorsBehavior: l
  }, Object.defineProperty(Ts, "DefaultRetryStrategy", {
    get: function() {
      return t.DefaultRetryStrategy;
    },
    set: function(c) {
      t.DefaultRetryStrategy = c;
    }
  }), Object.defineProperty(Ts, "BaseUrl", {
    get: function() {
      return t.BaseUrl;
    },
    set: function(c) {
      t.BaseUrl = c;
    }
  }), Object.defineProperty(Ts, "PreprocessUrl", {
    get: function() {
      return t.PreprocessUrl;
    },
    set: function(c) {
      t.PreprocessUrl = c;
    }
  }), Object.defineProperty(Ts, "CorsBehavior", {
    get: function() {
      return t.CorsBehavior;
    },
    set: function(c) {
      t.CorsBehavior = c;
    }
  });
};
vl(Dn, Ua, pt, Cn, Ba, ki, Pr, Ns, Pn, In);
class Cs {
  /**
   * Tries to instantiate a new object from a given class name
   * @param className defines the class name to instantiate
   * @returns the new object or null if the system was not able to do the instantiation
   */
  static Instantiate(e) {
    if (this.RegisteredExternalClasses && this.RegisteredExternalClasses[e])
      return this.RegisteredExternalClasses[e];
    const t = si(e);
    if (t)
      return t;
    w.Warn(e + " not found, you may have missed an import.");
    const i = e.split(".");
    let s = window || this;
    for (let r = 0, n = i.length; r < n; r++)
      s = s[i[r]];
    return typeof s != "function" ? null : s;
  }
}
Cs.RegisteredExternalClasses = {};
function wn() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (h) => {
    const e = Math.random() * 16 | 0;
    return (h === "x" ? e : e & 3 | 8).toString(16);
  });
}
class z {
  /**
   * Gets or sets the base URL to use to load assets
   */
  static get BaseUrl() {
    return pt.BaseUrl;
  }
  static set BaseUrl(e) {
    pt.BaseUrl = e;
  }
  /**
   * Gets or sets the retry strategy to apply when an error happens while loading an asset
   */
  static get DefaultRetryStrategy() {
    return pt.DefaultRetryStrategy;
  }
  static set DefaultRetryStrategy(e) {
    pt.DefaultRetryStrategy = e;
  }
  /**
   * Default behaviour for cors in the application.
   * It can be a string if the expected behavior is identical in the entire app.
   * Or a callback to be able to set it per url or on a group of them (in case of Video source for instance)
   */
  static get CorsBehavior() {
    return pt.CorsBehavior;
  }
  static set CorsBehavior(e) {
    pt.CorsBehavior = e;
  }
  /**
   * Gets or sets a global variable indicating if fallback texture must be used when a texture cannot be loaded
   * @ignorenaming
   */
  static get UseFallbackTexture() {
    return de.UseFallbackTexture;
  }
  static set UseFallbackTexture(e) {
    de.UseFallbackTexture = e;
  }
  /**
   * Use this object to register external classes like custom textures or material
   * to allow the loaders to instantiate them
   */
  static get RegisteredExternalClasses() {
    return Cs.RegisteredExternalClasses;
  }
  static set RegisteredExternalClasses(e) {
    Cs.RegisteredExternalClasses = e;
  }
  /**
   * Texture content used if a texture cannot loaded
   * @ignorenaming
   */
  // eslint-disable-next-line @typescript-eslint/naming-convention
  static get fallbackTexture() {
    return de.FallbackTexture;
  }
  // eslint-disable-next-line @typescript-eslint/naming-convention
  static set fallbackTexture(e) {
    de.FallbackTexture = e;
  }
  /**
   * Read the content of a byte array at a specified coordinates (taking in account wrapping)
   * @param u defines the coordinate on X axis
   * @param v defines the coordinate on Y axis
   * @param width defines the width of the source data
   * @param height defines the height of the source data
   * @param pixels defines the source byte array
   * @param color defines the output color
   */
  static FetchToRef(e, t, i, s, r, n) {
    const a = Math.abs(e) * i % i | 0, o = Math.abs(t) * s % s | 0, l = (a + o * i) * 4;
    n.r = r[l] / 255, n.g = r[l + 1] / 255, n.b = r[l + 2] / 255, n.a = r[l + 3] / 255;
  }
  /**
   * Interpolates between a and b via alpha
   * @param a The lower value (returned when alpha = 0)
   * @param b The upper value (returned when alpha = 1)
   * @param alpha The interpolation-factor
   * @returns The mixed value
   */
  static Mix(e, t, i) {
    return e * (1 - i) + t * i;
  }
  /**
   * Tries to instantiate a new object from a given class name
   * @param className defines the class name to instantiate
   * @returns the new object or null if the system was not able to do the instantiation
   */
  static Instantiate(e) {
    return Cs.Instantiate(e);
  }
  /**
   * Polyfill for setImmediate
   * @param action defines the action to execute after the current execution block
   */
  static SetImmediate(e) {
    xr.SetImmediate(e);
  }
  /**
   * Function indicating if a number is an exponent of 2
   * @param value defines the value to test
   * @returns true if the value is an exponent of 2
   */
  static IsExponentOfTwo(e) {
    let t = 1;
    do
      t *= 2;
    while (t < e);
    return t === e;
  }
  /**
   * Returns the nearest 32-bit single precision float representation of a Number
   * @param value A Number.  If the parameter is of a different type, it will get converted
   * to a number or to NaN if it cannot be converted
   * @returns number
   */
  static FloatRound(e) {
    return Math.fround ? Math.fround(e) : (z._TmpFloatArray[0] = e, z._TmpFloatArray[0]);
  }
  /**
   * Extracts the filename from a path
   * @param path defines the path to use
   * @returns the filename
   */
  static GetFilename(e) {
    const t = e.lastIndexOf("/");
    return t < 0 ? e : e.substring(t + 1);
  }
  /**
   * Extracts the "folder" part of a path (everything before the filename).
   * @param uri The URI to extract the info from
   * @param returnUnchangedIfNoSlash Do not touch the URI if no slashes are present
   * @returns The "folder" part of the path
   */
  static GetFolderPath(e, t = !1) {
    const i = e.lastIndexOf("/");
    return i < 0 ? t ? e : "" : e.substring(0, i + 1);
  }
  /**
   * Convert an angle in radians to degrees
   * @param angle defines the angle to convert
   * @returns the angle in degrees
   */
  static ToDegrees(e) {
    return e * 180 / Math.PI;
  }
  /**
   * Convert an angle in degrees to radians
   * @param angle defines the angle to convert
   * @returns the angle in radians
   */
  static ToRadians(e) {
    return e * Math.PI / 180;
  }
  /**
   * Smooth angle changes (kind of low-pass filter), in particular for device orientation "shaking"
   * Use trigonometric functions to avoid discontinuity (0/360, -180/180)
   * @param previousAngle defines last angle value, in degrees
   * @param newAngle defines new angle value, in degrees
   * @param smoothFactor defines smoothing sensitivity; min 0: no smoothing, max 1: new data ignored
   * @returns the angle in degrees
   */
  static SmoothAngleChange(e, t, i = 0.9) {
    const s = this.ToRadians(e), r = this.ToRadians(t);
    return this.ToDegrees(Math.atan2((1 - i) * Math.sin(r) + i * Math.sin(s), (1 - i) * Math.cos(r) + i * Math.cos(s)));
  }
  /**
   * Returns an array if obj is not an array
   * @param obj defines the object to evaluate as an array
   * @param allowsNullUndefined defines a boolean indicating if obj is allowed to be null or undefined
   * @returns either obj directly if obj is an array or a new array containing obj
   */
  static MakeArray(e, t) {
    return t !== !0 && (e === void 0 || e == null) ? null : Array.isArray(e) ? e : [e];
  }
  /**
   * Gets the pointer prefix to use
   * @param engine defines the engine we are finding the prefix for
   * @returns "pointer" if touch is enabled. Else returns "mouse"
   */
  static GetPointerPrefix(e) {
    let t = "pointer";
    return _t() && !window.PointerEvent && (t = "mouse"), e._badDesktopOS && !e._badOS && // And not ipad pros who claim to be macs...
    !(document && "ontouchend" in document) && (t = "mouse"), t;
  }
  /**
   * Sets the cors behavior on a dom element. This will add the required Tools.CorsBehavior to the element.
   * @param url define the url we are trying
   * @param element define the dom element where to configure the cors policy
   * @param element.crossOrigin
   */
  static SetCorsBehavior(e, t) {
    In(e, t);
  }
  /**
   * Sets the referrerPolicy behavior on a dom element.
   * @param referrerPolicy define the referrer policy to use
   * @param element define the dom element where to configure the referrer policy
   * @param element.referrerPolicy
   */
  static SetReferrerPolicyBehavior(e, t) {
    t.referrerPolicy = e;
  }
  // External files
  /**
   * Removes unwanted characters from an url
   * @param url defines the url to clean
   * @returns the cleaned url
   */
  static CleanUrl(e) {
    return e = e.replace(/#/gm, "%23"), e;
  }
  /**
   * Gets or sets a function used to pre-process url before using them to load assets
   */
  static get PreprocessUrl() {
    return pt.PreprocessUrl;
  }
  static set PreprocessUrl(e) {
    pt.PreprocessUrl = e;
  }
  /**
   * Loads an image as an HTMLImageElement.
   * @param input url string, ArrayBuffer, or Blob to load
   * @param onLoad callback called when the image successfully loads
   * @param onError callback called when the image fails to load
   * @param offlineProvider offline provider for caching
   * @param mimeType optional mime type
   * @param imageBitmapOptions optional the options to use when creating an ImageBitmap
   * @returns the HTMLImageElement of the loaded image
   */
  static LoadImage(e, t, i, s, r, n) {
    return Pr(e, t, i, s, r, n);
  }
  /**
   * Loads a file from a url
   * @param url url string, ArrayBuffer, or Blob to load
   * @param onSuccess callback called when the file successfully loads
   * @param onProgress callback called while file is loading (if the server supports this mode)
   * @param offlineProvider defines the offline provider for caching
   * @param useArrayBuffer defines a boolean indicating that date must be returned as ArrayBuffer
   * @param onError callback called when the file fails to load
   * @returns a file request object
   */
  static LoadFile(e, t, i, s, r, n) {
    return ki(e, t, i, s, r, n);
  }
  /**
   * Loads a file from a url
   * @param url the file url to load
   * @param useArrayBuffer defines a boolean indicating that date must be returned as ArrayBuffer
   * @returns a promise containing an ArrayBuffer corresponding to the loaded file
   */
  static LoadFileAsync(e, t = !0) {
    return new Promise((i, s) => {
      ki(e, (r) => {
        i(r);
      }, void 0, void 0, t, (r, n) => {
        s(n);
      });
    });
  }
  /**
   * Load a script (identified by an url). When the url returns, the
   * content of this file is added into a new script element, attached to the DOM (body element)
   * @param scriptUrl defines the url of the script to laod
   * @param onSuccess defines the callback called when the script is loaded
   * @param onError defines the callback to call if an error occurs
   * @param scriptId defines the id of the script element
   */
  static LoadScript(e, t, i, s) {
    if (typeof importScripts == "function") {
      try {
        importScripts(e), t();
      } catch (a) {
        i == null || i(`Unable to load script '${e}' in worker`, a);
      }
      return;
    } else if (!_t()) {
      i == null || i(`Cannot load script '${e}' outside of a window or a worker`);
      return;
    }
    const r = document.getElementsByTagName("head")[0], n = document.createElement("script");
    n.setAttribute("type", "text/javascript"), n.setAttribute("src", e), s && (n.id = s), n.onload = () => {
      t && t();
    }, n.onerror = (a) => {
      i && i(`Unable to load script '${e}'`, a);
    }, r.appendChild(n);
  }
  /**
   * Load an asynchronous script (identified by an url). When the url returns, the
   * content of this file is added into a new script element, attached to the DOM (body element)
   * @param scriptUrl defines the url of the script to laod
   * @returns a promise request object
   */
  static LoadScriptAsync(e) {
    return new Promise((t, i) => {
      this.LoadScript(e, () => {
        t();
      }, (s, r) => {
        i(r || new Error(s));
      });
    });
  }
  /**
   * Loads a file from a blob
   * @param fileToLoad defines the blob to use
   * @param callback defines the callback to call when data is loaded
   * @param progressCallback defines the callback to call during loading process
   * @returns a file request object
   */
  static ReadFileAsDataURL(e, t, i) {
    const s = new FileReader(), r = {
      onCompleteObservable: new N(),
      abort: () => s.abort()
    };
    return s.onloadend = () => {
      r.onCompleteObservable.notifyObservers(r);
    }, s.onload = (n) => {
      t(n.target.result);
    }, s.onprogress = i, s.readAsDataURL(e), r;
  }
  /**
   * Reads a file from a File object
   * @param file defines the file to load
   * @param onSuccess defines the callback to call when data is loaded
   * @param onProgress defines the callback to call during loading process
   * @param useArrayBuffer defines a boolean indicating that data must be returned as an ArrayBuffer
   * @param onError defines the callback to call when an error occurs
   * @returns a file request object
   */
  static ReadFile(e, t, i, s, r) {
    return Ns(e, t, i, s, r);
  }
  /**
   * Creates a data url from a given string content
   * @param content defines the content to convert
   * @returns the new data url link
   */
  static FileAsURL(e) {
    const t = new Blob([e]);
    return window.URL.createObjectURL(t);
  }
  /**
   * Format the given number to a specific decimal format
   * @param value defines the number to format
   * @param decimals defines the number of decimals to use
   * @returns the formatted string
   */
  static Format(e, t = 2) {
    return e.toFixed(t);
  }
  /**
   * Tries to copy an object by duplicating every property
   * @param source defines the source object
   * @param destination defines the target object
   * @param doNotCopyList defines a list of properties to avoid
   * @param mustCopyList defines a list of properties to copy (even if they start with _)
   */
  static DeepCopy(e, t, i, s) {
    js.DeepCopy(e, t, i, s);
  }
  /**
   * Gets a boolean indicating if the given object has no own property
   * @param obj defines the object to test
   * @returns true if object has no own property
   */
  static IsEmpty(e) {
    for (const t in e)
      if (Object.prototype.hasOwnProperty.call(e, t))
        return !1;
    return !0;
  }
  /**
   * Function used to register events at window level
   * @param windowElement defines the Window object to use
   * @param events defines the events to register
   */
  static RegisterTopRootEvents(e, t) {
    for (let i = 0; i < t.length; i++) {
      const s = t[i];
      e.addEventListener(s.name, s.handler, !1);
      try {
        window.parent && window.parent.addEventListener(s.name, s.handler, !1);
      } catch {
      }
    }
  }
  /**
   * Function used to unregister events from window level
   * @param windowElement defines the Window object to use
   * @param events defines the events to unregister
   */
  static UnregisterTopRootEvents(e, t) {
    for (let i = 0; i < t.length; i++) {
      const s = t[i];
      e.removeEventListener(s.name, s.handler);
      try {
        e.parent && e.parent.removeEventListener(s.name, s.handler);
      } catch {
      }
    }
  }
  /**
   * Dumps the current bound framebuffer
   * @param width defines the rendering width
   * @param height defines the rendering height
   * @param engine defines the hosting engine
   * @param successCallback defines the callback triggered once the data are available
   * @param mimeType defines the mime type of the result
   * @param fileName defines the filename to download. If present, the result will automatically be downloaded
   * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
   * @returns a void promise
   */
  static async DumpFramebuffer(e, t, i, s, r = "image/png", n, a) {
    throw he("DumpTools");
  }
  /**
   * Dumps an array buffer
   * @param width defines the rendering width
   * @param height defines the rendering height
   * @param data the data array
   * @param successCallback defines the callback triggered once the data are available
   * @param mimeType defines the mime type of the result
   * @param fileName defines the filename to download. If present, the result will automatically be downloaded
   * @param invertY true to invert the picture in the Y dimension
   * @param toArrayBuffer true to convert the data to an ArrayBuffer (encoded as `mimeType`) instead of a base64 string
   * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
   */
  static DumpData(e, t, i, s, r = "image/png", n, a = !1, o = !1, l) {
    throw he("DumpTools");
  }
  /**
   * Dumps an array buffer
   * @param width defines the rendering width
   * @param height defines the rendering height
   * @param data the data array
   * @param mimeType defines the mime type of the result
   * @param fileName defines the filename to download. If present, the result will automatically be downloaded
   * @param invertY true to invert the picture in the Y dimension
   * @param toArrayBuffer true to convert the data to an ArrayBuffer (encoded as `mimeType`) instead of a base64 string
   * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
   * @returns a promise that resolve to the final data
   */
  static DumpDataAsync(e, t, i, s = "image/png", r, n = !1, a = !1, o) {
    throw he("DumpTools");
  }
  static _IsOffScreenCanvas(e) {
    return e.convertToBlob !== void 0;
  }
  /**
   * Converts the canvas data to blob.
   * This acts as a polyfill for browsers not supporting the to blob function.
   * @param canvas Defines the canvas to extract the data from (can be an offscreen canvas)
   * @param successCallback Defines the callback triggered once the data are available
   * @param mimeType Defines the mime type of the result
   * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
   */
  static ToBlob(e, t, i = "image/png", s) {
    !z._IsOffScreenCanvas(e) && !e.toBlob && (e.toBlob = function(r, n, a) {
      setTimeout(() => {
        const o = atob(this.toDataURL(n, a).split(",")[1]), l = o.length, c = new Uint8Array(l);
        for (let u = 0; u < l; u++)
          c[u] = o.charCodeAt(u);
        r(new Blob([c]));
      });
    }), z._IsOffScreenCanvas(e) ? e.convertToBlob({
      type: i,
      quality: s
    }).then((r) => t(r)) : e.toBlob(function(r) {
      t(r);
    }, i, s);
  }
  /**
   * Download a Blob object
   * @param blob the Blob object
   * @param fileName the file name to download
   * @returns
   */
  static DownloadBlob(e, t) {
    if ("download" in document.createElement("a")) {
      if (!t) {
        const i = /* @__PURE__ */ new Date();
        t = "screenshot_" + ((i.getFullYear() + "-" + (i.getMonth() + 1)).slice(2) + "-" + i.getDate() + "_" + i.getHours() + "-" + ("0" + i.getMinutes()).slice(-2)) + ".png";
      }
      z.Download(e, t);
    } else if (e && typeof URL < "u") {
      const i = URL.createObjectURL(e), s = window.open("");
      if (!s)
        return;
      const r = s.document.createElement("img");
      r.onload = function() {
        URL.revokeObjectURL(i);
      }, r.src = i, s.document.body.appendChild(r);
    }
  }
  /**
   * Encodes the canvas data to base 64, or automatically downloads the result if `fileName` is defined.
   * @param canvas The canvas to get the data from, which can be an offscreen canvas.
   * @param successCallback The callback which is triggered once the data is available. If `fileName` is defined, the callback will be invoked after the download occurs, and the `data` argument will be an empty string.
   * @param mimeType The mime type of the result.
   * @param fileName The name of the file to download. If defined, the result will automatically be downloaded. If not defined, and `successCallback` is also not defined, the result will automatically be downloaded with an auto-generated file name.
   * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
   */
  static EncodeScreenshotCanvasData(e, t, i = "image/png", s, r) {
    if (typeof s == "string" || !t)
      this.ToBlob(e, function(n) {
        n && z.DownloadBlob(n, s), t && t("");
      }, i, r);
    else if (t) {
      if (z._IsOffScreenCanvas(e)) {
        e.convertToBlob({
          type: i,
          quality: r
        }).then((a) => {
          const o = new FileReader();
          o.readAsDataURL(a), o.onloadend = () => {
            const l = o.result;
            t(l);
          };
        });
        return;
      }
      const n = e.toDataURL(i, r);
      t(n);
    }
  }
  /**
   * Downloads a blob in the browser
   * @param blob defines the blob to download
   * @param fileName defines the name of the downloaded file
   */
  static Download(e, t) {
    if (typeof URL > "u")
      return;
    const i = window.URL.createObjectURL(e), s = document.createElement("a");
    document.body.appendChild(s), s.style.display = "none", s.href = i, s.download = t, s.addEventListener("click", () => {
      s.parentElement && s.parentElement.removeChild(s);
    }), s.click(), window.URL.revokeObjectURL(i);
  }
  /**
   * Will return the right value of the noPreventDefault variable
   * Needed to keep backwards compatibility to the old API.
   *
   * @param args arguments passed to the attachControl function
   * @returns the correct value for noPreventDefault
   */
  static BackCompatCameraNoPreventDefault(e) {
    return typeof e[0] == "boolean" ? e[0] : typeof e[1] == "boolean" ? e[1] : !1;
  }
  /**
   * Captures a screenshot of the current rendering
   * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/renderToPNG
   * @param engine defines the rendering engine
   * @param camera defines the source camera
   * @param size This parameter can be set to a single number or to an object with the
   * following (optional) properties: precision, width, height. If a single number is passed,
   * it will be used for both width and height. If an object is passed, the screenshot size
   * will be derived from the parameters. The precision property is a multiplier allowing
   * rendering at a higher or lower resolution
   * @param successCallback defines the callback receives a single parameter which contains the
   * screenshot as a string of base64-encoded characters. This string can be assigned to the
   * src parameter of an <img> to display it
   * @param mimeType defines the MIME type of the screenshot image (default: image/png).
   * Check your browser for supported MIME types
   * @param forceDownload force the system to download the image even if a successCallback is provided
   * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static CreateScreenshot(e, t, i, s, r = "image/png", n = !1, a) {
    throw he("ScreenshotTools");
  }
  /**
   * Captures a screenshot of the current rendering
   * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/renderToPNG
   * @param engine defines the rendering engine
   * @param camera defines the source camera
   * @param size This parameter can be set to a single number or to an object with the
   * following (optional) properties: precision, width, height. If a single number is passed,
   * it will be used for both width and height. If an object is passed, the screenshot size
   * will be derived from the parameters. The precision property is a multiplier allowing
   * rendering at a higher or lower resolution
   * @param mimeType defines the MIME type of the screenshot image (default: image/png).
   * Check your browser for supported MIME types
   * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
   * @returns screenshot as a string of base64-encoded characters. This string can be assigned
   * to the src parameter of an <img> to display it
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static CreateScreenshotAsync(e, t, i, s = "image/png", r) {
    throw he("ScreenshotTools");
  }
  /**
   * Generates an image screenshot from the specified camera.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/renderToPNG
   * @param engine The engine to use for rendering
   * @param camera The camera to use for rendering
   * @param size This parameter can be set to a single number or to an object with the
   * following (optional) properties: precision, width, height. If a single number is passed,
   * it will be used for both width and height. If an object is passed, the screenshot size
   * will be derived from the parameters. The precision property is a multiplier allowing
   * rendering at a higher or lower resolution
   * @param successCallback The callback receives a single parameter which contains the
   * screenshot as a string of base64-encoded characters. This string can be assigned to the
   * src parameter of an <img> to display it
   * @param mimeType The MIME type of the screenshot image (default: image/png).
   * Check your browser for supported MIME types
   * @param samples Texture samples (default: 1)
   * @param antialiasing Whether antialiasing should be turned on or not (default: false)
   * @param fileName A name for for the downloaded file.
   * @param renderSprites Whether the sprites should be rendered or not (default: false)
   * @param enableStencilBuffer Whether the stencil buffer should be enabled or not (default: false)
   * @param useLayerMask if the camera's layer mask should be used to filter what should be rendered (default: true)
   * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static CreateScreenshotUsingRenderTarget(e, t, i, s, r = "image/png", n = 1, a = !1, o, l = !1, c = !1, u = !0, d) {
    throw he("ScreenshotTools");
  }
  /**
   * Generates an image screenshot from the specified camera.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/renderToPNG
   * @param engine The engine to use for rendering
   * @param camera The camera to use for rendering
   * @param size This parameter can be set to a single number or to an object with the
   * following (optional) properties: precision, width, height. If a single number is passed,
   * it will be used for both width and height. If an object is passed, the screenshot size
   * will be derived from the parameters. The precision property is a multiplier allowing
   * rendering at a higher or lower resolution
   * @param mimeType The MIME type of the screenshot image (default: image/png).
   * Check your browser for supported MIME types
   * @param samples Texture samples (default: 1)
   * @param antialiasing Whether antialiasing should be turned on or not (default: false)
   * @param fileName A name for for the downloaded file.
   * @returns screenshot as a string of base64-encoded characters. This string can be assigned
   * @param renderSprites Whether the sprites should be rendered or not (default: false)
   * @param enableStencilBuffer Whether the stencil buffer should be enabled or not (default: false)
   * @param useLayerMask if the camera's layer mask should be used to filter what should be rendered (default: true)
   * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
   * to the src parameter of an <img> to display it
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static CreateScreenshotUsingRenderTargetAsync(e, t, i, s = "image/png", r = 1, n = !1, a, o = !1, l = !1, c = !0, u) {
    throw he("ScreenshotTools");
  }
  /**
   * Implementation from http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#answer-2117523
   * Be aware Math.random() could cause collisions, but:
   * "All but 6 of the 128 bits of the ID are randomly generated, which means that for any two ids, there's a 1 in 2^^122 (or 5.3x10^^36) chance they'll collide"
   * @returns a pseudo random id
   */
  static RandomId() {
    return wn();
  }
  /**
   * Test if the given uri is a base64 string
   * @deprecated Please use FileTools.IsBase64DataUrl instead.
   * @param uri The uri to test
   * @returns True if the uri is a base64 string or false otherwise
   */
  static IsBase64(e) {
    return Cn(e);
  }
  /**
   * Decode the given base64 uri.
   * @deprecated Please use FileTools.DecodeBase64UrlToBinary instead.
   * @param uri The uri to decode
   * @returns The decoded base64 data.
   */
  static DecodeBase64(e) {
    return Dn(e);
  }
  /**
   * Gets a value indicating the number of loading errors
   * @ignorenaming
   */
  // eslint-disable-next-line @typescript-eslint/naming-convention
  static get errorsCount() {
    return w.errorsCount;
  }
  /**
   * Log a message to the console
   * @param message defines the message to log
   */
  static Log(e) {
    w.Log(e);
  }
  /**
   * Write a warning message to the console
   * @param message defines the message to log
   */
  static Warn(e) {
    w.Warn(e);
  }
  /**
   * Write an error message to the console
   * @param message defines the message to log
   */
  static Error(e) {
    w.Error(e);
  }
  /**
   * Gets current log cache (list of logs)
   */
  static get LogCache() {
    return w.LogCache;
  }
  /**
   * Clears the log cache
   */
  static ClearLogCache() {
    w.ClearLogCache();
  }
  /**
   * Sets the current log level (MessageLogLevel / WarningLogLevel / ErrorLogLevel)
   */
  static set LogLevels(e) {
    w.LogLevels = e;
  }
  /**
   * Sets the current performance log level
   */
  static set PerformanceLogLevel(e) {
    if ((e & z.PerformanceUserMarkLogLevel) === z.PerformanceUserMarkLogLevel) {
      z.StartPerformanceCounter = z._StartUserMark, z.EndPerformanceCounter = z._EndUserMark;
      return;
    }
    if ((e & z.PerformanceConsoleLogLevel) === z.PerformanceConsoleLogLevel) {
      z.StartPerformanceCounter = z._StartPerformanceConsole, z.EndPerformanceCounter = z._EndPerformanceConsole;
      return;
    }
    z.StartPerformanceCounter = z._StartPerformanceCounterDisabled, z.EndPerformanceCounter = z._EndPerformanceCounterDisabled;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static _StartPerformanceCounterDisabled(e, t) {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static _EndPerformanceCounterDisabled(e, t) {
  }
  static _StartUserMark(e, t = !0) {
    if (!z._Performance) {
      if (!_t())
        return;
      z._Performance = window.performance;
    }
    !t || !z._Performance.mark || z._Performance.mark(e + "-Begin");
  }
  static _EndUserMark(e, t = !0) {
    !t || !z._Performance.mark || (z._Performance.mark(e + "-End"), z._Performance.measure(e, e + "-Begin", e + "-End"));
  }
  static _StartPerformanceConsole(e, t = !0) {
    t && (z._StartUserMark(e, t), console.time && console.time(e));
  }
  static _EndPerformanceConsole(e, t = !0) {
    t && (z._EndUserMark(e, t), console.timeEnd(e));
  }
  /**
   * Gets either window.performance.now() if supported or Date.now() else
   */
  static get Now() {
    return Kt.Now;
  }
  /**
   * This method will return the name of the class used to create the instance of the given object.
   * It will works only on Javascript basic data types (number, string, ...) and instance of class declared with the @className decorator.
   * @param object the object to get the class name from
   * @param isType defines if the object is actually a type
   * @returns the name of the class, will be "object" for a custom data type not using the @className decorator
   */
  static GetClassName(e, t = !1) {
    let i = null;
    return !t && e.getClassName ? i = e.getClassName() : (e instanceof Object && (i = (t ? e : Object.getPrototypeOf(e)).constructor.__bjsclassName__), i || (i = typeof e)), i;
  }
  /**
   * Gets the first element of an array satisfying a given predicate
   * @param array defines the array to browse
   * @param predicate defines the predicate to use
   * @returns null if not found or the element
   */
  static First(e, t) {
    for (const i of e)
      if (t(i))
        return i;
    return null;
  }
  /**
   * This method will return the name of the full name of the class, including its owning module (if any).
   * It will works only on Javascript basic data types (number, string, ...) and instance of class declared with the @className decorator or implementing a method getClassName():string (in which case the module won't be specified).
   * @param object the object to get the class name from
   * @param isType defines if the object is actually a type
   * @returns a string that can have two forms: "moduleName.className" if module was specified when the class' Name was registered or "className" if there was not module specified.
   * @ignorenaming
   */
  // eslint-disable-next-line @typescript-eslint/naming-convention
  static getFullClassName(e, t = !1) {
    let i = null, s = null;
    if (!t && e.getClassName)
      i = e.getClassName();
    else {
      if (e instanceof Object) {
        const r = t ? e : Object.getPrototypeOf(e);
        i = r.constructor.__bjsclassName__, s = r.constructor.__bjsmoduleName__;
      }
      i || (i = typeof e);
    }
    return i ? (s != null ? s + "." : "") + i : null;
  }
  /**
   * Returns a promise that resolves after the given amount of time.
   * @param delay Number of milliseconds to delay
   * @returns Promise that resolves after the given amount of time
   */
  static DelayAsync(e) {
    return new Promise((t) => {
      setTimeout(() => {
        t();
      }, e);
    });
  }
  /**
   * Utility function to detect if the current user agent is Safari
   * @returns whether or not the current user agent is safari
   */
  static IsSafari() {
    return _r() ? /^((?!chrome|android).)*safari/i.test(navigator.userAgent) : !1;
  }
}
z.UseCustomRequestHeaders = !1;
z.CustomRequestHeaders = mt.CustomRequestHeaders;
z._TmpFloatArray = new Float32Array(1);
z.GetDOMTextContent = Da;
z.GetAbsoluteUrl = typeof document == "object" ? (h) => {
  const e = document.createElement("a");
  return e.href = h, e.href;
} : typeof URL == "function" && typeof location == "object" ? (h) => new URL(h, location.origin).href : () => {
  throw new Error("Unable to get absolute URL. Override BABYLON.Tools.GetAbsoluteUrl to a custom implementation for the current context.");
};
z.NoneLogLevel = w.NoneLogLevel;
z.MessageLogLevel = w.MessageLogLevel;
z.WarningLogLevel = w.WarningLogLevel;
z.ErrorLogLevel = w.ErrorLogLevel;
z.AllLogLevel = w.AllLogLevel;
z.IsWindowObjectExist = _t;
z.PerformanceNoneLogLevel = 0;
z.PerformanceUserMarkLogLevel = 1;
z.PerformanceConsoleLogLevel = 2;
z.StartPerformanceCounter = z._StartPerformanceCounterDisabled;
z.EndPerformanceCounter = z._EndPerformanceCounterDisabled;
class Ar {
  /**
   * Constructor.
   * @param iterations the number of iterations.
   * @param func the function to run each iteration
   * @param successCallback the callback that will be called upon successful execution
   * @param offset starting offset.
   */
  constructor(e, t, i, s = 0) {
    this.iterations = e, this.index = s - 1, this._done = !1, this._fn = t, this._successCallback = i;
  }
  /**
   * Execute the next iteration. Must be called after the last iteration was finished.
   */
  executeNext() {
    this._done || (this.index + 1 < this.iterations ? (++this.index, this._fn(this)) : this.breakLoop());
  }
  /**
   * Break the loop and run the success callback.
   */
  breakLoop() {
    this._done = !0, this._successCallback();
  }
  /**
   * Create and run an async loop.
   * @param iterations the number of iterations.
   * @param fn the function to run each iteration
   * @param successCallback the callback that will be called upon successful execution
   * @param offset starting offset.
   * @returns the created async loop object
   */
  static Run(e, t, i, s = 0) {
    const r = new Ar(e, t, i, s);
    return r.executeNext(), r;
  }
  /**
   * A for-loop that will run a given number of iterations synchronous and the rest async.
   * @param iterations total number of iterations
   * @param syncedIterations number of synchronous iterations in each async iteration.
   * @param fn the function to call each iteration.
   * @param callback a success call back that will be called when iterating stops.
   * @param breakFunction a break condition (optional)
   * @param timeout timeout settings for the setTimeout function. default - 0.
   * @returns the created async loop object
   */
  static SyncAsyncForLoop(e, t, i, s, r, n = 0) {
    return Ar.Run(Math.ceil(e / t), (a) => {
      r && r() ? a.breakLoop() : setTimeout(() => {
        for (let o = 0; o < t; ++o) {
          const l = a.index * t + o;
          if (l >= e)
            break;
          if (i(l), r && r()) {
            a.breakLoop();
            break;
          }
        }
        a.executeNext();
      }, n);
    }, s);
  }
}
de.FallbackTexture = "data:image/jpg;base64,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";
class xl {
  constructor() {
    this._doNotSerialize = !1, this._isDisposed = !1, this._sceneRootNodesIndex = -1, this._isEnabled = !0, this._isParentEnabled = !0, this._isReady = !0, this._onEnabledStateChangedObservable = new N(), this._onClonedObservable = new N();
  }
}
let ut = class sn {
  /**
   * Add a new node constructor
   * @param type defines the type name of the node to construct
   * @param constructorFunc defines the constructor function
   */
  static AddNodeConstructor(e, t) {
    this._NodeConstructors[e] = t;
  }
  /**
   * Returns a node constructor based on type name
   * @param type defines the type name
   * @param name defines the new node name
   * @param scene defines the hosting scene
   * @param options defines optional options to transmit to constructors
   * @returns the new constructor or null
   */
  static Construct(e, t, i, s) {
    const r = this._NodeConstructors[e];
    return r ? r(t, i, s) : null;
  }
  /**
   * Gets or sets the accessibility tag to describe the node for accessibility purpose.
   */
  set accessibilityTag(e) {
    this._accessibilityTag = e, this.onAccessibilityTagChangedObservable.notifyObservers(e);
  }
  get accessibilityTag() {
    return this._accessibilityTag;
  }
  /**
   * Gets or sets a boolean used to define if the node must be serialized
   */
  get doNotSerialize() {
    return this._nodeDataStorage._doNotSerialize ? !0 : this._parentNode ? this._parentNode.doNotSerialize : !1;
  }
  set doNotSerialize(e) {
    this._nodeDataStorage._doNotSerialize = e;
  }
  /**
   * Gets a boolean indicating if the node has been disposed
   * @returns true if the node was disposed
   */
  isDisposed() {
    return this._nodeDataStorage._isDisposed;
  }
  /**
   * Gets or sets the parent of the node (without keeping the current position in the scene)
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/parent_pivot/parent
   */
  set parent(e) {
    if (this._parentNode === e)
      return;
    const t = this._parentNode;
    if (this._parentNode && this._parentNode._children !== void 0 && this._parentNode._children !== null) {
      const i = this._parentNode._children.indexOf(this);
      i !== -1 && this._parentNode._children.splice(i, 1), !e && !this._nodeDataStorage._isDisposed && this._addToSceneRootNodes();
    }
    this._parentNode = e, this._parentNode && ((this._parentNode._children === void 0 || this._parentNode._children === null) && (this._parentNode._children = new Array()), this._parentNode._children.push(this), t || this._removeFromSceneRootNodes()), this._syncParentEnabledState();
  }
  get parent() {
    return this._parentNode;
  }
  /**
   * @internal
   */
  _serializeAsParent(e) {
    e.parentId = this.uniqueId;
  }
  /** @internal */
  _addToSceneRootNodes() {
    this._nodeDataStorage._sceneRootNodesIndex === -1 && (this._nodeDataStorage._sceneRootNodesIndex = this._scene.rootNodes.length, this._scene.rootNodes.push(this));
  }
  /** @internal */
  _removeFromSceneRootNodes() {
    if (this._nodeDataStorage._sceneRootNodesIndex !== -1) {
      const e = this._scene.rootNodes, t = e.length - 1;
      e[this._nodeDataStorage._sceneRootNodesIndex] = e[t], e[this._nodeDataStorage._sceneRootNodesIndex]._nodeDataStorage._sceneRootNodesIndex = this._nodeDataStorage._sceneRootNodesIndex, this._scene.rootNodes.pop(), this._nodeDataStorage._sceneRootNodesIndex = -1;
    }
  }
  /**
   * Gets or sets the animation properties override
   */
  get animationPropertiesOverride() {
    return this._animationPropertiesOverride ? this._animationPropertiesOverride : this._scene.animationPropertiesOverride;
  }
  set animationPropertiesOverride(e) {
    this._animationPropertiesOverride = e;
  }
  /**
   * Gets a string identifying the name of the class
   * @returns "Node" string
   */
  getClassName() {
    return "Node";
  }
  /**
   * Sets a callback that will be raised when the node will be disposed
   */
  set onDispose(e) {
    this._onDisposeObserver && this.onDisposeObservable.remove(this._onDisposeObserver), this._onDisposeObserver = this.onDisposeObservable.add(e);
  }
  /**
   * An event triggered when the enabled state of the node changes
   */
  get onEnabledStateChangedObservable() {
    return this._nodeDataStorage._onEnabledStateChangedObservable;
  }
  /**
   * An event triggered when the node is cloned
   */
  get onClonedObservable() {
    return this._nodeDataStorage._onClonedObservable;
  }
  /**
   * Creates a new Node
   * @param name the name and id to be given to this node
   * @param scene the scene this node will be added to
   */
  constructor(e, t = null) {
    this._isDirty = !1, this._nodeDataStorage = new xl(), this.state = "", this.metadata = null, this.reservedDataStore = null, this._accessibilityTag = null, this.onAccessibilityTagChangedObservable = new N(), this._parentContainer = null, this.animations = new Array(), this._ranges = {}, this.onReady = null, this._currentRenderId = -1, this._parentUpdateId = -1, this._childUpdateId = -1, this._waitingParentId = null, this._waitingParentInstanceIndex = null, this._waitingParsedUniqueId = null, this._cache = {}, this._parentNode = null, this._children = null, this._worldMatrix = I.Identity(), this._worldMatrixDeterminant = 0, this._worldMatrixDeterminantIsDirty = !0, this._animationPropertiesOverride = null, this._isNode = !0, this.onDisposeObservable = new N(), this._onDisposeObserver = null, this._behaviors = new Array(), this.name = e, this.id = e, this._scene = t || de.LastCreatedScene, this.uniqueId = this._scene.getUniqueId(), this._initCache();
  }
  /**
   * Gets the scene of the node
   * @returns a scene
   */
  getScene() {
    return this._scene;
  }
  /**
   * Gets the engine of the node
   * @returns a Engine
   */
  getEngine() {
    return this._scene.getEngine();
  }
  /**
   * Attach a behavior to the node
   * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors
   * @param behavior defines the behavior to attach
   * @param attachImmediately defines that the behavior must be attached even if the scene is still loading
   * @returns the current Node
   */
  addBehavior(e, t = !1) {
    return this._behaviors.indexOf(e) !== -1 ? this : (e.init(), this._scene.isLoading && !t ? this._scene.onDataLoadedObservable.addOnce(() => {
      e.attach(this);
    }) : e.attach(this), this._behaviors.push(e), this);
  }
  /**
   * Remove an attached behavior
   * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors
   * @param behavior defines the behavior to attach
   * @returns the current Node
   */
  removeBehavior(e) {
    const t = this._behaviors.indexOf(e);
    return t === -1 ? this : (this._behaviors[t].detach(), this._behaviors.splice(t, 1), this);
  }
  /**
   * Gets the list of attached behaviors
   * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors
   */
  get behaviors() {
    return this._behaviors;
  }
  /**
   * Gets an attached behavior by name
   * @param name defines the name of the behavior to look for
   * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors
   * @returns null if behavior was not found else the requested behavior
   */
  getBehaviorByName(e) {
    for (const t of this._behaviors)
      if (t.name === e)
        return t;
    return null;
  }
  /**
   * Returns the latest update of the World matrix
   * @returns a Matrix
   */
  getWorldMatrix() {
    return this._currentRenderId !== this._scene.getRenderId() && this.computeWorldMatrix(), this._worldMatrix;
  }
  /** @internal */
  _getWorldMatrixDeterminant() {
    return this._worldMatrixDeterminantIsDirty && (this._worldMatrixDeterminantIsDirty = !1, this._worldMatrixDeterminant = this._worldMatrix.determinant()), this._worldMatrixDeterminant;
  }
  /**
   * Returns directly the latest state of the mesh World matrix.
   * A Matrix is returned.
   */
  get worldMatrixFromCache() {
    return this._worldMatrix;
  }
  // override it in derived class if you add new variables to the cache
  // and call the parent class method
  /** @internal */
  _initCache() {
    this._cache = {}, this._cache.parent = void 0;
  }
  /**
   * @internal
   */
  updateCache(e) {
    !e && this.isSynchronized() || (this._cache.parent = this.parent, this._updateCache());
  }
  /**
   * @internal
   */
  _getActionManagerForTrigger(e, t = !0) {
    return this.parent ? this.parent._getActionManagerForTrigger(e, !1) : null;
  }
  // override it in derived class if you add new variables to the cache
  // and call the parent class method if !ignoreParentClass
  /**
   * @internal
   */
  _updateCache(e) {
  }
  // override it in derived class if you add new variables to the cache
  /** @internal */
  _isSynchronized() {
    return !0;
  }
  /** @internal */
  _markSyncedWithParent() {
    this._parentNode && (this._parentUpdateId = this._parentNode._childUpdateId);
  }
  /** @internal */
  isSynchronizedWithParent() {
    return this._parentNode ? this._parentNode._isDirty || this._parentUpdateId !== this._parentNode._childUpdateId ? !1 : this._parentNode.isSynchronized() : !0;
  }
  /** @internal */
  isSynchronized() {
    return this._cache.parent !== this._parentNode ? (this._cache.parent = this._parentNode, !1) : this._parentNode && !this.isSynchronizedWithParent() ? !1 : this._isSynchronized();
  }
  /**
   * Is this node ready to be used/rendered
   * @param _completeCheck defines if a complete check (including materials and lights) has to be done (false by default)
   * @returns true if the node is ready
   */
  isReady(e = !1) {
    return this._nodeDataStorage._isReady;
  }
  /**
   * Flag the  node as dirty (Forcing it to update everything)
   * @param _property helps children apply precise "dirtyfication"
   * @returns this node
   */
  markAsDirty(e) {
    return this._currentRenderId = Number.MAX_VALUE, this._isDirty = !0, this;
  }
  /**
   * Is this node enabled?
   * If the node has a parent, all ancestors will be checked and false will be returned if any are false (not enabled), otherwise will return true
   * @param checkAncestors indicates if this method should check the ancestors. The default is to check the ancestors. If set to false, the method will return the value of this node without checking ancestors
   * @returns whether this node (and its parent) is enabled
   */
  isEnabled(e = !0) {
    return e === !1 ? this._nodeDataStorage._isEnabled : this._nodeDataStorage._isEnabled ? this._nodeDataStorage._isParentEnabled : !1;
  }
  /** @internal */
  _syncParentEnabledState() {
    this._nodeDataStorage._isParentEnabled = this._parentNode ? this._parentNode.isEnabled() : !0, this._children && this._children.forEach((e) => {
      e._syncParentEnabledState();
    });
  }
  /**
   * Set the enabled state of this node
   * @param value defines the new enabled state
   */
  setEnabled(e) {
    this._nodeDataStorage._isEnabled !== e && (this._nodeDataStorage._isEnabled = e, this._syncParentEnabledState(), this._nodeDataStorage._onEnabledStateChangedObservable.notifyObservers(e));
  }
  /**
   * Is this node a descendant of the given node?
   * The function will iterate up the hierarchy until the ancestor was found or no more parents defined
   * @param ancestor defines the parent node to inspect
   * @returns a boolean indicating if this node is a descendant of the given node
   */
  isDescendantOf(e) {
    return this.parent ? this.parent === e ? !0 : this.parent.isDescendantOf(e) : !1;
  }
  /**
   * @internal
   */
  _getDescendants(e, t = !1, i) {
    if (this._children)
      for (let s = 0; s < this._children.length; s++) {
        const r = this._children[s];
        (!i || i(r)) && e.push(r), t || r._getDescendants(e, !1, i);
      }
  }
  /**
   * Will return all nodes that have this node as ascendant
   * @param directDescendantsOnly defines if true only direct descendants of 'this' will be considered, if false direct and also indirect (children of children, an so on in a recursive manner) descendants of 'this' will be considered
   * @param predicate defines an optional predicate that will be called on every evaluated child, the predicate must return true for a given child to be part of the result, otherwise it will be ignored
   * @returns all children nodes of all types
   */
  getDescendants(e, t) {
    const i = new Array();
    return this._getDescendants(i, e, t), i;
  }
  /**
   * Get all child-meshes of this node
   * @param directDescendantsOnly defines if true only direct descendants of 'this' will be considered, if false direct and also indirect (children of children, an so on in a recursive manner) descendants of 'this' will be considered (Default: false)
   * @param predicate defines an optional predicate that will be called on every evaluated child, the predicate must return true for a given child to be part of the result, otherwise it will be ignored
   * @returns an array of AbstractMesh
   */
  getChildMeshes(e, t) {
    const i = [];
    return this._getDescendants(i, e, (s) => (!t || t(s)) && s.cullingStrategy !== void 0), i;
  }
  /**
   * Get all direct children of this node
   * @param predicate defines an optional predicate that will be called on every evaluated child, the predicate must return true for a given child to be part of the result, otherwise it will be ignored
   * @param directDescendantsOnly defines if true only direct descendants of 'this' will be considered, if false direct and also indirect (children of children, an so on in a recursive manner) descendants of 'this' will be considered (Default: true)
   * @returns an array of Node
   */
  getChildren(e, t = !0) {
    return this.getDescendants(t, e);
  }
  /**
   * @internal
   */
  _setReady(e) {
    if (e !== this._nodeDataStorage._isReady) {
      if (!e) {
        this._nodeDataStorage._isReady = !1;
        return;
      }
      this.onReady && this.onReady(this), this._nodeDataStorage._isReady = !0;
    }
  }
  /**
   * Get an animation by name
   * @param name defines the name of the animation to look for
   * @returns null if not found else the requested animation
   */
  getAnimationByName(e) {
    for (let t = 0; t < this.animations.length; t++) {
      const i = this.animations[t];
      if (i.name === e)
        return i;
    }
    return null;
  }
  /**
   * Creates an animation range for this node
   * @param name defines the name of the range
   * @param from defines the starting key
   * @param to defines the end key
   */
  createAnimationRange(e, t, i) {
    if (!this._ranges[e]) {
      this._ranges[e] = sn._AnimationRangeFactory(e, t, i);
      for (let s = 0, r = this.animations.length; s < r; s++)
        this.animations[s] && this.animations[s].createRange(e, t, i);
    }
  }
  /**
   * Delete a specific animation range
   * @param name defines the name of the range to delete
   * @param deleteFrames defines if animation frames from the range must be deleted as well
   */
  deleteAnimationRange(e, t = !0) {
    for (let i = 0, s = this.animations.length; i < s; i++)
      this.animations[i] && this.animations[i].deleteRange(e, t);
    this._ranges[e] = null;
  }
  /**
   * Get an animation range by name
   * @param name defines the name of the animation range to look for
   * @returns null if not found else the requested animation range
   */
  getAnimationRange(e) {
    return this._ranges[e] || null;
  }
  /**
   * Clone the current node
   * @param name Name of the new clone
   * @param newParent New parent for the clone
   * @param doNotCloneChildren Do not clone children hierarchy
   * @returns the new transform node
   */
  clone(e, t, i) {
    const s = le.Clone(() => new sn(e, this.getScene()), this);
    if (t && (s.parent = t), !i) {
      const r = this.getDescendants(!0);
      for (let n = 0; n < r.length; n++) {
        const a = r[n];
        a.clone(e + "." + a.name, s);
      }
    }
    return s;
  }
  /**
   * Gets the list of all animation ranges defined on this node
   * @returns an array
   */
  getAnimationRanges() {
    const e = [];
    let t;
    for (t in this._ranges)
      e.push(this._ranges[t]);
    return e;
  }
  /**
   * Will start the animation sequence
   * @param name defines the range frames for animation sequence
   * @param loop defines if the animation should loop (false by default)
   * @param speedRatio defines the speed factor in which to run the animation (1 by default)
   * @param onAnimationEnd defines a function to be executed when the animation ended (undefined by default)
   * @returns the object created for this animation. If range does not exist, it will return null
   */
  beginAnimation(e, t, i, s) {
    const r = this.getAnimationRange(e);
    return r ? this._scene.beginAnimation(this, r.from, r.to, t, i, s) : null;
  }
  /**
   * Serialize animation ranges into a JSON compatible object
   * @returns serialization object
   */
  serializeAnimationRanges() {
    const e = [];
    for (const t in this._ranges) {
      const i = this._ranges[t];
      if (!i)
        continue;
      const s = {};
      s.name = t, s.from = i.from, s.to = i.to, e.push(s);
    }
    return e;
  }
  /**
   * Computes the world matrix of the node
   * @param _force defines if the cache version should be invalidated forcing the world matrix to be created from scratch
   * @returns the world matrix
   */
  computeWorldMatrix(e) {
    return this._worldMatrix || (this._worldMatrix = I.Identity()), this._worldMatrix;
  }
  /**
   * Releases resources associated with this node.
   * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
   * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
   */
  dispose(e, t = !1) {
    if (this._nodeDataStorage._isDisposed = !0, !e) {
      const i = this.getDescendants(!0);
      for (const s of i)
        s.dispose(e, t);
    }
    this.parent ? this.parent = null : this._removeFromSceneRootNodes(), this.onDisposeObservable.notifyObservers(this), this.onDisposeObservable.clear(), this.onEnabledStateChangedObservable.clear(), this.onClonedObservable.clear();
    for (const i of this._behaviors)
      i.detach();
    this._behaviors.length = 0, this.metadata = null;
  }
  /**
   * Parse animation range data from a serialization object and store them into a given node
   * @param node defines where to store the animation ranges
   * @param parsedNode defines the serialization object to read data from
   * @param _scene defines the hosting scene
   */
  static ParseAnimationRanges(e, t, i) {
    if (t.ranges)
      for (let s = 0; s < t.ranges.length; s++) {
        const r = t.ranges[s];
        e.createAnimationRange(r.name, r.from, r.to);
      }
  }
  /**
   * Return the minimum and maximum world vectors of the entire hierarchy under current node
   * @param includeDescendants Include bounding info from descendants as well (true by default)
   * @param predicate defines a callback function that can be customize to filter what meshes should be included in the list used to compute the bounding vectors
   * @returns the new bounding vectors
   */
  getHierarchyBoundingVectors(e = !0, t = null) {
    this.getScene().incrementRenderId(), this.computeWorldMatrix(!0);
    let i, s;
    const r = this;
    if (r.getBoundingInfo && r.subMeshes) {
      const n = r.getBoundingInfo();
      i = n.boundingBox.minimumWorld.clone(), s = n.boundingBox.maximumWorld.clone();
    } else
      i = new p(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE), s = new p(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
    if (e) {
      const n = this.getDescendants(!1);
      for (const a of n) {
        const o = a;
        if (o.computeWorldMatrix(!0), t && !t(o) || !o.getBoundingInfo || o.getTotalVertices() === 0)
          continue;
        const c = o.getBoundingInfo().boundingBox, u = c.minimumWorld, d = c.maximumWorld;
        p.CheckExtends(u, i, s), p.CheckExtends(d, i, s);
      }
    }
    return {
      min: i,
      max: s
    };
  }
};
ut._AnimationRangeFactory = (h, e, t) => {
  throw he("AnimationRange");
};
ut._NodeConstructors = {};
E([
  R()
], ut.prototype, "name", void 0);
E([
  R()
], ut.prototype, "id", void 0);
E([
  R()
], ut.prototype, "uniqueId", void 0);
E([
  R()
], ut.prototype, "state", void 0);
E([
  R()
], ut.prototype, "metadata", void 0);
class Bs {
  /**
   * Creates a Viewport object located at (x, y) and sized (width, height)
   * @param x defines viewport left coordinate
   * @param y defines viewport top coordinate
   * @param width defines the viewport width
   * @param height defines the viewport height
   */
  constructor(e, t, i, s) {
    this.x = e, this.y = t, this.width = i, this.height = s;
  }
  /**
   * Creates a new viewport using absolute sizing (from 0-> width, 0-> height instead of 0->1)
   * @param renderWidth defines the rendering width
   * @param renderHeight defines the rendering height
   * @returns a new Viewport
   */
  toGlobal(e, t) {
    return new Bs(this.x * e, this.y * t, this.width * e, this.height * t);
  }
  /**
   * Stores absolute viewport value into a target viewport (from 0-> width, 0-> height instead of 0->1)
   * @param renderWidth defines the rendering width
   * @param renderHeight defines the rendering height
   * @param ref defines the target viewport
   * @returns the current viewport
   */
  toGlobalToRef(e, t, i) {
    return i.x = this.x * e, i.y = this.y * t, i.width = this.width * e, i.height = this.height * t, this;
  }
  /**
   * Returns a new Viewport copied from the current one
   * @returns a new Viewport
   */
  clone() {
    return new Bs(this.x, this.y, this.width, this.height);
  }
}
class Dt {
  /**
   * Creates a Plane object according to the given floats a, b, c, d and the plane equation : ax + by + cz + d = 0
   * @param a a component of the plane
   * @param b b component of the plane
   * @param c c component of the plane
   * @param d d component of the plane
   */
  constructor(e, t, i, s) {
    this.normal = new p(e, t, i), this.d = s;
  }
  /**
   * @returns the plane coordinates as a new array of 4 elements [a, b, c, d].
   */
  asArray() {
    return [this.normal.x, this.normal.y, this.normal.z, this.d];
  }
  // Methods
  /**
   * @returns a new plane copied from the current Plane.
   */
  clone() {
    return new Dt(this.normal.x, this.normal.y, this.normal.z, this.d);
  }
  /**
   * @returns the string "Plane".
   */
  getClassName() {
    return "Plane";
  }
  /**
   * @returns the Plane hash code.
   */
  getHashCode() {
    let e = this.normal.getHashCode();
    return e = e * 397 ^ (this.d | 0), e;
  }
  /**
   * Normalize the current Plane in place.
   * @returns the updated Plane.
   */
  normalize() {
    const e = Math.sqrt(this.normal.x * this.normal.x + this.normal.y * this.normal.y + this.normal.z * this.normal.z);
    let t = 0;
    return e !== 0 && (t = 1 / e), this.normal.x *= t, this.normal.y *= t, this.normal.z *= t, this.d *= t, this;
  }
  /**
   * Applies a transformation the plane and returns the result
   * @param transformation the transformation matrix to be applied to the plane
   * @returns a new Plane as the result of the transformation of the current Plane by the given matrix.
   */
  transform(e) {
    const t = Dt._TmpMatrix;
    e.invertToRef(t);
    const i = t.m, s = this.normal.x, r = this.normal.y, n = this.normal.z, a = this.d, o = s * i[0] + r * i[1] + n * i[2] + a * i[3], l = s * i[4] + r * i[5] + n * i[6] + a * i[7], c = s * i[8] + r * i[9] + n * i[10] + a * i[11], u = s * i[12] + r * i[13] + n * i[14] + a * i[15];
    return new Dt(o, l, c, u);
  }
  /**
   * Compute the dot product between the point and the plane normal
   * @param point point to calculate the dot product with
   * @returns the dot product (float) of the point coordinates and the plane normal.
   */
  dotCoordinate(e) {
    return this.normal.x * e.x + this.normal.y * e.y + this.normal.z * e.z + this.d;
  }
  /**
   * Updates the current Plane from the plane defined by the three given points.
   * @param point1 one of the points used to construct the plane
   * @param point2 one of the points used to construct the plane
   * @param point3 one of the points used to construct the plane
   * @returns the updated Plane.
   */
  copyFromPoints(e, t, i) {
    const s = t.x - e.x, r = t.y - e.y, n = t.z - e.z, a = i.x - e.x, o = i.y - e.y, l = i.z - e.z, c = r * l - n * o, u = n * a - s * l, d = s * o - r * a, f = Math.sqrt(c * c + u * u + d * d);
    let _;
    return f !== 0 ? _ = 1 / f : _ = 0, this.normal.x = c * _, this.normal.y = u * _, this.normal.z = d * _, this.d = -(this.normal.x * e.x + this.normal.y * e.y + this.normal.z * e.z), this;
  }
  /**
   * Checks if the plane is facing a given direction (meaning if the plane's normal is pointing in the opposite direction of the given vector).
   * Note that for this function to work as expected you should make sure that:
   *   - direction and the plane normal are normalized
   *   - epsilon is a number just bigger than -1, something like -0.99 for eg
   * @param direction the direction to check if the plane is facing
   * @param epsilon value the dot product is compared against (returns true if dot <= epsilon)
   * @returns True if the plane is facing the given direction
   */
  isFrontFacingTo(e, t) {
    return p.Dot(this.normal, e) <= t;
  }
  /**
   * Calculates the distance to a point
   * @param point point to calculate distance to
   * @returns the signed distance (float) from the given point to the Plane.
   */
  signedDistanceTo(e) {
    return p.Dot(e, this.normal) + this.d;
  }
  // Statics
  /**
   * Creates a plane from an  array
   * @param array the array to create a plane from
   * @returns a new Plane from the given array.
   */
  static FromArray(e) {
    return new Dt(e[0], e[1], e[2], e[3]);
  }
  /**
   * Creates a plane from three points
   * @param point1 point used to create the plane
   * @param point2 point used to create the plane
   * @param point3 point used to create the plane
   * @returns a new Plane defined by the three given points.
   */
  static FromPoints(e, t, i) {
    const s = new Dt(0, 0, 0, 0);
    return s.copyFromPoints(e, t, i), s;
  }
  /**
   * Creates a plane from an origin point and a normal
   * @param origin origin of the plane to be constructed
   * @param normal normal of the plane to be constructed
   * @returns a new Plane the normal vector to this plane at the given origin point.
   * Note : the vector "normal" is updated because normalized.
   */
  static FromPositionAndNormal(e, t) {
    const i = new Dt(0, 0, 0, 0);
    return t.normalize(), i.normal = t, i.d = -(t.x * e.x + t.y * e.y + t.z * e.z), i;
  }
  /**
   * Calculates the distance from a plane and a point
   * @param origin origin of the plane to be constructed
   * @param normal normal of the plane to be constructed
   * @param point point to calculate distance to
   * @returns the signed distance between the plane defined by the normal vector at the "origin"" point and the given other point.
   */
  static SignedDistanceToPlaneFromPositionAndNormal(e, t, i) {
    const s = -(t.x * e.x + t.y * e.y + t.z * e.z);
    return p.Dot(i, t) + s;
  }
}
Dt._TmpMatrix = I.Identity();
class jt {
  /**
   * Gets the planes representing the frustum
   * @param transform matrix to be applied to the returned planes
   * @returns a new array of 6 Frustum planes computed by the given transformation matrix.
   */
  static GetPlanes(e) {
    const t = [];
    for (let i = 0; i < 6; i++)
      t.push(new Dt(0, 0, 0, 0));
    return jt.GetPlanesToRef(e, t), t;
  }
  /**
   * Gets the near frustum plane transformed by the transform matrix
   * @param transform transformation matrix to be applied to the resulting frustum plane
   * @param frustumPlane the resulting frustum plane
   */
  static GetNearPlaneToRef(e, t) {
    const i = e.m;
    t.normal.x = i[3] + i[2], t.normal.y = i[7] + i[6], t.normal.z = i[11] + i[10], t.d = i[15] + i[14], t.normalize();
  }
  /**
   * Gets the far frustum plane transformed by the transform matrix
   * @param transform transformation matrix to be applied to the resulting frustum plane
   * @param frustumPlane the resulting frustum plane
   */
  static GetFarPlaneToRef(e, t) {
    const i = e.m;
    t.normal.x = i[3] - i[2], t.normal.y = i[7] - i[6], t.normal.z = i[11] - i[10], t.d = i[15] - i[14], t.normalize();
  }
  /**
   * Gets the left frustum plane transformed by the transform matrix
   * @param transform transformation matrix to be applied to the resulting frustum plane
   * @param frustumPlane the resulting frustum plane
   */
  static GetLeftPlaneToRef(e, t) {
    const i = e.m;
    t.normal.x = i[3] + i[0], t.normal.y = i[7] + i[4], t.normal.z = i[11] + i[8], t.d = i[15] + i[12], t.normalize();
  }
  /**
   * Gets the right frustum plane transformed by the transform matrix
   * @param transform transformation matrix to be applied to the resulting frustum plane
   * @param frustumPlane the resulting frustum plane
   */
  static GetRightPlaneToRef(e, t) {
    const i = e.m;
    t.normal.x = i[3] - i[0], t.normal.y = i[7] - i[4], t.normal.z = i[11] - i[8], t.d = i[15] - i[12], t.normalize();
  }
  /**
   * Gets the top frustum plane transformed by the transform matrix
   * @param transform transformation matrix to be applied to the resulting frustum plane
   * @param frustumPlane the resulting frustum plane
   */
  static GetTopPlaneToRef(e, t) {
    const i = e.m;
    t.normal.x = i[3] - i[1], t.normal.y = i[7] - i[5], t.normal.z = i[11] - i[9], t.d = i[15] - i[13], t.normalize();
  }
  /**
   * Gets the bottom frustum plane transformed by the transform matrix
   * @param transform transformation matrix to be applied to the resulting frustum plane
   * @param frustumPlane the resulting frustum plane
   */
  static GetBottomPlaneToRef(e, t) {
    const i = e.m;
    t.normal.x = i[3] + i[1], t.normal.y = i[7] + i[5], t.normal.z = i[11] + i[9], t.d = i[15] + i[13], t.normalize();
  }
  /**
   * Sets the given array "frustumPlanes" with the 6 Frustum planes computed by the given transformation matrix.
   * @param transform transformation matrix to be applied to the resulting frustum planes
   * @param frustumPlanes the resulting frustum planes
   */
  static GetPlanesToRef(e, t) {
    jt.GetNearPlaneToRef(e, t[0]), jt.GetFarPlaneToRef(e, t[1]), jt.GetLeftPlaneToRef(e, t[2]), jt.GetRightPlaneToRef(e, t[3]), jt.GetTopPlaneToRef(e, t[4]), jt.GetBottomPlaneToRef(e, t[5]);
  }
  /**
   * Tests if a point is located between the frustum planes.
   * @param point defines the point to test
   * @param frustumPlanes defines the frustum planes to test
   * @returns true if the point is located between the frustum planes
   */
  static IsPointInFrustum(e, t) {
    for (let i = 0; i < 6; i++)
      if (t[i].dotCoordinate(e) < 0)
        return !1;
    return !0;
  }
}
class Q extends ut {
  /**
   * Define the current local position of the camera in the scene
   */
  get position() {
    return this._position;
  }
  set position(e) {
    this._position = e;
  }
  /**
   * The vector the camera should consider as up.
   * (default is Vector3(0, 1, 0) aka Vector3.Up())
   */
  set upVector(e) {
    this._upVector = e;
  }
  get upVector() {
    return this._upVector;
  }
  /**
   * The screen area in scene units squared
   */
  get screenArea() {
    var e, t, i, s;
    let r = 0, n = 0;
    if (this.mode === Q.PERSPECTIVE_CAMERA)
      this.fovMode === Q.FOVMODE_VERTICAL_FIXED ? (n = this.minZ * 2 * Math.tan(this.fov / 2), r = this.getEngine().getAspectRatio(this) * n) : (r = this.minZ * 2 * Math.tan(this.fov / 2), n = r / this.getEngine().getAspectRatio(this));
    else {
      const a = this.getEngine().getRenderWidth() / 2, o = this.getEngine().getRenderHeight() / 2;
      r = ((e = this.orthoRight) !== null && e !== void 0 ? e : a) - ((t = this.orthoLeft) !== null && t !== void 0 ? t : -a), n = ((i = this.orthoTop) !== null && i !== void 0 ? i : o) - ((s = this.orthoBottom) !== null && s !== void 0 ? s : -o);
    }
    return r * n;
  }
  set orthoLeft(e) {
    this._orthoLeft = e;
    for (const t of this._rigCameras)
      t.orthoLeft = e;
  }
  get orthoLeft() {
    return this._orthoLeft;
  }
  set orthoRight(e) {
    this._orthoRight = e;
    for (const t of this._rigCameras)
      t.orthoRight = e;
  }
  get orthoRight() {
    return this._orthoRight;
  }
  set orthoBottom(e) {
    this._orthoBottom = e;
    for (const t of this._rigCameras)
      t.orthoBottom = e;
  }
  get orthoBottom() {
    return this._orthoBottom;
  }
  set orthoTop(e) {
    this._orthoTop = e;
    for (const t of this._rigCameras)
      t.orthoTop = e;
  }
  get orthoTop() {
    return this._orthoTop;
  }
  set mode(e) {
    this._mode = e;
    for (const t of this._rigCameras)
      t.mode = e;
  }
  get mode() {
    return this._mode;
  }
  /**
   * Instantiates a new camera object.
   * This should not be used directly but through the inherited cameras: ArcRotate, Free...
   * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras
   * @param name Defines the name of the camera in the scene
   * @param position Defines the position of the camera
   * @param scene Defines the scene the camera belongs too
   * @param setActiveOnSceneIfNoneActive Defines if the camera should be set as active after creation if no other camera have been defined in the scene
   */
  constructor(e, t, i, s = !0) {
    super(e, i), this._position = p.Zero(), this._upVector = p.Up(), this._orthoLeft = null, this._orthoRight = null, this._orthoBottom = null, this._orthoTop = null, this.fov = 0.8, this.projectionPlaneTilt = 0, this.minZ = 1, this.maxZ = 1e4, this.inertia = 0.9, this._mode = Q.PERSPECTIVE_CAMERA, this.isIntermediate = !1, this.viewport = new Bs(0, 0, 1, 1), this.layerMask = 268435455, this.fovMode = Q.FOVMODE_VERTICAL_FIXED, this.cameraRigMode = Q.RIG_MODE_NONE, this.customRenderTargets = new Array(), this.outputRenderTarget = null, this.onViewMatrixChangedObservable = new N(), this.onProjectionMatrixChangedObservable = new N(), this.onAfterCheckInputsObservable = new N(), this.onRestoreStateObservable = new N(), this.isRigCamera = !1, this._rigCameras = new Array(), this._webvrViewMatrix = I.Identity(), this._skipRendering = !1, this._projectionMatrix = new I(), this._postProcesses = new Array(), this._activeMeshes = new At(256), this._globalPosition = p.Zero(), this._computedViewMatrix = I.Identity(), this._doNotComputeProjectionMatrix = !1, this._transformMatrix = I.Zero(), this._refreshFrustumPlanes = !0, this._absoluteRotation = U.Identity(), this._isCamera = !0, this._isLeftCamera = !1, this._isRightCamera = !1, this.getScene().addCamera(this), s && !this.getScene().activeCamera && (this.getScene().activeCamera = this), this.position = t, this.renderPassId = this.getScene().getEngine().createRenderPassId(`Camera ${e}`);
  }
  /**
   * Store current camera state (fov, position, etc..)
   * @returns the camera
   */
  storeState() {
    return this._stateStored = !0, this._storedFov = this.fov, this;
  }
  /**
   * Restores the camera state values if it has been stored. You must call storeState() first
   */
  _restoreStateValues() {
    return this._stateStored ? (this.fov = this._storedFov, !0) : !1;
  }
  /**
   * Restored camera state. You must call storeState() first.
   * @returns true if restored and false otherwise
   */
  restoreState() {
    return this._restoreStateValues() ? (this.onRestoreStateObservable.notifyObservers(this), !0) : !1;
  }
  /**
   * Gets the class name of the camera.
   * @returns the class name
   */
  getClassName() {
    return "Camera";
  }
  /**
   * Gets a string representation of the camera useful for debug purpose.
   * @param fullDetails Defines that a more verbose level of logging is required
   * @returns the string representation
   */
  toString(e) {
    let t = "Name: " + this.name;
    if (t += ", type: " + this.getClassName(), this.animations)
      for (let i = 0; i < this.animations.length; i++)
        t += ", animation[0]: " + this.animations[i].toString(e);
    return t;
  }
  /**
   * Automatically tilts the projection plane, using `projectionPlaneTilt`, to correct the perspective effect on vertical lines.
   */
  applyVerticalCorrection() {
    const e = this.absoluteRotation.toEulerAngles();
    this.projectionPlaneTilt = this._scene.useRightHandedSystem ? -e.x : e.x;
  }
  /**
   * Gets the current world space position of the camera.
   */
  get globalPosition() {
    return this._globalPosition;
  }
  /**
   * Gets the list of active meshes this frame (meshes no culled or excluded by lod s in the frame)
   * @returns the active meshe list
   */
  getActiveMeshes() {
    return this._activeMeshes;
  }
  /**
   * Check whether a mesh is part of the current active mesh list of the camera
   * @param mesh Defines the mesh to check
   * @returns true if active, false otherwise
   */
  isActiveMesh(e) {
    return this._activeMeshes.indexOf(e) !== -1;
  }
  /**
   * Is this camera ready to be used/rendered
   * @param completeCheck defines if a complete check (including post processes) has to be done (false by default)
   * @returns true if the camera is ready
   */
  isReady(e = !1) {
    if (e) {
      for (const t of this._postProcesses)
        if (t && !t.isReady())
          return !1;
    }
    return super.isReady(e);
  }
  /** @internal */
  _initCache() {
    super._initCache(), this._cache.position = new p(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE), this._cache.upVector = new p(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE), this._cache.mode = void 0, this._cache.minZ = void 0, this._cache.maxZ = void 0, this._cache.fov = void 0, this._cache.fovMode = void 0, this._cache.aspectRatio = void 0, this._cache.orthoLeft = void 0, this._cache.orthoRight = void 0, this._cache.orthoBottom = void 0, this._cache.orthoTop = void 0, this._cache.renderWidth = void 0, this._cache.renderHeight = void 0;
  }
  /**
   * @internal
   */
  _updateCache(e) {
    e || super._updateCache(), this._cache.position.copyFrom(this.position), this._cache.upVector.copyFrom(this.upVector);
  }
  /** @internal */
  _isSynchronized() {
    return this._isSynchronizedViewMatrix() && this._isSynchronizedProjectionMatrix();
  }
  /** @internal */
  _isSynchronizedViewMatrix() {
    return super._isSynchronized() ? this._cache.position.equals(this.position) && this._cache.upVector.equals(this.upVector) && this.isSynchronizedWithParent() : !1;
  }
  /** @internal */
  _isSynchronizedProjectionMatrix() {
    let e = this._cache.mode === this.mode && this._cache.minZ === this.minZ && this._cache.maxZ === this.maxZ;
    if (!e)
      return !1;
    const t = this.getEngine();
    return this.mode === Q.PERSPECTIVE_CAMERA ? e = this._cache.fov === this.fov && this._cache.fovMode === this.fovMode && this._cache.aspectRatio === t.getAspectRatio(this) && this._cache.projectionPlaneTilt === this.projectionPlaneTilt : e = this._cache.orthoLeft === this.orthoLeft && this._cache.orthoRight === this.orthoRight && this._cache.orthoBottom === this.orthoBottom && this._cache.orthoTop === this.orthoTop && this._cache.renderWidth === t.getRenderWidth() && this._cache.renderHeight === t.getRenderHeight(), e;
  }
  /**
   * Attach the input controls to a specific dom element to get the input from.
   * This function is here because typescript removes the typing of the last function.
   * @param _ignored defines an ignored parameter kept for backward compatibility.
   * @param _noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
   */
  attachControl(e, t) {
  }
  /**
   * Detach the current controls from the specified dom element.
   * This function is here because typescript removes the typing of the last function.
   * @param _ignored defines an ignored parameter kept for backward compatibility.
   */
  detachControl(e) {
  }
  /**
   * Update the camera state according to the different inputs gathered during the frame.
   */
  update() {
    this._checkInputs(), this.cameraRigMode !== Q.RIG_MODE_NONE && this._updateRigCameras(), this.getViewMatrix(), this.getProjectionMatrix();
  }
  /** @internal */
  _checkInputs() {
    this.onAfterCheckInputsObservable.notifyObservers(this);
  }
  /** @internal */
  get rigCameras() {
    return this._rigCameras;
  }
  /**
   * Gets the post process used by the rig cameras
   */
  get rigPostProcess() {
    return this._rigPostProcess;
  }
  /**
   * Internal, gets the first post process.
   * @returns the first post process to be run on this camera.
   */
  _getFirstPostProcess() {
    for (let e = 0; e < this._postProcesses.length; e++)
      if (this._postProcesses[e] !== null)
        return this._postProcesses[e];
    return null;
  }
  _cascadePostProcessesToRigCams() {
    const e = this._getFirstPostProcess();
    e && e.markTextureDirty();
    for (let t = 0, i = this._rigCameras.length; t < i; t++) {
      const s = this._rigCameras[t], r = s._rigPostProcess;
      r ? (r.getEffectName() === "pass" && (s.isIntermediate = this._postProcesses.length === 0), s._postProcesses = this._postProcesses.slice(0).concat(r), r.markTextureDirty()) : s._postProcesses = this._postProcesses.slice(0);
    }
  }
  /**
   * Attach a post process to the camera.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/postProcesses/usePostProcesses#attach-postprocess
   * @param postProcess The post process to attach to the camera
   * @param insertAt The position of the post process in case several of them are in use in the scene
   * @returns the position the post process has been inserted at
   */
  attachPostProcess(e, t = null) {
    return !e.isReusable() && this._postProcesses.indexOf(e) > -1 ? (w.Error("You're trying to reuse a post process not defined as reusable."), 0) : (t == null || t < 0 ? this._postProcesses.push(e) : this._postProcesses[t] === null ? this._postProcesses[t] = e : this._postProcesses.splice(t, 0, e), this._cascadePostProcessesToRigCams(), this._scene.prePassRenderer && this._scene.prePassRenderer.markAsDirty(), this._postProcesses.indexOf(e));
  }
  /**
   * Detach a post process to the camera.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/postProcesses/usePostProcesses#attach-postprocess
   * @param postProcess The post process to detach from the camera
   */
  detachPostProcess(e) {
    const t = this._postProcesses.indexOf(e);
    t !== -1 && (this._postProcesses[t] = null), this._scene.prePassRenderer && this._scene.prePassRenderer.markAsDirty(), this._cascadePostProcessesToRigCams();
  }
  /**
   * Gets the current world matrix of the camera
   */
  getWorldMatrix() {
    return this._isSynchronizedViewMatrix() ? this._worldMatrix : (this.getViewMatrix(), this._worldMatrix);
  }
  /** @internal */
  _getViewMatrix() {
    return I.Identity();
  }
  /**
   * Gets the current view matrix of the camera.
   * @param force forces the camera to recompute the matrix without looking at the cached state
   * @returns the view matrix
   */
  getViewMatrix(e) {
    return !e && this._isSynchronizedViewMatrix() ? this._computedViewMatrix : (this.updateCache(), this._computedViewMatrix = this._getViewMatrix(), this._currentRenderId = this.getScene().getRenderId(), this._childUpdateId++, this._refreshFrustumPlanes = !0, this._cameraRigParams && this._cameraRigParams.vrPreViewMatrix && this._computedViewMatrix.multiplyToRef(this._cameraRigParams.vrPreViewMatrix, this._computedViewMatrix), this.parent && this.parent.onViewMatrixChangedObservable && this.parent.onViewMatrixChangedObservable.notifyObservers(this.parent), this.onViewMatrixChangedObservable.notifyObservers(this), this._computedViewMatrix.invertToRef(this._worldMatrix), this._computedViewMatrix);
  }
  /**
   * Freeze the projection matrix.
   * It will prevent the cache check of the camera projection compute and can speed up perf
   * if no parameter of the camera are meant to change
   * @param projection Defines manually a projection if necessary
   */
  freezeProjectionMatrix(e) {
    this._doNotComputeProjectionMatrix = !0, e !== void 0 && (this._projectionMatrix = e);
  }
  /**
   * Unfreeze the projection matrix if it has previously been freezed by freezeProjectionMatrix.
   */
  unfreezeProjectionMatrix() {
    this._doNotComputeProjectionMatrix = !1;
  }
  /**
   * Gets the current projection matrix of the camera.
   * @param force forces the camera to recompute the matrix without looking at the cached state
   * @returns the projection matrix
   */
  getProjectionMatrix(e) {
    var t, i, s, r, n, a, o, l;
    if (this._doNotComputeProjectionMatrix || !e && this._isSynchronizedProjectionMatrix())
      return this._projectionMatrix;
    this._cache.mode = this.mode, this._cache.minZ = this.minZ, this._cache.maxZ = this.maxZ, this._refreshFrustumPlanes = !0;
    const c = this.getEngine(), u = this.getScene(), d = c.useReverseDepthBuffer;
    if (this.mode === Q.PERSPECTIVE_CAMERA) {
      this._cache.fov = this.fov, this._cache.fovMode = this.fovMode, this._cache.aspectRatio = c.getAspectRatio(this), this._cache.projectionPlaneTilt = this.projectionPlaneTilt, this.minZ <= 0 && (this.minZ = 0.1);
      let f;
      u.useRightHandedSystem ? f = I.PerspectiveFovRHToRef : f = I.PerspectiveFovLHToRef, f(this.fov, c.getAspectRatio(this), d ? this.maxZ : this.minZ, d ? this.minZ : this.maxZ, this._projectionMatrix, this.fovMode === Q.FOVMODE_VERTICAL_FIXED, c.isNDCHalfZRange, this.projectionPlaneTilt, d);
    } else {
      const f = c.getRenderWidth() / 2, _ = c.getRenderHeight() / 2;
      u.useRightHandedSystem ? I.OrthoOffCenterRHToRef((t = this.orthoLeft) !== null && t !== void 0 ? t : -f, (i = this.orthoRight) !== null && i !== void 0 ? i : f, (s = this.orthoBottom) !== null && s !== void 0 ? s : -_, (r = this.orthoTop) !== null && r !== void 0 ? r : _, d ? this.maxZ : this.minZ, d ? this.minZ : this.maxZ, this._projectionMatrix, c.isNDCHalfZRange) : I.OrthoOffCenterLHToRef((n = this.orthoLeft) !== null && n !== void 0 ? n : -f, (a = this.orthoRight) !== null && a !== void 0 ? a : f, (o = this.orthoBottom) !== null && o !== void 0 ? o : -_, (l = this.orthoTop) !== null && l !== void 0 ? l : _, d ? this.maxZ : this.minZ, d ? this.minZ : this.maxZ, this._projectionMatrix, c.isNDCHalfZRange), this._cache.orthoLeft = this.orthoLeft, this._cache.orthoRight = this.orthoRight, this._cache.orthoBottom = this.orthoBottom, this._cache.orthoTop = this.orthoTop, this._cache.renderWidth = c.getRenderWidth(), this._cache.renderHeight = c.getRenderHeight();
    }
    return this.onProjectionMatrixChangedObservable.notifyObservers(this), this._projectionMatrix;
  }
  /**
   * Gets the transformation matrix (ie. the multiplication of view by projection matrices)
   * @returns a Matrix
   */
  getTransformationMatrix() {
    return this._computedViewMatrix.multiplyToRef(this._projectionMatrix, this._transformMatrix), this._transformMatrix;
  }
  _updateFrustumPlanes() {
    this._refreshFrustumPlanes && (this.getTransformationMatrix(), this._frustumPlanes ? jt.GetPlanesToRef(this._transformMatrix, this._frustumPlanes) : this._frustumPlanes = jt.GetPlanes(this._transformMatrix), this._refreshFrustumPlanes = !1);
  }
  /**
   * Checks if a cullable object (mesh...) is in the camera frustum
   * This checks the bounding box center. See isCompletelyInFrustum for a full bounding check
   * @param target The object to check
   * @param checkRigCameras If the rig cameras should be checked (eg. with webVR camera both eyes should be checked) (Default: false)
   * @returns true if the object is in frustum otherwise false
   */
  isInFrustum(e, t = !1) {
    if (this._updateFrustumPlanes(), t && this.rigCameras.length > 0) {
      let i = !1;
      return this.rigCameras.forEach((s) => {
        s._updateFrustumPlanes(), i = i || e.isInFrustum(s._frustumPlanes);
      }), i;
    } else
      return e.isInFrustum(this._frustumPlanes);
  }
  /**
   * Checks if a cullable object (mesh...) is in the camera frustum
   * Unlike isInFrustum this checks the full bounding box
   * @param target The object to check
   * @returns true if the object is in frustum otherwise false
   */
  isCompletelyInFrustum(e) {
    return this._updateFrustumPlanes(), e.isCompletelyInFrustum(this._frustumPlanes);
  }
  /**
   * Gets a ray in the forward direction from the camera.
   * @param length Defines the length of the ray to create
   * @param transform Defines the transform to apply to the ray, by default the world matrix is used to create a workd space ray
   * @param origin Defines the start point of the ray which defaults to the camera position
   * @returns the forward ray
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getForwardRay(e = 100, t, i) {
    throw he("Ray");
  }
  /**
   * Gets a ray in the forward direction from the camera.
   * @param refRay the ray to (re)use when setting the values
   * @param length Defines the length of the ray to create
   * @param transform Defines the transform to apply to the ray, by default the world matrx is used to create a workd space ray
   * @param origin Defines the start point of the ray which defaults to the camera position
   * @returns the forward ray
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getForwardRayToRef(e, t = 100, i, s) {
    throw he("Ray");
  }
  /**
   * Releases resources associated with this node.
   * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
   * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
   */
  dispose(e, t = !1) {
    for (this.onViewMatrixChangedObservable.clear(), this.onProjectionMatrixChangedObservable.clear(), this.onAfterCheckInputsObservable.clear(), this.onRestoreStateObservable.clear(), this.inputs && this.inputs.clear(), this.getScene().stopAnimation(this), this.getScene().removeCamera(this); this._rigCameras.length > 0; ) {
      const s = this._rigCameras.pop();
      s && s.dispose();
    }
    if (this._parentContainer) {
      const s = this._parentContainer.cameras.indexOf(this);
      s > -1 && this._parentContainer.cameras.splice(s, 1), this._parentContainer = null;
    }
    if (this._rigPostProcess)
      this._rigPostProcess.dispose(this), this._rigPostProcess = null, this._postProcesses.length = 0;
    else if (this.cameraRigMode !== Q.RIG_MODE_NONE)
      this._rigPostProcess = null, this._postProcesses.length = 0;
    else {
      let s = this._postProcesses.length;
      for (; --s >= 0; ) {
        const r = this._postProcesses[s];
        r && r.dispose(this);
      }
    }
    let i = this.customRenderTargets.length;
    for (; --i >= 0; )
      this.customRenderTargets[i].dispose();
    this.customRenderTargets.length = 0, this._activeMeshes.dispose(), this.getScene().getEngine().releaseRenderPassId(this.renderPassId), super.dispose(e, t);
  }
  /**
   * Gets the left camera of a rig setup in case of Rigged Camera
   */
  get isLeftCamera() {
    return this._isLeftCamera;
  }
  /**
   * Gets the right camera of a rig setup in case of Rigged Camera
   */
  get isRightCamera() {
    return this._isRightCamera;
  }
  /**
   * Gets the left camera of a rig setup in case of Rigged Camera
   */
  get leftCamera() {
    return this._rigCameras.length < 1 ? null : this._rigCameras[0];
  }
  /**
   * Gets the right camera of a rig setup in case of Rigged Camera
   */
  get rightCamera() {
    return this._rigCameras.length < 2 ? null : this._rigCameras[1];
  }
  /**
   * Gets the left camera target of a rig setup in case of Rigged Camera
   * @returns the target position
   */
  getLeftTarget() {
    return this._rigCameras.length < 1 ? null : this._rigCameras[0].getTarget();
  }
  /**
   * Gets the right camera target of a rig setup in case of Rigged Camera
   * @returns the target position
   */
  getRightTarget() {
    return this._rigCameras.length < 2 ? null : this._rigCameras[1].getTarget();
  }
  /**
   * @internal
   */
  setCameraRigMode(e, t) {
    if (this.cameraRigMode !== e) {
      for (; this._rigCameras.length > 0; ) {
        const i = this._rigCameras.pop();
        i && i.dispose();
      }
      if (this.cameraRigMode = e, this._cameraRigParams = {}, this._cameraRigParams.interaxialDistance = t.interaxialDistance || 0.0637, this._cameraRigParams.stereoHalfAngle = z.ToRadians(this._cameraRigParams.interaxialDistance / 0.0637), this.cameraRigMode !== Q.RIG_MODE_NONE) {
        const i = this.createRigCamera(this.name + "_L", 0);
        i && (i._isLeftCamera = !0);
        const s = this.createRigCamera(this.name + "_R", 1);
        s && (s._isRightCamera = !0), i && s && (this._rigCameras.push(i), this._rigCameras.push(s));
      }
      this._setRigMode(t), this._cascadePostProcessesToRigCams(), this.update();
    }
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _setRigMode(e) {
  }
  /** @internal */
  _getVRProjectionMatrix() {
    return I.PerspectiveFovLHToRef(this._cameraRigParams.vrMetrics.aspectRatioFov, this._cameraRigParams.vrMetrics.aspectRatio, this.minZ, this.maxZ, this._cameraRigParams.vrWorkMatrix, !0, this.getEngine().isNDCHalfZRange), this._cameraRigParams.vrWorkMatrix.multiplyToRef(this._cameraRigParams.vrHMatrix, this._projectionMatrix), this._projectionMatrix;
  }
  _updateCameraRotationMatrix() {
  }
  _updateWebVRCameraRotationMatrix() {
  }
  /**
   * This function MUST be overwritten by the different WebVR cameras available.
   * The context in which it is running is the RIG camera. So 'this' is the TargetCamera, left or right.
   * @internal
   */
  _getWebVRProjectionMatrix() {
    return I.Identity();
  }
  /**
   * This function MUST be overwritten by the different WebVR cameras available.
   * The context in which it is running is the RIG camera. So 'this' is the TargetCamera, left or right.
   * @internal
   */
  _getWebVRViewMatrix() {
    return I.Identity();
  }
  /**
   * @internal
   */
  setCameraRigParameter(e, t) {
    this._cameraRigParams || (this._cameraRigParams = {}), this._cameraRigParams[e] = t, e === "interaxialDistance" && (this._cameraRigParams.stereoHalfAngle = z.ToRadians(t / 0.0637));
  }
  /**
   * needs to be overridden by children so sub has required properties to be copied
   * @internal
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  createRigCamera(e, t) {
    return null;
  }
  /**
   * May need to be overridden by children
   * @internal
   */
  _updateRigCameras() {
    for (let e = 0; e < this._rigCameras.length; e++)
      this._rigCameras[e].minZ = this.minZ, this._rigCameras[e].maxZ = this.maxZ, this._rigCameras[e].fov = this.fov, this._rigCameras[e].upVector.copyFrom(this.upVector);
    this.cameraRigMode === Q.RIG_MODE_STEREOSCOPIC_ANAGLYPH && (this._rigCameras[0].viewport = this._rigCameras[1].viewport = this.viewport);
  }
  /** @internal */
  _setupInputs() {
  }
  /**
   * Serialiaze the camera setup to a json representation
   * @returns the JSON representation
   */
  serialize() {
    const e = le.Serialize(this);
    return e.uniqueId = this.uniqueId, e.type = this.getClassName(), this.parent && this.parent._serializeAsParent(e), this.inputs && this.inputs.serialize(e), le.AppendSerializedAnimations(this, e), e.ranges = this.serializeAnimationRanges(), e.isEnabled = this.isEnabled(), e;
  }
  /**
   * Clones the current camera.
   * @param name The cloned camera name
   * @param newParent The cloned camera's new parent (none by default)
   * @returns the cloned camera
   */
  clone(e, t = null) {
    const i = le.Clone(Q.GetConstructorFromName(this.getClassName(), e, this.getScene(), this.interaxialDistance, this.isStereoscopicSideBySide), this);
    return i.name = e, i.parent = t, this.onClonedObservable.notifyObservers(i), i;
  }
  /**
   * Gets the direction of the camera relative to a given local axis.
   * @param localAxis Defines the reference axis to provide a relative direction.
   * @returns the direction
   */
  getDirection(e) {
    const t = p.Zero();
    return this.getDirectionToRef(e, t), t;
  }
  /**
   * Returns the current camera absolute rotation
   */
  get absoluteRotation() {
    return this.getWorldMatrix().decompose(void 0, this._absoluteRotation), this._absoluteRotation;
  }
  /**
   * Gets the direction of the camera relative to a given local axis into a passed vector.
   * @param localAxis Defines the reference axis to provide a relative direction.
   * @param result Defines the vector to store the result in
   */
  getDirectionToRef(e, t) {
    p.TransformNormalToRef(e, this.getWorldMatrix(), t);
  }
  /**
   * Gets a camera constructor for a given camera type
   * @param type The type of the camera to construct (should be equal to one of the camera class name)
   * @param name The name of the camera the result will be able to instantiate
   * @param scene The scene the result will construct the camera in
   * @param interaxial_distance In case of stereoscopic setup, the distance between both eyes
   * @param isStereoscopicSideBySide In case of stereoscopic setup, should the sereo be side b side
   * @returns a factory method to construct the camera
   */
  // eslint-disable-next-line @typescript-eslint/naming-convention
  static GetConstructorFromName(e, t, i, s = 0, r = !0) {
    const n = ut.Construct(e, t, i, {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      interaxial_distance: s,
      isStereoscopicSideBySide: r
    });
    return n || (() => Q._CreateDefaultParsedCamera(t, i));
  }
  /**
   * Compute the world  matrix of the camera.
   * @returns the camera world matrix
   */
  computeWorldMatrix() {
    return this.getWorldMatrix();
  }
  /**
   * Parse a JSON and creates the camera from the parsed information
   * @param parsedCamera The JSON to parse
   * @param scene The scene to instantiate the camera in
   * @returns the newly constructed camera
   */
  static Parse(e, t) {
    const i = e.type, s = Q.GetConstructorFromName(i, e.name, t, e.interaxial_distance, e.isStereoscopicSideBySide), r = le.Parse(s, e, t);
    if (e.parentId !== void 0 && (r._waitingParentId = e.parentId), e.parentInstanceIndex !== void 0 && (r._waitingParentInstanceIndex = e.parentInstanceIndex), r.inputs && (r.inputs.parse(e), r._setupInputs()), e.upVector && (r.upVector = p.FromArray(e.upVector)), r.setPosition && (r.position.copyFromFloats(0, 0, 0), r.setPosition(p.FromArray(e.position))), e.target && r.setTarget && r.setTarget(p.FromArray(e.target)), e.cameraRigMode) {
      const n = e.interaxial_distance ? { interaxialDistance: e.interaxial_distance } : {};
      r.setCameraRigMode(e.cameraRigMode, n);
    }
    if (e.animations) {
      for (let n = 0; n < e.animations.length; n++) {
        const a = e.animations[n], o = si("BABYLON.Animation");
        o && r.animations.push(o.Parse(a));
      }
      ut.ParseAnimationRanges(r, e, t);
    }
    return e.autoAnimate && t.beginAnimation(r, e.autoAnimateFrom, e.autoAnimateTo, e.autoAnimateLoop, e.autoAnimateSpeed || 1), e.isEnabled !== void 0 && r.setEnabled(e.isEnabled), r;
  }
}
Q._CreateDefaultParsedCamera = (h, e) => {
  throw he("UniversalCamera");
};
Q.PERSPECTIVE_CAMERA = 0;
Q.ORTHOGRAPHIC_CAMERA = 1;
Q.FOVMODE_VERTICAL_FIXED = 0;
Q.FOVMODE_HORIZONTAL_FIXED = 1;
Q.RIG_MODE_NONE = 0;
Q.RIG_MODE_STEREOSCOPIC_ANAGLYPH = 10;
Q.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_PARALLEL = 11;
Q.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED = 12;
Q.RIG_MODE_STEREOSCOPIC_OVERUNDER = 13;
Q.RIG_MODE_STEREOSCOPIC_INTERLACED = 14;
Q.RIG_MODE_VR = 20;
Q.RIG_MODE_WEBVR = 21;
Q.RIG_MODE_CUSTOM = 22;
Q.ForceAttachControlToAlwaysPreventDefault = !1;
E([
  wt("position")
], Q.prototype, "_position", void 0);
E([
  wt("upVector")
], Q.prototype, "_upVector", void 0);
E([
  R()
], Q.prototype, "orthoLeft", null);
E([
  R()
], Q.prototype, "orthoRight", null);
E([
  R()
], Q.prototype, "orthoBottom", null);
E([
  R()
], Q.prototype, "orthoTop", null);
E([
  R()
], Q.prototype, "fov", void 0);
E([
  R()
], Q.prototype, "projectionPlaneTilt", void 0);
E([
  R()
], Q.prototype, "minZ", void 0);
E([
  R()
], Q.prototype, "maxZ", void 0);
E([
  R()
], Q.prototype, "inertia", void 0);
E([
  R()
], Q.prototype, "mode", null);
E([
  R()
], Q.prototype, "layerMask", void 0);
E([
  R()
], Q.prototype, "fovMode", void 0);
E([
  R()
], Q.prototype, "cameraRigMode", void 0);
E([
  R()
], Q.prototype, "interaxialDistance", void 0);
E([
  R()
], Q.prototype, "isStereoscopicSideBySide", void 0);
function rn(h, e, t) {
  try {
    const i = h.next();
    i.done ? e(i) : i.value ? i.value.then(() => {
      i.value = void 0, e(i);
    }, t) : e(i);
  } catch (i) {
    t(i);
  }
}
function bl(h = 25) {
  let e;
  return (t, i, s) => {
    const r = performance.now();
    e === void 0 || r - e > h ? (e = r, setTimeout(() => {
      rn(t, i, s);
    }, 0)) : rn(t, i, s);
  };
}
function ka(h, e, t, i, s) {
  const r = () => {
    let n;
    const a = (o) => {
      o.done ? t(o.value) : n === void 0 ? n = !0 : r();
    };
    do
      n = void 0, e(h, a, i), n === void 0 && (n = !1);
    while (n);
  };
  r();
}
function On(h, e) {
  let t;
  return ka(h, rn, (i) => t = i, (i) => {
    throw i;
  }), t;
}
function Tl(h, e, t) {
  return new Promise((i, s) => {
    ka(h, e, i, s);
  });
}
function Al(h, e) {
  return (...t) => On(h(...t));
}
class Yn {
  constructor() {
    this._count = 0, this._data = {};
  }
  /**
   * This will clear this dictionary and copy the content from the 'source' one.
   * If the T value is a custom object, it won't be copied/cloned, the same object will be used
   * @param source the dictionary to take the content from and copy to this dictionary
   */
  copyFrom(e) {
    this.clear(), e.forEach((t, i) => this.add(t, i));
  }
  /**
   * Get a value based from its key
   * @param key the given key to get the matching value from
   * @returns the value if found, otherwise undefined is returned
   */
  get(e) {
    const t = this._data[e];
    if (t !== void 0)
      return t;
  }
  /**
   * Get a value from its key or add it if it doesn't exist.
   * This method will ensure you that a given key/data will be present in the dictionary.
   * @param key the given key to get the matching value from
   * @param factory the factory that will create the value if the key is not present in the dictionary.
   * The factory will only be invoked if there's no data for the given key.
   * @returns the value corresponding to the key.
   */
  getOrAddWithFactory(e, t) {
    let i = this.get(e);
    return i !== void 0 || (i = t(e), i && this.add(e, i)), i;
  }
  /**
   * Get a value from its key if present in the dictionary otherwise add it
   * @param key the key to get the value from
   * @param val if there's no such key/value pair in the dictionary add it with this value
   * @returns the value corresponding to the key
   */
  getOrAdd(e, t) {
    const i = this.get(e);
    return i !== void 0 ? i : (this.add(e, t), t);
  }
  /**
   * Check if there's a given key in the dictionary
   * @param key the key to check for
   * @returns true if the key is present, false otherwise
   */
  contains(e) {
    return this._data[e] !== void 0;
  }
  /**
   * Add a new key and its corresponding value
   * @param key the key to add
   * @param value the value corresponding to the key
   * @returns true if the operation completed successfully, false if we couldn't insert the key/value because there was already this key in the dictionary
   */
  add(e, t) {
    return this._data[e] !== void 0 ? !1 : (this._data[e] = t, ++this._count, !0);
  }
  /**
   * Update a specific value associated to a key
   * @param key defines the key to use
   * @param value defines the value to store
   * @returns true if the value was updated (or false if the key was not found)
   */
  set(e, t) {
    return this._data[e] === void 0 ? !1 : (this._data[e] = t, !0);
  }
  /**
   * Get the element of the given key and remove it from the dictionary
   * @param key defines the key to search
   * @returns the value associated with the key or null if not found
   */
  getAndRemove(e) {
    const t = this.get(e);
    return t !== void 0 ? (delete this._data[e], --this._count, t) : null;
  }
  /**
   * Remove a key/value from the dictionary.
   * @param key the key to remove
   * @returns true if the item was successfully deleted, false if no item with such key exist in the dictionary
   */
  remove(e) {
    return this.contains(e) ? (delete this._data[e], --this._count, !0) : !1;
  }
  /**
   * Clear the whole content of the dictionary
   */
  clear() {
    this._data = {}, this._count = 0;
  }
  /**
   * Gets the current count
   */
  get count() {
    return this._count;
  }
  /**
   * Execute a callback on each key/val of the dictionary.
   * Note that you can remove any element in this dictionary in the callback implementation
   * @param callback the callback to execute on a given key/value pair
   */
  forEach(e) {
    for (const t in this._data) {
      const i = this._data[t];
      e(t, i);
    }
  }
  /**
   * Execute a callback on every occurrence of the dictionary until it returns a valid TRes object.
   * If the callback returns null or undefined the method will iterate to the next key/value pair
   * Note that you can remove any element in this dictionary in the callback implementation
   * @param callback the callback to execute, if it return a valid T instanced object the enumeration will stop and the object will be returned
   * @returns the first item
   */
  first(e) {
    for (const t in this._data) {
      const i = this._data[t], s = e(t, i);
      if (s)
        return s;
    }
    return null;
  }
}
class Pi {
  constructor() {
    this.rootNodes = new Array(), this.cameras = new Array(), this.lights = new Array(), this.meshes = new Array(), this.skeletons = new Array(), this.particleSystems = new Array(), this.animations = [], this.animationGroups = new Array(), this.multiMaterials = new Array(), this.materials = new Array(), this.morphTargetManagers = new Array(), this.geometries = new Array(), this.transformNodes = new Array(), this.actionManagers = new Array(), this.textures = new Array(), this._environmentTexture = null, this.postProcesses = new Array();
  }
  /**
   * Adds a parser in the list of available ones
   * @param name Defines the name of the parser
   * @param parser Defines the parser to add
   */
  static AddParser(e, t) {
    this._BabylonFileParsers[e] = t;
  }
  /**
   * Gets a general parser from the list of available ones
   * @param name Defines the name of the parser
   * @returns the requested parser or null
   */
  static GetParser(e) {
    return this._BabylonFileParsers[e] ? this._BabylonFileParsers[e] : null;
  }
  /**
   * Adds n individual parser in the list of available ones
   * @param name Defines the name of the parser
   * @param parser Defines the parser to add
   */
  static AddIndividualParser(e, t) {
    this._IndividualBabylonFileParsers[e] = t;
  }
  /**
   * Gets an individual parser from the list of available ones
   * @param name Defines the name of the parser
   * @returns the requested parser or null
   */
  static GetIndividualParser(e) {
    return this._IndividualBabylonFileParsers[e] ? this._IndividualBabylonFileParsers[e] : null;
  }
  /**
   * Parser json data and populate both a scene and its associated container object
   * @param jsonData Defines the data to parse
   * @param scene Defines the scene to parse the data for
   * @param container Defines the container attached to the parsing sequence
   * @param rootUrl Defines the root url of the data
   */
  static Parse(e, t, i, s) {
    for (const r in this._BabylonFileParsers)
      Object.prototype.hasOwnProperty.call(this._BabylonFileParsers, r) && this._BabylonFileParsers[r](e, t, i, s);
  }
  /**
   * Texture used in all pbr material as the reflection texture.
   * As in the majority of the scene they are the same (exception for multi room and so on),
   * this is easier to reference from here than from all the materials.
   */
  get environmentTexture() {
    return this._environmentTexture;
  }
  set environmentTexture(e) {
    this._environmentTexture = e;
  }
  /**
   * @returns all meshes, lights, cameras, transformNodes and bones
   */
  getNodes() {
    let e = new Array();
    return e = e.concat(this.meshes), e = e.concat(this.lights), e = e.concat(this.cameras), e = e.concat(this.transformNodes), this.skeletons.forEach((t) => e = e.concat(t.bones)), e;
  }
}
Pi._BabylonFileParsers = {};
Pi._IndividualBabylonFileParsers = {};
class Va {
  /**
   * Creates a new instance
   * @param externalProperties list of external properties to inject into the object
   */
  constructor(e) {
    if (this._keys = [], this._isDirty = !0, this._areLightsDirty = !0, this._areLightsDisposed = !1, this._areAttributesDirty = !0, this._areTexturesDirty = !0, this._areFresnelDirty = !0, this._areMiscDirty = !0, this._arePrePassDirty = !0, this._areImageProcessingDirty = !0, this._normals = !1, this._uvs = !1, this._needNormals = !1, this._needUVs = !1, this._externalProperties = e, e)
      for (const t in e)
        Object.prototype.hasOwnProperty.call(e, t) && this._setDefaultValue(t);
  }
  /**
   * Specifies if the material needs to be re-calculated
   */
  get isDirty() {
    return this._isDirty;
  }
  /**
   * Marks the material to indicate that it has been re-calculated
   */
  markAsProcessed() {
    this._isDirty = !1, this._areAttributesDirty = !1, this._areTexturesDirty = !1, this._areFresnelDirty = !1, this._areLightsDirty = !1, this._areLightsDisposed = !1, this._areMiscDirty = !1, this._arePrePassDirty = !1, this._areImageProcessingDirty = !1;
  }
  /**
   * Marks the material to indicate that it needs to be re-calculated
   */
  markAsUnprocessed() {
    this._isDirty = !0;
  }
  /**
   * Marks the material to indicate all of its defines need to be re-calculated
   */
  markAllAsDirty() {
    this._areTexturesDirty = !0, this._areAttributesDirty = !0, this._areLightsDirty = !0, this._areFresnelDirty = !0, this._areMiscDirty = !0, this._arePrePassDirty = !1, this._areImageProcessingDirty = !0, this._isDirty = !0;
  }
  /**
   * Marks the material to indicate that image processing needs to be re-calculated
   */
  markAsImageProcessingDirty() {
    this._areImageProcessingDirty = !0, this._isDirty = !0;
  }
  /**
   * Marks the material to indicate the lights need to be re-calculated
   * @param disposed Defines whether the light is dirty due to dispose or not
   */
  markAsLightDirty(e = !1) {
    this._areLightsDirty = !0, this._areLightsDisposed = this._areLightsDisposed || e, this._isDirty = !0;
  }
  /**
   * Marks the attribute state as changed
   */
  markAsAttributesDirty() {
    this._areAttributesDirty = !0, this._isDirty = !0;
  }
  /**
   * Marks the texture state as changed
   */
  markAsTexturesDirty() {
    this._areTexturesDirty = !0, this._isDirty = !0;
  }
  /**
   * Marks the fresnel state as changed
   */
  markAsFresnelDirty() {
    this._areFresnelDirty = !0, this._isDirty = !0;
  }
  /**
   * Marks the misc state as changed
   */
  markAsMiscDirty() {
    this._areMiscDirty = !0, this._isDirty = !0;
  }
  /**
   * Marks the prepass state as changed
   */
  markAsPrePassDirty() {
    this._arePrePassDirty = !0, this._isDirty = !0;
  }
  /**
   * Rebuilds the material defines
   */
  rebuild() {
    this._keys.length = 0;
    for (const e of Object.keys(this))
      e[0] !== "_" && this._keys.push(e);
    if (this._externalProperties)
      for (const e in this._externalProperties)
        this._keys.indexOf(e) === -1 && this._keys.push(e);
  }
  /**
   * Specifies if two material defines are equal
   * @param other - A material define instance to compare to
   * @returns - Boolean indicating if the material defines are equal (true) or not (false)
   */
  isEqual(e) {
    if (this._keys.length !== e._keys.length)
      return !1;
    for (let t = 0; t < this._keys.length; t++) {
      const i = this._keys[t];
      if (this[i] !== e[i])
        return !1;
    }
    return !0;
  }
  /**
   * Clones this instance's defines to another instance
   * @param other - material defines to clone values to
   */
  cloneTo(e) {
    this._keys.length !== e._keys.length && (e._keys = this._keys.slice(0));
    for (let t = 0; t < this._keys.length; t++) {
      const i = this._keys[t];
      e[i] = this[i];
    }
  }
  /**
   * Resets the material define values
   */
  reset() {
    this._keys.forEach((e) => this._setDefaultValue(e));
  }
  _setDefaultValue(e) {
    var t, i, s, r, n;
    const a = (s = (i = (t = this._externalProperties) === null || t === void 0 ? void 0 : t[e]) === null || i === void 0 ? void 0 : i.type) !== null && s !== void 0 ? s : typeof this[e], o = (n = (r = this._externalProperties) === null || r === void 0 ? void 0 : r[e]) === null || n === void 0 ? void 0 : n.default;
    switch (a) {
      case "number":
        this[e] = o ?? 0;
        break;
      case "string":
        this[e] = o ?? "";
        break;
      default:
        this[e] = o ?? !1;
        break;
    }
  }
  /**
   * Converts the material define values to a string
   * @returns - String of material define information
   */
  toString() {
    let e = "";
    for (let t = 0; t < this._keys.length; t++) {
      const i = this._keys[t], s = this[i];
      switch (typeof s) {
        case "number":
        case "string":
          e += "#define " + i + " " + s + `
`;
          break;
        default:
          s && (e += "#define " + i + `
`);
          break;
      }
    }
    return e;
  }
}
class Ye {
  constructor() {
    this._dirty = !0, this._tempColor = new ye(0, 0, 0, 0), this._globalCurve = new ye(0, 0, 0, 0), this._highlightsCurve = new ye(0, 0, 0, 0), this._midtonesCurve = new ye(0, 0, 0, 0), this._shadowsCurve = new ye(0, 0, 0, 0), this._positiveCurve = new ye(0, 0, 0, 0), this._negativeCurve = new ye(0, 0, 0, 0), this._globalHue = 30, this._globalDensity = 0, this._globalSaturation = 0, this._globalExposure = 0, this._highlightsHue = 30, this._highlightsDensity = 0, this._highlightsSaturation = 0, this._highlightsExposure = 0, this._midtonesHue = 30, this._midtonesDensity = 0, this._midtonesSaturation = 0, this._midtonesExposure = 0, this._shadowsHue = 30, this._shadowsDensity = 0, this._shadowsSaturation = 0, this._shadowsExposure = 0;
  }
  /**
   * Gets the global Hue value.
   * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
   */
  get globalHue() {
    return this._globalHue;
  }
  /**
   * Sets the global Hue value.
   * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
   */
  set globalHue(e) {
    this._globalHue = e, this._dirty = !0;
  }
  /**
   * Gets the global Density value.
   * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
   * Values less than zero provide a filter of opposite hue.
   */
  get globalDensity() {
    return this._globalDensity;
  }
  /**
   * Sets the global Density value.
   * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
   * Values less than zero provide a filter of opposite hue.
   */
  set globalDensity(e) {
    this._globalDensity = e, this._dirty = !0;
  }
  /**
   * Gets the global Saturation value.
   * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
   */
  get globalSaturation() {
    return this._globalSaturation;
  }
  /**
   * Sets the global Saturation value.
   * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
   */
  set globalSaturation(e) {
    this._globalSaturation = e, this._dirty = !0;
  }
  /**
   * Gets the global Exposure value.
   * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
   */
  get globalExposure() {
    return this._globalExposure;
  }
  /**
   * Sets the global Exposure value.
   * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
   */
  set globalExposure(e) {
    this._globalExposure = e, this._dirty = !0;
  }
  /**
   * Gets the highlights Hue value.
   * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
   */
  get highlightsHue() {
    return this._highlightsHue;
  }
  /**
   * Sets the highlights Hue value.
   * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
   */
  set highlightsHue(e) {
    this._highlightsHue = e, this._dirty = !0;
  }
  /**
   * Gets the highlights Density value.
   * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
   * Values less than zero provide a filter of opposite hue.
   */
  get highlightsDensity() {
    return this._highlightsDensity;
  }
  /**
   * Sets the highlights Density value.
   * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
   * Values less than zero provide a filter of opposite hue.
   */
  set highlightsDensity(e) {
    this._highlightsDensity = e, this._dirty = !0;
  }
  /**
   * Gets the highlights Saturation value.
   * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
   */
  get highlightsSaturation() {
    return this._highlightsSaturation;
  }
  /**
   * Sets the highlights Saturation value.
   * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
   */
  set highlightsSaturation(e) {
    this._highlightsSaturation = e, this._dirty = !0;
  }
  /**
   * Gets the highlights Exposure value.
   * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
   */
  get highlightsExposure() {
    return this._highlightsExposure;
  }
  /**
   * Sets the highlights Exposure value.
   * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
   */
  set highlightsExposure(e) {
    this._highlightsExposure = e, this._dirty = !0;
  }
  /**
   * Gets the midtones Hue value.
   * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
   */
  get midtonesHue() {
    return this._midtonesHue;
  }
  /**
   * Sets the midtones Hue value.
   * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
   */
  set midtonesHue(e) {
    this._midtonesHue = e, this._dirty = !0;
  }
  /**
   * Gets the midtones Density value.
   * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
   * Values less than zero provide a filter of opposite hue.
   */
  get midtonesDensity() {
    return this._midtonesDensity;
  }
  /**
   * Sets the midtones Density value.
   * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
   * Values less than zero provide a filter of opposite hue.
   */
  set midtonesDensity(e) {
    this._midtonesDensity = e, this._dirty = !0;
  }
  /**
   * Gets the midtones Saturation value.
   * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
   */
  get midtonesSaturation() {
    return this._midtonesSaturation;
  }
  /**
   * Sets the midtones Saturation value.
   * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
   */
  set midtonesSaturation(e) {
    this._midtonesSaturation = e, this._dirty = !0;
  }
  /**
   * Gets the midtones Exposure value.
   * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
   */
  get midtonesExposure() {
    return this._midtonesExposure;
  }
  /**
   * Sets the midtones Exposure value.
   * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
   */
  set midtonesExposure(e) {
    this._midtonesExposure = e, this._dirty = !0;
  }
  /**
   * Gets the shadows Hue value.
   * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
   */
  get shadowsHue() {
    return this._shadowsHue;
  }
  /**
   * Sets the shadows Hue value.
   * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
   */
  set shadowsHue(e) {
    this._shadowsHue = e, this._dirty = !0;
  }
  /**
   * Gets the shadows Density value.
   * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
   * Values less than zero provide a filter of opposite hue.
   */
  get shadowsDensity() {
    return this._shadowsDensity;
  }
  /**
   * Sets the shadows Density value.
   * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
   * Values less than zero provide a filter of opposite hue.
   */
  set shadowsDensity(e) {
    this._shadowsDensity = e, this._dirty = !0;
  }
  /**
   * Gets the shadows Saturation value.
   * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
   */
  get shadowsSaturation() {
    return this._shadowsSaturation;
  }
  /**
   * Sets the shadows Saturation value.
   * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
   */
  set shadowsSaturation(e) {
    this._shadowsSaturation = e, this._dirty = !0;
  }
  /**
   * Gets the shadows Exposure value.
   * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
   */
  get shadowsExposure() {
    return this._shadowsExposure;
  }
  /**
   * Sets the shadows Exposure value.
   * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
   */
  set shadowsExposure(e) {
    this._shadowsExposure = e, this._dirty = !0;
  }
  /**
   * Returns the class name
   * @returns The class name
   */
  getClassName() {
    return "ColorCurves";
  }
  /**
   * Binds the color curves to the shader.
   * @param colorCurves The color curve to bind
   * @param effect The effect to bind to
   * @param positiveUniform The positive uniform shader parameter
   * @param neutralUniform The neutral uniform shader parameter
   * @param negativeUniform The negative uniform shader parameter
   */
  static Bind(e, t, i = "vCameraColorCurvePositive", s = "vCameraColorCurveNeutral", r = "vCameraColorCurveNegative") {
    e._dirty && (e._dirty = !1, e._getColorGradingDataToRef(e._globalHue, e._globalDensity, e._globalSaturation, e._globalExposure, e._globalCurve), e._getColorGradingDataToRef(e._highlightsHue, e._highlightsDensity, e._highlightsSaturation, e._highlightsExposure, e._tempColor), e._tempColor.multiplyToRef(e._globalCurve, e._highlightsCurve), e._getColorGradingDataToRef(e._midtonesHue, e._midtonesDensity, e._midtonesSaturation, e._midtonesExposure, e._tempColor), e._tempColor.multiplyToRef(e._globalCurve, e._midtonesCurve), e._getColorGradingDataToRef(e._shadowsHue, e._shadowsDensity, e._shadowsSaturation, e._shadowsExposure, e._tempColor), e._tempColor.multiplyToRef(e._globalCurve, e._shadowsCurve), e._highlightsCurve.subtractToRef(e._midtonesCurve, e._positiveCurve), e._midtonesCurve.subtractToRef(e._shadowsCurve, e._negativeCurve)), t && (t.setFloat4(i, e._positiveCurve.r, e._positiveCurve.g, e._positiveCurve.b, e._positiveCurve.a), t.setFloat4(s, e._midtonesCurve.r, e._midtonesCurve.g, e._midtonesCurve.b, e._midtonesCurve.a), t.setFloat4(r, e._negativeCurve.r, e._negativeCurve.g, e._negativeCurve.b, e._negativeCurve.a));
  }
  /**
   * Prepare the list of uniforms associated with the ColorCurves effects.
   * @param uniformsList The list of uniforms used in the effect
   */
  static PrepareUniforms(e) {
    e.push("vCameraColorCurveNeutral", "vCameraColorCurvePositive", "vCameraColorCurveNegative");
  }
  /**
   * Returns color grading data based on a hue, density, saturation and exposure value.
   * @param hue
   * @param density
   * @param saturation The saturation.
   * @param exposure The exposure.
   * @param result The result data container.
   */
  _getColorGradingDataToRef(e, t, i, s, r) {
    e != null && (e = Ye._Clamp(e, 0, 360), t = Ye._Clamp(t, -100, 100), i = Ye._Clamp(i, -100, 100), s = Ye._Clamp(s, -100, 100), t = Ye._ApplyColorGradingSliderNonlinear(t), t *= 0.5, s = Ye._ApplyColorGradingSliderNonlinear(s), t < 0 && (t *= -1, e = (e + 180) % 360), Ye._FromHSBToRef(e, t, 50 + 0.25 * s, r), r.scaleToRef(2, r), r.a = 1 + 0.01 * i);
  }
  /**
   * Takes an input slider value and returns an adjusted value that provides extra control near the centre.
   * @param value The input slider value in range [-100,100].
   * @returns Adjusted value.
   */
  static _ApplyColorGradingSliderNonlinear(e) {
    e /= 100;
    let t = Math.abs(e);
    return t = Math.pow(t, 2), e < 0 && (t *= -1), t *= 100, t;
  }
  /**
   * Returns an RGBA Color4 based on Hue, Saturation and Brightness (also referred to as value, HSV).
   * @param hue The hue (H) input.
   * @param saturation The saturation (S) input.
   * @param brightness The brightness (B) input.
   * @param result
   * @result An RGBA color represented as Vector4.
   */
  static _FromHSBToRef(e, t, i, s) {
    let r = Ye._Clamp(e, 0, 360);
    const n = Ye._Clamp(t / 100, 0, 1), a = Ye._Clamp(i / 100, 0, 1);
    if (n === 0)
      s.r = a, s.g = a, s.b = a;
    else {
      r /= 60;
      const o = Math.floor(r), l = r - o, c = a * (1 - n), u = a * (1 - n * l), d = a * (1 - n * (1 - l));
      switch (o) {
        case 0:
          s.r = a, s.g = d, s.b = c;
          break;
        case 1:
          s.r = u, s.g = a, s.b = c;
          break;
        case 2:
          s.r = c, s.g = a, s.b = d;
          break;
        case 3:
          s.r = c, s.g = u, s.b = a;
          break;
        case 4:
          s.r = d, s.g = c, s.b = a;
          break;
        default:
          s.r = a, s.g = c, s.b = u;
          break;
      }
    }
    s.a = 1;
  }
  /**
   * Returns a value clamped between min and max
   * @param value The value to clamp
   * @param min The minimum of value
   * @param max The maximum of value
   * @returns The clamped value.
   */
  static _Clamp(e, t, i) {
    return Math.min(Math.max(e, t), i);
  }
  /**
   * Clones the current color curve instance.
   * @returns The cloned curves
   */
  clone() {
    return le.Clone(() => new Ye(), this);
  }
  /**
   * Serializes the current color curve instance to a json representation.
   * @returns a JSON representation
   */
  serialize() {
    return le.Serialize(this);
  }
  /**
   * Parses the color curve from a json representation.
   * @param source the JSON source to parse
   * @returns The parsed curves
   */
  static Parse(e) {
    return le.Parse(() => new Ye(), e, null, null);
  }
}
E([
  R()
], Ye.prototype, "_globalHue", void 0);
E([
  R()
], Ye.prototype, "_globalDensity", void 0);
E([
  R()
], Ye.prototype, "_globalSaturation", void 0);
E([
  R()
], Ye.prototype, "_globalExposure", void 0);
E([
  R()
], Ye.prototype, "_highlightsHue", void 0);
E([
  R()
], Ye.prototype, "_highlightsDensity", void 0);
E([
  R()
], Ye.prototype, "_highlightsSaturation", void 0);
E([
  R()
], Ye.prototype, "_highlightsExposure", void 0);
E([
  R()
], Ye.prototype, "_midtonesHue", void 0);
E([
  R()
], Ye.prototype, "_midtonesDensity", void 0);
E([
  R()
], Ye.prototype, "_midtonesSaturation", void 0);
E([
  R()
], Ye.prototype, "_midtonesExposure", void 0);
le._ColorCurvesParser = Ye.Parse;
class De {
  constructor() {
    this.colorCurves = new Ye(), this._colorCurvesEnabled = !1, this._colorGradingEnabled = !1, this._colorGradingWithGreenDepth = !0, this._colorGradingBGR = !0, this._exposure = 1, this._toneMappingEnabled = !1, this._toneMappingType = De.TONEMAPPING_STANDARD, this._contrast = 1, this.vignetteStretch = 0, this.vignetteCenterX = 0, this.vignetteCenterY = 0, this.vignetteWeight = 1.5, this.vignetteColor = new ye(0, 0, 0, 0), this.vignetteCameraFov = 0.5, this._vignetteBlendMode = De.VIGNETTEMODE_MULTIPLY, this._vignetteEnabled = !1, this._ditheringEnabled = !1, this._ditheringIntensity = 1 / 255, this._skipFinalColorClamp = !1, this._applyByPostProcess = !1, this._isEnabled = !0, this.onUpdateParameters = new N();
  }
  /**
   * Gets whether the color curves effect is enabled.
   */
  get colorCurvesEnabled() {
    return this._colorCurvesEnabled;
  }
  /**
   * Sets whether the color curves effect is enabled.
   */
  set colorCurvesEnabled(e) {
    this._colorCurvesEnabled !== e && (this._colorCurvesEnabled = e, this._updateParameters());
  }
  /**
   * Color grading LUT texture used in the effect if colorGradingEnabled is set to true
   */
  get colorGradingTexture() {
    return this._colorGradingTexture;
  }
  /**
   * Color grading LUT texture used in the effect if colorGradingEnabled is set to true
   */
  set colorGradingTexture(e) {
    this._colorGradingTexture !== e && (this._colorGradingTexture = e, this._updateParameters());
  }
  /**
   * Gets whether the color grading effect is enabled.
   */
  get colorGradingEnabled() {
    return this._colorGradingEnabled;
  }
  /**
   * Sets whether the color grading effect is enabled.
   */
  set colorGradingEnabled(e) {
    this._colorGradingEnabled !== e && (this._colorGradingEnabled = e, this._updateParameters());
  }
  /**
   * Gets whether the color grading effect is using a green depth for the 3d Texture.
   */
  get colorGradingWithGreenDepth() {
    return this._colorGradingWithGreenDepth;
  }
  /**
   * Sets whether the color grading effect is using a green depth for the 3d Texture.
   */
  set colorGradingWithGreenDepth(e) {
    this._colorGradingWithGreenDepth !== e && (this._colorGradingWithGreenDepth = e, this._updateParameters());
  }
  /**
   * Gets whether the color grading texture contains BGR values.
   */
  get colorGradingBGR() {
    return this._colorGradingBGR;
  }
  /**
   * Sets whether the color grading texture contains BGR values.
   */
  set colorGradingBGR(e) {
    this._colorGradingBGR !== e && (this._colorGradingBGR = e, this._updateParameters());
  }
  /**
   * Gets the Exposure used in the effect.
   */
  get exposure() {
    return this._exposure;
  }
  /**
   * Sets the Exposure used in the effect.
   */
  set exposure(e) {
    this._exposure !== e && (this._exposure = e, this._updateParameters());
  }
  /**
   * Gets whether the tone mapping effect is enabled.
   */
  get toneMappingEnabled() {
    return this._toneMappingEnabled;
  }
  /**
   * Sets whether the tone mapping effect is enabled.
   */
  set toneMappingEnabled(e) {
    this._toneMappingEnabled !== e && (this._toneMappingEnabled = e, this._updateParameters());
  }
  /**
   * Gets the type of tone mapping effect.
   */
  get toneMappingType() {
    return this._toneMappingType;
  }
  /**
   * Sets the type of tone mapping effect used in BabylonJS.
   */
  set toneMappingType(e) {
    this._toneMappingType !== e && (this._toneMappingType = e, this._updateParameters());
  }
  /**
   * Gets the contrast used in the effect.
   */
  get contrast() {
    return this._contrast;
  }
  /**
   * Sets the contrast used in the effect.
   */
  set contrast(e) {
    this._contrast !== e && (this._contrast = e, this._updateParameters());
  }
  /**
   * Back Compat: Vignette center Y Offset.
   * @deprecated use vignetteCenterY instead
   */
  get vignetteCentreY() {
    return this.vignetteCenterY;
  }
  set vignetteCentreY(e) {
    this.vignetteCenterY = e;
  }
  /**
   * Back Compat: Vignette center X Offset.
   * @deprecated use vignetteCenterX instead
   */
  get vignetteCentreX() {
    return this.vignetteCenterX;
  }
  set vignetteCentreX(e) {
    this.vignetteCenterX = e;
  }
  /**
   * Gets the vignette blend mode allowing different kind of effect.
   */
  get vignetteBlendMode() {
    return this._vignetteBlendMode;
  }
  /**
   * Sets the vignette blend mode allowing different kind of effect.
   */
  set vignetteBlendMode(e) {
    this._vignetteBlendMode !== e && (this._vignetteBlendMode = e, this._updateParameters());
  }
  /**
   * Gets whether the vignette effect is enabled.
   */
  get vignetteEnabled() {
    return this._vignetteEnabled;
  }
  /**
   * Sets whether the vignette effect is enabled.
   */
  set vignetteEnabled(e) {
    this._vignetteEnabled !== e && (this._vignetteEnabled = e, this._updateParameters());
  }
  /**
   * Gets whether the dithering effect is enabled.
   * The dithering effect can be used to reduce banding.
   */
  get ditheringEnabled() {
    return this._ditheringEnabled;
  }
  /**
   * Sets whether the dithering effect is enabled.
   * The dithering effect can be used to reduce banding.
   */
  set ditheringEnabled(e) {
    this._ditheringEnabled !== e && (this._ditheringEnabled = e, this._updateParameters());
  }
  /**
   * Gets the dithering intensity. 0 is no dithering. Default is 1.0 / 255.0.
   */
  get ditheringIntensity() {
    return this._ditheringIntensity;
  }
  /**
   * Sets the dithering intensity. 0 is no dithering. Default is 1.0 / 255.0.
   */
  set ditheringIntensity(e) {
    this._ditheringIntensity !== e && (this._ditheringIntensity = e, this._updateParameters());
  }
  /**
   * If apply by post process is set to true, setting this to true will skip the the final color clamp step in the fragment shader
   * Applies to PBR materials.
   */
  get skipFinalColorClamp() {
    return this._skipFinalColorClamp;
  }
  /**
   * If apply by post process is set to true, setting this to true will skip the the final color clamp step in the fragment shader
   * Applies to PBR materials.
   */
  set skipFinalColorClamp(e) {
    this._skipFinalColorClamp !== e && (this._skipFinalColorClamp = e, this._updateParameters());
  }
  /**
   * Gets whether the image processing is applied through a post process or not.
   */
  get applyByPostProcess() {
    return this._applyByPostProcess;
  }
  /**
   * Sets whether the image processing is applied through a post process or not.
   */
  set applyByPostProcess(e) {
    this._applyByPostProcess !== e && (this._applyByPostProcess = e, this._updateParameters());
  }
  /**
   * Gets whether the image processing is enabled or not.
   */
  get isEnabled() {
    return this._isEnabled;
  }
  /**
   * Sets whether the image processing is enabled or not.
   */
  set isEnabled(e) {
    this._isEnabled !== e && (this._isEnabled = e, this._updateParameters());
  }
  /**
   * Method called each time the image processing information changes requires to recompile the effect.
   */
  _updateParameters() {
    this.onUpdateParameters.notifyObservers(this);
  }
  /**
   * Gets the current class name.
   * @returns "ImageProcessingConfiguration"
   */
  getClassName() {
    return "ImageProcessingConfiguration";
  }
  /**
   * Prepare the list of uniforms associated with the Image Processing effects.
   * @param uniforms The list of uniforms used in the effect
   * @param defines the list of defines currently in use
   */
  static PrepareUniforms(e, t) {
    t.EXPOSURE && e.push("exposureLinear"), t.CONTRAST && e.push("contrast"), t.COLORGRADING && e.push("colorTransformSettings"), (t.VIGNETTE || t.DITHER) && e.push("vInverseScreenSize"), t.VIGNETTE && (e.push("vignetteSettings1"), e.push("vignetteSettings2")), t.COLORCURVES && Ye.PrepareUniforms(e), t.DITHER && e.push("ditherIntensity");
  }
  /**
   * Prepare the list of samplers associated with the Image Processing effects.
   * @param samplersList The list of uniforms used in the effect
   * @param defines the list of defines currently in use
   */
  static PrepareSamplers(e, t) {
    t.COLORGRADING && e.push("txColorTransform");
  }
  /**
   * Prepare the list of defines associated to the shader.
   * @param defines the list of defines to complete
   * @param forPostProcess Define if we are currently in post process mode or not
   */
  prepareDefines(e, t = !1) {
    if (t !== this.applyByPostProcess || !this._isEnabled) {
      e.VIGNETTE = !1, e.TONEMAPPING = !1, e.TONEMAPPING_ACES = !1, e.CONTRAST = !1, e.EXPOSURE = !1, e.COLORCURVES = !1, e.COLORGRADING = !1, e.COLORGRADING3D = !1, e.DITHER = !1, e.IMAGEPROCESSING = !1, e.SKIPFINALCOLORCLAMP = this.skipFinalColorClamp, e.IMAGEPROCESSINGPOSTPROCESS = this.applyByPostProcess && this._isEnabled;
      return;
    }
    switch (e.VIGNETTE = this.vignetteEnabled, e.VIGNETTEBLENDMODEMULTIPLY = this.vignetteBlendMode === De._VIGNETTEMODE_MULTIPLY, e.VIGNETTEBLENDMODEOPAQUE = !e.VIGNETTEBLENDMODEMULTIPLY, e.TONEMAPPING = this.toneMappingEnabled, this._toneMappingType) {
      case De.TONEMAPPING_ACES:
        e.TONEMAPPING_ACES = !0;
        break;
      default:
        e.TONEMAPPING_ACES = !1;
        break;
    }
    e.CONTRAST = this.contrast !== 1, e.EXPOSURE = this.exposure !== 1, e.COLORCURVES = this.colorCurvesEnabled && !!this.colorCurves, e.COLORGRADING = this.colorGradingEnabled && !!this.colorGradingTexture, e.COLORGRADING ? e.COLORGRADING3D = this.colorGradingTexture.is3D : e.COLORGRADING3D = !1, e.SAMPLER3DGREENDEPTH = this.colorGradingWithGreenDepth, e.SAMPLER3DBGRMAP = this.colorGradingBGR, e.DITHER = this._ditheringEnabled, e.IMAGEPROCESSINGPOSTPROCESS = this.applyByPostProcess, e.SKIPFINALCOLORCLAMP = this.skipFinalColorClamp, e.IMAGEPROCESSING = e.VIGNETTE || e.TONEMAPPING || e.CONTRAST || e.EXPOSURE || e.COLORCURVES || e.COLORGRADING || e.DITHER;
  }
  /**
   * Returns true if all the image processing information are ready.
   * @returns True if ready, otherwise, false
   */
  isReady() {
    return !this.colorGradingEnabled || !this.colorGradingTexture || this.colorGradingTexture.isReady();
  }
  /**
   * Binds the image processing to the shader.
   * @param effect The effect to bind to
   * @param overrideAspectRatio Override the aspect ratio of the effect
   */
  bind(e, t) {
    if (this._colorCurvesEnabled && this.colorCurves && Ye.Bind(this.colorCurves, e), this._vignetteEnabled || this._ditheringEnabled) {
      const i = 1 / e.getEngine().getRenderWidth(), s = 1 / e.getEngine().getRenderHeight();
      if (e.setFloat2("vInverseScreenSize", i, s), this._ditheringEnabled && e.setFloat("ditherIntensity", 0.5 * this._ditheringIntensity), this._vignetteEnabled) {
        const r = t ?? s / i;
        let n = Math.tan(this.vignetteCameraFov * 0.5), a = n * r;
        const o = Math.sqrt(a * n);
        a = z.Mix(a, o, this.vignetteStretch), n = z.Mix(n, o, this.vignetteStretch), e.setFloat4("vignetteSettings1", a, n, -a * this.vignetteCenterX, -n * this.vignetteCenterY);
        const l = -2 * this.vignetteWeight;
        e.setFloat4("vignetteSettings2", this.vignetteColor.r, this.vignetteColor.g, this.vignetteColor.b, l);
      }
    }
    if (e.setFloat("exposureLinear", this.exposure), e.setFloat("contrast", this.contrast), this.colorGradingTexture) {
      e.setTexture("txColorTransform", this.colorGradingTexture);
      const i = this.colorGradingTexture.getSize().height;
      e.setFloat4(
        "colorTransformSettings",
        (i - 1) / i,
        // textureScale
        0.5 / i,
        // textureOffset
        i,
        // textureSize
        this.colorGradingTexture.level
        // weight
      );
    }
  }
  /**
   * Clones the current image processing instance.
   * @returns The cloned image processing
   */
  clone() {
    return le.Clone(() => new De(), this);
  }
  /**
   * Serializes the current image processing instance to a json representation.
   * @returns a JSON representation
   */
  serialize() {
    return le.Serialize(this);
  }
  /**
   * Parses the image processing from a json representation.
   * @param source the JSON source to parse
   * @returns The parsed image processing
   */
  static Parse(e) {
    const t = le.Parse(() => new De(), e, null, null);
    return e.vignetteCentreX !== void 0 && (t.vignetteCenterX = e.vignetteCentreX), e.vignetteCentreY !== void 0 && (t.vignetteCenterY = e.vignetteCentreY), t;
  }
  /**
   * Used to apply the vignette as a mix with the pixel color.
   */
  static get VIGNETTEMODE_MULTIPLY() {
    return this._VIGNETTEMODE_MULTIPLY;
  }
  /**
   * Used to apply the vignette as a replacement of the pixel color.
   */
  static get VIGNETTEMODE_OPAQUE() {
    return this._VIGNETTEMODE_OPAQUE;
  }
}
De.TONEMAPPING_STANDARD = 0;
De.TONEMAPPING_ACES = 1;
De._VIGNETTEMODE_MULTIPLY = 0;
De._VIGNETTEMODE_OPAQUE = 1;
E([
  Ko()
], De.prototype, "colorCurves", void 0);
E([
  R()
], De.prototype, "_colorCurvesEnabled", void 0);
E([
  Jt("colorGradingTexture")
], De.prototype, "_colorGradingTexture", void 0);
E([
  R()
], De.prototype, "_colorGradingEnabled", void 0);
E([
  R()
], De.prototype, "_colorGradingWithGreenDepth", void 0);
E([
  R()
], De.prototype, "_colorGradingBGR", void 0);
E([
  R()
], De.prototype, "_exposure", void 0);
E([
  R()
], De.prototype, "_toneMappingEnabled", void 0);
E([
  R()
], De.prototype, "_toneMappingType", void 0);
E([
  R()
], De.prototype, "_contrast", void 0);
E([
  R()
], De.prototype, "vignetteStretch", void 0);
E([
  R()
], De.prototype, "vignetteCenterX", void 0);
E([
  R()
], De.prototype, "vignetteCenterY", void 0);
E([
  R()
], De.prototype, "vignetteWeight", void 0);
E([
  Pa()
], De.prototype, "vignetteColor", void 0);
E([
  R()
], De.prototype, "vignetteCameraFov", void 0);
E([
  R()
], De.prototype, "_vignetteBlendMode", void 0);
E([
  R()
], De.prototype, "_vignetteEnabled", void 0);
E([
  R()
], De.prototype, "_ditheringEnabled", void 0);
E([
  R()
], De.prototype, "_ditheringIntensity", void 0);
E([
  R()
], De.prototype, "_skipFinalColorClamp", void 0);
E([
  R()
], De.prototype, "_applyByPostProcess", void 0);
E([
  R()
], De.prototype, "_isEnabled", void 0);
le._ImageProcessingConfigurationParser = De.Parse;
Z.prototype.createUniformBuffer = function(h) {
  const e = this._gl.createBuffer();
  if (!e)
    throw new Error("Unable to create uniform buffer");
  const t = new Ls(e);
  return this.bindUniformBuffer(t), h instanceof Float32Array ? this._gl.bufferData(this._gl.UNIFORM_BUFFER, h, this._gl.STATIC_DRAW) : this._gl.bufferData(this._gl.UNIFORM_BUFFER, new Float32Array(h), this._gl.STATIC_DRAW), this.bindUniformBuffer(null), t.references = 1, t;
};
Z.prototype.createDynamicUniformBuffer = function(h) {
  const e = this._gl.createBuffer();
  if (!e)
    throw new Error("Unable to create dynamic uniform buffer");
  const t = new Ls(e);
  return this.bindUniformBuffer(t), h instanceof Float32Array ? this._gl.bufferData(this._gl.UNIFORM_BUFFER, h, this._gl.DYNAMIC_DRAW) : this._gl.bufferData(this._gl.UNIFORM_BUFFER, new Float32Array(h), this._gl.DYNAMIC_DRAW), this.bindUniformBuffer(null), t.references = 1, t;
};
Z.prototype.updateUniformBuffer = function(h, e, t, i) {
  this.bindUniformBuffer(h), t === void 0 && (t = 0), i === void 0 ? e instanceof Float32Array ? this._gl.bufferSubData(this._gl.UNIFORM_BUFFER, t, e) : this._gl.bufferSubData(this._gl.UNIFORM_BUFFER, t, new Float32Array(e)) : e instanceof Float32Array ? this._gl.bufferSubData(this._gl.UNIFORM_BUFFER, 0, e.subarray(t, t + i)) : this._gl.bufferSubData(this._gl.UNIFORM_BUFFER, 0, new Float32Array(e).subarray(t, t + i)), this.bindUniformBuffer(null);
};
Z.prototype.bindUniformBuffer = function(h) {
  this._gl.bindBuffer(this._gl.UNIFORM_BUFFER, h ? h.underlyingResource : null);
};
Z.prototype.bindUniformBufferBase = function(h, e, t) {
  this._gl.bindBufferBase(this._gl.UNIFORM_BUFFER, e, h ? h.underlyingResource : null);
};
Z.prototype.bindUniformBlock = function(h, e, t) {
  const i = h.program, s = this._gl.getUniformBlockIndex(i, e);
  s !== 4294967295 && this._gl.uniformBlockBinding(i, s, t);
};
class H {
  /**
   * Instantiates a new Uniform buffer objects.
   *
   * Handles blocks of uniform on the GPU.
   *
   * If WebGL 2 is not available, this class falls back on traditional setUniformXXX calls.
   *
   * For more information, please refer to :
   * @see https://www.khronos.org/opengl/wiki/Uniform_Buffer_Object
   * @param engine Define the engine the buffer is associated with
   * @param data Define the data contained in the buffer
   * @param dynamic Define if the buffer is updatable
   * @param name to assign to the buffer (debugging purpose)
   * @param forceNoUniformBuffer define that this object must not rely on UBO objects
   */
  constructor(e, t, i, s, r = !1) {
    this._valueCache = {}, this._engine = e, this._noUBO = !e.supportsUniformBuffers || r, this._dynamic = i, this._name = s ?? "no-name", this._data = t || [], this._uniformLocations = {}, this._uniformSizes = {}, this._uniformArraySizes = {}, this._uniformLocationPointer = 0, this._needSync = !1, this._engine._features.trackUbosInFrame && (this._buffers = [], this._bufferIndex = -1, this._createBufferOnWrite = !1, this._currentFrameId = 0), this._noUBO ? (this.updateMatrix3x3 = this._updateMatrix3x3ForEffect, this.updateMatrix2x2 = this._updateMatrix2x2ForEffect, this.updateFloat = this._updateFloatForEffect, this.updateFloat2 = this._updateFloat2ForEffect, this.updateFloat3 = this._updateFloat3ForEffect, this.updateFloat4 = this._updateFloat4ForEffect, this.updateFloatArray = this._updateFloatArrayForEffect, this.updateArray = this._updateArrayForEffect, this.updateIntArray = this._updateIntArrayForEffect, this.updateUIntArray = this._updateUIntArrayForEffect, this.updateMatrix = this._updateMatrixForEffect, this.updateMatrices = this._updateMatricesForEffect, this.updateVector3 = this._updateVector3ForEffect, this.updateVector4 = this._updateVector4ForEffect, this.updateColor3 = this._updateColor3ForEffect, this.updateColor4 = this._updateColor4ForEffect, this.updateDirectColor4 = this._updateDirectColor4ForEffect, this.updateInt = this._updateIntForEffect, this.updateInt2 = this._updateInt2ForEffect, this.updateInt3 = this._updateInt3ForEffect, this.updateInt4 = this._updateInt4ForEffect, this.updateUInt = this._updateUIntForEffect, this.updateUInt2 = this._updateUInt2ForEffect, this.updateUInt3 = this._updateUInt3ForEffect, this.updateUInt4 = this._updateUInt4ForEffect) : (this._engine._uniformBuffers.push(this), this.updateMatrix3x3 = this._updateMatrix3x3ForUniform, this.updateMatrix2x2 = this._updateMatrix2x2ForUniform, this.updateFloat = this._updateFloatForUniform, this.updateFloat2 = this._updateFloat2ForUniform, this.updateFloat3 = this._updateFloat3ForUniform, this.updateFloat4 = this._updateFloat4ForUniform, this.updateFloatArray = this._updateFloatArrayForUniform, this.updateArray = this._updateArrayForUniform, this.updateIntArray = this._updateIntArrayForUniform, this.updateUIntArray = this._updateUIntArrayForUniform, this.updateMatrix = this._updateMatrixForUniform, this.updateMatrices = this._updateMatricesForUniform, this.updateVector3 = this._updateVector3ForUniform, this.updateVector4 = this._updateVector4ForUniform, this.updateColor3 = this._updateColor3ForUniform, this.updateColor4 = this._updateColor4ForUniform, this.updateDirectColor4 = this._updateDirectColor4ForUniform, this.updateInt = this._updateIntForUniform, this.updateInt2 = this._updateInt2ForUniform, this.updateInt3 = this._updateInt3ForUniform, this.updateInt4 = this._updateInt4ForUniform, this.updateUInt = this._updateUIntForUniform, this.updateUInt2 = this._updateUInt2ForUniform, this.updateUInt3 = this._updateUInt3ForUniform, this.updateUInt4 = this._updateUInt4ForUniform);
  }
  /**
   * Indicates if the buffer is using the WebGL2 UBO implementation,
   * or just falling back on setUniformXXX calls.
   */
  get useUbo() {
    return !this._noUBO;
  }
  /**
   * Indicates if the WebGL underlying uniform buffer is in sync
   * with the javascript cache data.
   */
  get isSync() {
    return !this._needSync;
  }
  /**
   * Indicates if the WebGL underlying uniform buffer is dynamic.
   * Also, a dynamic UniformBuffer will disable cache verification and always
   * update the underlying WebGL uniform buffer to the GPU.
   * @returns if Dynamic, otherwise false
   */
  isDynamic() {
    return this._dynamic !== void 0;
  }
  /**
   * The data cache on JS side.
   * @returns the underlying data as a float array
   */
  getData() {
    return this._bufferData;
  }
  /**
   * The underlying WebGL Uniform buffer.
   * @returns the webgl buffer
   */
  getBuffer() {
    return this._buffer;
  }
  /**
   * std140 layout specifies how to align data within an UBO structure.
   * See https://khronos.org/registry/OpenGL/specs/gl/glspec45.core.pdf#page=159
   * for specs.
   * @param size
   */
  _fillAlignment(e) {
    let t;
    if (e <= 2 ? t = e : t = 4, this._uniformLocationPointer % t !== 0) {
      const i = this._uniformLocationPointer;
      this._uniformLocationPointer += t - this._uniformLocationPointer % t;
      const s = this._uniformLocationPointer - i;
      for (let r = 0; r < s; r++)
        this._data.push(0);
    }
  }
  /**
   * Adds an uniform in the buffer.
   * Warning : the subsequents calls of this function must be in the same order as declared in the shader
   * for the layout to be correct ! The addUniform function only handles types like float, vec2, vec3, vec4, mat4,
   * meaning size=1,2,3,4 or 16. It does not handle struct types.
   * @param name Name of the uniform, as used in the uniform block in the shader.
   * @param size Data size, or data directly.
   * @param arraySize The number of elements in the array, 0 if not an array.
   */
  addUniform(e, t, i = 0) {
    if (this._noUBO || this._uniformLocations[e] !== void 0)
      return;
    let s;
    if (i > 0) {
      if (t instanceof Array)
        throw "addUniform should not be use with Array in UBO: " + e;
      if (this._fillAlignment(4), this._uniformArraySizes[e] = { strideSize: t, arraySize: i }, t == 16)
        t = t * i;
      else {
        const n = (4 - t) * i;
        t = t * i + n;
      }
      s = [];
      for (let r = 0; r < t; r++)
        s.push(0);
    } else {
      if (t instanceof Array)
        s = t, t = s.length;
      else {
        t = t, s = [];
        for (let r = 0; r < t; r++)
          s.push(0);
      }
      this._fillAlignment(t);
    }
    this._uniformSizes[e] = t, this._uniformLocations[e] = this._uniformLocationPointer, this._uniformLocationPointer += t;
    for (let r = 0; r < t; r++)
      this._data.push(s[r]);
    this._needSync = !0;
  }
  /**
   * Adds a Matrix 4x4 to the uniform buffer.
   * @param name Name of the uniform, as used in the uniform block in the shader.
   * @param mat A 4x4 matrix.
   */
  addMatrix(e, t) {
    this.addUniform(e, Array.prototype.slice.call(t.toArray()));
  }
  /**
   * Adds a vec2 to the uniform buffer.
   * @param name Name of the uniform, as used in the uniform block in the shader.
   * @param x Define the x component value of the vec2
   * @param y Define the y component value of the vec2
   */
  addFloat2(e, t, i) {
    const s = [t, i];
    this.addUniform(e, s);
  }
  /**
   * Adds a vec3 to the uniform buffer.
   * @param name Name of the uniform, as used in the uniform block in the shader.
   * @param x Define the x component value of the vec3
   * @param y Define the y component value of the vec3
   * @param z Define the z component value of the vec3
   */
  addFloat3(e, t, i, s) {
    const r = [t, i, s];
    this.addUniform(e, r);
  }
  /**
   * Adds a vec3 to the uniform buffer.
   * @param name Name of the uniform, as used in the uniform block in the shader.
   * @param color Define the vec3 from a Color
   */
  addColor3(e, t) {
    const i = [t.r, t.g, t.b];
    this.addUniform(e, i);
  }
  /**
   * Adds a vec4 to the uniform buffer.
   * @param name Name of the uniform, as used in the uniform block in the shader.
   * @param color Define the rgb components from a Color
   * @param alpha Define the a component of the vec4
   */
  addColor4(e, t, i) {
    const s = [t.r, t.g, t.b, i];
    this.addUniform(e, s);
  }
  /**
   * Adds a vec3 to the uniform buffer.
   * @param name Name of the uniform, as used in the uniform block in the shader.
   * @param vector Define the vec3 components from a Vector
   */
  addVector3(e, t) {
    const i = [t.x, t.y, t.z];
    this.addUniform(e, i);
  }
  /**
   * Adds a Matrix 3x3 to the uniform buffer.
   * @param name Name of the uniform, as used in the uniform block in the shader.
   */
  addMatrix3x3(e) {
    this.addUniform(e, 12);
  }
  /**
   * Adds a Matrix 2x2 to the uniform buffer.
   * @param name Name of the uniform, as used in the uniform block in the shader.
   */
  addMatrix2x2(e) {
    this.addUniform(e, 8);
  }
  /**
   * Effectively creates the WebGL Uniform Buffer, once layout is completed with `addUniform`.
   */
  create() {
    this._noUBO || this._buffer || (this._fillAlignment(4), this._bufferData = new Float32Array(this._data), this._rebuild(), this._needSync = !0);
  }
  /** @internal */
  _rebuild() {
    this._noUBO || !this._bufferData || (this._dynamic ? this._buffer = this._engine.createDynamicUniformBuffer(this._bufferData) : this._buffer = this._engine.createUniformBuffer(this._bufferData), this._engine._features.trackUbosInFrame && (this._buffers.push([this._buffer, this._engine._features.checkUbosContentBeforeUpload ? this._bufferData.slice() : void 0]), this._bufferIndex = this._buffers.length - 1, this._createBufferOnWrite = !1));
  }
  /** @internal */
  get _numBuffers() {
    return this._buffers.length;
  }
  /** @internal */
  get _indexBuffer() {
    return this._bufferIndex;
  }
  /** Gets the name of this buffer */
  get name() {
    return this._name;
  }
  /** Gets the current effect */
  get currentEffect() {
    return this._currentEffect;
  }
  _buffersEqual(e, t) {
    for (let i = 0; i < e.length; ++i)
      if (e[i] !== t[i])
        return !1;
    return !0;
  }
  _copyBuffer(e, t) {
    for (let i = 0; i < e.length; ++i)
      t[i] = e[i];
  }
  /**
   * Updates the WebGL Uniform Buffer on the GPU.
   * If the `dynamic` flag is set to true, no cache comparison is done.
   * Otherwise, the buffer will be updated only if the cache differs.
   */
  update() {
    if (!this._noUBO) {
      if (this.bindUniformBuffer(), !this._buffer) {
        this.create();
        return;
      }
      if (!this._dynamic && !this._needSync) {
        this._createBufferOnWrite = this._engine._features.trackUbosInFrame;
        return;
      }
      if (this._buffers && this._buffers.length > 1 && this._buffers[this._bufferIndex][1])
        if (this._buffersEqual(this._bufferData, this._buffers[this._bufferIndex][1])) {
          this._needSync = !1, this._createBufferOnWrite = this._engine._features.trackUbosInFrame;
          return;
        } else
          this._copyBuffer(this._bufferData, this._buffers[this._bufferIndex][1]);
      this._engine.updateUniformBuffer(this._buffer, this._bufferData), this._engine._features._collectUbosUpdatedInFrame && (H._UpdatedUbosInFrame[this._name] || (H._UpdatedUbosInFrame[this._name] = 0), H._UpdatedUbosInFrame[this._name]++), this._needSync = !1, this._createBufferOnWrite = this._engine._features.trackUbosInFrame;
    }
  }
  _createNewBuffer() {
    this._bufferIndex + 1 < this._buffers.length ? (this._bufferIndex++, this._buffer = this._buffers[this._bufferIndex][0], this._createBufferOnWrite = !1, this._needSync = !0) : this._rebuild();
  }
  _checkNewFrame() {
    this._engine._features.trackUbosInFrame && this._currentFrameId !== this._engine.frameId && (this._currentFrameId = this._engine.frameId, this._createBufferOnWrite = !1, this._buffers && this._buffers.length > 0 ? (this._needSync = this._bufferIndex !== 0, this._bufferIndex = 0, this._buffer = this._buffers[this._bufferIndex][0]) : this._bufferIndex = -1);
  }
  /**
   * Updates the value of an uniform. The `update` method must be called afterwards to make it effective in the GPU.
   * @param uniformName Define the name of the uniform, as used in the uniform block in the shader.
   * @param data Define the flattened data
   * @param size Define the size of the data.
   */
  updateUniform(e, t, i) {
    this._checkNewFrame();
    let s = this._uniformLocations[e];
    if (s === void 0) {
      if (this._buffer) {
        w.Error("Cannot add an uniform after UBO has been created.");
        return;
      }
      this.addUniform(e, i), s = this._uniformLocations[e];
    }
    if (this._buffer || this.create(), this._dynamic)
      for (let r = 0; r < i; r++)
        this._bufferData[s + r] = t[r];
    else {
      let r = !1;
      for (let n = 0; n < i; n++)
        (i === 16 && !this._engine._features.uniformBufferHardCheckMatrix || this._bufferData[s + n] !== z.FloatRound(t[n])) && (r = !0, this._createBufferOnWrite && this._createNewBuffer(), this._bufferData[s + n] = t[n]);
      this._needSync = this._needSync || r;
    }
  }
  /**
   * Updates the value of an uniform. The `update` method must be called afterwards to make it effective in the GPU.
   * @param uniformName Define the name of the uniform, as used in the uniform block in the shader.
   * @param data Define the flattened data
   * @param size Define the size of the data.
   */
  updateUniformArray(e, t, i) {
    this._checkNewFrame();
    const s = this._uniformLocations[e];
    if (s === void 0) {
      w.Error("Cannot add an uniform Array dynamically. Please, add it using addUniform and make sure that uniform buffers are supported by the current engine.");
      return;
    }
    this._buffer || this.create();
    const r = this._uniformArraySizes[e];
    if (this._dynamic)
      for (let n = 0; n < i; n++)
        this._bufferData[s + n] = t[n];
    else {
      let n = !1, a = 0, o = 0;
      for (let l = 0; l < i; l++)
        if (this._bufferData[s + o * 4 + a] !== z.FloatRound(t[l]) && (n = !0, this._createBufferOnWrite && this._createNewBuffer(), this._bufferData[s + o * 4 + a] = t[l]), a++, a === r.strideSize) {
          for (; a < 4; a++)
            this._bufferData[s + o * 4 + a] = 0;
          a = 0, o++;
        }
      this._needSync = this._needSync || n;
    }
  }
  _cacheMatrix(e, t) {
    this._checkNewFrame();
    const i = this._valueCache[e], s = t.updateFlag;
    return i !== void 0 && i === s ? !1 : (this._valueCache[e] = s, !0);
  }
  // Update methods
  _updateMatrix3x3ForUniform(e, t) {
    for (let i = 0; i < 3; i++)
      H._TempBuffer[i * 4] = t[i * 3], H._TempBuffer[i * 4 + 1] = t[i * 3 + 1], H._TempBuffer[i * 4 + 2] = t[i * 3 + 2], H._TempBuffer[i * 4 + 3] = 0;
    this.updateUniform(e, H._TempBuffer, 12);
  }
  _updateMatrix3x3ForEffect(e, t) {
    this._currentEffect.setMatrix3x3(e, t);
  }
  _updateMatrix2x2ForEffect(e, t) {
    this._currentEffect.setMatrix2x2(e, t);
  }
  _updateMatrix2x2ForUniform(e, t) {
    for (let i = 0; i < 2; i++)
      H._TempBuffer[i * 4] = t[i * 2], H._TempBuffer[i * 4 + 1] = t[i * 2 + 1], H._TempBuffer[i * 4 + 2] = 0, H._TempBuffer[i * 4 + 3] = 0;
    this.updateUniform(e, H._TempBuffer, 8);
  }
  _updateFloatForEffect(e, t) {
    this._currentEffect.setFloat(e, t);
  }
  _updateFloatForUniform(e, t) {
    H._TempBuffer[0] = t, this.updateUniform(e, H._TempBuffer, 1);
  }
  _updateFloat2ForEffect(e, t, i, s = "") {
    this._currentEffect.setFloat2(e + s, t, i);
  }
  _updateFloat2ForUniform(e, t, i) {
    H._TempBuffer[0] = t, H._TempBuffer[1] = i, this.updateUniform(e, H._TempBuffer, 2);
  }
  _updateFloat3ForEffect(e, t, i, s, r = "") {
    this._currentEffect.setFloat3(e + r, t, i, s);
  }
  _updateFloat3ForUniform(e, t, i, s) {
    H._TempBuffer[0] = t, H._TempBuffer[1] = i, H._TempBuffer[2] = s, this.updateUniform(e, H._TempBuffer, 3);
  }
  _updateFloat4ForEffect(e, t, i, s, r, n = "") {
    this._currentEffect.setFloat4(e + n, t, i, s, r);
  }
  _updateFloat4ForUniform(e, t, i, s, r) {
    H._TempBuffer[0] = t, H._TempBuffer[1] = i, H._TempBuffer[2] = s, H._TempBuffer[3] = r, this.updateUniform(e, H._TempBuffer, 4);
  }
  _updateFloatArrayForEffect(e, t) {
    this._currentEffect.setFloatArray(e, t);
  }
  _updateFloatArrayForUniform(e, t) {
    this.updateUniformArray(e, t, t.length);
  }
  _updateArrayForEffect(e, t) {
    this._currentEffect.setArray(e, t);
  }
  _updateArrayForUniform(e, t) {
    this.updateUniformArray(e, t, t.length);
  }
  _updateIntArrayForEffect(e, t) {
    this._currentEffect.setIntArray(e, t);
  }
  _updateIntArrayForUniform(e, t) {
    H._TempBufferInt32View.set(t), this.updateUniformArray(e, H._TempBuffer, t.length);
  }
  _updateUIntArrayForEffect(e, t) {
    this._currentEffect.setUIntArray(e, t);
  }
  _updateUIntArrayForUniform(e, t) {
    H._TempBufferUInt32View.set(t), this.updateUniformArray(e, H._TempBuffer, t.length);
  }
  _updateMatrixForEffect(e, t) {
    this._currentEffect.setMatrix(e, t);
  }
  _updateMatrixForUniform(e, t) {
    this._cacheMatrix(e, t) && this.updateUniform(e, t.toArray(), 16);
  }
  _updateMatricesForEffect(e, t) {
    this._currentEffect.setMatrices(e, t);
  }
  _updateMatricesForUniform(e, t) {
    this.updateUniform(e, t, t.length);
  }
  _updateVector3ForEffect(e, t) {
    this._currentEffect.setVector3(e, t);
  }
  _updateVector3ForUniform(e, t) {
    H._TempBuffer[0] = t.x, H._TempBuffer[1] = t.y, H._TempBuffer[2] = t.z, this.updateUniform(e, H._TempBuffer, 3);
  }
  _updateVector4ForEffect(e, t) {
    this._currentEffect.setVector4(e, t);
  }
  _updateVector4ForUniform(e, t) {
    H._TempBuffer[0] = t.x, H._TempBuffer[1] = t.y, H._TempBuffer[2] = t.z, H._TempBuffer[3] = t.w, this.updateUniform(e, H._TempBuffer, 4);
  }
  _updateColor3ForEffect(e, t, i = "") {
    this._currentEffect.setColor3(e + i, t);
  }
  _updateColor3ForUniform(e, t) {
    H._TempBuffer[0] = t.r, H._TempBuffer[1] = t.g, H._TempBuffer[2] = t.b, this.updateUniform(e, H._TempBuffer, 3);
  }
  _updateColor4ForEffect(e, t, i, s = "") {
    this._currentEffect.setColor4(e + s, t, i);
  }
  _updateDirectColor4ForEffect(e, t, i = "") {
    this._currentEffect.setDirectColor4(e + i, t);
  }
  _updateColor4ForUniform(e, t, i) {
    H._TempBuffer[0] = t.r, H._TempBuffer[1] = t.g, H._TempBuffer[2] = t.b, H._TempBuffer[3] = i, this.updateUniform(e, H._TempBuffer, 4);
  }
  _updateDirectColor4ForUniform(e, t) {
    H._TempBuffer[0] = t.r, H._TempBuffer[1] = t.g, H._TempBuffer[2] = t.b, H._TempBuffer[3] = t.a, this.updateUniform(e, H._TempBuffer, 4);
  }
  _updateIntForEffect(e, t, i = "") {
    this._currentEffect.setInt(e + i, t);
  }
  _updateIntForUniform(e, t) {
    H._TempBufferInt32View[0] = t, this.updateUniform(e, H._TempBuffer, 1);
  }
  _updateInt2ForEffect(e, t, i, s = "") {
    this._currentEffect.setInt2(e + s, t, i);
  }
  _updateInt2ForUniform(e, t, i) {
    H._TempBufferInt32View[0] = t, H._TempBufferInt32View[1] = i, this.updateUniform(e, H._TempBuffer, 2);
  }
  _updateInt3ForEffect(e, t, i, s, r = "") {
    this._currentEffect.setInt3(e + r, t, i, s);
  }
  _updateInt3ForUniform(e, t, i, s) {
    H._TempBufferInt32View[0] = t, H._TempBufferInt32View[1] = i, H._TempBufferInt32View[2] = s, this.updateUniform(e, H._TempBuffer, 3);
  }
  _updateInt4ForEffect(e, t, i, s, r, n = "") {
    this._currentEffect.setInt4(e + n, t, i, s, r);
  }
  _updateInt4ForUniform(e, t, i, s, r) {
    H._TempBufferInt32View[0] = t, H._TempBufferInt32View[1] = i, H._TempBufferInt32View[2] = s, H._TempBufferInt32View[3] = r, this.updateUniform(e, H._TempBuffer, 4);
  }
  _updateUIntForEffect(e, t, i = "") {
    this._currentEffect.setUInt(e + i, t);
  }
  _updateUIntForUniform(e, t) {
    H._TempBufferUInt32View[0] = t, this.updateUniform(e, H._TempBuffer, 1);
  }
  _updateUInt2ForEffect(e, t, i, s = "") {
    this._currentEffect.setUInt2(e + s, t, i);
  }
  _updateUInt2ForUniform(e, t, i) {
    H._TempBufferUInt32View[0] = t, H._TempBufferUInt32View[1] = i, this.updateUniform(e, H._TempBuffer, 2);
  }
  _updateUInt3ForEffect(e, t, i, s, r = "") {
    this._currentEffect.setUInt3(e + r, t, i, s);
  }
  _updateUInt3ForUniform(e, t, i, s) {
    H._TempBufferUInt32View[0] = t, H._TempBufferUInt32View[1] = i, H._TempBufferUInt32View[2] = s, this.updateUniform(e, H._TempBuffer, 3);
  }
  _updateUInt4ForEffect(e, t, i, s, r, n = "") {
    this._currentEffect.setUInt4(e + n, t, i, s, r);
  }
  _updateUInt4ForUniform(e, t, i, s, r) {
    H._TempBufferUInt32View[0] = t, H._TempBufferUInt32View[1] = i, H._TempBufferUInt32View[2] = s, H._TempBufferUInt32View[3] = r, this.updateUniform(e, H._TempBuffer, 4);
  }
  /**
   * Sets a sampler uniform on the effect.
   * @param name Define the name of the sampler.
   * @param texture Define the texture to set in the sampler
   */
  setTexture(e, t) {
    this._currentEffect.setTexture(e, t);
  }
  /**
   * Directly updates the value of the uniform in the cache AND on the GPU.
   * @param uniformName Define the name of the uniform, as used in the uniform block in the shader.
   * @param data Define the flattened data
   */
  updateUniformDirectly(e, t) {
    this.updateUniform(e, t, t.length), this.update();
  }
  /**
   * Associates an effect to this uniform buffer
   * @param effect Define the effect to associate the buffer to
   * @param name Name of the uniform block in the shader.
   */
  bindToEffect(e, t) {
    this._currentEffect = e, this._currentEffectName = t;
  }
  /**
   * Binds the current (GPU) buffer to the effect
   */
  bindUniformBuffer() {
    !this._noUBO && this._buffer && this._currentEffect && this._currentEffect.bindUniformBuffer(this._buffer, this._currentEffectName);
  }
  /**
   * Dissociates the current effect from this uniform buffer
   */
  unbindEffect() {
    this._currentEffect = void 0, this._currentEffectName = void 0;
  }
  /**
   * Sets the current state of the class (_bufferIndex, _buffer) to point to the data buffer passed in parameter if this buffer is one of the buffers handled by the class (meaning if it can be found in the _buffers array)
   * This method is meant to be able to update a buffer at any time: just call setDataBuffer to set the class in the right state, call some updateXXX methods and then call udpate() => that will update the GPU buffer on the graphic card
   * @param dataBuffer buffer to look for
   * @returns true if the buffer has been found and the class internal state points to it, else false
   */
  setDataBuffer(e) {
    if (!this._buffers)
      return this._buffer === e;
    for (let t = 0; t < this._buffers.length; ++t)
      if (this._buffers[t][0] === e)
        return this._bufferIndex = t, this._buffer = e, this._createBufferOnWrite = !1, this._currentEffect = void 0, !0;
    return !1;
  }
  /**
   * Disposes the uniform buffer.
   */
  dispose() {
    if (this._noUBO)
      return;
    const e = this._engine._uniformBuffers, t = e.indexOf(this);
    if (t !== -1 && (e[t] = e[e.length - 1], e.pop()), this._engine._features.trackUbosInFrame && this._buffers)
      for (let i = 0; i < this._buffers.length; ++i) {
        const s = this._buffers[i][0];
        this._engine._releaseBuffer(s);
      }
    else this._buffer && this._engine._releaseBuffer(this._buffer) && (this._buffer = null);
  }
}
H._UpdatedUbosInFrame = {};
H._MAX_UNIFORM_SIZE = 256;
H._TempBuffer = new Float32Array(H._MAX_UNIFORM_SIZE);
H._TempBufferInt32View = new Int32Array(H._TempBuffer.buffer);
H._TempBufferUInt32View = new Uint32Array(H._TempBuffer.buffer);
class gs {
  /**
   * Constructor
   * @param engine the engine
   * @param data the data to use for this buffer
   * @param updatable whether the data is updatable
   * @param stride the stride (optional)
   * @param postponeInternalCreation whether to postpone creating the internal WebGL buffer (optional)
   * @param instanced whether the buffer is instanced (optional)
   * @param useBytes set to true if the stride in in bytes (optional)
   * @param divisor sets an optional divisor for instances (1 by default)
   */
  constructor(e, t, i, s = 0, r = !1, n = !1, a = !1, o) {
    this._isAlreadyOwned = !1, e.getScene ? this._engine = e.getScene().getEngine() : this._engine = e, this._updatable = i, this._instanced = n, this._divisor = o || 1, t instanceof Zs ? (this._data = null, this._buffer = t) : (this._data = t, this._buffer = null), this.byteStride = a ? s : s * Float32Array.BYTES_PER_ELEMENT, r || this.create();
  }
  /**
   * Create a new VertexBuffer based on the current buffer
   * @param kind defines the vertex buffer kind (position, normal, etc.)
   * @param offset defines offset in the buffer (0 by default)
   * @param size defines the size in floats of attributes (position is 3 for instance)
   * @param stride defines the stride size in floats in the buffer (the offset to apply to reach next value when data is interleaved)
   * @param instanced defines if the vertex buffer contains indexed data
   * @param useBytes defines if the offset and stride are in bytes     *
   * @param divisor sets an optional divisor for instances (1 by default)
   * @returns the new vertex buffer
   */
  createVertexBuffer(e, t, i, s, r, n = !1, a) {
    const o = n ? t : t * Float32Array.BYTES_PER_ELEMENT, l = s ? n ? s : s * Float32Array.BYTES_PER_ELEMENT : this.byteStride;
    return new v(this._engine, this, e, this._updatable, !0, l, r === void 0 ? this._instanced : r, o, i, void 0, void 0, !0, this._divisor || a);
  }
  // Properties
  /**
   * Gets a boolean indicating if the Buffer is updatable?
   * @returns true if the buffer is updatable
   */
  isUpdatable() {
    return this._updatable;
  }
  /**
   * Gets current buffer's data
   * @returns a DataArray or null
   */
  getData() {
    return this._data;
  }
  /**
   * Gets underlying native buffer
   * @returns underlying native buffer
   */
  getBuffer() {
    return this._buffer;
  }
  /**
   * Gets the stride in float32 units (i.e. byte stride / 4).
   * May not be an integer if the byte stride is not divisible by 4.
   * @returns the stride in float32 units
   * @deprecated Please use byteStride instead.
   */
  getStrideSize() {
    return this.byteStride / Float32Array.BYTES_PER_ELEMENT;
  }
  // Methods
  /**
   * Store data into the buffer. Creates the buffer if not used already.
   * If the buffer was already used, it will be updated only if it is updatable, otherwise it will do nothing.
   * @param data defines the data to store
   */
  create(e = null) {
    !e && this._buffer || (e = e || this._data, e && (this._buffer ? this._updatable && (this._engine.updateDynamicVertexBuffer(this._buffer, e), this._data = e) : this._updatable ? (this._buffer = this._engine.createDynamicVertexBuffer(e), this._data = e) : this._buffer = this._engine.createVertexBuffer(e)));
  }
  /** @internal */
  _rebuild() {
    this._buffer = null, this.create(this._data);
  }
  /**
   * Update current buffer data
   * @param data defines the data to store
   */
  update(e) {
    this.create(e);
  }
  /**
   * Updates the data directly.
   * @param data the new data
   * @param offset the new offset
   * @param vertexCount the vertex count (optional)
   * @param useBytes set to true if the offset is in bytes
   */
  updateDirectly(e, t, i, s = !1) {
    this._buffer && this._updatable && (this._engine.updateDynamicVertexBuffer(this._buffer, e, s ? t : t * Float32Array.BYTES_PER_ELEMENT, i ? i * this.byteStride : void 0), t === 0 && i === void 0 ? this._data = e : this._data = null);
  }
  /** @internal */
  _increaseReferences() {
    if (this._buffer) {
      if (!this._isAlreadyOwned) {
        this._isAlreadyOwned = !0;
        return;
      }
      this._buffer.references++;
    }
  }
  /**
   * Release all resources
   */
  dispose() {
    this._buffer && this._engine._releaseBuffer(this._buffer) && (this._buffer = null, this._data = null);
  }
}
class v {
  /**
   * Gets or sets the instance divisor when in instanced mode
   */
  get instanceDivisor() {
    return this._instanceDivisor;
  }
  set instanceDivisor(e) {
    const t = e != 0;
    this._instanceDivisor = e, t !== this._instanced && (this._instanced = t, this._computeHashCode());
  }
  /**
   * Constructor
   * @param engine the engine
   * @param data the data to use for this vertex buffer
   * @param kind the vertex buffer kind
   * @param updatable whether the data is updatable
   * @param postponeInternalCreation whether to postpone creating the internal WebGL buffer (optional)
   * @param stride the stride (optional)
   * @param instanced whether the buffer is instanced (optional)
   * @param offset the offset of the data (optional)
   * @param size the number of components (optional)
   * @param type the type of the component (optional)
   * @param normalized whether the data contains normalized data (optional)
   * @param useBytes set to true if stride and offset are in bytes (optional)
   * @param divisor defines the instance divisor to use (1 by default)
   * @param takeBufferOwnership defines if the buffer should be released when the vertex buffer is disposed
   */
  constructor(e, t, i, s, r, n, a, o, l, c, u = !1, d = !1, f = 1, _ = !1) {
    if (t instanceof gs ? (this._buffer = t, this._ownsBuffer = _) : (this._buffer = new gs(e, t, s, n, r, a, d), this._ownsBuffer = !0), this.uniqueId = v._Counter++, this._kind = i, c == null) {
      const m = this.getData();
      this.type = v.FLOAT, m instanceof Int8Array ? this.type = v.BYTE : m instanceof Uint8Array ? this.type = v.UNSIGNED_BYTE : m instanceof Int16Array ? this.type = v.SHORT : m instanceof Uint16Array ? this.type = v.UNSIGNED_SHORT : m instanceof Int32Array ? this.type = v.INT : m instanceof Uint32Array && (this.type = v.UNSIGNED_INT);
    } else
      this.type = c;
    const g = v.GetTypeByteLength(this.type);
    d ? (this._size = l || (n ? n / g : v.DeduceStride(i)), this.byteStride = n || this._buffer.byteStride || this._size * g, this.byteOffset = o || 0) : (this._size = l || n || v.DeduceStride(i), this.byteStride = n ? n * g : this._buffer.byteStride || this._size * g, this.byteOffset = (o || 0) * g), this.normalized = u, this._instanced = a !== void 0 ? a : !1, this._instanceDivisor = a ? f : 0, this._computeHashCode();
  }
  _computeHashCode() {
    this.hashCode = (this.type - 5120 << 0) + ((this.normalized ? 1 : 0) << 3) + (this._size << 4) + ((this._instanced ? 1 : 0) << 6) + /* keep 5 bits free */
    (this.byteStride << 12);
  }
  /** @internal */
  _rebuild() {
    this._buffer && this._buffer._rebuild();
  }
  /**
   * Returns the kind of the VertexBuffer (string)
   * @returns a string
   */
  getKind() {
    return this._kind;
  }
  // Properties
  /**
   * Gets a boolean indicating if the VertexBuffer is updatable?
   * @returns true if the buffer is updatable
   */
  isUpdatable() {
    return this._buffer.isUpdatable();
  }
  /**
   * Gets current buffer's data
   * @returns a DataArray or null
   */
  getData() {
    return this._buffer.getData();
  }
  /**
   * Gets current buffer's data as a float array. Float data is constructed if the vertex buffer data cannot be returned directly.
   * @param totalVertices number of vertices in the buffer to take into account
   * @param forceCopy defines a boolean indicating that the returned array must be cloned upon returning it
   * @returns a float array containing vertex data
   */
  getFloatData(e, t) {
    const i = this.getData();
    if (!i)
      return null;
    const s = this.getSize() * v.GetTypeByteLength(this.type), r = e * this.getSize();
    if (this.type !== v.FLOAT || this.byteStride !== s) {
      const n = new Float32Array(r);
      return this.forEach(r, (a, o) => n[o] = a), n;
    }
    if (!(i instanceof Array || i instanceof Float32Array) || this.byteOffset !== 0 || i.length !== r)
      if (i instanceof Array) {
        const n = this.byteOffset / 4;
        return i.slice(n, n + r);
      } else {
        if (i instanceof ArrayBuffer)
          return new Float32Array(i, this.byteOffset, r);
        {
          let n = i.byteOffset + this.byteOffset;
          if (t) {
            const o = new Float32Array(r), l = new Float32Array(i.buffer, n, r);
            return o.set(l), o;
          }
          const a = n % 4;
          return a && (n = Math.max(0, n - a)), new Float32Array(i.buffer, n, r);
        }
      }
    return t ? i.slice() : i;
  }
  /**
   * Gets underlying native buffer
   * @returns underlying native buffer
   */
  getBuffer() {
    return this._buffer.getBuffer();
  }
  /**
   * Gets the stride in float32 units (i.e. byte stride / 4).
   * May not be an integer if the byte stride is not divisible by 4.
   * @returns the stride in float32 units
   * @deprecated Please use byteStride instead.
   */
  getStrideSize() {
    return this.byteStride / v.GetTypeByteLength(this.type);
  }
  /**
   * Returns the offset as a multiple of the type byte length.
   * @returns the offset in bytes
   * @deprecated Please use byteOffset instead.
   */
  getOffset() {
    return this.byteOffset / v.GetTypeByteLength(this.type);
  }
  /**
   * Returns the number of components or the byte size per vertex attribute
   * @param sizeInBytes If true, returns the size in bytes or else the size in number of components of the vertex attribute (default: false)
   * @returns the number of components
   */
  getSize(e = !1) {
    return e ? this._size * v.GetTypeByteLength(this.type) : this._size;
  }
  /**
   * Gets a boolean indicating is the internal buffer of the VertexBuffer is instanced
   * @returns true if this buffer is instanced
   */
  getIsInstanced() {
    return this._instanced;
  }
  /**
   * Returns the instancing divisor, zero for non-instanced (integer).
   * @returns a number
   */
  getInstanceDivisor() {
    return this._instanceDivisor;
  }
  // Methods
  /**
   * Store data into the buffer. If the buffer was already used it will be either recreated or updated depending on isUpdatable property
   * @param data defines the data to store
   */
  create(e) {
    this._buffer.create(e);
  }
  /**
   * Updates the underlying buffer according to the passed numeric array or Float32Array.
   * This function will create a new buffer if the current one is not updatable
   * @param data defines the data to store
   */
  update(e) {
    this._buffer.update(e);
  }
  /**
   * Updates directly the underlying WebGLBuffer according to the passed numeric array or Float32Array.
   * Returns the directly updated WebGLBuffer.
   * @param data the new data
   * @param offset the new offset
   * @param useBytes set to true if the offset is in bytes
   */
  updateDirectly(e, t, i = !1) {
    this._buffer.updateDirectly(e, t, void 0, i);
  }
  /**
   * Disposes the VertexBuffer and the underlying WebGLBuffer.
   */
  dispose() {
    this._ownsBuffer && this._buffer.dispose();
  }
  /**
   * Enumerates each value of this vertex buffer as numbers.
   * @param count the number of values to enumerate
   * @param callback the callback function called for each value
   */
  forEach(e, t) {
    v.ForEach(this._buffer.getData(), this.byteOffset, this.byteStride, this._size, this.type, e, this.normalized, t);
  }
  /**
   * Deduces the stride given a kind.
   * @param kind The kind string to deduce
   * @returns The deduced stride
   */
  static DeduceStride(e) {
    switch (e) {
      case v.UVKind:
      case v.UV2Kind:
      case v.UV3Kind:
      case v.UV4Kind:
      case v.UV5Kind:
      case v.UV6Kind:
        return 2;
      case v.NormalKind:
      case v.PositionKind:
        return 3;
      case v.ColorKind:
      case v.MatricesIndicesKind:
      case v.MatricesIndicesExtraKind:
      case v.MatricesWeightsKind:
      case v.MatricesWeightsExtraKind:
      case v.TangentKind:
        return 4;
      default:
        throw new Error("Invalid kind '" + e + "'");
    }
  }
  /**
   * Gets the byte length of the given type.
   * @param type the type
   * @returns the number of bytes
   */
  static GetTypeByteLength(e) {
    switch (e) {
      case v.BYTE:
      case v.UNSIGNED_BYTE:
        return 1;
      case v.SHORT:
      case v.UNSIGNED_SHORT:
        return 2;
      case v.INT:
      case v.UNSIGNED_INT:
      case v.FLOAT:
        return 4;
      default:
        throw new Error(`Invalid type '${e}'`);
    }
  }
  /**
   * Enumerates each value of the given parameters as numbers.
   * @param data the data to enumerate
   * @param byteOffset the byte offset of the data
   * @param byteStride the byte stride of the data
   * @param componentCount the number of components per element
   * @param componentType the type of the component
   * @param count the number of values to enumerate
   * @param normalized whether the data is normalized
   * @param callback the callback function called for each value
   */
  static ForEach(e, t, i, s, r, n, a, o) {
    if (e instanceof Array) {
      let l = t / 4;
      const c = i / 4;
      for (let u = 0; u < n; u += s) {
        for (let d = 0; d < s; d++)
          o(e[l + d], u + d);
        l += c;
      }
    } else {
      const l = e instanceof ArrayBuffer ? new DataView(e) : new DataView(e.buffer, e.byteOffset, e.byteLength), c = v.GetTypeByteLength(r);
      for (let u = 0; u < n; u += s) {
        let d = t;
        for (let f = 0; f < s; f++) {
          const _ = v._GetFloatValue(l, r, d, a);
          o(_, u + f), d += c;
        }
        t += i;
      }
    }
  }
  static _GetFloatValue(e, t, i, s) {
    switch (t) {
      case v.BYTE: {
        let r = e.getInt8(i);
        return s && (r = Math.max(r / 127, -1)), r;
      }
      case v.UNSIGNED_BYTE: {
        let r = e.getUint8(i);
        return s && (r = r / 255), r;
      }
      case v.SHORT: {
        let r = e.getInt16(i, !0);
        return s && (r = Math.max(r / 32767, -1)), r;
      }
      case v.UNSIGNED_SHORT: {
        let r = e.getUint16(i, !0);
        return s && (r = r / 65535), r;
      }
      case v.INT:
        return e.getInt32(i, !0);
      case v.UNSIGNED_INT:
        return e.getUint32(i, !0);
      case v.FLOAT:
        return e.getFloat32(i, !0);
      default:
        throw new Error(`Invalid component type ${t}`);
    }
  }
}
v._Counter = 0;
v.BYTE = 5120;
v.UNSIGNED_BYTE = 5121;
v.SHORT = 5122;
v.UNSIGNED_SHORT = 5123;
v.INT = 5124;
v.UNSIGNED_INT = 5125;
v.FLOAT = 5126;
v.PositionKind = "position";
v.NormalKind = "normal";
v.TangentKind = "tangent";
v.UVKind = "uv";
v.UV2Kind = "uv2";
v.UV3Kind = "uv3";
v.UV4Kind = "uv4";
v.UV5Kind = "uv5";
v.UV6Kind = "uv6";
v.ColorKind = "color";
v.ColorInstanceKind = "instanceColor";
v.MatricesIndicesKind = "matricesIndices";
v.MatricesWeightsKind = "matricesWeights";
v.MatricesIndicesExtraKind = "matricesIndicesExtra";
v.MatricesWeightsExtraKind = "matricesWeightsExtra";
class Gt {
  constructor() {
    this.hit = !1, this.distance = 0, this.pickedPoint = null, this.pickedMesh = null, this.bu = 0, this.bv = 0, this.faceId = -1, this.subMeshFaceId = -1, this.subMeshId = 0, this.pickedSprite = null, this.thinInstanceIndex = -1, this.ray = null, this.originMesh = null, this.aimTransform = null, this.gripTransform = null;
  }
  /**
   * Gets the normal corresponding to the face the pick collided with
   * @param useWorldCoordinates If the resulting normal should be relative to the world (default: false)
   * @param useVerticesNormals If the vertices normals should be used to calculate the normal instead of the normal map (default: true)
   * @returns The normal corresponding to the face the pick collided with
   * @remarks Note that the returned normal will always point towards the picking ray.
   */
  getNormal(e = !1, t = !0) {
    if (!this.pickedMesh || t && !this.pickedMesh.isVerticesDataPresent(v.NormalKind))
      return null;
    let i = this.pickedMesh.getIndices();
    (i == null ? void 0 : i.length) === 0 && (i = null);
    let s;
    const r = C.Vector3[0], n = C.Vector3[1], a = C.Vector3[2];
    if (t) {
      const l = this.pickedMesh.getVerticesData(v.NormalKind);
      let c = i ? p.FromArrayToRef(l, i[this.faceId * 3] * 3, r) : r.copyFromFloats(l[this.faceId * 3 * 3], l[this.faceId * 3 * 3 + 1], l[this.faceId * 3 * 3 + 2]), u = i ? p.FromArrayToRef(l, i[this.faceId * 3 + 1] * 3, n) : n.copyFromFloats(l[(this.faceId * 3 + 1) * 3], l[(this.faceId * 3 + 1) * 3 + 1], l[(this.faceId * 3 + 1) * 3 + 2]), d = i ? p.FromArrayToRef(l, i[this.faceId * 3 + 2] * 3, a) : a.copyFromFloats(l[(this.faceId * 3 + 2) * 3], l[(this.faceId * 3 + 2) * 3 + 1], l[(this.faceId * 3 + 2) * 3 + 2]);
      c = c.scale(this.bu), u = u.scale(this.bv), d = d.scale(1 - this.bu - this.bv), s = new p(c.x + u.x + d.x, c.y + u.y + d.y, c.z + u.z + d.z);
    } else {
      const l = this.pickedMesh.getVerticesData(v.PositionKind), c = i ? p.FromArrayToRef(l, i[this.faceId * 3] * 3, r) : r.copyFromFloats(l[this.faceId * 3 * 3], l[this.faceId * 3 * 3 + 1], l[this.faceId * 3 * 3 + 2]), u = i ? p.FromArrayToRef(l, i[this.faceId * 3 + 1] * 3, n) : n.copyFromFloats(l[(this.faceId * 3 + 1) * 3], l[(this.faceId * 3 + 1) * 3 + 1], l[(this.faceId * 3 + 1) * 3 + 2]), d = i ? p.FromArrayToRef(l, i[this.faceId * 3 + 2] * 3, a) : a.copyFromFloats(l[(this.faceId * 3 + 2) * 3], l[(this.faceId * 3 + 2) * 3 + 1], l[(this.faceId * 3 + 2) * 3 + 2]), f = c.subtract(u), _ = d.subtract(u);
      s = p.Cross(f, _);
    }
    const o = (l, c) => {
      let u = l.getWorldMatrix();
      l.nonUniformScaling && (C.Matrix[0].copyFrom(u), u = C.Matrix[0], u.setTranslationFromFloats(0, 0, 0), u.invert(), u.transposeToRef(C.Matrix[1]), u = C.Matrix[1]), p.TransformNormalToRef(c, u, c);
    };
    if (e && o(this.pickedMesh, s), this.ray) {
      const l = C.Vector3[0].copyFrom(s);
      e || o(this.pickedMesh, l), p.Dot(l, this.ray.direction) > 0 && s.negateInPlace();
    }
    return s.normalize(), s;
  }
  /**
   * Gets the texture coordinates of where the pick occurred
   * @param uvSet The UV set to use to calculate the texture coordinates (default: VertexBuffer.UVKind)
   * @returns The vector containing the coordinates of the texture
   */
  getTextureCoordinates(e = v.UVKind) {
    if (!this.pickedMesh || !this.pickedMesh.isVerticesDataPresent(e))
      return null;
    const t = this.pickedMesh.getIndices();
    if (!t)
      return null;
    const i = this.pickedMesh.getVerticesData(e);
    if (!i)
      return null;
    let s = ue.FromArray(i, t[this.faceId * 3] * 2), r = ue.FromArray(i, t[this.faceId * 3 + 1] * 2), n = ue.FromArray(i, t[this.faceId * 3 + 2] * 2);
    return s = s.scale(this.bu), r = r.scale(this.bv), n = n.scale(1 - this.bu - this.bv), new ue(s.x + r.x + n.x, s.y + r.y + n.y);
  }
}
class He {
  /**
   * Creates a new ActionEvent
   * @param source The mesh or sprite that triggered the action
   * @param pointerX The X mouse cursor position at the time of the event
   * @param pointerY The Y mouse cursor position at the time of the event
   * @param meshUnderPointer The mesh that is currently pointed at (can be null)
   * @param sourceEvent the original (browser) event that triggered the ActionEvent
   * @param additionalData additional data for the event
   */
  constructor(e, t, i, s, r, n) {
    this.source = e, this.pointerX = t, this.pointerY = i, this.meshUnderPointer = s, this.sourceEvent = r, this.additionalData = n;
  }
  /**
   * Helper function to auto-create an ActionEvent from a source mesh.
   * @param source The source mesh that triggered the event
   * @param evt The original (browser) event
   * @param additionalData additional data for the event
   * @returns the new ActionEvent
   */
  static CreateNew(e, t, i) {
    const s = e.getScene();
    return new He(e, s.pointerX, s.pointerY, s.meshUnderPointer || e, t, i);
  }
  /**
   * Helper function to auto-create an ActionEvent from a source sprite
   * @param source The source sprite that triggered the event
   * @param scene Scene associated with the sprite
   * @param evt The original (browser) event
   * @param additionalData additional data for the event
   * @returns the new ActionEvent
   */
  static CreateNewFromSprite(e, t, i, s) {
    return new He(e, t.pointerX, t.pointerY, t.meshUnderPointer, i, s);
  }
  /**
   * Helper function to auto-create an ActionEvent from a scene. If triggered by a mesh use ActionEvent.CreateNew
   * @param scene the scene where the event occurred
   * @param evt The original (browser) event
   * @returns the new ActionEvent
   */
  static CreateNewFromScene(e, t) {
    return new He(null, e.pointerX, e.pointerY, e.meshUnderPointer, t);
  }
  /**
   * Helper function to auto-create an ActionEvent from a primitive
   * @param prim defines the target primitive
   * @param pointerPos defines the pointer position
   * @param evt The original (browser) event
   * @param additionalData additional data for the event
   * @returns the new ActionEvent
   */
  static CreateNewFromPrimitive(e, t, i, s) {
    return new He(e, t.x, t.y, null, i, s);
  }
}
class nn {
  /**
   * Creates a new instance PostProcess
   * @param scene The scene that the post process is associated with.
   */
  constructor(e) {
    this._vertexBuffers = {}, this._scene = e;
  }
  _prepareBuffers() {
    if (this._vertexBuffers[v.PositionKind])
      return;
    const e = [];
    e.push(1, 1), e.push(-1, 1), e.push(-1, -1), e.push(1, -1), this._vertexBuffers[v.PositionKind] = new v(this._scene.getEngine(), e, v.PositionKind, !1, !1, 2), this._buildIndexBuffer();
  }
  _buildIndexBuffer() {
    const e = [];
    e.push(0), e.push(1), e.push(2), e.push(0), e.push(2), e.push(3), this._indexBuffer = this._scene.getEngine().createIndexBuffer(e);
  }
  /**
   * Rebuilds the vertex buffers of the manager.
   * @internal
   */
  _rebuild() {
    const e = this._vertexBuffers[v.PositionKind];
    e && (e._rebuild(), this._buildIndexBuffer());
  }
  // Methods
  /**
   * Prepares a frame to be run through a post process.
   * @param sourceTexture The input texture to the post processes. (default: null)
   * @param postProcesses An array of post processes to be run. (default: null)
   * @returns True if the post processes were able to be run.
   * @internal
   */
  _prepareFrame(e = null, t = null) {
    const i = this._scene.activeCamera;
    return !i || (t = t || i._postProcesses.filter((s) => s != null), !t || t.length === 0 || !this._scene.postProcessesEnabled) ? !1 : (t[0].activate(i, e, t != null), !0);
  }
  /**
   * Manually render a set of post processes to a texture.
   * Please note, the frame buffer won't be unbound after the call in case you have more render to do.
   * @param postProcesses An array of post processes to be run.
   * @param targetTexture The render target wrapper to render to.
   * @param forceFullscreenViewport force gl.viewport to be full screen eg. 0,0,textureWidth,textureHeight
   * @param faceIndex defines the face to render to if a cubemap is defined as the target
   * @param lodLevel defines which lod of the texture to render to
   * @param doNotBindFrambuffer If set to true, assumes that the framebuffer has been bound previously
   */
  directRender(e, t = null, i = !1, s = 0, r = 0, n = !1) {
    var a;
    const o = this._scene.getEngine();
    for (let l = 0; l < e.length; l++) {
      l < e.length - 1 ? e[l + 1].activate(this._scene.activeCamera, t == null ? void 0 : t.texture) : (t ? o.bindFramebuffer(t, s, void 0, void 0, i, r) : n || o.restoreDefaultFramebuffer(), (a = o._debugInsertMarker) === null || a === void 0 || a.call(o, `post process ${e[l].name} output`));
      const c = e[l], u = c.apply();
      u && (c.onBeforeRenderObservable.notifyObservers(u), this._prepareBuffers(), o.bindBuffers(this._vertexBuffers, this._indexBuffer, u), o.drawElementsType(0, 0, 6), c.onAfterRenderObservable.notifyObservers(u));
    }
    o.setDepthBuffer(!0), o.setDepthWrite(!0);
  }
  /**
   * Finalize the result of the output of the postprocesses.
   * @param doNotPresent If true the result will not be displayed to the screen.
   * @param targetTexture The render target wrapper to render to.
   * @param faceIndex The index of the face to bind the target texture to.
   * @param postProcesses The array of post processes to render.
   * @param forceFullscreenViewport force gl.viewport to be full screen eg. 0,0,textureWidth,textureHeight (default: false)
   * @internal
   */
  _finalizeFrame(e, t, i, s, r = !1) {
    var n;
    const a = this._scene.activeCamera;
    if (!a || (s = s || a._postProcesses.filter((l) => l != null), s.length === 0 || !this._scene.postProcessesEnabled))
      return;
    const o = this._scene.getEngine();
    for (let l = 0, c = s.length; l < c; l++) {
      const u = s[l];
      if (l < c - 1 ? u._outputTexture = s[l + 1].activate(a, t == null ? void 0 : t.texture) : (t ? (o.bindFramebuffer(t, i, void 0, void 0, r), u._outputTexture = t) : (o.restoreDefaultFramebuffer(), u._outputTexture = null), (n = o._debugInsertMarker) === null || n === void 0 || n.call(o, `post process ${s[l].name} output`)), e)
        break;
      const d = u.apply();
      d && (u.onBeforeRenderObservable.notifyObservers(d), this._prepareBuffers(), o.bindBuffers(this._vertexBuffers, this._indexBuffer, d), o.drawElementsType(0, 0, 6), u.onAfterRenderObservable.notifyObservers(d));
    }
    o.setDepthBuffer(!0), o.setDepthWrite(!0), o.setAlphaMode(0);
  }
  /**
   * Disposes of the post process manager.
   */
  dispose() {
    const e = this._vertexBuffers[v.PositionKind];
    e && (e.dispose(), this._vertexBuffers[v.PositionKind] = null), this._indexBuffer && (this._scene.getEngine()._releaseBuffer(this._indexBuffer), this._indexBuffer = null);
  }
}
class ei {
  /**
   * Set the opaque sort comparison function.
   * If null the sub meshes will be render in the order they were created
   */
  set opaqueSortCompareFn(e) {
    e ? this._opaqueSortCompareFn = e : this._opaqueSortCompareFn = ei.PainterSortCompare, this._renderOpaque = this._renderOpaqueSorted;
  }
  /**
   * Set the alpha test sort comparison function.
   * If null the sub meshes will be render in the order they were created
   */
  set alphaTestSortCompareFn(e) {
    e ? this._alphaTestSortCompareFn = e : this._alphaTestSortCompareFn = ei.PainterSortCompare, this._renderAlphaTest = this._renderAlphaTestSorted;
  }
  /**
   * Set the transparent sort comparison function.
   * If null the sub meshes will be render in the order they were created
   */
  set transparentSortCompareFn(e) {
    e ? this._transparentSortCompareFn = e : this._transparentSortCompareFn = ei.defaultTransparentSortCompare, this._renderTransparent = this._renderTransparentSorted;
  }
  /**
   * Creates a new rendering group.
   * @param index The rendering group index
   * @param scene
   * @param opaqueSortCompareFn The opaque sort comparison function. If null no order is applied
   * @param alphaTestSortCompareFn The alpha test sort comparison function. If null no order is applied
   * @param transparentSortCompareFn The transparent sort comparison function. If null back to front + alpha index sort is applied
   */
  constructor(e, t, i = null, s = null, r = null) {
    this.index = e, this._opaqueSubMeshes = new At(256), this._transparentSubMeshes = new At(256), this._alphaTestSubMeshes = new At(256), this._depthOnlySubMeshes = new At(256), this._particleSystems = new At(256), this._spriteManagers = new At(256), this._empty = !0, this._edgesRenderers = new Wi(16), this._scene = t, this.opaqueSortCompareFn = i, this.alphaTestSortCompareFn = s, this.transparentSortCompareFn = r;
  }
  /**
   * Render all the sub meshes contained in the group.
   * @param customRenderFunction Used to override the default render behaviour of the group.
   * @param renderSprites
   * @param renderParticles
   * @param activeMeshes
   * @returns true if rendered some submeshes.
   */
  render(e, t, i, s) {
    if (e) {
      e(this._opaqueSubMeshes, this._alphaTestSubMeshes, this._transparentSubMeshes, this._depthOnlySubMeshes);
      return;
    }
    const r = this._scene.getEngine();
    this._depthOnlySubMeshes.length !== 0 && (r.setColorWrite(!1), this._renderAlphaTest(this._depthOnlySubMeshes), r.setColorWrite(!0)), this._opaqueSubMeshes.length !== 0 && this._renderOpaque(this._opaqueSubMeshes), this._alphaTestSubMeshes.length !== 0 && this._renderAlphaTest(this._alphaTestSubMeshes);
    const n = r.getStencilBuffer();
    if (r.setStencilBuffer(!1), t && this._renderSprites(), i && this._renderParticles(s), this.onBeforeTransparentRendering && this.onBeforeTransparentRendering(), this._transparentSubMeshes.length !== 0 || this._scene.useOrderIndependentTransparency) {
      if (r.setStencilBuffer(n), this._scene.useOrderIndependentTransparency) {
        const a = this._scene.depthPeelingRenderer.render(this._transparentSubMeshes);
        a.length && this._renderTransparent(a);
      } else
        this._renderTransparent(this._transparentSubMeshes);
      r.setAlphaMode(0);
    }
    if (r.setStencilBuffer(!1), this._edgesRenderers.length) {
      for (let a = 0; a < this._edgesRenderers.length; a++)
        this._edgesRenderers.data[a].render();
      r.setAlphaMode(0);
    }
    r.setStencilBuffer(n);
  }
  /**
   * Renders the opaque submeshes in the order from the opaqueSortCompareFn.
   * @param subMeshes The submeshes to render
   */
  _renderOpaqueSorted(e) {
    return ei._RenderSorted(e, this._opaqueSortCompareFn, this._scene.activeCamera, !1);
  }
  /**
   * Renders the opaque submeshes in the order from the alphatestSortCompareFn.
   * @param subMeshes The submeshes to render
   */
  _renderAlphaTestSorted(e) {
    return ei._RenderSorted(e, this._alphaTestSortCompareFn, this._scene.activeCamera, !1);
  }
  /**
   * Renders the opaque submeshes in the order from the transparentSortCompareFn.
   * @param subMeshes The submeshes to render
   */
  _renderTransparentSorted(e) {
    return ei._RenderSorted(e, this._transparentSortCompareFn, this._scene.activeCamera, !0);
  }
  /**
   * Renders the submeshes in a specified order.
   * @param subMeshes The submeshes to sort before render
   * @param sortCompareFn The comparison function use to sort
   * @param camera The camera position use to preprocess the submeshes to help sorting
   * @param transparent Specifies to activate blending if true
   */
  static _RenderSorted(e, t, i, s) {
    let r = 0, n;
    const a = i ? i.globalPosition : ei._ZeroVector;
    if (s)
      for (; r < e.length; r++)
        n = e.data[r], n._alphaIndex = n.getMesh().alphaIndex, n._distanceToCamera = p.Distance(n.getBoundingInfo().boundingSphere.centerWorld, a);
    const o = e.length === e.data.length ? e.data : e.data.slice(0, e.length);
    t && o.sort(t);
    const l = o[0].getMesh().getScene();
    for (r = 0; r < o.length; r++)
      if (n = o[r], !(l._activeMeshesFrozenButKeepClipping && !n.isInFrustum(l._frustumPlanes))) {
        if (s) {
          const c = n.getMaterial();
          if (c && c.needDepthPrePass) {
            const u = c.getScene().getEngine();
            u.setColorWrite(!1), u.setAlphaMode(0), n.render(!1), u.setColorWrite(!0);
          }
        }
        n.render(s);
      }
  }
  /**
   * Build in function which can be applied to ensure meshes of a special queue (opaque, alpha test, transparent)
   * are rendered back to front if in the same alpha index.
   *
   * @param a The first submesh
   * @param b The second submesh
   * @returns The result of the comparison
   */
  // eslint-disable-next-line @typescript-eslint/naming-convention
  static defaultTransparentSortCompare(e, t) {
    return e._alphaIndex > t._alphaIndex ? 1 : e._alphaIndex < t._alphaIndex ? -1 : ei.backToFrontSortCompare(e, t);
  }
  /**
   * Build in function which can be applied to ensure meshes of a special queue (opaque, alpha test, transparent)
   * are rendered back to front.
   *
   * @param a The first submesh
   * @param b The second submesh
   * @returns The result of the comparison
   */
  // eslint-disable-next-line @typescript-eslint/naming-convention
  static backToFrontSortCompare(e, t) {
    return e._distanceToCamera < t._distanceToCamera ? 1 : e._distanceToCamera > t._distanceToCamera ? -1 : 0;
  }
  /**
   * Build in function which can be applied to ensure meshes of a special queue (opaque, alpha test, transparent)
   * are rendered front to back (prevent overdraw).
   *
   * @param a The first submesh
   * @param b The second submesh
   * @returns The result of the comparison
   */
  // eslint-disable-next-line @typescript-eslint/naming-convention
  static frontToBackSortCompare(e, t) {
    return e._distanceToCamera < t._distanceToCamera ? -1 : e._distanceToCamera > t._distanceToCamera ? 1 : 0;
  }
  /**
   * Build in function which can be applied to ensure meshes of a special queue (opaque, alpha test, transparent)
   * are grouped by material then geometry.
   *
   * @param a The first submesh
   * @param b The second submesh
   * @returns The result of the comparison
   */
  static PainterSortCompare(e, t) {
    const i = e.getMesh(), s = t.getMesh();
    return i.material && s.material ? i.material.uniqueId - s.material.uniqueId : i.uniqueId - s.uniqueId;
  }
  /**
   * Resets the different lists of submeshes to prepare a new frame.
   */
  prepare() {
    this._opaqueSubMeshes.reset(), this._transparentSubMeshes.reset(), this._alphaTestSubMeshes.reset(), this._depthOnlySubMeshes.reset(), this._particleSystems.reset(), this.prepareSprites(), this._edgesRenderers.reset(), this._empty = !0;
  }
  /**
   * Resets the different lists of sprites to prepare a new frame.
   */
  prepareSprites() {
    this._spriteManagers.reset();
  }
  dispose() {
    this._opaqueSubMeshes.dispose(), this._transparentSubMeshes.dispose(), this._alphaTestSubMeshes.dispose(), this._depthOnlySubMeshes.dispose(), this._particleSystems.dispose(), this._spriteManagers.dispose(), this._edgesRenderers.dispose();
  }
  /**
   * Inserts the submesh in its correct queue depending on its material.
   * @param subMesh The submesh to dispatch
   * @param [mesh] Optional reference to the submeshes's mesh. Provide if you have an exiting reference to improve performance.
   * @param [material] Optional reference to the submeshes's material. Provide if you have an exiting reference to improve performance.
   */
  dispatch(e, t, i) {
    t === void 0 && (t = e.getMesh()), i === void 0 && (i = e.getMaterial()), i != null && (i.needAlphaBlendingForMesh(t) ? this._transparentSubMeshes.push(e) : i.needAlphaTesting() ? (i.needDepthPrePass && this._depthOnlySubMeshes.push(e), this._alphaTestSubMeshes.push(e)) : (i.needDepthPrePass && this._depthOnlySubMeshes.push(e), this._opaqueSubMeshes.push(e)), t._renderingGroup = this, t._edgesRenderer && t._edgesRenderer.isEnabled && this._edgesRenderers.pushNoDuplicate(t._edgesRenderer), this._empty = !1);
  }
  dispatchSprites(e) {
    this._spriteManagers.push(e), this._empty = !1;
  }
  dispatchParticles(e) {
    this._particleSystems.push(e), this._empty = !1;
  }
  _renderParticles(e) {
    if (this._particleSystems.length === 0)
      return;
    const t = this._scene.activeCamera;
    this._scene.onBeforeParticlesRenderingObservable.notifyObservers(this._scene);
    for (let i = 0; i < this._particleSystems.length; i++) {
      const s = this._particleSystems.data[i];
      if ((t && t.layerMask & s.layerMask) === 0)
        continue;
      const r = s.emitter;
      (!r.position || !e || e.indexOf(r) !== -1) && this._scene._activeParticles.addCount(s.render(), !1);
    }
    this._scene.onAfterParticlesRenderingObservable.notifyObservers(this._scene);
  }
  _renderSprites() {
    if (!this._scene.spritesEnabled || this._spriteManagers.length === 0)
      return;
    const e = this._scene.activeCamera;
    this._scene.onBeforeSpritesRenderingObservable.notifyObservers(this._scene);
    for (let t = 0; t < this._spriteManagers.length; t++) {
      const i = this._spriteManagers.data[t];
      (e && e.layerMask & i.layerMask) !== 0 && i.render();
    }
    this._scene.onAfterSpritesRenderingObservable.notifyObservers(this._scene);
  }
}
ei._ZeroVector = p.Zero();
class El {
}
class bt {
  /**
   * Gets or sets a boolean indicating that the manager will not reset between frames.
   * This means that if a mesh becomes invisible or transparent it will not be visible until this boolean is set to false again.
   * By default, the rendering manager will dispatch all active meshes per frame (moving them to the transparent, opaque or alpha testing lists).
   * By turning this property on, you will accelerate the rendering by keeping all these lists unchanged between frames.
   */
  get maintainStateBetweenFrames() {
    return this._maintainStateBetweenFrames;
  }
  set maintainStateBetweenFrames(e) {
    if (e !== this._maintainStateBetweenFrames && (this._maintainStateBetweenFrames = e, !this._maintainStateBetweenFrames)) {
      for (const t of this._scene.meshes)
        if (t.subMeshes)
          for (const i of t.subMeshes)
            i._wasDispatched = !1;
      if (this._scene.spriteManagers)
        for (const t of this._scene.spriteManagers)
          t._wasDispatched = !1;
      for (const t of this._scene.particleSystems)
        t._wasDispatched = !1;
    }
  }
  /**
   * Instantiates a new rendering group for a particular scene
   * @param scene Defines the scene the groups belongs to
   */
  constructor(e) {
    this._useSceneAutoClearSetup = !1, this._renderingGroups = new Array(), this._autoClearDepthStencil = {}, this._customOpaqueSortCompareFn = {}, this._customAlphaTestSortCompareFn = {}, this._customTransparentSortCompareFn = {}, this._renderingGroupInfo = new El(), this._maintainStateBetweenFrames = !1, this._scene = e;
    for (let t = bt.MIN_RENDERINGGROUPS; t < bt.MAX_RENDERINGGROUPS; t++)
      this._autoClearDepthStencil[t] = { autoClear: !0, depth: !0, stencil: !0 };
  }
  /**
   * Gets the rendering group with the specified id.
   */
  getRenderingGroup(e) {
    const t = e || 0;
    return this._prepareRenderingGroup(t), this._renderingGroups[t];
  }
  _clearDepthStencilBuffer(e = !0, t = !0) {
    this._depthStencilBufferAlreadyCleaned || (this._scene.getEngine().clear(null, !1, e, t), this._depthStencilBufferAlreadyCleaned = !0);
  }
  /**
   * Renders the entire managed groups. This is used by the scene or the different render targets.
   * @internal
   */
  render(e, t, i, s) {
    const r = this._renderingGroupInfo;
    if (r.scene = this._scene, r.camera = this._scene.activeCamera, this._scene.spriteManagers && s)
      for (let n = 0; n < this._scene.spriteManagers.length; n++) {
        const a = this._scene.spriteManagers[n];
        this.dispatchSprites(a);
      }
    for (let n = bt.MIN_RENDERINGGROUPS; n < bt.MAX_RENDERINGGROUPS; n++) {
      this._depthStencilBufferAlreadyCleaned = n === bt.MIN_RENDERINGGROUPS;
      const a = this._renderingGroups[n];
      if (!a || a._empty)
        continue;
      const o = Math.pow(2, n);
      if (r.renderingGroupId = n, this._scene.onBeforeRenderingGroupObservable.notifyObservers(r, o), bt.AUTOCLEAR) {
        const l = this._useSceneAutoClearSetup ? this._scene.getAutoClearDepthStencilSetup(n) : this._autoClearDepthStencil[n];
        l && l.autoClear && this._clearDepthStencilBuffer(l.depth, l.stencil);
      }
      for (const l of this._scene._beforeRenderingGroupDrawStage)
        l.action(n);
      a.render(e, s, i, t);
      for (const l of this._scene._afterRenderingGroupDrawStage)
        l.action(n);
      this._scene.onAfterRenderingGroupObservable.notifyObservers(r, o);
    }
  }
  /**
   * Resets the different information of the group to prepare a new frame
   * @internal
   */
  reset() {
    if (!this.maintainStateBetweenFrames)
      for (let e = bt.MIN_RENDERINGGROUPS; e < bt.MAX_RENDERINGGROUPS; e++) {
        const t = this._renderingGroups[e];
        t && t.prepare();
      }
  }
  /**
   * Resets the sprites information of the group to prepare a new frame
   * @internal
   */
  resetSprites() {
    if (!this.maintainStateBetweenFrames)
      for (let e = bt.MIN_RENDERINGGROUPS; e < bt.MAX_RENDERINGGROUPS; e++) {
        const t = this._renderingGroups[e];
        t && t.prepareSprites();
      }
  }
  /**
   * Dispose and release the group and its associated resources.
   * @internal
   */
  dispose() {
    this.freeRenderingGroups(), this._renderingGroups.length = 0, this._renderingGroupInfo = null;
  }
  /**
   * Clear the info related to rendering groups preventing retention points during dispose.
   */
  freeRenderingGroups() {
    for (let e = bt.MIN_RENDERINGGROUPS; e < bt.MAX_RENDERINGGROUPS; e++) {
      const t = this._renderingGroups[e];
      t && t.dispose();
    }
  }
  _prepareRenderingGroup(e) {
    this._renderingGroups[e] === void 0 && (this._renderingGroups[e] = new ei(e, this._scene, this._customOpaqueSortCompareFn[e], this._customAlphaTestSortCompareFn[e], this._customTransparentSortCompareFn[e]));
  }
  /**
   * Add a sprite manager to the rendering manager in order to render it this frame.
   * @param spriteManager Define the sprite manager to render
   */
  dispatchSprites(e) {
    this.maintainStateBetweenFrames && e._wasDispatched || (e._wasDispatched = !0, this.getRenderingGroup(e.renderingGroupId).dispatchSprites(e));
  }
  /**
   * Add a particle system to the rendering manager in order to render it this frame.
   * @param particleSystem Define the particle system to render
   */
  dispatchParticles(e) {
    this.maintainStateBetweenFrames && e._wasDispatched || (e._wasDispatched = !0, this.getRenderingGroup(e.renderingGroupId).dispatchParticles(e));
  }
  /**
   * Add a submesh to the manager in order to render it this frame
   * @param subMesh The submesh to dispatch
   * @param mesh Optional reference to the submeshes's mesh. Provide if you have an exiting reference to improve performance.
   * @param material Optional reference to the submeshes's material. Provide if you have an exiting reference to improve performance.
   */
  dispatch(e, t, i) {
    t === void 0 && (t = e.getMesh()), !(this.maintainStateBetweenFrames && e._wasDispatched) && (e._wasDispatched = !0, this.getRenderingGroup(t.renderingGroupId).dispatch(e, t, i));
  }
  /**
   * Overrides the default sort function applied in the rendering group to prepare the meshes.
   * This allowed control for front to back rendering or reversely depending of the special needs.
   *
   * @param renderingGroupId The rendering group id corresponding to its index
   * @param opaqueSortCompareFn The opaque queue comparison function use to sort.
   * @param alphaTestSortCompareFn The alpha test queue comparison function use to sort.
   * @param transparentSortCompareFn The transparent queue comparison function use to sort.
   */
  setRenderingOrder(e, t = null, i = null, s = null) {
    if (this._customOpaqueSortCompareFn[e] = t, this._customAlphaTestSortCompareFn[e] = i, this._customTransparentSortCompareFn[e] = s, this._renderingGroups[e]) {
      const r = this._renderingGroups[e];
      r.opaqueSortCompareFn = this._customOpaqueSortCompareFn[e], r.alphaTestSortCompareFn = this._customAlphaTestSortCompareFn[e], r.transparentSortCompareFn = this._customTransparentSortCompareFn[e];
    }
  }
  /**
   * Specifies whether or not the stencil and depth buffer are cleared between two rendering groups.
   *
   * @param renderingGroupId The rendering group id corresponding to its index
   * @param autoClearDepthStencil Automatically clears depth and stencil between groups if true.
   * @param depth Automatically clears depth between groups if true and autoClear is true.
   * @param stencil Automatically clears stencil between groups if true and autoClear is true.
   */
  setRenderingAutoClearDepthStencil(e, t, i = !0, s = !0) {
    this._autoClearDepthStencil[e] = {
      autoClear: t,
      depth: i,
      stencil: s
    };
  }
  /**
   * Gets the current auto clear configuration for one rendering group of the rendering
   * manager.
   * @param index the rendering group index to get the information for
   * @returns The auto clear setup for the requested rendering group
   */
  getAutoClearDepthStencilSetup(e) {
    return this._autoClearDepthStencil[e];
  }
}
bt.MAX_RENDERINGGROUPS = 4;
bt.MIN_RENDERINGGROUPS = 0;
bt.AUTOCLEAR = !0;
class ne {
}
ne.NAME_EFFECTLAYER = "EffectLayer";
ne.NAME_LAYER = "Layer";
ne.NAME_LENSFLARESYSTEM = "LensFlareSystem";
ne.NAME_BOUNDINGBOXRENDERER = "BoundingBoxRenderer";
ne.NAME_PARTICLESYSTEM = "ParticleSystem";
ne.NAME_GAMEPAD = "Gamepad";
ne.NAME_SIMPLIFICATIONQUEUE = "SimplificationQueue";
ne.NAME_GEOMETRYBUFFERRENDERER = "GeometryBufferRenderer";
ne.NAME_PREPASSRENDERER = "PrePassRenderer";
ne.NAME_DEPTHRENDERER = "DepthRenderer";
ne.NAME_DEPTHPEELINGRENDERER = "DepthPeelingRenderer";
ne.NAME_POSTPROCESSRENDERPIPELINEMANAGER = "PostProcessRenderPipelineManager";
ne.NAME_SPRITE = "Sprite";
ne.NAME_SUBSURFACE = "SubSurface";
ne.NAME_OUTLINERENDERER = "Outline";
ne.NAME_PROCEDURALTEXTURE = "ProceduralTexture";
ne.NAME_SHADOWGENERATOR = "ShadowGenerator";
ne.NAME_OCTREE = "Octree";
ne.NAME_PHYSICSENGINE = "PhysicsEngine";
ne.NAME_AUDIO = "Audio";
ne.NAME_FLUIDRENDERER = "FluidRenderer";
ne.STEP_ISREADYFORMESH_EFFECTLAYER = 0;
ne.STEP_BEFOREEVALUATEACTIVEMESH_BOUNDINGBOXRENDERER = 0;
ne.STEP_EVALUATESUBMESH_BOUNDINGBOXRENDERER = 0;
ne.STEP_PREACTIVEMESH_BOUNDINGBOXRENDERER = 0;
ne.STEP_CAMERADRAWRENDERTARGET_EFFECTLAYER = 1;
ne.STEP_BEFORECAMERADRAW_PREPASS = 0;
ne.STEP_BEFORECAMERADRAW_EFFECTLAYER = 1;
ne.STEP_BEFORECAMERADRAW_LAYER = 2;
ne.STEP_BEFORERENDERTARGETDRAW_PREPASS = 0;
ne.STEP_BEFORERENDERTARGETDRAW_LAYER = 1;
ne.STEP_BEFORERENDERINGMESH_PREPASS = 0;
ne.STEP_BEFORERENDERINGMESH_OUTLINE = 1;
ne.STEP_AFTERRENDERINGMESH_PREPASS = 0;
ne.STEP_AFTERRENDERINGMESH_OUTLINE = 1;
ne.STEP_AFTERRENDERINGGROUPDRAW_EFFECTLAYER_DRAW = 0;
ne.STEP_AFTERRENDERINGGROUPDRAW_BOUNDINGBOXRENDERER = 1;
ne.STEP_BEFORECAMERAUPDATE_SIMPLIFICATIONQUEUE = 0;
ne.STEP_BEFORECAMERAUPDATE_GAMEPAD = 1;
ne.STEP_BEFORECLEAR_PROCEDURALTEXTURE = 0;
ne.STEP_BEFORECLEAR_PREPASS = 1;
ne.STEP_BEFORERENDERTARGETCLEAR_PREPASS = 0;
ne.STEP_AFTERRENDERTARGETDRAW_PREPASS = 0;
ne.STEP_AFTERRENDERTARGETDRAW_LAYER = 1;
ne.STEP_AFTERCAMERADRAW_PREPASS = 0;
ne.STEP_AFTERCAMERADRAW_EFFECTLAYER = 1;
ne.STEP_AFTERCAMERADRAW_LENSFLARESYSTEM = 2;
ne.STEP_AFTERCAMERADRAW_EFFECTLAYER_DRAW = 3;
ne.STEP_AFTERCAMERADRAW_LAYER = 4;
ne.STEP_AFTERCAMERADRAW_FLUIDRENDERER = 5;
ne.STEP_AFTERCAMERAPOSTPROCESS_LAYER = 0;
ne.STEP_AFTERRENDERTARGETPOSTPROCESS_LAYER = 0;
ne.STEP_AFTERRENDER_AUDIO = 0;
ne.STEP_GATHERRENDERTARGETS_DEPTHRENDERER = 0;
ne.STEP_GATHERRENDERTARGETS_GEOMETRYBUFFERRENDERER = 1;
ne.STEP_GATHERRENDERTARGETS_SHADOWGENERATOR = 2;
ne.STEP_GATHERRENDERTARGETS_POSTPROCESSRENDERPIPELINEMANAGER = 3;
ne.STEP_GATHERACTIVECAMERARENDERTARGETS_DEPTHRENDERER = 0;
ne.STEP_GATHERACTIVECAMERARENDERTARGETS_FLUIDRENDERER = 1;
ne.STEP_POINTERMOVE_SPRITE = 0;
ne.STEP_POINTERDOWN_SPRITE = 0;
ne.STEP_POINTERUP_SPRITE = 0;
class Je extends Array {
  /**
   * Hide ctor from the rest of the world.
   * @param items The items to add.
   */
  constructor(e) {
    super(...e);
  }
  /**
   * Creates a new Stage.
   * @returns A new instance of a Stage
   */
  static Create() {
    return Object.create(Je.prototype);
  }
  /**
   * Registers a step in an ordered way in the targeted stage.
   * @param index Defines the position to register the step in
   * @param component Defines the component attached to the step
   * @param action Defines the action to launch during the step
   */
  registerStep(e, t, i) {
    let s = 0, r = Number.MAX_VALUE;
    for (; s < this.length && (r = this[s].index, !(e < r)); s++)
      ;
    this.splice(s, 0, { index: e, component: t, action: i.bind(t) });
  }
  /**
   * Clears all the steps from the stage.
   */
  clear() {
    this.length = 0;
  }
}
class $ {
}
$.POINTERDOWN = 1;
$.POINTERUP = 2;
$.POINTERMOVE = 4;
$.POINTERWHEEL = 8;
$.POINTERPICK = 16;
$.POINTERTAP = 32;
$.POINTERDOUBLETAP = 64;
class Wa {
  /**
   * Instantiates the base class of pointers info.
   * @param type Defines the type of event (PointerEventTypes)
   * @param event Defines the related dom event
   */
  constructor(e, t) {
    this.type = e, this.event = t;
  }
}
class Ml extends Wa {
  /**
   * Instantiates a PointerInfoPre to store pointer related info to the onPrePointerObservable event.
   * @param type Defines the type of event (PointerEventTypes)
   * @param event Defines the related dom event
   * @param localX Defines the local x coordinates of the pointer when the event occured
   * @param localY Defines the local y coordinates of the pointer when the event occured
   */
  constructor(e, t, i, s) {
    super(e, t), this.ray = null, this.originalPickingInfo = null, this.skipOnPointerObservable = !1, this.localPosition = new ue(i, s);
  }
}
class pi extends Wa {
  /**
   * Defines the picking info associated with this PointerInfo object (if applicable)
   */
  get pickInfo() {
    return this._pickInfo || this._generatePickInfo(), this._pickInfo;
  }
  /**
   * Instantiates a PointerInfo to store pointer related info to the onPointerObservable event.
   * @param type Defines the type of event (PointerEventTypes)
   * @param event Defines the related dom event
   * @param pickInfo Defines the picking info associated to the info (if any)
   * @param inputManager Defines the InputManager to use if there is no pickInfo
   */
  constructor(e, t, i, s = null) {
    super(e, t), this._pickInfo = i, this._inputManager = s;
  }
  /**
   * Generates the picking info if needed
   */
  /** @internal */
  _generatePickInfo() {
    this._inputManager && (this._pickInfo = this._inputManager._pickMove(this.event), this._inputManager._setRayOnPointerInfo(this._pickInfo, this.event), this._inputManager = null);
  }
}
class Wt {
  constructor() {
    this.hoverCursor = "", this.actions = new Array(), this.isRecursive = !1;
  }
  /**
   * Does exist one action manager with at least one trigger
   **/
  static get HasTriggers() {
    for (const e in Wt.Triggers)
      if (Object.prototype.hasOwnProperty.call(Wt.Triggers, e))
        return !0;
    return !1;
  }
  /**
   * Does exist one action manager with at least one pick trigger
   **/
  static get HasPickTriggers() {
    for (const e in Wt.Triggers)
      if (Object.prototype.hasOwnProperty.call(Wt.Triggers, e)) {
        const t = parseInt(e);
        if (t >= 1 && t <= 7)
          return !0;
      }
    return !1;
  }
  /**
   * Does exist one action manager that handles actions of a given trigger
   * @param trigger defines the trigger to be tested
   * @returns a boolean indicating whether the trigger is handled by at least one action manager
   **/
  static HasSpecificTrigger(e) {
    for (const t in Wt.Triggers)
      if (Object.prototype.hasOwnProperty.call(Wt.Triggers, t) && parseInt(t) === e)
        return !0;
    return !1;
  }
}
Wt.Triggers = {};
class ms {
}
ms.KEYDOWN = 1;
ms.KEYUP = 2;
class an {
  /**
   * Instantiates a new keyboard info.
   * This class is used to store keyboard related info for the onKeyboardObservable event.
   * @param type Defines the type of event (KeyboardEventTypes)
   * @param event Defines the related dom event
   */
  constructor(e, t) {
    this.type = e, this.event = t;
  }
}
class qn extends an {
  /**
   * Defines whether the engine should skip the next onKeyboardObservable associated to this pre.
   * @deprecated use skipOnKeyboardObservable property instead
   */
  get skipOnPointerObservable() {
    return this.skipOnKeyboardObservable;
  }
  set skipOnPointerObservable(e) {
    this.skipOnKeyboardObservable = e;
  }
  /**
   * Instantiates a new keyboard pre info.
   * This class is used to store keyboard related info for the onPreKeyboardObservable event.
   * @param type Defines the type of event (KeyboardEventTypes)
   * @param event Defines the related dom event
   */
  constructor(e, t) {
    super(e, t), this.type = e, this.event = t, this.skipOnKeyboardObservable = !1;
  }
}
var j;
(function(h) {
  h[h.Generic = 0] = "Generic", h[h.Keyboard = 1] = "Keyboard", h[h.Mouse = 2] = "Mouse", h[h.Touch = 3] = "Touch", h[h.DualShock = 4] = "DualShock", h[h.Xbox = 5] = "Xbox", h[h.Switch = 6] = "Switch", h[h.DualSense = 7] = "DualSense";
})(j || (j = {}));
var ae;
(function(h) {
  h[h.Horizontal = 0] = "Horizontal", h[h.Vertical = 1] = "Vertical", h[h.LeftClick = 2] = "LeftClick", h[h.MiddleClick = 3] = "MiddleClick", h[h.RightClick = 4] = "RightClick", h[h.BrowserBack = 5] = "BrowserBack", h[h.BrowserForward = 6] = "BrowserForward", h[h.MouseWheelX = 7] = "MouseWheelX", h[h.MouseWheelY = 8] = "MouseWheelY", h[h.MouseWheelZ = 9] = "MouseWheelZ", h[h.Move = 12] = "Move";
})(ae || (ae = {}));
var Er;
(function(h) {
  h[h.Horizontal = 0] = "Horizontal", h[h.Vertical = 1] = "Vertical", h[h.LeftClick = 2] = "LeftClick", h[h.MiddleClick = 3] = "MiddleClick", h[h.RightClick = 4] = "RightClick", h[h.BrowserBack = 5] = "BrowserBack", h[h.BrowserForward = 6] = "BrowserForward", h[h.MouseWheelX = 7] = "MouseWheelX", h[h.MouseWheelY = 8] = "MouseWheelY", h[h.MouseWheelZ = 9] = "MouseWheelZ", h[h.DeltaHorizontal = 10] = "DeltaHorizontal", h[h.DeltaVertical = 11] = "DeltaVertical";
})(Er || (Er = {}));
var jn;
(function(h) {
  h[h.Cross = 0] = "Cross", h[h.Circle = 1] = "Circle", h[h.Square = 2] = "Square", h[h.Triangle = 3] = "Triangle", h[h.L1 = 4] = "L1", h[h.R1 = 5] = "R1", h[h.L2 = 6] = "L2", h[h.R2 = 7] = "R2", h[h.Share = 8] = "Share", h[h.Options = 9] = "Options", h[h.L3 = 10] = "L3", h[h.R3 = 11] = "R3", h[h.DPadUp = 12] = "DPadUp", h[h.DPadDown = 13] = "DPadDown", h[h.DPadLeft = 14] = "DPadLeft", h[h.DPadRight = 15] = "DPadRight", h[h.Home = 16] = "Home", h[h.TouchPad = 17] = "TouchPad", h[h.LStickXAxis = 18] = "LStickXAxis", h[h.LStickYAxis = 19] = "LStickYAxis", h[h.RStickXAxis = 20] = "RStickXAxis", h[h.RStickYAxis = 21] = "RStickYAxis";
})(jn || (jn = {}));
var Zn;
(function(h) {
  h[h.Cross = 0] = "Cross", h[h.Circle = 1] = "Circle", h[h.Square = 2] = "Square", h[h.Triangle = 3] = "Triangle", h[h.L1 = 4] = "L1", h[h.R1 = 5] = "R1", h[h.L2 = 6] = "L2", h[h.R2 = 7] = "R2", h[h.Create = 8] = "Create", h[h.Options = 9] = "Options", h[h.L3 = 10] = "L3", h[h.R3 = 11] = "R3", h[h.DPadUp = 12] = "DPadUp", h[h.DPadDown = 13] = "DPadDown", h[h.DPadLeft = 14] = "DPadLeft", h[h.DPadRight = 15] = "DPadRight", h[h.Home = 16] = "Home", h[h.TouchPad = 17] = "TouchPad", h[h.LStickXAxis = 18] = "LStickXAxis", h[h.LStickYAxis = 19] = "LStickYAxis", h[h.RStickXAxis = 20] = "RStickXAxis", h[h.RStickYAxis = 21] = "RStickYAxis";
})(Zn || (Zn = {}));
var Qn;
(function(h) {
  h[h.A = 0] = "A", h[h.B = 1] = "B", h[h.X = 2] = "X", h[h.Y = 3] = "Y", h[h.LB = 4] = "LB", h[h.RB = 5] = "RB", h[h.LT = 6] = "LT", h[h.RT = 7] = "RT", h[h.Back = 8] = "Back", h[h.Start = 9] = "Start", h[h.LS = 10] = "LS", h[h.RS = 11] = "RS", h[h.DPadUp = 12] = "DPadUp", h[h.DPadDown = 13] = "DPadDown", h[h.DPadLeft = 14] = "DPadLeft", h[h.DPadRight = 15] = "DPadRight", h[h.Home = 16] = "Home", h[h.LStickXAxis = 17] = "LStickXAxis", h[h.LStickYAxis = 18] = "LStickYAxis", h[h.RStickXAxis = 19] = "RStickXAxis", h[h.RStickYAxis = 20] = "RStickYAxis";
})(Qn || (Qn = {}));
var $n;
(function(h) {
  h[h.B = 0] = "B", h[h.A = 1] = "A", h[h.Y = 2] = "Y", h[h.X = 3] = "X", h[h.L = 4] = "L", h[h.R = 5] = "R", h[h.ZL = 6] = "ZL", h[h.ZR = 7] = "ZR", h[h.Minus = 8] = "Minus", h[h.Plus = 9] = "Plus", h[h.LS = 10] = "LS", h[h.RS = 11] = "RS", h[h.DPadUp = 12] = "DPadUp", h[h.DPadDown = 13] = "DPadDown", h[h.DPadLeft = 14] = "DPadLeft", h[h.DPadRight = 15] = "DPadRight", h[h.Home = 16] = "Home", h[h.Capture = 17] = "Capture", h[h.LStickXAxis = 18] = "LStickXAxis", h[h.LStickYAxis = 19] = "LStickYAxis", h[h.RStickXAxis = 20] = "RStickXAxis", h[h.RStickYAxis = 21] = "RStickYAxis";
})($n || ($n = {}));
var Jn;
(function(h) {
  h[h.PointerMove = 0] = "PointerMove", h[h.PointerDown = 1] = "PointerDown", h[h.PointerUp = 2] = "PointerUp";
})(Jn || (Jn = {}));
class xs {
}
xs.DOM_DELTA_PIXEL = 0;
xs.DOM_DELTA_LINE = 1;
xs.DOM_DELTA_PAGE = 2;
class zi {
  /**
   * Create device input events based on provided type and slot
   *
   * @param deviceType Type of device
   * @param deviceSlot "Slot" or index that device is referenced in
   * @param inputIndex Id of input to be checked
   * @param currentState Current value for given input
   * @param deviceInputSystem Reference to DeviceInputSystem
   * @param elementToAttachTo HTMLElement to reference as target for inputs
   * @returns IUIEvent object
   */
  static CreateDeviceEvent(e, t, i, s, r, n, a) {
    switch (e) {
      case j.Keyboard:
        return this._CreateKeyboardEvent(i, s, r, n);
      case j.Mouse:
        if (i === ae.MouseWheelX || i === ae.MouseWheelY || i === ae.MouseWheelZ)
          return this._CreateWheelEvent(e, t, i, s, r, n);
      case j.Touch:
        return this._CreatePointerEvent(e, t, i, s, r, n, a);
      default:
        throw `Unable to generate event for device ${j[e]}`;
    }
  }
  /**
   * Creates pointer event
   *
   * @param deviceType Type of device
   * @param deviceSlot "Slot" or index that device is referenced in
   * @param inputIndex Id of input to be checked
   * @param currentState Current value for given input
   * @param deviceInputSystem Reference to DeviceInputSystem
   * @param elementToAttachTo HTMLElement to reference as target for inputs
   * @returns IUIEvent object (Pointer)
   */
  static _CreatePointerEvent(e, t, i, s, r, n, a) {
    const o = this._CreateMouseEvent(e, t, i, s, r, n);
    e === j.Mouse ? (o.deviceType = j.Mouse, o.pointerId = 1, o.pointerType = "mouse") : (o.deviceType = j.Touch, o.pointerId = a ?? t, o.pointerType = "touch");
    let l = 0;
    return l += r.pollInput(e, t, ae.LeftClick), l += r.pollInput(e, t, ae.RightClick) * 2, l += r.pollInput(e, t, ae.MiddleClick) * 4, o.buttons = l, i === ae.Move ? o.type = "pointermove" : i >= ae.LeftClick && i <= ae.RightClick && (o.type = s === 1 ? "pointerdown" : "pointerup", o.button = i - 2), o;
  }
  /**
   * Create Mouse Wheel Event
   * @param deviceType Type of device
   * @param deviceSlot "Slot" or index that device is referenced in
   * @param inputIndex Id of input to be checked
   * @param currentState Current value for given input
   * @param deviceInputSystem Reference to DeviceInputSystem
   * @param elementToAttachTo HTMLElement to reference as target for inputs
   * @returns IUIEvent object (Wheel)
   */
  static _CreateWheelEvent(e, t, i, s, r, n) {
    const a = this._CreateMouseEvent(e, t, i, s, r, n);
    switch (a.pointerId = 1, a.type = "wheel", a.deltaMode = xs.DOM_DELTA_PIXEL, a.deltaX = 0, a.deltaY = 0, a.deltaZ = 0, i) {
      case ae.MouseWheelX:
        a.deltaX = s;
        break;
      case ae.MouseWheelY:
        a.deltaY = s;
        break;
      case ae.MouseWheelZ:
        a.deltaZ = s;
        break;
    }
    return a;
  }
  /**
   * Create Mouse Event
   * @param deviceType Type of device
   * @param deviceSlot "Slot" or index that device is referenced in
   * @param inputIndex Id of input to be checked
   * @param currentState Current value for given input
   * @param deviceInputSystem Reference to DeviceInputSystem
   * @param elementToAttachTo HTMLElement to reference as target for inputs
   * @returns IUIEvent object (Mouse)
   */
  static _CreateMouseEvent(e, t, i, s, r, n) {
    const a = this._CreateEvent(n), o = r.pollInput(e, t, ae.Horizontal), l = r.pollInput(e, t, ae.Vertical);
    return n ? (a.movementX = 0, a.movementY = 0, a.offsetX = a.movementX - n.getBoundingClientRect().x, a.offsetY = a.movementY - n.getBoundingClientRect().y) : (a.movementX = r.pollInput(e, t, Er.DeltaHorizontal), a.movementY = r.pollInput(e, t, Er.DeltaVertical), a.offsetX = 0, a.offsetY = 0), this._CheckNonCharacterKeys(a, r), a.clientX = o, a.clientY = l, a.x = o, a.y = l, a.deviceType = e, a.deviceSlot = t, a.inputIndex = i, a;
  }
  /**
   * Create Keyboard Event
   * @param inputIndex Id of input to be checked
   * @param currentState Current value for given input
   * @param deviceInputSystem Reference to DeviceInputSystem
   * @param elementToAttachTo HTMLElement to reference as target for inputs
   * @returns IEvent object (Keyboard)
   */
  static _CreateKeyboardEvent(e, t, i, s) {
    const r = this._CreateEvent(s);
    return this._CheckNonCharacterKeys(r, i), r.deviceType = j.Keyboard, r.deviceSlot = 0, r.inputIndex = e, r.type = t === 1 ? "keydown" : "keyup", r.key = String.fromCharCode(e), r.keyCode = e, r;
  }
  /**
   * Add parameters for non-character keys (Ctrl, Alt, Meta, Shift)
   * @param evt Event object to add parameters to
   * @param deviceInputSystem DeviceInputSystem to pull values from
   */
  static _CheckNonCharacterKeys(e, t) {
    const i = t.isDeviceAvailable(j.Keyboard), s = i && t.pollInput(j.Keyboard, 0, 18) === 1, r = i && t.pollInput(j.Keyboard, 0, 17) === 1, n = i && (t.pollInput(j.Keyboard, 0, 91) === 1 || t.pollInput(j.Keyboard, 0, 92) === 1 || t.pollInput(j.Keyboard, 0, 93) === 1), a = i && t.pollInput(j.Keyboard, 0, 16) === 1;
    e.altKey = s, e.ctrlKey = r, e.metaKey = n, e.shiftKey = a;
  }
  /**
   * Create base event object
   * @param elementToAttachTo Value to use as event target
   * @returns
   */
  static _CreateEvent(e) {
    const t = {};
    return t.preventDefault = () => {
    }, t.target = e, t;
  }
}
class Sl {
  constructor(e, t, i) {
    this._nativeInput = _native.DeviceInputSystem ? new _native.DeviceInputSystem(e, t, (s, r, n, a) => {
      const o = zi.CreateDeviceEvent(s, r, n, a, this);
      i(s, r, o);
    }) : this._createDummyNativeInput();
  }
  // Public functions
  /**
   * Checks for current device input value, given an id and input index. Throws exception if requested device not initialized.
   * @param deviceType Enum specifying device type
   * @param deviceSlot "Slot" or index that device is referenced in
   * @param inputIndex Id of input to be checked
   * @returns Current value of input
   */
  pollInput(e, t, i) {
    return this._nativeInput.pollInput(e, t, i);
  }
  /**
   * Check for a specific device in the DeviceInputSystem
   * @param deviceType Type of device to check for
   * @returns bool with status of device's existence
   */
  isDeviceAvailable(e) {
    return e === j.Mouse || e === j.Touch;
  }
  /**
   * Dispose of all the observables
   */
  dispose() {
    this._nativeInput.dispose();
  }
  /**
   * For versions of BabylonNative that don't have the NativeInput plugin initialized, create a dummy version
   * @returns Object with dummy functions
   */
  _createDummyNativeInput() {
    return {
      pollInput: () => 0,
      isDeviceAvailable: () => !1,
      dispose: () => {
      }
    };
  }
}
const ea = 255, ta = Object.keys(ae).length / 2;
class Rl {
  constructor(e, t, i, s) {
    this._inputs = [], this._keyboardActive = !1, this._pointerActive = !1, this._usingSafari = z.IsSafari(), this._usingMacOS = _r() && /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform), this._keyboardDownEvent = (r) => {
    }, this._keyboardUpEvent = (r) => {
    }, this._keyboardBlurEvent = (r) => {
    }, this._pointerMoveEvent = (r) => {
    }, this._pointerDownEvent = (r) => {
    }, this._pointerUpEvent = (r) => {
    }, this._pointerCancelEvent = (r) => {
    }, this._pointerWheelEvent = (r) => {
    }, this._pointerBlurEvent = (r) => {
    }, this._eventsAttached = !1, this._mouseId = -1, this._isUsingFirefox = _r() && navigator.userAgent && navigator.userAgent.indexOf("Firefox") !== -1, this._maxTouchPoints = 0, this._pointerInputClearObserver = null, this._gamepadConnectedEvent = (r) => {
    }, this._gamepadDisconnectedEvent = (r) => {
    }, this._eventPrefix = z.GetPointerPrefix(e), this._engine = e, this._onDeviceConnected = t, this._onDeviceDisconnected = i, this._onInputChanged = s, this._mouseId = this._isUsingFirefox ? 0 : 1, this._enableEvents(), this._usingMacOS && (this._metaKeys = []), this._engine._onEngineViewChanged || (this._engine._onEngineViewChanged = () => {
      this._enableEvents();
    });
  }
  // Public functions
  /**
   * Checks for current device input value, given an id and input index. Throws exception if requested device not initialized.
   * @param deviceType Enum specifying device type
   * @param deviceSlot "Slot" or index that device is referenced in
   * @param inputIndex Id of input to be checked
   * @returns Current value of input
   */
  pollInput(e, t, i) {
    const s = this._inputs[e][t];
    if (!s)
      throw `Unable to find device ${j[e]}`;
    e >= j.DualShock && e <= j.DualSense && this._updateDevice(e, t, i);
    const r = s[i];
    if (r === void 0)
      throw `Unable to find input ${i} for device ${j[e]} in slot ${t}`;
    return i === ae.Move && z.Warn("Unable to provide information for PointerInput.Move.  Try using PointerInput.Horizontal or PointerInput.Vertical for move data."), r;
  }
  /**
   * Check for a specific device in the DeviceInputSystem
   * @param deviceType Type of device to check for
   * @returns bool with status of device's existence
   */
  isDeviceAvailable(e) {
    return this._inputs[e] !== void 0;
  }
  /**
   * Dispose of all the eventlisteners
   */
  dispose() {
    this._onDeviceConnected = () => {
    }, this._onDeviceDisconnected = () => {
    }, this._onInputChanged = () => {
    }, delete this._engine._onEngineViewChanged, this._elementToAttachTo && this._disableEvents();
  }
  /**
   * Enable listening for user input events
   */
  _enableEvents() {
    const e = this === null || this === void 0 ? void 0 : this._engine.getInputElement();
    if (e && (!this._eventsAttached || this._elementToAttachTo !== e)) {
      if (this._disableEvents(), this._inputs) {
        for (const t of this._inputs)
          if (t)
            for (const i in t) {
              const s = +i, r = t[s];
              if (r)
                for (let n = 0; n < r.length; n++)
                  r[n] = 0;
            }
      }
      this._elementToAttachTo = e, this._elementToAttachTo.tabIndex = this._elementToAttachTo.tabIndex !== -1 ? this._elementToAttachTo.tabIndex : this._engine.canvasTabIndex, this._handleKeyActions(), this._handlePointerActions(), this._handleGamepadActions(), this._eventsAttached = !0, this._checkForConnectedDevices();
    }
  }
  /**
   * Disable listening for user input events
   */
  _disableEvents() {
    this._elementToAttachTo && (this._elementToAttachTo.removeEventListener("blur", this._keyboardBlurEvent), this._elementToAttachTo.removeEventListener("blur", this._pointerBlurEvent), this._elementToAttachTo.removeEventListener("keydown", this._keyboardDownEvent), this._elementToAttachTo.removeEventListener("keyup", this._keyboardUpEvent), this._elementToAttachTo.removeEventListener(this._eventPrefix + "move", this._pointerMoveEvent), this._elementToAttachTo.removeEventListener(this._eventPrefix + "down", this._pointerDownEvent), this._elementToAttachTo.removeEventListener(this._eventPrefix + "up", this._pointerUpEvent), this._elementToAttachTo.removeEventListener(this._eventPrefix + "cancel", this._pointerCancelEvent), this._elementToAttachTo.removeEventListener(this._wheelEventName, this._pointerWheelEvent), window.removeEventListener("gamepadconnected", this._gamepadConnectedEvent), window.removeEventListener("gamepaddisconnected", this._gamepadDisconnectedEvent)), this._pointerInputClearObserver && this._engine.onEndFrameObservable.remove(this._pointerInputClearObserver), this._eventsAttached = !1;
  }
  /**
   * Checks for existing connections to devices and register them, if necessary
   * Currently handles gamepads and mouse
   */
  _checkForConnectedDevices() {
    if (navigator.getGamepads) {
      const e = navigator.getGamepads();
      for (const t of e)
        t && this._addGamePad(t);
    }
    typeof matchMedia == "function" && matchMedia("(pointer:fine)").matches && this._addPointerDevice(j.Mouse, 0, 0, 0);
  }
  // Private functions
  /**
   * Add a gamepad to the DeviceInputSystem
   * @param gamepad A single DOM Gamepad object
   */
  _addGamePad(e) {
    const t = this._getGamepadDeviceType(e.id), i = e.index;
    this._gamepads = this._gamepads || new Array(e.index + 1), this._registerDevice(t, i, e.buttons.length + e.axes.length), this._gamepads[i] = t;
  }
  /**
   * Add pointer device to DeviceInputSystem
   * @param deviceType Type of Pointer to add
   * @param deviceSlot Pointer ID (0 for mouse, pointerId for Touch)
   * @param currentX Current X at point of adding
   * @param currentY Current Y at point of adding
   */
  _addPointerDevice(e, t, i, s) {
    this._pointerActive || (this._pointerActive = !0), this._registerDevice(e, t, ta);
    const r = this._inputs[e][t];
    r[0] = i, r[1] = s;
  }
  /**
   * Add device and inputs to device array
   * @param deviceType Enum specifying device type
   * @param deviceSlot "Slot" or index that device is referenced in
   * @param numberOfInputs Number of input entries to create for given device
   */
  _registerDevice(e, t, i) {
    if (t === void 0)
      throw `Unable to register device ${j[e]} to undefined slot.`;
    if (this._inputs[e] || (this._inputs[e] = {}), !this._inputs[e][t]) {
      const s = new Array(i);
      s.fill(0), this._inputs[e][t] = s, this._onDeviceConnected(e, t);
    }
  }
  /**
   * Given a specific device name, remove that device from the device map
   * @param deviceType Enum specifying device type
   * @param deviceSlot "Slot" or index that device is referenced in
   */
  _unregisterDevice(e, t) {
    this._inputs[e][t] && (delete this._inputs[e][t], this._onDeviceDisconnected(e, t));
  }
  /**
   * Handle all actions that come from keyboard interaction
   */
  _handleKeyActions() {
    this._keyboardDownEvent = (e) => {
      this._keyboardActive || (this._keyboardActive = !0, this._registerDevice(j.Keyboard, 0, ea));
      const t = this._inputs[j.Keyboard][0];
      if (t) {
        t[e.keyCode] = 1;
        const i = e;
        i.inputIndex = e.keyCode, this._usingMacOS && e.metaKey && e.key !== "Meta" && (this._metaKeys.includes(e.keyCode) || this._metaKeys.push(e.keyCode)), this._onInputChanged(j.Keyboard, 0, i);
      }
    }, this._keyboardUpEvent = (e) => {
      this._keyboardActive || (this._keyboardActive = !0, this._registerDevice(j.Keyboard, 0, ea));
      const t = this._inputs[j.Keyboard][0];
      if (t) {
        t[e.keyCode] = 0;
        const i = e;
        if (i.inputIndex = e.keyCode, this._usingMacOS && e.key === "Meta" && this._metaKeys.length > 0) {
          for (const s of this._metaKeys) {
            const r = zi.CreateDeviceEvent(j.Keyboard, 0, s, 0, this, this._elementToAttachTo);
            t[s] = 0, this._onInputChanged(j.Keyboard, 0, r);
          }
          this._metaKeys.splice(0, this._metaKeys.length);
        }
        this._onInputChanged(j.Keyboard, 0, i);
      }
    }, this._keyboardBlurEvent = () => {
      if (this._keyboardActive) {
        const e = this._inputs[j.Keyboard][0];
        for (let t = 0; t < e.length; t++)
          if (e[t] !== 0) {
            e[t] = 0;
            const i = zi.CreateDeviceEvent(j.Keyboard, 0, t, 0, this, this._elementToAttachTo);
            this._onInputChanged(j.Keyboard, 0, i);
          }
        this._usingMacOS && this._metaKeys.splice(0, this._metaKeys.length);
      }
    }, this._elementToAttachTo.addEventListener("keydown", this._keyboardDownEvent), this._elementToAttachTo.addEventListener("keyup", this._keyboardUpEvent), this._elementToAttachTo.addEventListener("blur", this._keyboardBlurEvent);
  }
  /**
   * Handle all actions that come from pointer interaction
   */
  _handlePointerActions() {
    this._maxTouchPoints = _r() && navigator.maxTouchPoints || 2, this._activeTouchIds || (this._activeTouchIds = new Array(this._maxTouchPoints));
    for (let i = 0; i < this._maxTouchPoints; i++)
      this._activeTouchIds[i] = -1;
    this._pointerMoveEvent = (i) => {
      const s = this._getPointerType(i), r = s === j.Mouse ? 0 : this._activeTouchIds.indexOf(i.pointerId);
      this._inputs[s] || (this._inputs[s] = {}), this._inputs[s][r] || this._addPointerDevice(s, r, i.clientX, i.clientY);
      const n = this._inputs[s][r];
      if (n) {
        const a = i;
        a.inputIndex = ae.Move, n[ae.Horizontal] = i.clientX, n[ae.Vertical] = i.clientY, i.pointerId === void 0 && (i.pointerId = this._mouseId), this._onInputChanged(s, r, a), !this._usingSafari && i.button !== -1 && (a.inputIndex = i.button + 2, n[i.button + 2] = n[i.button + 2] ? 0 : 1, this._onInputChanged(s, r, a));
      }
    }, this._pointerDownEvent = (i) => {
      const s = this._getPointerType(i);
      let r = s === j.Mouse ? 0 : i.pointerId;
      if (s === j.Touch) {
        const a = this._activeTouchIds.indexOf(-1);
        if (a >= 0)
          r = a, this._activeTouchIds[a] = i.pointerId;
        else {
          z.Warn(`Max number of touches exceeded.  Ignoring touches in excess of ${this._maxTouchPoints}`);
          return;
        }
      }
      this._inputs[s] || (this._inputs[s] = {}), this._inputs[s][r] ? s === j.Touch && this._onDeviceConnected(s, r) : this._addPointerDevice(s, r, i.clientX, i.clientY);
      const n = this._inputs[s][r];
      if (n) {
        const a = n[ae.Horizontal], o = n[ae.Vertical];
        if (s === j.Mouse) {
          if (i.pointerId === void 0 && (i.pointerId = this._mouseId), !document.pointerLockElement)
            try {
              this._elementToAttachTo.setPointerCapture(this._mouseId);
            } catch {
            }
        } else if (i.pointerId && !document.pointerLockElement)
          try {
            this._elementToAttachTo.setPointerCapture(i.pointerId);
          } catch {
          }
        n[ae.Horizontal] = i.clientX, n[ae.Vertical] = i.clientY, n[i.button + 2] = 1;
        const l = i;
        l.inputIndex = i.button + 2, this._onInputChanged(s, r, l), (a !== i.clientX || o !== i.clientY) && (l.inputIndex = ae.Move, this._onInputChanged(s, r, l));
      }
    }, this._pointerUpEvent = (i) => {
      var s, r, n, a, o;
      const l = this._getPointerType(i), c = l === j.Mouse ? 0 : this._activeTouchIds.indexOf(i.pointerId);
      if (l === j.Touch) {
        if (c === -1)
          return;
        this._activeTouchIds[c] = -1;
      }
      const u = (s = this._inputs[l]) === null || s === void 0 ? void 0 : s[c];
      if (u && u[i.button + 2] !== 0) {
        const d = u[ae.Horizontal], f = u[ae.Vertical];
        u[ae.Horizontal] = i.clientX, u[ae.Vertical] = i.clientY, u[i.button + 2] = 0;
        const _ = i;
        i.pointerId === void 0 && (i.pointerId = this._mouseId), (d !== i.clientX || f !== i.clientY) && (_.inputIndex = ae.Move, this._onInputChanged(l, c, _)), _.inputIndex = i.button + 2, l === j.Mouse && this._mouseId >= 0 && (!((n = (r = this._elementToAttachTo).hasPointerCapture) === null || n === void 0) && n.call(r, this._mouseId)) ? this._elementToAttachTo.releasePointerCapture(this._mouseId) : i.pointerId && (!((o = (a = this._elementToAttachTo).hasPointerCapture) === null || o === void 0) && o.call(a, i.pointerId)) && this._elementToAttachTo.releasePointerCapture(i.pointerId), this._onInputChanged(l, c, _), l === j.Touch && this._onDeviceDisconnected(l, c);
      }
    }, this._pointerCancelEvent = (i) => {
      var s, r, n, a;
      if (i.pointerType === "mouse") {
        const o = this._inputs[j.Mouse][0];
        this._mouseId >= 0 && (!((r = (s = this._elementToAttachTo).hasPointerCapture) === null || r === void 0) && r.call(s, this._mouseId)) && this._elementToAttachTo.releasePointerCapture(this._mouseId);
        for (let l = ae.LeftClick; l <= ae.BrowserForward; l++)
          if (o[l] === 1) {
            o[l] = 0;
            const c = zi.CreateDeviceEvent(j.Mouse, 0, l, 0, this, this._elementToAttachTo);
            this._onInputChanged(j.Mouse, 0, c);
          }
      } else {
        const o = this._activeTouchIds.indexOf(i.pointerId);
        !((a = (n = this._elementToAttachTo).hasPointerCapture) === null || a === void 0) && a.call(n, i.pointerId) && this._elementToAttachTo.releasePointerCapture(i.pointerId), this._inputs[j.Touch][o][ae.LeftClick] = 0;
        const l = zi.CreateDeviceEvent(j.Touch, o, ae.LeftClick, 0, this, this._elementToAttachTo, i.pointerId);
        this._onInputChanged(j.Touch, o, l), this._activeTouchIds[o] = -1, this._onDeviceDisconnected(j.Touch, o);
      }
    }, this._wheelEventName = "onwheel" in document.createElement("div") ? "wheel" : document.onmousewheel !== void 0 ? "mousewheel" : "DOMMouseScroll";
    let e = !1;
    const t = function() {
    };
    try {
      const i = Object.defineProperty({}, "passive", {
        get: function() {
          e = !0;
        }
      });
      this._elementToAttachTo.addEventListener("test", t, i), this._elementToAttachTo.removeEventListener("test", t, i);
    } catch {
    }
    this._pointerBlurEvent = () => {
      var i, s, r, n, a;
      if (this.isDeviceAvailable(j.Mouse)) {
        const o = this._inputs[j.Mouse][0];
        this._mouseId >= 0 && (!((s = (i = this._elementToAttachTo).hasPointerCapture) === null || s === void 0) && s.call(i, this._mouseId)) && this._elementToAttachTo.releasePointerCapture(this._mouseId);
        for (let l = ae.LeftClick; l <= ae.BrowserForward; l++)
          if (o[l] === 1) {
            o[l] = 0;
            const c = zi.CreateDeviceEvent(j.Mouse, 0, l, 0, this, this._elementToAttachTo);
            this._onInputChanged(j.Mouse, 0, c);
          }
      }
      if (this.isDeviceAvailable(j.Touch)) {
        const o = this._inputs[j.Touch];
        for (let l = 0; l < this._activeTouchIds.length; l++) {
          const c = this._activeTouchIds[l];
          if (!((n = (r = this._elementToAttachTo).hasPointerCapture) === null || n === void 0) && n.call(r, c) && this._elementToAttachTo.releasePointerCapture(c), c !== -1 && ((a = o[l]) === null || a === void 0 ? void 0 : a[ae.LeftClick]) === 1) {
            o[l][ae.LeftClick] = 0;
            const u = zi.CreateDeviceEvent(j.Touch, l, ae.LeftClick, 0, this, this._elementToAttachTo, c);
            this._onInputChanged(j.Touch, l, u), this._activeTouchIds[l] = -1, this._onDeviceDisconnected(j.Touch, l);
          }
        }
      }
    }, this._pointerWheelEvent = (i) => {
      const s = j.Mouse, r = 0;
      this._inputs[s] || (this._inputs[s] = []), this._inputs[s][r] || (this._pointerActive = !0, this._registerDevice(s, r, ta));
      const n = this._inputs[s][r];
      if (n) {
        n[ae.MouseWheelX] = i.deltaX || 0, n[ae.MouseWheelY] = i.deltaY || i.wheelDelta || 0, n[ae.MouseWheelZ] = i.deltaZ || 0;
        const a = i;
        i.pointerId === void 0 && (i.pointerId = this._mouseId), n[ae.MouseWheelX] !== 0 && (a.inputIndex = ae.MouseWheelX, this._onInputChanged(s, r, a)), n[ae.MouseWheelY] !== 0 && (a.inputIndex = ae.MouseWheelY, this._onInputChanged(s, r, a)), n[ae.MouseWheelZ] !== 0 && (a.inputIndex = ae.MouseWheelZ, this._onInputChanged(s, r, a));
      }
    }, this._elementToAttachTo.addEventListener(this._eventPrefix + "move", this._pointerMoveEvent), this._elementToAttachTo.addEventListener(this._eventPrefix + "down", this._pointerDownEvent), this._elementToAttachTo.addEventListener(this._eventPrefix + "up", this._pointerUpEvent), this._elementToAttachTo.addEventListener(this._eventPrefix + "cancel", this._pointerCancelEvent), this._elementToAttachTo.addEventListener("blur", this._pointerBlurEvent), this._elementToAttachTo.addEventListener(this._wheelEventName, this._pointerWheelEvent, e ? { passive: !1 } : !1), this._pointerInputClearObserver = this._engine.onEndFrameObservable.add(() => {
      if (this.isDeviceAvailable(j.Mouse)) {
        const i = this._inputs[j.Mouse][0];
        i[ae.MouseWheelX] = 0, i[ae.MouseWheelY] = 0, i[ae.MouseWheelZ] = 0;
      }
    });
  }
  /**
   * Handle all actions that come from gamepad interaction
   */
  _handleGamepadActions() {
    this._gamepadConnectedEvent = (e) => {
      this._addGamePad(e.gamepad);
    }, this._gamepadDisconnectedEvent = (e) => {
      if (this._gamepads) {
        const t = this._getGamepadDeviceType(e.gamepad.id), i = e.gamepad.index;
        this._unregisterDevice(t, i), delete this._gamepads[i];
      }
    }, window.addEventListener("gamepadconnected", this._gamepadConnectedEvent), window.addEventListener("gamepaddisconnected", this._gamepadDisconnectedEvent);
  }
  /**
   * Update all non-event based devices with each frame
   * @param deviceType Enum specifying device type
   * @param deviceSlot "Slot" or index that device is referenced in
   * @param inputIndex Id of input to be checked
   */
  _updateDevice(e, t, i) {
    const s = navigator.getGamepads()[t];
    if (s && e === this._gamepads[t]) {
      const r = this._inputs[e][t];
      i >= s.buttons.length ? r[i] = s.axes[i - s.buttons.length].valueOf() : r[i] = s.buttons[i].value;
    }
  }
  /**
   * Gets DeviceType from the device name
   * @param deviceName Name of Device from DeviceInputSystem
   * @returns DeviceType enum value
   */
  _getGamepadDeviceType(e) {
    return e.indexOf("054c") !== -1 ? e.indexOf("0ce6") !== -1 ? j.DualSense : j.DualShock : e.indexOf("Xbox One") !== -1 || e.search("Xbox 360") !== -1 || e.search("xinput") !== -1 ? j.Xbox : e.indexOf("057e") !== -1 ? j.Switch : j.Generic;
  }
  /**
   * Get DeviceType from a given pointer/mouse/touch event.
   * @param evt PointerEvent to evaluate
   * @returns DeviceType interpreted from event
   */
  _getPointerType(e) {
    let t = j.Mouse;
    return (e.pointerType === "touch" || e.pointerType === "pen" || e.touches) && (t = j.Touch), t;
  }
}
class ia {
  /**
   * Default Constructor
   * @param deviceInputSystem - Reference to DeviceInputSystem
   * @param deviceType - Type of device
   * @param deviceSlot - "Slot" or index that device is referenced in
   */
  constructor(e, t, i = 0) {
    this.deviceType = t, this.deviceSlot = i, this.onInputChangedObservable = new N(), this._deviceInputSystem = e;
  }
  /**
   * Get input for specific input
   * @param inputIndex - index of specific input on device
   * @returns Input value from DeviceInputSystem
   */
  getInput(e) {
    return this._deviceInputSystem.pollInput(this.deviceType, this.deviceSlot, e);
  }
}
class Il {
  constructor(e) {
    this._registeredManagers = new Array(), this._refCount = 0, this.registerManager = (n) => {
      for (let a = 0; a < this._devices.length; a++) {
        const o = this._devices[a];
        for (const l in o) {
          const c = +l;
          n._addDevice(new ia(this._deviceInputSystem, a, c));
        }
      }
      this._registeredManagers.push(n);
    }, this.unregisterManager = (n) => {
      const a = this._registeredManagers.indexOf(n);
      a > -1 && this._registeredManagers.splice(a, 1);
    };
    const t = Object.keys(j).length / 2;
    this._devices = new Array(t);
    const i = (n, a) => {
      this._devices[n] || (this._devices[n] = new Array()), this._devices[n][a] || (this._devices[n][a] = a);
      for (const o of this._registeredManagers) {
        const l = new ia(this._deviceInputSystem, n, a);
        o._addDevice(l);
      }
    }, s = (n, a) => {
      var o;
      !((o = this._devices[n]) === null || o === void 0) && o[a] && delete this._devices[n][a];
      for (const l of this._registeredManagers)
        l._removeDevice(n, a);
    }, r = (n, a, o) => {
      if (o)
        for (const l of this._registeredManagers)
          l._onInputChanged(n, a, o);
    };
    typeof _native < "u" ? this._deviceInputSystem = new Sl(i, s, r) : this._deviceInputSystem = new Rl(e, i, s, r);
  }
  dispose() {
    this._deviceInputSystem.dispose();
  }
}
class Pl {
  // Public Functions
  /**
   * Gets a DeviceSource, given a type and slot
   * @param deviceType - Type of Device
   * @param deviceSlot - Slot or ID of device
   * @returns DeviceSource
   */
  getDeviceSource(e, t) {
    if (t === void 0) {
      if (this._firstDevice[e] === void 0)
        return null;
      t = this._firstDevice[e];
    }
    return !this._devices[e] || this._devices[e][t] === void 0 ? null : this._devices[e][t];
  }
  /**
   * Gets an array of DeviceSource objects for a given device type
   * @param deviceType - Type of Device
   * @returns All available DeviceSources of a given type
   */
  getDeviceSources(e) {
    return this._devices[e] ? this._devices[e].filter((t) => !!t) : [];
  }
  /**
   * Default constructor
   * @param engine - Used to get canvas (if applicable)
   */
  constructor(e) {
    const t = Object.keys(j).length / 2;
    this._devices = new Array(t), this._firstDevice = new Array(t), this._engine = e, this._engine._deviceSourceManager || (this._engine._deviceSourceManager = new Il(e)), this._engine._deviceSourceManager._refCount++, this.onDeviceConnectedObservable = new N((i) => {
      for (const s of this._devices)
        if (s)
          for (const r of s)
            r && this.onDeviceConnectedObservable.notifyObserver(i, r);
    }), this.onDeviceDisconnectedObservable = new N(), this._engine._deviceSourceManager.registerManager(this), this._onDisposeObserver = e.onDisposeObservable.add(() => {
      this.dispose();
    });
  }
  /**
   * Dispose of DeviceSourceManager
   */
  dispose() {
    this.onDeviceConnectedObservable.clear(), this.onDeviceDisconnectedObservable.clear(), this._engine._deviceSourceManager && (this._engine._deviceSourceManager.unregisterManager(this), --this._engine._deviceSourceManager._refCount < 1 && (this._engine._deviceSourceManager.dispose(), delete this._engine._deviceSourceManager)), this._engine.onDisposeObservable.remove(this._onDisposeObserver);
  }
  // Hidden Functions
  /**
   * @param deviceSource - Source to add
   * @internal
   */
  _addDevice(e) {
    this._devices[e.deviceType] || (this._devices[e.deviceType] = new Array()), this._devices[e.deviceType][e.deviceSlot] || (this._devices[e.deviceType][e.deviceSlot] = e, this._updateFirstDevices(e.deviceType)), this.onDeviceConnectedObservable.notifyObservers(e);
  }
  /**
   * @param deviceType - DeviceType
   * @param deviceSlot - DeviceSlot
   * @internal
   */
  _removeDevice(e, t) {
    var i, s;
    const r = (i = this._devices[e]) === null || i === void 0 ? void 0 : i[t];
    this.onDeviceDisconnectedObservable.notifyObservers(r), !((s = this._devices[e]) === null || s === void 0) && s[t] && delete this._devices[e][t], this._updateFirstDevices(e);
  }
  /**
   * @param deviceType - DeviceType
   * @param deviceSlot - DeviceSlot
   * @param eventData - Event
   * @internal
   */
  _onInputChanged(e, t, i) {
    var s, r;
    (r = (s = this._devices[e]) === null || s === void 0 ? void 0 : s[t]) === null || r === void 0 || r.onInputChangedObservable.notifyObservers(i);
  }
  // Private Functions
  _updateFirstDevices(e) {
    switch (e) {
      case j.Keyboard:
      case j.Mouse:
        this._firstDevice[e] = 0;
        break;
      case j.Touch:
      case j.DualSense:
      case j.DualShock:
      case j.Xbox:
      case j.Switch:
      case j.Generic: {
        delete this._firstDevice[e];
        const t = this._devices[e];
        if (t) {
          for (let i = 0; i < t.length; i++)
            if (t[i]) {
              this._firstDevice[e] = i;
              break;
            }
        }
        break;
      }
    }
  }
}
class sa {
  constructor() {
    this._singleClick = !1, this._doubleClick = !1, this._hasSwiped = !1, this._ignore = !1;
  }
  get singleClick() {
    return this._singleClick;
  }
  get doubleClick() {
    return this._doubleClick;
  }
  get hasSwiped() {
    return this._hasSwiped;
  }
  get ignore() {
    return this._ignore;
  }
  set singleClick(e) {
    this._singleClick = e;
  }
  set doubleClick(e) {
    this._doubleClick = e;
  }
  set hasSwiped(e) {
    this._hasSwiped = e;
  }
  set ignore(e) {
    this._ignore = e;
  }
}
class et {
  /**
   * Creates a new InputManager
   * @param scene - defines the hosting scene
   */
  constructor(e) {
    this._alreadyAttached = !1, this._meshPickProceed = !1, this._currentPickResult = null, this._previousPickResult = null, this._totalPointersPressed = 0, this._doubleClickOccured = !1, this._isSwiping = !1, this._swipeButtonPressed = -1, this._skipPointerTap = !1, this._isMultiTouchGesture = !1, this._pointerX = 0, this._pointerY = 0, this._startingPointerPosition = new ue(0, 0), this._previousStartingPointerPosition = new ue(0, 0), this._startingPointerTime = 0, this._previousStartingPointerTime = 0, this._pointerCaptures = {}, this._meshUnderPointerId = {}, this._movePointerInfo = null, this._cameraObserverCount = 0, this._delayedClicks = [null, null, null, null, null], this._deviceSourceManager = null, this._scene = e || de.LastCreatedScene, this._scene;
  }
  /**
   * Gets the mesh that is currently under the pointer
   * @returns Mesh that the pointer is pointer is hovering over
   */
  get meshUnderPointer() {
    return this._movePointerInfo && (this._movePointerInfo._generatePickInfo(), this._movePointerInfo = null), this._pointerOverMesh;
  }
  /**
   * When using more than one pointer (for example in XR) you can get the mesh under the specific pointer
   * @param pointerId - the pointer id to use
   * @returns The mesh under this pointer id or null if not found
   */
  getMeshUnderPointerByPointerId(e) {
    return this._meshUnderPointerId[e] || null;
  }
  /**
   * Gets the pointer coordinates in 2D without any translation (ie. straight out of the pointer event)
   * @returns Vector with X/Y values directly from pointer event
   */
  get unTranslatedPointer() {
    return new ue(this._unTranslatedPointerX, this._unTranslatedPointerY);
  }
  /**
   * Gets or sets the current on-screen X position of the pointer
   * @returns Translated X with respect to screen
   */
  get pointerX() {
    return this._pointerX;
  }
  set pointerX(e) {
    this._pointerX = e;
  }
  /**
   * Gets or sets the current on-screen Y position of the pointer
   * @returns Translated Y with respect to screen
   */
  get pointerY() {
    return this._pointerY;
  }
  set pointerY(e) {
    this._pointerY = e;
  }
  _updatePointerPosition(e) {
    const t = this._scene.getEngine().getInputElementClientRect();
    t && (this._pointerX = e.clientX - t.left, this._pointerY = e.clientY - t.top, this._unTranslatedPointerX = this._pointerX, this._unTranslatedPointerY = this._pointerY);
  }
  _processPointerMove(e, t) {
    const i = this._scene, s = i.getEngine(), r = s.getInputElement();
    r && (r.tabIndex = s.canvasTabIndex, i.doNotHandleCursors || (r.style.cursor = i.defaultCursor)), this._setCursorAndPointerOverMesh(e, t, i);
    for (const o of i._pointerMoveStage) {
      e = e || this._pickMove(t);
      const l = !!(e != null && e.pickedMesh);
      e = o.action(this._unTranslatedPointerX, this._unTranslatedPointerY, e, l, r);
    }
    const n = t.inputIndex >= ae.MouseWheelX && t.inputIndex <= ae.MouseWheelZ ? $.POINTERWHEEL : $.POINTERMOVE;
    i.onPointerMove && (e = e || this._pickMove(t), i.onPointerMove(t, e, n));
    let a;
    e ? (a = new pi(n, t, e), this._setRayOnPointerInfo(e, t)) : (a = new pi(n, t, null, this), this._movePointerInfo = a), i.onPointerObservable.hasObservers() && i.onPointerObservable.notifyObservers(a, n);
  }
  // Pointers handling
  /** @internal */
  _setRayOnPointerInfo(e, t) {
    const i = this._scene;
    e && i._pickingAvailable && (e.ray || (e.ray = i.createPickingRay(t.offsetX, t.offsetY, I.Identity(), i.activeCamera)));
  }
  /** @internal */
  _addCameraPointerObserver(e, t) {
    return this._cameraObserverCount++, this._scene.onPointerObservable.add(e, t);
  }
  /** @internal */
  _removeCameraPointerObserver(e) {
    return this._cameraObserverCount--, this._scene.onPointerObservable.remove(e);
  }
  _checkForPicking() {
    return !!(this._scene.onPointerObservable.observers.length > this._cameraObserverCount || this._scene.onPointerPick);
  }
  _checkPrePointerObservable(e, t, i) {
    const s = this._scene, r = new Ml(i, t, this._unTranslatedPointerX, this._unTranslatedPointerY);
    return e && (r.originalPickingInfo = e, r.ray = e.ray, e.originMesh && (r.nearInteractionPickingInfo = e)), s.onPrePointerObservable.notifyObservers(r, i), !!r.skipOnPointerObservable;
  }
  /** @internal */
  _pickMove(e) {
    const t = this._scene, i = t.pick(this._unTranslatedPointerX, this._unTranslatedPointerY, t.pointerMovePredicate, t.pointerMoveFastCheck, t.cameraToUseForPointers, t.pointerMoveTrianglePredicate);
    return this._setCursorAndPointerOverMesh(i, e, t), i;
  }
  _setCursorAndPointerOverMesh(e, t, i) {
    const r = i.getEngine().getInputElement();
    if (e != null && e.pickedMesh) {
      if (this.setPointerOverMesh(e.pickedMesh, t.pointerId, e, t), !i.doNotHandleCursors && r && this._pointerOverMesh) {
        const n = this._pointerOverMesh._getActionManagerForTrigger();
        n && n.hasPointerTriggers && (r.style.cursor = n.hoverCursor || i.hoverCursor);
      }
    } else
      this.setPointerOverMesh(null, t.pointerId, e, t);
  }
  /**
   * Use this method to simulate a pointer move on a mesh
   * The pickResult parameter can be obtained from a scene.pick or scene.pickWithRay
   * @param pickResult - pickingInfo of the object wished to simulate pointer event on
   * @param pointerEventInit - pointer event state to be used when simulating the pointer event (eg. pointer id for multitouch)
   */
  simulatePointerMove(e, t) {
    const i = new PointerEvent("pointermove", t);
    i.inputIndex = ae.Move, !this._checkPrePointerObservable(e, i, $.POINTERMOVE) && this._processPointerMove(e, i);
  }
  /**
   * Use this method to simulate a pointer down on a mesh
   * The pickResult parameter can be obtained from a scene.pick or scene.pickWithRay
   * @param pickResult - pickingInfo of the object wished to simulate pointer event on
   * @param pointerEventInit - pointer event state to be used when simulating the pointer event (eg. pointer id for multitouch)
   */
  simulatePointerDown(e, t) {
    const i = new PointerEvent("pointerdown", t);
    i.inputIndex = i.button + 2, !this._checkPrePointerObservable(e, i, $.POINTERDOWN) && this._processPointerDown(e, i);
  }
  _processPointerDown(e, t) {
    const i = this._scene;
    if (e != null && e.pickedMesh) {
      this._pickedDownMesh = e.pickedMesh;
      const n = e.pickedMesh._getActionManagerForTrigger();
      if (n) {
        if (n.hasPickTriggers)
          switch (n.processTrigger(5, He.CreateNew(e.pickedMesh, t, e)), t.button) {
            case 0:
              n.processTrigger(2, He.CreateNew(e.pickedMesh, t, e));
              break;
            case 1:
              n.processTrigger(4, He.CreateNew(e.pickedMesh, t, e));
              break;
            case 2:
              n.processTrigger(3, He.CreateNew(e.pickedMesh, t, e));
              break;
          }
        n.hasSpecificTrigger(8) && window.setTimeout(() => {
          const a = i.pick(this._unTranslatedPointerX, this._unTranslatedPointerY, (o) => o.isPickable && o.isVisible && o.isReady() && o.actionManager && o.actionManager.hasSpecificTrigger(8) && o === this._pickedDownMesh, !1, i.cameraToUseForPointers);
          a != null && a.pickedMesh && n && this._totalPointersPressed !== 0 && Date.now() - this._startingPointerTime > et.LongPressDelay && !this._isPointerSwiping() && (this._startingPointerTime = 0, n.processTrigger(8, He.CreateNew(a.pickedMesh, t)));
        }, et.LongPressDelay);
      }
    } else
      for (const n of i._pointerDownStage)
        e = n.action(this._unTranslatedPointerX, this._unTranslatedPointerY, e, t, !1);
    let s;
    const r = $.POINTERDOWN;
    e ? (i.onPointerDown && i.onPointerDown(t, e, r), s = new pi(r, t, e), this._setRayOnPointerInfo(e, t)) : s = new pi(r, t, null, this), i.onPointerObservable.hasObservers() && i.onPointerObservable.notifyObservers(s, r);
  }
  /**
   * @internal
   * @internals Boolean if delta for pointer exceeds drag movement threshold
   */
  _isPointerSwiping() {
    return this._isSwiping;
  }
  /**
   * Use this method to simulate a pointer up on a mesh
   * The pickResult parameter can be obtained from a scene.pick or scene.pickWithRay
   * @param pickResult - pickingInfo of the object wished to simulate pointer event on
   * @param pointerEventInit - pointer event state to be used when simulating the pointer event (eg. pointer id for multitouch)
   * @param doubleTap - indicates that the pointer up event should be considered as part of a double click (false by default)
   */
  simulatePointerUp(e, t, i) {
    const s = new PointerEvent("pointerup", t);
    s.inputIndex = ae.Move;
    const r = new sa();
    i ? r.doubleClick = !0 : r.singleClick = !0, !this._checkPrePointerObservable(e, s, $.POINTERUP) && this._processPointerUp(e, s, r);
  }
  _processPointerUp(e, t, i) {
    const s = this._scene;
    if (e != null && e.pickedMesh) {
      if (this._pickedUpMesh = e.pickedMesh, this._pickedDownMesh === this._pickedUpMesh && (s.onPointerPick && s.onPointerPick(t, e), i.singleClick && !i.ignore && s.onPointerObservable.observers.length > this._cameraObserverCount)) {
        const n = $.POINTERPICK, a = new pi(n, t, e);
        this._setRayOnPointerInfo(e, t), s.onPointerObservable.notifyObservers(a, n);
      }
      const r = e.pickedMesh._getActionManagerForTrigger();
      if (r && !i.ignore) {
        r.processTrigger(7, He.CreateNew(e.pickedMesh, t, e)), !i.hasSwiped && i.singleClick && r.processTrigger(1, He.CreateNew(e.pickedMesh, t, e));
        const n = e.pickedMesh._getActionManagerForTrigger(6);
        i.doubleClick && n && n.processTrigger(6, He.CreateNew(e.pickedMesh, t, e));
      }
    } else if (!i.ignore)
      for (const r of s._pointerUpStage)
        e = r.action(this._unTranslatedPointerX, this._unTranslatedPointerY, e, t, i.doubleClick);
    if (this._pickedDownMesh && this._pickedDownMesh !== this._pickedUpMesh) {
      const r = this._pickedDownMesh._getActionManagerForTrigger(16);
      r && r.processTrigger(16, He.CreateNew(this._pickedDownMesh, t));
    }
    if (!i.ignore) {
      const r = new pi($.POINTERUP, t, e);
      if (this._setRayOnPointerInfo(e, t), s.onPointerObservable.notifyObservers(r, $.POINTERUP), s.onPointerUp && s.onPointerUp(t, e, $.POINTERUP), !i.hasSwiped && !this._skipPointerTap && !this._isMultiTouchGesture) {
        let n = 0;
        if (i.singleClick ? n = $.POINTERTAP : i.doubleClick && (n = $.POINTERDOUBLETAP), n) {
          const a = new pi(n, t, e);
          s.onPointerObservable.hasObservers() && s.onPointerObservable.hasSpecificMask(n) && s.onPointerObservable.notifyObservers(a, n);
        }
      }
    }
  }
  /**
   * Gets a boolean indicating if the current pointer event is captured (meaning that the scene has already handled the pointer down)
   * @param pointerId - defines the pointer id to use in a multi-touch scenario (0 by default)
   * @returns true if the pointer was captured
   */
  isPointerCaptured(e = 0) {
    return this._pointerCaptures[e];
  }
  /**
   * Attach events to the canvas (To handle actionManagers triggers and raise onPointerMove, onPointerDown and onPointerUp
   * @param attachUp - defines if you want to attach events to pointerup
   * @param attachDown - defines if you want to attach events to pointerdown
   * @param attachMove - defines if you want to attach events to pointermove
   * @param elementToAttachTo - defines the target DOM element to attach to (will use the canvas by default)
   */
  attachControl(e = !0, t = !0, i = !0, s = null) {
    const r = this._scene, n = r.getEngine();
    s || (s = n.getInputElement()), this._alreadyAttached && this.detachControl(), s && (this._alreadyAttachedTo = s), this._deviceSourceManager = new Pl(n), this._initActionManager = (a) => {
      if (!this._meshPickProceed) {
        const o = r.skipPointerUpPicking || r._registeredActions === 0 && !this._checkForPicking() && !r.onPointerUp ? null : r.pick(this._unTranslatedPointerX, this._unTranslatedPointerY, r.pointerUpPredicate, r.pointerUpFastCheck, r.cameraToUseForPointers);
        this._currentPickResult = o, o && (a = o.hit && o.pickedMesh ? o.pickedMesh._getActionManagerForTrigger() : null), this._meshPickProceed = !0;
      }
      return a;
    }, this._delayedSimpleClick = (a, o, l) => {
      if ((Date.now() - this._previousStartingPointerTime > et.DoubleClickDelay && !this._doubleClickOccured || a !== this._previousButtonPressed) && (this._doubleClickOccured = !1, o.singleClick = !0, o.ignore = !1, this._delayedClicks[a])) {
        const c = this._delayedClicks[a].evt, u = $.POINTERTAP, d = new pi(u, c, this._currentPickResult);
        r.onPointerObservable.hasObservers() && r.onPointerObservable.hasSpecificMask(u) && r.onPointerObservable.notifyObservers(d, u), this._delayedClicks[a] = null;
      }
    }, this._initClickEvent = (a, o, l, c) => {
      var u, d;
      const f = new sa();
      this._currentPickResult = null;
      let _ = null, g = a.hasSpecificMask($.POINTERPICK) || o.hasSpecificMask($.POINTERPICK) || a.hasSpecificMask($.POINTERTAP) || o.hasSpecificMask($.POINTERTAP) || a.hasSpecificMask($.POINTERDOUBLETAP) || o.hasSpecificMask($.POINTERDOUBLETAP);
      !g && Wt && (_ = this._initActionManager(_, f), _ && (g = _.hasPickTriggers));
      let m = !1;
      if (g) {
        const y = l.button;
        if (f.hasSwiped = this._isPointerSwiping(), !f.hasSwiped) {
          let x = !et.ExclusiveDoubleClickMode;
          if (x || (x = !a.hasSpecificMask($.POINTERDOUBLETAP) && !o.hasSpecificMask($.POINTERDOUBLETAP), x && !Wt.HasSpecificTrigger(6) && (_ = this._initActionManager(_, f), _ && (x = !_.hasSpecificTrigger(6)))), x)
            (Date.now() - this._previousStartingPointerTime > et.DoubleClickDelay || y !== this._previousButtonPressed) && (f.singleClick = !0, c(f, this._currentPickResult), m = !0);
          else {
            const T = {
              evt: l,
              clickInfo: f,
              timeoutId: window.setTimeout(this._delayedSimpleClick.bind(this, y, f, c), et.DoubleClickDelay)
            };
            this._delayedClicks[y] = T;
          }
          let A = a.hasSpecificMask($.POINTERDOUBLETAP) || o.hasSpecificMask($.POINTERDOUBLETAP);
          !A && Wt.HasSpecificTrigger(6) && (_ = this._initActionManager(_, f), _ && (A = _.hasSpecificTrigger(6))), A && (y === this._previousButtonPressed && Date.now() - this._previousStartingPointerTime < et.DoubleClickDelay && !this._doubleClickOccured ? (!f.hasSwiped && !this._isPointerSwiping() ? (this._previousStartingPointerTime = 0, this._doubleClickOccured = !0, f.doubleClick = !0, f.ignore = !1, et.ExclusiveDoubleClickMode && this._delayedClicks[y] && (clearTimeout((u = this._delayedClicks[y]) === null || u === void 0 ? void 0 : u.timeoutId), this._delayedClicks[y] = null), c(f, this._currentPickResult)) : (this._doubleClickOccured = !1, this._previousStartingPointerTime = this._startingPointerTime, this._previousStartingPointerPosition.x = this._startingPointerPosition.x, this._previousStartingPointerPosition.y = this._startingPointerPosition.y, this._previousButtonPressed = y, et.ExclusiveDoubleClickMode ? (this._delayedClicks[y] && (clearTimeout((d = this._delayedClicks[y]) === null || d === void 0 ? void 0 : d.timeoutId), this._delayedClicks[y] = null), c(f, this._previousPickResult)) : c(f, this._currentPickResult)), m = !0) : (this._doubleClickOccured = !1, this._previousStartingPointerTime = this._startingPointerTime, this._previousStartingPointerPosition.x = this._startingPointerPosition.x, this._previousStartingPointerPosition.y = this._startingPointerPosition.y, this._previousButtonPressed = y));
        }
      }
      m || c(f, this._currentPickResult);
    }, this._onPointerMove = (a) => {
      if (this._updatePointerPosition(a), !this._isSwiping && this._swipeButtonPressed !== -1 && (this._isSwiping = Math.abs(this._startingPointerPosition.x - this._pointerX) > et.DragMovementThreshold || Math.abs(this._startingPointerPosition.y - this._pointerY) > et.DragMovementThreshold), n.isPointerLock && n._verifyPointerLock(), this._checkPrePointerObservable(null, a, a.inputIndex >= ae.MouseWheelX && a.inputIndex <= ae.MouseWheelZ ? $.POINTERWHEEL : $.POINTERMOVE) || !r.cameraToUseForPointers && !r.activeCamera)
        return;
      if (r.skipPointerMovePicking) {
        this._processPointerMove(new Gt(), a);
        return;
      }
      r.pointerMovePredicate || (r.pointerMovePredicate = (l) => l.isPickable && l.isVisible && l.isReady() && l.isEnabled() && (l.enablePointerMoveEvents || r.constantlyUpdateMeshUnderPointer || l._getActionManagerForTrigger() !== null) && (!r.cameraToUseForPointers || (r.cameraToUseForPointers.layerMask & l.layerMask) !== 0));
      const o = r._registeredActions > 0 || r.constantlyUpdateMeshUnderPointer ? this._pickMove(a) : null;
      this._processPointerMove(o, a);
    }, this._onPointerDown = (a) => {
      var o;
      if (this._totalPointersPressed++, this._pickedDownMesh = null, this._meshPickProceed = !1, et.ExclusiveDoubleClickMode) {
        for (let c = 0; c < this._delayedClicks.length; c++)
          if (this._delayedClicks[c])
            if (a.button === c)
              clearTimeout((o = this._delayedClicks[c]) === null || o === void 0 ? void 0 : o.timeoutId);
            else {
              const u = this._delayedClicks[c].clickInfo;
              this._doubleClickOccured = !1, u.singleClick = !0, u.ignore = !1;
              const d = this._delayedClicks[c].evt, f = $.POINTERTAP, _ = new pi(f, d, this._currentPickResult);
              r.onPointerObservable.hasObservers() && r.onPointerObservable.hasSpecificMask(f) && r.onPointerObservable.notifyObservers(_, f), this._delayedClicks[c] = null;
            }
      }
      if (this._updatePointerPosition(a), this._swipeButtonPressed === -1 && (this._swipeButtonPressed = a.button), r.preventDefaultOnPointerDown && s && (a.preventDefault(), s.focus()), this._startingPointerPosition.x = this._pointerX, this._startingPointerPosition.y = this._pointerY, this._startingPointerTime = Date.now(), this._checkPrePointerObservable(null, a, $.POINTERDOWN) || !r.cameraToUseForPointers && !r.activeCamera)
        return;
      this._pointerCaptures[a.pointerId] = !0, r.pointerDownPredicate || (r.pointerDownPredicate = (c) => c.isPickable && c.isVisible && c.isReady() && c.isEnabled() && (!r.cameraToUseForPointers || (r.cameraToUseForPointers.layerMask & c.layerMask) !== 0)), this._pickedDownMesh = null;
      let l;
      r.skipPointerDownPicking || r._registeredActions === 0 && !this._checkForPicking() && !r.onPointerDown ? l = new Gt() : l = r.pick(this._unTranslatedPointerX, this._unTranslatedPointerY, r.pointerDownPredicate, r.pointerDownFastCheck, r.cameraToUseForPointers), this._processPointerDown(l, a);
    }, this._onPointerUp = (a) => {
      this._totalPointersPressed !== 0 && (this._totalPointersPressed--, this._pickedUpMesh = null, this._meshPickProceed = !1, this._updatePointerPosition(a), r.preventDefaultOnPointerUp && s && (a.preventDefault(), s.focus()), this._initClickEvent(r.onPrePointerObservable, r.onPointerObservable, a, (o, l) => {
        if (r.onPrePointerObservable.hasObservers() && (this._skipPointerTap = !1, !o.ignore)) {
          if (this._checkPrePointerObservable(null, a, $.POINTERUP)) {
            this._swipeButtonPressed === a.button && (this._isSwiping = !1, this._swipeButtonPressed = -1), a.buttons === 0 && (this._pointerCaptures[a.pointerId] = !1);
            return;
          }
          o.hasSwiped || (o.singleClick && r.onPrePointerObservable.hasSpecificMask($.POINTERTAP) && this._checkPrePointerObservable(null, a, $.POINTERTAP) && (this._skipPointerTap = !0), o.doubleClick && r.onPrePointerObservable.hasSpecificMask($.POINTERDOUBLETAP) && this._checkPrePointerObservable(null, a, $.POINTERDOUBLETAP) && (this._skipPointerTap = !0));
        }
        if (!this._pointerCaptures[a.pointerId]) {
          this._swipeButtonPressed === a.button && (this._isSwiping = !1, this._swipeButtonPressed = -1);
          return;
        }
        a.buttons === 0 && (this._pointerCaptures[a.pointerId] = !1), !(!r.cameraToUseForPointers && !r.activeCamera) && (r.pointerUpPredicate || (r.pointerUpPredicate = (c) => c.isPickable && c.isVisible && c.isReady() && c.isEnabled() && (!r.cameraToUseForPointers || (r.cameraToUseForPointers.layerMask & c.layerMask) !== 0)), !this._meshPickProceed && (Wt && Wt.HasTriggers || this._checkForPicking() || r.onPointerUp) && this._initActionManager(null, o), l || (l = this._currentPickResult), this._processPointerUp(l, a, o), this._previousPickResult = this._currentPickResult, this._swipeButtonPressed === a.button && (this._isSwiping = !1, this._swipeButtonPressed = -1));
      }));
    }, this._onKeyDown = (a) => {
      const o = ms.KEYDOWN;
      if (r.onPreKeyboardObservable.hasObservers()) {
        const l = new qn(o, a);
        if (r.onPreKeyboardObservable.notifyObservers(l, o), l.skipOnKeyboardObservable)
          return;
      }
      if (r.onKeyboardObservable.hasObservers()) {
        const l = new an(o, a);
        r.onKeyboardObservable.notifyObservers(l, o);
      }
      r.actionManager && r.actionManager.processTrigger(14, He.CreateNewFromScene(r, a));
    }, this._onKeyUp = (a) => {
      const o = ms.KEYUP;
      if (r.onPreKeyboardObservable.hasObservers()) {
        const l = new qn(o, a);
        if (r.onPreKeyboardObservable.notifyObservers(l, o), l.skipOnKeyboardObservable)
          return;
      }
      if (r.onKeyboardObservable.hasObservers()) {
        const l = new an(o, a);
        r.onKeyboardObservable.notifyObservers(l, o);
      }
      r.actionManager && r.actionManager.processTrigger(15, He.CreateNewFromScene(r, a));
    }, this._deviceSourceManager.onDeviceConnectedObservable.add((a) => {
      a.deviceType === j.Mouse ? a.onInputChangedObservable.add((o) => {
        o.inputIndex === ae.LeftClick || o.inputIndex === ae.MiddleClick || o.inputIndex === ae.RightClick || o.inputIndex === ae.BrowserBack || o.inputIndex === ae.BrowserForward ? t && a.getInput(o.inputIndex) === 1 ? this._onPointerDown(o) : e && a.getInput(o.inputIndex) === 0 && this._onPointerUp(o) : i && (o.inputIndex === ae.Move ? this._onPointerMove(o) : (o.inputIndex === ae.MouseWheelX || o.inputIndex === ae.MouseWheelY || o.inputIndex === ae.MouseWheelZ) && this._onPointerMove(o));
      }) : a.deviceType === j.Touch ? a.onInputChangedObservable.add((o) => {
        o.inputIndex === ae.LeftClick && (t && a.getInput(o.inputIndex) === 1 ? (this._onPointerDown(o), this._totalPointersPressed > 1 && (this._isMultiTouchGesture = !0)) : e && a.getInput(o.inputIndex) === 0 && (this._onPointerUp(o), this._totalPointersPressed === 0 && (this._isMultiTouchGesture = !1))), i && o.inputIndex === ae.Move && this._onPointerMove(o);
      }) : a.deviceType === j.Keyboard && a.onInputChangedObservable.add((o) => {
        o.type === "keydown" ? this._onKeyDown(o) : o.type === "keyup" && this._onKeyUp(o);
      });
    }), this._alreadyAttached = !0;
  }
  /**
   * Detaches all event handlers
   */
  detachControl() {
    this._alreadyAttached && (this._deviceSourceManager.dispose(), this._deviceSourceManager = null, this._alreadyAttachedTo && !this._scene.doNotHandleCursors && (this._alreadyAttachedTo.style.cursor = this._scene.defaultCursor), this._alreadyAttached = !1, this._alreadyAttachedTo = null);
  }
  /**
   * Force the value of meshUnderPointer
   * @param mesh - defines the mesh to use
   * @param pointerId - optional pointer id when using more than one pointer. Defaults to 0
   * @param pickResult - optional pickingInfo data used to find mesh
   * @param evt - optional pointer event
   */
  setPointerOverMesh(e, t = 0, i, s) {
    if (this._meshUnderPointerId[t] === e && (!e || !e._internalAbstractMeshDataInfo._pointerOverDisableMeshTesting))
      return;
    const r = this._meshUnderPointerId[t];
    let n;
    r && (n = r._getActionManagerForTrigger(10), n && n.processTrigger(10, He.CreateNew(r, s, { pointerId: t }))), e ? (this._meshUnderPointerId[t] = e, this._pointerOverMesh = e, n = e._getActionManagerForTrigger(9), n && n.processTrigger(9, He.CreateNew(e, s, { pointerId: t, pickResult: i }))) : (delete this._meshUnderPointerId[t], this._pointerOverMesh = null);
  }
  /**
   * Gets the mesh under the pointer
   * @returns a Mesh or null if no mesh is under the pointer
   */
  getPointerOverMesh() {
    return this.meshUnderPointer;
  }
  /**
   * @param mesh - Mesh to invalidate
   * @internal
   */
  _invalidateMesh(e) {
    this._pointerOverMesh === e && (this._pointerOverMesh = null), this._pickedDownMesh === e && (this._pickedDownMesh = null), this._pickedUpMesh === e && (this._pickedUpMesh = null);
    for (const t in this._meshUnderPointerId)
      this._meshUnderPointerId[t] === e && delete this._meshUnderPointerId[t];
  }
}
et.DragMovementThreshold = 10;
et.LongPressDelay = 500;
et.DoubleClickDelay = 300;
et.ExclusiveDoubleClickMode = !1;
class ci {
  /**
   * Returns the smallest value ever
   */
  get min() {
    return this._min;
  }
  /**
   * Returns the biggest value ever
   */
  get max() {
    return this._max;
  }
  /**
   * Returns the average value since the performance counter is running
   */
  get average() {
    return this._average;
  }
  /**
   * Returns the average value of the last second the counter was monitored
   */
  get lastSecAverage() {
    return this._lastSecAverage;
  }
  /**
   * Returns the current value
   */
  get current() {
    return this._current;
  }
  /**
   * Gets the accumulated total
   */
  get total() {
    return this._totalAccumulated;
  }
  /**
   * Gets the total value count
   */
  get count() {
    return this._totalValueCount;
  }
  /**
   * Creates a new counter
   */
  constructor() {
    this._startMonitoringTime = 0, this._min = 0, this._max = 0, this._average = 0, this._lastSecAverage = 0, this._current = 0, this._totalValueCount = 0, this._totalAccumulated = 0, this._lastSecAccumulated = 0, this._lastSecTime = 0, this._lastSecValueCount = 0;
  }
  /**
   * Call this method to start monitoring a new frame.
   * This scenario is typically used when you accumulate monitoring time many times for a single frame, you call this method at the start of the frame, then beginMonitoring to start recording and endMonitoring(false) to accumulated the recorded time to the PerfCounter or addCount() to accumulate a monitored count.
   */
  fetchNewFrame() {
    this._totalValueCount++, this._current = 0, this._lastSecValueCount++;
  }
  /**
   * Call this method to monitor a count of something (e.g. mesh drawn in viewport count)
   * @param newCount the count value to add to the monitored count
   * @param fetchResult true when it's the last time in the frame you add to the counter and you wish to update the statistics properties (min/max/average), false if you only want to update statistics.
   */
  addCount(e, t) {
    ci.Enabled && (this._current += e, t && this._fetchResult());
  }
  /**
   * Start monitoring this performance counter
   */
  beginMonitoring() {
    ci.Enabled && (this._startMonitoringTime = Kt.Now);
  }
  /**
   * Compute the time lapsed since the previous beginMonitoring() call.
   * @param newFrame true by default to fetch the result and monitor a new frame, if false the time monitored will be added to the current frame counter
   */
  endMonitoring(e = !0) {
    if (!ci.Enabled)
      return;
    e && this.fetchNewFrame();
    const t = Kt.Now;
    this._current = t - this._startMonitoringTime, e && this._fetchResult();
  }
  /**
   * Call this method to end the monitoring of a frame.
   * This scenario is typically used when you accumulate monitoring time many times for a single frame, you call this method at the end of the frame, after beginMonitoring to start recording and endMonitoring(false) to accumulated the recorded time to the PerfCounter or addCount() to accumulate a monitored count.
   */
  endFrame() {
    this._fetchResult();
  }
  _fetchResult() {
    this._totalAccumulated += this._current, this._lastSecAccumulated += this._current, this._min = Math.min(this._min, this._current), this._max = Math.max(this._max, this._current), this._average = this._totalAccumulated / this._totalValueCount;
    const e = Kt.Now;
    e - this._lastSecTime > 1e3 && (this._lastSecAverage = this._lastSecAccumulated / this._lastSecValueCount, this._lastSecTime = e, this._lastSecAccumulated = 0, this._lastSecValueCount = 0);
  }
}
ci.Enabled = !0;
class za {
  /**
   * Gets an unique (relatively to the current scene) Id
   */
  static get UniqueId() {
    const e = this._UniqueIdCounter;
    return this._UniqueIdCounter++, e;
  }
}
za._UniqueIdCounter = 1;
class we {
  /**
   * Sort function to order lights for rendering.
   * @param a First Light object to compare to second.
   * @param b Second Light object to compare first.
   * @returns -1 to reduce's a's index relative to be, 0 for no change, 1 to increase a's index relative to b.
   */
  static CompareLightsPriority(e, t) {
    return e.shadowEnabled !== t.shadowEnabled ? (t.shadowEnabled ? 1 : 0) - (e.shadowEnabled ? 1 : 0) : t.renderPriority - e.renderPriority;
  }
}
we.FALLOFF_DEFAULT = 0;
we.FALLOFF_PHYSICAL = 1;
we.FALLOFF_GLTF = 2;
we.FALLOFF_STANDARD = 3;
we.LIGHTMAP_DEFAULT = 0;
we.LIGHTMAP_SPECULAR = 1;
we.LIGHTMAP_SHADOWSONLY = 2;
we.INTENSITYMODE_AUTOMATIC = 0;
we.INTENSITYMODE_LUMINOUSPOWER = 1;
we.INTENSITYMODE_LUMINOUSINTENSITY = 2;
we.INTENSITYMODE_ILLUMINANCE = 3;
we.INTENSITYMODE_LUMINANCE = 4;
we.LIGHTTYPEID_POINTLIGHT = 0;
we.LIGHTTYPEID_DIRECTIONALLIGHT = 1;
we.LIGHTTYPEID_SPOTLIGHT = 2;
we.LIGHTTYPEID_HEMISPHERICLIGHT = 3;
class Cl {
  constructor() {
    this.pointerDownFastCheck = !1, this.pointerUpFastCheck = !1, this.pointerMoveFastCheck = !1, this.skipPointerMovePicking = !1, this.skipPointerDownPicking = !1, this.skipPointerUpPicking = !1;
  }
}
var ui;
(function(h) {
  h[h.BackwardCompatible = 0] = "BackwardCompatible", h[h.Intermediate = 1] = "Intermediate", h[h.Aggressive = 2] = "Aggressive";
})(ui || (ui = {}));
class ge extends Pi {
  /**
   * Factory used to create the default material.
   * @param scene The scene to create the material for
   * @returns The default material
   */
  static DefaultMaterialFactory(e) {
    throw he("StandardMaterial");
  }
  /**
   * Factory used to create the a collision coordinator.
   * @returns The collision coordinator
   */
  static CollisionCoordinatorFactory() {
    throw he("DefaultCollisionCoordinator");
  }
  /**
   * Texture used in all pbr material as the reflection texture.
   * As in the majority of the scene they are the same (exception for multi room and so on),
   * this is easier to reference from here than from all the materials.
   */
  get environmentTexture() {
    return this._environmentTexture;
  }
  /**
   * Texture used in all pbr material as the reflection texture.
   * As in the majority of the scene they are the same (exception for multi room and so on),
   * this is easier to set here than in all the materials.
   */
  set environmentTexture(e) {
    this._environmentTexture !== e && (this._environmentTexture = e, this.markAllMaterialsAsDirty(1));
  }
  /**
   * Default image processing configuration used either in the rendering
   * Forward main pass or through the imageProcessingPostProcess if present.
   * As in the majority of the scene they are the same (exception for multi camera),
   * this is easier to reference from here than from all the materials and post process.
   *
   * No setter as we it is a shared configuration, you can set the values instead.
   */
  get imageProcessingConfiguration() {
    return this._imageProcessingConfiguration;
  }
  /**
   * Gets or sets a value indicating how to treat performance relatively to ease of use and backward compatibility
   */
  get performancePriority() {
    return this._performancePriority;
  }
  set performancePriority(e) {
    if (e !== this._performancePriority) {
      switch (this._performancePriority = e, e) {
        case ui.BackwardCompatible:
          this.skipFrustumClipping = !1, this._renderingManager.maintainStateBetweenFrames = !1, this.skipPointerMovePicking = !1, this.autoClear = !0;
          break;
        case ui.Intermediate:
          this.skipFrustumClipping = !1, this._renderingManager.maintainStateBetweenFrames = !1, this.skipPointerMovePicking = !0, this.autoClear = !1;
          break;
        case ui.Aggressive:
          this.skipFrustumClipping = !0, this._renderingManager.maintainStateBetweenFrames = !0, this.skipPointerMovePicking = !0, this.autoClear = !1;
          break;
      }
      this.onScenePerformancePriorityChangedObservable.notifyObservers(e);
    }
  }
  /**
   * Gets or sets a boolean indicating if all rendering must be done in wireframe
   */
  set forceWireframe(e) {
    this._forceWireframe !== e && (this._forceWireframe = e, this.markAllMaterialsAsDirty(16));
  }
  get forceWireframe() {
    return this._forceWireframe;
  }
  /**
   * Gets or sets a boolean indicating if we should skip the frustum clipping part of the active meshes selection
   */
  set skipFrustumClipping(e) {
    this._skipFrustumClipping !== e && (this._skipFrustumClipping = e);
  }
  get skipFrustumClipping() {
    return this._skipFrustumClipping;
  }
  /**
   * Gets or sets a boolean indicating if all rendering must be done in point cloud
   */
  set forcePointsCloud(e) {
    this._forcePointsCloud !== e && (this._forcePointsCloud = e, this.markAllMaterialsAsDirty(16));
  }
  get forcePointsCloud() {
    return this._forcePointsCloud;
  }
  /**
   * Gets or sets the animation properties override
   */
  get animationPropertiesOverride() {
    return this._animationPropertiesOverride;
  }
  set animationPropertiesOverride(e) {
    this._animationPropertiesOverride = e;
  }
  /** Sets a function to be executed when this scene is disposed. */
  set onDispose(e) {
    this._onDisposeObserver && this.onDisposeObservable.remove(this._onDisposeObserver), this._onDisposeObserver = this.onDisposeObservable.add(e);
  }
  /** Sets a function to be executed before rendering this scene */
  set beforeRender(e) {
    this._onBeforeRenderObserver && this.onBeforeRenderObservable.remove(this._onBeforeRenderObserver), e && (this._onBeforeRenderObserver = this.onBeforeRenderObservable.add(e));
  }
  /** Sets a function to be executed after rendering this scene */
  set afterRender(e) {
    this._onAfterRenderObserver && this.onAfterRenderObservable.remove(this._onAfterRenderObserver), e && (this._onAfterRenderObserver = this.onAfterRenderObservable.add(e));
  }
  /** Sets a function to be executed before rendering a camera*/
  set beforeCameraRender(e) {
    this._onBeforeCameraRenderObserver && this.onBeforeCameraRenderObservable.remove(this._onBeforeCameraRenderObserver), this._onBeforeCameraRenderObserver = this.onBeforeCameraRenderObservable.add(e);
  }
  /** Sets a function to be executed after rendering a camera*/
  set afterCameraRender(e) {
    this._onAfterCameraRenderObserver && this.onAfterCameraRenderObservable.remove(this._onAfterCameraRenderObserver), this._onAfterCameraRenderObserver = this.onAfterCameraRenderObservable.add(e);
  }
  /**
   * Gets or sets a predicate used to select candidate meshes for a pointer down event
   */
  get pointerDownPredicate() {
    return this._pointerPickingConfiguration.pointerDownPredicate;
  }
  set pointerDownPredicate(e) {
    this._pointerPickingConfiguration.pointerDownPredicate = e;
  }
  /**
   * Gets or sets a predicate used to select candidate meshes for a pointer up event
   */
  get pointerUpPredicate() {
    return this._pointerPickingConfiguration.pointerUpPredicate;
  }
  set pointerUpPredicate(e) {
    this._pointerPickingConfiguration.pointerUpPredicate = e;
  }
  /**
   * Gets or sets a predicate used to select candidate meshes for a pointer move event
   */
  get pointerMovePredicate() {
    return this._pointerPickingConfiguration.pointerMovePredicate;
  }
  set pointerMovePredicate(e) {
    this._pointerPickingConfiguration.pointerMovePredicate = e;
  }
  /**
   * Gets or sets a predicate used to select candidate meshes for a pointer down event
   */
  get pointerDownFastCheck() {
    return this._pointerPickingConfiguration.pointerDownFastCheck;
  }
  set pointerDownFastCheck(e) {
    this._pointerPickingConfiguration.pointerDownFastCheck = e;
  }
  /**
   * Gets or sets a predicate used to select candidate meshes for a pointer up event
   */
  get pointerUpFastCheck() {
    return this._pointerPickingConfiguration.pointerUpFastCheck;
  }
  set pointerUpFastCheck(e) {
    this._pointerPickingConfiguration.pointerUpFastCheck = e;
  }
  /**
   * Gets or sets a predicate used to select candidate meshes for a pointer move event
   */
  get pointerMoveFastCheck() {
    return this._pointerPickingConfiguration.pointerMoveFastCheck;
  }
  set pointerMoveFastCheck(e) {
    this._pointerPickingConfiguration.pointerMoveFastCheck = e;
  }
  /**
   * Gets or sets a boolean indicating if the user want to entirely skip the picking phase when a pointer move event occurs.
   */
  get skipPointerMovePicking() {
    return this._pointerPickingConfiguration.skipPointerMovePicking;
  }
  set skipPointerMovePicking(e) {
    this._pointerPickingConfiguration.skipPointerMovePicking = e;
  }
  /**
   * Gets or sets a boolean indicating if the user want to entirely skip the picking phase when a pointer down event occurs.
   */
  get skipPointerDownPicking() {
    return this._pointerPickingConfiguration.skipPointerDownPicking;
  }
  set skipPointerDownPicking(e) {
    this._pointerPickingConfiguration.skipPointerDownPicking = e;
  }
  /**
   * Gets or sets a boolean indicating if the user want to entirely skip the picking phase when a pointer up event occurs.  Off by default.
   */
  get skipPointerUpPicking() {
    return this._pointerPickingConfiguration.skipPointerUpPicking;
  }
  set skipPointerUpPicking(e) {
    this._pointerPickingConfiguration.skipPointerUpPicking = e;
  }
  /**
   * Gets the pointer coordinates without any translation (ie. straight out of the pointer event)
   */
  get unTranslatedPointer() {
    return this._inputManager.unTranslatedPointer;
  }
  /**
   * Gets or sets the distance in pixel that you have to move to prevent some events. Default is 10 pixels
   */
  static get DragMovementThreshold() {
    return et.DragMovementThreshold;
  }
  static set DragMovementThreshold(e) {
    et.DragMovementThreshold = e;
  }
  /**
   * Time in milliseconds to wait to raise long press events if button is still pressed. Default is 500 ms
   */
  static get LongPressDelay() {
    return et.LongPressDelay;
  }
  static set LongPressDelay(e) {
    et.LongPressDelay = e;
  }
  /**
   * Time in milliseconds to wait to raise long press events if button is still pressed. Default is 300 ms
   */
  static get DoubleClickDelay() {
    return et.DoubleClickDelay;
  }
  static set DoubleClickDelay(e) {
    et.DoubleClickDelay = e;
  }
  /** If you need to check double click without raising a single click at first click, enable this flag */
  static get ExclusiveDoubleClickMode() {
    return et.ExclusiveDoubleClickMode;
  }
  static set ExclusiveDoubleClickMode(e) {
    et.ExclusiveDoubleClickMode = e;
  }
  /**
   * Bind the current view position to an effect.
   * @param effect The effect to be bound
   * @param variableName name of the shader variable that will hold the eye position
   * @param isVector3 true to indicates that variableName is a Vector3 and not a Vector4
   * @returns the computed eye position
   */
  bindEyePosition(e, t = "vEyePosition", i = !1) {
    var s;
    const r = this._forcedViewPosition ? this._forcedViewPosition : this._mirroredCameraPosition ? this._mirroredCameraPosition : (s = this.activeCamera.globalPosition) !== null && s !== void 0 ? s : this.activeCamera.devicePosition, n = this.useRightHandedSystem === (this._mirroredCameraPosition != null);
    return C.Vector4[0].set(r.x, r.y, r.z, n ? -1 : 1), e && (i ? e.setFloat3(t, C.Vector4[0].x, C.Vector4[0].y, C.Vector4[0].z) : e.setVector4(t, C.Vector4[0])), C.Vector4[0];
  }
  /**
   * Update the scene ubo before it can be used in rendering processing
   * @returns the scene UniformBuffer
   */
  finalizeSceneUbo() {
    const e = this.getSceneUniformBuffer(), t = this.bindEyePosition(null);
    return e.updateFloat4("vEyePosition", t.x, t.y, t.z, t.w), e.update(), e;
  }
  /**
   * Gets or sets a boolean indicating if the scene must use right-handed coordinates system
   */
  set useRightHandedSystem(e) {
    this._useRightHandedSystem !== e && (this._useRightHandedSystem = e, this.markAllMaterialsAsDirty(16));
  }
  get useRightHandedSystem() {
    return this._useRightHandedSystem;
  }
  /**
   * Sets the step Id used by deterministic lock step
   * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
   * @param newStepId defines the step Id
   */
  setStepId(e) {
    this._currentStepId = e;
  }
  /**
   * Gets the step Id used by deterministic lock step
   * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
   * @returns the step Id
   */
  getStepId() {
    return this._currentStepId;
  }
  /**
   * Gets the internal step used by deterministic lock step
   * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
   * @returns the internal step
   */
  getInternalStep() {
    return this._currentInternalStep;
  }
  /**
   * Gets or sets a boolean indicating if fog is enabled on this scene
   * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/environment_introduction#fog
   * (Default is true)
   */
  set fogEnabled(e) {
    this._fogEnabled !== e && (this._fogEnabled = e, this.markAllMaterialsAsDirty(16));
  }
  get fogEnabled() {
    return this._fogEnabled;
  }
  /**
   * Gets or sets the fog mode to use
   * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/environment_introduction#fog
   * | mode | value |
   * | --- | --- |
   * | FOGMODE_NONE | 0 |
   * | FOGMODE_EXP | 1 |
   * | FOGMODE_EXP2 | 2 |
   * | FOGMODE_LINEAR | 3 |
   */
  set fogMode(e) {
    this._fogMode !== e && (this._fogMode = e, this.markAllMaterialsAsDirty(16));
  }
  get fogMode() {
    return this._fogMode;
  }
  /**
   * Flag indicating that the frame buffer binding is handled by another component
   */
  get prePass() {
    return !!this.prePassRenderer && this.prePassRenderer.defaultRT.enabled;
  }
  /**
   * Gets or sets a boolean indicating if shadows are enabled on this scene
   */
  set shadowsEnabled(e) {
    this._shadowsEnabled !== e && (this._shadowsEnabled = e, this.markAllMaterialsAsDirty(2));
  }
  get shadowsEnabled() {
    return this._shadowsEnabled;
  }
  /**
   * Gets or sets a boolean indicating if lights are enabled on this scene
   */
  set lightsEnabled(e) {
    this._lightsEnabled !== e && (this._lightsEnabled = e, this.markAllMaterialsAsDirty(2));
  }
  get lightsEnabled() {
    return this._lightsEnabled;
  }
  /** All of the active cameras added to this scene. */
  get activeCameras() {
    return this._activeCameras;
  }
  set activeCameras(e) {
    this._unObserveActiveCameras && (this._unObserveActiveCameras(), this._unObserveActiveCameras = null), e && (this._unObserveActiveCameras = Ra(e, () => {
      this.onActiveCamerasChanged.notifyObservers(this);
    })), this._activeCameras = e;
  }
  /** Gets or sets the current active camera */
  get activeCamera() {
    return this._activeCamera;
  }
  set activeCamera(e) {
    e !== this._activeCamera && (this._activeCamera = e, this.onActiveCameraChanged.notifyObservers(this));
  }
  /** The default material used on meshes when no material is affected */
  get defaultMaterial() {
    return this._defaultMaterial || (this._defaultMaterial = ge.DefaultMaterialFactory(this)), this._defaultMaterial;
  }
  /** The default material used on meshes when no material is affected */
  set defaultMaterial(e) {
    this._defaultMaterial = e;
  }
  /**
   * Gets or sets a boolean indicating if textures are enabled on this scene
   */
  set texturesEnabled(e) {
    this._texturesEnabled !== e && (this._texturesEnabled = e, this.markAllMaterialsAsDirty(1));
  }
  get texturesEnabled() {
    return this._texturesEnabled;
  }
  /**
   * Gets or sets a boolean indicating if skeletons are enabled on this scene
   */
  set skeletonsEnabled(e) {
    this._skeletonsEnabled !== e && (this._skeletonsEnabled = e, this.markAllMaterialsAsDirty(8));
  }
  get skeletonsEnabled() {
    return this._skeletonsEnabled;
  }
  /** @internal */
  get collisionCoordinator() {
    return this._collisionCoordinator || (this._collisionCoordinator = ge.CollisionCoordinatorFactory(), this._collisionCoordinator.init(this)), this._collisionCoordinator;
  }
  /**
   * Gets the scene's rendering manager
   */
  get renderingManager() {
    return this._renderingManager;
  }
  /**
   * Gets the list of frustum planes (built from the active camera)
   */
  get frustumPlanes() {
    return this._frustumPlanes;
  }
  /**
   * Registers the transient components if needed.
   */
  _registerTransientComponents() {
    if (this._transientComponents.length > 0) {
      for (const e of this._transientComponents)
        e.register();
      this._transientComponents.length = 0;
    }
  }
  /**
   * @internal
   * Add a component to the scene.
   * Note that the ccomponent could be registered on th next frame if this is called after
   * the register component stage.
   * @param component Defines the component to add to the scene
   */
  _addComponent(e) {
    this._components.push(e), this._transientComponents.push(e);
    const t = e;
    t.addFromContainer && t.serialize && this._serializableComponents.push(t);
  }
  /**
   * @internal
   * Gets a component from the scene.
   * @param name defines the name of the component to retrieve
   * @returns the component or null if not present
   */
  _getComponent(e) {
    for (const t of this._components)
      if (t.name === e)
        return t;
    return null;
  }
  /**
   * Creates a new Scene
   * @param engine defines the engine to use to render this scene
   * @param options defines the scene options
   */
  constructor(e, t) {
    super(), this._inputManager = new et(this), this.cameraToUseForPointers = null, this._isScene = !0, this._blockEntityCollection = !1, this.autoClear = !0, this.autoClearDepthAndStencil = !0, this.clearColor = new ye(0.2, 0.2, 0.3, 1), this.ambientColor = new ie(0, 0, 0), this.environmentIntensity = 1, this._performancePriority = ui.BackwardCompatible, this.onScenePerformancePriorityChangedObservable = new N(), this._forceWireframe = !1, this._skipFrustumClipping = !1, this._forcePointsCloud = !1, this.animationsEnabled = !0, this._animationPropertiesOverride = null, this.useConstantAnimationDeltaTime = !1, this.constantlyUpdateMeshUnderPointer = !1, this.hoverCursor = "pointer", this.defaultCursor = "", this.doNotHandleCursors = !1, this.preventDefaultOnPointerDown = !0, this.preventDefaultOnPointerUp = !0, this.metadata = null, this.reservedDataStore = null, this.disableOfflineSupportExceptionRules = new Array(), this.onDisposeObservable = new N(), this._onDisposeObserver = null, this.onBeforeRenderObservable = new N(), this._onBeforeRenderObserver = null, this.onAfterRenderObservable = new N(), this.onAfterRenderCameraObservable = new N(), this._onAfterRenderObserver = null, this.onBeforeAnimationsObservable = new N(), this.onAfterAnimationsObservable = new N(), this.onBeforeDrawPhaseObservable = new N(), this.onAfterDrawPhaseObservable = new N(), this.onReadyObservable = new N(), this.onBeforeCameraRenderObservable = new N(), this._onBeforeCameraRenderObserver = null, this.onAfterCameraRenderObservable = new N(), this._onAfterCameraRenderObserver = null, this.onBeforeActiveMeshesEvaluationObservable = new N(), this.onAfterActiveMeshesEvaluationObservable = new N(), this.onBeforeParticlesRenderingObservable = new N(), this.onAfterParticlesRenderingObservable = new N(), this.onDataLoadedObservable = new N(), this.onNewCameraAddedObservable = new N(), this.onCameraRemovedObservable = new N(), this.onNewLightAddedObservable = new N(), this.onLightRemovedObservable = new N(), this.onNewGeometryAddedObservable = new N(), this.onGeometryRemovedObservable = new N(), this.onNewTransformNodeAddedObservable = new N(), this.onTransformNodeRemovedObservable = new N(), this.onNewMeshAddedObservable = new N(), this.onMeshRemovedObservable = new N(), this.onNewSkeletonAddedObservable = new N(), this.onSkeletonRemovedObservable = new N(), this.onNewMaterialAddedObservable = new N(), this.onNewMultiMaterialAddedObservable = new N(), this.onMaterialRemovedObservable = new N(), this.onMultiMaterialRemovedObservable = new N(), this.onNewTextureAddedObservable = new N(), this.onTextureRemovedObservable = new N(), this.onBeforeRenderTargetsRenderObservable = new N(), this.onAfterRenderTargetsRenderObservable = new N(), this.onBeforeStepObservable = new N(), this.onAfterStepObservable = new N(), this.onActiveCameraChanged = new N(), this.onActiveCamerasChanged = new N(), this.onBeforeRenderingGroupObservable = new N(), this.onAfterRenderingGroupObservable = new N(), this.onMeshImportedObservable = new N(), this.onAnimationFileImportedObservable = new N(), this._registeredForLateAnimationBindings = new Wi(256), this._pointerPickingConfiguration = new Cl(), this.onPrePointerObservable = new N(), this.onPointerObservable = new N(), this.onPreKeyboardObservable = new N(), this.onKeyboardObservable = new N(), this._useRightHandedSystem = !1, this._timeAccumulator = 0, this._currentStepId = 0, this._currentInternalStep = 0, this._fogEnabled = !0, this._fogMode = ge.FOGMODE_NONE, this.fogColor = new ie(0.2, 0.2, 0.3), this.fogDensity = 0.1, this.fogStart = 0, this.fogEnd = 1e3, this.needsPreviousWorldMatrices = !1, this._shadowsEnabled = !0, this._lightsEnabled = !0, this._unObserveActiveCameras = null, this._texturesEnabled = !0, this.physicsEnabled = !0, this.particlesEnabled = !0, this.spritesEnabled = !0, this._skeletonsEnabled = !0, this.lensFlaresEnabled = !0, this.collisionsEnabled = !0, this.gravity = new p(0, -9.807, 0), this.postProcessesEnabled = !0, this.renderTargetsEnabled = !0, this.dumpNextRenderTargets = !1, this.customRenderTargets = new Array(), this.importedMeshesFiles = new Array(), this.probesEnabled = !0, this._meshesForIntersections = new Wi(256), this.proceduralTexturesEnabled = !0, this._totalVertices = new ci(), this._activeIndices = new ci(), this._activeParticles = new ci(), this._activeBones = new ci(), this._animationTime = 0, this.animationTimeScale = 1, this._renderId = 0, this._frameId = 0, this._executeWhenReadyTimeoutId = null, this._intermediateRendering = !1, this._defaultFrameBufferCleared = !1, this._viewUpdateFlag = -1, this._projectionUpdateFlag = -1, this._toBeDisposed = new Array(256), this._activeRequests = new Array(), this._pendingData = new Array(), this._isDisposed = !1, this.dispatchAllSubMeshesOfActiveMeshes = !1, this._activeMeshes = new At(256), this._processedMaterials = new At(256), this._renderTargets = new Wi(256), this._materialsRenderTargets = new Wi(256), this._activeParticleSystems = new At(256), this._activeSkeletons = new Wi(32), this._softwareSkinnedMeshes = new Wi(32), this._activeAnimatables = new Array(), this._transformMatrix = I.Zero(), this.requireLightSorting = !1, this._components = [], this._serializableComponents = [], this._transientComponents = [], this._beforeCameraUpdateStage = Je.Create(), this._beforeClearStage = Je.Create(), this._beforeRenderTargetClearStage = Je.Create(), this._gatherRenderTargetsStage = Je.Create(), this._gatherActiveCameraRenderTargetsStage = Je.Create(), this._isReadyForMeshStage = Je.Create(), this._beforeEvaluateActiveMeshStage = Je.Create(), this._evaluateSubMeshStage = Je.Create(), this._preActiveMeshStage = Je.Create(), this._cameraDrawRenderTargetStage = Je.Create(), this._beforeCameraDrawStage = Je.Create(), this._beforeRenderTargetDrawStage = Je.Create(), this._beforeRenderingGroupDrawStage = Je.Create(), this._beforeRenderingMeshStage = Je.Create(), this._afterRenderingMeshStage = Je.Create(), this._afterRenderingGroupDrawStage = Je.Create(), this._afterCameraDrawStage = Je.Create(), this._afterCameraPostProcessStage = Je.Create(), this._afterRenderTargetDrawStage = Je.Create(), this._afterRenderTargetPostProcessStage = Je.Create(), this._afterRenderStage = Je.Create(), this._pointerMoveStage = Je.Create(), this._pointerDownStage = Je.Create(), this._pointerUpStage = Je.Create(), this._geometriesByUniqueId = null, this._defaultMeshCandidates = {
      data: [],
      length: 0
    }, this._defaultSubMeshCandidates = {
      data: [],
      length: 0
    }, this._preventFreeActiveMeshesAndRenderingGroups = !1, this._activeMeshesFrozen = !1, this._activeMeshesFrozenButKeepClipping = !1, this._skipEvaluateActiveMeshesCompletely = !1, this._allowPostProcessClearColor = !0, this.getDeterministicFrameTime = () => this._engine.getTimeStep(), this._registeredActions = 0, this._blockMaterialDirtyMechanism = !1, this._perfCollector = null, this.activeCameras = new Array();
    const i = Object.assign({ useGeometryUniqueIdsMap: !0, useMaterialMeshMap: !0, useClonedMeshMap: !0, virtual: !1 }, t);
    this._engine = e || de.LastCreatedEngine, i.virtual ? this._engine._virtualScenes.push(this) : (de._LastCreatedScene = this, this._engine.scenes.push(this)), this._uid = null, this._renderingManager = new bt(this), nn && (this.postProcessManager = new nn(this)), _t() && this.attachControl(), this._createUbo(), De && (this._imageProcessingConfiguration = new De()), this.setDefaultCandidateProviders(), i.useGeometryUniqueIdsMap && (this._geometriesByUniqueId = {}), this.useMaterialMeshMap = i.useMaterialMeshMap, this.useClonedMeshMap = i.useClonedMeshMap, (!t || !t.virtual) && this._engine.onNewSceneAddedObservable.notifyObservers(this);
  }
  /**
   * Gets a string identifying the name of the class
   * @returns "Scene" string
   */
  getClassName() {
    return "Scene";
  }
  /**
   * @internal
   */
  _getDefaultMeshCandidates() {
    return this._defaultMeshCandidates.data = this.meshes, this._defaultMeshCandidates.length = this.meshes.length, this._defaultMeshCandidates;
  }
  /**
   * @internal
   */
  _getDefaultSubMeshCandidates(e) {
    return this._defaultSubMeshCandidates.data = e.subMeshes, this._defaultSubMeshCandidates.length = e.subMeshes.length, this._defaultSubMeshCandidates;
  }
  /**
   * Sets the default candidate providers for the scene.
   * This sets the getActiveMeshCandidates, getActiveSubMeshCandidates, getIntersectingSubMeshCandidates
   * and getCollidingSubMeshCandidates to their default function
   */
  setDefaultCandidateProviders() {
    this.getActiveMeshCandidates = this._getDefaultMeshCandidates.bind(this), this.getActiveSubMeshCandidates = this._getDefaultSubMeshCandidates.bind(this), this.getIntersectingSubMeshCandidates = this._getDefaultSubMeshCandidates.bind(this), this.getCollidingSubMeshCandidates = this._getDefaultSubMeshCandidates.bind(this);
  }
  /**
   * Gets the mesh that is currently under the pointer
   */
  get meshUnderPointer() {
    return this._inputManager.meshUnderPointer;
  }
  /**
   * Gets or sets the current on-screen X position of the pointer
   */
  get pointerX() {
    return this._inputManager.pointerX;
  }
  set pointerX(e) {
    this._inputManager.pointerX = e;
  }
  /**
   * Gets or sets the current on-screen Y position of the pointer
   */
  get pointerY() {
    return this._inputManager.pointerY;
  }
  set pointerY(e) {
    this._inputManager.pointerY = e;
  }
  /**
   * Gets the cached material (ie. the latest rendered one)
   * @returns the cached material
   */
  getCachedMaterial() {
    return this._cachedMaterial;
  }
  /**
   * Gets the cached effect (ie. the latest rendered one)
   * @returns the cached effect
   */
  getCachedEffect() {
    return this._cachedEffect;
  }
  /**
   * Gets the cached visibility state (ie. the latest rendered one)
   * @returns the cached visibility state
   */
  getCachedVisibility() {
    return this._cachedVisibility;
  }
  /**
   * Gets a boolean indicating if the current material / effect / visibility must be bind again
   * @param material defines the current material
   * @param effect defines the current effect
   * @param visibility defines the current visibility state
   * @returns true if one parameter is not cached
   */
  isCachedMaterialInvalid(e, t, i = 1) {
    return this._cachedEffect !== t || this._cachedMaterial !== e || this._cachedVisibility !== i;
  }
  /**
   * Gets the engine associated with the scene
   * @returns an Engine
   */
  getEngine() {
    return this._engine;
  }
  /**
   * Gets the total number of vertices rendered per frame
   * @returns the total number of vertices rendered per frame
   */
  getTotalVertices() {
    return this._totalVertices.current;
  }
  /**
   * Gets the performance counter for total vertices
   * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimize_your_scene#instrumentation
   */
  get totalVerticesPerfCounter() {
    return this._totalVertices;
  }
  /**
   * Gets the total number of active indices rendered per frame (You can deduce the number of rendered triangles by dividing this number by 3)
   * @returns the total number of active indices rendered per frame
   */
  getActiveIndices() {
    return this._activeIndices.current;
  }
  /**
   * Gets the performance counter for active indices
   * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimize_your_scene#instrumentation
   */
  get totalActiveIndicesPerfCounter() {
    return this._activeIndices;
  }
  /**
   * Gets the total number of active particles rendered per frame
   * @returns the total number of active particles rendered per frame
   */
  getActiveParticles() {
    return this._activeParticles.current;
  }
  /**
   * Gets the performance counter for active particles
   * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimize_your_scene#instrumentation
   */
  get activeParticlesPerfCounter() {
    return this._activeParticles;
  }
  /**
   * Gets the total number of active bones rendered per frame
   * @returns the total number of active bones rendered per frame
   */
  getActiveBones() {
    return this._activeBones.current;
  }
  /**
   * Gets the performance counter for active bones
   * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimize_your_scene#instrumentation
   */
  get activeBonesPerfCounter() {
    return this._activeBones;
  }
  /**
   * Gets the array of active meshes
   * @returns an array of AbstractMesh
   */
  getActiveMeshes() {
    return this._activeMeshes;
  }
  /**
   * Gets the animation ratio (which is 1.0 is the scene renders at 60fps and 2 if the scene renders at 30fps, etc.)
   * @returns a number
   */
  getAnimationRatio() {
    return this._animationRatio !== void 0 ? this._animationRatio : 1;
  }
  /**
   * Gets an unique Id for the current render phase
   * @returns a number
   */
  getRenderId() {
    return this._renderId;
  }
  /**
   * Gets an unique Id for the current frame
   * @returns a number
   */
  getFrameId() {
    return this._frameId;
  }
  /** Call this function if you want to manually increment the render Id*/
  incrementRenderId() {
    this._renderId++;
  }
  _createUbo() {
    this.setSceneUniformBuffer(this.createSceneUniformBuffer());
  }
  /**
   * Use this method to simulate a pointer move on a mesh
   * The pickResult parameter can be obtained from a scene.pick or scene.pickWithRay
   * @param pickResult pickingInfo of the object wished to simulate pointer event on
   * @param pointerEventInit pointer event state to be used when simulating the pointer event (eg. pointer id for multitouch)
   * @returns the current scene
   */
  simulatePointerMove(e, t) {
    return this._inputManager.simulatePointerMove(e, t), this;
  }
  /**
   * Use this method to simulate a pointer down on a mesh
   * The pickResult parameter can be obtained from a scene.pick or scene.pickWithRay
   * @param pickResult pickingInfo of the object wished to simulate pointer event on
   * @param pointerEventInit pointer event state to be used when simulating the pointer event (eg. pointer id for multitouch)
   * @returns the current scene
   */
  simulatePointerDown(e, t) {
    return this._inputManager.simulatePointerDown(e, t), this;
  }
  /**
   * Use this method to simulate a pointer up on a mesh
   * The pickResult parameter can be obtained from a scene.pick or scene.pickWithRay
   * @param pickResult pickingInfo of the object wished to simulate pointer event on
   * @param pointerEventInit pointer event state to be used when simulating the pointer event (eg. pointer id for multitouch)
   * @param doubleTap indicates that the pointer up event should be considered as part of a double click (false by default)
   * @returns the current scene
   */
  simulatePointerUp(e, t, i) {
    return this._inputManager.simulatePointerUp(e, t, i), this;
  }
  /**
   * Gets a boolean indicating if the current pointer event is captured (meaning that the scene has already handled the pointer down)
   * @param pointerId defines the pointer id to use in a multi-touch scenario (0 by default)
   * @returns true if the pointer was captured
   */
  isPointerCaptured(e = 0) {
    return this._inputManager.isPointerCaptured(e);
  }
  /**
   * Attach events to the canvas (To handle actionManagers triggers and raise onPointerMove, onPointerDown and onPointerUp
   * @param attachUp defines if you want to attach events to pointerup
   * @param attachDown defines if you want to attach events to pointerdown
   * @param attachMove defines if you want to attach events to pointermove
   */
  attachControl(e = !0, t = !0, i = !0) {
    this._inputManager.attachControl(e, t, i);
  }
  /** Detaches all event handlers*/
  detachControl() {
    this._inputManager.detachControl();
  }
  /**
   * This function will check if the scene can be rendered (textures are loaded, shaders are compiled)
   * Delay loaded resources are not taking in account
   * @param checkRenderTargets true to also check that the meshes rendered as part of a render target are ready (default: true)
   * @returns true if all required resources are ready
   */
  isReady(e = !0) {
    var t, i, s;
    if (this._isDisposed)
      return !1;
    let r;
    const n = this.getEngine(), a = n.currentRenderPassId;
    n.currentRenderPassId = (i = (t = this.activeCamera) === null || t === void 0 ? void 0 : t.renderPassId) !== null && i !== void 0 ? i : a;
    let o = !0;
    for (this._pendingData.length > 0 && (o = !1), (s = this.prePassRenderer) === null || s === void 0 || s.update(), e && (this._processedMaterials.reset(), this._materialsRenderTargets.reset()), r = 0; r < this.meshes.length; r++) {
      const l = this.meshes[r];
      if (!l.subMeshes || l.subMeshes.length === 0)
        continue;
      if (!l.isReady(!0)) {
        o = !1;
        continue;
      }
      const c = l.hasThinInstances || l.getClassName() === "InstancedMesh" || l.getClassName() === "InstancedLinesMesh" || n.getCaps().instancedArrays && l.instances.length > 0;
      for (const d of this._isReadyForMeshStage)
        d.action(l, c) || (o = !1);
      if (!e)
        continue;
      const u = l.material || this.defaultMaterial;
      if (u)
        if (u._storeEffectOnSubMeshes)
          for (const d of l.subMeshes) {
            const f = d.getMaterial();
            f && f.hasRenderTargetTextures && f.getRenderTargetTextures != null && this._processedMaterials.indexOf(f) === -1 && (this._processedMaterials.push(f), this._materialsRenderTargets.concatWithNoDuplicate(f.getRenderTargetTextures()));
          }
        else
          u.hasRenderTargetTextures && u.getRenderTargetTextures != null && this._processedMaterials.indexOf(u) === -1 && (this._processedMaterials.push(u), this._materialsRenderTargets.concatWithNoDuplicate(u.getRenderTargetTextures()));
    }
    if (e)
      for (r = 0; r < this._materialsRenderTargets.length; ++r)
        this._materialsRenderTargets.data[r].isReadyForRendering() || (o = !1);
    for (r = 0; r < this.geometries.length; r++)
      this.geometries[r].delayLoadState === 2 && (o = !1);
    if (this.activeCameras && this.activeCameras.length > 0)
      for (const l of this.activeCameras)
        l.isReady(!0) || (o = !1);
    else this.activeCamera && (this.activeCamera.isReady(!0) || (o = !1));
    for (const l of this.particleSystems)
      l.isReady() || (o = !1);
    if (this.layers)
      for (const l of this.layers)
        l.isReady() || (o = !1);
    return n.areAllEffectsReady() || (o = !1), n.currentRenderPassId = a, o;
  }
  /** Resets all cached information relative to material (including effect and visibility) */
  resetCachedMaterial() {
    this._cachedMaterial = null, this._cachedEffect = null, this._cachedVisibility = null;
  }
  /**
   * Registers a function to be called before every frame render
   * @param func defines the function to register
   */
  registerBeforeRender(e) {
    this.onBeforeRenderObservable.add(e);
  }
  /**
   * Unregisters a function called before every frame render
   * @param func defines the function to unregister
   */
  unregisterBeforeRender(e) {
    this.onBeforeRenderObservable.removeCallback(e);
  }
  /**
   * Registers a function to be called after every frame render
   * @param func defines the function to register
   */
  registerAfterRender(e) {
    this.onAfterRenderObservable.add(e);
  }
  /**
   * Unregisters a function called after every frame render
   * @param func defines the function to unregister
   */
  unregisterAfterRender(e) {
    this.onAfterRenderObservable.removeCallback(e);
  }
  _executeOnceBeforeRender(e) {
    const t = () => {
      e(), setTimeout(() => {
        this.unregisterBeforeRender(t);
      });
    };
    this.registerBeforeRender(t);
  }
  /**
   * The provided function will run before render once and will be disposed afterwards.
   * A timeout delay can be provided so that the function will be executed in N ms.
   * The timeout is using the browser's native setTimeout so time percision cannot be guaranteed.
   * @param func The function to be executed.
   * @param timeout optional delay in ms
   */
  executeOnceBeforeRender(e, t) {
    t !== void 0 ? setTimeout(() => {
      this._executeOnceBeforeRender(e);
    }, t) : this._executeOnceBeforeRender(e);
  }
  /**
   * This function can help adding any object to the list of data awaited to be ready in order to check for a complete scene loading.
   * @param data defines the object to wait for
   */
  addPendingData(e) {
    this._pendingData.push(e);
  }
  /**
   * Remove a pending data from the loading list which has previously been added with addPendingData.
   * @param data defines the object to remove from the pending list
   */
  removePendingData(e) {
    const t = this.isLoading, i = this._pendingData.indexOf(e);
    i !== -1 && this._pendingData.splice(i, 1), t && !this.isLoading && this.onDataLoadedObservable.notifyObservers(this);
  }
  /**
   * Returns the number of items waiting to be loaded
   * @returns the number of items waiting to be loaded
   */
  getWaitingItemsCount() {
    return this._pendingData.length;
  }
  /**
   * Returns a boolean indicating if the scene is still loading data
   */
  get isLoading() {
    return this._pendingData.length > 0;
  }
  /**
   * Registers a function to be executed when the scene is ready
   * @param func - the function to be executed
   * @param checkRenderTargets true to also check that the meshes rendered as part of a render target are ready (default: false)
   */
  executeWhenReady(e, t = !1) {
    this.onReadyObservable.addOnce(e), this._executeWhenReadyTimeoutId === null && this._checkIsReady(t);
  }
  /**
   * Returns a promise that resolves when the scene is ready
   * @param checkRenderTargets true to also check that the meshes rendered as part of a render target are ready (default: false)
   * @returns A promise that resolves when the scene is ready
   */
  whenReadyAsync(e = !1) {
    return new Promise((t) => {
      this.executeWhenReady(() => {
        t();
      }, e);
    });
  }
  /**
   * @internal
   */
  _checkIsReady(e = !1) {
    if (this._registerTransientComponents(), this.isReady(e)) {
      this.onReadyObservable.notifyObservers(this), this.onReadyObservable.clear(), this._executeWhenReadyTimeoutId = null;
      return;
    }
    if (this._isDisposed) {
      this.onReadyObservable.clear(), this._executeWhenReadyTimeoutId = null;
      return;
    }
    this._executeWhenReadyTimeoutId = setTimeout(() => {
      this.incrementRenderId(), this._checkIsReady(e);
    }, 100);
  }
  /**
   * Gets all animatable attached to the scene
   */
  get animatables() {
    return this._activeAnimatables;
  }
  /**
   * Resets the last animation time frame.
   * Useful to override when animations start running when loading a scene for the first time.
   */
  resetLastAnimationTimeFrame() {
    this._animationTimeLast = Kt.Now;
  }
  // Matrix
  /**
   * Gets the current view matrix
   * @returns a Matrix
   */
  getViewMatrix() {
    return this._viewMatrix;
  }
  /**
   * Gets the current projection matrix
   * @returns a Matrix
   */
  getProjectionMatrix() {
    return this._projectionMatrix;
  }
  /**
   * Gets the current transform matrix
   * @returns a Matrix made of View * Projection
   */
  getTransformMatrix() {
    return this._transformMatrix;
  }
  /**
   * Sets the current transform matrix
   * @param viewL defines the View matrix to use
   * @param projectionL defines the Projection matrix to use
   * @param viewR defines the right View matrix to use (if provided)
   * @param projectionR defines the right Projection matrix to use (if provided)
   */
  setTransformMatrix(e, t, i, s) {
    !i && !s && this._multiviewSceneUbo && (this._multiviewSceneUbo.dispose(), this._multiviewSceneUbo = null), !(this._viewUpdateFlag === e.updateFlag && this._projectionUpdateFlag === t.updateFlag) && (this._viewUpdateFlag = e.updateFlag, this._projectionUpdateFlag = t.updateFlag, this._viewMatrix = e, this._projectionMatrix = t, this._viewMatrix.multiplyToRef(this._projectionMatrix, this._transformMatrix), this._frustumPlanes ? jt.GetPlanesToRef(this._transformMatrix, this._frustumPlanes) : this._frustumPlanes = jt.GetPlanes(this._transformMatrix), this._multiviewSceneUbo && this._multiviewSceneUbo.useUbo ? this._updateMultiviewUbo(i, s) : this._sceneUbo.useUbo && (this._sceneUbo.updateMatrix("viewProjection", this._transformMatrix), this._sceneUbo.updateMatrix("view", this._viewMatrix), this._sceneUbo.updateMatrix("projection", this._projectionMatrix)));
  }
  /**
   * Gets the uniform buffer used to store scene data
   * @returns a UniformBuffer
   */
  getSceneUniformBuffer() {
    return this._multiviewSceneUbo ? this._multiviewSceneUbo : this._sceneUbo;
  }
  /**
   * Creates a scene UBO
   * @param name name of the uniform buffer (optional, for debugging purpose only)
   * @returns a new ubo
   */
  createSceneUniformBuffer(e) {
    const t = new H(this._engine, void 0, !1, e ?? "scene");
    return t.addUniform("viewProjection", 16), t.addUniform("view", 16), t.addUniform("projection", 16), t.addUniform("vEyePosition", 4), t;
  }
  /**
   * Sets the scene ubo
   * @param ubo the ubo to set for the scene
   */
  setSceneUniformBuffer(e) {
    this._sceneUbo = e, this._viewUpdateFlag = -1, this._projectionUpdateFlag = -1;
  }
  /**
   * Gets an unique (relatively to the current scene) Id
   * @returns an unique number for the scene
   */
  getUniqueId() {
    return za.UniqueId;
  }
  /**
   * Add a mesh to the list of scene's meshes
   * @param newMesh defines the mesh to add
   * @param recursive if all child meshes should also be added to the scene
   */
  addMesh(e, t = !1) {
    this._blockEntityCollection || (this.meshes.push(e), e._resyncLightSources(), e.parent || e._addToSceneRootNodes(), this.onNewMeshAddedObservable.notifyObservers(e), t && e.getChildMeshes().forEach((i) => {
      this.addMesh(i);
    }));
  }
  /**
   * Remove a mesh for the list of scene's meshes
   * @param toRemove defines the mesh to remove
   * @param recursive if all child meshes should also be removed from the scene
   * @returns the index where the mesh was in the mesh list
   */
  removeMesh(e, t = !1) {
    const i = this.meshes.indexOf(e);
    return i !== -1 && (this.meshes[i] = this.meshes[this.meshes.length - 1], this.meshes.pop(), e.parent || e._removeFromSceneRootNodes()), this._inputManager._invalidateMesh(e), this.onMeshRemovedObservable.notifyObservers(e), t && e.getChildMeshes().forEach((s) => {
      this.removeMesh(s);
    }), i;
  }
  /**
   * Add a transform node to the list of scene's transform nodes
   * @param newTransformNode defines the transform node to add
   */
  addTransformNode(e) {
    this._blockEntityCollection || e.getScene() === this && e._indexInSceneTransformNodesArray !== -1 || (e._indexInSceneTransformNodesArray = this.transformNodes.length, this.transformNodes.push(e), e.parent || e._addToSceneRootNodes(), this.onNewTransformNodeAddedObservable.notifyObservers(e));
  }
  /**
   * Remove a transform node for the list of scene's transform nodes
   * @param toRemove defines the transform node to remove
   * @returns the index where the transform node was in the transform node list
   */
  removeTransformNode(e) {
    const t = e._indexInSceneTransformNodesArray;
    if (t !== -1) {
      if (t !== this.transformNodes.length - 1) {
        const i = this.transformNodes[this.transformNodes.length - 1];
        this.transformNodes[t] = i, i._indexInSceneTransformNodesArray = t;
      }
      e._indexInSceneTransformNodesArray = -1, this.transformNodes.pop(), e.parent || e._removeFromSceneRootNodes();
    }
    return this.onTransformNodeRemovedObservable.notifyObservers(e), t;
  }
  /**
   * Remove a skeleton for the list of scene's skeletons
   * @param toRemove defines the skeleton to remove
   * @returns the index where the skeleton was in the skeleton list
   */
  removeSkeleton(e) {
    const t = this.skeletons.indexOf(e);
    return t !== -1 && (this.skeletons.splice(t, 1), this.onSkeletonRemovedObservable.notifyObservers(e), this._executeActiveContainerCleanup(this._activeSkeletons)), t;
  }
  /**
   * Remove a morph target for the list of scene's morph targets
   * @param toRemove defines the morph target to remove
   * @returns the index where the morph target was in the morph target list
   */
  removeMorphTargetManager(e) {
    const t = this.morphTargetManagers.indexOf(e);
    return t !== -1 && this.morphTargetManagers.splice(t, 1), t;
  }
  /**
   * Remove a light for the list of scene's lights
   * @param toRemove defines the light to remove
   * @returns the index where the light was in the light list
   */
  removeLight(e) {
    const t = this.lights.indexOf(e);
    if (t !== -1) {
      for (const i of this.meshes)
        i._removeLightSource(e, !1);
      this.lights.splice(t, 1), this.sortLightsByPriority(), e.parent || e._removeFromSceneRootNodes();
    }
    return this.onLightRemovedObservable.notifyObservers(e), t;
  }
  /**
   * Remove a camera for the list of scene's cameras
   * @param toRemove defines the camera to remove
   * @returns the index where the camera was in the camera list
   */
  removeCamera(e) {
    const t = this.cameras.indexOf(e);
    if (t !== -1 && (this.cameras.splice(t, 1), e.parent || e._removeFromSceneRootNodes()), this.activeCameras) {
      const i = this.activeCameras.indexOf(e);
      i !== -1 && this.activeCameras.splice(i, 1);
    }
    return this.activeCamera === e && (this.cameras.length > 0 ? this.activeCamera = this.cameras[0] : this.activeCamera = null), this.onCameraRemovedObservable.notifyObservers(e), t;
  }
  /**
   * Remove a particle system for the list of scene's particle systems
   * @param toRemove defines the particle system to remove
   * @returns the index where the particle system was in the particle system list
   */
  removeParticleSystem(e) {
    const t = this.particleSystems.indexOf(e);
    return t !== -1 && (this.particleSystems.splice(t, 1), this._executeActiveContainerCleanup(this._activeParticleSystems)), t;
  }
  /**
   * Remove a animation for the list of scene's animations
   * @param toRemove defines the animation to remove
   * @returns the index where the animation was in the animation list
   */
  removeAnimation(e) {
    const t = this.animations.indexOf(e);
    return t !== -1 && this.animations.splice(t, 1), t;
  }
  /**
   * Will stop the animation of the given target
   * @param target - the target
   * @param animationName - the name of the animation to stop (all animations will be stopped if both this and targetMask are empty)
   * @param targetMask - a function that determines if the animation should be stopped based on its target (all animations will be stopped if both this and animationName are empty)
   */
  stopAnimation(e, t, i) {
  }
  /**
   * Removes the given animation group from this scene.
   * @param toRemove The animation group to remove
   * @returns The index of the removed animation group
   */
  removeAnimationGroup(e) {
    const t = this.animationGroups.indexOf(e);
    return t !== -1 && this.animationGroups.splice(t, 1), t;
  }
  /**
   * Removes the given multi-material from this scene.
   * @param toRemove The multi-material to remove
   * @returns The index of the removed multi-material
   */
  removeMultiMaterial(e) {
    const t = this.multiMaterials.indexOf(e);
    return t !== -1 && this.multiMaterials.splice(t, 1), this.onMultiMaterialRemovedObservable.notifyObservers(e), t;
  }
  /**
   * Removes the given material from this scene.
   * @param toRemove The material to remove
   * @returns The index of the removed material
   */
  removeMaterial(e) {
    const t = e._indexInSceneMaterialArray;
    if (t !== -1 && t < this.materials.length) {
      if (t !== this.materials.length - 1) {
        const i = this.materials[this.materials.length - 1];
        this.materials[t] = i, i._indexInSceneMaterialArray = t;
      }
      e._indexInSceneMaterialArray = -1, this.materials.pop();
    }
    return this.onMaterialRemovedObservable.notifyObservers(e), t;
  }
  /**
   * Removes the given action manager from this scene.
   * @deprecated
   * @param toRemove The action manager to remove
   * @returns The index of the removed action manager
   */
  removeActionManager(e) {
    const t = this.actionManagers.indexOf(e);
    return t !== -1 && this.actionManagers.splice(t, 1), t;
  }
  /**
   * Removes the given texture from this scene.
   * @param toRemove The texture to remove
   * @returns The index of the removed texture
   */
  removeTexture(e) {
    const t = this.textures.indexOf(e);
    return t !== -1 && this.textures.splice(t, 1), this.onTextureRemovedObservable.notifyObservers(e), t;
  }
  /**
   * Adds the given light to this scene
   * @param newLight The light to add
   */
  addLight(e) {
    if (!this._blockEntityCollection) {
      this.lights.push(e), this.sortLightsByPriority(), e.parent || e._addToSceneRootNodes();
      for (const t of this.meshes)
        t.lightSources.indexOf(e) === -1 && (t.lightSources.push(e), t._resyncLightSources());
      this.onNewLightAddedObservable.notifyObservers(e);
    }
  }
  /**
   * Sorts the list list based on light priorities
   */
  sortLightsByPriority() {
    this.requireLightSorting && this.lights.sort(we.CompareLightsPriority);
  }
  /**
   * Adds the given camera to this scene
   * @param newCamera The camera to add
   */
  addCamera(e) {
    this._blockEntityCollection || (this.cameras.push(e), this.onNewCameraAddedObservable.notifyObservers(e), e.parent || e._addToSceneRootNodes());
  }
  /**
   * Adds the given skeleton to this scene
   * @param newSkeleton The skeleton to add
   */
  addSkeleton(e) {
    this._blockEntityCollection || (this.skeletons.push(e), this.onNewSkeletonAddedObservable.notifyObservers(e));
  }
  /**
   * Adds the given particle system to this scene
   * @param newParticleSystem The particle system to add
   */
  addParticleSystem(e) {
    this._blockEntityCollection || this.particleSystems.push(e);
  }
  /**
   * Adds the given animation to this scene
   * @param newAnimation The animation to add
   */
  addAnimation(e) {
    this._blockEntityCollection || this.animations.push(e);
  }
  /**
   * Adds the given animation group to this scene.
   * @param newAnimationGroup The animation group to add
   */
  addAnimationGroup(e) {
    this._blockEntityCollection || this.animationGroups.push(e);
  }
  /**
   * Adds the given multi-material to this scene
   * @param newMultiMaterial The multi-material to add
   */
  addMultiMaterial(e) {
    this._blockEntityCollection || (this.multiMaterials.push(e), this.onNewMultiMaterialAddedObservable.notifyObservers(e));
  }
  /**
   * Adds the given material to this scene
   * @param newMaterial The material to add
   */
  addMaterial(e) {
    this._blockEntityCollection || e.getScene() === this && e._indexInSceneMaterialArray !== -1 || (e._indexInSceneMaterialArray = this.materials.length, this.materials.push(e), this.onNewMaterialAddedObservable.notifyObservers(e));
  }
  /**
   * Adds the given morph target to this scene
   * @param newMorphTargetManager The morph target to add
   */
  addMorphTargetManager(e) {
    this._blockEntityCollection || this.morphTargetManagers.push(e);
  }
  /**
   * Adds the given geometry to this scene
   * @param newGeometry The geometry to add
   */
  addGeometry(e) {
    this._blockEntityCollection || (this._geometriesByUniqueId && (this._geometriesByUniqueId[e.uniqueId] = this.geometries.length), this.geometries.push(e));
  }
  /**
   * Adds the given action manager to this scene
   * @deprecated
   * @param newActionManager The action manager to add
   */
  addActionManager(e) {
    this.actionManagers.push(e);
  }
  /**
   * Adds the given texture to this scene.
   * @param newTexture The texture to add
   */
  addTexture(e) {
    this._blockEntityCollection || (this.textures.push(e), this.onNewTextureAddedObservable.notifyObservers(e));
  }
  /**
   * Switch active camera
   * @param newCamera defines the new active camera
   * @param attachControl defines if attachControl must be called for the new active camera (default: true)
   */
  switchActiveCamera(e, t = !0) {
    this._engine.getInputElement() && (this.activeCamera && this.activeCamera.detachControl(), this.activeCamera = e, t && e.attachControl());
  }
  /**
   * sets the active camera of the scene using its Id
   * @param id defines the camera's Id
   * @returns the new active camera or null if none found.
   */
  setActiveCameraById(e) {
    const t = this.getCameraById(e);
    return t ? (this.activeCamera = t, t) : null;
  }
  /**
   * sets the active camera of the scene using its name
   * @param name defines the camera's name
   * @returns the new active camera or null if none found.
   */
  setActiveCameraByName(e) {
    const t = this.getCameraByName(e);
    return t ? (this.activeCamera = t, t) : null;
  }
  /**
   * get an animation group using its name
   * @param name defines the material's name
   * @returns the animation group or null if none found.
   */
  getAnimationGroupByName(e) {
    for (let t = 0; t < this.animationGroups.length; t++)
      if (this.animationGroups[t].name === e)
        return this.animationGroups[t];
    return null;
  }
  _getMaterial(e, t) {
    for (let i = 0; i < this.materials.length; i++) {
      const s = this.materials[i];
      if (t(s))
        return s;
    }
    if (e)
      for (let i = 0; i < this.multiMaterials.length; i++) {
        const s = this.multiMaterials[i];
        if (t(s))
          return s;
      }
    return null;
  }
  /**
   * Get a material using its unique id
   * @param uniqueId defines the material's unique id
   * @param allowMultiMaterials determines whether multimaterials should be considered
   * @returns the material or null if none found.
   */
  getMaterialByUniqueID(e, t = !1) {
    return this._getMaterial(t, (i) => i.uniqueId === e);
  }
  /**
   * get a material using its id
   * @param id defines the material's Id
   * @param allowMultiMaterials determines whether multimaterials should be considered
   * @returns the material or null if none found.
   */
  getMaterialById(e, t = !1) {
    return this._getMaterial(t, (i) => i.id === e);
  }
  /**
   * Gets a material using its name
   * @param name defines the material's name
   * @param allowMultiMaterials determines whether multimaterials should be considered
   * @returns the material or null if none found.
   */
  getMaterialByName(e, t = !1) {
    return this._getMaterial(t, (i) => i.name === e);
  }
  /**
   * Gets a last added material using a given id
   * @param id defines the material's id
   * @param allowMultiMaterials determines whether multimaterials should be considered
   * @returns the last material with the given id or null if none found.
   */
  getLastMaterialById(e, t = !1) {
    for (let i = this.materials.length - 1; i >= 0; i--)
      if (this.materials[i].id === e)
        return this.materials[i];
    if (t) {
      for (let i = this.multiMaterials.length - 1; i >= 0; i--)
        if (this.multiMaterials[i].id === e)
          return this.multiMaterials[i];
    }
    return null;
  }
  /**
   * Get a texture using its unique id
   * @param uniqueId defines the texture's unique id
   * @returns the texture or null if none found.
   */
  getTextureByUniqueId(e) {
    for (let t = 0; t < this.textures.length; t++)
      if (this.textures[t].uniqueId === e)
        return this.textures[t];
    return null;
  }
  /**
   * Gets a texture using its name
   * @param name defines the texture's name
   * @returns the texture or null if none found.
   */
  getTextureByName(e) {
    for (let t = 0; t < this.textures.length; t++)
      if (this.textures[t].name === e)
        return this.textures[t];
    return null;
  }
  /**
   * Gets a camera using its Id
   * @param id defines the Id to look for
   * @returns the camera or null if not found
   */
  getCameraById(e) {
    for (let t = 0; t < this.cameras.length; t++)
      if (this.cameras[t].id === e)
        return this.cameras[t];
    return null;
  }
  /**
   * Gets a camera using its unique Id
   * @param uniqueId defines the unique Id to look for
   * @returns the camera or null if not found
   */
  getCameraByUniqueId(e) {
    for (let t = 0; t < this.cameras.length; t++)
      if (this.cameras[t].uniqueId === e)
        return this.cameras[t];
    return null;
  }
  /**
   * Gets a camera using its name
   * @param name defines the camera's name
   * @returns the camera or null if none found.
   */
  getCameraByName(e) {
    for (let t = 0; t < this.cameras.length; t++)
      if (this.cameras[t].name === e)
        return this.cameras[t];
    return null;
  }
  /**
   * Gets a bone using its Id
   * @param id defines the bone's Id
   * @returns the bone or null if not found
   */
  getBoneById(e) {
    for (let t = 0; t < this.skeletons.length; t++) {
      const i = this.skeletons[t];
      for (let s = 0; s < i.bones.length; s++)
        if (i.bones[s].id === e)
          return i.bones[s];
    }
    return null;
  }
  /**
   * Gets a bone using its id
   * @param name defines the bone's name
   * @returns the bone or null if not found
   */
  getBoneByName(e) {
    for (let t = 0; t < this.skeletons.length; t++) {
      const i = this.skeletons[t];
      for (let s = 0; s < i.bones.length; s++)
        if (i.bones[s].name === e)
          return i.bones[s];
    }
    return null;
  }
  /**
   * Gets a light node using its name
   * @param name defines the the light's name
   * @returns the light or null if none found.
   */
  getLightByName(e) {
    for (let t = 0; t < this.lights.length; t++)
      if (this.lights[t].name === e)
        return this.lights[t];
    return null;
  }
  /**
   * Gets a light node using its Id
   * @param id defines the light's Id
   * @returns the light or null if none found.
   */
  getLightById(e) {
    for (let t = 0; t < this.lights.length; t++)
      if (this.lights[t].id === e)
        return this.lights[t];
    return null;
  }
  /**
   * Gets a light node using its scene-generated unique Id
   * @param uniqueId defines the light's unique Id
   * @returns the light or null if none found.
   */
  getLightByUniqueId(e) {
    for (let t = 0; t < this.lights.length; t++)
      if (this.lights[t].uniqueId === e)
        return this.lights[t];
    return null;
  }
  /**
   * Gets a particle system by Id
   * @param id defines the particle system Id
   * @returns the corresponding system or null if none found
   */
  getParticleSystemById(e) {
    for (let t = 0; t < this.particleSystems.length; t++)
      if (this.particleSystems[t].id === e)
        return this.particleSystems[t];
    return null;
  }
  /**
   * Gets a geometry using its Id
   * @param id defines the geometry's Id
   * @returns the geometry or null if none found.
   */
  getGeometryById(e) {
    for (let t = 0; t < this.geometries.length; t++)
      if (this.geometries[t].id === e)
        return this.geometries[t];
    return null;
  }
  _getGeometryByUniqueId(e) {
    if (this._geometriesByUniqueId) {
      const t = this._geometriesByUniqueId[e];
      if (t !== void 0)
        return this.geometries[t];
    } else
      for (let t = 0; t < this.geometries.length; t++)
        if (this.geometries[t].uniqueId === e)
          return this.geometries[t];
    return null;
  }
  /**
   * Add a new geometry to this scene
   * @param geometry defines the geometry to be added to the scene.
   * @param force defines if the geometry must be pushed even if a geometry with this id already exists
   * @returns a boolean defining if the geometry was added or not
   */
  pushGeometry(e, t) {
    return !t && this._getGeometryByUniqueId(e.uniqueId) ? !1 : (this.addGeometry(e), this.onNewGeometryAddedObservable.notifyObservers(e), !0);
  }
  /**
   * Removes an existing geometry
   * @param geometry defines the geometry to be removed from the scene
   * @returns a boolean defining if the geometry was removed or not
   */
  removeGeometry(e) {
    let t;
    if (this._geometriesByUniqueId) {
      if (t = this._geometriesByUniqueId[e.uniqueId], t === void 0)
        return !1;
    } else if (t = this.geometries.indexOf(e), t < 0)
      return !1;
    if (t !== this.geometries.length - 1) {
      const i = this.geometries[this.geometries.length - 1];
      i && (this.geometries[t] = i, this._geometriesByUniqueId && (this._geometriesByUniqueId[i.uniqueId] = t));
    }
    return this._geometriesByUniqueId && (this._geometriesByUniqueId[e.uniqueId] = void 0), this.geometries.pop(), this.onGeometryRemovedObservable.notifyObservers(e), !0;
  }
  /**
   * Gets the list of geometries attached to the scene
   * @returns an array of Geometry
   */
  getGeometries() {
    return this.geometries;
  }
  /**
   * Gets the first added mesh found of a given Id
   * @param id defines the Id to search for
   * @returns the mesh found or null if not found at all
   */
  getMeshById(e) {
    for (let t = 0; t < this.meshes.length; t++)
      if (this.meshes[t].id === e)
        return this.meshes[t];
    return null;
  }
  /**
   * Gets a list of meshes using their Id
   * @param id defines the Id to search for
   * @returns a list of meshes
   */
  getMeshesById(e) {
    return this.meshes.filter(function(t) {
      return t.id === e;
    });
  }
  /**
   * Gets the first added transform node found of a given Id
   * @param id defines the Id to search for
   * @returns the found transform node or null if not found at all.
   */
  getTransformNodeById(e) {
    for (let t = 0; t < this.transformNodes.length; t++)
      if (this.transformNodes[t].id === e)
        return this.transformNodes[t];
    return null;
  }
  /**
   * Gets a transform node with its auto-generated unique Id
   * @param uniqueId defines the unique Id to search for
   * @returns the found transform node or null if not found at all.
   */
  getTransformNodeByUniqueId(e) {
    for (let t = 0; t < this.transformNodes.length; t++)
      if (this.transformNodes[t].uniqueId === e)
        return this.transformNodes[t];
    return null;
  }
  /**
   * Gets a list of transform nodes using their Id
   * @param id defines the Id to search for
   * @returns a list of transform nodes
   */
  getTransformNodesById(e) {
    return this.transformNodes.filter(function(t) {
      return t.id === e;
    });
  }
  /**
   * Gets a mesh with its auto-generated unique Id
   * @param uniqueId defines the unique Id to search for
   * @returns the found mesh or null if not found at all.
   */
  getMeshByUniqueId(e) {
    for (let t = 0; t < this.meshes.length; t++)
      if (this.meshes[t].uniqueId === e)
        return this.meshes[t];
    return null;
  }
  /**
   * Gets a the last added mesh using a given Id
   * @param id defines the Id to search for
   * @returns the found mesh or null if not found at all.
   */
  getLastMeshById(e) {
    for (let t = this.meshes.length - 1; t >= 0; t--)
      if (this.meshes[t].id === e)
        return this.meshes[t];
    return null;
  }
  /**
   * Gets a the last transform node using a given Id
   * @param id defines the Id to search for
   * @returns the found mesh or null if not found at all.
   */
  getLastTransformNodeById(e) {
    for (let t = this.transformNodes.length - 1; t >= 0; t--)
      if (this.transformNodes[t].id === e)
        return this.transformNodes[t];
    return null;
  }
  /**
   * Gets a the last added node (Mesh, Camera, Light) using a given Id
   * @param id defines the Id to search for
   * @returns the found node or null if not found at all
   */
  getLastEntryById(e) {
    let t;
    for (t = this.meshes.length - 1; t >= 0; t--)
      if (this.meshes[t].id === e)
        return this.meshes[t];
    for (t = this.transformNodes.length - 1; t >= 0; t--)
      if (this.transformNodes[t].id === e)
        return this.transformNodes[t];
    for (t = this.cameras.length - 1; t >= 0; t--)
      if (this.cameras[t].id === e)
        return this.cameras[t];
    for (t = this.lights.length - 1; t >= 0; t--)
      if (this.lights[t].id === e)
        return this.lights[t];
    return null;
  }
  /**
   * Gets a node (Mesh, Camera, Light) using a given Id
   * @param id defines the Id to search for
   * @returns the found node or null if not found at all
   */
  getNodeById(e) {
    const t = this.getMeshById(e);
    if (t)
      return t;
    const i = this.getTransformNodeById(e);
    if (i)
      return i;
    const s = this.getLightById(e);
    if (s)
      return s;
    const r = this.getCameraById(e);
    if (r)
      return r;
    const n = this.getBoneById(e);
    return n || null;
  }
  /**
   * Gets a node (Mesh, Camera, Light) using a given name
   * @param name defines the name to search for
   * @returns the found node or null if not found at all.
   */
  getNodeByName(e) {
    const t = this.getMeshByName(e);
    if (t)
      return t;
    const i = this.getTransformNodeByName(e);
    if (i)
      return i;
    const s = this.getLightByName(e);
    if (s)
      return s;
    const r = this.getCameraByName(e);
    if (r)
      return r;
    const n = this.getBoneByName(e);
    return n || null;
  }
  /**
   * Gets a mesh using a given name
   * @param name defines the name to search for
   * @returns the found mesh or null if not found at all.
   */
  getMeshByName(e) {
    for (let t = 0; t < this.meshes.length; t++)
      if (this.meshes[t].name === e)
        return this.meshes[t];
    return null;
  }
  /**
   * Gets a transform node using a given name
   * @param name defines the name to search for
   * @returns the found transform node or null if not found at all.
   */
  getTransformNodeByName(e) {
    for (let t = 0; t < this.transformNodes.length; t++)
      if (this.transformNodes[t].name === e)
        return this.transformNodes[t];
    return null;
  }
  /**
   * Gets a skeleton using a given Id (if many are found, this function will pick the last one)
   * @param id defines the Id to search for
   * @returns the found skeleton or null if not found at all.
   */
  getLastSkeletonById(e) {
    for (let t = this.skeletons.length - 1; t >= 0; t--)
      if (this.skeletons[t].id === e)
        return this.skeletons[t];
    return null;
  }
  /**
   * Gets a skeleton using a given auto generated unique id
   * @param  uniqueId defines the unique id to search for
   * @returns the found skeleton or null if not found at all.
   */
  getSkeletonByUniqueId(e) {
    for (let t = 0; t < this.skeletons.length; t++)
      if (this.skeletons[t].uniqueId === e)
        return this.skeletons[t];
    return null;
  }
  /**
   * Gets a skeleton using a given id (if many are found, this function will pick the first one)
   * @param id defines the id to search for
   * @returns the found skeleton or null if not found at all.
   */
  getSkeletonById(e) {
    for (let t = 0; t < this.skeletons.length; t++)
      if (this.skeletons[t].id === e)
        return this.skeletons[t];
    return null;
  }
  /**
   * Gets a skeleton using a given name
   * @param name defines the name to search for
   * @returns the found skeleton or null if not found at all.
   */
  getSkeletonByName(e) {
    for (let t = 0; t < this.skeletons.length; t++)
      if (this.skeletons[t].name === e)
        return this.skeletons[t];
    return null;
  }
  /**
   * Gets a morph target manager  using a given id (if many are found, this function will pick the last one)
   * @param id defines the id to search for
   * @returns the found morph target manager or null if not found at all.
   */
  getMorphTargetManagerById(e) {
    for (let t = 0; t < this.morphTargetManagers.length; t++)
      if (this.morphTargetManagers[t].uniqueId === e)
        return this.morphTargetManagers[t];
    return null;
  }
  /**
   * Gets a morph target using a given id (if many are found, this function will pick the first one)
   * @param id defines the id to search for
   * @returns the found morph target or null if not found at all.
   */
  getMorphTargetById(e) {
    for (let t = 0; t < this.morphTargetManagers.length; ++t) {
      const i = this.morphTargetManagers[t];
      for (let s = 0; s < i.numTargets; ++s) {
        const r = i.getTarget(s);
        if (r.id === e)
          return r;
      }
    }
    return null;
  }
  /**
   * Gets a morph target using a given name (if many are found, this function will pick the first one)
   * @param name defines the name to search for
   * @returns the found morph target or null if not found at all.
   */
  getMorphTargetByName(e) {
    for (let t = 0; t < this.morphTargetManagers.length; ++t) {
      const i = this.morphTargetManagers[t];
      for (let s = 0; s < i.numTargets; ++s) {
        const r = i.getTarget(s);
        if (r.name === e)
          return r;
      }
    }
    return null;
  }
  /**
   * Gets a post process using a given name (if many are found, this function will pick the first one)
   * @param name defines the name to search for
   * @returns the found post process or null if not found at all.
   */
  getPostProcessByName(e) {
    for (let t = 0; t < this.postProcesses.length; ++t) {
      const i = this.postProcesses[t];
      if (i.name === e)
        return i;
    }
    return null;
  }
  /**
   * Gets a boolean indicating if the given mesh is active
   * @param mesh defines the mesh to look for
   * @returns true if the mesh is in the active list
   */
  isActiveMesh(e) {
    return this._activeMeshes.indexOf(e) !== -1;
  }
  /**
   * Return a unique id as a string which can serve as an identifier for the scene
   */
  get uid() {
    return this._uid || (this._uid = z.RandomId()), this._uid;
  }
  /**
   * Add an externally attached data from its key.
   * This method call will fail and return false, if such key already exists.
   * If you don't care and just want to get the data no matter what, use the more convenient getOrAddExternalDataWithFactory() method.
   * @param key the unique key that identifies the data
   * @param data the data object to associate to the key for this Engine instance
   * @returns true if no such key were already present and the data was added successfully, false otherwise
   */
  addExternalData(e, t) {
    return this._externalData || (this._externalData = new Yn()), this._externalData.add(e, t);
  }
  /**
   * Get an externally attached data from its key
   * @param key the unique key that identifies the data
   * @returns the associated data, if present (can be null), or undefined if not present
   */
  getExternalData(e) {
    return this._externalData ? this._externalData.get(e) : null;
  }
  /**
   * Get an externally attached data from its key, create it using a factory if it's not already present
   * @param key the unique key that identifies the data
   * @param factory the factory that will be called to create the instance if and only if it doesn't exists
   * @returns the associated data, can be null if the factory returned null.
   */
  getOrAddExternalDataWithFactory(e, t) {
    return this._externalData || (this._externalData = new Yn()), this._externalData.getOrAddWithFactory(e, t);
  }
  /**
   * Remove an externally attached data from the Engine instance
   * @param key the unique key that identifies the data
   * @returns true if the data was successfully removed, false if it doesn't exist
   */
  removeExternalData(e) {
    return this._externalData.remove(e);
  }
  _evaluateSubMesh(e, t, i, s) {
    if (s || e.isInFrustum(this._frustumPlanes)) {
      for (const n of this._evaluateSubMeshStage)
        n.action(t, e);
      const r = e.getMaterial();
      r != null && (r.hasRenderTargetTextures && r.getRenderTargetTextures != null && this._processedMaterials.indexOf(r) === -1 && (this._processedMaterials.push(r), this._materialsRenderTargets.concatWithNoDuplicate(r.getRenderTargetTextures())), this._renderingManager.dispatch(e, t, r));
    }
  }
  /**
   * Clear the processed materials smart array preventing retention point in material dispose.
   */
  freeProcessedMaterials() {
    this._processedMaterials.dispose();
  }
  /** Gets or sets a boolean blocking all the calls to freeActiveMeshes and freeRenderingGroups
   * It can be used in order to prevent going through methods freeRenderingGroups and freeActiveMeshes several times to improve performance
   * when disposing several meshes in a row or a hierarchy of meshes.
   * When used, it is the responsibility of the user to blockfreeActiveMeshesAndRenderingGroups back to false.
   */
  get blockfreeActiveMeshesAndRenderingGroups() {
    return this._preventFreeActiveMeshesAndRenderingGroups;
  }
  set blockfreeActiveMeshesAndRenderingGroups(e) {
    this._preventFreeActiveMeshesAndRenderingGroups !== e && (e && (this.freeActiveMeshes(), this.freeRenderingGroups()), this._preventFreeActiveMeshesAndRenderingGroups = e);
  }
  /**
   * Clear the active meshes smart array preventing retention point in mesh dispose.
   */
  freeActiveMeshes() {
    if (!this.blockfreeActiveMeshesAndRenderingGroups && (this._activeMeshes.dispose(), this.activeCamera && this.activeCamera._activeMeshes && this.activeCamera._activeMeshes.dispose(), this.activeCameras))
      for (let e = 0; e < this.activeCameras.length; e++) {
        const t = this.activeCameras[e];
        t && t._activeMeshes && t._activeMeshes.dispose();
      }
  }
  /**
   * Clear the info related to rendering groups preventing retention points during dispose.
   */
  freeRenderingGroups() {
    if (!this.blockfreeActiveMeshesAndRenderingGroups && (this._renderingManager && this._renderingManager.freeRenderingGroups(), this.textures))
      for (let e = 0; e < this.textures.length; e++) {
        const t = this.textures[e];
        t && t.renderList && t.freeRenderingGroups();
      }
  }
  /** @internal */
  _isInIntermediateRendering() {
    return this._intermediateRendering;
  }
  /**
   * Use this function to stop evaluating active meshes. The current list will be keep alive between frames
   * @param skipEvaluateActiveMeshes defines an optional boolean indicating that the evaluate active meshes step must be completely skipped
   * @param onSuccess optional success callback
   * @param onError optional error callback
   * @param freezeMeshes defines if meshes should be frozen (true by default)
   * @param keepFrustumCulling defines if you want to keep running the frustum clipping (false by default)
   * @returns the current scene
   */
  freezeActiveMeshes(e = !1, t, i, s = !0, r = !1) {
    return this.executeWhenReady(() => {
      if (!this.activeCamera) {
        i && i("No active camera found");
        return;
      }
      if (this._frustumPlanes || this.updateTransformMatrix(), this._evaluateActiveMeshes(), this._activeMeshesFrozen = !0, this._activeMeshesFrozenButKeepClipping = r, this._skipEvaluateActiveMeshesCompletely = e, s)
        for (let n = 0; n < this._activeMeshes.length; n++)
          this._activeMeshes.data[n]._freeze();
      t && t();
    }), this;
  }
  /**
   * Use this function to restart evaluating active meshes on every frame
   * @returns the current scene
   */
  unfreezeActiveMeshes() {
    for (let e = 0; e < this.meshes.length; e++) {
      const t = this.meshes[e];
      t._internalAbstractMeshDataInfo && (t._internalAbstractMeshDataInfo._isActive = !1);
    }
    for (let e = 0; e < this._activeMeshes.length; e++)
      this._activeMeshes.data[e]._unFreeze();
    return this._activeMeshesFrozen = !1, this;
  }
  _executeActiveContainerCleanup(e) {
    !(this._engine.snapshotRendering && this._engine.snapshotRenderingMode === 1) && this._activeMeshesFrozen && this._activeMeshes.length || this.onBeforeRenderObservable.addOnce(() => e.dispose());
  }
  _evaluateActiveMeshes() {
    var e;
    if (this._engine.snapshotRendering && this._engine.snapshotRenderingMode === 1) {
      this._activeMeshes.length > 0 && ((e = this.activeCamera) === null || e === void 0 || e._activeMeshes.reset(), this._activeMeshes.reset(), this._renderingManager.reset(), this._processedMaterials.reset(), this._activeParticleSystems.reset(), this._activeSkeletons.reset(), this._softwareSkinnedMeshes.reset());
      return;
    }
    if (this._activeMeshesFrozen && this._activeMeshes.length) {
      if (!this._skipEvaluateActiveMeshesCompletely) {
        const s = this._activeMeshes.length;
        for (let r = 0; r < s; r++)
          this._activeMeshes.data[r].computeWorldMatrix();
      }
      if (this._activeParticleSystems) {
        const s = this._activeParticleSystems.length;
        for (let r = 0; r < s; r++)
          this._activeParticleSystems.data[r].animate();
      }
      this._renderingManager.resetSprites();
      return;
    }
    if (!this.activeCamera)
      return;
    this.onBeforeActiveMeshesEvaluationObservable.notifyObservers(this), this.activeCamera._activeMeshes.reset(), this._activeMeshes.reset(), this._renderingManager.reset(), this._processedMaterials.reset(), this._activeParticleSystems.reset(), this._activeSkeletons.reset(), this._softwareSkinnedMeshes.reset(), this._materialsRenderTargets.reset();
    for (const s of this._beforeEvaluateActiveMeshStage)
      s.action();
    const t = this.getActiveMeshCandidates(), i = t.length;
    for (let s = 0; s < i; s++) {
      const r = t.data[s];
      if (r._internalAbstractMeshDataInfo._currentLODIsUpToDate = !1, r.isBlocked || (this._totalVertices.addCount(r.getTotalVertices(), !1), !r.isReady() || !r.isEnabled() || r.scaling.hasAZeroComponent))
        continue;
      r.computeWorldMatrix(), r.actionManager && r.actionManager.hasSpecificTriggers2(12, 13) && this._meshesForIntersections.pushNoDuplicate(r);
      let n = this.customLODSelector ? this.customLODSelector(r, this.activeCamera) : r.getLOD(this.activeCamera);
      if (r._internalAbstractMeshDataInfo._currentLOD = n, r._internalAbstractMeshDataInfo._currentLODIsUpToDate = !0, n != null && (n !== r && n.billboardMode !== 0 && n.computeWorldMatrix(), r._preActivate(), r.isVisible && r.visibility > 0 && r.layerMask & this.activeCamera.layerMask && (this._skipFrustumClipping || r.alwaysSelectAsActiveMesh || r.isInFrustum(this._frustumPlanes)))) {
        this._activeMeshes.push(r), this.activeCamera._activeMeshes.push(r), n !== r && n._activate(this._renderId, !1);
        for (const a of this._preActiveMeshStage)
          a.action(r);
        r._activate(this._renderId, !1) && (r.isAnInstance ? r._internalAbstractMeshDataInfo._actAsRegularMesh && (n = r) : n._internalAbstractMeshDataInfo._onlyForInstances = !1, n._internalAbstractMeshDataInfo._isActive = !0, this._activeMesh(r, n)), r._postActivate();
      }
    }
    if (this.onAfterActiveMeshesEvaluationObservable.notifyObservers(this), this.particlesEnabled) {
      this.onBeforeParticlesRenderingObservable.notifyObservers(this);
      for (let s = 0; s < this.particleSystems.length; s++) {
        const r = this.particleSystems[s];
        if (!r.isStarted() || !r.emitter)
          continue;
        const n = r.emitter;
        (!n.position || n.isEnabled()) && (this._activeParticleSystems.push(r), r.animate(), this._renderingManager.dispatchParticles(r));
      }
      this.onAfterParticlesRenderingObservable.notifyObservers(this);
    }
  }
  _activeMesh(e, t) {
    this._skeletonsEnabled && t.skeleton !== null && t.skeleton !== void 0 && (this._activeSkeletons.pushNoDuplicate(t.skeleton) && (t.skeleton.prepare(), this._activeBones.addCount(t.skeleton.bones.length, !1)), t.computeBonesUsingShaders || this._softwareSkinnedMeshes.pushNoDuplicate(t));
    let i = e.hasInstances || e.isAnInstance || this.dispatchAllSubMeshesOfActiveMeshes || this._skipFrustumClipping || t.alwaysSelectAsActiveMesh;
    if (t && t.subMeshes && t.subMeshes.length > 0) {
      const s = this.getActiveSubMeshCandidates(t), r = s.length;
      i = i || r === 1;
      for (let n = 0; n < r; n++) {
        const a = s.data[n];
        this._evaluateSubMesh(a, t, e, i);
      }
    }
  }
  /**
   * Update the transform matrix to update from the current active camera
   * @param force defines a boolean used to force the update even if cache is up to date
   */
  updateTransformMatrix(e) {
    if (this.activeCamera)
      if (this.activeCamera._renderingMultiview) {
        const t = this.activeCamera._rigCameras[0], i = this.activeCamera._rigCameras[1];
        this.setTransformMatrix(t.getViewMatrix(), t.getProjectionMatrix(e), i.getViewMatrix(), i.getProjectionMatrix(e));
      } else
        this.setTransformMatrix(this.activeCamera.getViewMatrix(), this.activeCamera.getProjectionMatrix(e));
  }
  _bindFrameBuffer(e, t = !0) {
    e && e._multiviewTexture ? e._multiviewTexture._bindFrameBuffer() : e && e.outputRenderTarget ? e.outputRenderTarget._bindFrameBuffer() : this._engine._currentFrameBufferIsDefaultFrameBuffer() || this._engine.restoreDefaultFramebuffer(), t && this._clearFrameBuffer(e);
  }
  _clearFrameBuffer(e) {
    if (!(e && e._multiviewTexture)) if (e && e.outputRenderTarget && !e._renderingMultiview) {
      const t = e.outputRenderTarget;
      t.onClearObservable.hasObservers() ? t.onClearObservable.notifyObservers(this._engine) : t.skipInitialClear || (this.autoClear && this._engine.clear(t.clearColor || this.clearColor, !t._cleared, !0, !0), t._cleared = !0);
    } else
      this._defaultFrameBufferCleared ? this._engine.clear(null, !1, !0, !0) : (this._defaultFrameBufferCleared = !0, this._clear());
  }
  /**
   * @internal
   */
  _renderForCamera(e, t, i = !0) {
    var s, r, n;
    if (e && e._skipRendering)
      return;
    const a = this._engine;
    if (this._activeCamera = e, !this.activeCamera)
      throw new Error("Active camera not set");
    if (a.setViewport(this.activeCamera.viewport), this.resetCachedMaterial(), this._renderId++, !this.prePass && i) {
      let l = !0;
      e._renderingMultiview && e.outputRenderTarget && (l = e.outputRenderTarget.skipInitialClear, this.autoClear && (this._defaultFrameBufferCleared = !1, e.outputRenderTarget.skipInitialClear = !1)), this._bindFrameBuffer(this._activeCamera), e._renderingMultiview && e.outputRenderTarget && (e.outputRenderTarget.skipInitialClear = l);
    }
    this.updateTransformMatrix(), this.onBeforeCameraRenderObservable.notifyObservers(this.activeCamera), this._evaluateActiveMeshes();
    for (let l = 0; l < this._softwareSkinnedMeshes.length; l++) {
      const c = this._softwareSkinnedMeshes.data[l];
      c.applySkeleton(c.skeleton);
    }
    this.onBeforeRenderTargetsRenderObservable.notifyObservers(this), this._renderTargets.concatWithNoDuplicate(this._materialsRenderTargets), e.customRenderTargets && e.customRenderTargets.length > 0 && this._renderTargets.concatWithNoDuplicate(e.customRenderTargets), t && t.customRenderTargets && t.customRenderTargets.length > 0 && this._renderTargets.concatWithNoDuplicate(t.customRenderTargets), this.environmentTexture && this.environmentTexture.isRenderTarget && this._renderTargets.pushNoDuplicate(this.environmentTexture);
    for (const l of this._gatherActiveCameraRenderTargetsStage)
      l.action(this._renderTargets);
    let o = !1;
    if (this.renderTargetsEnabled) {
      if (this._intermediateRendering = !0, this._renderTargets.length > 0) {
        z.StartPerformanceCounter("Render targets", this._renderTargets.length > 0);
        for (let l = 0; l < this._renderTargets.length; l++) {
          const c = this._renderTargets.data[l];
          if (c._shouldRender()) {
            this._renderId++;
            const u = c.activeCamera && c.activeCamera !== this.activeCamera;
            c.render(u, this.dumpNextRenderTargets), o = !0;
          }
        }
        z.EndPerformanceCounter("Render targets", this._renderTargets.length > 0), this._renderId++;
      }
      for (const l of this._cameraDrawRenderTargetStage)
        o = l.action(this.activeCamera) || o;
      this._intermediateRendering = !1;
    }
    this._engine.currentRenderPassId = (n = (r = (s = e.outputRenderTarget) === null || s === void 0 ? void 0 : s.renderPassId) !== null && r !== void 0 ? r : e.renderPassId) !== null && n !== void 0 ? n : 0, o && !this.prePass && this._bindFrameBuffer(this._activeCamera, !1), this.onAfterRenderTargetsRenderObservable.notifyObservers(this), this.postProcessManager && !e._multiviewTexture && !this.prePass && this.postProcessManager._prepareFrame();
    for (const l of this._beforeCameraDrawStage)
      l.action(this.activeCamera);
    this.onBeforeDrawPhaseObservable.notifyObservers(this), a.snapshotRendering && a.snapshotRenderingMode === 1 && this.finalizeSceneUbo(), this._renderingManager.render(null, null, !0, !0), this.onAfterDrawPhaseObservable.notifyObservers(this);
    for (const l of this._afterCameraDrawStage)
      l.action(this.activeCamera);
    if (this.postProcessManager && !e._multiviewTexture) {
      const l = e.outputRenderTarget ? e.outputRenderTarget.renderTarget : void 0;
      this.postProcessManager._finalizeFrame(e.isIntermediate, l);
    }
    for (const l of this._afterCameraPostProcessStage)
      l.action(this.activeCamera);
    this._renderTargets.reset(), this.onAfterCameraRenderObservable.notifyObservers(this.activeCamera);
  }
  _processSubCameras(e, t = !0) {
    if (e.cameraRigMode === 0 || e._renderingMultiview) {
      e._renderingMultiview && !this._multiviewSceneUbo && this._createMultiviewUbo(), this._renderForCamera(e, void 0, t), this.onAfterRenderCameraObservable.notifyObservers(e);
      return;
    }
    if (e._useMultiviewToSingleView)
      this._renderMultiviewToSingleView(e);
    else {
      this.onBeforeCameraRenderObservable.notifyObservers(e);
      for (let i = 0; i < e._rigCameras.length; i++)
        this._renderForCamera(e._rigCameras[i], e);
    }
    this._activeCamera = e, this.updateTransformMatrix(), this.onAfterRenderCameraObservable.notifyObservers(e);
  }
  _checkIntersections() {
    for (let e = 0; e < this._meshesForIntersections.length; e++) {
      const t = this._meshesForIntersections.data[e];
      if (t.actionManager)
        for (let i = 0; t.actionManager && i < t.actionManager.actions.length; i++) {
          const s = t.actionManager.actions[i];
          if (s.trigger === 12 || s.trigger === 13) {
            const r = s.getTriggerParameter(), n = r.mesh ? r.mesh : r, a = n.intersectsMesh(t, r.usePreciseIntersection), o = t._intersectionsInProgress.indexOf(n);
            a && o === -1 ? s.trigger === 12 ? (s._executeCurrent(He.CreateNew(t, void 0, n)), t._intersectionsInProgress.push(n)) : s.trigger === 13 && t._intersectionsInProgress.push(n) : !a && o > -1 && (s.trigger === 13 && s._executeCurrent(He.CreateNew(t, void 0, n)), (!t.actionManager.hasSpecificTrigger(13, (l) => {
              const c = l.mesh ? l.mesh : l;
              return n === c;
            }) || s.trigger === 13) && t._intersectionsInProgress.splice(o, 1));
          }
        }
    }
  }
  /**
   * @internal
   */
  _advancePhysicsEngineStep(e) {
  }
  /** @internal */
  _animate() {
  }
  /** Execute all animations (for a frame) */
  animate() {
    if (this._engine.isDeterministicLockStep()) {
      let e = Math.max(ge.MinDeltaTime, Math.min(this._engine.getDeltaTime(), ge.MaxDeltaTime)) + this._timeAccumulator;
      const t = this._engine.getTimeStep(), i = 1e3 / t / 1e3;
      let s = 0;
      const r = this._engine.getLockstepMaxSteps();
      let n = Math.floor(e / t);
      for (n = Math.min(n, r); e > 0 && s < n; )
        this.onBeforeStepObservable.notifyObservers(this), this._animationRatio = t * i, this._animate(), this.onAfterAnimationsObservable.notifyObservers(this), this.physicsEnabled && this._advancePhysicsEngineStep(t), this.onAfterStepObservable.notifyObservers(this), this._currentStepId++, s++, e -= t;
      this._timeAccumulator = e < 0 ? 0 : e;
    } else {
      const e = this.useConstantAnimationDeltaTime ? 16 : Math.max(ge.MinDeltaTime, Math.min(this._engine.getDeltaTime(), ge.MaxDeltaTime));
      this._animationRatio = e * (60 / 1e3), this._animate(), this.onAfterAnimationsObservable.notifyObservers(this), this.physicsEnabled && this._advancePhysicsEngineStep(e);
    }
  }
  _clear() {
    (this.autoClearDepthAndStencil || this.autoClear) && this._engine.clear(this.clearColor, this.autoClear || this.forceWireframe || this.forcePointsCloud, this.autoClearDepthAndStencil, this.autoClearDepthAndStencil);
  }
  _checkCameraRenderTarget(e) {
    var t;
    if (e != null && e.outputRenderTarget && !(e != null && e.isRigCamera) && (e.outputRenderTarget._cleared = !1), !((t = e == null ? void 0 : e.rigCameras) === null || t === void 0) && t.length)
      for (let i = 0; i < e.rigCameras.length; ++i) {
        const s = e.rigCameras[i].outputRenderTarget;
        s && (s._cleared = !1);
      }
  }
  /**
   * Resets the draw wrappers cache of all meshes
   * @param passId If provided, releases only the draw wrapper corresponding to this render pass id
   */
  resetDrawCache(e) {
    if (this.meshes)
      for (const t of this.meshes)
        t.resetDrawCache(e);
  }
  /**
   * Render the scene
   * @param updateCameras defines a boolean indicating if cameras must update according to their inputs (true by default)
   * @param ignoreAnimations defines a boolean indicating if animations should not be executed (false by default)
   */
  render(e = !0, t = !1) {
    var i, s, r;
    if (this.isDisposed)
      return;
    this.onReadyObservable.hasObservers() && this._executeWhenReadyTimeoutId === null && this._checkIsReady(), this._frameId++, this._defaultFrameBufferCleared = !1, this._checkCameraRenderTarget(this.activeCamera), !((i = this.activeCameras) === null || i === void 0) && i.length && this.activeCameras.forEach(this._checkCameraRenderTarget), this._registerTransientComponents(), this._activeParticles.fetchNewFrame(), this._totalVertices.fetchNewFrame(), this._activeIndices.fetchNewFrame(), this._activeBones.fetchNewFrame(), this._meshesForIntersections.reset(), this.resetCachedMaterial(), this.onBeforeAnimationsObservable.notifyObservers(this), this.actionManager && this.actionManager.processTrigger(11), t || this.animate();
    for (const o of this._beforeCameraUpdateStage)
      o.action();
    if (e) {
      if (this.activeCameras && this.activeCameras.length > 0)
        for (let o = 0; o < this.activeCameras.length; o++) {
          const l = this.activeCameras[o];
          if (l.update(), l.cameraRigMode !== 0)
            for (let c = 0; c < l._rigCameras.length; c++)
              l._rigCameras[c].update();
        }
      else if (this.activeCamera && (this.activeCamera.update(), this.activeCamera.cameraRigMode !== 0))
        for (let o = 0; o < this.activeCamera._rigCameras.length; o++)
          this.activeCamera._rigCameras[o].update();
    }
    this.onBeforeRenderObservable.notifyObservers(this);
    const n = this.getEngine();
    this.onBeforeRenderTargetsRenderObservable.notifyObservers(this);
    const a = !((s = this.activeCameras) === null || s === void 0) && s.length ? this.activeCameras[0] : this.activeCamera;
    if (this.renderTargetsEnabled) {
      z.StartPerformanceCounter("Custom render targets", this.customRenderTargets.length > 0), this._intermediateRendering = !0;
      for (let o = 0; o < this.customRenderTargets.length; o++) {
        const l = this.customRenderTargets[o];
        if (l._shouldRender()) {
          if (this._renderId++, this.activeCamera = l.activeCamera || this.activeCamera, !this.activeCamera)
            throw new Error("Active camera not set");
          n.setViewport(this.activeCamera.viewport), this.updateTransformMatrix(), l.render(a !== this.activeCamera, this.dumpNextRenderTargets);
        }
      }
      z.EndPerformanceCounter("Custom render targets", this.customRenderTargets.length > 0), this._intermediateRendering = !1, this._renderId++;
    }
    this._engine.currentRenderPassId = (r = a == null ? void 0 : a.renderPassId) !== null && r !== void 0 ? r : 0, this.activeCamera = a, this._activeCamera && this._activeCamera.cameraRigMode !== 22 && !this.prePass && this._bindFrameBuffer(this._activeCamera, !1), this.onAfterRenderTargetsRenderObservable.notifyObservers(this);
    for (const o of this._beforeClearStage)
      o.action();
    this._clearFrameBuffer(this.activeCamera);
    for (const o of this._gatherRenderTargetsStage)
      o.action(this._renderTargets);
    if (this.activeCameras && this.activeCameras.length > 0)
      for (let o = 0; o < this.activeCameras.length; o++)
        this._processSubCameras(this.activeCameras[o], o > 0);
    else {
      if (!this.activeCamera)
        throw new Error("No camera defined");
      this._processSubCameras(this.activeCamera, !!this.activeCamera.outputRenderTarget);
    }
    this._checkIntersections();
    for (const o of this._afterRenderStage)
      o.action();
    if (this.afterRender && this.afterRender(), this.onAfterRenderObservable.notifyObservers(this), this._toBeDisposed.length) {
      for (let o = 0; o < this._toBeDisposed.length; o++) {
        const l = this._toBeDisposed[o];
        l && l.dispose();
      }
      this._toBeDisposed.length = 0;
    }
    this.dumpNextRenderTargets && (this.dumpNextRenderTargets = !1), this._activeBones.addCount(0, !0), this._activeIndices.addCount(0, !0), this._activeParticles.addCount(0, !0), this._engine.restoreDefaultFramebuffer();
  }
  /**
   * Freeze all materials
   * A frozen material will not be updatable but should be faster to render
   * Note: multimaterials will not be frozen, but their submaterials will
   */
  freezeMaterials() {
    for (let e = 0; e < this.materials.length; e++)
      this.materials[e].freeze();
  }
  /**
   * Unfreeze all materials
   * A frozen material will not be updatable but should be faster to render
   */
  unfreezeMaterials() {
    for (let e = 0; e < this.materials.length; e++)
      this.materials[e].unfreeze();
  }
  /**
   * Releases all held resources
   */
  dispose() {
    if (this.isDisposed)
      return;
    this.beforeRender = null, this.afterRender = null, this.metadata = null, this.skeletons.length = 0, this.morphTargetManagers.length = 0, this._transientComponents.length = 0, this._isReadyForMeshStage.clear(), this._beforeEvaluateActiveMeshStage.clear(), this._evaluateSubMeshStage.clear(), this._preActiveMeshStage.clear(), this._cameraDrawRenderTargetStage.clear(), this._beforeCameraDrawStage.clear(), this._beforeRenderTargetDrawStage.clear(), this._beforeRenderingGroupDrawStage.clear(), this._beforeRenderingMeshStage.clear(), this._afterRenderingMeshStage.clear(), this._afterRenderingGroupDrawStage.clear(), this._afterCameraDrawStage.clear(), this._afterRenderTargetDrawStage.clear(), this._afterRenderStage.clear(), this._beforeCameraUpdateStage.clear(), this._beforeClearStage.clear(), this._gatherRenderTargetsStage.clear(), this._gatherActiveCameraRenderTargetsStage.clear(), this._pointerMoveStage.clear(), this._pointerDownStage.clear(), this._pointerUpStage.clear(), this.importedMeshesFiles = new Array(), this.stopAllAnimations && (this._activeAnimatables.forEach((r) => {
      r.onAnimationEndObservable.clear(), r.onAnimationEnd = null;
    }), this.stopAllAnimations()), this.resetCachedMaterial(), this.activeCamera && (this.activeCamera._activeMeshes.dispose(), this.activeCamera = null), this.activeCameras = null, this._activeMeshes.dispose(), this._renderingManager.dispose(), this._processedMaterials.dispose(), this._activeParticleSystems.dispose(), this._activeSkeletons.dispose(), this._softwareSkinnedMeshes.dispose(), this._renderTargets.dispose(), this._materialsRenderTargets.dispose(), this._registeredForLateAnimationBindings.dispose(), this._meshesForIntersections.dispose(), this._toBeDisposed.length = 0;
    const e = this._activeRequests.slice();
    for (const r of e)
      r.abort();
    this._activeRequests.length = 0;
    try {
      this.onDisposeObservable.notifyObservers(this);
    } catch (r) {
      console.error("An error occurred while calling onDisposeObservable!", r);
    }
    if (this.detachControl(), this._engine.getInputElement())
      for (let r = 0; r < this.cameras.length; r++)
        this.cameras[r].detachControl();
    this._disposeList(this.animationGroups), this._disposeList(this.lights), this._disposeList(this.meshes, (r) => r.dispose(!0)), this._disposeList(this.transformNodes, (r) => r.dispose(!0));
    const i = this.cameras;
    this._disposeList(i), this._defaultMaterial && this._defaultMaterial.dispose(), this._disposeList(this.multiMaterials), this._disposeList(this.materials), this._disposeList(this.particleSystems), this._disposeList(this.postProcesses), this._disposeList(this.textures), this._disposeList(this.morphTargetManagers), this._sceneUbo.dispose(), this._multiviewSceneUbo && this._multiviewSceneUbo.dispose(), this.postProcessManager.dispose(), this._disposeList(this._components);
    let s = this._engine.scenes.indexOf(this);
    s > -1 && this._engine.scenes.splice(s, 1), de._LastCreatedScene === this && (this._engine.scenes.length > 0 ? de._LastCreatedScene = this._engine.scenes[this._engine.scenes.length - 1] : de._LastCreatedScene = null), s = this._engine._virtualScenes.indexOf(this), s > -1 && this._engine._virtualScenes.splice(s, 1), this._engine.wipeCaches(!0), this.onDisposeObservable.clear(), this.onBeforeRenderObservable.clear(), this.onAfterRenderObservable.clear(), this.onBeforeRenderTargetsRenderObservable.clear(), this.onAfterRenderTargetsRenderObservable.clear(), this.onAfterStepObservable.clear(), this.onBeforeStepObservable.clear(), this.onBeforeActiveMeshesEvaluationObservable.clear(), this.onAfterActiveMeshesEvaluationObservable.clear(), this.onBeforeParticlesRenderingObservable.clear(), this.onAfterParticlesRenderingObservable.clear(), this.onBeforeDrawPhaseObservable.clear(), this.onAfterDrawPhaseObservable.clear(), this.onBeforeAnimationsObservable.clear(), this.onAfterAnimationsObservable.clear(), this.onDataLoadedObservable.clear(), this.onBeforeRenderingGroupObservable.clear(), this.onAfterRenderingGroupObservable.clear(), this.onMeshImportedObservable.clear(), this.onBeforeCameraRenderObservable.clear(), this.onAfterCameraRenderObservable.clear(), this.onAfterRenderCameraObservable.clear(), this.onReadyObservable.clear(), this.onNewCameraAddedObservable.clear(), this.onCameraRemovedObservable.clear(), this.onNewLightAddedObservable.clear(), this.onLightRemovedObservable.clear(), this.onNewGeometryAddedObservable.clear(), this.onGeometryRemovedObservable.clear(), this.onNewTransformNodeAddedObservable.clear(), this.onTransformNodeRemovedObservable.clear(), this.onNewMeshAddedObservable.clear(), this.onMeshRemovedObservable.clear(), this.onNewSkeletonAddedObservable.clear(), this.onSkeletonRemovedObservable.clear(), this.onNewMaterialAddedObservable.clear(), this.onNewMultiMaterialAddedObservable.clear(), this.onMaterialRemovedObservable.clear(), this.onMultiMaterialRemovedObservable.clear(), this.onNewTextureAddedObservable.clear(), this.onTextureRemovedObservable.clear(), this.onPrePointerObservable.clear(), this.onPointerObservable.clear(), this.onPreKeyboardObservable.clear(), this.onKeyboardObservable.clear(), this.onActiveCameraChanged.clear(), this.onScenePerformancePriorityChangedObservable.clear(), this._isDisposed = !0;
  }
  _disposeList(e, t) {
    const i = e.slice(0);
    t = t ?? ((s) => s.dispose());
    for (const s of i)
      t(s);
    e.length = 0;
  }
  /**
   * Gets if the scene is already disposed
   */
  get isDisposed() {
    return this._isDisposed;
  }
  /**
   * Call this function to reduce memory footprint of the scene.
   * Vertex buffers will not store CPU data anymore (this will prevent picking, collisions or physics to work correctly)
   */
  clearCachedVertexData() {
    for (let e = 0; e < this.meshes.length; e++) {
      const i = this.meshes[e].geometry;
      i && i.clearCachedData();
    }
  }
  /**
   * This function will remove the local cached buffer data from texture.
   * It will save memory but will prevent the texture from being rebuilt
   */
  cleanCachedTextureBuffer() {
    for (const e of this.textures)
      e._buffer && (e._buffer = null);
  }
  /**
   * Get the world extend vectors with an optional filter
   *
   * @param filterPredicate the predicate - which meshes should be included when calculating the world size
   * @returns {{ min: Vector3; max: Vector3 }} min and max vectors
   */
  getWorldExtends(e) {
    const t = new p(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE), i = new p(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
    return e = e || (() => !0), this.meshes.filter(e).forEach((s) => {
      if (s.computeWorldMatrix(!0), !s.subMeshes || s.subMeshes.length === 0 || s.infiniteDistance)
        return;
      const r = s.getBoundingInfo(), n = r.boundingBox.minimumWorld, a = r.boundingBox.maximumWorld;
      p.CheckExtends(n, t, i), p.CheckExtends(a, t, i);
    }), {
      min: t,
      max: i
    };
  }
  // Picking
  /**
   * Creates a ray that can be used to pick in the scene
   * @param x defines the x coordinate of the origin (on-screen)
   * @param y defines the y coordinate of the origin (on-screen)
   * @param world defines the world matrix to use if you want to pick in object space (instead of world space)
   * @param camera defines the camera to use for the picking
   * @param cameraViewSpace defines if picking will be done in view space (false by default)
   * @returns a Ray
   */
  createPickingRay(e, t, i, s, r = !1) {
    throw he("Ray");
  }
  /**
   * Creates a ray that can be used to pick in the scene
   * @param x defines the x coordinate of the origin (on-screen)
   * @param y defines the y coordinate of the origin (on-screen)
   * @param world defines the world matrix to use if you want to pick in object space (instead of world space)
   * @param result defines the ray where to store the picking ray
   * @param camera defines the camera to use for the picking
   * @param cameraViewSpace defines if picking will be done in view space (false by default)
   * @param enableDistantPicking defines if picking should handle large values for mesh position/scaling (false by default)
   * @returns the current scene
   */
  createPickingRayToRef(e, t, i, s, r, n = !1, a = !1) {
    throw he("Ray");
  }
  /**
   * Creates a ray that can be used to pick in the scene
   * @param x defines the x coordinate of the origin (on-screen)
   * @param y defines the y coordinate of the origin (on-screen)
   * @param camera defines the camera to use for the picking
   * @returns a Ray
   */
  createPickingRayInCameraSpace(e, t, i) {
    throw he("Ray");
  }
  /**
   * Creates a ray that can be used to pick in the scene
   * @param x defines the x coordinate of the origin (on-screen)
   * @param y defines the y coordinate of the origin (on-screen)
   * @param result defines the ray where to store the picking ray
   * @param camera defines the camera to use for the picking
   * @returns the current scene
   */
  createPickingRayInCameraSpaceToRef(e, t, i, s) {
    throw he("Ray");
  }
  /** @internal */
  get _pickingAvailable() {
    return !1;
  }
  /** Launch a ray to try to pick a mesh in the scene
   * @param x position on screen
   * @param y position on screen
   * @param predicate Predicate function used to determine eligible meshes. Can be set to null. In this case, a mesh must be enabled, visible and with isPickable set to true
   * @param fastCheck defines if the first intersection will be used (and not the closest)
   * @param camera to use for computing the picking ray. Can be set to null. In this case, the scene.activeCamera will be used
   * @param trianglePredicate defines an optional predicate used to select faces when a mesh intersection is detected
   * @returns a PickingInfo
   */
  pick(e, t, i, s, r, n) {
    return new Gt();
  }
  /** Launch a ray to try to pick a mesh in the scene using only bounding information of the main mesh (not using submeshes)
   * @param x position on screen
   * @param y position on screen
   * @param predicate Predicate function used to determine eligible meshes. Can be set to null. In this case, a mesh must be enabled, visible and with isPickable set to true
   * @param fastCheck defines if the first intersection will be used (and not the closest)
   * @param camera to use for computing the picking ray. Can be set to null. In this case, the scene.activeCamera will be used
   * @returns a PickingInfo (Please note that some info will not be set like distance, bv, bu and everything that cannot be capture by only using bounding infos)
   */
  pickWithBoundingInfo(e, t, i, s, r) {
    return new Gt();
  }
  /**
   * Use the given ray to pick a mesh in the scene. A mesh triangle can be picked both from its front and back sides,
   * irrespective of orientation.
   * @param ray The ray to use to pick meshes
   * @param predicate Predicate function used to determine eligible meshes. Can be set to null. In this case, a mesh must have isPickable set to true
   * @param fastCheck defines if the first intersection will be used (and not the closest)
   * @param trianglePredicate defines an optional predicate used to select faces when a mesh intersection is detected
   * @returns a PickingInfo
   */
  pickWithRay(e, t, i, s) {
    throw he("Ray");
  }
  /**
   * Launch a ray to try to pick a mesh in the scene. A mesh triangle can be picked both from its front and back sides,
   * irrespective of orientation.
   * @param x X position on screen
   * @param y Y position on screen
   * @param predicate Predicate function used to determine eligible meshes. Can be set to null. In this case, a mesh must be enabled, visible and with isPickable set to true
   * @param camera camera to use for computing the picking ray. Can be set to null. In this case, the scene.activeCamera will be used
   * @param trianglePredicate defines an optional predicate used to select faces when a mesh intersection is detected
   * @returns an array of PickingInfo
   */
  multiPick(e, t, i, s, r) {
    throw he("Ray");
  }
  /**
   * Launch a ray to try to pick a mesh in the scene
   * @param ray Ray to use
   * @param predicate Predicate function used to determine eligible meshes. Can be set to null. In this case, a mesh must be enabled, visible and with isPickable set to true
   * @param trianglePredicate defines an optional predicate used to select faces when a mesh intersection is detected
   * @returns an array of PickingInfo
   */
  multiPickWithRay(e, t, i) {
    throw he("Ray");
  }
  /**
   * Force the value of meshUnderPointer
   * @param mesh defines the mesh to use
   * @param pointerId optional pointer id when using more than one pointer
   * @param pickResult optional pickingInfo data used to find mesh
   */
  setPointerOverMesh(e, t, i) {
    this._inputManager.setPointerOverMesh(e, t, i);
  }
  /**
   * Gets the mesh under the pointer
   * @returns a Mesh or null if no mesh is under the pointer
   */
  getPointerOverMesh() {
    return this._inputManager.getPointerOverMesh();
  }
  // Misc.
  /** @internal */
  _rebuildGeometries() {
    for (const e of this.geometries)
      e._rebuild();
    for (const e of this.meshes)
      e._rebuild();
    this.postProcessManager && this.postProcessManager._rebuild();
    for (const e of this._components)
      e.rebuild();
    for (const e of this.particleSystems)
      e.rebuild();
    if (this.spriteManagers)
      for (const e of this.spriteManagers)
        e.rebuild();
  }
  /** @internal */
  _rebuildTextures() {
    for (const e of this.textures)
      e._rebuild();
    this.markAllMaterialsAsDirty(1);
  }
  // Tags
  _getByTags(e, t, i) {
    if (t === void 0)
      return e;
    const s = [];
    i = i || ((r) => {
    });
    for (const r in e) {
      const n = e[r];
      Ee && Ee.MatchesQuery(n, t) && (s.push(n), i(n));
    }
    return s;
  }
  /**
   * Get a list of meshes by tags
   * @param tagsQuery defines the tags query to use
   * @param forEach defines a predicate used to filter results
   * @returns an array of Mesh
   */
  getMeshesByTags(e, t) {
    return this._getByTags(this.meshes, e, t);
  }
  /**
   * Get a list of cameras by tags
   * @param tagsQuery defines the tags query to use
   * @param forEach defines a predicate used to filter results
   * @returns an array of Camera
   */
  getCamerasByTags(e, t) {
    return this._getByTags(this.cameras, e, t);
  }
  /**
   * Get a list of lights by tags
   * @param tagsQuery defines the tags query to use
   * @param forEach defines a predicate used to filter results
   * @returns an array of Light
   */
  getLightsByTags(e, t) {
    return this._getByTags(this.lights, e, t);
  }
  /**
   * Get a list of materials by tags
   * @param tagsQuery defines the tags query to use
   * @param forEach defines a predicate used to filter results
   * @returns an array of Material
   */
  getMaterialByTags(e, t) {
    return this._getByTags(this.materials, e, t).concat(this._getByTags(this.multiMaterials, e, t));
  }
  /**
   * Get a list of transform nodes by tags
   * @param tagsQuery defines the tags query to use
   * @param forEach defines a predicate used to filter results
   * @returns an array of TransformNode
   */
  getTransformNodesByTags(e, t) {
    return this._getByTags(this.transformNodes, e, t);
  }
  /**
   * Overrides the default sort function applied in the rendering group to prepare the meshes.
   * This allowed control for front to back rendering or reversly depending of the special needs.
   *
   * @param renderingGroupId The rendering group id corresponding to its index
   * @param opaqueSortCompareFn The opaque queue comparison function use to sort.
   * @param alphaTestSortCompareFn The alpha test queue comparison function use to sort.
   * @param transparentSortCompareFn The transparent queue comparison function use to sort.
   */
  setRenderingOrder(e, t = null, i = null, s = null) {
    this._renderingManager.setRenderingOrder(e, t, i, s);
  }
  /**
   * Specifies whether or not the stencil and depth buffer are cleared between two rendering groups.
   *
   * @param renderingGroupId The rendering group id corresponding to its index
   * @param autoClearDepthStencil Automatically clears depth and stencil between groups if true.
   * @param depth Automatically clears depth between groups if true and autoClear is true.
   * @param stencil Automatically clears stencil between groups if true and autoClear is true.
   */
  setRenderingAutoClearDepthStencil(e, t, i = !0, s = !0) {
    this._renderingManager.setRenderingAutoClearDepthStencil(e, t, i, s);
  }
  /**
   * Gets the current auto clear configuration for one rendering group of the rendering
   * manager.
   * @param index the rendering group index to get the information for
   * @returns The auto clear setup for the requested rendering group
   */
  getAutoClearDepthStencilSetup(e) {
    return this._renderingManager.getAutoClearDepthStencilSetup(e);
  }
  /** Gets or sets a boolean blocking all the calls to markAllMaterialsAsDirty (ie. the materials won't be updated if they are out of sync) */
  get blockMaterialDirtyMechanism() {
    return this._blockMaterialDirtyMechanism;
  }
  set blockMaterialDirtyMechanism(e) {
    this._blockMaterialDirtyMechanism !== e && (this._blockMaterialDirtyMechanism = e, e || this.markAllMaterialsAsDirty(63));
  }
  /**
   * Will flag all materials as dirty to trigger new shader compilation
   * @param flag defines the flag used to specify which material part must be marked as dirty
   * @param predicate If not null, it will be used to specify if a material has to be marked as dirty
   */
  markAllMaterialsAsDirty(e, t) {
    if (!this._blockMaterialDirtyMechanism)
      for (const i of this.materials)
        t && !t(i) || i.markAsDirty(e);
  }
  /**
   * @internal
   */
  _loadFile(e, t, i, s, r, n, a) {
    const o = ki(e, t, i, s ? this.offlineProvider : void 0, r, n, a);
    return this._activeRequests.push(o), o.onCompleteObservable.add((l) => {
      this._activeRequests.splice(this._activeRequests.indexOf(l), 1);
    }), o;
  }
  /**
   * @internal
   */
  _loadFileAsync(e, t, i, s, r) {
    return new Promise((n, a) => {
      this._loadFile(e, (o) => {
        n(o);
      }, t, i, s, (o, l) => {
        a(l);
      }, r);
    });
  }
  /**
   * @internal
   */
  _requestFile(e, t, i, s, r, n, a) {
    const o = Pn(e, t, i, s ? this.offlineProvider : void 0, r, n, a);
    return this._activeRequests.push(o), o.onCompleteObservable.add((l) => {
      this._activeRequests.splice(this._activeRequests.indexOf(l), 1);
    }), o;
  }
  /**
   * @internal
   */
  _requestFileAsync(e, t, i, s, r) {
    return new Promise((n, a) => {
      this._requestFile(e, (o) => {
        n(o);
      }, t, i, s, (o) => {
        a(o);
      }, r);
    });
  }
  /**
   * @internal
   */
  _readFile(e, t, i, s, r) {
    const n = Ns(e, t, i, s, r);
    return this._activeRequests.push(n), n.onCompleteObservable.add((a) => {
      this._activeRequests.splice(this._activeRequests.indexOf(a), 1);
    }), n;
  }
  /**
   * @internal
   */
  _readFileAsync(e, t, i) {
    return new Promise((s, r) => {
      this._readFile(e, (n) => {
        s(n);
      }, t, i, (n) => {
        r(n);
      });
    });
  }
  /**
   * This method gets the performance collector belonging to the scene, which is generally shared with the inspector.
   * @returns the perf collector belonging to the scene.
   */
  getPerfCollector() {
    throw he("performanceViewerSceneExtension");
  }
  // deprecated
  /**
   * Sets the active camera of the scene using its Id
   * @param id defines the camera's Id
   * @returns the new active camera or null if none found.
   * @deprecated Please use setActiveCameraById instead
   */
  setActiveCameraByID(e) {
    return this.setActiveCameraById(e);
  }
  /**
   * Get a material using its id
   * @param id defines the material's Id
   * @returns the material or null if none found.
   * @deprecated Please use getMaterialById instead
   */
  getMaterialByID(e) {
    return this.getMaterialById(e);
  }
  /**
   * Gets a the last added material using a given id
   * @param id defines the material's Id
   * @returns the last material with the given id or null if none found.
   * @deprecated Please use getLastMaterialById instead
   */
  getLastMaterialByID(e) {
    return this.getLastMaterialById(e);
  }
  /**
   * Get a texture using its unique id
   * @param uniqueId defines the texture's unique id
   * @returns the texture or null if none found.
   * @deprecated Please use getTextureByUniqueId instead
   */
  getTextureByUniqueID(e) {
    return this.getTextureByUniqueId(e);
  }
  /**
   * Gets a camera using its Id
   * @param id defines the Id to look for
   * @returns the camera or null if not found
   * @deprecated Please use getCameraById instead
   */
  getCameraByID(e) {
    return this.getCameraById(e);
  }
  /**
   * Gets a camera using its unique Id
   * @param uniqueId defines the unique Id to look for
   * @returns the camera or null if not found
   * @deprecated Please use getCameraByUniqueId instead
   */
  getCameraByUniqueID(e) {
    return this.getCameraByUniqueId(e);
  }
  /**
   * Gets a bone using its Id
   * @param id defines the bone's Id
   * @returns the bone or null if not found
   * @deprecated Please use getBoneById instead
   */
  getBoneByID(e) {
    return this.getBoneById(e);
  }
  /**
   * Gets a light node using its Id
   * @param id defines the light's Id
   * @returns the light or null if none found.
   * @deprecated Please use getLightById instead
   */
  getLightByID(e) {
    return this.getLightById(e);
  }
  /**
   * Gets a light node using its scene-generated unique Id
   * @param uniqueId defines the light's unique Id
   * @returns the light or null if none found.
   * @deprecated Please use getLightByUniqueId instead
   */
  getLightByUniqueID(e) {
    return this.getLightByUniqueId(e);
  }
  /**
   * Gets a particle system by Id
   * @param id defines the particle system Id
   * @returns the corresponding system or null if none found
   * @deprecated Please use getParticleSystemById instead
   */
  getParticleSystemByID(e) {
    return this.getParticleSystemById(e);
  }
  /**
   * Gets a geometry using its Id
   * @param id defines the geometry's Id
   * @returns the geometry or null if none found.
   * @deprecated Please use getGeometryById instead
   */
  getGeometryByID(e) {
    return this.getGeometryById(e);
  }
  /**
   * Gets the first added mesh found of a given Id
   * @param id defines the Id to search for
   * @returns the mesh found or null if not found at all
   * @deprecated Please use getMeshById instead
   */
  getMeshByID(e) {
    return this.getMeshById(e);
  }
  /**
   * Gets a mesh with its auto-generated unique Id
   * @param uniqueId defines the unique Id to search for
   * @returns the found mesh or null if not found at all.
   * @deprecated Please use getMeshByUniqueId instead
   */
  getMeshByUniqueID(e) {
    return this.getMeshByUniqueId(e);
  }
  /**
   * Gets a the last added mesh using a given Id
   * @param id defines the Id to search for
   * @returns the found mesh or null if not found at all.
   * @deprecated Please use getLastMeshById instead
   */
  getLastMeshByID(e) {
    return this.getLastMeshById(e);
  }
  /**
   * Gets a list of meshes using their Id
   * @param id defines the Id to search for
   * @returns a list of meshes
   * @deprecated Please use getMeshesById instead
   */
  getMeshesByID(e) {
    return this.getMeshesById(e);
  }
  /**
   * Gets the first added transform node found of a given Id
   * @param id defines the Id to search for
   * @returns the found transform node or null if not found at all.
   * @deprecated Please use getTransformNodeById instead
   */
  getTransformNodeByID(e) {
    return this.getTransformNodeById(e);
  }
  /**
   * Gets a transform node with its auto-generated unique Id
   * @param uniqueId defines the unique Id to search for
   * @returns the found transform node or null if not found at all.
   * @deprecated Please use getTransformNodeByUniqueId instead
   */
  getTransformNodeByUniqueID(e) {
    return this.getTransformNodeByUniqueId(e);
  }
  /**
   * Gets a list of transform nodes using their Id
   * @param id defines the Id to search for
   * @returns a list of transform nodes
   * @deprecated Please use getTransformNodesById instead
   */
  getTransformNodesByID(e) {
    return this.getTransformNodesById(e);
  }
  /**
   * Gets a node (Mesh, Camera, Light) using a given Id
   * @param id defines the Id to search for
   * @returns the found node or null if not found at all
   * @deprecated Please use getNodeById instead
   */
  getNodeByID(e) {
    return this.getNodeById(e);
  }
  /**
   * Gets a the last added node (Mesh, Camera, Light) using a given Id
   * @param id defines the Id to search for
   * @returns the found node or null if not found at all
   * @deprecated Please use getLastEntryById instead
   */
  getLastEntryByID(e) {
    return this.getLastEntryById(e);
  }
  /**
   * Gets a skeleton using a given Id (if many are found, this function will pick the last one)
   * @param id defines the Id to search for
   * @returns the found skeleton or null if not found at all.
   * @deprecated Please use getLastSkeletonById instead
   */
  getLastSkeletonByID(e) {
    return this.getLastSkeletonById(e);
  }
}
ge.FOGMODE_NONE = 0;
ge.FOGMODE_EXP = 1;
ge.FOGMODE_EXP2 = 2;
ge.FOGMODE_LINEAR = 3;
ge.MinDeltaTime = 1;
ge.MaxDeltaTime = 1e3;
class on {
  constructor(e, t, i) {
    this.bu = e, this.bv = t, this.distance = i, this.faceId = 0, this.subMeshId = 0;
  }
}
class yi {
  /**
   * Creates a new bounding box
   * @param min defines the minimum vector (in local space)
   * @param max defines the maximum vector (in local space)
   * @param worldMatrix defines the new world matrix
   */
  constructor(e, t, i) {
    this.vectors = ot.BuildArray(8, p.Zero), this.center = p.Zero(), this.centerWorld = p.Zero(), this.extendSize = p.Zero(), this.extendSizeWorld = p.Zero(), this.directions = ot.BuildArray(3, p.Zero), this.vectorsWorld = ot.BuildArray(8, p.Zero), this.minimumWorld = p.Zero(), this.maximumWorld = p.Zero(), this.minimum = p.Zero(), this.maximum = p.Zero(), this._drawWrapperFront = null, this._drawWrapperBack = null, this.reConstruct(e, t, i);
  }
  // Methods
  /**
   * Recreates the entire bounding box from scratch as if we call the constructor in place
   * @param min defines the new minimum vector (in local space)
   * @param max defines the new maximum vector (in local space)
   * @param worldMatrix defines the new world matrix
   */
  reConstruct(e, t, i) {
    const s = e.x, r = e.y, n = e.z, a = t.x, o = t.y, l = t.z, c = this.vectors;
    this.minimum.copyFromFloats(s, r, n), this.maximum.copyFromFloats(a, o, l), c[0].copyFromFloats(s, r, n), c[1].copyFromFloats(a, o, l), c[2].copyFromFloats(a, r, n), c[3].copyFromFloats(s, o, n), c[4].copyFromFloats(s, r, l), c[5].copyFromFloats(a, o, n), c[6].copyFromFloats(s, o, l), c[7].copyFromFloats(a, r, l), t.addToRef(e, this.center).scaleInPlace(0.5), t.subtractToRef(e, this.extendSize).scaleInPlace(0.5), this._worldMatrix = i || I.IdentityReadOnly, this._update(this._worldMatrix);
  }
  /**
   * Scale the current bounding box by applying a scale factor
   * @param factor defines the scale factor to apply
   * @returns the current bounding box
   */
  scale(e) {
    const t = yi._TmpVector3, i = this.maximum.subtractToRef(this.minimum, t[0]), s = i.length();
    i.normalizeFromLength(s);
    const r = s * e, n = i.scaleInPlace(r * 0.5), a = this.center.subtractToRef(n, t[1]), o = this.center.addToRef(n, t[2]);
    return this.reConstruct(a, o, this._worldMatrix), this;
  }
  /**
   * Gets the world matrix of the bounding box
   * @returns a matrix
   */
  getWorldMatrix() {
    return this._worldMatrix;
  }
  /**
   * @internal
   */
  _update(e) {
    const t = this.minimumWorld, i = this.maximumWorld, s = this.directions, r = this.vectorsWorld, n = this.vectors;
    if (e.isIdentity()) {
      t.copyFrom(this.minimum), i.copyFrom(this.maximum);
      for (let a = 0; a < 8; ++a)
        r[a].copyFrom(n[a]);
      this.extendSizeWorld.copyFrom(this.extendSize), this.centerWorld.copyFrom(this.center);
    } else {
      t.setAll(Number.MAX_VALUE), i.setAll(-Number.MAX_VALUE);
      for (let a = 0; a < 8; ++a) {
        const o = r[a];
        p.TransformCoordinatesToRef(n[a], e, o), t.minimizeInPlace(o), i.maximizeInPlace(o);
      }
      i.subtractToRef(t, this.extendSizeWorld).scaleInPlace(0.5), i.addToRef(t, this.centerWorld).scaleInPlace(0.5);
    }
    p.FromArrayToRef(e.m, 0, s[0]), p.FromArrayToRef(e.m, 4, s[1]), p.FromArrayToRef(e.m, 8, s[2]), this._worldMatrix = e;
  }
  /**
   * Tests if the bounding box is intersecting the frustum planes
   * @param frustumPlanes defines the frustum planes to test
   * @returns true if there is an intersection
   */
  isInFrustum(e) {
    return yi.IsInFrustum(this.vectorsWorld, e);
  }
  /**
   * Tests if the bounding box is entirely inside the frustum planes
   * @param frustumPlanes defines the frustum planes to test
   * @returns true if there is an inclusion
   */
  isCompletelyInFrustum(e) {
    return yi.IsCompletelyInFrustum(this.vectorsWorld, e);
  }
  /**
   * Tests if a point is inside the bounding box
   * @param point defines the point to test
   * @returns true if the point is inside the bounding box
   */
  intersectsPoint(e) {
    const t = this.minimumWorld, i = this.maximumWorld, s = t.x, r = t.y, n = t.z, a = i.x, o = i.y, l = i.z, c = e.x, u = e.y, d = e.z, f = -pe;
    return !(a - c < f || f > c - s || o - u < f || f > u - r || l - d < f || f > d - n);
  }
  /**
   * Tests if the bounding box intersects with a bounding sphere
   * @param sphere defines the sphere to test
   * @returns true if there is an intersection
   */
  intersectsSphere(e) {
    return yi.IntersectsSphere(this.minimumWorld, this.maximumWorld, e.centerWorld, e.radiusWorld);
  }
  /**
   * Tests if the bounding box intersects with a box defined by a min and max vectors
   * @param min defines the min vector to use
   * @param max defines the max vector to use
   * @returns true if there is an intersection
   */
  intersectsMinMax(e, t) {
    const i = this.minimumWorld, s = this.maximumWorld, r = i.x, n = i.y, a = i.z, o = s.x, l = s.y, c = s.z, u = e.x, d = e.y, f = e.z, _ = t.x, g = t.y, m = t.z;
    return !(o < u || r > _ || l < d || n > g || c < f || a > m);
  }
  /**
   * Disposes the resources of the class
   */
  dispose() {
    var e, t;
    (e = this._drawWrapperFront) === null || e === void 0 || e.dispose(), (t = this._drawWrapperBack) === null || t === void 0 || t.dispose();
  }
  // Statics
  /**
   * Tests if two bounding boxes are intersections
   * @param box0 defines the first box to test
   * @param box1 defines the second box to test
   * @returns true if there is an intersection
   */
  static Intersects(e, t) {
    return e.intersectsMinMax(t.minimumWorld, t.maximumWorld);
  }
  /**
   * Tests if a bounding box defines by a min/max vectors intersects a sphere
   * @param minPoint defines the minimum vector of the bounding box
   * @param maxPoint defines the maximum vector of the bounding box
   * @param sphereCenter defines the sphere center
   * @param sphereRadius defines the sphere radius
   * @returns true if there is an intersection
   */
  static IntersectsSphere(e, t, i, s) {
    const r = yi._TmpVector3[0];
    return p.ClampToRef(i, e, t, r), p.DistanceSquared(i, r) <= s * s;
  }
  /**
   * Tests if a bounding box defined with 8 vectors is entirely inside frustum planes
   * @param boundingVectors defines an array of 8 vectors representing a bounding box
   * @param frustumPlanes defines the frustum planes to test
   * @returns true if there is an inclusion
   */
  static IsCompletelyInFrustum(e, t) {
    for (let i = 0; i < 6; ++i) {
      const s = t[i];
      for (let r = 0; r < 8; ++r)
        if (s.dotCoordinate(e[r]) < 0)
          return !1;
    }
    return !0;
  }
  /**
   * Tests if a bounding box defined with 8 vectors intersects frustum planes
   * @param boundingVectors defines an array of 8 vectors representing a bounding box
   * @param frustumPlanes defines the frustum planes to test
   * @returns true if there is an intersection
   */
  static IsInFrustum(e, t) {
    for (let i = 0; i < 6; ++i) {
      let s = !0;
      const r = t[i];
      for (let n = 0; n < 8; ++n)
        if (r.dotCoordinate(e[n]) >= 0) {
          s = !1;
          break;
        }
      if (s)
        return !1;
    }
    return !0;
  }
}
yi._TmpVector3 = ot.BuildArray(3, p.Zero);
class qi {
  /**
   * Creates a new bounding sphere
   * @param min defines the minimum vector (in local space)
   * @param max defines the maximum vector (in local space)
   * @param worldMatrix defines the new world matrix
   */
  constructor(e, t, i) {
    this.center = p.Zero(), this.centerWorld = p.Zero(), this.minimum = p.Zero(), this.maximum = p.Zero(), this.reConstruct(e, t, i);
  }
  /**
   * Recreates the entire bounding sphere from scratch as if we call the constructor in place
   * @param min defines the new minimum vector (in local space)
   * @param max defines the new maximum vector (in local space)
   * @param worldMatrix defines the new world matrix
   */
  reConstruct(e, t, i) {
    this.minimum.copyFrom(e), this.maximum.copyFrom(t);
    const s = p.Distance(e, t);
    t.addToRef(e, this.center).scaleInPlace(0.5), this.radius = s * 0.5, this._update(i || I.IdentityReadOnly);
  }
  /**
   * Scale the current bounding sphere by applying a scale factor
   * @param factor defines the scale factor to apply
   * @returns the current bounding box
   */
  scale(e) {
    const t = this.radius * e, i = qi._TmpVector3, s = i[0].setAll(t), r = this.center.subtractToRef(s, i[1]), n = this.center.addToRef(s, i[2]);
    return this.reConstruct(r, n, this._worldMatrix), this;
  }
  /**
   * Gets the world matrix of the bounding box
   * @returns a matrix
   */
  getWorldMatrix() {
    return this._worldMatrix;
  }
  // Methods
  /**
   * @internal
   */
  _update(e) {
    if (e.isIdentity())
      this.centerWorld.copyFrom(this.center), this.radiusWorld = this.radius;
    else {
      p.TransformCoordinatesToRef(this.center, e, this.centerWorld);
      const t = qi._TmpVector3[0];
      p.TransformNormalFromFloatsToRef(1, 1, 1, e, t), this.radiusWorld = Math.max(Math.abs(t.x), Math.abs(t.y), Math.abs(t.z)) * this.radius;
    }
  }
  /**
   * Tests if the bounding sphere is intersecting the frustum planes
   * @param frustumPlanes defines the frustum planes to test
   * @returns true if there is an intersection
   */
  isInFrustum(e) {
    const t = this.centerWorld, i = this.radiusWorld;
    for (let s = 0; s < 6; s++)
      if (e[s].dotCoordinate(t) <= -i)
        return !1;
    return !0;
  }
  /**
   * Tests if the bounding sphere center is in between the frustum planes.
   * Used for optimistic fast inclusion.
   * @param frustumPlanes defines the frustum planes to test
   * @returns true if the sphere center is in between the frustum planes
   */
  isCenterInFrustum(e) {
    const t = this.centerWorld;
    for (let i = 0; i < 6; i++)
      if (e[i].dotCoordinate(t) < 0)
        return !1;
    return !0;
  }
  /**
   * Tests if a point is inside the bounding sphere
   * @param point defines the point to test
   * @returns true if the point is inside the bounding sphere
   */
  intersectsPoint(e) {
    const t = p.DistanceSquared(this.centerWorld, e);
    return !(this.radiusWorld * this.radiusWorld < t);
  }
  // Statics
  /**
   * Checks if two sphere intersect
   * @param sphere0 sphere 0
   * @param sphere1 sphere 1
   * @returns true if the spheres intersect
   */
  static Intersects(e, t) {
    const i = p.DistanceSquared(e.centerWorld, t.centerWorld), s = e.radiusWorld + t.radiusWorld;
    return !(s * s < i);
  }
  /**
   * Creates a sphere from a center and a radius
   * @param center The center
   * @param radius radius
   * @param matrix Optional worldMatrix
   * @returns The sphere
   */
  static CreateFromCenterAndRadius(e, t, i) {
    this._TmpVector3[0].copyFrom(e), this._TmpVector3[1].copyFromFloats(0, 0, t), this._TmpVector3[2].copyFrom(e), this._TmpVector3[0].addInPlace(this._TmpVector3[1]), this._TmpVector3[2].subtractInPlace(this._TmpVector3[1]);
    const s = new qi(this._TmpVector3[0], this._TmpVector3[2]);
    return i ? s._worldMatrix = i : s._worldMatrix = I.Identity(), s;
  }
}
qi._TmpVector3 = ot.BuildArray(3, p.Zero);
const zr = { min: 0, max: 0 }, Gr = { min: 0, max: 0 }, ra = (h, e, t) => {
  const i = p.Dot(e.centerWorld, h), s = Math.abs(p.Dot(e.directions[0], h)) * e.extendSize.x, r = Math.abs(p.Dot(e.directions[1], h)) * e.extendSize.y, n = Math.abs(p.Dot(e.directions[2], h)) * e.extendSize.z, a = s + r + n;
  t.min = i - a, t.max = i + a;
}, Ft = (h, e, t) => (ra(h, e, zr), ra(h, t, Gr), !(zr.min > Gr.max || Gr.min > zr.max));
class $t {
  /**
   * Constructs bounding info
   * @param minimum min vector of the bounding box/sphere
   * @param maximum max vector of the bounding box/sphere
   * @param worldMatrix defines the new world matrix
   */
  constructor(e, t, i) {
    this._isLocked = !1, this.boundingBox = new yi(e, t, i), this.boundingSphere = new qi(e, t, i);
  }
  /**
   * Recreates the entire bounding info from scratch as if we call the constructor in place
   * @param min defines the new minimum vector (in local space)
   * @param max defines the new maximum vector (in local space)
   * @param worldMatrix defines the new world matrix
   */
  reConstruct(e, t, i) {
    this.boundingBox.reConstruct(e, t, i), this.boundingSphere.reConstruct(e, t, i);
  }
  /**
   * min vector of the bounding box/sphere
   */
  get minimum() {
    return this.boundingBox.minimum;
  }
  /**
   * max vector of the bounding box/sphere
   */
  get maximum() {
    return this.boundingBox.maximum;
  }
  /**
   * If the info is locked and won't be updated to avoid perf overhead
   */
  get isLocked() {
    return this._isLocked;
  }
  set isLocked(e) {
    this._isLocked = e;
  }
  // Methods
  /**
   * Updates the bounding sphere and box
   * @param world world matrix to be used to update
   */
  update(e) {
    this._isLocked || (this.boundingBox._update(e), this.boundingSphere._update(e));
  }
  /**
   * Recreate the bounding info to be centered around a specific point given a specific extend.
   * @param center New center of the bounding info
   * @param extend New extend of the bounding info
   * @returns the current bounding info
   */
  centerOn(e, t) {
    const i = $t._TmpVector3[0].copyFrom(e).subtractInPlace(t), s = $t._TmpVector3[1].copyFrom(e).addInPlace(t);
    return this.boundingBox.reConstruct(i, s, this.boundingBox.getWorldMatrix()), this.boundingSphere.reConstruct(i, s, this.boundingBox.getWorldMatrix()), this;
  }
  /**
   * Grows the bounding info to include the given point.
   * @param point The point that will be included in the current bounding info (in local space)
   * @returns the current bounding info
   */
  encapsulate(e) {
    const t = p.Minimize(this.minimum, e), i = p.Maximize(this.maximum, e);
    return this.reConstruct(t, i, this.boundingBox.getWorldMatrix()), this;
  }
  /**
   * Grows the bounding info to encapsulate the given bounding info.
   * @param toEncapsulate The bounding info that will be encapsulated in the current bounding info
   * @returns the current bounding info
   */
  encapsulateBoundingInfo(e) {
    const t = C.Matrix[0];
    this.boundingBox.getWorldMatrix().invertToRef(t);
    const i = C.Vector3[0];
    return p.TransformCoordinatesToRef(e.boundingBox.minimumWorld, t, i), this.encapsulate(i), p.TransformCoordinatesToRef(e.boundingBox.maximumWorld, t, i), this.encapsulate(i), this;
  }
  /**
   * Scale the current bounding info by applying a scale factor
   * @param factor defines the scale factor to apply
   * @returns the current bounding info
   */
  scale(e) {
    return this.boundingBox.scale(e), this.boundingSphere.scale(e), this;
  }
  /**
   * Returns `true` if the bounding info is within the frustum defined by the passed array of planes.
   * @param frustumPlanes defines the frustum to test
   * @param strategy defines the strategy to use for the culling (default is BABYLON.AbstractMesh.CULLINGSTRATEGY_STANDARD)
   * The different strategies available are:
   * * BABYLON.AbstractMesh.CULLINGSTRATEGY_STANDARD most accurate but slower @see https://doc.babylonjs.com/typedoc/classes/BABYLON.AbstractMesh#CULLINGSTRATEGY_STANDARD
   * * BABYLON.AbstractMesh.CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY faster but less accurate @see https://doc.babylonjs.com/typedoc/classes/BABYLON.AbstractMesh#CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY
   * * BABYLON.AbstractMesh.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION can be faster if always visible @see https://doc.babylonjs.com/typedoc/classes/BABYLON.AbstractMesh#CULLINGSTRATEGY_OPTIMISTIC_INCLUSION
   * * BABYLON.AbstractMesh.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION_THEN_BSPHERE_ONLY can be faster if always visible @see https://doc.babylonjs.com/typedoc/classes/BABYLON.AbstractMesh#CULLINGSTRATEGY_OPTIMISTIC_INCLUSION_THEN_BSPHERE_ONLY
   * @returns true if the bounding info is in the frustum planes
   */
  isInFrustum(e, t = 0) {
    return (t === 2 || t === 3) && this.boundingSphere.isCenterInFrustum(e) ? !0 : this.boundingSphere.isInFrustum(e) ? t === 1 || t === 3 ? !0 : this.boundingBox.isInFrustum(e) : !1;
  }
  /**
   * Gets the world distance between the min and max points of the bounding box
   */
  get diagonalLength() {
    const e = this.boundingBox;
    return e.maximumWorld.subtractToRef(e.minimumWorld, $t._TmpVector3[0]).length();
  }
  /**
   * Checks if a cullable object (mesh...) is in the camera frustum
   * Unlike isInFrustum this checks the full bounding box
   * @param frustumPlanes Camera near/planes
   * @returns true if the object is in frustum otherwise false
   */
  isCompletelyInFrustum(e) {
    return this.boundingBox.isCompletelyInFrustum(e);
  }
  /**
   * @internal
   */
  _checkCollision(e) {
    return e._canDoCollision(this.boundingSphere.centerWorld, this.boundingSphere.radiusWorld, this.boundingBox.minimumWorld, this.boundingBox.maximumWorld);
  }
  /**
   * Checks if a point is inside the bounding box and bounding sphere or the mesh
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/interactions/mesh_intersect
   * @param point the point to check intersection with
   * @returns if the point intersects
   */
  intersectsPoint(e) {
    return !(!this.boundingSphere.centerWorld || !this.boundingSphere.intersectsPoint(e) || !this.boundingBox.intersectsPoint(e));
  }
  /**
   * Checks if another bounding info intersects the bounding box and bounding sphere or the mesh
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/interactions/mesh_intersect
   * @param boundingInfo the bounding info to check intersection with
   * @param precise if the intersection should be done using OBB
   * @returns if the bounding info intersects
   */
  intersects(e, t) {
    if (!qi.Intersects(this.boundingSphere, e.boundingSphere) || !yi.Intersects(this.boundingBox, e.boundingBox))
      return !1;
    if (!t)
      return !0;
    const i = this.boundingBox, s = e.boundingBox;
    return !(!Ft(i.directions[0], i, s) || !Ft(i.directions[1], i, s) || !Ft(i.directions[2], i, s) || !Ft(s.directions[0], i, s) || !Ft(s.directions[1], i, s) || !Ft(s.directions[2], i, s) || !Ft(p.Cross(i.directions[0], s.directions[0]), i, s) || !Ft(p.Cross(i.directions[0], s.directions[1]), i, s) || !Ft(p.Cross(i.directions[0], s.directions[2]), i, s) || !Ft(p.Cross(i.directions[1], s.directions[0]), i, s) || !Ft(p.Cross(i.directions[1], s.directions[1]), i, s) || !Ft(p.Cross(i.directions[1], s.directions[2]), i, s) || !Ft(p.Cross(i.directions[2], s.directions[0]), i, s) || !Ft(p.Cross(i.directions[2], s.directions[1]), i, s) || !Ft(p.Cross(i.directions[2], s.directions[2]), i, s));
  }
}
$t._TmpVector3 = ot.BuildArray(2, p.Zero);
class Cr {
  static extractMinAndMaxIndexed(e, t, i, s, r, n) {
    for (let a = i; a < i + s; a++) {
      const o = t[a] * 3, l = e[o], c = e[o + 1], u = e[o + 2];
      r.minimizeInPlaceFromFloats(l, c, u), n.maximizeInPlaceFromFloats(l, c, u);
    }
  }
  static extractMinAndMax(e, t, i, s, r, n) {
    for (let a = t, o = t * s; a < t + i; a++, o += s) {
      const l = e[o], c = e[o + 1], u = e[o + 2];
      r.minimizeInPlaceFromFloats(l, c, u), n.maximizeInPlaceFromFloats(l, c, u);
    }
  }
}
E([
  Ui.filter((...[h, e]) => !Array.isArray(h) && !Array.isArray(e))
  // eslint-disable-next-line @typescript-eslint/naming-convention
], Cr, "extractMinAndMaxIndexed", null);
E([
  Ui.filter((...[h]) => !Array.isArray(h))
  // eslint-disable-next-line @typescript-eslint/naming-convention
], Cr, "extractMinAndMax", null);
function Dl(h, e, t, i, s = null) {
  const r = new p(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE), n = new p(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
  return Cr.extractMinAndMaxIndexed(h, e, t, i, r, n), s && (r.x -= r.x * s.x + s.y, r.y -= r.y * s.x + s.y, r.z -= r.z * s.x + s.y, n.x += n.x * s.x + s.y, n.y += n.y * s.x + s.y, n.z += n.z * s.x + s.y), {
    minimum: r,
    maximum: n
  };
}
function Ga(h, e, t, i = null, s) {
  const r = new p(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE), n = new p(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
  return s || (s = 3), Cr.extractMinAndMax(h, e, t, s, r, n), i && (r.x -= r.x * i.x + i.y, r.y -= r.y * i.x + i.y, r.z -= r.z * i.x + i.y, n.x += n.x * i.x + i.y, n.y += n.y * i.x + i.y, n.z += n.z * i.x + i.y), {
    minimum: r,
    maximum: n
  };
}
class Qt {
  /**
   * Gets material defines used by the effect associated to the sub mesh
   */
  get materialDefines() {
    var e;
    return this._mainDrawWrapperOverride ? this._mainDrawWrapperOverride.defines : (e = this._getDrawWrapper()) === null || e === void 0 ? void 0 : e.defines;
  }
  /**
   * Sets material defines used by the effect associated to the sub mesh
   */
  set materialDefines(e) {
    var t;
    const i = (t = this._mainDrawWrapperOverride) !== null && t !== void 0 ? t : this._getDrawWrapper(void 0, !0);
    i.defines = e;
  }
  /**
   * @internal
   */
  _getDrawWrapper(e, t = !1) {
    e = e ?? this._engine.currentRenderPassId;
    let i = this._drawWrappers[e];
    return !i && t && (this._drawWrappers[e] = i = new xi(this._mesh.getScene().getEngine())), i;
  }
  /**
   * @internal
   */
  _removeDrawWrapper(e, t = !0) {
    var i;
    t && ((i = this._drawWrappers[e]) === null || i === void 0 || i.dispose()), this._drawWrappers[e] = void 0;
  }
  /**
   * Gets associated (main) effect (possibly the effect override if defined)
   */
  get effect() {
    var e, t;
    return this._mainDrawWrapperOverride ? this._mainDrawWrapperOverride.effect : (t = (e = this._getDrawWrapper()) === null || e === void 0 ? void 0 : e.effect) !== null && t !== void 0 ? t : null;
  }
  /** @internal */
  get _drawWrapper() {
    var e;
    return (e = this._mainDrawWrapperOverride) !== null && e !== void 0 ? e : this._getDrawWrapper(void 0, !0);
  }
  /** @internal */
  get _drawWrapperOverride() {
    return this._mainDrawWrapperOverride;
  }
  /**
   * @internal
   */
  _setMainDrawWrapperOverride(e) {
    this._mainDrawWrapperOverride = e;
  }
  /**
   * Sets associated effect (effect used to render this submesh)
   * @param effect defines the effect to associate with
   * @param defines defines the set of defines used to compile this effect
   * @param materialContext material context associated to the effect
   * @param resetContext true to reset the draw context
   */
  setEffect(e, t = null, i, s = !0) {
    const r = this._drawWrapper;
    r.setEffect(e, t, s), i !== void 0 && (r.materialContext = i), e || (r.defines = null, r.materialContext = void 0);
  }
  /**
   * Resets the draw wrappers cache
   * @param passId If provided, releases only the draw wrapper corresponding to this render pass id
   */
  resetDrawCache(e) {
    if (this._drawWrappers)
      if (e !== void 0) {
        this._removeDrawWrapper(e);
        return;
      } else
        for (const t of this._drawWrappers)
          t == null || t.dispose();
    this._drawWrappers = [];
  }
  /**
   * Add a new submesh to a mesh
   * @param materialIndex defines the material index to use
   * @param verticesStart defines vertex index start
   * @param verticesCount defines vertices count
   * @param indexStart defines index start
   * @param indexCount defines indices count
   * @param mesh defines the parent mesh
   * @param renderingMesh defines an optional rendering mesh
   * @param createBoundingBox defines if bounding box should be created for this submesh
   * @returns the new submesh
   */
  static AddToMesh(e, t, i, s, r, n, a, o = !0) {
    return new Qt(e, t, i, s, r, n, a, o);
  }
  /**
   * Creates a new submesh
   * @param materialIndex defines the material index to use
   * @param verticesStart defines vertex index start
   * @param verticesCount defines vertices count
   * @param indexStart defines index start
   * @param indexCount defines indices count
   * @param mesh defines the parent mesh
   * @param renderingMesh defines an optional rendering mesh
   * @param createBoundingBox defines if bounding box should be created for this submesh
   * @param addToMesh defines a boolean indicating that the submesh must be added to the mesh.subMeshes array (true by default)
   */
  constructor(e, t, i, s, r, n, a, o = !0, l = !0) {
    this.materialIndex = e, this.verticesStart = t, this.verticesCount = i, this.indexStart = s, this.indexCount = r, this._mainDrawWrapperOverride = null, this._linesIndexCount = 0, this._linesIndexBuffer = null, this._lastColliderWorldVertices = null, this._lastColliderTransformMatrix = null, this._wasDispatched = !1, this._renderId = 0, this._alphaIndex = 0, this._distanceToCamera = 0, this._currentMaterial = null, this._mesh = n, this._renderingMesh = a || n, l && n.subMeshes.push(this), this._engine = this._mesh.getScene().getEngine(), this.resetDrawCache(), this._trianglePlanes = [], this._id = n.subMeshes.length - 1, o && (this.refreshBoundingInfo(), n.computeWorldMatrix(!0));
  }
  /**
   * Returns true if this submesh covers the entire parent mesh
   * @ignorenaming
   */
  // eslint-disable-next-line @typescript-eslint/naming-convention
  get IsGlobal() {
    return this.verticesStart === 0 && this.verticesCount === this._mesh.getTotalVertices() && this.indexStart === 0 && this.indexCount === this._mesh.getTotalIndices();
  }
  /**
   * Returns the submesh BoundingInfo object
   * @returns current bounding info (or mesh's one if the submesh is global)
   */
  getBoundingInfo() {
    return this.IsGlobal ? this._mesh.getBoundingInfo() : this._boundingInfo;
  }
  /**
   * Sets the submesh BoundingInfo
   * @param boundingInfo defines the new bounding info to use
   * @returns the SubMesh
   */
  setBoundingInfo(e) {
    return this._boundingInfo = e, this;
  }
  /**
   * Returns the mesh of the current submesh
   * @returns the parent mesh
   */
  getMesh() {
    return this._mesh;
  }
  /**
   * Returns the rendering mesh of the submesh
   * @returns the rendering mesh (could be different from parent mesh)
   */
  getRenderingMesh() {
    return this._renderingMesh;
  }
  /**
   * Returns the replacement mesh of the submesh
   * @returns the replacement mesh (could be different from parent mesh)
   */
  getReplacementMesh() {
    return this._mesh._internalAbstractMeshDataInfo._actAsRegularMesh ? this._mesh : null;
  }
  /**
   * Returns the effective mesh of the submesh
   * @returns the effective mesh (could be different from parent mesh)
   */
  getEffectiveMesh() {
    const e = this._mesh._internalAbstractMeshDataInfo._actAsRegularMesh ? this._mesh : null;
    return e || this._renderingMesh;
  }
  /**
   * Returns the submesh material
   * @param getDefaultMaterial Defines whether or not to get the default material if nothing has been defined.
   * @returns null or the current material
   */
  getMaterial(e = !0) {
    var t;
    const i = (t = this._renderingMesh.getMaterialForRenderPass(this._engine.currentRenderPassId)) !== null && t !== void 0 ? t : this._renderingMesh.material;
    if (i) {
      if (this._isMultiMaterial(i)) {
        const s = i.getSubMaterial(this.materialIndex);
        return this._currentMaterial !== s && (this._currentMaterial = s, this.resetDrawCache()), s;
      }
    } else return e ? this._mesh.getScene().defaultMaterial : null;
    return i;
  }
  _isMultiMaterial(e) {
    return e.getSubMaterial !== void 0;
  }
  // Methods
  /**
   * Sets a new updated BoundingInfo object to the submesh
   * @param data defines an optional position array to use to determine the bounding info
   * @returns the SubMesh
   */
  refreshBoundingInfo(e = null) {
    if (this._lastColliderWorldVertices = null, this.IsGlobal || !this._renderingMesh || !this._renderingMesh.geometry)
      return this;
    if (e || (e = this._renderingMesh.getVerticesData(v.PositionKind)), !e)
      return this._boundingInfo = this._mesh.getBoundingInfo(), this;
    const t = this._renderingMesh.getIndices();
    let i;
    if (this.indexStart === 0 && this.indexCount === t.length) {
      const s = this._renderingMesh.getBoundingInfo();
      i = { minimum: s.minimum.clone(), maximum: s.maximum.clone() };
    } else
      i = Dl(e, t, this.indexStart, this.indexCount, this._renderingMesh.geometry.boundingBias);
    return this._boundingInfo ? this._boundingInfo.reConstruct(i.minimum, i.maximum) : this._boundingInfo = new $t(i.minimum, i.maximum), this;
  }
  /**
   * @internal
   */
  _checkCollision(e) {
    return this.getBoundingInfo()._checkCollision(e);
  }
  /**
   * Updates the submesh BoundingInfo
   * @param world defines the world matrix to use to update the bounding info
   * @returns the submesh
   */
  updateBoundingInfo(e) {
    let t = this.getBoundingInfo();
    return t || (this.refreshBoundingInfo(), t = this.getBoundingInfo()), t && t.update(e), this;
  }
  /**
   * True is the submesh bounding box intersects the frustum defined by the passed array of planes.
   * @param frustumPlanes defines the frustum planes
   * @returns true if the submesh is intersecting with the frustum
   */
  isInFrustum(e) {
    const t = this.getBoundingInfo();
    return t ? t.isInFrustum(e, this._mesh.cullingStrategy) : !1;
  }
  /**
   * True is the submesh bounding box is completely inside the frustum defined by the passed array of planes
   * @param frustumPlanes defines the frustum planes
   * @returns true if the submesh is inside the frustum
   */
  isCompletelyInFrustum(e) {
    const t = this.getBoundingInfo();
    return t ? t.isCompletelyInFrustum(e) : !1;
  }
  /**
   * Renders the submesh
   * @param enableAlphaMode defines if alpha needs to be used
   * @returns the submesh
   */
  render(e) {
    return this._renderingMesh.render(this, e, this._mesh._internalAbstractMeshDataInfo._actAsRegularMesh ? this._mesh : void 0), this;
  }
  /**
   * @internal
   */
  _getLinesIndexBuffer(e, t) {
    if (!this._linesIndexBuffer) {
      const i = [];
      for (let s = this.indexStart; s < this.indexStart + this.indexCount; s += 3)
        i.push(e[s], e[s + 1], e[s + 1], e[s + 2], e[s + 2], e[s]);
      this._linesIndexBuffer = t.createIndexBuffer(i), this._linesIndexCount = i.length;
    }
    return this._linesIndexBuffer;
  }
  /**
   * Checks if the submesh intersects with a ray
   * @param ray defines the ray to test
   * @returns true is the passed ray intersects the submesh bounding box
   */
  canIntersects(e) {
    const t = this.getBoundingInfo();
    return t ? e.intersectsBox(t.boundingBox) : !1;
  }
  /**
   * Intersects current submesh with a ray
   * @param ray defines the ray to test
   * @param positions defines mesh's positions array
   * @param indices defines mesh's indices array
   * @param fastCheck defines if the first intersection will be used (and not the closest)
   * @param trianglePredicate defines an optional predicate used to select faces when a mesh intersection is detected
   * @returns intersection info or null if no intersection
   */
  intersects(e, t, i, s, r) {
    const n = this.getMaterial();
    if (!n)
      return null;
    let a = 3, o = !1;
    switch (n.fillMode) {
      case 3:
      case 5:
      case 6:
      case 8:
        return null;
      case 7:
        a = 1, o = !0;
        break;
    }
    return n.fillMode === 4 ? i.length ? this._intersectLines(e, t, i, this._mesh.intersectionThreshold, s) : this._intersectUnIndexedLines(e, t, i, this._mesh.intersectionThreshold, s) : !i.length && this._mesh._unIndexed ? this._intersectUnIndexedTriangles(e, t, i, s, r) : this._intersectTriangles(e, t, i, a, o, s, r);
  }
  /**
   * @internal
   */
  _intersectLines(e, t, i, s, r) {
    let n = null;
    for (let a = this.indexStart; a < this.indexStart + this.indexCount; a += 2) {
      const o = t[i[a]], l = t[i[a + 1]], c = e.intersectionSegment(o, l, s);
      if (!(c < 0) && (r || !n || c < n.distance) && (n = new on(null, null, c), n.faceId = a / 2, r))
        break;
    }
    return n;
  }
  /**
   * @internal
   */
  _intersectUnIndexedLines(e, t, i, s, r) {
    let n = null;
    for (let a = this.verticesStart; a < this.verticesStart + this.verticesCount; a += 2) {
      const o = t[a], l = t[a + 1], c = e.intersectionSegment(o, l, s);
      if (!(c < 0) && (r || !n || c < n.distance) && (n = new on(null, null, c), n.faceId = a / 2, r))
        break;
    }
    return n;
  }
  /**
   * @internal
   */
  _intersectTriangles(e, t, i, s, r, n, a) {
    let o = null, l = -1;
    for (let c = this.indexStart; c < this.indexStart + this.indexCount - (3 - s); c += s) {
      l++;
      const u = i[c], d = i[c + 1], f = i[c + 2];
      if (r && f === 4294967295) {
        c += 2;
        continue;
      }
      const _ = t[u], g = t[d], m = t[f];
      if (!_ || !g || !m || a && !a(_, g, m, e, u, d, f))
        continue;
      const y = e.intersectsTriangle(_, g, m);
      if (y) {
        if (y.distance < 0)
          continue;
        if ((n || !o || y.distance < o.distance) && (o = y, o.faceId = l, n))
          break;
      }
    }
    return o;
  }
  /**
   * @internal
   */
  _intersectUnIndexedTriangles(e, t, i, s, r) {
    let n = null;
    for (let a = this.verticesStart; a < this.verticesStart + this.verticesCount; a += 3) {
      const o = t[a], l = t[a + 1], c = t[a + 2];
      if (r && !r(o, l, c, e, -1, -1, -1))
        continue;
      const u = e.intersectsTriangle(o, l, c);
      if (u) {
        if (u.distance < 0)
          continue;
        if ((s || !n || u.distance < n.distance) && (n = u, n.faceId = a / 3, s))
          break;
      }
    }
    return n;
  }
  /** @internal */
  _rebuild() {
    this._linesIndexBuffer && (this._linesIndexBuffer = null);
  }
  // Clone
  /**
   * Creates a new submesh from the passed mesh
   * @param newMesh defines the new hosting mesh
   * @param newRenderingMesh defines an optional rendering mesh
   * @returns the new submesh
   */
  clone(e, t) {
    const i = new Qt(this.materialIndex, this.verticesStart, this.verticesCount, this.indexStart, this.indexCount, e, t, !1);
    if (!this.IsGlobal) {
      const s = this.getBoundingInfo();
      if (!s)
        return i;
      i._boundingInfo = new $t(s.minimum, s.maximum);
    }
    return i;
  }
  // Dispose
  /**
   * Release associated resources
   */
  dispose() {
    this._linesIndexBuffer && (this._mesh.getScene().getEngine()._releaseBuffer(this._linesIndexBuffer), this._linesIndexBuffer = null);
    const e = this._mesh.subMeshes.indexOf(this);
    this._mesh.subMeshes.splice(e, 1), this.resetDrawCache();
  }
  /**
   * Gets the class name
   * @returns the string "SubMesh".
   */
  getClassName() {
    return "SubMesh";
  }
  // Statics
  /**
   * Creates a new submesh from indices data
   * @param materialIndex the index of the main mesh material
   * @param startIndex the index where to start the copy in the mesh indices array
   * @param indexCount the number of indices to copy then from the startIndex
   * @param mesh the main mesh to create the submesh from
   * @param renderingMesh the optional rendering mesh
   * @param createBoundingBox defines if bounding box should be created for this submesh
   * @returns a new submesh
   */
  static CreateFromIndices(e, t, i, s, r, n = !0) {
    let a = Number.MAX_VALUE, o = -Number.MAX_VALUE;
    const c = (r || s).getIndices();
    for (let u = t; u < t + i; u++) {
      const d = c[u];
      d < a && (a = d), d > o && (o = d);
    }
    return new Qt(e, a, o - a + 1, t, i, s, r, n);
  }
}
class Xr {
}
class q {
  /**
   * Creates a new VertexData
   */
  constructor() {
    this.uniqueId = 0, this._applyTo = Al(this._applyToCoroutine.bind(this)), this.uniqueId = q._UniqueIDGenerator, q._UniqueIDGenerator++;
  }
  /**
   * Uses the passed data array to set the set the values for the specified kind of data
   * @param data a linear array of floating numbers
   * @param kind the type of data that is being set, eg positions, colors etc
   */
  set(e, t) {
    switch (e.length || w.Warn(`Setting vertex data kind '${t}' with an empty array`), t) {
      case v.PositionKind:
        this.positions = e;
        break;
      case v.NormalKind:
        this.normals = e;
        break;
      case v.TangentKind:
        this.tangents = e;
        break;
      case v.UVKind:
        this.uvs = e;
        break;
      case v.UV2Kind:
        this.uvs2 = e;
        break;
      case v.UV3Kind:
        this.uvs3 = e;
        break;
      case v.UV4Kind:
        this.uvs4 = e;
        break;
      case v.UV5Kind:
        this.uvs5 = e;
        break;
      case v.UV6Kind:
        this.uvs6 = e;
        break;
      case v.ColorKind:
        this.colors = e;
        break;
      case v.MatricesIndicesKind:
        this.matricesIndices = e;
        break;
      case v.MatricesWeightsKind:
        this.matricesWeights = e;
        break;
      case v.MatricesIndicesExtraKind:
        this.matricesIndicesExtra = e;
        break;
      case v.MatricesWeightsExtraKind:
        this.matricesWeightsExtra = e;
        break;
    }
  }
  /**
   * Associates the vertexData to the passed Mesh.
   * Sets it as updatable or not (default `false`)
   * @param mesh the mesh the vertexData is applied to
   * @param updatable when used and having the value true allows new data to update the vertexData
   * @returns the VertexData
   */
  applyToMesh(e, t) {
    return this._applyTo(e, t, !1), this;
  }
  /**
   * Associates the vertexData to the passed Geometry.
   * Sets it as updatable or not (default `false`)
   * @param geometry the geometry the vertexData is applied to
   * @param updatable when used and having the value true allows new data to update the vertexData
   * @returns VertexData
   */
  applyToGeometry(e, t) {
    return this._applyTo(e, t, !1), this;
  }
  /**
   * Updates the associated mesh
   * @param mesh the mesh to be updated
   * @returns VertexData
   */
  updateMesh(e) {
    return this._update(e), this;
  }
  /**
   * Updates the associated geometry
   * @param geometry the geometry to be updated
   * @returns VertexData.
   */
  updateGeometry(e) {
    return this._update(e), this;
  }
  /**
   * @internal
   */
  *_applyToCoroutine(e, t = !1, i) {
    if (this.positions && (e.setVerticesData(v.PositionKind, this.positions, t), i && (yield)), this.normals && (e.setVerticesData(v.NormalKind, this.normals, t), i && (yield)), this.tangents && (e.setVerticesData(v.TangentKind, this.tangents, t), i && (yield)), this.uvs && (e.setVerticesData(v.UVKind, this.uvs, t), i && (yield)), this.uvs2 && (e.setVerticesData(v.UV2Kind, this.uvs2, t), i && (yield)), this.uvs3 && (e.setVerticesData(v.UV3Kind, this.uvs3, t), i && (yield)), this.uvs4 && (e.setVerticesData(v.UV4Kind, this.uvs4, t), i && (yield)), this.uvs5 && (e.setVerticesData(v.UV5Kind, this.uvs5, t), i && (yield)), this.uvs6 && (e.setVerticesData(v.UV6Kind, this.uvs6, t), i && (yield)), this.colors && (e.setVerticesData(v.ColorKind, this.colors, t), i && (yield)), this.matricesIndices && (e.setVerticesData(v.MatricesIndicesKind, this.matricesIndices, t), i && (yield)), this.matricesWeights && (e.setVerticesData(v.MatricesWeightsKind, this.matricesWeights, t), i && (yield)), this.matricesIndicesExtra && (e.setVerticesData(v.MatricesIndicesExtraKind, this.matricesIndicesExtra, t), i && (yield)), this.matricesWeightsExtra && (e.setVerticesData(v.MatricesWeightsExtraKind, this.matricesWeightsExtra, t), i && (yield)), this.indices ? (e.setIndices(this.indices, null, t), i && (yield)) : e.setIndices([], null), e.subMeshes && this.materialInfos && this.materialInfos.length > 1) {
      const s = e;
      s.subMeshes = [];
      for (const r of this.materialInfos)
        new Qt(r.materialIndex, r.verticesStart, r.verticesCount, r.indexStart, r.indexCount, s);
    }
    return this;
  }
  _update(e, t, i) {
    return this.positions && e.updateVerticesData(v.PositionKind, this.positions, t, i), this.normals && e.updateVerticesData(v.NormalKind, this.normals, t, i), this.tangents && e.updateVerticesData(v.TangentKind, this.tangents, t, i), this.uvs && e.updateVerticesData(v.UVKind, this.uvs, t, i), this.uvs2 && e.updateVerticesData(v.UV2Kind, this.uvs2, t, i), this.uvs3 && e.updateVerticesData(v.UV3Kind, this.uvs3, t, i), this.uvs4 && e.updateVerticesData(v.UV4Kind, this.uvs4, t, i), this.uvs5 && e.updateVerticesData(v.UV5Kind, this.uvs5, t, i), this.uvs6 && e.updateVerticesData(v.UV6Kind, this.uvs6, t, i), this.colors && e.updateVerticesData(v.ColorKind, this.colors, t, i), this.matricesIndices && e.updateVerticesData(v.MatricesIndicesKind, this.matricesIndices, t, i), this.matricesWeights && e.updateVerticesData(v.MatricesWeightsKind, this.matricesWeights, t, i), this.matricesIndicesExtra && e.updateVerticesData(v.MatricesIndicesExtraKind, this.matricesIndicesExtra, t, i), this.matricesWeightsExtra && e.updateVerticesData(v.MatricesWeightsExtraKind, this.matricesWeightsExtra, t, i), this.indices && e.setIndices(this.indices, null), this;
  }
  static _TransformVector3Coordinates(e, t, i = 0, s = e.length) {
    const r = C.Vector3[0], n = C.Vector3[1];
    for (let a = i; a < i + s; a += 3)
      p.FromArrayToRef(e, a, r), p.TransformCoordinatesToRef(r, t, n), e[a] = n.x, e[a + 1] = n.y, e[a + 2] = n.z;
  }
  static _TransformVector3Normals(e, t, i = 0, s = e.length) {
    const r = C.Vector3[0], n = C.Vector3[1];
    for (let a = i; a < i + s; a += 3)
      p.FromArrayToRef(e, a, r), p.TransformNormalToRef(r, t, n), e[a] = n.x, e[a + 1] = n.y, e[a + 2] = n.z;
  }
  static _TransformVector4Normals(e, t, i = 0, s = e.length) {
    const r = C.Vector4[0], n = C.Vector4[1];
    for (let a = i; a < i + s; a += 4)
      ze.FromArrayToRef(e, a, r), ze.TransformNormalToRef(r, t, n), e[a] = n.x, e[a + 1] = n.y, e[a + 2] = n.z, e[a + 3] = n.w;
  }
  static _FlipFaces(e, t = 0, i = e.length) {
    for (let s = t; s < t + i; s += 3) {
      const r = e[s + 1];
      e[s + 1] = e[s + 2], e[s + 2] = r;
    }
  }
  /**
   * Transforms each position and each normal of the vertexData according to the passed Matrix
   * @param matrix the transforming matrix
   * @returns the VertexData
   */
  transform(e) {
    const t = e.determinant() < 0;
    return this.positions && q._TransformVector3Coordinates(this.positions, e), this.normals && q._TransformVector3Normals(this.normals, e), this.tangents && q._TransformVector4Normals(this.tangents, e), t && this.indices && q._FlipFaces(this.indices), this;
  }
  /**
   * Generates an array of vertex data where each vertex data only has one material info
   * @returns An array of VertexData
   */
  splitBasedOnMaterialID() {
    if (!this.materialInfos || this.materialInfos.length < 2)
      return [this];
    const e = new Array();
    for (const t of this.materialInfos) {
      const i = new q();
      if (this.positions && (i.positions = this.positions.slice(t.verticesStart * 3, (t.verticesCount + t.verticesStart) * 3)), this.normals && (i.normals = this.normals.slice(t.verticesStart * 3, (t.verticesCount + t.verticesStart) * 3)), this.tangents && (i.tangents = this.tangents.slice(t.verticesStart * 4, (t.verticesCount + t.verticesStart) * 4)), this.colors && (i.colors = this.colors.slice(t.verticesStart * 4, (t.verticesCount + t.verticesStart) * 4)), this.uvs && (i.uvs = this.uvs.slice(t.verticesStart * 2, (t.verticesCount + t.verticesStart) * 2)), this.uvs2 && (i.uvs2 = this.uvs2.slice(t.verticesStart * 2, (t.verticesCount + t.verticesStart) * 2)), this.uvs3 && (i.uvs3 = this.uvs3.slice(t.verticesStart * 2, (t.verticesCount + t.verticesStart) * 2)), this.uvs4 && (i.uvs4 = this.uvs4.slice(t.verticesStart * 2, (t.verticesCount + t.verticesStart) * 2)), this.uvs5 && (i.uvs5 = this.uvs5.slice(t.verticesStart * 2, (t.verticesCount + t.verticesStart) * 2)), this.uvs6 && (i.uvs6 = this.uvs6.slice(t.verticesStart * 2, (t.verticesCount + t.verticesStart) * 2)), this.matricesIndices && (i.matricesIndices = this.matricesIndices.slice(t.verticesStart * 4, (t.verticesCount + t.verticesStart) * 4)), this.matricesIndicesExtra && (i.matricesIndicesExtra = this.matricesIndicesExtra.slice(t.verticesStart * 4, (t.verticesCount + t.verticesStart) * 4)), this.matricesWeights && (i.matricesWeights = this.matricesWeights.slice(t.verticesStart * 4, (t.verticesCount + t.verticesStart) * 4)), this.matricesWeightsExtra && (i.matricesWeightsExtra = this.matricesWeightsExtra.slice(t.verticesStart * 4, (t.verticesCount + t.verticesStart) * 4)), this.indices) {
        i.indices = [];
        for (let r = t.indexStart; r < t.indexStart + t.indexCount; r++)
          i.indices.push(this.indices[r] - t.verticesStart);
      }
      const s = new Xr();
      s.indexStart = 0, s.indexCount = i.indices ? i.indices.length : 0, s.materialIndex = t.materialIndex, s.verticesStart = 0, s.verticesCount = (i.positions ? i.positions.length : 0) / 3, i.materialInfos = [s], e.push(i);
    }
    return e;
  }
  /**
   * Merges the passed VertexData into the current one
   * @param others the VertexData to be merged into the current one
   * @param use32BitsIndices defines a boolean indicating if indices must be store in a 32 bits array
   * @param forceCloneIndices defines a boolean indicating if indices are forced to be cloned
   * @param mergeMaterialIds defines a boolean indicating if we need to merge the material infos
   * @param enableCompletion defines a boolean indicating if the vertex data should be completed to be compatible
   * @returns the modified VertexData
   */
  merge(e, t = !1, i = !1, s = !1, r = !1) {
    const n = Array.isArray(e) ? e.map((a) => ({ vertexData: a })) : [{ vertexData: e }];
    return On(this._mergeCoroutine(void 0, n, t, !1, i, s, r));
  }
  /**
   * @internal
   */
  *_mergeCoroutine(e, t, i = !1, s, r, n = !1, a = !1) {
    var o, l, c, u;
    this._validate();
    let d = t.map((y) => y.vertexData), f = this;
    for (const y of d)
      if (y) {
        if (y._validate(), a)
          !this.normals != !y.normals && (this.normals ? y.normals = Array.from(this.normals) : this.normals = Array.from(y.normals)), !this.tangents != !y.tangents && (this.tangents ? y.tangents = Array.from(this.tangents) : this.tangents = Array.from(y.tangents)), !this.uvs != !y.uvs && (this.uvs ? y.uvs = Array.from(this.uvs) : this.uvs = Array.from(y.uvs)), !this.uvs2 != !y.uvs2 && (this.uvs2 ? y.uvs2 = Array.from(this.uvs2) : this.uvs2 = Array.from(y.uvs2)), !this.uvs3 != !y.uvs3 && (this.uvs3 ? y.uvs3 = Array.from(this.uvs3) : this.uvs3 = Array.from(y.uvs3)), !this.uvs4 != !y.uvs4 && (this.uvs4 ? y.uvs4 = Array.from(this.uvs4) : this.uvs4 = Array.from(y.uvs4)), !this.uvs5 != !y.uvs5 && (this.uvs5 ? y.uvs5 = Array.from(this.uvs5) : this.uvs5 = Array.from(y.uvs5)), !this.uvs6 != !y.uvs6 && (this.uvs6 ? y.uvs6 = Array.from(this.uvs6) : this.uvs6 = Array.from(y.uvs6)), !this.colors != !y.colors && (this.colors ? y.colors = Array.from(this.colors) : this.colors = Array.from(y.colors)), !this.matricesIndices != !y.matricesIndices && (this.matricesIndices ? y.matricesIndices = Array.from(this.matricesIndices) : this.matricesIndices = Array.from(y.matricesIndices)), !this.matricesWeights != !y.matricesWeights && (this.matricesWeights ? y.matricesWeights = Array.from(this.matricesWeights) : this.matricesWeights = Array.from(y.matricesWeights)), !this.matricesIndicesExtra != !y.matricesIndicesExtra && (this.matricesIndicesExtra ? y.matricesIndicesExtra = Array.from(this.matricesIndicesExtra) : this.matricesIndicesExtra = Array.from(y.matricesIndicesExtra)), !this.matricesWeightsExtra != !y.matricesWeightsExtra && (this.matricesWeightsExtra ? y.matricesWeightsExtra = Array.from(this.matricesWeightsExtra) : this.matricesWeightsExtra = Array.from(y.matricesWeightsExtra));
        else if (!this.normals != !y.normals || !this.tangents != !y.tangents || !this.uvs != !y.uvs || !this.uvs2 != !y.uvs2 || !this.uvs3 != !y.uvs3 || !this.uvs4 != !y.uvs4 || !this.uvs5 != !y.uvs5 || !this.uvs6 != !y.uvs6 || !this.colors != !y.colors || !this.matricesIndices != !y.matricesIndices || !this.matricesWeights != !y.matricesWeights || !this.matricesIndicesExtra != !y.matricesIndicesExtra || !this.matricesWeightsExtra != !y.matricesWeightsExtra)
          throw new Error("Cannot merge vertex data that do not have the same set of attributes");
      }
    if (n) {
      let y = 0, x = 0, A = 0;
      const T = [];
      let M = null;
      const b = [];
      for (const P of this.splitBasedOnMaterialID())
        b.push({ vertexData: P, transform: e });
      for (const P of t)
        for (const D of P.vertexData.splitBasedOnMaterialID())
          b.push({ vertexData: D, transform: P.transform });
      b.sort((P, D) => {
        const O = P.vertexData.materialInfos ? P.vertexData.materialInfos[0].materialIndex : 0, X = D.vertexData.materialInfos ? D.vertexData.materialInfos[0].materialIndex : 0;
        return O > X ? 1 : O === X ? 0 : -1;
      });
      for (const P of b) {
        const D = P.vertexData;
        if (D.materialInfos ? y = D.materialInfos[0].materialIndex : y = 0, M && M.materialIndex === y)
          M.indexCount += D.indices.length, M.verticesCount += D.positions.length / 3;
        else {
          const O = new Xr();
          O.materialIndex = y, O.indexStart = x, O.indexCount = D.indices.length, O.verticesStart = A, O.verticesCount = D.positions.length / 3, T.push(O), M = O;
        }
        x += D.indices.length, A += D.positions.length / 3;
      }
      const S = b.splice(0, 1)[0];
      f = S.vertexData, e = S.transform, d = b.map((P) => P.vertexData), t = b, this.materialInfos = T;
    }
    const _ = d.reduce((y, x) => {
      var A, T;
      return y + ((T = (A = x.indices) === null || A === void 0 ? void 0 : A.length) !== null && T !== void 0 ? T : 0);
    }, (l = (o = f.indices) === null || o === void 0 ? void 0 : o.length) !== null && l !== void 0 ? l : 0);
    let m = r || d.some((y) => y.indices === f.indices) ? (c = f.indices) === null || c === void 0 ? void 0 : c.slice() : f.indices;
    if (_ > 0) {
      let y = (u = m == null ? void 0 : m.length) !== null && u !== void 0 ? u : 0;
      if (m || (m = new Array(_)), m.length !== _) {
        if (Array.isArray(m))
          m.length = _;
        else {
          const A = i || m instanceof Uint32Array ? new Uint32Array(_) : new Uint16Array(_);
          A.set(m), m = A;
        }
        e && e.determinant() < 0 && q._FlipFaces(m, 0, y);
      }
      let x = f.positions ? f.positions.length / 3 : 0;
      for (const { vertexData: A, transform: T } of t)
        if (A.indices) {
          for (let M = 0; M < A.indices.length; M++)
            m[y + M] = A.indices[M] + x;
          T && T.determinant() < 0 && q._FlipFaces(m, y, A.indices.length), x += A.positions.length / 3, y += A.indices.length, s && (yield);
        }
    }
    return this.indices = m, this.positions = q._MergeElement(v.PositionKind, f.positions, e, t.map((y) => [y.vertexData.positions, y.transform])), s && (yield), f.normals && (this.normals = q._MergeElement(v.NormalKind, f.normals, e, t.map((y) => [y.vertexData.normals, y.transform])), s && (yield)), f.tangents && (this.tangents = q._MergeElement(v.TangentKind, f.tangents, e, t.map((y) => [y.vertexData.tangents, y.transform])), s && (yield)), f.uvs && (this.uvs = q._MergeElement(v.UVKind, f.uvs, e, t.map((y) => [y.vertexData.uvs, y.transform])), s && (yield)), f.uvs2 && (this.uvs2 = q._MergeElement(v.UV2Kind, f.uvs2, e, t.map((y) => [y.vertexData.uvs2, y.transform])), s && (yield)), f.uvs3 && (this.uvs3 = q._MergeElement(v.UV3Kind, f.uvs3, e, t.map((y) => [y.vertexData.uvs3, y.transform])), s && (yield)), f.uvs4 && (this.uvs4 = q._MergeElement(v.UV4Kind, f.uvs4, e, t.map((y) => [y.vertexData.uvs4, y.transform])), s && (yield)), f.uvs5 && (this.uvs5 = q._MergeElement(v.UV5Kind, f.uvs5, e, t.map((y) => [y.vertexData.uvs5, y.transform])), s && (yield)), f.uvs6 && (this.uvs6 = q._MergeElement(v.UV6Kind, f.uvs6, e, t.map((y) => [y.vertexData.uvs6, y.transform])), s && (yield)), f.colors && (this.colors = q._MergeElement(v.ColorKind, f.colors, e, t.map((y) => [y.vertexData.colors, y.transform])), s && (yield)), f.matricesIndices && (this.matricesIndices = q._MergeElement(v.MatricesIndicesKind, f.matricesIndices, e, t.map((y) => [y.vertexData.matricesIndices, y.transform])), s && (yield)), f.matricesWeights && (this.matricesWeights = q._MergeElement(v.MatricesWeightsKind, f.matricesWeights, e, t.map((y) => [y.vertexData.matricesWeights, y.transform])), s && (yield)), f.matricesIndicesExtra && (this.matricesIndicesExtra = q._MergeElement(v.MatricesIndicesExtraKind, f.matricesIndicesExtra, e, t.map((y) => [y.vertexData.matricesIndicesExtra, y.transform])), s && (yield)), f.matricesWeightsExtra && (this.matricesWeightsExtra = q._MergeElement(v.MatricesWeightsExtraKind, f.matricesWeightsExtra, e, t.map((y) => [y.vertexData.matricesWeightsExtra, y.transform]))), this;
  }
  static _MergeElement(e, t, i, s) {
    const r = s.filter((o) => o[0] !== null && o[0] !== void 0);
    if (!t && r.length == 0)
      return t;
    if (!t)
      return this._MergeElement(e, r[0][0], r[0][1], r.slice(1));
    const n = r.reduce((o, l) => o + l[0].length, t.length), a = e === v.PositionKind ? q._TransformVector3Coordinates : e === v.NormalKind ? q._TransformVector3Normals : e === v.TangentKind ? q._TransformVector4Normals : () => {
    };
    if (t instanceof Float32Array) {
      const o = new Float32Array(n);
      o.set(t), i && a(o, i, 0, t.length);
      let l = t.length;
      for (const [c, u] of r)
        o.set(c, l), u && a(o, u, l, c.length), l += c.length;
      return o;
    } else {
      const o = new Array(n);
      for (let c = 0; c < t.length; c++)
        o[c] = t[c];
      i && a(o, i, 0, t.length);
      let l = t.length;
      for (const [c, u] of r) {
        for (let d = 0; d < c.length; d++)
          o[l + d] = c[d];
        u && a(o, u, l, c.length), l += c.length;
      }
      return o;
    }
  }
  _validate() {
    if (!this.positions)
      throw new Ei("Positions are required", Yi.MeshInvalidPositionsError);
    const e = (s, r) => {
      const n = v.DeduceStride(s);
      if (r.length % n !== 0)
        throw new Error("The " + s + "s array count must be a multiple of " + n);
      return r.length / n;
    }, t = e(v.PositionKind, this.positions), i = (s, r) => {
      const n = e(s, r);
      if (n !== t)
        throw new Error("The " + s + "s element count (" + n + ") does not match the positions count (" + t + ")");
    };
    this.normals && i(v.NormalKind, this.normals), this.tangents && i(v.TangentKind, this.tangents), this.uvs && i(v.UVKind, this.uvs), this.uvs2 && i(v.UV2Kind, this.uvs2), this.uvs3 && i(v.UV3Kind, this.uvs3), this.uvs4 && i(v.UV4Kind, this.uvs4), this.uvs5 && i(v.UV5Kind, this.uvs5), this.uvs6 && i(v.UV6Kind, this.uvs6), this.colors && i(v.ColorKind, this.colors), this.matricesIndices && i(v.MatricesIndicesKind, this.matricesIndices), this.matricesWeights && i(v.MatricesWeightsKind, this.matricesWeights), this.matricesIndicesExtra && i(v.MatricesIndicesExtraKind, this.matricesIndicesExtra), this.matricesWeightsExtra && i(v.MatricesWeightsExtraKind, this.matricesWeightsExtra);
  }
  /**
   * Clone the current vertex data
   * @returns a copy of the current data
   */
  clone() {
    const e = this.serialize();
    return q.Parse(e);
  }
  /**
   * Serializes the VertexData
   * @returns a serialized object
   */
  serialize() {
    const e = {};
    if (this.positions && (e.positions = Array.from(this.positions)), this.normals && (e.normals = Array.from(this.normals)), this.tangents && (e.tangents = Array.from(this.tangents)), this.uvs && (e.uvs = Array.from(this.uvs)), this.uvs2 && (e.uvs2 = Array.from(this.uvs2)), this.uvs3 && (e.uvs3 = Array.from(this.uvs3)), this.uvs4 && (e.uvs4 = Array.from(this.uvs4)), this.uvs5 && (e.uvs5 = Array.from(this.uvs5)), this.uvs6 && (e.uvs6 = Array.from(this.uvs6)), this.colors && (e.colors = Array.from(this.colors)), this.matricesIndices && (e.matricesIndices = Array.from(this.matricesIndices), e.matricesIndices._isExpanded = !0), this.matricesWeights && (e.matricesWeights = Array.from(this.matricesWeights)), this.matricesIndicesExtra && (e.matricesIndicesExtra = Array.from(this.matricesIndicesExtra), e.matricesIndicesExtra._isExpanded = !0), this.matricesWeightsExtra && (e.matricesWeightsExtra = Array.from(this.matricesWeightsExtra)), e.indices = Array.from(this.indices), this.materialInfos) {
      e.materialInfos = [];
      for (const t of this.materialInfos) {
        const i = {
          indexStart: t.indexStart,
          indexCount: t.indexCount,
          materialIndex: t.materialIndex,
          verticesStart: t.verticesStart,
          verticesCount: t.verticesCount
        };
        e.materialInfos.push(i);
      }
    }
    return e;
  }
  // Statics
  /**
   * Extracts the vertexData from a mesh
   * @param mesh the mesh from which to extract the VertexData
   * @param copyWhenShared defines if the VertexData must be cloned when shared between multiple meshes, optional, default false
   * @param forceCopy indicating that the VertexData must be cloned, optional, default false
   * @returns the object VertexData associated to the passed mesh
   */
  static ExtractFromMesh(e, t, i) {
    return q._ExtractFrom(e, t, i);
  }
  /**
   * Extracts the vertexData from the geometry
   * @param geometry the geometry from which to extract the VertexData
   * @param copyWhenShared defines if the VertexData must be cloned when the geometry is shared between multiple meshes, optional, default false
   * @param forceCopy indicating that the VertexData must be cloned, optional, default false
   * @returns the object VertexData associated to the passed mesh
   */
  static ExtractFromGeometry(e, t, i) {
    return q._ExtractFrom(e, t, i);
  }
  static _ExtractFrom(e, t, i) {
    const s = new q();
    return e.isVerticesDataPresent(v.PositionKind) && (s.positions = e.getVerticesData(v.PositionKind, t, i)), e.isVerticesDataPresent(v.NormalKind) && (s.normals = e.getVerticesData(v.NormalKind, t, i)), e.isVerticesDataPresent(v.TangentKind) && (s.tangents = e.getVerticesData(v.TangentKind, t, i)), e.isVerticesDataPresent(v.UVKind) && (s.uvs = e.getVerticesData(v.UVKind, t, i)), e.isVerticesDataPresent(v.UV2Kind) && (s.uvs2 = e.getVerticesData(v.UV2Kind, t, i)), e.isVerticesDataPresent(v.UV3Kind) && (s.uvs3 = e.getVerticesData(v.UV3Kind, t, i)), e.isVerticesDataPresent(v.UV4Kind) && (s.uvs4 = e.getVerticesData(v.UV4Kind, t, i)), e.isVerticesDataPresent(v.UV5Kind) && (s.uvs5 = e.getVerticesData(v.UV5Kind, t, i)), e.isVerticesDataPresent(v.UV6Kind) && (s.uvs6 = e.getVerticesData(v.UV6Kind, t, i)), e.isVerticesDataPresent(v.ColorKind) && (s.colors = e.getVerticesData(v.ColorKind, t, i)), e.isVerticesDataPresent(v.MatricesIndicesKind) && (s.matricesIndices = e.getVerticesData(v.MatricesIndicesKind, t, i)), e.isVerticesDataPresent(v.MatricesWeightsKind) && (s.matricesWeights = e.getVerticesData(v.MatricesWeightsKind, t, i)), e.isVerticesDataPresent(v.MatricesIndicesExtraKind) && (s.matricesIndicesExtra = e.getVerticesData(v.MatricesIndicesExtraKind, t, i)), e.isVerticesDataPresent(v.MatricesWeightsExtraKind) && (s.matricesWeightsExtra = e.getVerticesData(v.MatricesWeightsExtraKind, t, i)), s.indices = e.getIndices(t, i), s;
  }
  /**
   * Creates the VertexData for a Ribbon
   * @param options an object used to set the following optional parameters for the ribbon, required but can be empty
   * * pathArray array of paths, each of which an array of successive Vector3
   * * closeArray creates a seam between the first and the last paths of the pathArray, optional, default false
   * * closePath creates a seam between the first and the last points of each path of the path array, optional, default false
   * * offset a positive integer, only used when pathArray contains a single path (offset = 10 means the point 1 is joined to the point 11), default rounded half size of the pathArray length
   * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
   * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
   * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
   * * invertUV swaps in the U and V coordinates when applying a texture, optional, default false
   * * uvs a linear array, of length 2 * number of vertices, of custom UV values, optional
   * * colors a linear array, of length 4 * number of vertices, of custom color values, optional
   * @param options.pathArray
   * @param options.closeArray
   * @param options.closePath
   * @param options.offset
   * @param options.sideOrientation
   * @param options.frontUVs
   * @param options.backUVs
   * @param options.invertUV
   * @param options.uvs
   * @param options.colors
   * @returns the VertexData of the ribbon
   * @deprecated use CreateRibbonVertexData instead
   */
  static CreateRibbon(e) {
    throw he("ribbonBuilder");
  }
  /**
   * Creates the VertexData for a box
   * @param options an object used to set the following optional parameters for the box, required but can be empty
   * * size sets the width, height and depth of the box to the value of size, optional default 1
   * * width sets the width (x direction) of the box, overwrites the width set by size, optional, default size
   * * height sets the height (y direction) of the box, overwrites the height set by size, optional, default size
   * * depth sets the depth (z direction) of the box, overwrites the depth set by size, optional, default size
   * * faceUV an array of 6 Vector4 elements used to set different images to each box side
   * * faceColors an array of 6 Color3 elements used to set different colors to each box side
   * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
   * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
   * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
   * @param options.size
   * @param options.width
   * @param options.height
   * @param options.depth
   * @param options.faceUV
   * @param options.faceColors
   * @param options.sideOrientation
   * @param options.frontUVs
   * @param options.backUVs
   * @returns the VertexData of the box
   * @deprecated Please use CreateBoxVertexData from the BoxBuilder file instead
   */
  static CreateBox(e) {
    throw he("boxBuilder");
  }
  /**
   * Creates the VertexData for a tiled box
   * @param options an object used to set the following optional parameters for the box, required but can be empty
   * * faceTiles sets the pattern, tile size and number of tiles for a face
   * * faceUV an array of 6 Vector4 elements used to set different images to each box side
   * * faceColors an array of 6 Color3 elements used to set different colors to each box side
   * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
   * @param options.pattern
   * @param options.width
   * @param options.height
   * @param options.depth
   * @param options.tileSize
   * @param options.tileWidth
   * @param options.tileHeight
   * @param options.alignHorizontal
   * @param options.alignVertical
   * @param options.faceUV
   * @param options.faceColors
   * @param options.sideOrientation
   * @returns the VertexData of the box
   * @deprecated Please use CreateTiledBoxVertexData instead
   */
  static CreateTiledBox(e) {
    throw he("tiledBoxBuilder");
  }
  /**
   * Creates the VertexData for a tiled plane
   * @param options an object used to set the following optional parameters for the box, required but can be empty
   * * pattern a limited pattern arrangement depending on the number
   * * tileSize sets the width, height and depth of the tile to the value of size, optional default 1
   * * tileWidth sets the width (x direction) of the tile, overwrites the width set by size, optional, default size
   * * tileHeight sets the height (y direction) of the tile, overwrites the height set by size, optional, default size
   * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
   * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
   * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
   * @param options.pattern
   * @param options.tileSize
   * @param options.tileWidth
   * @param options.tileHeight
   * @param options.size
   * @param options.width
   * @param options.height
   * @param options.alignHorizontal
   * @param options.alignVertical
   * @param options.sideOrientation
   * @param options.frontUVs
   * @param options.backUVs
   * @returns the VertexData of the tiled plane
   * @deprecated use CreateTiledPlaneVertexData instead
   */
  static CreateTiledPlane(e) {
    throw he("tiledPlaneBuilder");
  }
  /**
   * Creates the VertexData for an ellipsoid, defaults to a sphere
   * @param options an object used to set the following optional parameters for the box, required but can be empty
   * * segments sets the number of horizontal strips optional, default 32
   * * diameter sets the axes dimensions, diameterX, diameterY and diameterZ to the value of diameter, optional default 1
   * * diameterX sets the diameterX (x direction) of the ellipsoid, overwrites the diameterX set by diameter, optional, default diameter
   * * diameterY sets the diameterY (y direction) of the ellipsoid, overwrites the diameterY set by diameter, optional, default diameter
   * * diameterZ sets the diameterZ (z direction) of the ellipsoid, overwrites the diameterZ set by diameter, optional, default diameter
   * * arc a number from 0 to 1, to create an unclosed ellipsoid based on the fraction of the circumference (latitude) given by the arc value, optional, default 1
   * * slice a number from 0 to 1, to create an unclosed ellipsoid based on the fraction of the height (latitude) given by the arc value, optional, default 1
   * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
   * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
   * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
   * @param options.segments
   * @param options.diameter
   * @param options.diameterX
   * @param options.diameterY
   * @param options.diameterZ
   * @param options.arc
   * @param options.slice
   * @param options.sideOrientation
   * @param options.frontUVs
   * @param options.backUVs
   * @returns the VertexData of the ellipsoid
   * @deprecated use CreateSphereVertexData instead
   */
  static CreateSphere(e) {
    throw he("sphereBuilder");
  }
  /**
   * Creates the VertexData for a cylinder, cone or prism
   * @param options an object used to set the following optional parameters for the box, required but can be empty
   * * height sets the height (y direction) of the cylinder, optional, default 2
   * * diameterTop sets the diameter of the top of the cone, overwrites diameter,  optional, default diameter
   * * diameterBottom sets the diameter of the bottom of the cone, overwrites diameter,  optional, default diameter
   * * diameter sets the diameter of the top and bottom of the cone, optional default 1
   * * tessellation the number of prism sides, 3 for a triangular prism, optional, default 24
   * * subdivisions` the number of rings along the cylinder height, optional, default 1
   * * arc a number from 0 to 1, to create an unclosed cylinder based on the fraction of the circumference given by the arc value, optional, default 1
   * * faceColors an array of Color3 elements used to set different colors to the top, rings and bottom respectively
   * * faceUV an array of Vector4 elements used to set different images to the top, rings and bottom respectively
   * * hasRings when true makes each subdivision independently treated as a face for faceUV and faceColors, optional, default false
   * * enclose when true closes an open cylinder by adding extra flat faces between the height axis and vertical edges, think cut cake
   * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
   * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
   * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
   * @param options.height
   * @param options.diameterTop
   * @param options.diameterBottom
   * @param options.diameter
   * @param options.tessellation
   * @param options.subdivisions
   * @param options.arc
   * @param options.faceColors
   * @param options.faceUV
   * @param options.hasRings
   * @param options.enclose
   * @param options.sideOrientation
   * @param options.frontUVs
   * @param options.backUVs
   * @returns the VertexData of the cylinder, cone or prism
   * @deprecated please use CreateCylinderVertexData instead
   */
  static CreateCylinder(e) {
    throw he("cylinderBuilder");
  }
  /**
   * Creates the VertexData for a torus
   * @param options an object used to set the following optional parameters for the box, required but can be empty
   * * diameter the diameter of the torus, optional default 1
   * * thickness the diameter of the tube forming the torus, optional default 0.5
   * * tessellation the number of prism sides, 3 for a triangular prism, optional, default 24
   * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
   * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
   * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
   * @param options.diameter
   * @param options.thickness
   * @param options.tessellation
   * @param options.sideOrientation
   * @param options.frontUVs
   * @param options.backUVs
   * @returns the VertexData of the torus
   * @deprecated use CreateTorusVertexData instead
   */
  static CreateTorus(e) {
    throw he("torusBuilder");
  }
  /**
   * Creates the VertexData of the LineSystem
   * @param options an object used to set the following optional parameters for the LineSystem, required but can be empty
   *  - lines an array of lines, each line being an array of successive Vector3
   *  - colors an array of line colors, each of the line colors being an array of successive Color4, one per line point
   * @param options.lines
   * @param options.colors
   * @returns the VertexData of the LineSystem
   * @deprecated use CreateLineSystemVertexData instead
   */
  static CreateLineSystem(e) {
    throw he("linesBuilder");
  }
  /**
   * Create the VertexData for a DashedLines
   * @param options an object used to set the following optional parameters for the DashedLines, required but can be empty
   *  - points an array successive Vector3
   *  - dashSize the size of the dashes relative to the dash number, optional, default 3
   *  - gapSize the size of the gap between two successive dashes relative to the dash number, optional, default 1
   *  - dashNb the intended total number of dashes, optional, default 200
   * @param options.points
   * @param options.dashSize
   * @param options.gapSize
   * @param options.dashNb
   * @returns the VertexData for the DashedLines
   * @deprecated use CreateDashedLinesVertexData instead
   */
  static CreateDashedLines(e) {
    throw he("linesBuilder");
  }
  /**
   * Creates the VertexData for a Ground
   * @param options an object used to set the following optional parameters for the Ground, required but can be empty
   *  - width the width (x direction) of the ground, optional, default 1
   *  - height the height (z direction) of the ground, optional, default 1
   *  - subdivisions the number of subdivisions per side, optional, default 1
   * @param options.width
   * @param options.height
   * @param options.subdivisions
   * @param options.subdivisionsX
   * @param options.subdivisionsY
   * @returns the VertexData of the Ground
   * @deprecated Please use CreateGroundVertexData instead
   */
  static CreateGround(e) {
    throw he("groundBuilder");
  }
  /**
   * Creates the VertexData for a TiledGround by subdividing the ground into tiles
   * @param options an object used to set the following optional parameters for the Ground, required but can be empty
   * * xmin the ground minimum X coordinate, optional, default -1
   * * zmin the ground minimum Z coordinate, optional, default -1
   * * xmax the ground maximum X coordinate, optional, default 1
   * * zmax the ground maximum Z coordinate, optional, default 1
   * * subdivisions a javascript object {w: positive integer, h: positive integer}, `w` and `h` are the numbers of subdivisions on the ground width and height creating 'tiles', default {w: 6, h: 6}
   * * precision a javascript object {w: positive integer, h: positive integer}, `w` and `h` are the numbers of subdivisions on the tile width and height, default {w: 2, h: 2}
   * @param options.xmin
   * @param options.zmin
   * @param options.xmax
   * @param options.zmax
   * @param options.subdivisions
   * @param options.subdivisions.w
   * @param options.subdivisions.h
   * @param options.precision
   * @param options.precision.w
   * @param options.precision.h
   * @returns the VertexData of the TiledGround
   * @deprecated use CreateTiledGroundVertexData instead
   */
  static CreateTiledGround(e) {
    throw he("groundBuilder");
  }
  /**
   * Creates the VertexData of the Ground designed from a heightmap
   * @param options an object used to set the following parameters for the Ground, required and provided by CreateGroundFromHeightMap
   * * width the width (x direction) of the ground
   * * height the height (z direction) of the ground
   * * subdivisions the number of subdivisions per side
   * * minHeight the minimum altitude on the ground, optional, default 0
   * * maxHeight the maximum altitude on the ground, optional default 1
   * * colorFilter the filter to apply to the image pixel colors to compute the height, optional Color3, default (0.3, 0.59, 0.11)
   * * buffer the array holding the image color data
   * * bufferWidth the width of image
   * * bufferHeight the height of image
   * * alphaFilter Remove any data where the alpha channel is below this value, defaults 0 (all data visible)
   * @param options.width
   * @param options.height
   * @param options.subdivisions
   * @param options.minHeight
   * @param options.maxHeight
   * @param options.colorFilter
   * @param options.buffer
   * @param options.bufferWidth
   * @param options.bufferHeight
   * @param options.alphaFilter
   * @returns the VertexData of the Ground designed from a heightmap
   * @deprecated use CreateGroundFromHeightMapVertexData instead
   */
  static CreateGroundFromHeightMap(e) {
    throw he("groundBuilder");
  }
  /**
   * Creates the VertexData for a Plane
   * @param options an object used to set the following optional parameters for the plane, required but can be empty
   * * size sets the width and height of the plane to the value of size, optional default 1
   * * width sets the width (x direction) of the plane, overwrites the width set by size, optional, default size
   * * height sets the height (y direction) of the plane, overwrites the height set by size, optional, default size
   * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
   * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
   * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
   * @param options.size
   * @param options.width
   * @param options.height
   * @param options.sideOrientation
   * @param options.frontUVs
   * @param options.backUVs
   * @returns the VertexData of the box
   * @deprecated use CreatePlaneVertexData instead
   */
  static CreatePlane(e) {
    throw he("planeBuilder");
  }
  /**
   * Creates the VertexData of the Disc or regular Polygon
   * @param options an object used to set the following optional parameters for the disc, required but can be empty
   * * radius the radius of the disc, optional default 0.5
   * * tessellation the number of polygon sides, optional, default 64
   * * arc a number from 0 to 1, to create an unclosed polygon based on the fraction of the circumference given by the arc value, optional, default 1
   * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
   * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
   * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
   * @param options.radius
   * @param options.tessellation
   * @param options.arc
   * @param options.sideOrientation
   * @param options.frontUVs
   * @param options.backUVs
   * @returns the VertexData of the box
   * @deprecated use CreateDiscVertexData instead
   */
  static CreateDisc(e) {
    throw he("discBuilder");
  }
  /**
   * Creates the VertexData for an irregular Polygon in the XoZ plane using a mesh built by polygonTriangulation.build()
   * All parameters are provided by CreatePolygon as needed
   * @param polygon a mesh built from polygonTriangulation.build()
   * @param sideOrientation takes the values Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
   * @param fUV an array of Vector4 elements used to set different images to the top, rings and bottom respectively
   * @param fColors an array of Color3 elements used to set different colors to the top, rings and bottom respectively
   * @param frontUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
   * @param backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
   * @param wrap a boolean, default false, when true and fUVs used texture is wrapped around all sides, when false texture is applied side
   * @returns the VertexData of the Polygon
   * @deprecated use CreatePolygonVertexData instead
   */
  static CreatePolygon(e, t, i, s, r, n, a) {
    throw he("polygonBuilder");
  }
  /**
   * Creates the VertexData of the IcoSphere
   * @param options an object used to set the following optional parameters for the IcoSphere, required but can be empty
   * * radius the radius of the IcoSphere, optional default 1
   * * radiusX allows stretching in the x direction, optional, default radius
   * * radiusY allows stretching in the y direction, optional, default radius
   * * radiusZ allows stretching in the z direction, optional, default radius
   * * flat when true creates a flat shaded mesh, optional, default true
   * * subdivisions increasing the subdivisions increases the number of faces, optional, default 4
   * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
   * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
   * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
   * @param options.radius
   * @param options.radiusX
   * @param options.radiusY
   * @param options.radiusZ
   * @param options.flat
   * @param options.subdivisions
   * @param options.sideOrientation
   * @param options.frontUVs
   * @param options.backUVs
   * @returns the VertexData of the IcoSphere
   * @deprecated use CreateIcoSphereVertexData instead
   */
  static CreateIcoSphere(e) {
    throw he("icoSphereBuilder");
  }
  // inspired from // http://stemkoski.github.io/Three.js/Polyhedra.html
  /**
   * Creates the VertexData for a Polyhedron
   * @param options an object used to set the following optional parameters for the polyhedron, required but can be empty
   * * type provided types are:
   *  * 0 : Tetrahedron, 1 : Octahedron, 2 : Dodecahedron, 3 : Icosahedron, 4 : Rhombicuboctahedron, 5 : Triangular Prism, 6 : Pentagonal Prism, 7 : Hexagonal Prism, 8 : Square Pyramid (J1)
   *  * 9 : Pentagonal Pyramid (J2), 10 : Triangular Dipyramid (J12), 11 : Pentagonal Dipyramid (J13), 12 : Elongated Square Dipyramid (J15), 13 : Elongated Pentagonal Dipyramid (J16), 14 : Elongated Pentagonal Cupola (J20)
   * * size the size of the IcoSphere, optional default 1
   * * sizeX allows stretching in the x direction, optional, default size
   * * sizeY allows stretching in the y direction, optional, default size
   * * sizeZ allows stretching in the z direction, optional, default size
   * * custom a number that overwrites the type to create from an extended set of polyhedron from https://www.babylonjs-playground.com/#21QRSK#15 with minimised editor
   * * faceUV an array of Vector4 elements used to set different images to the top, rings and bottom respectively
   * * faceColors an array of Color3 elements used to set different colors to the top, rings and bottom respectively
   * * flat when true creates a flat shaded mesh, optional, default true
   * * subdivisions increasing the subdivisions increases the number of faces, optional, default 4
   * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
   * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
   * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
   * @param options.type
   * @param options.size
   * @param options.sizeX
   * @param options.sizeY
   * @param options.sizeZ
   * @param options.custom
   * @param options.faceUV
   * @param options.faceColors
   * @param options.flat
   * @param options.sideOrientation
   * @param options.frontUVs
   * @param options.backUVs
   * @returns the VertexData of the Polyhedron
   * @deprecated use CreatePolyhedronVertexData instead
   */
  static CreatePolyhedron(e) {
    throw he("polyhedronBuilder");
  }
  /**
   * Creates the VertexData for a Capsule, inspired from https://github.com/maximeq/three-js-capsule-geometry/blob/master/src/CapsuleBufferGeometry.js
   * @param options an object used to set the following optional parameters for the capsule, required but can be empty
   * @returns the VertexData of the Capsule
   * @deprecated Please use CreateCapsuleVertexData from the capsuleBuilder file instead
   */
  static CreateCapsule(e = {
    orientation: p.Up(),
    subdivisions: 2,
    tessellation: 16,
    height: 1,
    radius: 0.25,
    capSubdivisions: 6
  }) {
    throw he("capsuleBuilder");
  }
  // based on http://code.google.com/p/away3d/source/browse/trunk/fp10/Away3D/src/away3d/primitives/TorusKnot.as?spec=svn2473&r=2473
  /**
   * Creates the VertexData for a TorusKnot
   * @param options an object used to set the following optional parameters for the TorusKnot, required but can be empty
   * * radius the radius of the torus knot, optional, default 2
   * * tube the thickness of the tube, optional, default 0.5
   * * radialSegments the number of sides on each tube segments, optional, default 32
   * * tubularSegments the number of tubes to decompose the knot into, optional, default 32
   * * p the number of windings around the z axis, optional,  default 2
   * * q the number of windings around the x axis, optional,  default 3
   * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
   * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
   * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
   * @param options.radius
   * @param options.tube
   * @param options.radialSegments
   * @param options.tubularSegments
   * @param options.p
   * @param options.q
   * @param options.sideOrientation
   * @param options.frontUVs
   * @param options.backUVs
   * @returns the VertexData of the Torus Knot
   * @deprecated use CreateTorusKnotVertexData instead
   */
  static CreateTorusKnot(e) {
    throw he("torusKnotBuilder");
  }
  // Tools
  /**
   * Compute normals for given positions and indices
   * @param positions an array of vertex positions, [...., x, y, z, ......]
   * @param indices an array of indices in groups of three for each triangular facet, [...., i, j, k, ......]
   * @param normals an array of vertex normals, [...., x, y, z, ......]
   * @param options an object used to set the following optional parameters for the TorusKnot, optional
   * * facetNormals : optional array of facet normals (vector3)
   * * facetPositions : optional array of facet positions (vector3)
   * * facetPartitioning : optional partitioning array. facetPositions is required for facetPartitioning computation
   * * ratio : optional partitioning ratio / bounding box, required for facetPartitioning computation
   * * bInfo : optional bounding info, required for facetPartitioning computation
   * * bbSize : optional bounding box size data, required for facetPartitioning computation
   * * subDiv : optional partitioning data about subdivisions on  each axis (int), required for facetPartitioning computation
   * * useRightHandedSystem: optional boolean to for right handed system computation
   * * depthSort : optional boolean to enable the facet depth sort computation
   * * distanceTo : optional Vector3 to compute the facet depth from this location
   * * depthSortedFacets : optional array of depthSortedFacets to store the facet distances from the reference location
   * @param options.facetNormals
   * @param options.facetPositions
   * @param options.facetPartitioning
   * @param options.ratio
   * @param options.bInfo
   * @param options.bbSize
   * @param options.subDiv
   * @param options.useRightHandedSystem
   * @param options.depthSort
   * @param options.distanceTo
   * @param options.depthSortedFacets
   */
  static ComputeNormals(e, t, i, s) {
    let r = 0, n = 0, a = 0, o = 0, l = 0, c = 0, u = 0, d = 0, f = 0, _ = 0, g = 0, m = 0, y = 0, x = 0, A = 0, T = 0, M = 0, b = 0, S = 0, P = 0, D = !1, O = !1, X = !1, k = !1, Y = 1, se = 0, Te = null;
    s && (D = !!s.facetNormals, O = !!s.facetPositions, X = !!s.facetPartitioning, Y = s.useRightHandedSystem === !0 ? -1 : 1, se = s.ratio || 0, k = !!s.depthSort, Te = s.distanceTo, k && Te === void 0 && (Te = p.Zero()));
    let ve = 0, Oe = 0, Ne = 0, ke = 0;
    for (X && s && s.bbSize && (ve = s.subDiv.X * se / s.bbSize.x, Oe = s.subDiv.Y * se / s.bbSize.y, Ne = s.subDiv.Z * se / s.bbSize.z, ke = s.subDiv.max * s.subDiv.max, s.facetPartitioning.length = 0), r = 0; r < e.length; r++)
      i[r] = 0;
    const Se = t.length / 3 | 0;
    for (r = 0; r < Se; r++) {
      if (m = t[r * 3] * 3, y = m + 1, x = m + 2, A = t[r * 3 + 1] * 3, T = A + 1, M = A + 2, b = t[r * 3 + 2] * 3, S = b + 1, P = b + 2, n = e[m] - e[A], a = e[y] - e[T], o = e[x] - e[M], l = e[b] - e[A], c = e[S] - e[T], u = e[P] - e[M], d = Y * (a * u - o * c), f = Y * (o * l - n * u), _ = Y * (n * c - a * l), g = Math.sqrt(d * d + f * f + _ * _), g = g === 0 ? 1 : g, d /= g, f /= g, _ /= g, D && s && (s.facetNormals[r].x = d, s.facetNormals[r].y = f, s.facetNormals[r].z = _), O && s && (s.facetPositions[r].x = (e[m] + e[A] + e[b]) / 3, s.facetPositions[r].y = (e[y] + e[T] + e[S]) / 3, s.facetPositions[r].z = (e[x] + e[M] + e[P]) / 3), X && s) {
        const Be = Math.floor((s.facetPositions[r].x - s.bInfo.minimum.x * se) * ve), Me = Math.floor((s.facetPositions[r].y - s.bInfo.minimum.y * se) * Oe), je = Math.floor((s.facetPositions[r].z - s.bInfo.minimum.z * se) * Ne), Rt = Math.floor((e[m] - s.bInfo.minimum.x * se) * ve), oi = Math.floor((e[y] - s.bInfo.minimum.y * se) * Oe), Mt = Math.floor((e[x] - s.bInfo.minimum.z * se) * Ne), it = Math.floor((e[A] - s.bInfo.minimum.x * se) * ve), Xt = Math.floor((e[T] - s.bInfo.minimum.y * se) * Oe), xt = Math.floor((e[M] - s.bInfo.minimum.z * se) * Ne), Ht = Math.floor((e[b] - s.bInfo.minimum.x * se) * ve), Fe = Math.floor((e[S] - s.bInfo.minimum.y * se) * Oe), ce = Math.floor((e[P] - s.bInfo.minimum.z * se) * Ne), tt = Rt + s.subDiv.max * oi + ke * Mt, Ot = it + s.subDiv.max * Xt + ke * xt, ft = Ht + s.subDiv.max * Fe + ke * ce, It = Be + s.subDiv.max * Me + ke * je;
        s.facetPartitioning[It] = s.facetPartitioning[It] ? s.facetPartitioning[It] : new Array(), s.facetPartitioning[tt] = s.facetPartitioning[tt] ? s.facetPartitioning[tt] : new Array(), s.facetPartitioning[Ot] = s.facetPartitioning[Ot] ? s.facetPartitioning[Ot] : new Array(), s.facetPartitioning[ft] = s.facetPartitioning[ft] ? s.facetPartitioning[ft] : new Array(), s.facetPartitioning[tt].push(r), Ot != tt && s.facetPartitioning[Ot].push(r), ft == Ot || ft == tt || s.facetPartitioning[ft].push(r), It == tt || It == Ot || It == ft || s.facetPartitioning[It].push(r);
      }
      if (k && s && s.facetPositions) {
        const Be = s.depthSortedFacets[r];
        Be.ind = r * 3, Be.sqDistance = p.DistanceSquared(s.facetPositions[r], Te);
      }
      i[m] += d, i[y] += f, i[x] += _, i[A] += d, i[T] += f, i[M] += _, i[b] += d, i[S] += f, i[P] += _;
    }
    for (r = 0; r < i.length / 3; r++)
      d = i[r * 3], f = i[r * 3 + 1], _ = i[r * 3 + 2], g = Math.sqrt(d * d + f * f + _ * _), g = g === 0 ? 1 : g, d /= g, f /= g, _ /= g, i[r * 3] = d, i[r * 3 + 1] = f, i[r * 3 + 2] = _;
  }
  /**
   * @internal
   */
  static _ComputeSides(e, t, i, s, r, n, a) {
    const o = i.length, l = s.length;
    let c, u;
    switch (e = e || q.DEFAULTSIDE, e) {
      case q.FRONTSIDE:
        break;
      case q.BACKSIDE:
        for (c = 0; c < o; c += 3) {
          const d = i[c];
          i[c] = i[c + 2], i[c + 2] = d;
        }
        for (u = 0; u < l; u++)
          s[u] = -s[u];
        break;
      case q.DOUBLESIDE: {
        const d = t.length, f = d / 3;
        for (let m = 0; m < d; m++)
          t[d + m] = t[m];
        for (c = 0; c < o; c += 3)
          i[c + o] = i[c + 2] + f, i[c + 1 + o] = i[c + 1] + f, i[c + 2 + o] = i[c] + f;
        for (u = 0; u < l; u++)
          s[l + u] = -s[u];
        const _ = r.length;
        let g = 0;
        for (g = 0; g < _; g++)
          r[g + _] = r[g];
        for (n = n || new ze(0, 0, 1, 1), a = a || new ze(0, 0, 1, 1), g = 0, c = 0; c < _ / 2; c++)
          r[g] = n.x + (n.z - n.x) * r[g], r[g + 1] = n.y + (n.w - n.y) * r[g + 1], r[g + _] = a.x + (a.z - a.x) * r[g + _], r[g + _ + 1] = a.y + (a.w - a.y) * r[g + _ + 1], g += 2;
        break;
      }
    }
  }
  /**
   * Creates a VertexData from serialized data
   * @param parsedVertexData the parsed data from an imported file
   * @returns a VertexData
   */
  static Parse(e) {
    const t = new q(), i = e.positions;
    i && t.set(i, v.PositionKind);
    const s = e.normals;
    s && t.set(s, v.NormalKind);
    const r = e.tangents;
    r && t.set(r, v.TangentKind);
    const n = e.uvs;
    n && t.set(n, v.UVKind);
    const a = e.uvs2;
    a && t.set(a, v.UV2Kind);
    const o = e.uvs3;
    o && t.set(o, v.UV3Kind);
    const l = e.uvs4;
    l && t.set(l, v.UV4Kind);
    const c = e.uvs5;
    c && t.set(c, v.UV5Kind);
    const u = e.uvs6;
    u && t.set(u, v.UV6Kind);
    const d = e.colors;
    d && t.set(ye.CheckColors4(d, i.length / 3), v.ColorKind);
    const f = e.matricesIndices;
    f && t.set(f, v.MatricesIndicesKind);
    const _ = e.matricesWeights;
    _ && t.set(_, v.MatricesWeightsKind);
    const g = e.indices;
    g && (t.indices = g);
    const m = e.materialInfos;
    if (m) {
      t.materialInfos = [];
      for (const y of m) {
        const x = new Xr();
        x.indexCount = y.indexCount, x.indexStart = y.indexStart, x.verticesCount = y.verticesCount, x.verticesStart = y.verticesStart, x.materialIndex = y.materialIndex, t.materialInfos.push(x);
      }
    }
    return t;
  }
  /**
   * Applies VertexData created from the imported parameters to the geometry
   * @param parsedVertexData the parsed data from an imported file
   * @param geometry the geometry to apply the VertexData to
   */
  static ImportVertexData(e, t) {
    const i = q.Parse(e);
    t.setAllVerticesData(i, e.updatable);
  }
}
q.FRONTSIDE = 0;
q.BACKSIDE = 1;
q.DOUBLESIDE = 2;
q.DEFAULTSIDE = 0;
q._UniqueIDGenerator = 0;
E([
  Ui.filter((...[h]) => !Array.isArray(h))
], q, "_TransformVector3Coordinates", null);
E([
  Ui.filter((...[h]) => !Array.isArray(h))
], q, "_TransformVector3Normals", null);
E([
  Ui.filter((...[h]) => !Array.isArray(h))
], q, "_TransformVector4Normals", null);
E([
  Ui.filter((...[h]) => !Array.isArray(h))
], q, "_FlipFaces", null);
class st {
  /**
   * Gets or sets a boolean indicating if entire scene must be loaded even if scene contains incremental data
   */
  static get ForceFullSceneLoadingForIncremental() {
    return st._ForceFullSceneLoadingForIncremental;
  }
  static set ForceFullSceneLoadingForIncremental(e) {
    st._ForceFullSceneLoadingForIncremental = e;
  }
  /**
   * Gets or sets a boolean indicating if loading screen must be displayed while loading a scene
   */
  static get ShowLoadingScreen() {
    return st._ShowLoadingScreen;
  }
  static set ShowLoadingScreen(e) {
    st._ShowLoadingScreen = e;
  }
  /**
   * Defines the current logging level (while loading the scene)
   * @ignorenaming
   */
  // eslint-disable-next-line @typescript-eslint/naming-convention
  static get loggingLevel() {
    return st._LoggingLevel;
  }
  // eslint-disable-next-line @typescript-eslint/naming-convention
  static set loggingLevel(e) {
    st._LoggingLevel = e;
  }
  /**
   * Gets or set a boolean indicating if matrix weights must be cleaned upon loading
   */
  static get CleanBoneMatrixWeights() {
    return st._CleanBoneMatrixWeights;
  }
  static set CleanBoneMatrixWeights(e) {
    st._CleanBoneMatrixWeights = e;
  }
}
st._ForceFullSceneLoadingForIncremental = !1;
st._ShowLoadingScreen = !0;
st._CleanBoneMatrixWeights = !1;
st._LoggingLevel = 0;
class ct {
}
ct.UseOpenGLOrientationForUV = !1;
class Ct {
  /**
   *  Gets or sets the Bias Vector to apply on the bounding elements (box/sphere), the max extend is computed as v += v * bias.x + bias.y, the min is computed as v -= v * bias.x + bias.y
   */
  get boundingBias() {
    return this._boundingBias;
  }
  /**
   *  Gets or sets the Bias Vector to apply on the bounding elements (box/sphere), the max extend is computed as v += v * bias.x + bias.y, the min is computed as v -= v * bias.x + bias.y
   */
  set boundingBias(e) {
    this._boundingBias ? this._boundingBias.copyFrom(e) : this._boundingBias = e.clone(), this._updateBoundingInfo(!0, null);
  }
  /**
   * Static function used to attach a new empty geometry to a mesh
   * @param mesh defines the mesh to attach the geometry to
   * @returns the new Geometry
   */
  static CreateGeometryForMesh(e) {
    const t = new Ct(Ct.RandomId(), e.getScene());
    return t.applyToMesh(e), t;
  }
  /** Get the list of meshes using this geometry */
  get meshes() {
    return this._meshes;
  }
  /**
   * Creates a new geometry
   * @param id defines the unique ID
   * @param scene defines the hosting scene
   * @param vertexData defines the VertexData used to get geometry data
   * @param updatable defines if geometry must be updatable (false by default)
   * @param mesh defines the mesh that will be associated with the geometry
   */
  constructor(e, t, i, s = !1, r = null) {
    this.delayLoadState = 0, this._totalVertices = 0, this._isDisposed = !1, this._indexBufferIsUpdatable = !1, this._positionsCache = [], this._parentContainer = null, this.useBoundingInfoFromGeometry = !1, this._scene = t || de.LastCreatedScene, this._scene && (this.id = e, this.uniqueId = this._scene.getUniqueId(), this._engine = this._scene.getEngine(), this._meshes = [], this._vertexBuffers = {}, this._indices = [], this._updatable = s, i ? this.setAllVerticesData(i, s) : this._totalVertices = 0, this._engine.getCaps().vertexArrayObject && (this._vertexArrayObjects = {}), r && (this.applyToMesh(r), r.computeWorldMatrix(!0)));
  }
  /**
   * Gets the current extend of the geometry
   */
  get extend() {
    return this._extend;
  }
  /**
   * Gets the hosting scene
   * @returns the hosting Scene
   */
  getScene() {
    return this._scene;
  }
  /**
   * Gets the hosting engine
   * @returns the hosting Engine
   */
  getEngine() {
    return this._engine;
  }
  /**
   * Defines if the geometry is ready to use
   * @returns true if the geometry is ready to be used
   */
  isReady() {
    return this.delayLoadState === 1 || this.delayLoadState === 0;
  }
  /**
   * Gets a value indicating that the geometry should not be serialized
   */
  get doNotSerialize() {
    for (let e = 0; e < this._meshes.length; e++)
      if (!this._meshes[e].doNotSerialize)
        return !1;
    return !0;
  }
  /** @internal */
  _rebuild() {
    this._vertexArrayObjects && (this._vertexArrayObjects = {}), this._meshes.length !== 0 && this._indices && (this._indexBuffer = this._engine.createIndexBuffer(this._indices, this._updatable));
    for (const e in this._vertexBuffers)
      this._vertexBuffers[e]._rebuild();
  }
  /**
   * Affects all geometry data in one call
   * @param vertexData defines the geometry data
   * @param updatable defines if the geometry must be flagged as updatable (false as default)
   */
  setAllVerticesData(e, t) {
    e.applyToGeometry(this, t), this._notifyUpdate();
  }
  /**
   * Set specific vertex data
   * @param kind defines the data kind (Position, normal, etc...)
   * @param data defines the vertex data to use
   * @param updatable defines if the vertex must be flagged as updatable (false as default)
   * @param stride defines the stride to use (0 by default). This value is deduced from the kind value if not specified
   */
  setVerticesData(e, t, i = !1, s) {
    i && Array.isArray(t) && (t = new Float32Array(t));
    const r = new v(this._engine, t, e, i, this._meshes.length === 0, s);
    this.setVerticesBuffer(r);
  }
  /**
   * Removes a specific vertex data
   * @param kind defines the data kind (Position, normal, etc...)
   */
  removeVerticesData(e) {
    this._vertexBuffers[e] && (this._vertexBuffers[e].dispose(), delete this._vertexBuffers[e]), this._vertexArrayObjects && this._disposeVertexArrayObjects();
  }
  /**
   * Affect a vertex buffer to the geometry. the vertexBuffer.getKind() function is used to determine where to store the data
   * @param buffer defines the vertex buffer to use
   * @param totalVertices defines the total number of vertices for position kind (could be null)
   * @param disposeExistingBuffer disposes the existing buffer, if any (default: true)
   */
  setVerticesBuffer(e, t = null, i = !0) {
    const s = e.getKind();
    this._vertexBuffers[s] && i && this._vertexBuffers[s].dispose(), e._buffer && e._buffer._increaseReferences(), this._vertexBuffers[s] = e;
    const r = this._meshes, n = r.length;
    if (s === v.PositionKind) {
      const a = e.getData();
      t != null ? this._totalVertices = t : a != null && (this._totalVertices = a.length / (e.type === v.BYTE ? e.byteStride : e.byteStride / 4)), this._updateExtend(a), this._resetPointsArrayCache();
      for (let o = 0; o < n; o++) {
        const l = r[o];
        l.buildBoundingInfo(this._extend.minimum, this._extend.maximum), l._createGlobalSubMesh(l.isUnIndexed), l.computeWorldMatrix(!0), l.synchronizeInstances();
      }
    }
    this._notifyUpdate(s);
  }
  /**
   * Update a specific vertex buffer
   * This function will directly update the underlying DataBuffer according to the passed numeric array or Float32Array
   * It will do nothing if the buffer is not updatable
   * @param kind defines the data kind (Position, normal, etc...)
   * @param data defines the data to use
   * @param offset defines the offset in the target buffer where to store the data
   * @param useBytes set to true if the offset is in bytes
   */
  updateVerticesDataDirectly(e, t, i, s = !1) {
    const r = this.getVertexBuffer(e);
    r && (r.updateDirectly(t, i, s), this._notifyUpdate(e));
  }
  /**
   * Update a specific vertex buffer
   * This function will create a new buffer if the current one is not updatable
   * @param kind defines the data kind (Position, normal, etc...)
   * @param data defines the data to use
   * @param updateExtends defines if the geometry extends must be recomputed (false by default)
   */
  updateVerticesData(e, t, i = !1) {
    const s = this.getVertexBuffer(e);
    s && (s.update(t), e === v.PositionKind && this._updateBoundingInfo(i, t), this._notifyUpdate(e));
  }
  _updateBoundingInfo(e, t) {
    if (e && this._updateExtend(t), this._resetPointsArrayCache(), e) {
      const i = this._meshes;
      for (const s of i) {
        s.hasBoundingInfo ? s.getBoundingInfo().reConstruct(this._extend.minimum, this._extend.maximum) : s.buildBoundingInfo(this._extend.minimum, this._extend.maximum);
        const r = s.subMeshes;
        for (const n of r)
          n.refreshBoundingInfo();
      }
    }
  }
  /**
   * @internal
   */
  _bind(e, t, i, s) {
    if (!e)
      return;
    t === void 0 && (t = this._indexBuffer);
    const r = this.getVertexBuffers();
    if (!r)
      return;
    if (t != this._indexBuffer || !this._vertexArrayObjects && !s) {
      this._engine.bindBuffers(r, t, e, i);
      return;
    }
    const n = s || this._vertexArrayObjects;
    n[e.key] || (n[e.key] = this._engine.recordVertexArrayObject(r, t, e, i)), this._engine.bindVertexArrayObject(n[e.key], t);
  }
  /**
   * Gets total number of vertices
   * @returns the total number of vertices
   */
  getTotalVertices() {
    return this.isReady() ? this._totalVertices : 0;
  }
  /**
   * Gets a specific vertex data attached to this geometry. Float data is constructed if the vertex buffer data cannot be returned directly.
   * @param kind defines the data kind (Position, normal, etc...)
   * @param copyWhenShared defines if the returned array must be cloned upon returning it if the current geometry is shared between multiple meshes
   * @param forceCopy defines a boolean indicating that the returned array must be cloned upon returning it
   * @returns a float array containing vertex data
   */
  getVerticesData(e, t, i) {
    const s = this.getVertexBuffer(e);
    return s ? s.getFloatData(this._totalVertices, i || t && this._meshes.length !== 1) : null;
  }
  /**
   * Returns a boolean defining if the vertex data for the requested `kind` is updatable
   * @param kind defines the data kind (Position, normal, etc...)
   * @returns true if the vertex buffer with the specified kind is updatable
   */
  isVertexBufferUpdatable(e) {
    const t = this._vertexBuffers[e];
    return t ? t.isUpdatable() : !1;
  }
  /**
   * Gets a specific vertex buffer
   * @param kind defines the data kind (Position, normal, etc...)
   * @returns a VertexBuffer
   */
  getVertexBuffer(e) {
    return this.isReady() ? this._vertexBuffers[e] : null;
  }
  /**
   * Returns all vertex buffers
   * @returns an object holding all vertex buffers indexed by kind
   */
  getVertexBuffers() {
    return this.isReady() ? this._vertexBuffers : null;
  }
  /**
   * Gets a boolean indicating if specific vertex buffer is present
   * @param kind defines the data kind (Position, normal, etc...)
   * @returns true if data is present
   */
  isVerticesDataPresent(e) {
    return this._vertexBuffers ? this._vertexBuffers[e] !== void 0 : this._delayInfo ? this._delayInfo.indexOf(e) !== -1 : !1;
  }
  /**
   * Gets a list of all attached data kinds (Position, normal, etc...)
   * @returns a list of string containing all kinds
   */
  getVerticesDataKinds() {
    const e = [];
    let t;
    if (!this._vertexBuffers && this._delayInfo)
      for (t in this._delayInfo)
        e.push(t);
    else
      for (t in this._vertexBuffers)
        e.push(t);
    return e;
  }
  /**
   * Update index buffer
   * @param indices defines the indices to store in the index buffer
   * @param offset defines the offset in the target buffer where to store the data
   * @param gpuMemoryOnly defines a boolean indicating that only the GPU memory must be updated leaving the CPU version of the indices unchanged (false by default)
   */
  updateIndices(e, t, i = !1) {
    if (this._indexBuffer)
      if (!this._indexBufferIsUpdatable)
        this.setIndices(e, null, !0);
      else {
        const s = e.length !== this._indices.length;
        if (i || (this._indices = e.slice()), this._engine.updateDynamicIndexBuffer(this._indexBuffer, e, t), s)
          for (const r of this._meshes)
            r._createGlobalSubMesh(!0);
      }
  }
  /**
   * Creates a new index buffer
   * @param indices defines the indices to store in the index buffer
   * @param totalVertices defines the total number of vertices (could be null)
   * @param updatable defines if the index buffer must be flagged as updatable (false by default)
   */
  setIndices(e, t = null, i = !1) {
    this._indexBuffer && this._engine._releaseBuffer(this._indexBuffer), this._indices = e, this._indexBufferIsUpdatable = i, this._meshes.length !== 0 && this._indices && (this._indexBuffer = this._engine.createIndexBuffer(this._indices, i)), t != null && (this._totalVertices = t);
    for (const s of this._meshes)
      s._createGlobalSubMesh(!0), s.synchronizeInstances();
    this._notifyUpdate();
  }
  /**
   * Return the total number of indices
   * @returns the total number of indices
   */
  getTotalIndices() {
    return this.isReady() ? this._indices.length : 0;
  }
  /**
   * Gets the index buffer array
   * @param copyWhenShared defines if the returned array must be cloned upon returning it if the current geometry is shared between multiple meshes
   * @param forceCopy defines a boolean indicating that the returned array must be cloned upon returning it
   * @returns the index buffer array
   */
  getIndices(e, t) {
    if (!this.isReady())
      return null;
    const i = this._indices;
    return !t && (!e || this._meshes.length === 1) ? i : i.slice();
  }
  /**
   * Gets the index buffer
   * @returns the index buffer
   */
  getIndexBuffer() {
    return this.isReady() ? this._indexBuffer : null;
  }
  /**
   * @internal
   */
  _releaseVertexArrayObject(e = null) {
    !e || !this._vertexArrayObjects || this._vertexArrayObjects[e.key] && (this._engine.releaseVertexArrayObject(this._vertexArrayObjects[e.key]), delete this._vertexArrayObjects[e.key]);
  }
  /**
   * Release the associated resources for a specific mesh
   * @param mesh defines the source mesh
   * @param shouldDispose defines if the geometry must be disposed if there is no more mesh pointing to it
   */
  releaseForMesh(e, t) {
    const i = this._meshes, s = i.indexOf(e);
    s !== -1 && (i.splice(s, 1), this._vertexArrayObjects && e._invalidateInstanceVertexArrayObject(), e._geometry = null, i.length === 0 && t && this.dispose());
  }
  /**
   * Apply current geometry to a given mesh
   * @param mesh defines the mesh to apply geometry to
   */
  applyToMesh(e) {
    if (e._geometry === this)
      return;
    const t = e._geometry;
    t && t.releaseForMesh(e), this._vertexArrayObjects && e._invalidateInstanceVertexArrayObject();
    const i = this._meshes;
    e._geometry = this, e._internalAbstractMeshDataInfo._positions = null, this._scene.pushGeometry(this), i.push(e), this.isReady() ? this._applyToMesh(e) : this._boundingInfo && e.setBoundingInfo(this._boundingInfo);
  }
  _updateExtend(e = null) {
    if (this.useBoundingInfoFromGeometry && this._boundingInfo)
      this._extend = {
        minimum: this._boundingInfo.minimum.clone(),
        maximum: this._boundingInfo.maximum.clone()
      };
    else {
      if (!e && (e = this.getVerticesData(v.PositionKind), !e))
        return;
      this._extend = Ga(e, 0, this._totalVertices, this.boundingBias, 3);
    }
  }
  _applyToMesh(e) {
    const t = this._meshes.length;
    for (const i in this._vertexBuffers)
      t === 1 && this._vertexBuffers[i].create(), i === v.PositionKind && (this._extend || this._updateExtend(), e.buildBoundingInfo(this._extend.minimum, this._extend.maximum), e._createGlobalSubMesh(e.isUnIndexed), e._updateBoundingInfo());
    t === 1 && this._indices && this._indices.length > 0 && (this._indexBuffer = this._engine.createIndexBuffer(this._indices, this._updatable)), e._syncGeometryWithMorphTargetManager(), e.synchronizeInstances();
  }
  _notifyUpdate(e) {
    this.onGeometryUpdated && this.onGeometryUpdated(this, e), this._vertexArrayObjects && this._disposeVertexArrayObjects();
    for (const t of this._meshes)
      t._markSubMeshesAsAttributesDirty();
  }
  /**
   * Load the geometry if it was flagged as delay loaded
   * @param scene defines the hosting scene
   * @param onLoaded defines a callback called when the geometry is loaded
   */
  load(e, t) {
    if (this.delayLoadState !== 2) {
      if (this.isReady()) {
        t && t();
        return;
      }
      this.delayLoadState = 2, this._queueLoad(e, t);
    }
  }
  _queueLoad(e, t) {
    this.delayLoadingFile && (e.addPendingData(this), e._loadFile(this.delayLoadingFile, (i) => {
      if (!this._delayLoadingFunction)
        return;
      this._delayLoadingFunction(JSON.parse(i), this), this.delayLoadState = 1, this._delayInfo = [], e.removePendingData(this);
      const s = this._meshes, r = s.length;
      for (let n = 0; n < r; n++)
        this._applyToMesh(s[n]);
      t && t();
    }, void 0, !0));
  }
  /**
   * Invert the geometry to move from a right handed system to a left handed one.
   */
  toLeftHanded() {
    const e = this.getIndices(!1);
    if (e != null && e.length > 0) {
      for (let s = 0; s < e.length; s += 3) {
        const r = e[s + 0];
        e[s + 0] = e[s + 2], e[s + 2] = r;
      }
      this.setIndices(e);
    }
    const t = this.getVerticesData(v.PositionKind, !1);
    if (t != null && t.length > 0) {
      for (let s = 0; s < t.length; s += 3)
        t[s + 2] = -t[s + 2];
      this.setVerticesData(v.PositionKind, t, !1);
    }
    const i = this.getVerticesData(v.NormalKind, !1);
    if (i != null && i.length > 0) {
      for (let s = 0; s < i.length; s += 3)
        i[s + 2] = -i[s + 2];
      this.setVerticesData(v.NormalKind, i, !1);
    }
  }
  // Cache
  /** @internal */
  _resetPointsArrayCache() {
    this._positions = null;
  }
  /** @internal */
  _generatePointsArray() {
    if (this._positions)
      return !0;
    const e = this.getVerticesData(v.PositionKind);
    if (!e || e.length === 0)
      return !1;
    for (let t = this._positionsCache.length * 3, i = this._positionsCache.length; t < e.length; t += 3, ++i)
      this._positionsCache[i] = p.FromArray(e, t);
    for (let t = 0, i = 0; t < e.length; t += 3, ++i)
      this._positionsCache[i].set(e[0 + t], e[1 + t], e[2 + t]);
    return this._positionsCache.length = e.length / 3, this._positions = this._positionsCache, !0;
  }
  /**
   * Gets a value indicating if the geometry is disposed
   * @returns true if the geometry was disposed
   */
  isDisposed() {
    return this._isDisposed;
  }
  _disposeVertexArrayObjects() {
    if (this._vertexArrayObjects) {
      for (const i in this._vertexArrayObjects)
        this._engine.releaseVertexArrayObject(this._vertexArrayObjects[i]);
      this._vertexArrayObjects = {};
      const e = this._meshes, t = e.length;
      for (let i = 0; i < t; i++)
        e[i]._invalidateInstanceVertexArrayObject();
    }
  }
  /**
   * Free all associated resources
   */
  dispose() {
    const e = this._meshes, t = e.length;
    let i;
    for (i = 0; i < t; i++)
      this.releaseForMesh(e[i]);
    this._meshes.length = 0, this._disposeVertexArrayObjects();
    for (const s in this._vertexBuffers)
      this._vertexBuffers[s].dispose();
    if (this._vertexBuffers = {}, this._totalVertices = 0, this._indexBuffer && this._engine._releaseBuffer(this._indexBuffer), this._indexBuffer = null, this._indices = [], this.delayLoadState = 0, this.delayLoadingFile = null, this._delayLoadingFunction = null, this._delayInfo = [], this._boundingInfo = null, this._scene.removeGeometry(this), this._parentContainer) {
      const s = this._parentContainer.geometries.indexOf(this);
      s > -1 && this._parentContainer.geometries.splice(s, 1), this._parentContainer = null;
    }
    this._isDisposed = !0;
  }
  /**
   * Clone the current geometry into a new geometry
   * @param id defines the unique ID of the new geometry
   * @returns a new geometry object
   */
  copy(e) {
    const t = new q();
    t.indices = [];
    const i = this.getIndices();
    if (i)
      for (let o = 0; o < i.length; o++)
        t.indices.push(i[o]);
    let s = !1, r = !1, n;
    for (n in this._vertexBuffers) {
      const o = this.getVerticesData(n);
      if (o && (o instanceof Float32Array ? t.set(new Float32Array(o), n) : t.set(o.slice(0), n), !r)) {
        const l = this.getVertexBuffer(n);
        l && (s = l.isUpdatable(), r = !s);
      }
    }
    const a = new Ct(e, this._scene, t, s);
    a.delayLoadState = this.delayLoadState, a.delayLoadingFile = this.delayLoadingFile, a._delayLoadingFunction = this._delayLoadingFunction;
    for (n in this._delayInfo)
      a._delayInfo = a._delayInfo || [], a._delayInfo.push(n);
    return a._boundingInfo = new $t(this._extend.minimum, this._extend.maximum), a;
  }
  /**
   * Serialize the current geometry info (and not the vertices data) into a JSON object
   * @returns a JSON representation of the current geometry data (without the vertices data)
   */
  serialize() {
    const e = {};
    return e.id = this.id, e.uniqueId = this.uniqueId, e.updatable = this._updatable, Ee && Ee.HasTags(this) && (e.tags = Ee.GetTags(this)), e;
  }
  _toNumberArray(e) {
    return Array.isArray(e) ? e : Array.prototype.slice.call(e);
  }
  /**
   * Release any memory retained by the cached data on the Geometry.
   *
   * Call this function to reduce memory footprint of the mesh.
   * Vertex buffers will not store CPU data anymore (this will prevent picking, collisions or physics to work correctly)
   */
  clearCachedData() {
    this._indices = [], this._resetPointsArrayCache();
    for (const e in this._vertexBuffers)
      Object.prototype.hasOwnProperty.call(this._vertexBuffers, e) && (this._vertexBuffers[e]._buffer._data = null);
  }
  /**
   * Serialize all vertices data into a JSON object
   * @returns a JSON representation of the current geometry data
   */
  serializeVerticeData() {
    const e = this.serialize();
    return this.isVerticesDataPresent(v.PositionKind) && (e.positions = this._toNumberArray(this.getVerticesData(v.PositionKind)), this.isVertexBufferUpdatable(v.PositionKind) && (e.positions._updatable = !0)), this.isVerticesDataPresent(v.NormalKind) && (e.normals = this._toNumberArray(this.getVerticesData(v.NormalKind)), this.isVertexBufferUpdatable(v.NormalKind) && (e.normals._updatable = !0)), this.isVerticesDataPresent(v.TangentKind) && (e.tangents = this._toNumberArray(this.getVerticesData(v.TangentKind)), this.isVertexBufferUpdatable(v.TangentKind) && (e.tangents._updatable = !0)), this.isVerticesDataPresent(v.UVKind) && (e.uvs = this._toNumberArray(this.getVerticesData(v.UVKind)), this.isVertexBufferUpdatable(v.UVKind) && (e.uvs._updatable = !0)), this.isVerticesDataPresent(v.UV2Kind) && (e.uv2s = this._toNumberArray(this.getVerticesData(v.UV2Kind)), this.isVertexBufferUpdatable(v.UV2Kind) && (e.uv2s._updatable = !0)), this.isVerticesDataPresent(v.UV3Kind) && (e.uv3s = this._toNumberArray(this.getVerticesData(v.UV3Kind)), this.isVertexBufferUpdatable(v.UV3Kind) && (e.uv3s._updatable = !0)), this.isVerticesDataPresent(v.UV4Kind) && (e.uv4s = this._toNumberArray(this.getVerticesData(v.UV4Kind)), this.isVertexBufferUpdatable(v.UV4Kind) && (e.uv4s._updatable = !0)), this.isVerticesDataPresent(v.UV5Kind) && (e.uv5s = this._toNumberArray(this.getVerticesData(v.UV5Kind)), this.isVertexBufferUpdatable(v.UV5Kind) && (e.uv5s._updatable = !0)), this.isVerticesDataPresent(v.UV6Kind) && (e.uv6s = this._toNumberArray(this.getVerticesData(v.UV6Kind)), this.isVertexBufferUpdatable(v.UV6Kind) && (e.uv6s._updatable = !0)), this.isVerticesDataPresent(v.ColorKind) && (e.colors = this._toNumberArray(this.getVerticesData(v.ColorKind)), this.isVertexBufferUpdatable(v.ColorKind) && (e.colors._updatable = !0)), this.isVerticesDataPresent(v.MatricesIndicesKind) && (e.matricesIndices = this._toNumberArray(this.getVerticesData(v.MatricesIndicesKind)), e.matricesIndices._isExpanded = !0, this.isVertexBufferUpdatable(v.MatricesIndicesKind) && (e.matricesIndices._updatable = !0)), this.isVerticesDataPresent(v.MatricesWeightsKind) && (e.matricesWeights = this._toNumberArray(this.getVerticesData(v.MatricesWeightsKind)), this.isVertexBufferUpdatable(v.MatricesWeightsKind) && (e.matricesWeights._updatable = !0)), e.indices = this._toNumberArray(this.getIndices()), e;
  }
  // Statics
  /**
   * Extracts a clone of a mesh geometry
   * @param mesh defines the source mesh
   * @param id defines the unique ID of the new geometry object
   * @returns the new geometry object
   */
  static ExtractFromMesh(e, t) {
    const i = e._geometry;
    return i ? i.copy(t) : null;
  }
  /**
   * You should now use Tools.RandomId(), this method is still here for legacy reasons.
   * Implementation from http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#answer-2117523
   * Be aware Math.random() could cause collisions, but:
   * "All but 6 of the 128 bits of the ID are randomly generated, which means that for any two ids, there's a 1 in 2^^122 (or 5.3x10^^36) chance they'll collide"
   * @returns a string containing a new GUID
   */
  static RandomId() {
    return z.RandomId();
  }
  static _GetGeometryByLoadedUniqueId(e, t) {
    for (let i = 0; i < t.geometries.length; i++)
      if (t.geometries[i]._loadedUniqueId === e)
        return t.geometries[i];
    return null;
  }
  /**
   * @internal
   */
  static _ImportGeometry(e, t) {
    const i = t.getScene(), s = e.geometryUniqueId, r = e.geometryId;
    if (s || r) {
      const n = s ? this._GetGeometryByLoadedUniqueId(s, i) : i.getGeometryById(r);
      n && n.applyToMesh(t);
    } else if (e instanceof ArrayBuffer) {
      const n = t._binaryInfo;
      if (n.positionsAttrDesc && n.positionsAttrDesc.count > 0) {
        const a = new Float32Array(e, n.positionsAttrDesc.offset, n.positionsAttrDesc.count);
        t.setVerticesData(v.PositionKind, a, !1);
      }
      if (n.normalsAttrDesc && n.normalsAttrDesc.count > 0) {
        const a = new Float32Array(e, n.normalsAttrDesc.offset, n.normalsAttrDesc.count);
        t.setVerticesData(v.NormalKind, a, !1);
      }
      if (n.tangetsAttrDesc && n.tangetsAttrDesc.count > 0) {
        const a = new Float32Array(e, n.tangetsAttrDesc.offset, n.tangetsAttrDesc.count);
        t.setVerticesData(v.TangentKind, a, !1);
      }
      if (n.uvsAttrDesc && n.uvsAttrDesc.count > 0) {
        const a = new Float32Array(e, n.uvsAttrDesc.offset, n.uvsAttrDesc.count);
        if (ct.UseOpenGLOrientationForUV)
          for (let o = 1; o < a.length; o += 2)
            a[o] = 1 - a[o];
        t.setVerticesData(v.UVKind, a, !1);
      }
      if (n.uvs2AttrDesc && n.uvs2AttrDesc.count > 0) {
        const a = new Float32Array(e, n.uvs2AttrDesc.offset, n.uvs2AttrDesc.count);
        if (ct.UseOpenGLOrientationForUV)
          for (let o = 1; o < a.length; o += 2)
            a[o] = 1 - a[o];
        t.setVerticesData(v.UV2Kind, a, !1);
      }
      if (n.uvs3AttrDesc && n.uvs3AttrDesc.count > 0) {
        const a = new Float32Array(e, n.uvs3AttrDesc.offset, n.uvs3AttrDesc.count);
        if (ct.UseOpenGLOrientationForUV)
          for (let o = 1; o < a.length; o += 2)
            a[o] = 1 - a[o];
        t.setVerticesData(v.UV3Kind, a, !1);
      }
      if (n.uvs4AttrDesc && n.uvs4AttrDesc.count > 0) {
        const a = new Float32Array(e, n.uvs4AttrDesc.offset, n.uvs4AttrDesc.count);
        if (ct.UseOpenGLOrientationForUV)
          for (let o = 1; o < a.length; o += 2)
            a[o] = 1 - a[o];
        t.setVerticesData(v.UV4Kind, a, !1);
      }
      if (n.uvs5AttrDesc && n.uvs5AttrDesc.count > 0) {
        const a = new Float32Array(e, n.uvs5AttrDesc.offset, n.uvs5AttrDesc.count);
        if (ct.UseOpenGLOrientationForUV)
          for (let o = 1; o < a.length; o += 2)
            a[o] = 1 - a[o];
        t.setVerticesData(v.UV5Kind, a, !1);
      }
      if (n.uvs6AttrDesc && n.uvs6AttrDesc.count > 0) {
        const a = new Float32Array(e, n.uvs6AttrDesc.offset, n.uvs6AttrDesc.count);
        if (ct.UseOpenGLOrientationForUV)
          for (let o = 1; o < a.length; o += 2)
            a[o] = 1 - a[o];
        t.setVerticesData(v.UV6Kind, a, !1);
      }
      if (n.colorsAttrDesc && n.colorsAttrDesc.count > 0) {
        const a = new Float32Array(e, n.colorsAttrDesc.offset, n.colorsAttrDesc.count);
        t.setVerticesData(v.ColorKind, a, !1, n.colorsAttrDesc.stride);
      }
      if (n.matricesIndicesAttrDesc && n.matricesIndicesAttrDesc.count > 0) {
        const a = new Int32Array(e, n.matricesIndicesAttrDesc.offset, n.matricesIndicesAttrDesc.count), o = [];
        for (let l = 0; l < a.length; l++) {
          const c = a[l];
          o.push(c & 255), o.push((c & 65280) >> 8), o.push((c & 16711680) >> 16), o.push(c >> 24 & 255);
        }
        t.setVerticesData(v.MatricesIndicesKind, o, !1);
      }
      if (n.matricesIndicesExtraAttrDesc && n.matricesIndicesExtraAttrDesc.count > 0) {
        const a = new Int32Array(e, n.matricesIndicesExtraAttrDesc.offset, n.matricesIndicesExtraAttrDesc.count), o = [];
        for (let l = 0; l < a.length; l++) {
          const c = a[l];
          o.push(c & 255), o.push((c & 65280) >> 8), o.push((c & 16711680) >> 16), o.push(c >> 24 & 255);
        }
        t.setVerticesData(v.MatricesIndicesExtraKind, o, !1);
      }
      if (n.matricesWeightsAttrDesc && n.matricesWeightsAttrDesc.count > 0) {
        const a = new Float32Array(e, n.matricesWeightsAttrDesc.offset, n.matricesWeightsAttrDesc.count);
        t.setVerticesData(v.MatricesWeightsKind, a, !1);
      }
      if (n.indicesAttrDesc && n.indicesAttrDesc.count > 0) {
        const a = new Int32Array(e, n.indicesAttrDesc.offset, n.indicesAttrDesc.count);
        t.setIndices(a, null);
      }
      if (n.subMeshesAttrDesc && n.subMeshesAttrDesc.count > 0) {
        const a = new Int32Array(e, n.subMeshesAttrDesc.offset, n.subMeshesAttrDesc.count * 5);
        t.subMeshes = [];
        for (let o = 0; o < n.subMeshesAttrDesc.count; o++) {
          const l = a[o * 5 + 0], c = a[o * 5 + 1], u = a[o * 5 + 2], d = a[o * 5 + 3], f = a[o * 5 + 4];
          Qt.AddToMesh(l, c, u, d, f, t);
        }
      }
    } else if (e.positions && e.normals && e.indices) {
      if (t.setVerticesData(v.PositionKind, e.positions, e.positions._updatable), t.setVerticesData(v.NormalKind, e.normals, e.normals._updatable), e.tangents && t.setVerticesData(v.TangentKind, e.tangents, e.tangents._updatable), e.uvs && t.setVerticesData(v.UVKind, e.uvs, e.uvs._updatable), e.uvs2 && t.setVerticesData(v.UV2Kind, e.uvs2, e.uvs2._updatable), e.uvs3 && t.setVerticesData(v.UV3Kind, e.uvs3, e.uvs3._updatable), e.uvs4 && t.setVerticesData(v.UV4Kind, e.uvs4, e.uvs4._updatable), e.uvs5 && t.setVerticesData(v.UV5Kind, e.uvs5, e.uvs5._updatable), e.uvs6 && t.setVerticesData(v.UV6Kind, e.uvs6, e.uvs6._updatable), e.colors && t.setVerticesData(v.ColorKind, ye.CheckColors4(e.colors, e.positions.length / 3), e.colors._updatable), e.matricesIndices)
        if (e.matricesIndices._isExpanded)
          delete e.matricesIndices._isExpanded, t.setVerticesData(v.MatricesIndicesKind, e.matricesIndices, e.matricesIndices._updatable);
        else {
          const n = [];
          for (let a = 0; a < e.matricesIndices.length; a++) {
            const o = e.matricesIndices[a];
            n.push(o & 255), n.push((o & 65280) >> 8), n.push((o & 16711680) >> 16), n.push(o >> 24 & 255);
          }
          t.setVerticesData(v.MatricesIndicesKind, n, e.matricesIndices._updatable);
        }
      if (e.matricesIndicesExtra)
        if (e.matricesIndicesExtra._isExpanded)
          delete e.matricesIndices._isExpanded, t.setVerticesData(v.MatricesIndicesExtraKind, e.matricesIndicesExtra, e.matricesIndicesExtra._updatable);
        else {
          const n = [];
          for (let a = 0; a < e.matricesIndicesExtra.length; a++) {
            const o = e.matricesIndicesExtra[a];
            n.push(o & 255), n.push((o & 65280) >> 8), n.push((o & 16711680) >> 16), n.push(o >> 24 & 255);
          }
          t.setVerticesData(v.MatricesIndicesExtraKind, n, e.matricesIndicesExtra._updatable);
        }
      e.matricesWeights && (Ct._CleanMatricesWeights(e, t), t.setVerticesData(v.MatricesWeightsKind, e.matricesWeights, e.matricesWeights._updatable)), e.matricesWeightsExtra && t.setVerticesData(v.MatricesWeightsExtraKind, e.matricesWeightsExtra, e.matricesWeights._updatable), t.setIndices(e.indices, null);
    }
    if (e.subMeshes) {
      t.subMeshes = [];
      for (let n = 0; n < e.subMeshes.length; n++) {
        const a = e.subMeshes[n];
        Qt.AddToMesh(a.materialIndex, a.verticesStart, a.verticesCount, a.indexStart, a.indexCount, t);
      }
    }
    t._shouldGenerateFlatShading && (t.convertToFlatShadedMesh(), t._shouldGenerateFlatShading = !1), t.computeWorldMatrix(!0), i.onMeshImportedObservable.notifyObservers(t);
  }
  static _CleanMatricesWeights(e, t) {
    if (!st.CleanBoneMatrixWeights)
      return;
    let s = 0;
    if (e.skeletonId > -1) {
      const u = t.getScene().getLastSkeletonById(e.skeletonId);
      if (!u)
        return;
      s = u.bones.length;
    } else
      return;
    const r = t.getVerticesData(v.MatricesIndicesKind), n = t.getVerticesData(v.MatricesIndicesExtraKind), a = e.matricesWeights, o = e.matricesWeightsExtra, l = e.numBoneInfluencer, c = a.length;
    for (let u = 0; u < c; u += 4) {
      let d = 0, f = -1;
      for (let _ = 0; _ < 4; _++) {
        const g = a[u + _];
        d += g, g < 1e-3 && f < 0 && (f = _);
      }
      if (o)
        for (let _ = 0; _ < 4; _++) {
          const g = o[u + _];
          d += g, g < 1e-3 && f < 0 && (f = _ + 4);
        }
      if ((f < 0 || f > l - 1) && (f = l - 1), d > 1e-3) {
        const _ = 1 / d;
        for (let g = 0; g < 4; g++)
          a[u + g] *= _;
        if (o)
          for (let g = 0; g < 4; g++)
            o[u + g] *= _;
      } else
        f >= 4 ? (o[u + f - 4] = 1 - d, n[u + f - 4] = s) : (a[u + f] = 1 - d, r[u + f] = s);
    }
    t.setVerticesData(v.MatricesIndicesKind, r), e.matricesWeightsExtra && t.setVerticesData(v.MatricesIndicesExtraKind, n);
  }
  /**
   * Create a new geometry from persisted data (Using .babylon file format)
   * @param parsedVertexData defines the persisted data
   * @param scene defines the hosting scene
   * @param rootUrl defines the root url to use to load assets (like delayed data)
   * @returns the new geometry object
   */
  static Parse(e, t, i) {
    const s = new Ct(e.id, t, void 0, e.updatable);
    return s._loadedUniqueId = e.uniqueId, Ee && Ee.AddTagsTo(s, e.tags), e.delayLoadingFile ? (s.delayLoadState = 4, s.delayLoadingFile = i + e.delayLoadingFile, s._boundingInfo = new $t(p.FromArray(e.boundingBoxMinimum), p.FromArray(e.boundingBoxMaximum)), s._delayInfo = [], e.hasUVs && s._delayInfo.push(v.UVKind), e.hasUVs2 && s._delayInfo.push(v.UV2Kind), e.hasUVs3 && s._delayInfo.push(v.UV3Kind), e.hasUVs4 && s._delayInfo.push(v.UV4Kind), e.hasUVs5 && s._delayInfo.push(v.UV5Kind), e.hasUVs6 && s._delayInfo.push(v.UV6Kind), e.hasColors && s._delayInfo.push(v.ColorKind), e.hasMatricesIndices && s._delayInfo.push(v.MatricesIndicesKind), e.hasMatricesWeights && s._delayInfo.push(v.MatricesWeightsKind), s._delayLoadingFunction = q.ImportVertexData) : q.ImportVertexData(e, s), t.pushGeometry(s, !0), s;
  }
}
class wl {
  /**
   * constructor
   * @param frameSampleSize The number of samples required to saturate the sliding window
   */
  constructor(e = 30) {
    this._enabled = !0, this._rollingFrameTime = new Ol(e);
  }
  /**
   * Samples current frame
   * @param timeMs A timestamp in milliseconds of the current frame to compare with other frames
   */
  sampleFrame(e = Kt.Now) {
    if (this._enabled) {
      if (this._lastFrameTimeMs != null) {
        const t = e - this._lastFrameTimeMs;
        this._rollingFrameTime.add(t);
      }
      this._lastFrameTimeMs = e;
    }
  }
  /**
   * Returns the average frame time in milliseconds over the sliding window (or the subset of frames sampled so far)
   */
  get averageFrameTime() {
    return this._rollingFrameTime.average;
  }
  /**
   * Returns the variance frame time in milliseconds over the sliding window (or the subset of frames sampled so far)
   */
  get averageFrameTimeVariance() {
    return this._rollingFrameTime.variance;
  }
  /**
   * Returns the frame time of the most recent frame
   */
  get instantaneousFrameTime() {
    return this._rollingFrameTime.history(0);
  }
  /**
   * Returns the average framerate in frames per second over the sliding window (or the subset of frames sampled so far)
   */
  get averageFPS() {
    return 1e3 / this._rollingFrameTime.average;
  }
  /**
   * Returns the average framerate in frames per second using the most recent frame time
   */
  get instantaneousFPS() {
    const e = this._rollingFrameTime.history(0);
    return e === 0 ? 0 : 1e3 / e;
  }
  /**
   * Returns true if enough samples have been taken to completely fill the sliding window
   */
  get isSaturated() {
    return this._rollingFrameTime.isSaturated();
  }
  /**
   * Enables contributions to the sliding window sample set
   */
  enable() {
    this._enabled = !0;
  }
  /**
   * Disables contributions to the sliding window sample set
   * Samples will not be interpolated over the disabled period
   */
  disable() {
    this._enabled = !1, this._lastFrameTimeMs = null;
  }
  /**
   * Returns true if sampling is enabled
   */
  get isEnabled() {
    return this._enabled;
  }
  /**
   * Resets performance monitor
   */
  reset() {
    this._lastFrameTimeMs = null, this._rollingFrameTime.reset();
  }
}
class Ol {
  /**
   * constructor
   * @param length The number of samples required to saturate the sliding window
   */
  constructor(e) {
    this._samples = new Array(e), this.reset();
  }
  /**
   * Adds a sample to the sample set
   * @param v The sample value
   */
  add(e) {
    let t;
    if (this.isSaturated()) {
      const i = this._samples[this._pos];
      t = i - this.average, this.average -= t / (this._sampleCount - 1), this._m2 -= t * (i - this.average);
    } else
      this._sampleCount++;
    t = e - this.average, this.average += t / this._sampleCount, this._m2 += t * (e - this.average), this.variance = this._m2 / (this._sampleCount - 1), this._samples[this._pos] = e, this._pos++, this._pos %= this._samples.length;
  }
  /**
   * Returns previously added values or null if outside of history or outside the sliding window domain
   * @param i Index in history. For example, pass 0 for the most recent value and 1 for the value before that
   * @returns Value previously recorded with add() or null if outside of range
   */
  history(e) {
    if (e >= this._sampleCount || e >= this._samples.length)
      return 0;
    const t = this._wrapPosition(this._pos - 1);
    return this._samples[this._wrapPosition(t - e)];
  }
  /**
   * Returns true if enough samples have been taken to completely fill the sliding window
   * @returns true if sample-set saturated
   */
  isSaturated() {
    return this._sampleCount >= this._samples.length;
  }
  /**
   * Resets the rolling average (equivalent to 0 samples taken so far)
   */
  reset() {
    this.average = 0, this.variance = 0, this._sampleCount = 0, this._pos = 0, this._m2 = 0;
  }
  /**
   * Wraps a value around the sample range boundaries
   * @param i Position in sample range, for example if the sample length is 5, and i is -3, then 2 will be returned.
   * @returns Wrapped position in sample range
   */
  _wrapPosition(e) {
    const t = this._samples.length;
    return (e % t + t) % t;
  }
}
Z.prototype.setAlphaConstants = function(h, e, t, i) {
  this._alphaState.setAlphaBlendConstants(h, e, t, i);
};
Z.prototype.setAlphaMode = function(h, e = !1) {
  if (this._alphaMode === h) {
    if (!e) {
      const t = h === 0;
      this.depthCullingState.depthMask !== t && (this.depthCullingState.depthMask = t);
    }
    return;
  }
  switch (h) {
    case 0:
      this._alphaState.alphaBlend = !1;
      break;
    case 7:
      this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE, this._gl.ONE_MINUS_SRC_ALPHA, this._gl.ONE, this._gl.ONE), this._alphaState.alphaBlend = !0;
      break;
    case 8:
      this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE, this._gl.ONE_MINUS_SRC_ALPHA, this._gl.ONE, this._gl.ONE_MINUS_SRC_ALPHA), this._alphaState.alphaBlend = !0;
      break;
    case 2:
      this._alphaState.setAlphaBlendFunctionParameters(this._gl.SRC_ALPHA, this._gl.ONE_MINUS_SRC_ALPHA, this._gl.ONE, this._gl.ONE), this._alphaState.alphaBlend = !0;
      break;
    case 6:
      this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE, this._gl.ONE, this._gl.ZERO, this._gl.ONE), this._alphaState.alphaBlend = !0;
      break;
    case 1:
      this._alphaState.setAlphaBlendFunctionParameters(this._gl.SRC_ALPHA, this._gl.ONE, this._gl.ZERO, this._gl.ONE), this._alphaState.alphaBlend = !0;
      break;
    case 3:
      this._alphaState.setAlphaBlendFunctionParameters(this._gl.ZERO, this._gl.ONE_MINUS_SRC_COLOR, this._gl.ONE, this._gl.ONE), this._alphaState.alphaBlend = !0;
      break;
    case 4:
      this._alphaState.setAlphaBlendFunctionParameters(this._gl.DST_COLOR, this._gl.ZERO, this._gl.ONE, this._gl.ONE), this._alphaState.alphaBlend = !0;
      break;
    case 5:
      this._alphaState.setAlphaBlendFunctionParameters(this._gl.SRC_ALPHA, this._gl.ONE_MINUS_SRC_COLOR, this._gl.ONE, this._gl.ONE), this._alphaState.alphaBlend = !0;
      break;
    case 9:
      this._alphaState.setAlphaBlendFunctionParameters(this._gl.CONSTANT_COLOR, this._gl.ONE_MINUS_CONSTANT_COLOR, this._gl.CONSTANT_ALPHA, this._gl.ONE_MINUS_CONSTANT_ALPHA), this._alphaState.alphaBlend = !0;
      break;
    case 10:
      this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE, this._gl.ONE_MINUS_SRC_COLOR, this._gl.ONE, this._gl.ONE_MINUS_SRC_ALPHA), this._alphaState.alphaBlend = !0;
      break;
    case 11:
      this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE, this._gl.ONE, this._gl.ONE, this._gl.ONE), this._alphaState.alphaBlend = !0;
      break;
    case 12:
      this._alphaState.setAlphaBlendFunctionParameters(this._gl.DST_ALPHA, this._gl.ONE, this._gl.ZERO, this._gl.ZERO), this._alphaState.alphaBlend = !0;
      break;
    case 13:
      this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE_MINUS_DST_COLOR, this._gl.ONE_MINUS_SRC_COLOR, this._gl.ONE_MINUS_DST_ALPHA, this._gl.ONE_MINUS_SRC_ALPHA), this._alphaState.alphaBlend = !0;
      break;
    case 14:
      this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE, this._gl.ONE_MINUS_SRC_ALPHA, this._gl.ONE, this._gl.ONE_MINUS_SRC_ALPHA), this._alphaState.alphaBlend = !0;
      break;
    case 15:
      this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE, this._gl.ONE, this._gl.ONE, this._gl.ZERO), this._alphaState.alphaBlend = !0;
      break;
    case 16:
      this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE_MINUS_DST_COLOR, this._gl.ONE_MINUS_SRC_COLOR, this._gl.ZERO, this._gl.ONE), this._alphaState.alphaBlend = !0;
      break;
    case 17:
      this._alphaState.setAlphaBlendFunctionParameters(this._gl.SRC_ALPHA, this._gl.ONE_MINUS_SRC_ALPHA, this._gl.ONE, this._gl.ONE_MINUS_SRC_ALPHA), this._alphaState.alphaBlend = !0;
      break;
  }
  e || (this.depthCullingState.depthMask = h === 0), this._alphaMode = h;
};
Z.prototype.getAlphaMode = function() {
  return this._alphaMode;
};
Z.prototype.setAlphaEquation = function(h) {
  if (this._alphaEquation !== h) {
    switch (h) {
      case 0:
        this._alphaState.setAlphaEquationParameters(32774, 32774);
        break;
      case 1:
        this._alphaState.setAlphaEquationParameters(32778, 32778);
        break;
      case 2:
        this._alphaState.setAlphaEquationParameters(32779, 32779);
        break;
      case 3:
        this._alphaState.setAlphaEquationParameters(32776, 32776);
        break;
      case 4:
        this._alphaState.setAlphaEquationParameters(32775, 32775);
        break;
      case 5:
        this._alphaState.setAlphaEquationParameters(32775, 32774);
        break;
    }
    this._alphaEquation = h;
  }
};
Z.prototype.getAlphaEquation = function() {
  return this._alphaEquation;
};
function Fl(h, e, t = !1, i) {
  switch (h) {
    case 3:
      return e instanceof ArrayBuffer ? new Int8Array(e) : new Int8Array(e);
    case 0:
      return e instanceof ArrayBuffer ? new Uint8Array(e) : new Uint8Array(e);
    case 4:
      return e instanceof ArrayBuffer ? new Int16Array(e) : new Int16Array(t ? e / 2 : e);
    case 5:
    case 8:
    case 9:
    case 10:
    case 2:
      return e instanceof ArrayBuffer ? new Uint16Array(e) : new Uint16Array(t ? e / 2 : e);
    case 6:
      return e instanceof ArrayBuffer ? new Int32Array(e) : new Int32Array(t ? e / 4 : e);
    case 7:
    case 11:
    case 12:
    case 13:
    case 14:
    case 15:
      return e instanceof ArrayBuffer ? new Uint32Array(e) : new Uint32Array(t ? e / 4 : e);
    case 1:
      return e instanceof ArrayBuffer ? new Float32Array(e) : new Float32Array(t ? e / 4 : e);
  }
  return e instanceof ArrayBuffer ? new Uint8Array(e) : new Uint8Array(e);
}
Z.prototype._readTexturePixelsSync = function(h, e, t, i = -1, s = 0, r = null, n = !0, a = !1, o = 0, l = 0) {
  var c, u;
  const d = this._gl;
  if (!d)
    throw new Error("Engine does not have gl rendering context.");
  if (!this._dummyFramebuffer) {
    const _ = d.createFramebuffer();
    if (!_)
      throw new Error("Unable to create dummy framebuffer");
    this._dummyFramebuffer = _;
  }
  d.bindFramebuffer(d.FRAMEBUFFER, this._dummyFramebuffer), i > -1 ? d.framebufferTexture2D(d.FRAMEBUFFER, d.COLOR_ATTACHMENT0, d.TEXTURE_CUBE_MAP_POSITIVE_X + i, (c = h._hardwareTexture) === null || c === void 0 ? void 0 : c.underlyingResource, s) : d.framebufferTexture2D(d.FRAMEBUFFER, d.COLOR_ATTACHMENT0, d.TEXTURE_2D, (u = h._hardwareTexture) === null || u === void 0 ? void 0 : u.underlyingResource, s);
  let f = h.type !== void 0 ? this._getWebGLTextureType(h.type) : d.UNSIGNED_BYTE;
  if (a)
    r || (r = Fl(h.type, 4 * e * t));
  else switch (f) {
    case d.UNSIGNED_BYTE:
      r || (r = new Uint8Array(4 * e * t)), f = d.UNSIGNED_BYTE;
      break;
    default:
      r || (r = new Float32Array(4 * e * t)), f = d.FLOAT;
      break;
  }
  return n && this.flushFramebuffer(), d.readPixels(o, l, e, t, d.RGBA, f, r), d.bindFramebuffer(d.FRAMEBUFFER, this._currentFramebuffer), r;
};
Z.prototype._readTexturePixels = function(h, e, t, i = -1, s = 0, r = null, n = !0, a = !1, o = 0, l = 0) {
  return Promise.resolve(this._readTexturePixelsSync(h, e, t, i, s, r, n, a, o, l));
};
Z.prototype.updateDynamicIndexBuffer = function(h, e, t = 0) {
  this._currentBoundBuffer[this._gl.ELEMENT_ARRAY_BUFFER] = null, this.bindIndexBuffer(h);
  let i;
  h.is32Bits ? i = e instanceof Uint32Array ? e : new Uint32Array(e) : i = e instanceof Uint16Array ? e : new Uint16Array(e), this._gl.bufferData(this._gl.ELEMENT_ARRAY_BUFFER, i, this._gl.DYNAMIC_DRAW), this._resetIndexBufferBinding();
};
Z.prototype.updateDynamicVertexBuffer = function(h, e, t, i) {
  this.bindArrayBuffer(h), t === void 0 && (t = 0);
  const s = e.byteLength || e.length;
  i === void 0 || i >= s && t === 0 ? e instanceof Array ? this._gl.bufferSubData(this._gl.ARRAY_BUFFER, t, new Float32Array(e)) : this._gl.bufferSubData(this._gl.ARRAY_BUFFER, t, e) : e instanceof Array ? this._gl.bufferSubData(this._gl.ARRAY_BUFFER, 0, new Float32Array(e).subarray(t, t + i)) : (e instanceof ArrayBuffer ? e = new Uint8Array(e, t, i) : e = new Uint8Array(e.buffer, e.byteOffset + t, i), this._gl.bufferSubData(this._gl.ARRAY_BUFFER, 0, e)), this._resetVertexBufferBinding();
};
class L extends Z {
  /**
   * Returns the current npm package of the sdk
   */
  // Not mixed with Version for tooling purpose.
  static get NpmPackage() {
    return Z.NpmPackage;
  }
  /**
   * Returns the current version of the framework
   */
  static get Version() {
    return Z.Version;
  }
  /** Gets the list of created engines */
  static get Instances() {
    return de.Instances;
  }
  /**
   * Gets the latest created engine
   */
  static get LastCreatedEngine() {
    return de.LastCreatedEngine;
  }
  /**
   * Gets the latest created scene
   */
  static get LastCreatedScene() {
    return de.LastCreatedScene;
  }
  /** @internal */
  /**
   * Engine abstraction for loading and creating an image bitmap from a given source string.
   * @param imageSource source to load the image from.
   * @param options An object that sets options for the image's extraction.
   * @returns ImageBitmap.
   */
  _createImageBitmapFromSource(e, t) {
    return new Promise((s, r) => {
      const n = new Image();
      n.onload = () => {
        n.decode().then(() => {
          this.createImageBitmap(n, t).then((a) => {
            s(a);
          });
        });
      }, n.onerror = () => {
        r(`Error loading image ${n.src}`);
      }, n.src = e;
    });
  }
  /**
   * Engine abstraction for createImageBitmap
   * @param image source for image
   * @param options An object that sets options for the image's extraction.
   * @returns ImageBitmap
   */
  createImageBitmap(e, t) {
    return createImageBitmap(e, t);
  }
  /**
   * Resize an image and returns the image data as an uint8array
   * @param image image to resize
   * @param bufferWidth destination buffer width
   * @param bufferHeight destination buffer height
   * @returns an uint8array containing RGBA values of bufferWidth * bufferHeight size
   */
  resizeImageBitmap(e, t, i) {
    const r = this.createCanvas(t, i).getContext("2d");
    if (!r)
      throw new Error("Unable to get 2d context for resizeImageBitmap");
    return r.drawImage(e, 0, 0), r.getImageData(0, 0, t, i).data;
  }
  /**
   * Will flag all materials in all scenes in all engines as dirty to trigger new shader compilation
   * @param flag defines which part of the materials must be marked as dirty
   * @param predicate defines a predicate used to filter which materials should be affected
   */
  static MarkAllMaterialsAsDirty(e, t) {
    for (let i = 0; i < L.Instances.length; i++) {
      const s = L.Instances[i];
      for (let r = 0; r < s.scenes.length; r++)
        s.scenes[r].markAllMaterialsAsDirty(e, t);
    }
  }
  /**
   * Method called to create the default loading screen.
   * This can be overridden in your own app.
   * @param canvas The rendering canvas element
   * @returns The loading screen
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static DefaultLoadingScreenFactory(e) {
    throw he("LoadingScreen");
  }
  get _supportsHardwareTextureRescaling() {
    return !!L._RescalePostProcessFactory;
  }
  /**
   * Gets the performance monitor attached to this engine
   * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimize_your_scene#engineinstrumentation
   */
  get performanceMonitor() {
    return this._performanceMonitor;
  }
  /**
   * (WebGPU only) True (default) to be in compatibility mode, meaning rendering all existing scenes without artifacts (same rendering than WebGL).
   * Setting the property to false will improve performances but may not work in some scenes if some precautions are not taken.
   * See https://doc.babylonjs.com/setup/support/webGPU/webGPUOptimization/webGPUNonCompatibilityMode for more details
   */
  get compatibilityMode() {
    return this._compatibilityMode;
  }
  set compatibilityMode(e) {
    this._compatibilityMode = !0;
  }
  // Events
  /**
   * Gets the HTML element used to attach event listeners
   * @returns a HTML element
   */
  getInputElement() {
    return this._renderingCanvas;
  }
  /**
   * Creates a new engine
   * @param canvasOrContext defines the canvas or WebGL context to use for rendering. If you provide a WebGL context, Babylon.js will not hook events on the canvas (like pointers, keyboards, etc...) so no event observables will be available. This is mostly used when Babylon.js is used as a plugin on a system which already used the WebGL context
   * @param antialias defines enable antialiasing (default: false)
   * @param options defines further options to be sent to the getContext() function
   * @param adaptToDeviceRatio defines whether to adapt to the device's viewport characteristics (default: false)
   */
  constructor(e, t, i, s = !1) {
    if (super(e, t, i, s), this.enableOfflineSupport = !1, this.disableManifestCheck = !1, this.disableContextMenu = !0, this.scenes = new Array(), this._virtualScenes = new Array(), this.onNewSceneAddedObservable = new N(), this.postProcesses = new Array(), this.isPointerLock = !1, this.onResizeObservable = new N(), this.onCanvasBlurObservable = new N(), this.onCanvasFocusObservable = new N(), this.onCanvasPointerOutObservable = new N(), this.onBeginFrameObservable = new N(), this.customAnimationFrameRequester = null, this.onEndFrameObservable = new N(), this.onBeforeShaderCompilationObservable = new N(), this.onAfterShaderCompilationObservable = new N(), this._deterministicLockstep = !1, this._lockstepMaxSteps = 4, this._timeStep = 1 / 60, this._fps = 60, this._deltaTime = 0, this._drawCalls = new ci(), this.canvasTabIndex = 1, this.disablePerformanceMonitorInBackground = !1, this._performanceMonitor = new wl(), this._compatibilityMode = !0, this.currentRenderPassId = 0, this._renderPassNames = ["main"], L.Instances.push(this), !!e) {
      if (this._features.supportRenderPasses = !0, i = this._creationOptions, e.getContext) {
        const r = e;
        this._sharedInit(r), this._connectVREvents();
      }
      this._prepareVRComponent(), i.autoEnableWebVR && this.initWebVR();
    }
  }
  _initGLContext() {
    super._initGLContext(), this._rescalePostProcess = null;
  }
  /**
   * Shared initialization across engines types.
   * @param canvas The canvas associated with this instance of the engine.
   */
  _sharedInit(e) {
    super._sharedInit(e), this._onCanvasFocus = () => {
      this.onCanvasFocusObservable.notifyObservers(this);
    }, this._onCanvasBlur = () => {
      this.onCanvasBlurObservable.notifyObservers(this);
    }, this._onCanvasContextMenu = (i) => {
      this.disableContextMenu && i.preventDefault();
    }, e.addEventListener("focus", this._onCanvasFocus), e.addEventListener("blur", this._onCanvasBlur), e.addEventListener("contextmenu", this._onCanvasContextMenu), this._onBlur = () => {
      this.disablePerformanceMonitorInBackground && this._performanceMonitor.disable(), this._windowIsBackground = !0;
    }, this._onFocus = () => {
      this.disablePerformanceMonitorInBackground && this._performanceMonitor.enable(), this._windowIsBackground = !1;
    }, this._onCanvasPointerOut = (i) => {
      document.elementFromPoint(i.clientX, i.clientY) !== e && this.onCanvasPointerOutObservable.notifyObservers(i);
    };
    const t = this.getHostWindow();
    t && typeof t.addEventListener == "function" && (t.addEventListener("blur", this._onBlur), t.addEventListener("focus", this._onFocus)), e.addEventListener("pointerout", this._onCanvasPointerOut), this._creationOptions.doNotHandleTouchAction || this._disableTouchAction(), !L.audioEngine && this._creationOptions.audioEngine && L.AudioEngineFactory && (L.audioEngine = L.AudioEngineFactory(this.getRenderingCanvas(), this.getAudioContext(), this.getAudioDestination())), Rs() && (this._onFullscreenChange = () => {
      this.isFullscreen = !!document.fullscreenElement, this.isFullscreen && this._pointerLockRequested && e && L._RequestPointerlock(e);
    }, document.addEventListener("fullscreenchange", this._onFullscreenChange, !1), document.addEventListener("webkitfullscreenchange", this._onFullscreenChange, !1), this._onPointerLockChange = () => {
      this.isPointerLock = document.pointerLockElement === e;
    }, document.addEventListener("pointerlockchange", this._onPointerLockChange, !1), document.addEventListener("webkitpointerlockchange", this._onPointerLockChange, !1)), this.enableOfflineSupport = L.OfflineProviderFactory !== void 0, this._deterministicLockstep = !!this._creationOptions.deterministicLockstep, this._lockstepMaxSteps = this._creationOptions.lockstepMaxSteps || 0, this._timeStep = this._creationOptions.timeStep || 1 / 60;
  }
  /** @internal */
  _verifyPointerLock() {
    var e;
    (e = this._onPointerLockChange) === null || e === void 0 || e.call(this);
  }
  /**
   * Gets current aspect ratio
   * @param viewportOwner defines the camera to use to get the aspect ratio
   * @param useScreen defines if screen size must be used (or the current render target if any)
   * @returns a number defining the aspect ratio
   */
  getAspectRatio(e, t = !1) {
    const i = e.viewport;
    return this.getRenderWidth(t) * i.width / (this.getRenderHeight(t) * i.height);
  }
  /**
   * Gets current screen aspect ratio
   * @returns a number defining the aspect ratio
   */
  getScreenAspectRatio() {
    return this.getRenderWidth(!0) / this.getRenderHeight(!0);
  }
  /**
   * Gets the client rect of the HTML canvas attached with the current webGL context
   * @returns a client rectangle
   */
  getRenderingCanvasClientRect() {
    return this._renderingCanvas ? this._renderingCanvas.getBoundingClientRect() : null;
  }
  /**
   * Gets the client rect of the HTML element used for events
   * @returns a client rectangle
   */
  getInputElementClientRect() {
    return this._renderingCanvas ? this.getInputElement().getBoundingClientRect() : null;
  }
  /**
   * Gets a boolean indicating that the engine is running in deterministic lock step mode
   * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
   * @returns true if engine is in deterministic lock step mode
   */
  isDeterministicLockStep() {
    return this._deterministicLockstep;
  }
  /**
   * Gets the max steps when engine is running in deterministic lock step
   * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
   * @returns the max steps
   */
  getLockstepMaxSteps() {
    return this._lockstepMaxSteps;
  }
  /**
   * Returns the time in ms between steps when using deterministic lock step.
   * @returns time step in (ms)
   */
  getTimeStep() {
    return this._timeStep * 1e3;
  }
  /**
   * Force the mipmap generation for the given render target texture
   * @param texture defines the render target texture to use
   * @param unbind defines whether or not to unbind the texture after generation. Defaults to true.
   */
  generateMipMapsForCubemap(e, t = !0) {
    if (e.generateMipMaps) {
      const i = this._gl;
      this._bindTextureDirectly(i.TEXTURE_CUBE_MAP, e, !0), i.generateMipmap(i.TEXTURE_CUBE_MAP), t && this._bindTextureDirectly(i.TEXTURE_CUBE_MAP, null);
    }
  }
  /** States */
  /**
   * Gets a boolean indicating if depth writing is enabled
   * @returns the current depth writing state
   */
  getDepthWrite() {
    return this._depthCullingState.depthMask;
  }
  /**
   * Enable or disable depth writing
   * @param enable defines the state to set
   */
  setDepthWrite(e) {
    this._depthCullingState.depthMask = e;
  }
  /**
   * Gets a boolean indicating if stencil buffer is enabled
   * @returns the current stencil buffer state
   */
  getStencilBuffer() {
    return this._stencilState.stencilTest;
  }
  /**
   * Enable or disable the stencil buffer
   * @param enable defines if the stencil buffer must be enabled or disabled
   */
  setStencilBuffer(e) {
    this._stencilState.stencilTest = e;
  }
  /**
   * Gets the current stencil mask
   * @returns a number defining the new stencil mask to use
   */
  getStencilMask() {
    return this._stencilState.stencilMask;
  }
  /**
   * Sets the current stencil mask
   * @param mask defines the new stencil mask to use
   */
  setStencilMask(e) {
    this._stencilState.stencilMask = e;
  }
  /**
   * Gets the current stencil function
   * @returns a number defining the stencil function to use
   */
  getStencilFunction() {
    return this._stencilState.stencilFunc;
  }
  /**
   * Gets the current stencil reference value
   * @returns a number defining the stencil reference value to use
   */
  getStencilFunctionReference() {
    return this._stencilState.stencilFuncRef;
  }
  /**
   * Gets the current stencil mask
   * @returns a number defining the stencil mask to use
   */
  getStencilFunctionMask() {
    return this._stencilState.stencilFuncMask;
  }
  /**
   * Sets the current stencil function
   * @param stencilFunc defines the new stencil function to use
   */
  setStencilFunction(e) {
    this._stencilState.stencilFunc = e;
  }
  /**
   * Sets the current stencil reference
   * @param reference defines the new stencil reference to use
   */
  setStencilFunctionReference(e) {
    this._stencilState.stencilFuncRef = e;
  }
  /**
   * Sets the current stencil mask
   * @param mask defines the new stencil mask to use
   */
  setStencilFunctionMask(e) {
    this._stencilState.stencilFuncMask = e;
  }
  /**
   * Gets the current stencil operation when stencil fails
   * @returns a number defining stencil operation to use when stencil fails
   */
  getStencilOperationFail() {
    return this._stencilState.stencilOpStencilFail;
  }
  /**
   * Gets the current stencil operation when depth fails
   * @returns a number defining stencil operation to use when depth fails
   */
  getStencilOperationDepthFail() {
    return this._stencilState.stencilOpDepthFail;
  }
  /**
   * Gets the current stencil operation when stencil passes
   * @returns a number defining stencil operation to use when stencil passes
   */
  getStencilOperationPass() {
    return this._stencilState.stencilOpStencilDepthPass;
  }
  /**
   * Sets the stencil operation to use when stencil fails
   * @param operation defines the stencil operation to use when stencil fails
   */
  setStencilOperationFail(e) {
    this._stencilState.stencilOpStencilFail = e;
  }
  /**
   * Sets the stencil operation to use when depth fails
   * @param operation defines the stencil operation to use when depth fails
   */
  setStencilOperationDepthFail(e) {
    this._stencilState.stencilOpDepthFail = e;
  }
  /**
   * Sets the stencil operation to use when stencil passes
   * @param operation defines the stencil operation to use when stencil passes
   */
  setStencilOperationPass(e) {
    this._stencilState.stencilOpStencilDepthPass = e;
  }
  /**
   * Sets a boolean indicating if the dithering state is enabled or disabled
   * @param value defines the dithering state
   */
  setDitheringState(e) {
    e ? this._gl.enable(this._gl.DITHER) : this._gl.disable(this._gl.DITHER);
  }
  /**
   * Sets a boolean indicating if the rasterizer state is enabled or disabled
   * @param value defines the rasterizer state
   */
  setRasterizerState(e) {
    e ? this._gl.disable(this._gl.RASTERIZER_DISCARD) : this._gl.enable(this._gl.RASTERIZER_DISCARD);
  }
  /**
   * Gets the current depth function
   * @returns a number defining the depth function
   */
  getDepthFunction() {
    return this._depthCullingState.depthFunc;
  }
  /**
   * Sets the current depth function
   * @param depthFunc defines the function to use
   */
  setDepthFunction(e) {
    this._depthCullingState.depthFunc = e;
  }
  /**
   * Sets the current depth function to GREATER
   */
  setDepthFunctionToGreater() {
    this.setDepthFunction(516);
  }
  /**
   * Sets the current depth function to GEQUAL
   */
  setDepthFunctionToGreaterOrEqual() {
    this.setDepthFunction(518);
  }
  /**
   * Sets the current depth function to LESS
   */
  setDepthFunctionToLess() {
    this.setDepthFunction(513);
  }
  /**
   * Sets the current depth function to LEQUAL
   */
  setDepthFunctionToLessOrEqual() {
    this.setDepthFunction(515);
  }
  /**
   * Caches the the state of the stencil buffer
   */
  cacheStencilState() {
    this._cachedStencilBuffer = this.getStencilBuffer(), this._cachedStencilFunction = this.getStencilFunction(), this._cachedStencilMask = this.getStencilMask(), this._cachedStencilOperationPass = this.getStencilOperationPass(), this._cachedStencilOperationFail = this.getStencilOperationFail(), this._cachedStencilOperationDepthFail = this.getStencilOperationDepthFail(), this._cachedStencilReference = this.getStencilFunctionReference();
  }
  /**
   * Restores the state of the stencil buffer
   */
  restoreStencilState() {
    this.setStencilFunction(this._cachedStencilFunction), this.setStencilMask(this._cachedStencilMask), this.setStencilBuffer(this._cachedStencilBuffer), this.setStencilOperationPass(this._cachedStencilOperationPass), this.setStencilOperationFail(this._cachedStencilOperationFail), this.setStencilOperationDepthFail(this._cachedStencilOperationDepthFail), this.setStencilFunctionReference(this._cachedStencilReference);
  }
  /**
   * Directly set the WebGL Viewport
   * @param x defines the x coordinate of the viewport (in screen space)
   * @param y defines the y coordinate of the viewport (in screen space)
   * @param width defines the width of the viewport (in screen space)
   * @param height defines the height of the viewport (in screen space)
   * @returns the current viewport Object (if any) that is being replaced by this call. You can restore this viewport later on to go back to the original state
   */
  setDirectViewport(e, t, i, s) {
    const r = this._cachedViewport;
    return this._cachedViewport = null, this._viewport(e, t, i, s), r;
  }
  /**
   * Executes a scissor clear (ie. a clear on a specific portion of the screen)
   * @param x defines the x-coordinate of the bottom left corner of the clear rectangle
   * @param y defines the y-coordinate of the corner of the clear rectangle
   * @param width defines the width of the clear rectangle
   * @param height defines the height of the clear rectangle
   * @param clearColor defines the clear color
   */
  scissorClear(e, t, i, s, r) {
    this.enableScissor(e, t, i, s), this.clear(r, !0, !0, !0), this.disableScissor();
  }
  /**
   * Enable scissor test on a specific rectangle (ie. render will only be executed on a specific portion of the screen)
   * @param x defines the x-coordinate of the bottom left corner of the clear rectangle
   * @param y defines the y-coordinate of the corner of the clear rectangle
   * @param width defines the width of the clear rectangle
   * @param height defines the height of the clear rectangle
   */
  enableScissor(e, t, i, s) {
    const r = this._gl;
    r.enable(r.SCISSOR_TEST), r.scissor(e, t, i, s);
  }
  /**
   * Disable previously set scissor test rectangle
   */
  disableScissor() {
    const e = this._gl;
    e.disable(e.SCISSOR_TEST);
  }
  /**
   * @internal
   */
  _reportDrawCall(e = 1) {
    this._drawCalls.addCount(e, !1);
  }
  /**
   * Initializes a webVR display and starts listening to display change events
   * The onVRDisplayChangedObservable will be notified upon these changes
   * @returns The onVRDisplayChangedObservable
   */
  initWebVR() {
    throw he("WebVRCamera");
  }
  /** @internal */
  _prepareVRComponent() {
  }
  /**
   * @internal
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _connectVREvents(e, t) {
  }
  /** @internal */
  _submitVRFrame() {
  }
  /**
   * Call this function to leave webVR mode
   * Will do nothing if webVR is not supported or if there is no webVR device
   * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/webVRCamera
   */
  disableVR() {
  }
  /**
   * Gets a boolean indicating that the system is in VR mode and is presenting
   * @returns true if VR mode is engaged
   */
  isVRPresenting() {
    return !1;
  }
  /** @internal */
  _requestVRFrame() {
  }
  /**
   * @internal
   */
  _loadFileAsync(e, t, i) {
    return new Promise((s, r) => {
      this._loadFile(e, (n) => {
        s(n);
      }, void 0, t, i, (n, a) => {
        r(a);
      });
    });
  }
  /**
   * Gets the source code of the vertex shader associated with a specific webGL program
   * @param program defines the program to use
   * @returns a string containing the source code of the vertex shader associated with the program
   */
  getVertexShaderSource(e) {
    const t = this._gl.getAttachedShaders(e);
    return t ? this._gl.getShaderSource(t[0]) : null;
  }
  /**
   * Gets the source code of the fragment shader associated with a specific webGL program
   * @param program defines the program to use
   * @returns a string containing the source code of the fragment shader associated with the program
   */
  getFragmentShaderSource(e) {
    const t = this._gl.getAttachedShaders(e);
    return t ? this._gl.getShaderSource(t[1]) : null;
  }
  /**
   * Sets a depth stencil texture from a render target to the according uniform.
   * @param channel The texture channel
   * @param uniform The uniform to set
   * @param texture The render target texture containing the depth stencil texture to apply
   * @param name The texture name
   */
  setDepthStencilTexture(e, t, i, s) {
    e !== void 0 && (t && (this._boundUniforms[e] = t), !i || !i.depthStencilTexture ? this._setTexture(e, null, void 0, void 0, s) : this._setTexture(e, i, !1, !0, s));
  }
  /**
   * Sets a texture to the webGL context from a postprocess
   * @param channel defines the channel to use
   * @param postProcess defines the source postprocess
   * @param name name of the channel
   */
  setTextureFromPostProcess(e, t, i) {
    var s;
    let r = null;
    t && (t._forcedOutputTexture ? r = t._forcedOutputTexture : t._textures.data[t._currentRenderTextureInd] && (r = t._textures.data[t._currentRenderTextureInd])), this._bindTexture(e, (s = r == null ? void 0 : r.texture) !== null && s !== void 0 ? s : null, i);
  }
  /**
   * Binds the output of the passed in post process to the texture channel specified
   * @param channel The channel the texture should be bound to
   * @param postProcess The post process which's output should be bound
   * @param name name of the channel
   */
  setTextureFromPostProcessOutput(e, t, i) {
    var s, r;
    this._bindTexture(e, (r = (s = t == null ? void 0 : t._outputTexture) === null || s === void 0 ? void 0 : s.texture) !== null && r !== void 0 ? r : null, i);
  }
  _rebuildBuffers() {
    for (const e of this.scenes)
      e.resetCachedMaterial(), e._rebuildGeometries(), e._rebuildTextures();
    for (const e of this._virtualScenes)
      e.resetCachedMaterial(), e._rebuildGeometries(), e._rebuildTextures();
    super._rebuildBuffers();
  }
  /** @internal */
  _renderFrame() {
    for (let e = 0; e < this._activeRenderLoops.length; e++) {
      const t = this._activeRenderLoops[e];
      t();
    }
  }
  _cancelFrame() {
    if (this._renderingQueueLaunched && this.customAnimationFrameRequester) {
      this._renderingQueueLaunched = !1;
      const { cancelAnimationFrame: e } = this.customAnimationFrameRequester;
      e && e(this.customAnimationFrameRequester.requestID);
    } else
      super._cancelFrame();
  }
  _renderLoop() {
    if (!this._contextWasLost) {
      let e = !0;
      (this.isDisposed || !this.renderEvenInBackground && this._windowIsBackground) && (e = !1), e && (this.beginFrame(), this._renderViews() || this._renderFrame(), this.endFrame());
    }
    this._activeRenderLoops.length > 0 ? this.customAnimationFrameRequester ? (this.customAnimationFrameRequester.requestID = this._queueNewFrame(this.customAnimationFrameRequester.renderFunction || this._boundRenderFunction, this.customAnimationFrameRequester), this._frameHandler = this.customAnimationFrameRequester.requestID) : this.isVRPresenting() ? this._requestVRFrame() : this._frameHandler = this._queueNewFrame(this._boundRenderFunction, this.getHostWindow()) : this._renderingQueueLaunched = !1;
  }
  /** @internal */
  _renderViews() {
    return !1;
  }
  /**
   * Toggle full screen mode
   * @param requestPointerLock defines if a pointer lock should be requested from the user
   */
  switchFullscreen(e) {
    this.isFullscreen ? this.exitFullscreen() : this.enterFullscreen(e);
  }
  /**
   * Enters full screen mode
   * @param requestPointerLock defines if a pointer lock should be requested from the user
   */
  enterFullscreen(e) {
    this.isFullscreen || (this._pointerLockRequested = e, this._renderingCanvas && L._RequestFullscreen(this._renderingCanvas));
  }
  /**
   * Exits full screen mode
   */
  exitFullscreen() {
    this.isFullscreen && L._ExitFullscreen();
  }
  /**
   * Enters Pointerlock mode
   */
  enterPointerlock() {
    this._renderingCanvas && L._RequestPointerlock(this._renderingCanvas);
  }
  /**
   * Exits Pointerlock mode
   */
  exitPointerlock() {
    L._ExitPointerlock();
  }
  /**
   * Begin a new frame
   */
  beginFrame() {
    this._measureFps(), this.onBeginFrameObservable.notifyObservers(this), super.beginFrame();
  }
  /**
   * End the current frame
   */
  endFrame() {
    super.endFrame(), this._submitVRFrame(), this.onEndFrameObservable.notifyObservers(this);
  }
  /**
   * Resize the view according to the canvas' size
   * @param forceSetSize true to force setting the sizes of the underlying canvas
   */
  resize(e = !1) {
    this.isVRPresenting() || super.resize(e);
  }
  /**
   * Force a specific size of the canvas
   * @param width defines the new canvas' width
   * @param height defines the new canvas' height
   * @param forceSetSize true to force setting the sizes of the underlying canvas
   * @returns true if the size was changed
   */
  setSize(e, t, i = !1) {
    if (!this._renderingCanvas || !super.setSize(e, t, i))
      return !1;
    if (this.scenes) {
      for (let s = 0; s < this.scenes.length; s++) {
        const r = this.scenes[s];
        for (let n = 0; n < r.cameras.length; n++) {
          const a = r.cameras[n];
          a._currentRenderId = 0;
        }
      }
      this.onResizeObservable.hasObservers() && this.onResizeObservable.notifyObservers(this);
    }
    return !0;
  }
  _deletePipelineContext(e) {
    const t = e;
    t && t.program && t.transformFeedback && (this.deleteTransformFeedback(t.transformFeedback), t.transformFeedback = null), super._deletePipelineContext(e);
  }
  createShaderProgram(e, t, i, s, r, n = null) {
    r = r || this._gl, this.onBeforeShaderCompilationObservable.notifyObservers(this);
    const a = super.createShaderProgram(e, t, i, s, r, n);
    return this.onAfterShaderCompilationObservable.notifyObservers(this), a;
  }
  _createShaderProgram(e, t, i, s, r = null) {
    const n = s.createProgram();
    if (e.program = n, !n)
      throw new Error("Unable to create program");
    if (s.attachShader(n, t), s.attachShader(n, i), this.webGLVersion > 1 && r) {
      const a = this.createTransformFeedback();
      this.bindTransformFeedback(a), this.setTranformFeedbackVaryings(n, r), e.transformFeedback = a;
    }
    return s.linkProgram(n), this.webGLVersion > 1 && r && this.bindTransformFeedback(null), e.context = s, e.vertexShader = t, e.fragmentShader = i, e.isParallelCompiled || this._finalizePipelineContext(e), n;
  }
  /**
   * @internal
   */
  _releaseTexture(e) {
    super._releaseTexture(e);
  }
  /**
   * @internal
   */
  _releaseRenderTargetWrapper(e) {
    super._releaseRenderTargetWrapper(e), this.scenes.forEach((t) => {
      t.postProcesses.forEach((i) => {
        i._outputTexture === e && (i._outputTexture = null);
      }), t.cameras.forEach((i) => {
        i._postProcesses.forEach((s) => {
          s && s._outputTexture === e && (s._outputTexture = null);
        });
      });
    });
  }
  /**
   * Gets the names of the render passes that are currently created
   * @returns list of the render pass names
   */
  getRenderPassNames() {
    return this._renderPassNames;
  }
  /**
   * Gets the name of the current render pass
   * @returns name of the current render pass
   */
  getCurrentRenderPassName() {
    return this._renderPassNames[this.currentRenderPassId];
  }
  /**
   * Creates a render pass id
   * @param name Name of the render pass (for debug purpose only)
   * @returns the id of the new render pass
   */
  createRenderPassId(e) {
    const t = ++L._RenderPassIdCounter;
    return this._renderPassNames[t] = e ?? "NONAME", t;
  }
  /**
   * Releases a render pass id
   * @param id id of the render pass to release
   */
  releaseRenderPassId(e) {
    this._renderPassNames[e] = void 0;
    for (let t = 0; t < this.scenes.length; ++t) {
      const i = this.scenes[t];
      for (let s = 0; s < i.meshes.length; ++s) {
        const r = i.meshes[s];
        if (r.subMeshes)
          for (let n = 0; n < r.subMeshes.length; ++n)
            r.subMeshes[n]._removeDrawWrapper(e);
      }
    }
  }
  /**
   * @internal
   * Rescales a texture
   * @param source input texture
   * @param destination destination texture
   * @param scene scene to use to render the resize
   * @param internalFormat format to use when resizing
   * @param onComplete callback to be called when resize has completed
   */
  _rescaleTexture(e, t, i, s, r) {
    this._gl.texParameteri(this._gl.TEXTURE_2D, this._gl.TEXTURE_MAG_FILTER, this._gl.LINEAR), this._gl.texParameteri(this._gl.TEXTURE_2D, this._gl.TEXTURE_MIN_FILTER, this._gl.LINEAR), this._gl.texParameteri(this._gl.TEXTURE_2D, this._gl.TEXTURE_WRAP_S, this._gl.CLAMP_TO_EDGE), this._gl.texParameteri(this._gl.TEXTURE_2D, this._gl.TEXTURE_WRAP_T, this._gl.CLAMP_TO_EDGE);
    const n = this.createRenderTargetTexture({
      width: t.width,
      height: t.height
    }, {
      generateMipMaps: !1,
      type: 0,
      samplingMode: 2,
      generateDepthBuffer: !1,
      generateStencilBuffer: !1
    });
    !this._rescalePostProcess && L._RescalePostProcessFactory && (this._rescalePostProcess = L._RescalePostProcessFactory(this)), this._rescalePostProcess && (this._rescalePostProcess.externalTextureSamplerBinding = !0, this._rescalePostProcess.getEffect().executeWhenCompiled(() => {
      this._rescalePostProcess.onApply = function(o) {
        o._bindTexture("textureSampler", e);
      };
      let a = i;
      a || (a = this.scenes[this.scenes.length - 1]), a.postProcessManager.directRender([this._rescalePostProcess], n, !0), this._bindTextureDirectly(this._gl.TEXTURE_2D, t, !0), this._gl.copyTexImage2D(this._gl.TEXTURE_2D, 0, s, 0, 0, t.width, t.height, 0), this.unBindFramebuffer(n), n.dispose(), r && r();
    }));
  }
  // FPS
  /**
   * Gets the current framerate
   * @returns a number representing the framerate
   */
  getFps() {
    return this._fps;
  }
  /**
   * Gets the time spent between current and previous frame
   * @returns a number representing the delta time in ms
   */
  getDeltaTime() {
    return this._deltaTime;
  }
  _measureFps() {
    this._performanceMonitor.sampleFrame(), this._fps = this._performanceMonitor.averageFPS, this._deltaTime = this._performanceMonitor.instantaneousFrameTime || 0;
  }
  /**
   * Wraps an external web gl texture in a Babylon texture.
   * @param texture defines the external texture
   * @param hasMipMaps defines whether the external texture has mip maps (default: false)
   * @param samplingMode defines the sampling mode for the external texture (default: 3)
   * @returns the babylon internal texture
   */
  wrapWebGLTexture(e, t = !1, i = 3) {
    const s = new Fa(e, this._gl), r = new zt(this, Ze.Unknown, !0);
    return r._hardwareTexture = s, r.isReady = !0, r.useMipMaps = t, this.updateTextureSamplingMode(i, r), r;
  }
  /**
   * @internal
   */
  _uploadImageToTexture(e, t, i = 0, s = 0) {
    const r = this._gl, n = this._getWebGLTextureType(e.type), a = this._getInternalFormat(e.format), o = this._getRGBABufferInternalSizedFormat(e.type, a), l = e.isCube ? r.TEXTURE_CUBE_MAP : r.TEXTURE_2D;
    this._bindTextureDirectly(l, e, !0), this._unpackFlipY(e.invertY);
    let c = r.TEXTURE_2D;
    e.isCube && (c = r.TEXTURE_CUBE_MAP_POSITIVE_X + i), r.texImage2D(c, s, o, a, n, t), this._bindTextureDirectly(l, null, !0);
  }
  /**
   * Updates a depth texture Comparison Mode and Function.
   * If the comparison Function is equal to 0, the mode will be set to none.
   * Otherwise, this only works in webgl 2 and requires a shadow sampler in the shader.
   * @param texture The texture to set the comparison function for
   * @param comparisonFunction The comparison function to set, 0 if no comparison required
   */
  updateTextureComparisonFunction(e, t) {
    if (this.webGLVersion === 1) {
      w.Error("WebGL 1 does not support texture comparison.");
      return;
    }
    const i = this._gl;
    e.isCube ? (this._bindTextureDirectly(this._gl.TEXTURE_CUBE_MAP, e, !0), t === 0 ? (i.texParameteri(i.TEXTURE_CUBE_MAP, i.TEXTURE_COMPARE_FUNC, 515), i.texParameteri(i.TEXTURE_CUBE_MAP, i.TEXTURE_COMPARE_MODE, i.NONE)) : (i.texParameteri(i.TEXTURE_CUBE_MAP, i.TEXTURE_COMPARE_FUNC, t), i.texParameteri(i.TEXTURE_CUBE_MAP, i.TEXTURE_COMPARE_MODE, i.COMPARE_REF_TO_TEXTURE)), this._bindTextureDirectly(this._gl.TEXTURE_CUBE_MAP, null)) : (this._bindTextureDirectly(this._gl.TEXTURE_2D, e, !0), t === 0 ? (i.texParameteri(i.TEXTURE_2D, i.TEXTURE_COMPARE_FUNC, 515), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_COMPARE_MODE, i.NONE)) : (i.texParameteri(i.TEXTURE_2D, i.TEXTURE_COMPARE_FUNC, t), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_COMPARE_MODE, i.COMPARE_REF_TO_TEXTURE)), this._bindTextureDirectly(this._gl.TEXTURE_2D, null)), e._comparisonFunction = t;
  }
  /**
   * Creates a webGL buffer to use with instantiation
   * @param capacity defines the size of the buffer
   * @returns the webGL buffer
   */
  createInstancesBuffer(e) {
    const t = this._gl.createBuffer();
    if (!t)
      throw new Error("Unable to create instance buffer");
    const i = new Ls(t);
    return i.capacity = e, this.bindArrayBuffer(i), this._gl.bufferData(this._gl.ARRAY_BUFFER, e, this._gl.DYNAMIC_DRAW), i.references = 1, i;
  }
  /**
   * Delete a webGL buffer used with instantiation
   * @param buffer defines the webGL buffer to delete
   */
  deleteInstancesBuffer(e) {
    this._gl.deleteBuffer(e);
  }
  _clientWaitAsync(e, t = 0, i = 10) {
    const s = this._gl;
    return new Promise((r, n) => {
      const a = () => {
        const o = s.clientWaitSync(e, t, 0);
        if (o == s.WAIT_FAILED) {
          n();
          return;
        }
        if (o == s.TIMEOUT_EXPIRED) {
          setTimeout(a, i);
          return;
        }
        r();
      };
      a();
    });
  }
  /**
   * @internal
   */
  _readPixelsAsync(e, t, i, s, r, n, a) {
    if (this._webGLVersion < 2)
      throw new Error("_readPixelsAsync only work on WebGL2+");
    const o = this._gl, l = o.createBuffer();
    o.bindBuffer(o.PIXEL_PACK_BUFFER, l), o.bufferData(o.PIXEL_PACK_BUFFER, a.byteLength, o.STREAM_READ), o.readPixels(e, t, i, s, r, n, 0), o.bindBuffer(o.PIXEL_PACK_BUFFER, null);
    const c = o.fenceSync(o.SYNC_GPU_COMMANDS_COMPLETE, 0);
    return c ? (o.flush(), this._clientWaitAsync(c, 0, 10).then(() => (o.deleteSync(c), o.bindBuffer(o.PIXEL_PACK_BUFFER, l), o.getBufferSubData(o.PIXEL_PACK_BUFFER, 0, a), o.bindBuffer(o.PIXEL_PACK_BUFFER, null), o.deleteBuffer(l), a))) : null;
  }
  dispose() {
    for (this.hideLoadingUI(), this.onNewSceneAddedObservable.clear(); this.postProcesses.length; )
      this.postProcesses[0].dispose();
    for (this._rescalePostProcess && this._rescalePostProcess.dispose(); this.scenes.length; )
      this.scenes[0].dispose();
    for (; this._virtualScenes.length; )
      this._virtualScenes[0].dispose();
    de.Instances.length === 1 && L.audioEngine && (L.audioEngine.dispose(), L.audioEngine = null), this.disableVR();
    const e = this.getHostWindow();
    e && typeof e.removeEventListener == "function" && (e.removeEventListener("blur", this._onBlur), e.removeEventListener("focus", this._onFocus)), this._renderingCanvas && (this._renderingCanvas.removeEventListener("focus", this._onCanvasFocus), this._renderingCanvas.removeEventListener("blur", this._onCanvasBlur), this._renderingCanvas.removeEventListener("pointerout", this._onCanvasPointerOut), this._renderingCanvas.removeEventListener("contextmenu", this._onCanvasContextMenu)), Rs() && (document.removeEventListener("fullscreenchange", this._onFullscreenChange), document.removeEventListener("mozfullscreenchange", this._onFullscreenChange), document.removeEventListener("webkitfullscreenchange", this._onFullscreenChange), document.removeEventListener("msfullscreenchange", this._onFullscreenChange), document.removeEventListener("pointerlockchange", this._onPointerLockChange), document.removeEventListener("mspointerlockchange", this._onPointerLockChange), document.removeEventListener("mozpointerlockchange", this._onPointerLockChange), document.removeEventListener("webkitpointerlockchange", this._onPointerLockChange)), super.dispose();
    const t = de.Instances.indexOf(this);
    t >= 0 && de.Instances.splice(t, 1), L.Instances.length || de.OnEnginesDisposedObservable.notifyObservers(this), this.onResizeObservable.clear(), this.onCanvasBlurObservable.clear(), this.onCanvasFocusObservable.clear(), this.onCanvasPointerOutObservable.clear(), this.onBeginFrameObservable.clear(), this.onEndFrameObservable.clear();
  }
  _disableTouchAction() {
    !this._renderingCanvas || !this._renderingCanvas.setAttribute || (this._renderingCanvas.setAttribute("touch-action", "none"), this._renderingCanvas.style.touchAction = "none", this._renderingCanvas.style.webkitTapHighlightColor = "transparent");
  }
  // Loading screen
  /**
   * Display the loading screen
   * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/customLoadingScreen
   */
  displayLoadingUI() {
    if (!_t())
      return;
    const e = this.loadingScreen;
    e && e.displayLoadingUI();
  }
  /**
   * Hide the loading screen
   * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/customLoadingScreen
   */
  hideLoadingUI() {
    if (!_t())
      return;
    const e = this._loadingScreen;
    e && e.hideLoadingUI();
  }
  /**
   * Gets the current loading screen object
   * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/customLoadingScreen
   */
  get loadingScreen() {
    return !this._loadingScreen && this._renderingCanvas && (this._loadingScreen = L.DefaultLoadingScreenFactory(this._renderingCanvas)), this._loadingScreen;
  }
  /**
   * Sets the current loading screen object
   * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/customLoadingScreen
   */
  set loadingScreen(e) {
    this._loadingScreen = e;
  }
  /**
   * Sets the current loading screen text
   * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/customLoadingScreen
   */
  set loadingUIText(e) {
    this.loadingScreen.loadingUIText = e;
  }
  /**
   * Sets the current loading screen background color
   * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/customLoadingScreen
   */
  set loadingUIBackgroundColor(e) {
    this.loadingScreen.loadingUIBackgroundColor = e;
  }
  /**
   * creates and returns a new video element
   * @param constraints video constraints
   * @returns video element
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  createVideoElement(e) {
    return document.createElement("video");
  }
  /** Pointerlock and fullscreen */
  /**
   * Ask the browser to promote the current element to pointerlock mode
   * @param element defines the DOM element to promote
   */
  static _RequestPointerlock(e) {
    if (e.requestPointerLock) {
      const t = e.requestPointerLock();
      t instanceof Promise ? t.then(() => {
        e.focus();
      }).catch(() => {
      }) : e.focus();
    }
  }
  /**
   * Asks the browser to exit pointerlock mode
   */
  static _ExitPointerlock() {
    document.exitPointerLock && document.exitPointerLock();
  }
  /**
   * Ask the browser to promote the current element to fullscreen rendering mode
   * @param element defines the DOM element to promote
   */
  static _RequestFullscreen(e) {
    const t = e.requestFullscreen || e.webkitRequestFullscreen;
    t && t.call(e);
  }
  /**
   * Asks the browser to exit fullscreen mode
   */
  static _ExitFullscreen() {
    const e = document;
    document.exitFullscreen ? document.exitFullscreen() : e.webkitCancelFullScreen && e.webkitCancelFullScreen();
  }
  /**
   * Get Font size information
   * @param font font name
   * @returns an object containing ascent, height and descent
   */
  getFontOffset(e) {
    const t = document.createElement("span");
    t.innerHTML = "Hg", t.setAttribute("style", `font: ${e} !important`);
    const i = document.createElement("div");
    i.style.display = "inline-block", i.style.width = "1px", i.style.height = "0px", i.style.verticalAlign = "bottom";
    const s = document.createElement("div");
    s.style.whiteSpace = "nowrap", s.appendChild(t), s.appendChild(i), document.body.appendChild(s);
    let r = 0, n = 0;
    try {
      n = i.getBoundingClientRect().top - t.getBoundingClientRect().top, i.style.verticalAlign = "baseline", r = i.getBoundingClientRect().top - t.getBoundingClientRect().top;
    } finally {
      document.body.removeChild(s);
    }
    return { ascent: r, height: n, descent: n - r };
  }
}
L.ALPHA_DISABLE = 0;
L.ALPHA_ADD = 1;
L.ALPHA_COMBINE = 2;
L.ALPHA_SUBTRACT = 3;
L.ALPHA_MULTIPLY = 4;
L.ALPHA_MAXIMIZED = 5;
L.ALPHA_ONEONE = 6;
L.ALPHA_PREMULTIPLIED = 7;
L.ALPHA_PREMULTIPLIED_PORTERDUFF = 8;
L.ALPHA_INTERPOLATE = 9;
L.ALPHA_SCREENMODE = 10;
L.DELAYLOADSTATE_NONE = 0;
L.DELAYLOADSTATE_LOADED = 1;
L.DELAYLOADSTATE_LOADING = 2;
L.DELAYLOADSTATE_NOTLOADED = 4;
L.NEVER = 512;
L.ALWAYS = 519;
L.LESS = 513;
L.EQUAL = 514;
L.LEQUAL = 515;
L.GREATER = 516;
L.GEQUAL = 518;
L.NOTEQUAL = 517;
L.KEEP = 7680;
L.REPLACE = 7681;
L.INCR = 7682;
L.DECR = 7683;
L.INVERT = 5386;
L.INCR_WRAP = 34055;
L.DECR_WRAP = 34056;
L.TEXTURE_CLAMP_ADDRESSMODE = 0;
L.TEXTURE_WRAP_ADDRESSMODE = 1;
L.TEXTURE_MIRROR_ADDRESSMODE = 2;
L.TEXTUREFORMAT_ALPHA = 0;
L.TEXTUREFORMAT_LUMINANCE = 1;
L.TEXTUREFORMAT_LUMINANCE_ALPHA = 2;
L.TEXTUREFORMAT_RGB = 4;
L.TEXTUREFORMAT_RGBA = 5;
L.TEXTUREFORMAT_RED = 6;
L.TEXTUREFORMAT_R = 6;
L.TEXTUREFORMAT_RG = 7;
L.TEXTUREFORMAT_RED_INTEGER = 8;
L.TEXTUREFORMAT_R_INTEGER = 8;
L.TEXTUREFORMAT_RG_INTEGER = 9;
L.TEXTUREFORMAT_RGB_INTEGER = 10;
L.TEXTUREFORMAT_RGBA_INTEGER = 11;
L.TEXTURETYPE_UNSIGNED_BYTE = 0;
L.TEXTURETYPE_UNSIGNED_INT = 0;
L.TEXTURETYPE_FLOAT = 1;
L.TEXTURETYPE_HALF_FLOAT = 2;
L.TEXTURETYPE_BYTE = 3;
L.TEXTURETYPE_SHORT = 4;
L.TEXTURETYPE_UNSIGNED_SHORT = 5;
L.TEXTURETYPE_INT = 6;
L.TEXTURETYPE_UNSIGNED_INTEGER = 7;
L.TEXTURETYPE_UNSIGNED_SHORT_4_4_4_4 = 8;
L.TEXTURETYPE_UNSIGNED_SHORT_5_5_5_1 = 9;
L.TEXTURETYPE_UNSIGNED_SHORT_5_6_5 = 10;
L.TEXTURETYPE_UNSIGNED_INT_2_10_10_10_REV = 11;
L.TEXTURETYPE_UNSIGNED_INT_24_8 = 12;
L.TEXTURETYPE_UNSIGNED_INT_10F_11F_11F_REV = 13;
L.TEXTURETYPE_UNSIGNED_INT_5_9_9_9_REV = 14;
L.TEXTURETYPE_FLOAT_32_UNSIGNED_INT_24_8_REV = 15;
L.TEXTURE_NEAREST_SAMPLINGMODE = 1;
L.TEXTURE_BILINEAR_SAMPLINGMODE = 2;
L.TEXTURE_TRILINEAR_SAMPLINGMODE = 3;
L.TEXTURE_NEAREST_NEAREST_MIPLINEAR = 8;
L.TEXTURE_LINEAR_LINEAR_MIPNEAREST = 11;
L.TEXTURE_LINEAR_LINEAR_MIPLINEAR = 3;
L.TEXTURE_NEAREST_NEAREST_MIPNEAREST = 4;
L.TEXTURE_NEAREST_LINEAR_MIPNEAREST = 5;
L.TEXTURE_NEAREST_LINEAR_MIPLINEAR = 6;
L.TEXTURE_NEAREST_LINEAR = 7;
L.TEXTURE_NEAREST_NEAREST = 1;
L.TEXTURE_LINEAR_NEAREST_MIPNEAREST = 9;
L.TEXTURE_LINEAR_NEAREST_MIPLINEAR = 10;
L.TEXTURE_LINEAR_LINEAR = 2;
L.TEXTURE_LINEAR_NEAREST = 12;
L.TEXTURE_EXPLICIT_MODE = 0;
L.TEXTURE_SPHERICAL_MODE = 1;
L.TEXTURE_PLANAR_MODE = 2;
L.TEXTURE_CUBIC_MODE = 3;
L.TEXTURE_PROJECTION_MODE = 4;
L.TEXTURE_SKYBOX_MODE = 5;
L.TEXTURE_INVCUBIC_MODE = 6;
L.TEXTURE_EQUIRECTANGULAR_MODE = 7;
L.TEXTURE_FIXED_EQUIRECTANGULAR_MODE = 8;
L.TEXTURE_FIXED_EQUIRECTANGULAR_MIRRORED_MODE = 9;
L.SCALEMODE_FLOOR = 1;
L.SCALEMODE_NEAREST = 2;
L.SCALEMODE_CEILING = 3;
L._RescalePostProcessFactory = null;
L._RenderPassIdCounter = 0;
var Pe;
(function(h) {
  h[h.LOCAL = 0] = "LOCAL", h[h.WORLD = 1] = "WORLD", h[h.BONE = 2] = "BONE";
})(Pe || (Pe = {}));
class Et {
}
Et.X = new p(1, 0, 0);
Et.Y = new p(0, 1, 0);
Et.Z = new p(0, 0, 1);
var Xi;
(function(h) {
  h[h.X = 0] = "X", h[h.Y = 1] = "Y", h[h.Z = 2] = "Z";
})(Xi || (Xi = {}));
const Ll = I.Compose(p.One(), U.FromEulerAngles(0, Math.PI, 0), p.Zero());
class oe extends ut {
  /**
   * Gets or sets the billboard mode. Default is 0.
   *
   * | Value | Type | Description |
   * | --- | --- | --- |
   * | 0 | BILLBOARDMODE_NONE |  |
   * | 1 | BILLBOARDMODE_X |  |
   * | 2 | BILLBOARDMODE_Y |  |
   * | 4 | BILLBOARDMODE_Z |  |
   * | 7 | BILLBOARDMODE_ALL |  |
   *
   */
  get billboardMode() {
    return this._billboardMode;
  }
  set billboardMode(e) {
    this._billboardMode !== e && (this._billboardMode = e, this._cache.useBillboardPosition = (this._billboardMode & oe.BILLBOARDMODE_USE_POSITION) !== 0, this._computeUseBillboardPath());
  }
  /**
   * Gets or sets a boolean indicating that parent rotation should be preserved when using billboards.
   * This could be useful for glTF objects where parent rotation helps converting from right handed to left handed
   */
  get preserveParentRotationForBillboard() {
    return this._preserveParentRotationForBillboard;
  }
  set preserveParentRotationForBillboard(e) {
    e !== this._preserveParentRotationForBillboard && (this._preserveParentRotationForBillboard = e, this._computeUseBillboardPath());
  }
  _computeUseBillboardPath() {
    this._cache.useBillboardPath = this._billboardMode !== oe.BILLBOARDMODE_NONE && !this.preserveParentRotationForBillboard;
  }
  /**
   * Gets or sets the distance of the object to max, often used by skybox
   */
  get infiniteDistance() {
    return this._infiniteDistance;
  }
  set infiniteDistance(e) {
    this._infiniteDistance !== e && (this._infiniteDistance = e);
  }
  constructor(e, t = null, i = !0) {
    super(e, t), this._forward = new p(0, 0, 1), this._up = new p(0, 1, 0), this._right = new p(1, 0, 0), this._position = p.Zero(), this._rotation = p.Zero(), this._rotationQuaternion = null, this._scaling = p.One(), this._transformToBoneReferal = null, this._isAbsoluteSynced = !1, this._billboardMode = oe.BILLBOARDMODE_NONE, this._preserveParentRotationForBillboard = !1, this.scalingDeterminant = 1, this._infiniteDistance = !1, this.ignoreNonUniformScaling = !1, this.reIntegrateRotationIntoRotationQuaternion = !1, this._poseMatrix = null, this._localMatrix = I.Zero(), this._usePivotMatrix = !1, this._absolutePosition = p.Zero(), this._absoluteScaling = p.Zero(), this._absoluteRotationQuaternion = U.Identity(), this._pivotMatrix = I.Identity(), this._postMultiplyPivotMatrix = !1, this._isWorldMatrixFrozen = !1, this._indexInSceneTransformNodesArray = -1, this.onAfterWorldMatrixUpdateObservable = new N(), this._nonUniformScaling = !1, i && this.getScene().addTransformNode(this);
  }
  /**
   * Gets a string identifying the name of the class
   * @returns "TransformNode" string
   */
  getClassName() {
    return "TransformNode";
  }
  /**
   * Gets or set the node position (default is (0.0, 0.0, 0.0))
   */
  get position() {
    return this._position;
  }
  set position(e) {
    this._position = e, this._isDirty = !0;
  }
  /**
   * return true if a pivot has been set
   * @returns true if a pivot matrix is used
   */
  isUsingPivotMatrix() {
    return this._usePivotMatrix;
  }
  /**
   * Gets or sets the rotation property : a Vector3 defining the rotation value in radians around each local axis X, Y, Z  (default is (0.0, 0.0, 0.0)).
   * If rotation quaternion is set, this Vector3 will be ignored and copy from the quaternion
   */
  get rotation() {
    return this._rotation;
  }
  set rotation(e) {
    this._rotation = e, this._rotationQuaternion = null, this._isDirty = !0;
  }
  /**
   * Gets or sets the scaling property : a Vector3 defining the node scaling along each local axis X, Y, Z (default is (1.0, 1.0, 1.0)).
   */
  get scaling() {
    return this._scaling;
  }
  set scaling(e) {
    this._scaling = e, this._isDirty = !0;
  }
  /**
   * Gets or sets the rotation Quaternion property : this a Quaternion object defining the node rotation by using a unit quaternion (undefined by default, but can be null).
   * If set, only the rotationQuaternion is then used to compute the node rotation (ie. node.rotation will be ignored)
   */
  get rotationQuaternion() {
    return this._rotationQuaternion;
  }
  set rotationQuaternion(e) {
    this._rotationQuaternion = e, e && this._rotation.setAll(0), this._isDirty = !0;
  }
  /**
   * The forward direction of that transform in world space.
   */
  get forward() {
    return p.TransformNormalFromFloatsToRef(0, 0, this.getScene().useRightHandedSystem ? -1 : 1, this.getWorldMatrix(), this._forward), this._forward.normalize();
  }
  /**
   * The up direction of that transform in world space.
   */
  get up() {
    return p.TransformNormalFromFloatsToRef(0, 1, 0, this.getWorldMatrix(), this._up), this._up.normalize();
  }
  /**
   * The right direction of that transform in world space.
   */
  get right() {
    return p.TransformNormalFromFloatsToRef(this.getScene().useRightHandedSystem ? -1 : 1, 0, 0, this.getWorldMatrix(), this._right), this._right.normalize();
  }
  /**
   * Copies the parameter passed Matrix into the mesh Pose matrix.
   * @param matrix the matrix to copy the pose from
   * @returns this TransformNode.
   */
  updatePoseMatrix(e) {
    return this._poseMatrix ? (this._poseMatrix.copyFrom(e), this) : (this._poseMatrix = e.clone(), this);
  }
  /**
   * Returns the mesh Pose matrix.
   * @returns the pose matrix
   */
  getPoseMatrix() {
    return this._poseMatrix || (this._poseMatrix = I.Identity()), this._poseMatrix;
  }
  /** @internal */
  _isSynchronized() {
    const e = this._cache;
    return !(this._billboardMode !== e.billboardMode || this._billboardMode !== oe.BILLBOARDMODE_NONE || e.pivotMatrixUpdated || this._infiniteDistance || this._position._isDirty || this._scaling._isDirty || this._rotationQuaternion && this._rotationQuaternion._isDirty || this._rotation._isDirty);
  }
  /** @internal */
  _initCache() {
    super._initCache();
    const e = this._cache;
    e.localMatrixUpdated = !1, e.billboardMode = -1, e.infiniteDistance = !1, e.useBillboardPosition = !1, e.useBillboardPath = !1;
  }
  /**
   * Returns the current mesh absolute position.
   * Returns a Vector3.
   */
  get absolutePosition() {
    return this.getAbsolutePosition();
  }
  /**
   * Returns the current mesh absolute scaling.
   * Returns a Vector3.
   */
  get absoluteScaling() {
    return this._syncAbsoluteScalingAndRotation(), this._absoluteScaling;
  }
  /**
   * Returns the current mesh absolute rotation.
   * Returns a Quaternion.
   */
  get absoluteRotationQuaternion() {
    return this._syncAbsoluteScalingAndRotation(), this._absoluteRotationQuaternion;
  }
  /**
   * Sets a new matrix to apply before all other transformation
   * @param matrix defines the transform matrix
   * @returns the current TransformNode
   */
  setPreTransformMatrix(e) {
    return this.setPivotMatrix(e, !1);
  }
  /**
   * Sets a new pivot matrix to the current node
   * @param matrix defines the new pivot matrix to use
   * @param postMultiplyPivotMatrix defines if the pivot matrix must be cancelled in the world matrix. When this parameter is set to true (default), the inverse of the pivot matrix is also applied at the end to cancel the transformation effect
   * @returns the current TransformNode
   */
  setPivotMatrix(e, t = !0) {
    return this._pivotMatrix.copyFrom(e), this._usePivotMatrix = !this._pivotMatrix.isIdentity(), this._cache.pivotMatrixUpdated = !0, this._postMultiplyPivotMatrix = t, this._postMultiplyPivotMatrix && (this._pivotMatrixInverse ? this._pivotMatrix.invertToRef(this._pivotMatrixInverse) : this._pivotMatrixInverse = I.Invert(this._pivotMatrix)), this;
  }
  /**
   * Returns the mesh pivot matrix.
   * Default : Identity.
   * @returns the matrix
   */
  getPivotMatrix() {
    return this._pivotMatrix;
  }
  /**
   * Instantiate (when possible) or clone that node with its hierarchy
   * @param newParent defines the new parent to use for the instance (or clone)
   * @param options defines options to configure how copy is done
   * @param options.doNotInstantiate defines if the model must be instantiated or just cloned
   * @param onNewNodeCreated defines an option callback to call when a clone or an instance is created
   * @returns an instance (or a clone) of the current node with its hierarchy
   */
  instantiateHierarchy(e = null, t, i) {
    const s = this.clone("Clone of " + (this.name || this.id), e || this.parent, !0);
    s && i && i(this, s);
    for (const r of this.getChildTransformNodes(!0))
      r.instantiateHierarchy(s, t, i);
    return s;
  }
  /**
   * Prevents the World matrix to be computed any longer
   * @param newWorldMatrix defines an optional matrix to use as world matrix
   * @param decompose defines whether to decompose the given newWorldMatrix or directly assign
   * @returns the TransformNode.
   */
  freezeWorldMatrix(e = null, t = !1) {
    return e ? t ? (this._rotation.setAll(0), this._rotationQuaternion = this._rotationQuaternion || U.Identity(), e.decompose(this._scaling, this._rotationQuaternion, this._position), this.computeWorldMatrix(!0)) : (this._worldMatrix = e, this._absolutePosition.copyFromFloats(this._worldMatrix.m[12], this._worldMatrix.m[13], this._worldMatrix.m[14]), this._afterComputeWorldMatrix()) : (this._isWorldMatrixFrozen = !1, this.computeWorldMatrix(!0)), this._isDirty = !1, this._isWorldMatrixFrozen = !0, this;
  }
  /**
   * Allows back the World matrix computation.
   * @returns the TransformNode.
   */
  unfreezeWorldMatrix() {
    return this._isWorldMatrixFrozen = !1, this.computeWorldMatrix(!0), this;
  }
  /**
   * True if the World matrix has been frozen.
   */
  get isWorldMatrixFrozen() {
    return this._isWorldMatrixFrozen;
  }
  /**
   * Returns the mesh absolute position in the World.
   * @returns a Vector3.
   */
  getAbsolutePosition() {
    return this.computeWorldMatrix(), this._absolutePosition;
  }
  /**
   * Sets the mesh absolute position in the World from a Vector3 or an Array(3).
   * @param absolutePosition the absolute position to set
   * @returns the TransformNode.
   */
  setAbsolutePosition(e) {
    if (!e)
      return this;
    let t, i, s;
    if (e.x === void 0) {
      if (arguments.length < 3)
        return this;
      t = arguments[0], i = arguments[1], s = arguments[2];
    } else
      t = e.x, i = e.y, s = e.z;
    if (this.parent) {
      const r = C.Matrix[0];
      this.parent.getWorldMatrix().invertToRef(r), p.TransformCoordinatesFromFloatsToRef(t, i, s, r, this.position);
    } else
      this.position.x = t, this.position.y = i, this.position.z = s;
    return this._absolutePosition.copyFrom(e), this;
  }
  /**
   * Sets the mesh position in its local space.
   * @param vector3 the position to set in localspace
   * @returns the TransformNode.
   */
  setPositionWithLocalVector(e) {
    return this.computeWorldMatrix(), this.position = p.TransformNormal(e, this._localMatrix), this;
  }
  /**
   * Returns the mesh position in the local space from the current World matrix values.
   * @returns a new Vector3.
   */
  getPositionExpressedInLocalSpace() {
    this.computeWorldMatrix();
    const e = C.Matrix[0];
    return this._localMatrix.invertToRef(e), p.TransformNormal(this.position, e);
  }
  /**
   * Translates the mesh along the passed Vector3 in its local space.
   * @param vector3 the distance to translate in localspace
   * @returns the TransformNode.
   */
  locallyTranslate(e) {
    return this.computeWorldMatrix(!0), this.position = p.TransformCoordinates(e, this._localMatrix), this;
  }
  /**
   * Orients a mesh towards a target point. Mesh must be drawn facing user.
   * @param targetPoint the position (must be in same space as current mesh) to look at
   * @param yawCor optional yaw (y-axis) correction in radians
   * @param pitchCor optional pitch (x-axis) correction in radians
   * @param rollCor optional roll (z-axis) correction in radians
   * @param space the chosen space of the target
   * @returns the TransformNode.
   */
  lookAt(e, t = 0, i = 0, s = 0, r = Pe.LOCAL) {
    const n = oe._LookAtVectorCache, a = r === Pe.LOCAL ? this.position : this.getAbsolutePosition();
    if (e.subtractToRef(a, n), this.setDirection(n, t, i, s), r === Pe.WORLD && this.parent)
      if (this.rotationQuaternion) {
        const o = C.Matrix[0];
        this.rotationQuaternion.toRotationMatrix(o);
        const l = C.Matrix[1];
        this.parent.getWorldMatrix().getRotationMatrixToRef(l), l.invert(), o.multiplyToRef(l, o), this.rotationQuaternion.fromRotationMatrix(o);
      } else {
        const o = C.Quaternion[0];
        U.FromEulerVectorToRef(this.rotation, o);
        const l = C.Matrix[0];
        o.toRotationMatrix(l);
        const c = C.Matrix[1];
        this.parent.getWorldMatrix().getRotationMatrixToRef(c), c.invert(), l.multiplyToRef(c, l), o.fromRotationMatrix(l), o.toEulerAnglesToRef(this.rotation);
      }
    return this;
  }
  /**
   * Returns a new Vector3 that is the localAxis, expressed in the mesh local space, rotated like the mesh.
   * This Vector3 is expressed in the World space.
   * @param localAxis axis to rotate
   * @returns a new Vector3 that is the localAxis, expressed in the mesh local space, rotated like the mesh.
   */
  getDirection(e) {
    const t = p.Zero();
    return this.getDirectionToRef(e, t), t;
  }
  /**
   * Sets the Vector3 "result" as the rotated Vector3 "localAxis" in the same rotation than the mesh.
   * localAxis is expressed in the mesh local space.
   * result is computed in the World space from the mesh World matrix.
   * @param localAxis axis to rotate
   * @param result the resulting transformnode
   * @returns this TransformNode.
   */
  getDirectionToRef(e, t) {
    return p.TransformNormalToRef(e, this.getWorldMatrix(), t), this;
  }
  /**
   * Sets this transform node rotation to the given local axis.
   * @param localAxis the axis in local space
   * @param yawCor optional yaw (y-axis) correction in radians
   * @param pitchCor optional pitch (x-axis) correction in radians
   * @param rollCor optional roll (z-axis) correction in radians
   * @returns this TransformNode
   */
  setDirection(e, t = 0, i = 0, s = 0) {
    const r = -Math.atan2(e.z, e.x) + Math.PI / 2, n = Math.sqrt(e.x * e.x + e.z * e.z), a = -Math.atan2(e.y, n);
    return this.rotationQuaternion ? U.RotationYawPitchRollToRef(r + t, a + i, s, this.rotationQuaternion) : (this.rotation.x = a + i, this.rotation.y = r + t, this.rotation.z = s), this;
  }
  /**
   * Sets a new pivot point to the current node
   * @param point defines the new pivot point to use
   * @param space defines if the point is in world or local space (local by default)
   * @returns the current TransformNode
   */
  setPivotPoint(e, t = Pe.LOCAL) {
    this.getScene().getRenderId() == 0 && this.computeWorldMatrix(!0);
    const i = this.getWorldMatrix();
    if (t == Pe.WORLD) {
      const s = C.Matrix[0];
      i.invertToRef(s), e = p.TransformCoordinates(e, s);
    }
    return this.setPivotMatrix(I.Translation(-e.x, -e.y, -e.z), !0);
  }
  /**
   * Returns a new Vector3 set with the mesh pivot point coordinates in the local space.
   * @returns the pivot point
   */
  getPivotPoint() {
    const e = p.Zero();
    return this.getPivotPointToRef(e), e;
  }
  /**
   * Sets the passed Vector3 "result" with the coordinates of the mesh pivot point in the local space.
   * @param result the vector3 to store the result
   * @returns this TransformNode.
   */
  getPivotPointToRef(e) {
    return e.x = -this._pivotMatrix.m[12], e.y = -this._pivotMatrix.m[13], e.z = -this._pivotMatrix.m[14], this;
  }
  /**
   * Returns a new Vector3 set with the mesh pivot point World coordinates.
   * @returns a new Vector3 set with the mesh pivot point World coordinates.
   */
  getAbsolutePivotPoint() {
    const e = p.Zero();
    return this.getAbsolutePivotPointToRef(e), e;
  }
  /**
   * Sets the Vector3 "result" coordinates with the mesh pivot point World coordinates.
   * @param result vector3 to store the result
   * @returns this TransformNode.
   */
  getAbsolutePivotPointToRef(e) {
    return this.getPivotPointToRef(e), p.TransformCoordinatesToRef(e, this.getWorldMatrix(), e), this;
  }
  /**
   * Flag the transform node as dirty (Forcing it to update everything)
   * @param property if set to "rotation" the objects rotationQuaternion will be set to null
   * @returns this  node
   */
  markAsDirty(e) {
    if (this._isDirty)
      return this;
    if (this._children)
      for (const t of this._children)
        t.markAsDirty(e);
    return super.markAsDirty(e);
  }
  /**
   * Defines the passed node as the parent of the current node.
   * The node will remain exactly where it is and its position / rotation will be updated accordingly.
   * Note that if the mesh has a pivot matrix / point defined it will be applied after the parent was updated.
   * In that case the node will not remain in the same space as it is, as the pivot will be applied.
   * To avoid this, you can set updatePivot to true and the pivot will be updated to identity
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/parent_pivot/parent
   * @param node the node ot set as the parent
   * @param preserveScalingSign if true, keep scaling sign of child. Otherwise, scaling sign might change.
   * @param updatePivot if true, update the pivot matrix to keep the node in the same space as before
   * @returns this TransformNode.
   */
  setParent(e, t = !1, i = !1) {
    if (!e && !this.parent)
      return this;
    const s = C.Quaternion[0], r = C.Vector3[0], n = C.Vector3[1], a = C.Matrix[1];
    I.IdentityToRef(a);
    const o = C.Matrix[0];
    this.computeWorldMatrix(!0);
    let l = this.rotationQuaternion;
    return l || (l = oe._TmpRotation, U.RotationYawPitchRollToRef(this._rotation.y, this._rotation.x, this._rotation.z, l)), I.ComposeToRef(this.scaling, l, this.position, o), this.parent && o.multiplyToRef(this.parent.computeWorldMatrix(!0), o), e && (e.computeWorldMatrix(!0).invertToRef(a), o.multiplyToRef(a, o)), o.decompose(n, s, r, t ? this : void 0), this.rotationQuaternion ? this.rotationQuaternion.copyFrom(s) : s.toEulerAnglesToRef(this.rotation), this.scaling.copyFrom(n), this.position.copyFrom(r), this.parent = e, i && this.setPivotMatrix(I.Identity()), this;
  }
  /**
   * True if the scaling property of this object is non uniform eg. (1,2,1)
   */
  get nonUniformScaling() {
    return this._nonUniformScaling;
  }
  /**
   * @internal
   */
  _updateNonUniformScalingState(e) {
    return this._nonUniformScaling === e ? !1 : (this._nonUniformScaling = e, !0);
  }
  /**
   * Attach the current TransformNode to another TransformNode associated with a bone
   * @param bone Bone affecting the TransformNode
   * @param affectedTransformNode TransformNode associated with the bone
   * @returns this object
   */
  attachToBone(e, t) {
    return this._currentParentWhenAttachingToBone = this.parent, this._transformToBoneReferal = t, this.parent = e, e.getSkeleton().prepare(), e.getFinalMatrix().determinant() < 0 && (this.scalingDeterminant *= -1), this;
  }
  /**
   * Detach the transform node if its associated with a bone
   * @param resetToPreviousParent Indicates if the parent that was in effect when attachToBone was called should be set back or if we should set parent to null instead (defaults to the latter)
   * @returns this object
   */
  detachFromBone(e = !1) {
    return this.parent ? (this.parent.getWorldMatrix().determinant() < 0 && (this.scalingDeterminant *= -1), this._transformToBoneReferal = null, e ? this.parent = this._currentParentWhenAttachingToBone : this.parent = null, this) : (e && (this.parent = this._currentParentWhenAttachingToBone), this);
  }
  /**
   * Rotates the mesh around the axis vector for the passed angle (amount) expressed in radians, in the given space.
   * space (default LOCAL) can be either Space.LOCAL, either Space.WORLD.
   * Note that the property `rotationQuaternion` is then automatically updated and the property `rotation` is set to (0,0,0) and no longer used.
   * The passed axis is also normalized.
   * @param axis the axis to rotate around
   * @param amount the amount to rotate in radians
   * @param space Space to rotate in (Default: local)
   * @returns the TransformNode.
   */
  rotate(e, t, i) {
    e.normalize(), this.rotationQuaternion || (this.rotationQuaternion = this.rotation.toQuaternion(), this.rotation.setAll(0));
    let s;
    if (!i || i === Pe.LOCAL)
      s = U.RotationAxisToRef(e, t, oe._RotationAxisCache), this.rotationQuaternion.multiplyToRef(s, this.rotationQuaternion);
    else {
      if (this.parent) {
        const r = C.Matrix[0];
        this.parent.getWorldMatrix().invertToRef(r), e = p.TransformNormal(e, r);
      }
      s = U.RotationAxisToRef(e, t, oe._RotationAxisCache), s.multiplyToRef(this.rotationQuaternion, this.rotationQuaternion);
    }
    return this;
  }
  /**
   * Rotates the mesh around the axis vector for the passed angle (amount) expressed in radians, in world space.
   * Note that the property `rotationQuaternion` is then automatically updated and the property `rotation` is set to (0,0,0) and no longer used.
   * The passed axis is also normalized. .
   * Method is based on http://www.euclideanspace.com/maths/geometry/affine/aroundPoint/index.htm
   * @param point the point to rotate around
   * @param axis the axis to rotate around
   * @param amount the amount to rotate in radians
   * @returns the TransformNode
   */
  rotateAround(e, t, i) {
    t.normalize(), this.rotationQuaternion || (this.rotationQuaternion = U.RotationYawPitchRoll(this.rotation.y, this.rotation.x, this.rotation.z), this.rotation.setAll(0));
    const s = C.Vector3[0], r = C.Vector3[1], n = C.Vector3[2], a = C.Quaternion[0], o = C.Matrix[0], l = C.Matrix[1], c = C.Matrix[2], u = C.Matrix[3];
    return e.subtractToRef(this.position, s), I.TranslationToRef(s.x, s.y, s.z, o), I.TranslationToRef(-s.x, -s.y, -s.z, l), I.RotationAxisToRef(t, i, c), l.multiplyToRef(c, u), u.multiplyToRef(o, u), u.decompose(r, a, n), this.position.addInPlace(n), a.multiplyToRef(this.rotationQuaternion, this.rotationQuaternion), this;
  }
  /**
   * Translates the mesh along the axis vector for the passed distance in the given space.
   * space (default LOCAL) can be either Space.LOCAL, either Space.WORLD.
   * @param axis the axis to translate in
   * @param distance the distance to translate
   * @param space Space to rotate in (Default: local)
   * @returns the TransformNode.
   */
  translate(e, t, i) {
    const s = e.scale(t);
    if (!i || i === Pe.LOCAL) {
      const r = this.getPositionExpressedInLocalSpace().add(s);
      this.setPositionWithLocalVector(r);
    } else
      this.setAbsolutePosition(this.getAbsolutePosition().add(s));
    return this;
  }
  /**
   * Adds a rotation step to the mesh current rotation.
   * x, y, z are Euler angles expressed in radians.
   * This methods updates the current mesh rotation, either mesh.rotation, either mesh.rotationQuaternion if it's set.
   * This means this rotation is made in the mesh local space only.
   * It's useful to set a custom rotation order different from the BJS standard one YXZ.
   * Example : this rotates the mesh first around its local X axis, then around its local Z axis, finally around its local Y axis.
   * ```javascript
   * mesh.addRotation(x1, 0, 0).addRotation(0, 0, z2).addRotation(0, 0, y3);
   * ```
   * Note that `addRotation()` accumulates the passed rotation values to the current ones and computes the .rotation or .rotationQuaternion updated values.
   * Under the hood, only quaternions are used. So it's a little faster is you use .rotationQuaternion because it doesn't need to translate them back to Euler angles.
   * @param x Rotation to add
   * @param y Rotation to add
   * @param z Rotation to add
   * @returns the TransformNode.
   */
  addRotation(e, t, i) {
    let s;
    this.rotationQuaternion ? s = this.rotationQuaternion : (s = C.Quaternion[1], U.RotationYawPitchRollToRef(this.rotation.y, this.rotation.x, this.rotation.z, s));
    const r = C.Quaternion[0];
    return U.RotationYawPitchRollToRef(t, e, i, r), s.multiplyInPlace(r), this.rotationQuaternion || s.toEulerAnglesToRef(this.rotation), this;
  }
  /**
   * @internal
   */
  _getEffectiveParent() {
    return this.parent;
  }
  /**
   * Returns whether the transform node world matrix computation needs the camera information to be computed.
   * This is the case when the node is a billboard or has an infinite distance for instance.
   * @returns true if the world matrix computation needs the camera information to be computed
   */
  isWorldMatrixCameraDependent() {
    return this._infiniteDistance && !this.parent || this._billboardMode !== oe.BILLBOARDMODE_NONE && !this.preserveParentRotationForBillboard;
  }
  /**
   * Computes the world matrix of the node
   * @param force defines if the cache version should be invalidated forcing the world matrix to be created from scratch
   * @param camera defines the camera used if different from the scene active camera (This is used with modes like Billboard or infinite distance)
   * @returns the world matrix
   */
  computeWorldMatrix(e = !1, t = null) {
    if (this._isWorldMatrixFrozen && !this._isDirty)
      return this._worldMatrix;
    const i = this.getScene().getRenderId();
    if (!this._isDirty && !e && (this._currentRenderId === i || this.isSynchronized()))
      return this._currentRenderId = i, this._worldMatrix;
    t = t || this.getScene().activeCamera, this._updateCache();
    const s = this._cache;
    s.pivotMatrixUpdated = !1, s.billboardMode = this.billboardMode, s.infiniteDistance = this.infiniteDistance, s.parent = this._parentNode, this._currentRenderId = i, this._childUpdateId += 1, this._isDirty = !1, this._position._isDirty = !1, this._rotation._isDirty = !1, this._scaling._isDirty = !1;
    const r = this._getEffectiveParent(), n = oe._TmpScaling;
    let a = this._position;
    if (this._infiniteDistance && !this.parent && t) {
      const l = t.getWorldMatrix(), c = new p(l.m[12], l.m[13], l.m[14]);
      a = oe._TmpTranslation, a.copyFromFloats(this._position.x + c.x, this._position.y + c.y, this._position.z + c.z);
    }
    n.copyFromFloats(this._scaling.x * this.scalingDeterminant, this._scaling.y * this.scalingDeterminant, this._scaling.z * this.scalingDeterminant);
    let o;
    if (this._rotationQuaternion ? (this._rotationQuaternion._isDirty = !1, o = this._rotationQuaternion, this.reIntegrateRotationIntoRotationQuaternion && this.rotation.lengthSquared() && (this._rotationQuaternion.multiplyInPlace(U.RotationYawPitchRoll(this._rotation.y, this._rotation.x, this._rotation.z)), this._rotation.copyFromFloats(0, 0, 0))) : (o = oe._TmpRotation, U.RotationYawPitchRollToRef(this._rotation.y, this._rotation.x, this._rotation.z, o)), this._usePivotMatrix) {
      const l = C.Matrix[1];
      I.ScalingToRef(n.x, n.y, n.z, l);
      const c = C.Matrix[0];
      o.toRotationMatrix(c), this._pivotMatrix.multiplyToRef(l, C.Matrix[4]), C.Matrix[4].multiplyToRef(c, this._localMatrix), this._postMultiplyPivotMatrix && this._localMatrix.multiplyToRef(this._pivotMatrixInverse, this._localMatrix), this._localMatrix.addTranslationFromFloats(a.x, a.y, a.z);
    } else
      I.ComposeToRef(n, o, a, this._localMatrix);
    if (r && r.getWorldMatrix) {
      if (e && r.computeWorldMatrix(e), s.useBillboardPath) {
        this._transformToBoneReferal ? r.getWorldMatrix().multiplyToRef(this._transformToBoneReferal.getWorldMatrix(), C.Matrix[7]) : C.Matrix[7].copyFrom(r.getWorldMatrix());
        const l = C.Vector3[5], c = C.Vector3[6], u = C.Quaternion[0];
        C.Matrix[7].decompose(c, u, l), I.ScalingToRef(c.x, c.y, c.z, C.Matrix[7]), C.Matrix[7].setTranslation(l), oe.BillboardUseParentOrientation && (this._position.applyRotationQuaternionToRef(u, l), this._localMatrix.setTranslation(l)), this._localMatrix.multiplyToRef(C.Matrix[7], this._worldMatrix);
      } else
        this._transformToBoneReferal ? (this._localMatrix.multiplyToRef(r.getWorldMatrix(), C.Matrix[6]), C.Matrix[6].multiplyToRef(this._transformToBoneReferal.getWorldMatrix(), this._worldMatrix)) : this._localMatrix.multiplyToRef(r.getWorldMatrix(), this._worldMatrix);
      this._markSyncedWithParent();
    } else
      this._worldMatrix.copyFrom(this._localMatrix);
    if (s.useBillboardPath && t && this.billboardMode && !s.useBillboardPosition) {
      const l = C.Vector3[0];
      if (this._worldMatrix.getTranslationToRef(l), C.Matrix[1].copyFrom(t.getViewMatrix()), this._scene.useRightHandedSystem && C.Matrix[1].multiplyToRef(Ll, C.Matrix[1]), C.Matrix[1].setTranslationFromFloats(0, 0, 0), C.Matrix[1].invertToRef(C.Matrix[0]), (this.billboardMode & oe.BILLBOARDMODE_ALL) !== oe.BILLBOARDMODE_ALL) {
        C.Matrix[0].decompose(void 0, C.Quaternion[0], void 0);
        const c = C.Vector3[1];
        C.Quaternion[0].toEulerAnglesToRef(c), (this.billboardMode & oe.BILLBOARDMODE_X) !== oe.BILLBOARDMODE_X && (c.x = 0), (this.billboardMode & oe.BILLBOARDMODE_Y) !== oe.BILLBOARDMODE_Y && (c.y = 0), (this.billboardMode & oe.BILLBOARDMODE_Z) !== oe.BILLBOARDMODE_Z && (c.z = 0), I.RotationYawPitchRollToRef(c.y, c.x, c.z, C.Matrix[0]);
      }
      this._worldMatrix.setTranslationFromFloats(0, 0, 0), this._worldMatrix.multiplyToRef(C.Matrix[0], this._worldMatrix), this._worldMatrix.setTranslation(C.Vector3[0]);
    } else if (s.useBillboardPath && t && s.useBillboardPosition) {
      const l = C.Vector3[0];
      this._worldMatrix.getTranslationToRef(l);
      const c = t.globalPosition;
      this._worldMatrix.invertToRef(C.Matrix[1]);
      const u = C.Vector3[1];
      p.TransformCoordinatesToRef(c, C.Matrix[1], u), u.normalize();
      const d = -Math.atan2(u.z, u.x) + Math.PI / 2, f = Math.sqrt(u.x * u.x + u.z * u.z), _ = -Math.atan2(u.y, f);
      if (U.RotationYawPitchRollToRef(d, _, 0, C.Quaternion[0]), (this.billboardMode & oe.BILLBOARDMODE_ALL) !== oe.BILLBOARDMODE_ALL) {
        const g = C.Vector3[1];
        C.Quaternion[0].toEulerAnglesToRef(g), (this.billboardMode & oe.BILLBOARDMODE_X) !== oe.BILLBOARDMODE_X && (g.x = 0), (this.billboardMode & oe.BILLBOARDMODE_Y) !== oe.BILLBOARDMODE_Y && (g.y = 0), (this.billboardMode & oe.BILLBOARDMODE_Z) !== oe.BILLBOARDMODE_Z && (g.z = 0), I.RotationYawPitchRollToRef(g.y, g.x, g.z, C.Matrix[0]);
      } else
        I.FromQuaternionToRef(C.Quaternion[0], C.Matrix[0]);
      this._worldMatrix.setTranslationFromFloats(0, 0, 0), this._worldMatrix.multiplyToRef(C.Matrix[0], this._worldMatrix), this._worldMatrix.setTranslation(C.Vector3[0]);
    }
    return this.ignoreNonUniformScaling ? this._updateNonUniformScalingState(!1) : this._scaling.isNonUniformWithinEpsilon(1e-6) ? this._updateNonUniformScalingState(!0) : r && r._nonUniformScaling ? this._updateNonUniformScalingState(r._nonUniformScaling) : this._updateNonUniformScalingState(!1), this._afterComputeWorldMatrix(), this._absolutePosition.copyFromFloats(this._worldMatrix.m[12], this._worldMatrix.m[13], this._worldMatrix.m[14]), this._isAbsoluteSynced = !1, this.onAfterWorldMatrixUpdateObservable.notifyObservers(this), this._poseMatrix || (this._poseMatrix = I.Invert(this._worldMatrix)), this._worldMatrixDeterminantIsDirty = !0, this._worldMatrix;
  }
  /**
   * Resets this nodeTransform's local matrix to Matrix.Identity().
   * @param independentOfChildren indicates if all child nodeTransform's world-space transform should be preserved.
   */
  resetLocalMatrix(e = !0) {
    if (this.computeWorldMatrix(), e) {
      const t = this.getChildren();
      for (let i = 0; i < t.length; ++i) {
        const s = t[i];
        if (s) {
          s.computeWorldMatrix();
          const r = C.Matrix[0];
          s._localMatrix.multiplyToRef(this._localMatrix, r);
          const n = C.Quaternion[0];
          r.decompose(s.scaling, n, s.position), s.rotationQuaternion ? s.rotationQuaternion.copyFrom(n) : n.toEulerAnglesToRef(s.rotation);
        }
      }
    }
    this.scaling.copyFromFloats(1, 1, 1), this.position.copyFromFloats(0, 0, 0), this.rotation.copyFromFloats(0, 0, 0), this.rotationQuaternion && (this.rotationQuaternion = U.Identity()), this._worldMatrix = I.Identity();
  }
  _afterComputeWorldMatrix() {
  }
  /**
   * If you'd like to be called back after the mesh position, rotation or scaling has been updated.
   * @param func callback function to add
   *
   * @returns the TransformNode.
   */
  registerAfterWorldMatrixUpdate(e) {
    return this.onAfterWorldMatrixUpdateObservable.add(e), this;
  }
  /**
   * Removes a registered callback function.
   * @param func callback function to remove
   * @returns the TransformNode.
   */
  unregisterAfterWorldMatrixUpdate(e) {
    return this.onAfterWorldMatrixUpdateObservable.removeCallback(e), this;
  }
  /**
   * Gets the position of the current mesh in camera space
   * @param camera defines the camera to use
   * @returns a position
   */
  getPositionInCameraSpace(e = null) {
    return e || (e = this.getScene().activeCamera), p.TransformCoordinates(this.getAbsolutePosition(), e.getViewMatrix());
  }
  /**
   * Returns the distance from the mesh to the active camera
   * @param camera defines the camera to use
   * @returns the distance
   */
  getDistanceToCamera(e = null) {
    return e || (e = this.getScene().activeCamera), this.getAbsolutePosition().subtract(e.globalPosition).length();
  }
  /**
   * Clone the current transform node
   * @param name Name of the new clone
   * @param newParent New parent for the clone
   * @param doNotCloneChildren Do not clone children hierarchy
   * @returns the new transform node
   */
  clone(e, t, i) {
    const s = le.Clone(() => new oe(e, this.getScene()), this);
    if (s.name = e, s.id = e, t && (s.parent = t), !i) {
      const r = this.getDescendants(!0);
      for (let n = 0; n < r.length; n++) {
        const a = r[n];
        a.clone && a.clone(e + "." + a.name, s);
      }
    }
    return s;
  }
  /**
   * Serializes the objects information.
   * @param currentSerializationObject defines the object to serialize in
   * @returns the serialized object
   */
  serialize(e) {
    const t = le.Serialize(this, e);
    return t.type = this.getClassName(), t.uniqueId = this.uniqueId, this.parent && this.parent._serializeAsParent(t), t.localMatrix = this.getPivotMatrix().asArray(), t.isEnabled = this.isEnabled(), t;
  }
  // Statics
  /**
   * Returns a new TransformNode object parsed from the source provided.
   * @param parsedTransformNode is the source.
   * @param scene the scene the object belongs to
   * @param rootUrl is a string, it's the root URL to prefix the `delayLoadingFile` property with
   * @returns a new TransformNode object parsed from the source provided.
   */
  static Parse(e, t, i) {
    const s = le.Parse(() => new oe(e.name, t), e, t, i);
    return e.localMatrix ? s.setPreTransformMatrix(I.FromArray(e.localMatrix)) : e.pivotMatrix && s.setPivotMatrix(I.FromArray(e.pivotMatrix)), s.setEnabled(e.isEnabled), s._waitingParsedUniqueId = e.uniqueId, e.parentId !== void 0 && (s._waitingParentId = e.parentId), e.parentInstanceIndex !== void 0 && (s._waitingParentInstanceIndex = e.parentInstanceIndex), s;
  }
  /**
   * Get all child-transformNodes of this node
   * @param directDescendantsOnly defines if true only direct descendants of 'this' will be considered, if false direct and also indirect (children of children, an so on in a recursive manner) descendants of 'this' will be considered
   * @param predicate defines an optional predicate that will be called on every evaluated child, the predicate must return true for a given child to be part of the result, otherwise it will be ignored
   * @returns an array of TransformNode
   */
  getChildTransformNodes(e, t) {
    const i = [];
    return this._getDescendants(i, e, (s) => (!t || t(s)) && s instanceof oe), i;
  }
  /**
   * Releases resources associated with this transform node.
   * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
   * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
   */
  dispose(e, t = !1) {
    if (this.getScene().stopAnimation(this), this.getScene().removeTransformNode(this), this._parentContainer) {
      const i = this._parentContainer.transformNodes.indexOf(this);
      i > -1 && this._parentContainer.transformNodes.splice(i, 1), this._parentContainer = null;
    }
    if (this.onAfterWorldMatrixUpdateObservable.clear(), e) {
      const i = this.getChildTransformNodes(!0);
      for (const s of i)
        s.parent = null, s.computeWorldMatrix(!0);
    }
    super.dispose(e, t);
  }
  /**
   * Uniformly scales the mesh to fit inside of a unit cube (1 X 1 X 1 units)
   * @param includeDescendants Use the hierarchy's bounding box instead of the mesh's bounding box. Default is false
   * @param ignoreRotation ignore rotation when computing the scale (ie. object will be axis aligned). Default is false
   * @param predicate predicate that is passed in to getHierarchyBoundingVectors when selecting which object should be included when scaling
   * @returns the current mesh
   */
  normalizeToUnitCube(e = !0, t = !1, i) {
    let s = null, r = null;
    t && (this.rotationQuaternion ? (r = this.rotationQuaternion.clone(), this.rotationQuaternion.copyFromFloats(0, 0, 0, 1)) : this.rotation && (s = this.rotation.clone(), this.rotation.copyFromFloats(0, 0, 0)));
    const n = this.getHierarchyBoundingVectors(e, i), a = n.max.subtract(n.min), o = Math.max(a.x, a.y, a.z);
    if (o === 0)
      return this;
    const l = 1 / o;
    return this.scaling.scaleInPlace(l), t && (this.rotationQuaternion && r ? this.rotationQuaternion.copyFrom(r) : this.rotation && s && this.rotation.copyFrom(s)), this;
  }
  _syncAbsoluteScalingAndRotation() {
    this._isAbsoluteSynced || (this._worldMatrix.decompose(this._absoluteScaling, this._absoluteRotationQuaternion), this._isAbsoluteSynced = !0);
  }
}
oe.BILLBOARDMODE_NONE = 0;
oe.BILLBOARDMODE_X = 1;
oe.BILLBOARDMODE_Y = 2;
oe.BILLBOARDMODE_Z = 4;
oe.BILLBOARDMODE_ALL = 7;
oe.BILLBOARDMODE_USE_POSITION = 128;
oe.BillboardUseParentOrientation = !1;
oe._TmpRotation = U.Zero();
oe._TmpScaling = p.Zero();
oe._TmpTranslation = p.Zero();
oe._LookAtVectorCache = new p(0, 0, 0);
oe._RotationAxisCache = new U();
E([
  wt("position")
], oe.prototype, "_position", void 0);
E([
  wt("rotation")
], oe.prototype, "_rotation", void 0);
E([
  Yo("rotationQuaternion")
], oe.prototype, "_rotationQuaternion", void 0);
E([
  wt("scaling")
], oe.prototype, "_scaling", void 0);
E([
  R("billboardMode")
], oe.prototype, "_billboardMode", void 0);
E([
  R()
], oe.prototype, "scalingDeterminant", void 0);
E([
  R("infiniteDistance")
], oe.prototype, "_infiniteDistance", void 0);
E([
  R()
], oe.prototype, "ignoreNonUniformScaling", void 0);
E([
  R()
], oe.prototype, "reIntegrateRotationIntoRotationQuaternion", void 0);
class Nl {
  constructor() {
    this._checkCollisions = !1, this._collisionMask = -1, this._collisionGroup = -1, this._surroundingMeshes = null, this._collider = null, this._oldPositionForCollisions = new p(0, 0, 0), this._diffPositionForCollisions = new p(0, 0, 0), this._collisionResponse = !0;
  }
}
class Bl {
  constructor() {
    this.facetNb = 0, this.partitioningSubdivisions = 10, this.partitioningBBoxRatio = 1.01, this.facetDataEnabled = !1, this.facetParameters = {}, this.bbSize = p.Zero(), this.subDiv = {
      // actual number of subdivisions per axis for ComputeNormals()
      max: 1,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      X: 1,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      Y: 1,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      Z: 1
    }, this.facetDepthSort = !1, this.facetDepthSortEnabled = !1;
  }
}
class Ul {
  constructor() {
    this._hasVertexAlpha = !1, this._useVertexColors = !0, this._numBoneInfluencers = 4, this._applyFog = !0, this._receiveShadows = !1, this._facetData = new Bl(), this._visibility = 1, this._skeleton = null, this._layerMask = 268435455, this._computeBonesUsingShaders = !0, this._isActive = !1, this._onlyForInstances = !1, this._isActiveIntermediate = !1, this._onlyForInstancesIntermediate = !1, this._actAsRegularMesh = !1, this._currentLOD = null, this._currentLODIsUpToDate = !1, this._collisionRetryCount = 3, this._morphTargetManager = null, this._renderingGroupId = 0, this._bakedVertexAnimationManager = null, this._material = null, this._positions = null, this._pointerOverDisableMeshTesting = !1, this._meshCollisionData = new Nl(), this._enableDistantPicking = !1, this._rawBoundingInfo = null;
  }
}
class Ut extends oe {
  /**
   * No billboard
   */
  static get BILLBOARDMODE_NONE() {
    return oe.BILLBOARDMODE_NONE;
  }
  /** Billboard on X axis */
  static get BILLBOARDMODE_X() {
    return oe.BILLBOARDMODE_X;
  }
  /** Billboard on Y axis */
  static get BILLBOARDMODE_Y() {
    return oe.BILLBOARDMODE_Y;
  }
  /** Billboard on Z axis */
  static get BILLBOARDMODE_Z() {
    return oe.BILLBOARDMODE_Z;
  }
  /** Billboard on all axes */
  static get BILLBOARDMODE_ALL() {
    return oe.BILLBOARDMODE_ALL;
  }
  /** Billboard on using position instead of orientation */
  static get BILLBOARDMODE_USE_POSITION() {
    return oe.BILLBOARDMODE_USE_POSITION;
  }
  /**
   * Gets the number of facets in the mesh
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData#what-is-a-mesh-facet
   */
  get facetNb() {
    return this._internalAbstractMeshDataInfo._facetData.facetNb;
  }
  /**
   * Gets or set the number (integer) of subdivisions per axis in the partitioning space
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData#tweaking-the-partitioning
   */
  get partitioningSubdivisions() {
    return this._internalAbstractMeshDataInfo._facetData.partitioningSubdivisions;
  }
  set partitioningSubdivisions(e) {
    this._internalAbstractMeshDataInfo._facetData.partitioningSubdivisions = e;
  }
  /**
   * The ratio (float) to apply to the bounding box size to set to the partitioning space.
   * Ex : 1.01 (default) the partitioning space is 1% bigger than the bounding box
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData#tweaking-the-partitioning
   */
  get partitioningBBoxRatio() {
    return this._internalAbstractMeshDataInfo._facetData.partitioningBBoxRatio;
  }
  set partitioningBBoxRatio(e) {
    this._internalAbstractMeshDataInfo._facetData.partitioningBBoxRatio = e;
  }
  /**
   * Gets or sets a boolean indicating that the facets must be depth sorted on next call to `updateFacetData()`.
   * Works only for updatable meshes.
   * Doesn't work with multi-materials
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData#facet-depth-sort
   */
  get mustDepthSortFacets() {
    return this._internalAbstractMeshDataInfo._facetData.facetDepthSort;
  }
  set mustDepthSortFacets(e) {
    this._internalAbstractMeshDataInfo._facetData.facetDepthSort = e;
  }
  /**
   * The location (Vector3) where the facet depth sort must be computed from.
   * By default, the active camera position.
   * Used only when facet depth sort is enabled
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData#facet-depth-sort
   */
  get facetDepthSortFrom() {
    return this._internalAbstractMeshDataInfo._facetData.facetDepthSortFrom;
  }
  set facetDepthSortFrom(e) {
    this._internalAbstractMeshDataInfo._facetData.facetDepthSortFrom = e;
  }
  /** number of collision detection tries. Change this value if not all collisions are detected and handled properly */
  get collisionRetryCount() {
    return this._internalAbstractMeshDataInfo._collisionRetryCount;
  }
  set collisionRetryCount(e) {
    this._internalAbstractMeshDataInfo._collisionRetryCount = e;
  }
  /**
   * gets a boolean indicating if facetData is enabled
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData#what-is-a-mesh-facet
   */
  get isFacetDataEnabled() {
    return this._internalAbstractMeshDataInfo._facetData.facetDataEnabled;
  }
  /**
   * Gets or sets the morph target manager
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/morphTargets
   */
  get morphTargetManager() {
    return this._internalAbstractMeshDataInfo._morphTargetManager;
  }
  set morphTargetManager(e) {
    this._internalAbstractMeshDataInfo._morphTargetManager !== e && (this._internalAbstractMeshDataInfo._morphTargetManager = e, this._syncGeometryWithMorphTargetManager());
  }
  /**
   * Gets or sets the baked vertex animation manager
   * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/baked_texture_animations
   */
  get bakedVertexAnimationManager() {
    return this._internalAbstractMeshDataInfo._bakedVertexAnimationManager;
  }
  set bakedVertexAnimationManager(e) {
    this._internalAbstractMeshDataInfo._bakedVertexAnimationManager !== e && (this._internalAbstractMeshDataInfo._bakedVertexAnimationManager = e, this._markSubMeshesAsAttributesDirty());
  }
  /** @internal */
  _syncGeometryWithMorphTargetManager() {
  }
  /**
   * @internal
   */
  _updateNonUniformScalingState(e) {
    return super._updateNonUniformScalingState(e) ? (this._markSubMeshesAsMiscDirty(), !0) : !1;
  }
  /** @internal */
  get rawBoundingInfo() {
    return this._internalAbstractMeshDataInfo._rawBoundingInfo;
  }
  set rawBoundingInfo(e) {
    this._internalAbstractMeshDataInfo._rawBoundingInfo = e;
  }
  /** Set a function to call when this mesh collides with another one */
  set onCollide(e) {
    this._internalAbstractMeshDataInfo._meshCollisionData._onCollideObserver && this.onCollideObservable.remove(this._internalAbstractMeshDataInfo._meshCollisionData._onCollideObserver), this._internalAbstractMeshDataInfo._meshCollisionData._onCollideObserver = this.onCollideObservable.add(e);
  }
  /** Set a function to call when the collision's position changes */
  set onCollisionPositionChange(e) {
    this._internalAbstractMeshDataInfo._meshCollisionData._onCollisionPositionChangeObserver && this.onCollisionPositionChangeObservable.remove(this._internalAbstractMeshDataInfo._meshCollisionData._onCollisionPositionChangeObserver), this._internalAbstractMeshDataInfo._meshCollisionData._onCollisionPositionChangeObserver = this.onCollisionPositionChangeObservable.add(e);
  }
  /**
   * Gets or sets mesh visibility between 0 and 1 (default is 1)
   */
  get visibility() {
    return this._internalAbstractMeshDataInfo._visibility;
  }
  /**
   * Gets or sets mesh visibility between 0 and 1 (default is 1)
   */
  set visibility(e) {
    if (this._internalAbstractMeshDataInfo._visibility === e)
      return;
    const t = this._internalAbstractMeshDataInfo._visibility;
    this._internalAbstractMeshDataInfo._visibility = e, (t === 1 && e !== 1 || t !== 1 && e === 1) && this._markSubMeshesAsDirty((i) => {
      i.markAsMiscDirty(), i.markAsPrePassDirty();
    });
  }
  /**
   * Gets or sets the property which disables the test that is checking that the mesh under the pointer is the same than the previous time we tested for it (default: false).
   * Set this property to true if you want thin instances picking to be reported accurately when moving over the mesh.
   * Note that setting this property to true will incur some performance penalties when dealing with pointer events for this mesh so use it sparingly.
   */
  get pointerOverDisableMeshTesting() {
    return this._internalAbstractMeshDataInfo._pointerOverDisableMeshTesting;
  }
  set pointerOverDisableMeshTesting(e) {
    this._internalAbstractMeshDataInfo._pointerOverDisableMeshTesting = e;
  }
  /**
   * Specifies the rendering group id for this mesh (0 by default)
   * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/advanced/transparent_rendering#rendering-groups
   */
  get renderingGroupId() {
    return this._internalAbstractMeshDataInfo._renderingGroupId;
  }
  set renderingGroupId(e) {
    this._internalAbstractMeshDataInfo._renderingGroupId = e;
  }
  /** Gets or sets current material */
  get material() {
    return this._internalAbstractMeshDataInfo._material;
  }
  set material(e) {
    this._internalAbstractMeshDataInfo._material !== e && (this._internalAbstractMeshDataInfo._material && this._internalAbstractMeshDataInfo._material.meshMap && (this._internalAbstractMeshDataInfo._material.meshMap[this.uniqueId] = void 0), this._internalAbstractMeshDataInfo._material = e, e && e.meshMap && (e.meshMap[this.uniqueId] = this), this.onMaterialChangedObservable.hasObservers() && this.onMaterialChangedObservable.notifyObservers(this), this.subMeshes && (this.resetDrawCache(), this._unBindEffect()));
  }
  /**
   * Gets the material used to render the mesh in a specific render pass
   * @param renderPassId render pass id
   * @returns material used for the render pass. If no specific material is used for this render pass, undefined is returned (meaning mesh.material is used for this pass)
   */
  getMaterialForRenderPass(e) {
    var t;
    return (t = this._internalAbstractMeshDataInfo._materialForRenderPass) === null || t === void 0 ? void 0 : t[e];
  }
  /**
   * Sets the material to be used to render the mesh in a specific render pass
   * @param renderPassId render pass id
   * @param material material to use for this render pass. If undefined is passed, no specific material will be used for this render pass but the regular material will be used instead (mesh.material)
   */
  setMaterialForRenderPass(e, t) {
    this.resetDrawCache(e), this._internalAbstractMeshDataInfo._materialForRenderPass || (this._internalAbstractMeshDataInfo._materialForRenderPass = []), this._internalAbstractMeshDataInfo._materialForRenderPass[e] = t;
  }
  /**
   * Gets or sets a boolean indicating that this mesh can receive realtime shadows
   * @see https://doc.babylonjs.com/features/featuresDeepDive/lights/shadows
   */
  get receiveShadows() {
    return this._internalAbstractMeshDataInfo._receiveShadows;
  }
  set receiveShadows(e) {
    this._internalAbstractMeshDataInfo._receiveShadows !== e && (this._internalAbstractMeshDataInfo._receiveShadows = e, this._markSubMeshesAsLightDirty());
  }
  /** Gets or sets a boolean indicating that this mesh contains vertex color data with alpha values */
  get hasVertexAlpha() {
    return this._internalAbstractMeshDataInfo._hasVertexAlpha;
  }
  set hasVertexAlpha(e) {
    this._internalAbstractMeshDataInfo._hasVertexAlpha !== e && (this._internalAbstractMeshDataInfo._hasVertexAlpha = e, this._markSubMeshesAsAttributesDirty(), this._markSubMeshesAsMiscDirty());
  }
  /** Gets or sets a boolean indicating that this mesh needs to use vertex color data to render (if this kind of vertex data is available in the geometry) */
  get useVertexColors() {
    return this._internalAbstractMeshDataInfo._useVertexColors;
  }
  set useVertexColors(e) {
    this._internalAbstractMeshDataInfo._useVertexColors !== e && (this._internalAbstractMeshDataInfo._useVertexColors = e, this._markSubMeshesAsAttributesDirty());
  }
  /**
   * Gets or sets a boolean indicating that bone animations must be computed by the GPU (true by default)
   */
  get computeBonesUsingShaders() {
    return this._internalAbstractMeshDataInfo._computeBonesUsingShaders;
  }
  set computeBonesUsingShaders(e) {
    this._internalAbstractMeshDataInfo._computeBonesUsingShaders !== e && (this._internalAbstractMeshDataInfo._computeBonesUsingShaders = e, this._markSubMeshesAsAttributesDirty());
  }
  /** Gets or sets the number of allowed bone influences per vertex (4 by default) */
  get numBoneInfluencers() {
    return this._internalAbstractMeshDataInfo._numBoneInfluencers;
  }
  set numBoneInfluencers(e) {
    this._internalAbstractMeshDataInfo._numBoneInfluencers !== e && (this._internalAbstractMeshDataInfo._numBoneInfluencers = e, this._markSubMeshesAsAttributesDirty());
  }
  /** Gets or sets a boolean indicating that this mesh will allow fog to be rendered on it (true by default) */
  get applyFog() {
    return this._internalAbstractMeshDataInfo._applyFog;
  }
  set applyFog(e) {
    this._internalAbstractMeshDataInfo._applyFog !== e && (this._internalAbstractMeshDataInfo._applyFog = e, this._markSubMeshesAsMiscDirty());
  }
  /** When enabled, decompose picking matrices for better precision with large values for mesh position and scling */
  get enableDistantPicking() {
    return this._internalAbstractMeshDataInfo._enableDistantPicking;
  }
  set enableDistantPicking(e) {
    this._internalAbstractMeshDataInfo._enableDistantPicking = e;
  }
  /**
   * Gets or sets the current layer mask (default is 0x0FFFFFFF)
   * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/layerMasksAndMultiCam
   */
  get layerMask() {
    return this._internalAbstractMeshDataInfo._layerMask;
  }
  set layerMask(e) {
    e !== this._internalAbstractMeshDataInfo._layerMask && (this._internalAbstractMeshDataInfo._layerMask = e, this._resyncLightSources());
  }
  /**
   * Gets or sets a collision mask used to mask collisions (default is -1).
   * A collision between A and B will happen if A.collisionGroup & b.collisionMask !== 0
   */
  get collisionMask() {
    return this._internalAbstractMeshDataInfo._meshCollisionData._collisionMask;
  }
  set collisionMask(e) {
    this._internalAbstractMeshDataInfo._meshCollisionData._collisionMask = isNaN(e) ? -1 : e;
  }
  /**
   * Gets or sets a collision response flag (default is true).
   * when collisionResponse is false, events are still triggered but colliding entity has no response
   * This helps creating trigger volume when user wants collision feedback events but not position/velocity
   * to respond to the collision.
   */
  get collisionResponse() {
    return this._internalAbstractMeshDataInfo._meshCollisionData._collisionResponse;
  }
  set collisionResponse(e) {
    this._internalAbstractMeshDataInfo._meshCollisionData._collisionResponse = e;
  }
  /**
   * Gets or sets the current collision group mask (-1 by default).
   * A collision between A and B will happen if A.collisionGroup & b.collisionMask !== 0
   */
  get collisionGroup() {
    return this._internalAbstractMeshDataInfo._meshCollisionData._collisionGroup;
  }
  set collisionGroup(e) {
    this._internalAbstractMeshDataInfo._meshCollisionData._collisionGroup = isNaN(e) ? -1 : e;
  }
  /**
   * Gets or sets current surrounding meshes (null by default).
   *
   * By default collision detection is tested against every mesh in the scene.
   * It is possible to set surroundingMeshes to a defined list of meshes and then only these specified
   * meshes will be tested for the collision.
   *
   * Note: if set to an empty array no collision will happen when this mesh is moved.
   */
  get surroundingMeshes() {
    return this._internalAbstractMeshDataInfo._meshCollisionData._surroundingMeshes;
  }
  set surroundingMeshes(e) {
    this._internalAbstractMeshDataInfo._meshCollisionData._surroundingMeshes = e;
  }
  /** Gets the list of lights affecting that mesh */
  get lightSources() {
    return this._lightSources;
  }
  /** @internal */
  get _positions() {
    return null;
  }
  /**
   * Gets or sets a skeleton to apply skinning transformations
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/bonesSkeletons
   */
  set skeleton(e) {
    const t = this._internalAbstractMeshDataInfo._skeleton;
    t && t.needInitialSkinMatrix && t._unregisterMeshWithPoseMatrix(this), e && e.needInitialSkinMatrix && e._registerMeshWithPoseMatrix(this), this._internalAbstractMeshDataInfo._skeleton = e, this._internalAbstractMeshDataInfo._skeleton || (this._bonesTransformMatrices = null), this._markSubMeshesAsAttributesDirty();
  }
  get skeleton() {
    return this._internalAbstractMeshDataInfo._skeleton;
  }
  // Constructor
  /**
   * Creates a new AbstractMesh
   * @param name defines the name of the mesh
   * @param scene defines the hosting scene
   */
  constructor(e, t = null) {
    switch (super(e, t, !1), this._internalAbstractMeshDataInfo = new Ul(), this._waitingMaterialId = null, this.cullingStrategy = Ut.CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY, this.onCollideObservable = new N(), this.onCollisionPositionChangeObservable = new N(), this.onMaterialChangedObservable = new N(), this.definedFacingForward = !0, this._occlusionQuery = null, this._renderingGroup = null, this.alphaIndex = Number.MAX_VALUE, this.isVisible = !0, this.isPickable = !0, this.isNearPickable = !1, this.isNearGrabbable = !1, this.showSubMeshesBoundingBox = !1, this.isBlocker = !1, this.enablePointerMoveEvents = !1, this.outlineColor = ie.Red(), this.outlineWidth = 0.02, this.overlayColor = ie.Red(), this.overlayAlpha = 0.5, this.useOctreeForRenderingSelection = !0, this.useOctreeForPicking = !0, this.useOctreeForCollisions = !0, this.alwaysSelectAsActiveMesh = !1, this.doNotSyncBoundingInfo = !1, this.actionManager = null, this.ellipsoid = new p(0.5, 1, 0.5), this.ellipsoidOffset = new p(0, 0, 0), this.edgesWidth = 1, this.edgesColor = new ye(1, 0, 0, 1), this._edgesRenderer = null, this._masterMesh = null, this._boundingInfo = null, this._boundingInfoIsDirty = !0, this._renderId = 0, this._intersectionsInProgress = new Array(), this._unIndexed = !1, this._lightSources = new Array(), this._waitingData = {
      lods: null,
      actions: null,
      freezeWorldMatrix: null
    }, this._bonesTransformMatrices = null, this._transformMatrixTexture = null, this.onRebuildObservable = new N(), this._onCollisionPositionChange = (i, s, r = null) => {
      s.subtractToRef(this._internalAbstractMeshDataInfo._meshCollisionData._oldPositionForCollisions, this._internalAbstractMeshDataInfo._meshCollisionData._diffPositionForCollisions), this._internalAbstractMeshDataInfo._meshCollisionData._diffPositionForCollisions.length() > L.CollisionsEpsilon && this.position.addInPlace(this._internalAbstractMeshDataInfo._meshCollisionData._diffPositionForCollisions), r && this.onCollideObservable.notifyObservers(r), this.onCollisionPositionChangeObservable.notifyObservers(this.position);
    }, t = this.getScene(), t.addMesh(this), this._resyncLightSources(), this._uniformBuffer = new H(this.getScene().getEngine(), void 0, void 0, e, !this.getScene().getEngine().isWebGPU), this._buildUniformLayout(), t.performancePriority) {
      case ui.Aggressive:
        this.doNotSyncBoundingInfo = !0;
      case ui.Intermediate:
        this.alwaysSelectAsActiveMesh = !0, this.isPickable = !1;
        break;
    }
  }
  _buildUniformLayout() {
    this._uniformBuffer.addUniform("world", 16), this._uniformBuffer.addUniform("visibility", 1), this._uniformBuffer.create();
  }
  /**
   * Transfer the mesh values to its UBO.
   * @param world The world matrix associated with the mesh
   */
  transferToEffect(e) {
    const t = this._uniformBuffer;
    t.updateMatrix("world", e), t.updateFloat("visibility", this._internalAbstractMeshDataInfo._visibility), t.update();
  }
  /**
   * Gets the mesh uniform buffer.
   * @returns the uniform buffer of the mesh.
   */
  getMeshUniformBuffer() {
    return this._uniformBuffer;
  }
  /**
   * Returns the string "AbstractMesh"
   * @returns "AbstractMesh"
   */
  getClassName() {
    return "AbstractMesh";
  }
  /**
   * Gets a string representation of the current mesh
   * @param fullDetails defines a boolean indicating if full details must be included
   * @returns a string representation of the current mesh
   */
  toString(e) {
    let t = "Name: " + this.name + ", isInstance: " + (this.getClassName() !== "InstancedMesh" ? "YES" : "NO");
    t += ", # of submeshes: " + (this.subMeshes ? this.subMeshes.length : 0);
    const i = this._internalAbstractMeshDataInfo._skeleton;
    return i && (t += ", skeleton: " + i.name), e && (t += ", billboard mode: " + ["NONE", "X", "Y", null, "Z", null, null, "ALL"][this.billboardMode], t += ", freeze wrld mat: " + (this._isWorldMatrixFrozen || this._waitingData.freezeWorldMatrix ? "YES" : "NO")), t;
  }
  /**
   * @internal
   */
  _getEffectiveParent() {
    return this._masterMesh && this.billboardMode !== oe.BILLBOARDMODE_NONE ? this._masterMesh : super._getEffectiveParent();
  }
  /**
   * @internal
   */
  _getActionManagerForTrigger(e, t = !0) {
    if (this.actionManager && (t || this.actionManager.isRecursive))
      if (e) {
        if (this.actionManager.hasSpecificTrigger(e))
          return this.actionManager;
      } else
        return this.actionManager;
    return this.parent ? this.parent._getActionManagerForTrigger(e, !1) : null;
  }
  /**
   * @internal
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _rebuild(e = !1) {
    if (this.onRebuildObservable.notifyObservers(this), this._occlusionQuery !== null && (this._occlusionQuery = null), !!this.subMeshes)
      for (const t of this.subMeshes)
        t._rebuild();
  }
  /** @internal */
  _resyncLightSources() {
    this._lightSources.length = 0;
    for (const e of this.getScene().lights)
      e.isEnabled() && e.canAffectMesh(this) && this._lightSources.push(e);
    this._markSubMeshesAsLightDirty();
  }
  /**
   * @internal
   */
  _resyncLightSource(e) {
    const t = e.isEnabled() && e.canAffectMesh(this), i = this._lightSources.indexOf(e);
    let s = !1;
    if (i === -1) {
      if (!t)
        return;
      this._lightSources.push(e);
    } else {
      if (t)
        return;
      s = !0, this._lightSources.splice(i, 1);
    }
    this._markSubMeshesAsLightDirty(s);
  }
  /** @internal */
  _unBindEffect() {
    for (const e of this.subMeshes)
      e.setEffect(null);
  }
  /**
   * @internal
   */
  _removeLightSource(e, t) {
    const i = this._lightSources.indexOf(e);
    i !== -1 && (this._lightSources.splice(i, 1), this._markSubMeshesAsLightDirty(t));
  }
  _markSubMeshesAsDirty(e) {
    if (this.subMeshes)
      for (const t of this.subMeshes)
        for (let i = 0; i < t._drawWrappers.length; ++i) {
          const s = t._drawWrappers[i];
          !s || !s.defines || !s.defines.markAllAsDirty || e(s.defines);
        }
  }
  /**
   * @internal
   */
  _markSubMeshesAsLightDirty(e = !1) {
    this._markSubMeshesAsDirty((t) => t.markAsLightDirty(e));
  }
  /** @internal */
  _markSubMeshesAsAttributesDirty() {
    this._markSubMeshesAsDirty((e) => e.markAsAttributesDirty());
  }
  /** @internal */
  _markSubMeshesAsMiscDirty() {
    this._markSubMeshesAsDirty((e) => e.markAsMiscDirty());
  }
  /**
   * Flag the AbstractMesh as dirty (Forcing it to update everything)
   * @param property if set to "rotation" the objects rotationQuaternion will be set to null
   * @returns this AbstractMesh
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  markAsDirty(e) {
    return this._currentRenderId = Number.MAX_VALUE, this._isDirty = !0, this;
  }
  /**
   * Resets the draw wrappers cache for all submeshes of this abstract mesh
   * @param passId If provided, releases only the draw wrapper corresponding to this render pass id
   */
  resetDrawCache(e) {
    if (this.subMeshes)
      for (const t of this.subMeshes)
        t.resetDrawCache(e);
  }
  // Methods
  /**
   * Returns true if the mesh is blocked. Implemented by child classes
   */
  get isBlocked() {
    return !1;
  }
  /**
   * Returns the mesh itself by default. Implemented by child classes
   * @param camera defines the camera to use to pick the right LOD level
   * @returns the currentAbstractMesh
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getLOD(e) {
    return this;
  }
  /**
   * Returns 0 by default. Implemented by child classes
   * @returns an integer
   */
  getTotalVertices() {
    return 0;
  }
  /**
   * Returns a positive integer : the total number of indices in this mesh geometry.
   * @returns the number of indices or zero if the mesh has no geometry.
   */
  getTotalIndices() {
    return 0;
  }
  /**
   * Returns null by default. Implemented by child classes
   * @returns null
   */
  getIndices() {
    return null;
  }
  /**
   * Returns the array of the requested vertex data kind. Implemented by child classes
   * @param kind defines the vertex data kind to use
   * @returns null
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getVerticesData(e) {
    return null;
  }
  /**
   * Sets the vertex data of the mesh geometry for the requested `kind`.
   * If the mesh has no geometry, a new Geometry object is set to the mesh and then passed this vertex data.
   * Note that a new underlying VertexBuffer object is created each call.
   * If the `kind` is the `PositionKind`, the mesh BoundingInfo is renewed, so the bounding box and sphere, and the mesh World Matrix is recomputed.
   * @param kind defines vertex data kind:
   * * VertexBuffer.PositionKind
   * * VertexBuffer.UVKind
   * * VertexBuffer.UV2Kind
   * * VertexBuffer.UV3Kind
   * * VertexBuffer.UV4Kind
   * * VertexBuffer.UV5Kind
   * * VertexBuffer.UV6Kind
   * * VertexBuffer.ColorKind
   * * VertexBuffer.MatricesIndicesKind
   * * VertexBuffer.MatricesIndicesExtraKind
   * * VertexBuffer.MatricesWeightsKind
   * * VertexBuffer.MatricesWeightsExtraKind
   * @param data defines the data source
   * @param updatable defines if the data must be flagged as updatable (or static)
   * @param stride defines the vertex stride (size of an entire vertex). Can be null and in this case will be deduced from vertex data kind
   * @returns the current mesh
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setVerticesData(e, t, i, s) {
    return this;
  }
  /**
   * Updates the existing vertex data of the mesh geometry for the requested `kind`.
   * If the mesh has no geometry, it is simply returned as it is.
   * @param kind defines vertex data kind:
   * * VertexBuffer.PositionKind
   * * VertexBuffer.UVKind
   * * VertexBuffer.UV2Kind
   * * VertexBuffer.UV3Kind
   * * VertexBuffer.UV4Kind
   * * VertexBuffer.UV5Kind
   * * VertexBuffer.UV6Kind
   * * VertexBuffer.ColorKind
   * * VertexBuffer.MatricesIndicesKind
   * * VertexBuffer.MatricesIndicesExtraKind
   * * VertexBuffer.MatricesWeightsKind
   * * VertexBuffer.MatricesWeightsExtraKind
   * @param data defines the data source
   * @param updateExtends If `kind` is `PositionKind` and if `updateExtends` is true, the mesh BoundingInfo is renewed, so the bounding box and sphere, and the mesh World Matrix is recomputed
   * @param makeItUnique If true, a new global geometry is created from this data and is set to the mesh
   * @returns the current mesh
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  updateVerticesData(e, t, i, s) {
    return this;
  }
  /**
   * Sets the mesh indices,
   * If the mesh has no geometry, a new Geometry object is created and set to the mesh.
   * @param indices Expects an array populated with integers or a typed array (Int32Array, Uint32Array, Uint16Array)
   * @param totalVertices Defines the total number of vertices
   * @returns the current mesh
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setIndices(e, t) {
    return this;
  }
  /**
   * Gets a boolean indicating if specific vertex data is present
   * @param kind defines the vertex data kind to use
   * @returns true is data kind is present
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  isVerticesDataPresent(e) {
    return !1;
  }
  /**
   * Returns the mesh BoundingInfo object or creates a new one and returns if it was undefined.
   * Note that it returns a shallow bounding of the mesh (i.e. it does not include children).
   * However, if the mesh contains thin instances, it will be expanded to include them. If you want the "raw" bounding data instead, then use `getRawBoundingInfo()`.
   * To get the full bounding of all children, call `getHierarchyBoundingVectors` instead.
   * @returns a BoundingInfo
   */
  getBoundingInfo() {
    return this._masterMesh ? this._masterMesh.getBoundingInfo() : (this._boundingInfoIsDirty && (this._boundingInfoIsDirty = !1, this._updateBoundingInfo()), this._boundingInfo);
  }
  /**
   * Returns the bounding info unnafected by instance data.
   * @returns the bounding info of the mesh unaffected by instance data.
   */
  getRawBoundingInfo() {
    var e;
    return (e = this.rawBoundingInfo) !== null && e !== void 0 ? e : this.getBoundingInfo();
  }
  /**
   * Overwrite the current bounding info
   * @param boundingInfo defines the new bounding info
   * @returns the current mesh
   */
  setBoundingInfo(e) {
    return this._boundingInfo = e, this;
  }
  /**
   * Returns true if there is already a bounding info
   */
  get hasBoundingInfo() {
    return this._boundingInfo !== null;
  }
  /**
   * Creates a new bounding info for the mesh
   * @param minimum min vector of the bounding box/sphere
   * @param maximum max vector of the bounding box/sphere
   * @param worldMatrix defines the new world matrix
   * @returns the new bounding info
   */
  buildBoundingInfo(e, t, i) {
    return this._boundingInfo = new $t(e, t, i), this._boundingInfo;
  }
  /**
   * Uniformly scales the mesh to fit inside of a unit cube (1 X 1 X 1 units)
   * @param includeDescendants Use the hierarchy's bounding box instead of the mesh's bounding box. Default is false
   * @param ignoreRotation ignore rotation when computing the scale (ie. object will be axis aligned). Default is false
   * @param predicate predicate that is passed in to getHierarchyBoundingVectors when selecting which object should be included when scaling
   * @returns the current mesh
   */
  normalizeToUnitCube(e = !0, t = !1, i) {
    return super.normalizeToUnitCube(e, t, i);
  }
  /** Gets a boolean indicating if this mesh has skinning data and an attached skeleton */
  get useBones() {
    return this.skeleton && this.getScene().skeletonsEnabled && this.isVerticesDataPresent(v.MatricesIndicesKind) && this.isVerticesDataPresent(v.MatricesWeightsKind);
  }
  /** @internal */
  _preActivate() {
  }
  /**
   * @internal
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _preActivateForIntermediateRendering(e) {
  }
  /**
   * @internal
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _activate(e, t) {
    return this._renderId = e, !0;
  }
  /** @internal */
  _postActivate() {
  }
  /** @internal */
  _freeze() {
  }
  /** @internal */
  _unFreeze() {
  }
  /**
   * Gets the current world matrix
   * @returns a Matrix
   */
  getWorldMatrix() {
    return this._masterMesh && this.billboardMode === oe.BILLBOARDMODE_NONE ? this._masterMesh.getWorldMatrix() : super.getWorldMatrix();
  }
  /** @internal */
  _getWorldMatrixDeterminant() {
    return this._masterMesh ? this._masterMesh._getWorldMatrixDeterminant() : super._getWorldMatrixDeterminant();
  }
  /**
   * Gets a boolean indicating if this mesh is an instance or a regular mesh
   */
  get isAnInstance() {
    return !1;
  }
  /**
   * Gets a boolean indicating if this mesh has instances
   */
  get hasInstances() {
    return !1;
  }
  /**
   * Gets a boolean indicating if this mesh has thin instances
   */
  get hasThinInstances() {
    return !1;
  }
  // ================================== Point of View Movement =================================
  /**
   * Perform relative position change from the point of view of behind the front of the mesh.
   * This is performed taking into account the meshes current rotation, so you do not have to care.
   * Supports definition of mesh facing forward or backward {@link definedFacingForwardSearch | See definedFacingForwardSearch }.
   * @param amountRight defines the distance on the right axis
   * @param amountUp defines the distance on the up axis
   * @param amountForward defines the distance on the forward axis
   * @returns the current mesh
   */
  movePOV(e, t, i) {
    return this.position.addInPlace(this.calcMovePOV(e, t, i)), this;
  }
  /**
   * Calculate relative position change from the point of view of behind the front of the mesh.
   * This is performed taking into account the meshes current rotation, so you do not have to care.
   * Supports definition of mesh facing forward or backward {@link definedFacingForwardSearch | See definedFacingForwardSearch }.
   * @param amountRight defines the distance on the right axis
   * @param amountUp defines the distance on the up axis
   * @param amountForward defines the distance on the forward axis
   * @returns the new displacement vector
   */
  calcMovePOV(e, t, i) {
    const s = new I();
    (this.rotationQuaternion ? this.rotationQuaternion : U.RotationYawPitchRoll(this.rotation.y, this.rotation.x, this.rotation.z)).toRotationMatrix(s);
    const n = p.Zero(), a = this.definedFacingForward ? -1 : 1;
    return p.TransformCoordinatesFromFloatsToRef(e * a, t, i * a, s, n), n;
  }
  // ================================== Point of View Rotation =================================
  /**
   * Perform relative rotation change from the point of view of behind the front of the mesh.
   * Supports definition of mesh facing forward or backward {@link definedFacingForwardSearch | See definedFacingForwardSearch }.
   * @param flipBack defines the flip
   * @param twirlClockwise defines the twirl
   * @param tiltRight defines the tilt
   * @returns the current mesh
   */
  rotatePOV(e, t, i) {
    return this.rotation.addInPlace(this.calcRotatePOV(e, t, i)), this;
  }
  /**
   * Calculate relative rotation change from the point of view of behind the front of the mesh.
   * Supports definition of mesh facing forward or backward {@link definedFacingForwardSearch | See definedFacingForwardSearch }.
   * @param flipBack defines the flip
   * @param twirlClockwise defines the twirl
   * @param tiltRight defines the tilt
   * @returns the new rotation vector
   */
  calcRotatePOV(e, t, i) {
    const s = this.definedFacingForward ? 1 : -1;
    return new p(e * s, t, i * s);
  }
  /**
   * This method recomputes and sets a new BoundingInfo to the mesh unless it is locked.
   * This means the mesh underlying bounding box and sphere are recomputed.
   * @param applySkeleton defines whether to apply the skeleton before computing the bounding info
   * @param applyMorph  defines whether to apply the morph target before computing the bounding info
   * @returns the current mesh
   */
  refreshBoundingInfo(e = !1, t = !1) {
    return this._boundingInfo && this._boundingInfo.isLocked ? this : (this._refreshBoundingInfo(this._getPositionData(e, t), null), this);
  }
  /**
   * @internal
   */
  _refreshBoundingInfo(e, t) {
    if (e) {
      const i = Ga(e, 0, this.getTotalVertices(), t);
      this._boundingInfo ? this._boundingInfo.reConstruct(i.minimum, i.maximum) : this._boundingInfo = new $t(i.minimum, i.maximum);
    }
    if (this.subMeshes)
      for (let i = 0; i < this.subMeshes.length; i++)
        this.subMeshes[i].refreshBoundingInfo(e);
    this._updateBoundingInfo();
  }
  /**
   * Internal function to get buffer data and possibly apply morphs and normals
   * @param applySkeleton
   * @param applyMorph
   * @param data
   * @param kind the kind of data you want. Can be Normal or Position
   */
  _getData(e = !1, t = !1, i, s = v.PositionKind) {
    if (i = i ?? this.getVerticesData(s).slice(), i && t && this.morphTargetManager) {
      let r = 0, n = 0;
      for (let a = 0; a < i.length; a++) {
        for (let o = 0; o < this.morphTargetManager.numTargets; o++) {
          const l = this.morphTargetManager.getTarget(o), c = l.influence;
          if (c > 0) {
            const u = l.getPositions();
            u && (i[a] += (u[a] - i[a]) * c);
          }
        }
        if (r++, s === v.PositionKind && this._positions && r === 3) {
          r = 0;
          const o = n * 3;
          this._positions[n++].copyFromFloats(i[o], i[o + 1], i[o + 2]);
        }
      }
    }
    if (i && e && this.skeleton) {
      const r = this.getVerticesData(v.MatricesIndicesKind), n = this.getVerticesData(v.MatricesWeightsKind);
      if (n && r) {
        const a = this.numBoneInfluencers > 4, o = a ? this.getVerticesData(v.MatricesIndicesExtraKind) : null, l = a ? this.getVerticesData(v.MatricesWeightsExtraKind) : null, c = this.skeleton.getTransformMatrices(this), u = C.Vector3[0], d = C.Matrix[0], f = C.Matrix[1];
        let _ = 0;
        for (let g = 0; g < i.length; g += 3, _ += 4) {
          d.reset();
          let m, y;
          for (m = 0; m < 4; m++)
            y = n[_ + m], y > 0 && (I.FromFloat32ArrayToRefScaled(c, Math.floor(r[_ + m] * 16), y, f), d.addToSelf(f));
          if (a)
            for (m = 0; m < 4; m++)
              y = l[_ + m], y > 0 && (I.FromFloat32ArrayToRefScaled(c, Math.floor(o[_ + m] * 16), y, f), d.addToSelf(f));
          s === v.NormalKind ? p.TransformNormalFromFloatsToRef(i[g], i[g + 1], i[g + 2], d, u) : p.TransformCoordinatesFromFloatsToRef(i[g], i[g + 1], i[g + 2], d, u), u.toArray(i, g), s === v.PositionKind && this._positions && this._positions[g / 3].copyFrom(u);
        }
      }
    }
    return i;
  }
  /**
   * Get the normals vertex data and optionally apply skeleton and morphing.
   * @param applySkeleton defines whether to apply the skeleton
   * @param applyMorph  defines whether to apply the morph target
   * @returns the normals data
   */
  getNormalsData(e = !1, t = !1) {
    return this._getData(e, t, null, v.NormalKind);
  }
  /**
   * Get the position vertex data and optionally apply skeleton and morphing.
   * @param applySkeleton defines whether to apply the skeleton
   * @param applyMorph  defines whether to apply the morph target
   * @param data defines the position data to apply the skeleton and morph to
   * @returns the position data
   */
  getPositionData(e = !1, t = !1, i) {
    return this._getData(e, t, i, v.PositionKind);
  }
  /**
   * @internal
   */
  _getPositionData(e, t) {
    var i;
    let s = this.getVerticesData(v.PositionKind);
    if (this._internalAbstractMeshDataInfo._positions && (this._internalAbstractMeshDataInfo._positions = null), s && (e && this.skeleton || t && this.morphTargetManager)) {
      if (s = s.slice(), this._generatePointsArray(), this._positions) {
        const r = this._positions;
        this._internalAbstractMeshDataInfo._positions = new Array(r.length);
        for (let n = 0; n < r.length; n++)
          this._internalAbstractMeshDataInfo._positions[n] = ((i = r[n]) === null || i === void 0 ? void 0 : i.clone()) || new p();
      }
      return this.getPositionData(e, t, s);
    }
    return s;
  }
  /** @internal */
  _updateBoundingInfo() {
    return this._boundingInfo ? this._boundingInfo.update(this.worldMatrixFromCache) : this._boundingInfo = new $t(p.Zero(), p.Zero(), this.worldMatrixFromCache), this._updateSubMeshesBoundingInfo(this.worldMatrixFromCache), this;
  }
  /**
   * @internal
   */
  _updateSubMeshesBoundingInfo(e) {
    if (!this.subMeshes)
      return this;
    const t = this.subMeshes.length;
    for (let i = 0; i < t; i++) {
      const s = this.subMeshes[i];
      (t > 1 || !s.IsGlobal) && s.updateBoundingInfo(e);
    }
    return this;
  }
  /** @internal */
  _afterComputeWorldMatrix() {
    this.doNotSyncBoundingInfo || (this._boundingInfoIsDirty = !0);
  }
  /**
   * Returns `true` if the mesh is within the frustum defined by the passed array of planes.
   * A mesh is in the frustum if its bounding box intersects the frustum
   * @param frustumPlanes defines the frustum to test
   * @returns true if the mesh is in the frustum planes
   */
  isInFrustum(e) {
    return this.getBoundingInfo().isInFrustum(e, this.cullingStrategy);
  }
  /**
   * Returns `true` if the mesh is completely in the frustum defined be the passed array of planes.
   * A mesh is completely in the frustum if its bounding box it completely inside the frustum.
   * @param frustumPlanes defines the frustum to test
   * @returns true if the mesh is completely in the frustum planes
   */
  isCompletelyInFrustum(e) {
    return this.getBoundingInfo().isCompletelyInFrustum(e);
  }
  /**
   * True if the mesh intersects another mesh or a SolidParticle object
   * @param mesh defines a target mesh or SolidParticle to test
   * @param precise Unless the parameter `precise` is set to `true` the intersection is computed according to Axis Aligned Bounding Boxes (AABB), else according to OBB (Oriented BBoxes)
   * @param includeDescendants Can be set to true to test if the mesh defined in parameters intersects with the current mesh or any child meshes
   * @returns true if there is an intersection
   */
  intersectsMesh(e, t = !1, i) {
    const s = this.getBoundingInfo(), r = e.getBoundingInfo();
    if (s.intersects(r, t))
      return !0;
    if (i) {
      for (const n of this.getChildMeshes())
        if (n.intersectsMesh(e, t, !0))
          return !0;
    }
    return !1;
  }
  /**
   * Returns true if the passed point (Vector3) is inside the mesh bounding box
   * @param point defines the point to test
   * @returns true if there is an intersection
   */
  intersectsPoint(e) {
    return this.getBoundingInfo().intersectsPoint(e);
  }
  // Collisions
  /**
   * Gets or sets a boolean indicating that this mesh can be used in the collision engine
   * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions
   */
  get checkCollisions() {
    return this._internalAbstractMeshDataInfo._meshCollisionData._checkCollisions;
  }
  set checkCollisions(e) {
    this._internalAbstractMeshDataInfo._meshCollisionData._checkCollisions = e;
  }
  /**
   * Gets Collider object used to compute collisions (not physics)
   * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions
   */
  get collider() {
    return this._internalAbstractMeshDataInfo._meshCollisionData._collider;
  }
  /**
   * Move the mesh using collision engine
   * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions
   * @param displacement defines the requested displacement vector
   * @returns the current mesh
   */
  moveWithCollisions(e) {
    this.getAbsolutePosition().addToRef(this.ellipsoidOffset, this._internalAbstractMeshDataInfo._meshCollisionData._oldPositionForCollisions);
    const i = this.getScene().collisionCoordinator;
    return this._internalAbstractMeshDataInfo._meshCollisionData._collider || (this._internalAbstractMeshDataInfo._meshCollisionData._collider = i.createCollider()), this._internalAbstractMeshDataInfo._meshCollisionData._collider._radius = this.ellipsoid, i.getNewPosition(this._internalAbstractMeshDataInfo._meshCollisionData._oldPositionForCollisions, e, this._internalAbstractMeshDataInfo._meshCollisionData._collider, this.collisionRetryCount, this, this._onCollisionPositionChange, this.uniqueId), this;
  }
  // Collisions
  /**
   * @internal
   */
  _collideForSubMesh(e, t, i) {
    var s;
    if (this._generatePointsArray(), !this._positions)
      return this;
    if (!e._lastColliderWorldVertices || !e._lastColliderTransformMatrix.equals(t)) {
      e._lastColliderTransformMatrix = t.clone(), e._lastColliderWorldVertices = [], e._trianglePlanes = [];
      const r = e.verticesStart, n = e.verticesStart + e.verticesCount;
      for (let a = r; a < n; a++)
        e._lastColliderWorldVertices.push(p.TransformCoordinates(this._positions[a], t));
    }
    return i._collide(e._trianglePlanes, e._lastColliderWorldVertices, this.getIndices(), e.indexStart, e.indexStart + e.indexCount, e.verticesStart, !!e.getMaterial(), this, this._shouldConvertRHS(), ((s = e.getMaterial()) === null || s === void 0 ? void 0 : s.fillMode) === 7), this;
  }
  /**
   * @internal
   */
  _processCollisionsForSubMeshes(e, t) {
    const i = this._scene.getCollidingSubMeshCandidates(this, e), s = i.length;
    for (let r = 0; r < s; r++) {
      const n = i.data[r];
      s > 1 && !n._checkCollision(e) || this._collideForSubMesh(n, t, e);
    }
    return this;
  }
  /** @internal */
  _shouldConvertRHS() {
    return !1;
  }
  /**
   * @internal
   */
  _checkCollision(e) {
    if (!this.getBoundingInfo()._checkCollision(e))
      return this;
    const t = C.Matrix[0], i = C.Matrix[1];
    return I.ScalingToRef(1 / e._radius.x, 1 / e._radius.y, 1 / e._radius.z, t), this.worldMatrixFromCache.multiplyToRef(t, i), this._processCollisionsForSubMeshes(e, i), this;
  }
  // Picking
  /** @internal */
  _generatePointsArray() {
    return !1;
  }
  /**
   * Checks if the passed Ray intersects with the mesh. A mesh triangle can be picked both from its front and back sides,
   * irrespective of orientation.
   * @param ray defines the ray to use. It should be in the mesh's LOCAL coordinate space.
   * @param fastCheck defines if fast mode (but less precise) must be used (false by default)
   * @param trianglePredicate defines an optional predicate used to select faces when a mesh intersection is detected
   * @param onlyBoundingInfo defines a boolean indicating if picking should only happen using bounding info (false by default)
   * @param worldToUse defines the world matrix to use to get the world coordinate of the intersection point
   * @param skipBoundingInfo a boolean indicating if we should skip the bounding info check
   * @returns the picking info
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/interactions/mesh_intersect
   */
  intersects(e, t, i, s = !1, r, n = !1) {
    const a = new Gt(), o = this.getClassName(), l = o === "InstancedLinesMesh" || o === "LinesMesh" || o === "GreasedLineMesh" ? this.intersectionThreshold : 0, c = this.getBoundingInfo();
    if (!this.subMeshes || !n && (!e.intersectsSphere(c.boundingSphere, l) || !e.intersectsBox(c.boundingBox, l)))
      return a;
    if (s)
      return a.hit = !n, a.pickedMesh = n ? null : this, a.distance = n ? 0 : p.Distance(e.origin, c.boundingSphere.center), a.subMeshId = 0, a;
    if (!this._generatePointsArray())
      return a;
    let u = null;
    const d = this._scene.getIntersectingSubMeshCandidates(this, e), f = d.length;
    let _ = !1;
    for (let g = 0; g < f; g++) {
      const y = d.data[g].getMaterial();
      if (y && (y.fillMode == 7 || y.fillMode == 0 || y.fillMode == 1 || y.fillMode == 2 || y.fillMode == 4)) {
        _ = !0;
        break;
      }
    }
    if (!_)
      return a.hit = !0, a.pickedMesh = this, a.distance = p.Distance(e.origin, c.boundingSphere.center), a.subMeshId = -1, a;
    for (let g = 0; g < f; g++) {
      const m = d.data[g];
      if (f > 1 && !m.canIntersects(e))
        continue;
      const y = m.intersects(e, this._positions, this.getIndices(), t, i);
      if (y && (t || !u || y.distance < u.distance) && (u = y, u.subMeshId = g, t))
        break;
    }
    if (u) {
      const g = r ?? this.getWorldMatrix(), m = C.Vector3[0], y = C.Vector3[1];
      p.TransformCoordinatesToRef(e.origin, g, m), e.direction.scaleToRef(u.distance, y);
      const A = p.TransformNormal(y, g).addInPlace(m);
      return a.hit = !0, a.distance = p.Distance(m, A), a.pickedPoint = A, a.pickedMesh = this, a.bu = u.bu || 0, a.bv = u.bv || 0, a.subMeshFaceId = u.faceId, a.faceId = u.faceId + d.data[u.subMeshId].indexStart / (this.getClassName().indexOf("LinesMesh") !== -1 ? 2 : 3), a.subMeshId = u.subMeshId, a;
    }
    return a;
  }
  /**
   * Clones the current mesh
   * @param name defines the mesh name
   * @param newParent defines the new mesh parent
   * @param doNotCloneChildren defines a boolean indicating that children must not be cloned (false by default)
   * @returns the new mesh
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  clone(e, t, i) {
    return null;
  }
  /**
   * Disposes all the submeshes of the current meshnp
   * @returns the current mesh
   */
  releaseSubMeshes() {
    if (this.subMeshes)
      for (; this.subMeshes.length; )
        this.subMeshes[0].dispose();
    else
      this.subMeshes = new Array();
    return this;
  }
  /**
   * Releases resources associated with this abstract mesh.
   * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
   * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
   */
  dispose(e, t = !1) {
    let i;
    for (this._scene.useMaterialMeshMap && this._internalAbstractMeshDataInfo._material && this._internalAbstractMeshDataInfo._material.meshMap && (this._internalAbstractMeshDataInfo._material.meshMap[this.uniqueId] = void 0), this.getScene().freeActiveMeshes(), this.getScene().freeRenderingGroups(), this.actionManager !== void 0 && this.actionManager !== null && (this.actionManager.dispose(), this.actionManager = null), this._internalAbstractMeshDataInfo._skeleton = null, this._transformMatrixTexture && (this._transformMatrixTexture.dispose(), this._transformMatrixTexture = null), i = 0; i < this._intersectionsInProgress.length; i++) {
      const n = this._intersectionsInProgress[i], a = n._intersectionsInProgress.indexOf(this);
      n._intersectionsInProgress.splice(a, 1);
    }
    this._intersectionsInProgress.length = 0, this.getScene().lights.forEach((n) => {
      let a = n.includedOnlyMeshes.indexOf(this);
      a !== -1 && n.includedOnlyMeshes.splice(a, 1), a = n.excludedMeshes.indexOf(this), a !== -1 && n.excludedMeshes.splice(a, 1);
      const o = n.getShadowGenerators();
      if (o) {
        const l = o.values();
        for (let c = l.next(); c.done !== !0; c = l.next()) {
          const d = c.value.getShadowMap();
          d && d.renderList && (a = d.renderList.indexOf(this), a !== -1 && d.renderList.splice(a, 1));
        }
      }
    }), (this.getClassName() !== "InstancedMesh" || this.getClassName() !== "InstancedLinesMesh") && this.releaseSubMeshes();
    const r = this.getScene().getEngine();
    if (this._occlusionQuery !== null && (this.isOcclusionQueryInProgress = !1, r.deleteQuery(this._occlusionQuery), this._occlusionQuery = null), r.wipeCaches(), this.getScene().removeMesh(this), this._parentContainer) {
      const n = this._parentContainer.meshes.indexOf(this);
      n > -1 && this._parentContainer.meshes.splice(n, 1), this._parentContainer = null;
    }
    if (t && this.material && (this.material.getClassName() === "MultiMaterial" ? this.material.dispose(!1, !0, !0) : this.material.dispose(!1, !0)), !e)
      for (i = 0; i < this.getScene().particleSystems.length; i++)
        this.getScene().particleSystems[i].emitter === this && (this.getScene().particleSystems[i].dispose(), i--);
    this._internalAbstractMeshDataInfo._facetData.facetDataEnabled && this.disableFacetData(), this._uniformBuffer.dispose(), this.onAfterWorldMatrixUpdateObservable.clear(), this.onCollideObservable.clear(), this.onCollisionPositionChangeObservable.clear(), this.onRebuildObservable.clear(), super.dispose(e, t);
  }
  /**
   * Adds the passed mesh as a child to the current mesh
   * @param mesh defines the child mesh
   * @param preserveScalingSign if true, keep scaling sign of child. Otherwise, scaling sign might change.
   * @returns the current mesh
   */
  addChild(e, t = !1) {
    return e.setParent(this, t), this;
  }
  /**
   * Removes the passed mesh from the current mesh children list
   * @param mesh defines the child mesh
   * @param preserveScalingSign if true, keep scaling sign of child. Otherwise, scaling sign might change.
   * @returns the current mesh
   */
  removeChild(e, t = !1) {
    return e.setParent(null, t), this;
  }
  // Facet data
  /** @internal */
  _initFacetData() {
    const e = this._internalAbstractMeshDataInfo._facetData;
    e.facetNormals || (e.facetNormals = new Array()), e.facetPositions || (e.facetPositions = new Array()), e.facetPartitioning || (e.facetPartitioning = new Array()), e.facetNb = this.getIndices().length / 3 | 0, e.partitioningSubdivisions = e.partitioningSubdivisions ? e.partitioningSubdivisions : 10, e.partitioningBBoxRatio = e.partitioningBBoxRatio ? e.partitioningBBoxRatio : 1.01;
    for (let t = 0; t < e.facetNb; t++)
      e.facetNormals[t] = p.Zero(), e.facetPositions[t] = p.Zero();
    return e.facetDataEnabled = !0, this;
  }
  /**
   * Updates the mesh facetData arrays and the internal partitioning when the mesh is morphed or updated.
   * This method can be called within the render loop.
   * You don't need to call this method by yourself in the render loop when you update/morph a mesh with the methods CreateXXX() as they automatically manage this computation
   * @returns the current mesh
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
   */
  updateFacetData() {
    const e = this._internalAbstractMeshDataInfo._facetData;
    e.facetDataEnabled || this._initFacetData();
    const t = this.getVerticesData(v.PositionKind), i = this.getIndices(), s = this.getVerticesData(v.NormalKind), r = this.getBoundingInfo();
    if (e.facetDepthSort && !e.facetDepthSortEnabled) {
      if (e.facetDepthSortEnabled = !0, i instanceof Uint16Array)
        e.depthSortedIndices = new Uint16Array(i);
      else if (i instanceof Uint32Array)
        e.depthSortedIndices = new Uint32Array(i);
      else {
        let a = !1;
        for (let o = 0; o < i.length; o++)
          if (i[o] > 65535) {
            a = !0;
            break;
          }
        a ? e.depthSortedIndices = new Uint32Array(i) : e.depthSortedIndices = new Uint16Array(i);
      }
      if (e.facetDepthSortFunction = function(a, o) {
        return o.sqDistance - a.sqDistance;
      }, !e.facetDepthSortFrom) {
        const a = this.getScene().activeCamera;
        e.facetDepthSortFrom = a ? a.position : p.Zero();
      }
      e.depthSortedFacets = [];
      for (let a = 0; a < e.facetNb; a++) {
        const o = { ind: a * 3, sqDistance: 0 };
        e.depthSortedFacets.push(o);
      }
      e.invertedMatrix = I.Identity(), e.facetDepthSortOrigin = p.Zero();
    }
    e.bbSize.x = r.maximum.x - r.minimum.x > pe ? r.maximum.x - r.minimum.x : pe, e.bbSize.y = r.maximum.y - r.minimum.y > pe ? r.maximum.y - r.minimum.y : pe, e.bbSize.z = r.maximum.z - r.minimum.z > pe ? r.maximum.z - r.minimum.z : pe;
    let n = e.bbSize.x > e.bbSize.y ? e.bbSize.x : e.bbSize.y;
    if (n = n > e.bbSize.z ? n : e.bbSize.z, e.subDiv.max = e.partitioningSubdivisions, e.subDiv.X = Math.floor(e.subDiv.max * e.bbSize.x / n), e.subDiv.Y = Math.floor(e.subDiv.max * e.bbSize.y / n), e.subDiv.Z = Math.floor(e.subDiv.max * e.bbSize.z / n), e.subDiv.X = e.subDiv.X < 1 ? 1 : e.subDiv.X, e.subDiv.Y = e.subDiv.Y < 1 ? 1 : e.subDiv.Y, e.subDiv.Z = e.subDiv.Z < 1 ? 1 : e.subDiv.Z, e.facetParameters.facetNormals = this.getFacetLocalNormals(), e.facetParameters.facetPositions = this.getFacetLocalPositions(), e.facetParameters.facetPartitioning = this.getFacetLocalPartitioning(), e.facetParameters.bInfo = r, e.facetParameters.bbSize = e.bbSize, e.facetParameters.subDiv = e.subDiv, e.facetParameters.ratio = this.partitioningBBoxRatio, e.facetParameters.depthSort = e.facetDepthSort, e.facetDepthSort && e.facetDepthSortEnabled && (this.computeWorldMatrix(!0), this._worldMatrix.invertToRef(e.invertedMatrix), p.TransformCoordinatesToRef(e.facetDepthSortFrom, e.invertedMatrix, e.facetDepthSortOrigin), e.facetParameters.distanceTo = e.facetDepthSortOrigin), e.facetParameters.depthSortedFacets = e.depthSortedFacets, s && q.ComputeNormals(t, i, s, e.facetParameters), e.facetDepthSort && e.facetDepthSortEnabled) {
      e.depthSortedFacets.sort(e.facetDepthSortFunction);
      const a = e.depthSortedIndices.length / 3 | 0;
      for (let o = 0; o < a; o++) {
        const l = e.depthSortedFacets[o].ind;
        e.depthSortedIndices[o * 3] = i[l], e.depthSortedIndices[o * 3 + 1] = i[l + 1], e.depthSortedIndices[o * 3 + 2] = i[l + 2];
      }
      this.updateIndices(e.depthSortedIndices, void 0, !0);
    }
    return this;
  }
  /**
   * Returns the facetLocalNormals array.
   * The normals are expressed in the mesh local spac
   * @returns an array of Vector3
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
   */
  getFacetLocalNormals() {
    const e = this._internalAbstractMeshDataInfo._facetData;
    return e.facetNormals || this.updateFacetData(), e.facetNormals;
  }
  /**
   * Returns the facetLocalPositions array.
   * The facet positions are expressed in the mesh local space
   * @returns an array of Vector3
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
   */
  getFacetLocalPositions() {
    const e = this._internalAbstractMeshDataInfo._facetData;
    return e.facetPositions || this.updateFacetData(), e.facetPositions;
  }
  /**
   * Returns the facetLocalPartitioning array
   * @returns an array of array of numbers
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
   */
  getFacetLocalPartitioning() {
    const e = this._internalAbstractMeshDataInfo._facetData;
    return e.facetPartitioning || this.updateFacetData(), e.facetPartitioning;
  }
  /**
   * Returns the i-th facet position in the world system.
   * This method allocates a new Vector3 per call
   * @param i defines the facet index
   * @returns a new Vector3
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
   */
  getFacetPosition(e) {
    const t = p.Zero();
    return this.getFacetPositionToRef(e, t), t;
  }
  /**
   * Sets the reference Vector3 with the i-th facet position in the world system
   * @param i defines the facet index
   * @param ref defines the target vector
   * @returns the current mesh
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
   */
  getFacetPositionToRef(e, t) {
    const i = this.getFacetLocalPositions()[e], s = this.getWorldMatrix();
    return p.TransformCoordinatesToRef(i, s, t), this;
  }
  /**
   * Returns the i-th facet normal in the world system.
   * This method allocates a new Vector3 per call
   * @param i defines the facet index
   * @returns a new Vector3
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
   */
  getFacetNormal(e) {
    const t = p.Zero();
    return this.getFacetNormalToRef(e, t), t;
  }
  /**
   * Sets the reference Vector3 with the i-th facet normal in the world system
   * @param i defines the facet index
   * @param ref defines the target vector
   * @returns the current mesh
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
   */
  getFacetNormalToRef(e, t) {
    const i = this.getFacetLocalNormals()[e];
    return p.TransformNormalToRef(i, this.getWorldMatrix(), t), this;
  }
  /**
   * Returns the facets (in an array) in the same partitioning block than the one the passed coordinates are located (expressed in the mesh local system)
   * @param x defines x coordinate
   * @param y defines y coordinate
   * @param z defines z coordinate
   * @returns the array of facet indexes
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
   */
  getFacetsAtLocalCoordinates(e, t, i) {
    const s = this.getBoundingInfo(), r = this._internalAbstractMeshDataInfo._facetData, n = Math.floor((e - s.minimum.x * r.partitioningBBoxRatio) * r.subDiv.X * r.partitioningBBoxRatio / r.bbSize.x), a = Math.floor((t - s.minimum.y * r.partitioningBBoxRatio) * r.subDiv.Y * r.partitioningBBoxRatio / r.bbSize.y), o = Math.floor((i - s.minimum.z * r.partitioningBBoxRatio) * r.subDiv.Z * r.partitioningBBoxRatio / r.bbSize.z);
    return n < 0 || n > r.subDiv.max || a < 0 || a > r.subDiv.max || o < 0 || o > r.subDiv.max ? null : r.facetPartitioning[n + r.subDiv.max * a + r.subDiv.max * r.subDiv.max * o];
  }
  /**
   * Returns the closest mesh facet index at (x,y,z) World coordinates, null if not found
   * @param x defines x coordinate
   * @param y defines y coordinate
   * @param z defines z coordinate
   * @param projected sets as the (x,y,z) world projection on the facet
   * @param checkFace if true (default false), only the facet "facing" to (x,y,z) or only the ones "turning their backs", according to the parameter "facing" are returned
   * @param facing if facing and checkFace are true, only the facet "facing" to (x, y, z) are returned : positive dot (x, y, z) * facet position. If facing si false and checkFace is true, only the facet "turning their backs" to (x, y, z) are returned : negative dot (x, y, z) * facet position
   * @returns the face index if found (or null instead)
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
   */
  getClosestFacetAtCoordinates(e, t, i, s, r = !1, n = !0) {
    const a = this.getWorldMatrix(), o = C.Matrix[5];
    a.invertToRef(o);
    const l = C.Vector3[8];
    p.TransformCoordinatesFromFloatsToRef(e, t, i, o, l);
    const c = this.getClosestFacetAtLocalCoordinates(l.x, l.y, l.z, s, r, n);
    return s && p.TransformCoordinatesFromFloatsToRef(s.x, s.y, s.z, a, s), c;
  }
  /**
   * Returns the closest mesh facet index at (x,y,z) local coordinates, null if not found
   * @param x defines x coordinate
   * @param y defines y coordinate
   * @param z defines z coordinate
   * @param projected sets as the (x,y,z) local projection on the facet
   * @param checkFace if true (default false), only the facet "facing" to (x,y,z) or only the ones "turning their backs", according to the parameter "facing" are returned
   * @param facing if facing and checkFace are true, only the facet "facing" to (x, y, z) are returned : positive dot (x, y, z) * facet position. If facing si false and checkFace is true, only the facet "turning their backs" to (x, y, z) are returned : negative dot (x, y, z) * facet position
   * @returns the face index if found (or null instead)
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
   */
  getClosestFacetAtLocalCoordinates(e, t, i, s, r = !1, n = !0) {
    let a = null, o = 0, l = 0, c = 0, u = 0, d = 0, f = 0, _ = 0, g = 0;
    const m = this.getFacetLocalPositions(), y = this.getFacetLocalNormals(), x = this.getFacetsAtLocalCoordinates(e, t, i);
    if (!x)
      return null;
    let A = Number.MAX_VALUE, T = A, M, b, S;
    for (let P = 0; P < x.length; P++)
      M = x[P], b = y[M], S = m[M], u = (e - S.x) * b.x + (t - S.y) * b.y + (i - S.z) * b.z, (!r || r && n && u >= 0 || r && !n && u <= 0) && (u = b.x * S.x + b.y * S.y + b.z * S.z, d = -(b.x * e + b.y * t + b.z * i - u) / (b.x * b.x + b.y * b.y + b.z * b.z), f = e + b.x * d, _ = t + b.y * d, g = i + b.z * d, o = f - e, l = _ - t, c = g - i, T = o * o + l * l + c * c, T < A && (A = T, a = M, s && (s.x = f, s.y = _, s.z = g)));
    return a;
  }
  /**
   * Returns the object "parameter" set with all the expected parameters for facetData computation by ComputeNormals()
   * @returns the parameters
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
   */
  getFacetDataParameters() {
    return this._internalAbstractMeshDataInfo._facetData.facetParameters;
  }
  /**
   * Disables the feature FacetData and frees the related memory
   * @returns the current mesh
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
   */
  disableFacetData() {
    const e = this._internalAbstractMeshDataInfo._facetData;
    return e.facetDataEnabled && (e.facetDataEnabled = !1, e.facetPositions = new Array(), e.facetNormals = new Array(), e.facetPartitioning = new Array(), e.facetParameters = null, e.depthSortedIndices = new Uint32Array(0)), this;
  }
  /**
   * Updates the AbstractMesh indices array
   * @param indices defines the data source
   * @param offset defines the offset in the index buffer where to store the new data (can be null)
   * @param gpuMemoryOnly defines a boolean indicating that only the GPU memory must be updated leaving the CPU version of the indices unchanged (false by default)
   * @returns the current mesh
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  updateIndices(e, t, i = !1) {
    return this;
  }
  /**
   * Creates new normals data for the mesh
   * @param updatable defines if the normal vertex buffer must be flagged as updatable
   * @returns the current mesh
   */
  createNormals(e) {
    const t = this.getVerticesData(v.PositionKind), i = this.getIndices();
    let s;
    return this.isVerticesDataPresent(v.NormalKind) ? s = this.getVerticesData(v.NormalKind) : s = [], q.ComputeNormals(t, i, s, { useRightHandedSystem: this.getScene().useRightHandedSystem }), this.setVerticesData(v.NormalKind, s, e), this;
  }
  /**
   * Align the mesh with a normal
   * @param normal defines the normal to use
   * @param upDirection can be used to redefined the up vector to use (will use the (0, 1, 0) by default)
   * @returns the current mesh
   */
  alignWithNormal(e, t) {
    t || (t = Et.Y);
    const i = C.Vector3[0], s = C.Vector3[1];
    return p.CrossToRef(t, e, s), p.CrossToRef(e, s, i), this.rotationQuaternion ? U.RotationQuaternionFromAxisToRef(i, e, s, this.rotationQuaternion) : p.RotationFromAxisToRef(i, e, s, this.rotation), this;
  }
  /** @internal */
  _checkOcclusionQuery() {
    return !1;
  }
  /**
   * Disables the mesh edge rendering mode
   * @returns the currentAbstractMesh
   */
  disableEdgesRendering() {
    throw he("EdgesRenderer");
  }
  /**
   * Enables the edge rendering mode on the mesh.
   * This mode makes the mesh edges visible
   * @param epsilon defines the maximal distance between two angles to detect a face
   * @param checkVerticesInsteadOfIndices indicates that we should check vertex list directly instead of faces
   * @param options options to the edge renderer
   * @returns the currentAbstractMesh
   * @see https://www.babylonjs-playground.com/#19O9TU#0
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  enableEdgesRendering(e, t, i) {
    throw he("EdgesRenderer");
  }
  /**
   * This function returns all of the particle systems in the scene that use the mesh as an emitter.
   * @returns an array of particle systems in the scene that use the mesh as an emitter
   */
  getConnectedParticleSystems() {
    return this._scene.particleSystems.filter((e) => e.emitter === this);
  }
}
Ut.OCCLUSION_TYPE_NONE = 0;
Ut.OCCLUSION_TYPE_OPTIMISTIC = 1;
Ut.OCCLUSION_TYPE_STRICT = 2;
Ut.OCCLUSION_ALGORITHM_TYPE_ACCURATE = 0;
Ut.OCCLUSION_ALGORITHM_TYPE_CONSERVATIVE = 1;
Ut.CULLINGSTRATEGY_STANDARD = 0;
Ut.CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY = 1;
Ut.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION = 2;
Ut.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION_THEN_BSPHERE_ONLY = 3;
Xe("BABYLON.AbstractMesh", Ut);
function Xa(h) {
  h.indexOf("vClipPlane") === -1 && h.push("vClipPlane"), h.indexOf("vClipPlane2") === -1 && h.push("vClipPlane2"), h.indexOf("vClipPlane3") === -1 && h.push("vClipPlane3"), h.indexOf("vClipPlane4") === -1 && h.push("vClipPlane4"), h.indexOf("vClipPlane5") === -1 && h.push("vClipPlane5"), h.indexOf("vClipPlane6") === -1 && h.push("vClipPlane6");
}
function kl(h, e, t) {
  var i, s, r, n, a, o;
  const l = !!((i = h.clipPlane) !== null && i !== void 0 ? i : e.clipPlane), c = !!((s = h.clipPlane2) !== null && s !== void 0 ? s : e.clipPlane2), u = !!((r = h.clipPlane3) !== null && r !== void 0 ? r : e.clipPlane3), d = !!((n = h.clipPlane4) !== null && n !== void 0 ? n : e.clipPlane4), f = !!((a = h.clipPlane5) !== null && a !== void 0 ? a : e.clipPlane5), _ = !!((o = h.clipPlane6) !== null && o !== void 0 ? o : e.clipPlane6);
  l && t.push("#define CLIPPLANE"), c && t.push("#define CLIPPLANE2"), u && t.push("#define CLIPPLANE3"), d && t.push("#define CLIPPLANE4"), f && t.push("#define CLIPPLANE5"), _ && t.push("#define CLIPPLANE6");
}
function Vl(h, e, t) {
  var i, s, r, n, a, o;
  let l = !1;
  const c = !!((i = h.clipPlane) !== null && i !== void 0 ? i : e.clipPlane), u = !!((s = h.clipPlane2) !== null && s !== void 0 ? s : e.clipPlane2), d = !!((r = h.clipPlane3) !== null && r !== void 0 ? r : e.clipPlane3), f = !!((n = h.clipPlane4) !== null && n !== void 0 ? n : e.clipPlane4), _ = !!((a = h.clipPlane5) !== null && a !== void 0 ? a : e.clipPlane5), g = !!((o = h.clipPlane6) !== null && o !== void 0 ? o : e.clipPlane6);
  return t.CLIPPLANE !== c && (t.CLIPPLANE = c, l = !0), t.CLIPPLANE2 !== u && (t.CLIPPLANE2 = u, l = !0), t.CLIPPLANE3 !== d && (t.CLIPPLANE3 = d, l = !0), t.CLIPPLANE4 !== f && (t.CLIPPLANE4 = f, l = !0), t.CLIPPLANE5 !== _ && (t.CLIPPLANE5 = _, l = !0), t.CLIPPLANE6 !== g && (t.CLIPPLANE6 = g, l = !0), l;
}
function Ha(h, e, t) {
  var i, s, r, n, a, o;
  let l = (i = e.clipPlane) !== null && i !== void 0 ? i : t.clipPlane;
  is(h, "vClipPlane", l), l = (s = e.clipPlane2) !== null && s !== void 0 ? s : t.clipPlane2, is(h, "vClipPlane2", l), l = (r = e.clipPlane3) !== null && r !== void 0 ? r : t.clipPlane3, is(h, "vClipPlane3", l), l = (n = e.clipPlane4) !== null && n !== void 0 ? n : t.clipPlane4, is(h, "vClipPlane4", l), l = (a = e.clipPlane5) !== null && a !== void 0 ? a : t.clipPlane5, is(h, "vClipPlane5", l), l = (o = e.clipPlane6) !== null && o !== void 0 ? o : t.clipPlane6, is(h, "vClipPlane6", l);
}
function is(h, e, t) {
  t && h.setFloat4(e, t.normal.x, t.normal.y, t.normal.z, t.d);
}
class Re {
  /**
   * Binds the scene's uniform buffer to the effect.
   * @param effect defines the effect to bind to the scene uniform buffer
   * @param sceneUbo defines the uniform buffer storing scene data
   */
  static BindSceneUniformBuffer(e, t) {
    t.bindToEffect(e, "Scene");
  }
  /**
   * Helps preparing the defines values about the UVs in used in the effect.
   * UVs are shared as much as we can across channels in the shaders.
   * @param texture The texture we are preparing the UVs for
   * @param defines The defines to update
   * @param key The channel key "diffuse", "specular"... used in the shader
   */
  static PrepareDefinesForMergedUV(e, t, i) {
    t._needUVs = !0, t[i] = !0, e.optimizeUVAllocation && e.getTextureMatrix().isIdentityAs3x2() ? (t[i + "DIRECTUV"] = e.coordinatesIndex + 1, t["MAINUV" + (e.coordinatesIndex + 1)] = !0) : t[i + "DIRECTUV"] = 0;
  }
  /**
   * Binds a texture matrix value to its corresponding uniform
   * @param texture The texture to bind the matrix for
   * @param uniformBuffer The uniform buffer receiving the data
   * @param key The channel key "diffuse", "specular"... used in the shader
   */
  static BindTextureMatrix(e, t, i) {
    const s = e.getTextureMatrix();
    t.updateMatrix(i + "Matrix", s);
  }
  /**
   * Gets the current status of the fog (should it be enabled?)
   * @param mesh defines the mesh to evaluate for fog support
   * @param scene defines the hosting scene
   * @returns true if fog must be enabled
   */
  static GetFogState(e, t) {
    return t.fogEnabled && e.applyFog && t.fogMode !== ge.FOGMODE_NONE;
  }
  /**
   * Helper used to prepare the list of defines associated with misc. values for shader compilation
   * @param mesh defines the current mesh
   * @param scene defines the current scene
   * @param useLogarithmicDepth defines if logarithmic depth has to be turned on
   * @param pointsCloud defines if point cloud rendering has to be turned on
   * @param fogEnabled defines if fog has to be turned on
   * @param alphaTest defines if alpha testing has to be turned on
   * @param defines defines the current list of defines
   * @param applyDecalAfterDetail Defines if the decal is applied after or before the detail
   */
  static PrepareDefinesForMisc(e, t, i, s, r, n, a, o = !1) {
    a._areMiscDirty && (a.LOGARITHMICDEPTH = i, a.POINTSIZE = s, a.FOG = r && this.GetFogState(e, t), a.NONUNIFORMSCALING = e.nonUniformScaling, a.ALPHATEST = n, a.DECAL_AFTER_DETAIL = o);
  }
  /**
   * Helper used to prepare the defines relative to the active camera
   * @param scene defines the current scene
   * @param defines specifies the list of active defines
   * @returns true if the defines have been updated, else false
   */
  static PrepareDefinesForCamera(e, t) {
    let i = !1;
    if (e.activeCamera) {
      const s = t.CAMERA_ORTHOGRAPHIC ? 1 : 0, r = t.CAMERA_PERSPECTIVE ? 1 : 0, n = e.activeCamera.mode === Q.ORTHOGRAPHIC_CAMERA ? 1 : 0, a = e.activeCamera.mode === Q.PERSPECTIVE_CAMERA ? 1 : 0;
      (s ^ n || r ^ a) && (t.CAMERA_ORTHOGRAPHIC = n === 1, t.CAMERA_PERSPECTIVE = a === 1, i = !0);
    }
    return i;
  }
  /**
   * Helper used to prepare the list of defines associated with frame values for shader compilation
   * @param scene defines the current scene
   * @param engine defines the current engine
   * @param material defines the material we are compiling the shader for
   * @param defines specifies the list of active defines
   * @param useInstances defines if instances have to be turned on
   * @param useClipPlane defines if clip plane have to be turned on
   * @param useThinInstances defines if thin instances have to be turned on
   */
  static PrepareDefinesForFrameBoundValues(e, t, i, s, r, n = null, a = !1) {
    let o = Re.PrepareDefinesForCamera(e, s);
    n !== !1 && (o = Vl(i, e, s)), s.DEPTHPREPASS !== !t.getColorWrite() && (s.DEPTHPREPASS = !s.DEPTHPREPASS, o = !0), s.INSTANCES !== r && (s.INSTANCES = r, o = !0), s.THIN_INSTANCES !== a && (s.THIN_INSTANCES = a, o = !0), o && s.markAsUnprocessed();
  }
  /**
   * Prepares the defines for bones
   * @param mesh The mesh containing the geometry data we will draw
   * @param defines The defines to update
   */
  static PrepareDefinesForBones(e, t) {
    if (e.useBones && e.computeBonesUsingShaders && e.skeleton) {
      t.NUM_BONE_INFLUENCERS = e.numBoneInfluencers;
      const i = t.BONETEXTURE !== void 0;
      if (e.skeleton.isUsingTextureForMatrices && i)
        t.BONETEXTURE = !0;
      else {
        t.BonesPerMesh = e.skeleton.bones.length + 1, t.BONETEXTURE = i ? !1 : void 0;
        const s = e.getScene().prePassRenderer;
        if (s && s.enabled) {
          const r = s.excludedSkinnedMesh.indexOf(e) === -1;
          t.BONES_VELOCITY_ENABLED = r;
        }
      }
    } else
      t.NUM_BONE_INFLUENCERS = 0, t.BonesPerMesh = 0, t.BONETEXTURE !== void 0 && (t.BONETEXTURE = !1);
  }
  /**
   * Prepares the defines for morph targets
   * @param mesh The mesh containing the geometry data we will draw
   * @param defines The defines to update
   */
  static PrepareDefinesForMorphTargets(e, t) {
    const i = e.morphTargetManager;
    i ? (t.MORPHTARGETS_UV = i.supportsUVs && t.UV1, t.MORPHTARGETS_TANGENT = i.supportsTangents && t.TANGENT, t.MORPHTARGETS_NORMAL = i.supportsNormals && t.NORMAL, t.MORPHTARGETS = i.numInfluencers > 0, t.NUM_MORPH_INFLUENCERS = i.numInfluencers, t.MORPHTARGETS_TEXTURE = i.isUsingTextureForTargets) : (t.MORPHTARGETS_UV = !1, t.MORPHTARGETS_TANGENT = !1, t.MORPHTARGETS_NORMAL = !1, t.MORPHTARGETS = !1, t.NUM_MORPH_INFLUENCERS = 0);
  }
  /**
   * Prepares the defines for baked vertex animation
   * @param mesh The mesh containing the geometry data we will draw
   * @param defines The defines to update
   */
  static PrepareDefinesForBakedVertexAnimation(e, t) {
    const i = e.bakedVertexAnimationManager;
    t.BAKED_VERTEX_ANIMATION_TEXTURE = !!(i && i.isEnabled);
  }
  /**
   * Prepares the defines used in the shader depending on the attributes data available in the mesh
   * @param mesh The mesh containing the geometry data we will draw
   * @param defines The defines to update
   * @param useVertexColor Precise whether vertex colors should be used or not (override mesh info)
   * @param useBones Precise whether bones should be used or not (override mesh info)
   * @param useMorphTargets Precise whether morph targets should be used or not (override mesh info)
   * @param useVertexAlpha Precise whether vertex alpha should be used or not (override mesh info)
   * @param useBakedVertexAnimation Precise whether baked vertex animation should be used or not (override mesh info)
   * @returns false if defines are considered not dirty and have not been checked
   */
  static PrepareDefinesForAttributes(e, t, i, s, r = !1, n = !0, a = !0) {
    if (!t._areAttributesDirty && t._needNormals === t._normals && t._needUVs === t._uvs)
      return !1;
    t._normals = t._needNormals, t._uvs = t._needUVs, t.NORMAL = t._needNormals && e.isVerticesDataPresent(v.NormalKind), t._needNormals && e.isVerticesDataPresent(v.TangentKind) && (t.TANGENT = !0);
    for (let o = 1; o <= 6; ++o)
      t["UV" + o] = t._needUVs ? e.isVerticesDataPresent(`uv${o === 1 ? "" : o}`) : !1;
    if (i) {
      const o = e.useVertexColors && e.isVerticesDataPresent(v.ColorKind);
      t.VERTEXCOLOR = o, t.VERTEXALPHA = e.hasVertexAlpha && o && n;
    }
    return e.isVerticesDataPresent(v.ColorInstanceKind) && (e.hasInstances || e.hasThinInstances) && (t.INSTANCESCOLOR = !0), s && this.PrepareDefinesForBones(e, t), r && this.PrepareDefinesForMorphTargets(e, t), a && this.PrepareDefinesForBakedVertexAnimation(e, t), !0;
  }
  /**
   * Prepares the defines related to multiview
   * @param scene The scene we are intending to draw
   * @param defines The defines to update
   */
  static PrepareDefinesForMultiview(e, t) {
    if (e.activeCamera) {
      const i = t.MULTIVIEW;
      t.MULTIVIEW = e.activeCamera.outputRenderTarget !== null && e.activeCamera.outputRenderTarget.getViewCount() > 1, t.MULTIVIEW != i && t.markAsUnprocessed();
    }
  }
  /**
   * Prepares the defines related to order independant transparency
   * @param scene The scene we are intending to draw
   * @param defines The defines to update
   * @param needAlphaBlending Determines if the material needs alpha blending
   */
  static PrepareDefinesForOIT(e, t, i) {
    const s = t.ORDER_INDEPENDENT_TRANSPARENCY, r = t.ORDER_INDEPENDENT_TRANSPARENCY_16BITS;
    t.ORDER_INDEPENDENT_TRANSPARENCY = e.useOrderIndependentTransparency && i, t.ORDER_INDEPENDENT_TRANSPARENCY_16BITS = !e.getEngine().getCaps().textureFloatLinearFiltering, (s !== t.ORDER_INDEPENDENT_TRANSPARENCY || r !== t.ORDER_INDEPENDENT_TRANSPARENCY_16BITS) && t.markAsUnprocessed();
  }
  /**
   * Prepares the defines related to the prepass
   * @param scene The scene we are intending to draw
   * @param defines The defines to update
   * @param canRenderToMRT Indicates if this material renders to several textures in the prepass
   */
  static PrepareDefinesForPrePass(e, t, i) {
    const s = t.PREPASS;
    if (!t._arePrePassDirty)
      return;
    const r = [
      {
        type: 1,
        define: "PREPASS_POSITION",
        index: "PREPASS_POSITION_INDEX"
      },
      {
        type: 2,
        define: "PREPASS_VELOCITY",
        index: "PREPASS_VELOCITY_INDEX"
      },
      {
        type: 3,
        define: "PREPASS_REFLECTIVITY",
        index: "PREPASS_REFLECTIVITY_INDEX"
      },
      {
        type: 0,
        define: "PREPASS_IRRADIANCE",
        index: "PREPASS_IRRADIANCE_INDEX"
      },
      {
        type: 7,
        define: "PREPASS_ALBEDO_SQRT",
        index: "PREPASS_ALBEDO_SQRT_INDEX"
      },
      {
        type: 5,
        define: "PREPASS_DEPTH",
        index: "PREPASS_DEPTH_INDEX"
      },
      {
        type: 6,
        define: "PREPASS_NORMAL",
        index: "PREPASS_NORMAL_INDEX"
      }
    ];
    if (e.prePassRenderer && e.prePassRenderer.enabled && i) {
      t.PREPASS = !0, t.SCENE_MRT_COUNT = e.prePassRenderer.mrtCount;
      for (let n = 0; n < r.length; n++) {
        const a = e.prePassRenderer.getIndex(r[n].type);
        a !== -1 ? (t[r[n].define] = !0, t[r[n].index] = a) : t[r[n].define] = !1;
      }
    } else {
      t.PREPASS = !1;
      for (let n = 0; n < r.length; n++)
        t[r[n].define] = !1;
    }
    t.PREPASS != s && (t.markAsUnprocessed(), t.markAsImageProcessingDirty());
  }
  /**
   * Prepares the defines related to the light information passed in parameter
   * @param scene The scene we are intending to draw
   * @param mesh The mesh the effect is compiling for
   * @param light The light the effect is compiling for
   * @param lightIndex The index of the light
   * @param defines The defines to update
   * @param specularSupported Specifies whether specular is supported or not (override lights data)
   * @param state Defines the current state regarding what is needed (normals, etc...)
   * @param state.needNormals
   * @param state.needRebuild
   * @param state.shadowEnabled
   * @param state.specularEnabled
   * @param state.lightmapMode
   */
  static PrepareDefinesForLight(e, t, i, s, r, n, a) {
    var o;
    switch (a.needNormals = !0, r["LIGHT" + s] === void 0 && (a.needRebuild = !0), r["LIGHT" + s] = !0, r["SPOTLIGHT" + s] = !1, r["HEMILIGHT" + s] = !1, r["POINTLIGHT" + s] = !1, r["DIRLIGHT" + s] = !1, i.prepareLightSpecificDefines(r, s), r["LIGHT_FALLOFF_PHYSICAL" + s] = !1, r["LIGHT_FALLOFF_GLTF" + s] = !1, r["LIGHT_FALLOFF_STANDARD" + s] = !1, i.falloffType) {
      case we.FALLOFF_GLTF:
        r["LIGHT_FALLOFF_GLTF" + s] = !0;
        break;
      case we.FALLOFF_PHYSICAL:
        r["LIGHT_FALLOFF_PHYSICAL" + s] = !0;
        break;
      case we.FALLOFF_STANDARD:
        r["LIGHT_FALLOFF_STANDARD" + s] = !0;
        break;
    }
    if (n && !i.specular.equalsFloats(0, 0, 0) && (a.specularEnabled = !0), r["SHADOW" + s] = !1, r["SHADOWCSM" + s] = !1, r["SHADOWCSMDEBUG" + s] = !1, r["SHADOWCSMNUM_CASCADES" + s] = !1, r["SHADOWCSMUSESHADOWMAXZ" + s] = !1, r["SHADOWCSMNOBLEND" + s] = !1, r["SHADOWCSM_RIGHTHANDED" + s] = !1, r["SHADOWPCF" + s] = !1, r["SHADOWPCSS" + s] = !1, r["SHADOWPOISSON" + s] = !1, r["SHADOWESM" + s] = !1, r["SHADOWCLOSEESM" + s] = !1, r["SHADOWCUBE" + s] = !1, r["SHADOWLOWQUALITY" + s] = !1, r["SHADOWMEDIUMQUALITY" + s] = !1, t && t.receiveShadows && e.shadowsEnabled && i.shadowEnabled) {
      const l = (o = i.getShadowGenerator(e.activeCamera)) !== null && o !== void 0 ? o : i.getShadowGenerator();
      if (l) {
        const c = l.getShadowMap();
        c && c.renderList && c.renderList.length > 0 && (a.shadowEnabled = !0, l.prepareDefines(r, s));
      }
    }
    i.lightmapMode != we.LIGHTMAP_DEFAULT ? (a.lightmapMode = !0, r["LIGHTMAPEXCLUDED" + s] = !0, r["LIGHTMAPNOSPECULAR" + s] = i.lightmapMode == we.LIGHTMAP_SHADOWSONLY) : (r["LIGHTMAPEXCLUDED" + s] = !1, r["LIGHTMAPNOSPECULAR" + s] = !1);
  }
  /**
   * Prepares the defines related to the light information passed in parameter
   * @param scene The scene we are intending to draw
   * @param mesh The mesh the effect is compiling for
   * @param defines The defines to update
   * @param specularSupported Specifies whether specular is supported or not (override lights data)
   * @param maxSimultaneousLights Specifies how manuy lights can be added to the effect at max
   * @param disableLighting Specifies whether the lighting is disabled (override scene and light)
   * @returns true if normals will be required for the rest of the effect
   */
  static PrepareDefinesForLights(e, t, i, s, r = 4, n = !1) {
    if (!i._areLightsDirty)
      return i._needNormals;
    let a = 0;
    const o = {
      needNormals: i._needNormals,
      needRebuild: !1,
      lightmapMode: !1,
      shadowEnabled: !1,
      specularEnabled: !1
    };
    if (e.lightsEnabled && !n) {
      for (const c of t.lightSources)
        if (this.PrepareDefinesForLight(e, t, c, a, i, s, o), a++, a === r)
          break;
    }
    i.SPECULARTERM = o.specularEnabled, i.SHADOWS = o.shadowEnabled;
    for (let c = a; c < r; c++)
      i["LIGHT" + c] !== void 0 && (i["LIGHT" + c] = !1, i["HEMILIGHT" + c] = !1, i["POINTLIGHT" + c] = !1, i["DIRLIGHT" + c] = !1, i["SPOTLIGHT" + c] = !1, i["SHADOW" + c] = !1, i["SHADOWCSM" + c] = !1, i["SHADOWCSMDEBUG" + c] = !1, i["SHADOWCSMNUM_CASCADES" + c] = !1, i["SHADOWCSMUSESHADOWMAXZ" + c] = !1, i["SHADOWCSMNOBLEND" + c] = !1, i["SHADOWCSM_RIGHTHANDED" + c] = !1, i["SHADOWPCF" + c] = !1, i["SHADOWPCSS" + c] = !1, i["SHADOWPOISSON" + c] = !1, i["SHADOWESM" + c] = !1, i["SHADOWCLOSEESM" + c] = !1, i["SHADOWCUBE" + c] = !1, i["SHADOWLOWQUALITY" + c] = !1, i["SHADOWMEDIUMQUALITY" + c] = !1);
    const l = e.getEngine().getCaps();
    return i.SHADOWFLOAT === void 0 && (o.needRebuild = !0), i.SHADOWFLOAT = o.shadowEnabled && (l.textureFloatRender && l.textureFloatLinearFiltering || l.textureHalfFloatRender && l.textureHalfFloatLinearFiltering), i.LIGHTMAPEXCLUDED = o.lightmapMode, o.needRebuild && i.rebuild(), o.needNormals;
  }
  /**
   * Prepares the uniforms and samplers list to be used in the effect (for a specific light)
   * @param lightIndex defines the light index
   * @param uniformsList The uniform list
   * @param samplersList The sampler list
   * @param projectedLightTexture defines if projected texture must be used
   * @param uniformBuffersList defines an optional list of uniform buffers
   * @param updateOnlyBuffersList True to only update the uniformBuffersList array
   */
  static PrepareUniformsAndSamplersForLight(e, t, i, s, r = null, n = !1) {
    r && r.push("Light" + e), !n && (t.push("vLightData" + e, "vLightDiffuse" + e, "vLightSpecular" + e, "vLightDirection" + e, "vLightFalloff" + e, "vLightGround" + e, "lightMatrix" + e, "shadowsInfo" + e, "depthValues" + e), i.push("shadowSampler" + e), i.push("depthSampler" + e), t.push("viewFrustumZ" + e, "cascadeBlendFactor" + e, "lightSizeUVCorrection" + e, "depthCorrection" + e, "penumbraDarkness" + e, "frustumLengths" + e), s && (i.push("projectionLightSampler" + e), t.push("textureProjectionMatrix" + e)));
  }
  /**
   * Prepares the uniforms and samplers list to be used in the effect
   * @param uniformsListOrOptions The uniform names to prepare or an EffectCreationOptions containing the list and extra information
   * @param samplersList The sampler list
   * @param defines The defines helping in the list generation
   * @param maxSimultaneousLights The maximum number of simultaneous light allowed in the effect
   */
  static PrepareUniformsAndSamplersList(e, t, i, s = 4) {
    let r, n = null;
    if (e.uniformsNames) {
      const a = e;
      r = a.uniformsNames, n = a.uniformBuffersNames, t = a.samplers, i = a.defines, s = a.maxSimultaneousLights || 0;
    } else
      r = e, t || (t = []);
    for (let a = 0; a < s && i["LIGHT" + a]; a++)
      this.PrepareUniformsAndSamplersForLight(a, r, t, i["PROJECTEDLIGHTTEXTURE" + a], n);
    i.NUM_MORPH_INFLUENCERS && r.push("morphTargetInfluences"), i.BAKED_VERTEX_ANIMATION_TEXTURE && (r.push("bakedVertexAnimationSettings"), r.push("bakedVertexAnimationTextureSizeInverted"), r.push("bakedVertexAnimationTime"), t.push("bakedVertexAnimationTexture"));
  }
  /**
   * This helps decreasing rank by rank the shadow quality (0 being the highest rank and quality)
   * @param defines The defines to update while falling back
   * @param fallbacks The authorized effect fallbacks
   * @param maxSimultaneousLights The maximum number of lights allowed
   * @param rank the current rank of the Effect
   * @returns The newly affected rank
   */
  static HandleFallbacksForShadows(e, t, i = 4, s = 0) {
    let r = 0;
    for (let n = 0; n < i && e["LIGHT" + n]; n++)
      n > 0 && (r = s + n, t.addFallback(r, "LIGHT" + n)), e.SHADOWS || (e["SHADOW" + n] && t.addFallback(s, "SHADOW" + n), e["SHADOWPCF" + n] && t.addFallback(s, "SHADOWPCF" + n), e["SHADOWPCSS" + n] && t.addFallback(s, "SHADOWPCSS" + n), e["SHADOWPOISSON" + n] && t.addFallback(s, "SHADOWPOISSON" + n), e["SHADOWESM" + n] && t.addFallback(s, "SHADOWESM" + n), e["SHADOWCLOSEESM" + n] && t.addFallback(s, "SHADOWCLOSEESM" + n));
    return r++;
  }
  /**
   * Prepares the list of attributes required for morph targets according to the effect defines.
   * @param attribs The current list of supported attribs
   * @param mesh The mesh to prepare the morph targets attributes for
   * @param influencers The number of influencers
   */
  static PrepareAttributesForMorphTargetsInfluencers(e, t, i) {
    this._TmpMorphInfluencers.NUM_MORPH_INFLUENCERS = i, this.PrepareAttributesForMorphTargets(e, t, this._TmpMorphInfluencers);
  }
  /**
   * Prepares the list of attributes required for morph targets according to the effect defines.
   * @param attribs The current list of supported attribs
   * @param mesh The mesh to prepare the morph targets attributes for
   * @param defines The current Defines of the effect
   */
  static PrepareAttributesForMorphTargets(e, t, i) {
    const s = i.NUM_MORPH_INFLUENCERS;
    if (s > 0 && de.LastCreatedEngine) {
      const r = de.LastCreatedEngine.getCaps().maxVertexAttribs, n = t.morphTargetManager;
      if (n != null && n.isUsingTextureForTargets)
        return;
      const a = n && n.supportsNormals && i.NORMAL, o = n && n.supportsTangents && i.TANGENT, l = n && n.supportsUVs && i.UV1;
      for (let c = 0; c < s; c++)
        e.push(v.PositionKind + c), a && e.push(v.NormalKind + c), o && e.push(v.TangentKind + c), l && e.push(v.UVKind + "_" + c), e.length > r && w.Error("Cannot add more vertex attributes for mesh " + t.name);
    }
  }
  /**
   * Prepares the list of attributes required for baked vertex animations according to the effect defines.
   * @param attribs The current list of supported attribs
   * @param mesh The mesh to prepare the morph targets attributes for
   * @param defines The current Defines of the effect
   */
  static PrepareAttributesForBakedVertexAnimation(e, t, i) {
    i.BAKED_VERTEX_ANIMATION_TEXTURE && i.INSTANCES && e.push("bakedVertexAnimationSettingsInstanced");
  }
  /**
   * Prepares the list of attributes required for bones according to the effect defines.
   * @param attribs The current list of supported attribs
   * @param mesh The mesh to prepare the bones attributes for
   * @param defines The current Defines of the effect
   * @param fallbacks The current effect fallback strategy
   */
  static PrepareAttributesForBones(e, t, i, s) {
    i.NUM_BONE_INFLUENCERS > 0 && (s.addCPUSkinningFallback(0, t), e.push(v.MatricesIndicesKind), e.push(v.MatricesWeightsKind), i.NUM_BONE_INFLUENCERS > 4 && (e.push(v.MatricesIndicesExtraKind), e.push(v.MatricesWeightsExtraKind)));
  }
  /**
   * Check and prepare the list of attributes required for instances according to the effect defines.
   * @param attribs The current list of supported attribs
   * @param defines The current MaterialDefines of the effect
   */
  static PrepareAttributesForInstances(e, t) {
    (t.INSTANCES || t.THIN_INSTANCES) && this.PushAttributesForInstances(e, !!t.PREPASS_VELOCITY), t.INSTANCESCOLOR && e.push(v.ColorInstanceKind);
  }
  /**
   * Add the list of attributes required for instances to the attribs array.
   * @param attribs The current list of supported attribs
   * @param needsPreviousMatrices If the shader needs previous matrices
   */
  static PushAttributesForInstances(e, t = !1) {
    e.push("world0"), e.push("world1"), e.push("world2"), e.push("world3"), t && (e.push("previousWorld0"), e.push("previousWorld1"), e.push("previousWorld2"), e.push("previousWorld3"));
  }
  /**
   * Binds the light information to the effect.
   * @param light The light containing the generator
   * @param effect The effect we are binding the data to
   * @param lightIndex The light index in the effect used to render
   */
  static BindLightProperties(e, t, i) {
    e.transferToEffect(t, i + "");
  }
  /**
   * Binds the lights information from the scene to the effect for the given mesh.
   * @param light Light to bind
   * @param lightIndex Light index
   * @param scene The scene where the light belongs to
   * @param effect The effect we are binding the data to
   * @param useSpecular Defines if specular is supported
   * @param receiveShadows Defines if the effect (mesh) we bind the light for receives shadows
   */
  static BindLight(e, t, i, s, r, n = !0) {
    e._bindLight(t, i, s, r, n);
  }
  /**
   * Binds the lights information from the scene to the effect for the given mesh.
   * @param scene The scene the lights belongs to
   * @param mesh The mesh we are binding the information to render
   * @param effect The effect we are binding the data to
   * @param defines The generated defines for the effect
   * @param maxSimultaneousLights The maximum number of light that can be bound to the effect
   */
  static BindLights(e, t, i, s, r = 4) {
    const n = Math.min(t.lightSources.length, r);
    for (let a = 0; a < n; a++) {
      const o = t.lightSources[a];
      this.BindLight(o, a, e, i, typeof s == "boolean" ? s : s.SPECULARTERM, t.receiveShadows);
    }
  }
  /**
   * Binds the fog information from the scene to the effect for the given mesh.
   * @param scene The scene the lights belongs to
   * @param mesh The mesh we are binding the information to render
   * @param effect The effect we are binding the data to
   * @param linearSpace Defines if the fog effect is applied in linear space
   */
  static BindFogParameters(e, t, i, s = !1) {
    e.fogEnabled && t.applyFog && e.fogMode !== ge.FOGMODE_NONE && (i.setFloat4("vFogInfos", e.fogMode, e.fogStart, e.fogEnd, e.fogDensity), s ? (e.fogColor.toLinearSpaceToRef(this._TempFogColor, e.getEngine().useExactSrgbConversions), i.setColor3("vFogColor", this._TempFogColor)) : i.setColor3("vFogColor", e.fogColor));
  }
  /**
   * Binds the bones information from the mesh to the effect.
   * @param mesh The mesh we are binding the information to render
   * @param effect The effect we are binding the data to
   * @param prePassConfiguration Configuration for the prepass, in case prepass is activated
   */
  static BindBonesParameters(e, t, i) {
    if (!(!t || !e) && (e.computeBonesUsingShaders && t._bonesComputationForcedToCPU && (e.computeBonesUsingShaders = !1), e.useBones && e.computeBonesUsingShaders && e.skeleton)) {
      const s = e.skeleton;
      if (s.isUsingTextureForMatrices && t.getUniformIndex("boneTextureWidth") > -1) {
        const r = s.getTransformMatrixTexture(e);
        t.setTexture("boneSampler", r), t.setFloat("boneTextureWidth", 4 * (s.bones.length + 1));
      } else {
        const r = s.getTransformMatrices(e);
        r && (t.setMatrices("mBones", r), i && e.getScene().prePassRenderer && e.getScene().prePassRenderer.getIndex(2) && (i.previousBones[e.uniqueId] || (i.previousBones[e.uniqueId] = r.slice()), t.setMatrices("mPreviousBones", i.previousBones[e.uniqueId]), Re._CopyBonesTransformationMatrices(r, i.previousBones[e.uniqueId])));
      }
    }
  }
  // Copies the bones transformation matrices into the target array and returns the target's reference
  static _CopyBonesTransformationMatrices(e, t) {
    return t.set(e), t;
  }
  /**
   * Binds the morph targets information from the mesh to the effect.
   * @param abstractMesh The mesh we are binding the information to render
   * @param effect The effect we are binding the data to
   */
  static BindMorphTargetParameters(e, t) {
    const i = e.morphTargetManager;
    !e || !i || t.setFloatArray("morphTargetInfluences", i.influences);
  }
  /**
   * Binds the logarithmic depth information from the scene to the effect for the given defines.
   * @param defines The generated defines used in the effect
   * @param effect The effect we are binding the data to
   * @param scene The scene we are willing to render with logarithmic scale for
   */
  static BindLogDepth(e, t, i) {
    if (!e || e.LOGARITHMICDEPTH || e.indexOf && e.indexOf("LOGARITHMICDEPTH") >= 0) {
      const s = i.activeCamera;
      s.mode === Q.ORTHOGRAPHIC_CAMERA && w.Error("Logarithmic depth is not compatible with orthographic cameras!", 20), t.setFloat("logarithmicDepthConstant", 2 / (Math.log(s.maxZ + 1) / Math.LN2));
    }
  }
}
Re._TmpMorphInfluencers = { NUM_MORPH_INFLUENCERS: 0 };
Re._TempFogColor = ie.Black();
class Ci {
  /**
   * Creates a material stencil state instance
   */
  constructor() {
    this.reset();
  }
  /**
   * Resets all the stencil states to default values
   */
  reset() {
    this.enabled = !1, this.mask = 255, this.func = 519, this.funcRef = 1, this.funcMask = 255, this.opStencilFail = 7680, this.opDepthFail = 7680, this.opStencilDepthPass = 7681;
  }
  /**
   * Gets or sets the stencil function
   */
  get func() {
    return this._func;
  }
  set func(e) {
    this._func = e;
  }
  /**
   * Gets or sets the stencil function reference
   */
  get funcRef() {
    return this._funcRef;
  }
  set funcRef(e) {
    this._funcRef = e;
  }
  /**
   * Gets or sets the stencil function mask
   */
  get funcMask() {
    return this._funcMask;
  }
  set funcMask(e) {
    this._funcMask = e;
  }
  /**
   * Gets or sets the operation when the stencil test fails
   */
  get opStencilFail() {
    return this._opStencilFail;
  }
  set opStencilFail(e) {
    this._opStencilFail = e;
  }
  /**
   * Gets or sets the operation when the depth test fails
   */
  get opDepthFail() {
    return this._opDepthFail;
  }
  set opDepthFail(e) {
    this._opDepthFail = e;
  }
  /**
   * Gets or sets the operation when the stencil+depth test succeeds
   */
  get opStencilDepthPass() {
    return this._opStencilDepthPass;
  }
  set opStencilDepthPass(e) {
    this._opStencilDepthPass = e;
  }
  /**
   * Gets or sets the stencil mask
   */
  get mask() {
    return this._mask;
  }
  set mask(e) {
    this._mask = e;
  }
  /**
   * Enables or disables the stencil test
   */
  get enabled() {
    return this._enabled;
  }
  set enabled(e) {
    this._enabled = e;
  }
  /**
   * Get the current class name, useful for serialization or dynamic coding.
   * @returns "MaterialStencilState"
   */
  getClassName() {
    return "MaterialStencilState";
  }
  /**
   * Makes a duplicate of the current configuration into another one.
   * @param stencilState defines stencil state where to copy the info
   */
  copyTo(e) {
    le.Clone(() => e, this);
  }
  /**
   * Serializes this stencil configuration.
   * @returns - An object with the serialized config.
   */
  serialize() {
    return le.Serialize(this);
  }
  /**
   * Parses a stencil state configuration from a serialized object.
   * @param source - Serialized object.
   * @param scene Defines the scene we are parsing for
   * @param rootUrl Defines the rootUrl to load from
   */
  parse(e, t, i) {
    le.Parse(() => this, e, t, i);
  }
}
E([
  R()
], Ci.prototype, "func", null);
E([
  R()
], Ci.prototype, "funcRef", null);
E([
  R()
], Ci.prototype, "funcMask", null);
E([
  R()
], Ci.prototype, "opStencilFail", null);
E([
  R()
], Ci.prototype, "opDepthFail", null);
E([
  R()
], Ci.prototype, "opStencilDepthPass", null);
E([
  R()
], Ci.prototype, "mask", null);
E([
  R()
], Ci.prototype, "enabled", null);
var St;
(function(h) {
  h[h.Created = 1] = "Created", h[h.Disposed = 2] = "Disposed", h[h.GetDefineNames = 4] = "GetDefineNames", h[h.PrepareUniformBuffer = 8] = "PrepareUniformBuffer", h[h.IsReadyForSubMesh = 16] = "IsReadyForSubMesh", h[h.PrepareDefines = 32] = "PrepareDefines", h[h.BindForSubMesh = 64] = "BindForSubMesh", h[h.PrepareEffect = 128] = "PrepareEffect", h[h.GetAnimatables = 256] = "GetAnimatables", h[h.GetActiveTextures = 512] = "GetActiveTextures", h[h.HasTexture = 1024] = "HasTexture", h[h.FillRenderTargetTextures = 2048] = "FillRenderTargetTextures", h[h.HasRenderTargetTextures = 4096] = "HasRenderTargetTextures", h[h.HardBindForSubMesh = 8192] = "HardBindForSubMesh";
})(St || (St = {}));
class F {
  /**
   * If the material can be rendered to several textures with MRT extension
   */
  get canRenderToMRT() {
    return !1;
  }
  /**
   * Sets the alpha value of the material
   */
  set alpha(e) {
    if (this._alpha === e)
      return;
    const t = this._alpha;
    this._alpha = e, (t === 1 || e === 1) && this.markAsDirty(F.MiscDirtyFlag + F.PrePassDirtyFlag);
  }
  /**
   * Gets the alpha value of the material
   */
  get alpha() {
    return this._alpha;
  }
  /**
   * Sets the culling state (true to enable culling, false to disable)
   */
  set backFaceCulling(e) {
    this._backFaceCulling !== e && (this._backFaceCulling = e, this.markAsDirty(F.TextureDirtyFlag));
  }
  /**
   * Gets the culling state
   */
  get backFaceCulling() {
    return this._backFaceCulling;
  }
  /**
   * Sets the type of faces that should be culled (true for back faces, false for front faces)
   */
  set cullBackFaces(e) {
    this._cullBackFaces !== e && (this._cullBackFaces = e, this.markAsDirty(F.TextureDirtyFlag));
  }
  /**
   * Gets the type of faces that should be culled
   */
  get cullBackFaces() {
    return this._cullBackFaces;
  }
  /**
   * Block the dirty-mechanism for this specific material
   * When set to false after being true the material will be marked as dirty.
   */
  get blockDirtyMechanism() {
    return this._blockDirtyMechanism;
  }
  set blockDirtyMechanism(e) {
    this._blockDirtyMechanism !== e && (this._blockDirtyMechanism = e, e || this.markDirty());
  }
  /**
   * This allows you to modify the material without marking it as dirty after every change.
   * This function should be used if you need to make more than one dirty-enabling change to the material - adding a texture, setting a new fill mode and so on.
   * The callback will pass the material as an argument, so you can make your changes to it.
   * @param callback the callback to be executed that will update the material
   */
  atomicMaterialsUpdate(e) {
    this.blockDirtyMechanism = !0;
    try {
      e(this);
    } finally {
      this.blockDirtyMechanism = !1;
    }
  }
  /**
   * Gets a boolean indicating that current material needs to register RTT
   */
  get hasRenderTargetTextures() {
    return this._eventInfo.hasRenderTargetTextures = !1, this._callbackPluginEventHasRenderTargetTextures(this._eventInfo), this._eventInfo.hasRenderTargetTextures;
  }
  /**
   * Called during a dispose event
   */
  set onDispose(e) {
    this._onDisposeObserver && this.onDisposeObservable.remove(this._onDisposeObserver), this._onDisposeObserver = this.onDisposeObservable.add(e);
  }
  /**
   * An event triggered when the material is bound
   */
  get onBindObservable() {
    return this._onBindObservable || (this._onBindObservable = new N()), this._onBindObservable;
  }
  /**
   * Called during a bind event
   */
  set onBind(e) {
    this._onBindObserver && this.onBindObservable.remove(this._onBindObserver), this._onBindObserver = this.onBindObservable.add(e);
  }
  /**
   * An event triggered when the material is unbound
   */
  get onUnBindObservable() {
    return this._onUnBindObservable || (this._onUnBindObservable = new N()), this._onUnBindObservable;
  }
  /**
   * An event triggered when the effect is (re)created
   */
  get onEffectCreatedObservable() {
    return this._onEffectCreatedObservable || (this._onEffectCreatedObservable = new N()), this._onEffectCreatedObservable;
  }
  /**
   * Sets the value of the alpha mode.
   *
   * | Value | Type | Description |
   * | --- | --- | --- |
   * | 0 | ALPHA_DISABLE |   |
   * | 1 | ALPHA_ADD |   |
   * | 2 | ALPHA_COMBINE |   |
   * | 3 | ALPHA_SUBTRACT |   |
   * | 4 | ALPHA_MULTIPLY |   |
   * | 5 | ALPHA_MAXIMIZED |   |
   * | 6 | ALPHA_ONEONE |   |
   * | 7 | ALPHA_PREMULTIPLIED |   |
   * | 8 | ALPHA_PREMULTIPLIED_PORTERDUFF |   |
   * | 9 | ALPHA_INTERPOLATE |   |
   * | 10 | ALPHA_SCREENMODE |   |
   *
   */
  set alphaMode(e) {
    this._alphaMode !== e && (this._alphaMode = e, this.markAsDirty(F.TextureDirtyFlag));
  }
  /**
   * Gets the value of the alpha mode
   */
  get alphaMode() {
    return this._alphaMode;
  }
  /**
   * Sets the need depth pre-pass value
   */
  set needDepthPrePass(e) {
    this._needDepthPrePass !== e && (this._needDepthPrePass = e, this._needDepthPrePass && (this.checkReadyOnEveryCall = !0));
  }
  /**
   * Gets the depth pre-pass value
   */
  get needDepthPrePass() {
    return this._needDepthPrePass;
  }
  /**
   * Can this material render to prepass
   */
  get isPrePassCapable() {
    return !1;
  }
  /**
   * Sets the state for enabling fog
   */
  set fogEnabled(e) {
    this._fogEnabled !== e && (this._fogEnabled = e, this.markAsDirty(F.MiscDirtyFlag));
  }
  /**
   * Gets the value of the fog enabled state
   */
  get fogEnabled() {
    return this._fogEnabled;
  }
  get wireframe() {
    switch (this._fillMode) {
      case F.WireFrameFillMode:
      case F.LineListDrawMode:
      case F.LineLoopDrawMode:
      case F.LineStripDrawMode:
        return !0;
    }
    return this._scene.forceWireframe;
  }
  /**
   * Sets the state of wireframe mode
   */
  set wireframe(e) {
    this.fillMode = e ? F.WireFrameFillMode : F.TriangleFillMode;
  }
  /**
   * Gets the value specifying if point clouds are enabled
   */
  get pointsCloud() {
    switch (this._fillMode) {
      case F.PointFillMode:
      case F.PointListDrawMode:
        return !0;
    }
    return this._scene.forcePointsCloud;
  }
  /**
   * Sets the state of point cloud mode
   */
  set pointsCloud(e) {
    this.fillMode = e ? F.PointFillMode : F.TriangleFillMode;
  }
  /**
   * Gets the material fill mode
   */
  get fillMode() {
    return this._fillMode;
  }
  /**
   * Sets the material fill mode
   */
  set fillMode(e) {
    this._fillMode !== e && (this._fillMode = e, this.markAsDirty(F.MiscDirtyFlag));
  }
  /** @internal */
  _getDrawWrapper() {
    return this._drawWrapper;
  }
  /**
   * @internal
   */
  _setDrawWrapper(e) {
    this._drawWrapper = e;
  }
  /**
   * Creates a material instance
   * @param name defines the name of the material
   * @param scene defines the scene to reference
   * @param doNotAdd specifies if the material should be added to the scene
   */
  constructor(e, t, i) {
    this.shadowDepthWrapper = null, this.allowShaderHotSwapping = !0, this.metadata = null, this.reservedDataStore = null, this.checkReadyOnEveryCall = !1, this.checkReadyOnlyOnce = !1, this.state = "", this._alpha = 1, this._backFaceCulling = !0, this._cullBackFaces = !0, this._blockDirtyMechanism = !1, this.onCompiled = null, this.onError = null, this.getRenderTargetTextures = null, this.doNotSerialize = !1, this._storeEffectOnSubMeshes = !1, this.animations = null, this.onDisposeObservable = new N(), this._onDisposeObserver = null, this._onUnBindObservable = null, this._onBindObserver = null, this._alphaMode = 2, this._needDepthPrePass = !1, this.disableDepthWrite = !1, this.disableColorWrite = !1, this.forceDepthWrite = !1, this.depthFunction = 0, this.separateCullingPass = !1, this._fogEnabled = !0, this.pointSize = 1, this.zOffset = 0, this.zOffsetUnits = 0, this.stencil = new Ci(), this._useUBO = !1, this._fillMode = F.TriangleFillMode, this._cachedDepthWriteState = !1, this._cachedColorWriteState = !1, this._cachedDepthFunctionState = 0, this._indexInSceneMaterialArray = -1, this.meshMap = null, this._parentContainer = null, this._uniformBufferLayoutBuilt = !1, this._eventInfo = {}, this._callbackPluginEventGeneric = () => {
    }, this._callbackPluginEventIsReadyForSubMesh = () => {
    }, this._callbackPluginEventPrepareDefines = () => {
    }, this._callbackPluginEventPrepareDefinesBeforeAttributes = () => {
    }, this._callbackPluginEventHardBindForSubMesh = () => {
    }, this._callbackPluginEventBindForSubMesh = () => {
    }, this._callbackPluginEventHasRenderTargetTextures = () => {
    }, this._callbackPluginEventFillRenderTargetTextures = () => {
    }, this._forceAlphaTest = !1, this._transparencyMode = null, this.name = e;
    const s = t || de.LastCreatedScene;
    s && (this._scene = s, this._dirtyCallbacks = {}, this._dirtyCallbacks[1] = this._markAllSubMeshesAsTexturesDirty.bind(this), this._dirtyCallbacks[2] = this._markAllSubMeshesAsLightsDirty.bind(this), this._dirtyCallbacks[4] = this._markAllSubMeshesAsFresnelDirty.bind(this), this._dirtyCallbacks[8] = this._markAllSubMeshesAsAttributesDirty.bind(this), this._dirtyCallbacks[16] = this._markAllSubMeshesAsMiscDirty.bind(this), this._dirtyCallbacks[32] = this._markAllSubMeshesAsPrePassDirty.bind(this), this._dirtyCallbacks[63] = this._markAllSubMeshesAsAllDirty.bind(this), this.id = e || z.RandomId(), this.uniqueId = this._scene.getUniqueId(), this._materialContext = this._scene.getEngine().createMaterialContext(), this._drawWrapper = new xi(this._scene.getEngine(), !1), this._drawWrapper.materialContext = this._materialContext, this._scene.useRightHandedSystem ? this.sideOrientation = F.ClockWiseSideOrientation : this.sideOrientation = F.CounterClockWiseSideOrientation, this._uniformBuffer = new H(this._scene.getEngine(), void 0, void 0, e), this._useUBO = this.getScene().getEngine().supportsUniformBuffers, i || this._scene.addMaterial(this), this._scene.useMaterialMeshMap && (this.meshMap = {}), F.OnEventObservable.notifyObservers(this, St.Created));
  }
  /**
   * Returns a string representation of the current material
   * @param fullDetails defines a boolean indicating which levels of logging is desired
   * @returns a string with material information
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  toString(e) {
    return "Name: " + this.name;
  }
  /**
   * Gets the class name of the material
   * @returns a string with the class name of the material
   */
  getClassName() {
    return "Material";
  }
  /** @internal */
  get _isMaterial() {
    return !0;
  }
  /**
   * Specifies if updates for the material been locked
   */
  get isFrozen() {
    return this.checkReadyOnlyOnce;
  }
  /**
   * Locks updates for the material
   */
  freeze() {
    this.markDirty(), this.checkReadyOnlyOnce = !0;
  }
  /**
   * Unlocks updates for the material
   */
  unfreeze() {
    this.markDirty(), this.checkReadyOnlyOnce = !1;
  }
  /**
   * Specifies if the material is ready to be used
   * @param mesh defines the mesh to check
   * @param useInstances specifies if instances should be used
   * @returns a boolean indicating if the material is ready to be used
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  isReady(e, t) {
    return !0;
  }
  /**
   * Specifies that the submesh is ready to be used
   * @param mesh defines the mesh to check
   * @param subMesh defines which submesh to check
   * @param useInstances specifies that instances should be used
   * @returns a boolean indicating that the submesh is ready or not
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  isReadyForSubMesh(e, t, i) {
    const s = t.materialDefines;
    return s ? (this._eventInfo.isReadyForSubMesh = !0, this._eventInfo.defines = s, this._callbackPluginEventIsReadyForSubMesh(this._eventInfo), this._eventInfo.isReadyForSubMesh) : !1;
  }
  /**
   * Returns the material effect
   * @returns the effect associated with the material
   */
  getEffect() {
    return this._drawWrapper.effect;
  }
  /**
   * Returns the current scene
   * @returns a Scene
   */
  getScene() {
    return this._scene;
  }
  /**
   * Gets the current transparency mode.
   */
  get transparencyMode() {
    return this._transparencyMode;
  }
  /**
   * Sets the transparency mode of the material.
   *
   * | Value | Type                                | Description |
   * | ----- | ----------------------------------- | ----------- |
   * | 0     | OPAQUE                              |             |
   * | 1     | ALPHATEST                           |             |
   * | 2     | ALPHABLEND                          |             |
   * | 3     | ALPHATESTANDBLEND                   |             |
   *
   */
  set transparencyMode(e) {
    this._transparencyMode !== e && (this._transparencyMode = e, this._forceAlphaTest = e === F.MATERIAL_ALPHATESTANDBLEND, this._markAllSubMeshesAsTexturesAndMiscDirty());
  }
  /**
   * Returns true if alpha blending should be disabled.
   */
  get _disableAlphaBlending() {
    return this._transparencyMode === F.MATERIAL_OPAQUE || this._transparencyMode === F.MATERIAL_ALPHATEST;
  }
  /**
   * Specifies whether or not this material should be rendered in alpha blend mode.
   * @returns a boolean specifying if alpha blending is needed
   */
  needAlphaBlending() {
    return this._disableAlphaBlending ? !1 : this.alpha < 1;
  }
  /**
   * Specifies if the mesh will require alpha blending
   * @param mesh defines the mesh to check
   * @returns a boolean specifying if alpha blending is needed for the mesh
   */
  needAlphaBlendingForMesh(e) {
    return e.visibility < 1 ? !0 : this._disableAlphaBlending ? !1 : e.hasVertexAlpha || this.needAlphaBlending();
  }
  /**
   * Specifies whether or not this material should be rendered in alpha test mode.
   * @returns a boolean specifying if an alpha test is needed.
   */
  needAlphaTesting() {
    return !!this._forceAlphaTest;
  }
  /**
   * Specifies if material alpha testing should be turned on for the mesh
   * @param mesh defines the mesh to check
   */
  _shouldTurnAlphaTestOn(e) {
    return !this.needAlphaBlendingForMesh(e) && this.needAlphaTesting();
  }
  /**
   * Gets the texture used for the alpha test
   * @returns the texture to use for alpha testing
   */
  getAlphaTestTexture() {
    return null;
  }
  /**
   * Marks the material to indicate that it needs to be re-calculated
   * @param forceMaterialDirty - Forces the material to be marked as dirty for all components (same as this.markAsDirty(Material.AllDirtyFlag)). You should use this flag if the material is frozen and you want to force a recompilation.
   */
  markDirty(e = !1) {
    const t = this.getScene().meshes;
    for (const i of t)
      if (i.subMeshes)
        for (const s of i.subMeshes)
          s.getMaterial() === this && s.effect && (s.effect._wasPreviouslyReady = !1, s.effect._wasPreviouslyUsingInstances = null, s.effect._forceRebindOnNextCall = e);
    e && this.markAsDirty(F.AllDirtyFlag);
  }
  /**
   * @internal
   */
  _preBind(e, t = null) {
    const i = this._scene.getEngine(), r = (t ?? this.sideOrientation) === F.ClockWiseSideOrientation;
    return i.enableEffect(e || this._getDrawWrapper()), i.setState(this.backFaceCulling, this.zOffset, !1, r, this._scene._mirroredCameraPosition ? !this.cullBackFaces : this.cullBackFaces, this.stencil, this.zOffsetUnits), r;
  }
  /**
   * Binds the material to the mesh
   * @param world defines the world transformation matrix
   * @param mesh defines the mesh to bind the material to
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  bind(e, t) {
  }
  /**
   * Initializes the uniform buffer layout for the shader.
   */
  buildUniformLayout() {
    const e = this._uniformBuffer;
    this._eventInfo.ubo = e, this._callbackPluginEventGeneric(St.PrepareUniformBuffer, this._eventInfo), e.create(), this._uniformBufferLayoutBuilt = !0;
  }
  /**
   * Binds the submesh to the material
   * @param world defines the world transformation matrix
   * @param mesh defines the mesh containing the submesh
   * @param subMesh defines the submesh to bind the material to
   */
  bindForSubMesh(e, t, i) {
    const s = i.effect;
    s && (this._eventInfo.subMesh = i, this._callbackPluginEventBindForSubMesh(this._eventInfo), s._forceRebindOnNextCall = !1);
  }
  /**
   * Binds the world matrix to the material
   * @param world defines the world transformation matrix
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  bindOnlyWorldMatrix(e) {
  }
  /**
   * Binds the view matrix to the effect
   * @param effect defines the effect to bind the view matrix to
   */
  bindView(e) {
    this._useUBO ? this._needToBindSceneUbo = !0 : e.setMatrix("view", this.getScene().getViewMatrix());
  }
  /**
   * Binds the view projection and projection matrices to the effect
   * @param effect defines the effect to bind the view projection and projection matrices to
   */
  bindViewProjection(e) {
    this._useUBO ? this._needToBindSceneUbo = !0 : (e.setMatrix("viewProjection", this.getScene().getTransformMatrix()), e.setMatrix("projection", this.getScene().getProjectionMatrix()));
  }
  /**
   * Binds the view matrix to the effect
   * @param effect defines the effect to bind the view matrix to
   * @param variableName name of the shader variable that will hold the eye position
   */
  bindEyePosition(e, t) {
    this._useUBO ? this._needToBindSceneUbo = !0 : this._scene.bindEyePosition(e, t);
  }
  /**
   * Processes to execute after binding the material to a mesh
   * @param mesh defines the rendered mesh
   * @param effect
   */
  _afterBind(e, t = null) {
    if (this._scene._cachedMaterial = this, this._needToBindSceneUbo && t && (this._needToBindSceneUbo = !1, Re.BindSceneUniformBuffer(t, this.getScene().getSceneUniformBuffer()), this._scene.finalizeSceneUbo()), e ? this._scene._cachedVisibility = e.visibility : this._scene._cachedVisibility = 1, this._onBindObservable && e && this._onBindObservable.notifyObservers(e), this.disableDepthWrite) {
      const i = this._scene.getEngine();
      this._cachedDepthWriteState = i.getDepthWrite(), i.setDepthWrite(!1);
    }
    if (this.disableColorWrite) {
      const i = this._scene.getEngine();
      this._cachedColorWriteState = i.getColorWrite(), i.setColorWrite(!1);
    }
    if (this.depthFunction !== 0) {
      const i = this._scene.getEngine();
      this._cachedDepthFunctionState = i.getDepthFunction() || 0, i.setDepthFunction(this.depthFunction);
    }
  }
  /**
   * Unbinds the material from the mesh
   */
  unbind() {
    this._onUnBindObservable && this._onUnBindObservable.notifyObservers(this), this.depthFunction !== 0 && this._scene.getEngine().setDepthFunction(this._cachedDepthFunctionState), this.disableDepthWrite && this._scene.getEngine().setDepthWrite(this._cachedDepthWriteState), this.disableColorWrite && this._scene.getEngine().setColorWrite(this._cachedColorWriteState);
  }
  /**
   * Returns the animatable textures.
   * @returns - Array of animatable textures.
   */
  getAnimatables() {
    return this._eventInfo.animatables = [], this._callbackPluginEventGeneric(St.GetAnimatables, this._eventInfo), this._eventInfo.animatables;
  }
  /**
   * Gets the active textures from the material
   * @returns an array of textures
   */
  getActiveTextures() {
    return this._eventInfo.activeTextures = [], this._callbackPluginEventGeneric(St.GetActiveTextures, this._eventInfo), this._eventInfo.activeTextures;
  }
  /**
   * Specifies if the material uses a texture
   * @param texture defines the texture to check against the material
   * @returns a boolean specifying if the material uses the texture
   */
  hasTexture(e) {
    return this._eventInfo.hasTexture = !1, this._eventInfo.texture = e, this._callbackPluginEventGeneric(St.HasTexture, this._eventInfo), this._eventInfo.hasTexture;
  }
  /**
   * Makes a duplicate of the material, and gives it a new name
   * @param name defines the new name for the duplicated material
   * @returns the cloned material
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  clone(e) {
    return null;
  }
  _clonePlugins(e, t) {
    const i = {};
    if (this._serializePlugins(i), F._parsePlugins(i, e, this._scene, t), this.pluginManager)
      for (const s of this.pluginManager._plugins) {
        const r = e.pluginManager.getPlugin(s.name);
        s.copyTo(r);
      }
  }
  /**
   * Gets the meshes bound to the material
   * @returns an array of meshes bound to the material
   */
  getBindedMeshes() {
    if (this.meshMap) {
      const e = new Array();
      for (const t in this.meshMap) {
        const i = this.meshMap[t];
        i && e.push(i);
      }
      return e;
    } else
      return this._scene.meshes.filter((t) => t.material === this);
  }
  /**
   * Force shader compilation
   * @param mesh defines the mesh associated with this material
   * @param onCompiled defines a function to execute once the material is compiled
   * @param options defines the options to configure the compilation
   * @param onError defines a function to execute if the material fails compiling
   */
  forceCompilation(e, t, i, s) {
    const r = Object.assign({ clipPlane: !1, useInstances: !1 }, i), n = this.getScene(), a = this.allowShaderHotSwapping;
    this.allowShaderHotSwapping = !1;
    const o = () => {
      if (!this._scene || !this._scene.getEngine())
        return;
      const l = n.clipPlane;
      if (r.clipPlane && (n.clipPlane = new Dt(0, 0, 0, 1)), this._storeEffectOnSubMeshes) {
        let c = !0, u = null;
        if (e.subMeshes) {
          const d = new Qt(0, 0, 0, 0, 0, e, void 0, !1, !1);
          d.materialDefines && (d.materialDefines._renderId = -1), this.isReadyForSubMesh(e, d, r.useInstances) || (d.effect && d.effect.getCompilationError() && d.effect.allFallbacksProcessed() ? u = d.effect.getCompilationError() : (c = !1, setTimeout(o, 16)));
        }
        c && (this.allowShaderHotSwapping = a, u && s && s(u), t && t(this));
      } else
        this.isReady() ? (this.allowShaderHotSwapping = a, t && t(this)) : setTimeout(o, 16);
      r.clipPlane && (n.clipPlane = l);
    };
    o();
  }
  /**
   * Force shader compilation
   * @param mesh defines the mesh that will use this material
   * @param options defines additional options for compiling the shaders
   * @returns a promise that resolves when the compilation completes
   */
  forceCompilationAsync(e, t) {
    return new Promise((i, s) => {
      this.forceCompilation(e, () => {
        i();
      }, t, (r) => {
        s(r);
      });
    });
  }
  /**
   * Marks a define in the material to indicate that it needs to be re-computed
   * @param flag defines a flag used to determine which parts of the material have to be marked as dirty
   */
  markAsDirty(e) {
    this.getScene().blockMaterialDirtyMechanism || this._blockDirtyMechanism || (F._DirtyCallbackArray.length = 0, e & F.TextureDirtyFlag && F._DirtyCallbackArray.push(F._TextureDirtyCallBack), e & F.LightDirtyFlag && F._DirtyCallbackArray.push(F._LightsDirtyCallBack), e & F.FresnelDirtyFlag && F._DirtyCallbackArray.push(F._FresnelDirtyCallBack), e & F.AttributesDirtyFlag && F._DirtyCallbackArray.push(F._AttributeDirtyCallBack), e & F.MiscDirtyFlag && F._DirtyCallbackArray.push(F._MiscDirtyCallBack), e & F.PrePassDirtyFlag && F._DirtyCallbackArray.push(F._PrePassDirtyCallBack), F._DirtyCallbackArray.length && this._markAllSubMeshesAsDirty(F._RunDirtyCallBacks), this.getScene().resetCachedMaterial());
  }
  /**
   * Resets the draw wrappers cache for all submeshes that are using this material
   */
  resetDrawCache() {
    const e = this.getScene().meshes;
    for (const t of e)
      if (t.subMeshes)
        for (const i of t.subMeshes)
          i.getMaterial() === this && i.resetDrawCache();
  }
  /**
   * Marks all submeshes of a material to indicate that their material defines need to be re-calculated
   * @param func defines a function which checks material defines against the submeshes
   */
  _markAllSubMeshesAsDirty(e) {
    if (this.getScene().blockMaterialDirtyMechanism || this._blockDirtyMechanism)
      return;
    const t = this.getScene().meshes;
    for (const i of t)
      if (i.subMeshes) {
        for (const s of i.subMeshes)
          if (s.getMaterial(!1) === this)
            for (const r of s._drawWrappers)
              !r || !r.defines || !r.defines.markAllAsDirty || this._materialContext === r.materialContext && e(r.defines);
      }
  }
  /**
   * Indicates that the scene should check if the rendering now needs a prepass
   */
  _markScenePrePassDirty() {
    if (this.getScene().blockMaterialDirtyMechanism || this._blockDirtyMechanism)
      return;
    const e = this.getScene().enablePrePassRenderer();
    e && e.markAsDirty();
  }
  /**
   * Indicates that we need to re-calculated for all submeshes
   */
  _markAllSubMeshesAsAllDirty() {
    this._markAllSubMeshesAsDirty(F._AllDirtyCallBack);
  }
  /**
   * Indicates that image processing needs to be re-calculated for all submeshes
   */
  _markAllSubMeshesAsImageProcessingDirty() {
    this._markAllSubMeshesAsDirty(F._ImageProcessingDirtyCallBack);
  }
  /**
   * Indicates that textures need to be re-calculated for all submeshes
   */
  _markAllSubMeshesAsTexturesDirty() {
    this._markAllSubMeshesAsDirty(F._TextureDirtyCallBack);
  }
  /**
   * Indicates that fresnel needs to be re-calculated for all submeshes
   */
  _markAllSubMeshesAsFresnelDirty() {
    this._markAllSubMeshesAsDirty(F._FresnelDirtyCallBack);
  }
  /**
   * Indicates that fresnel and misc need to be re-calculated for all submeshes
   */
  _markAllSubMeshesAsFresnelAndMiscDirty() {
    this._markAllSubMeshesAsDirty(F._FresnelAndMiscDirtyCallBack);
  }
  /**
   * Indicates that lights need to be re-calculated for all submeshes
   */
  _markAllSubMeshesAsLightsDirty() {
    this._markAllSubMeshesAsDirty(F._LightsDirtyCallBack);
  }
  /**
   * Indicates that attributes need to be re-calculated for all submeshes
   */
  _markAllSubMeshesAsAttributesDirty() {
    this._markAllSubMeshesAsDirty(F._AttributeDirtyCallBack);
  }
  /**
   * Indicates that misc needs to be re-calculated for all submeshes
   */
  _markAllSubMeshesAsMiscDirty() {
    this._markAllSubMeshesAsDirty(F._MiscDirtyCallBack);
  }
  /**
   * Indicates that prepass needs to be re-calculated for all submeshes
   */
  _markAllSubMeshesAsPrePassDirty() {
    this._markAllSubMeshesAsDirty(F._MiscDirtyCallBack);
  }
  /**
   * Indicates that textures and misc need to be re-calculated for all submeshes
   */
  _markAllSubMeshesAsTexturesAndMiscDirty() {
    this._markAllSubMeshesAsDirty(F._TextureAndMiscDirtyCallBack);
  }
  _checkScenePerformancePriority() {
    if (this._scene.performancePriority !== ui.BackwardCompatible) {
      this.checkReadyOnlyOnce = !0;
      const e = this._scene.onScenePerformancePriorityChangedObservable.addOnce(() => {
        this.checkReadyOnlyOnce = !1;
      });
      this.onDisposeObservable.add(() => {
        this._scene.onScenePerformancePriorityChangedObservable.remove(e);
      });
    }
  }
  /**
   * Sets the required values to the prepass renderer.
   * @param prePassRenderer defines the prepass renderer to setup.
   * @returns true if the pre pass is needed.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setPrePassRenderer(e) {
    return !1;
  }
  /**
   * Disposes the material
   * @param forceDisposeEffect specifies if effects should be forcefully disposed
   * @param forceDisposeTextures specifies if textures should be forcefully disposed
   * @param notBoundToMesh specifies if the material that is being disposed is known to be not bound to any mesh
   */
  dispose(e, t, i) {
    const s = this.getScene();
    if (s.stopAnimation(this), s.freeProcessedMaterials(), s.removeMaterial(this), this._eventInfo.forceDisposeTextures = t, this._callbackPluginEventGeneric(St.Disposed, this._eventInfo), this._parentContainer) {
      const r = this._parentContainer.materials.indexOf(this);
      r > -1 && this._parentContainer.materials.splice(r, 1), this._parentContainer = null;
    }
    if (i !== !0)
      if (this.meshMap)
        for (const r in this.meshMap) {
          const n = this.meshMap[r];
          n && (n.material = null, this.releaseVertexArrayObject(n, e));
        }
      else {
        const r = s.meshes;
        for (const n of r)
          n.material === this && !n.sourceMesh && (n.material = null, this.releaseVertexArrayObject(n, e));
      }
    this._uniformBuffer.dispose(), e && this._drawWrapper.effect && (this._storeEffectOnSubMeshes || this._drawWrapper.effect.dispose(), this._drawWrapper.effect = null), this.metadata = null, this.onDisposeObservable.notifyObservers(this), this.onDisposeObservable.clear(), this._onBindObservable && this._onBindObservable.clear(), this._onUnBindObservable && this._onUnBindObservable.clear(), this._onEffectCreatedObservable && this._onEffectCreatedObservable.clear(), this._eventInfo && (this._eventInfo = {});
  }
  /**
   * @internal
   */
  // eslint-disable-next-line @typescript-eslint/naming-convention
  releaseVertexArrayObject(e, t) {
    if (e.geometry) {
      const i = e.geometry;
      if (this._storeEffectOnSubMeshes)
        for (const s of e.subMeshes)
          i._releaseVertexArrayObject(s.effect), t && s.effect && s.effect.dispose();
      else
        i._releaseVertexArrayObject(this._drawWrapper.effect);
    }
  }
  /**
   * Serializes this material
   * @returns the serialized material object
   */
  serialize() {
    const e = le.Serialize(this);
    return e.stencil = this.stencil.serialize(), e.uniqueId = this.uniqueId, this._serializePlugins(e), e;
  }
  _serializePlugins(e) {
    if (e.plugins = {}, this.pluginManager)
      for (const t of this.pluginManager._plugins)
        e.plugins[t.getClassName()] = t.serialize();
  }
  /**
   * Creates a material from parsed material data
   * @param parsedMaterial defines parsed material data
   * @param scene defines the hosting scene
   * @param rootUrl defines the root URL to use to load textures
   * @returns a new material
   */
  static Parse(e, t, i) {
    if (!e.customType)
      e.customType = "BABYLON.StandardMaterial";
    else if (e.customType === "BABYLON.PBRMaterial" && e.overloadedAlbedo && (e.customType = "BABYLON.LegacyPBRMaterial", !BABYLON.LegacyPBRMaterial))
      return w.Error("Your scene is trying to load a legacy version of the PBRMaterial, please, include it from the materials library."), null;
    const r = z.Instantiate(e.customType).Parse(e, t, i);
    return r._loadedUniqueId = e.uniqueId, r;
  }
  static _parsePlugins(e, t, i, s) {
    var r;
    if (e.plugins)
      for (const n in e.plugins) {
        const a = e.plugins[n];
        let o = (r = t.pluginManager) === null || r === void 0 ? void 0 : r.getPlugin(a.name);
        if (!o) {
          const l = z.Instantiate("BABYLON." + n);
          l && (o = new l(t));
        }
        o == null || o.parse(a, i, s);
      }
  }
}
F.TriangleFillMode = 0;
F.WireFrameFillMode = 1;
F.PointFillMode = 2;
F.PointListDrawMode = 3;
F.LineListDrawMode = 4;
F.LineLoopDrawMode = 5;
F.LineStripDrawMode = 6;
F.TriangleStripDrawMode = 7;
F.TriangleFanDrawMode = 8;
F.ClockWiseSideOrientation = 0;
F.CounterClockWiseSideOrientation = 1;
F.TextureDirtyFlag = 1;
F.LightDirtyFlag = 2;
F.FresnelDirtyFlag = 4;
F.AttributesDirtyFlag = 8;
F.MiscDirtyFlag = 16;
F.PrePassDirtyFlag = 32;
F.AllDirtyFlag = 63;
F.MATERIAL_OPAQUE = 0;
F.MATERIAL_ALPHATEST = 1;
F.MATERIAL_ALPHABLEND = 2;
F.MATERIAL_ALPHATESTANDBLEND = 3;
F.MATERIAL_NORMALBLENDMETHOD_WHITEOUT = 0;
F.MATERIAL_NORMALBLENDMETHOD_RNM = 1;
F.OnEventObservable = new N();
F._AllDirtyCallBack = (h) => h.markAllAsDirty();
F._ImageProcessingDirtyCallBack = (h) => h.markAsImageProcessingDirty();
F._TextureDirtyCallBack = (h) => h.markAsTexturesDirty();
F._FresnelDirtyCallBack = (h) => h.markAsFresnelDirty();
F._MiscDirtyCallBack = (h) => h.markAsMiscDirty();
F._PrePassDirtyCallBack = (h) => h.markAsPrePassDirty();
F._LightsDirtyCallBack = (h) => h.markAsLightDirty();
F._AttributeDirtyCallBack = (h) => h.markAsAttributesDirty();
F._FresnelAndMiscDirtyCallBack = (h) => {
  F._FresnelDirtyCallBack(h), F._MiscDirtyCallBack(h);
};
F._TextureAndMiscDirtyCallBack = (h) => {
  F._TextureDirtyCallBack(h), F._MiscDirtyCallBack(h);
};
F._DirtyCallbackArray = [];
F._RunDirtyCallBacks = (h) => {
  for (const e of F._DirtyCallbackArray)
    e(h);
};
E([
  R()
], F.prototype, "id", void 0);
E([
  R()
], F.prototype, "uniqueId", void 0);
E([
  R()
], F.prototype, "name", void 0);
E([
  R()
], F.prototype, "metadata", void 0);
E([
  R()
], F.prototype, "checkReadyOnEveryCall", void 0);
E([
  R()
], F.prototype, "checkReadyOnlyOnce", void 0);
E([
  R()
], F.prototype, "state", void 0);
E([
  R("alpha")
], F.prototype, "_alpha", void 0);
E([
  R("backFaceCulling")
], F.prototype, "_backFaceCulling", void 0);
E([
  R("cullBackFaces")
], F.prototype, "_cullBackFaces", void 0);
E([
  R()
], F.prototype, "sideOrientation", void 0);
E([
  R("alphaMode")
], F.prototype, "_alphaMode", void 0);
E([
  R()
], F.prototype, "_needDepthPrePass", void 0);
E([
  R()
], F.prototype, "disableDepthWrite", void 0);
E([
  R()
], F.prototype, "disableColorWrite", void 0);
E([
  R()
], F.prototype, "forceDepthWrite", void 0);
E([
  R()
], F.prototype, "depthFunction", void 0);
E([
  R()
], F.prototype, "separateCullingPass", void 0);
E([
  R("fogEnabled")
], F.prototype, "_fogEnabled", void 0);
E([
  R()
], F.prototype, "pointSize", void 0);
E([
  R()
], F.prototype, "zOffset", void 0);
E([
  R()
], F.prototype, "zOffsetUnits", void 0);
E([
  R()
], F.prototype, "pointsCloud", null);
E([
  R()
], F.prototype, "fillMode", null);
E([
  R()
], F.prototype, "transparencyMode", null);
class Vi extends F {
  /**
   * Gets or Sets the list of Materials used within the multi material.
   * They need to be ordered according to the submeshes order in the associated mesh
   */
  get subMaterials() {
    return this._subMaterials;
  }
  set subMaterials(e) {
    this._subMaterials = e, this._hookArray(e);
  }
  /**
   * Function used to align with Node.getChildren()
   * @returns the list of Materials used within the multi material
   */
  getChildren() {
    return this.subMaterials;
  }
  /**
   * Instantiates a new Multi Material
   * A multi-material is used to apply different materials to different parts of the same object without the need of
   * separate meshes. This can be use to improve performances.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/multiMaterials
   * @param name Define the name in the scene
   * @param scene Define the scene the material belongs to
   */
  constructor(e, t) {
    super(e, t, !0), this._waitingSubMaterialsUniqueIds = [], this.getScene().addMultiMaterial(this), this.subMaterials = new Array(), this._storeEffectOnSubMeshes = !0;
  }
  _hookArray(e) {
    const t = e.push;
    e.push = (...s) => {
      const r = t.apply(e, s);
      return this._markAllSubMeshesAsTexturesDirty(), r;
    };
    const i = e.splice;
    e.splice = (s, r) => {
      const n = i.apply(e, [s, r]);
      return this._markAllSubMeshesAsTexturesDirty(), n;
    };
  }
  /**
   * Get one of the submaterial by its index in the submaterials array
   * @param index The index to look the sub material at
   * @returns The Material if the index has been defined
   */
  getSubMaterial(e) {
    return e < 0 || e >= this.subMaterials.length ? this.getScene().defaultMaterial : this.subMaterials[e];
  }
  /**
   * Get the list of active textures for the whole sub materials list.
   * @returns All the textures that will be used during the rendering
   */
  getActiveTextures() {
    return super.getActiveTextures().concat(...this.subMaterials.map((e) => e ? e.getActiveTextures() : []));
  }
  /**
   * Specifies if any sub-materials of this multi-material use a given texture.
   * @param texture Defines the texture to check against this multi-material's sub-materials.
   * @returns A boolean specifying if any sub-material of this multi-material uses the texture.
   */
  hasTexture(e) {
    var t;
    if (super.hasTexture(e))
      return !0;
    for (let i = 0; i < this.subMaterials.length; i++)
      if (!((t = this.subMaterials[i]) === null || t === void 0) && t.hasTexture(e))
        return !0;
    return !1;
  }
  /**
   * Gets the current class name of the material e.g. "MultiMaterial"
   * Mainly use in serialization.
   * @returns the class name
   */
  getClassName() {
    return "MultiMaterial";
  }
  /**
   * Checks if the material is ready to render the requested sub mesh
   * @param mesh Define the mesh the submesh belongs to
   * @param subMesh Define the sub mesh to look readiness for
   * @param useInstances Define whether or not the material is used with instances
   * @returns true if ready, otherwise false
   */
  isReadyForSubMesh(e, t, i) {
    for (let s = 0; s < this.subMaterials.length; s++) {
      const r = this.subMaterials[s];
      if (r) {
        if (r._storeEffectOnSubMeshes) {
          if (!r.isReadyForSubMesh(e, t, i))
            return !1;
          continue;
        }
        if (!r.isReady(e))
          return !1;
      }
    }
    return !0;
  }
  /**
   * Clones the current material and its related sub materials
   * @param name Define the name of the newly cloned material
   * @param cloneChildren Define if submaterial will be cloned or shared with the parent instance
   * @returns the cloned material
   */
  clone(e, t) {
    const i = new Vi(e, this.getScene());
    for (let s = 0; s < this.subMaterials.length; s++) {
      let r = null;
      const n = this.subMaterials[s];
      t && n ? r = n.clone(e + "-" + n.name) : r = this.subMaterials[s], i.subMaterials.push(r);
    }
    return i;
  }
  /**
   * Serializes the materials into a JSON representation.
   * @returns the JSON representation
   */
  serialize() {
    const e = {};
    e.name = this.name, e.id = this.id, e.uniqueId = this.uniqueId, Ee && (e.tags = Ee.GetTags(this)), e.materialsUniqueIds = [], e.materials = [];
    for (let t = 0; t < this.subMaterials.length; t++) {
      const i = this.subMaterials[t];
      i ? (e.materialsUniqueIds.push(i.uniqueId), e.materials.push(i.id)) : (e.materialsUniqueIds.push(null), e.materials.push(null));
    }
    return e;
  }
  /**
   * Dispose the material and release its associated resources
   * @param forceDisposeEffect Define if we want to force disposing the associated effect (if false the shader is not released and could be reuse later on)
   * @param forceDisposeTextures Define if we want to force disposing the associated textures (if false, they will not be disposed and can still be use elsewhere in the app)
   * @param forceDisposeChildren Define if we want to force disposing the associated submaterials (if false, they will not be disposed and can still be use elsewhere in the app)
   */
  dispose(e, t, i) {
    const s = this.getScene();
    if (!s)
      return;
    if (i)
      for (let n = 0; n < this.subMaterials.length; n++) {
        const a = this.subMaterials[n];
        a && a.dispose(e, t);
      }
    const r = s.multiMaterials.indexOf(this);
    r >= 0 && s.multiMaterials.splice(r, 1), super.dispose(e, t);
  }
  /**
   * Creates a MultiMaterial from parsed MultiMaterial data.
   * @param parsedMultiMaterial defines parsed MultiMaterial data.
   * @param scene defines the hosting scene
   * @returns a new MultiMaterial
   */
  static ParseMultiMaterial(e, t) {
    const i = new Vi(e.name, t);
    return i.id = e.id, i._loadedUniqueId = e.uniqueId, Ee && Ee.AddTagsTo(i, e.tags), e.materialsUniqueIds ? i._waitingSubMaterialsUniqueIds = e.materialsUniqueIds : e.materials.forEach((s) => i.subMaterials.push(t.getLastMaterialById(s))), i;
  }
}
Xe("BABYLON.MultiMaterial", Vi);
class Wl {
  /**
   * Creates a new LOD level
   * @param distanceOrScreenCoverage defines either the distance or the screen coverage where this level should start being displayed
   * @param mesh defines the mesh to use to render this level
   */
  constructor(e, t) {
    this.distanceOrScreenCoverage = e, this.mesh = t;
  }
}
class Ka {
}
class zl {
  constructor() {
    this.visibleInstances = {}, this.batchCache = new na(), this.batchCacheReplacementModeInFrozenMode = new na(), this.instancesBufferSize = 32 * 16 * 4;
  }
}
class na {
  constructor() {
    this.mustReturn = !1, this.visibleInstances = new Array(), this.renderSelf = new Array(), this.hardwareInstancedRendering = new Array();
  }
}
class Gl {
  constructor() {
    this.instancesCount = 0, this.matrixBuffer = null, this.previousMatrixBuffer = null, this.matrixBufferSize = 32 * 16, this.matrixData = null, this.boundingVectors = [], this.worldMatrices = null;
  }
}
class Xl {
  constructor() {
    this._areNormalsFrozen = !1, this._source = null, this.meshMap = null, this._preActivateId = -1, this._LODLevels = new Array(), this._useLODScreenCoverage = !1, this._effectiveMaterial = null, this._forcedInstanceCount = 0, this._overrideRenderingFillMode = null;
  }
}
class K extends Ut {
  /**
   * Gets the default side orientation.
   * @param orientation the orientation to value to attempt to get
   * @returns the default orientation
   * @internal
   */
  static _GetDefaultSideOrientation(e) {
    return e || K.FRONTSIDE;
  }
  /**
   * Determines if the LOD levels are intended to be calculated using screen coverage (surface area ratio) instead of distance.
   */
  get useLODScreenCoverage() {
    return this._internalMeshDataInfo._useLODScreenCoverage;
  }
  set useLODScreenCoverage(e) {
    this._internalMeshDataInfo._useLODScreenCoverage = e, this._sortLODLevels();
  }
  get computeBonesUsingShaders() {
    return this._internalAbstractMeshDataInfo._computeBonesUsingShaders;
  }
  set computeBonesUsingShaders(e) {
    this._internalAbstractMeshDataInfo._computeBonesUsingShaders !== e && (e && this._internalMeshDataInfo._sourcePositions && (this.setVerticesData(v.PositionKind, this._internalMeshDataInfo._sourcePositions, !0), this._internalMeshDataInfo._sourceNormals && this.setVerticesData(v.NormalKind, this._internalMeshDataInfo._sourceNormals, !0), this._internalMeshDataInfo._sourcePositions = null, this._internalMeshDataInfo._sourceNormals = null), this._internalAbstractMeshDataInfo._computeBonesUsingShaders = e, this._markSubMeshesAsAttributesDirty());
  }
  /**
   * An event triggered before rendering the mesh
   */
  get onBeforeRenderObservable() {
    return this._internalMeshDataInfo._onBeforeRenderObservable || (this._internalMeshDataInfo._onBeforeRenderObservable = new N()), this._internalMeshDataInfo._onBeforeRenderObservable;
  }
  /**
   * An event triggered before binding the mesh
   */
  get onBeforeBindObservable() {
    return this._internalMeshDataInfo._onBeforeBindObservable || (this._internalMeshDataInfo._onBeforeBindObservable = new N()), this._internalMeshDataInfo._onBeforeBindObservable;
  }
  /**
   * An event triggered after rendering the mesh
   */
  get onAfterRenderObservable() {
    return this._internalMeshDataInfo._onAfterRenderObservable || (this._internalMeshDataInfo._onAfterRenderObservable = new N()), this._internalMeshDataInfo._onAfterRenderObservable;
  }
  /**
   * An event triggeredbetween rendering pass when using separateCullingPass = true
   */
  get onBetweenPassObservable() {
    return this._internalMeshDataInfo._onBetweenPassObservable || (this._internalMeshDataInfo._onBetweenPassObservable = new N()), this._internalMeshDataInfo._onBetweenPassObservable;
  }
  /**
   * An event triggered before drawing the mesh
   */
  get onBeforeDrawObservable() {
    return this._internalMeshDataInfo._onBeforeDrawObservable || (this._internalMeshDataInfo._onBeforeDrawObservable = new N()), this._internalMeshDataInfo._onBeforeDrawObservable;
  }
  /**
   * Sets a callback to call before drawing the mesh. It is recommended to use onBeforeDrawObservable instead
   */
  set onBeforeDraw(e) {
    this._onBeforeDrawObserver && this.onBeforeDrawObservable.remove(this._onBeforeDrawObserver), this._onBeforeDrawObserver = this.onBeforeDrawObservable.add(e);
  }
  get hasInstances() {
    return this.instances.length > 0;
  }
  get hasThinInstances() {
    var e;
    return ((e = this._thinInstanceDataStorage.instancesCount) !== null && e !== void 0 ? e : 0) > 0;
  }
  /**
   * Gets or sets the forced number of instances to display.
   * If 0 (default value), the number of instances is not forced and depends on the draw type
   * (regular / instance / thin instances mesh)
   */
  get forcedInstanceCount() {
    return this._internalMeshDataInfo._forcedInstanceCount;
  }
  set forcedInstanceCount(e) {
    this._internalMeshDataInfo._forcedInstanceCount = e;
  }
  /**
   * Use this property to override the Material's fillMode value
   */
  get overrideRenderingFillMode() {
    return this._internalMeshDataInfo._overrideRenderingFillMode;
  }
  set overrideRenderingFillMode(e) {
    this._internalMeshDataInfo._overrideRenderingFillMode = e;
  }
  /**
   * Gets the source mesh (the one used to clone this one from)
   */
  get source() {
    return this._internalMeshDataInfo._source;
  }
  /**
   * Gets the list of clones of this mesh
   * The scene must have been constructed with useClonedMeshMap=true for this to work!
   * Note that useClonedMeshMap=true is the default setting
   */
  get cloneMeshMap() {
    return this._internalMeshDataInfo.meshMap;
  }
  /**
   * Gets or sets a boolean indicating that this mesh does not use index buffer
   */
  get isUnIndexed() {
    return this._unIndexed;
  }
  set isUnIndexed(e) {
    this._unIndexed !== e && (this._unIndexed = e, this._markSubMeshesAsAttributesDirty());
  }
  /** Gets the array buffer used to store the instanced buffer used for instances' world matrices */
  get worldMatrixInstancedBuffer() {
    return this._instanceDataStorage.instancesData;
  }
  /** Gets the array buffer used to store the instanced buffer used for instances' previous world matrices */
  get previousWorldMatrixInstancedBuffer() {
    return this._instanceDataStorage.instancesPreviousData;
  }
  /** Gets or sets a boolean indicating that the update of the instance buffer of the world matrices is manual */
  get manualUpdateOfWorldMatrixInstancedBuffer() {
    return this._instanceDataStorage.manualUpdate;
  }
  set manualUpdateOfWorldMatrixInstancedBuffer(e) {
    this._instanceDataStorage.manualUpdate = e;
  }
  /** Gets or sets a boolean indicating that the update of the instance buffer of the world matrices is manual */
  get manualUpdateOfPreviousWorldMatrixInstancedBuffer() {
    return this._instanceDataStorage.previousManualUpdate;
  }
  set manualUpdateOfPreviousWorldMatrixInstancedBuffer(e) {
    this._instanceDataStorage.previousManualUpdate = e;
  }
  /** Gets or sets a boolean indicating that the update of the instance buffer of the world matrices must be performed in all cases (and notably even in frozen mode) */
  get forceWorldMatrixInstancedBufferUpdate() {
    return this._instanceDataStorage.forceMatrixUpdates;
  }
  set forceWorldMatrixInstancedBufferUpdate(e) {
    this._instanceDataStorage.forceMatrixUpdates = e;
  }
  /**
   * @constructor
   * @param name The value used by scene.getMeshByName() to do a lookup.
   * @param scene The scene to add this mesh to.
   * @param parent The parent of this mesh, if it has one
   * @param source An optional Mesh from which geometry is shared, cloned.
   * @param doNotCloneChildren When cloning, skip cloning child meshes of source, default False.
   *                  When false, achieved by calling a clone(), also passing False.
   *                  This will make creation of children, recursive.
   * @param clonePhysicsImpostor When cloning, include cloning mesh physics impostor, default True.
   */
  constructor(e, t = null, i = null, s = null, r, n = !0) {
    if (super(e, t), this._internalMeshDataInfo = new Xl(), this.delayLoadState = 0, this.instances = new Array(), this._creationDataStorage = null, this._geometry = null, this._instanceDataStorage = new zl(), this._thinInstanceDataStorage = new Gl(), this._shouldGenerateFlatShading = !1, this._originalBuilderSideOrientation = K.DEFAULTSIDE, this.overrideMaterialSideOrientation = null, this.ignoreCameraMaxZ = !1, t = this.getScene(), this._onBeforeDraw = (a, o, l) => {
      a && l && (this._uniformBuffer ? this.transferToEffect(o) : l.bindOnlyWorldMatrix(o));
    }, s) {
      if (s._geometry && s._geometry.applyToMesh(this), js.DeepCopy(s, this, [
        "name",
        "material",
        "skeleton",
        "instances",
        "parent",
        "uniqueId",
        "source",
        "metadata",
        "morphTargetManager",
        "hasInstances",
        "worldMatrixInstancedBuffer",
        "previousWorldMatrixInstancedBuffer",
        "hasLODLevels",
        "geometry",
        "isBlocked",
        "areNormalsFrozen",
        "facetNb",
        "isFacetDataEnabled",
        "lightSources",
        "useBones",
        "isAnInstance",
        "collider",
        "edgesRenderer",
        "forward",
        "up",
        "right",
        "absolutePosition",
        "absoluteScaling",
        "absoluteRotationQuaternion",
        "isWorldMatrixFrozen",
        "nonUniformScaling",
        "behaviors",
        "worldMatrixFromCache",
        "hasThinInstances",
        "cloneMeshMap",
        "hasBoundingInfo",
        "physicsBody",
        "physicsImpostor"
      ], ["_poseMatrix"]), this._internalMeshDataInfo._source = s, t.useClonedMeshMap && (s._internalMeshDataInfo.meshMap || (s._internalMeshDataInfo.meshMap = {}), s._internalMeshDataInfo.meshMap[this.uniqueId] = this), this._originalBuilderSideOrientation = s._originalBuilderSideOrientation, this._creationDataStorage = s._creationDataStorage, s._ranges) {
        const a = s._ranges;
        for (const o in a)
          Object.prototype.hasOwnProperty.call(a, o) && a[o] && this.createAnimationRange(o, a[o].from, a[o].to);
      }
      if (s.metadata && s.metadata.clone ? this.metadata = s.metadata.clone() : this.metadata = s.metadata, this._internalMetadata = s._internalMetadata, Ee && Ee.HasTags(s) && Ee.AddTagsTo(this, Ee.GetTags(s, !0)), this.setEnabled(s.isEnabled(!1)), this.parent = s.parent, this.setPivotMatrix(s.getPivotMatrix()), this.id = e + "." + s.id, this.material = s.material, !r) {
        const a = s.getDescendants(!0);
        for (let o = 0; o < a.length; o++) {
          const l = a[o];
          l.clone && l.clone(e + "." + l.name, this);
        }
      }
      if (s.morphTargetManager && (this.morphTargetManager = s.morphTargetManager), t.getPhysicsEngine) {
        const a = t.getPhysicsEngine();
        if (n && a)
          if (a.getPluginVersion() === 1) {
            const o = a.getImpostorForPhysicsObject(s);
            o && (this.physicsImpostor = o.clone(this));
          } else a.getPluginVersion() === 2 && s.physicsBody && s.physicsBody.clone(this);
      }
      for (let a = 0; a < t.particleSystems.length; a++) {
        const o = t.particleSystems[a];
        o.emitter === s && o.clone(o.name, this);
      }
      this.skeleton = s.skeleton, this.refreshBoundingInfo(!0, !0), this.computeWorldMatrix(!0);
    }
    i !== null && (this.parent = i), this._instanceDataStorage.hardwareInstancedRendering = this.getEngine().getCaps().instancedArrays, this._internalMeshDataInfo._onMeshReadyObserverAdded = (a) => {
      a.unregisterOnNextCall = !0, this.isReady(!0) ? this.onMeshReadyObservable.notifyObservers(this) : this._internalMeshDataInfo._checkReadinessObserver || (this._internalMeshDataInfo._checkReadinessObserver = this._scene.onBeforeRenderObservable.add(() => {
        this.isReady(!0) && (this._scene.onBeforeRenderObservable.remove(this._internalMeshDataInfo._checkReadinessObserver), this._internalMeshDataInfo._checkReadinessObserver = null, this.onMeshReadyObservable.notifyObservers(this));
      }));
    }, this.onMeshReadyObservable = new N(this._internalMeshDataInfo._onMeshReadyObserverAdded), s && s.onClonedObservable.notifyObservers(this);
  }
  instantiateHierarchy(e = null, t, i) {
    const s = this.getTotalVertices() === 0 || t && t.doNotInstantiate && (t.doNotInstantiate === !0 || t.doNotInstantiate(this)) ? this.clone("Clone of " + (this.name || this.id), e || this.parent, !0) : this.createInstance("instance of " + (this.name || this.id));
    s.parent = e || this.parent, s.position = this.position.clone(), s.scaling = this.scaling.clone(), this.rotationQuaternion ? s.rotationQuaternion = this.rotationQuaternion.clone() : s.rotation = this.rotation.clone(), i && i(this, s);
    for (const r of this.getChildTransformNodes(!0))
      r.getClassName() === "InstancedMesh" && s.getClassName() === "Mesh" && r.sourceMesh === this ? r.instantiateHierarchy(s, {
        doNotInstantiate: t && t.doNotInstantiate || !1,
        newSourcedMesh: s
      }, i) : r.instantiateHierarchy(s, t, i);
    return s;
  }
  /**
   * Gets the class name
   * @returns the string "Mesh".
   */
  getClassName() {
    return "Mesh";
  }
  /** @internal */
  get _isMesh() {
    return !0;
  }
  /**
   * Returns a description of this mesh
   * @param fullDetails define if full details about this mesh must be used
   * @returns a descriptive string representing this mesh
   */
  toString(e) {
    let t = super.toString(e);
    if (t += ", n vertices: " + this.getTotalVertices(), t += ", parent: " + (this._waitingParentId ? this._waitingParentId : this.parent ? this.parent.name : "NONE"), this.animations)
      for (let i = 0; i < this.animations.length; i++)
        t += ", animation[0]: " + this.animations[i].toString(e);
    if (e)
      if (this._geometry) {
        const i = this.getIndices(), s = this.getVerticesData(v.PositionKind);
        s && i && (t += ", flat shading: " + (s.length / 3 === i.length ? "YES" : "NO"));
      } else
        t += ", flat shading: UNKNOWN";
    return t;
  }
  /** @internal */
  _unBindEffect() {
    super._unBindEffect();
    for (const e of this.instances)
      e._unBindEffect();
  }
  /**
   * Gets a boolean indicating if this mesh has LOD
   */
  get hasLODLevels() {
    return this._internalMeshDataInfo._LODLevels.length > 0;
  }
  /**
   * Gets the list of MeshLODLevel associated with the current mesh
   * @returns an array of MeshLODLevel
   */
  getLODLevels() {
    return this._internalMeshDataInfo._LODLevels;
  }
  _sortLODLevels() {
    const e = this._internalMeshDataInfo._useLODScreenCoverage ? -1 : 1;
    this._internalMeshDataInfo._LODLevels.sort((t, i) => t.distanceOrScreenCoverage < i.distanceOrScreenCoverage ? e : t.distanceOrScreenCoverage > i.distanceOrScreenCoverage ? -e : 0);
  }
  /**
   * Add a mesh as LOD level triggered at the given distance.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/LOD
   * @param distanceOrScreenCoverage Either distance from the center of the object to show this level or the screen coverage if `useScreenCoverage` is set to `true`.
   * If screen coverage, value is a fraction of the screen's total surface, between 0 and 1.
   * Example Playground for distance https://playground.babylonjs.com/#QE7KM#197
   * Example Playground for screen coverage https://playground.babylonjs.com/#QE7KM#196
   * @param mesh The mesh to be added as LOD level (can be null)
   * @returns This mesh (for chaining)
   */
  addLODLevel(e, t) {
    if (t && t._masterMesh)
      return w.Warn("You cannot use a mesh as LOD level twice"), this;
    const i = new Wl(e, t);
    return this._internalMeshDataInfo._LODLevels.push(i), t && (t._masterMesh = this), this._sortLODLevels(), this;
  }
  /**
   * Returns the LOD level mesh at the passed distance or null if not found.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/LOD
   * @param distance The distance from the center of the object to show this level
   * @returns a Mesh or `null`
   */
  getLODLevelAtDistance(e) {
    const t = this._internalMeshDataInfo;
    for (let i = 0; i < t._LODLevels.length; i++) {
      const s = t._LODLevels[i];
      if (s.distanceOrScreenCoverage === e)
        return s.mesh;
    }
    return null;
  }
  /**
   * Remove a mesh from the LOD array
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/LOD
   * @param mesh defines the mesh to be removed
   * @returns This mesh (for chaining)
   */
  removeLODLevel(e) {
    const t = this._internalMeshDataInfo;
    for (let i = 0; i < t._LODLevels.length; i++)
      t._LODLevels[i].mesh === e && (t._LODLevels.splice(i, 1), e && (e._masterMesh = null));
    return this._sortLODLevels(), this;
  }
  /**
   * Returns the registered LOD mesh distant from the parameter `camera` position if any, else returns the current mesh.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/LOD
   * @param camera defines the camera to use to compute distance
   * @param boundingSphere defines a custom bounding sphere to use instead of the one from this mesh
   * @returns This mesh (for chaining)
   */
  getLOD(e, t) {
    const i = this._internalMeshDataInfo;
    if (!i._LODLevels || i._LODLevels.length === 0)
      return this;
    const s = t || this.getBoundingInfo().boundingSphere, r = e.mode === Q.ORTHOGRAPHIC_CAMERA ? e.minZ : s.centerWorld.subtract(e.globalPosition).length();
    let n = r, a = 1;
    if (i._useLODScreenCoverage) {
      const o = e.screenArea;
      let l = s.radiusWorld * e.minZ / r;
      l = l * l * Math.PI, n = l / o, a = -1;
    }
    if (a * i._LODLevels[i._LODLevels.length - 1].distanceOrScreenCoverage > a * n)
      return this.onLODLevelSelection && this.onLODLevelSelection(n, this, this), this;
    for (let o = 0; o < i._LODLevels.length; o++) {
      const l = i._LODLevels[o];
      if (a * l.distanceOrScreenCoverage < a * n) {
        if (l.mesh) {
          if (l.mesh.delayLoadState === 4)
            return l.mesh._checkDelayState(), this;
          if (l.mesh.delayLoadState === 2)
            return this;
          l.mesh._preActivate(), l.mesh._updateSubMeshesBoundingInfo(this.worldMatrixFromCache);
        }
        return this.onLODLevelSelection && this.onLODLevelSelection(n, this, l.mesh), l.mesh;
      }
    }
    return this.onLODLevelSelection && this.onLODLevelSelection(n, this, this), this;
  }
  /**
   * Gets the mesh internal Geometry object
   */
  get geometry() {
    return this._geometry;
  }
  /**
   * Returns the total number of vertices within the mesh geometry or zero if the mesh has no geometry.
   * @returns the total number of vertices
   */
  getTotalVertices() {
    return this._geometry === null || this._geometry === void 0 ? 0 : this._geometry.getTotalVertices();
  }
  /**
   * Returns the content of an associated vertex buffer
   * @param kind defines which buffer to read from (positions, indices, normals, etc). Possible `kind` values :
   * - VertexBuffer.PositionKind
   * - VertexBuffer.UVKind
   * - VertexBuffer.UV2Kind
   * - VertexBuffer.UV3Kind
   * - VertexBuffer.UV4Kind
   * - VertexBuffer.UV5Kind
   * - VertexBuffer.UV6Kind
   * - VertexBuffer.ColorKind
   * - VertexBuffer.MatricesIndicesKind
   * - VertexBuffer.MatricesIndicesExtraKind
   * - VertexBuffer.MatricesWeightsKind
   * - VertexBuffer.MatricesWeightsExtraKind
   * @param copyWhenShared defines a boolean indicating that if the mesh geometry is shared among some other meshes, the returned array is a copy of the internal one
   * @param forceCopy defines a boolean forcing the copy of the buffer no matter what the value of copyWhenShared is
   * @param bypassInstanceData defines a boolean indicating that the function should not take into account the instance data (applies only if the mesh has instances). Default: false
   * @returns a FloatArray or null if the mesh has no geometry or no vertex buffer for this kind.
   */
  getVerticesData(e, t, i, s) {
    var r, n;
    if (!this._geometry)
      return null;
    let a = s || (n = (r = this._userInstancedBuffersStorage) === null || r === void 0 ? void 0 : r.vertexBuffers[e]) === null || n === void 0 ? void 0 : n.getFloatData(
      this.instances.length + 1,
      // +1 because the master mesh is not included in the instances array
      i || t && this._geometry.meshes.length !== 1
    );
    return a || (a = this._geometry.getVerticesData(e, t, i)), a;
  }
  /**
   * Returns the mesh VertexBuffer object from the requested `kind`
   * @param kind defines which buffer to read from (positions, indices, normals, etc). Possible `kind` values :
   * - VertexBuffer.PositionKind
   * - VertexBuffer.NormalKind
   * - VertexBuffer.UVKind
   * - VertexBuffer.UV2Kind
   * - VertexBuffer.UV3Kind
   * - VertexBuffer.UV4Kind
   * - VertexBuffer.UV5Kind
   * - VertexBuffer.UV6Kind
   * - VertexBuffer.ColorKind
   * - VertexBuffer.MatricesIndicesKind
   * - VertexBuffer.MatricesIndicesExtraKind
   * - VertexBuffer.MatricesWeightsKind
   * - VertexBuffer.MatricesWeightsExtraKind
   * @param bypassInstanceData defines a boolean indicating that the function should not take into account the instance data (applies only if the mesh has instances). Default: false
   * @returns a FloatArray or null if the mesh has no vertex buffer for this kind.
   */
  getVertexBuffer(e, t) {
    var i, s;
    return this._geometry ? (s = t || (i = this._userInstancedBuffersStorage) === null || i === void 0 ? void 0 : i.vertexBuffers[e]) !== null && s !== void 0 ? s : this._geometry.getVertexBuffer(e) : null;
  }
  /**
   * Tests if a specific vertex buffer is associated with this mesh
   * @param kind defines which buffer to check (positions, indices, normals, etc). Possible `kind` values :
   * - VertexBuffer.PositionKind
   * - VertexBuffer.NormalKind
   * - VertexBuffer.UVKind
   * - VertexBuffer.UV2Kind
   * - VertexBuffer.UV3Kind
   * - VertexBuffer.UV4Kind
   * - VertexBuffer.UV5Kind
   * - VertexBuffer.UV6Kind
   * - VertexBuffer.ColorKind
   * - VertexBuffer.MatricesIndicesKind
   * - VertexBuffer.MatricesIndicesExtraKind
   * - VertexBuffer.MatricesWeightsKind
   * - VertexBuffer.MatricesWeightsExtraKind
   * @param bypassInstanceData defines a boolean indicating that the function should not take into account the instance data (applies only if the mesh has instances). Default: false
   * @returns a boolean
   */
  isVerticesDataPresent(e, t) {
    var i;
    return this._geometry ? !t && ((i = this._userInstancedBuffersStorage) === null || i === void 0 ? void 0 : i.vertexBuffers[e]) !== void 0 || this._geometry.isVerticesDataPresent(e) : this._delayInfo ? this._delayInfo.indexOf(e) !== -1 : !1;
  }
  /**
   * Returns a boolean defining if the vertex data for the requested `kind` is updatable.
   * @param kind defines which buffer to check (positions, indices, normals, etc). Possible `kind` values :
   * - VertexBuffer.PositionKind
   * - VertexBuffer.UVKind
   * - VertexBuffer.UV2Kind
   * - VertexBuffer.UV3Kind
   * - VertexBuffer.UV4Kind
   * - VertexBuffer.UV5Kind
   * - VertexBuffer.UV6Kind
   * - VertexBuffer.ColorKind
   * - VertexBuffer.MatricesIndicesKind
   * - VertexBuffer.MatricesIndicesExtraKind
   * - VertexBuffer.MatricesWeightsKind
   * - VertexBuffer.MatricesWeightsExtraKind
   * @param bypassInstanceData defines a boolean indicating that the function should not take into account the instance data (applies only if the mesh has instances). Default: false
   * @returns a boolean
   */
  isVertexBufferUpdatable(e, t) {
    var i;
    if (!this._geometry)
      return this._delayInfo ? this._delayInfo.indexOf(e) !== -1 : !1;
    if (!t) {
      const s = (i = this._userInstancedBuffersStorage) === null || i === void 0 ? void 0 : i.vertexBuffers[e];
      if (s)
        return s.isUpdatable();
    }
    return this._geometry.isVertexBufferUpdatable(e);
  }
  /**
   * Returns a string which contains the list of existing `kinds` of Vertex Data associated with this mesh.
   * @param bypassInstanceData defines a boolean indicating that the function should not take into account the instance data (applies only if the mesh has instances). Default: false
   * @returns an array of strings
   */
  getVerticesDataKinds(e) {
    if (!this._geometry) {
      const i = new Array();
      return this._delayInfo && this._delayInfo.forEach(function(s) {
        i.push(s);
      }), i;
    }
    const t = this._geometry.getVerticesDataKinds();
    if (!e && this._userInstancedBuffersStorage)
      for (const i in this._userInstancedBuffersStorage.vertexBuffers)
        t.indexOf(i) === -1 && t.push(i);
    return t;
  }
  /**
   * Returns a positive integer : the total number of indices in this mesh geometry.
   * @returns the numner of indices or zero if the mesh has no geometry.
   */
  getTotalIndices() {
    return this._geometry ? this._geometry.getTotalIndices() : 0;
  }
  /**
   * Returns an array of integers or a typed array (Int32Array, Uint32Array, Uint16Array) populated with the mesh indices.
   * @param copyWhenShared If true (default false) and and if the mesh geometry is shared among some other meshes, the returned array is a copy of the internal one.
   * @param forceCopy defines a boolean indicating that the returned array must be cloned upon returning it
   * @returns the indices array or an empty array if the mesh has no geometry
   */
  getIndices(e, t) {
    return this._geometry ? this._geometry.getIndices(e, t) : [];
  }
  get isBlocked() {
    return this._masterMesh !== null && this._masterMesh !== void 0;
  }
  /**
   * Determine if the current mesh is ready to be rendered
   * @param completeCheck defines if a complete check (including materials and lights) has to be done (false by default)
   * @param forceInstanceSupport will check if the mesh will be ready when used with instances (false by default)
   * @returns true if all associated assets are ready (material, textures, shaders)
   */
  isReady(e = !1, t = !1) {
    var i, s, r, n, a, o, l;
    if (this.delayLoadState === 2 || !super.isReady(e))
      return !1;
    if (!this.subMeshes || this.subMeshes.length === 0 || !e)
      return !0;
    const c = this.getEngine(), u = this.getScene(), d = t || c.getCaps().instancedArrays && (this.instances.length > 0 || this.hasThinInstances);
    this.computeWorldMatrix();
    const f = this.material || u.defaultMaterial;
    if (f) {
      if (f._storeEffectOnSubMeshes)
        for (const g of this.subMeshes) {
          const m = g.getMaterial();
          if (m) {
            if (m._storeEffectOnSubMeshes) {
              if (!m.isReadyForSubMesh(this, g, d))
                return !1;
            } else if (!m.isReady(this, d))
              return !1;
          }
        }
      else if (!f.isReady(this, d))
        return !1;
    }
    const _ = c.currentRenderPassId;
    for (const g of this.lightSources) {
      const m = g.getShadowGenerators();
      if (!m)
        continue;
      const y = m.values();
      for (let x = y.next(); x.done !== !0; x = y.next()) {
        const A = x.value;
        if (A && (!(!((i = A.getShadowMap()) === null || i === void 0) && i.renderList) || !((s = A.getShadowMap()) === null || s === void 0) && s.renderList && ((n = (r = A.getShadowMap()) === null || r === void 0 ? void 0 : r.renderList) === null || n === void 0 ? void 0 : n.indexOf(this)) !== -1)) {
          const M = (a = A.getShadowMap().renderPassIds) !== null && a !== void 0 ? a : [c.currentRenderPassId];
          for (let b = 0; b < M.length; ++b) {
            c.currentRenderPassId = M[b];
            for (const S of this.subMeshes)
              if (!A.isReady(S, d, (l = (o = S.getMaterial()) === null || o === void 0 ? void 0 : o.needAlphaBlendingForMesh(this)) !== null && l !== void 0 ? l : !1))
                return c.currentRenderPassId = _, !1;
          }
          c.currentRenderPassId = _;
        }
      }
    }
    for (const g of this._internalMeshDataInfo._LODLevels)
      if (g.mesh && !g.mesh.isReady(d))
        return !1;
    return !0;
  }
  /**
   * Gets a boolean indicating if the normals aren't to be recomputed on next mesh `positions` array update. This property is pertinent only for updatable parametric shapes.
   */
  get areNormalsFrozen() {
    return this._internalMeshDataInfo._areNormalsFrozen;
  }
  /**
   * This function affects parametric shapes on vertex position update only : ribbons, tubes, etc. It has no effect at all on other shapes. It prevents the mesh normals from being recomputed on next `positions` array update.
   * @returns the current mesh
   */
  freezeNormals() {
    return this._internalMeshDataInfo._areNormalsFrozen = !0, this;
  }
  /**
   * This function affects parametric shapes on vertex position update only : ribbons, tubes, etc. It has no effect at all on other shapes. It reactivates the mesh normals computation if it was previously frozen
   * @returns the current mesh
   */
  unfreezeNormals() {
    return this._internalMeshDataInfo._areNormalsFrozen = !1, this;
  }
  /**
   * Sets a value overriding the instance count. Only applicable when custom instanced InterleavedVertexBuffer are used rather than InstancedMeshs
   */
  set overridenInstanceCount(e) {
    this._instanceDataStorage.overridenInstanceCount = e;
  }
  // Methods
  /** @internal */
  _preActivate() {
    const e = this._internalMeshDataInfo, t = this.getScene().getRenderId();
    return e._preActivateId === t ? this : (e._preActivateId = t, this._instanceDataStorage.visibleInstances = null, this);
  }
  /**
   * @internal
   */
  _preActivateForIntermediateRendering(e) {
    return this._instanceDataStorage.visibleInstances && (this._instanceDataStorage.visibleInstances.intermediateDefaultRenderId = e), this;
  }
  /**
   * @internal
   */
  _registerInstanceForRenderId(e, t) {
    return this._instanceDataStorage.visibleInstances || (this._instanceDataStorage.visibleInstances = {
      defaultRenderId: t,
      selfDefaultRenderId: this._renderId
    }), this._instanceDataStorage.visibleInstances[t] || (this._instanceDataStorage.previousRenderId !== void 0 && this._instanceDataStorage.isFrozen && (this._instanceDataStorage.visibleInstances[this._instanceDataStorage.previousRenderId] = null), this._instanceDataStorage.previousRenderId = t, this._instanceDataStorage.visibleInstances[t] = new Array()), this._instanceDataStorage.visibleInstances[t].push(e), this;
  }
  _afterComputeWorldMatrix() {
    super._afterComputeWorldMatrix(), this.hasThinInstances && (this.doNotSyncBoundingInfo || this.thinInstanceRefreshBoundingInfo(!1));
  }
  /** @internal */
  _postActivate() {
    this.edgesShareWithInstances && this.edgesRenderer && this.edgesRenderer.isEnabled && this._renderingGroup && (this._renderingGroup._edgesRenderers.pushNoDuplicate(this.edgesRenderer), this.edgesRenderer.customInstances.push(this.getWorldMatrix()));
  }
  /**
   * This method recomputes and sets a new BoundingInfo to the mesh unless it is locked.
   * This means the mesh underlying bounding box and sphere are recomputed.
   * @param applySkeleton defines whether to apply the skeleton before computing the bounding info
   * @param applyMorph  defines whether to apply the morph target before computing the bounding info
   * @returns the current mesh
   */
  refreshBoundingInfo(e = !1, t = !1) {
    if (this.hasBoundingInfo && this.getBoundingInfo().isLocked)
      return this;
    const i = this.geometry ? this.geometry.boundingBias : null;
    return this._refreshBoundingInfo(this._getPositionData(e, t), i), this;
  }
  /**
   * @internal
   */
  _createGlobalSubMesh(e) {
    const t = this.getTotalVertices();
    if (!t || !this.getIndices())
      return null;
    if (this.subMeshes && this.subMeshes.length > 0) {
      const i = this.getIndices();
      if (!i)
        return null;
      const s = i.length;
      let r = !1;
      if (e)
        r = !0;
      else
        for (const n of this.subMeshes) {
          if (n.indexStart + n.indexCount > s) {
            r = !0;
            break;
          }
          if (n.verticesStart + n.verticesCount > t) {
            r = !0;
            break;
          }
        }
      if (!r)
        return this.subMeshes[0];
    }
    return this.releaseSubMeshes(), new Qt(0, 0, t, 0, this.getTotalIndices(), this);
  }
  /**
   * This function will subdivide the mesh into multiple submeshes
   * @param count defines the expected number of submeshes
   */
  subdivide(e) {
    if (e < 1)
      return;
    const t = this.getTotalIndices();
    let i = t / e | 0, s = 0;
    for (; i % 3 !== 0; )
      i++;
    this.releaseSubMeshes();
    for (let r = 0; r < e && !(s >= t); r++)
      Qt.CreateFromIndices(0, s, r === e - 1 ? t - s : i, this, void 0, !1), s += i;
    this.refreshBoundingInfo(), this.synchronizeInstances();
  }
  /**
   * Copy a FloatArray into a specific associated vertex buffer
   * @param kind defines which buffer to write to (positions, indices, normals, etc). Possible `kind` values :
   * - VertexBuffer.PositionKind
   * - VertexBuffer.UVKind
   * - VertexBuffer.UV2Kind
   * - VertexBuffer.UV3Kind
   * - VertexBuffer.UV4Kind
   * - VertexBuffer.UV5Kind
   * - VertexBuffer.UV6Kind
   * - VertexBuffer.ColorKind
   * - VertexBuffer.MatricesIndicesKind
   * - VertexBuffer.MatricesIndicesExtraKind
   * - VertexBuffer.MatricesWeightsKind
   * - VertexBuffer.MatricesWeightsExtraKind
   * @param data defines the data source
   * @param updatable defines if the updated vertex buffer must be flagged as updatable
   * @param stride defines the data stride size (can be null)
   * @returns the current mesh
   */
  setVerticesData(e, t, i = !1, s) {
    if (this._geometry)
      this._geometry.setVerticesData(e, t, i, s);
    else {
      const r = new q();
      r.set(t, e);
      const n = this.getScene();
      new Ct(Ct.RandomId(), n, r, i, this);
    }
    return this;
  }
  /**
   * Delete a vertex buffer associated with this mesh
   * @param kind defines which buffer to delete (positions, indices, normals, etc). Possible `kind` values :
   * - VertexBuffer.PositionKind
   * - VertexBuffer.UVKind
   * - VertexBuffer.UV2Kind
   * - VertexBuffer.UV3Kind
   * - VertexBuffer.UV4Kind
   * - VertexBuffer.UV5Kind
   * - VertexBuffer.UV6Kind
   * - VertexBuffer.ColorKind
   * - VertexBuffer.MatricesIndicesKind
   * - VertexBuffer.MatricesIndicesExtraKind
   * - VertexBuffer.MatricesWeightsKind
   * - VertexBuffer.MatricesWeightsExtraKind
   */
  removeVerticesData(e) {
    this._geometry && this._geometry.removeVerticesData(e);
  }
  /**
   * Flags an associated vertex buffer as updatable
   * @param kind defines which buffer to use (positions, indices, normals, etc). Possible `kind` values :
   * - VertexBuffer.PositionKind
   * - VertexBuffer.UVKind
   * - VertexBuffer.UV2Kind
   * - VertexBuffer.UV3Kind
   * - VertexBuffer.UV4Kind
   * - VertexBuffer.UV5Kind
   * - VertexBuffer.UV6Kind
   * - VertexBuffer.ColorKind
   * - VertexBuffer.MatricesIndicesKind
   * - VertexBuffer.MatricesIndicesExtraKind
   * - VertexBuffer.MatricesWeightsKind
   * - VertexBuffer.MatricesWeightsExtraKind
   * @param updatable defines if the updated vertex buffer must be flagged as updatable
   */
  markVerticesDataAsUpdatable(e, t = !0) {
    const i = this.getVertexBuffer(e);
    !i || i.isUpdatable() === t || this.setVerticesData(e, this.getVerticesData(e), t);
  }
  /**
   * Sets the mesh global Vertex Buffer
   * @param buffer defines the buffer to use
   * @param disposeExistingBuffer disposes the existing buffer, if any (default: true)
   * @returns the current mesh
   */
  setVerticesBuffer(e, t = !0) {
    return this._geometry || (this._geometry = Ct.CreateGeometryForMesh(this)), this._geometry.setVerticesBuffer(e, null, t), this;
  }
  /**
   * Update a specific associated vertex buffer
   * @param kind defines which buffer to write to (positions, indices, normals, etc). Possible `kind` values :
   * - VertexBuffer.PositionKind
   * - VertexBuffer.UVKind
   * - VertexBuffer.UV2Kind
   * - VertexBuffer.UV3Kind
   * - VertexBuffer.UV4Kind
   * - VertexBuffer.UV5Kind
   * - VertexBuffer.UV6Kind
   * - VertexBuffer.ColorKind
   * - VertexBuffer.MatricesIndicesKind
   * - VertexBuffer.MatricesIndicesExtraKind
   * - VertexBuffer.MatricesWeightsKind
   * - VertexBuffer.MatricesWeightsExtraKind
   * @param data defines the data source
   * @param updateExtends defines if extends info of the mesh must be updated (can be null). This is mostly useful for "position" kind
   * @param makeItUnique defines if the geometry associated with the mesh must be cloned to make the change only for this mesh (and not all meshes associated with the same geometry)
   * @returns the current mesh
   */
  updateVerticesData(e, t, i, s) {
    return this._geometry ? (s ? (this.makeGeometryUnique(), this.updateVerticesData(e, t, i, !1)) : this._geometry.updateVerticesData(e, t, i), this) : this;
  }
  /**
   * This method updates the vertex positions of an updatable mesh according to the `positionFunction` returned values.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/dynamicMeshMorph#other-shapes-updatemeshpositions
   * @param positionFunction is a simple JS function what is passed the mesh `positions` array. It doesn't need to return anything
   * @param computeNormals is a boolean (default true) to enable/disable the mesh normal recomputation after the vertex position update
   * @returns the current mesh
   */
  updateMeshPositions(e, t = !0) {
    const i = this.getVerticesData(v.PositionKind);
    if (!i)
      return this;
    if (e(i), this.updateVerticesData(v.PositionKind, i, !1, !1), t) {
      const s = this.getIndices(), r = this.getVerticesData(v.NormalKind);
      if (!r)
        return this;
      q.ComputeNormals(i, s, r), this.updateVerticesData(v.NormalKind, r, !1, !1);
    }
    return this;
  }
  /**
   * Creates a un-shared specific occurence of the geometry for the mesh.
   * @returns the current mesh
   */
  makeGeometryUnique() {
    if (!this._geometry)
      return this;
    if (this._geometry.meshes.length === 1)
      return this;
    const e = this._geometry, t = this._geometry.copy(Ct.RandomId());
    return e.releaseForMesh(this, !0), t.applyToMesh(this), this;
  }
  /**
   * Set the index buffer of this mesh
   * @param indices defines the source data
   * @param totalVertices defines the total number of vertices referenced by this index data (can be null)
   * @param updatable defines if the updated index buffer must be flagged as updatable (default is false)
   * @returns the current mesh
   */
  setIndices(e, t = null, i = !1) {
    if (this._geometry)
      this._geometry.setIndices(e, t, i);
    else {
      const s = new q();
      s.indices = e;
      const r = this.getScene();
      new Ct(Ct.RandomId(), r, s, i, this);
    }
    return this;
  }
  /**
   * Update the current index buffer
   * @param indices defines the source data
   * @param offset defines the offset in the index buffer where to store the new data (can be null)
   * @param gpuMemoryOnly defines a boolean indicating that only the GPU memory must be updated leaving the CPU version of the indices unchanged (false by default)
   * @returns the current mesh
   */
  updateIndices(e, t, i = !1) {
    return this._geometry ? (this._geometry.updateIndices(e, t, i), this) : this;
  }
  /**
   * Invert the geometry to move from a right handed system to a left handed one.
   * @returns the current mesh
   */
  toLeftHanded() {
    return this._geometry ? (this._geometry.toLeftHanded(), this) : this;
  }
  /**
   * @internal
   */
  _bind(e, t, i, s = !0) {
    if (!this._geometry)
      return this;
    const r = this.getScene().getEngine();
    this.morphTargetManager && this.morphTargetManager.isUsingTextureForTargets && this.morphTargetManager._bind(t);
    let n;
    if (this._unIndexed)
      n = null;
    else
      switch (this._getRenderingFillMode(i)) {
        case F.PointFillMode:
          n = null;
          break;
        case F.WireFrameFillMode:
          n = e._getLinesIndexBuffer(this.getIndices(), r);
          break;
        default:
        case F.TriangleFillMode:
          n = this._geometry.getIndexBuffer();
          break;
      }
    return !s || !this._userInstancedBuffersStorage || this.hasThinInstances ? this._geometry._bind(t, n) : this._geometry._bind(t, n, this._userInstancedBuffersStorage.vertexBuffers, this._userInstancedBuffersStorage.vertexArrayObjects), this;
  }
  /**
   * @internal
   */
  _draw(e, t, i) {
    if (!this._geometry || !this._geometry.getVertexBuffers() || !this._unIndexed && !this._geometry.getIndexBuffer())
      return this;
    this._internalMeshDataInfo._onBeforeDrawObservable && this._internalMeshDataInfo._onBeforeDrawObservable.notifyObservers(this);
    const r = this.getScene().getEngine();
    return this._unIndexed || t == F.PointFillMode ? r.drawArraysType(t, e.verticesStart, e.verticesCount, this.forcedInstanceCount || i) : t == F.WireFrameFillMode ? r.drawElementsType(t, 0, e._linesIndexCount, this.forcedInstanceCount || i) : r.drawElementsType(t, e.indexStart, e.indexCount, this.forcedInstanceCount || i), this;
  }
  /**
   * Registers for this mesh a javascript function called just before the rendering process
   * @param func defines the function to call before rendering this mesh
   * @returns the current mesh
   */
  registerBeforeRender(e) {
    return this.onBeforeRenderObservable.add(e), this;
  }
  /**
   * Disposes a previously registered javascript function called before the rendering
   * @param func defines the function to remove
   * @returns the current mesh
   */
  unregisterBeforeRender(e) {
    return this.onBeforeRenderObservable.removeCallback(e), this;
  }
  /**
   * Registers for this mesh a javascript function called just after the rendering is complete
   * @param func defines the function to call after rendering this mesh
   * @returns the current mesh
   */
  registerAfterRender(e) {
    return this.onAfterRenderObservable.add(e), this;
  }
  /**
   * Disposes a previously registered javascript function called after the rendering.
   * @param func defines the function to remove
   * @returns the current mesh
   */
  unregisterAfterRender(e) {
    return this.onAfterRenderObservable.removeCallback(e), this;
  }
  /**
   * @internal
   */
  _getInstancesRenderList(e, t = !1) {
    if (this._instanceDataStorage.isFrozen) {
      if (t)
        return this._instanceDataStorage.batchCacheReplacementModeInFrozenMode.hardwareInstancedRendering[e] = !1, this._instanceDataStorage.batchCacheReplacementModeInFrozenMode.renderSelf[e] = !0, this._instanceDataStorage.batchCacheReplacementModeInFrozenMode;
      if (this._instanceDataStorage.previousBatch)
        return this._instanceDataStorage.previousBatch;
    }
    const i = this.getScene(), s = i._isInIntermediateRendering(), r = s ? this._internalAbstractMeshDataInfo._onlyForInstancesIntermediate : this._internalAbstractMeshDataInfo._onlyForInstances, n = this._instanceDataStorage.batchCache;
    if (n.mustReturn = !1, n.renderSelf[e] = t || !r && this.isEnabled() && this.isVisible, n.visibleInstances[e] = null, this._instanceDataStorage.visibleInstances && !t) {
      const a = this._instanceDataStorage.visibleInstances, o = i.getRenderId(), l = s ? a.intermediateDefaultRenderId : a.defaultRenderId;
      n.visibleInstances[e] = a[o], !n.visibleInstances[e] && l && (n.visibleInstances[e] = a[l]);
    }
    return n.hardwareInstancedRendering[e] = !t && this._instanceDataStorage.hardwareInstancedRendering && n.visibleInstances[e] !== null && n.visibleInstances[e] !== void 0, this._instanceDataStorage.previousBatch = n, n;
  }
  /**
   * @internal
   */
  _renderWithInstances(e, t, i, s, r) {
    var n;
    const a = i.visibleInstances[e._id], o = a ? a.length : 0, l = this._instanceDataStorage, c = l.instancesBufferSize;
    let u = l.instancesBuffer, d = l.instancesPreviousBuffer;
    const _ = (o + 1) * 16 * 4;
    for (; l.instancesBufferSize < _; )
      l.instancesBufferSize *= 2;
    (!l.instancesData || c != l.instancesBufferSize) && (l.instancesData = new Float32Array(l.instancesBufferSize / 4)), (this._scene.needsPreviousWorldMatrices && !l.instancesPreviousData || c != l.instancesBufferSize) && (l.instancesPreviousData = new Float32Array(l.instancesBufferSize / 4));
    let g = 0, m = 0;
    const y = i.renderSelf[e._id], x = !u || c !== l.instancesBufferSize || this._scene.needsPreviousWorldMatrices && !l.instancesPreviousBuffer;
    if (!this._instanceDataStorage.manualUpdate && (!l.isFrozen || x)) {
      const A = this.getWorldMatrix();
      if (y && (this._scene.needsPreviousWorldMatrices && (l.masterMeshPreviousWorldMatrix ? (l.masterMeshPreviousWorldMatrix.copyToArray(l.instancesPreviousData, g), l.masterMeshPreviousWorldMatrix.copyFrom(A)) : (l.masterMeshPreviousWorldMatrix = A.clone(), l.masterMeshPreviousWorldMatrix.copyToArray(l.instancesPreviousData, g))), A.copyToArray(l.instancesData, g), g += 16, m++), a) {
        if (K.INSTANCEDMESH_SORT_TRANSPARENT && this._scene.activeCamera && (!((n = e.getMaterial()) === null || n === void 0) && n.needAlphaBlendingForMesh(e.getRenderingMesh()))) {
          const T = this._scene.activeCamera.globalPosition;
          for (let M = 0; M < a.length; M++) {
            const b = a[M];
            b._distanceToCamera = p.Distance(b.getBoundingInfo().boundingSphere.centerWorld, T);
          }
          a.sort((M, b) => M._distanceToCamera > b._distanceToCamera ? -1 : M._distanceToCamera < b._distanceToCamera ? 1 : 0);
        }
        for (let T = 0; T < a.length; T++) {
          const M = a[T], b = M.getWorldMatrix();
          b.copyToArray(l.instancesData, g), this._scene.needsPreviousWorldMatrices && (M._previousWorldMatrix ? (M._previousWorldMatrix.copyToArray(l.instancesPreviousData, g), M._previousWorldMatrix.copyFrom(b)) : (M._previousWorldMatrix = b.clone(), M._previousWorldMatrix.copyToArray(l.instancesPreviousData, g))), g += 16, m++;
        }
      }
    } else
      m = (y ? 1 : 0) + o;
    return x ? (u && u.dispose(), d && d.dispose(), u = new gs(r, l.instancesData, !0, 16, !1, !0), l.instancesBuffer = u, this._userInstancedBuffersStorage || (this._userInstancedBuffersStorage = {
      data: {},
      vertexBuffers: {},
      strides: {},
      sizes: {},
      vertexArrayObjects: this.getEngine().getCaps().vertexArrayObject ? {} : void 0
    }), this._userInstancedBuffersStorage.vertexBuffers.world0 = u.createVertexBuffer("world0", 0, 4), this._userInstancedBuffersStorage.vertexBuffers.world1 = u.createVertexBuffer("world1", 4, 4), this._userInstancedBuffersStorage.vertexBuffers.world2 = u.createVertexBuffer("world2", 8, 4), this._userInstancedBuffersStorage.vertexBuffers.world3 = u.createVertexBuffer("world3", 12, 4), this._scene.needsPreviousWorldMatrices && (d = new gs(r, l.instancesPreviousData, !0, 16, !1, !0), l.instancesPreviousBuffer = d, this._userInstancedBuffersStorage.vertexBuffers.previousWorld0 = d.createVertexBuffer("previousWorld0", 0, 4), this._userInstancedBuffersStorage.vertexBuffers.previousWorld1 = d.createVertexBuffer("previousWorld1", 4, 4), this._userInstancedBuffersStorage.vertexBuffers.previousWorld2 = d.createVertexBuffer("previousWorld2", 8, 4), this._userInstancedBuffersStorage.vertexBuffers.previousWorld3 = d.createVertexBuffer("previousWorld3", 12, 4)), this._invalidateInstanceVertexArrayObject()) : (!this._instanceDataStorage.isFrozen || this._instanceDataStorage.forceMatrixUpdates) && (u.updateDirectly(l.instancesData, 0, m), this._scene.needsPreviousWorldMatrices && (!this._instanceDataStorage.manualUpdate || this._instanceDataStorage.previousManualUpdate) && d.updateDirectly(l.instancesPreviousData, 0, m)), this._processInstancedBuffers(a, y), this.getScene()._activeIndices.addCount(e.indexCount * m, !1), r._currentDrawContext && (r._currentDrawContext.useInstancing = !0), this._bind(e, s, t), this._draw(e, t, m), this._scene.needsPreviousWorldMatrices && !x && this._instanceDataStorage.manualUpdate && (!this._instanceDataStorage.isFrozen || this._instanceDataStorage.forceMatrixUpdates) && !this._instanceDataStorage.previousManualUpdate && d.updateDirectly(l.instancesData, 0, m), r.unbindInstanceAttributes(), this;
  }
  /**
   * @internal
   */
  _renderWithThinInstances(e, t, i, s) {
    var r, n;
    const a = (n = (r = this._thinInstanceDataStorage) === null || r === void 0 ? void 0 : r.instancesCount) !== null && n !== void 0 ? n : 0;
    this.getScene()._activeIndices.addCount(e.indexCount * a, !1), s._currentDrawContext && (s._currentDrawContext.useInstancing = !0), this._bind(e, i, t), this._draw(e, t, a), this._scene.needsPreviousWorldMatrices && !this._thinInstanceDataStorage.previousMatrixData && this._thinInstanceDataStorage.matrixData && (this._thinInstanceDataStorage.previousMatrixBuffer ? this._thinInstanceDataStorage.previousMatrixBuffer.updateDirectly(this._thinInstanceDataStorage.matrixData, 0, a) : this._thinInstanceDataStorage.previousMatrixBuffer = this._thinInstanceCreateMatrixBuffer("previousWorld", this._thinInstanceDataStorage.matrixData, !1)), s.unbindInstanceAttributes();
  }
  /**
   * @internal
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _processInstancedBuffers(e, t) {
  }
  /**
   * @internal
   */
  _processRendering(e, t, i, s, r, n, a, o) {
    const l = this.getScene(), c = l.getEngine();
    if (s = this._getRenderingFillMode(s), n && t.getRenderingMesh().hasThinInstances)
      return this._renderWithThinInstances(t, s, i, c), this;
    if (n)
      this._renderWithInstances(t, s, r, i, c);
    else {
      c._currentDrawContext && (c._currentDrawContext.useInstancing = !1);
      let u = 0;
      r.renderSelf[t._id] && (a && a(!1, e.getWorldMatrix(), o), u++, this._draw(t, s, this._instanceDataStorage.overridenInstanceCount));
      const d = r.visibleInstances[t._id];
      if (d) {
        const f = d.length;
        u += f;
        for (let _ = 0; _ < f; _++) {
          const m = d[_].getWorldMatrix();
          a && a(!0, m, o), this._draw(t, s);
        }
      }
      l._activeIndices.addCount(t.indexCount * u, !1);
    }
    return this;
  }
  /**
   * @internal
   */
  _rebuild(e = !1) {
    if (this._instanceDataStorage.instancesBuffer && (e && this._instanceDataStorage.instancesBuffer.dispose(), this._instanceDataStorage.instancesBuffer = null), this._userInstancedBuffersStorage) {
      for (const t in this._userInstancedBuffersStorage.vertexBuffers) {
        const i = this._userInstancedBuffersStorage.vertexBuffers[t];
        i && (e && i.dispose(), this._userInstancedBuffersStorage.vertexBuffers[t] = null);
      }
      this._userInstancedBuffersStorage.vertexArrayObjects && (this._userInstancedBuffersStorage.vertexArrayObjects = {});
    }
    this._internalMeshDataInfo._effectiveMaterial = null, super._rebuild(e);
  }
  /** @internal */
  _freeze() {
    if (this.subMeshes) {
      for (let e = 0; e < this.subMeshes.length; e++)
        this._getInstancesRenderList(e);
      this._internalMeshDataInfo._effectiveMaterial = null, this._instanceDataStorage.isFrozen = !0;
    }
  }
  /** @internal */
  _unFreeze() {
    this._instanceDataStorage.isFrozen = !1, this._instanceDataStorage.previousBatch = null;
  }
  /**
   * Triggers the draw call for the mesh. Usually, you don't need to call this method by your own because the mesh rendering is handled by the scene rendering manager
   * @param subMesh defines the subMesh to render
   * @param enableAlphaMode defines if alpha mode can be changed
   * @param effectiveMeshReplacement defines an optional mesh used to provide info for the rendering
   * @returns the current mesh
   */
  render(e, t, i) {
    var s, r, n;
    const a = this.getScene();
    if (this._internalAbstractMeshDataInfo._isActiveIntermediate ? this._internalAbstractMeshDataInfo._isActiveIntermediate = !1 : this._internalAbstractMeshDataInfo._isActive = !1, this._checkOcclusionQuery() && !this._occlusionDataStorage.forceRenderingWhenOccluded)
      return this;
    const o = this._getInstancesRenderList(e._id, !!i);
    if (o.mustReturn)
      return this;
    if (!this._geometry || !this._geometry.getVertexBuffers() || !this._unIndexed && !this._geometry.getIndexBuffer())
      return this;
    const l = a.getEngine();
    let c = 0, u = null;
    this.ignoreCameraMaxZ && a.activeCamera && !a._isInIntermediateRendering() && (c = a.activeCamera.maxZ, u = a.activeCamera, a.activeCamera.maxZ = 0, a.updateTransformMatrix(!0)), this._internalMeshDataInfo._onBeforeRenderObservable && this._internalMeshDataInfo._onBeforeRenderObservable.notifyObservers(this);
    const d = e.getRenderingMesh(), f = o.hardwareInstancedRendering[e._id] || d.hasThinInstances || !!this._userInstancedBuffersStorage && !e.getMesh()._internalAbstractMeshDataInfo._actAsRegularMesh, _ = this._instanceDataStorage, g = e.getMaterial();
    if (!g)
      return u && (u.maxZ = c, a.updateTransformMatrix(!0)), this;
    if (!_.isFrozen || !this._internalMeshDataInfo._effectiveMaterial || this._internalMeshDataInfo._effectiveMaterial !== g) {
      if (g._storeEffectOnSubMeshes) {
        if (!g.isReadyForSubMesh(this, e, f))
          return u && (u.maxZ = c, a.updateTransformMatrix(!0)), this;
      } else if (!g.isReady(this, f))
        return u && (u.maxZ = c, a.updateTransformMatrix(!0)), this;
      this._internalMeshDataInfo._effectiveMaterial = g;
    } else if (g._storeEffectOnSubMeshes && !(!((s = e.effect) === null || s === void 0) && s._wasPreviouslyReady) || !g._storeEffectOnSubMeshes && !(!((r = g.getEffect()) === null || r === void 0) && r._wasPreviouslyReady))
      return u && (u.maxZ = c, a.updateTransformMatrix(!0)), this;
    t && l.setAlphaMode(this._internalMeshDataInfo._effectiveMaterial.alphaMode);
    let m;
    this._internalMeshDataInfo._effectiveMaterial._storeEffectOnSubMeshes ? m = e._drawWrapper : m = this._internalMeshDataInfo._effectiveMaterial._getDrawWrapper();
    const y = (n = m == null ? void 0 : m.effect) !== null && n !== void 0 ? n : null;
    for (const P of a._beforeRenderingMeshStage)
      P.action(this, e, o, y);
    if (!m || !y)
      return u && (u.maxZ = c, a.updateTransformMatrix(!0)), this;
    const x = i || this;
    let A;
    if (!_.isFrozen && (this._internalMeshDataInfo._effectiveMaterial.backFaceCulling || this.overrideMaterialSideOrientation !== null)) {
      const P = x._getWorldMatrixDeterminant();
      A = this.overrideMaterialSideOrientation, A == null && (A = this._internalMeshDataInfo._effectiveMaterial.sideOrientation), P < 0 && (A = A === F.ClockWiseSideOrientation ? F.CounterClockWiseSideOrientation : F.ClockWiseSideOrientation), _.sideOrientation = A;
    } else
      A = _.sideOrientation;
    const T = this._internalMeshDataInfo._effectiveMaterial._preBind(m, A);
    this._internalMeshDataInfo._effectiveMaterial.forceDepthWrite && l.setDepthWrite(!0);
    const M = this._internalMeshDataInfo._effectiveMaterial, b = M.fillMode;
    this._internalMeshDataInfo._onBeforeBindObservable && this._internalMeshDataInfo._onBeforeBindObservable.notifyObservers(this), f || this._bind(e, y, b, !1);
    const S = x.getWorldMatrix();
    M._storeEffectOnSubMeshes ? M.bindForSubMesh(S, this, e) : M.bind(S, this), !M.backFaceCulling && M.separateCullingPass && (l.setState(!0, M.zOffset, !1, !T, M.cullBackFaces, M.stencil, M.zOffsetUnits), this._processRendering(this, e, y, b, o, f, this._onBeforeDraw, this._internalMeshDataInfo._effectiveMaterial), l.setState(!0, M.zOffset, !1, T, M.cullBackFaces, M.stencil, M.zOffsetUnits), this._internalMeshDataInfo._onBetweenPassObservable && this._internalMeshDataInfo._onBetweenPassObservable.notifyObservers(e)), this._processRendering(this, e, y, b, o, f, this._onBeforeDraw, this._internalMeshDataInfo._effectiveMaterial), this._internalMeshDataInfo._effectiveMaterial.unbind();
    for (const P of a._afterRenderingMeshStage)
      P.action(this, e, o, y);
    return this._internalMeshDataInfo._onAfterRenderObservable && this._internalMeshDataInfo._onAfterRenderObservable.notifyObservers(this), u && (u.maxZ = c, a.updateTransformMatrix(!0)), a.performancePriority === ui.Aggressive && !_.isFrozen && this._freeze(), this;
  }
  /**
   *   Renormalize the mesh and patch it up if there are no weights
   *   Similar to normalization by adding the weights compute the reciprocal and multiply all elements, this wil ensure that everything adds to 1.
   *   However in the case of zero weights then we set just a single influence to 1.
   *   We check in the function for extra's present and if so we use the normalizeSkinWeightsWithExtras rather than the FourWeights version.
   */
  cleanMatrixWeights() {
    this.isVerticesDataPresent(v.MatricesWeightsKind) && (this.isVerticesDataPresent(v.MatricesWeightsExtraKind) ? this._normalizeSkinWeightsAndExtra() : this._normalizeSkinFourWeights());
  }
  // faster 4 weight version.
  _normalizeSkinFourWeights() {
    const e = this.getVerticesData(v.MatricesWeightsKind), t = e.length;
    for (let i = 0; i < t; i += 4) {
      const s = e[i] + e[i + 1] + e[i + 2] + e[i + 3];
      if (s === 0)
        e[i] = 1;
      else {
        const r = 1 / s;
        e[i] *= r, e[i + 1] *= r, e[i + 2] *= r, e[i + 3] *= r;
      }
    }
    this.setVerticesData(v.MatricesWeightsKind, e);
  }
  // handle special case of extra verts.  (in theory gltf can handle 12 influences)
  _normalizeSkinWeightsAndExtra() {
    const e = this.getVerticesData(v.MatricesWeightsExtraKind), t = this.getVerticesData(v.MatricesWeightsKind), i = t.length;
    for (let s = 0; s < i; s += 4) {
      let r = t[s] + t[s + 1] + t[s + 2] + t[s + 3];
      if (r += e[s] + e[s + 1] + e[s + 2] + e[s + 3], r === 0)
        t[s] = 1;
      else {
        const n = 1 / r;
        t[s] *= n, t[s + 1] *= n, t[s + 2] *= n, t[s + 3] *= n, e[s] *= n, e[s + 1] *= n, e[s + 2] *= n, e[s + 3] *= n;
      }
    }
    this.setVerticesData(v.MatricesWeightsKind, t), this.setVerticesData(v.MatricesWeightsKind, e);
  }
  /**
   * ValidateSkinning is used to determine that a mesh has valid skinning data along with skin metrics, if missing weights,
   * or not normalized it is returned as invalid mesh the string can be used for console logs, or on screen messages to let
   * the user know there was an issue with importing the mesh
   * @returns a validation object with skinned, valid and report string
   */
  validateSkinning() {
    const e = this.getVerticesData(v.MatricesWeightsExtraKind), t = this.getVerticesData(v.MatricesWeightsKind);
    if (t === null || this.skeleton == null)
      return { skinned: !1, valid: !0, report: "not skinned" };
    const i = t.length;
    let s = 0, r = 0, n = 0, a = 0;
    const o = e === null ? 4 : 8, l = new Array();
    for (let m = 0; m <= o; m++)
      l[m] = 0;
    const c = 1e-3;
    for (let m = 0; m < i; m += 4) {
      let y = t[m], x = y, A = x === 0 ? 0 : 1;
      for (let T = 1; T < o; T++) {
        const M = T < 4 ? t[m + T] : e[m + T - 4];
        M > y && s++, M !== 0 && A++, x += M, y = M;
      }
      if (l[A]++, A > n && (n = A), x === 0)
        r++;
      else {
        const T = 1 / x;
        let M = 0;
        for (let b = 0; b < o; b++)
          b < 4 ? M += Math.abs(t[m + b] - t[m + b] * T) : M += Math.abs(e[m + b - 4] - e[m + b - 4] * T);
        M > c && a++;
      }
    }
    const u = this.skeleton.bones.length, d = this.getVerticesData(v.MatricesIndicesKind), f = this.getVerticesData(v.MatricesIndicesExtraKind);
    let _ = 0;
    for (let m = 0; m < i; m += 4)
      for (let y = 0; y < o; y++) {
        const x = y < 4 ? d[m + y] : f[m + y - 4];
        (x >= u || x < 0) && _++;
      }
    const g = "Number of Weights = " + i / 4 + `
Maximum influences = ` + n + `
Missing Weights = ` + r + `
Not Sorted = ` + s + `
Not Normalized = ` + a + `
WeightCounts = [` + l + `]
Number of bones = ` + u + `
Bad Bone Indices = ` + _;
    return { skinned: !0, valid: r === 0 && a === 0 && _ === 0, report: g };
  }
  /** @internal */
  _checkDelayState() {
    const e = this.getScene();
    return this._geometry ? this._geometry.load(e) : this.delayLoadState === 4 && (this.delayLoadState = 2, this._queueLoad(e)), this;
  }
  _queueLoad(e) {
    e.addPendingData(this);
    const t = this.delayLoadingFile.indexOf(".babylonbinarymeshdata") !== -1;
    return z.LoadFile(this.delayLoadingFile, (i) => {
      i instanceof ArrayBuffer ? this._delayLoadingFunction(i, this) : this._delayLoadingFunction(JSON.parse(i), this), this.instances.forEach((s) => {
        s.refreshBoundingInfo(), s._syncSubMeshes();
      }), this.delayLoadState = 1, e.removePendingData(this);
    }, () => {
    }, e.offlineProvider, t), this;
  }
  /**
   * Returns `true` if the mesh is within the frustum defined by the passed array of planes.
   * A mesh is in the frustum if its bounding box intersects the frustum
   * @param frustumPlanes defines the frustum to test
   * @returns true if the mesh is in the frustum planes
   */
  isInFrustum(e) {
    return this.delayLoadState === 2 || !super.isInFrustum(e) ? !1 : (this._checkDelayState(), !0);
  }
  /**
   * Sets the mesh material by the material or multiMaterial `id` property
   * @param id is a string identifying the material or the multiMaterial
   * @returns the current mesh
   */
  setMaterialById(e) {
    const t = this.getScene().materials;
    let i;
    for (i = t.length - 1; i > -1; i--)
      if (t[i].id === e)
        return this.material = t[i], this;
    const s = this.getScene().multiMaterials;
    for (i = s.length - 1; i > -1; i--)
      if (s[i].id === e)
        return this.material = s[i], this;
    return this;
  }
  /**
   * Returns as a new array populated with the mesh material and/or skeleton, if any.
   * @returns an array of IAnimatable
   */
  getAnimatables() {
    const e = new Array();
    return this.material && e.push(this.material), this.skeleton && e.push(this.skeleton), e;
  }
  /**
   * Modifies the mesh geometry according to the passed transformation matrix.
   * This method returns nothing, but it really modifies the mesh even if it's originally not set as updatable.
   * The mesh normals are modified using the same transformation.
   * Note that, under the hood, this method sets a new VertexBuffer each call.
   * @param transform defines the transform matrix to use
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/center_origin/bakingTransforms
   * @returns the current mesh
   */
  bakeTransformIntoVertices(e) {
    if (!this.isVerticesDataPresent(v.PositionKind))
      return this;
    const t = this.subMeshes.splice(0);
    this._resetPointsArrayCache();
    let i = this.getVerticesData(v.PositionKind);
    const s = p.Zero();
    let r;
    for (r = 0; r < i.length; r += 3)
      p.TransformCoordinatesFromFloatsToRef(i[r], i[r + 1], i[r + 2], e, s).toArray(i, r);
    if (this.setVerticesData(v.PositionKind, i, this.getVertexBuffer(v.PositionKind).isUpdatable()), this.isVerticesDataPresent(v.NormalKind)) {
      for (i = this.getVerticesData(v.NormalKind), r = 0; r < i.length; r += 3)
        p.TransformNormalFromFloatsToRef(i[r], i[r + 1], i[r + 2], e, s).normalize().toArray(i, r);
      this.setVerticesData(v.NormalKind, i, this.getVertexBuffer(v.NormalKind).isUpdatable());
    }
    return e.determinant() < 0 && this.flipFaces(), this.releaseSubMeshes(), this.subMeshes = t, this;
  }
  /**
   * Modifies the mesh geometry according to its own current World Matrix.
   * The mesh World Matrix is then reset.
   * This method returns nothing but really modifies the mesh even if it's originally not set as updatable.
   * Note that, under the hood, this method sets a new VertexBuffer each call.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/center_origin/bakingTransforms
   * @param bakeIndependentlyOfChildren indicates whether to preserve all child nodes' World Matrix during baking
   * @returns the current mesh
   */
  bakeCurrentTransformIntoVertices(e = !0) {
    return this.bakeTransformIntoVertices(this.computeWorldMatrix(!0)), this.resetLocalMatrix(e), this;
  }
  // Cache
  /** @internal */
  get _positions() {
    return this._internalAbstractMeshDataInfo._positions ? this._internalAbstractMeshDataInfo._positions : this._geometry ? this._geometry._positions : null;
  }
  /** @internal */
  _resetPointsArrayCache() {
    return this._geometry && this._geometry._resetPointsArrayCache(), this;
  }
  /** @internal */
  _generatePointsArray() {
    return this._geometry ? this._geometry._generatePointsArray() : !1;
  }
  /**
   * Returns a new Mesh object generated from the current mesh properties.
   * This method must not get confused with createInstance()
   * @param name is a string, the name given to the new mesh
   * @param newParent can be any Node object (default `null`)
   * @param doNotCloneChildren allows/denies the recursive cloning of the original mesh children if any (default `false`)
   * @param clonePhysicsImpostor allows/denies the cloning in the same time of the original mesh `body` used by the physics engine, if any (default `true`)
   * @returns a new mesh
   */
  clone(e = "", t = null, i, s = !0) {
    return new K(e, this.getScene(), t, this, i, s);
  }
  /**
   * Releases resources associated with this mesh.
   * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
   * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
   */
  dispose(e, t = !1) {
    this.morphTargetManager = null, this._geometry && this._geometry.releaseForMesh(this, !0);
    const i = this._internalMeshDataInfo;
    if (i._onBeforeDrawObservable && i._onBeforeDrawObservable.clear(), i._onBeforeBindObservable && i._onBeforeBindObservable.clear(), i._onBeforeRenderObservable && i._onBeforeRenderObservable.clear(), i._onAfterRenderObservable && i._onAfterRenderObservable.clear(), i._onBetweenPassObservable && i._onBetweenPassObservable.clear(), this._scene.useClonedMeshMap) {
      if (i.meshMap)
        for (const s in i.meshMap) {
          const r = i.meshMap[s];
          r && (r._internalMeshDataInfo._source = null, i.meshMap[s] = void 0);
        }
      i._source && i._source._internalMeshDataInfo.meshMap && (i._source._internalMeshDataInfo.meshMap[this.uniqueId] = void 0);
    } else {
      const s = this.getScene().meshes;
      for (const r of s) {
        const n = r;
        n._internalMeshDataInfo && n._internalMeshDataInfo._source && n._internalMeshDataInfo._source === this && (n._internalMeshDataInfo._source = null);
      }
    }
    i._source = null, this._instanceDataStorage.visibleInstances = {}, this._disposeInstanceSpecificData(), this._disposeThinInstanceSpecificData(), this._internalMeshDataInfo._checkReadinessObserver && this._scene.onBeforeRenderObservable.remove(this._internalMeshDataInfo._checkReadinessObserver), super.dispose(e, t);
  }
  /** @internal */
  _disposeInstanceSpecificData() {
  }
  /** @internal */
  _disposeThinInstanceSpecificData() {
  }
  /** @internal */
  _invalidateInstanceVertexArrayObject() {
  }
  /**
   * Modifies the mesh geometry according to a displacement map.
   * A displacement map is a colored image. Each pixel color value (actually a gradient computed from red, green, blue values) will give the displacement to apply to each mesh vertex.
   * The mesh must be set as updatable. Its internal geometry is directly modified, no new buffer are allocated.
   * @param url is a string, the URL from the image file is to be downloaded.
   * @param minHeight is the lower limit of the displacement.
   * @param maxHeight is the upper limit of the displacement.
   * @param onSuccess is an optional Javascript function to be called just after the mesh is modified. It is passed the modified mesh and must return nothing.
   * @param uvOffset is an optional vector2 used to offset UV.
   * @param uvScale is an optional vector2 used to scale UV.
   * @param forceUpdate defines whether or not to force an update of the generated buffers. This is useful to apply on a deserialized model for instance.
   * @returns the Mesh.
   */
  applyDisplacementMap(e, t, i, s, r, n, a = !1) {
    const o = this.getScene(), l = (c) => {
      const u = c.width, d = c.height, _ = this.getEngine().createCanvas(u, d).getContext("2d");
      _.drawImage(c, 0, 0);
      const g = _.getImageData(0, 0, u, d).data;
      this.applyDisplacementMapFromBuffer(g, u, d, t, i, r, n, a), s && s(this);
    };
    return z.LoadImage(e, l, () => {
    }, o.offlineProvider), this;
  }
  /**
   * Modifies the mesh geometry according to a displacementMap buffer.
   * A displacement map is a colored image. Each pixel color value (actually a gradient computed from red, green, blue values) will give the displacement to apply to each mesh vertex.
   * The mesh must be set as updatable. Its internal geometry is directly modified, no new buffer are allocated.
   * @param buffer is a `Uint8Array` buffer containing series of `Uint8` lower than 255, the red, green, blue and alpha values of each successive pixel.
   * @param heightMapWidth is the width of the buffer image.
   * @param heightMapHeight is the height of the buffer image.
   * @param minHeight is the lower limit of the displacement.
   * @param maxHeight is the upper limit of the displacement.
   * @param uvOffset is an optional vector2 used to offset UV.
   * @param uvScale is an optional vector2 used to scale UV.
   * @param forceUpdate defines whether or not to force an update of the generated buffers. This is useful to apply on a deserialized model for instance.
   * @returns the Mesh.
   */
  applyDisplacementMapFromBuffer(e, t, i, s, r, n, a, o = !1) {
    if (!this.isVerticesDataPresent(v.PositionKind) || !this.isVerticesDataPresent(v.NormalKind) || !this.isVerticesDataPresent(v.UVKind))
      return w.Warn("Cannot call applyDisplacementMap: Given mesh is not complete. Position, Normal or UV are missing"), this;
    const l = this.getVerticesData(v.PositionKind, !0, !0), c = this.getVerticesData(v.NormalKind), u = this.getVerticesData(v.UVKind);
    let d = p.Zero();
    const f = p.Zero(), _ = ue.Zero();
    n = n || ue.Zero(), a = a || new ue(1, 1);
    for (let g = 0; g < l.length; g += 3) {
      p.FromArrayToRef(l, g, d), p.FromArrayToRef(c, g, f), ue.FromArrayToRef(u, g / 3 * 2, _);
      const m = Math.abs(_.x * a.x + n.x % 1) * (t - 1) % t | 0, y = Math.abs(_.y * a.y + n.y % 1) * (i - 1) % i | 0, x = (m + y * t) * 4, A = e[x] / 255, T = e[x + 1] / 255, M = e[x + 2] / 255, b = A * 0.3 + T * 0.59 + M * 0.11;
      f.normalize(), f.scaleInPlace(s + (r - s) * b), d = d.add(f), d.toArray(l, g);
    }
    return q.ComputeNormals(l, this.getIndices(), c), o ? (this.setVerticesData(v.PositionKind, l), this.setVerticesData(v.NormalKind, c), this.setVerticesData(v.UVKind, u)) : (this.updateVerticesData(v.PositionKind, l), this.updateVerticesData(v.NormalKind, c)), this;
  }
  _getFlattenedNormals(e, t) {
    const i = new Float32Array(e.length * 3);
    let s = 0;
    const r = this.overrideMaterialSideOrientation === (this._scene.useRightHandedSystem ? 1 : 0);
    for (let n = 0; n < e.length; n += 3) {
      const a = p.FromArray(t, e[n] * 3), o = p.FromArray(t, e[n + 1] * 3), l = p.FromArray(t, e[n + 2] * 3), c = a.subtract(o), u = l.subtract(o), d = p.Normalize(p.Cross(c, u));
      r && d.scaleInPlace(-1);
      for (let f = 0; f < 3; f++)
        i[s++] = d.x, i[s++] = d.y, i[s++] = d.z;
    }
    return i;
  }
  _convertToUnIndexedMesh(e = !1) {
    const t = this.getVerticesDataKinds(), i = this.getIndices(), s = {}, r = (a, o) => {
      const l = new Float32Array(i.length * o);
      let c = 0;
      for (let u = 0; u < i.length; u++)
        for (let d = 0; d < o; d++)
          l[c++] = a[i[u] * o + d];
      return l;
    }, n = this.geometry ? this.subMeshes.slice(0) : [];
    for (const a of t)
      s[a] = this.getVerticesData(a);
    for (const a of t) {
      const o = this.getVertexBuffer(a), l = o.getStrideSize();
      if (e && a === v.NormalKind) {
        const c = this._getFlattenedNormals(i, s[v.PositionKind]);
        this.setVerticesData(v.NormalKind, c, o.isUpdatable(), l);
      } else
        this.setVerticesData(a, r(s[a], l), o.isUpdatable(), l);
    }
    if (this.morphTargetManager) {
      for (let a = 0; a < this.morphTargetManager.numTargets; a++) {
        const o = this.morphTargetManager.getTarget(a), l = o.getPositions();
        o.setPositions(r(l, 3));
        const c = o.getNormals();
        c && o.setNormals(e ? this._getFlattenedNormals(i, l) : r(c, 3));
        const u = o.getTangents();
        u && o.setTangents(r(u, 3));
        const d = o.getUVs();
        d && o.setUVs(r(d, 2));
      }
      this.morphTargetManager.synchronize();
    }
    for (let a = 0; a < i.length; a++)
      i[a] = a;
    this.setIndices(i), this._unIndexed = !0, this.releaseSubMeshes();
    for (const a of n)
      Qt.AddToMesh(a.materialIndex, a.indexStart, a.indexCount, a.indexStart, a.indexCount, this);
    return this.synchronizeInstances(), this;
  }
  /**
   * Modify the mesh to get a flat shading rendering.
   * This means each mesh facet will then have its own normals. Usually new vertices are added in the mesh geometry to get this result.
   * Warning : the mesh is really modified even if not set originally as updatable and, under the hood, a new VertexBuffer is allocated.
   * @returns current mesh
   */
  convertToFlatShadedMesh() {
    return this._convertToUnIndexedMesh(!0);
  }
  /**
   * This method removes all the mesh indices and add new vertices (duplication) in order to unfold facets into buffers.
   * In other words, more vertices, no more indices and a single bigger VBO.
   * The mesh is really modified even if not set originally as updatable. Under the hood, a new VertexBuffer is allocated.
   * @returns current mesh
   */
  convertToUnIndexedMesh() {
    return this._convertToUnIndexedMesh();
  }
  /**
   * Inverses facet orientations.
   * Warning : the mesh is really modified even if not set originally as updatable. A new VertexBuffer is created under the hood each call.
   * @param flipNormals will also inverts the normals
   * @returns current mesh
   */
  flipFaces(e = !1) {
    const t = q.ExtractFromMesh(this);
    let i;
    if (e && this.isVerticesDataPresent(v.NormalKind) && t.normals)
      for (i = 0; i < t.normals.length; i++)
        t.normals[i] *= -1;
    if (t.indices) {
      let s;
      for (i = 0; i < t.indices.length; i += 3)
        s = t.indices[i + 1], t.indices[i + 1] = t.indices[i + 2], t.indices[i + 2] = s;
    }
    return t.applyToMesh(this, this.isVertexBufferUpdatable(v.PositionKind)), this;
  }
  /**
   * Increase the number of facets and hence vertices in a mesh
   * Vertex normals are interpolated from existing vertex normals
   * Warning : the mesh is really modified even if not set originally as updatable. A new VertexBuffer is created under the hood each call.
   * @param numberPerEdge the number of new vertices to add to each edge of a facet, optional default 1
   */
  increaseVertices(e = 1) {
    const t = q.ExtractFromMesh(this), i = t.indices && !Array.isArray(t.indices) && Array.from ? Array.from(t.indices) : t.indices, s = t.positions && !Array.isArray(t.positions) && Array.from ? Array.from(t.positions) : t.positions, r = t.uvs && !Array.isArray(t.uvs) && Array.from ? Array.from(t.uvs) : t.uvs, n = t.normals && !Array.isArray(t.normals) && Array.from ? Array.from(t.normals) : t.normals;
    if (!i || !s)
      w.Warn("Couldn't increase number of vertices : VertexData must contain at least indices and positions");
    else {
      t.indices = i, t.positions = s, r && (t.uvs = r), n && (t.normals = n);
      const a = e + 1, o = new Array();
      for (let M = 0; M < a + 1; M++)
        o[M] = new Array();
      let l, c;
      const u = new p(0, 0, 0), d = new p(0, 0, 0), f = new ue(0, 0), _ = new Array(), g = new Array(), m = new Array();
      let y, x = s.length, A;
      r && (A = r.length);
      let T;
      n && (T = n.length);
      for (let M = 0; M < i.length; M += 3) {
        g[0] = i[M], g[1] = i[M + 1], g[2] = i[M + 2];
        for (let b = 0; b < 3; b++)
          if (l = g[b], c = g[(b + 1) % 3], m[l] === void 0 && m[c] === void 0 ? (m[l] = new Array(), m[c] = new Array()) : (m[l] === void 0 && (m[l] = new Array()), m[c] === void 0 && (m[c] = new Array())), m[l][c] === void 0 && m[c][l] === void 0) {
            m[l][c] = [], u.x = (s[3 * c] - s[3 * l]) / a, u.y = (s[3 * c + 1] - s[3 * l + 1]) / a, u.z = (s[3 * c + 2] - s[3 * l + 2]) / a, n && (d.x = (n[3 * c] - n[3 * l]) / a, d.y = (n[3 * c + 1] - n[3 * l + 1]) / a, d.z = (n[3 * c + 2] - n[3 * l + 2]) / a), r && (f.x = (r[2 * c] - r[2 * l]) / a, f.y = (r[2 * c + 1] - r[2 * l + 1]) / a), m[l][c].push(l);
            for (let S = 1; S < a; S++)
              m[l][c].push(s.length / 3), s[x++] = s[3 * l] + S * u.x, s[x++] = s[3 * l + 1] + S * u.y, s[x++] = s[3 * l + 2] + S * u.z, n && (n[T++] = n[3 * l] + S * d.x, n[T++] = n[3 * l + 1] + S * d.y, n[T++] = n[3 * l + 2] + S * d.z), r && (r[A++] = r[2 * l] + S * f.x, r[A++] = r[2 * l + 1] + S * f.y);
            m[l][c].push(c), m[c][l] = new Array(), y = m[l][c].length;
            for (let S = 0; S < y; S++)
              m[c][l][S] = m[l][c][y - 1 - S];
          }
        o[0][0] = i[M], o[1][0] = m[i[M]][i[M + 1]][1], o[1][1] = m[i[M]][i[M + 2]][1];
        for (let b = 2; b < a; b++) {
          o[b][0] = m[i[M]][i[M + 1]][b], o[b][b] = m[i[M]][i[M + 2]][b], u.x = (s[3 * o[b][b]] - s[3 * o[b][0]]) / b, u.y = (s[3 * o[b][b] + 1] - s[3 * o[b][0] + 1]) / b, u.z = (s[3 * o[b][b] + 2] - s[3 * o[b][0] + 2]) / b, n && (d.x = (n[3 * o[b][b]] - n[3 * o[b][0]]) / b, d.y = (n[3 * o[b][b] + 1] - n[3 * o[b][0] + 1]) / b, d.z = (n[3 * o[b][b] + 2] - n[3 * o[b][0] + 2]) / b), r && (f.x = (r[2 * o[b][b]] - r[2 * o[b][0]]) / b, f.y = (r[2 * o[b][b] + 1] - r[2 * o[b][0] + 1]) / b);
          for (let S = 1; S < b; S++)
            o[b][S] = s.length / 3, s[x++] = s[3 * o[b][0]] + S * u.x, s[x++] = s[3 * o[b][0] + 1] + S * u.y, s[x++] = s[3 * o[b][0] + 2] + S * u.z, n && (n[T++] = n[3 * o[b][0]] + S * d.x, n[T++] = n[3 * o[b][0] + 1] + S * d.y, n[T++] = n[3 * o[b][0] + 2] + S * d.z), r && (r[A++] = r[2 * o[b][0]] + S * f.x, r[A++] = r[2 * o[b][0] + 1] + S * f.y);
        }
        o[a] = m[i[M + 1]][i[M + 2]], _.push(o[0][0], o[1][0], o[1][1]);
        for (let b = 1; b < a; b++) {
          let S;
          for (S = 0; S < b; S++)
            _.push(o[b][S], o[b + 1][S], o[b + 1][S + 1]), _.push(o[b][S], o[b + 1][S + 1], o[b][S + 1]);
          _.push(o[b][S], o[b + 1][S], o[b + 1][S + 1]);
        }
      }
      t.indices = _, t.applyToMesh(this, this.isVertexBufferUpdatable(v.PositionKind));
    }
  }
  /**
   * Force adjacent facets to share vertices and remove any facets that have all vertices in a line
   * This will undo any application of covertToFlatShadedMesh
   * Warning : the mesh is really modified even if not set originally as updatable. A new VertexBuffer is created under the hood each call.
   */
  forceSharedVertices() {
    const e = q.ExtractFromMesh(this), t = e.uvs, i = e.indices, s = e.positions, r = e.colors, n = e.matricesIndices, a = e.matricesWeights, o = e.matricesIndicesExtra, l = e.matricesWeightsExtra;
    if (i === void 0 || s === void 0 || i === null || s === null)
      w.Warn("VertexData contains empty entries");
    else {
      const c = new Array(), u = new Array(), d = new Array(), f = new Array(), _ = new Array(), g = new Array(), m = new Array(), y = new Array();
      let x = new Array(), A = 0;
      const T = {};
      let M, b;
      for (let P = 0; P < i.length; P += 3) {
        b = [i[P], i[P + 1], i[P + 2]], x = new Array();
        for (let D = 0; D < 3; D++) {
          x[D] = "";
          for (let O = 0; O < 3; O++)
            Math.abs(s[3 * b[D] + O]) < 1e-8 && (s[3 * b[D] + O] = 0), x[D] += s[3 * b[D] + O] + "|";
        }
        if (!(x[0] == x[1] || x[0] == x[2] || x[1] == x[2]))
          for (let D = 0; D < 3; D++) {
            if (M = T[x[D]], M === void 0) {
              T[x[D]] = A, M = A++;
              for (let O = 0; O < 3; O++)
                c.push(s[3 * b[D] + O]);
              if (r != null)
                for (let O = 0; O < 4; O++)
                  f.push(r[4 * b[D] + O]);
              if (t != null)
                for (let O = 0; O < 2; O++)
                  d.push(t[2 * b[D] + O]);
              if (n != null)
                for (let O = 0; O < 4; O++)
                  _.push(n[4 * b[D] + O]);
              if (a != null)
                for (let O = 0; O < 4; O++)
                  g.push(a[4 * b[D] + O]);
              if (o != null)
                for (let O = 0; O < 4; O++)
                  m.push(o[4 * b[D] + O]);
              if (l != null)
                for (let O = 0; O < 4; O++)
                  y.push(l[4 * b[D] + O]);
            }
            u.push(M);
          }
      }
      const S = new Array();
      q.ComputeNormals(c, u, S), e.positions = c, e.indices = u, e.normals = S, t != null && (e.uvs = d), r != null && (e.colors = f), n != null && (e.matricesIndices = _), a != null && (e.matricesWeights = g), o != null && (e.matricesIndicesExtra = m), a != null && (e.matricesWeightsExtra = y), e.applyToMesh(this, this.isVertexBufferUpdatable(v.PositionKind));
    }
  }
  // Instances
  /**
   * @internal
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/naming-convention
  static _instancedMeshFactory(e, t) {
    throw he("InstancedMesh");
  }
  /**
   * @internal
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static _PhysicsImpostorParser(e, t, i) {
    throw he("PhysicsImpostor");
  }
  /**
   * Creates a new InstancedMesh object from the mesh model.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/copies/instances
   * @param name defines the name of the new instance
   * @returns a new InstancedMesh
   */
  createInstance(e) {
    return K._instancedMeshFactory(e, this);
  }
  /**
   * Synchronises all the mesh instance submeshes to the current mesh submeshes, if any.
   * After this call, all the mesh instances have the same submeshes than the current mesh.
   * @returns the current mesh
   */
  synchronizeInstances() {
    for (let e = 0; e < this.instances.length; e++)
      this.instances[e]._syncSubMeshes();
    return this;
  }
  /**
   * Optimization of the mesh's indices, in case a mesh has duplicated vertices.
   * The function will only reorder the indices and will not remove unused vertices to avoid problems with submeshes.
   * This should be used together with the simplification to avoid disappearing triangles.
   * @param successCallback an optional success callback to be called after the optimization finished.
   * @returns the current mesh
   */
  optimizeIndices(e) {
    const t = this.getIndices(), i = this.getVerticesData(v.PositionKind);
    if (!i || !t)
      return this;
    const s = new Array();
    for (let n = 0; n < i.length; n = n + 3)
      s.push(p.FromArray(i, n));
    const r = new Array();
    return Ar.SyncAsyncForLoop(s.length, 40, (n) => {
      const a = s.length - 1 - n, o = s[a];
      for (let l = 0; l < a; ++l) {
        const c = s[l];
        if (o.equals(c)) {
          r[a] = l;
          break;
        }
      }
    }, () => {
      for (let a = 0; a < t.length; ++a)
        t[a] = r[t[a]] || t[a];
      const n = this.subMeshes.slice(0);
      this.setIndices(t), this.subMeshes = n, e && e(this);
    }), this;
  }
  /**
   * Serialize current mesh
   * @param serializationObject defines the object which will receive the serialization data
   */
  serialize(e = {}) {
    e.name = this.name, e.id = this.id, e.uniqueId = this.uniqueId, e.type = this.getClassName(), Ee && Ee.HasTags(this) && (e.tags = Ee.GetTags(this)), e.position = this.position.asArray(), this.rotationQuaternion ? e.rotationQuaternion = this.rotationQuaternion.asArray() : this.rotation && (e.rotation = this.rotation.asArray()), e.scaling = this.scaling.asArray(), this._postMultiplyPivotMatrix ? e.pivotMatrix = this.getPivotMatrix().asArray() : e.localMatrix = this.getPivotMatrix().asArray(), e.isEnabled = this.isEnabled(!1), e.isVisible = this.isVisible, e.infiniteDistance = this.infiniteDistance, e.pickable = this.isPickable, e.receiveShadows = this.receiveShadows, e.billboardMode = this.billboardMode, e.visibility = this.visibility, e.checkCollisions = this.checkCollisions, e.isBlocker = this.isBlocker, e.overrideMaterialSideOrientation = this.overrideMaterialSideOrientation, this.parent && this.parent._serializeAsParent(e), e.isUnIndexed = this.isUnIndexed;
    const t = this._geometry;
    if (t && this.subMeshes) {
      e.geometryUniqueId = t.uniqueId, e.geometryId = t.id, e.subMeshes = [];
      for (let i = 0; i < this.subMeshes.length; i++) {
        const s = this.subMeshes[i];
        e.subMeshes.push({
          materialIndex: s.materialIndex,
          verticesStart: s.verticesStart,
          verticesCount: s.verticesCount,
          indexStart: s.indexStart,
          indexCount: s.indexCount
        });
      }
    }
    if (this.material ? this.material.doNotSerialize || (e.materialUniqueId = this.material.uniqueId, e.materialId = this.material.id) : (this.material = null, e.materialUniqueId = this._scene.defaultMaterial.uniqueId, e.materialId = this._scene.defaultMaterial.id), this.morphTargetManager && (e.morphTargetManagerId = this.morphTargetManager.uniqueId), this.skeleton && (e.skeletonId = this.skeleton.id, e.numBoneInfluencers = this.numBoneInfluencers), this.getScene()._getComponent(ne.NAME_PHYSICSENGINE)) {
      const i = this.getPhysicsImpostor();
      i && (e.physicsMass = i.getParam("mass"), e.physicsFriction = i.getParam("friction"), e.physicsRestitution = i.getParam("mass"), e.physicsImpostor = i.type);
    }
    this.metadata && (e.metadata = this.metadata), e.instances = [];
    for (let i = 0; i < this.instances.length; i++) {
      const s = this.instances[i];
      if (s.doNotSerialize)
        continue;
      const r = {
        name: s.name,
        id: s.id,
        isEnabled: s.isEnabled(!1),
        isVisible: s.isVisible,
        isPickable: s.isPickable,
        checkCollisions: s.checkCollisions,
        position: s.position.asArray(),
        scaling: s.scaling.asArray()
      };
      if (s.parent && s.parent._serializeAsParent(r), s.rotationQuaternion ? r.rotationQuaternion = s.rotationQuaternion.asArray() : s.rotation && (r.rotation = s.rotation.asArray()), this.getScene()._getComponent(ne.NAME_PHYSICSENGINE)) {
        const n = s.getPhysicsImpostor();
        n && (r.physicsMass = n.getParam("mass"), r.physicsFriction = n.getParam("friction"), r.physicsRestitution = n.getParam("mass"), r.physicsImpostor = n.type);
      }
      s.metadata && (r.metadata = s.metadata), s.actionManager && (r.actions = s.actionManager.serialize(s.name)), e.instances.push(r), le.AppendSerializedAnimations(s, r), r.ranges = s.serializeAnimationRanges();
    }
    if (this._thinInstanceDataStorage.instancesCount && this._thinInstanceDataStorage.matrixData && (e.thinInstances = {
      instancesCount: this._thinInstanceDataStorage.instancesCount,
      matrixData: Array.from(this._thinInstanceDataStorage.matrixData),
      matrixBufferSize: this._thinInstanceDataStorage.matrixBufferSize,
      enablePicking: this.thinInstanceEnablePicking
    }, this._userThinInstanceBuffersStorage)) {
      const i = {
        data: {},
        sizes: {},
        strides: {}
      };
      for (const s in this._userThinInstanceBuffersStorage.data)
        i.data[s] = Array.from(this._userThinInstanceBuffersStorage.data[s]), i.sizes[s] = this._userThinInstanceBuffersStorage.sizes[s], i.strides[s] = this._userThinInstanceBuffersStorage.strides[s];
      e.thinInstances.userThinInstance = i;
    }
    return le.AppendSerializedAnimations(this, e), e.ranges = this.serializeAnimationRanges(), e.layerMask = this.layerMask, e.alphaIndex = this.alphaIndex, e.hasVertexAlpha = this.hasVertexAlpha, e.overlayAlpha = this.overlayAlpha, e.overlayColor = this.overlayColor.asArray(), e.renderOverlay = this.renderOverlay, e.applyFog = this.applyFog, this.actionManager && (e.actions = this.actionManager.serialize(this.name)), e;
  }
  /** @internal */
  _syncGeometryWithMorphTargetManager() {
    if (!this.geometry)
      return;
    this._markSubMeshesAsAttributesDirty();
    const e = this._internalAbstractMeshDataInfo._morphTargetManager;
    if (e && e.vertexCount) {
      if (e.vertexCount !== this.getTotalVertices()) {
        w.Error("Mesh is incompatible with morph targets. Targets and mesh must all have the same vertices count."), this.morphTargetManager = null;
        return;
      }
      if (e.isUsingTextureForTargets)
        return;
      for (let t = 0; t < e.numInfluencers; t++) {
        const i = e.getActiveTarget(t), s = i.getPositions();
        if (!s) {
          w.Error("Invalid morph target. Target must have positions.");
          return;
        }
        this.geometry.setVerticesData(v.PositionKind + t, s, !1, 3);
        const r = i.getNormals();
        r && this.geometry.setVerticesData(v.NormalKind + t, r, !1, 3);
        const n = i.getTangents();
        n && this.geometry.setVerticesData(v.TangentKind + t, n, !1, 3);
        const a = i.getUVs();
        a && this.geometry.setVerticesData(v.UVKind + "_" + t, a, !1, 2);
      }
    } else {
      let t = 0;
      for (; this.geometry.isVerticesDataPresent(v.PositionKind + t); )
        this.geometry.removeVerticesData(v.PositionKind + t), this.geometry.isVerticesDataPresent(v.NormalKind + t) && this.geometry.removeVerticesData(v.NormalKind + t), this.geometry.isVerticesDataPresent(v.TangentKind + t) && this.geometry.removeVerticesData(v.TangentKind + t), this.geometry.isVerticesDataPresent(v.UVKind + t) && this.geometry.removeVerticesData(v.UVKind + "_" + t), t++;
    }
  }
  /**
   * Returns a new Mesh object parsed from the source provided.
   * @param parsedMesh is the source
   * @param scene defines the hosting scene
   * @param rootUrl is the root URL to prefix the `delayLoadingFile` property with
   * @returns a new Mesh
   */
  static Parse(e, t, i) {
    let s;
    if (e.type && e.type === "LinesMesh" ? s = K._LinesMeshParser(e, t) : e.type && e.type === "GroundMesh" ? s = K._GroundMeshParser(e, t) : e.type && e.type === "GoldbergMesh" ? s = K._GoldbergMeshParser(e, t) : e.type && e.type === "GreasedLineMesh" ? s = K._GreasedLineMeshParser(e, t) : e.type && e.type === "TrailMesh" ? s = K._TrailMeshParser(e, t) : s = new K(e.name, t), s.id = e.id, s._waitingParsedUniqueId = e.uniqueId, Ee && Ee.AddTagsTo(s, e.tags), s.position = p.FromArray(e.position), e.metadata !== void 0 && (s.metadata = e.metadata), e.rotationQuaternion ? s.rotationQuaternion = U.FromArray(e.rotationQuaternion) : e.rotation && (s.rotation = p.FromArray(e.rotation)), s.scaling = p.FromArray(e.scaling), e.localMatrix ? s.setPreTransformMatrix(I.FromArray(e.localMatrix)) : e.pivotMatrix && s.setPivotMatrix(I.FromArray(e.pivotMatrix)), s.setEnabled(e.isEnabled), s.isVisible = e.isVisible, s.infiniteDistance = e.infiniteDistance, s.showBoundingBox = e.showBoundingBox, s.showSubMeshesBoundingBox = e.showSubMeshesBoundingBox, e.applyFog !== void 0 && (s.applyFog = e.applyFog), e.pickable !== void 0 && (s.isPickable = e.pickable), e.alphaIndex !== void 0 && (s.alphaIndex = e.alphaIndex), s.receiveShadows = e.receiveShadows, e.billboardMode !== void 0 && (s.billboardMode = e.billboardMode), e.visibility !== void 0 && (s.visibility = e.visibility), s.checkCollisions = e.checkCollisions, s.overrideMaterialSideOrientation = e.overrideMaterialSideOrientation, e.isBlocker !== void 0 && (s.isBlocker = e.isBlocker), s._shouldGenerateFlatShading = e.useFlatShading, e.freezeWorldMatrix && (s._waitingData.freezeWorldMatrix = e.freezeWorldMatrix), e.parentId !== void 0 && (s._waitingParentId = e.parentId), e.parentInstanceIndex !== void 0 && (s._waitingParentInstanceIndex = e.parentInstanceIndex), e.actions !== void 0 && (s._waitingData.actions = e.actions), e.overlayAlpha !== void 0 && (s.overlayAlpha = e.overlayAlpha), e.overlayColor !== void 0 && (s.overlayColor = ie.FromArray(e.overlayColor)), e.renderOverlay !== void 0 && (s.renderOverlay = e.renderOverlay), s.isUnIndexed = !!e.isUnIndexed, s.hasVertexAlpha = e.hasVertexAlpha, e.delayLoadingFile ? (s.delayLoadState = 4, s.delayLoadingFile = i + e.delayLoadingFile, s.buildBoundingInfo(p.FromArray(e.boundingBoxMinimum), p.FromArray(e.boundingBoxMaximum)), e._binaryInfo && (s._binaryInfo = e._binaryInfo), s._delayInfo = [], e.hasUVs && s._delayInfo.push(v.UVKind), e.hasUVs2 && s._delayInfo.push(v.UV2Kind), e.hasUVs3 && s._delayInfo.push(v.UV3Kind), e.hasUVs4 && s._delayInfo.push(v.UV4Kind), e.hasUVs5 && s._delayInfo.push(v.UV5Kind), e.hasUVs6 && s._delayInfo.push(v.UV6Kind), e.hasColors && s._delayInfo.push(v.ColorKind), e.hasMatricesIndices && s._delayInfo.push(v.MatricesIndicesKind), e.hasMatricesWeights && s._delayInfo.push(v.MatricesWeightsKind), s._delayLoadingFunction = Ct._ImportGeometry, st.ForceFullSceneLoadingForIncremental && s._checkDelayState()) : Ct._ImportGeometry(e, s), e.materialUniqueId ? s._waitingMaterialId = e.materialUniqueId : e.materialId && (s._waitingMaterialId = e.materialId), e.morphTargetManagerId > -1 && (s.morphTargetManager = t.getMorphTargetManagerById(e.morphTargetManagerId)), e.skeletonId !== void 0 && e.skeletonId !== null && (s.skeleton = t.getLastSkeletonById(e.skeletonId), e.numBoneInfluencers && (s.numBoneInfluencers = e.numBoneInfluencers)), e.animations) {
      for (let r = 0; r < e.animations.length; r++) {
        const n = e.animations[r], a = si("BABYLON.Animation");
        a && s.animations.push(a.Parse(n));
      }
      ut.ParseAnimationRanges(s, e, t);
    }
    if (e.autoAnimate && t.beginAnimation(s, e.autoAnimateFrom, e.autoAnimateTo, e.autoAnimateLoop, e.autoAnimateSpeed || 1), e.layerMask && !isNaN(e.layerMask) ? s.layerMask = Math.abs(parseInt(e.layerMask)) : s.layerMask = 268435455, e.physicsImpostor && K._PhysicsImpostorParser(t, s, e), e.lodMeshIds && (s._waitingData.lods = {
      ids: e.lodMeshIds,
      distances: e.lodDistances ? e.lodDistances : null,
      coverages: e.lodCoverages ? e.lodCoverages : null
    }), e.instances)
      for (let r = 0; r < e.instances.length; r++) {
        const n = e.instances[r], a = s.createInstance(n.name);
        if (n.id && (a.id = n.id), Ee && (n.tags ? Ee.AddTagsTo(a, n.tags) : Ee.AddTagsTo(a, e.tags)), a.position = p.FromArray(n.position), n.metadata !== void 0 && (a.metadata = n.metadata), n.parentId !== void 0 && (a._waitingParentId = n.parentId), n.parentInstanceIndex !== void 0 && (a._waitingParentInstanceIndex = n.parentInstanceIndex), n.isEnabled !== void 0 && n.isEnabled !== null && a.setEnabled(n.isEnabled), n.isVisible !== void 0 && n.isVisible !== null && (a.isVisible = n.isVisible), n.isPickable !== void 0 && n.isPickable !== null && (a.isPickable = n.isPickable), n.rotationQuaternion ? a.rotationQuaternion = U.FromArray(n.rotationQuaternion) : n.rotation && (a.rotation = p.FromArray(n.rotation)), a.scaling = p.FromArray(n.scaling), n.checkCollisions != null && n.checkCollisions != null && (a.checkCollisions = n.checkCollisions), n.pickable != null && n.pickable != null && (a.isPickable = n.pickable), n.showBoundingBox != null && n.showBoundingBox != null && (a.showBoundingBox = n.showBoundingBox), n.showSubMeshesBoundingBox != null && n.showSubMeshesBoundingBox != null && (a.showSubMeshesBoundingBox = n.showSubMeshesBoundingBox), n.alphaIndex != null && n.showSubMeshesBoundingBox != null && (a.alphaIndex = n.alphaIndex), n.physicsImpostor && K._PhysicsImpostorParser(t, a, n), n.actions !== void 0 && (a._waitingData.actions = n.actions), n.animations) {
          for (let o = 0; o < n.animations.length; o++) {
            const l = n.animations[o], c = si("BABYLON.Animation");
            c && a.animations.push(c.Parse(l));
          }
          ut.ParseAnimationRanges(a, n, t), n.autoAnimate && t.beginAnimation(a, n.autoAnimateFrom, n.autoAnimateTo, n.autoAnimateLoop, n.autoAnimateSpeed || 1);
        }
      }
    if (e.thinInstances) {
      const r = e.thinInstances;
      if (s.thinInstanceEnablePicking = !!r.enablePicking, r.matrixData ? (s.thinInstanceSetBuffer("matrix", new Float32Array(r.matrixData), 16, !1), s._thinInstanceDataStorage.matrixBufferSize = r.matrixBufferSize, s._thinInstanceDataStorage.instancesCount = r.instancesCount) : s._thinInstanceDataStorage.matrixBufferSize = r.matrixBufferSize, e.thinInstances.userThinInstance) {
        const n = e.thinInstances.userThinInstance;
        for (const a in n.data)
          s.thinInstanceSetBuffer(a, new Float32Array(n.data[a]), n.strides[a], !1), s._userThinInstanceBuffersStorage.sizes[a] = n.sizes[a];
      }
    }
    return s;
  }
  // Skeletons
  /**
   * Prepare internal position array for software CPU skinning
   * @returns original positions used for CPU skinning. Useful for integrating Morphing with skeletons in same mesh
   */
  setPositionsForCPUSkinning() {
    const e = this._internalMeshDataInfo;
    if (!e._sourcePositions) {
      const t = this.getVerticesData(v.PositionKind);
      if (!t)
        return e._sourcePositions;
      e._sourcePositions = new Float32Array(t), this.isVertexBufferUpdatable(v.PositionKind) || this.setVerticesData(v.PositionKind, t, !0);
    }
    return e._sourcePositions;
  }
  /**
   * Prepare internal normal array for software CPU skinning
   * @returns original normals used for CPU skinning. Useful for integrating Morphing with skeletons in same mesh.
   */
  setNormalsForCPUSkinning() {
    const e = this._internalMeshDataInfo;
    if (!e._sourceNormals) {
      const t = this.getVerticesData(v.NormalKind);
      if (!t)
        return e._sourceNormals;
      e._sourceNormals = new Float32Array(t), this.isVertexBufferUpdatable(v.NormalKind) || this.setVerticesData(v.NormalKind, t, !0);
    }
    return e._sourceNormals;
  }
  /**
   * Updates the vertex buffer by applying transformation from the bones
   * @param skeleton defines the skeleton to apply to current mesh
   * @returns the current mesh
   */
  applySkeleton(e) {
    if (!this.geometry)
      return this;
    if (this.geometry._softwareSkinningFrameId == this.getScene().getFrameId())
      return this;
    if (this.geometry._softwareSkinningFrameId = this.getScene().getFrameId(), !this.isVerticesDataPresent(v.PositionKind))
      return this;
    if (!this.isVerticesDataPresent(v.MatricesIndicesKind))
      return this;
    if (!this.isVerticesDataPresent(v.MatricesWeightsKind))
      return this;
    const t = this.isVerticesDataPresent(v.NormalKind), i = this._internalMeshDataInfo;
    if (!i._sourcePositions) {
      const y = this.subMeshes.slice();
      this.setPositionsForCPUSkinning(), this.subMeshes = y;
    }
    t && !i._sourceNormals && this.setNormalsForCPUSkinning();
    let s = this.getVerticesData(v.PositionKind);
    if (!s)
      return this;
    s instanceof Float32Array || (s = new Float32Array(s));
    let r = this.getVerticesData(v.NormalKind);
    if (t) {
      if (!r)
        return this;
      r instanceof Float32Array || (r = new Float32Array(r));
    }
    const n = this.getVerticesData(v.MatricesIndicesKind), a = this.getVerticesData(v.MatricesWeightsKind);
    if (!a || !n)
      return this;
    const o = this.numBoneInfluencers > 4, l = o ? this.getVerticesData(v.MatricesIndicesExtraKind) : null, c = o ? this.getVerticesData(v.MatricesWeightsExtraKind) : null, u = e.getTransformMatrices(this), d = p.Zero(), f = new I(), _ = new I();
    let g = 0, m;
    for (let y = 0; y < s.length; y += 3, g += 4) {
      let x;
      for (m = 0; m < 4; m++)
        x = a[g + m], x > 0 && (I.FromFloat32ArrayToRefScaled(u, Math.floor(n[g + m] * 16), x, _), f.addToSelf(_));
      if (o)
        for (m = 0; m < 4; m++)
          x = c[g + m], x > 0 && (I.FromFloat32ArrayToRefScaled(u, Math.floor(l[g + m] * 16), x, _), f.addToSelf(_));
      p.TransformCoordinatesFromFloatsToRef(i._sourcePositions[y], i._sourcePositions[y + 1], i._sourcePositions[y + 2], f, d), d.toArray(s, y), t && (p.TransformNormalFromFloatsToRef(i._sourceNormals[y], i._sourceNormals[y + 1], i._sourceNormals[y + 2], f, d), d.toArray(r, y)), f.reset();
    }
    return this.updateVerticesData(v.PositionKind, s), t && this.updateVerticesData(v.NormalKind, r), this;
  }
  // Tools
  /**
   * Returns an object containing a min and max Vector3 which are the minimum and maximum vectors of each mesh bounding box from the passed array, in the world coordinates
   * @param meshes defines the list of meshes to scan
   * @returns an object `{min:` Vector3`, max:` Vector3`}`
   */
  static MinMax(e) {
    let t = null, i = null;
    return e.forEach(function(s) {
      const n = s.getBoundingInfo().boundingBox;
      !t || !i ? (t = n.minimumWorld, i = n.maximumWorld) : (t.minimizeInPlace(n.minimumWorld), i.maximizeInPlace(n.maximumWorld));
    }), !t || !i ? {
      min: p.Zero(),
      max: p.Zero()
    } : {
      min: t,
      max: i
    };
  }
  /**
   * Returns the center of the `{min:` Vector3`, max:` Vector3`}` or the center of MinMax vector3 computed from a mesh array
   * @param meshesOrMinMaxVector could be an array of meshes or a `{min:` Vector3`, max:` Vector3`}` object
   * @returns a vector3
   */
  static Center(e) {
    const t = e instanceof Array ? K.MinMax(e) : e;
    return p.Center(t.min, t.max);
  }
  /**
   * Merge the array of meshes into a single mesh for performance reasons.
   * @param meshes array of meshes with the vertices to merge. Entries cannot be empty meshes.
   * @param disposeSource when true (default), dispose of the vertices from the source meshes.
   * @param allow32BitsIndices when the sum of the vertices > 64k, this must be set to true.
   * @param meshSubclass (optional) can be set to a Mesh where the merged vertices will be inserted.
   * @param subdivideWithSubMeshes when true (false default), subdivide mesh into subMeshes.
   * @param multiMultiMaterials when true (false default), subdivide mesh into subMeshes with multiple materials, ignores subdivideWithSubMeshes.
   * @returns a new mesh
   */
  static MergeMeshes(e, t = !0, i, s, r, n) {
    return On(K._MergeMeshesCoroutine(e, t, i, s, r, n, !1));
  }
  /**
   * Merge the array of meshes into a single mesh for performance reasons.
   * @param meshes array of meshes with the vertices to merge. Entries cannot be empty meshes.
   * @param disposeSource when true (default), dispose of the vertices from the source meshes.
   * @param allow32BitsIndices when the sum of the vertices > 64k, this must be set to true.
   * @param meshSubclass (optional) can be set to a Mesh where the merged vertices will be inserted.
   * @param subdivideWithSubMeshes when true (false default), subdivide mesh into subMeshes.
   * @param multiMultiMaterials when true (false default), subdivide mesh into subMeshes with multiple materials, ignores subdivideWithSubMeshes.
   * @returns a new mesh
   */
  static MergeMeshesAsync(e, t = !0, i, s, r, n) {
    return Tl(K._MergeMeshesCoroutine(e, t, i, s, r, n, !0), bl());
  }
  static *_MergeMeshesCoroutine(e, t = !0, i, s, r, n, a) {
    if (e = e.filter(Boolean), e.length === 0)
      return null;
    let o;
    if (!i) {
      let S = 0;
      for (o = 0; o < e.length; o++)
        if (S += e[o].getTotalVertices(), S >= 65536)
          return w.Warn("Cannot merge meshes because resulting mesh will have more than 65536 vertices. Please use allow32BitsIndices = true to use 32 bits indices"), null;
    }
    n && (r = !1);
    const l = new Array(), c = new Array(), u = new Array(), d = e[0].overrideMaterialSideOrientation;
    for (o = 0; o < e.length; o++) {
      const S = e[o];
      if (S.isAnInstance)
        return w.Warn("Cannot merge instance meshes."), null;
      if (d !== S.overrideMaterialSideOrientation)
        return w.Warn("Cannot merge meshes with different overrideMaterialSideOrientation values."), null;
      if (r && u.push(S.getTotalIndices()), n)
        if (S.material) {
          const P = S.material;
          if (P instanceof Vi) {
            for (let D = 0; D < P.subMaterials.length; D++)
              l.indexOf(P.subMaterials[D]) < 0 && l.push(P.subMaterials[D]);
            for (let D = 0; D < S.subMeshes.length; D++)
              c.push(l.indexOf(P.subMaterials[S.subMeshes[D].materialIndex])), u.push(S.subMeshes[D].indexCount);
          } else {
            l.indexOf(P) < 0 && l.push(P);
            for (let D = 0; D < S.subMeshes.length; D++)
              c.push(l.indexOf(P)), u.push(S.subMeshes[D].indexCount);
          }
        } else
          for (let P = 0; P < S.subMeshes.length; P++)
            c.push(0), u.push(S.subMeshes[P].indexCount);
    }
    const f = e[0], _ = (S) => {
      const P = S.computeWorldMatrix(!0);
      return { vertexData: q.ExtractFromMesh(S, !1, !1), transform: P };
    }, { vertexData: g, transform: m } = _(f);
    a && (yield);
    const y = new Array(e.length - 1);
    for (let S = 1; S < e.length; S++)
      y[S - 1] = _(e[S]), a && (yield);
    const x = g._mergeCoroutine(m, y, i, a, !t);
    let A = x.next();
    for (; !A.done; )
      a && (yield), A = x.next();
    const T = A.value;
    s || (s = new K(f.name + "_merged", f.getScene()));
    const M = T._applyToCoroutine(s, void 0, a);
    let b = M.next();
    for (; !b.done; )
      a && (yield), b = M.next();
    if (s.checkCollisions = f.checkCollisions, s.overrideMaterialSideOrientation = f.overrideMaterialSideOrientation, t)
      for (o = 0; o < e.length; o++)
        e[o].dispose();
    if (r || n) {
      s.releaseSubMeshes(), o = 0;
      let S = 0;
      for (; o < u.length; )
        Qt.CreateFromIndices(0, S, u[o], s, void 0, !1), S += u[o], o++;
      for (const P of s.subMeshes)
        P.refreshBoundingInfo();
      s.computeWorldMatrix(!0);
    }
    if (n) {
      const S = new Vi(f.name + "_merged", f.getScene());
      S.subMaterials = l;
      for (let P = 0; P < s.subMeshes.length; P++)
        s.subMeshes[P].materialIndex = c[P];
      s.material = S;
    } else
      s.material = f.material;
    return s;
  }
  /**
   * @internal
   */
  addInstance(e) {
    e._indexInSourceMeshInstanceArray = this.instances.length, this.instances.push(e);
  }
  /**
   * @internal
   */
  removeInstance(e) {
    const t = e._indexInSourceMeshInstanceArray;
    if (t != -1) {
      if (t !== this.instances.length - 1) {
        const i = this.instances[this.instances.length - 1];
        this.instances[t] = i, i._indexInSourceMeshInstanceArray = t;
      }
      e._indexInSourceMeshInstanceArray = -1, this.instances.pop();
    }
  }
  /** @internal */
  _shouldConvertRHS() {
    return this.overrideMaterialSideOrientation === F.CounterClockWiseSideOrientation;
  }
  /** @internal */
  _getRenderingFillMode(e) {
    var t;
    const i = this.getScene();
    return i.forcePointsCloud ? F.PointFillMode : i.forceWireframe ? F.WireFrameFillMode : (t = this.overrideRenderingFillMode) !== null && t !== void 0 ? t : e;
  }
  // deprecated methods
  /**
   * Sets the mesh material by the material or multiMaterial `id` property
   * @param id is a string identifying the material or the multiMaterial
   * @returns the current mesh
   * @deprecated Please use MeshBuilder instead Please use setMaterialById instead
   */
  setMaterialByID(e) {
    return this.setMaterialById(e);
  }
  /**
   * Creates a ribbon mesh.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param
   * @param name defines the name of the mesh to create
   * @param pathArray is a required array of paths, what are each an array of successive Vector3. The pathArray parameter depicts the ribbon geometry.
   * @param closeArray creates a seam between the first and the last paths of the path array (default is false)
   * @param closePath creates a seam between the first and the last points of each path of the path array
   * @param offset is taken in account only if the `pathArray` is containing a single path
   * @param scene defines the hosting scene
   * @param updatable defines if the mesh must be flagged as updatable
   * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
   * @param instance defines an instance of an existing Ribbon object to be updated with the passed `pathArray` parameter (https://doc.babylonjs.com/how_to/How_to_dynamically_morph_a_mesh#ribbon)
   * @returns a new Mesh
   * @deprecated Please use MeshBuilder instead
   */
  static CreateRibbon(e, t, i, s, r, n, a, o, l) {
    throw new Error("Import MeshBuilder to populate this function");
  }
  /**
   * Creates a plane polygonal mesh.  By default, this is a disc.
   * @param name defines the name of the mesh to create
   * @param radius sets the radius size (float) of the polygon (default 0.5)
   * @param tessellation sets the number of polygon sides (positive integer, default 64). So a tessellation valued to 3 will build a triangle, to 4 a square, etc
   * @param scene defines the hosting scene
   * @param updatable defines if the mesh must be flagged as updatable
   * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
   * @returns a new Mesh
   * @deprecated Please use MeshBuilder instead
   */
  static CreateDisc(e, t, i, s, r, n) {
    throw new Error("Import MeshBuilder to populate this function");
  }
  /**
   * Creates a box mesh.
   * @param name defines the name of the mesh to create
   * @param size sets the size (float) of each box side (default 1)
   * @param scene defines the hosting scene
   * @param updatable defines if the mesh must be flagged as updatable
   * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
   * @returns a new Mesh
   * @deprecated Please use MeshBuilder instead
   */
  static CreateBox(e, t, i, s, r) {
    throw new Error("Import MeshBuilder to populate this function");
  }
  /**
   * Creates a sphere mesh.
   * @param name defines the name of the mesh to create
   * @param segments sets the sphere number of horizontal stripes (positive integer, default 32)
   * @param diameter sets the diameter size (float) of the sphere (default 1)
   * @param scene defines the hosting scene
   * @param updatable defines if the mesh must be flagged as updatable
   * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
   * @returns a new Mesh
   * @deprecated Please use MeshBuilder instead
   */
  static CreateSphere(e, t, i, s, r, n) {
    throw new Error("Import MeshBuilder to populate this function");
  }
  /**
   * Creates a hemisphere mesh.
   * @param name defines the name of the mesh to create
   * @param segments sets the sphere number of horizontal stripes (positive integer, default 32)
   * @param diameter sets the diameter size (float) of the sphere (default 1)
   * @param scene defines the hosting scene
   * @returns a new Mesh
   * @deprecated Please use MeshBuilder instead
   */
  static CreateHemisphere(e, t, i, s) {
    throw new Error("Import MeshBuilder to populate this function");
  }
  /**
   * Creates a cylinder or a cone mesh.
   * @param name defines the name of the mesh to create
   * @param height sets the height size (float) of the cylinder/cone (float, default 2)
   * @param diameterTop set the top cap diameter (floats, default 1)
   * @param diameterBottom set the bottom cap diameter (floats, default 1). This value can't be zero
   * @param tessellation sets the number of cylinder sides (positive integer, default 24). Set it to 3 to get a prism for instance
   * @param subdivisions sets the number of rings along the cylinder height (positive integer, default 1)
   * @param scene defines the hosting scene
   * @param updatable defines if the mesh must be flagged as updatable
   * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
   * @returns a new Mesh
   * @deprecated Please use MeshBuilder instead
   */
  static CreateCylinder(e, t, i, s, r, n, a, o, l) {
    throw new Error("Import MeshBuilder to populate this function");
  }
  // Torus  (Code from SharpDX.org)
  /**
   * Creates a torus mesh.
   * @param name defines the name of the mesh to create
   * @param diameter sets the diameter size (float) of the torus (default 1)
   * @param thickness sets the diameter size of the tube of the torus (float, default 0.5)
   * @param tessellation sets the number of torus sides (positive integer, default 16)
   * @param scene defines the hosting scene
   * @param updatable defines if the mesh must be flagged as updatable
   * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
   * @returns a new Mesh
   * @deprecated Please use MeshBuilder instead
   */
  static CreateTorus(e, t, i, s, r, n, a) {
    throw new Error("Import MeshBuilder to populate this function");
  }
  /**
   * Creates a torus knot mesh.
   * @param name defines the name of the mesh to create
   * @param radius sets the global radius size (float) of the torus knot (default 2)
   * @param tube sets the diameter size of the tube of the torus (float, default 0.5)
   * @param radialSegments sets the number of sides on each tube segments (positive integer, default 32)
   * @param tubularSegments sets the number of tubes to decompose the knot into (positive integer, default 32)
   * @param p the number of windings on X axis (positive integers, default 2)
   * @param q the number of windings on Y axis (positive integers, default 3)
   * @param scene defines the hosting scene
   * @param updatable defines if the mesh must be flagged as updatable
   * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
   * @returns a new Mesh
   * @deprecated Please use MeshBuilder instead
   */
  static CreateTorusKnot(e, t, i, s, r, n, a, o, l, c) {
    throw new Error("Import MeshBuilder to populate this function");
  }
  /**
   * Creates a line mesh..
   * @param name defines the name of the mesh to create
   * @param points is an array successive Vector3
   * @param scene defines the hosting scene
   * @param updatable defines if the mesh must be flagged as updatable
   * @param instance is an instance of an existing LineMesh object to be updated with the passed `points` parameter (https://doc.babylonjs.com/how_to/How_to_dynamically_morph_a_mesh#lines-and-dashedlines).
   * @returns a new Mesh
   * @deprecated Please use MeshBuilder instead
   */
  static CreateLines(e, t, i, s, r) {
    throw new Error("Import MeshBuilder to populate this function");
  }
  /**
   * Creates a dashed line mesh.
   * @param name defines the name of the mesh to create
   * @param points is an array successive Vector3
   * @param dashSize is the size of the dashes relatively the dash number (positive float, default 3)
   * @param gapSize is the size of the gap between two successive dashes relatively the dash number (positive float, default 1)
   * @param dashNb is the intended total number of dashes (positive integer, default 200)
   * @param scene defines the hosting scene
   * @param updatable defines if the mesh must be flagged as updatable
   * @param instance is an instance of an existing LineMesh object to be updated with the passed `points` parameter (https://doc.babylonjs.com/how_to/How_to_dynamically_morph_a_mesh#lines-and-dashedlines)
   * @returns a new Mesh
   * @deprecated Please use MeshBuilder instead
   */
  static CreateDashedLines(e, t, i, s, r, n, a, o) {
    throw new Error("Import MeshBuilder to populate this function");
  }
  /**
   * Creates a polygon mesh.Please consider using the same method from the MeshBuilder class instead
   * The polygon's shape will depend on the input parameters and is constructed parallel to a ground mesh.
   * The parameter `shape` is a required array of successive Vector3 representing the corners of the polygon in th XoZ plane, that is y = 0 for all vectors.
   * You can set the mesh side orientation with the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
   * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created.
   * Remember you can only change the shape positions, not their number when updating a polygon.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param#non-regular-polygon
   * @param name defines the name of the mesh to create
   * @param shape is a required array of successive Vector3 representing the corners of the polygon in th XoZ plane, that is y = 0 for all vectors
   * @param scene defines the hosting scene
   * @param holes is a required array of arrays of successive Vector3 used to defines holes in the polygon
   * @param updatable defines if the mesh must be flagged as updatable
   * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
   * @param earcutInjection can be used to inject your own earcut reference
   * @returns a new Mesh
   * @deprecated Please use MeshBuilder instead
   */
  static CreatePolygon(e, t, i, s, r, n, a) {
    throw new Error("Import MeshBuilder to populate this function");
  }
  /**
   * Creates an extruded polygon mesh, with depth in the Y direction..
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param#extruded-non-regular-polygon
   * @param name defines the name of the mesh to create
   * @param shape is a required array of successive Vector3 representing the corners of the polygon in th XoZ plane, that is y = 0 for all vectors
   * @param depth defines the height of extrusion
   * @param scene defines the hosting scene
   * @param holes is a required array of arrays of successive Vector3 used to defines holes in the polygon
   * @param updatable defines if the mesh must be flagged as updatable
   * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
   * @param earcutInjection can be used to inject your own earcut reference
   * @returns a new Mesh
   * @deprecated Please use MeshBuilder instead
   */
  static ExtrudePolygon(e, t, i, s, r, n, a, o) {
    throw new Error("Import MeshBuilder to populate this function");
  }
  /**
   * Creates an extruded shape mesh.
   * The extrusion is a parametric shape. It has no predefined shape. Its final shape will depend on the input parameters.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param#extruded-shapes
   * @param name defines the name of the mesh to create
   * @param shape is a required array of successive Vector3. This array depicts the shape to be extruded in its local space : the shape must be designed in the xOy plane and will be extruded along the Z axis
   * @param path is a required array of successive Vector3. This is the axis curve the shape is extruded along
   * @param scale is the value to scale the shape
   * @param rotation is the angle value to rotate the shape each step (each path point), from the former step (so rotation added each step) along the curve
   * @param cap sets the way the extruded shape is capped. Possible values : Mesh.NO_CAP (default), Mesh.CAP_START, Mesh.CAP_END, Mesh.CAP_ALL
   * @param scene defines the hosting scene
   * @param updatable defines if the mesh must be flagged as updatable
   * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
   * @param instance is an instance of an existing ExtrudedShape object to be updated with the passed `shape`, `path`, `scale` or `rotation` parameters (https://doc.babylonjs.com/how_to/How_to_dynamically_morph_a_mesh#extruded-shape)
   * @returns a new Mesh
   * @deprecated Please use MeshBuilder instead
   */
  static ExtrudeShape(e, t, i, s, r, n, a, o, l, c) {
    throw new Error("Import MeshBuilder to populate this function");
  }
  /**
   * Creates an custom extruded shape mesh.
   * The custom extrusion is a parametric shape.
   * It has no predefined shape. Its final shape will depend on the input parameters.
   *
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param#extruded-shapes
   * @param name defines the name of the mesh to create
   * @param shape is a required array of successive Vector3. This array depicts the shape to be extruded in its local space : the shape must be designed in the xOy plane and will be extruded along the Z axis
   * @param path is a required array of successive Vector3. This is the axis curve the shape is extruded along
   * @param scaleFunction is a custom Javascript function called on each path point
   * @param rotationFunction is a custom Javascript function called on each path point
   * @param ribbonCloseArray forces the extrusion underlying ribbon to close all the paths in its `pathArray`
   * @param ribbonClosePath forces the extrusion underlying ribbon to close its `pathArray`
   * @param cap sets the way the extruded shape is capped. Possible values : Mesh.NO_CAP (default), Mesh.CAP_START, Mesh.CAP_END, Mesh.CAP_ALL
   * @param scene defines the hosting scene
   * @param updatable defines if the mesh must be flagged as updatable
   * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
   * @param instance is an instance of an existing ExtrudedShape object to be updated with the passed `shape`, `path`, `scale` or `rotation` parameters (https://doc.babylonjs.com/features/featuresDeepDive/mesh/dynamicMeshMorph#extruded-shape)
   * @returns a new Mesh
   * @deprecated Please use MeshBuilder instead
   */
  static ExtrudeShapeCustom(e, t, i, s, r, n, a, o, l, c, u, d) {
    throw new Error("Import MeshBuilder to populate this function");
  }
  /**
   * Creates lathe mesh.
   * The lathe is a shape with a symmetry axis : a 2D model shape is rotated around this axis to design the lathe.
   * @param name defines the name of the mesh to create
   * @param shape is a required array of successive Vector3. This array depicts the shape to be rotated in its local space : the shape must be designed in the xOy plane and will be rotated around the Y axis. It's usually a 2D shape, so the Vector3 z coordinates are often set to zero
   * @param radius is the radius value of the lathe
   * @param tessellation is the side number of the lathe.
   * @param scene defines the hosting scene
   * @param updatable defines if the mesh must be flagged as updatable
   * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
   * @returns a new Mesh
   * @deprecated Please use MeshBuilder instead
   */
  static CreateLathe(e, t, i, s, r, n, a) {
    throw new Error("Import MeshBuilder to populate this function");
  }
  /**
   * Creates a plane mesh.
   * @param name defines the name of the mesh to create
   * @param size sets the size (float) of both sides of the plane at once (default 1)
   * @param scene defines the hosting scene
   * @param updatable defines if the mesh must be flagged as updatable
   * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
   * @returns a new Mesh
   * @deprecated Please use MeshBuilder instead
   */
  static CreatePlane(e, t, i, s, r) {
    throw new Error("Import MeshBuilder to populate this function");
  }
  /**
   * Creates a ground mesh.
   * @param name defines the name of the mesh to create
   * @param width set the width of the ground
   * @param height set the height of the ground
   * @param subdivisions sets the number of subdivisions per side
   * @param scene defines the hosting scene
   * @param updatable defines if the mesh must be flagged as updatable
   * @returns a new Mesh
   * @deprecated Please use MeshBuilder instead
   */
  static CreateGround(e, t, i, s, r, n) {
    throw new Error("Import MeshBuilder to populate this function");
  }
  /**
   * Creates a tiled ground mesh.
   * @param name defines the name of the mesh to create
   * @param xmin set the ground minimum X coordinate
   * @param zmin set the ground minimum Y coordinate
   * @param xmax set the ground maximum X coordinate
   * @param zmax set the ground maximum Z coordinate
   * @param subdivisions is an object `{w: positive integer, h: positive integer}` (default `{w: 6, h: 6}`). `w` and `h` are the numbers of subdivisions on the ground width and height. Each subdivision is called a tile
   * @param precision is an object `{w: positive integer, h: positive integer}` (default `{w: 2, h: 2}`). `w` and `h` are the numbers of subdivisions on the ground width and height of each tile
   * @param scene defines the hosting scene
   * @param updatable defines if the mesh must be flagged as updatable
   * @returns a new Mesh
   * @deprecated Please use MeshBuilder instead
   */
  static CreateTiledGround(e, t, i, s, r, n, a, o, l) {
    throw new Error("Import MeshBuilder to populate this function");
  }
  /**
   * Creates a ground mesh from a height map.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set/height_map
   * @param name defines the name of the mesh to create
   * @param url sets the URL of the height map image resource
   * @param width set the ground width size
   * @param height set the ground height size
   * @param subdivisions sets the number of subdivision per side
   * @param minHeight is the minimum altitude on the ground
   * @param maxHeight is the maximum altitude on the ground
   * @param scene defines the hosting scene
   * @param updatable defines if the mesh must be flagged as updatable
   * @param onReady  is a callback function that will be called  once the mesh is built (the height map download can last some time)
   * @param alphaFilter will filter any data where the alpha channel is below this value, defaults 0 (all data visible)
   * @returns a new Mesh
   * @deprecated Please use MeshBuilder instead
   */
  static CreateGroundFromHeightMap(e, t, i, s, r, n, a, o, l, c, u) {
    throw new Error("Import MeshBuilder to populate this function");
  }
  /**
   * Creates a tube mesh.
   * The tube is a parametric shape.
   * It has no predefined shape. Its final shape will depend on the input parameters.
   *
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param
   * @param name defines the name of the mesh to create
   * @param path is a required array of successive Vector3. It is the curve used as the axis of the tube
   * @param radius sets the tube radius size
   * @param tessellation is the number of sides on the tubular surface
   * @param radiusFunction is a custom function. If it is not null, it overrides the parameter `radius`. This function is called on each point of the tube path and is passed the index `i` of the i-th point and the distance of this point from the first point of the path
   * @param cap sets the way the extruded shape is capped. Possible values : Mesh.NO_CAP (default), Mesh.CAP_START, Mesh.CAP_END, Mesh.CAP_ALL
   * @param scene defines the hosting scene
   * @param updatable defines if the mesh must be flagged as updatable
   * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
   * @param instance is an instance of an existing Tube object to be updated with the passed `pathArray` parameter (https://doc.babylonjs.com/how_to/How_to_dynamically_morph_a_mesh#tube)
   * @returns a new Mesh
   * @deprecated Please use MeshBuilder instead
   */
  static CreateTube(e, t, i, s, r, n, a, o, l, c) {
    throw new Error("Import MeshBuilder to populate this function");
  }
  /**
   * Creates a polyhedron mesh.
   *.
   * * The parameter `type` (positive integer, max 14, default 0) sets the polyhedron type to build among the 15 embedded types. Please refer to the type sheet in the tutorial to choose the wanted type
   * * The parameter `size` (positive float, default 1) sets the polygon size
   * * You can overwrite the `size` on each dimension bu using the parameters `sizeX`, `sizeY` or `sizeZ` (positive floats, default to `size` value)
   * * You can build other polyhedron types than the 15 embbeded ones by setting the parameter `custom` (`polyhedronObject`, default null). If you set the parameter `custom`, this overwrittes the parameter `type`
   * * A `polyhedronObject` is a formatted javascript object. You'll find a full file with pre-set polyhedra here : https://github.com/BabylonJS/Extensions/tree/master/Polyhedron
   * * You can set the color and the UV of each side of the polyhedron with the parameters `faceColors` (Color4, default `(1, 1, 1, 1)`) and faceUV (Vector4, default `(0, 0, 1, 1)`)
   * * To understand how to set `faceUV` or `faceColors`, please read this by considering the right number of faces of your polyhedron, instead of only 6 for the box : https://doc.babylonjs.com/features/featuresDeepDive/materials/using/texturePerBoxFace
   * * The parameter `flat` (boolean, default true). If set to false, it gives the polyhedron a single global face, so less vertices and shared normals. In this case, `faceColors` and `faceUV` are ignored
   * * You can also set the mesh side orientation with the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
   * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation
   * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
   * @param name defines the name of the mesh to create
   * @param options defines the options used to create the mesh
   * @param scene defines the hosting scene
   * @returns a new Mesh
   * @deprecated Please use MeshBuilder instead
   */
  static CreatePolyhedron(e, t, i) {
    throw new Error("Import MeshBuilder to populate this function");
  }
  /**
   * Creates a sphere based upon an icosahedron with 20 triangular faces which can be subdivided
   * * The parameter `radius` sets the radius size (float) of the icosphere (default 1)
   * * You can set some different icosphere dimensions, for instance to build an ellipsoid, by using the parameters `radiusX`, `radiusY` and `radiusZ` (all by default have the same value than `radius`)
   * * The parameter `subdivisions` sets the number of subdivisions (positive integer, default 4). The more subdivisions, the more faces on the icosphere whatever its size
   * * The parameter `flat` (boolean, default true) gives each side its own normals. Set it to false to get a smooth continuous light reflection on the surface
   * * You can also set the mesh side orientation with the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
   * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation
   * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/polyhedra#icosphere
   * @param name defines the name of the mesh
   * @param options defines the options used to create the mesh
   * @param scene defines the hosting scene
   * @returns a new Mesh
   * @deprecated Please use MeshBuilder instead
   */
  static CreateIcoSphere(e, t, i) {
    throw new Error("Import MeshBuilder to populate this function");
  }
  /**
   * Creates a decal mesh.
   *.
   * A decal is a mesh usually applied as a model onto the surface of another mesh
   * @param name  defines the name of the mesh
   * @param sourceMesh defines the mesh receiving the decal
   * @param position sets the position of the decal in world coordinates
   * @param normal sets the normal of the mesh where the decal is applied onto in world coordinates
   * @param size sets the decal scaling
   * @param angle sets the angle to rotate the decal
   * @returns a new Mesh
   * @deprecated Please use MeshBuilder instead
   */
  static CreateDecal(e, t, i, s, r, n) {
    throw new Error("Import MeshBuilder to populate this function");
  }
  /** Creates a Capsule Mesh
   * @param name defines the name of the mesh.
   * @param options the constructors options used to shape the mesh.
   * @param scene defines the scene the mesh is scoped to.
   * @returns the capsule mesh
   * @see https://doc.babylonjs.com/how_to/capsule_shape
   * @deprecated Please use MeshBuilder instead
   */
  static CreateCapsule(e, t, i) {
    throw new Error("Import MeshBuilder to populate this function");
  }
  /**
   * Extends a mesh to a Goldberg mesh
   * Warning  the mesh to convert MUST be an import of a perviously exported Goldberg mesh
   * @param mesh the mesh to convert
   * @returns the extended mesh
   * @deprecated Please use ExtendMeshToGoldberg instead
   */
  static ExtendToGoldberg(e) {
    throw new Error("Import MeshBuilder to populate this function");
  }
}
K.FRONTSIDE = q.FRONTSIDE;
K.BACKSIDE = q.BACKSIDE;
K.DOUBLESIDE = q.DOUBLESIDE;
K.DEFAULTSIDE = q.DEFAULTSIDE;
K.NO_CAP = 0;
K.CAP_START = 1;
K.CAP_END = 2;
K.CAP_ALL = 3;
K.NO_FLIP = 0;
K.FLIP_TILE = 1;
K.ROTATE_TILE = 2;
K.FLIP_ROW = 3;
K.ROTATE_ROW = 4;
K.FLIP_N_ROTATE_TILE = 5;
K.FLIP_N_ROTATE_ROW = 6;
K.CENTER = 0;
K.LEFT = 1;
K.RIGHT = 2;
K.TOP = 3;
K.BOTTOM = 4;
K.INSTANCEDMESH_SORT_TRANSPARENT = !1;
K._GroundMeshParser = (h, e) => {
  throw he("GroundMesh");
};
K._GoldbergMeshParser = (h, e) => {
  throw he("GoldbergMesh");
};
K._LinesMeshParser = (h, e) => {
  throw he("LinesMesh");
};
K._GreasedLineMeshParser = (h, e) => {
  throw he("GreasedLineMesh");
};
K._TrailMeshParser = (h, e) => {
  throw he("TrailMesh");
};
Xe("BABYLON.Mesh", K);
class Zt {
  /**
   * Creates a Size object from the given width and height (floats).
   * @param width width of the new size
   * @param height height of the new size
   */
  constructor(e, t) {
    this.width = e, this.height = t;
  }
  /**
   * Returns a string with the Size width and height
   * @returns a string with the Size width and height
   */
  toString() {
    return `{W: ${this.width}, H: ${this.height}}`;
  }
  /**
   * "Size"
   * @returns the string "Size"
   */
  getClassName() {
    return "Size";
  }
  /**
   * Returns the Size hash code.
   * @returns a hash code for a unique width and height
   */
  getHashCode() {
    let e = this.width | 0;
    return e = e * 397 ^ (this.height | 0), e;
  }
  /**
   * Updates the current size from the given one.
   * @param src the given size
   */
  copyFrom(e) {
    this.width = e.width, this.height = e.height;
  }
  /**
   * Updates in place the current Size from the given floats.
   * @param width width of the new size
   * @param height height of the new size
   * @returns the updated Size.
   */
  copyFromFloats(e, t) {
    return this.width = e, this.height = t, this;
  }
  /**
   * Updates in place the current Size from the given floats.
   * @param width width to set
   * @param height height to set
   * @returns the updated Size.
   */
  set(e, t) {
    return this.copyFromFloats(e, t);
  }
  /**
   * Multiplies the width and height by numbers
   * @param w factor to multiple the width by
   * @param h factor to multiple the height by
   * @returns a new Size set with the multiplication result of the current Size and the given floats.
   */
  multiplyByFloats(e, t) {
    return new Zt(this.width * e, this.height * t);
  }
  /**
   * Clones the size
   * @returns a new Size copied from the given one.
   */
  clone() {
    return new Zt(this.width, this.height);
  }
  /**
   * True if the current Size and the given one width and height are strictly equal.
   * @param other the other size to compare against
   * @returns True if the current Size and the given one width and height are strictly equal.
   */
  equals(e) {
    return e ? this.width === e.width && this.height === e.height : !1;
  }
  /**
   * The surface of the Size : width * height (float).
   */
  get surface() {
    return this.width * this.height;
  }
  /**
   * Create a new size of zero
   * @returns a new Size set to (0.0, 0.0)
   */
  static Zero() {
    return new Zt(0, 0);
  }
  /**
   * Sums the width and height of two sizes
   * @param otherSize size to add to this size
   * @returns a new Size set as the addition result of the current Size and the given one.
   */
  add(e) {
    return new Zt(this.width + e.width, this.height + e.height);
  }
  /**
   * Subtracts the width and height of two
   * @param otherSize size to subtract to this size
   * @returns a new Size set as the subtraction result of  the given one from the current Size.
   */
  subtract(e) {
    return new Zt(this.width - e.width, this.height - e.height);
  }
  /**
   * Creates a new Size set at the linear interpolation "amount" between "start" and "end"
   * @param start starting size to lerp between
   * @param end end size to lerp between
   * @param amount amount to lerp between the start and end values
   * @returns a new Size set at the linear interpolation "amount" between "start" and "end"
   */
  static Lerp(e, t, i) {
    const s = e.width + (t.width - e.width) * i, r = e.height + (t.height - e.height) * i;
    return new Zt(s, r);
  }
}
class Fn {
  /**
   * | Value | Type               | Description |
   * | ----- | ------------------ | ----------- |
   * | 0     | CLAMP_ADDRESSMODE  |             |
   * | 1     | WRAP_ADDRESSMODE   |             |
   * | 2     | MIRROR_ADDRESSMODE |             |
   */
  get wrapU() {
    return this._wrapU;
  }
  set wrapU(e) {
    this._wrapU = e;
  }
  /**
   * | Value | Type               | Description |
   * | ----- | ------------------ | ----------- |
   * | 0     | CLAMP_ADDRESSMODE  |             |
   * | 1     | WRAP_ADDRESSMODE   |             |
   * | 2     | MIRROR_ADDRESSMODE |             |
   */
  get wrapV() {
    return this._wrapV;
  }
  set wrapV(e) {
    this._wrapV = e;
  }
  /**
   * How a texture is mapped.
   * Unused in thin texture mode.
   */
  get coordinatesMode() {
    return 0;
  }
  /**
   * Define if the texture is a cube texture or if false a 2d texture.
   */
  get isCube() {
    return this._texture ? this._texture.isCube : !1;
  }
  set isCube(e) {
    this._texture && (this._texture.isCube = e);
  }
  /**
   * Define if the texture is a 3d texture (webgl 2) or if false a 2d texture.
   */
  get is3D() {
    return this._texture ? this._texture.is3D : !1;
  }
  set is3D(e) {
    this._texture && (this._texture.is3D = e);
  }
  /**
   * Define if the texture is a 2d array texture (webgl 2) or if false a 2d texture.
   */
  get is2DArray() {
    return this._texture ? this._texture.is2DArray : !1;
  }
  set is2DArray(e) {
    this._texture && (this._texture.is2DArray = e);
  }
  /**
   * Get the class name of the texture.
   * @returns "ThinTexture"
   */
  getClassName() {
    return "ThinTexture";
  }
  static _IsRenderTargetWrapper(e) {
    return (e == null ? void 0 : e._shareDepth) !== void 0;
  }
  /**
   * Instantiates a new ThinTexture.
   * Base class of all the textures in babylon.
   * This can be used as an internal texture wrapper in ThinEngine to benefit from the cache
   * @param internalTexture Define the internalTexture to wrap. You can also pass a RenderTargetWrapper, in which case the texture will be the render target's texture
   */
  constructor(e) {
    this._wrapU = 1, this._wrapV = 1, this.wrapR = 1, this.anisotropicFilteringLevel = 4, this.delayLoadState = 0, this._texture = null, this._engine = null, this._cachedSize = Zt.Zero(), this._cachedBaseSize = Zt.Zero(), this._initialSamplingMode = 2, this._texture = Fn._IsRenderTargetWrapper(e) ? e.texture : e, this._texture && (this._engine = this._texture.getEngine());
  }
  /**
   * Get if the texture is ready to be used (downloaded, converted, mip mapped...).
   * @returns true if fully ready
   */
  isReady() {
    return this.delayLoadState === 4 ? (this.delayLoad(), !1) : this._texture ? this._texture.isReady : !1;
  }
  /**
   * Triggers the load sequence in delayed load mode.
   */
  delayLoad() {
  }
  /**
   * Get the underlying lower level texture from Babylon.
   * @returns the internal texture
   */
  getInternalTexture() {
    return this._texture;
  }
  /**
   * Get the size of the texture.
   * @returns the texture size.
   */
  getSize() {
    if (this._texture) {
      if (this._texture.width)
        return this._cachedSize.width = this._texture.width, this._cachedSize.height = this._texture.height, this._cachedSize;
      if (this._texture._size)
        return this._cachedSize.width = this._texture._size, this._cachedSize.height = this._texture._size, this._cachedSize;
    }
    return this._cachedSize;
  }
  /**
   * Get the base size of the texture.
   * It can be different from the size if the texture has been resized for POT for instance
   * @returns the base size
   */
  getBaseSize() {
    return !this.isReady() || !this._texture ? (this._cachedBaseSize.width = 0, this._cachedBaseSize.height = 0, this._cachedBaseSize) : this._texture._size ? (this._cachedBaseSize.width = this._texture._size, this._cachedBaseSize.height = this._texture._size, this._cachedBaseSize) : (this._cachedBaseSize.width = this._texture.baseWidth, this._cachedBaseSize.height = this._texture.baseHeight, this._cachedBaseSize);
  }
  /**
   * Get the current sampling mode associated with the texture.
   */
  get samplingMode() {
    return this._texture ? this._texture.samplingMode : this._initialSamplingMode;
  }
  /**
   * Update the sampling mode of the texture.
   * Default is Trilinear mode.
   *
   * | Value | Type               | Description |
   * | ----- | ------------------ | ----------- |
   * | 1     | NEAREST_SAMPLINGMODE or NEAREST_NEAREST_MIPLINEAR  | Nearest is: mag = nearest, min = nearest, mip = linear |
   * | 2     | BILINEAR_SAMPLINGMODE or LINEAR_LINEAR_MIPNEAREST | Bilinear is: mag = linear, min = linear, mip = nearest |
   * | 3     | TRILINEAR_SAMPLINGMODE or LINEAR_LINEAR_MIPLINEAR | Trilinear is: mag = linear, min = linear, mip = linear |
   * | 4     | NEAREST_NEAREST_MIPNEAREST |             |
   * | 5    | NEAREST_LINEAR_MIPNEAREST |             |
   * | 6    | NEAREST_LINEAR_MIPLINEAR |             |
   * | 7    | NEAREST_LINEAR |             |
   * | 8    | NEAREST_NEAREST |             |
   * | 9   | LINEAR_NEAREST_MIPNEAREST |             |
   * | 10   | LINEAR_NEAREST_MIPLINEAR |             |
   * | 11   | LINEAR_LINEAR |             |
   * | 12   | LINEAR_NEAREST |             |
   *
   *    > _mag_: magnification filter (close to the viewer)
   *    > _min_: minification filter (far from the viewer)
   *    > _mip_: filter used between mip map levels
   *@param samplingMode Define the new sampling mode of the texture
   */
  updateSamplingMode(e) {
    this._texture && this._engine && this._engine.updateTextureSamplingMode(e, this._texture);
  }
  /**
   * Release and destroy the underlying lower level texture aka internalTexture.
   */
  releaseInternalTexture() {
    this._texture && (this._texture.dispose(), this._texture = null);
  }
  /**
   * Dispose the texture and release its associated resources.
   */
  dispose() {
    this._texture && (this.releaseInternalTexture(), this._engine = null);
  }
}
class Ve extends Fn {
  /**
   * Define if the texture is having a usable alpha value (can be use for transparency or glossiness for instance).
   */
  set hasAlpha(e) {
    this._hasAlpha !== e && (this._hasAlpha = e, this._scene && this._scene.markAllMaterialsAsDirty(1, (t) => t.hasTexture(this)));
  }
  get hasAlpha() {
    return this._hasAlpha;
  }
  /**
   * Defines if the alpha value should be determined via the rgb values.
   * If true the luminance of the pixel might be used to find the corresponding alpha value.
   */
  set getAlphaFromRGB(e) {
    this._getAlphaFromRGB !== e && (this._getAlphaFromRGB = e, this._scene && this._scene.markAllMaterialsAsDirty(1, (t) => t.hasTexture(this)));
  }
  get getAlphaFromRGB() {
    return this._getAlphaFromRGB;
  }
  /**
   * Define the UV channel to use starting from 0 and defaulting to 0.
   * This is part of the texture as textures usually maps to one uv set.
   */
  set coordinatesIndex(e) {
    this._coordinatesIndex !== e && (this._coordinatesIndex = e, this._scene && this._scene.markAllMaterialsAsDirty(1, (t) => t.hasTexture(this)));
  }
  get coordinatesIndex() {
    return this._coordinatesIndex;
  }
  /**
   * How a texture is mapped.
   *
   * | Value | Type                                | Description |
   * | ----- | ----------------------------------- | ----------- |
   * | 0     | EXPLICIT_MODE                       |             |
   * | 1     | SPHERICAL_MODE                      |             |
   * | 2     | PLANAR_MODE                         |             |
   * | 3     | CUBIC_MODE                          |             |
   * | 4     | PROJECTION_MODE                     |             |
   * | 5     | SKYBOX_MODE                         |             |
   * | 6     | INVCUBIC_MODE                       |             |
   * | 7     | EQUIRECTANGULAR_MODE                |             |
   * | 8     | FIXED_EQUIRECTANGULAR_MODE          |             |
   * | 9     | FIXED_EQUIRECTANGULAR_MIRRORED_MODE |             |
   */
  set coordinatesMode(e) {
    this._coordinatesMode !== e && (this._coordinatesMode = e, this._scene && this._scene.markAllMaterialsAsDirty(1, (t) => t.hasTexture(this)));
  }
  get coordinatesMode() {
    return this._coordinatesMode;
  }
  /**
   * | Value | Type               | Description |
   * | ----- | ------------------ | ----------- |
   * | 0     | CLAMP_ADDRESSMODE  |             |
   * | 1     | WRAP_ADDRESSMODE   |             |
   * | 2     | MIRROR_ADDRESSMODE |             |
   */
  get wrapU() {
    return this._wrapU;
  }
  set wrapU(e) {
    this._wrapU = e;
  }
  /**
   * | Value | Type               | Description |
   * | ----- | ------------------ | ----------- |
   * | 0     | CLAMP_ADDRESSMODE  |             |
   * | 1     | WRAP_ADDRESSMODE   |             |
   * | 2     | MIRROR_ADDRESSMODE |             |
   */
  get wrapV() {
    return this._wrapV;
  }
  set wrapV(e) {
    this._wrapV = e;
  }
  /**
   * Define if the texture is a cube texture or if false a 2d texture.
   */
  get isCube() {
    return this._texture ? this._texture.isCube : this._isCube;
  }
  set isCube(e) {
    this._texture ? this._texture.isCube = e : this._isCube = e;
  }
  /**
   * Define if the texture is a 3d texture (webgl 2) or if false a 2d texture.
   */
  get is3D() {
    return this._texture ? this._texture.is3D : !1;
  }
  set is3D(e) {
    this._texture && (this._texture.is3D = e);
  }
  /**
   * Define if the texture is a 2d array texture (webgl 2) or if false a 2d texture.
   */
  get is2DArray() {
    return this._texture ? this._texture.is2DArray : !1;
  }
  set is2DArray(e) {
    this._texture && (this._texture.is2DArray = e);
  }
  /**
   * Define if the texture contains data in gamma space (most of the png/jpg aside bump).
   * HDR texture are usually stored in linear space.
   * This only impacts the PBR and Background materials
   */
  get gammaSpace() {
    if (this._texture)
      this._texture._gammaSpace === null && (this._texture._gammaSpace = this._gammaSpace);
    else
      return this._gammaSpace;
    return this._texture._gammaSpace && !this._texture._useSRGBBuffer;
  }
  set gammaSpace(e) {
    if (this._texture) {
      if (this._texture._gammaSpace === e)
        return;
      this._texture._gammaSpace = e;
    } else {
      if (this._gammaSpace === e)
        return;
      this._gammaSpace = e;
    }
    this._markAllSubMeshesAsTexturesDirty();
  }
  /**
   * Gets or sets whether or not the texture contains RGBD data.
   */
  get isRGBD() {
    return this._texture != null && this._texture._isRGBD;
  }
  set isRGBD(e) {
    this._texture && (this._texture._isRGBD = e);
  }
  /**
   * Are mip maps generated for this texture or not.
   */
  get noMipmap() {
    return !1;
  }
  /**
   * With prefiltered texture, defined the offset used during the prefiltering steps.
   */
  get lodGenerationOffset() {
    return this._texture ? this._texture._lodGenerationOffset : 0;
  }
  set lodGenerationOffset(e) {
    this._texture && (this._texture._lodGenerationOffset = e);
  }
  /**
   * With prefiltered texture, defined the scale used during the prefiltering steps.
   */
  get lodGenerationScale() {
    return this._texture ? this._texture._lodGenerationScale : 0;
  }
  set lodGenerationScale(e) {
    this._texture && (this._texture._lodGenerationScale = e);
  }
  /**
   * With prefiltered texture, defined if the specular generation is based on a linear ramp.
   * By default we are using a log2 of the linear roughness helping to keep a better resolution for
   * average roughness values.
   */
  get linearSpecularLOD() {
    return this._texture ? this._texture._linearSpecularLOD : !1;
  }
  set linearSpecularLOD(e) {
    this._texture && (this._texture._linearSpecularLOD = e);
  }
  /**
   * In case a better definition than spherical harmonics is required for the diffuse part of the environment.
   * You can set the irradiance texture to rely on a texture instead of the spherical approach.
   * This texture need to have the same characteristics than its parent (Cube vs 2d, coordinates mode, Gamma/Linear, RGBD).
   */
  get irradianceTexture() {
    return this._texture ? this._texture._irradianceTexture : null;
  }
  set irradianceTexture(e) {
    this._texture && (this._texture._irradianceTexture = e);
  }
  /**
   * Define the unique id of the texture in the scene.
   */
  get uid() {
    return this._uid || (this._uid = wn()), this._uid;
  }
  /**
   * Return a string representation of the texture.
   * @returns the texture as a string
   */
  toString() {
    return this.name;
  }
  /**
   * Get the class name of the texture.
   * @returns "BaseTexture"
   */
  getClassName() {
    return "BaseTexture";
  }
  /**
   * Callback triggered when the texture has been disposed.
   * Kept for back compatibility, you can use the onDisposeObservable instead.
   */
  set onDispose(e) {
    this._onDisposeObserver && this.onDisposeObservable.remove(this._onDisposeObserver), this._onDisposeObserver = this.onDisposeObservable.add(e);
  }
  /**
   * Define if the texture is preventing a material to render or not.
   * If not and the texture is not ready, the engine will use a default black texture instead.
   */
  get isBlocking() {
    return !0;
  }
  /**
   * Was there any loading error?
   */
  get loadingError() {
    return this._loadingError;
  }
  /**
   * If a loading error occurred this object will be populated with information about the error.
   */
  get errorObject() {
    return this._errorObject;
  }
  /**
   * Instantiates a new BaseTexture.
   * Base class of all the textures in babylon.
   * It groups all the common properties the materials, post process, lights... might need
   * in order to make a correct use of the texture.
   * @param sceneOrEngine Define the scene or engine the texture belongs to
   * @param internalTexture Define the internal texture associated with the texture
   */
  constructor(e, t = null) {
    super(null), this.metadata = null, this.reservedDataStore = null, this._hasAlpha = !1, this._getAlphaFromRGB = !1, this.level = 1, this._coordinatesIndex = 0, this.optimizeUVAllocation = !0, this._coordinatesMode = 0, this.wrapR = 1, this.anisotropicFilteringLevel = Ve.DEFAULT_ANISOTROPIC_FILTERING_LEVEL, this._isCube = !1, this._gammaSpace = !0, this.invertZ = !1, this.lodLevelInAlpha = !1, this.isRenderTarget = !1, this._prefiltered = !1, this._forceSerialize = !1, this.animations = new Array(), this.onDisposeObservable = new N(), this._onDisposeObserver = null, this._scene = null, this._uid = null, this._parentContainer = null, this._loadingError = !1, e ? Ve._IsScene(e) ? this._scene = e : this._engine = e : this._scene = de.LastCreatedScene, this._scene && (this.uniqueId = this._scene.getUniqueId(), this._scene.addTexture(this), this._engine = this._scene.getEngine()), this._texture = t, this._uid = null;
  }
  /**
   * Get the scene the texture belongs to.
   * @returns the scene or null if undefined
   */
  getScene() {
    return this._scene;
  }
  /** @internal */
  _getEngine() {
    return this._engine;
  }
  /**
   * Checks if the texture has the same transform matrix than another texture
   * @param texture texture to check against
   * @returns true if the transforms are the same, else false
   */
  checkTransformsAreIdentical(e) {
    return e !== null;
  }
  /**
   * Get the texture transform matrix used to offset tile the texture for instance.
   * @returns the transformation matrix
   */
  getTextureMatrix() {
    return I.IdentityReadOnly;
  }
  /**
   * Get the texture reflection matrix used to rotate/transform the reflection.
   * @returns the reflection matrix
   */
  getReflectionTextureMatrix() {
    return I.IdentityReadOnly;
  }
  /**
   * Gets a suitable rotate/transform matrix when the texture is used for refraction.
   * There's a separate function from getReflectionTextureMatrix because refraction requires a special configuration of the matrix in right-handed mode.
   * @returns The refraction matrix
   */
  getRefractionTextureMatrix() {
    return this.getReflectionTextureMatrix();
  }
  /**
   * Get if the texture is ready to be consumed (either it is ready or it is not blocking)
   * @returns true if ready, not blocking or if there was an error loading the texture
   */
  isReadyOrNotBlocking() {
    return !this.isBlocking || this.isReady() || this.loadingError;
  }
  /**
   * Scales the texture if is `canRescale()`
   * @param ratio the resize factor we want to use to rescale
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  scale(e) {
  }
  /**
   * Get if the texture can rescale.
   */
  get canRescale() {
    return !1;
  }
  /**
   * @internal
   */
  _getFromCache(e, t, i, s, r, n) {
    const a = this._getEngine();
    if (!a)
      return null;
    const o = a._getUseSRGBBuffer(!!r, t), l = a.getLoadedTexturesCache();
    for (let c = 0; c < l.length; c++) {
      const u = l[c];
      if ((r === void 0 || o === u._useSRGBBuffer) && (s === void 0 || s === u.invertY) && u.url === e && u.generateMipMaps === !t && (!i || i === u.samplingMode) && (n === void 0 || n === u.isCube))
        return u.incrementReferences(), u;
    }
    return null;
  }
  /** @internal */
  _rebuild() {
  }
  /**
   * Clones the texture.
   * @returns the cloned texture
   */
  clone() {
    return null;
  }
  /**
   * Get the texture underlying type (INT, FLOAT...)
   */
  get textureType() {
    return this._texture && this._texture.type !== void 0 ? this._texture.type : 0;
  }
  /**
   * Get the texture underlying format (RGB, RGBA...)
   */
  get textureFormat() {
    return this._texture && this._texture.format !== void 0 ? this._texture.format : 5;
  }
  /**
   * Indicates that textures need to be re-calculated for all materials
   */
  _markAllSubMeshesAsTexturesDirty() {
    const e = this.getScene();
    e && e.markAllMaterialsAsDirty(1);
  }
  /**
   * Reads the pixels stored in the webgl texture and returns them as an ArrayBuffer.
   * This will returns an RGBA array buffer containing either in values (0-255) or
   * float values (0-1) depending of the underlying buffer type.
   * @param faceIndex defines the face of the texture to read (in case of cube texture)
   * @param level defines the LOD level of the texture to read (in case of Mip Maps)
   * @param buffer defines a user defined buffer to fill with data (can be null)
   * @param flushRenderer true to flush the renderer from the pending commands before reading the pixels
   * @param noDataConversion false to convert the data to Uint8Array (if texture type is UNSIGNED_BYTE) or to Float32Array (if texture type is anything but UNSIGNED_BYTE). If true, the type of the generated buffer (if buffer==null) will depend on the type of the texture
   * @param x defines the region x coordinates to start reading from (default to 0)
   * @param y defines the region y coordinates to start reading from (default to 0)
   * @param width defines the region width to read from (default to the texture size at level)
   * @param height defines the region width to read from (default to the texture size at level)
   * @returns The Array buffer promise containing the pixels data.
   */
  readPixels(e = 0, t = 0, i = null, s = !0, r = !1, n = 0, a = 0, o = Number.MAX_VALUE, l = Number.MAX_VALUE) {
    if (!this._texture)
      return null;
    const c = this._getEngine();
    if (!c)
      return null;
    const u = this.getSize();
    let d = u.width, f = u.height;
    t !== 0 && (d = d / Math.pow(2, t), f = f / Math.pow(2, t), d = Math.round(d), f = Math.round(f)), o = Math.min(d, o), l = Math.min(f, l);
    try {
      return this._texture.isCube ? c._readTexturePixels(this._texture, o, l, e, t, i, s, r, n, a) : c._readTexturePixels(this._texture, o, l, -1, t, i, s, r, n, a);
    } catch {
      return null;
    }
  }
  /**
   * @internal
   */
  _readPixelsSync(e = 0, t = 0, i = null, s = !0, r = !1) {
    if (!this._texture)
      return null;
    const n = this.getSize();
    let a = n.width, o = n.height;
    const l = this._getEngine();
    if (!l)
      return null;
    t != 0 && (a = a / Math.pow(2, t), o = o / Math.pow(2, t), a = Math.round(a), o = Math.round(o));
    try {
      return this._texture.isCube ? l._readTexturePixelsSync(this._texture, a, o, e, t, i, s, r) : l._readTexturePixelsSync(this._texture, a, o, -1, t, i, s, r);
    } catch {
      return null;
    }
  }
  /** @internal */
  get _lodTextureHigh() {
    return this._texture ? this._texture._lodTextureHigh : null;
  }
  /** @internal */
  get _lodTextureMid() {
    return this._texture ? this._texture._lodTextureMid : null;
  }
  /** @internal */
  get _lodTextureLow() {
    return this._texture ? this._texture._lodTextureLow : null;
  }
  /**
   * Dispose the texture and release its associated resources.
   */
  dispose() {
    if (this._scene) {
      this._scene.stopAnimation && this._scene.stopAnimation(this), this._scene.removePendingData(this);
      const e = this._scene.textures.indexOf(this);
      if (e >= 0 && this._scene.textures.splice(e, 1), this._scene.onTextureRemovedObservable.notifyObservers(this), this._scene = null, this._parentContainer) {
        const t = this._parentContainer.textures.indexOf(this);
        t > -1 && this._parentContainer.textures.splice(t, 1), this._parentContainer = null;
      }
    }
    this.onDisposeObservable.notifyObservers(this), this.onDisposeObservable.clear(), this.metadata = null, super.dispose();
  }
  /**
   * Serialize the texture into a JSON representation that can be parsed later on.
   * @param allowEmptyName True to force serialization even if name is empty. Default: false
   * @returns the JSON representation of the texture
   */
  serialize(e = !1) {
    if (!this.name && !e)
      return null;
    const t = le.Serialize(this);
    return le.AppendSerializedAnimations(this, t), t;
  }
  /**
   * Helper function to be called back once a list of texture contains only ready textures.
   * @param textures Define the list of textures to wait for
   * @param callback Define the callback triggered once the entire list will be ready
   */
  static WhenAllReady(e, t) {
    let i = e.length;
    if (i === 0) {
      t();
      return;
    }
    for (let s = 0; s < e.length; s++) {
      const r = e[s];
      if (r.isReady())
        --i === 0 && t();
      else {
        const n = r.onLoadObservable;
        n ? n.addOnce(() => {
          --i === 0 && t();
        }) : --i === 0 && t();
      }
    }
  }
  static _IsScene(e) {
    return e.getClassName() === "Scene";
  }
}
Ve.DEFAULT_ANISOTROPIC_FILTERING_LEVEL = 4;
E([
  R()
], Ve.prototype, "uniqueId", void 0);
E([
  R()
], Ve.prototype, "name", void 0);
E([
  R()
], Ve.prototype, "metadata", void 0);
E([
  R("hasAlpha")
], Ve.prototype, "_hasAlpha", void 0);
E([
  R("getAlphaFromRGB")
], Ve.prototype, "_getAlphaFromRGB", void 0);
E([
  R()
], Ve.prototype, "level", void 0);
E([
  R("coordinatesIndex")
], Ve.prototype, "_coordinatesIndex", void 0);
E([
  R()
], Ve.prototype, "optimizeUVAllocation", void 0);
E([
  R("coordinatesMode")
], Ve.prototype, "_coordinatesMode", void 0);
E([
  R()
], Ve.prototype, "wrapU", null);
E([
  R()
], Ve.prototype, "wrapV", null);
E([
  R()
], Ve.prototype, "wrapR", void 0);
E([
  R()
], Ve.prototype, "anisotropicFilteringLevel", void 0);
E([
  R()
], Ve.prototype, "isCube", null);
E([
  R()
], Ve.prototype, "is3D", null);
E([
  R()
], Ve.prototype, "is2DArray", null);
E([
  R()
], Ve.prototype, "gammaSpace", null);
E([
  R()
], Ve.prototype, "invertZ", void 0);
E([
  R()
], Ve.prototype, "lodLevelInAlpha", void 0);
E([
  R()
], Ve.prototype, "lodGenerationOffset", null);
E([
  R()
], Ve.prototype, "lodGenerationScale", null);
E([
  R()
], Ve.prototype, "linearSpecularLOD", null);
E([
  Jt()
], Ve.prototype, "irradianceTexture", null);
E([
  R()
], Ve.prototype, "isRenderTarget", void 0);
function Ya(h, e, t = !1) {
  const i = e.width, s = e.height;
  if (h instanceof Float32Array) {
    let l = h.byteLength / h.BYTES_PER_ELEMENT;
    const c = new Uint8Array(l);
    for (; --l >= 0; ) {
      let u = h[l];
      u < 0 ? u = 0 : u > 1 && (u = 1), c[l] = u * 255;
    }
    h = c;
  }
  const r = document.createElement("canvas");
  r.width = i, r.height = s;
  const n = r.getContext("2d");
  if (!n)
    return null;
  const a = n.createImageData(i, s);
  if (a.data.set(h), n.putImageData(a, 0, 0), t) {
    const l = document.createElement("canvas");
    l.width = i, l.height = s;
    const c = l.getContext("2d");
    return c ? (c.translate(0, s), c.scale(1, -1), c.drawImage(r, 0, 0), l.toDataURL("image/png")) : null;
  }
  return r.toDataURL("image/png");
}
function Hl(h, e = 0, t = 0) {
  const i = h.getInternalTexture();
  if (!i)
    return null;
  const s = h._readPixelsSync(e, t);
  return s ? Ya(s, h.getSize(), i.invertY) : null;
}
async function Kl(h, e = 0, t = 0) {
  const i = h.getInternalTexture();
  if (!i)
    return null;
  const s = await h.readPixels(e, t);
  return s ? Ya(s, h.getSize(), i.invertY) : null;
}
class W extends Ve {
  /**
   * Are mip maps generated for this texture or not.
   */
  get noMipmap() {
    return this._noMipmap;
  }
  /** Returns the texture mime type if it was defined by a loader (undefined else) */
  get mimeType() {
    return this._mimeType;
  }
  /**
   * Is the texture preventing material to render while loading.
   * If false, a default texture will be used instead of the loading one during the preparation step.
   */
  set isBlocking(e) {
    this._isBlocking = e;
  }
  get isBlocking() {
    return this._isBlocking;
  }
  /**
   * Gets a boolean indicating if the texture needs to be inverted on the y axis during loading
   */
  get invertY() {
    return this._invertY;
  }
  /**
   * Instantiates a new texture.
   * This represents a texture in babylon. It can be easily loaded from a network, base64 or html input.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/materials_introduction#texture
   * @param url defines the url of the picture to load as a texture
   * @param sceneOrEngine defines the scene or engine the texture will belong to
   * @param noMipmapOrOptions defines if the texture will require mip maps or not or set of all options to create the texture
   * @param invertY defines if the texture needs to be inverted on the y axis during loading
   * @param samplingMode defines the sampling mode we want for the texture while fetching from it (Texture.NEAREST_SAMPLINGMODE...)
   * @param onLoad defines a callback triggered when the texture has been loaded
   * @param onError defines a callback triggered when an error occurred during the loading session
   * @param buffer defines the buffer to load the texture from in case the texture is loaded from a buffer representation
   * @param deleteBuffer defines if the buffer we are loading the texture from should be deleted after load
   * @param format defines the format of the texture we are trying to load (Engine.TEXTUREFORMAT_RGBA...)
   * @param mimeType defines an optional mime type information
   * @param loaderOptions options to be passed to the loader
   * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
   * @param forcedExtension defines the extension to use to pick the right loader
   */
  constructor(e, t, i, s, r = W.TRILINEAR_SAMPLINGMODE, n = null, a = null, o = null, l = !1, c, u, d, f, _) {
    var g, m, y, x, A, T, M, b, S;
    super(t), this.url = null, this.uOffset = 0, this.vOffset = 0, this.uScale = 1, this.vScale = 1, this.uAng = 0, this.vAng = 0, this.wAng = 0, this.uRotationCenter = 0.5, this.vRotationCenter = 0.5, this.wRotationCenter = 0.5, this.homogeneousRotationInUVTransform = !1, this.inspectableCustomProperties = null, this._noMipmap = !1, this._invertY = !1, this._rowGenerationMatrix = null, this._cachedTextureMatrix = null, this._projectionModeMatrix = null, this._t0 = null, this._t1 = null, this._t2 = null, this._cachedUOffset = -1, this._cachedVOffset = -1, this._cachedUScale = 0, this._cachedVScale = 0, this._cachedUAng = -1, this._cachedVAng = -1, this._cachedWAng = -1, this._cachedReflectionProjectionMatrixId = -1, this._cachedURotationCenter = -1, this._cachedVRotationCenter = -1, this._cachedWRotationCenter = -1, this._cachedHomogeneousRotationInUVTransform = !1, this._cachedReflectionTextureMatrix = null, this._cachedReflectionUOffset = -1, this._cachedReflectionVOffset = -1, this._cachedReflectionUScale = 0, this._cachedReflectionVScale = 0, this._cachedReflectionCoordinatesMode = -1, this._buffer = null, this._deleteBuffer = !1, this._format = null, this._delayedOnLoad = null, this._delayedOnError = null, this.onLoadObservable = new N(), this._isBlocking = !0, this.name = e || "", this.url = e;
    let P, D = !1, O = null;
    typeof i == "object" && i !== null ? (P = (g = i.noMipmap) !== null && g !== void 0 ? g : !1, s = (m = i.invertY) !== null && m !== void 0 ? m : !ct.UseOpenGLOrientationForUV, r = (y = i.samplingMode) !== null && y !== void 0 ? y : W.TRILINEAR_SAMPLINGMODE, n = (x = i.onLoad) !== null && x !== void 0 ? x : null, a = (A = i.onError) !== null && A !== void 0 ? A : null, o = (T = i.buffer) !== null && T !== void 0 ? T : null, l = (M = i.deleteBuffer) !== null && M !== void 0 ? M : !1, c = i.format, u = i.mimeType, d = i.loaderOptions, f = i.creationFlags, D = (b = i.useSRGBBuffer) !== null && b !== void 0 ? b : !1, O = (S = i.internalTexture) !== null && S !== void 0 ? S : null) : P = !!i, this._noMipmap = P, this._invertY = s === void 0 ? !ct.UseOpenGLOrientationForUV : s, this._initialSamplingMode = r, this._buffer = o, this._deleteBuffer = l, this._mimeType = u, this._loaderOptions = d, this._creationFlags = f, this._useSRGBBuffer = D, this._forcedExtension = _, c && (this._format = c);
    const X = this.getScene(), k = this._getEngine();
    if (!k)
      return;
    k.onBeforeTextureInitObservable.notifyObservers(this);
    const Y = () => {
      this._texture && (this._texture._invertVScale && (this.vScale *= -1, this.vOffset += 1), this._texture._cachedWrapU !== null && (this.wrapU = this._texture._cachedWrapU, this._texture._cachedWrapU = null), this._texture._cachedWrapV !== null && (this.wrapV = this._texture._cachedWrapV, this._texture._cachedWrapV = null), this._texture._cachedWrapR !== null && (this.wrapR = this._texture._cachedWrapR, this._texture._cachedWrapR = null)), this.onLoadObservable.hasObservers() && this.onLoadObservable.notifyObservers(this), n && n(), !this.isBlocking && X && X.resetCachedMaterial();
    }, se = (Te, ve) => {
      this._loadingError = !0, this._errorObject = { message: Te, exception: ve }, a && a(Te, ve), W.OnTextureLoadErrorObservable.notifyObservers(this);
    };
    if (!this.url && !O) {
      this._delayedOnLoad = Y, this._delayedOnError = se;
      return;
    }
    if (this._texture = O ?? this._getFromCache(this.url, P, r, this._invertY, D), this._texture)
      if (this._texture.isReady)
        xr.SetImmediate(() => Y());
      else {
        const Te = this._texture.onLoadedObservable.add(Y);
        this._texture.onErrorObservable.add((ve) => {
          var Oe;
          se(ve.message, ve.exception), (Oe = this._texture) === null || Oe === void 0 || Oe.onLoadedObservable.remove(Te);
        });
      }
    else if (!X || !X.useDelayedTextureLoading) {
      try {
        this._texture = k.createTexture(this.url, P, this._invertY, X, r, Y, se, this._buffer, void 0, this._format, this._forcedExtension, u, d, f, D);
      } catch (Te) {
        throw se("error loading", Te), Te;
      }
      l && (this._buffer = null);
    } else
      this.delayLoadState = 4, this._delayedOnLoad = Y, this._delayedOnError = se;
  }
  /**
   * Update the url (and optional buffer) of this texture if url was null during construction.
   * @param url the url of the texture
   * @param buffer the buffer of the texture (defaults to null)
   * @param onLoad callback called when the texture is loaded  (defaults to null)
   * @param forcedExtension defines the extension to use to pick the right loader
   */
  updateURL(e, t = null, i, s) {
    this.url && (this.releaseInternalTexture(), this.getScene().markAllMaterialsAsDirty(1)), (!this.name || this.name.startsWith("data:")) && (this.name = e), this.url = e, this._buffer = t, this._forcedExtension = s, this.delayLoadState = 4, i && (this._delayedOnLoad = i), this.delayLoad();
  }
  /**
   * Finish the loading sequence of a texture flagged as delayed load.
   * @internal
   */
  delayLoad() {
    if (this.delayLoadState !== 4)
      return;
    const e = this.getScene();
    e && (this.delayLoadState = 1, this._texture = this._getFromCache(this.url, this._noMipmap, this.samplingMode, this._invertY, this._useSRGBBuffer), this._texture ? this._delayedOnLoad && (this._texture.isReady ? xr.SetImmediate(this._delayedOnLoad) : this._texture.onLoadedObservable.add(this._delayedOnLoad)) : (this._texture = e.getEngine().createTexture(this.url, this._noMipmap, this._invertY, e, this.samplingMode, this._delayedOnLoad, this._delayedOnError, this._buffer, null, this._format, this._forcedExtension, this._mimeType, this._loaderOptions, this._creationFlags, this._useSRGBBuffer), this._deleteBuffer && (this._buffer = null)), this._delayedOnLoad = null, this._delayedOnError = null);
  }
  _prepareRowForTextureGeneration(e, t, i, s) {
    e *= this._cachedUScale, t *= this._cachedVScale, e -= this.uRotationCenter * this._cachedUScale, t -= this.vRotationCenter * this._cachedVScale, i -= this.wRotationCenter, p.TransformCoordinatesFromFloatsToRef(e, t, i, this._rowGenerationMatrix, s), s.x += this.uRotationCenter * this._cachedUScale + this._cachedUOffset, s.y += this.vRotationCenter * this._cachedVScale + this._cachedVOffset, s.z += this.wRotationCenter;
  }
  /**
   * Checks if the texture has the same transform matrix than another texture
   * @param texture texture to check against
   * @returns true if the transforms are the same, else false
   */
  checkTransformsAreIdentical(e) {
    return e !== null && this.uOffset === e.uOffset && this.vOffset === e.vOffset && this.uScale === e.uScale && this.vScale === e.vScale && this.uAng === e.uAng && this.vAng === e.vAng && this.wAng === e.wAng;
  }
  /**
   * Get the current texture matrix which includes the requested offsetting, tiling and rotation components.
   * @param uBase
   * @returns the transform matrix of the texture.
   */
  getTextureMatrix(e = 1) {
    if (this.uOffset === this._cachedUOffset && this.vOffset === this._cachedVOffset && this.uScale * e === this._cachedUScale && this.vScale === this._cachedVScale && this.uAng === this._cachedUAng && this.vAng === this._cachedVAng && this.wAng === this._cachedWAng && this.uRotationCenter === this._cachedURotationCenter && this.vRotationCenter === this._cachedVRotationCenter && this.wRotationCenter === this._cachedWRotationCenter && this.homogeneousRotationInUVTransform === this._cachedHomogeneousRotationInUVTransform)
      return this._cachedTextureMatrix;
    this._cachedUOffset = this.uOffset, this._cachedVOffset = this.vOffset, this._cachedUScale = this.uScale * e, this._cachedVScale = this.vScale, this._cachedUAng = this.uAng, this._cachedVAng = this.vAng, this._cachedWAng = this.wAng, this._cachedURotationCenter = this.uRotationCenter, this._cachedVRotationCenter = this.vRotationCenter, this._cachedWRotationCenter = this.wRotationCenter, this._cachedHomogeneousRotationInUVTransform = this.homogeneousRotationInUVTransform, (!this._cachedTextureMatrix || !this._rowGenerationMatrix) && (this._cachedTextureMatrix = I.Zero(), this._rowGenerationMatrix = new I(), this._t0 = p.Zero(), this._t1 = p.Zero(), this._t2 = p.Zero()), I.RotationYawPitchRollToRef(this.vAng, this.uAng, this.wAng, this._rowGenerationMatrix), this.homogeneousRotationInUVTransform ? (I.TranslationToRef(-this._cachedURotationCenter, -this._cachedVRotationCenter, -this._cachedWRotationCenter, C.Matrix[0]), I.TranslationToRef(this._cachedURotationCenter, this._cachedVRotationCenter, this._cachedWRotationCenter, C.Matrix[1]), I.ScalingToRef(this._cachedUScale, this._cachedVScale, 0, C.Matrix[2]), I.TranslationToRef(this._cachedUOffset, this._cachedVOffset, 0, C.Matrix[3]), C.Matrix[0].multiplyToRef(this._rowGenerationMatrix, this._cachedTextureMatrix), this._cachedTextureMatrix.multiplyToRef(C.Matrix[1], this._cachedTextureMatrix), this._cachedTextureMatrix.multiplyToRef(C.Matrix[2], this._cachedTextureMatrix), this._cachedTextureMatrix.multiplyToRef(C.Matrix[3], this._cachedTextureMatrix), this._cachedTextureMatrix.setRowFromFloats(2, this._cachedTextureMatrix.m[12], this._cachedTextureMatrix.m[13], this._cachedTextureMatrix.m[14], 1)) : (this._prepareRowForTextureGeneration(0, 0, 0, this._t0), this._prepareRowForTextureGeneration(1, 0, 0, this._t1), this._prepareRowForTextureGeneration(0, 1, 0, this._t2), this._t1.subtractInPlace(this._t0), this._t2.subtractInPlace(this._t0), I.FromValuesToRef(this._t1.x, this._t1.y, this._t1.z, 0, this._t2.x, this._t2.y, this._t2.z, 0, this._t0.x, this._t0.y, this._t0.z, 0, 0, 0, 0, 1, this._cachedTextureMatrix));
    const t = this.getScene();
    return t ? (this.optimizeUVAllocation && t.markAllMaterialsAsDirty(1, (i) => i.hasTexture(this)), this._cachedTextureMatrix) : this._cachedTextureMatrix;
  }
  /**
   * Get the current matrix used to apply reflection. This is useful to rotate an environment texture for instance.
   * @returns The reflection texture transform
   */
  getReflectionTextureMatrix() {
    const e = this.getScene();
    if (!e)
      return this._cachedReflectionTextureMatrix;
    if (this.uOffset === this._cachedReflectionUOffset && this.vOffset === this._cachedReflectionVOffset && this.uScale === this._cachedReflectionUScale && this.vScale === this._cachedReflectionVScale && this.coordinatesMode === this._cachedReflectionCoordinatesMode)
      if (this.coordinatesMode === W.PROJECTION_MODE) {
        if (this._cachedReflectionProjectionMatrixId === e.getProjectionMatrix().updateFlag)
          return this._cachedReflectionTextureMatrix;
      } else
        return this._cachedReflectionTextureMatrix;
    this._cachedReflectionTextureMatrix || (this._cachedReflectionTextureMatrix = I.Zero()), this._projectionModeMatrix || (this._projectionModeMatrix = I.Zero());
    const t = this._cachedReflectionCoordinatesMode !== this.coordinatesMode;
    switch (this._cachedReflectionUOffset = this.uOffset, this._cachedReflectionVOffset = this.vOffset, this._cachedReflectionUScale = this.uScale, this._cachedReflectionVScale = this.vScale, this._cachedReflectionCoordinatesMode = this.coordinatesMode, this.coordinatesMode) {
      case W.PLANAR_MODE: {
        I.IdentityToRef(this._cachedReflectionTextureMatrix), this._cachedReflectionTextureMatrix[0] = this.uScale, this._cachedReflectionTextureMatrix[5] = this.vScale, this._cachedReflectionTextureMatrix[12] = this.uOffset, this._cachedReflectionTextureMatrix[13] = this.vOffset;
        break;
      }
      case W.PROJECTION_MODE: {
        I.FromValuesToRef(0.5, 0, 0, 0, 0, -0.5, 0, 0, 0, 0, 0, 0, 0.5, 0.5, 1, 1, this._projectionModeMatrix);
        const i = e.getProjectionMatrix();
        this._cachedReflectionProjectionMatrixId = i.updateFlag, i.multiplyToRef(this._projectionModeMatrix, this._cachedReflectionTextureMatrix);
        break;
      }
      default:
        I.IdentityToRef(this._cachedReflectionTextureMatrix);
        break;
    }
    return t && e.markAllMaterialsAsDirty(1, (i) => i.getActiveTextures().indexOf(this) !== -1), this._cachedReflectionTextureMatrix;
  }
  /**
   * Clones the texture.
   * @returns the cloned texture
   */
  clone() {
    const e = {
      noMipmap: this._noMipmap,
      invertY: this._invertY,
      samplingMode: this.samplingMode,
      onLoad: void 0,
      onError: void 0,
      buffer: this._texture ? this._texture._buffer : void 0,
      deleteBuffer: this._deleteBuffer,
      format: this.textureFormat,
      mimeType: this.mimeType,
      loaderOptions: this._loaderOptions,
      creationFlags: this._creationFlags,
      useSRGBBuffer: this._useSRGBBuffer
    };
    return le.Clone(() => new W(this._texture ? this._texture.url : null, this.getScene(), e), this);
  }
  /**
   * Serialize the texture to a JSON representation we can easily use in the respective Parse function.
   * @returns The JSON representation of the texture
   */
  serialize() {
    var e, t;
    const i = this.name;
    W.SerializeBuffers || this.name.startsWith("data:") && (this.name = ""), this.name.startsWith("data:") && this.url === this.name && (this.url = "");
    const s = super.serialize(W._SerializeInternalTextureUniqueId);
    return s ? ((W.SerializeBuffers || W.ForceSerializeBuffers) && (typeof this._buffer == "string" && this._buffer.substr(0, 5) === "data:" ? (s.base64String = this._buffer, s.name = s.name.replace("data:", "")) : this.url && this.url.startsWith("data:") && this._buffer instanceof Uint8Array ? s.base64String = "data:image/png;base64," + wa(this._buffer) : (W.ForceSerializeBuffers || this.url && this.url.startsWith("blob:") || this._forceSerialize) && (s.base64String = !this._engine || this._engine._features.supportSyncTextureRead ? Hl(this) : Kl(this))), s.invertY = this._invertY, s.samplingMode = this.samplingMode, s._creationFlags = this._creationFlags, s._useSRGBBuffer = this._useSRGBBuffer, W._SerializeInternalTextureUniqueId && (s.internalTextureUniqueId = (t = (e = this._texture) === null || e === void 0 ? void 0 : e.uniqueId) !== null && t !== void 0 ? t : void 0), this.name = i, s) : null;
  }
  /**
   * Get the current class name of the texture useful for serialization or dynamic coding.
   * @returns "Texture"
   */
  getClassName() {
    return "Texture";
  }
  /**
   * Dispose the texture and release its associated resources.
   */
  dispose() {
    super.dispose(), this.onLoadObservable.clear(), this._delayedOnLoad = null, this._delayedOnError = null, this._buffer = null;
  }
  /**
   * Parse the JSON representation of a texture in order to recreate the texture in the given scene.
   * @param parsedTexture Define the JSON representation of the texture
   * @param scene Define the scene the parsed texture should be instantiated in
   * @param rootUrl Define the root url of the parsing sequence in the case of relative dependencies
   * @returns The parsed texture if successful
   */
  static Parse(e, t, i) {
    if (e.customType) {
      const l = Cs.Instantiate(e.customType).Parse(e, t, i);
      return e.samplingMode && l.updateSamplingMode && l._samplingMode && l._samplingMode !== e.samplingMode && l.updateSamplingMode(e.samplingMode), l;
    }
    if (e.isCube && !e.isRenderTarget)
      return W._CubeTextureParser(e, t, i);
    const s = e.internalTextureUniqueId !== void 0;
    if (!e.name && !e.isRenderTarget && !s)
      return null;
    let r;
    if (s) {
      const o = t.getEngine().getLoadedTexturesCache();
      for (const l of o)
        if (l.uniqueId === e.internalTextureUniqueId) {
          r = l;
          break;
        }
    }
    const n = (o) => {
      var l;
      if (o && o._texture && (o._texture._cachedWrapU = null, o._texture._cachedWrapV = null, o._texture._cachedWrapR = null), e.samplingMode) {
        const c = e.samplingMode;
        o && o.samplingMode !== c && o.updateSamplingMode(c);
      }
      if (o && e.animations)
        for (let c = 0; c < e.animations.length; c++) {
          const u = e.animations[c], d = si("BABYLON.Animation");
          d && o.animations.push(d.Parse(u));
        }
      s && !r && ((l = o == null ? void 0 : o._texture) === null || l === void 0 || l._setUniqueId(e.internalTextureUniqueId));
    };
    return le.Parse(() => {
      var o, l, c;
      let u = !0;
      if (e.noMipmap && (u = !1), e.mirrorPlane) {
        const d = W._CreateMirror(e.name, e.renderTargetSize, t, u);
        return d._waitingRenderList = e.renderList, d.mirrorPlane = Dt.FromArray(e.mirrorPlane), n(d), d;
      } else if (e.isRenderTarget) {
        let d = null;
        if (e.isCube) {
          if (t.reflectionProbes)
            for (let f = 0; f < t.reflectionProbes.length; f++) {
              const _ = t.reflectionProbes[f];
              if (_.name === e.name)
                return _.cubeTexture;
            }
        } else
          d = W._CreateRenderTargetTexture(e.name, e.renderTargetSize, t, u, (o = e._creationFlags) !== null && o !== void 0 ? o : 0), d._waitingRenderList = e.renderList;
        return n(d), d;
      } else {
        let d;
        if (e.base64String && !r)
          d = W.CreateFromBase64String(e.base64String, e.base64String, t, !u, e.invertY, e.samplingMode, () => {
            n(d);
          }, (l = e._creationFlags) !== null && l !== void 0 ? l : 0, (c = e._useSRGBBuffer) !== null && c !== void 0 ? c : !1), d.name = e.name;
        else {
          let f;
          e.name && (e.name.indexOf("://") > 0 || e.name.startsWith("data:")) ? f = e.name : f = i + e.name, e.url && (e.url.startsWith("data:") || W.UseSerializedUrlIfAny) && (f = e.url);
          const _ = {
            noMipmap: !u,
            invertY: e.invertY,
            samplingMode: e.samplingMode,
            onLoad: () => {
              n(d);
            },
            internalTexture: r
          };
          d = new W(f, t, _);
        }
        return d;
      }
    }, e, t);
  }
  /**
   * Creates a texture from its base 64 representation.
   * @param data Define the base64 payload without the data: prefix
   * @param name Define the name of the texture in the scene useful fo caching purpose for instance
   * @param scene Define the scene the texture should belong to
   * @param noMipmapOrOptions defines if the texture will require mip maps or not or set of all options to create the texture
   * @param invertY define if the texture needs to be inverted on the y axis during loading
   * @param samplingMode define the sampling mode we want for the texture while fetching from it (Texture.NEAREST_SAMPLINGMODE...)
   * @param onLoad define a callback triggered when the texture has been loaded
   * @param onError define a callback triggered when an error occurred during the loading session
   * @param format define the format of the texture we are trying to load (Engine.TEXTUREFORMAT_RGBA...)
   * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
   * @returns the created texture
   */
  static CreateFromBase64String(e, t, i, s, r, n = W.TRILINEAR_SAMPLINGMODE, a = null, o = null, l = 5, c) {
    return new W("data:" + t, i, s, r, n, a, o, e, !1, l, void 0, void 0, c);
  }
  /**
   * Creates a texture from its data: representation. (data: will be added in case only the payload has been passed in)
   * @param name Define the name of the texture in the scene useful fo caching purpose for instance
   * @param buffer define the buffer to load the texture from in case the texture is loaded from a buffer representation
   * @param scene Define the scene the texture should belong to
   * @param deleteBuffer define if the buffer we are loading the texture from should be deleted after load
   * @param noMipmapOrOptions defines if the texture will require mip maps or not or set of all options to create the texture
   * @param invertY define if the texture needs to be inverted on the y axis during loading
   * @param samplingMode define the sampling mode we want for the texture while fetching from it (Texture.NEAREST_SAMPLINGMODE...)
   * @param onLoad define a callback triggered when the texture has been loaded
   * @param onError define a callback triggered when an error occurred during the loading session
   * @param format define the format of the texture we are trying to load (Engine.TEXTUREFORMAT_RGBA...)
   * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
   * @returns the created texture
   */
  static LoadFromDataString(e, t, i, s = !1, r, n = !0, a = W.TRILINEAR_SAMPLINGMODE, o = null, l = null, c = 5, u) {
    return e.substr(0, 5) !== "data:" && (e = "data:" + e), new W(e, i, r, n, a, o, l, t, s, c, void 0, void 0, u);
  }
}
W.SerializeBuffers = !0;
W.ForceSerializeBuffers = !1;
W.OnTextureLoadErrorObservable = new N();
W._SerializeInternalTextureUniqueId = !1;
W._CubeTextureParser = (h, e, t) => {
  throw he("CubeTexture");
};
W._CreateMirror = (h, e, t, i) => {
  throw he("MirrorTexture");
};
W._CreateRenderTargetTexture = (h, e, t, i, s) => {
  throw he("RenderTargetTexture");
};
W.NEAREST_SAMPLINGMODE = 1;
W.NEAREST_NEAREST_MIPLINEAR = 8;
W.BILINEAR_SAMPLINGMODE = 2;
W.LINEAR_LINEAR_MIPNEAREST = 11;
W.TRILINEAR_SAMPLINGMODE = 3;
W.LINEAR_LINEAR_MIPLINEAR = 3;
W.NEAREST_NEAREST_MIPNEAREST = 4;
W.NEAREST_LINEAR_MIPNEAREST = 5;
W.NEAREST_LINEAR_MIPLINEAR = 6;
W.NEAREST_LINEAR = 7;
W.NEAREST_NEAREST = 1;
W.LINEAR_NEAREST_MIPNEAREST = 9;
W.LINEAR_NEAREST_MIPLINEAR = 10;
W.LINEAR_LINEAR = 2;
W.LINEAR_NEAREST = 12;
W.EXPLICIT_MODE = 0;
W.SPHERICAL_MODE = 1;
W.PLANAR_MODE = 2;
W.CUBIC_MODE = 3;
W.PROJECTION_MODE = 4;
W.SKYBOX_MODE = 5;
W.INVCUBIC_MODE = 6;
W.EQUIRECTANGULAR_MODE = 7;
W.FIXED_EQUIRECTANGULAR_MODE = 8;
W.FIXED_EQUIRECTANGULAR_MIRRORED_MODE = 9;
W.CLAMP_ADDRESSMODE = 0;
W.WRAP_ADDRESSMODE = 1;
W.MIRROR_ADDRESSMODE = 2;
W.UseSerializedUrlIfAny = !1;
E([
  R()
], W.prototype, "url", void 0);
E([
  R()
], W.prototype, "uOffset", void 0);
E([
  R()
], W.prototype, "vOffset", void 0);
E([
  R()
], W.prototype, "uScale", void 0);
E([
  R()
], W.prototype, "vScale", void 0);
E([
  R()
], W.prototype, "uAng", void 0);
E([
  R()
], W.prototype, "vAng", void 0);
E([
  R()
], W.prototype, "wAng", void 0);
E([
  R()
], W.prototype, "uRotationCenter", void 0);
E([
  R()
], W.prototype, "vRotationCenter", void 0);
E([
  R()
], W.prototype, "wRotationCenter", void 0);
E([
  R()
], W.prototype, "homogeneousRotationInUVTransform", void 0);
E([
  R()
], W.prototype, "isBlocking", null);
Xe("BABYLON.Texture", W);
le._TextureParser = W.Parse;
Z.prototype._createDepthStencilCubeTexture = function(h, e, t) {
  const i = new zt(this, Ze.DepthStencil);
  if (i.isCube = !0, this.webGLVersion === 1)
    return w.Error("Depth cube texture is not supported by WebGL 1."), i;
  const s = Object.assign({ bilinearFiltering: !1, comparisonFunction: 0, generateStencil: !1 }, e), r = this._gl;
  this._bindTextureDirectly(r.TEXTURE_CUBE_MAP, i, !0), this._setupDepthStencilTexture(i, h, s.generateStencil, s.bilinearFiltering, s.comparisonFunction), t._depthStencilTexture = i, t._depthStencilTextureWithStencil = s.generateStencil;
  for (let n = 0; n < 6; n++)
    s.generateStencil ? r.texImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + n, 0, r.DEPTH24_STENCIL8, h, h, 0, r.DEPTH_STENCIL, r.UNSIGNED_INT_24_8, null) : r.texImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + n, 0, r.DEPTH_COMPONENT24, h, h, 0, r.DEPTH_COMPONENT, r.UNSIGNED_INT, null);
  return this._bindTextureDirectly(r.TEXTURE_CUBE_MAP, null), this._internalTexturesCache.push(i), i;
};
Z.prototype._partialLoadFile = function(h, e, t, i, s = null) {
  const r = (a) => {
    t[e] = a, t._internalCount++, t._internalCount === 6 && i(t);
  }, n = (a, o) => {
    s && a && s(a.status + " " + a.statusText, o);
  };
  this._loadFile(h, r, void 0, void 0, !0, n);
};
Z.prototype._cascadeLoadFiles = function(h, e, t, i = null) {
  const s = [];
  s._internalCount = 0;
  for (let r = 0; r < 6; r++)
    this._partialLoadFile(t[r], r, s, e, i);
};
Z.prototype._cascadeLoadImgs = function(h, e, t, i, s = null, r) {
  const n = [];
  n._internalCount = 0;
  for (let a = 0; a < 6; a++)
    this._partialLoadImg(i[a], a, n, h, e, t, s, r);
};
Z.prototype._partialLoadImg = function(h, e, t, i, s, r, n = null, a) {
  const o = wn();
  Pr(h, (u) => {
    t[e] = u, t._internalCount++, i && i.removePendingData(o), t._internalCount === 6 && r && r(s, t);
  }, (u, d) => {
    i && i.removePendingData(o), n && n(u, d);
  }, i ? i.offlineProvider : null, a), i && i.addPendingData(o);
};
Z.prototype._setCubeMapTextureParams = function(h, e, t) {
  const i = this._gl;
  i.texParameteri(i.TEXTURE_CUBE_MAP, i.TEXTURE_MAG_FILTER, i.LINEAR), i.texParameteri(i.TEXTURE_CUBE_MAP, i.TEXTURE_MIN_FILTER, e ? i.LINEAR_MIPMAP_LINEAR : i.LINEAR), i.texParameteri(i.TEXTURE_CUBE_MAP, i.TEXTURE_WRAP_S, i.CLAMP_TO_EDGE), i.texParameteri(i.TEXTURE_CUBE_MAP, i.TEXTURE_WRAP_T, i.CLAMP_TO_EDGE), h.samplingMode = e ? 3 : 2, e && this.getCaps().textureMaxLevel && t !== void 0 && t > 0 && (i.texParameteri(i.TEXTURE_CUBE_MAP, i.TEXTURE_MAX_LEVEL, t), h._maxLodLevel = t), this._bindTextureDirectly(i.TEXTURE_CUBE_MAP, null);
};
Z.prototype.createCubeTextureBase = function(h, e, t, i, s = null, r = null, n, a = null, o = !1, l = 0, c = 0, u = null, d = null, f = null, _ = !1) {
  const g = u || new zt(this, Ze.Cube);
  g.isCube = !0, g.url = h, g.generateMipMaps = !i, g._lodGenerationScale = l, g._lodGenerationOffset = c, g._useSRGBBuffer = !!_ && this._caps.supportSRGBBuffers && (this.webGLVersion > 1 || this.isWebGPU || !!i), g !== u && (g.label = h.substring(0, 60)), this._doNotHandleContextLost || (g._extension = a, g._files = t);
  const m = h;
  this._transformTextureUrl && !u && (h = this._transformTextureUrl(h));
  const y = h.split("?")[0], x = y.lastIndexOf("."), A = a || (x > -1 ? y.substring(x).toLowerCase() : "");
  let T = null;
  for (const b of Z._TextureLoaders)
    if (b.canLoad(A)) {
      T = b;
      break;
    }
  const M = (b, S) => {
    h === m ? r && b && r(b.status + " " + b.statusText, S) : (w.Warn(`Failed to load ${h}, falling back to the ${m}`), this.createCubeTextureBase(m, e, t, !!i, s, r, n, a, o, l, c, g, d, f, _));
  };
  if (T) {
    const b = (S) => {
      d && d(g, S), T.loadCubeData(S, g, o, s, r);
    };
    t && t.length === 6 ? T.supportCascades ? this._cascadeLoadFiles(e, (S) => b(S.map((P) => new Uint8Array(P))), t, r) : r ? r("Textures type does not support cascades.") : w.Warn("Texture loader does not support cascades.") : this._loadFile(h, (S) => b(new Uint8Array(S)), void 0, void 0, !0, M);
  } else {
    if (!t)
      throw new Error("Cannot load cubemap because files were not defined");
    this._cascadeLoadImgs(e, g, (b, S) => {
      f && f(b, S);
    }, t, r);
  }
  return this._internalTexturesCache.push(g), g;
};
Z.prototype.createCubeTexture = function(h, e, t, i, s = null, r = null, n, a = null, o = !1, l = 0, c = 0, u = null, d, f = !1) {
  const _ = this._gl;
  return this.createCubeTextureBase(h, e, t, !!i, s, r, n, a, o, l, c, u, (g) => this._bindTextureDirectly(_.TEXTURE_CUBE_MAP, g, !0), (g, m) => {
    const y = this.needPOTTextures ? Z.GetExponentOfTwo(m[0].width, this._caps.maxCubemapTextureSize) : m[0].width, x = y, A = [
      _.TEXTURE_CUBE_MAP_POSITIVE_X,
      _.TEXTURE_CUBE_MAP_POSITIVE_Y,
      _.TEXTURE_CUBE_MAP_POSITIVE_Z,
      _.TEXTURE_CUBE_MAP_NEGATIVE_X,
      _.TEXTURE_CUBE_MAP_NEGATIVE_Y,
      _.TEXTURE_CUBE_MAP_NEGATIVE_Z
    ];
    this._bindTextureDirectly(_.TEXTURE_CUBE_MAP, g, !0), this._unpackFlipY(!1);
    const T = n ? this._getInternalFormat(n, g._useSRGBBuffer) : g._useSRGBBuffer ? this._glSRGBExtensionValues.SRGB8_ALPHA8 : _.RGBA;
    let M = n ? this._getInternalFormat(n) : _.RGBA;
    g._useSRGBBuffer && this.webGLVersion === 1 && (M = T);
    for (let b = 0; b < A.length; b++)
      if (m[b].width !== y || m[b].height !== x) {
        if (this._prepareWorkingCanvas(), !this._workingCanvas || !this._workingContext) {
          w.Warn("Cannot create canvas to resize texture.");
          return;
        }
        this._workingCanvas.width = y, this._workingCanvas.height = x, this._workingContext.drawImage(m[b], 0, 0, m[b].width, m[b].height, 0, 0, y, x), _.texImage2D(A[b], 0, T, M, _.UNSIGNED_BYTE, this._workingCanvas);
      } else
        _.texImage2D(A[b], 0, T, M, _.UNSIGNED_BYTE, m[b]);
    i || _.generateMipmap(_.TEXTURE_CUBE_MAP), this._setCubeMapTextureParams(g, !i), g.width = y, g.height = x, g.isReady = !0, n && (g.format = n), g.onLoadedObservable.notifyObservers(g), g.onLoadedObservable.clear(), s && s();
  }, !!f);
};
class vt extends Ve {
  /**
   * Gets or sets the size of the bounding box associated with the cube texture
   * When defined, the cubemap will switch to local mode
   * @see https://community.arm.com/graphics/b/blog/posts/reflections-based-on-local-cubemaps-in-unity
   * @example https://www.babylonjs-playground.com/#RNASML
   */
  set boundingBoxSize(e) {
    if (this._boundingBoxSize && this._boundingBoxSize.equals(e))
      return;
    this._boundingBoxSize = e;
    const t = this.getScene();
    t && t.markAllMaterialsAsDirty(1);
  }
  /**
   * Returns the bounding box size
   * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/reflectionTexture#using-local-cubemap-mode
   */
  get boundingBoxSize() {
    return this._boundingBoxSize;
  }
  /**
   * Sets texture matrix rotation angle around Y axis in radians.
   */
  set rotationY(e) {
    this._rotationY = e, this.setReflectionTextureMatrix(I.RotationY(this._rotationY));
  }
  /**
   * Gets texture matrix rotation angle around Y axis radians.
   */
  get rotationY() {
    return this._rotationY;
  }
  /**
   * Are mip maps generated for this texture or not.
   */
  get noMipmap() {
    return this._noMipmap;
  }
  /**
   * Gets the forced extension (if any)
   */
  get forcedExtension() {
    return this._forcedExtension;
  }
  /**
   * Creates a cube texture from an array of image urls
   * @param files defines an array of image urls
   * @param scene defines the hosting scene
   * @param noMipmap specifies if mip maps are not used
   * @returns a cube texture
   */
  static CreateFromImages(e, t, i) {
    let s = "";
    return e.forEach((r) => s += r), new vt(s, t, null, i, e);
  }
  /**
   * Creates and return a texture created from prefilterd data by tools like IBL Baker or Lys.
   * @param url defines the url of the prefiltered texture
   * @param scene defines the scene the texture is attached to
   * @param forcedExtension defines the extension of the file if different from the url
   * @param createPolynomials defines whether or not to create polynomial harmonics from the texture data if necessary
   * @returns the prefiltered texture
   */
  static CreateFromPrefilteredData(e, t, i = null, s = !0) {
    const r = t.useDelayedTextureLoading;
    t.useDelayedTextureLoading = !1;
    const n = new vt(e, t, null, !1, null, null, null, void 0, !0, i, s);
    return t.useDelayedTextureLoading = r, n;
  }
  /**
   * Creates a cube texture to use with reflection for instance. It can be based upon dds or six images as well
   * as prefiltered data.
   * @param rootUrl defines the url of the texture or the root name of the six images
   * @param sceneOrEngine defines the scene or engine the texture is attached to
   * @param extensions defines the suffixes add to the picture name in case six images are in use like _px.jpg...
   * @param noMipmap defines if mipmaps should be created or not
   * @param files defines the six files to load for the different faces in that order: px, py, pz, nx, ny, nz
   * @param onLoad defines a callback triggered at the end of the file load if no errors occurred
   * @param onError defines a callback triggered in case of error during load
   * @param format defines the internal format to use for the texture once loaded
   * @param prefiltered defines whether or not the texture is created from prefiltered data
   * @param forcedExtension defines the extensions to use (force a special type of file to load) in case it is different from the file name
   * @param createPolynomials defines whether or not to create polynomial harmonics from the texture data if necessary
   * @param lodScale defines the scale applied to environment texture. This manages the range of LOD level used for IBL according to the roughness
   * @param lodOffset defines the offset applied to environment texture. This manages first LOD level used for IBL according to the roughness
   * @param loaderOptions options to be passed to the loader
   * @param useSRGBBuffer Defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU) (default: false)
   * @returns the cube texture
   */
  constructor(e, t, i = null, s = !1, r = null, n = null, a = null, o = 5, l = !1, c = null, u = !1, d = 0.8, f = 0, _, g) {
    var m;
    super(t), this._lodScale = 0.8, this._lodOffset = 0, this.onLoadObservable = new N(), this.boundingBoxPosition = p.Zero(), this._rotationY = 0, this._files = null, this._forcedExtension = null, this._extensions = null, this._textureMatrixRefraction = new I(), this.name = e, this.url = e, this._noMipmap = s, this.hasAlpha = !1, this._format = o, this.isCube = !0, this._textureMatrix = I.Identity(), this._createPolynomials = u, this.coordinatesMode = W.CUBIC_MODE, this._extensions = i, this._files = r, this._forcedExtension = c, this._loaderOptions = _, this._useSRGBBuffer = g, this._lodScale = d, this._lodOffset = f, !(!e && !r) && this.updateURL(e, c, n, l, a, i, (m = this.getScene()) === null || m === void 0 ? void 0 : m.useDelayedTextureLoading, r);
  }
  /**
   * Get the current class name of the texture useful for serialization or dynamic coding.
   * @returns "CubeTexture"
   */
  getClassName() {
    return "CubeTexture";
  }
  /**
   * Update the url (and optional buffer) of this texture if url was null during construction.
   * @param url the url of the texture
   * @param forcedExtension defines the extension to use
   * @param onLoad callback called when the texture is loaded  (defaults to null)
   * @param prefiltered Defines whether the updated texture is prefiltered or not
   * @param onError callback called if there was an error during the loading process (defaults to null)
   * @param extensions defines the suffixes add to the picture name in case six images are in use like _px.jpg...
   * @param delayLoad defines if the texture should be loaded now (false by default)
   * @param files defines the six files to load for the different faces in that order: px, py, pz, nx, ny, nz
   */
  updateURL(e, t, i = null, s = !1, r = null, n = null, a = !1, o = null) {
    (!this.name || this.name.startsWith("data:")) && (this.name = e), this.url = e, t && (this._forcedExtension = t);
    const l = e.lastIndexOf("."), c = t || (l > -1 ? e.substring(l).toLowerCase() : ""), u = c.indexOf(".dds") === 0, d = c.indexOf(".env") === 0, f = c.indexOf(".basis") === 0;
    if (d ? (this.gammaSpace = !1, this._prefiltered = !1, this.anisotropicFilteringLevel = 1) : (this._prefiltered = s, s && (this.gammaSpace = !1, this.anisotropicFilteringLevel = 1)), o)
      this._files = o;
    else if (!f && !d && !u && !n && (n = ["_px.jpg", "_py.jpg", "_pz.jpg", "_nx.jpg", "_ny.jpg", "_nz.jpg"]), this._files = this._files || [], this._files.length = 0, n) {
      for (let _ = 0; _ < n.length; _++)
        this._files.push(e + n[_]);
      this._extensions = n;
    }
    a ? (this.delayLoadState = 4, this._delayedOnLoad = i, this._delayedOnError = r) : this._loadTexture(i, r);
  }
  /**
   * Delays loading of the cube texture
   * @param forcedExtension defines the extension to use
   */
  delayLoad(e) {
    this.delayLoadState === 4 && (e && (this._forcedExtension = e), this.delayLoadState = 1, this._loadTexture(this._delayedOnLoad, this._delayedOnError));
  }
  /**
   * Returns the reflection texture matrix
   * @returns the reflection texture matrix
   */
  getReflectionTextureMatrix() {
    return this._textureMatrix;
  }
  /**
   * Sets the reflection texture matrix
   * @param value Reflection texture matrix
   */
  setReflectionTextureMatrix(e) {
    var t, i;
    if (e.updateFlag === this._textureMatrix.updateFlag || (e.isIdentity() !== this._textureMatrix.isIdentity() && ((t = this.getScene()) === null || t === void 0 || t.markAllMaterialsAsDirty(1, (a) => a.getActiveTextures().indexOf(this) !== -1)), this._textureMatrix = e, !(!((i = this.getScene()) === null || i === void 0) && i.useRightHandedSystem)))
      return;
    const s = C.Vector3[0], r = C.Quaternion[0], n = C.Vector3[1];
    this._textureMatrix.decompose(s, r, n), r.z *= -1, r.w *= -1, I.ComposeToRef(s, r, n, this._textureMatrixRefraction);
  }
  /**
   * Gets a suitable rotate/transform matrix when the texture is used for refraction.
   * There's a separate function from getReflectionTextureMatrix because refraction requires a special configuration of the matrix in right-handed mode.
   * @returns The refraction matrix
   */
  getRefractionTextureMatrix() {
    var e;
    return !((e = this.getScene()) === null || e === void 0) && e.useRightHandedSystem ? this._textureMatrixRefraction : this._textureMatrix;
  }
  _loadTexture(e = null, t = null) {
    var i;
    const s = this.getScene(), r = this._texture;
    this._texture = this._getFromCache(this.url, this._noMipmap, void 0, void 0, this._useSRGBBuffer, this.isCube);
    const n = () => {
      var o;
      this.onLoadObservable.notifyObservers(this), r && (r.dispose(), (o = this.getScene()) === null || o === void 0 || o.markAllMaterialsAsDirty(1)), e && e();
    }, a = (o, l) => {
      this._loadingError = !0, this._errorObject = { message: o, exception: l }, t && t(o, l), W.OnTextureLoadErrorObservable.notifyObservers(this);
    };
    this._texture ? this._texture.isReady ? z.SetImmediate(() => n()) : this._texture.onLoadedObservable.add(() => n()) : (this._prefiltered ? this._texture = this._getEngine().createPrefilteredCubeTexture(this.url, s, this._lodScale, this._lodOffset, e, a, this._format, this._forcedExtension, this._createPolynomials) : this._texture = this._getEngine().createCubeTexture(this.url, s, this._files, this._noMipmap, e, a, this._format, this._forcedExtension, !1, this._lodScale, this._lodOffset, null, this._loaderOptions, !!this._useSRGBBuffer), (i = this._texture) === null || i === void 0 || i.onLoadedObservable.add(() => this.onLoadObservable.notifyObservers(this)));
  }
  /**
   * Parses text to create a cube texture
   * @param parsedTexture define the serialized text to read from
   * @param scene defines the hosting scene
   * @param rootUrl defines the root url of the cube texture
   * @returns a cube texture
   */
  static Parse(e, t, i) {
    const s = le.Parse(() => {
      var r;
      let n = !1;
      return e.prefiltered && (n = e.prefiltered), new vt(i + ((r = e.url) !== null && r !== void 0 ? r : e.name), t, e.extensions, !1, e.files || null, null, null, void 0, n, e.forcedExtension);
    }, e, t);
    if (e.boundingBoxPosition && (s.boundingBoxPosition = p.FromArray(e.boundingBoxPosition)), e.boundingBoxSize && (s.boundingBoxSize = p.FromArray(e.boundingBoxSize)), e.animations)
      for (let r = 0; r < e.animations.length; r++) {
        const n = e.animations[r], a = si("BABYLON.Animation");
        a && s.animations.push(a.Parse(n));
      }
    return s;
  }
  /**
   * Makes a clone, or deep copy, of the cube texture
   * @returns a new cube texture
   */
  clone() {
    let e = 0;
    const t = le.Clone(() => {
      const i = new vt(this.url, this.getScene() || this._getEngine(), this._extensions, this._noMipmap, this._files);
      return e = i.uniqueId, i;
    }, this);
    return t.uniqueId = e, t;
  }
}
E([
  R()
], vt.prototype, "url", void 0);
E([
  wt()
], vt.prototype, "boundingBoxPosition", void 0);
E([
  wt()
], vt.prototype, "boundingBoxSize", null);
E([
  R("rotationY")
], vt.prototype, "rotationY", null);
E([
  R("files")
], vt.prototype, "_files", void 0);
E([
  R("forcedExtension")
], vt.prototype, "_forcedExtension", void 0);
E([
  R("extensions")
], vt.prototype, "_extensions", void 0);
E([
  Ca("textureMatrix")
], vt.prototype, "_textureMatrix", void 0);
E([
  Ca("textureMatrixRefraction")
], vt.prototype, "_textureMatrixRefraction", void 0);
W._CubeTextureParser = vt.Parse;
Xe("BABYLON.CubeTexture", vt);
class es {
  /**
   * Converts a panorama stored in RGB right to left up to down format into a cubemap (6 faces).
   *
   * @param float32Array The source data.
   * @param inputWidth The width of the input panorama.
   * @param inputHeight The height of the input panorama.
   * @param size The willing size of the generated cubemap (each faces will be size * size pixels)
   * @returns The cubemap data
   */
  static ConvertPanoramaToCubemap(e, t, i, s, r = !1) {
    if (!e)
      throw "ConvertPanoramaToCubemap: input cannot be null";
    if (e.length != t * i * 3)
      throw "ConvertPanoramaToCubemap: input size is wrong";
    const n = this.CreateCubemapTexture(s, this.FACE_FRONT, e, t, i, r), a = this.CreateCubemapTexture(s, this.FACE_BACK, e, t, i, r), o = this.CreateCubemapTexture(s, this.FACE_LEFT, e, t, i, r), l = this.CreateCubemapTexture(s, this.FACE_RIGHT, e, t, i, r), c = this.CreateCubemapTexture(s, this.FACE_UP, e, t, i, r), u = this.CreateCubemapTexture(s, this.FACE_DOWN, e, t, i, r);
    return {
      front: n,
      back: a,
      left: o,
      right: l,
      up: c,
      down: u,
      size: s,
      type: 1,
      format: 4,
      gammaSpace: !1
    };
  }
  static CreateCubemapTexture(e, t, i, s, r, n = !1) {
    const a = new ArrayBuffer(e * e * 4 * 3), o = new Float32Array(a), l = n ? Math.max(1, Math.round(s / 4 / e)) : 1, c = 1 / l, u = c * c, d = t[1].subtract(t[0]).scale(c / e), f = t[3].subtract(t[2]).scale(c / e), _ = 1 / e;
    let g = 0;
    for (let m = 0; m < e; m++)
      for (let y = 0; y < l; y++) {
        let x = t[0], A = t[2];
        for (let T = 0; T < e; T++)
          for (let M = 0; M < l; M++) {
            const b = A.subtract(x).scale(g).add(x);
            b.normalize();
            const S = this.CalcProjectionSpherical(b, i, s, r);
            o[m * e * 3 + T * 3 + 0] += S.r * u, o[m * e * 3 + T * 3 + 1] += S.g * u, o[m * e * 3 + T * 3 + 2] += S.b * u, x = x.add(d), A = A.add(f);
          }
        g += _ * c;
      }
    return o;
  }
  static CalcProjectionSpherical(e, t, i, s) {
    let r = Math.atan2(e.z, e.x);
    const n = Math.acos(e.y);
    for (; r < -Math.PI; )
      r += 2 * Math.PI;
    for (; r > Math.PI; )
      r -= 2 * Math.PI;
    let a = r / Math.PI;
    const o = n / Math.PI;
    a = a * 0.5 + 0.5;
    let l = Math.round(a * i);
    l < 0 ? l = 0 : l >= i && (l = i - 1);
    let c = Math.round(o * s);
    c < 0 ? c = 0 : c >= s && (c = s - 1);
    const u = s - c - 1, d = t[u * i * 3 + l * 3 + 0], f = t[u * i * 3 + l * 3 + 1], _ = t[u * i * 3 + l * 3 + 2];
    return {
      r: d,
      g: f,
      b: _
    };
  }
}
es.FACE_LEFT = [new p(-1, -1, -1), new p(1, -1, -1), new p(-1, 1, -1), new p(1, 1, -1)];
es.FACE_RIGHT = [new p(1, -1, 1), new p(-1, -1, 1), new p(1, 1, 1), new p(-1, 1, 1)];
es.FACE_FRONT = [new p(1, -1, -1), new p(1, -1, 1), new p(1, 1, -1), new p(1, 1, 1)];
es.FACE_BACK = [new p(-1, -1, 1), new p(-1, -1, -1), new p(-1, 1, 1), new p(-1, 1, -1)];
es.FACE_DOWN = [new p(1, 1, -1), new p(1, 1, 1), new p(-1, 1, -1), new p(-1, 1, 1)];
es.FACE_UP = [new p(-1, -1, -1), new p(-1, -1, 1), new p(1, -1, -1), new p(1, -1, 1)];
class Yl {
  static _Ldexp(e, t) {
    return t > 1023 ? e * Math.pow(2, 1023) * Math.pow(2, t - 1023) : t < -1074 ? e * Math.pow(2, -1074) * Math.pow(2, t + 1074) : e * Math.pow(2, t);
  }
  static _Rgbe2float(e, t, i, s, r, n) {
    r > 0 ? (r = this._Ldexp(1, r - 136), e[n + 0] = t * r, e[n + 1] = i * r, e[n + 2] = s * r) : (e[n + 0] = 0, e[n + 1] = 0, e[n + 2] = 0);
  }
  static _ReadStringLine(e, t) {
    let i = "", s = "";
    for (let r = t; r < e.length - t && (s = String.fromCharCode(e[r]), s != `
`); r++)
      i += s;
    return i;
  }
  /**
   * Reads header information from an RGBE texture stored in a native array.
   * More information on this format are available here:
   * https://en.wikipedia.org/wiki/RGBE_image_format
   *
   * @param uint8array The binary file stored in  native array.
   * @returns The header information.
   */
  // eslint-disable-next-line @typescript-eslint/naming-convention
  static RGBE_ReadHeader(e) {
    let t = 0, i = 0, s = this._ReadStringLine(e, 0);
    if (s[0] != "#" || s[1] != "?")
      throw "Bad HDR Format.";
    let r = !1, n = !1, a = 0;
    do
      a += s.length + 1, s = this._ReadStringLine(e, a), s == "FORMAT=32-bit_rle_rgbe" ? n = !0 : s.length == 0 && (r = !0);
    while (!r);
    if (!n)
      throw "HDR Bad header format, unsupported FORMAT";
    a += s.length + 1, s = this._ReadStringLine(e, a);
    const l = /^-Y (.*) \+X (.*)$/g.exec(s);
    if (!l || l.length < 3)
      throw "HDR Bad header format, no size";
    if (i = parseInt(l[2]), t = parseInt(l[1]), i < 8 || i > 32767)
      throw "HDR Bad header format, unsupported size";
    return a += s.length + 1, {
      height: t,
      width: i,
      dataPosition: a
    };
  }
  /**
   * Returns the cubemap information (each faces texture data) extracted from an RGBE texture.
   * This RGBE texture needs to store the information as a panorama.
   *
   * More information on this format are available here:
   * https://en.wikipedia.org/wiki/RGBE_image_format
   *
   * @param buffer The binary file stored in an array buffer.
   * @param size The expected size of the extracted cubemap.
   * @returns The Cube Map information.
   */
  static GetCubeMapTextureData(e, t, i = !1) {
    const s = new Uint8Array(e), r = this.RGBE_ReadHeader(s), n = this.RGBE_ReadPixels(s, r);
    return es.ConvertPanoramaToCubemap(n, r.width, r.height, t, i);
  }
  /**
   * Returns the pixels data extracted from an RGBE texture.
   * This pixels will be stored left to right up to down in the R G B order in one array.
   *
   * More information on this format are available here:
   * https://en.wikipedia.org/wiki/RGBE_image_format
   *
   * @param uint8array The binary file stored in an array buffer.
   * @param hdrInfo The header information of the file.
   * @returns The pixels data in RGB right to left up to down order.
   */
  // eslint-disable-next-line @typescript-eslint/naming-convention
  static RGBE_ReadPixels(e, t) {
    return this._RGBEReadPixelsRLE(e, t);
  }
  static _RGBEReadPixelsRLE(e, t) {
    let i = t.height;
    const s = t.width;
    let r, n, a, o, l, c = t.dataPosition, u = 0, d = 0, f = 0;
    const _ = new ArrayBuffer(s * 4), g = new Uint8Array(_), m = new ArrayBuffer(t.width * t.height * 4 * 3), y = new Float32Array(m);
    for (; i > 0; ) {
      if (r = e[c++], n = e[c++], a = e[c++], o = e[c++], r != 2 || n != 2 || a & 128 || t.width < 8 || t.width > 32767)
        return this._RGBEReadPixelsNOTRLE(e, t);
      if ((a << 8 | o) != s)
        throw "HDR Bad header format, wrong scan line width";
      for (u = 0, f = 0; f < 4; f++)
        for (d = (f + 1) * s; u < d; )
          if (r = e[c++], n = e[c++], r > 128) {
            if (l = r - 128, l == 0 || l > d - u)
              throw "HDR Bad Format, bad scanline data (run)";
            for (; l-- > 0; )
              g[u++] = n;
          } else {
            if (l = r, l == 0 || l > d - u)
              throw "HDR Bad Format, bad scanline data (non-run)";
            if (g[u++] = n, --l > 0)
              for (let x = 0; x < l; x++)
                g[u++] = e[c++];
          }
      for (f = 0; f < s; f++)
        r = g[f], n = g[f + s], a = g[f + 2 * s], o = g[f + 3 * s], this._Rgbe2float(y, r, n, a, o, (t.height - i) * s * 3 + f * 3);
      i--;
    }
    return y;
  }
  static _RGBEReadPixelsNOTRLE(e, t) {
    let i = t.height;
    const s = t.width;
    let r, n, a, o, l, c = t.dataPosition;
    const u = new ArrayBuffer(t.width * t.height * 4 * 3), d = new Float32Array(u);
    for (; i > 0; ) {
      for (l = 0; l < t.width; l++)
        r = e[c++], n = e[c++], a = e[c++], o = e[c++], this._Rgbe2float(d, r, n, a, o, (t.height - i) * s * 3 + l * 3);
      i--;
    }
    return d;
  }
}
var ds;
(function(h) {
  h[h.CW = 0] = "CW", h[h.CCW = 1] = "CCW";
})(ds || (ds = {}));
class Li {
  /**
   * Creates an Angle object of "radians" radians (float).
   * @param radians the angle in radians
   */
  constructor(e) {
    this._radians = e, this._radians < 0 && (this._radians += 2 * Math.PI);
  }
  /**
   * Get value in degrees
   * @returns the Angle value in degrees (float)
   */
  degrees() {
    return this._radians * 180 / Math.PI;
  }
  /**
   * Get value in radians
   * @returns the Angle value in radians (float)
   */
  radians() {
    return this._radians;
  }
  /**
   * Gets a new Angle object valued with the gradient angle, in radians, of the line joining two points
   * @param a defines first point as the origin
   * @param b defines point
   * @returns a new Angle
   */
  static BetweenTwoPoints(e, t) {
    const i = t.subtract(e), s = Math.atan2(i.y, i.x);
    return new Li(s);
  }
  /**
   * Gets a new Angle object from the given float in radians
   * @param radians defines the angle value in radians
   * @returns a new Angle
   */
  static FromRadians(e) {
    return new Li(e);
  }
  /**
   * Gets a new Angle object from the given float in degrees
   * @param degrees defines the angle value in degrees
   * @returns a new Angle
   */
  static FromDegrees(e) {
    return new Li(e * Math.PI / 180);
  }
}
class ql {
  /**
   * Creates an Arc object from the three given points : start, middle and end.
   * @param startPoint Defines the start point of the arc
   * @param midPoint Defines the middle point of the arc
   * @param endPoint Defines the end point of the arc
   */
  constructor(e, t, i) {
    this.startPoint = e, this.midPoint = t, this.endPoint = i;
    const s = Math.pow(t.x, 2) + Math.pow(t.y, 2), r = (Math.pow(e.x, 2) + Math.pow(e.y, 2) - s) / 2, n = (s - Math.pow(i.x, 2) - Math.pow(i.y, 2)) / 2, a = (e.x - t.x) * (t.y - i.y) - (t.x - i.x) * (e.y - t.y);
    this.centerPoint = new ue((r * (t.y - i.y) - n * (e.y - t.y)) / a, ((e.x - t.x) * n - (t.x - i.x) * r) / a), this.radius = this.centerPoint.subtract(this.startPoint).length(), this.startAngle = Li.BetweenTwoPoints(this.centerPoint, this.startPoint);
    const o = this.startAngle.degrees();
    let l = Li.BetweenTwoPoints(this.centerPoint, this.midPoint).degrees(), c = Li.BetweenTwoPoints(this.centerPoint, this.endPoint).degrees();
    l - o > 180 && (l -= 360), l - o < -180 && (l += 360), c - l > 180 && (c -= 360), c - l < -180 && (c += 360), this.orientation = l - o < 0 ? ds.CW : ds.CCW, this.angle = Li.FromDegrees(this.orientation === ds.CW ? o - c : c - o);
  }
}
class Ln {
  /**
   * Creates a Path2 object from the starting 2D coordinates x and y.
   * @param x the starting points x value
   * @param y the starting points y value
   */
  constructor(e, t) {
    this._points = new Array(), this._length = 0, this.closed = !1, this._points.push(new ue(e, t));
  }
  /**
   * Adds a new segment until the given coordinates (x, y) to the current Path2.
   * @param x the added points x value
   * @param y the added points y value
   * @returns the updated Path2.
   */
  addLineTo(e, t) {
    if (this.closed)
      return this;
    const i = new ue(e, t), s = this._points[this._points.length - 1];
    return this._points.push(i), this._length += i.subtract(s).length(), this;
  }
  /**
   * Adds _numberOfSegments_ segments according to the arc definition (middle point coordinates, end point coordinates, the arc start point being the current Path2 last point) to the current Path2.
   * @param midX middle point x value
   * @param midY middle point y value
   * @param endX end point x value
   * @param endY end point y value
   * @param numberOfSegments (default: 36)
   * @returns the updated Path2.
   */
  addArcTo(e, t, i, s, r = 36) {
    if (this.closed)
      return this;
    const n = this._points[this._points.length - 1], a = new ue(e, t), o = new ue(i, s), l = new ql(n, a, o);
    let c = l.angle.radians() / r;
    l.orientation === ds.CW && (c *= -1);
    let u = l.startAngle.radians() + c;
    for (let d = 0; d < r; d++) {
      const f = Math.cos(u) * l.radius + l.centerPoint.x, _ = Math.sin(u) * l.radius + l.centerPoint.y;
      this.addLineTo(f, _), u += c;
    }
    return this;
  }
  /**
   * Adds _numberOfSegments_ segments according to the quadratic curve definition to the current Path2.
   * @param controlX control point x value
   * @param controlY control point y value
   * @param endX end point x value
   * @param endY end point y value
   * @param numberOfSegments (default: 36)
   * @returns the updated Path2.
   */
  addQuadraticCurveTo(e, t, i, s, r = 36) {
    if (this.closed)
      return this;
    const n = (o, l, c, u) => (1 - o) * (1 - o) * l + 2 * o * (1 - o) * c + o * o * u, a = this._points[this._points.length - 1];
    for (let o = 0; o <= r; o++) {
      const l = o / r, c = n(l, a.x, e, i), u = n(l, a.y, t, s);
      this.addLineTo(c, u);
    }
    return this;
  }
  /**
   * Adds _numberOfSegments_ segments according to the bezier curve definition to the current Path2.
   * @param originTangentX tangent vector at the origin point x value
   * @param originTangentY tangent vector at the origin point y value
   * @param destinationTangentX tangent vector at the destination point x value
   * @param destinationTangentY tangent vector at the destination point y value
   * @param endX end point x value
   * @param endY end point y value
   * @param numberOfSegments (default: 36)
   * @returns the updated Path2.
   */
  addBezierCurveTo(e, t, i, s, r, n, a = 36) {
    if (this.closed)
      return this;
    const o = (c, u, d, f, _) => (1 - c) * (1 - c) * (1 - c) * u + 3 * c * (1 - c) * (1 - c) * d + 3 * c * c * (1 - c) * f + c * c * c * _, l = this._points[this._points.length - 1];
    for (let c = 0; c <= a; c++) {
      const u = c / a, d = o(u, l.x, e, i, r), f = o(u, l.y, t, s, n);
      this.addLineTo(d, f);
    }
    return this;
  }
  /**
   * Defines if a given point is inside the polygon defines by the path
   * @param point defines the point to test
   * @returns true if the point is inside
   */
  isPointInside(e) {
    let t = !1;
    const i = this._points.length;
    for (let s = i - 1, r = 0; r < i; s = r++) {
      let n = this._points[s], a = this._points[r], o = a.x - n.x, l = a.y - n.y;
      if (Math.abs(l) > Number.EPSILON) {
        if (l < 0 && (n = this._points[r], o = -o, a = this._points[s], l = -l), e.y < n.y || e.y > a.y)
          continue;
        if (e.y === n.y && e.x === n.x)
          return !0;
        {
          const c = l * (e.x - n.x) - o * (e.y - n.y);
          if (c === 0)
            return !0;
          if (c < 0)
            continue;
          t = !t;
        }
      } else {
        if (e.y !== n.y)
          continue;
        if (a.x <= e.x && e.x <= n.x || n.x <= e.x && e.x <= a.x)
          return !0;
      }
    }
    return t;
  }
  /**
   * Closes the Path2.
   * @returns the Path2.
   */
  close() {
    return this.closed = !0, this;
  }
  /**
   * Gets the sum of the distance between each sequential point in the path
   * @returns the Path2 total length (float).
   */
  length() {
    let e = this._length;
    if (this.closed) {
      const t = this._points[this._points.length - 1], i = this._points[0];
      e += i.subtract(t).length();
    }
    return e;
  }
  /**
   * Gets the area of the polygon defined by the path
   * @returns area value
   */
  area() {
    const e = this._points.length;
    let t = 0;
    for (let i = e - 1, s = 0; s < e; i = s++)
      t += this._points[i].x * this._points[s].y - this._points[s].x * this._points[i].y;
    return t * 0.5;
  }
  /**
   * Gets the points which construct the path
   * @returns the Path2 internal array of points.
   */
  getPoints() {
    return this._points;
  }
  /**
   * Retreives the point at the distance aways from the starting point
   * @param normalizedLengthPosition the length along the path to retrieve the point from
   * @returns a new Vector2 located at a percentage of the Path2 total length on this path.
   */
  getPointAtLengthPosition(e) {
    if (e < 0 || e > 1)
      return ue.Zero();
    const t = e * this.length();
    let i = 0;
    for (let s = 0; s < this._points.length; s++) {
      const r = (s + 1) % this._points.length, n = this._points[s], o = this._points[r].subtract(n), l = o.length() + i;
      if (t >= i && t <= l) {
        const c = o.normalize(), u = t - i;
        return new ue(n.x + c.x * u, n.y + c.y * u);
      }
      i = l;
    }
    return ue.Zero();
  }
  /**
   * Creates a new path starting from an x and y position
   * @param x starting x value
   * @param y starting y value
   * @returns a new Path2 starting at the coordinates (x, y).
   */
  static StartingAt(e, t) {
    return new Ln(e, t);
  }
}
class Us {
  /**
   * new Path3D(path, normal, raw)
   * Creates a Path3D. A Path3D is a logical math object, so not a mesh.
   * please read the description in the tutorial : https://doc.babylonjs.com/features/featuresDeepDive/mesh/path3D
   * @param path an array of Vector3, the curve axis of the Path3D
   * @param firstNormal (options) Vector3, the first wanted normal to the curve. Ex (0, 1, 0) for a vertical normal.
   * @param raw (optional, default false) : boolean, if true the returned Path3D isn't normalized. Useful to depict path acceleration or speed.
   * @param alignTangentsWithPath (optional, default false) : boolean, if true the tangents will be aligned with the path.
   */
  constructor(e, t = null, i, s = !1) {
    this.path = e, this._curve = new Array(), this._distances = new Array(), this._tangents = new Array(), this._normals = new Array(), this._binormals = new Array(), this._pointAtData = {
      id: 0,
      point: p.Zero(),
      previousPointArrayIndex: 0,
      position: 0,
      subPosition: 0,
      interpolateReady: !1,
      interpolationMatrix: I.Identity()
    };
    for (let r = 0; r < e.length; r++)
      this._curve[r] = e[r].clone();
    this._raw = i || !1, this._alignTangentsWithPath = s, this._compute(t, s);
  }
  /**
   * Returns the Path3D array of successive Vector3 designing its curve.
   * @returns the Path3D array of successive Vector3 designing its curve.
   */
  getCurve() {
    return this._curve;
  }
  /**
   * Returns the Path3D array of successive Vector3 designing its curve.
   * @returns the Path3D array of successive Vector3 designing its curve.
   */
  getPoints() {
    return this._curve;
  }
  /**
   * @returns the computed length (float) of the path.
   */
  length() {
    return this._distances[this._distances.length - 1];
  }
  /**
   * Returns an array populated with tangent vectors on each Path3D curve point.
   * @returns an array populated with tangent vectors on each Path3D curve point.
   */
  getTangents() {
    return this._tangents;
  }
  /**
   * Returns an array populated with normal vectors on each Path3D curve point.
   * @returns an array populated with normal vectors on each Path3D curve point.
   */
  getNormals() {
    return this._normals;
  }
  /**
   * Returns an array populated with binormal vectors on each Path3D curve point.
   * @returns an array populated with binormal vectors on each Path3D curve point.
   */
  getBinormals() {
    return this._binormals;
  }
  /**
   * Returns an array populated with distances (float) of the i-th point from the first curve point.
   * @returns an array populated with distances (float) of the i-th point from the first curve point.
   */
  getDistances() {
    return this._distances;
  }
  /**
   * Returns an interpolated point along this path
   * @param position the position of the point along this path, from 0.0 to 1.0
   * @returns a new Vector3 as the point
   */
  getPointAt(e) {
    return this._updatePointAtData(e).point;
  }
  /**
   * Returns the tangent vector of an interpolated Path3D curve point at the specified position along this path.
   * @param position the position of the point along this path, from 0.0 to 1.0
   * @param interpolated (optional, default false) : boolean, if true returns an interpolated tangent instead of the tangent of the previous path point.
   * @returns a tangent vector corresponding to the interpolated Path3D curve point, if not interpolated, the tangent is taken from the precomputed tangents array.
   */
  getTangentAt(e, t = !1) {
    return this._updatePointAtData(e, t), t ? p.TransformCoordinates(p.Forward(), this._pointAtData.interpolationMatrix) : this._tangents[this._pointAtData.previousPointArrayIndex];
  }
  /**
   * Returns the tangent vector of an interpolated Path3D curve point at the specified position along this path.
   * @param position the position of the point along this path, from 0.0 to 1.0
   * @param interpolated (optional, default false) : boolean, if true returns an interpolated normal instead of the normal of the previous path point.
   * @returns a normal vector corresponding to the interpolated Path3D curve point, if not interpolated, the normal is taken from the precomputed normals array.
   */
  getNormalAt(e, t = !1) {
    return this._updatePointAtData(e, t), t ? p.TransformCoordinates(p.Right(), this._pointAtData.interpolationMatrix) : this._normals[this._pointAtData.previousPointArrayIndex];
  }
  /**
   * Returns the binormal vector of an interpolated Path3D curve point at the specified position along this path.
   * @param position the position of the point along this path, from 0.0 to 1.0
   * @param interpolated (optional, default false) : boolean, if true returns an interpolated binormal instead of the binormal of the previous path point.
   * @returns a binormal vector corresponding to the interpolated Path3D curve point, if not interpolated, the binormal is taken from the precomputed binormals array.
   */
  getBinormalAt(e, t = !1) {
    return this._updatePointAtData(e, t), t ? p.TransformCoordinates(p.UpReadOnly, this._pointAtData.interpolationMatrix) : this._binormals[this._pointAtData.previousPointArrayIndex];
  }
  /**
   * Returns the distance (float) of an interpolated Path3D curve point at the specified position along this path.
   * @param position the position of the point along this path, from 0.0 to 1.0
   * @returns the distance of the interpolated Path3D curve point at the specified position along this path.
   */
  getDistanceAt(e) {
    return this.length() * e;
  }
  /**
   * Returns the array index of the previous point of an interpolated point along this path
   * @param position the position of the point to interpolate along this path, from 0.0 to 1.0
   * @returns the array index
   */
  getPreviousPointIndexAt(e) {
    return this._updatePointAtData(e), this._pointAtData.previousPointArrayIndex;
  }
  /**
   * Returns the position of an interpolated point relative to the two path points it lies between, from 0.0 (point A) to 1.0 (point B)
   * @param position the position of the point to interpolate along this path, from 0.0 to 1.0
   * @returns the sub position
   */
  getSubPositionAt(e) {
    return this._updatePointAtData(e), this._pointAtData.subPosition;
  }
  /**
   * Returns the position of the closest virtual point on this path to an arbitrary Vector3, from 0.0 to 1.0
   * @param target the vector of which to get the closest position to
   * @returns the position of the closest virtual point on this path to the target vector
   */
  getClosestPositionTo(e) {
    let t = Number.MAX_VALUE, i = 0;
    for (let s = 0; s < this._curve.length - 1; s++) {
      const r = this._curve[s + 0], n = this._curve[s + 1].subtract(r).normalize(), a = this._distances[s + 1] - this._distances[s + 0], o = Math.min(Math.max(p.Dot(n, e.subtract(r).normalize()), 0) * p.Distance(r, e) / a, 1), l = p.Distance(r.add(n.scale(o * a)), e);
      l < t && (t = l, i = (this._distances[s + 0] + a * o) / this.length());
    }
    return i;
  }
  /**
   * Returns a sub path (slice) of this path
   * @param start the position of the fist path point, from 0.0 to 1.0, or a negative value, which will get wrapped around from the end of the path to 0.0 to 1.0 values
   * @param end the position of the last path point, from 0.0 to 1.0, or a negative value, which will get wrapped around from the end of the path to 0.0 to 1.0 values
   * @returns a sub path (slice) of this path
   */
  slice(e = 0, t = 1) {
    if (e < 0 && (e = 1 - e * -1 % 1), t < 0 && (t = 1 - t * -1 % 1), e > t) {
      const l = e;
      e = t, t = l;
    }
    const i = this.getCurve(), s = this.getPointAt(e);
    let r = this.getPreviousPointIndexAt(e);
    const n = this.getPointAt(t), a = this.getPreviousPointIndexAt(t) + 1, o = [];
    return e !== 0 && (r++, o.push(s)), o.push(...i.slice(r, a)), (t !== 1 || e === 1) && o.push(n), new Us(o, this.getNormalAt(e), this._raw, this._alignTangentsWithPath);
  }
  /**
   * Forces the Path3D tangent, normal, binormal and distance recomputation.
   * @param path path which all values are copied into the curves points
   * @param firstNormal which should be projected onto the curve
   * @param alignTangentsWithPath (optional, default false) : boolean, if true the tangents will be aligned with the path
   * @returns the same object updated.
   */
  update(e, t = null, i = !1) {
    for (let s = 0; s < e.length; s++)
      this._curve[s].x = e[s].x, this._curve[s].y = e[s].y, this._curve[s].z = e[s].z;
    return this._compute(t, i), this;
  }
  // private function compute() : computes tangents, normals and binormals
  _compute(e, t = !1) {
    const i = this._curve.length;
    if (i < 2)
      return;
    this._tangents[0] = this._getFirstNonNullVector(0), this._raw || this._tangents[0].normalize(), this._tangents[i - 1] = this._curve[i - 1].subtract(this._curve[i - 2]), this._raw || this._tangents[i - 1].normalize();
    const s = this._tangents[0], r = this._normalVector(s, e);
    this._normals[0] = r, this._raw || this._normals[0].normalize(), this._binormals[0] = p.Cross(s, this._normals[0]), this._raw || this._binormals[0].normalize(), this._distances[0] = 0;
    let n, a, o, l, c;
    for (let u = 1; u < i; u++)
      n = this._getLastNonNullVector(u), u < i - 1 && (a = this._getFirstNonNullVector(u), this._tangents[u] = t ? a : n.add(a), this._tangents[u].normalize()), this._distances[u] = this._distances[u - 1] + this._curve[u].subtract(this._curve[u - 1]).length(), o = this._tangents[u], c = this._binormals[u - 1], this._normals[u] = p.Cross(c, o), this._raw || (this._normals[u].length() === 0 ? (l = this._normals[u - 1], this._normals[u] = l.clone()) : this._normals[u].normalize()), this._binormals[u] = p.Cross(o, this._normals[u]), this._raw || this._binormals[u].normalize();
    this._pointAtData.id = NaN;
  }
  // private function getFirstNonNullVector(index)
  // returns the first non null vector from index : curve[index + N].subtract(curve[index])
  _getFirstNonNullVector(e) {
    let t = 1, i = this._curve[e + t].subtract(this._curve[e]);
    for (; i.length() === 0 && e + t + 1 < this._curve.length; )
      t++, i = this._curve[e + t].subtract(this._curve[e]);
    return i;
  }
  // private function getLastNonNullVector(index)
  // returns the last non null vector from index : curve[index].subtract(curve[index - N])
  _getLastNonNullVector(e) {
    let t = 1, i = this._curve[e].subtract(this._curve[e - t]);
    for (; i.length() === 0 && e > t + 1; )
      t++, i = this._curve[e].subtract(this._curve[e - t]);
    return i;
  }
  // private function normalVector(v0, vt, va) :
  // returns an arbitrary point in the plane defined by the point v0 and the vector vt orthogonal to this plane
  // if va is passed, it returns the va projection on the plane orthogonal to vt at the point v0
  _normalVector(e, t) {
    let i, s = e.length();
    if (s === 0 && (s = 1), t == null) {
      let r;
      J.WithinEpsilon(Math.abs(e.y) / s, 1, pe) ? J.WithinEpsilon(Math.abs(e.x) / s, 1, pe) ? J.WithinEpsilon(Math.abs(e.z) / s, 1, pe) ? r = p.Zero() : r = new p(0, 0, 1) : r = new p(1, 0, 0) : r = new p(0, -1, 0), i = p.Cross(e, r);
    } else
      i = p.Cross(e, t), p.CrossToRef(i, e, i);
    return i.normalize(), i;
  }
  /**
   * Updates the point at data for an interpolated point along this curve
   * @param position the position of the point along this curve, from 0.0 to 1.0
   * @param interpolateTNB
   * @interpolateTNB whether to compute the interpolated tangent, normal and binormal
   * @returns the (updated) point at data
   */
  _updatePointAtData(e, t = !1) {
    if (this._pointAtData.id === e)
      return this._pointAtData.interpolateReady || this._updateInterpolationMatrix(), this._pointAtData;
    this._pointAtData.id = e;
    const i = this.getPoints();
    if (e <= 0)
      return this._setPointAtData(0, 0, i[0], 0, t);
    if (e >= 1)
      return this._setPointAtData(1, 1, i[i.length - 1], i.length - 1, t);
    let s = i[0], r, n = 0;
    const a = e * this.length();
    for (let o = 1; o < i.length; o++) {
      r = i[o];
      const l = p.Distance(s, r);
      if (n += l, n === a)
        return this._setPointAtData(e, 1, r, o, t);
      if (n > a) {
        const u = (n - a) / l, d = s.subtract(r), f = r.add(d.scaleInPlace(u));
        return this._setPointAtData(e, 1 - u, f, o - 1, t);
      }
      s = r;
    }
    return this._pointAtData;
  }
  /**
   * Updates the point at data from the specified parameters
   * @param position where along the path the interpolated point is, from 0.0 to 1.0
   * @param subPosition
   * @param point the interpolated point
   * @param parentIndex the index of an existing curve point that is on, or else positionally the first behind, the interpolated point
   * @param interpolateTNB
   */
  _setPointAtData(e, t, i, s, r) {
    return this._pointAtData.point = i, this._pointAtData.position = e, this._pointAtData.subPosition = t, this._pointAtData.previousPointArrayIndex = s, this._pointAtData.interpolateReady = r, r && this._updateInterpolationMatrix(), this._pointAtData;
  }
  /**
   * Updates the point at interpolation matrix for the tangents, normals and binormals
   */
  _updateInterpolationMatrix() {
    this._pointAtData.interpolationMatrix = I.Identity();
    const e = this._pointAtData.previousPointArrayIndex;
    if (e !== this._tangents.length - 1) {
      const t = e + 1, i = this._tangents[e].clone(), s = this._normals[e].clone(), r = this._binormals[e].clone(), n = this._tangents[t].clone(), a = this._normals[t].clone(), o = this._binormals[t].clone(), l = U.RotationQuaternionFromAxis(s, r, i), c = U.RotationQuaternionFromAxis(a, o, n);
      U.Slerp(l, c, this._pointAtData.subPosition).toRotationMatrix(this._pointAtData.interpolationMatrix);
    }
  }
}
class Nt {
  /**
   * Returns a Curve3 object along a Quadratic Bezier curve : https://doc.babylonjs.com/features/featuresDeepDive/mesh/drawCurves#quadratic-bezier-curve
   * @param v0 (Vector3) the origin point of the Quadratic Bezier
   * @param v1 (Vector3) the control point
   * @param v2 (Vector3) the end point of the Quadratic Bezier
   * @param nbPoints (integer) the wanted number of points in the curve
   * @returns the created Curve3
   */
  static CreateQuadraticBezier(e, t, i, s) {
    s = s > 2 ? s : 3;
    const r = new Array(), n = (a, o, l, c) => (1 - a) * (1 - a) * o + 2 * a * (1 - a) * l + a * a * c;
    for (let a = 0; a <= s; a++)
      r.push(new p(n(a / s, e.x, t.x, i.x), n(a / s, e.y, t.y, i.y), n(a / s, e.z, t.z, i.z)));
    return new Nt(r);
  }
  /**
   * Returns a Curve3 object along a Cubic Bezier curve : https://doc.babylonjs.com/features/featuresDeepDive/mesh/drawCurves#cubic-bezier-curve
   * @param v0 (Vector3) the origin point of the Cubic Bezier
   * @param v1 (Vector3) the first control point
   * @param v2 (Vector3) the second control point
   * @param v3 (Vector3) the end point of the Cubic Bezier
   * @param nbPoints (integer) the wanted number of points in the curve
   * @returns the created Curve3
   */
  static CreateCubicBezier(e, t, i, s, r) {
    r = r > 3 ? r : 4;
    const n = new Array(), a = (o, l, c, u, d) => (1 - o) * (1 - o) * (1 - o) * l + 3 * o * (1 - o) * (1 - o) * c + 3 * o * o * (1 - o) * u + o * o * o * d;
    for (let o = 0; o <= r; o++)
      n.push(new p(a(o / r, e.x, t.x, i.x, s.x), a(o / r, e.y, t.y, i.y, s.y), a(o / r, e.z, t.z, i.z, s.z)));
    return new Nt(n);
  }
  /**
   * Returns a Curve3 object along a Hermite Spline curve : https://doc.babylonjs.com/features/featuresDeepDive/mesh/drawCurves#hermite-spline
   * @param p1 (Vector3) the origin point of the Hermite Spline
   * @param t1 (Vector3) the tangent vector at the origin point
   * @param p2 (Vector3) the end point of the Hermite Spline
   * @param t2 (Vector3) the tangent vector at the end point
   * @param nSeg (integer) the number of curve segments or nSeg + 1 points in the array
   * @returns the created Curve3
   */
  static CreateHermiteSpline(e, t, i, s, r) {
    const n = new Array(), a = 1 / r;
    for (let o = 0; o <= r; o++)
      n.push(p.Hermite(e, t, i, s, o * a));
    return new Nt(n);
  }
  /**
   * Returns a Curve3 object along a CatmullRom Spline curve :
   * @param points (array of Vector3) the points the spline must pass through. At least, four points required
   * @param nbPoints (integer) the wanted number of points between each curve control points
   * @param closed (boolean) optional with default false, when true forms a closed loop from the points
   * @returns the created Curve3
   */
  static CreateCatmullRomSpline(e, t, i) {
    const s = new Array(), r = 1 / t;
    let n = 0;
    if (i) {
      const a = e.length;
      for (let o = 0; o < a; o++) {
        n = 0;
        for (let l = 0; l < t; l++)
          s.push(p.CatmullRom(e[o % a], e[(o + 1) % a], e[(o + 2) % a], e[(o + 3) % a], n)), n += r;
      }
      s.push(s[0]);
    } else {
      const a = new Array();
      a.push(e[0].clone()), Array.prototype.push.apply(a, e), a.push(e[e.length - 1].clone());
      let o = 0;
      for (; o < a.length - 3; o++) {
        n = 0;
        for (let l = 0; l < t; l++)
          s.push(p.CatmullRom(a[o], a[o + 1], a[o + 2], a[o + 3], n)), n += r;
      }
      o--, s.push(p.CatmullRom(a[o], a[o + 1], a[o + 2], a[o + 3], n));
    }
    return new Nt(s);
  }
  /**
   * Returns a Curve3 object along an arc through three vector3 points:
   * The three points should not be colinear. When they are the Curve3 is empty.
   * @param first (Vector3) the first point the arc must pass through.
   * @param second (Vector3) the second point the arc must pass through.
   * @param third (Vector3) the third point the arc must pass through.
   * @param steps (number) the larger the number of steps the more detailed the arc.
   * @param closed (boolean) optional with default false, when true forms the chord from the first and third point
   * @param fullCircle Circle (boolean) optional with default false, when true forms the complete circle through the three points
   * @returns the created Curve3
   */
  static ArcThru3Points(e, t, i, s = 32, r = !1, n = !1) {
    const a = new Array(), o = t.subtract(e), l = i.subtract(t), c = e.subtract(i), u = p.Cross(o, l), d = u.length();
    if (d < Math.pow(10, -8))
      return new Nt(a);
    const f = o.lengthSquared(), _ = l.lengthSquared(), g = c.lengthSquared(), m = u.lengthSquared(), y = o.length(), x = l.length(), A = c.length(), T = 0.5 * y * x * A / d, M = p.Dot(o, c), b = p.Dot(o, l), S = p.Dot(l, c), P = -0.5 * _ * M / m, D = -0.5 * g * b / m, O = -0.5 * f * S / m, X = e.scale(P).add(t.scale(D)).add(i.scale(O)), Y = e.subtract(X).normalize(), se = p.Cross(u, Y).normalize();
    if (n) {
      const Te = 2 * Math.PI / s;
      for (let ve = 0; ve <= 2 * Math.PI; ve += Te)
        a.push(X.add(Y.scale(T * Math.cos(ve)).add(se.scale(T * Math.sin(ve)))));
      a.push(e);
    } else {
      const Te = 1 / s;
      let ve = 0, Oe = p.Zero();
      do
        Oe = X.add(Y.scale(T * Math.cos(ve)).add(se.scale(T * Math.sin(ve)))), a.push(Oe), ve += Te;
      while (!Oe.equalsWithEpsilon(i, T * Te * 1.1));
      a.push(i), r && a.push(e);
    }
    return new Nt(a);
  }
  /**
   * A Curve3 object is a logical object, so not a mesh, to handle curves in the 3D geometric space.
   * A Curve3 is designed from a series of successive Vector3.
   * Tuto : https://doc.babylonjs.com/features/featuresDeepDive/mesh/drawCurves#curve3-object
   * @param points points which make up the curve
   */
  constructor(e) {
    this._length = 0, this._points = e, this._length = this._computeLength(e);
  }
  /**
   * @returns the Curve3 stored array of successive Vector3
   */
  getPoints() {
    return this._points;
  }
  /**
   * @returns the computed length (float) of the curve.
   */
  length() {
    return this._length;
  }
  /**
   * Returns a new instance of Curve3 object : var curve = curveA.continue(curveB);
   * This new Curve3 is built by translating and sticking the curveB at the end of the curveA.
   * curveA and curveB keep unchanged.
   * @param curve the curve to continue from this curve
   * @returns the newly constructed curve
   */
  continue(e) {
    const t = this._points[this._points.length - 1], i = this._points.slice(), s = e.getPoints();
    for (let n = 1; n < s.length; n++)
      i.push(s[n].subtract(s[0]).add(t));
    return new Nt(i);
  }
  _computeLength(e) {
    let t = 0;
    for (let i = 1; i < e.length; i++)
      t += e[i].subtract(e[i - 1]).length();
    return t;
  }
}
const li = [
  Math.sqrt(1 / (4 * Math.PI)),
  -Math.sqrt(3 / (4 * Math.PI)),
  Math.sqrt(3 / (4 * Math.PI)),
  -Math.sqrt(3 / (4 * Math.PI)),
  Math.sqrt(15 / (4 * Math.PI)),
  -Math.sqrt(15 / (4 * Math.PI)),
  Math.sqrt(5 / (16 * Math.PI)),
  -Math.sqrt(15 / (4 * Math.PI)),
  Math.sqrt(15 / (16 * Math.PI))
  // l22
], jl = [
  () => 1,
  (h) => h.y,
  (h) => h.z,
  (h) => h.x,
  (h) => h.x * h.y,
  (h) => h.y * h.z,
  (h) => 3 * h.z * h.z - 1,
  (h) => h.x * h.z,
  (h) => h.x * h.x - h.y * h.y
  // l22
], gi = (h, e) => li[h] * jl[h](e), mi = [Math.PI, 2 * Math.PI / 3, 2 * Math.PI / 3, 2 * Math.PI / 3, Math.PI / 4, Math.PI / 4, Math.PI / 4, Math.PI / 4, Math.PI / 4];
class ks {
  constructor() {
    this.preScaled = !1, this.l00 = p.Zero(), this.l1_1 = p.Zero(), this.l10 = p.Zero(), this.l11 = p.Zero(), this.l2_2 = p.Zero(), this.l2_1 = p.Zero(), this.l20 = p.Zero(), this.l21 = p.Zero(), this.l22 = p.Zero();
  }
  /**
   * Adds a light to the spherical harmonics
   * @param direction the direction of the light
   * @param color the color of the light
   * @param deltaSolidAngle the delta solid angle of the light
   */
  addLight(e, t, i) {
    C.Vector3[0].set(t.r, t.g, t.b);
    const s = C.Vector3[0], r = C.Vector3[1];
    s.scaleToRef(i, r), r.scaleToRef(gi(0, e), C.Vector3[2]), this.l00.addInPlace(C.Vector3[2]), r.scaleToRef(gi(1, e), C.Vector3[2]), this.l1_1.addInPlace(C.Vector3[2]), r.scaleToRef(gi(2, e), C.Vector3[2]), this.l10.addInPlace(C.Vector3[2]), r.scaleToRef(gi(3, e), C.Vector3[2]), this.l11.addInPlace(C.Vector3[2]), r.scaleToRef(gi(4, e), C.Vector3[2]), this.l2_2.addInPlace(C.Vector3[2]), r.scaleToRef(gi(5, e), C.Vector3[2]), this.l2_1.addInPlace(C.Vector3[2]), r.scaleToRef(gi(6, e), C.Vector3[2]), this.l20.addInPlace(C.Vector3[2]), r.scaleToRef(gi(7, e), C.Vector3[2]), this.l21.addInPlace(C.Vector3[2]), r.scaleToRef(gi(8, e), C.Vector3[2]), this.l22.addInPlace(C.Vector3[2]);
  }
  /**
   * Scales the spherical harmonics by the given amount
   * @param scale the amount to scale
   */
  scaleInPlace(e) {
    this.l00.scaleInPlace(e), this.l1_1.scaleInPlace(e), this.l10.scaleInPlace(e), this.l11.scaleInPlace(e), this.l2_2.scaleInPlace(e), this.l2_1.scaleInPlace(e), this.l20.scaleInPlace(e), this.l21.scaleInPlace(e), this.l22.scaleInPlace(e);
  }
  /**
   * Convert from incident radiance (Li) to irradiance (E) by applying convolution with the cosine-weighted hemisphere.
   *
   * ```
   * E_lm = A_l * L_lm
   * ```
   *
   * In spherical harmonics this convolution amounts to scaling factors for each frequency band.
   * This corresponds to equation 5 in "An Efficient Representation for Irradiance Environment Maps", where
   * the scaling factors are given in equation 9.
   */
  convertIncidentRadianceToIrradiance() {
    this.l00.scaleInPlace(mi[0]), this.l1_1.scaleInPlace(mi[1]), this.l10.scaleInPlace(mi[2]), this.l11.scaleInPlace(mi[3]), this.l2_2.scaleInPlace(mi[4]), this.l2_1.scaleInPlace(mi[5]), this.l20.scaleInPlace(mi[6]), this.l21.scaleInPlace(mi[7]), this.l22.scaleInPlace(mi[8]);
  }
  /**
   * Convert from irradiance to outgoing radiance for Lambertian BDRF, suitable for efficient shader evaluation.
   *
   * ```
   * L = (1/pi) * E * rho
   * ```
   *
   * This is done by an additional scale by 1/pi, so is a fairly trivial operation but important conceptually.
   */
  convertIrradianceToLambertianRadiance() {
    this.scaleInPlace(1 / Math.PI);
  }
  /**
   * Integrates the reconstruction coefficients directly in to the SH preventing further
   * required operations at run time.
   *
   * This is simply done by scaling back the SH with Ylm constants parameter.
   * The trigonometric part being applied by the shader at run time.
   */
  preScaleForRendering() {
    this.preScaled = !0, this.l00.scaleInPlace(li[0]), this.l1_1.scaleInPlace(li[1]), this.l10.scaleInPlace(li[2]), this.l11.scaleInPlace(li[3]), this.l2_2.scaleInPlace(li[4]), this.l2_1.scaleInPlace(li[5]), this.l20.scaleInPlace(li[6]), this.l21.scaleInPlace(li[7]), this.l22.scaleInPlace(li[8]);
  }
  /**
   * update the spherical harmonics coefficients from the given array
   * @param data defines the 9x3 coefficients (l00, l1-1, l10, l11, l2-2, l2-1, l20, l21, l22)
   * @returns the spherical harmonics (this)
   */
  updateFromArray(e) {
    return p.FromArrayToRef(e[0], 0, this.l00), p.FromArrayToRef(e[1], 0, this.l1_1), p.FromArrayToRef(e[2], 0, this.l10), p.FromArrayToRef(e[3], 0, this.l11), p.FromArrayToRef(e[4], 0, this.l2_2), p.FromArrayToRef(e[5], 0, this.l2_1), p.FromArrayToRef(e[6], 0, this.l20), p.FromArrayToRef(e[7], 0, this.l21), p.FromArrayToRef(e[8], 0, this.l22), this;
  }
  /**
   * update the spherical harmonics coefficients from the given floats array
   * @param data defines the 9x3 coefficients (l00, l1-1, l10, l11, l2-2, l2-1, l20, l21, l22)
   * @returns the spherical harmonics (this)
   */
  updateFromFloatsArray(e) {
    return p.FromFloatsToRef(e[0], e[1], e[2], this.l00), p.FromFloatsToRef(e[3], e[4], e[5], this.l1_1), p.FromFloatsToRef(e[6], e[7], e[8], this.l10), p.FromFloatsToRef(e[9], e[10], e[11], this.l11), p.FromFloatsToRef(e[12], e[13], e[14], this.l2_2), p.FromFloatsToRef(e[15], e[16], e[17], this.l2_1), p.FromFloatsToRef(e[18], e[19], e[20], this.l20), p.FromFloatsToRef(e[21], e[22], e[23], this.l21), p.FromFloatsToRef(e[24], e[25], e[26], this.l22), this;
  }
  /**
   * Constructs a spherical harmonics from an array.
   * @param data defines the 9x3 coefficients (l00, l1-1, l10, l11, l2-2, l2-1, l20, l21, l22)
   * @returns the spherical harmonics
   */
  static FromArray(e) {
    return new ks().updateFromArray(e);
  }
  // Keep for references.
  /**
   * Gets the spherical harmonics from polynomial
   * @param polynomial the spherical polynomial
   * @returns the spherical harmonics
   */
  static FromPolynomial(e) {
    const t = new ks();
    return t.l00 = e.xx.scale(0.376127).add(e.yy.scale(0.376127)).add(e.zz.scale(0.376126)), t.l1_1 = e.y.scale(0.977204), t.l10 = e.z.scale(0.977204), t.l11 = e.x.scale(0.977204), t.l2_2 = e.xy.scale(1.16538), t.l2_1 = e.yz.scale(1.16538), t.l20 = e.zz.scale(1.34567).subtract(e.xx.scale(0.672834)).subtract(e.yy.scale(0.672834)), t.l21 = e.zx.scale(1.16538), t.l22 = e.xx.scale(1.16538).subtract(e.yy.scale(1.16538)), t.l1_1.scaleInPlace(-1), t.l11.scaleInPlace(-1), t.l2_1.scaleInPlace(-1), t.l21.scaleInPlace(-1), t.scaleInPlace(Math.PI), t;
  }
}
class Mr {
  constructor() {
    this.x = p.Zero(), this.y = p.Zero(), this.z = p.Zero(), this.xx = p.Zero(), this.yy = p.Zero(), this.zz = p.Zero(), this.xy = p.Zero(), this.yz = p.Zero(), this.zx = p.Zero();
  }
  /**
   * The spherical harmonics used to create the polynomials.
   */
  get preScaledHarmonics() {
    return this._harmonics || (this._harmonics = ks.FromPolynomial(this)), this._harmonics.preScaled || this._harmonics.preScaleForRendering(), this._harmonics;
  }
  /**
   * Adds an ambient color to the spherical polynomial
   * @param color the color to add
   */
  addAmbient(e) {
    C.Vector3[0].copyFromFloats(e.r, e.g, e.b);
    const t = C.Vector3[0];
    this.xx.addInPlace(t), this.yy.addInPlace(t), this.zz.addInPlace(t);
  }
  /**
   * Scales the spherical polynomial by the given amount
   * @param scale the amount to scale
   */
  scaleInPlace(e) {
    this.x.scaleInPlace(e), this.y.scaleInPlace(e), this.z.scaleInPlace(e), this.xx.scaleInPlace(e), this.yy.scaleInPlace(e), this.zz.scaleInPlace(e), this.yz.scaleInPlace(e), this.zx.scaleInPlace(e), this.xy.scaleInPlace(e);
  }
  /**
   * Updates the spherical polynomial from harmonics
   * @param harmonics the spherical harmonics
   * @returns the spherical polynomial
   */
  updateFromHarmonics(e) {
    return this._harmonics = e, this.x.copyFrom(e.l11), this.x.scaleInPlace(1.02333).scaleInPlace(-1), this.y.copyFrom(e.l1_1), this.y.scaleInPlace(1.02333).scaleInPlace(-1), this.z.copyFrom(e.l10), this.z.scaleInPlace(1.02333), this.xx.copyFrom(e.l00), C.Vector3[0].copyFrom(e.l20).scaleInPlace(0.247708), C.Vector3[1].copyFrom(e.l22).scaleInPlace(0.429043), this.xx.scaleInPlace(0.886277).subtractInPlace(C.Vector3[0]).addInPlace(C.Vector3[1]), this.yy.copyFrom(e.l00), this.yy.scaleInPlace(0.886277).subtractInPlace(C.Vector3[0]).subtractInPlace(C.Vector3[1]), this.zz.copyFrom(e.l00), C.Vector3[0].copyFrom(e.l20).scaleInPlace(0.495417), this.zz.scaleInPlace(0.886277).addInPlace(C.Vector3[0]), this.yz.copyFrom(e.l2_1), this.yz.scaleInPlace(0.858086).scaleInPlace(-1), this.zx.copyFrom(e.l21), this.zx.scaleInPlace(0.858086).scaleInPlace(-1), this.xy.copyFrom(e.l2_2), this.xy.scaleInPlace(0.858086), this.scaleInPlace(1 / Math.PI), this;
  }
  /**
   * Gets the spherical polynomial from harmonics
   * @param harmonics the spherical harmonics
   * @returns the spherical polynomial
   */
  static FromHarmonics(e) {
    return new Mr().updateFromHarmonics(e);
  }
  /**
   * Constructs a spherical polynomial from an array.
   * @param data defines the 9x3 coefficients (x, y, z, xx, yy, zz, yz, zx, xy)
   * @returns the spherical polynomial
   */
  static FromArray(e) {
    const t = new Mr();
    return p.FromArrayToRef(e[0], 0, t.x), p.FromArrayToRef(e[1], 0, t.y), p.FromArrayToRef(e[2], 0, t.z), p.FromArrayToRef(e[3], 0, t.xx), p.FromArrayToRef(e[4], 0, t.yy), p.FromArrayToRef(e[5], 0, t.zz), p.FromArrayToRef(e[6], 0, t.yz), p.FromArrayToRef(e[7], 0, t.zx), p.FromArrayToRef(e[8], 0, t.xy), t;
  }
}
class ss {
  constructor(e, t, i, s) {
    this.name = e, this.worldAxisForNormal = t, this.worldAxisForFileX = i, this.worldAxisForFileY = s;
  }
}
class Qs {
  /**
   * Converts a texture to the according Spherical Polynomial data.
   * This extracts the first 3 orders only as they are the only one used in the lighting.
   *
   * @param texture The texture to extract the information from.
   * @returns The Spherical Polynomial data.
   */
  static ConvertCubeMapTextureToSphericalPolynomial(e) {
    var t;
    if (!e.isCube)
      return null;
    (t = e.getScene()) === null || t === void 0 || t.getEngine().flushFramebuffer();
    const i = e.getSize().width, s = e.readPixels(0, void 0, void 0, !1), r = e.readPixels(1, void 0, void 0, !1);
    let n, a;
    e.isRenderTarget ? (n = e.readPixels(3, void 0, void 0, !1), a = e.readPixels(2, void 0, void 0, !1)) : (n = e.readPixels(2, void 0, void 0, !1), a = e.readPixels(3, void 0, void 0, !1));
    const o = e.readPixels(4, void 0, void 0, !1), l = e.readPixels(5, void 0, void 0, !1), c = e.gammaSpace, u = 5;
    let d = 0;
    return (e.textureType == 1 || e.textureType == 2) && (d = 1), new Promise((f) => {
      Promise.all([r, s, n, a, o, l]).then(([_, g, m, y, x, A]) => {
        const T = {
          size: i,
          right: g,
          left: _,
          up: m,
          down: y,
          front: x,
          back: A,
          format: u,
          type: d,
          gammaSpace: c
        };
        f(this.ConvertCubeMapToSphericalPolynomial(T));
      });
    });
  }
  /**
   * Compute the area on the unit sphere of the rectangle defined by (x,y) and the origin
   * See https://www.rorydriscoll.com/2012/01/15/cubemap-texel-solid-angle/
   * @param x
   * @param y
   */
  static _AreaElement(e, t) {
    return Math.atan2(e * t, Math.sqrt(e * e + t * t + 1));
  }
  /**
   * Converts a cubemap to the according Spherical Polynomial data.
   * This extracts the first 3 orders only as they are the only one used in the lighting.
   *
   * @param cubeInfo The Cube map to extract the information from.
   * @returns The Spherical Polynomial data.
   */
  static ConvertCubeMapToSphericalPolynomial(e) {
    const t = new ks();
    let i = 0;
    const s = 2 / e.size, r = s, n = 0.5 * s, a = n - 1;
    for (let d = 0; d < 6; d++) {
      const f = this._FileFaces[d], _ = e[f.name];
      let g = a;
      const m = e.format === 5 ? 4 : 3;
      for (let y = 0; y < e.size; y++) {
        let x = a;
        for (let A = 0; A < e.size; A++) {
          const T = f.worldAxisForFileX.scale(x).add(f.worldAxisForFileY.scale(g)).add(f.worldAxisForNormal);
          T.normalize();
          const M = this._AreaElement(x - n, g - n) - this._AreaElement(x - n, g + n) - this._AreaElement(x + n, g - n) + this._AreaElement(x + n, g + n);
          let b = _[y * e.size * m + A * m + 0], S = _[y * e.size * m + A * m + 1], P = _[y * e.size * m + A * m + 2];
          isNaN(b) && (b = 0), isNaN(S) && (S = 0), isNaN(P) && (P = 0), e.type === 0 && (b /= 255, S /= 255, P /= 255), e.gammaSpace && (b = Math.pow(J.Clamp(b), dr), S = Math.pow(J.Clamp(S), dr), P = Math.pow(J.Clamp(P), dr));
          const D = this.MAX_HDRI_VALUE;
          if (this.PRESERVE_CLAMPED_COLORS) {
            const X = Math.max(b, S, P);
            if (X > D) {
              const k = D / X;
              b *= k, S *= k, P *= k;
            }
          } else
            b = J.Clamp(b, 0, D), S = J.Clamp(S, 0, D), P = J.Clamp(P, 0, D);
          const O = new ie(b, S, P);
          t.addLight(T, O, M), i += M, x += s;
        }
        g += r;
      }
    }
    const u = 4 * Math.PI * 6 / 6 / i;
    return t.scaleInPlace(u), t.convertIncidentRadianceToIrradiance(), t.convertIrradianceToLambertianRadiance(), Mr.FromHarmonics(t);
  }
}
Qs._FileFaces = [
  new ss("right", new p(1, 0, 0), new p(0, 0, -1), new p(0, -1, 0)),
  new ss("left", new p(-1, 0, 0), new p(0, 0, 1), new p(0, -1, 0)),
  new ss("up", new p(0, 1, 0), new p(1, 0, 0), new p(0, 0, 1)),
  new ss("down", new p(0, -1, 0), new p(1, 0, 0), new p(0, 0, -1)),
  new ss("front", new p(0, 0, 1), new p(1, 0, 0), new p(0, -1, 0)),
  new ss("back", new p(0, 0, -1), new p(-1, 0, 0), new p(0, -1, 0))
  // -Z bottom
];
Qs.MAX_HDRI_VALUE = 4096;
Qs.PRESERVE_CLAMPED_COLORS = !1;
const Zl = "postprocessVertexShader", Ql = `attribute vec2 position;uniform vec2 scale;varying vec2 vUV;const vec2 madd=vec2(0.5,0.5);
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
vUV=(position*madd+madd)*scale;gl_Position=vec4(position,0.0,1.0);
#define CUSTOM_VERTEX_MAIN_END
}`;
G.ShadersStore[Zl] = Ql;
const Hr = {
  positions: [1, 1, -1, 1, -1, -1, 1, -1],
  indices: [0, 1, 2, 0, 2, 3]
};
class qa {
  /**
   * Creates an effect renderer
   * @param engine the engine to use for rendering
   * @param options defines the options of the effect renderer
   */
  constructor(e, t = Hr) {
    var i, s;
    this._fullscreenViewport = new Bs(0, 0, 1, 1);
    const r = (i = t.positions) !== null && i !== void 0 ? i : Hr.positions, n = (s = t.indices) !== null && s !== void 0 ? s : Hr.indices;
    this.engine = e, this._vertexBuffers = {
      [v.PositionKind]: new v(e, r, v.PositionKind, !1, !1, 2)
    }, this._indexBuffer = e.createIndexBuffer(n), this._onContextRestoredObserver = e.onContextRestoredObservable.add(() => {
      this._indexBuffer = e.createIndexBuffer(n);
      for (const a in this._vertexBuffers)
        this._vertexBuffers[a]._rebuild();
    });
  }
  /**
   * Sets the current viewport in normalized coordinates 0-1
   * @param viewport Defines the viewport to set (defaults to 0 0 1 1)
   */
  setViewport(e = this._fullscreenViewport) {
    this.engine.setViewport(e);
  }
  /**
   * Binds the embedded attributes buffer to the effect.
   * @param effect Defines the effect to bind the attributes for
   */
  bindBuffers(e) {
    this.engine.bindBuffers(this._vertexBuffers, this._indexBuffer, e);
  }
  /**
   * Sets the current effect wrapper to use during draw.
   * The effect needs to be ready before calling this api.
   * This also sets the default full screen position attribute.
   * @param effectWrapper Defines the effect to draw with
   */
  applyEffectWrapper(e) {
    this.engine.setState(!0), this.engine.depthCullingState.depthTest = !1, this.engine.stencilState.stencilTest = !1, this.engine.enableEffect(e._drawWrapper), this.bindBuffers(e.effect), e.onApplyObservable.notifyObservers({});
  }
  /**
   * Saves engine states
   */
  saveStates() {
    this._savedStateDepthTest = this.engine.depthCullingState.depthTest, this._savedStateStencilTest = this.engine.stencilState.stencilTest;
  }
  /**
   * Restores engine states
   */
  restoreStates() {
    this.engine.depthCullingState.depthTest = this._savedStateDepthTest, this.engine.stencilState.stencilTest = this._savedStateStencilTest;
  }
  /**
   * Draws a full screen quad.
   */
  draw() {
    this.engine.drawElementsType(0, 0, 6);
  }
  _isRenderTargetTexture(e) {
    return e.renderTarget !== void 0;
  }
  /**
   * renders one or more effects to a specified texture
   * @param effectWrapper the effect to renderer
   * @param outputTexture texture to draw to, if null it will render to the screen.
   */
  render(e, t = null) {
    if (!e.effect.isReady())
      return;
    this.saveStates(), this.setViewport();
    const i = t === null ? null : this._isRenderTargetTexture(t) ? t.renderTarget : t;
    i && this.engine.bindFramebuffer(i), this.applyEffectWrapper(e), this.draw(), i && this.engine.unBindFramebuffer(i), this.restoreStates();
  }
  /**
   * Disposes of the effect renderer
   */
  dispose() {
    const e = this._vertexBuffers[v.PositionKind];
    e && (e.dispose(), delete this._vertexBuffers[v.PositionKind]), this._indexBuffer && this.engine._releaseBuffer(this._indexBuffer), this._onContextRestoredObserver && (this.engine.onContextRestoredObservable.remove(this._onContextRestoredObserver), this._onContextRestoredObserver = null);
  }
}
class ja {
  /**
   * The underlying effect
   */
  get effect() {
    return this._drawWrapper.effect;
  }
  set effect(e) {
    this._drawWrapper.effect = e;
  }
  /**
   * Creates an effect to be renderer
   * @param creationOptions options to create the effect
   */
  constructor(e) {
    this.onApplyObservable = new N();
    let t;
    const i = e.uniformNames || [];
    e.vertexShader ? t = {
      fragmentSource: e.fragmentShader,
      vertexSource: e.vertexShader,
      spectorName: e.name || "effectWrapper"
    } : (i.push("scale"), t = {
      fragmentSource: e.fragmentShader,
      vertex: "postprocess",
      spectorName: e.name || "effectWrapper"
    }, this.onApplyObservable.add(() => {
      this.effect.setFloat2("scale", 1, 1);
    }));
    const s = e.defines ? e.defines.join(`
`) : "";
    this._drawWrapper = new xi(e.engine), e.useShaderStore ? (t.fragment = t.fragmentSource, t.vertex || (t.vertex = t.vertexSource), delete t.fragmentSource, delete t.vertexSource, this.effect = e.engine.createEffect(t, e.attributeNames || ["position"], i, e.samplerNames, s, void 0, e.onCompiled, void 0, void 0, e.shaderLanguage)) : (this.effect = new yt(t, e.attributeNames || ["position"], i, e.samplerNames, e.engine, s, void 0, e.onCompiled, void 0, void 0, void 0, e.shaderLanguage), this._onContextRestoredObserver = e.engine.onContextRestoredObservable.add(() => {
      this.effect._pipelineContext = null, this.effect._wasPreviouslyReady = !1, this.effect._prepareEffect();
    }));
  }
  /**
   * Disposes of the effect wrapper
   */
  dispose() {
    this._onContextRestoredObserver && (this.effect.getEngine().onContextRestoredObservable.remove(this._onContextRestoredObserver), this._onContextRestoredObserver = null), this.effect.dispose();
  }
}
const $l = "hdrFilteringVertexShader", Jl = `attribute vec2 position;varying vec3 direction;uniform vec3 up;uniform vec3 right;uniform vec3 front;
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
mat3 view=mat3(up,right,front);direction=view*vec3(position,1.0);gl_Position=vec4(position,0.0,1.0);
#define CUSTOM_VERTEX_MAIN_END
}`;
G.ShadersStore[$l] = Jl;
const eh = "helperFunctions", th = `const float PI=3.1415926535897932384626433832795;const float HALF_MIN=5.96046448e-08; 
const float LinearEncodePowerApprox=2.2;const float GammaEncodePowerApprox=1.0/LinearEncodePowerApprox;const vec3 LuminanceEncodeApprox=vec3(0.2126,0.7152,0.0722);const float Epsilon=0.0000001;
#define saturate(x) clamp(x,0.0,1.0)
#define absEps(x) abs(x)+Epsilon
#define maxEps(x) max(x,Epsilon)
#define saturateEps(x) clamp(x,Epsilon,1.0)
mat3 transposeMat3(mat3 inMatrix) {vec3 i0=inMatrix[0];vec3 i1=inMatrix[1];vec3 i2=inMatrix[2];mat3 outMatrix=mat3(
vec3(i0.x,i1.x,i2.x),
vec3(i0.y,i1.y,i2.y),
vec3(i0.z,i1.z,i2.z)
);return outMatrix;}
mat3 inverseMat3(mat3 inMatrix) {float a00=inMatrix[0][0],a01=inMatrix[0][1],a02=inMatrix[0][2];float a10=inMatrix[1][0],a11=inMatrix[1][1],a12=inMatrix[1][2];float a20=inMatrix[2][0],a21=inMatrix[2][1],a22=inMatrix[2][2];float b01=a22*a11-a12*a21;float b11=-a22*a10+a12*a20;float b21=a21*a10-a11*a20;float det=a00*b01+a01*b11+a02*b21;return mat3(b01,(-a22*a01+a02*a21),(a12*a01-a02*a11),
b11,(a22*a00-a02*a20),(-a12*a00+a02*a10),
b21,(-a21*a00+a01*a20),(a11*a00-a01*a10))/det;}
#if USE_EXACT_SRGB_CONVERSIONS
vec3 toLinearSpaceExact(vec3 color)
{vec3 nearZeroSection=0.0773993808*color;vec3 remainingSection=pow(0.947867299*(color+vec3(0.055)),vec3(2.4));
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
return mix(remainingSection,nearZeroSection,lessThanEqual(color,vec3(0.04045)));
#else
return
vec3(
color.r<=0.04045 ? nearZeroSection.r : remainingSection.r,
color.g<=0.04045 ? nearZeroSection.g : remainingSection.g,
color.b<=0.04045 ? nearZeroSection.b : remainingSection.b);
#endif
}
vec3 toGammaSpaceExact(vec3 color)
{vec3 nearZeroSection=12.92*color;vec3 remainingSection=1.055*pow(color,vec3(0.41666))-vec3(0.055);
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
return mix(remainingSection,nearZeroSection,lessThanEqual(color,vec3(0.0031308)));
#else
return
vec3(
color.r<=0.0031308 ? nearZeroSection.r : remainingSection.r,
color.g<=0.0031308 ? nearZeroSection.g : remainingSection.g,
color.b<=0.0031308 ? nearZeroSection.b : remainingSection.b);
#endif
}
#endif
float toLinearSpace(float color)
{
#if USE_EXACT_SRGB_CONVERSIONS
float nearZeroSection=0.0773993808*color;float remainingSection=pow(0.947867299*(color+0.055),2.4);return color<=0.04045 ? nearZeroSection : remainingSection;
#else
return pow(color,LinearEncodePowerApprox);
#endif
}
vec3 toLinearSpace(vec3 color)
{
#if USE_EXACT_SRGB_CONVERSIONS
return toLinearSpaceExact(color);
#else
return pow(color,vec3(LinearEncodePowerApprox));
#endif
}
vec4 toLinearSpace(vec4 color)
{
#if USE_EXACT_SRGB_CONVERSIONS
return vec4(toLinearSpaceExact(color.rgb),color.a);
#else
return vec4(pow(color.rgb,vec3(LinearEncodePowerApprox)),color.a);
#endif
}
float toGammaSpace(float color)
{
#if USE_EXACT_SRGB_CONVERSIONS
float nearZeroSection=12.92*color;float remainingSection=1.055*pow(color,0.41666)-0.055;return color<=0.0031308 ? nearZeroSection : remainingSection;
#else
return pow(color,GammaEncodePowerApprox);
#endif
}
vec3 toGammaSpace(vec3 color)
{
#if USE_EXACT_SRGB_CONVERSIONS
return toGammaSpaceExact(color);
#else
return pow(color,vec3(GammaEncodePowerApprox));
#endif
}
vec4 toGammaSpace(vec4 color)
{
#if USE_EXACT_SRGB_CONVERSIONS
return vec4(toGammaSpaceExact(color.rgb),color.a);
#else
return vec4(pow(color.rgb,vec3(GammaEncodePowerApprox)),color.a);
#endif
}
float square(float value)
{return value*value;}
vec3 square(vec3 value)
{return value*value;}
float pow5(float value) {float sq=value*value;return sq*sq*value;}
float getLuminance(vec3 color)
{return clamp(dot(color,LuminanceEncodeApprox),0.,1.);}
float getRand(vec2 seed) {return fract(sin(dot(seed.xy ,vec2(12.9898,78.233)))*43758.5453);}
float dither(vec2 seed,float varianceAmount) {float rand=getRand(seed);float normVariance=varianceAmount/255.0;float dither=mix(-normVariance,normVariance,rand);return dither;}
const float rgbdMaxRange=255.0;vec4 toRGBD(vec3 color) {float maxRGB=maxEps(max(color.r,max(color.g,color.b)));float D =max(rgbdMaxRange/maxRGB,1.);D =clamp(floor(D)/255.0,0.,1.);vec3 rgb=color.rgb*D;rgb=toGammaSpace(rgb);return vec4(clamp(rgb,0.,1.),D); }
vec3 fromRGBD(vec4 rgbd) {rgbd.rgb=toLinearSpace(rgbd.rgb);return rgbd.rgb/rgbd.a;}
vec3 parallaxCorrectNormal( vec3 vertexPos,vec3 origVec,vec3 cubeSize,vec3 cubePos ) {vec3 invOrigVec=vec3(1.0,1.0,1.0)/origVec;vec3 halfSize=cubeSize*0.5;vec3 intersecAtMaxPlane=(cubePos+halfSize-vertexPos)*invOrigVec;vec3 intersecAtMinPlane=(cubePos-halfSize-vertexPos)*invOrigVec;vec3 largestIntersec=max(intersecAtMaxPlane,intersecAtMinPlane);float distance=min(min(largestIntersec.x,largestIntersec.y),largestIntersec.z);vec3 intersectPositionWS=vertexPos+origVec*distance;return intersectPositionWS-cubePos;}
`;
G.IncludesShadersStore[eh] = th;
const ih = "importanceSampling", sh = `vec3 hemisphereCosSample(vec2 u) {float phi=2.*PI*u.x;float cosTheta2=1.-u.y;float cosTheta=sqrt(cosTheta2);float sinTheta=sqrt(1.-cosTheta2);return vec3(sinTheta*cos(phi),sinTheta*sin(phi),cosTheta);}
vec3 hemisphereImportanceSampleDggx(vec2 u,float a) {float phi=2.*PI*u.x;float cosTheta2=(1.-u.y)/(1.+(a+1.)*((a-1.)*u.y));float cosTheta=sqrt(cosTheta2);float sinTheta=sqrt(1.-cosTheta2);return vec3(sinTheta*cos(phi),sinTheta*sin(phi),cosTheta);}
vec3 hemisphereImportanceSampleDCharlie(vec2 u,float a) { 
float phi=2.*PI*u.x;float sinTheta=pow(u.y,a/(2.*a+1.));float cosTheta=sqrt(1.-sinTheta*sinTheta);return vec3(sinTheta*cos(phi),sinTheta*sin(phi),cosTheta);}`;
G.IncludesShadersStore[ih] = sh;
const rh = "pbrBRDFFunctions", nh = `#define FRESNEL_MAXIMUM_ON_ROUGH 0.25
#ifdef MS_BRDF_ENERGY_CONSERVATION
vec3 getEnergyConservationFactor(const vec3 specularEnvironmentR0,const vec3 environmentBrdf) {return 1.0+specularEnvironmentR0*(1.0/environmentBrdf.y-1.0);}
#endif
#ifdef ENVIRONMENTBRDF
vec3 getBRDFLookup(float NdotV,float perceptualRoughness) {vec2 UV=vec2(NdotV,perceptualRoughness);vec4 brdfLookup=texture2D(environmentBrdfSampler,UV);
#ifdef ENVIRONMENTBRDF_RGBD
brdfLookup.rgb=fromRGBD(brdfLookup.rgba);
#endif
return brdfLookup.rgb;}
vec3 getReflectanceFromBRDFLookup(const vec3 specularEnvironmentR0,const vec3 specularEnvironmentR90,const vec3 environmentBrdf) {
#ifdef BRDF_V_HEIGHT_CORRELATED
vec3 reflectance=(specularEnvironmentR90-specularEnvironmentR0)*environmentBrdf.x+specularEnvironmentR0*environmentBrdf.y;
#else
vec3 reflectance=specularEnvironmentR0*environmentBrdf.x+specularEnvironmentR90*environmentBrdf.y;
#endif
return reflectance;}
vec3 getReflectanceFromBRDFLookup(const vec3 specularEnvironmentR0,const vec3 environmentBrdf) {
#ifdef BRDF_V_HEIGHT_CORRELATED
vec3 reflectance=mix(environmentBrdf.xxx,environmentBrdf.yyy,specularEnvironmentR0);
#else
vec3 reflectance=specularEnvironmentR0*environmentBrdf.x+environmentBrdf.y;
#endif
return reflectance;}
#endif
/* NOT USED
#if defined(SHEEN) && defined(SHEEN_SOFTER)
float getBRDFLookupCharlieSheen(float NdotV,float perceptualRoughness)
{float c=1.0-NdotV;float c3=c*c*c;return 0.65584461*c3+1.0/(4.16526551+exp(-7.97291361*perceptualRoughness+6.33516894));}
#endif
*/
#if !defined(ENVIRONMENTBRDF) || defined(REFLECTIONMAP_SKYBOX) || defined(ALPHAFRESNEL)
vec3 getReflectanceFromAnalyticalBRDFLookup_Jones(float VdotN,vec3 reflectance0,vec3 reflectance90,float smoothness)
{float weight=mix(FRESNEL_MAXIMUM_ON_ROUGH,1.0,smoothness);return reflectance0+weight*(reflectance90-reflectance0)*pow5(saturate(1.0-VdotN));}
#endif
#if defined(SHEEN) && defined(ENVIRONMENTBRDF)
/**
* The sheen BRDF not containing F can be easily stored in the blue channel of the BRDF texture.
* The blue channel contains DCharlie*VAshikhmin*NdotL as a lokkup table
*/
vec3 getSheenReflectanceFromBRDFLookup(const vec3 reflectance0,const vec3 environmentBrdf) {vec3 sheenEnvironmentReflectance=reflectance0*environmentBrdf.b;return sheenEnvironmentReflectance;}
#endif
vec3 fresnelSchlickGGX(float VdotH,vec3 reflectance0,vec3 reflectance90)
{return reflectance0+(reflectance90-reflectance0)*pow5(1.0-VdotH);}
float fresnelSchlickGGX(float VdotH,float reflectance0,float reflectance90)
{return reflectance0+(reflectance90-reflectance0)*pow5(1.0-VdotH);}
#ifdef CLEARCOAT
vec3 getR0RemappedForClearCoat(vec3 f0) {
#ifdef CLEARCOAT_DEFAULTIOR
#ifdef MOBILE
return saturate(f0*(f0*0.526868+0.529324)-0.0482256);
#else
return saturate(f0*(f0*(0.941892-0.263008*f0)+0.346479)-0.0285998);
#endif
#else
vec3 s=sqrt(f0);vec3 t=(vClearCoatRefractionParams.z+vClearCoatRefractionParams.w*s)/(vClearCoatRefractionParams.w+vClearCoatRefractionParams.z*s);return square(t);
#endif
}
#endif
#ifdef IRIDESCENCE
const mat3 XYZ_TO_REC709=mat3(
3.2404542,-0.9692660, 0.0556434,
-1.5371385, 1.8760108,-0.2040259,
-0.4985314, 0.0415560, 1.0572252
);vec3 getIORTfromAirToSurfaceR0(vec3 f0) {vec3 sqrtF0=sqrt(f0);return (1.+sqrtF0)/(1.-sqrtF0);}
vec3 getR0fromIORs(vec3 iorT,float iorI) {return square((iorT-vec3(iorI))/(iorT+vec3(iorI)));}
float getR0fromIORs(float iorT,float iorI) {return square((iorT-iorI)/(iorT+iorI));}
vec3 evalSensitivity(float opd,vec3 shift) {float phase=2.0*PI*opd*1.0e-9;const vec3 val=vec3(5.4856e-13,4.4201e-13,5.2481e-13);const vec3 pos=vec3(1.6810e+06,1.7953e+06,2.2084e+06);const vec3 var=vec3(4.3278e+09,9.3046e+09,6.6121e+09);vec3 xyz=val*sqrt(2.0*PI*var)*cos(pos*phase+shift)*exp(-square(phase)*var);xyz.x+=9.7470e-14*sqrt(2.0*PI*4.5282e+09)*cos(2.2399e+06*phase+shift[0])*exp(-4.5282e+09*square(phase));xyz/=1.0685e-7;vec3 srgb=XYZ_TO_REC709*xyz;return srgb;}
vec3 evalIridescence(float outsideIOR,float eta2,float cosTheta1,float thinFilmThickness,vec3 baseF0) {vec3 I=vec3(1.0);float iridescenceIOR=mix(outsideIOR,eta2,smoothstep(0.0,0.03,thinFilmThickness));float sinTheta2Sq=square(outsideIOR/iridescenceIOR)*(1.0-square(cosTheta1));float cosTheta2Sq=1.0-sinTheta2Sq;if (cosTheta2Sq<0.0) {return I;}
float cosTheta2=sqrt(cosTheta2Sq);float R0=getR0fromIORs(iridescenceIOR,outsideIOR);float R12=fresnelSchlickGGX(cosTheta1,R0,1.);float R21=R12;float T121=1.0-R12;float phi12=0.0;if (iridescenceIOR<outsideIOR) phi12=PI;float phi21=PI-phi12;vec3 baseIOR=getIORTfromAirToSurfaceR0(clamp(baseF0,0.0,0.9999)); 
vec3 R1=getR0fromIORs(baseIOR,iridescenceIOR);vec3 R23=fresnelSchlickGGX(cosTheta2,R1,vec3(1.));vec3 phi23=vec3(0.0);if (baseIOR[0]<iridescenceIOR) phi23[0]=PI;if (baseIOR[1]<iridescenceIOR) phi23[1]=PI;if (baseIOR[2]<iridescenceIOR) phi23[2]=PI;float opd=2.0*iridescenceIOR*thinFilmThickness*cosTheta2;vec3 phi=vec3(phi21)+phi23;vec3 R123=clamp(R12*R23,1e-5,0.9999);vec3 r123=sqrt(R123);vec3 Rs=square(T121)*R23/(vec3(1.0)-R123);vec3 C0=R12+Rs;I=C0;vec3 Cm=Rs-T121;for (int m=1; m<=2; ++m)
{Cm*=r123;vec3 Sm=2.0*evalSensitivity(float(m)*opd,float(m)*phi);I+=Cm*Sm;}
return max(I,vec3(0.0));}
#endif
float normalDistributionFunction_TrowbridgeReitzGGX(float NdotH,float alphaG)
{float a2=square(alphaG);float d=NdotH*NdotH*(a2-1.0)+1.0;return a2/(PI*d*d);}
#ifdef SHEEN
float normalDistributionFunction_CharlieSheen(float NdotH,float alphaG)
{float invR=1./alphaG;float cos2h=NdotH*NdotH;float sin2h=1.-cos2h;return (2.+invR)*pow(sin2h,invR*.5)/(2.*PI);}
#endif
#ifdef ANISOTROPIC
float normalDistributionFunction_BurleyGGX_Anisotropic(float NdotH,float TdotH,float BdotH,const vec2 alphaTB) {float a2=alphaTB.x*alphaTB.y;vec3 v=vec3(alphaTB.y*TdotH,alphaTB.x *BdotH,a2*NdotH);float v2=dot(v,v);float w2=a2/v2;return a2*w2*w2*RECIPROCAL_PI;}
#endif
#ifdef BRDF_V_HEIGHT_CORRELATED
float smithVisibility_GGXCorrelated(float NdotL,float NdotV,float alphaG) {
#ifdef MOBILE
float GGXV=NdotL*(NdotV*(1.0-alphaG)+alphaG);float GGXL=NdotV*(NdotL*(1.0-alphaG)+alphaG);return 0.5/(GGXV+GGXL);
#else
float a2=alphaG*alphaG;float GGXV=NdotL*sqrt(NdotV*(NdotV-a2*NdotV)+a2);float GGXL=NdotV*sqrt(NdotL*(NdotL-a2*NdotL)+a2);return 0.5/(GGXV+GGXL);
#endif
}
#else
float smithVisibilityG1_TrowbridgeReitzGGXFast(float dot,float alphaG)
{
#ifdef MOBILE
return 1.0/(dot+alphaG+(1.0-alphaG)*dot ));
#else
float alphaSquared=alphaG*alphaG;return 1.0/(dot+sqrt(alphaSquared+(1.0-alphaSquared)*dot*dot));
#endif
}
float smithVisibility_TrowbridgeReitzGGXFast(float NdotL,float NdotV,float alphaG)
{float visibility=smithVisibilityG1_TrowbridgeReitzGGXFast(NdotL,alphaG)*smithVisibilityG1_TrowbridgeReitzGGXFast(NdotV,alphaG);return visibility;}
#endif
#ifdef ANISOTROPIC
float smithVisibility_GGXCorrelated_Anisotropic(float NdotL,float NdotV,float TdotV,float BdotV,float TdotL,float BdotL,const vec2 alphaTB) {float lambdaV=NdotL*length(vec3(alphaTB.x*TdotV,alphaTB.y*BdotV,NdotV));float lambdaL=NdotV*length(vec3(alphaTB.x*TdotL,alphaTB.y*BdotL,NdotL));float v=0.5/(lambdaV+lambdaL);return v;}
#endif
#ifdef CLEARCOAT
float visibility_Kelemen(float VdotH) {return 0.25/(VdotH*VdotH); }
#endif
#ifdef SHEEN
float visibility_Ashikhmin(float NdotL,float NdotV)
{return 1./(4.*(NdotL+NdotV-NdotL*NdotV));}
/* NOT USED
#ifdef SHEEN_SOFTER
float l(float x,float alphaG)
{float oneMinusAlphaSq=(1.0-alphaG)*(1.0-alphaG);float a=mix(21.5473,25.3245,oneMinusAlphaSq);float b=mix(3.82987,3.32435,oneMinusAlphaSq);float c=mix(0.19823,0.16801,oneMinusAlphaSq);float d=mix(-1.97760,-1.27393,oneMinusAlphaSq);float e=mix(-4.32054,-4.85967,oneMinusAlphaSq);return a/(1.0+b*pow(x,c))+d*x+e;}
float lambdaSheen(float cosTheta,float alphaG)
{return abs(cosTheta)<0.5 ? exp(l(cosTheta,alphaG)) : exp(2.0*l(0.5,alphaG)-l(1.0-cosTheta,alphaG));}
float visibility_CharlieSheen(float NdotL,float NdotV,float alphaG)
{float G=1.0/(1.0+lambdaSheen(NdotV,alphaG)+lambdaSheen(NdotL,alphaG));return G/(4.0*NdotV*NdotL);}
#endif
*/
#endif
float diffuseBRDF_Burley(float NdotL,float NdotV,float VdotH,float roughness) {float diffuseFresnelNV=pow5(saturateEps(1.0-NdotL));float diffuseFresnelNL=pow5(saturateEps(1.0-NdotV));float diffuseFresnel90=0.5+2.0*VdotH*VdotH*roughness;float fresnel =
(1.0+(diffuseFresnel90-1.0)*diffuseFresnelNL) *
(1.0+(diffuseFresnel90-1.0)*diffuseFresnelNV);return fresnel/PI;}
#ifdef SS_TRANSLUCENCY
vec3 transmittanceBRDF_Burley(const vec3 tintColor,const vec3 diffusionDistance,float thickness) {vec3 S=1./maxEps(diffusionDistance);vec3 temp=exp((-0.333333333*thickness)*S);return tintColor.rgb*0.25*(temp*temp*temp+3.0*temp);}
float computeWrappedDiffuseNdotL(float NdotL,float w) {float t=1.0+w;float invt2=1.0/square(t);return saturate((NdotL+w)*invt2);}
#endif
`;
G.IncludesShadersStore[rh] = nh;
const ah = "hdrFilteringFunctions", oh = `#ifdef NUM_SAMPLES
#if NUM_SAMPLES>0
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
float radicalInverse_VdC(uint bits) 
{bits=(bits<<16u) | (bits>>16u);bits=((bits & 0x55555555u)<<1u) | ((bits & 0xAAAAAAAAu)>>1u);bits=((bits & 0x33333333u)<<2u) | ((bits & 0xCCCCCCCCu)>>2u);bits=((bits & 0x0F0F0F0Fu)<<4u) | ((bits & 0xF0F0F0F0u)>>4u);bits=((bits & 0x00FF00FFu)<<8u) | ((bits & 0xFF00FF00u)>>8u);return float(bits)*2.3283064365386963e-10; }
vec2 hammersley(uint i,uint N)
{return vec2(float(i)/float(N),radicalInverse_VdC(i));}
#else
float vanDerCorpus(int n,int base)
{float invBase=1.0/float(base);float denom =1.0;float result =0.0;for(int i=0; i<32; ++i)
{if(n>0)
{denom =mod(float(n),2.0);result+=denom*invBase;invBase=invBase/2.0;n =int(float(n)/2.0);}}
return result;}
vec2 hammersley(int i,int N)
{return vec2(float(i)/float(N),vanDerCorpus(i,2));}
#endif
float log4(float x) {return log2(x)/2.;}
const float NUM_SAMPLES_FLOAT=float(NUM_SAMPLES);const float NUM_SAMPLES_FLOAT_INVERSED=1./NUM_SAMPLES_FLOAT;const float K=4.;
#define inline
vec3 irradiance(samplerCube inputTexture,vec3 inputN,vec2 filteringInfo)
{vec3 n=normalize(inputN);vec3 result=vec3(0.0);vec3 tangent=abs(n.z)<0.999 ? vec3(0.,0.,1.) : vec3(1.,0.,0.);tangent=normalize(cross(tangent,n));vec3 bitangent=cross(n,tangent);mat3 tbn=mat3(tangent,bitangent,n);float maxLevel=filteringInfo.y;float dim0=filteringInfo.x;float omegaP=(4.*PI)/(6.*dim0*dim0);
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
for(uint i=0u; i<NUM_SAMPLES; ++i)
#else
for(int i=0; i<NUM_SAMPLES; ++i)
#endif
{vec2 Xi=hammersley(i,NUM_SAMPLES);vec3 Ls=hemisphereCosSample(Xi);Ls=normalize(Ls);vec3 Ns=vec3(0.,0.,1.);float NoL=dot(Ns,Ls);if (NoL>0.) {float pdf_inversed=PI/NoL;float omegaS=NUM_SAMPLES_FLOAT_INVERSED*pdf_inversed;float l=log4(omegaS)-log4(omegaP)+log4(K);float mipLevel=clamp(l,0.0,maxLevel);vec3 c=textureCubeLodEXT(inputTexture,tbn*Ls,mipLevel).rgb;
#ifdef GAMMA_INPUT
c=toLinearSpace(c);
#endif
result+=c;}}
result=result*NUM_SAMPLES_FLOAT_INVERSED;return result;}
#define inline
vec3 radiance(float alphaG,samplerCube inputTexture,vec3 inputN,vec2 filteringInfo)
{vec3 n=normalize(inputN);if (alphaG==0.) {vec3 c=textureCube(inputTexture,n).rgb;
#ifdef GAMMA_INPUT
c=toLinearSpace(c);
#endif
return c;} else {vec3 result=vec3(0.);vec3 tangent=abs(n.z)<0.999 ? vec3(0.,0.,1.) : vec3(1.,0.,0.);tangent=normalize(cross(tangent,n));vec3 bitangent=cross(n,tangent);mat3 tbn=mat3(tangent,bitangent,n);float maxLevel=filteringInfo.y;float dim0=filteringInfo.x;float omegaP=(4.*PI)/(6.*dim0*dim0);float weight=0.;
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
for(uint i=0u; i<NUM_SAMPLES; ++i)
#else
for(int i=0; i<NUM_SAMPLES; ++i)
#endif
{vec2 Xi=hammersley(i,NUM_SAMPLES);vec3 H=hemisphereImportanceSampleDggx(Xi,alphaG);float NoV=1.;float NoH=H.z;float NoH2=H.z*H.z;float NoL=2.*NoH2-1.;vec3 L=vec3(2.*NoH*H.x,2.*NoH*H.y,NoL);L=normalize(L);if (NoL>0.) {float pdf_inversed=4./normalDistributionFunction_TrowbridgeReitzGGX(NoH,alphaG);float omegaS=NUM_SAMPLES_FLOAT_INVERSED*pdf_inversed;float l=log4(omegaS)-log4(omegaP)+log4(K);float mipLevel=clamp(float(l),0.0,maxLevel);weight+=NoL;vec3 c=textureCubeLodEXT(inputTexture,tbn*L,mipLevel).rgb;
#ifdef GAMMA_INPUT
c=toLinearSpace(c);
#endif
result+=c*NoL;}}
result=result/weight;return result;}}
#endif
#endif
`;
G.IncludesShadersStore[ah] = oh;
const lh = "hdrFilteringPixelShader", hh = `#include<helperFunctions>
#include<importanceSampling>
#include<pbrBRDFFunctions>
#include<hdrFilteringFunctions>
uniform float alphaG;uniform samplerCube inputTexture;uniform vec2 vFilteringInfo;uniform float hdrScale;varying vec3 direction;void main() {vec3 color=radiance(alphaG,inputTexture,direction,vFilteringInfo);gl_FragColor=vec4(color*hdrScale,1.0);}`;
G.ShadersStore[lh] = hh;
class ch {
  /**
   * Instantiates HDR filter for reflection maps
   *
   * @param engine Thin engine
   * @param options Options
   */
  constructor(e, t = {}) {
    this._lodGenerationOffset = 0, this._lodGenerationScale = 0.8, this.quality = 4096, this.hdrScale = 1, this._engine = e, this.hdrScale = t.hdrScale || this.hdrScale, this.quality = t.quality || this.quality;
  }
  _createRenderTarget(e) {
    let t = 0;
    this._engine.getCaps().textureHalfFloatRender ? t = 2 : this._engine.getCaps().textureFloatRender && (t = 1);
    const i = this._engine.createRenderTargetCubeTexture(e, {
      format: 5,
      type: t,
      createMipMaps: !0,
      generateMipMaps: !1,
      generateDepthBuffer: !1,
      generateStencilBuffer: !1,
      samplingMode: 1
    });
    return this._engine.updateTextureWrappingMode(i.texture, 0, 0, 0), this._engine.updateTextureSamplingMode(3, i.texture, !0), i;
  }
  _prefilterInternal(e) {
    const t = e.getSize().width, i = J.ILog2(t) + 1, s = this._effectWrapper.effect, r = this._createRenderTarget(t);
    this._effectRenderer.saveStates(), this._effectRenderer.setViewport();
    const n = e.getInternalTexture();
    n && this._engine.updateTextureSamplingMode(3, n, !0), this._effectRenderer.applyEffectWrapper(this._effectWrapper);
    const a = [
      [new p(0, 0, -1), new p(0, -1, 0), new p(1, 0, 0)],
      [new p(0, 0, 1), new p(0, -1, 0), new p(-1, 0, 0)],
      [new p(1, 0, 0), new p(0, 0, 1), new p(0, 1, 0)],
      [new p(1, 0, 0), new p(0, 0, -1), new p(0, -1, 0)],
      [new p(1, 0, 0), new p(0, -1, 0), new p(0, 0, 1)],
      [new p(-1, 0, 0), new p(0, -1, 0), new p(0, 0, -1)]
      // NegativeZ
    ];
    s.setFloat("hdrScale", this.hdrScale), s.setFloat2("vFilteringInfo", e.getSize().width, i), s.setTexture("inputTexture", e);
    for (let c = 0; c < 6; c++) {
      s.setVector3("up", a[c][0]), s.setVector3("right", a[c][1]), s.setVector3("front", a[c][2]);
      for (let u = 0; u < i; u++) {
        this._engine.bindFramebuffer(r, c, void 0, void 0, !0, u), this._effectRenderer.applyEffectWrapper(this._effectWrapper);
        let d = Math.pow(2, (u - this._lodGenerationOffset) / this._lodGenerationScale) / t;
        u === 0 && (d = 0), s.setFloat("alphaG", d), this._effectRenderer.draw();
      }
    }
    this._effectRenderer.restoreStates(), this._engine.restoreDefaultFramebuffer(), this._engine._releaseTexture(e._texture);
    const o = r.texture.type, l = r.texture.format;
    return r._swapAndDie(e._texture), e._texture.type = o, e._texture.format = l, e.gammaSpace = !1, e.lodGenerationOffset = this._lodGenerationOffset, e.lodGenerationScale = this._lodGenerationScale, e._prefiltered = !0, e;
  }
  _createEffect(e, t) {
    const i = [];
    return e.gammaSpace && i.push("#define GAMMA_INPUT"), i.push("#define NUM_SAMPLES " + this.quality + "u"), new ja({
      engine: this._engine,
      name: "hdrFiltering",
      vertexShader: "hdrFiltering",
      fragmentShader: "hdrFiltering",
      samplerNames: ["inputTexture"],
      uniformNames: ["vSampleDirections", "vWeights", "up", "right", "front", "vFilteringInfo", "hdrScale", "alphaG"],
      useShaderStore: !0,
      defines: i,
      onCompiled: t
    });
  }
  /**
   * Get a value indicating if the filter is ready to be used
   * @param texture Texture to filter
   * @returns true if the filter is ready
   */
  isReady(e) {
    return e.isReady() && this._effectWrapper.effect.isReady();
  }
  /**
   * Prefilters a cube texture to have mipmap levels representing roughness values.
   * Prefiltering will be invoked at the end of next rendering pass.
   * This has to be done once the map is loaded, and has not been prefiltered by a third party software.
   * See http://blog.selfshadow.com/publications/s2013-shading-course/karis/s2013_pbs_epic_notes_v2.pdf for more information
   * @param texture Texture to filter
   * @param onFinished Callback when filtering is done
   * @returns Promise called when prefiltering is done
   */
  prefilter(e, t = null) {
    return this._engine._features.allowTexturePrefiltering ? new Promise((i) => {
      this._effectRenderer = new qa(this._engine), this._effectWrapper = this._createEffect(e), this._effectWrapper.effect.executeWhenCompiled(() => {
        this._prefilterInternal(e), this._effectRenderer.dispose(), this._effectWrapper.dispose(), i(), t && t();
      });
    }) : (w.Warn("HDR prefiltering is not available in WebGL 1., you can use real time filtering instead."), Promise.reject("HDR prefiltering is not available in WebGL 1., you can use real time filtering instead."));
  }
}
class uh {
  /**
   * Gets the depth/stencil texture (if created by a createDepthStencilTexture() call)
   */
  get depthStencilTexture() {
    return this._depthStencilTexture;
  }
  /**
   * Indicates if the depth/stencil texture has a stencil aspect
   */
  get depthStencilTextureWithStencil() {
    return this._depthStencilTextureWithStencil;
  }
  /**
   * Defines if the render target wrapper is for a cube texture or if false a 2d texture
   */
  get isCube() {
    return this._isCube;
  }
  /**
   * Defines if the render target wrapper is for a single or multi target render wrapper
   */
  get isMulti() {
    return this._isMulti;
  }
  /**
   * Defines if the render target wrapper is for a single or an array of textures
   */
  get is2DArray() {
    return this.layers > 0;
  }
  /**
   * Gets the size of the render target wrapper (used for cubes, as width=height in this case)
   */
  get size() {
    return this.width;
  }
  /**
   * Gets the width of the render target wrapper
   */
  get width() {
    return this._size.width || this._size;
  }
  /**
   * Gets the height of the render target wrapper
   */
  get height() {
    return this._size.height || this._size;
  }
  /**
   * Gets the number of layers of the render target wrapper (only used if is2DArray is true and wrapper is not a multi render target)
   */
  get layers() {
    return this._size.layers || 0;
  }
  /**
   * Gets the render texture. If this is a multi render target, gets the first texture
   */
  get texture() {
    var e, t;
    return (t = (e = this._textures) === null || e === void 0 ? void 0 : e[0]) !== null && t !== void 0 ? t : null;
  }
  /**
   * Gets the list of render textures. If we are not in a multi render target, the list will be null (use the texture getter instead)
   */
  get textures() {
    return this._textures;
  }
  /**
   * Gets the face indices that correspond to the list of render textures. If we are not in a multi render target, the list will be null
   */
  get faceIndices() {
    return this._faceIndices;
  }
  /**
   * Gets the layer indices that correspond to the list of render textures. If we are not in a multi render target, the list will be null
   */
  get layerIndices() {
    return this._layerIndices;
  }
  /**
   * Gets the sample count of the render target
   */
  get samples() {
    return this._samples;
  }
  /**
   * Sets the sample count of the render target
   * @param value sample count
   * @param initializeBuffers If set to true, the engine will make an initializing call to drawBuffers (only used when isMulti=true).
   * @param force true to force calling the update sample count engine function even if the current sample count is equal to value
   * @returns the sample count that has been set
   */
  setSamples(e, t = !0, i = !1) {
    if (this.samples === e && !i)
      return e;
    const s = this._isMulti ? this._engine.updateMultipleRenderTargetTextureSampleCount(this, e, t) : this._engine.updateRenderTargetTextureSampleCount(this, e);
    return this._samples = e, s;
  }
  /**
   * Initializes the render target wrapper
   * @param isMulti true if the wrapper is a multi render target
   * @param isCube true if the wrapper should render to a cube texture
   * @param size size of the render target (width/height/layers)
   * @param engine engine used to create the render target
   */
  constructor(e, t, i, s) {
    this._textures = null, this._faceIndices = null, this._layerIndices = null, this._samples = 1, this._attachments = null, this._generateStencilBuffer = !1, this._generateDepthBuffer = !1, this._depthStencilTextureWithStencil = !1, this._isMulti = e, this._isCube = t, this._size = i, this._engine = s, this._depthStencilTexture = null;
  }
  /**
   * Sets the render target texture(s)
   * @param textures texture(s) to set
   */
  setTextures(e) {
    Array.isArray(e) ? this._textures = e : e ? this._textures = [e] : this._textures = null;
  }
  /**
   * Set a texture in the textures array
   * @param texture The texture to set
   * @param index The index in the textures array to set
   * @param disposePrevious If this function should dispose the previous texture
   */
  setTexture(e, t = 0, i = !0) {
    this._textures || (this._textures = []), this._textures[t] && i && this._textures[t].dispose(), this._textures[t] = e;
  }
  /**
   * Sets the layer and face indices of every render target texture bound to each color attachment
   * @param layers The layers of each texture to be set
   * @param faces The faces of each texture to be set
   */
  setLayerAndFaceIndices(e, t) {
    this._layerIndices = e, this._faceIndices = t;
  }
  /**
   * Sets the layer and face indices of a texture in the textures array that should be bound to each color attachment
   * @param index The index of the texture in the textures array to modify
   * @param layer The layer of the texture to be set
   * @param face The face of the texture to be set
   */
  setLayerAndFaceIndex(e = 0, t, i) {
    this._layerIndices || (this._layerIndices = []), this._faceIndices || (this._faceIndices = []), t !== void 0 && t >= 0 && (this._layerIndices[e] = t), i !== void 0 && i >= 0 && (this._faceIndices[e] = i);
  }
  /**
   * Creates the depth/stencil texture
   * @param comparisonFunction Comparison function to use for the texture
   * @param bilinearFiltering true if bilinear filtering should be used when sampling the texture
   * @param generateStencil true if the stencil aspect should also be created
   * @param samples sample count to use when creating the texture
   * @param format format of the depth texture
   * @param label defines the label to use for the texture (for debugging purpose only)
   * @returns the depth/stencil created texture
   */
  createDepthStencilTexture(e = 0, t = !0, i = !1, s = 1, r = 14, n) {
    var a;
    return (a = this._depthStencilTexture) === null || a === void 0 || a.dispose(), this._depthStencilTextureWithStencil = i, this._depthStencilTexture = this._engine.createDepthStencilTexture(this._size, {
      bilinearFiltering: t,
      comparisonFunction: e,
      generateStencil: i,
      isCube: this._isCube,
      samples: s,
      depthTextureFormat: r,
      label: n
    }, this), this._depthStencilTexture;
  }
  /**
   * Shares the depth buffer of this render target with another render target.
   * @internal
   * @param renderTarget Destination renderTarget
   */
  _shareDepth(e) {
    this._depthStencilTexture && (e._depthStencilTexture && e._depthStencilTexture.dispose(), e._depthStencilTexture = this._depthStencilTexture, this._depthStencilTexture.incrementReferences());
  }
  /**
   * @internal
   */
  _swapAndDie(e) {
    this.texture && this.texture._swapAndDie(e), this._textures = null, this.dispose(!0);
  }
  _cloneRenderTargetWrapper() {
    var e, t, i, s, r, n, a, o;
    let l = null;
    if (this._isMulti) {
      const c = this.textures;
      if (c && c.length > 0) {
        let u = !1, d = c.length;
        const f = c[c.length - 1]._source;
        (f === Ze.Depth || f === Ze.DepthStencil) && (u = !0, d--);
        const _ = [], g = [], m = [], y = [], x = [], A = [], T = [], M = {};
        for (let P = 0; P < d; ++P) {
          const D = c[P];
          _.push(D.samplingMode), g.push(D.type), m.push(D.format), M[D.uniqueId] !== void 0 ? (y.push(-1), T.push(0)) : (M[D.uniqueId] = P, D.is2DArray ? (y.push(35866), T.push(D.depth)) : D.isCube ? (y.push(34067), T.push(0)) : D.is3D ? (y.push(32879), T.push(D.depth)) : (y.push(3553), T.push(0))), this._faceIndices && x.push((e = this._faceIndices[P]) !== null && e !== void 0 ? e : 0), this._layerIndices && A.push((t = this._layerIndices[P]) !== null && t !== void 0 ? t : 0);
        }
        const b = {
          samplingModes: _,
          generateMipMaps: c[0].generateMipMaps,
          generateDepthBuffer: this._generateDepthBuffer,
          generateStencilBuffer: this._generateStencilBuffer,
          generateDepthTexture: u,
          types: g,
          formats: m,
          textureCount: d,
          targetTypes: y,
          faceIndex: x,
          layerIndex: A,
          layerCounts: T
        }, S = {
          width: this.width,
          height: this.height
        };
        l = this._engine.createMultipleRenderTarget(S, b);
        for (let P = 0; P < d; ++P) {
          if (y[P] !== -1)
            continue;
          const D = M[c[P].uniqueId];
          l.setTexture(l.textures[D], P);
        }
      }
    } else {
      const c = {};
      if (c.generateDepthBuffer = this._generateDepthBuffer, c.generateMipMaps = (s = (i = this.texture) === null || i === void 0 ? void 0 : i.generateMipMaps) !== null && s !== void 0 ? s : !1, c.generateStencilBuffer = this._generateStencilBuffer, c.samplingMode = (r = this.texture) === null || r === void 0 ? void 0 : r.samplingMode, c.type = (n = this.texture) === null || n === void 0 ? void 0 : n.type, c.format = (a = this.texture) === null || a === void 0 ? void 0 : a.format, this.isCube)
        l = this._engine.createRenderTargetCubeTexture(this.width, c);
      else {
        const u = {
          width: this.width,
          height: this.height,
          layers: this.is2DArray ? (o = this.texture) === null || o === void 0 ? void 0 : o.depth : void 0
        };
        l = this._engine.createRenderTargetTexture(u, c);
      }
      l.texture.isReady = !0;
    }
    return l;
  }
  _swapRenderTargetWrapper(e) {
    if (this._textures && e._textures)
      for (let t = 0; t < this._textures.length; ++t)
        this._textures[t]._swapAndDie(e._textures[t], !1), e._textures[t].isReady = !0;
    this._depthStencilTexture && e._depthStencilTexture && (this._depthStencilTexture._swapAndDie(e._depthStencilTexture), e._depthStencilTexture.isReady = !0), this._textures = null, this._depthStencilTexture = null;
  }
  /** @internal */
  _rebuild() {
    const e = this._cloneRenderTargetWrapper();
    if (e) {
      if (this._depthStencilTexture) {
        const t = this._depthStencilTexture.samplingMode, i = t === 2 || t === 3 || t === 11;
        e.createDepthStencilTexture(this._depthStencilTexture._comparisonFunction, i, this._depthStencilTextureWithStencil, this._depthStencilTexture.samples);
      }
      this.samples > 1 && e.setSamples(this.samples), e._swapRenderTargetWrapper(this), e.dispose();
    }
  }
  /**
   * Releases the internal render textures
   */
  releaseTextures() {
    var e, t;
    if (this._textures)
      for (let i = 0; (t = i < ((e = this._textures) === null || e === void 0 ? void 0 : e.length)) !== null && t !== void 0 && t; ++i)
        this._textures[i].dispose();
    this._textures = null;
  }
  /**
   * Disposes the whole render target wrapper
   * @param disposeOnlyFramebuffers true if only the frame buffers should be released (used for the WebGL engine). If false, all the textures will also be released
   */
  dispose(e = !1) {
    var t;
    e || ((t = this._depthStencilTexture) === null || t === void 0 || t.dispose(), this._depthStencilTexture = null, this.releaseTextures()), this._engine._releaseRenderTargetWrapper(this);
  }
}
class dh extends uh {
  constructor(e, t, i, s, r) {
    super(e, t, i, s), this._framebuffer = null, this._depthStencilBuffer = null, this._MSAAFramebuffer = null, this._colorTextureArray = null, this._depthStencilTextureArray = null, this._disposeOnlyFramebuffers = !1, this._context = r;
  }
  _cloneRenderTargetWrapper() {
    let e = null;
    return this._colorTextureArray && this._depthStencilTextureArray ? (e = this._engine.createMultiviewRenderTargetTexture(this.width, this.height), e.texture.isReady = !0) : e = super._cloneRenderTargetWrapper(), e;
  }
  _swapRenderTargetWrapper(e) {
    super._swapRenderTargetWrapper(e), e._framebuffer = this._framebuffer, e._depthStencilBuffer = this._depthStencilBuffer, e._MSAAFramebuffer = this._MSAAFramebuffer, e._colorTextureArray = this._colorTextureArray, e._depthStencilTextureArray = this._depthStencilTextureArray, this._framebuffer = this._depthStencilBuffer = this._MSAAFramebuffer = this._colorTextureArray = this._depthStencilTextureArray = null;
  }
  /**
   * Shares the depth buffer of this render target with another render target.
   * @internal
   * @param renderTarget Destination renderTarget
   */
  _shareDepth(e) {
    super._shareDepth(e);
    const t = this._context, i = this._depthStencilBuffer, s = e._MSAAFramebuffer || e._framebuffer;
    e._depthStencilBuffer && t.deleteRenderbuffer(e._depthStencilBuffer), e._depthStencilBuffer = this._depthStencilBuffer, this._engine._bindUnboundFramebuffer(s), t.framebufferRenderbuffer(t.FRAMEBUFFER, t.DEPTH_ATTACHMENT, t.RENDERBUFFER, i), this._engine._bindUnboundFramebuffer(null);
  }
  /**
   * Binds a texture to this render target on a specific attachment
   * @param texture The texture to bind to the framebuffer
   * @param attachmentIndex Index of the attachment
   * @param faceIndexOrLayer The face or layer of the texture to render to in case of cube texture or array texture
   * @param lodLevel defines the lod level to bind to the frame buffer
   */
  _bindTextureRenderTarget(e, t = 0, i, s = 0) {
    var r, n, a, o;
    if (!e._hardwareTexture)
      return;
    const l = this._framebuffer, c = this._engine._currentFramebuffer;
    if (this._engine._bindUnboundFramebuffer(l), this._engine.webGLVersion > 1) {
      const u = this._context, d = u["COLOR_ATTACHMENT" + t];
      e.is2DArray || e.is3D ? (i = (n = i ?? ((r = this.layerIndices) === null || r === void 0 ? void 0 : r[t])) !== null && n !== void 0 ? n : 0, u.framebufferTextureLayer(u.FRAMEBUFFER, d, e._hardwareTexture.underlyingResource, s, i)) : e.isCube ? (i = (o = i ?? ((a = this.faceIndices) === null || a === void 0 ? void 0 : a[t])) !== null && o !== void 0 ? o : 0, u.framebufferTexture2D(u.FRAMEBUFFER, d, u.TEXTURE_CUBE_MAP_POSITIVE_X + i, e._hardwareTexture.underlyingResource, s)) : u.framebufferTexture2D(u.FRAMEBUFFER, d, u.TEXTURE_2D, e._hardwareTexture.underlyingResource, s);
    } else {
      const u = this._context, d = u["COLOR_ATTACHMENT" + t + "_WEBGL"], f = i !== void 0 ? u.TEXTURE_CUBE_MAP_POSITIVE_X + i : u.TEXTURE_2D;
      u.framebufferTexture2D(u.FRAMEBUFFER, d, f, e._hardwareTexture.underlyingResource, s);
    }
    this._engine._bindUnboundFramebuffer(c);
  }
  /**
   * Set a texture in the textures array
   * @param texture the texture to set
   * @param index the index in the textures array to set
   * @param disposePrevious If this function should dispose the previous texture
   */
  setTexture(e, t = 0, i = !0) {
    super.setTexture(e, t, i), this._bindTextureRenderTarget(e, t);
  }
  /**
   * Sets the layer and face indices of every render target texture
   * @param layers The layer of the texture to be set (make negative to not modify)
   * @param faces The face of the texture to be set (make negative to not modify)
   */
  setLayerAndFaceIndices(e, t) {
    var i, s;
    if (super.setLayerAndFaceIndices(e, t), !this.textures || !this.layerIndices || !this.faceIndices)
      return;
    const r = (s = (i = this._attachments) === null || i === void 0 ? void 0 : i.length) !== null && s !== void 0 ? s : this.textures.length;
    for (let n = 0; n < r; n++) {
      const a = this.textures[n];
      a && (a.is2DArray || a.is3D ? this._bindTextureRenderTarget(a, n, this.layerIndices[n]) : a.isCube ? this._bindTextureRenderTarget(a, n, this.faceIndices[n]) : this._bindTextureRenderTarget(a, n));
    }
  }
  /**
   * Set the face and layer indices of a texture in the textures array
   * @param index The index of the texture in the textures array to modify
   * @param layer The layer of the texture to be set
   * @param face The face of the texture to be set
   */
  setLayerAndFaceIndex(e = 0, t, i) {
    if (super.setLayerAndFaceIndex(e, t, i), !this.textures || !this.layerIndices || !this.faceIndices)
      return;
    const s = this.textures[e];
    s.is2DArray || s.is3D ? this._bindTextureRenderTarget(this.textures[e], e, this.layerIndices[e]) : s.isCube && this._bindTextureRenderTarget(this.textures[e], e, this.faceIndices[e]);
  }
  dispose(e = this._disposeOnlyFramebuffers) {
    const t = this._context;
    e || (this._colorTextureArray && (this._context.deleteTexture(this._colorTextureArray), this._colorTextureArray = null), this._depthStencilTextureArray && (this._context.deleteTexture(this._depthStencilTextureArray), this._depthStencilTextureArray = null)), this._framebuffer && (t.deleteFramebuffer(this._framebuffer), this._framebuffer = null), this._depthStencilBuffer && (t.deleteRenderbuffer(this._depthStencilBuffer), this._depthStencilBuffer = null), this._MSAAFramebuffer && (t.deleteFramebuffer(this._MSAAFramebuffer), this._MSAAFramebuffer = null), super.dispose(e);
  }
}
Z.prototype._createHardwareRenderTargetWrapper = function(h, e, t) {
  const i = new dh(h, e, t, this, this._gl);
  return this._renderTargetWrapperCache.push(i), i;
};
Z.prototype.createRenderTargetTexture = function(h, e) {
  var t, i;
  const s = this._createHardwareRenderTargetWrapper(!1, !1, h);
  let r = !0, n = !1, a = !1, o, l = 1;
  e !== void 0 && typeof e == "object" && (r = (t = e.generateDepthBuffer) !== null && t !== void 0 ? t : !0, n = !!e.generateStencilBuffer, a = !!e.noColorAttachment, o = e.colorAttachment, l = (i = e.samples) !== null && i !== void 0 ? i : 1);
  const c = o || (a ? null : this._createInternalTexture(h, e, !0, Ze.RenderTarget)), u = h.width || h, d = h.height || h, f = this._currentFramebuffer, _ = this._gl, g = _.createFramebuffer();
  return this._bindUnboundFramebuffer(g), s._depthStencilBuffer = this._setupFramebufferDepthAttachments(n, r, u, d), c && !c.is2DArray && _.framebufferTexture2D(_.FRAMEBUFFER, _.COLOR_ATTACHMENT0, _.TEXTURE_2D, c._hardwareTexture.underlyingResource, 0), this._bindUnboundFramebuffer(f), s._framebuffer = g, s._generateDepthBuffer = r, s._generateStencilBuffer = n, s.setTextures(c), this.updateRenderTargetTextureSampleCount(s, l), s;
};
Z.prototype.createDepthStencilTexture = function(h, e, t) {
  if (e.isCube) {
    const i = h.width || h;
    return this._createDepthStencilCubeTexture(i, e, t);
  } else
    return this._createDepthStencilTexture(h, e, t);
};
Z.prototype._createDepthStencilTexture = function(h, e, t) {
  const i = this._gl, s = h.layers || 0, r = s !== 0 ? i.TEXTURE_2D_ARRAY : i.TEXTURE_2D, n = new zt(this, Ze.DepthStencil);
  if (!this._caps.depthTextureExtension)
    return w.Error("Depth texture is not supported by your browser or hardware."), n;
  const a = Object.assign({ bilinearFiltering: !1, comparisonFunction: 0, generateStencil: !1 }, e);
  if (this._bindTextureDirectly(r, n, !0), this._setupDepthStencilTexture(n, h, a.generateStencil, a.comparisonFunction === 0 ? !1 : a.bilinearFiltering, a.comparisonFunction, a.samples), a.depthTextureFormat !== void 0) {
    if (a.depthTextureFormat !== 15 && a.depthTextureFormat !== 16 && a.depthTextureFormat !== 17 && a.depthTextureFormat !== 13 && a.depthTextureFormat !== 14 && a.depthTextureFormat !== 18)
      return w.Error("Depth texture format is not supported."), n;
    n.format = a.depthTextureFormat;
  } else
    n.format = a.generateStencil ? 13 : 16;
  const o = n.format === 17 || n.format === 13 || n.format === 18;
  t._depthStencilTexture = n, t._depthStencilTextureWithStencil = o;
  let l = i.UNSIGNED_INT;
  n.format === 15 ? l = i.UNSIGNED_SHORT : n.format === 17 || n.format === 13 ? l = i.UNSIGNED_INT_24_8 : n.format === 14 ? l = i.FLOAT : n.format === 18 && (l = i.FLOAT_32_UNSIGNED_INT_24_8_REV);
  const c = o ? i.DEPTH_STENCIL : i.DEPTH_COMPONENT;
  let u = c;
  this.webGLVersion > 1 && (n.format === 15 ? u = i.DEPTH_COMPONENT16 : n.format === 16 ? u = i.DEPTH_COMPONENT24 : n.format === 17 || n.format === 13 ? u = i.DEPTH24_STENCIL8 : n.format === 14 ? u = i.DEPTH_COMPONENT32F : n.format === 18 && (u = i.DEPTH32F_STENCIL8)), n.is2DArray ? i.texImage3D(r, 0, u, n.width, n.height, s, 0, c, l, null) : i.texImage2D(r, 0, u, n.width, n.height, 0, c, l, null), this._bindTextureDirectly(r, null), this._internalTexturesCache.push(n);
  const d = t;
  if (d._depthStencilBuffer) {
    const f = this._currentFramebuffer;
    this._bindUnboundFramebuffer(d._framebuffer), i.framebufferRenderbuffer(i.FRAMEBUFFER, i.DEPTH_STENCIL_ATTACHMENT, i.RENDERBUFFER, null), i.framebufferRenderbuffer(i.FRAMEBUFFER, i.DEPTH_ATTACHMENT, i.RENDERBUFFER, null), i.framebufferRenderbuffer(i.FRAMEBUFFER, i.STENCIL_ATTACHMENT, i.RENDERBUFFER, null), this._bindUnboundFramebuffer(f), i.deleteRenderbuffer(d._depthStencilBuffer), d._depthStencilBuffer = null;
  }
  return n;
};
Z.prototype.updateRenderTargetTextureSampleCount = function(h, e) {
  if (this.webGLVersion < 2 || !h || !h.texture)
    return 1;
  if (h.samples === e)
    return e;
  const t = this._gl;
  e = Math.min(e, this.getCaps().maxMSAASamples), h._depthStencilBuffer && (t.deleteRenderbuffer(h._depthStencilBuffer), h._depthStencilBuffer = null), h._MSAAFramebuffer && (t.deleteFramebuffer(h._MSAAFramebuffer), h._MSAAFramebuffer = null);
  const i = h.texture._hardwareTexture;
  if (i.releaseMSAARenderBuffers(), e > 1 && typeof t.renderbufferStorageMultisample == "function") {
    const s = t.createFramebuffer();
    if (!s)
      throw new Error("Unable to create multi sampled framebuffer");
    h._MSAAFramebuffer = s, this._bindUnboundFramebuffer(h._MSAAFramebuffer);
    const r = this._createRenderBuffer(h.texture.width, h.texture.height, e, -1, this._getRGBAMultiSampleBufferFormat(h.texture.type), t.COLOR_ATTACHMENT0, !1);
    if (!r)
      throw new Error("Unable to create multi sampled framebuffer");
    i.addMSAARenderBuffer(r);
  } else
    this._bindUnboundFramebuffer(h._framebuffer);
  return h.texture.samples = e, h._samples = e, h._depthStencilBuffer = this._setupFramebufferDepthAttachments(h._generateStencilBuffer, h._generateDepthBuffer, h.texture.width, h.texture.height, e), this._bindUnboundFramebuffer(null), e;
};
Z.prototype.createRenderTargetCubeTexture = function(h, e) {
  const t = this._createHardwareRenderTargetWrapper(!1, !0, h), i = Object.assign({ generateMipMaps: !0, generateDepthBuffer: !0, generateStencilBuffer: !1, type: 0, samplingMode: 3, format: 5 }, e);
  i.generateStencilBuffer = i.generateDepthBuffer && i.generateStencilBuffer, (i.type === 1 && !this._caps.textureFloatLinearFiltering || i.type === 2 && !this._caps.textureHalfFloatLinearFiltering) && (i.samplingMode = 1);
  const s = this._gl, r = new zt(this, Ze.RenderTarget);
  this._bindTextureDirectly(s.TEXTURE_CUBE_MAP, r, !0);
  const n = this._getSamplingParameters(i.samplingMode, i.generateMipMaps);
  i.type === 1 && !this._caps.textureFloat && (i.type = 0, w.Warn("Float textures are not supported. Cube render target forced to TEXTURETYPE_UNESIGNED_BYTE type")), s.texParameteri(s.TEXTURE_CUBE_MAP, s.TEXTURE_MAG_FILTER, n.mag), s.texParameteri(s.TEXTURE_CUBE_MAP, s.TEXTURE_MIN_FILTER, n.min), s.texParameteri(s.TEXTURE_CUBE_MAP, s.TEXTURE_WRAP_S, s.CLAMP_TO_EDGE), s.texParameteri(s.TEXTURE_CUBE_MAP, s.TEXTURE_WRAP_T, s.CLAMP_TO_EDGE);
  for (let o = 0; o < 6; o++)
    s.texImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + o, 0, this._getRGBABufferInternalSizedFormat(i.type, i.format), h, h, 0, this._getInternalFormat(i.format), this._getWebGLTextureType(i.type), null);
  const a = s.createFramebuffer();
  return this._bindUnboundFramebuffer(a), t._depthStencilBuffer = this._setupFramebufferDepthAttachments(i.generateStencilBuffer, i.generateDepthBuffer, h, h), i.generateMipMaps && s.generateMipmap(s.TEXTURE_CUBE_MAP), this._bindTextureDirectly(s.TEXTURE_CUBE_MAP, null), this._bindUnboundFramebuffer(null), t._framebuffer = a, t._generateDepthBuffer = i.generateDepthBuffer, t._generateStencilBuffer = i.generateStencilBuffer, r.width = h, r.height = h, r.isReady = !0, r.isCube = !0, r.samples = 1, r.generateMipMaps = i.generateMipMaps, r.samplingMode = i.samplingMode, r.type = i.type, r.format = i.format, this._internalTexturesCache.push(r), t.setTextures(r), t;
};
const Za = "passPixelShader", Qa = `varying vec2 vUV;uniform sampler2D textureSampler;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) 
{gl_FragColor=texture2D(textureSampler,vUV);}`;
G.ShadersStore[Za] = Qa;
const aa = { name: Za, shader: Qa };
class Pt {
  static _CreateDumpRenderer() {
    if (!Pt._DumpToolsEngine) {
      let e = new OffscreenCanvas(100, 100), t = null;
      const i = {
        preserveDrawingBuffer: !0,
        depth: !1,
        stencil: !1,
        alpha: !0,
        premultipliedAlpha: !1,
        antialias: !1,
        failIfMajorPerformanceCaveat: !1
      };
      try {
        t = new Z(e, !1, i);
      } catch {
        e = document.createElement("canvas"), t = new Z(e, !1, i);
      }
      t.getCaps().parallelShaderCompile = void 0;
      const s = new qa(t), r = new ja({
        engine: t,
        name: aa.name,
        fragmentShader: aa.shader,
        samplerNames: ["textureSampler"]
      });
      Pt._DumpToolsEngine = {
        canvas: e,
        engine: t,
        renderer: s,
        wrapper: r
      };
    }
    return Pt._DumpToolsEngine;
  }
  /**
   * Dumps the current bound framebuffer
   * @param width defines the rendering width
   * @param height defines the rendering height
   * @param engine defines the hosting engine
   * @param successCallback defines the callback triggered once the data are available
   * @param mimeType defines the mime type of the result
   * @param fileName defines the filename to download. If present, the result will automatically be downloaded
   * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
   * @returns a void promise
   */
  static async DumpFramebuffer(e, t, i, s, r = "image/png", n, a) {
    const o = await i.readPixels(0, 0, e, t), l = new Uint8Array(o.buffer);
    Pt.DumpData(e, t, l, s, r, n, !0, void 0, a);
  }
  /**
   * Dumps an array buffer
   * @param width defines the rendering width
   * @param height defines the rendering height
   * @param data the data array
   * @param mimeType defines the mime type of the result
   * @param fileName defines the filename to download. If present, the result will automatically be downloaded
   * @param invertY true to invert the picture in the Y dimension
   * @param toArrayBuffer true to convert the data to an ArrayBuffer (encoded as `mimeType`) instead of a base64 string
   * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
   * @returns a promise that resolve to the final data
   */
  static DumpDataAsync(e, t, i, s = "image/png", r, n = !1, a = !1, o) {
    return new Promise((l) => {
      Pt.DumpData(e, t, i, (c) => l(c), s, r, n, a, o);
    });
  }
  /**
   * Dumps an array buffer
   * @param width defines the rendering width
   * @param height defines the rendering height
   * @param data the data array
   * @param successCallback defines the callback triggered once the data are available
   * @param mimeType defines the mime type of the result
   * @param fileName defines the filename to download. If present, the result will automatically be downloaded
   * @param invertY true to invert the picture in the Y dimension
   * @param toArrayBuffer true to convert the data to an ArrayBuffer (encoded as `mimeType`) instead of a base64 string
   * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
   */
  static DumpData(e, t, i, s, r = "image/png", n, a = !1, o = !1, l) {
    const c = Pt._CreateDumpRenderer();
    if (c.engine.setSize(e, t, !0), i instanceof Float32Array) {
      const d = new Uint8Array(i.length);
      let f = i.length;
      for (; f--; ) {
        const _ = i[f];
        d[f] = Math.round(J.Clamp(_) * 255);
      }
      i = d;
    }
    const u = c.engine.createRawTexture(i, e, t, 5, !1, !a, 1);
    c.renderer.setViewport(), c.renderer.applyEffectWrapper(c.wrapper), c.wrapper.effect._bindTexture("textureSampler", u), c.renderer.draw(), o ? z.ToBlob(c.canvas, (d) => {
      const f = new FileReader();
      f.onload = (_) => {
        const g = _.target.result;
        s && s(g);
      }, f.readAsArrayBuffer(d);
    }, r, l) : z.EncodeScreenshotCanvasData(c.canvas, s, r, n, l), u.dispose();
  }
  /**
   * Dispose the dump tools associated resources
   */
  static Dispose() {
    Pt._DumpToolsEngine && (Pt._DumpToolsEngine.wrapper.dispose(), Pt._DumpToolsEngine.renderer.dispose(), Pt._DumpToolsEngine.engine.dispose()), Pt._DumpToolsEngine = null;
  }
}
const fh = () => {
  z.DumpData = Pt.DumpData, z.DumpDataAsync = Pt.DumpDataAsync, z.DumpFramebuffer = Pt.DumpFramebuffer;
};
fh();
class Mi extends W {
  /**
   * Use this list to define the list of mesh you want to render.
   */
  get renderList() {
    return this._renderList;
  }
  set renderList(e) {
    this._unObserveRenderList && (this._unObserveRenderList(), this._unObserveRenderList = null), e && (this._unObserveRenderList = Ra(e, this._renderListHasChanged)), this._renderList = e;
  }
  /**
   * Post-processes for this render target
   */
  get postProcesses() {
    return this._postProcesses;
  }
  get _prePassEnabled() {
    return !!this._prePassRenderTarget && this._prePassRenderTarget.enabled;
  }
  /**
   * Set a after unbind callback in the texture.
   * This has been kept for backward compatibility and use of onAfterUnbindObservable is recommended.
   */
  set onAfterUnbind(e) {
    this._onAfterUnbindObserver && this.onAfterUnbindObservable.remove(this._onAfterUnbindObserver), this._onAfterUnbindObserver = this.onAfterUnbindObservable.add(e);
  }
  /**
   * Set a before render callback in the texture.
   * This has been kept for backward compatibility and use of onBeforeRenderObservable is recommended.
   */
  set onBeforeRender(e) {
    this._onBeforeRenderObserver && this.onBeforeRenderObservable.remove(this._onBeforeRenderObserver), this._onBeforeRenderObserver = this.onBeforeRenderObservable.add(e);
  }
  /**
   * Set a after render callback in the texture.
   * This has been kept for backward compatibility and use of onAfterRenderObservable is recommended.
   */
  set onAfterRender(e) {
    this._onAfterRenderObserver && this.onAfterRenderObservable.remove(this._onAfterRenderObserver), this._onAfterRenderObserver = this.onAfterRenderObservable.add(e);
  }
  /**
   * Set a clear callback in the texture.
   * This has been kept for backward compatibility and use of onClearObservable is recommended.
   */
  set onClear(e) {
    this._onClearObserver && this.onClearObservable.remove(this._onClearObserver), this._onClearObserver = this.onClearObservable.add(e);
  }
  /**
   * Gets the render pass ids used by the render target texture. For a single render target the array length will be 1, for a cube texture it will be 6 and for
   * a 2D texture array it will return an array of ids the size of the 2D texture array
   */
  get renderPassIds() {
    return this._renderPassIds;
  }
  /**
   * Gets the current value of the refreshId counter
   */
  get currentRefreshId() {
    return this._currentRefreshId;
  }
  /**
   * Sets a specific material to be used to render a mesh/a list of meshes in this render target texture
   * @param mesh mesh or array of meshes
   * @param material material or array of materials to use for this render pass. If undefined is passed, no specific material will be used but the regular material instead (mesh.material). It's possible to provide an array of materials to use a different material for each rendering in the case of a cube texture (6 rendering) and a 2D texture array (as many rendering as the length of the array)
   */
  setMaterialForRendering(e, t) {
    let i;
    Array.isArray(e) ? i = e : i = [e];
    for (let s = 0; s < i.length; ++s)
      for (let r = 0; r < this._renderPassIds.length; ++r)
        i[s].setMaterialForRenderPass(this._renderPassIds[r], t !== void 0 ? Array.isArray(t) ? t[r] : t : void 0);
  }
  /**
   * Define if the texture has multiple draw buffers or if false a single draw buffer.
   */
  get isMulti() {
    var e, t;
    return (t = (e = this._renderTarget) === null || e === void 0 ? void 0 : e.isMulti) !== null && t !== void 0 ? t : !1;
  }
  /**
   * Gets render target creation options that were used.
   */
  get renderTargetOptions() {
    return this._renderTargetOptions;
  }
  /**
   * Gets the render target wrapper associated with this render target
   */
  get renderTarget() {
    return this._renderTarget;
  }
  _onRatioRescale() {
    this._sizeRatio && this.resize(this._initialSizeParameter);
  }
  /**
   * Gets or sets the size of the bounding box associated with the texture (when in cube mode)
   * When defined, the cubemap will switch to local mode
   * @see https://community.arm.com/graphics/b/blog/posts/reflections-based-on-local-cubemaps-in-unity
   * @example https://www.babylonjs-playground.com/#RNASML
   */
  set boundingBoxSize(e) {
    if (this._boundingBoxSize && this._boundingBoxSize.equals(e))
      return;
    this._boundingBoxSize = e;
    const t = this.getScene();
    t && t.markAllMaterialsAsDirty(1);
  }
  get boundingBoxSize() {
    return this._boundingBoxSize;
  }
  /**
   * In case the RTT has been created with a depth texture, get the associated
   * depth texture.
   * Otherwise, return null.
   */
  get depthStencilTexture() {
    var e, t;
    return (t = (e = this._renderTarget) === null || e === void 0 ? void 0 : e._depthStencilTexture) !== null && t !== void 0 ? t : null;
  }
  /** @internal */
  constructor(e, t, i, s = !1, r = !0, n = 0, a = !1, o = W.TRILINEAR_SAMPLINGMODE, l = !0, c = !1, u = !1, d = 5, f = !1, _, g, m = !1, y = !1) {
    var x, A, T, M, b, S;
    let P;
    if (typeof s == "object") {
      const O = s;
      s = !!O.generateMipMaps, r = (x = O.doNotChangeAspectRatio) !== null && x !== void 0 ? x : !0, n = (A = O.type) !== null && A !== void 0 ? A : 0, a = !!O.isCube, o = (T = O.samplingMode) !== null && T !== void 0 ? T : W.TRILINEAR_SAMPLINGMODE, l = (M = O.generateDepthBuffer) !== null && M !== void 0 ? M : !0, c = !!O.generateStencilBuffer, u = !!O.isMulti, d = (b = O.format) !== null && b !== void 0 ? b : 5, f = !!O.delayAllocation, _ = O.samples, g = O.creationFlags, m = !!O.noColorAttachment, y = !!O.useSRGBBuffer, P = O.colorAttachment;
    }
    if (super(null, i, !s, void 0, o, void 0, void 0, void 0, void 0, d), this._unObserveRenderList = null, this._renderListHasChanged = (O, X) => {
      var k;
      const Y = this._renderList ? this._renderList.length : 0;
      (X === 0 && Y > 0 || Y === 0) && ((k = this.getScene()) === null || k === void 0 || k.meshes.forEach((se) => {
        se._markSubMeshesAsLightDirty();
      }));
    }, this.renderParticles = !0, this.renderSprites = !1, this.forceLayerMaskCheck = !1, this.ignoreCameraViewport = !1, this.onBeforeBindObservable = new N(), this.onAfterUnbindObservable = new N(), this.onBeforeRenderObservable = new N(), this.onAfterRenderObservable = new N(), this.onClearObservable = new N(), this.onResizeObservable = new N(), this._cleared = !1, this.skipInitialClear = !1, this._currentRefreshId = -1, this._refreshRate = 1, this._samples = 1, this._canRescale = !0, this._renderTarget = null, this.boundingBoxPosition = p.Zero(), i = this.getScene(), !i)
      return;
    const D = this.getScene().getEngine();
    this._coordinatesMode = W.PROJECTION_MODE, this.renderList = new Array(), this.name = e, this.isRenderTarget = !0, this._initialSizeParameter = t, this._renderPassIds = [], this._isCubeData = a, this._processSizeParameter(t), this.renderPassId = this._renderPassIds[0], this._resizeObserver = D.onResizeObservable.add(() => {
    }), this._generateMipMaps = !!s, this._doNotChangeAspectRatio = r, this._renderingManager = new bt(i), this._renderingManager._useSceneAutoClearSetup = !0, !u && (this._renderTargetOptions = {
      generateMipMaps: s,
      type: n,
      format: (S = this._format) !== null && S !== void 0 ? S : void 0,
      samplingMode: this.samplingMode,
      generateDepthBuffer: l,
      generateStencilBuffer: c,
      samples: _,
      creationFlags: g,
      noColorAttachment: m,
      useSRGBBuffer: y,
      colorAttachment: P,
      label: this.name
    }, this.samplingMode === W.NEAREST_SAMPLINGMODE && (this.wrapU = W.CLAMP_ADDRESSMODE, this.wrapV = W.CLAMP_ADDRESSMODE), f || (a ? (this._renderTarget = i.getEngine().createRenderTargetCubeTexture(this.getRenderSize(), this._renderTargetOptions), this.coordinatesMode = W.INVCUBIC_MODE, this._textureMatrix = I.Identity()) : this._renderTarget = i.getEngine().createRenderTargetTexture(this._size, this._renderTargetOptions), this._texture = this._renderTarget.texture, _ !== void 0 && (this.samples = _)));
  }
  /**
   * Creates a depth stencil texture.
   * This is only available in WebGL 2 or with the depth texture extension available.
   * @param comparisonFunction Specifies the comparison function to set on the texture. If 0 or undefined, the texture is not in comparison mode (default: 0)
   * @param bilinearFiltering Specifies whether or not bilinear filtering is enable on the texture (default: true)
   * @param generateStencil Specifies whether or not a stencil should be allocated in the texture (default: false)
   * @param samples sample count of the depth/stencil texture (default: 1)
   * @param format format of the depth texture (default: 14)
   */
  createDepthStencilTexture(e = 0, t = !0, i = !1, s = 1, r = 14) {
    var n;
    (n = this._renderTarget) === null || n === void 0 || n.createDepthStencilTexture(e, t, i, s, r);
  }
  _releaseRenderPassId() {
    if (this._scene) {
      const e = this._scene.getEngine();
      for (let t = 0; t < this._renderPassIds.length; ++t)
        e.releaseRenderPassId(this._renderPassIds[t]);
    }
    this._renderPassIds = [];
  }
  _createRenderPassId() {
    this._releaseRenderPassId();
    const e = this._scene.getEngine(), t = this._isCubeData ? 6 : this.getRenderLayers() || 1;
    for (let i = 0; i < t; ++i)
      this._renderPassIds[i] = e.createRenderPassId(`RenderTargetTexture - ${this.name}#${i}`);
  }
  _processSizeParameter(e, t = !0) {
    if (e.ratio) {
      this._sizeRatio = e.ratio;
      const i = this._getEngine();
      this._size = {
        width: this._bestReflectionRenderTargetDimension(i.getRenderWidth(), this._sizeRatio),
        height: this._bestReflectionRenderTargetDimension(i.getRenderHeight(), this._sizeRatio)
      };
    } else
      this._size = e;
    t && this._createRenderPassId();
  }
  /**
   * Define the number of samples to use in case of MSAA.
   * It defaults to one meaning no MSAA has been enabled.
   */
  get samples() {
    var e, t;
    return (t = (e = this._renderTarget) === null || e === void 0 ? void 0 : e.samples) !== null && t !== void 0 ? t : this._samples;
  }
  set samples(e) {
    this._renderTarget && (this._samples = this._renderTarget.setSamples(e));
  }
  /**
   * Resets the refresh counter of the texture and start bak from scratch.
   * Could be useful to regenerate the texture if it is setup to render only once.
   */
  resetRefreshCounter() {
    this._currentRefreshId = -1;
  }
  /**
   * Define the refresh rate of the texture or the rendering frequency.
   * Use 0 to render just once, 1 to render on every frame, 2 to render every two frames and so on...
   */
  get refreshRate() {
    return this._refreshRate;
  }
  set refreshRate(e) {
    this._refreshRate = e, this.resetRefreshCounter();
  }
  /**
   * Adds a post process to the render target rendering passes.
   * @param postProcess define the post process to add
   */
  addPostProcess(e) {
    if (!this._postProcessManager) {
      const t = this.getScene();
      if (!t)
        return;
      this._postProcessManager = new nn(t), this._postProcesses = new Array();
    }
    this._postProcesses.push(e), this._postProcesses[0].autoClear = !1;
  }
  /**
   * Clear all the post processes attached to the render target
   * @param dispose define if the cleared post processes should also be disposed (false by default)
   */
  clearPostProcesses(e = !1) {
    if (this._postProcesses) {
      if (e)
        for (const t of this._postProcesses)
          t.dispose();
      this._postProcesses = [];
    }
  }
  /**
   * Remove one of the post process from the list of attached post processes to the texture
   * @param postProcess define the post process to remove from the list
   */
  removePostProcess(e) {
    if (!this._postProcesses)
      return;
    const t = this._postProcesses.indexOf(e);
    t !== -1 && (this._postProcesses.splice(t, 1), this._postProcesses.length > 0 && (this._postProcesses[0].autoClear = !1));
  }
  /** @internal */
  _shouldRender() {
    return this._currentRefreshId === -1 ? (this._currentRefreshId = 1, !0) : this.refreshRate === this._currentRefreshId ? (this._currentRefreshId = 1, !0) : (this._currentRefreshId++, !1);
  }
  /**
   * Gets the actual render size of the texture.
   * @returns the width of the render size
   */
  getRenderSize() {
    return this.getRenderWidth();
  }
  /**
   * Gets the actual render width of the texture.
   * @returns the width of the render size
   */
  getRenderWidth() {
    return this._size.width ? this._size.width : this._size;
  }
  /**
   * Gets the actual render height of the texture.
   * @returns the height of the render size
   */
  getRenderHeight() {
    return this._size.width ? this._size.height : this._size;
  }
  /**
   * Gets the actual number of layers of the texture.
   * @returns the number of layers
   */
  getRenderLayers() {
    const e = this._size.layers;
    return e || 0;
  }
  /**
   * Don't allow this render target texture to rescale. Mainly used to prevent rescaling by the scene optimizer.
   */
  disableRescaling() {
    this._canRescale = !1;
  }
  /**
   * Get if the texture can be rescaled or not.
   */
  get canRescale() {
    return this._canRescale;
  }
  /**
   * Resize the texture using a ratio.
   * @param ratio the ratio to apply to the texture size in order to compute the new target size
   */
  scale(e) {
    const t = Math.max(1, this.getRenderSize() * e);
    this.resize(t);
  }
  /**
   * Get the texture reflection matrix used to rotate/transform the reflection.
   * @returns the reflection matrix
   */
  getReflectionTextureMatrix() {
    return this.isCube ? this._textureMatrix : super.getReflectionTextureMatrix();
  }
  /**
   * Resize the texture to a new desired size.
   * Be careful as it will recreate all the data in the new texture.
   * @param size Define the new size. It can be:
   *   - a number for squared texture,
   *   - an object containing { width: number, height: number }
   *   - or an object containing a ratio { ratio: number }
   */
  resize(e) {
    var t;
    const i = this.isCube;
    (t = this._renderTarget) === null || t === void 0 || t.dispose(), this._renderTarget = null;
    const s = this.getScene();
    s && (this._processSizeParameter(e, !1), i ? this._renderTarget = s.getEngine().createRenderTargetCubeTexture(this.getRenderSize(), this._renderTargetOptions) : this._renderTarget = s.getEngine().createRenderTargetTexture(this._size, this._renderTargetOptions), this._texture = this._renderTarget.texture, this._renderTargetOptions.samples !== void 0 && (this.samples = this._renderTargetOptions.samples), this.onResizeObservable.hasObservers() && this.onResizeObservable.notifyObservers(this));
  }
  /**
   * Renders all the objects from the render list into the texture.
   * @param useCameraPostProcess Define if camera post processes should be used during the rendering
   * @param dumpForDebug Define if the rendering result should be dumped (copied) for debugging purpose
   */
  render(e = !1, t = !1) {
    this._render(e, t);
  }
  /**
   * This function will check if the render target texture can be rendered (textures are loaded, shaders are compiled)
   * @returns true if all required resources are ready
   */
  isReadyForRendering() {
    return this._render(!1, !1, !0);
  }
  _render(e = !1, t = !1, i = !1) {
    var s;
    const r = this.getScene();
    if (!r)
      return i;
    const n = r.getEngine();
    if (this.useCameraPostProcesses !== void 0 && (e = this.useCameraPostProcesses), this._waitingRenderList) {
      this.renderList = [];
      for (let u = 0; u < this._waitingRenderList.length; u++) {
        const d = this._waitingRenderList[u], f = r.getMeshById(d);
        f && this.renderList.push(f);
      }
      this._waitingRenderList = void 0;
    }
    if (this.renderListPredicate) {
      this.renderList ? this.renderList.length = 0 : this.renderList = [];
      const u = this.getScene();
      if (!u)
        return i;
      const d = u.meshes;
      for (let f = 0; f < d.length; f++) {
        const _ = d[f];
        this.renderListPredicate(_) && this.renderList.push(_);
      }
    }
    const a = n.currentRenderPassId;
    this.onBeforeBindObservable.notifyObservers(this);
    const o = (s = this.activeCamera) !== null && s !== void 0 ? s : r.activeCamera, l = r.activeCamera;
    o && (o !== r.activeCamera && (r.setTransformMatrix(o.getViewMatrix(), o.getProjectionMatrix(!0)), r.activeCamera = o), n.setViewport(o.rigParent ? o.rigParent.viewport : o.viewport, this.getRenderWidth(), this.getRenderHeight())), this._defaultRenderListPrepared = !1;
    let c = i;
    if (i) {
      r.getViewMatrix() || r.updateTransformMatrix();
      const u = this.is2DArray ? this.getRenderLayers() : this.isCube ? 6 : 1;
      for (let d = 0; d < u && c; d++) {
        let f = null;
        const _ = this.renderList ? this.renderList : r.getActiveMeshes().data, g = this.renderList ? this.renderList.length : r.getActiveMeshes().length;
        n.currentRenderPassId = this._renderPassIds[d], this.onBeforeRenderObservable.notifyObservers(d), this.getCustomRenderList && (f = this.getCustomRenderList(d, _, g)), f || (f = _), this._doNotChangeAspectRatio || r.updateTransformMatrix(!0);
        for (let m = 0; m < f.length && c; ++m) {
          const y = f[m];
          if (!(!y.isEnabled() || y.isBlocked || !y.isVisible || !y.subMeshes)) {
            if (this.customIsReadyFunction) {
              if (!this.customIsReadyFunction(y, this.refreshRate, i)) {
                c = !1;
                continue;
              }
            } else if (!y.isReady(!0)) {
              c = !1;
              continue;
            }
          }
        }
        this.onAfterRenderObservable.notifyObservers(d), (this.is2DArray || this.isCube) && (r.incrementRenderId(), r.resetCachedMaterial());
      }
    } else if (this.is2DArray && !this.isMulti)
      for (let u = 0; u < this.getRenderLayers(); u++)
        this._renderToTarget(0, e, t, u, o), r.incrementRenderId(), r.resetCachedMaterial();
    else if (this.isCube && !this.isMulti)
      for (let u = 0; u < 6; u++)
        this._renderToTarget(u, e, t, void 0, o), r.incrementRenderId(), r.resetCachedMaterial();
    else
      this._renderToTarget(0, e, t, void 0, o);
    return this.onAfterUnbindObservable.notifyObservers(this), n.currentRenderPassId = a, l && (r.activeCamera = l, (r.getEngine().scenes.length > 1 || this.activeCamera && this.activeCamera !== r.activeCamera) && r.setTransformMatrix(r.activeCamera.getViewMatrix(), r.activeCamera.getProjectionMatrix(!0)), n.setViewport(r.activeCamera.viewport)), r.resetCachedMaterial(), c;
  }
  _bestReflectionRenderTargetDimension(e, t) {
    const s = e * t, r = L.NearestPOT(s + 128 * 128 / (128 + s));
    return Math.min(L.FloorPOT(e), r);
  }
  _prepareRenderingManager(e, t, i, s) {
    const r = this.getScene();
    if (!r)
      return;
    this._renderingManager.reset();
    const n = r.getRenderId();
    for (let a = 0; a < t; a++) {
      const o = e[a];
      if (o && !o.isBlocked) {
        if (this.customIsReadyFunction) {
          if (!this.customIsReadyFunction(o, this.refreshRate, !1)) {
            this.resetRefreshCounter();
            continue;
          }
        } else if (!o.isReady(this.refreshRate === 0)) {
          this.resetRefreshCounter();
          continue;
        }
        if (!o._internalAbstractMeshDataInfo._currentLODIsUpToDate && r.activeCamera && (o._internalAbstractMeshDataInfo._currentLOD = r.customLODSelector ? r.customLODSelector(o, this.activeCamera || r.activeCamera) : o.getLOD(this.activeCamera || r.activeCamera), o._internalAbstractMeshDataInfo._currentLODIsUpToDate = !0), !o._internalAbstractMeshDataInfo._currentLOD)
          continue;
        let l = o._internalAbstractMeshDataInfo._currentLOD;
        l._preActivateForIntermediateRendering(n);
        let c;
        if (s && i ? c = (o.layerMask & i.layerMask) === 0 : c = !1, o.isEnabled() && o.isVisible && o.subMeshes && !c && (l !== o && l._activate(n, !0), o._activate(n, !0) && o.subMeshes.length)) {
          o.isAnInstance ? o._internalAbstractMeshDataInfo._actAsRegularMesh && (l = o) : l._internalAbstractMeshDataInfo._onlyForInstancesIntermediate = !1, l._internalAbstractMeshDataInfo._isActiveIntermediate = !0;
          for (let u = 0; u < l.subMeshes.length; u++) {
            const d = l.subMeshes[u];
            this._renderingManager.dispatch(d, l);
          }
        }
      }
    }
    for (let a = 0; a < r.particleSystems.length; a++) {
      const o = r.particleSystems[a], l = o.emitter;
      !o.isStarted() || !l || l.position && !l.isEnabled() || this._renderingManager.dispatchParticles(o);
    }
  }
  /**
   * @internal
   * @param faceIndex face index to bind to if this is a cubetexture
   * @param layer defines the index of the texture to bind in the array
   */
  _bindFrameBuffer(e = 0, t = 0) {
    const i = this.getScene();
    if (!i)
      return;
    const s = i.getEngine();
    this._renderTarget && s.bindFramebuffer(this._renderTarget, this.isCube ? e : void 0, void 0, void 0, this.ignoreCameraViewport, 0, t);
  }
  _unbindFrameBuffer(e, t) {
    this._renderTarget && e.unBindFramebuffer(this._renderTarget, this.isCube, () => {
      this.onAfterRenderObservable.notifyObservers(t);
    });
  }
  /**
   * @internal
   */
  _prepareFrame(e, t, i, s) {
    this._postProcessManager ? this._prePassEnabled || this._postProcessManager._prepareFrame(this._texture, this._postProcesses) : (!s || !e.postProcessManager._prepareFrame(this._texture)) && this._bindFrameBuffer(t, i);
  }
  _renderToTarget(e, t, i, s = 0, r = null) {
    var n, a, o, l, c, u;
    const d = this.getScene();
    if (!d)
      return;
    const f = d.getEngine();
    if ((n = f._debugPushGroup) === null || n === void 0 || n.call(f, `render to face #${e} layer #${s}`, 1), this._prepareFrame(d, e, s, t), this.is2DArray ? (f.currentRenderPassId = this._renderPassIds[s], this.onBeforeRenderObservable.notifyObservers(s)) : (f.currentRenderPassId = this._renderPassIds[e], this.onBeforeRenderObservable.notifyObservers(e)), f.snapshotRendering && f.snapshotRenderingMode === 1)
      this.onClearObservable.hasObservers() ? this.onClearObservable.notifyObservers(f) : this.skipInitialClear || f.clear(this.clearColor || d.clearColor, !0, !0, !0);
    else {
      let g = null;
      const m = this.renderList ? this.renderList : d.getActiveMeshes().data, y = this.renderList ? this.renderList.length : d.getActiveMeshes().length;
      this.getCustomRenderList && (g = this.getCustomRenderList(this.is2DArray ? s : e, m, y)), g ? this._prepareRenderingManager(g, g.length, r, this.forceLayerMaskCheck) : (this._defaultRenderListPrepared || (this._prepareRenderingManager(m, y, r, !this.renderList || this.forceLayerMaskCheck), this._defaultRenderListPrepared = !0), g = m);
      for (const A of d._beforeRenderTargetClearStage)
        A.action(this, e, s);
      this.onClearObservable.hasObservers() ? this.onClearObservable.notifyObservers(f) : this.skipInitialClear || f.clear(this.clearColor || d.clearColor, !0, !0, !0), this._doNotChangeAspectRatio || d.updateTransformMatrix(!0);
      for (const A of d._beforeRenderTargetDrawStage)
        A.action(this, e, s);
      this._renderingManager.render(this.customRenderFunction, g, this.renderParticles, this.renderSprites);
      for (const A of d._afterRenderTargetDrawStage)
        A.action(this, e, s);
      const x = (o = (a = this._texture) === null || a === void 0 ? void 0 : a.generateMipMaps) !== null && o !== void 0 ? o : !1;
      this._texture && (this._texture.generateMipMaps = !1), this._postProcessManager ? this._postProcessManager._finalizeFrame(!1, (l = this._renderTarget) !== null && l !== void 0 ? l : void 0, e, this._postProcesses, this.ignoreCameraViewport) : t && d.postProcessManager._finalizeFrame(!1, (c = this._renderTarget) !== null && c !== void 0 ? c : void 0, e);
      for (const A of d._afterRenderTargetPostProcessStage)
        A.action(this, e, s);
      this._texture && (this._texture.generateMipMaps = x), this._doNotChangeAspectRatio || d.updateTransformMatrix(!0), i && Pt.DumpFramebuffer(this.getRenderWidth(), this.getRenderHeight(), f);
    }
    this._unbindFrameBuffer(f, e), this._texture && this.isCube && e === 5 && f.generateMipMapsForCubemap(this._texture), (u = f._debugPopGroup) === null || u === void 0 || u.call(f, 1);
  }
  /**
   * Overrides the default sort function applied in the rendering group to prepare the meshes.
   * This allowed control for front to back rendering or reversely depending of the special needs.
   *
   * @param renderingGroupId The rendering group id corresponding to its index
   * @param opaqueSortCompareFn The opaque queue comparison function use to sort.
   * @param alphaTestSortCompareFn The alpha test queue comparison function use to sort.
   * @param transparentSortCompareFn The transparent queue comparison function use to sort.
   */
  setRenderingOrder(e, t = null, i = null, s = null) {
    this._renderingManager.setRenderingOrder(e, t, i, s);
  }
  /**
   * Specifies whether or not the stencil and depth buffer are cleared between two rendering groups.
   *
   * @param renderingGroupId The rendering group id corresponding to its index
   * @param autoClearDepthStencil Automatically clears depth and stencil between groups if true.
   */
  setRenderingAutoClearDepthStencil(e, t) {
    this._renderingManager.setRenderingAutoClearDepthStencil(e, t), this._renderingManager._useSceneAutoClearSetup = !1;
  }
  /**
   * Clones the texture.
   * @returns the cloned texture
   */
  clone() {
    const e = this.getSize(), t = new Mi(this.name, e, this.getScene(), this._renderTargetOptions.generateMipMaps, this._doNotChangeAspectRatio, this._renderTargetOptions.type, this.isCube, this._renderTargetOptions.samplingMode, this._renderTargetOptions.generateDepthBuffer, this._renderTargetOptions.generateStencilBuffer, void 0, this._renderTargetOptions.format, void 0, this._renderTargetOptions.samples);
    return t.hasAlpha = this.hasAlpha, t.level = this.level, t.coordinatesMode = this.coordinatesMode, this.renderList && (t.renderList = this.renderList.slice(0)), t;
  }
  /**
   * Serialize the texture to a JSON representation we can easily use in the respective Parse function.
   * @returns The JSON representation of the texture
   */
  serialize() {
    if (!this.name)
      return null;
    const e = super.serialize();
    if (e.renderTargetSize = this.getRenderSize(), e.renderList = [], this.renderList)
      for (let t = 0; t < this.renderList.length; t++)
        e.renderList.push(this.renderList[t].id);
    return e;
  }
  /**
   *  This will remove the attached framebuffer objects. The texture will not be able to be used as render target anymore
   */
  disposeFramebufferObjects() {
    var e;
    (e = this._renderTarget) === null || e === void 0 || e.dispose(!0);
  }
  /**
   * Release and destroy the underlying lower level texture aka internalTexture.
   */
  releaseInternalTexture() {
    var e;
    (e = this._renderTarget) === null || e === void 0 || e.releaseTextures(), this._texture = null;
  }
  /**
   * Dispose the texture and release its associated resources.
   */
  dispose() {
    var e;
    this.onResizeObservable.clear(), this.onClearObservable.clear(), this.onAfterRenderObservable.clear(), this.onAfterUnbindObservable.clear(), this.onBeforeBindObservable.clear(), this.onBeforeRenderObservable.clear(), this._postProcessManager && (this._postProcessManager.dispose(), this._postProcessManager = null), this._prePassRenderTarget && this._prePassRenderTarget.dispose(), this._releaseRenderPassId(), this.clearPostProcesses(!0), this._resizeObserver && (this.getScene().getEngine().onResizeObservable.remove(this._resizeObserver), this._resizeObserver = null), this.renderList = null;
    const t = this.getScene();
    if (!t)
      return;
    let i = t.customRenderTargets.indexOf(this);
    i >= 0 && t.customRenderTargets.splice(i, 1);
    for (const s of t.cameras)
      i = s.customRenderTargets.indexOf(this), i >= 0 && s.customRenderTargets.splice(i, 1);
    (e = this._renderTarget) === null || e === void 0 || e.dispose(), this._renderTarget = null, this._texture = null, super.dispose();
  }
  /** @internal */
  _rebuild() {
    this.refreshRate === Mi.REFRESHRATE_RENDER_ONCE && (this.refreshRate = Mi.REFRESHRATE_RENDER_ONCE), this._postProcessManager && this._postProcessManager._rebuild();
  }
  /**
   * Clear the info related to rendering groups preventing retention point in material dispose.
   */
  freeRenderingGroups() {
    this._renderingManager && this._renderingManager.freeRenderingGroups();
  }
  /**
   * Gets the number of views the corresponding to the texture (eg. a MultiviewRenderTarget will have > 1)
   * @returns the view count
   */
  getViewCount() {
    return 1;
  }
}
Mi.REFRESHRATE_RENDER_ONCE = 0;
Mi.REFRESHRATE_RENDER_ONEVERYFRAME = 1;
Mi.REFRESHRATE_RENDER_ONEVERYTWOFRAMES = 2;
W._CreateRenderTargetTexture = (h, e, t, i, s) => new Mi(h, e, t, i);
class qe {
  /**
   * Registers a shader code processing with a post process name.
   * @param postProcessName name of the post process. Use null for the fallback shader code processing. This is the shader code processing that will be used in case no specific shader code processing has been associated to a post process name
   * @param customShaderCodeProcessing shader code processing to associate to the post process name
   * @returns
   */
  static RegisterShaderCodeProcessing(e, t) {
    if (!t) {
      delete qe._CustomShaderCodeProcessing[e ?? ""];
      return;
    }
    qe._CustomShaderCodeProcessing[e ?? ""] = t;
  }
  static _GetShaderCodeProcessing(e) {
    var t;
    return (t = qe._CustomShaderCodeProcessing[e]) !== null && t !== void 0 ? t : qe._CustomShaderCodeProcessing[""];
  }
  /**
   * Number of sample textures (default: 1)
   */
  get samples() {
    return this._samples;
  }
  set samples(e) {
    this._samples = Math.min(e, this._engine.getCaps().maxMSAASamples), this._textures.forEach((t) => {
      t.setSamples(this._samples);
    });
  }
  /**
   * Returns the fragment url or shader name used in the post process.
   * @returns the fragment url or name in the shader store.
   */
  getEffectName() {
    return this._fragmentUrl;
  }
  /**
   * A function that is added to the onActivateObservable
   */
  set onActivate(e) {
    this._onActivateObserver && this.onActivateObservable.remove(this._onActivateObserver), e && (this._onActivateObserver = this.onActivateObservable.add(e));
  }
  /**
   * A function that is added to the onSizeChangedObservable
   */
  set onSizeChanged(e) {
    this._onSizeChangedObserver && this.onSizeChangedObservable.remove(this._onSizeChangedObserver), this._onSizeChangedObserver = this.onSizeChangedObservable.add(e);
  }
  /**
   * A function that is added to the onApplyObservable
   */
  set onApply(e) {
    this._onApplyObserver && this.onApplyObservable.remove(this._onApplyObserver), this._onApplyObserver = this.onApplyObservable.add(e);
  }
  /**
   * A function that is added to the onBeforeRenderObservable
   */
  set onBeforeRender(e) {
    this._onBeforeRenderObserver && this.onBeforeRenderObservable.remove(this._onBeforeRenderObserver), this._onBeforeRenderObserver = this.onBeforeRenderObservable.add(e);
  }
  /**
   * A function that is added to the onAfterRenderObservable
   */
  set onAfterRender(e) {
    this._onAfterRenderObserver && this.onAfterRenderObservable.remove(this._onAfterRenderObserver), this._onAfterRenderObserver = this.onAfterRenderObservable.add(e);
  }
  /**
   * The input texture for this post process and the output texture of the previous post process. When added to a pipeline the previous post process will
   * render it's output into this texture and this texture will be used as textureSampler in the fragment shader of this post process.
   */
  get inputTexture() {
    return this._textures.data[this._currentRenderTextureInd];
  }
  set inputTexture(e) {
    this._forcedOutputTexture = e;
  }
  /**
   * Since inputTexture should always be defined, if we previously manually set `inputTexture`,
   * the only way to unset it is to use this function to restore its internal state
   */
  restoreDefaultInputTexture() {
    this._forcedOutputTexture && (this._forcedOutputTexture = null, this.markTextureDirty());
  }
  /**
   * Gets the camera which post process is applied to.
   * @returns The camera the post process is applied to.
   */
  getCamera() {
    return this._camera;
  }
  /**
   * Gets the texel size of the postprocess.
   * See https://en.wikipedia.org/wiki/Texel_(graphics)
   */
  get texelSize() {
    return this._shareOutputWithPostProcess ? this._shareOutputWithPostProcess.texelSize : (this._forcedOutputTexture && this._texelSize.copyFromFloats(1 / this._forcedOutputTexture.width, 1 / this._forcedOutputTexture.height), this._texelSize);
  }
  /**
   * Creates a new instance PostProcess
   * @param name The name of the PostProcess.
   * @param fragmentUrl The url of the fragment shader to be used.
   * @param parameters Array of the names of uniform non-sampler2D variables that will be passed to the shader.
   * @param samplers Array of the names of uniform sampler2D variables that will be passed to the shader.
   * @param options The required width/height ratio to downsize to before computing the render pass. (Use 1.0 for full size)
   * @param camera The camera to apply the render pass to.
   * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
   * @param engine The engine which the post process will be applied. (default: current engine)
   * @param reusable If the post process can be reused on the same frame. (default: false)
   * @param defines String of defines that will be set when running the fragment shader. (default: null)
   * @param textureType Type of textures used when performing the post process. (default: 0)
   * @param vertexUrl The url of the vertex shader to be used. (default: "postprocess")
   * @param indexParameters The index parameters to be used for babylons include syntax "#include<kernelBlurVaryingDeclaration>[0..varyingCount]". (default: undefined) See usage in babylon.blurPostProcess.ts and kernelBlur.vertex.fx
   * @param blockCompilation If the shader should not be compiled immediatly. (default: false)
   * @param textureFormat Format of textures used when performing the post process. (default: TEXTUREFORMAT_RGBA)
   */
  constructor(e, t, i, s, r, n, a = 1, o, l, c = null, u = 0, d = "postprocess", f, _ = !1, g = 5, m = dt.GLSL) {
    this._parentContainer = null, this.width = -1, this.height = -1, this.nodeMaterialSource = null, this._outputTexture = null, this.autoClear = !0, this.forceAutoClearInAlphaMode = !1, this.alphaMode = 0, this.animations = new Array(), this.enablePixelPerfectMode = !1, this.forceFullscreenViewport = !0, this.scaleMode = 1, this.alwaysForcePOT = !1, this._samples = 1, this.adaptScaleToCurrentViewport = !1, this._reusable = !1, this._renderId = 0, this.externalTextureSamplerBinding = !1, this._textures = new At(2), this._textureCache = [], this._currentRenderTextureInd = 0, this._scaleRatio = new ue(1, 1), this._texelSize = ue.Zero(), this.onActivateObservable = new N(), this.onSizeChangedObservable = new N(), this.onApplyObservable = new N(), this.onBeforeRenderObservable = new N(), this.onAfterRenderObservable = new N(), this.name = e, n != null ? (this._camera = n, this._scene = n.getScene(), n.attachPostProcess(this), this._engine = this._scene.getEngine(), this._scene.postProcesses.push(this), this.uniqueId = this._scene.getUniqueId()) : o && (this._engine = o, this._engine.postProcesses.push(this)), this._options = r, this.renderTargetSamplingMode = a || 1, this._reusable = l || !1, this._textureType = u, this._textureFormat = g, this._shaderLanguage = m, this._samplers = s || [], this._samplers.push("textureSampler"), this._fragmentUrl = t, this._vertexUrl = d, this._parameters = i || [], this._parameters.push("scale"), this._indexParameters = f, this._drawWrapper = new xi(this._engine), _ || this.updateEffect(c);
  }
  /**
   * Gets a string identifying the name of the class
   * @returns "PostProcess" string
   */
  getClassName() {
    return "PostProcess";
  }
  /**
   * Gets the engine which this post process belongs to.
   * @returns The engine the post process was enabled with.
   */
  getEngine() {
    return this._engine;
  }
  /**
   * The effect that is created when initializing the post process.
   * @returns The created effect corresponding the the postprocess.
   */
  getEffect() {
    return this._drawWrapper.effect;
  }
  /**
   * To avoid multiple redundant textures for multiple post process, the output the output texture for this post process can be shared with another.
   * @param postProcess The post process to share the output with.
   * @returns This post process.
   */
  shareOutputWith(e) {
    return this._disposeTextures(), this._shareOutputWithPostProcess = e, this;
  }
  /**
   * Reverses the effect of calling shareOutputWith and returns the post process back to its original state.
   * This should be called if the post process that shares output with this post process is disabled/disposed.
   */
  useOwnOutput() {
    this._textures.length == 0 && (this._textures = new At(2)), this._shareOutputWithPostProcess = null;
  }
  /**
   * Updates the effect with the current post process compile time values and recompiles the shader.
   * @param defines Define statements that should be added at the beginning of the shader. (default: null)
   * @param uniforms Set of uniform variables that will be passed to the shader. (default: null)
   * @param samplers Set of Texture2D variables that will be passed to the shader. (default: null)
   * @param indexParameters The index parameters to be used for babylons include syntax "#include<kernelBlurVaryingDeclaration>[0..varyingCount]". (default: undefined) See usage in babylon.blurPostProcess.ts and kernelBlur.vertex.fx
   * @param onCompiled Called when the shader has been compiled.
   * @param onError Called if there is an error when compiling a shader.
   * @param vertexUrl The url of the vertex shader to be used (default: the one given at construction time)
   * @param fragmentUrl The url of the fragment shader to be used (default: the one given at construction time)
   */
  updateEffect(e = null, t = null, i = null, s, r, n, a, o) {
    var l, c;
    const u = qe._GetShaderCodeProcessing(this.name);
    if (u != null && u.defineCustomBindings) {
      const d = (l = t == null ? void 0 : t.slice()) !== null && l !== void 0 ? l : [];
      d.push(...this._parameters);
      const f = (c = i == null ? void 0 : i.slice()) !== null && c !== void 0 ? c : [];
      f.push(...this._samplers), e = u.defineCustomBindings(this.name, e, d, f), t = d, i = f;
    }
    this._postProcessDefines = e, this._drawWrapper.effect = this._engine.createEffect({ vertex: a ?? this._vertexUrl, fragment: o ?? this._fragmentUrl }, {
      attributes: ["position"],
      uniformsNames: t || this._parameters,
      uniformBuffersNames: [],
      samplers: i || this._samplers,
      defines: e !== null ? e : "",
      fallbacks: null,
      onCompiled: r ?? null,
      onError: n ?? null,
      indexParameters: s || this._indexParameters,
      processCodeAfterIncludes: u != null && u.processCodeAfterIncludes ? (d, f) => u.processCodeAfterIncludes(this.name, d, f) : null,
      processFinalCode: u != null && u.processFinalCode ? (d, f) => u.processFinalCode(this.name, d, f) : null,
      shaderLanguage: this._shaderLanguage
    }, this._engine);
  }
  /**
   * The post process is reusable if it can be used multiple times within one frame.
   * @returns If the post process is reusable
   */
  isReusable() {
    return this._reusable;
  }
  /** invalidate frameBuffer to hint the postprocess to create a depth buffer */
  markTextureDirty() {
    this.width = -1;
  }
  _createRenderTargetTexture(e, t, i = 0) {
    for (let r = 0; r < this._textureCache.length; r++)
      if (this._textureCache[r].texture.width === e.width && this._textureCache[r].texture.height === e.height && this._textureCache[r].postProcessChannel === i && this._textureCache[r].texture._generateDepthBuffer === t.generateDepthBuffer && this._textureCache[r].texture.samples === t.samples)
        return this._textureCache[r].texture;
    const s = this._engine.createRenderTargetTexture(e, t);
    return this._textureCache.push({ texture: s, postProcessChannel: i, lastUsedRenderId: -1 }), s;
  }
  _flushTextureCache() {
    const e = this._renderId;
    for (let t = this._textureCache.length - 1; t >= 0; t--)
      if (e - this._textureCache[t].lastUsedRenderId > 100) {
        let i = !1;
        for (let s = 0; s < this._textures.length; s++)
          if (this._textures.data[s] === this._textureCache[t].texture) {
            i = !0;
            break;
          }
        i || (this._textureCache[t].texture.dispose(), this._textureCache.splice(t, 1));
      }
  }
  _resize(e, t, i, s, r) {
    this._textures.length > 0 && this._textures.reset(), this.width = e, this.height = t;
    let n = null;
    for (let l = 0; l < i._postProcesses.length; l++)
      if (i._postProcesses[l] !== null) {
        n = i._postProcesses[l];
        break;
      }
    const a = { width: this.width, height: this.height }, o = {
      generateMipMaps: s,
      generateDepthBuffer: r || n === this,
      generateStencilBuffer: (r || n === this) && this._engine.isStencilEnable,
      samplingMode: this.renderTargetSamplingMode,
      type: this._textureType,
      format: this._textureFormat,
      samples: this._samples,
      label: "PostProcessRTT-" + this.name
    };
    this._textures.push(this._createRenderTargetTexture(a, o, 0)), this._reusable && this._textures.push(this._createRenderTargetTexture(a, o, 1)), this._texelSize.copyFromFloats(1 / this.width, 1 / this.height), this.onSizeChangedObservable.notifyObservers(this);
  }
  /**
   * Activates the post process by intializing the textures to be used when executed. Notifies onActivateObservable.
   * When this post process is used in a pipeline, this is call will bind the input texture of this post process to the output of the previous.
   * @param camera The camera that will be used in the post process. This camera will be used when calling onActivateObservable.
   * @param sourceTexture The source texture to be inspected to get the width and height if not specified in the post process constructor. (default: null)
   * @param forceDepthStencil If true, a depth and stencil buffer will be generated. (default: false)
   * @returns The render target wrapper that was bound to be written to.
   */
  activate(e, t = null, i) {
    var s, r;
    e = e || this._camera;
    const n = e.getScene(), a = n.getEngine(), o = a.getCaps().maxTextureSize;
    let l = (t ? t.width : this._engine.getRenderWidth(!0)) * this._options | 0;
    const c = (t ? t.height : this._engine.getRenderHeight(!0)) * this._options | 0, u = e.parent;
    u && (u.leftCamera == e || u.rightCamera == e) && (l /= 2);
    let d = this._options.width || l, f = this._options.height || c;
    const _ = this.renderTargetSamplingMode !== 7 && this.renderTargetSamplingMode !== 1 && this.renderTargetSamplingMode !== 2;
    if (!this._shareOutputWithPostProcess && !this._forcedOutputTexture) {
      if (this.adaptScaleToCurrentViewport) {
        const m = a.currentViewport;
        m && (d *= m.width, f *= m.height);
      }
      (_ || this.alwaysForcePOT) && (this._options.width || (d = a.needPOTTextures ? L.GetExponentOfTwo(d, o, this.scaleMode) : d), this._options.height || (f = a.needPOTTextures ? L.GetExponentOfTwo(f, o, this.scaleMode) : f)), (this.width !== d || this.height !== f) && this._resize(d, f, e, _, i), this._textures.forEach((m) => {
        m.samples !== this.samples && this._engine.updateRenderTargetTextureSampleCount(m, this.samples);
      }), this._flushTextureCache(), this._renderId++;
    }
    let g;
    if (this._shareOutputWithPostProcess)
      g = this._shareOutputWithPostProcess.inputTexture;
    else if (this._forcedOutputTexture)
      g = this._forcedOutputTexture, this.width = this._forcedOutputTexture.width, this.height = this._forcedOutputTexture.height;
    else {
      g = this.inputTexture;
      let m;
      for (let y = 0; y < this._textureCache.length; y++)
        if (this._textureCache[y].texture === g) {
          m = this._textureCache[y];
          break;
        }
      m && (m.lastUsedRenderId = this._renderId);
    }
    return this.enablePixelPerfectMode ? (this._scaleRatio.copyFromFloats(l / d, c / f), this._engine.bindFramebuffer(g, 0, l, c, this.forceFullscreenViewport)) : (this._scaleRatio.copyFromFloats(1, 1), this._engine.bindFramebuffer(g, 0, void 0, void 0, this.forceFullscreenViewport)), (r = (s = this._engine)._debugInsertMarker) === null || r === void 0 || r.call(s, `post process ${this.name} input`), this.onActivateObservable.notifyObservers(e), this.autoClear && (this.alphaMode === 0 || this.forceAutoClearInAlphaMode) && this._engine.clear(this.clearColor ? this.clearColor : n.clearColor, n._allowPostProcessClearColor, !0, !0), this._reusable && (this._currentRenderTextureInd = (this._currentRenderTextureInd + 1) % 2), g;
  }
  /**
   * If the post process is supported.
   */
  get isSupported() {
    return this._drawWrapper.effect.isSupported;
  }
  /**
   * The aspect ratio of the output texture.
   */
  get aspectRatio() {
    return this._shareOutputWithPostProcess ? this._shareOutputWithPostProcess.aspectRatio : this._forcedOutputTexture ? this._forcedOutputTexture.width / this._forcedOutputTexture.height : this.width / this.height;
  }
  /**
   * Get a value indicating if the post-process is ready to be used
   * @returns true if the post-process is ready (shader is compiled)
   */
  isReady() {
    var e, t;
    return (t = (e = this._drawWrapper.effect) === null || e === void 0 ? void 0 : e.isReady()) !== null && t !== void 0 ? t : !1;
  }
  /**
   * Binds all textures and uniforms to the shader, this will be run on every pass.
   * @returns the effect corresponding to this post process. Null if not compiled or not ready.
   */
  apply() {
    var e, t, i;
    if (!(!((e = this._drawWrapper.effect) === null || e === void 0) && e.isReady()))
      return null;
    this._engine.enableEffect(this._drawWrapper), this._engine.setState(!1), this._engine.setDepthBuffer(!1), this._engine.setDepthWrite(!1), this._engine.setAlphaMode(this.alphaMode), this.alphaConstants && this.getEngine().setAlphaConstants(this.alphaConstants.r, this.alphaConstants.g, this.alphaConstants.b, this.alphaConstants.a);
    let s;
    return this._shareOutputWithPostProcess ? s = this._shareOutputWithPostProcess.inputTexture : this._forcedOutputTexture ? s = this._forcedOutputTexture : s = this.inputTexture, this.externalTextureSamplerBinding || this._drawWrapper.effect._bindTexture("textureSampler", s == null ? void 0 : s.texture), this._drawWrapper.effect.setVector2("scale", this._scaleRatio), this.onApplyObservable.notifyObservers(this._drawWrapper.effect), (i = (t = qe._GetShaderCodeProcessing(this.name)) === null || t === void 0 ? void 0 : t.bindCustomBindings) === null || i === void 0 || i.call(t, this.name, this._drawWrapper.effect), this._drawWrapper.effect;
  }
  _disposeTextures() {
    if (this._shareOutputWithPostProcess || this._forcedOutputTexture) {
      this._disposeTextureCache();
      return;
    }
    this._disposeTextureCache(), this._textures.dispose();
  }
  _disposeTextureCache() {
    for (let e = this._textureCache.length - 1; e >= 0; e--)
      this._textureCache[e].texture.dispose();
    this._textureCache.length = 0;
  }
  /**
   * Sets the required values to the prepass renderer.
   * @param prePassRenderer defines the prepass renderer to setup.
   * @returns true if the pre pass is needed.
   */
  setPrePassRenderer(e) {
    return this._prePassEffectConfiguration ? (this._prePassEffectConfiguration = e.addEffectConfiguration(this._prePassEffectConfiguration), this._prePassEffectConfiguration.enabled = !0, !0) : !1;
  }
  /**
   * Disposes the post process.
   * @param camera The camera to dispose the post process on.
   */
  dispose(e) {
    e = e || this._camera, this._disposeTextures();
    let t;
    if (this._scene && (t = this._scene.postProcesses.indexOf(this), t !== -1 && this._scene.postProcesses.splice(t, 1)), this._parentContainer) {
      const i = this._parentContainer.postProcesses.indexOf(this);
      i > -1 && this._parentContainer.postProcesses.splice(i, 1), this._parentContainer = null;
    }
    if (t = this._engine.postProcesses.indexOf(this), t !== -1 && this._engine.postProcesses.splice(t, 1), !!e) {
      if (e.detachPostProcess(this), t = e._postProcesses.indexOf(this), t === 0 && e._postProcesses.length > 0) {
        const i = this._camera._getFirstPostProcess();
        i && i.markTextureDirty();
      }
      this.onActivateObservable.clear(), this.onAfterRenderObservable.clear(), this.onApplyObservable.clear(), this.onBeforeRenderObservable.clear(), this.onSizeChangedObservable.clear();
    }
  }
  /**
   * Serializes the post process to a JSON object
   * @returns the JSON object
   */
  serialize() {
    const e = le.Serialize(this), t = this.getCamera() || this._scene && this._scene.activeCamera;
    return e.customType = "BABYLON." + this.getClassName(), e.cameraId = t ? t.id : null, e.reusable = this._reusable, e.textureType = this._textureType, e.fragmentUrl = this._fragmentUrl, e.parameters = this._parameters, e.samplers = this._samplers, e.options = this._options, e.defines = this._postProcessDefines, e.textureFormat = this._textureFormat, e.vertexUrl = this._vertexUrl, e.indexParameters = this._indexParameters, e;
  }
  /**
   * Clones this post process
   * @returns a new post process similar to this one
   */
  clone() {
    const e = this.serialize();
    e._engine = this._engine, e.cameraId = null;
    const t = qe.Parse(e, this._scene, "");
    return t ? (t.onActivateObservable = this.onActivateObservable.clone(), t.onSizeChangedObservable = this.onSizeChangedObservable.clone(), t.onApplyObservable = this.onApplyObservable.clone(), t.onBeforeRenderObservable = this.onBeforeRenderObservable.clone(), t.onAfterRenderObservable = this.onAfterRenderObservable.clone(), t._prePassEffectConfiguration = this._prePassEffectConfiguration, t) : null;
  }
  /**
   * Creates a material from parsed material data
   * @param parsedPostProcess defines parsed post process data
   * @param scene defines the hosting scene
   * @param rootUrl defines the root URL to use to load textures
   * @returns a new post process
   */
  static Parse(e, t, i) {
    const s = si(e.customType);
    if (!s || !s._Parse)
      return null;
    const r = t ? t.getCameraById(e.cameraId) : null;
    return s._Parse(e, r, t, i);
  }
  /**
   * @internal
   */
  static _Parse(e, t, i, s) {
    return le.Parse(() => new qe(e.name, e.fragmentUrl, e.parameters, e.samplers, e.options, t, e.renderTargetSamplingMode, e._engine, e.reusable, e.defines, e.textureType, e.vertexUrl, e.indexParameters, !1, e.textureFormat), e, i, s);
  }
}
qe._CustomShaderCodeProcessing = {};
E([
  R()
], qe.prototype, "uniqueId", void 0);
E([
  R()
], qe.prototype, "name", void 0);
E([
  R()
], qe.prototype, "width", void 0);
E([
  R()
], qe.prototype, "height", void 0);
E([
  R()
], qe.prototype, "renderTargetSamplingMode", void 0);
E([
  Pa()
], qe.prototype, "clearColor", void 0);
E([
  R()
], qe.prototype, "autoClear", void 0);
E([
  R()
], qe.prototype, "forceAutoClearInAlphaMode", void 0);
E([
  R()
], qe.prototype, "alphaMode", void 0);
E([
  R()
], qe.prototype, "alphaConstants", void 0);
E([
  R()
], qe.prototype, "enablePixelPerfectMode", void 0);
E([
  R()
], qe.prototype, "forceFullscreenViewport", void 0);
E([
  R()
], qe.prototype, "scaleMode", void 0);
E([
  R()
], qe.prototype, "alwaysForcePOT", void 0);
E([
  R("samples")
], qe.prototype, "_samples", void 0);
E([
  R()
], qe.prototype, "adaptScaleToCurrentViewport", void 0);
Xe("BABYLON.PostProcess", qe);
const _h = "passCubePixelShader", ph = `varying vec2 vUV;uniform samplerCube textureSampler;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) 
{vec2 uv=vUV*2.0-1.0;
#ifdef POSITIVEX
gl_FragColor=textureCube(textureSampler,vec3(1.001,uv.y,uv.x));
#endif
#ifdef NEGATIVEX
gl_FragColor=textureCube(textureSampler,vec3(-1.001,uv.y,uv.x));
#endif
#ifdef POSITIVEY
gl_FragColor=textureCube(textureSampler,vec3(uv.y,1.001,uv.x));
#endif
#ifdef NEGATIVEY
gl_FragColor=textureCube(textureSampler,vec3(uv.y,-1.001,uv.x));
#endif
#ifdef POSITIVEZ
gl_FragColor=textureCube(textureSampler,vec3(uv,1.001));
#endif
#ifdef NEGATIVEZ
gl_FragColor=textureCube(textureSampler,vec3(uv,-1.001));
#endif
}`;
G.ShadersStore[_h] = ph;
class Dr extends qe {
  /**
   * Gets a string identifying the name of the class
   * @returns "PassPostProcess" string
   */
  getClassName() {
    return "PassPostProcess";
  }
  /**
   * Creates the PassPostProcess
   * @param name The name of the effect.
   * @param options The required width/height ratio to downsize to before computing the render pass.
   * @param camera The camera to apply the render pass to.
   * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
   * @param engine The engine which the post process will be applied. (default: current engine)
   * @param reusable If the post process can be reused on the same frame. (default: false)
   * @param textureType The type of texture to be used when performing the post processing.
   * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
   */
  constructor(e, t, i = null, s, r, n, a = 0, o = !1) {
    super(e, "pass", null, null, t, i, s, r, n, void 0, a, void 0, null, o);
  }
  /**
   * @internal
   */
  static _Parse(e, t, i, s) {
    return le.Parse(() => new Dr(e.name, e.options, t, e.renderTargetSamplingMode, e._engine, e.reusable), e, i, s);
  }
}
Xe("BABYLON.PassPostProcess", Dr);
L._RescalePostProcessFactory = (h) => new Dr("rescale", 1, null, 2, h, !1, 0);
let ar, oa;
function Kr(h) {
  ar || (ar = new Float32Array(1), oa = new Int32Array(ar.buffer)), ar[0] = h;
  const e = oa[0];
  let t = e >> 16 & 32768, i = e >> 12 & 2047;
  const s = e >> 23 & 255;
  return s < 103 ? t : s > 142 ? (t |= 31744, t |= (s == 255 ? 0 : 1) && e & 8388607, t) : s < 113 ? (i |= 2048, t |= (i >> 114 - s) + (i >> 113 - s & 1), t) : (t |= s - 112 << 10 | i >> 1, t += i & 1, t);
}
Z.prototype.updateRawTexture = function(h, e, t, i, s = null, r = 0, n = !1) {
  if (!h)
    return;
  const a = this._getRGBABufferInternalSizedFormat(r, t, n), o = this._getInternalFormat(t), l = this._getWebGLTextureType(r);
  this._bindTextureDirectly(this._gl.TEXTURE_2D, h, !0), this._unpackFlipY(i === void 0 ? !0 : !!i), this._doNotHandleContextLost || (h._bufferView = e, h.format = t, h.type = r, h.invertY = i, h._compression = s), h.width % 4 !== 0 && this._gl.pixelStorei(this._gl.UNPACK_ALIGNMENT, 1), s && e ? this._gl.compressedTexImage2D(this._gl.TEXTURE_2D, 0, this.getCaps().s3tc[s], h.width, h.height, 0, e) : this._gl.texImage2D(this._gl.TEXTURE_2D, 0, a, h.width, h.height, 0, o, l, e), h.generateMipMaps && this._gl.generateMipmap(this._gl.TEXTURE_2D), this._bindTextureDirectly(this._gl.TEXTURE_2D, null), h.isReady = !0;
};
Z.prototype.createRawTexture = function(h, e, t, i, s, r, n, a = null, o = 0, l = 0, c = !1) {
  const u = new zt(this, Ze.Raw);
  u.baseWidth = e, u.baseHeight = t, u.width = e, u.height = t, u.format = i, u.generateMipMaps = s, u.samplingMode = n, u.invertY = r, u._compression = a, u.type = o, u._useSRGBBuffer = this._getUseSRGBBuffer(c, !s), this._doNotHandleContextLost || (u._bufferView = h), this.updateRawTexture(u, h, i, r, a, o, u._useSRGBBuffer), this._bindTextureDirectly(this._gl.TEXTURE_2D, u, !0);
  const d = this._getSamplingParameters(n, s);
  return this._gl.texParameteri(this._gl.TEXTURE_2D, this._gl.TEXTURE_MAG_FILTER, d.mag), this._gl.texParameteri(this._gl.TEXTURE_2D, this._gl.TEXTURE_MIN_FILTER, d.min), s && this._gl.generateMipmap(this._gl.TEXTURE_2D), this._bindTextureDirectly(this._gl.TEXTURE_2D, null), this._internalTexturesCache.push(u), u;
};
Z.prototype.createRawCubeTexture = function(h, e, t, i, s, r, n, a = null) {
  const o = this._gl, l = new zt(this, Ze.CubeRaw);
  l.isCube = !0, l.format = t, l.type = i, this._doNotHandleContextLost || (l._bufferViewArray = h);
  const c = this._getWebGLTextureType(i);
  let u = this._getInternalFormat(t);
  u === o.RGB && (u = o.RGBA), c === o.FLOAT && !this._caps.textureFloatLinearFiltering ? (s = !1, n = 1, w.Warn("Float texture filtering is not supported. Mipmap generation and sampling mode are forced to false and TEXTURE_NEAREST_SAMPLINGMODE, respectively.")) : c === this._gl.HALF_FLOAT_OES && !this._caps.textureHalfFloatLinearFiltering ? (s = !1, n = 1, w.Warn("Half float texture filtering is not supported. Mipmap generation and sampling mode are forced to false and TEXTURE_NEAREST_SAMPLINGMODE, respectively.")) : c === o.FLOAT && !this._caps.textureFloatRender ? (s = !1, w.Warn("Render to float textures is not supported. Mipmap generation forced to false.")) : c === o.HALF_FLOAT && !this._caps.colorBufferFloat && (s = !1, w.Warn("Render to half float textures is not supported. Mipmap generation forced to false."));
  const d = e, f = d;
  if (l.width = d, l.height = f, l.invertY = r, l._compression = a, !this.needPOTTextures || z.IsExponentOfTwo(l.width) && z.IsExponentOfTwo(l.height) || (s = !1), h)
    this.updateRawCubeTexture(l, h, t, i, r, a);
  else {
    const m = this._getRGBABufferInternalSizedFormat(i), y = 0;
    this._bindTextureDirectly(o.TEXTURE_CUBE_MAP, l, !0);
    for (let x = 0; x < 6; x++)
      a ? o.compressedTexImage2D(o.TEXTURE_CUBE_MAP_POSITIVE_X + x, y, this.getCaps().s3tc[a], l.width, l.height, 0, void 0) : o.texImage2D(o.TEXTURE_CUBE_MAP_POSITIVE_X + x, y, m, l.width, l.height, 0, u, c, null);
    this._bindTextureDirectly(this._gl.TEXTURE_CUBE_MAP, null);
  }
  this._bindTextureDirectly(this._gl.TEXTURE_CUBE_MAP, l, !0), h && s && this._gl.generateMipmap(this._gl.TEXTURE_CUBE_MAP);
  const g = this._getSamplingParameters(n, s);
  return o.texParameteri(o.TEXTURE_CUBE_MAP, o.TEXTURE_MAG_FILTER, g.mag), o.texParameteri(o.TEXTURE_CUBE_MAP, o.TEXTURE_MIN_FILTER, g.min), o.texParameteri(o.TEXTURE_CUBE_MAP, o.TEXTURE_WRAP_S, o.CLAMP_TO_EDGE), o.texParameteri(o.TEXTURE_CUBE_MAP, o.TEXTURE_WRAP_T, o.CLAMP_TO_EDGE), this._bindTextureDirectly(o.TEXTURE_CUBE_MAP, null), l.generateMipMaps = s, l.samplingMode = n, l.isReady = !0, l;
};
Z.prototype.updateRawCubeTexture = function(h, e, t, i, s, r = null, n = 0) {
  h._bufferViewArray = e, h.format = t, h.type = i, h.invertY = s, h._compression = r;
  const a = this._gl, o = this._getWebGLTextureType(i);
  let l = this._getInternalFormat(t);
  const c = this._getRGBABufferInternalSizedFormat(i);
  let u = !1;
  l === a.RGB && (l = a.RGBA, u = !0), this._bindTextureDirectly(a.TEXTURE_CUBE_MAP, h, !0), this._unpackFlipY(s === void 0 ? !0 : !!s), h.width % 4 !== 0 && a.pixelStorei(a.UNPACK_ALIGNMENT, 1);
  for (let f = 0; f < 6; f++) {
    let _ = e[f];
    r ? a.compressedTexImage2D(a.TEXTURE_CUBE_MAP_POSITIVE_X + f, n, this.getCaps().s3tc[r], h.width, h.height, 0, _) : (u && (_ = $a(_, h.width, h.height, i)), a.texImage2D(a.TEXTURE_CUBE_MAP_POSITIVE_X + f, n, c, h.width, h.height, 0, l, o, _));
  }
  (!this.needPOTTextures || z.IsExponentOfTwo(h.width) && z.IsExponentOfTwo(h.height)) && h.generateMipMaps && n === 0 && this._gl.generateMipmap(this._gl.TEXTURE_CUBE_MAP), this._bindTextureDirectly(this._gl.TEXTURE_CUBE_MAP, null), h.isReady = !0;
};
Z.prototype.createRawCubeTextureFromUrl = function(h, e, t, i, s, r, n, a, o = null, l = null, c = 3, u = !1) {
  const d = this._gl, f = this.createRawCubeTexture(null, t, i, s, !r, u, c, null);
  e == null || e.addPendingData(f), f.url = h, f.isReady = !1, this._internalTexturesCache.push(f);
  const _ = (m, y) => {
    e == null || e.removePendingData(f), l && m && l(m.status + " " + m.statusText, y);
  }, g = (m) => {
    const y = f.width, x = n(m);
    if (x) {
      if (a) {
        const A = this._getWebGLTextureType(s);
        let T = this._getInternalFormat(i);
        const M = this._getRGBABufferInternalSizedFormat(s);
        let b = !1;
        T === d.RGB && (T = d.RGBA, b = !0), this._bindTextureDirectly(d.TEXTURE_CUBE_MAP, f, !0), this._unpackFlipY(!1);
        const S = a(x);
        for (let P = 0; P < S.length; P++) {
          const D = y >> P;
          for (let O = 0; O < 6; O++) {
            let X = S[P][O];
            b && (X = $a(X, D, D, s)), d.texImage2D(O, P, M, D, D, 0, T, A, X);
          }
        }
        this._bindTextureDirectly(d.TEXTURE_CUBE_MAP, null);
      } else
        this.updateRawCubeTexture(f, x, i, s, u);
      f.isReady = !0, e == null || e.removePendingData(f), f.onLoadedObservable.notifyObservers(f), f.onLoadedObservable.clear(), o && o();
    }
  };
  return this._loadFile(h, (m) => {
    g(m);
  }, void 0, e == null ? void 0 : e.offlineProvider, !0, _), f;
};
function $a(h, e, t, i) {
  let s, r = 1;
  i === 1 ? s = new Float32Array(e * t * 4) : i === 2 ? (s = new Uint16Array(e * t * 4), r = 15360) : i === 7 ? s = new Uint32Array(e * t * 4) : s = new Uint8Array(e * t * 4);
  for (let n = 0; n < e; n++)
    for (let a = 0; a < t; a++) {
      const o = (a * e + n) * 3, l = (a * e + n) * 4;
      s[l + 0] = h[o + 0], s[l + 1] = h[o + 1], s[l + 2] = h[o + 2], s[l + 3] = r;
    }
  return s;
}
function Ja(h) {
  return function(e, t, i, s, r, n, a, o, l = null, c = 0) {
    const u = h ? this._gl.TEXTURE_3D : this._gl.TEXTURE_2D_ARRAY, d = h ? Ze.Raw3D : Ze.Raw2DArray, f = new zt(this, d);
    f.baseWidth = t, f.baseHeight = i, f.baseDepth = s, f.width = t, f.height = i, f.depth = s, f.format = r, f.type = c, f.generateMipMaps = n, f.samplingMode = o, h ? f.is3D = !0 : f.is2DArray = !0, this._doNotHandleContextLost || (f._bufferView = e), h ? this.updateRawTexture3D(f, e, r, a, l, c) : this.updateRawTexture2DArray(f, e, r, a, l, c), this._bindTextureDirectly(u, f, !0);
    const _ = this._getSamplingParameters(o, n);
    return this._gl.texParameteri(u, this._gl.TEXTURE_MAG_FILTER, _.mag), this._gl.texParameteri(u, this._gl.TEXTURE_MIN_FILTER, _.min), n && this._gl.generateMipmap(u), this._bindTextureDirectly(u, null), this._internalTexturesCache.push(f), f;
  };
}
Z.prototype.createRawTexture2DArray = Ja(!1);
Z.prototype.createRawTexture3D = Ja(!0);
function eo(h) {
  return function(e, t, i, s, r = null, n = 0) {
    const a = h ? this._gl.TEXTURE_3D : this._gl.TEXTURE_2D_ARRAY, o = this._getWebGLTextureType(n), l = this._getInternalFormat(i), c = this._getRGBABufferInternalSizedFormat(n, i);
    this._bindTextureDirectly(a, e, !0), this._unpackFlipY(s === void 0 ? !0 : !!s), this._doNotHandleContextLost || (e._bufferView = t, e.format = i, e.invertY = s, e._compression = r), e.width % 4 !== 0 && this._gl.pixelStorei(this._gl.UNPACK_ALIGNMENT, 1), r && t ? this._gl.compressedTexImage3D(a, 0, this.getCaps().s3tc[r], e.width, e.height, e.depth, 0, t) : this._gl.texImage3D(a, 0, c, e.width, e.height, e.depth, 0, l, o, t), e.generateMipMaps && this._gl.generateMipmap(a), this._bindTextureDirectly(a, null), e.isReady = !0;
  };
}
Z.prototype.updateRawTexture2DArray = eo(!1);
Z.prototype.updateRawTexture3D = eo(!0);
Ve.prototype.forceSphericalPolynomialsRecompute = function() {
  this._texture && (this._texture._sphericalPolynomial = null, this._texture._sphericalPolynomialPromise = null, this._texture._sphericalPolynomialComputed = !1);
};
Object.defineProperty(Ve.prototype, "sphericalPolynomial", {
  get: function() {
    if (this._texture) {
      if (this._texture._sphericalPolynomial || this._texture._sphericalPolynomialComputed)
        return this._texture._sphericalPolynomial;
      if (this._texture.isReady)
        return this._texture._sphericalPolynomialPromise || (this._texture._sphericalPolynomialPromise = Qs.ConvertCubeMapTextureToSphericalPolynomial(this), this._texture._sphericalPolynomialPromise === null ? this._texture._sphericalPolynomialComputed = !0 : this._texture._sphericalPolynomialPromise.then((h) => {
          this._texture._sphericalPolynomial = h, this._texture._sphericalPolynomialComputed = !0;
        })), null;
    }
    return null;
  },
  set: function(h) {
    this._texture && (this._texture._sphericalPolynomial = h);
  },
  enumerable: !0,
  configurable: !0
});
class ji extends Ve {
  /**
   * Sets whether or not the texture is blocking during loading.
   */
  set isBlocking(e) {
    this._isBlocking = e;
  }
  /**
   * Gets whether or not the texture is blocking during loading.
   */
  get isBlocking() {
    return this._isBlocking;
  }
  /**
   * Sets texture matrix rotation angle around Y axis in radians.
   */
  set rotationY(e) {
    this._rotationY = e, this.setReflectionTextureMatrix(I.RotationY(this._rotationY));
  }
  /**
   * Gets texture matrix rotation angle around Y axis radians.
   */
  get rotationY() {
    return this._rotationY;
  }
  /**
   * Gets or sets the size of the bounding box associated with the cube texture
   * When defined, the cubemap will switch to local mode
   * @see https://community.arm.com/graphics/b/blog/posts/reflections-based-on-local-cubemaps-in-unity
   * @example https://www.babylonjs-playground.com/#RNASML
   */
  set boundingBoxSize(e) {
    if (this._boundingBoxSize && this._boundingBoxSize.equals(e))
      return;
    this._boundingBoxSize = e;
    const t = this.getScene();
    t && t.markAllMaterialsAsDirty(1);
  }
  get boundingBoxSize() {
    return this._boundingBoxSize;
  }
  /**
   * Instantiates an HDRTexture from the following parameters.
   *
   * @param url The location of the HDR raw data (Panorama stored in RGBE format)
   * @param sceneOrEngine The scene or engine the texture will be used in
   * @param size The cubemap desired size (the more it increases the longer the generation will be)
   * @param noMipmap Forces to not generate the mipmap if true
   * @param generateHarmonics Specifies whether you want to extract the polynomial harmonics during the generation process
   * @param gammaSpace Specifies if the texture will be use in gamma or linear space (the PBR material requires those texture in linear space, but the standard material would require them in Gamma space)
   * @param prefilterOnLoad Prefilters HDR texture to allow use of this texture as a PBR reflection texture.
   * @param onLoad
   * @param onError
   */
  constructor(e, t, i, s = !1, r = !0, n = !1, a = !1, o = null, l = null, c = !1) {
    var u;
    super(t), this._generateHarmonics = !0, this._onError = null, this._isBlocking = !0, this._rotationY = 0, this.boundingBoxPosition = p.Zero(), this.onLoadObservable = new N(), e && (this._coordinatesMode = W.CUBIC_MODE, this.name = e, this.url = e, this.hasAlpha = !1, this.isCube = !0, this._textureMatrix = I.Identity(), this._prefilterOnLoad = a, this._onLoad = () => {
      this.onLoadObservable.notifyObservers(this), o && o();
    }, this._onError = l, this.gammaSpace = n, this._noMipmap = s, this._size = i, this._supersample = c, this._generateHarmonics = r, this._texture = this._getFromCache(e, this._noMipmap, void 0, void 0, void 0, this.isCube), this._texture ? this._texture.isReady ? z.SetImmediate(() => this._onLoad()) : this._texture.onLoadedObservable.add(this._onLoad) : !((u = this.getScene()) === null || u === void 0) && u.useDelayedTextureLoading ? this.delayLoadState = 4 : this._loadTexture());
  }
  /**
   * Get the current class name of the texture useful for serialization or dynamic coding.
   * @returns "HDRCubeTexture"
   */
  getClassName() {
    return "HDRCubeTexture";
  }
  /**
   * Occurs when the file is raw .hdr file.
   */
  _loadTexture() {
    const e = this._getEngine(), t = e.getCaps();
    let i = 0;
    t.textureFloat && t.textureFloatLinearFiltering ? i = 1 : t.textureHalfFloat && t.textureHalfFloatLinearFiltering && (i = 2);
    const s = (r) => {
      this.lodGenerationOffset = 0, this.lodGenerationScale = 0.8;
      const n = Yl.GetCubeMapTextureData(r, this._size, this._supersample);
      if (this._generateHarmonics) {
        const c = Qs.ConvertCubeMapToSphericalPolynomial(n);
        this.sphericalPolynomial = c;
      }
      const a = [];
      let o = null, l = null;
      for (let c = 0; c < 6; c++) {
        i === 2 ? l = new Uint16Array(this._size * this._size * 3) : i === 0 && (o = new Uint8Array(this._size * this._size * 3));
        const u = n[ji._FacesMapping[c]];
        if (this.gammaSpace || l || o) {
          for (let d = 0; d < this._size * this._size; d++)
            if (this.gammaSpace && (u[d * 3 + 0] = Math.pow(u[d * 3 + 0], ur), u[d * 3 + 1] = Math.pow(u[d * 3 + 1], ur), u[d * 3 + 2] = Math.pow(u[d * 3 + 2], ur)), l && (l[d * 3 + 0] = Kr(u[d * 3 + 0]), l[d * 3 + 1] = Kr(u[d * 3 + 1]), l[d * 3 + 2] = Kr(u[d * 3 + 2])), o) {
              let f = Math.max(u[d * 3 + 0] * 255, 0), _ = Math.max(u[d * 3 + 1] * 255, 0), g = Math.max(u[d * 3 + 2] * 255, 0);
              const m = Math.max(Math.max(f, _), g);
              if (m > 255) {
                const y = 255 / m;
                f *= y, _ *= y, g *= y;
              }
              o[d * 3 + 0] = f, o[d * 3 + 1] = _, o[d * 3 + 2] = g;
            }
        }
        l ? a.push(l) : o ? a.push(o) : a.push(u);
      }
      return a;
    };
    if (e._features.allowTexturePrefiltering && this._prefilterOnLoad) {
      const r = this._onLoad, n = new ch(e);
      this._onLoad = () => {
        n.prefilter(this, r);
      };
    }
    this._texture = e.createRawCubeTextureFromUrl(this.url, this.getScene(), this._size, 4, i, this._noMipmap, s, null, this._onLoad, this._onError);
  }
  clone() {
    const e = new ji(this.url, this.getScene() || this._getEngine(), this._size, this._noMipmap, this._generateHarmonics, this.gammaSpace);
    return e.level = this.level, e.wrapU = this.wrapU, e.wrapV = this.wrapV, e.coordinatesIndex = this.coordinatesIndex, e.coordinatesMode = this.coordinatesMode, e;
  }
  // Methods
  delayLoad() {
    this.delayLoadState === 4 && (this.delayLoadState = 1, this._texture = this._getFromCache(this.url, this._noMipmap), this._texture || this._loadTexture());
  }
  /**
   * Get the texture reflection matrix used to rotate/transform the reflection.
   * @returns the reflection matrix
   */
  getReflectionTextureMatrix() {
    return this._textureMatrix;
  }
  /**
   * Set the texture reflection matrix used to rotate/transform the reflection.
   * @param value Define the reflection matrix to set
   */
  setReflectionTextureMatrix(e) {
    var t;
    this._textureMatrix = e, e.updateFlag !== this._textureMatrix.updateFlag && e.isIdentity() !== this._textureMatrix.isIdentity() && ((t = this.getScene()) === null || t === void 0 || t.markAllMaterialsAsDirty(1, (i) => i.getActiveTextures().indexOf(this) !== -1));
  }
  /**
   * Dispose the texture and release its associated resources.
   */
  dispose() {
    this.onLoadObservable.clear(), super.dispose();
  }
  /**
   * Parses a JSON representation of an HDR Texture in order to create the texture
   * @param parsedTexture Define the JSON representation
   * @param scene Define the scene the texture should be created in
   * @param rootUrl Define the root url in case we need to load relative dependencies
   * @returns the newly created texture after parsing
   */
  static Parse(e, t, i) {
    let s = null;
    return e.name && !e.isRenderTarget && (s = new ji(i + e.name, t, e.size, e.noMipmap, e.generateHarmonics, e.useInGammaSpace), s.name = e.name, s.hasAlpha = e.hasAlpha, s.level = e.level, s.coordinatesMode = e.coordinatesMode, s.isBlocking = e.isBlocking), s && (e.boundingBoxPosition && (s.boundingBoxPosition = p.FromArray(e.boundingBoxPosition)), e.boundingBoxSize && (s.boundingBoxSize = p.FromArray(e.boundingBoxSize)), e.rotationY && (s.rotationY = e.rotationY)), s;
  }
  serialize() {
    if (!this.name)
      return null;
    const e = {};
    return e.name = this.name, e.hasAlpha = this.hasAlpha, e.isCube = !0, e.level = this.level, e.size = this._size, e.coordinatesMode = this.coordinatesMode, e.useInGammaSpace = this.gammaSpace, e.generateHarmonics = this._generateHarmonics, e.customType = "BABYLON.HDRCubeTexture", e.noMipmap = this._noMipmap, e.isBlocking = this._isBlocking, e.rotationY = this._rotationY, e;
  }
}
ji._FacesMapping = ["right", "left", "up", "down", "front", "back"];
Xe("BABYLON.HDRCubeTexture", ji);
var ln;
(function(h) {
  h[h.NONE = 0] = "NONE", h[h.STEP = 1] = "STEP";
})(ln || (ln = {}));
class ys {
  /**
   * Initializes the range of an animation
   * @param name The name of the animation range
   * @param from The starting frame of the animation
   * @param to The ending frame of the animation
   */
  constructor(e, t, i) {
    this.name = e, this.from = t, this.to = i;
  }
  /**
   * Makes a copy of the animation range
   * @returns A copy of the animation range
   */
  clone() {
    return new ys(this.name, this.from, this.to);
  }
}
class B {
  /**
   * @internal Internal use
   */
  static _PrepareAnimation(e, t, i, s, r, n, a, o) {
    let l;
    if (!isNaN(parseFloat(r)) && isFinite(r) ? l = B.ANIMATIONTYPE_FLOAT : r instanceof U ? l = B.ANIMATIONTYPE_QUATERNION : r instanceof p ? l = B.ANIMATIONTYPE_VECTOR3 : r instanceof ue ? l = B.ANIMATIONTYPE_VECTOR2 : r instanceof ie ? l = B.ANIMATIONTYPE_COLOR3 : r instanceof ye ? l = B.ANIMATIONTYPE_COLOR4 : r instanceof Zt && (l = B.ANIMATIONTYPE_SIZE), l == null)
      return null;
    const c = new B(e, t, i, l, a), u = [
      { frame: 0, value: r },
      { frame: s, value: n }
    ];
    return c.setKeys(u), o !== void 0 && c.setEasingFunction(o), c;
  }
  /**
   * Sets up an animation
   * @param property The property to animate
   * @param animationType The animation type to apply
   * @param framePerSecond The frames per second of the animation
   * @param easingFunction The easing function used in the animation
   * @returns The created animation
   */
  static CreateAnimation(e, t, i, s) {
    const r = new B(e + "Animation", e, i, t, B.ANIMATIONLOOPMODE_CONSTANT);
    return r.setEasingFunction(s), r;
  }
  /**
   * Create and start an animation on a node
   * @param name defines the name of the global animation that will be run on all nodes
   * @param target defines the target where the animation will take place
   * @param targetProperty defines property to animate
   * @param framePerSecond defines the number of frame per second yo use
   * @param totalFrame defines the number of frames in total
   * @param from defines the initial value
   * @param to defines the final value
   * @param loopMode defines which loop mode you want to use (off by default)
   * @param easingFunction defines the easing function to use (linear by default)
   * @param onAnimationEnd defines the callback to call when animation end
   * @param scene defines the hosting scene
   * @returns the animatable created for this animation
   */
  static CreateAndStartAnimation(e, t, i, s, r, n, a, o, l, c, u) {
    const d = B._PrepareAnimation(e, i, s, r, n, a, o, l);
    return !d || (t.getScene && (u = t.getScene()), !u) ? null : u.beginDirectAnimation(t, [d], 0, r, d.loopMode === 1, 1, c);
  }
  /**
   * Create and start an animation on a node and its descendants
   * @param name defines the name of the global animation that will be run on all nodes
   * @param node defines the root node where the animation will take place
   * @param directDescendantsOnly if true only direct descendants will be used, if false direct and also indirect (children of children, an so on in a recursive manner) descendants will be used
   * @param targetProperty defines property to animate
   * @param framePerSecond defines the number of frame per second to use
   * @param totalFrame defines the number of frames in total
   * @param from defines the initial value
   * @param to defines the final value
   * @param loopMode defines which loop mode you want to use (off by default)
   * @param easingFunction defines the easing function to use (linear by default)
   * @param onAnimationEnd defines the callback to call when an animation ends (will be called once per node)
   * @returns the list of animatables created for all nodes
   * @example https://www.babylonjs-playground.com/#MH0VLI
   */
  static CreateAndStartHierarchyAnimation(e, t, i, s, r, n, a, o, l, c, u) {
    const d = B._PrepareAnimation(e, s, r, n, a, o, l, c);
    return d ? t.getScene().beginDirectHierarchyAnimation(t, i, [d], 0, n, d.loopMode === 1, 1, u) : null;
  }
  /**
   * Creates a new animation, merges it with the existing animations and starts it
   * @param name Name of the animation
   * @param node Node which contains the scene that begins the animations
   * @param targetProperty Specifies which property to animate
   * @param framePerSecond The frames per second of the animation
   * @param totalFrame The total number of frames
   * @param from The frame at the beginning of the animation
   * @param to The frame at the end of the animation
   * @param loopMode Specifies the loop mode of the animation
   * @param easingFunction (Optional) The easing function of the animation, which allow custom mathematical formulas for animations
   * @param onAnimationEnd Callback to run once the animation is complete
   * @returns Nullable animation
   */
  static CreateMergeAndStartAnimation(e, t, i, s, r, n, a, o, l, c) {
    const u = B._PrepareAnimation(e, i, s, r, n, a, o, l);
    return u ? (t.animations.push(u), t.getScene().beginAnimation(t, 0, r, u.loopMode === 1, 1, c)) : null;
  }
  /**
   * Convert the keyframes for all animations belonging to the group to be relative to a given reference frame.
   * @param sourceAnimation defines the Animation containing keyframes to convert
   * @param referenceFrame defines the frame that keyframes in the range will be relative to
   * @param range defines the name of the AnimationRange belonging to the Animation to convert
   * @param cloneOriginal defines whether or not to clone the animation and convert the clone or convert the original animation (default is false)
   * @param clonedName defines the name of the resulting cloned Animation if cloneOriginal is true
   * @returns a new Animation if cloneOriginal is true or the original Animation if cloneOriginal is false
   */
  static MakeAnimationAdditive(e, t = 0, i, s = !1, r) {
    let n = e;
    if (s && (n = e.clone(), n.name = r || n.name), !n._keys.length)
      return n;
    t = t >= 0 ? t : 0;
    let a = 0;
    const o = n._keys[0];
    let l = n._keys.length - 1;
    const c = n._keys[l], u = {
      referenceValue: o.value,
      referencePosition: C.Vector3[0],
      referenceQuaternion: C.Quaternion[0],
      referenceScaling: C.Vector3[1],
      keyPosition: C.Vector3[2],
      keyQuaternion: C.Quaternion[1],
      keyScaling: C.Vector3[3]
    };
    let d = !1, f = o.frame, _ = c.frame;
    if (i) {
      const x = n.getRange(i);
      x && (f = x.from, _ = x.to);
    }
    let g = o.frame === f, m = c.frame === _;
    if (n._keys.length === 1) {
      const x = n._getKeyValue(n._keys[0]);
      u.referenceValue = x.clone ? x.clone() : x, d = !0;
    } else if (t <= o.frame) {
      const x = n._getKeyValue(o.value);
      u.referenceValue = x.clone ? x.clone() : x, d = !0;
    } else if (t >= c.frame) {
      const x = n._getKeyValue(c.value);
      u.referenceValue = x.clone ? x.clone() : x, d = !0;
    }
    let y = 0;
    for (; !d || !g || !m && y < n._keys.length - 1; ) {
      const x = n._keys[y], A = n._keys[y + 1];
      if (!d && t >= x.frame && t <= A.frame) {
        let T;
        if (t === x.frame)
          T = n._getKeyValue(x.value);
        else if (t === A.frame)
          T = n._getKeyValue(A.value);
        else {
          const M = {
            key: y,
            repeatCount: 0,
            loopMode: this.ANIMATIONLOOPMODE_CONSTANT
          };
          T = n._interpolate(t, M);
        }
        u.referenceValue = T.clone ? T.clone() : T, d = !0;
      }
      if (!g && f >= x.frame && f <= A.frame) {
        if (f === x.frame)
          a = y;
        else if (f === A.frame)
          a = y + 1;
        else {
          const T = {
            key: y,
            repeatCount: 0,
            loopMode: this.ANIMATIONLOOPMODE_CONSTANT
          }, M = n._interpolate(f, T), b = {
            frame: f,
            value: M.clone ? M.clone() : M
          };
          n._keys.splice(y + 1, 0, b), a = y + 1;
        }
        g = !0;
      }
      if (!m && _ >= x.frame && _ <= A.frame) {
        if (_ === x.frame)
          l = y;
        else if (_ === A.frame)
          l = y + 1;
        else {
          const T = {
            key: y,
            repeatCount: 0,
            loopMode: this.ANIMATIONLOOPMODE_CONSTANT
          }, M = n._interpolate(_, T), b = {
            frame: _,
            value: M.clone ? M.clone() : M
          };
          n._keys.splice(y + 1, 0, b), l = y + 1;
        }
        m = !0;
      }
      y++;
    }
    for (n.dataType === B.ANIMATIONTYPE_QUATERNION ? u.referenceValue.normalize().conjugateInPlace() : n.dataType === B.ANIMATIONTYPE_MATRIX && (u.referenceValue.decompose(u.referenceScaling, u.referenceQuaternion, u.referencePosition), u.referenceQuaternion.normalize().conjugateInPlace()), y = a; y <= l; y++) {
      const x = n._keys[y];
      if (!(y && n.dataType !== B.ANIMATIONTYPE_FLOAT && x.value === o.value))
        switch (n.dataType) {
          case B.ANIMATIONTYPE_MATRIX:
            x.value.decompose(u.keyScaling, u.keyQuaternion, u.keyPosition), u.keyPosition.subtractInPlace(u.referencePosition), u.keyScaling.divideInPlace(u.referenceScaling), u.referenceQuaternion.multiplyToRef(u.keyQuaternion, u.keyQuaternion), I.ComposeToRef(u.keyScaling, u.keyQuaternion, u.keyPosition, x.value);
            break;
          case B.ANIMATIONTYPE_QUATERNION:
            u.referenceValue.multiplyToRef(x.value, x.value);
            break;
          case B.ANIMATIONTYPE_VECTOR2:
          case B.ANIMATIONTYPE_VECTOR3:
          case B.ANIMATIONTYPE_COLOR3:
          case B.ANIMATIONTYPE_COLOR4:
            x.value.subtractToRef(u.referenceValue, x.value);
            break;
          case B.ANIMATIONTYPE_SIZE:
            x.value.width -= u.referenceValue.width, x.value.height -= u.referenceValue.height;
            break;
          default:
            x.value -= u.referenceValue;
        }
    }
    return n;
  }
  /**
   * Transition property of an host to the target Value
   * @param property The property to transition
   * @param targetValue The target Value of the property
   * @param host The object where the property to animate belongs
   * @param scene Scene used to run the animation
   * @param frameRate Framerate (in frame/s) to use
   * @param transition The transition type we want to use
   * @param duration The duration of the animation, in milliseconds
   * @param onAnimationEnd Callback trigger at the end of the animation
   * @returns Nullable animation
   */
  static TransitionTo(e, t, i, s, r, n, a, o = null) {
    if (a <= 0)
      return i[e] = t, o && o(), null;
    const l = r * (a / 1e3);
    n.setKeys([
      {
        frame: 0,
        value: i[e].clone ? i[e].clone() : i[e]
      },
      {
        frame: l,
        value: t
      }
    ]), i.animations || (i.animations = []), i.animations.push(n);
    const c = s.beginAnimation(i, 0, l, !1);
    return c.onAnimationEnd = o, c;
  }
  /**
   * Return the array of runtime animations currently using this animation
   */
  get runtimeAnimations() {
    return this._runtimeAnimations;
  }
  /**
   * Specifies if any of the runtime animations are currently running
   */
  get hasRunningRuntimeAnimations() {
    for (const e of this._runtimeAnimations)
      if (!e.isStopped())
        return !0;
    return !1;
  }
  /**
   * Initializes the animation
   * @param name Name of the animation
   * @param targetProperty Property to animate
   * @param framePerSecond The frames per second of the animation
   * @param dataType The data type of the animation
   * @param loopMode The loop mode of the animation
   * @param enableBlending Specifies if blending should be enabled
   */
  constructor(e, t, i, s, r, n) {
    this.name = e, this.targetProperty = t, this.framePerSecond = i, this.dataType = s, this.loopMode = r, this.enableBlending = n, this._easingFunction = null, this._runtimeAnimations = new Array(), this._events = new Array(), this.blendingSpeed = 0.01, this._ranges = {}, this.targetPropertyPath = t.split("."), this.dataType = s, this.loopMode = r === void 0 ? B.ANIMATIONLOOPMODE_CYCLE : r, this.uniqueId = B._UniqueIdGenerator++;
  }
  // Methods
  /**
   * Converts the animation to a string
   * @param fullDetails support for multiple levels of logging within scene loading
   * @returns String form of the animation
   */
  toString(e) {
    let t = "Name: " + this.name + ", property: " + this.targetProperty;
    if (t += ", datatype: " + ["Float", "Vector3", "Quaternion", "Matrix", "Color3", "Vector2"][this.dataType], t += ", nKeys: " + (this._keys ? this._keys.length : "none"), t += ", nRanges: " + (this._ranges ? Object.keys(this._ranges).length : "none"), e) {
      t += ", Ranges: {";
      let i = !0;
      for (const s in this._ranges)
        i && (t += ", ", i = !1), t += s;
      t += "}";
    }
    return t;
  }
  /**
   * Add an event to this animation
   * @param event Event to add
   */
  addEvent(e) {
    this._events.push(e), this._events.sort((t, i) => t.frame - i.frame);
  }
  /**
   * Remove all events found at the given frame
   * @param frame The frame to remove events from
   */
  removeEvents(e) {
    for (let t = 0; t < this._events.length; t++)
      this._events[t].frame === e && (this._events.splice(t, 1), t--);
  }
  /**
   * Retrieves all the events from the animation
   * @returns Events from the animation
   */
  getEvents() {
    return this._events;
  }
  /**
   * Creates an animation range
   * @param name Name of the animation range
   * @param from Starting frame of the animation range
   * @param to Ending frame of the animation
   */
  createRange(e, t, i) {
    this._ranges[e] || (this._ranges[e] = new ys(e, t, i));
  }
  /**
   * Deletes an animation range by name
   * @param name Name of the animation range to delete
   * @param deleteFrames Specifies if the key frames for the range should also be deleted (true) or not (false)
   */
  deleteRange(e, t = !0) {
    const i = this._ranges[e];
    if (i) {
      if (t) {
        const s = i.from, r = i.to;
        for (let n = this._keys.length - 1; n >= 0; n--)
          this._keys[n].frame >= s && this._keys[n].frame <= r && this._keys.splice(n, 1);
      }
      this._ranges[e] = null;
    }
  }
  /**
   * Gets the animation range by name, or null if not defined
   * @param name Name of the animation range
   * @returns Nullable animation range
   */
  getRange(e) {
    return this._ranges[e];
  }
  /**
   * Gets the key frames from the animation
   * @returns The key frames of the animation
   */
  getKeys() {
    return this._keys;
  }
  /**
   * Gets the highest frame rate of the animation
   * @returns Highest frame rate of the animation
   */
  getHighestFrame() {
    let e = 0;
    for (let t = 0, i = this._keys.length; t < i; t++)
      e < this._keys[t].frame && (e = this._keys[t].frame);
    return e;
  }
  /**
   * Gets the easing function of the animation
   * @returns Easing function of the animation
   */
  getEasingFunction() {
    return this._easingFunction;
  }
  /**
   * Sets the easing function of the animation
   * @param easingFunction A custom mathematical formula for animation
   */
  setEasingFunction(e) {
    this._easingFunction = e;
  }
  /**
   * Interpolates a scalar linearly
   * @param startValue Start value of the animation curve
   * @param endValue End value of the animation curve
   * @param gradient Scalar amount to interpolate
   * @returns Interpolated scalar value
   */
  floatInterpolateFunction(e, t, i) {
    return J.Lerp(e, t, i);
  }
  /**
   * Interpolates a scalar cubically
   * @param startValue Start value of the animation curve
   * @param outTangent End tangent of the animation
   * @param endValue End value of the animation curve
   * @param inTangent Start tangent of the animation curve
   * @param gradient Scalar amount to interpolate
   * @returns Interpolated scalar value
   */
  floatInterpolateFunctionWithTangents(e, t, i, s, r) {
    return J.Hermite(e, t, i, s, r);
  }
  /**
   * Interpolates a quaternion using a spherical linear interpolation
   * @param startValue Start value of the animation curve
   * @param endValue End value of the animation curve
   * @param gradient Scalar amount to interpolate
   * @returns Interpolated quaternion value
   */
  quaternionInterpolateFunction(e, t, i) {
    return U.Slerp(e, t, i);
  }
  /**
   * Interpolates a quaternion cubically
   * @param startValue Start value of the animation curve
   * @param outTangent End tangent of the animation curve
   * @param endValue End value of the animation curve
   * @param inTangent Start tangent of the animation curve
   * @param gradient Scalar amount to interpolate
   * @returns Interpolated quaternion value
   */
  quaternionInterpolateFunctionWithTangents(e, t, i, s, r) {
    return U.Hermite(e, t, i, s, r).normalize();
  }
  /**
   * Interpolates a Vector3 linearly
   * @param startValue Start value of the animation curve
   * @param endValue End value of the animation curve
   * @param gradient Scalar amount to interpolate (value between 0 and 1)
   * @returns Interpolated scalar value
   */
  vector3InterpolateFunction(e, t, i) {
    return p.Lerp(e, t, i);
  }
  /**
   * Interpolates a Vector3 cubically
   * @param startValue Start value of the animation curve
   * @param outTangent End tangent of the animation
   * @param endValue End value of the animation curve
   * @param inTangent Start tangent of the animation curve
   * @param gradient Scalar amount to interpolate (value between 0 and 1)
   * @returns InterpolatedVector3 value
   */
  vector3InterpolateFunctionWithTangents(e, t, i, s, r) {
    return p.Hermite(e, t, i, s, r);
  }
  /**
   * Interpolates a Vector2 linearly
   * @param startValue Start value of the animation curve
   * @param endValue End value of the animation curve
   * @param gradient Scalar amount to interpolate (value between 0 and 1)
   * @returns Interpolated Vector2 value
   */
  vector2InterpolateFunction(e, t, i) {
    return ue.Lerp(e, t, i);
  }
  /**
   * Interpolates a Vector2 cubically
   * @param startValue Start value of the animation curve
   * @param outTangent End tangent of the animation
   * @param endValue End value of the animation curve
   * @param inTangent Start tangent of the animation curve
   * @param gradient Scalar amount to interpolate (value between 0 and 1)
   * @returns Interpolated Vector2 value
   */
  vector2InterpolateFunctionWithTangents(e, t, i, s, r) {
    return ue.Hermite(e, t, i, s, r);
  }
  /**
   * Interpolates a size linearly
   * @param startValue Start value of the animation curve
   * @param endValue End value of the animation curve
   * @param gradient Scalar amount to interpolate
   * @returns Interpolated Size value
   */
  sizeInterpolateFunction(e, t, i) {
    return Zt.Lerp(e, t, i);
  }
  /**
   * Interpolates a Color3 linearly
   * @param startValue Start value of the animation curve
   * @param endValue End value of the animation curve
   * @param gradient Scalar amount to interpolate
   * @returns Interpolated Color3 value
   */
  color3InterpolateFunction(e, t, i) {
    return ie.Lerp(e, t, i);
  }
  /**
   * Interpolates a Color3 cubically
   * @param startValue Start value of the animation curve
   * @param outTangent End tangent of the animation
   * @param endValue End value of the animation curve
   * @param inTangent Start tangent of the animation curve
   * @param gradient Scalar amount to interpolate
   * @returns interpolated value
   */
  color3InterpolateFunctionWithTangents(e, t, i, s, r) {
    return ie.Hermite(e, t, i, s, r);
  }
  /**
   * Interpolates a Color4 linearly
   * @param startValue Start value of the animation curve
   * @param endValue End value of the animation curve
   * @param gradient Scalar amount to interpolate
   * @returns Interpolated Color3 value
   */
  color4InterpolateFunction(e, t, i) {
    return ye.Lerp(e, t, i);
  }
  /**
   * Interpolates a Color4 cubically
   * @param startValue Start value of the animation curve
   * @param outTangent End tangent of the animation
   * @param endValue End value of the animation curve
   * @param inTangent Start tangent of the animation curve
   * @param gradient Scalar amount to interpolate
   * @returns interpolated value
   */
  color4InterpolateFunctionWithTangents(e, t, i, s, r) {
    return ye.Hermite(e, t, i, s, r);
  }
  /**
   * @internal Internal use only
   */
  _getKeyValue(e) {
    return typeof e == "function" ? e() : e;
  }
  /**
   * Evaluate the animation value at a given frame
   * @param currentFrame defines the frame where we want to evaluate the animation
   * @returns the animation value
   */
  evaluate(e) {
    return this._interpolate(e, {
      key: 0,
      repeatCount: 0,
      loopMode: B.ANIMATIONLOOPMODE_CONSTANT
    });
  }
  /**
   * @internal Internal use only
   */
  _interpolate(e, t) {
    if (t.loopMode === B.ANIMATIONLOOPMODE_CONSTANT && t.repeatCount > 0)
      return t.highLimitValue.clone ? t.highLimitValue.clone() : t.highLimitValue;
    const i = this._keys, s = i.length;
    let r = t.key;
    for (; r >= 0 && e < i[r].frame; )
      --r;
    for (; r + 1 <= s - 1 && e >= i[r + 1].frame; )
      ++r;
    if (t.key = r, r < 0)
      return this._getKeyValue(i[0].value);
    if (r + 1 > s - 1)
      return this._getKeyValue(i[s - 1].value);
    const n = i[r], a = i[r + 1], o = this._getKeyValue(n.value), l = this._getKeyValue(a.value);
    if (n.interpolation === ln.STEP)
      return a.frame > e ? o : l;
    const c = n.outTangent !== void 0 && a.inTangent !== void 0, u = a.frame - n.frame;
    let d = (e - n.frame) / u;
    const f = this.getEasingFunction();
    switch (f !== null && (d = f.ease(d)), this.dataType) {
      case B.ANIMATIONTYPE_FLOAT: {
        const _ = c ? this.floatInterpolateFunctionWithTangents(o, n.outTangent * u, l, a.inTangent * u, d) : this.floatInterpolateFunction(o, l, d);
        switch (t.loopMode) {
          case B.ANIMATIONLOOPMODE_CYCLE:
          case B.ANIMATIONLOOPMODE_CONSTANT:
          case B.ANIMATIONLOOPMODE_YOYO:
            return _;
          case B.ANIMATIONLOOPMODE_RELATIVE:
            return t.offsetValue * t.repeatCount + _;
        }
        break;
      }
      case B.ANIMATIONTYPE_QUATERNION: {
        const _ = c ? this.quaternionInterpolateFunctionWithTangents(o, n.outTangent.scale(u), l, a.inTangent.scale(u), d) : this.quaternionInterpolateFunction(o, l, d);
        switch (t.loopMode) {
          case B.ANIMATIONLOOPMODE_CYCLE:
          case B.ANIMATIONLOOPMODE_CONSTANT:
          case B.ANIMATIONLOOPMODE_YOYO:
            return _;
          case B.ANIMATIONLOOPMODE_RELATIVE:
            return _.addInPlace(t.offsetValue.scale(t.repeatCount));
        }
        return _;
      }
      case B.ANIMATIONTYPE_VECTOR3: {
        const _ = c ? this.vector3InterpolateFunctionWithTangents(o, n.outTangent.scale(u), l, a.inTangent.scale(u), d) : this.vector3InterpolateFunction(o, l, d);
        switch (t.loopMode) {
          case B.ANIMATIONLOOPMODE_CYCLE:
          case B.ANIMATIONLOOPMODE_CONSTANT:
          case B.ANIMATIONLOOPMODE_YOYO:
            return _;
          case B.ANIMATIONLOOPMODE_RELATIVE:
            return _.add(t.offsetValue.scale(t.repeatCount));
        }
        break;
      }
      case B.ANIMATIONTYPE_VECTOR2: {
        const _ = c ? this.vector2InterpolateFunctionWithTangents(o, n.outTangent.scale(u), l, a.inTangent.scale(u), d) : this.vector2InterpolateFunction(o, l, d);
        switch (t.loopMode) {
          case B.ANIMATIONLOOPMODE_CYCLE:
          case B.ANIMATIONLOOPMODE_CONSTANT:
          case B.ANIMATIONLOOPMODE_YOYO:
            return _;
          case B.ANIMATIONLOOPMODE_RELATIVE:
            return _.add(t.offsetValue.scale(t.repeatCount));
        }
        break;
      }
      case B.ANIMATIONTYPE_SIZE: {
        switch (t.loopMode) {
          case B.ANIMATIONLOOPMODE_CYCLE:
          case B.ANIMATIONLOOPMODE_CONSTANT:
          case B.ANIMATIONLOOPMODE_YOYO:
            return this.sizeInterpolateFunction(o, l, d);
          case B.ANIMATIONLOOPMODE_RELATIVE:
            return this.sizeInterpolateFunction(o, l, d).add(t.offsetValue.scale(t.repeatCount));
        }
        break;
      }
      case B.ANIMATIONTYPE_COLOR3: {
        const _ = c ? this.color3InterpolateFunctionWithTangents(o, n.outTangent.scale(u), l, a.inTangent.scale(u), d) : this.color3InterpolateFunction(o, l, d);
        switch (t.loopMode) {
          case B.ANIMATIONLOOPMODE_CYCLE:
          case B.ANIMATIONLOOPMODE_CONSTANT:
          case B.ANIMATIONLOOPMODE_YOYO:
            return _;
          case B.ANIMATIONLOOPMODE_RELATIVE:
            return _.add(t.offsetValue.scale(t.repeatCount));
        }
        break;
      }
      case B.ANIMATIONTYPE_COLOR4: {
        const _ = c ? this.color4InterpolateFunctionWithTangents(o, n.outTangent.scale(u), l, a.inTangent.scale(u), d) : this.color4InterpolateFunction(o, l, d);
        switch (t.loopMode) {
          case B.ANIMATIONLOOPMODE_CYCLE:
          case B.ANIMATIONLOOPMODE_CONSTANT:
          case B.ANIMATIONLOOPMODE_YOYO:
            return _;
          case B.ANIMATIONLOOPMODE_RELATIVE:
            return _.add(t.offsetValue.scale(t.repeatCount));
        }
        break;
      }
      case B.ANIMATIONTYPE_MATRIX: {
        switch (t.loopMode) {
          case B.ANIMATIONLOOPMODE_CYCLE:
          case B.ANIMATIONLOOPMODE_CONSTANT:
          case B.ANIMATIONLOOPMODE_YOYO:
            return B.AllowMatricesInterpolation ? this.matrixInterpolateFunction(o, l, d, t.workValue) : o;
          case B.ANIMATIONLOOPMODE_RELATIVE:
            return o;
        }
        break;
      }
    }
    return 0;
  }
  /**
   * Defines the function to use to interpolate matrices
   * @param startValue defines the start matrix
   * @param endValue defines the end matrix
   * @param gradient defines the gradient between both matrices
   * @param result defines an optional target matrix where to store the interpolation
   * @returns the interpolated matrix
   */
  matrixInterpolateFunction(e, t, i, s) {
    return B.AllowMatrixDecomposeForInterpolation ? s ? (I.DecomposeLerpToRef(e, t, i, s), s) : I.DecomposeLerp(e, t, i) : s ? (I.LerpToRef(e, t, i, s), s) : I.Lerp(e, t, i);
  }
  /**
   * Makes a copy of the animation
   * @returns Cloned animation
   */
  clone() {
    const e = new B(this.name, this.targetPropertyPath.join("."), this.framePerSecond, this.dataType, this.loopMode);
    if (e.enableBlending = this.enableBlending, e.blendingSpeed = this.blendingSpeed, this._keys && e.setKeys(this._keys), this._ranges) {
      e._ranges = {};
      for (const t in this._ranges) {
        const i = this._ranges[t];
        i && (e._ranges[t] = i.clone());
      }
    }
    return e;
  }
  /**
   * Sets the key frames of the animation
   * @param values The animation key frames to set
   */
  setKeys(e) {
    this._keys = e.slice(0);
  }
  /**
   * Serializes the animation to an object
   * @returns Serialized object
   */
  serialize() {
    const e = {};
    e.name = this.name, e.property = this.targetProperty, e.framePerSecond = this.framePerSecond, e.dataType = this.dataType, e.loopBehavior = this.loopMode, e.enableBlending = this.enableBlending, e.blendingSpeed = this.blendingSpeed;
    const t = this.dataType;
    e.keys = [];
    const i = this.getKeys();
    for (let s = 0; s < i.length; s++) {
      const r = i[s], n = {};
      switch (n.frame = r.frame, t) {
        case B.ANIMATIONTYPE_FLOAT:
          n.values = [r.value], r.inTangent !== void 0 && n.values.push(r.inTangent), r.outTangent !== void 0 && (r.inTangent === void 0 && n.values.push(void 0), n.values.push(r.outTangent)), r.interpolation !== void 0 && (r.inTangent === void 0 && n.values.push(void 0), r.outTangent === void 0 && n.values.push(void 0), n.values.push(r.interpolation));
          break;
        case B.ANIMATIONTYPE_QUATERNION:
        case B.ANIMATIONTYPE_MATRIX:
        case B.ANIMATIONTYPE_VECTOR3:
        case B.ANIMATIONTYPE_COLOR3:
        case B.ANIMATIONTYPE_COLOR4:
          n.values = r.value.asArray(), r.inTangent != null && n.values.push(r.inTangent.asArray()), r.outTangent != null && (r.inTangent === void 0 && n.values.push(void 0), n.values.push(r.outTangent.asArray())), r.interpolation !== void 0 && (r.inTangent === void 0 && n.values.push(void 0), r.outTangent === void 0 && n.values.push(void 0), n.values.push(r.interpolation));
          break;
      }
      e.keys.push(n);
    }
    e.ranges = [];
    for (const s in this._ranges) {
      const r = this._ranges[s];
      if (!r)
        continue;
      const n = {};
      n.name = s, n.from = r.from, n.to = r.to, e.ranges.push(n);
    }
    return e;
  }
  /**
   * @internal
   */
  static _UniversalLerp(e, t, i) {
    const s = e.constructor;
    return s.Lerp ? s.Lerp(e, t, i) : s.Slerp ? s.Slerp(e, t, i) : e.toFixed ? e * (1 - i) + i * t : t;
  }
  /**
   * Parses an animation object and creates an animation
   * @param parsedAnimation Parsed animation object
   * @returns Animation object
   */
  static Parse(e) {
    const t = new B(e.name, e.property, e.framePerSecond, e.dataType, e.loopBehavior), i = e.dataType, s = [];
    let r, n;
    for (e.enableBlending && (t.enableBlending = e.enableBlending), e.blendingSpeed && (t.blendingSpeed = e.blendingSpeed), n = 0; n < e.keys.length; n++) {
      const a = e.keys[n];
      let o, l, c;
      switch (i) {
        case B.ANIMATIONTYPE_FLOAT:
          r = a.values[0], a.values.length >= 2 && (o = a.values[1]), a.values.length >= 3 && (l = a.values[2]), a.values.length >= 4 && (c = a.values[3]);
          break;
        case B.ANIMATIONTYPE_QUATERNION:
          if (r = U.FromArray(a.values), a.values.length >= 8) {
            const d = U.FromArray(a.values.slice(4, 8));
            d.equals(U.Zero()) || (o = d);
          }
          if (a.values.length >= 12) {
            const d = U.FromArray(a.values.slice(8, 12));
            d.equals(U.Zero()) || (l = d);
          }
          a.values.length >= 13 && (c = a.values[12]);
          break;
        case B.ANIMATIONTYPE_MATRIX:
          r = I.FromArray(a.values), a.values.length >= 17 && (c = a.values[16]);
          break;
        case B.ANIMATIONTYPE_COLOR3:
          r = ie.FromArray(a.values), a.values[3] && (o = ie.FromArray(a.values[3])), a.values[4] && (l = ie.FromArray(a.values[4])), a.values[5] && (c = a.values[5]);
          break;
        case B.ANIMATIONTYPE_COLOR4:
          r = ye.FromArray(a.values), a.values[4] && (o = ye.FromArray(a.values[4])), a.values[5] && (l = ye.FromArray(a.values[5])), a.values[6] && (c = ye.FromArray(a.values[6]));
          break;
        case B.ANIMATIONTYPE_VECTOR3:
        default:
          r = p.FromArray(a.values), a.values[3] && (o = p.FromArray(a.values[3])), a.values[4] && (l = p.FromArray(a.values[4])), a.values[5] && (c = a.values[5]);
          break;
      }
      const u = {};
      u.frame = a.frame, u.value = r, o != null && (u.inTangent = o), l != null && (u.outTangent = l), c != null && (u.interpolation = c), s.push(u);
    }
    if (t.setKeys(s), e.ranges)
      for (n = 0; n < e.ranges.length; n++)
        r = e.ranges[n], t.createRange(r.name, r.from, r.to);
    return t;
  }
  /**
   * Appends the serialized animations from the source animations
   * @param source Source containing the animations
   * @param destination Target to store the animations
   */
  static AppendSerializedAnimations(e, t) {
    le.AppendSerializedAnimations(e, t);
  }
  /**
   * Creates a new animation or an array of animations from a snippet saved in a remote file
   * @param name defines the name of the animation to create (can be null or empty to use the one from the json data)
   * @param url defines the url to load from
   * @returns a promise that will resolve to the new animation or an array of animations
   */
  static ParseFromFileAsync(e, t) {
    return new Promise((i, s) => {
      const r = new mt();
      r.addEventListener("readystatechange", () => {
        if (r.readyState == 4)
          if (r.status == 200) {
            let n = JSON.parse(r.responseText);
            if (n.animations && (n = n.animations), n.length) {
              const a = new Array();
              for (const o of n)
                a.push(this.Parse(o));
              i(a);
            } else {
              const a = this.Parse(n);
              e && (a.name = e), i(a);
            }
          } else
            s("Unable to load the animation");
      }), r.open("GET", t), r.send();
    });
  }
  /**
   * Creates an animation or an array of animations from a snippet saved by the Inspector
   * @param snippetId defines the snippet to load
   * @returns a promise that will resolve to the new animation or a new array of animations
   */
  static ParseFromSnippetAsync(e) {
    return new Promise((t, i) => {
      const s = new mt();
      s.addEventListener("readystatechange", () => {
        if (s.readyState == 4)
          if (s.status == 200) {
            const r = JSON.parse(JSON.parse(s.responseText).jsonPayload);
            if (r.animations) {
              const n = JSON.parse(r.animations), a = new Array();
              for (const o of n.animations) {
                const l = this.Parse(o);
                l.snippetId = e, a.push(l);
              }
              t(a);
            } else {
              const n = JSON.parse(r.animation), a = this.Parse(n);
              a.snippetId = e, t(a);
            }
          } else
            i("Unable to load the snippet " + e);
      }), s.open("GET", this.SnippetUrl + "/" + e.replace(/#/g, "/")), s.send();
    });
  }
}
B._UniqueIdGenerator = 0;
B.AllowMatricesInterpolation = !1;
B.AllowMatrixDecomposeForInterpolation = !0;
B.SnippetUrl = "https://snippet.babylonjs.com";
B.ANIMATIONTYPE_FLOAT = 0;
B.ANIMATIONTYPE_VECTOR3 = 1;
B.ANIMATIONTYPE_QUATERNION = 2;
B.ANIMATIONTYPE_MATRIX = 3;
B.ANIMATIONTYPE_COLOR3 = 4;
B.ANIMATIONTYPE_COLOR4 = 7;
B.ANIMATIONTYPE_VECTOR2 = 5;
B.ANIMATIONTYPE_SIZE = 6;
B.ANIMATIONLOOPMODE_RELATIVE = 0;
B.ANIMATIONLOOPMODE_CYCLE = 1;
B.ANIMATIONLOOPMODE_CONSTANT = 2;
B.ANIMATIONLOOPMODE_YOYO = 4;
B.CreateFromSnippetAsync = B.ParseFromSnippetAsync;
Xe("BABYLON.Animation", B);
ut._AnimationRangeFactory = (h, e, t) => new ys(h, e, t);
class gh {
  /**
   * Returns the string "TargetedAnimation"
   * @returns "TargetedAnimation"
   */
  getClassName() {
    return "TargetedAnimation";
  }
  /**
   * Serialize the object
   * @returns the JSON object representing the current entity
   */
  serialize() {
    const e = {};
    return e.animation = this.animation.serialize(), e.targetId = this.target.id, e;
  }
}
class Ds {
  /**
   * Makes sure that the animations are either played or stopped according to the animation group mask.
   * Note however that the call won't have any effect if the animation group has not been started yet.
   * You should call this function if you modify the mask after the animation group has been started.
   */
  syncWithMask() {
    if (this.mask)
      for (let e = 0; e < this._animatables.length; ++e) {
        const t = this._animatables[e];
        this.mask.retainsTarget(t.target.name) ? t.paused && t.restart() : t.paused || t.pause();
      }
  }
  /**
   * Removes all animations for the targets not retained by the animation group mask.
   * Use this function if you know you won't need those animations anymore and if you want to free memory.
   */
  removeUnmaskedAnimations() {
    if (this.mask) {
      for (let e = 0; e < this._animatables.length; ++e) {
        const t = this._animatables[e];
        this.mask.retainsTarget(t.target.name) || (t.stop(), this._animatables.splice(e, 1), --e);
      }
      for (let e = 0; e < this._targetedAnimations.length; e++) {
        const t = this._targetedAnimations[e];
        this.mask.retainsTarget(t.target.name) || (this._targetedAnimations.splice(e, 1), --e);
      }
    }
  }
  /**
   * Gets the first frame
   */
  get from() {
    return this._from;
  }
  /**
   * Gets the last frame
   */
  get to() {
    return this._to;
  }
  /**
   * Define if the animations are started
   */
  get isStarted() {
    return this._isStarted;
  }
  /**
   * Gets a value indicating that the current group is playing
   */
  get isPlaying() {
    return this._isStarted && !this._isPaused;
  }
  /**
   * Gets or sets the speed ratio to use for all animations
   */
  get speedRatio() {
    return this._speedRatio;
  }
  /**
   * Gets or sets the speed ratio to use for all animations
   */
  set speedRatio(e) {
    if (this._speedRatio !== e) {
      this._speedRatio = e;
      for (let t = 0; t < this._animatables.length; t++) {
        const i = this._animatables[t];
        i.speedRatio = this._speedRatio;
      }
    }
  }
  /**
   * Gets or sets if all animations should loop or not
   */
  get loopAnimation() {
    return this._loopAnimation;
  }
  set loopAnimation(e) {
    if (this._loopAnimation !== e) {
      this._loopAnimation = e;
      for (let t = 0; t < this._animatables.length; t++) {
        const i = this._animatables[t];
        i.loopAnimation = this._loopAnimation;
      }
    }
  }
  /**
   * Gets or sets if all animations should be evaluated additively
   */
  get isAdditive() {
    return this._isAdditive;
  }
  set isAdditive(e) {
    if (this._isAdditive !== e) {
      this._isAdditive = e;
      for (let t = 0; t < this._animatables.length; t++) {
        const i = this._animatables[t];
        i.isAdditive = this._isAdditive;
      }
    }
  }
  /**
   * Gets or sets the weight to apply to all animations of the group
   */
  get weight() {
    return this._weight;
  }
  set weight(e) {
    this._weight !== e && (this._weight = e, this.setWeightForAllAnimatables(this._weight));
  }
  /**
   * Gets the targeted animations for this animation group
   */
  get targetedAnimations() {
    return this._targetedAnimations;
  }
  /**
   * returning the list of animatables controlled by this animation group.
   */
  get animatables() {
    return this._animatables;
  }
  /**
   * Gets the list of target animations
   */
  get children() {
    return this._targetedAnimations;
  }
  /**
   * Gets or sets the order of play of the animation group (default: 0)
   */
  get playOrder() {
    return this._playOrder;
  }
  set playOrder(e) {
    if (this._playOrder !== e && (this._playOrder = e, this._animatables.length > 0)) {
      for (let t = 0; t < this._animatables.length; t++)
        this._animatables[t].playOrder = this._playOrder;
      this._scene.sortActiveAnimatables();
    }
  }
  /**
   * Allows the animations of the animation group to blend with current running animations
   * Note: this method should be called after all targeted animations have been added to the group
   * @param blendingSpeed defines the blending speed to use
   */
  enableBlending(e) {
    for (let t = 0; t < this._targetedAnimations.length; ++t)
      this._targetedAnimations[t].animation.enableBlending = !0, this._targetedAnimations[t].animation.blendingSpeed = e;
  }
  /**
   * Disable animation blending
   */
  disableBlending() {
    for (let e = 0; e < this._targetedAnimations.length; ++e)
      this._targetedAnimations[e].animation.enableBlending = !1;
  }
  /**
   * Merge the array of animation groups into a new animation group
   * @param animationGroups List of animation groups to merge
   * @param disposeSource If true, animation groups will be disposed after being merged (default: true)
   * @param normalize If true, animation groups will be normalized before being merged, so that all animations have the same "from" and "to" frame (default: false)
   * @param weight Weight for the new animation group. If not provided, it will inherit the weight from the first animation group of the array
   * @returns The new animation group or null if no animation groups were passed
   */
  static MergeAnimationGroups(e, t = !0, i = !1, s) {
    if (e.length === 0)
      return null;
    s = s ?? e[0].weight;
    let r = Number.MAX_VALUE, n = Number.MIN_VALUE;
    if (i)
      for (const o of e)
        o.from < r && (r = o.from), o.to > n && (n = o.to);
    const a = new Ds(e[0].name + "_merged", e[0]._scene, s);
    for (const o of e) {
      i && o.normalize(r, n);
      for (const l of o.targetedAnimations)
        a.addTargetedAnimation(l.animation, l.target);
      t && o.dispose();
    }
    return a;
  }
  /**
   * Instantiates a new Animation Group.
   * This helps managing several animations at once.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/groupAnimations
   * @param name Defines the name of the group
   * @param scene Defines the scene the group belongs to
   * @param weight Defines the weight to use for animations in the group (-1.0 by default, meaning "no weight")
   * @param playOrder Defines the order of play of the animation group (default is 0)
   */
  constructor(e, t = null, i = -1, s = 0) {
    this.name = e, this._targetedAnimations = new Array(), this._animatables = new Array(), this._from = Number.MAX_VALUE, this._to = -Number.MAX_VALUE, this._speedRatio = 1, this._loopAnimation = !1, this._isAdditive = !1, this._weight = -1, this._playOrder = 0, this._parentContainer = null, this.onAnimationEndObservable = new N(), this.onAnimationLoopObservable = new N(), this.onAnimationGroupLoopObservable = new N(), this.onAnimationGroupEndObservable = new N(), this.onAnimationGroupPauseObservable = new N(), this.onAnimationGroupPlayObservable = new N(), this.metadata = null, this._animationLoopFlags = [], this._scene = t || de.LastCreatedScene, this._weight = i, this._playOrder = s, this.uniqueId = this._scene.getUniqueId(), this._scene.addAnimationGroup(this);
  }
  /**
   * Add an animation (with its target) in the group
   * @param animation defines the animation we want to add
   * @param target defines the target of the animation
   * @returns the TargetedAnimation object
   */
  addTargetedAnimation(e, t) {
    const i = new gh();
    i.animation = e, i.target = t;
    const s = e.getKeys();
    return this._from > s[0].frame && (this._from = s[0].frame), this._to < s[s.length - 1].frame && (this._to = s[s.length - 1].frame), this._targetedAnimations.push(i), i;
  }
  /**
   * Remove an animation from the group
   * @param animation defines the animation we want to remove
   */
  removeTargetedAnimation(e) {
    for (let t = this._targetedAnimations.length - 1; t > -1; t--)
      this._targetedAnimations[t].animation === e && this._targetedAnimations.splice(t, 1);
  }
  /**
   * This function will normalize every animation in the group to make sure they all go from beginFrame to endFrame
   * It can add constant keys at begin or end
   * @param beginFrame defines the new begin frame for all animations or the smallest begin frame of all animations if null (defaults to null)
   * @param endFrame defines the new end frame for all animations or the largest end frame of all animations if null (defaults to null)
   * @returns the animation group
   */
  normalize(e = null, t = null) {
    e == null && (e = this._from), t == null && (t = this._to);
    for (let i = 0; i < this._targetedAnimations.length; i++) {
      const r = this._targetedAnimations[i].animation.getKeys(), n = r[0], a = r[r.length - 1];
      if (n.frame > e) {
        const o = {
          frame: e,
          value: n.value,
          inTangent: n.inTangent,
          outTangent: n.outTangent,
          interpolation: n.interpolation
        };
        r.splice(0, 0, o);
      }
      if (a.frame < t) {
        const o = {
          frame: t,
          value: a.value,
          inTangent: a.inTangent,
          outTangent: a.outTangent,
          interpolation: a.interpolation
        };
        r.push(o);
      }
    }
    return this._from = e, this._to = t, this;
  }
  _processLoop(e, t, i) {
    e.onAnimationLoop = () => {
      this.onAnimationLoopObservable.notifyObservers(t), !this._animationLoopFlags[i] && (this._animationLoopFlags[i] = !0, this._animationLoopCount++, this._animationLoopCount === this._targetedAnimations.length && (this.onAnimationGroupLoopObservable.notifyObservers(this), this._animationLoopCount = 0, this._animationLoopFlags.length = 0));
    };
  }
  /**
   * Start all animations on given targets
   * @param loop defines if animations must loop
   * @param speedRatio defines the ratio to apply to animation speed (1 by default)
   * @param from defines the from key (optional)
   * @param to defines the to key (optional)
   * @param isAdditive defines the additive state for the resulting animatables (optional)
   * @returns the current animation group
   */
  start(e = !1, t = 1, i, s, r) {
    if (this._isStarted || this._targetedAnimations.length === 0)
      return this;
    this._loopAnimation = e, this._animationLoopCount = 0, this._animationLoopFlags.length = 0;
    for (let n = 0; n < this._targetedAnimations.length; n++) {
      const a = this._targetedAnimations[n], o = this._scene.beginDirectAnimation(a.target, [a.animation], i !== void 0 ? i : this._from, s !== void 0 ? s : this._to, e, t, void 0, void 0, r !== void 0 ? r : this._isAdditive);
      o.weight = this._weight, o.playOrder = this._playOrder, o.onAnimationEnd = () => {
        this.onAnimationEndObservable.notifyObservers(a), this._checkAnimationGroupEnded(o);
      }, this._processLoop(o, a, n), this._animatables.push(o);
    }
    return this.syncWithMask(), this._scene.sortActiveAnimatables(), this._speedRatio = t, this._isStarted = !0, this._isPaused = !1, this.onAnimationGroupPlayObservable.notifyObservers(this), this;
  }
  /**
   * Pause all animations
   * @returns the animation group
   */
  pause() {
    if (!this._isStarted)
      return this;
    this._isPaused = !0;
    for (let e = 0; e < this._animatables.length; e++)
      this._animatables[e].pause();
    return this.onAnimationGroupPauseObservable.notifyObservers(this), this;
  }
  /**
   * Play all animations to initial state
   * This function will start() the animations if they were not started or will restart() them if they were paused
   * @param loop defines if animations must loop
   * @returns the animation group
   */
  play(e) {
    return this.isStarted && this._animatables.length === this._targetedAnimations.length ? (e !== void 0 && (this.loopAnimation = e), this.restart()) : (this.stop(), this.start(e, this._speedRatio)), this._isPaused = !1, this;
  }
  /**
   * Reset all animations to initial state
   * @returns the animation group
   */
  reset() {
    if (!this._isStarted)
      return this.play(), this.goToFrame(0), this.stop(), this;
    for (let e = 0; e < this._animatables.length; e++)
      this._animatables[e].reset();
    return this;
  }
  /**
   * Restart animations from key 0
   * @returns the animation group
   */
  restart() {
    if (!this._isStarted)
      return this;
    for (let e = 0; e < this._animatables.length; e++)
      this._animatables[e].restart();
    return this.onAnimationGroupPlayObservable.notifyObservers(this), this;
  }
  /**
   * Stop all animations
   * @returns the animation group
   */
  stop() {
    if (!this._isStarted)
      return this;
    const e = this._animatables.slice();
    for (let i = 0; i < e.length; i++)
      e[i].stop(void 0, void 0, !0);
    let t = 0;
    for (let i = 0; i < this._scene._activeAnimatables.length; i++) {
      const s = this._scene._activeAnimatables[i];
      s._runtimeAnimations.length > 0 && (this._scene._activeAnimatables[t++] = s);
    }
    return this._scene._activeAnimatables.length = t, this._isStarted = !1, this;
  }
  /**
   * Set animation weight for all animatables
   *
   * @since 6.12.4
   *  You can pass the weight to the AnimationGroup constructor, or use the weight property to set it after the group has been created,
   *  making it easier to define the overall animation weight than calling setWeightForAllAnimatables() after the animation group has been started
   * @param weight defines the weight to use
   * @returns the animationGroup
   * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#animation-weights
   */
  setWeightForAllAnimatables(e) {
    for (let t = 0; t < this._animatables.length; t++) {
      const i = this._animatables[t];
      i.weight = e;
    }
    return this;
  }
  /**
   * Synchronize and normalize all animatables with a source animatable
   * @param root defines the root animatable to synchronize with (null to stop synchronizing)
   * @returns the animationGroup
   * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#animation-weights
   */
  syncAllAnimationsWith(e) {
    for (let t = 0; t < this._animatables.length; t++)
      this._animatables[t].syncWith(e);
    return this;
  }
  /**
   * Goes to a specific frame in this animation group
   * @param frame the frame number to go to
   * @returns the animationGroup
   */
  goToFrame(e) {
    if (!this._isStarted)
      return this;
    for (let t = 0; t < this._animatables.length; t++)
      this._animatables[t].goToFrame(e);
    return this;
  }
  /**
   * Dispose all associated resources
   */
  dispose() {
    this._targetedAnimations.length = 0, this._animatables.length = 0;
    const e = this._scene.animationGroups.indexOf(this);
    if (e > -1 && this._scene.animationGroups.splice(e, 1), this._parentContainer) {
      const t = this._parentContainer.animationGroups.indexOf(this);
      t > -1 && this._parentContainer.animationGroups.splice(t, 1), this._parentContainer = null;
    }
    this.onAnimationEndObservable.clear(), this.onAnimationGroupEndObservable.clear(), this.onAnimationGroupPauseObservable.clear(), this.onAnimationGroupPlayObservable.clear(), this.onAnimationLoopObservable.clear(), this.onAnimationGroupLoopObservable.clear();
  }
  _checkAnimationGroupEnded(e) {
    const t = this._animatables.indexOf(e);
    t > -1 && this._animatables.splice(t, 1), this._animatables.length === 0 && (this._isStarted = !1, this.onAnimationGroupEndObservable.notifyObservers(this));
  }
  /**
   * Clone the current animation group and returns a copy
   * @param newName defines the name of the new group
   * @param targetConverter defines an optional function used to convert current animation targets to new ones
   * @param cloneAnimations defines if the animations should be cloned or referenced
   * @returns the new animation group
   */
  clone(e, t, i = !1) {
    const s = new Ds(e || this.name, this._scene);
    for (const r of this._targetedAnimations)
      s.addTargetedAnimation(i ? r.animation.clone() : r.animation, t ? t(r.target) : r.target);
    return s;
  }
  /**
   * Serializes the animationGroup to an object
   * @returns Serialized object
   */
  serialize() {
    const e = {};
    e.name = this.name, e.from = this.from, e.to = this.to, e.targetedAnimations = [];
    for (let t = 0; t < this.targetedAnimations.length; t++) {
      const i = this.targetedAnimations[t];
      e.targetedAnimations[t] = i.serialize();
    }
    return Ee && Ee.HasTags(this) && (e.tags = Ee.GetTags(this)), this.metadata && (e.metadata = this.metadata), e;
  }
  // Statics
  /**
   * Returns a new AnimationGroup object parsed from the source provided.
   * @param parsedAnimationGroup defines the source
   * @param scene defines the scene that will receive the animationGroup
   * @returns a new AnimationGroup
   */
  static Parse(e, t) {
    const i = new Ds(e.name, t);
    for (let s = 0; s < e.targetedAnimations.length; s++) {
      const r = e.targetedAnimations[s], n = B.Parse(r.animation), a = r.targetId;
      if (r.animation.property === "influence") {
        const o = t.getMorphTargetById(a);
        o && i.addTargetedAnimation(n, o);
      } else {
        const o = t.getNodeById(a);
        o != null && i.addTargetedAnimation(n, o);
      }
    }
    return e.from !== null && e.to !== null && i.normalize(e.from, e.to), Ee && Ee.AddTagsTo(i, e.tags), e.metadata !== void 0 && (i.metadata = e.metadata), i;
  }
  /**
   * Convert the keyframes for all animations belonging to the group to be relative to a given reference frame.
   * @param sourceAnimationGroup defines the AnimationGroup containing animations to convert
   * @param referenceFrame defines the frame that keyframes in the range will be relative to
   * @param range defines the name of the AnimationRange belonging to the animations in the group to convert
   * @param cloneOriginal defines whether or not to clone the group and convert the clone or convert the original group (default is false)
   * @param clonedName defines the name of the resulting cloned AnimationGroup if cloneOriginal is true
   * @returns a new AnimationGroup if cloneOriginal is true or the original AnimationGroup if cloneOriginal is false
   */
  static MakeAnimationAdditive(e, t = 0, i, s = !1, r) {
    let n = e;
    s && (n = e.clone(r || n.name));
    const a = n.targetedAnimations;
    for (let o = 0; o < a.length; o++) {
      const l = a[o];
      B.MakeAnimationAdditive(l.animation, t, i);
    }
    return n.isAdditive = !0, n;
  }
  /**
   * Returns the string "AnimationGroup"
   * @returns "AnimationGroup"
   */
  getClassName() {
    return "AnimationGroup";
  }
  /**
   * Creates a detailed string about the object
   * @param fullDetails defines if the output string will support multiple levels of logging within scene loading
   * @returns a string representing the object
   */
  toString(e) {
    let t = "Name: " + this.name;
    return t += ", type: " + this.getClassName(), e && (t += ", from: " + this._from, t += ", to: " + this._to, t += ", isStarted: " + this._isStarted, t += ", speedRatio: " + this._speedRatio, t += ", targetedAnimations length: " + this._targetedAnimations.length, t += ", animatables length: " + this._animatables), t;
  }
}
class me extends ut {
  /**
   * Defines how far from the source the light is impacting in scene units.
   * Note: Unused in PBR material as the distance light falloff is defined following the inverse squared falloff.
   */
  get range() {
    return this._range;
  }
  /**
   * Defines how far from the source the light is impacting in scene units.
   * Note: Unused in PBR material as the distance light falloff is defined following the inverse squared falloff.
   */
  set range(e) {
    this._range = e, this._inverseSquaredRange = 1 / (this.range * this.range);
  }
  /**
   * Gets the photometric scale used to interpret the intensity.
   * This is only relevant with PBR Materials where the light intensity can be defined in a physical way.
   */
  get intensityMode() {
    return this._intensityMode;
  }
  /**
   * Sets the photometric scale used to interpret the intensity.
   * This is only relevant with PBR Materials where the light intensity can be defined in a physical way.
   */
  set intensityMode(e) {
    this._intensityMode = e, this._computePhotometricScale();
  }
  /**
   * Gets the light radius used by PBR Materials to simulate soft area lights.
   */
  get radius() {
    return this._radius;
  }
  /**
   * sets the light radius used by PBR Materials to simulate soft area lights.
   */
  set radius(e) {
    this._radius = e, this._computePhotometricScale();
  }
  /**
   * Gets whether or not the shadows are enabled for this light. This can help turning off/on shadow without detaching
   * the current shadow generator.
   */
  get shadowEnabled() {
    return this._shadowEnabled;
  }
  /**
   * Sets whether or not the shadows are enabled for this light. This can help turning off/on shadow without detaching
   * the current shadow generator.
   */
  set shadowEnabled(e) {
    this._shadowEnabled !== e && (this._shadowEnabled = e, this._markMeshesAsLightDirty());
  }
  /**
   * Gets the only meshes impacted by this light.
   */
  get includedOnlyMeshes() {
    return this._includedOnlyMeshes;
  }
  /**
   * Sets the only meshes impacted by this light.
   */
  set includedOnlyMeshes(e) {
    this._includedOnlyMeshes = e, this._hookArrayForIncludedOnly(e);
  }
  /**
   * Gets the meshes not impacted by this light.
   */
  get excludedMeshes() {
    return this._excludedMeshes;
  }
  /**
   * Sets the meshes not impacted by this light.
   */
  set excludedMeshes(e) {
    this._excludedMeshes = e, this._hookArrayForExcluded(e);
  }
  /**
   * Gets the layer id use to find what meshes are not impacted by the light.
   * Inactive if 0
   */
  get excludeWithLayerMask() {
    return this._excludeWithLayerMask;
  }
  /**
   * Sets the layer id use to find what meshes are not impacted by the light.
   * Inactive if 0
   */
  set excludeWithLayerMask(e) {
    this._excludeWithLayerMask = e, this._resyncMeshes();
  }
  /**
   * Gets the layer id use to find what meshes are impacted by the light.
   * Inactive if 0
   */
  get includeOnlyWithLayerMask() {
    return this._includeOnlyWithLayerMask;
  }
  /**
   * Sets the layer id use to find what meshes are impacted by the light.
   * Inactive if 0
   */
  set includeOnlyWithLayerMask(e) {
    this._includeOnlyWithLayerMask = e, this._resyncMeshes();
  }
  /**
   * Gets the lightmap mode of this light (should be one of the constants defined by Light.LIGHTMAP_x)
   */
  get lightmapMode() {
    return this._lightmapMode;
  }
  /**
   * Sets the lightmap mode of this light (should be one of the constants defined by Light.LIGHTMAP_x)
   */
  set lightmapMode(e) {
    this._lightmapMode !== e && (this._lightmapMode = e, this._markMeshesAsLightDirty());
  }
  /**
   * Creates a Light object in the scene.
   * Documentation : https://doc.babylonjs.com/features/featuresDeepDive/lights/lights_introduction
   * @param name The friendly name of the light
   * @param scene The scene the light belongs too
   */
  constructor(e, t) {
    super(e, t), this.diffuse = new ie(1, 1, 1), this.specular = new ie(1, 1, 1), this.falloffType = me.FALLOFF_DEFAULT, this.intensity = 1, this._range = Number.MAX_VALUE, this._inverseSquaredRange = 0, this._photometricScale = 1, this._intensityMode = me.INTENSITYMODE_AUTOMATIC, this._radius = 1e-5, this.renderPriority = 0, this._shadowEnabled = !0, this._excludeWithLayerMask = 0, this._includeOnlyWithLayerMask = 0, this._lightmapMode = 0, this._shadowGenerators = null, this._excludedMeshesIds = new Array(), this._includedOnlyMeshesIds = new Array(), this._isLight = !0, this.getScene().addLight(this), this._uniformBuffer = new H(this.getScene().getEngine(), void 0, void 0, e), this._buildUniformLayout(), this.includedOnlyMeshes = new Array(), this.excludedMeshes = new Array(), this._resyncMeshes();
  }
  /**
   * Sets the passed Effect "effect" with the Light textures.
   * @param effect The effect to update
   * @param lightIndex The index of the light in the effect to update
   * @returns The light
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  transferTexturesToEffect(e, t) {
    return this;
  }
  /**
   * Binds the lights information from the scene to the effect for the given mesh.
   * @param lightIndex Light index
   * @param scene The scene where the light belongs to
   * @param effect The effect we are binding the data to
   * @param useSpecular Defines if specular is supported
   * @param receiveShadows Defines if the effect (mesh) we bind the light for receives shadows
   */
  _bindLight(e, t, i, s, r = !0) {
    var n;
    const a = e.toString();
    let o = !1;
    if (this._uniformBuffer.bindToEffect(i, "Light" + a), this._renderId !== t.getRenderId() || this._lastUseSpecular !== s || !this._uniformBuffer.useUbo) {
      this._renderId = t.getRenderId(), this._lastUseSpecular = s;
      const l = this.getScaledIntensity();
      this.transferToEffect(i, a), this.diffuse.scaleToRef(l, ns.Color3[0]), this._uniformBuffer.updateColor4("vLightDiffuse", ns.Color3[0], this.range, a), s && (this.specular.scaleToRef(l, ns.Color3[1]), this._uniformBuffer.updateColor4("vLightSpecular", ns.Color3[1], this.radius, a)), o = !0;
    }
    if (this.transferTexturesToEffect(i, a), t.shadowsEnabled && this.shadowEnabled && r) {
      const l = (n = this.getShadowGenerator(t.activeCamera)) !== null && n !== void 0 ? n : this.getShadowGenerator();
      l && (l.bindShadowLight(a, i), o = !0);
    }
    o ? this._uniformBuffer.update() : this._uniformBuffer.bindUniformBuffer();
  }
  /**
   * Returns the string "Light".
   * @returns the class name
   */
  getClassName() {
    return "Light";
  }
  /**
   * Converts the light information to a readable string for debug purpose.
   * @param fullDetails Supports for multiple levels of logging within scene loading
   * @returns the human readable light info
   */
  toString(e) {
    let t = "Name: " + this.name;
    if (t += ", type: " + ["Point", "Directional", "Spot", "Hemispheric"][this.getTypeID()], this.animations)
      for (let i = 0; i < this.animations.length; i++)
        t += ", animation[0]: " + this.animations[i].toString(e);
    return t;
  }
  /** @internal */
  _syncParentEnabledState() {
    super._syncParentEnabledState(), this.isDisposed() || this._resyncMeshes();
  }
  /**
   * Set the enabled state of this node.
   * @param value - the new enabled state
   */
  setEnabled(e) {
    super.setEnabled(e), this._resyncMeshes();
  }
  /**
   * Returns the Light associated shadow generator if any.
   * @param camera Camera for which the shadow generator should be retrieved (default: null). If null, retrieves the default shadow generator
   * @returns the associated shadow generator.
   */
  getShadowGenerator(e = null) {
    var t;
    return this._shadowGenerators === null ? null : (t = this._shadowGenerators.get(e)) !== null && t !== void 0 ? t : null;
  }
  /**
   * Returns all the shadow generators associated to this light
   * @returns
   */
  getShadowGenerators() {
    return this._shadowGenerators;
  }
  /**
   * Returns a Vector3, the absolute light position in the World.
   * @returns the world space position of the light
   */
  getAbsolutePosition() {
    return p.Zero();
  }
  /**
   * Specifies if the light will affect the passed mesh.
   * @param mesh The mesh to test against the light
   * @returns true the mesh is affected otherwise, false.
   */
  canAffectMesh(e) {
    return e ? !(this.includedOnlyMeshes && this.includedOnlyMeshes.length > 0 && this.includedOnlyMeshes.indexOf(e) === -1 || this.excludedMeshes && this.excludedMeshes.length > 0 && this.excludedMeshes.indexOf(e) !== -1 || this.includeOnlyWithLayerMask !== 0 && !(this.includeOnlyWithLayerMask & e.layerMask) || this.excludeWithLayerMask !== 0 && this.excludeWithLayerMask & e.layerMask) : !0;
  }
  /**
   * Releases resources associated with this node.
   * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
   * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
   */
  dispose(e, t = !1) {
    if (this._shadowGenerators) {
      const i = this._shadowGenerators.values();
      for (let s = i.next(); s.done !== !0; s = i.next())
        s.value.dispose();
      this._shadowGenerators = null;
    }
    if (this.getScene().stopAnimation(this), this._parentContainer) {
      const i = this._parentContainer.lights.indexOf(this);
      i > -1 && this._parentContainer.lights.splice(i, 1), this._parentContainer = null;
    }
    for (const i of this.getScene().meshes)
      i._removeLightSource(this, !0);
    this._uniformBuffer.dispose(), this.getScene().removeLight(this), super.dispose(e, t);
  }
  /**
   * Returns the light type ID (integer).
   * @returns The light Type id as a constant defines in Light.LIGHTTYPEID_x
   */
  getTypeID() {
    return 0;
  }
  /**
   * Returns the intensity scaled by the Photometric Scale according to the light type and intensity mode.
   * @returns the scaled intensity in intensity mode unit
   */
  getScaledIntensity() {
    return this._photometricScale * this.intensity;
  }
  /**
   * Returns a new Light object, named "name", from the current one.
   * @param name The name of the cloned light
   * @param newParent The parent of this light, if it has one
   * @returns the new created light
   */
  clone(e, t = null) {
    const i = me.GetConstructorFromName(this.getTypeID(), e, this.getScene());
    if (!i)
      return null;
    const s = le.Clone(i, this);
    return e && (s.name = e), t && (s.parent = t), s.setEnabled(this.isEnabled()), this.onClonedObservable.notifyObservers(s), s;
  }
  /**
   * Serializes the current light into a Serialization object.
   * @returns the serialized object.
   */
  serialize() {
    const e = le.Serialize(this);
    return e.uniqueId = this.uniqueId, e.type = this.getTypeID(), this.parent && this.parent._serializeAsParent(e), this.excludedMeshes.length > 0 && (e.excludedMeshesIds = [], this.excludedMeshes.forEach((t) => {
      e.excludedMeshesIds.push(t.id);
    })), this.includedOnlyMeshes.length > 0 && (e.includedOnlyMeshesIds = [], this.includedOnlyMeshes.forEach((t) => {
      e.includedOnlyMeshesIds.push(t.id);
    })), le.AppendSerializedAnimations(this, e), e.ranges = this.serializeAnimationRanges(), e.isEnabled = this.isEnabled(), e;
  }
  /**
   * Creates a new typed light from the passed type (integer) : point light = 0, directional light = 1, spot light = 2, hemispheric light = 3.
   * This new light is named "name" and added to the passed scene.
   * @param type Type according to the types available in Light.LIGHTTYPEID_x
   * @param name The friendly name of the light
   * @param scene The scene the new light will belong to
   * @returns the constructor function
   */
  static GetConstructorFromName(e, t, i) {
    const s = ut.Construct("Light_Type_" + e, t, i);
    return s || null;
  }
  /**
   * Parses the passed "parsedLight" and returns a new instanced Light from this parsing.
   * @param parsedLight The JSON representation of the light
   * @param scene The scene to create the parsed light in
   * @returns the created light after parsing
   */
  static Parse(e, t) {
    const i = me.GetConstructorFromName(e.type, e.name, t);
    if (!i)
      return null;
    const s = le.Parse(i, e, t);
    if (e.excludedMeshesIds && (s._excludedMeshesIds = e.excludedMeshesIds), e.includedOnlyMeshesIds && (s._includedOnlyMeshesIds = e.includedOnlyMeshesIds), e.parentId !== void 0 && (s._waitingParentId = e.parentId), e.parentInstanceIndex !== void 0 && (s._waitingParentInstanceIndex = e.parentInstanceIndex), e.falloffType !== void 0 && (s.falloffType = e.falloffType), e.lightmapMode !== void 0 && (s.lightmapMode = e.lightmapMode), e.animations) {
      for (let r = 0; r < e.animations.length; r++) {
        const n = e.animations[r], a = si("BABYLON.Animation");
        a && s.animations.push(a.Parse(n));
      }
      ut.ParseAnimationRanges(s, e, t);
    }
    return e.autoAnimate && t.beginAnimation(s, e.autoAnimateFrom, e.autoAnimateTo, e.autoAnimateLoop, e.autoAnimateSpeed || 1), e.isEnabled !== void 0 && s.setEnabled(e.isEnabled), s;
  }
  _hookArrayForExcluded(e) {
    const t = e.push;
    e.push = (...s) => {
      const r = t.apply(e, s);
      for (const n of s)
        n._resyncLightSource(this);
      return r;
    };
    const i = e.splice;
    e.splice = (s, r) => {
      const n = i.apply(e, [s, r]);
      for (const a of n)
        a._resyncLightSource(this);
      return n;
    };
    for (const s of e)
      s._resyncLightSource(this);
  }
  _hookArrayForIncludedOnly(e) {
    const t = e.push;
    e.push = (...s) => {
      const r = t.apply(e, s);
      return this._resyncMeshes(), r;
    };
    const i = e.splice;
    e.splice = (s, r) => {
      const n = i.apply(e, [s, r]);
      return this._resyncMeshes(), n;
    }, this._resyncMeshes();
  }
  _resyncMeshes() {
    for (const e of this.getScene().meshes)
      e._resyncLightSource(this);
  }
  /**
   * Forces the meshes to update their light related information in their rendering used effects
   * @internal Internal Use Only
   */
  _markMeshesAsLightDirty() {
    for (const e of this.getScene().meshes)
      e.lightSources.indexOf(this) !== -1 && e._markSubMeshesAsLightDirty();
  }
  /**
   * Recomputes the cached photometric scale if needed.
   */
  _computePhotometricScale() {
    this._photometricScale = this._getPhotometricScale(), this.getScene().resetCachedMaterial();
  }
  /**
   * Returns the Photometric Scale according to the light type and intensity mode.
   */
  _getPhotometricScale() {
    let e = 0;
    const t = this.getTypeID();
    let i = this.intensityMode;
    switch (i === me.INTENSITYMODE_AUTOMATIC && (t === me.LIGHTTYPEID_DIRECTIONALLIGHT ? i = me.INTENSITYMODE_ILLUMINANCE : i = me.INTENSITYMODE_LUMINOUSINTENSITY), t) {
      case me.LIGHTTYPEID_POINTLIGHT:
      case me.LIGHTTYPEID_SPOTLIGHT:
        switch (i) {
          case me.INTENSITYMODE_LUMINOUSPOWER:
            e = 1 / (4 * Math.PI);
            break;
          case me.INTENSITYMODE_LUMINOUSINTENSITY:
            e = 1;
            break;
          case me.INTENSITYMODE_LUMINANCE:
            e = this.radius * this.radius;
            break;
        }
        break;
      case me.LIGHTTYPEID_DIRECTIONALLIGHT:
        switch (i) {
          case me.INTENSITYMODE_ILLUMINANCE:
            e = 1;
            break;
          case me.INTENSITYMODE_LUMINANCE: {
            let s = this.radius;
            s = Math.max(s, 1e-3), e = 2 * Math.PI * (1 - Math.cos(s));
            break;
          }
        }
        break;
      case me.LIGHTTYPEID_HEMISPHERICLIGHT:
        e = 1;
        break;
    }
    return e;
  }
  /**
   * Reorder the light in the scene according to their defined priority.
   * @internal Internal Use Only
   */
  _reorderLightsInScene() {
    const e = this.getScene();
    this._renderPriority != 0 && (e.requireLightSorting = !0), this.getScene().sortLightsByPriority();
  }
}
me.FALLOFF_DEFAULT = we.FALLOFF_DEFAULT;
me.FALLOFF_PHYSICAL = we.FALLOFF_PHYSICAL;
me.FALLOFF_GLTF = we.FALLOFF_GLTF;
me.FALLOFF_STANDARD = we.FALLOFF_STANDARD;
me.LIGHTMAP_DEFAULT = we.LIGHTMAP_DEFAULT;
me.LIGHTMAP_SPECULAR = we.LIGHTMAP_SPECULAR;
me.LIGHTMAP_SHADOWSONLY = we.LIGHTMAP_SHADOWSONLY;
me.INTENSITYMODE_AUTOMATIC = we.INTENSITYMODE_AUTOMATIC;
me.INTENSITYMODE_LUMINOUSPOWER = we.INTENSITYMODE_LUMINOUSPOWER;
me.INTENSITYMODE_LUMINOUSINTENSITY = we.INTENSITYMODE_LUMINOUSINTENSITY;
me.INTENSITYMODE_ILLUMINANCE = we.INTENSITYMODE_ILLUMINANCE;
me.INTENSITYMODE_LUMINANCE = we.INTENSITYMODE_LUMINANCE;
me.LIGHTTYPEID_POINTLIGHT = we.LIGHTTYPEID_POINTLIGHT;
me.LIGHTTYPEID_DIRECTIONALLIGHT = we.LIGHTTYPEID_DIRECTIONALLIGHT;
me.LIGHTTYPEID_SPOTLIGHT = we.LIGHTTYPEID_SPOTLIGHT;
me.LIGHTTYPEID_HEMISPHERICLIGHT = we.LIGHTTYPEID_HEMISPHERICLIGHT;
E([
  Ji()
], me.prototype, "diffuse", void 0);
E([
  Ji()
], me.prototype, "specular", void 0);
E([
  R()
], me.prototype, "falloffType", void 0);
E([
  R()
], me.prototype, "intensity", void 0);
E([
  R()
], me.prototype, "range", null);
E([
  R()
], me.prototype, "intensityMode", null);
E([
  R()
], me.prototype, "radius", null);
E([
  R()
], me.prototype, "_renderPriority", void 0);
E([
  Le("_reorderLightsInScene")
], me.prototype, "renderPriority", void 0);
E([
  R("shadowEnabled")
], me.prototype, "_shadowEnabled", void 0);
E([
  R("excludeWithLayerMask")
], me.prototype, "_excludeWithLayerMask", void 0);
E([
  R("includeOnlyWithLayerMask")
], me.prototype, "_includeOnlyWithLayerMask", void 0);
E([
  R("lightmapMode")
], me.prototype, "_lightmapMode", void 0);
var wi;
(function(h) {
  h[h.Clean = 0] = "Clean", h[h.Stop = 1] = "Stop", h[h.Sync = 2] = "Sync", h[h.NoSync = 3] = "NoSync";
})(wi || (wi = {}));
class fe {
  /**
   * Gets or sets a boolean indicating if entire scene must be loaded even if scene contains incremental data
   */
  static get ForceFullSceneLoadingForIncremental() {
    return st.ForceFullSceneLoadingForIncremental;
  }
  static set ForceFullSceneLoadingForIncremental(e) {
    st.ForceFullSceneLoadingForIncremental = e;
  }
  /**
   * Gets or sets a boolean indicating if loading screen must be displayed while loading a scene
   */
  static get ShowLoadingScreen() {
    return st.ShowLoadingScreen;
  }
  static set ShowLoadingScreen(e) {
    st.ShowLoadingScreen = e;
  }
  /**
   * Defines the current logging level (while loading the scene)
   * @ignorenaming
   */
  // eslint-disable-next-line @typescript-eslint/naming-convention
  static get loggingLevel() {
    return st.loggingLevel;
  }
  // eslint-disable-next-line @typescript-eslint/naming-convention
  static set loggingLevel(e) {
    st.loggingLevel = e;
  }
  /**
   * Gets or set a boolean indicating if matrix weights must be cleaned upon loading
   */
  static get CleanBoneMatrixWeights() {
    return st.CleanBoneMatrixWeights;
  }
  static set CleanBoneMatrixWeights(e) {
    st.CleanBoneMatrixWeights = e;
  }
  /**
   * Gets the default plugin (used to load Babylon files)
   * @returns the .babylon plugin
   */
  static GetDefaultPlugin() {
    return fe._RegisteredPlugins[".babylon"];
  }
  static _GetPluginForExtension(e) {
    const t = fe._RegisteredPlugins[e];
    return t || (w.Warn("Unable to find a plugin to load " + e + " files. Trying to use .babylon default plugin. To load from a specific filetype (eg. gltf) see: https://doc.babylonjs.com/features/featuresDeepDive/importers/loadingFileTypes"), fe.GetDefaultPlugin());
  }
  static _GetPluginForDirectLoad(e) {
    for (const t in fe._RegisteredPlugins) {
      const i = fe._RegisteredPlugins[t].plugin;
      if (i.canDirectLoad && i.canDirectLoad(e))
        return fe._RegisteredPlugins[t];
    }
    return fe.GetDefaultPlugin();
  }
  static _GetPluginForFilename(e) {
    const t = e.indexOf("?");
    t !== -1 && (e = e.substring(0, t));
    const i = e.lastIndexOf("."), s = e.substring(i, e.length).toLowerCase();
    return fe._GetPluginForExtension(s);
  }
  static _GetDirectLoad(e) {
    return e.substr(0, 5) === "data:" ? e.substr(5) : null;
  }
  static _FormatErrorMessage(e, t, i) {
    let r = "Unable to load from " + (e.rawData ? "binary data" : e.url);
    return t ? r += `: ${t}` : i && (r += `: ${i}`), r;
  }
  static _LoadData(e, t, i, s, r, n, a, o) {
    const l = fe._GetDirectLoad(e.url);
    if (e.rawData && !a)
      throw "When using ArrayBufferView to load data the file extension must be provided.";
    const c = a ? fe._GetPluginForExtension(a) : l ? fe._GetPluginForDirectLoad(e.url) : fe._GetPluginForFilename(e.url);
    if (e.rawData && !c.isBinary)
      throw "Loading from ArrayBufferView can not be used with plugins that don't support binary loading.";
    let u;
    if (c.plugin.createPlugin !== void 0 ? u = c.plugin.createPlugin() : u = c.plugin, !u)
      throw "The loader plugin corresponding to the file type you are trying to load has not been found. If using es6, please import the plugin you wish to use before.";
    if (fe.OnPluginActivatedObservable.notifyObservers(u), l && (u.canDirectLoad && u.canDirectLoad(e.url) || !Cn(e.url))) {
      if (u.directLoad) {
        const T = u.directLoad(t, l);
        T.then ? T.then((M) => {
          i(u, M);
        }).catch((M) => {
          r("Error in directLoad of _loadData: " + M, M);
        }) : i(u, T);
      } else
        i(u, l);
      return u;
    }
    const d = c.isBinary, f = (T, M) => {
      if (t.isDisposed) {
        r("Scene has been disposed");
        return;
      }
      i(u, T, M);
    };
    let _ = null, g = !1;
    const m = u.onDisposeObservable;
    m && m.add(() => {
      g = !0, _ && (_.abort(), _ = null), n();
    });
    const y = () => {
      if (g)
        return;
      const T = (M, b) => {
        r(M == null ? void 0 : M.statusText, b);
      };
      if (!u.loadFile && e.rawData)
        throw "Plugin does not support loading ArrayBufferView.";
      _ = u.loadFile ? u.loadFile(t, e.rawData || e.file || e.url, e.rootUrl, f, s, d, T, o) : t._loadFile(e.file || e.url, f, s, !0, d, T);
    }, x = t.getEngine();
    let A = x.enableOfflineSupport;
    if (A) {
      let T = !1;
      for (const M of t.disableOfflineSupportExceptionRules)
        if (M.test(e.url)) {
          T = !0;
          break;
        }
      A = !T;
    }
    return A && L.OfflineProviderFactory ? t.offlineProvider = L.OfflineProviderFactory(e.url, y, x.disableManifestCheck) : y(), u;
  }
  static _GetFileInfo(e, t) {
    let i, s, r = null, n = null;
    if (!t)
      i = e, s = z.GetFilename(e), e = z.GetFolderPath(e);
    else if (t.name) {
      const a = t;
      i = `file:${a.name}`, s = a.name, r = a;
    } else if (ArrayBuffer.isView(t))
      i = "", s = "arrayBuffer", n = t;
    else if (typeof t == "string" && t.startsWith("data:"))
      i = t, s = "";
    else {
      const a = t;
      if (a.substr(0, 1) === "/")
        return z.Error("Wrong sceneFilename parameter"), null;
      i = e + a, s = a;
    }
    return {
      url: i,
      rootUrl: e,
      name: s,
      file: r,
      rawData: n
    };
  }
  // Public functions
  /**
   * Gets a plugin that can load the given extension
   * @param extension defines the extension to load
   * @returns a plugin or null if none works
   */
  static GetPluginForExtension(e) {
    return fe._GetPluginForExtension(e).plugin;
  }
  /**
   * Gets a boolean indicating that the given extension can be loaded
   * @param extension defines the extension to load
   * @returns true if the extension is supported
   */
  static IsPluginForExtensionAvailable(e) {
    return !!fe._RegisteredPlugins[e];
  }
  /**
   * Adds a new plugin to the list of registered plugins
   * @param plugin defines the plugin to add
   */
  static RegisterPlugin(e) {
    if (typeof e.extensions == "string") {
      const t = e.extensions;
      fe._RegisteredPlugins[t.toLowerCase()] = {
        plugin: e,
        isBinary: !1
      };
    } else {
      const t = e.extensions;
      Object.keys(t).forEach((i) => {
        fe._RegisteredPlugins[i.toLowerCase()] = {
          plugin: e,
          isBinary: t[i].isBinary
        };
      });
    }
  }
  /**
   * Import meshes into a scene
   * @param meshNames an array of mesh names, a single mesh name, or empty string for all meshes that filter what meshes are imported
   * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
   * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene or a File object (default: empty string)
   * @param scene the instance of BABYLON.Scene to append to
   * @param onSuccess a callback with a list of imported meshes, particleSystems, skeletons, and animationGroups when import succeeds
   * @param onProgress a callback with a progress event for each file being loaded
   * @param onError a callback with the scene, a message, and possibly an exception when import fails
   * @param pluginExtension the extension used to determine the plugin
   * @returns The loaded plugin
   */
  static ImportMesh(e, t, i = "", s = de.LastCreatedScene, r = null, n = null, a = null, o = null, l = "") {
    if (!s)
      return w.Error("No scene available to import mesh to"), null;
    const c = fe._GetFileInfo(t, i);
    if (!c)
      return null;
    const u = {};
    s.addPendingData(u);
    const d = () => {
      s.removePendingData(u);
    }, f = (m, y) => {
      const x = fe._FormatErrorMessage(c, m, y);
      a ? a(s, x, new Ei(x, Yi.SceneLoaderError, y)) : w.Error(x), d();
    }, _ = n ? (m) => {
      try {
        n(m);
      } catch (y) {
        f("Error in onProgress callback: " + y, y);
      }
    } : void 0, g = (m, y, x, A, T, M, b) => {
      if (s.importedMeshesFiles.push(c.url), r)
        try {
          r(m, y, x, A, T, M, b);
        } catch (S) {
          f("Error in onSuccess callback: " + S, S);
        }
      s.removePendingData(u);
    };
    return fe._LoadData(c, s, (m, y, x) => {
      if (m.rewriteRootURL && (c.rootUrl = m.rewriteRootURL(c.rootUrl, x)), m.importMesh) {
        const A = m, T = new Array(), M = new Array(), b = new Array();
        if (!A.importMesh(e, s, y, c.rootUrl, T, M, b, f))
          return;
        s.loadingPluginName = m.name, g(T, M, b, [], [], [], []);
      } else
        m.importMeshAsync(e, s, y, c.rootUrl, _, c.name).then((T) => {
          s.loadingPluginName = m.name, g(T.meshes, T.particleSystems, T.skeletons, T.animationGroups, T.transformNodes, T.geometries, T.lights);
        }).catch((T) => {
          f(T.message, T);
        });
    }, _, f, d, o, l);
  }
  /**
   * Import meshes into a scene
   * @param meshNames an array of mesh names, a single mesh name, or empty string for all meshes that filter what meshes are imported
   * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
   * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene or a File object (default: empty string)
   * @param scene the instance of BABYLON.Scene to append to
   * @param onProgress a callback with a progress event for each file being loaded
   * @param pluginExtension the extension used to determine the plugin
   * @returns The loaded list of imported meshes, particle systems, skeletons, and animation groups
   */
  static ImportMeshAsync(e, t, i = "", s = de.LastCreatedScene, r = null, n = null, a = "") {
    return new Promise((o, l) => {
      fe.ImportMesh(e, t, i, s, (c, u, d, f, _, g, m) => {
        o({
          meshes: c,
          particleSystems: u,
          skeletons: d,
          animationGroups: f,
          transformNodes: _,
          geometries: g,
          lights: m
        });
      }, r, (c, u, d) => {
        l(d || new Error(u));
      }, n, a);
    });
  }
  /**
   * Load a scene
   * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
   * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene or a File object (default: empty string)
   * @param engine is the instance of BABYLON.Engine to use to create the scene
   * @param onSuccess a callback with the scene when import succeeds
   * @param onProgress a callback with a progress event for each file being loaded
   * @param onError a callback with the scene, a message, and possibly an exception when import fails
   * @param pluginExtension the extension used to determine the plugin
   * @returns The loaded plugin
   */
  static Load(e, t = "", i = de.LastCreatedEngine, s = null, r = null, n = null, a = null, o = "") {
    return i ? fe.Append(e, t, new ge(i), s, r, n, a, o) : (z.Error("No engine available"), null);
  }
  /**
   * Load a scene
   * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
   * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene or a File object (default: empty string)
   * @param engine is the instance of BABYLON.Engine to use to create the scene
   * @param onProgress a callback with a progress event for each file being loaded
   * @param pluginExtension the extension used to determine the plugin
   * @returns The loaded scene
   */
  static LoadAsync(e, t = "", i = de.LastCreatedEngine, s = null, r = null, n = "") {
    return new Promise((a, o) => {
      fe.Load(e, t, i, (l) => {
        a(l);
      }, s, (l, c, u) => {
        o(u || new Error(c));
      }, r, n);
    });
  }
  /**
   * Append a scene
   * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
   * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene or a File object (default: empty string)
   * @param scene is the instance of BABYLON.Scene to append to
   * @param onSuccess a callback with the scene when import succeeds
   * @param onProgress a callback with a progress event for each file being loaded
   * @param onError a callback with the scene, a message, and possibly an exception when import fails
   * @param pluginExtension the extension used to determine the plugin
   * @returns The loaded plugin
   */
  static Append(e, t = "", i = de.LastCreatedScene, s = null, r = null, n = null, a = null, o = "") {
    if (!i)
      return w.Error("No scene available to append to"), null;
    const l = fe._GetFileInfo(e, t);
    if (!l)
      return null;
    const c = {};
    i.addPendingData(c);
    const u = () => {
      i.removePendingData(c);
    };
    fe.ShowLoadingScreen && !this._ShowingLoadingScreen && (this._ShowingLoadingScreen = !0, i.getEngine().displayLoadingUI(), i.executeWhenReady(() => {
      i.getEngine().hideLoadingUI(), this._ShowingLoadingScreen = !1;
    }));
    const d = (g, m) => {
      const y = fe._FormatErrorMessage(l, g, m);
      n ? n(i, y, new Ei(y, Yi.SceneLoaderError, m)) : w.Error(y), u();
    }, f = r ? (g) => {
      try {
        r(g);
      } catch (m) {
        d("Error in onProgress callback", m);
      }
    } : void 0, _ = () => {
      if (s)
        try {
          s(i);
        } catch (g) {
          d("Error in onSuccess callback", g);
        }
      i.removePendingData(c);
    };
    return fe._LoadData(l, i, (g, m) => {
      if (g.load) {
        if (!g.load(i, m, l.rootUrl, d))
          return;
        i.loadingPluginName = g.name, _();
      } else
        g.loadAsync(i, m, l.rootUrl, f, l.name).then(() => {
          i.loadingPluginName = g.name, _();
        }).catch((x) => {
          d(x.message, x);
        });
    }, f, d, u, a, o);
  }
  /**
   * Append a scene
   * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
   * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene or a File object (default: empty string)
   * @param scene is the instance of BABYLON.Scene to append to
   * @param onProgress a callback with a progress event for each file being loaded
   * @param pluginExtension the extension used to determine the plugin
   * @returns The given scene
   */
  static AppendAsync(e, t = "", i = de.LastCreatedScene, s = null, r = null, n = "") {
    return new Promise((a, o) => {
      fe.Append(e, t, i, (l) => {
        a(l);
      }, s, (l, c, u) => {
        o(u || new Error(c));
      }, r, n);
    });
  }
  /**
   * Load a scene into an asset container
   * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
   * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene or a File object (default: empty string)
   * @param scene is the instance of BABYLON.Scene to append to (default: last created scene)
   * @param onSuccess a callback with the scene when import succeeds
   * @param onProgress a callback with a progress event for each file being loaded
   * @param onError a callback with the scene, a message, and possibly an exception when import fails
   * @param pluginExtension the extension used to determine the plugin
   * @returns The loaded plugin
   */
  static LoadAssetContainer(e, t = "", i = de.LastCreatedScene, s = null, r = null, n = null, a = null, o = "") {
    if (!i)
      return w.Error("No scene available to load asset container to"), null;
    const l = fe._GetFileInfo(e, t);
    if (!l)
      return null;
    const c = {};
    i.addPendingData(c);
    const u = () => {
      i.removePendingData(c);
    }, d = (g, m) => {
      const y = fe._FormatErrorMessage(l, g, m);
      n ? n(i, y, new Ei(y, Yi.SceneLoaderError, m)) : w.Error(y), u();
    }, f = r ? (g) => {
      try {
        r(g);
      } catch (m) {
        d("Error in onProgress callback", m);
      }
    } : void 0, _ = (g) => {
      if (s)
        try {
          s(g);
        } catch (m) {
          d("Error in onSuccess callback", m);
        }
      i.removePendingData(c);
    };
    return fe._LoadData(l, i, (g, m) => {
      if (g.loadAssetContainer) {
        const x = g.loadAssetContainer(i, m, l.rootUrl, d);
        if (!x)
          return;
        x.populateRootNodes(), i.loadingPluginName = g.name, _(x);
      } else g.loadAssetContainerAsync ? g.loadAssetContainerAsync(i, m, l.rootUrl, f, l.name).then((x) => {
        x.populateRootNodes(), i.loadingPluginName = g.name, _(x);
      }).catch((x) => {
        d(x.message, x);
      }) : d("LoadAssetContainer is not supported by this plugin. Plugin did not provide a loadAssetContainer or loadAssetContainerAsync method.");
    }, f, d, u, a, o);
  }
  /**
   * Load a scene into an asset container
   * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
   * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene (default: empty string)
   * @param scene is the instance of Scene to append to
   * @param onProgress a callback with a progress event for each file being loaded
   * @param pluginExtension the extension used to determine the plugin
   * @returns The loaded asset container
   */
  static LoadAssetContainerAsync(e, t = "", i = de.LastCreatedScene, s = null, r = null) {
    return new Promise((n, a) => {
      fe.LoadAssetContainer(e, t, i, (o) => {
        n(o);
      }, s, (o, l, c) => {
        a(c || new Error(l));
      }, r);
    });
  }
  /**
   * Import animations from a file into a scene
   * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
   * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene or a File object (default: empty string)
   * @param scene is the instance of BABYLON.Scene to append to (default: last created scene)
   * @param overwriteAnimations when true, animations are cleaned before importing new ones. Animations are appended otherwise
   * @param animationGroupLoadingMode defines how to handle old animations groups before importing new ones
   * @param targetConverter defines a function used to convert animation targets from loaded scene to current scene (default: search node by name)
   * @param onSuccess a callback with the scene when import succeeds
   * @param onProgress a callback with a progress event for each file being loaded
   * @param onError a callback with the scene, a message, and possibly an exception when import fails
   * @param pluginExtension the extension used to determine the plugin
   */
  static ImportAnimations(e, t = "", i = de.LastCreatedScene, s = !0, r = wi.Clean, n = null, a = null, o = null, l = null, c = null) {
    if (!i) {
      w.Error("No scene available to load animations to");
      return;
    }
    if (s) {
      for (const _ of i.animatables)
        _.reset();
      i.stopAllAnimations(), i.animationGroups.slice().forEach((_) => {
        _.dispose();
      }), i.getNodes().forEach((_) => {
        _.animations && (_.animations = []);
      });
    } else
      switch (r) {
        case wi.Clean:
          i.animationGroups.slice().forEach((f) => {
            f.dispose();
          });
          break;
        case wi.Stop:
          i.animationGroups.forEach((f) => {
            f.stop();
          });
          break;
        case wi.Sync:
          i.animationGroups.forEach((f) => {
            f.reset(), f.restart();
          });
          break;
        case wi.NoSync:
          break;
        default:
          w.Error("Unknown animation group loading mode value '" + r + "'");
          return;
      }
    const u = i.animatables.length, d = (f) => {
      f.mergeAnimationsTo(i, i.animatables.slice(u), n), f.dispose(), i.onAnimationFileImportedObservable.notifyObservers(i), a && a(i);
    };
    this.LoadAssetContainer(e, t, i, d, o, l, c);
  }
  /**
   * Import animations from a file into a scene
   * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
   * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene or a File object (default: empty string)
   * @param scene is the instance of BABYLON.Scene to append to (default: last created scene)
   * @param overwriteAnimations when true, animations are cleaned before importing new ones. Animations are appended otherwise
   * @param animationGroupLoadingMode defines how to handle old animations groups before importing new ones
   * @param targetConverter defines a function used to convert animation targets from loaded scene to current scene (default: search node by name)
   * @param onSuccess a callback with the scene when import succeeds
   * @param onProgress a callback with a progress event for each file being loaded
   * @param onError a callback with the scene, a message, and possibly an exception when import fails
   * @param pluginExtension the extension used to determine the plugin
   * @returns the updated scene with imported animations
   */
  static ImportAnimationsAsync(e, t = "", i = de.LastCreatedScene, s = !0, r = wi.Clean, n = null, a = null, o = null, l = null, c = null) {
    return new Promise((u, d) => {
      fe.ImportAnimations(e, t, i, s, r, n, (f) => {
        u(f);
      }, o, (f, _, g) => {
        d(g || new Error(_));
      }, c);
    });
  }
}
fe.NO_LOGGING = 0;
fe.MINIMAL_LOGGING = 1;
fe.SUMMARY_LOGGING = 2;
fe.DETAILED_LOGGING = 3;
fe.OnPluginActivatedObservable = new N();
fe._RegisteredPlugins = {};
fe._ShowingLoadingScreen = !1;
K._instancedMeshFactory = (h, e) => {
  const t = new Nn(h, e);
  if (e.instancedBuffers) {
    t.instancedBuffers = {};
    for (const i in e.instancedBuffers)
      t.instancedBuffers[i] = e.instancedBuffers[i];
  }
  return t;
};
class Nn extends Ut {
  /**
   * Creates a new InstancedMesh object from the mesh source.
   * @param name defines the name of the instance
   * @param source the mesh to create the instance from
   */
  constructor(e, t) {
    super(e, t.getScene()), this._indexInSourceMeshInstanceArray = -1, this._distanceToCamera = 0, t.addInstance(this), this._sourceMesh = t, this._unIndexed = t._unIndexed, this.position.copyFrom(t.position), this.rotation.copyFrom(t.rotation), this.scaling.copyFrom(t.scaling), t.rotationQuaternion && (this.rotationQuaternion = t.rotationQuaternion.clone()), this.animations = t.animations.slice();
    for (const i of t.getAnimationRanges())
      i != null && this.createAnimationRange(i.name, i.from, i.to);
    this.infiniteDistance = t.infiniteDistance, this.setPivotMatrix(t.getPivotMatrix()), this.refreshBoundingInfo(!0, !0), this._syncSubMeshes();
  }
  /**
   * Returns the string "InstancedMesh".
   */
  getClassName() {
    return "InstancedMesh";
  }
  /** Gets the list of lights affecting that mesh */
  get lightSources() {
    return this._sourceMesh._lightSources;
  }
  _resyncLightSources() {
  }
  _resyncLightSource() {
  }
  _removeLightSource() {
  }
  // Methods
  /**
   * If the source mesh receives shadows
   */
  get receiveShadows() {
    return this._sourceMesh.receiveShadows;
  }
  set receiveShadows(e) {
    var t;
    ((t = this._sourceMesh) === null || t === void 0 ? void 0 : t.receiveShadows) !== e && z.Warn("Setting receiveShadows on an instanced mesh has no effect");
  }
  /**
   * The material of the source mesh
   */
  get material() {
    return this._sourceMesh.material;
  }
  set material(e) {
    var t;
    ((t = this._sourceMesh) === null || t === void 0 ? void 0 : t.material) !== e && z.Warn("Setting material on an instanced mesh has no effect");
  }
  /**
   * Visibility of the source mesh
   */
  get visibility() {
    return this._sourceMesh.visibility;
  }
  set visibility(e) {
    var t;
    ((t = this._sourceMesh) === null || t === void 0 ? void 0 : t.visibility) !== e && z.Warn("Setting visibility on an instanced mesh has no effect");
  }
  /**
   * Skeleton of the source mesh
   */
  get skeleton() {
    return this._sourceMesh.skeleton;
  }
  set skeleton(e) {
    var t;
    ((t = this._sourceMesh) === null || t === void 0 ? void 0 : t.skeleton) !== e && z.Warn("Setting skeleton on an instanced mesh has no effect");
  }
  /**
   * Rendering ground id of the source mesh
   */
  get renderingGroupId() {
    return this._sourceMesh.renderingGroupId;
  }
  set renderingGroupId(e) {
    !this._sourceMesh || e === this._sourceMesh.renderingGroupId || w.Warn("Note - setting renderingGroupId of an instanced mesh has no effect on the scene");
  }
  /**
   * Returns the total number of vertices (integer).
   */
  getTotalVertices() {
    return this._sourceMesh ? this._sourceMesh.getTotalVertices() : 0;
  }
  /**
   * Returns a positive integer : the total number of indices in this mesh geometry.
   * @returns the number of indices or zero if the mesh has no geometry.
   */
  getTotalIndices() {
    return this._sourceMesh.getTotalIndices();
  }
  /**
   * The source mesh of the instance
   */
  get sourceMesh() {
    return this._sourceMesh;
  }
  /**
   * Creates a new InstancedMesh object from the mesh model.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/copies/instances
   * @param name defines the name of the new instance
   * @returns a new InstancedMesh
   */
  createInstance(e) {
    return this._sourceMesh.createInstance(e);
  }
  /**
   * Is this node ready to be used/rendered
   * @param completeCheck defines if a complete check (including materials and lights) has to be done (false by default)
   * @returns {boolean} is it ready
   */
  isReady(e = !1) {
    return this._sourceMesh.isReady(e, !0);
  }
  /**
   * Returns an array of integers or a typed array (Int32Array, Uint32Array, Uint16Array) populated with the mesh indices.
   * @param kind kind of verticies to retrieve (eg. positions, normals, uvs, etc.)
   * @param copyWhenShared If true (default false) and and if the mesh geometry is shared among some other meshes, the returned array is a copy of the internal one.
   * @param forceCopy defines a boolean forcing the copy of the buffer no matter what the value of copyWhenShared is
   * @returns a float array or a Float32Array of the requested kind of data : positions, normals, uvs, etc.
   */
  getVerticesData(e, t, i) {
    return this._sourceMesh.getVerticesData(e, t, i);
  }
  /**
   * Sets the vertex data of the mesh geometry for the requested `kind`.
   * If the mesh has no geometry, a new Geometry object is set to the mesh and then passed this vertex data.
   * The `data` are either a numeric array either a Float32Array.
   * The parameter `updatable` is passed as is to the underlying Geometry object constructor (if initially none) or updater.
   * The parameter `stride` is an optional positive integer, it is usually automatically deducted from the `kind` (3 for positions or normals, 2 for UV, etc).
   * Note that a new underlying VertexBuffer object is created each call.
   * If the `kind` is the `PositionKind`, the mesh BoundingInfo is renewed, so the bounding box and sphere, and the mesh World Matrix is recomputed.
   *
   * Possible `kind` values :
   * - VertexBuffer.PositionKind
   * - VertexBuffer.UVKind
   * - VertexBuffer.UV2Kind
   * - VertexBuffer.UV3Kind
   * - VertexBuffer.UV4Kind
   * - VertexBuffer.UV5Kind
   * - VertexBuffer.UV6Kind
   * - VertexBuffer.ColorKind
   * - VertexBuffer.MatricesIndicesKind
   * - VertexBuffer.MatricesIndicesExtraKind
   * - VertexBuffer.MatricesWeightsKind
   * - VertexBuffer.MatricesWeightsExtraKind
   *
   * Returns the Mesh.
   * @param kind
   * @param data
   * @param updatable
   * @param stride
   */
  setVerticesData(e, t, i, s) {
    return this.sourceMesh && this.sourceMesh.setVerticesData(e, t, i, s), this.sourceMesh;
  }
  /**
   * Updates the existing vertex data of the mesh geometry for the requested `kind`.
   * If the mesh has no geometry, it is simply returned as it is.
   * The `data` are either a numeric array either a Float32Array.
   * No new underlying VertexBuffer object is created.
   * If the `kind` is the `PositionKind` and if `updateExtends` is true, the mesh BoundingInfo is renewed, so the bounding box and sphere, and the mesh World Matrix is recomputed.
   * If the parameter `makeItUnique` is true, a new global geometry is created from this positions and is set to the mesh.
   *
   * Possible `kind` values :
   * - VertexBuffer.PositionKind
   * - VertexBuffer.UVKind
   * - VertexBuffer.UV2Kind
   * - VertexBuffer.UV3Kind
   * - VertexBuffer.UV4Kind
   * - VertexBuffer.UV5Kind
   * - VertexBuffer.UV6Kind
   * - VertexBuffer.ColorKind
   * - VertexBuffer.MatricesIndicesKind
   * - VertexBuffer.MatricesIndicesExtraKind
   * - VertexBuffer.MatricesWeightsKind
   * - VertexBuffer.MatricesWeightsExtraKind
   *
   * Returns the Mesh.
   * @param kind
   * @param data
   * @param updateExtends
   * @param makeItUnique
   */
  updateVerticesData(e, t, i, s) {
    return this.sourceMesh && this.sourceMesh.updateVerticesData(e, t, i, s), this.sourceMesh;
  }
  /**
   * Sets the mesh indices.
   * Expects an array populated with integers or a typed array (Int32Array, Uint32Array, Uint16Array).
   * If the mesh has no geometry, a new Geometry object is created and set to the mesh.
   * This method creates a new index buffer each call.
   * Returns the Mesh.
   * @param indices
   * @param totalVertices
   */
  setIndices(e, t = null) {
    return this.sourceMesh && this.sourceMesh.setIndices(e, t), this.sourceMesh;
  }
  /**
   * Boolean : True if the mesh owns the requested kind of data.
   * @param kind
   */
  isVerticesDataPresent(e) {
    return this._sourceMesh.isVerticesDataPresent(e);
  }
  /**
   * Returns an array of indices (IndicesArray).
   */
  getIndices() {
    return this._sourceMesh.getIndices();
  }
  get _positions() {
    return this._sourceMesh._positions;
  }
  /**
   * This method recomputes and sets a new BoundingInfo to the mesh unless it is locked.
   * This means the mesh underlying bounding box and sphere are recomputed.
   * @param applySkeleton defines whether to apply the skeleton before computing the bounding info
   * @param applyMorph  defines whether to apply the morph target before computing the bounding info
   * @returns the current mesh
   */
  refreshBoundingInfo(e = !1, t = !1) {
    if (this.hasBoundingInfo && this.getBoundingInfo().isLocked)
      return this;
    const i = this._sourceMesh.geometry ? this._sourceMesh.geometry.boundingBias : null;
    return this._refreshBoundingInfo(this._sourceMesh._getPositionData(e, t), i), this;
  }
  /** @internal */
  _preActivate() {
    return this._currentLOD && this._currentLOD._preActivate(), this;
  }
  /**
   * @internal
   */
  _activate(e, t) {
    if (super._activate(e, t), this._sourceMesh.subMeshes || w.Warn("Instances should only be created for meshes with geometry."), this._currentLOD) {
      if (this._currentLOD._getWorldMatrixDeterminant() >= 0 != this._getWorldMatrixDeterminant() >= 0)
        return this._internalAbstractMeshDataInfo._actAsRegularMesh = !0, !0;
      if (this._internalAbstractMeshDataInfo._actAsRegularMesh = !1, this._currentLOD._registerInstanceForRenderId(this, e), t) {
        if (!this._currentLOD._internalAbstractMeshDataInfo._isActiveIntermediate)
          return this._currentLOD._internalAbstractMeshDataInfo._onlyForInstancesIntermediate = !0, !0;
      } else if (!this._currentLOD._internalAbstractMeshDataInfo._isActive)
        return this._currentLOD._internalAbstractMeshDataInfo._onlyForInstances = !0, !0;
    }
    return !1;
  }
  /** @internal */
  _postActivate() {
    this._sourceMesh.edgesShareWithInstances && this._sourceMesh._edgesRenderer && this._sourceMesh._edgesRenderer.isEnabled && this._sourceMesh._renderingGroup ? (this._sourceMesh._renderingGroup._edgesRenderers.pushNoDuplicate(this._sourceMesh._edgesRenderer), this._sourceMesh._edgesRenderer.customInstances.push(this.getWorldMatrix())) : this._edgesRenderer && this._edgesRenderer.isEnabled && this._sourceMesh._renderingGroup && this._sourceMesh._renderingGroup._edgesRenderers.push(this._edgesRenderer);
  }
  getWorldMatrix() {
    if (this._currentLOD && this._currentLOD.billboardMode !== oe.BILLBOARDMODE_NONE && this._currentLOD._masterMesh !== this) {
      this._billboardWorldMatrix || (this._billboardWorldMatrix = new I());
      const e = this._currentLOD._masterMesh;
      return this._currentLOD._masterMesh = this, C.Vector3[7].copyFrom(this._currentLOD.position), this._currentLOD.position.set(0, 0, 0), this._billboardWorldMatrix.copyFrom(this._currentLOD.computeWorldMatrix(!0)), this._currentLOD.position.copyFrom(C.Vector3[7]), this._currentLOD._masterMesh = e, this._billboardWorldMatrix;
    }
    return super.getWorldMatrix();
  }
  get isAnInstance() {
    return !0;
  }
  /**
   * Returns the current associated LOD AbstractMesh.
   * @param camera
   */
  getLOD(e) {
    if (!e)
      return this;
    const t = this.sourceMesh.getLODLevels();
    if (!t || t.length === 0)
      this._currentLOD = this.sourceMesh;
    else {
      const i = this.getBoundingInfo();
      this._currentLOD = this.sourceMesh.getLOD(e, i.boundingSphere);
    }
    return this._currentLOD;
  }
  /**
   * @internal
   */
  _preActivateForIntermediateRendering(e) {
    return this.sourceMesh._preActivateForIntermediateRendering(e);
  }
  /** @internal */
  _syncSubMeshes() {
    if (this.releaseSubMeshes(), this._sourceMesh.subMeshes)
      for (let e = 0; e < this._sourceMesh.subMeshes.length; e++)
        this._sourceMesh.subMeshes[e].clone(this, this._sourceMesh);
    return this;
  }
  /** @internal */
  _generatePointsArray() {
    return this._sourceMesh._generatePointsArray();
  }
  /** @internal */
  _updateBoundingInfo() {
    return this.hasBoundingInfo ? this.getBoundingInfo().update(this.worldMatrixFromCache) : this.buildBoundingInfo(this.absolutePosition, this.absolutePosition, this.worldMatrixFromCache), this._updateSubMeshesBoundingInfo(this.worldMatrixFromCache), this;
  }
  /**
   * Creates a new InstancedMesh from the current mesh.
   *
   * Returns the clone.
   * @param name the cloned mesh name
   * @param newParent the optional Node to parent the clone to.
   * @param doNotCloneChildren if `true` the model children aren't cloned.
   * @param newSourceMesh if set this mesh will be used as the source mesh instead of ths instance's one
   * @returns the clone
   */
  clone(e, t = null, i, s) {
    const r = (s || this._sourceMesh).createInstance(e);
    if (js.DeepCopy(this, r, [
      "name",
      "subMeshes",
      "uniqueId",
      "parent",
      "lightSources",
      "receiveShadows",
      "material",
      "visibility",
      "skeleton",
      "sourceMesh",
      "isAnInstance",
      "facetNb",
      "isFacetDataEnabled",
      "isBlocked",
      "useBones",
      "hasInstances",
      "collider",
      "edgesRenderer",
      "forward",
      "up",
      "right",
      "absolutePosition",
      "absoluteScaling",
      "absoluteRotationQuaternion",
      "isWorldMatrixFrozen",
      "nonUniformScaling",
      "behaviors",
      "worldMatrixFromCache",
      "hasThinInstances",
      "hasBoundingInfo"
    ], []), this.refreshBoundingInfo(), t && (r.parent = t), !i)
      for (let n = 0; n < this.getScene().meshes.length; n++) {
        const a = this.getScene().meshes[n];
        a.parent === this && a.clone(a.name, r);
      }
    return r.computeWorldMatrix(!0), this.onClonedObservable.notifyObservers(r), r;
  }
  /**
   * Disposes the InstancedMesh.
   * Returns nothing.
   * @param doNotRecurse
   * @param disposeMaterialAndTextures
   */
  dispose(e, t = !1) {
    this._sourceMesh.removeInstance(this), super.dispose(e, t);
  }
  /**
   * @internal
   */
  _serializeAsParent(e) {
    super._serializeAsParent(e), e.parentId = this._sourceMesh.uniqueId, e.parentInstanceIndex = this._indexInSourceMeshInstanceArray;
  }
  /**
   * Instantiate (when possible) or clone that node with its hierarchy
   * @param newParent defines the new parent to use for the instance (or clone)
   * @param options defines options to configure how copy is done
   * @param options.doNotInstantiate defines if the model must be instantiated or just cloned
   * @param options.newSourcedMesh newSourcedMesh the new source mesh for the instance (or clone)
   * @param onNewNodeCreated defines an option callback to call when a clone or an instance is created
   * @returns an instance (or a clone) of the current node with its hierarchy
   */
  instantiateHierarchy(e = null, t, i) {
    const s = this.clone("Clone of " + (this.name || this.id), e || this.parent, !0, t && t.newSourcedMesh);
    s && i && i(this, s);
    for (const r of this.getChildTransformNodes(!0))
      r.instantiateHierarchy(s, t, i);
    return s;
  }
}
K.prototype.registerInstancedBuffer = function(h, e) {
  var t, i;
  if ((i = (t = this._userInstancedBuffersStorage) === null || t === void 0 ? void 0 : t.vertexBuffers[h]) === null || i === void 0 || i.dispose(), !this.instancedBuffers) {
    this.instancedBuffers = {};
    for (const s of this.instances)
      s.instancedBuffers = {};
    this._userInstancedBuffersStorage || (this._userInstancedBuffersStorage = {
      data: {},
      vertexBuffers: {},
      strides: {},
      sizes: {},
      vertexArrayObjects: this.getEngine().getCaps().vertexArrayObject ? {} : void 0
    });
  }
  this.instancedBuffers[h] = null, this._userInstancedBuffersStorage.strides[h] = e, this._userInstancedBuffersStorage.sizes[h] = e * 32, this._userInstancedBuffersStorage.data[h] = new Float32Array(this._userInstancedBuffersStorage.sizes[h]), this._userInstancedBuffersStorage.vertexBuffers[h] = new v(this.getEngine(), this._userInstancedBuffersStorage.data[h], h, !0, !1, e, !0);
  for (const s of this.instances)
    s.instancedBuffers[h] = null;
  this._invalidateInstanceVertexArrayObject(), this._markSubMeshesAsAttributesDirty();
};
K.prototype._processInstancedBuffers = function(h, e) {
  const t = h ? h.length : 0;
  for (const i in this.instancedBuffers) {
    let s = this._userInstancedBuffersStorage.sizes[i];
    const r = this._userInstancedBuffersStorage.strides[i], n = (t + 1) * r;
    for (; s < n; )
      s *= 2;
    this._userInstancedBuffersStorage.data[i].length != s && (this._userInstancedBuffersStorage.data[i] = new Float32Array(s), this._userInstancedBuffersStorage.sizes[i] = s, this._userInstancedBuffersStorage.vertexBuffers[i] && (this._userInstancedBuffersStorage.vertexBuffers[i].dispose(), this._userInstancedBuffersStorage.vertexBuffers[i] = null));
    const a = this._userInstancedBuffersStorage.data[i];
    let o = 0;
    if (e) {
      const l = this.instancedBuffers[i];
      l.toArray ? l.toArray(a, o) : l.copyToArray ? l.copyToArray(a, o) : a[o] = l, o += r;
    }
    for (let l = 0; l < t; l++) {
      const u = h[l].instancedBuffers[i];
      u.toArray ? u.toArray(a, o) : u.copyToArray ? u.copyToArray(a, o) : a[o] = u, o += r;
    }
    this._userInstancedBuffersStorage.vertexBuffers[i] ? this._userInstancedBuffersStorage.vertexBuffers[i].updateDirectly(a, 0) : (this._userInstancedBuffersStorage.vertexBuffers[i] = new v(this.getEngine(), this._userInstancedBuffersStorage.data[i], i, !0, !1, r, !0), this._invalidateInstanceVertexArrayObject());
  }
};
K.prototype._invalidateInstanceVertexArrayObject = function() {
  if (!(!this._userInstancedBuffersStorage || this._userInstancedBuffersStorage.vertexArrayObjects === void 0)) {
    for (const h in this._userInstancedBuffersStorage.vertexArrayObjects)
      this.getEngine().releaseVertexArrayObject(this._userInstancedBuffersStorage.vertexArrayObjects[h]);
    this._userInstancedBuffersStorage.vertexArrayObjects = {};
  }
};
K.prototype._disposeInstanceSpecificData = function() {
  for (this._instanceDataStorage.instancesBuffer && (this._instanceDataStorage.instancesBuffer.dispose(), this._instanceDataStorage.instancesBuffer = null); this.instances.length; )
    this.instances[0].dispose();
  for (const h in this.instancedBuffers)
    this._userInstancedBuffersStorage.vertexBuffers[h] && this._userInstancedBuffersStorage.vertexBuffers[h].dispose();
  this._invalidateInstanceVertexArrayObject(), this.instancedBuffers = {};
};
class mh extends Pi {
}
class yh {
  constructor() {
    this.rootNodes = [], this.skeletons = [], this.animationGroups = [];
  }
  /**
   * Disposes the instantiated entries from the scene
   */
  dispose() {
    this.rootNodes.slice(0).forEach((e) => {
      e.dispose();
    }), this.rootNodes.length = 0, this.skeletons.slice(0).forEach((e) => {
      e.dispose();
    }), this.skeletons.length = 0, this.animationGroups.slice(0).forEach((e) => {
      e.dispose();
    }), this.animationGroups.length = 0;
  }
}
class vh extends Pi {
  /**
   * Instantiates an AssetContainer.
   * @param scene The scene the AssetContainer belongs to.
   */
  constructor(e) {
    super(), this._wasAddedToScene = !1, e = e || de.LastCreatedScene, e && (this.scene = e, this.sounds = [], this.effectLayers = [], this.layers = [], this.lensFlareSystems = [], this.proceduralTextures = [], this.reflectionProbes = [], e.onDisposeObservable.add(() => {
      this._wasAddedToScene || this.dispose();
    }), this._onContextRestoredObserver = e.getEngine().onContextRestoredObservable.add(() => {
      for (const t of this.geometries)
        t._rebuild();
      for (const t of this.meshes)
        t._rebuild();
      for (const t of this.particleSystems)
        t.rebuild();
      for (const t of this.textures)
        t._rebuild();
    }));
  }
  /**
   * Given a list of nodes, return a topological sorting of them.
   * @param nodes
   */
  _topologicalSort(e) {
    const t = /* @__PURE__ */ new Map();
    for (const a of e)
      t.set(a.uniqueId, a);
    const i = {
      dependsOn: /* @__PURE__ */ new Map(),
      dependedBy: /* @__PURE__ */ new Map()
      // given a node id, what are the ids of the nodes that depend on it
    };
    for (const a of e) {
      const o = a.uniqueId;
      i.dependsOn.set(o, /* @__PURE__ */ new Set()), i.dependedBy.set(o, /* @__PURE__ */ new Set());
    }
    for (const a of e) {
      const o = a.uniqueId, l = i.dependsOn.get(o);
      if (a instanceof Nn) {
        const u = a.sourceMesh;
        t.has(u.uniqueId) && (l.add(u.uniqueId), i.dependedBy.get(u.uniqueId).add(o));
      }
      const c = i.dependedBy.get(o);
      for (const u of a.getDescendants()) {
        const d = u.uniqueId;
        t.has(d) && (c.add(d), i.dependsOn.get(d).add(o));
      }
    }
    const s = [], r = [];
    for (const a of e) {
      const o = a.uniqueId;
      i.dependsOn.get(o).size === 0 && (r.push(a), t.delete(o));
    }
    const n = r;
    for (; n.length > 0; ) {
      const a = n.shift();
      s.push(a);
      const o = i.dependedBy.get(a.uniqueId);
      for (const l of Array.from(o.values())) {
        const c = i.dependsOn.get(l);
        c.delete(a.uniqueId), c.size === 0 && t.get(l) && (n.push(t.get(l)), t.delete(l));
      }
    }
    return t.size > 0 && (console.error("SceneSerializer._topologicalSort: There were unvisited nodes:"), t.forEach((a) => console.error(a.name))), s;
  }
  _addNodeAndDescendantsToList(e, t, i, s) {
    if (!(!i || s && !s(i) || t.has(i.uniqueId))) {
      e.push(i), t.add(i.uniqueId);
      for (const r of i.getDescendants(!0))
        this._addNodeAndDescendantsToList(e, t, r, s);
    }
  }
  /**
   * Check if a specific node is contained in this asset container.
   * @param node
   */
  _isNodeInContainer(e) {
    return e instanceof K && this.meshes.indexOf(e) !== -1 || e instanceof oe && this.transformNodes.indexOf(e) !== -1 || e instanceof me && this.lights.indexOf(e) !== -1 || e instanceof Q && this.cameras.indexOf(e) !== -1;
  }
  /**
   * For every node in the scene, check if its parent node is also in the scene.
   */
  _isValidHierarchy() {
    for (const e of this.meshes)
      if (e.parent && !this._isNodeInContainer(e.parent))
        return w.Warn(`Node ${e.name} has a parent that is not in the container.`), !1;
    for (const e of this.transformNodes)
      if (e.parent && !this._isNodeInContainer(e.parent))
        return w.Warn(`Node ${e.name} has a parent that is not in the container.`), !1;
    for (const e of this.lights)
      if (e.parent && !this._isNodeInContainer(e.parent))
        return w.Warn(`Node ${e.name} has a parent that is not in the container.`), !1;
    for (const e of this.cameras)
      if (e.parent && !this._isNodeInContainer(e.parent))
        return w.Warn(`Node ${e.name} has a parent that is not in the container.`), !1;
    return !0;
  }
  /**
   * Instantiate or clone all meshes and add the new ones to the scene.
   * Skeletons and animation groups will all be cloned
   * @param nameFunction defines an optional function used to get new names for clones
   * @param cloneMaterials defines an optional boolean that defines if materials must be cloned as well (false by default)
   * @param options defines an optional list of options to control how to instantiate / clone models
   * @param options.doNotInstantiate defines if the model must be instantiated or just cloned
   * @param options.predicate defines a predicate used to filter whih mesh to instantiate/clone
   * @returns a list of rootNodes, skeletons and animation groups that were duplicated
   */
  instantiateModelsToScene(e, t = !1, i) {
    this._isValidHierarchy() || z.Warn("SceneSerializer.InstantiateModelsToScene: The Asset Container hierarchy is not valid.");
    const s = {}, r = {}, n = new yh(), a = [], o = [], l = Object.assign({ doNotInstantiate: !0 }, i), c = (g, m) => {
      if (s[g.uniqueId] = m.uniqueId, r[m.uniqueId] = m, e && (m.name = e(g.name)), m instanceof K) {
        const y = m;
        if (y.morphTargetManager) {
          const x = g.morphTargetManager;
          y.morphTargetManager = x.clone();
          for (let A = 0; A < x.numTargets; A++) {
            const T = x.getTarget(A), M = y.morphTargetManager.getTarget(A);
            s[T.uniqueId] = M.uniqueId, r[M.uniqueId] = M;
          }
        }
      }
    }, u = [], d = /* @__PURE__ */ new Set();
    for (const g of this.transformNodes)
      g.parent === null && this._addNodeAndDescendantsToList(u, d, g, l.predicate);
    for (const g of this.meshes)
      g.parent === null && this._addNodeAndDescendantsToList(u, d, g, l.predicate);
    const f = this._topologicalSort(u), _ = (g, m) => {
      if (c(g, m), g.parent) {
        const y = s[g.parent.uniqueId], x = r[y];
        x ? m.parent = x : m.parent = g.parent;
      }
      if (m.position && g.position && m.position.copyFrom(g.position), m.rotationQuaternion && g.rotationQuaternion && m.rotationQuaternion.copyFrom(g.rotationQuaternion), m.rotation && g.rotation && m.rotation.copyFrom(g.rotation), m.scaling && g.scaling && m.scaling.copyFrom(g.scaling), m.material) {
        const y = m;
        if (y.material)
          if (t) {
            const x = g.material;
            if (o.indexOf(x) === -1) {
              let A = x.clone(e ? e(x.name) : "Clone of " + x.name);
              if (o.push(x), s[x.uniqueId] = A.uniqueId, r[A.uniqueId] = A, x.getClassName() === "MultiMaterial") {
                const T = x;
                for (const M of T.subMaterials)
                  M && (A = M.clone(e ? e(M.name) : "Clone of " + M.name), o.push(M), s[M.uniqueId] = A.uniqueId, r[A.uniqueId] = A);
                T.subMaterials = T.subMaterials.map((M) => M && r[s[M.uniqueId]]);
              }
            }
            y.getClassName() !== "InstancedMesh" && (y.material = r[s[x.uniqueId]]);
          } else
            y.material.getClassName() === "MultiMaterial" ? this.scene.multiMaterials.indexOf(y.material) === -1 && this.scene.addMultiMaterial(y.material) : this.scene.materials.indexOf(y.material) === -1 && this.scene.addMaterial(y.material);
      }
      m.parent === null && n.rootNodes.push(m);
    };
    return f.forEach((g) => {
      if (g.getClassName() === "InstancedMesh") {
        const m = g, y = m.sourceMesh, x = s[y.uniqueId], T = (typeof x == "number" ? r[x] : y).createInstance(m.name);
        _(m, T);
      } else {
        let m = !0;
        g.getClassName() === "TransformNode" || g.getClassName() === "Node" || g.skeleton || !g.getTotalVertices || g.getTotalVertices() === 0 ? m = !1 : l.doNotInstantiate && (typeof l.doNotInstantiate == "function" ? m = !l.doNotInstantiate(g) : m = !l.doNotInstantiate);
        const y = m ? g.createInstance(`instance of ${g.name}`) : g.clone(`Clone of ${g.name}`, null, !0);
        if (!y)
          throw new Error(`Could not clone or instantiate node on Asset Container ${g.name}`);
        _(g, y);
      }
    }), this.skeletons.forEach((g) => {
      if (l.predicate && !l.predicate(g))
        return;
      const m = g.clone(e ? e(g.name) : "Clone of " + g.name);
      for (const y of this.meshes)
        if (y.skeleton === g && !y.isAnInstance) {
          const x = r[s[y.uniqueId]];
          if (!x || x.isAnInstance || (x.skeleton = m, a.indexOf(m) !== -1))
            continue;
          a.push(m);
          for (const A of m.bones)
            A._linkedTransformNode && (A._linkedTransformNode = r[s[A._linkedTransformNode.uniqueId]]);
        }
      n.skeletons.push(m);
    }), this.animationGroups.forEach((g) => {
      if (l.predicate && !l.predicate(g))
        return;
      const m = g.clone(e ? e(g.name) : "Clone of " + g.name, (y) => r[s[y.uniqueId]] || y);
      n.animationGroups.push(m);
    }), n;
  }
  /**
   * Adds all the assets from the container to the scene.
   */
  addAllToScene() {
    if (!this._wasAddedToScene) {
      this._isValidHierarchy() || z.Warn("SceneSerializer.addAllToScene: The Asset Container hierarchy is not valid."), this._wasAddedToScene = !0, this.addToScene(null), this.environmentTexture && (this.scene.environmentTexture = this.environmentTexture);
      for (const e of this.scene._serializableComponents)
        e.addFromContainer(this);
      this.scene.getEngine().onContextRestoredObservable.remove(this._onContextRestoredObserver), this._onContextRestoredObserver = null;
    }
  }
  /**
   * Adds assets from the container to the scene.
   * @param predicate defines a predicate used to select which entity will be added (can be null)
   */
  addToScene(e = null) {
    const t = [];
    this.cameras.forEach((i) => {
      e && !e(i) || (this.scene.addCamera(i), t.push(i));
    }), this.lights.forEach((i) => {
      e && !e(i) || (this.scene.addLight(i), t.push(i));
    }), this.meshes.forEach((i) => {
      e && !e(i) || (this.scene.addMesh(i), t.push(i));
    }), this.skeletons.forEach((i) => {
      e && !e(i) || this.scene.addSkeleton(i);
    }), this.animations.forEach((i) => {
      e && !e(i) || this.scene.addAnimation(i);
    }), this.animationGroups.forEach((i) => {
      e && !e(i) || this.scene.addAnimationGroup(i);
    }), this.multiMaterials.forEach((i) => {
      e && !e(i) || this.scene.addMultiMaterial(i);
    }), this.materials.forEach((i) => {
      e && !e(i) || this.scene.addMaterial(i);
    }), this.morphTargetManagers.forEach((i) => {
      e && !e(i) || this.scene.addMorphTargetManager(i);
    }), this.geometries.forEach((i) => {
      e && !e(i) || this.scene.addGeometry(i);
    }), this.transformNodes.forEach((i) => {
      e && !e(i) || (this.scene.addTransformNode(i), t.push(i));
    }), this.actionManagers.forEach((i) => {
      e && !e(i) || this.scene.addActionManager(i);
    }), this.textures.forEach((i) => {
      e && !e(i) || this.scene.addTexture(i);
    }), this.reflectionProbes.forEach((i) => {
      e && !e(i) || this.scene.addReflectionProbe(i);
    });
    for (const i of t)
      i.parent && this.scene.getNodes().indexOf(i.parent) === -1 && (i.setParent ? i.setParent(null) : i.parent = null);
  }
  /**
   * Removes all the assets in the container from the scene
   */
  removeAllFromScene() {
    this._isValidHierarchy() || z.Warn("SceneSerializer.removeAllFromScene: The Asset Container hierarchy is not valid."), this._wasAddedToScene = !1, this.removeFromScene(null), this.environmentTexture === this.scene.environmentTexture && (this.scene.environmentTexture = null);
    for (const e of this.scene._serializableComponents)
      e.removeFromContainer(this);
  }
  /**
   * Removes assets in the container from the scene
   * @param predicate defines a predicate used to select which entity will be added (can be null)
   */
  removeFromScene(e = null) {
    this.cameras.forEach((t) => {
      e && !e(t) || this.scene.removeCamera(t);
    }), this.lights.forEach((t) => {
      e && !e(t) || this.scene.removeLight(t);
    }), this.meshes.forEach((t) => {
      e && !e(t) || this.scene.removeMesh(t);
    }), this.skeletons.forEach((t) => {
      e && !e(t) || this.scene.removeSkeleton(t);
    }), this.animations.forEach((t) => {
      e && !e(t) || this.scene.removeAnimation(t);
    }), this.animationGroups.forEach((t) => {
      e && !e(t) || this.scene.removeAnimationGroup(t);
    }), this.multiMaterials.forEach((t) => {
      e && !e(t) || this.scene.removeMultiMaterial(t);
    }), this.materials.forEach((t) => {
      e && !e(t) || this.scene.removeMaterial(t);
    }), this.morphTargetManagers.forEach((t) => {
      e && !e(t) || this.scene.removeMorphTargetManager(t);
    }), this.geometries.forEach((t) => {
      e && !e(t) || this.scene.removeGeometry(t);
    }), this.transformNodes.forEach((t) => {
      e && !e(t) || this.scene.removeTransformNode(t);
    }), this.actionManagers.forEach((t) => {
      e && !e(t) || this.scene.removeActionManager(t);
    }), this.textures.forEach((t) => {
      e && !e(t) || this.scene.removeTexture(t);
    }), this.reflectionProbes.forEach((t) => {
      e && !e(t) || this.scene.removeReflectionProbe(t);
    });
  }
  /**
   * Disposes all the assets in the container
   */
  dispose() {
    this.cameras.slice(0).forEach((e) => {
      e.dispose();
    }), this.cameras.length = 0, this.lights.slice(0).forEach((e) => {
      e.dispose();
    }), this.lights.length = 0, this.meshes.slice(0).forEach((e) => {
      e.dispose();
    }), this.meshes.length = 0, this.skeletons.slice(0).forEach((e) => {
      e.dispose();
    }), this.skeletons.length = 0, this.animationGroups.slice(0).forEach((e) => {
      e.dispose();
    }), this.animationGroups.length = 0, this.multiMaterials.slice(0).forEach((e) => {
      e.dispose();
    }), this.multiMaterials.length = 0, this.materials.slice(0).forEach((e) => {
      e.dispose();
    }), this.materials.length = 0, this.geometries.slice(0).forEach((e) => {
      e.dispose();
    }), this.geometries.length = 0, this.transformNodes.slice(0).forEach((e) => {
      e.dispose();
    }), this.transformNodes.length = 0, this.actionManagers.slice(0).forEach((e) => {
      e.dispose();
    }), this.actionManagers.length = 0, this.textures.slice(0).forEach((e) => {
      e.dispose();
    }), this.textures.length = 0, this.reflectionProbes.slice(0).forEach((e) => {
      e.dispose();
    }), this.reflectionProbes.length = 0, this.morphTargetManagers.slice(0).forEach((e) => {
      e.dispose();
    }), this.morphTargetManagers.length = 0, this.environmentTexture && (this.environmentTexture.dispose(), this.environmentTexture = null);
    for (const e of this.scene._serializableComponents)
      e.removeFromContainer(this, !0);
    this._onContextRestoredObserver && (this.scene.getEngine().onContextRestoredObservable.remove(this._onContextRestoredObserver), this._onContextRestoredObserver = null);
  }
  _moveAssets(e, t, i) {
    if (!(!e || !t))
      for (const s of e) {
        let r = !0;
        if (i) {
          for (const n of i)
            if (s === n) {
              r = !1;
              break;
            }
        }
        r && (t.push(s), s._parentContainer = this);
      }
  }
  /**
   * Removes all the assets contained in the scene and adds them to the container.
   * @param keepAssets Set of assets to keep in the scene. (default: empty)
   */
  moveAllFromScene(e) {
    this._wasAddedToScene = !1, e === void 0 && (e = new mh());
    for (const t in this)
      Object.prototype.hasOwnProperty.call(this, t) && (this[t] = this[t] || (t === "_environmentTexture" ? null : []), this._moveAssets(this.scene[t], this[t], e[t]));
    this.environmentTexture = this.scene.environmentTexture, this.removeAllFromScene();
  }
  /**
   * Adds all meshes in the asset container to a root mesh that can be used to position all the contained meshes. The root mesh is then added to the front of the meshes in the assetContainer.
   * @returns the root mesh
   */
  createRootMesh() {
    const e = new K("assetContainerRootMesh", this.scene);
    return this.meshes.forEach((t) => {
      t.parent || e.addChild(t);
    }), this.meshes.unshift(e), e;
  }
  /**
   * Merge animations (direct and animation groups) from this asset container into a scene
   * @param scene is the instance of BABYLON.Scene to append to (default: last created scene)
   * @param animatables set of animatables to retarget to a node from the scene
   * @param targetConverter defines a function used to convert animation targets from the asset container to the scene (default: search node by name)
   * @returns an array of the new AnimationGroup added to the scene (empty array if none)
   */
  mergeAnimationsTo(e = de.LastCreatedScene, t, i = null) {
    if (!e)
      return w.Error("No scene available to merge animations to"), [];
    const s = i || ((a) => {
      let o = null;
      const l = a.animations.length ? a.animations[0].targetProperty : "", c = a.name.split(".").join("").split("_primitive")[0];
      switch (l) {
        case "position":
        case "rotationQuaternion":
          o = e.getTransformNodeByName(a.name) || e.getTransformNodeByName(c);
          break;
        case "influence":
          o = e.getMorphTargetByName(a.name) || e.getMorphTargetByName(c);
          break;
        default:
          o = e.getNodeByName(a.name) || e.getNodeByName(c);
      }
      return o;
    });
    this.getNodes().forEach((a) => {
      const o = s(a);
      if (o !== null) {
        for (const l of a.animations) {
          const c = o.animations.filter((u) => u.targetProperty === l.targetProperty);
          for (const u of c) {
            const d = o.animations.indexOf(u, 0);
            d > -1 && o.animations.splice(d, 1);
          }
        }
        o.animations = o.animations.concat(a.animations);
      }
    });
    const n = new Array();
    return this.animationGroups.slice().forEach((a) => {
      n.push(a.clone(a.name, s)), a.animatables.forEach((o) => {
        o.stop();
      });
    }), t.forEach((a) => {
      const o = s(a.target);
      o && (e.beginAnimation(o, a.fromFrame, a.toFrame, a.loopAnimation, a.speedRatio, a.onAnimationEnd ? a.onAnimationEnd : void 0, void 0, !0, void 0, a.onAnimationLoop ? a.onAnimationLoop : void 0), e.stopAnimation(a.target));
    }), n;
  }
  /**
   * @since 6.15.0
   * This method checks for any node that has no parent
   * and is not in the rootNodes array, and adds the node
   * there, if so.
   */
  populateRootNodes() {
    this.rootNodes.length = 0, this.meshes.forEach((e) => {
      !e.parent && this.rootNodes.indexOf(e) === -1 && this.rootNodes.push(e);
    }), this.transformNodes.forEach((e) => {
      !e.parent && this.rootNodes.indexOf(e) === -1 && this.rootNodes.push(e);
    }), this.lights.forEach((e) => {
      !e.parent && this.rootNodes.indexOf(e) === -1 && this.rootNodes.push(e);
    }), this.cameras.forEach((e) => {
      !e.parent && this.rootNodes.indexOf(e) === -1 && this.rootNodes.push(e);
    });
  }
}
class Qe {
  /**
   * Creates a new Action
   * @param triggerOptions the trigger, with or without parameters, for the action
   * @param condition an optional determinant of action
   */
  constructor(e, t) {
    this.triggerOptions = e, this.onBeforeExecuteObservable = new N(), e.parameter ? (this.trigger = e.trigger, this._triggerParameter = e.parameter) : e.trigger ? this.trigger = e.trigger : this.trigger = e, this._nextActiveAction = this, this._condition = t;
  }
  /**
   * Internal only
   * @internal
   */
  _prepare() {
  }
  /**
   * Gets the trigger parameter
   * @returns the trigger parameter
   */
  getTriggerParameter() {
    return this._triggerParameter;
  }
  /**
   * Sets the trigger parameter
   * @param value defines the new trigger parameter
   */
  setTriggerParameter(e) {
    this._triggerParameter = e;
  }
  /**
   * Internal only - Returns if the current condition allows to run the action
   * @internal
   */
  _evaluateConditionForCurrentFrame() {
    const e = this._condition;
    if (!e)
      return !0;
    const t = this._actionManager.getScene().getRenderId();
    return e._evaluationId !== t && (e._evaluationId = t, e._currentResult = e.isValid()), e._currentResult;
  }
  /**
   * Internal only - executes current action event
   * @internal
   */
  _executeCurrent(e) {
    this._evaluateConditionForCurrentFrame() && (this.onBeforeExecuteObservable.notifyObservers(this), this._nextActiveAction.execute(e), this.skipToNextActiveAction());
  }
  /**
   * Execute placeholder for child classes
   * @param evt optional action event
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  execute(e) {
  }
  /**
   * Skips to next active action
   */
  skipToNextActiveAction() {
    this._nextActiveAction._child ? (this._nextActiveAction._child._actionManager || (this._nextActiveAction._child._actionManager = this._actionManager), this._nextActiveAction = this._nextActiveAction._child) : this._nextActiveAction = this;
  }
  /**
   * Adds action to chain of actions, may be a DoNothingAction
   * @param action defines the next action to execute
   * @returns The action passed in
   * @see https://www.babylonjs-playground.com/#1T30HR#0
   */
  then(e) {
    return this._child = e, e._actionManager = this._actionManager, e._prepare(), e;
  }
  /**
   * Internal only
   * @internal
   */
  _getProperty(e) {
    return this._actionManager._getProperty(e);
  }
  /**
   * @internal
   */
  _getEffectiveTarget(e, t) {
    return this._actionManager._getEffectiveTarget(e, t);
  }
  /**
   * Serialize placeholder for child classes
   * @param parent of child
   * @returns the serialized object
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  serialize(e) {
  }
  /**
   * Internal only called by serialize
   * @internal
   */
  _serialize(e, t) {
    const i = {
      type: 1,
      children: [],
      name: e.name,
      properties: e.properties || []
    };
    if (this._child && this._child.serialize(i), this._condition) {
      const s = this._condition.serialize();
      return s.children.push(i), t && t.children.push(s), s;
    }
    return t && t.children.push(i), i;
  }
}
Qe._SerializeValueAsString = (h) => typeof h == "number" ? h.toString() : typeof h == "boolean" ? h ? "true" : "false" : h instanceof ue ? h.x + ", " + h.y : h instanceof p ? h.x + ", " + h.y + ", " + h.z : h instanceof ie ? h.r + ", " + h.g + ", " + h.b : h instanceof ye ? h.r + ", " + h.g + ", " + h.b + ", " + h.a : h;
Qe._GetTargetProperty = (h) => ({
  name: "target",
  targetType: h._isMesh ? "MeshProperties" : h._isLight ? "LightProperties" : h._isCamera ? "CameraProperties" : h._isMaterial ? "MaterialProperties" : "SceneProperties",
  value: h._isScene ? "Scene" : h.name
});
Xe("BABYLON.Action", Qe);
class Vs {
  /**
   * Creates a new Condition
   * @param actionManager the manager of the action the condition is applied to
   */
  constructor(e) {
    this._actionManager = e;
  }
  /**
   * Check if the current condition is valid
   * @returns a boolean
   */
  isValid() {
    return !0;
  }
  /**
   * @internal
   */
  _getProperty(e) {
    return this._actionManager._getProperty(e);
  }
  /**
   * @internal
   */
  _getEffectiveTarget(e, t) {
    return this._actionManager._getEffectiveTarget(e, t);
  }
  /**
   * Serialize placeholder for child classes
   * @returns the serialized object
   */
  serialize() {
  }
  /**
   * @internal
   */
  _serialize(e) {
    return {
      type: 2,
      children: [],
      name: e.name,
      properties: e.properties
    };
  }
}
class nt extends Vs {
  /**
   * returns the number for IsEqual
   */
  static get IsEqual() {
    return nt._IsEqual;
  }
  /**
   * Returns the number for IsDifferent
   */
  static get IsDifferent() {
    return nt._IsDifferent;
  }
  /**
   * Returns the number for IsGreater
   */
  static get IsGreater() {
    return nt._IsGreater;
  }
  /**
   * Returns the number for IsLesser
   */
  static get IsLesser() {
    return nt._IsLesser;
  }
  /**
   * Creates a new ValueCondition
   * @param actionManager manager for the action the condition applies to
   * @param target for the action
   * @param propertyPath path to specify the property of the target the conditional operator uses
   * @param value the value compared by the conditional operator against the current value of the property
   * @param operator the conditional operator, default ValueCondition.IsEqual
   */
  constructor(e, t, i, s, r = nt.IsEqual) {
    super(e), this.propertyPath = i, this.value = s, this.operator = r, this._target = t, this._effectiveTarget = this._getEffectiveTarget(t, this.propertyPath), this._property = this._getProperty(this.propertyPath);
  }
  /**
   * Compares the given value with the property value for the specified conditional operator
   * @returns the result of the comparison
   */
  isValid() {
    switch (this.operator) {
      case nt.IsGreater:
        return this._effectiveTarget[this._property] > this.value;
      case nt.IsLesser:
        return this._effectiveTarget[this._property] < this.value;
      case nt.IsEqual:
      case nt.IsDifferent: {
        let e;
        return this.value.equals ? e = this.value.equals(this._effectiveTarget[this._property]) : e = this.value === this._effectiveTarget[this._property], this.operator === nt.IsEqual ? e : !e;
      }
    }
    return !1;
  }
  /**
   * Serialize the ValueCondition into a JSON compatible object
   * @returns serialization object
   */
  serialize() {
    return this._serialize({
      name: "ValueCondition",
      properties: [
        Qe._GetTargetProperty(this._target),
        { name: "propertyPath", value: this.propertyPath },
        { name: "value", value: Qe._SerializeValueAsString(this.value) },
        { name: "operator", value: nt.GetOperatorName(this.operator) }
      ]
    });
  }
  /**
   * Gets the name of the conditional operator for the ValueCondition
   * @param operator the conditional operator
   * @returns the name
   */
  static GetOperatorName(e) {
    switch (e) {
      case nt._IsEqual:
        return "IsEqual";
      case nt._IsDifferent:
        return "IsDifferent";
      case nt._IsGreater:
        return "IsGreater";
      case nt._IsLesser:
        return "IsLesser";
      default:
        return "";
    }
  }
}
nt._IsEqual = 0;
nt._IsDifferent = 1;
nt._IsGreater = 2;
nt._IsLesser = 3;
class xh extends Vs {
  /**
   * Creates a new PredicateCondition
   * @param actionManager manager for the action the condition applies to
   * @param predicate defines the predicate function used to validate the condition
   */
  constructor(e, t) {
    super(e), this.predicate = t;
  }
  /**
   * @returns the validity of the predicate condition
   */
  isValid() {
    return this.predicate();
  }
}
class bh extends Vs {
  /**
   * Creates a new StateCondition
   * @param actionManager manager for the action the condition applies to
   * @param target of the condition
   * @param value to compare with target state
   */
  constructor(e, t, i) {
    super(e), this.value = i, this._target = t;
  }
  /**
   * Gets a boolean indicating if the current condition is met
   * @returns the validity of the state
   */
  isValid() {
    return this._target.state === this.value;
  }
  /**
   * Serialize the StateCondition into a JSON compatible object
   * @returns serialization object
   */
  serialize() {
    return this._serialize({
      name: "StateCondition",
      properties: [Qe._GetTargetProperty(this._target), { name: "value", value: this.value }]
    });
  }
}
Xe("BABYLON.ValueCondition", nt);
Xe("BABYLON.PredicateCondition", xh);
Xe("BABYLON.StateCondition", bh);
class Th extends Qe {
  /**
   * Instantiate the action
   * @param triggerOptions defines the trigger options
   * @param target defines the object containing the boolean
   * @param propertyPath defines the path to the boolean property in the target object
   * @param condition defines the trigger related conditions
   */
  constructor(e, t, i, s) {
    super(e, s), this.propertyPath = i, this._target = this._effectiveTarget = t;
  }
  /** @internal */
  _prepare() {
    this._effectiveTarget = this._getEffectiveTarget(this._effectiveTarget, this.propertyPath), this._property = this._getProperty(this.propertyPath);
  }
  /**
   * Execute the action toggle the boolean value.
   */
  execute() {
    this._effectiveTarget[this._property] = !this._effectiveTarget[this._property];
  }
  /**
   * Serializes the actions and its related information.
   * @param parent defines the object to serialize in
   * @returns the serialized object
   */
  serialize(e) {
    return super._serialize({
      name: "SwitchBooleanAction",
      properties: [Qe._GetTargetProperty(this._target), { name: "propertyPath", value: this.propertyPath }]
    }, e);
  }
}
class Ah extends Qe {
  /**
   * Instantiate the action
   * @param triggerOptions defines the trigger options
   * @param target defines the object containing the state property
   * @param value defines the value to store in the state field
   * @param condition defines the trigger related conditions
   */
  constructor(e, t, i, s) {
    super(e, s), this.value = i, this._target = t;
  }
  /**
   * Execute the action and store the value on the target state property.
   */
  execute() {
    this._target.state = this.value;
  }
  /**
   * Serializes the actions and its related information.
   * @param parent defines the object to serialize in
   * @returns the serialized object
   */
  serialize(e) {
    return super._serialize({
      name: "SetStateAction",
      properties: [Qe._GetTargetProperty(this._target), { name: "value", value: this.value }]
    }, e);
  }
}
class Eh extends Qe {
  /**
   * Instantiate the action
   * @param triggerOptions defines the trigger options
   * @param target defines the object containing the property
   * @param propertyPath defines the path of the property to set in the target
   * @param value defines the value to set in the property
   * @param condition defines the trigger related conditions
   */
  constructor(e, t, i, s, r) {
    super(e, r), this.propertyPath = i, this.value = s, this._target = this._effectiveTarget = t;
  }
  /** @internal */
  _prepare() {
    this._effectiveTarget = this._getEffectiveTarget(this._effectiveTarget, this.propertyPath), this._property = this._getProperty(this.propertyPath);
  }
  /**
   * Execute the action and set the targeted property to the desired value.
   */
  execute() {
    this._effectiveTarget[this._property] = this.value, this._target.markAsDirty && this._target.markAsDirty(this._property);
  }
  /**
   * Serializes the actions and its related information.
   * @param parent defines the object to serialize in
   * @returns the serialized object
   */
  serialize(e) {
    return super._serialize({
      name: "SetValueAction",
      properties: [
        Qe._GetTargetProperty(this._target),
        { name: "propertyPath", value: this.propertyPath },
        { name: "value", value: Qe._SerializeValueAsString(this.value) }
      ]
    }, e);
  }
}
class Mh extends Qe {
  /**
   * Instantiate the action
   * @param triggerOptions defines the trigger options
   * @param target defines the object containing the property
   * @param propertyPath defines the path of the property to increment in the target
   * @param value defines the value value we should increment the property by
   * @param condition defines the trigger related conditions
   */
  constructor(e, t, i, s, r) {
    super(e, r), this.propertyPath = i, this.value = s, this._target = this._effectiveTarget = t;
  }
  /** @internal */
  _prepare() {
    this._effectiveTarget = this._getEffectiveTarget(this._effectiveTarget, this.propertyPath), this._property = this._getProperty(this.propertyPath), typeof this._effectiveTarget[this._property] != "number" && w.Warn("Warning: IncrementValueAction can only be used with number values");
  }
  /**
   * Execute the action and increment the target of the value amount.
   */
  execute() {
    this._effectiveTarget[this._property] += this.value, this._target.markAsDirty && this._target.markAsDirty(this._property);
  }
  /**
   * Serializes the actions and its related information.
   * @param parent defines the object to serialize in
   * @returns the serialized object
   */
  serialize(e) {
    return super._serialize({
      name: "IncrementValueAction",
      properties: [
        Qe._GetTargetProperty(this._target),
        { name: "propertyPath", value: this.propertyPath },
        { name: "value", value: Qe._SerializeValueAsString(this.value) }
      ]
    }, e);
  }
}
class Sh extends Qe {
  /**
   * Instantiate the action
   * @param triggerOptions defines the trigger options
   * @param target defines the target animation or animation name
   * @param from defines from where the animation should start (animation frame)
   * @param to defines where the animation should stop (animation frame)
   * @param loop defines if the animation should loop or stop after the first play
   * @param condition defines the trigger related conditions
   */
  constructor(e, t, i, s, r, n) {
    super(e, n), this.from = i, this.to = s, this.loop = r, this._target = t;
  }
  /** @internal */
  _prepare() {
  }
  /**
   * Execute the action and play the animation.
   */
  execute() {
    this._actionManager.getScene().beginAnimation(this._target, this.from, this.to, this.loop);
  }
  /**
   * Serializes the actions and its related information.
   * @param parent defines the object to serialize in
   * @returns the serialized object
   */
  serialize(e) {
    return super._serialize({
      name: "PlayAnimationAction",
      properties: [
        Qe._GetTargetProperty(this._target),
        { name: "from", value: String(this.from) },
        { name: "to", value: String(this.to) },
        { name: "loop", value: Qe._SerializeValueAsString(this.loop) || !1 }
      ]
    }, e);
  }
}
class Rh extends Qe {
  /**
   * Instantiate the action
   * @param triggerOptions defines the trigger options
   * @param target defines the target animation or animation name
   * @param condition defines the trigger related conditions
   */
  constructor(e, t, i) {
    super(e, i), this._target = t;
  }
  /** @internal */
  _prepare() {
  }
  /**
   * Execute the action and stop the animation.
   */
  execute() {
    this._actionManager.getScene().stopAnimation(this._target);
  }
  /**
   * Serializes the actions and its related information.
   * @param parent defines the object to serialize in
   * @returns the serialized object
   */
  serialize(e) {
    return super._serialize({
      name: "StopAnimationAction",
      properties: [Qe._GetTargetProperty(this._target)]
    }, e);
  }
}
class to extends Qe {
  /**
   * Instantiate the action
   * @param triggerOptions defines the trigger options
   * @param condition defines the trigger related conditions
   */
  constructor(e = 0, t) {
    super(e, t);
  }
  /**
   * Execute the action and do nothing.
   */
  execute() {
  }
  /**
   * Serializes the actions and its related information.
   * @param parent defines the object to serialize in
   * @returns the serialized object
   */
  serialize(e) {
    return super._serialize({
      name: "DoNothingAction",
      properties: []
    }, e);
  }
}
class Ih extends Qe {
  /**
   * Instantiate the action
   * @param triggerOptions defines the trigger options
   * @param children defines the list of aggregated animations to run
   * @param condition defines the trigger related conditions
   * @param enableChildrenConditions defines if the children actions conditions should be check before execution
   */
  constructor(e, t, i, s = !0) {
    super(e, i), this.children = t, this.enableChildrenConditions = s;
  }
  /** @internal */
  _prepare() {
    for (let e = 0; e < this.children.length; e++)
      this.children[e]._actionManager = this._actionManager, this.children[e]._prepare();
  }
  /**
   * Execute the action and executes all the aggregated actions.
   * @param evt
   */
  execute(e) {
    for (const t of this.children)
      (!this.enableChildrenConditions || t._evaluateConditionForCurrentFrame()) && t.execute(e);
  }
  /**
   * Serializes the actions and its related information.
   * @param parent defines the object to serialize in
   * @returns the serialized object
   */
  serialize(e) {
    const t = super._serialize({
      name: "CombineAction",
      properties: [],
      combine: []
    }, e);
    for (let i = 0; i < this.children.length; i++)
      t.combine.push(this.children[i].serialize(null));
    return t;
  }
}
class Ph extends Qe {
  /**
   * Instantiate the action
   * @param triggerOptions defines the trigger options
   * @param func defines the callback function to run
   * @param condition defines the trigger related conditions
   */
  constructor(e, t, i) {
    super(e, i), this.func = t;
  }
  /**
   * Execute the action and run the attached code.
   * @param evt
   */
  execute(e) {
    this.func(e);
  }
}
class io extends Qe {
  /**
   * Instantiate the action
   * @param triggerOptions defines the trigger options
   * @param target defines the target containing the parent property
   * @param parent defines from where the animation should start (animation frame)
   * @param condition defines the trigger related conditions
   */
  constructor(e, t, i, s) {
    super(e, s), this._target = t, this._parent = i;
  }
  /** @internal */
  _prepare() {
  }
  /**
   * Execute the action and set the parent property.
   */
  execute() {
    if (this._target.parent === this._parent)
      return;
    const e = this._parent.getWorldMatrix().clone();
    e.invert(), this._target.position = p.TransformCoordinates(this._target.position, e), this._target.parent = this._parent;
  }
  /**
   * Serializes the actions and its related information.
   * @param parent defines the object to serialize in
   * @returns the serialized object
   */
  serialize(e) {
    return super._serialize({
      name: "SetParentAction",
      properties: [Qe._GetTargetProperty(this._target), Qe._GetTargetProperty(this._parent)]
    }, e);
  }
}
Xe("BABYLON.SetParentAction", io);
Xe("BABYLON.ExecuteCodeAction", Ph);
Xe("BABYLON.DoNothingAction", to);
Xe("BABYLON.StopAnimationAction", Rh);
Xe("BABYLON.PlayAnimationAction", Sh);
Xe("BABYLON.IncrementValueAction", Mh);
Xe("BABYLON.SetValueAction", Eh);
Xe("BABYLON.SetStateAction", Ah);
Xe("BABYLON.SetParentAction", io);
Xe("BABYLON.SwitchBooleanAction", Th);
Xe("BABYLON.CombineAction", Ih);
class Ce extends Wt {
  /**
   * Creates a new action manager
   * @param scene defines the hosting scene
   */
  constructor(e) {
    super(), e = e || de.LastCreatedScene, e && (this._scene = e, e.actionManagers.push(this));
  }
  // Methods
  /**
   * Releases all associated resources
   */
  dispose() {
    const e = this._scene.actionManagers.indexOf(this);
    for (let i = 0; i < this.actions.length; i++) {
      const s = this.actions[i];
      Ce.Triggers[s.trigger]--, Ce.Triggers[s.trigger] === 0 && delete Ce.Triggers[s.trigger];
    }
    this.actions.length = 0, e > -1 && this._scene.actionManagers.splice(e, 1);
    const t = this._scene.meshes.find((i) => i.actionManager === this);
    t && (t.actionManager = null);
  }
  /**
   * Gets hosting scene
   * @returns the hosting scene
   */
  getScene() {
    return this._scene;
  }
  /**
   * Does this action manager handles actions of any of the given triggers
   * @param triggers defines the triggers to be tested
   * @returns a boolean indicating whether one (or more) of the triggers is handled
   */
  hasSpecificTriggers(e) {
    for (let t = 0; t < this.actions.length; t++) {
      const i = this.actions[t];
      if (e.indexOf(i.trigger) > -1)
        return !0;
    }
    return !1;
  }
  /**
   * Does this action manager handles actions of any of the given triggers. This function takes two arguments for
   * speed.
   * @param triggerA defines the trigger to be tested
   * @param triggerB defines the trigger to be tested
   * @returns a boolean indicating whether one (or more) of the triggers is handled
   */
  hasSpecificTriggers2(e, t) {
    for (let i = 0; i < this.actions.length; i++) {
      const s = this.actions[i];
      if (e == s.trigger || t == s.trigger)
        return !0;
    }
    return !1;
  }
  /**
   * Does this action manager handles actions of a given trigger
   * @param trigger defines the trigger to be tested
   * @param parameterPredicate defines an optional predicate to filter triggers by parameter
   * @returns whether the trigger is handled
   */
  hasSpecificTrigger(e, t) {
    for (let i = 0; i < this.actions.length; i++) {
      const s = this.actions[i];
      if (s.trigger === e)
        if (t) {
          if (t(s.getTriggerParameter()))
            return !0;
        } else
          return !0;
    }
    return !1;
  }
  /**
   * Does this action manager has pointer triggers
   */
  get hasPointerTriggers() {
    for (let e = 0; e < this.actions.length; e++) {
      const t = this.actions[e];
      if (t.trigger >= Ce.OnPickTrigger && t.trigger <= Ce.OnPointerOutTrigger)
        return !0;
    }
    return !1;
  }
  /**
   * Does this action manager has pick triggers
   */
  get hasPickTriggers() {
    for (let e = 0; e < this.actions.length; e++) {
      const t = this.actions[e];
      if (t.trigger >= Ce.OnPickTrigger && t.trigger <= Ce.OnPickUpTrigger)
        return !0;
    }
    return !1;
  }
  /**
   * Registers an action to this action manager
   * @param action defines the action to be registered
   * @returns the action amended (prepared) after registration
   */
  registerAction(e) {
    return e.trigger === Ce.OnEveryFrameTrigger && this.getScene().actionManager !== this ? (w.Warn("OnEveryFrameTrigger can only be used with scene.actionManager"), null) : (this.actions.push(e), this.getScene()._registeredActions++, Ce.Triggers[e.trigger] ? Ce.Triggers[e.trigger]++ : Ce.Triggers[e.trigger] = 1, e._actionManager = this, e._prepare(), e);
  }
  /**
   * Unregisters an action to this action manager
   * @param action defines the action to be unregistered
   * @returns a boolean indicating whether the action has been unregistered
   */
  unregisterAction(e) {
    const t = this.actions.indexOf(e);
    return t !== -1 ? (this.actions.splice(t, 1), Ce.Triggers[e.trigger] -= 1, Ce.Triggers[e.trigger] === 0 && delete Ce.Triggers[e.trigger], e._actionManager = null, this.getScene()._registeredActions--, !0) : !1;
  }
  /**
   * Process a specific trigger
   * @param trigger defines the trigger to process
   * @param evt defines the event details to be processed
   */
  processTrigger(e, t) {
    for (let i = 0; i < this.actions.length; i++) {
      const s = this.actions[i];
      if (s.trigger === e) {
        if (t && (e === Ce.OnKeyUpTrigger || e === Ce.OnKeyDownTrigger)) {
          const r = s.getTriggerParameter();
          if (typeof r == "function") {
            if (!r(t))
              continue;
          } else if (r && r !== t.sourceEvent.keyCode) {
            if (!r.toLowerCase)
              continue;
            const n = r.toLowerCase();
            if (n !== t.sourceEvent.key) {
              const a = t.sourceEvent.charCode ? t.sourceEvent.charCode : t.sourceEvent.keyCode;
              if (String.fromCharCode(a).toLowerCase() !== n)
                continue;
            }
          }
        }
        s._executeCurrent(t);
      }
    }
  }
  /**
   * @internal
   */
  _getEffectiveTarget(e, t) {
    const i = t.split(".");
    for (let s = 0; s < i.length - 1; s++)
      e = e[i[s]];
    return e;
  }
  /**
   * @internal
   */
  _getProperty(e) {
    const t = e.split(".");
    return t[t.length - 1];
  }
  /**
   * Serialize this manager to a JSON object
   * @param name defines the property name to store this manager
   * @returns a JSON representation of this manager
   */
  serialize(e) {
    const t = {
      children: new Array(),
      name: e,
      type: 3,
      properties: new Array()
      // Empty for root but required
    };
    for (let i = 0; i < this.actions.length; i++) {
      const s = {
        type: 0,
        children: new Array(),
        name: Ce.GetTriggerName(this.actions[i].trigger),
        properties: new Array()
      }, r = this.actions[i].triggerOptions;
      if (r && typeof r != "number")
        if (r.parameter instanceof Node)
          s.properties.push(Qe._GetTargetProperty(r.parameter));
        else if (typeof r.parameter == "object") {
          const n = {};
          js.DeepCopy(r.parameter, n, ["mesh"]), r.parameter && r.parameter.mesh && (n._meshId = r.parameter.mesh.id), s.properties.push({ name: "parameter", targetType: null, value: n });
        } else
          s.properties.push({ name: "parameter", targetType: null, value: r.parameter });
      this.actions[i].serialize(s), t.children.push(s);
    }
    return t;
  }
  /**
   * Creates a new ActionManager from a JSON data
   * @param parsedActions defines the JSON data to read from
   * @param object defines the hosting mesh
   * @param scene defines the hosting scene
   */
  static Parse(e, t, i) {
    const s = new Ce(i);
    t === null ? i.actionManager = s : t.actionManager = s;
    const r = (o, l) => {
      const c = si("BABYLON." + o);
      return c && new c(...l);
    }, n = (o, l, c, u) => {
      if (u === null) {
        const g = parseFloat(l);
        return l === "true" || l === "false" ? l === "true" : isNaN(g) ? l : g;
      }
      const d = u.split("."), f = l.split(",");
      for (let g = 0; g < d.length; g++)
        c = c[d[g]];
      if (typeof c == "boolean")
        return f[0] === "true";
      if (typeof c == "string")
        return f[0];
      const _ = new Array();
      for (let g = 0; g < f.length; g++)
        _.push(parseFloat(f[g]));
      return c instanceof p ? p.FromArray(_) : c instanceof ze ? ze.FromArray(_) : c instanceof ie ? ie.FromArray(_) : c instanceof ye ? ye.FromArray(_) : parseFloat(f[0]);
    }, a = (o, l, c, u, d = null) => {
      if (o.detached)
        return;
      const f = new Array();
      let _ = null, g = null;
      const m = o.combine && o.combine.length > 0;
      if (o.type === 2 ? f.push(s) : f.push(l), m) {
        const x = new Array();
        for (let A = 0; A < o.combine.length; A++)
          a(o.combine[A], Ce.NothingTrigger, c, u, x);
        f.push(x);
      } else
        for (let x = 0; x < o.properties.length; x++) {
          let A = o.properties[x].value;
          const T = o.properties[x].name, M = o.properties[x].targetType;
          T === "target" ? M === "SceneProperties" ? A = _ = i : M === "MaterialProperties" ? A = _ = i.getMaterialByName(A) : A = _ = i.getNodeByName(A) : T === "parent" ? A = i.getNodeByName(A) : T === "sound" ? i.getSoundByName && (A = i.getSoundByName(A)) : T !== "propertyPath" ? o.type === 2 && T === "operator" ? A = nt[A] : A = n(T, A, _, T === "value" ? g : null) : g = A, f.push(A);
        }
      if (d === null ? f.push(c) : f.push(null), o.name === "InterpolateValueAction") {
        const x = f[f.length - 2];
        f[f.length - 1] = x, f[f.length - 2] = c;
      }
      let y = r(o.name, f);
      if (y instanceof Vs && c !== null) {
        const x = new to(l, c);
        u ? u.then(x) : s.registerAction(x), u = x;
      }
      d === null ? y instanceof Vs ? (c = y, y = u) : (c = null, u ? u.then(y) : s.registerAction(y)) : d.push(y);
      for (let x = 0; x < o.children.length; x++)
        a(o.children[x], l, c, y, null);
    };
    for (let o = 0; o < e.children.length; o++) {
      let l;
      const c = e.children[o];
      if (c.properties.length > 0) {
        const u = c.properties[0].value, d = c.properties[0].targetType === null ? u : i.getMeshByName(u);
        d._meshId && (d.mesh = i.getMeshById(d._meshId)), l = { trigger: Ce[c.name], parameter: d };
      } else
        l = Ce[c.name];
      for (let u = 0; u < c.children.length; u++)
        c.detached || a(c.children[u], l, null, null);
    }
  }
  /**
   * Get a trigger name by index
   * @param trigger defines the trigger index
   * @returns a trigger name
   */
  static GetTriggerName(e) {
    switch (e) {
      case 0:
        return "NothingTrigger";
      case 1:
        return "OnPickTrigger";
      case 2:
        return "OnLeftPickTrigger";
      case 3:
        return "OnRightPickTrigger";
      case 4:
        return "OnCenterPickTrigger";
      case 5:
        return "OnPickDownTrigger";
      case 6:
        return "OnDoublePickTrigger";
      case 7:
        return "OnPickUpTrigger";
      case 8:
        return "OnLongPressTrigger";
      case 9:
        return "OnPointerOverTrigger";
      case 10:
        return "OnPointerOutTrigger";
      case 11:
        return "OnEveryFrameTrigger";
      case 12:
        return "OnIntersectionEnterTrigger";
      case 13:
        return "OnIntersectionExitTrigger";
      case 14:
        return "OnKeyDownTrigger";
      case 15:
        return "OnKeyUpTrigger";
      case 16:
        return "OnPickOutTrigger";
      default:
        return "";
    }
  }
}
Ce.NothingTrigger = 0;
Ce.OnPickTrigger = 1;
Ce.OnLeftPickTrigger = 2;
Ce.OnRightPickTrigger = 3;
Ce.OnCenterPickTrigger = 4;
Ce.OnPickDownTrigger = 5;
Ce.OnDoublePickTrigger = 6;
Ce.OnPickUpTrigger = 7;
Ce.OnPickOutTrigger = 16;
Ce.OnLongPressTrigger = 8;
Ce.OnPointerOverTrigger = 9;
Ce.OnPointerOutTrigger = 10;
Ce.OnEveryFrameTrigger = 11;
Ce.OnIntersectionEnterTrigger = 12;
Ce.OnIntersectionExitTrigger = 13;
Ce.OnKeyDownTrigger = 14;
Ce.OnKeyUpTrigger = 15;
class We extends ut {
  /** @internal */
  get _matrix() {
    return this._compose(), this._localMatrix;
  }
  /** @internal */
  set _matrix(e) {
    e.updateFlag === this._localMatrix.updateFlag && !this._needToCompose || (this._needToCompose = !1, this._localMatrix.copyFrom(e), this._markAsDirtyAndDecompose());
  }
  /**
   * Create a new bone
   * @param name defines the bone name
   * @param skeleton defines the parent skeleton
   * @param parentBone defines the parent (can be null if the bone is the root)
   * @param localMatrix defines the local matrix (default: identity)
   * @param restMatrix defines the rest matrix (default: localMatrix)
   * @param bindMatrix defines the bind matrix (default: localMatrix)
   * @param index defines index of the bone in the hierarchy (default: null)
   */
  constructor(e, t, i = null, s = null, r = null, n = null, a = null) {
    var o;
    super(e, t.getScene()), this.name = e, this.children = new Array(), this.animations = new Array(), this._index = null, this._scalingDeterminant = 1, this._needToDecompose = !0, this._needToCompose = !1, this._linkedTransformNode = null, this._waitingTransformNodeId = null, this._skeleton = t, this._localMatrix = (o = s == null ? void 0 : s.clone()) !== null && o !== void 0 ? o : I.Identity(), this._restMatrix = r ?? this._localMatrix.clone(), this._bindMatrix = n ?? this._localMatrix.clone(), this._index = a, this._absoluteMatrix = new I(), this._absoluteBindMatrix = new I(), this._absoluteInverseBindMatrix = new I(), this._finalMatrix = new I(), t.bones.push(this), this.setParent(i, !1), this._updateAbsoluteBindMatrices();
  }
  /**
   * Gets the current object class name.
   * @returns the class name
   */
  getClassName() {
    return "Bone";
  }
  // Members
  /**
   * Gets the parent skeleton
   * @returns a skeleton
   */
  getSkeleton() {
    return this._skeleton;
  }
  get parent() {
    return this._parentNode;
  }
  /**
   * Gets parent bone
   * @returns a bone or null if the bone is the root of the bone hierarchy
   */
  getParent() {
    return this.parent;
  }
  /**
   * Returns an array containing the children of the bone
   * @returns an array containing the children of the bone (can be empty if the bone has no children)
   */
  getChildren() {
    return this.children;
  }
  /**
   * Gets the node index in matrix array generated for rendering
   * @returns the node index
   */
  getIndex() {
    return this._index === null ? this.getSkeleton().bones.indexOf(this) : this._index;
  }
  set parent(e) {
    this.setParent(e);
  }
  /**
   * Sets the parent bone
   * @param parent defines the parent (can be null if the bone is the root)
   * @param updateAbsoluteBindMatrices defines if the absolute bind and absolute inverse bind matrices must be updated
   */
  setParent(e, t = !0) {
    if (this.parent !== e) {
      if (this.parent) {
        const i = this.parent.children.indexOf(this);
        i !== -1 && this.parent.children.splice(i, 1);
      }
      this._parentNode = e, this.parent && this.parent.children.push(this), t && this._updateAbsoluteBindMatrices(), this.markAsDirty();
    }
  }
  /**
   * Gets the local matrix
   * @returns the local matrix
   */
  getLocalMatrix() {
    return this._compose(), this._localMatrix;
  }
  /**
   * Gets the bind matrix
   * @returns the bind matrix
   */
  getBindMatrix() {
    return this._bindMatrix;
  }
  /**
   * Gets the bind matrix.
   * @returns the bind matrix
   * @deprecated Please use getBindMatrix instead
   */
  getBaseMatrix() {
    return this.getBindMatrix();
  }
  /**
   * Gets the rest matrix
   * @returns the rest matrix
   */
  getRestMatrix() {
    return this._restMatrix;
  }
  /**
   * Gets the rest matrix
   * @returns the rest matrix
   * @deprecated Please use getRestMatrix instead
   */
  getRestPose() {
    return this.getRestMatrix();
  }
  /**
   * Sets the rest matrix
   * @param matrix the local-space rest matrix to set for this bone
   */
  setRestMatrix(e) {
    this._restMatrix.copyFrom(e);
  }
  /**
   * Sets the rest matrix
   * @param matrix the local-space rest to set for this bone
   * @deprecated Please use setRestMatrix instead
   */
  setRestPose(e) {
    this.setRestMatrix(e);
  }
  /**
   * Gets the bind matrix
   * @returns the bind matrix
   * @deprecated Please use getBindMatrix instead
   */
  getBindPose() {
    return this.getBindMatrix();
  }
  /**
   * Sets the bind matrix
   * This will trigger a recomputation of the absolute bind and absolute inverse bind matrices for this bone and its children
   * Note that the local matrix will also be set with the matrix passed in parameter!
   * @param matrix the local-space bind matrix to set for this bone
   */
  setBindMatrix(e) {
    this.updateMatrix(e);
  }
  /**
   * Sets the bind matrix
   * @param matrix the local-space bind to set for this bone
   * @deprecated Please use setBindMatrix instead
   */
  setBindPose(e) {
    this.setBindMatrix(e);
  }
  /**
   * Gets the matrix used to store the final world transformation of the bone (ie. the matrix sent to shaders)
   */
  getFinalMatrix() {
    return this._finalMatrix;
  }
  /**
   * Gets the matrix used to store the final world transformation of the bone (ie. the matrix sent to shaders)
   * @deprecated Please use getFinalMatrix instead
   */
  getWorldMatrix() {
    return this.getFinalMatrix();
  }
  /**
   * Sets the local matrix to the rest matrix
   */
  returnToRest() {
    var e;
    if (this._linkedTransformNode) {
      const t = C.Vector3[0], i = C.Quaternion[0], s = C.Vector3[1];
      this.getRestMatrix().decompose(t, i, s), this._linkedTransformNode.position.copyFrom(s), this._linkedTransformNode.rotationQuaternion = (e = this._linkedTransformNode.rotationQuaternion) !== null && e !== void 0 ? e : U.Identity(), this._linkedTransformNode.rotationQuaternion.copyFrom(i), this._linkedTransformNode.scaling.copyFrom(t);
    } else
      this._matrix = this._restMatrix;
  }
  /**
   * Gets the inverse of the bind matrix, in world space (relative to the skeleton root)
   * @returns the inverse bind matrix, in world space
   */
  getAbsoluteInverseBindMatrix() {
    return this._absoluteInverseBindMatrix;
  }
  /**
   * Gets the inverse of the bind matrix, in world space (relative to the skeleton root)
   * @returns the inverse bind matrix, in world space
   * @deprecated Please use getAbsoluteInverseBindMatrix instead
   */
  getInvertedAbsoluteTransform() {
    return this.getAbsoluteInverseBindMatrix();
  }
  /**
   * Gets the bone matrix, in world space (relative to the skeleton root)
   * @returns the bone matrix, in world space
   */
  getAbsoluteMatrix() {
    return this._absoluteMatrix;
  }
  /**
   * Gets the bone matrix, in world space (relative to the skeleton root)
   * @returns the bone matrix, in world space
   * @deprecated Please use getAbsoluteMatrix instead
   */
  getAbsoluteTransform() {
    return this._absoluteMatrix;
  }
  /**
   * Links with the given transform node.
   * The local matrix of this bone is overwritten by the transform of the node every frame.
   * @param transformNode defines the transform node to link to
   */
  linkTransformNode(e) {
    this._linkedTransformNode && this._skeleton._numBonesWithLinkedTransformNode--, this._linkedTransformNode = e, this._linkedTransformNode && this._skeleton._numBonesWithLinkedTransformNode++;
  }
  // Properties (matches TransformNode properties)
  /**
   * Gets the node used to drive the bone's transformation
   * @returns a transform node or null
   */
  getTransformNode() {
    return this._linkedTransformNode;
  }
  /** Gets or sets current position (in local space) */
  get position() {
    return this._decompose(), this._localPosition;
  }
  set position(e) {
    this._decompose(), this._localPosition.copyFrom(e), this._markAsDirtyAndCompose();
  }
  /** Gets or sets current rotation (in local space) */
  get rotation() {
    return this.getRotation();
  }
  set rotation(e) {
    this.setRotation(e);
  }
  /** Gets or sets current rotation quaternion (in local space) */
  get rotationQuaternion() {
    return this._decompose(), this._localRotation;
  }
  set rotationQuaternion(e) {
    this.setRotationQuaternion(e);
  }
  /** Gets or sets current scaling (in local space) */
  get scaling() {
    return this.getScale();
  }
  set scaling(e) {
    this.setScale(e);
  }
  /**
   * Gets the animation properties override
   */
  get animationPropertiesOverride() {
    return this._skeleton.animationPropertiesOverride;
  }
  // Methods
  _decompose() {
    this._needToDecompose && (this._needToDecompose = !1, this._localScaling || (this._localScaling = p.Zero(), this._localRotation = U.Zero(), this._localPosition = p.Zero()), this._localMatrix.decompose(this._localScaling, this._localRotation, this._localPosition));
  }
  _compose() {
    if (this._needToCompose) {
      if (!this._localScaling) {
        this._needToCompose = !1;
        return;
      }
      this._needToCompose = !1, I.ComposeToRef(this._localScaling, this._localRotation, this._localPosition, this._localMatrix);
    }
  }
  /**
   * Update the bind (and optionally the local) matrix
   * @param bindMatrix defines the new matrix to set to the bind/local matrix, in local space
   * @param updateAbsoluteBindMatrices defines if the absolute bind and absolute inverse bind matrices must be recomputed (default: true)
   * @param updateLocalMatrix defines if the local matrix should also be updated with the matrix passed in parameter (default: true)
   */
  updateMatrix(e, t = !0, i = !0) {
    this._bindMatrix.copyFrom(e), t && this._updateAbsoluteBindMatrices(), i ? this._matrix = e : this.markAsDirty();
  }
  /**
   * @internal
   */
  _updateAbsoluteBindMatrices(e, t = !0) {
    if (e || (e = this._bindMatrix), this.parent ? e.multiplyToRef(this.parent._absoluteBindMatrix, this._absoluteBindMatrix) : this._absoluteBindMatrix.copyFrom(e), this._absoluteBindMatrix.invertToRef(this._absoluteInverseBindMatrix), t)
      for (let i = 0; i < this.children.length; i++)
        this.children[i]._updateAbsoluteBindMatrices();
    this._scalingDeterminant = this._absoluteBindMatrix.determinant() < 0 ? -1 : 1;
  }
  /**
   * Flag the bone as dirty (Forcing it to update everything)
   * @returns this bone
   */
  markAsDirty() {
    return this._currentRenderId++, this._childUpdateId++, this._skeleton._markAsDirty(), this;
  }
  /** @internal */
  _markAsDirtyAndCompose() {
    this.markAsDirty(), this._needToCompose = !0;
  }
  _markAsDirtyAndDecompose() {
    this.markAsDirty(), this._needToDecompose = !0;
  }
  _updatePosition(e, t = Pe.LOCAL, i, s = !0) {
    const r = this.getLocalMatrix();
    if (t == Pe.LOCAL)
      s ? (r.addAtIndex(12, e.x), r.addAtIndex(13, e.y), r.addAtIndex(14, e.z)) : r.setTranslationFromFloats(e.x, e.y, e.z);
    else {
      let n = null;
      i && (n = i.getWorldMatrix()), this._skeleton.computeAbsoluteMatrices();
      const a = We._TmpMats[0], o = We._TmpVecs[0];
      this.parent ? i && n ? (a.copyFrom(this.parent.getAbsoluteMatrix()), a.multiplyToRef(n, a)) : a.copyFrom(this.parent.getAbsoluteMatrix()) : I.IdentityToRef(a), s && a.setTranslationFromFloats(0, 0, 0), a.invert(), p.TransformCoordinatesToRef(e, a, o), s ? (r.addAtIndex(12, o.x), r.addAtIndex(13, o.y), r.addAtIndex(14, o.z)) : r.setTranslationFromFloats(o.x, o.y, o.z);
    }
    this._markAsDirtyAndDecompose();
  }
  /**
   * Translate the bone in local or world space
   * @param vec The amount to translate the bone
   * @param space The space that the translation is in (default: Space.LOCAL)
   * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
   */
  translate(e, t = Pe.LOCAL, i) {
    this._updatePosition(e, t, i, !0);
  }
  /**
   * Set the position of the bone in local or world space
   * @param position The position to set the bone
   * @param space The space that the position is in (default: Space.LOCAL)
   * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
   */
  setPosition(e, t = Pe.LOCAL, i) {
    this._updatePosition(e, t, i, !1);
  }
  /**
   * Set the absolute position of the bone (world space)
   * @param position The position to set the bone
   * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
   */
  setAbsolutePosition(e, t) {
    this.setPosition(e, Pe.WORLD, t);
  }
  /**
   * Scale the bone on the x, y and z axes (in local space)
   * @param x The amount to scale the bone on the x axis
   * @param y The amount to scale the bone on the y axis
   * @param z The amount to scale the bone on the z axis
   * @param scaleChildren sets this to true if children of the bone should be scaled as well (false by default)
   */
  scale(e, t, i, s = !1) {
    const r = this.getLocalMatrix(), n = We._TmpMats[0];
    I.ScalingToRef(e, t, i, n), n.multiplyToRef(r, r), n.invert();
    for (const a of this.children) {
      const o = a.getLocalMatrix();
      o.multiplyToRef(n, o), o.multiplyAtIndex(12, e), o.multiplyAtIndex(13, t), o.multiplyAtIndex(14, i), a._markAsDirtyAndDecompose();
    }
    if (this._markAsDirtyAndDecompose(), s)
      for (const a of this.children)
        a.scale(e, t, i, s);
  }
  /**
   * Set the bone scaling in local space
   * @param scale defines the scaling vector
   */
  setScale(e) {
    this._decompose(), this._localScaling.copyFrom(e), this._markAsDirtyAndCompose();
  }
  /**
   * Gets the current scaling in local space
   * @returns the current scaling vector
   */
  getScale() {
    return this._decompose(), this._localScaling;
  }
  /**
   * Gets the current scaling in local space and stores it in a target vector
   * @param result defines the target vector
   */
  getScaleToRef(e) {
    this._decompose(), e.copyFrom(this._localScaling);
  }
  /**
   * Set the yaw, pitch, and roll of the bone in local or world space
   * @param yaw The rotation of the bone on the y axis
   * @param pitch The rotation of the bone on the x axis
   * @param roll The rotation of the bone on the z axis
   * @param space The space that the axes of rotation are in
   * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
   */
  setYawPitchRoll(e, t, i, s = Pe.LOCAL, r) {
    if (s === Pe.LOCAL) {
      const o = We._TmpQuat;
      U.RotationYawPitchRollToRef(e, t, i, o), this.setRotationQuaternion(o, s, r);
      return;
    }
    const n = We._TmpMats[0];
    if (!this._getAbsoluteInverseMatrixUnscaledToRef(n, r))
      return;
    const a = We._TmpMats[1];
    I.RotationYawPitchRollToRef(e, t, i, a), n.multiplyToRef(a, a), this._rotateWithMatrix(a, s, r);
  }
  /**
   * Add a rotation to the bone on an axis in local or world space
   * @param axis The axis to rotate the bone on
   * @param amount The amount to rotate the bone
   * @param space The space that the axis is in
   * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
   */
  rotate(e, t, i = Pe.LOCAL, s) {
    const r = We._TmpMats[0];
    r.setTranslationFromFloats(0, 0, 0), I.RotationAxisToRef(e, t, r), this._rotateWithMatrix(r, i, s);
  }
  /**
   * Set the rotation of the bone to a particular axis angle in local or world space
   * @param axis The axis to rotate the bone on
   * @param angle The angle that the bone should be rotated to
   * @param space The space that the axis is in
   * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
   */
  setAxisAngle(e, t, i = Pe.LOCAL, s) {
    if (i === Pe.LOCAL) {
      const a = We._TmpQuat;
      U.RotationAxisToRef(e, t, a), this.setRotationQuaternion(a, i, s);
      return;
    }
    const r = We._TmpMats[0];
    if (!this._getAbsoluteInverseMatrixUnscaledToRef(r, s))
      return;
    const n = We._TmpMats[1];
    I.RotationAxisToRef(e, t, n), r.multiplyToRef(n, n), this._rotateWithMatrix(n, i, s);
  }
  /**
   * Set the euler rotation of the bone in local or world space
   * @param rotation The euler rotation that the bone should be set to
   * @param space The space that the rotation is in
   * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
   */
  setRotation(e, t = Pe.LOCAL, i) {
    this.setYawPitchRoll(e.y, e.x, e.z, t, i);
  }
  /**
   * Set the quaternion rotation of the bone in local or world space
   * @param quat The quaternion rotation that the bone should be set to
   * @param space The space that the rotation is in
   * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
   */
  setRotationQuaternion(e, t = Pe.LOCAL, i) {
    if (t === Pe.LOCAL) {
      this._decompose(), this._localRotation.copyFrom(e), this._markAsDirtyAndCompose();
      return;
    }
    const s = We._TmpMats[0];
    if (!this._getAbsoluteInverseMatrixUnscaledToRef(s, i))
      return;
    const r = We._TmpMats[1];
    I.FromQuaternionToRef(e, r), s.multiplyToRef(r, r), this._rotateWithMatrix(r, t, i);
  }
  /**
   * Set the rotation matrix of the bone in local or world space
   * @param rotMat The rotation matrix that the bone should be set to
   * @param space The space that the rotation is in
   * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
   */
  setRotationMatrix(e, t = Pe.LOCAL, i) {
    if (t === Pe.LOCAL) {
      const n = We._TmpQuat;
      U.FromRotationMatrixToRef(e, n), this.setRotationQuaternion(n, t, i);
      return;
    }
    const s = We._TmpMats[0];
    if (!this._getAbsoluteInverseMatrixUnscaledToRef(s, i))
      return;
    const r = We._TmpMats[1];
    r.copyFrom(e), s.multiplyToRef(e, r), this._rotateWithMatrix(r, t, i);
  }
  _rotateWithMatrix(e, t = Pe.LOCAL, i) {
    const s = this.getLocalMatrix(), r = s.m[12], n = s.m[13], a = s.m[14], o = this.getParent(), l = We._TmpMats[3], c = We._TmpMats[4];
    o && t == Pe.WORLD ? (i ? (l.copyFrom(i.getWorldMatrix()), o.getAbsoluteMatrix().multiplyToRef(l, l)) : l.copyFrom(o.getAbsoluteMatrix()), c.copyFrom(l), c.invert(), s.multiplyToRef(l, s), s.multiplyToRef(e, s), s.multiplyToRef(c, s)) : t == Pe.WORLD && i ? (l.copyFrom(i.getWorldMatrix()), c.copyFrom(l), c.invert(), s.multiplyToRef(l, s), s.multiplyToRef(e, s), s.multiplyToRef(c, s)) : s.multiplyToRef(e, s), s.setTranslationFromFloats(r, n, a), this.computeAbsoluteMatrices(), this._markAsDirtyAndDecompose();
  }
  _getAbsoluteInverseMatrixUnscaledToRef(e, t) {
    const i = We._TmpMats[2];
    return e.copyFrom(this.getAbsoluteMatrix()), t ? (e.multiplyToRef(t.getWorldMatrix(), e), I.ScalingToRef(t.scaling.x, t.scaling.y, t.scaling.z, i)) : I.IdentityToRef(i), e.invert(), isNaN(e.m[0]) ? !1 : (i.multiplyAtIndex(0, this._scalingDeterminant), e.multiplyToRef(i, e), !0);
  }
  /**
   * Get the position of the bone in local or world space
   * @param space The space that the returned position is in
   * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
   * @returns The position of the bone
   */
  getPosition(e = Pe.LOCAL, t = null) {
    const i = p.Zero();
    return this.getPositionToRef(e, t, i), i;
  }
  /**
   * Copy the position of the bone to a vector3 in local or world space
   * @param space The space that the returned position is in
   * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
   * @param result The vector3 to copy the position to
   */
  getPositionToRef(e = Pe.LOCAL, t, i) {
    if (e == Pe.LOCAL) {
      const s = this.getLocalMatrix();
      i.x = s.m[12], i.y = s.m[13], i.z = s.m[14];
    } else {
      let s = null;
      t && (s = t.getWorldMatrix()), this._skeleton.computeAbsoluteMatrices();
      let r = We._TmpMats[0];
      t && s ? (r.copyFrom(this.getAbsoluteMatrix()), r.multiplyToRef(s, r)) : r = this.getAbsoluteMatrix(), i.x = r.m[12], i.y = r.m[13], i.z = r.m[14];
    }
  }
  /**
   * Get the absolute position of the bone (world space)
   * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
   * @returns The absolute position of the bone
   */
  getAbsolutePosition(e = null) {
    const t = p.Zero();
    return this.getPositionToRef(Pe.WORLD, e, t), t;
  }
  /**
   * Copy the absolute position of the bone (world space) to the result param
   * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
   * @param result The vector3 to copy the absolute position to
   */
  getAbsolutePositionToRef(e, t) {
    this.getPositionToRef(Pe.WORLD, e, t);
  }
  /**
   * Compute the absolute matrices of this bone and its children
   */
  computeAbsoluteMatrices() {
    if (this._compose(), this.parent)
      this._localMatrix.multiplyToRef(this.parent._absoluteMatrix, this._absoluteMatrix);
    else {
      this._absoluteMatrix.copyFrom(this._localMatrix);
      const i = this._skeleton.getPoseMatrix();
      i && this._absoluteMatrix.multiplyToRef(i, this._absoluteMatrix);
    }
    const e = this.children, t = e.length;
    for (let i = 0; i < t; i++)
      e[i].computeAbsoluteMatrices();
  }
  /**
   * Compute the absolute matrices of this bone and its children
   * @deprecated Please use computeAbsoluteMatrices instead
   */
  computeAbsoluteTransforms() {
    this.computeAbsoluteMatrices();
  }
  /**
   * Get the world direction from an axis that is in the local space of the bone
   * @param localAxis The local direction that is used to compute the world direction
   * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
   * @returns The world direction
   */
  getDirection(e, t = null) {
    const i = p.Zero();
    return this.getDirectionToRef(e, t, i), i;
  }
  /**
   * Copy the world direction to a vector3 from an axis that is in the local space of the bone
   * @param localAxis The local direction that is used to compute the world direction
   * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
   * @param result The vector3 that the world direction will be copied to
   */
  getDirectionToRef(e, t = null, i) {
    let s = null;
    t && (s = t.getWorldMatrix()), this._skeleton.computeAbsoluteMatrices();
    const r = We._TmpMats[0];
    r.copyFrom(this.getAbsoluteMatrix()), t && s && r.multiplyToRef(s, r), p.TransformNormalToRef(e, r, i), i.normalize();
  }
  /**
   * Get the euler rotation of the bone in local or world space
   * @param space The space that the rotation should be in
   * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
   * @returns The euler rotation
   */
  getRotation(e = Pe.LOCAL, t = null) {
    const i = p.Zero();
    return this.getRotationToRef(e, t, i), i;
  }
  /**
   * Copy the euler rotation of the bone to a vector3.  The rotation can be in either local or world space
   * @param space The space that the rotation should be in
   * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
   * @param result The vector3 that the rotation should be copied to
   */
  getRotationToRef(e = Pe.LOCAL, t = null, i) {
    const s = We._TmpQuat;
    this.getRotationQuaternionToRef(e, t, s), s.toEulerAnglesToRef(i);
  }
  /**
   * Get the quaternion rotation of the bone in either local or world space
   * @param space The space that the rotation should be in
   * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
   * @returns The quaternion rotation
   */
  getRotationQuaternion(e = Pe.LOCAL, t = null) {
    const i = U.Identity();
    return this.getRotationQuaternionToRef(e, t, i), i;
  }
  /**
   * Copy the quaternion rotation of the bone to a quaternion.  The rotation can be in either local or world space
   * @param space The space that the rotation should be in
   * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
   * @param result The quaternion that the rotation should be copied to
   */
  getRotationQuaternionToRef(e = Pe.LOCAL, t = null, i) {
    if (e == Pe.LOCAL)
      this._decompose(), i.copyFrom(this._localRotation);
    else {
      const s = We._TmpMats[0], r = this.getAbsoluteMatrix();
      t ? r.multiplyToRef(t.getWorldMatrix(), s) : s.copyFrom(r), s.multiplyAtIndex(0, this._scalingDeterminant), s.multiplyAtIndex(1, this._scalingDeterminant), s.multiplyAtIndex(2, this._scalingDeterminant), s.decompose(void 0, i, void 0);
    }
  }
  /**
   * Get the rotation matrix of the bone in local or world space
   * @param space The space that the rotation should be in
   * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
   * @returns The rotation matrix
   */
  getRotationMatrix(e = Pe.LOCAL, t) {
    const i = I.Identity();
    return this.getRotationMatrixToRef(e, t, i), i;
  }
  /**
   * Copy the rotation matrix of the bone to a matrix.  The rotation can be in either local or world space
   * @param space The space that the rotation should be in
   * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
   * @param result The quaternion that the rotation should be copied to
   */
  getRotationMatrixToRef(e = Pe.LOCAL, t, i) {
    if (e == Pe.LOCAL)
      this.getLocalMatrix().getRotationMatrixToRef(i);
    else {
      const s = We._TmpMats[0], r = this.getAbsoluteMatrix();
      t ? r.multiplyToRef(t.getWorldMatrix(), s) : s.copyFrom(r), s.multiplyAtIndex(0, this._scalingDeterminant), s.multiplyAtIndex(1, this._scalingDeterminant), s.multiplyAtIndex(2, this._scalingDeterminant), s.getRotationMatrixToRef(i);
    }
  }
  /**
   * Get the world position of a point that is in the local space of the bone
   * @param position The local position
   * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
   * @returns The world position
   */
  getAbsolutePositionFromLocal(e, t = null) {
    const i = p.Zero();
    return this.getAbsolutePositionFromLocalToRef(e, t, i), i;
  }
  /**
   * Get the world position of a point that is in the local space of the bone and copy it to the result param
   * @param position The local position
   * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
   * @param result The vector3 that the world position should be copied to
   */
  getAbsolutePositionFromLocalToRef(e, t = null, i) {
    let s = null;
    t && (s = t.getWorldMatrix()), this._skeleton.computeAbsoluteMatrices();
    const r = We._TmpMats[0];
    r.copyFrom(this.getAbsoluteMatrix()), t && s && r.multiplyToRef(s, r), p.TransformCoordinatesToRef(e, r, i);
  }
  /**
   * Get the local position of a point that is in world space
   * @param position The world position
   * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
   * @returns The local position
   */
  getLocalPositionFromAbsolute(e, t = null) {
    const i = p.Zero();
    return this.getLocalPositionFromAbsoluteToRef(e, t, i), i;
  }
  /**
   * Get the local position of a point that is in world space and copy it to the result param
   * @param position The world position
   * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
   * @param result The vector3 that the local position should be copied to
   */
  getLocalPositionFromAbsoluteToRef(e, t = null, i) {
    let s = null;
    t && (s = t.getWorldMatrix()), this._skeleton.computeAbsoluteMatrices();
    const r = We._TmpMats[0];
    r.copyFrom(this.getAbsoluteMatrix()), t && s && r.multiplyToRef(s, r), r.invert(), p.TransformCoordinatesToRef(e, r, i);
  }
  /**
   * Set the current local matrix as the restMatrix for this bone.
   */
  setCurrentPoseAsRest() {
    this.setRestMatrix(this.getLocalMatrix());
  }
}
We._TmpVecs = ot.BuildArray(2, p.Zero);
We._TmpQuat = U.Identity();
We._TmpMats = ot.BuildArray(5, I.Identity);
class qt extends W {
  /**
   * Instantiates a new RawTexture.
   * Raw texture can help creating a texture directly from an array of data.
   * This can be super useful if you either get the data from an uncompressed source or
   * if you wish to create your texture pixel by pixel.
   * @param data define the array of data to use to create the texture (null to create an empty texture)
   * @param width define the width of the texture
   * @param height define the height of the texture
   * @param format define the format of the data (RGB, RGBA... Engine.TEXTUREFORMAT_xxx)
   * @param sceneOrEngine defines the scene or engine the texture will belong to
   * @param generateMipMaps define whether mip maps should be generated or not
   * @param invertY define if the data should be flipped on Y when uploaded to the GPU
   * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
   * @param type define the format of the data (int, float... Engine.TEXTURETYPE_xxx)
   * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
   * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
   */
  constructor(e, t, i, s, r, n = !0, a = !1, o = 3, l = 0, c, u) {
    super(null, r, !n, a, void 0, void 0, void 0, void 0, void 0, void 0, void 0, void 0, c), this.format = s, this._engine && (!this._engine._caps.textureFloatLinearFiltering && l === 1 && (o = 1), !this._engine._caps.textureHalfFloatLinearFiltering && l === 2 && (o = 1), this._texture = this._engine.createRawTexture(e, t, i, s, n, a, o, null, l, c ?? 0, u ?? !1), this.wrapU = W.CLAMP_ADDRESSMODE, this.wrapV = W.CLAMP_ADDRESSMODE);
  }
  /**
   * Updates the texture underlying data.
   * @param data Define the new data of the texture
   */
  update(e) {
    this._getEngine().updateRawTexture(this._texture, e, this._texture.format, this._texture.invertY, null, this._texture.type, this._texture._useSRGBBuffer);
  }
  /**
   * Creates a luminance texture from some data.
   * @param data Define the texture data
   * @param width Define the width of the texture
   * @param height Define the height of the texture
   * @param sceneOrEngine defines the scene or engine the texture will belong to
   * @param generateMipMaps Define whether or not to create mip maps for the texture
   * @param invertY define if the data should be flipped on Y when uploaded to the GPU
   * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
   * @returns the luminance texture
   */
  static CreateLuminanceTexture(e, t, i, s, r = !0, n = !1, a = 3) {
    return new qt(e, t, i, 1, s, r, n, a);
  }
  /**
   * Creates a luminance alpha texture from some data.
   * @param data Define the texture data
   * @param width Define the width of the texture
   * @param height Define the height of the texture
   * @param sceneOrEngine defines the scene or engine the texture will belong to
   * @param generateMipMaps Define whether or not to create mip maps for the texture
   * @param invertY define if the data should be flipped on Y when uploaded to the GPU
   * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
   * @returns the luminance alpha texture
   */
  static CreateLuminanceAlphaTexture(e, t, i, s, r = !0, n = !1, a = 3) {
    return new qt(e, t, i, 2, s, r, n, a);
  }
  /**
   * Creates an alpha texture from some data.
   * @param data Define the texture data
   * @param width Define the width of the texture
   * @param height Define the height of the texture
   * @param sceneOrEngine defines the scene or engine the texture will belong to
   * @param generateMipMaps Define whether or not to create mip maps for the texture
   * @param invertY define if the data should be flipped on Y when uploaded to the GPU
   * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
   * @returns the alpha texture
   */
  static CreateAlphaTexture(e, t, i, s, r = !0, n = !1, a = 3) {
    return new qt(e, t, i, 0, s, r, n, a);
  }
  /**
   * Creates a RGB texture from some data.
   * @param data Define the texture data
   * @param width Define the width of the texture
   * @param height Define the height of the texture
   * @param sceneOrEngine defines the scene or engine the texture will belong to
   * @param generateMipMaps Define whether or not to create mip maps for the texture
   * @param invertY define if the data should be flipped on Y when uploaded to the GPU
   * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
   * @param type define the format of the data (int, float... Engine.TEXTURETYPE_xxx)
   * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
   * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
   * @returns the RGB alpha texture
   */
  static CreateRGBTexture(e, t, i, s, r = !0, n = !1, a = 3, o = 0, l = 0, c = !1) {
    return new qt(e, t, i, 4, s, r, n, a, o, l, c);
  }
  /**
   * Creates a RGBA texture from some data.
   * @param data Define the texture data
   * @param width Define the width of the texture
   * @param height Define the height of the texture
   * @param sceneOrEngine defines the scene or engine the texture will belong to
   * @param generateMipMaps Define whether or not to create mip maps for the texture
   * @param invertY define if the data should be flipped on Y when uploaded to the GPU
   * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
   * @param type define the format of the data (int, float... Engine.TEXTURETYPE_xxx)
   * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
   * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
   * @returns the RGBA texture
   */
  static CreateRGBATexture(e, t, i, s, r = !0, n = !1, a = 3, o = 0, l = 0, c = !1) {
    return new qt(e, t, i, 5, s, r, n, a, o, l, c);
  }
  /**
   * Creates a RGBA storage texture from some data.
   * @param data Define the texture data
   * @param width Define the width of the texture
   * @param height Define the height of the texture
   * @param sceneOrEngine defines the scene or engine the texture will belong to
   * @param generateMipMaps Define whether or not to create mip maps for the texture
   * @param invertY define if the data should be flipped on Y when uploaded to the GPU
   * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
   * @param type define the format of the data (int, float... Engine.TEXTURETYPE_xxx)
   * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
   * @returns the RGBA texture
   */
  static CreateRGBAStorageTexture(e, t, i, s, r = !0, n = !1, a = 3, o = 0, l = !1) {
    return new qt(e, t, i, 5, s, r, n, a, o, 1, l);
  }
  /**
   * Creates a R texture from some data.
   * @param data Define the texture data
   * @param width Define the width of the texture
   * @param height Define the height of the texture
   * @param sceneOrEngine defines the scene or engine the texture will belong to
   * @param generateMipMaps Define whether or not to create mip maps for the texture
   * @param invertY define if the data should be flipped on Y when uploaded to the GPU
   * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
   * @param type define the format of the data (int, float... Engine.TEXTURETYPE_xxx)
   * @returns the R texture
   */
  static CreateRTexture(e, t, i, s, r = !0, n = !1, a = W.TRILINEAR_SAMPLINGMODE, o = 1) {
    return new qt(e, t, i, 6, s, r, n, a, o);
  }
  /**
   * Creates a R storage texture from some data.
   * @param data Define the texture data
   * @param width Define the width of the texture
   * @param height Define the height of the texture
   * @param sceneOrEngine defines the scene or engine the texture will belong to
   * @param generateMipMaps Define whether or not to create mip maps for the texture
   * @param invertY define if the data should be flipped on Y when uploaded to the GPU
   * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
   * @param type define the format of the data (int, float... Engine.TEXTURETYPE_xxx)
   * @returns the R texture
   */
  static CreateRStorageTexture(e, t, i, s, r = !0, n = !1, a = W.TRILINEAR_SAMPLINGMODE, o = 1) {
    return new qt(e, t, i, 6, s, r, n, a, o, 1);
  }
}
class Ws {
  /**
   * Gets or sets a boolean indicating that bone matrices should be stored as a texture instead of using shader uniforms (default is true).
   * Please note that this option is not available if the hardware does not support it
   */
  get useTextureToStoreBoneMatrices() {
    return this._useTextureToStoreBoneMatrices;
  }
  set useTextureToStoreBoneMatrices(e) {
    this._useTextureToStoreBoneMatrices = e, this._markAsDirty();
  }
  /**
   * Gets or sets the animation properties override
   */
  get animationPropertiesOverride() {
    return this._animationPropertiesOverride ? this._animationPropertiesOverride : this._scene.animationPropertiesOverride;
  }
  set animationPropertiesOverride(e) {
    this._animationPropertiesOverride = e;
  }
  /**
   * Gets a boolean indicating that the skeleton effectively stores matrices into a texture
   */
  get isUsingTextureForMatrices() {
    return this.useTextureToStoreBoneMatrices && this._canUseTextureForBones;
  }
  /**
   * Gets the unique ID of this skeleton
   */
  get uniqueId() {
    return this._uniqueId;
  }
  /**
   * Creates a new skeleton
   * @param name defines the skeleton name
   * @param id defines the skeleton Id
   * @param scene defines the hosting scene
   */
  constructor(e, t, i) {
    this.name = e, this.id = t, this.bones = new Array(), this.needInitialSkinMatrix = !1, this._isDirty = !0, this._meshesWithPoseMatrix = new Array(), this._identity = I.Identity(), this._ranges = {}, this._absoluteTransformIsDirty = !0, this._canUseTextureForBones = !1, this._uniqueId = 0, this._numBonesWithLinkedTransformNode = 0, this._hasWaitingData = null, this._parentContainer = null, this.doNotSerialize = !1, this._useTextureToStoreBoneMatrices = !0, this._animationPropertiesOverride = null, this.onBeforeComputeObservable = new N(), this.bones = [], this._scene = i || de.LastCreatedScene, this._uniqueId = this._scene.getUniqueId(), this._scene.addSkeleton(this), this._isDirty = !0;
    const s = this._scene.getEngine().getCaps();
    this._canUseTextureForBones = s.textureFloat && s.maxVertexTextureImageUnits > 0;
  }
  /**
   * Gets the current object class name.
   * @returns the class name
   */
  getClassName() {
    return "Skeleton";
  }
  /**
   * Returns an array containing the root bones
   * @returns an array containing the root bones
   */
  getChildren() {
    return this.bones.filter((e) => !e.getParent());
  }
  // Members
  /**
   * Gets the list of transform matrices to send to shaders (one matrix per bone)
   * @param mesh defines the mesh to use to get the root matrix (if needInitialSkinMatrix === true)
   * @returns a Float32Array containing matrices data
   */
  getTransformMatrices(e) {
    return this.needInitialSkinMatrix ? (e._bonesTransformMatrices || this.prepare(), e._bonesTransformMatrices) : ((!this._transformMatrices || this._isDirty) && this.prepare(), this._transformMatrices);
  }
  /**
   * Gets the list of transform matrices to send to shaders inside a texture (one matrix per bone)
   * @param mesh defines the mesh to use to get the root matrix (if needInitialSkinMatrix === true)
   * @returns a raw texture containing the data
   */
  getTransformMatrixTexture(e) {
    return this.needInitialSkinMatrix && e._transformMatrixTexture ? e._transformMatrixTexture : this._transformMatrixTexture;
  }
  /**
   * Gets the current hosting scene
   * @returns a scene object
   */
  getScene() {
    return this._scene;
  }
  // Methods
  /**
   * Gets a string representing the current skeleton data
   * @param fullDetails defines a boolean indicating if we want a verbose version
   * @returns a string representing the current skeleton data
   */
  toString(e) {
    let t = `Name: ${this.name}, nBones: ${this.bones.length}`;
    if (t += `, nAnimationRanges: ${this._ranges ? Object.keys(this._ranges).length : "none"}`, e) {
      t += ", Ranges: {";
      let i = !0;
      for (const s in this._ranges)
        i && (t += ", ", i = !1), t += s;
      t += "}";
    }
    return t;
  }
  /**
   * Get bone's index searching by name
   * @param name defines bone's name to search for
   * @returns the indice of the bone. Returns -1 if not found
   */
  getBoneIndexByName(e) {
    for (let t = 0, i = this.bones.length; t < i; t++)
      if (this.bones[t].name === e)
        return t;
    return -1;
  }
  /**
   * Create a new animation range
   * @param name defines the name of the range
   * @param from defines the start key
   * @param to defines the end key
   */
  createAnimationRange(e, t, i) {
    if (!this._ranges[e]) {
      this._ranges[e] = new ys(e, t, i);
      for (let s = 0, r = this.bones.length; s < r; s++)
        this.bones[s].animations[0] && this.bones[s].animations[0].createRange(e, t, i);
    }
  }
  /**
   * Delete a specific animation range
   * @param name defines the name of the range
   * @param deleteFrames defines if frames must be removed as well
   */
  deleteAnimationRange(e, t = !0) {
    for (let i = 0, s = this.bones.length; i < s; i++)
      this.bones[i].animations[0] && this.bones[i].animations[0].deleteRange(e, t);
    this._ranges[e] = null;
  }
  /**
   * Gets a specific animation range
   * @param name defines the name of the range to look for
   * @returns the requested animation range or null if not found
   */
  getAnimationRange(e) {
    return this._ranges[e] || null;
  }
  /**
   * Gets the list of all animation ranges defined on this skeleton
   * @returns an array
   */
  getAnimationRanges() {
    const e = [];
    let t;
    for (t in this._ranges)
      e.push(this._ranges[t]);
    return e;
  }
  /**
   * Copy animation range from a source skeleton.
   * This is not for a complete retargeting, only between very similar skeleton's with only possible bone length differences
   * @param source defines the source skeleton
   * @param name defines the name of the range to copy
   * @param rescaleAsRequired defines if rescaling must be applied if required
   * @returns true if operation was successful
   */
  copyAnimationRange(e, t, i = !1) {
    if (this._ranges[t] || !e.getAnimationRange(t))
      return !1;
    let s = !0;
    const r = this._getHighestAnimationFrame() + 1, n = {}, a = e.bones;
    let o, l;
    for (l = 0, o = a.length; l < o; l++)
      n[a[l].name] = a[l];
    this.bones.length !== a.length && (w.Warn(`copyAnimationRange: this rig has ${this.bones.length} bones, while source as ${a.length}`), s = !1);
    const c = i && this.dimensionsAtRest && e.dimensionsAtRest ? this.dimensionsAtRest.divide(e.dimensionsAtRest) : null;
    for (l = 0, o = this.bones.length; l < o; l++) {
      const d = this.bones[l].name, f = n[d];
      f ? s = s && this.bones[l].copyAnimationRange(f, t, r, i, c) : (w.Warn("copyAnimationRange: not same rig, missing source bone " + d), s = !1);
    }
    const u = e.getAnimationRange(t);
    return u && (this._ranges[t] = new ys(t, u.from + r, u.to + r)), s;
  }
  /**
   * Forces the skeleton to go to rest pose
   */
  returnToRest() {
    for (const e of this.bones)
      e._index !== -1 && e.returnToRest();
  }
  _getHighestAnimationFrame() {
    let e = 0;
    for (let t = 0, i = this.bones.length; t < i; t++)
      if (this.bones[t].animations[0]) {
        const s = this.bones[t].animations[0].getHighestFrame();
        e < s && (e = s);
      }
    return e;
  }
  /**
   * Begin a specific animation range
   * @param name defines the name of the range to start
   * @param loop defines if looping must be turned on (false by default)
   * @param speedRatio defines the speed ratio to apply (1 by default)
   * @param onAnimationEnd defines a callback which will be called when animation will end
   * @returns a new animatable
   */
  beginAnimation(e, t, i, s) {
    const r = this.getAnimationRange(e);
    return r ? this._scene.beginAnimation(this, r.from, r.to, t, i, s) : null;
  }
  /**
   * Convert the keyframes for a range of animation on a skeleton to be relative to a given reference frame.
   * @param skeleton defines the Skeleton containing the animation range to convert
   * @param referenceFrame defines the frame that keyframes in the range will be relative to
   * @param range defines the name of the AnimationRange belonging to the Skeleton to convert
   * @returns the original skeleton
   */
  static MakeAnimationAdditive(e, t = 0, i) {
    const s = e.getAnimationRange(i);
    if (!s)
      return null;
    const r = e._scene.getAllAnimatablesByTarget(e);
    let n = null;
    for (let o = 0; o < r.length; o++) {
      const l = r[o];
      if (l.fromFrame === (s == null ? void 0 : s.from) && l.toFrame === (s == null ? void 0 : s.to)) {
        n = l;
        break;
      }
    }
    const a = e.getAnimatables();
    for (let o = 0; o < a.length; o++) {
      const c = a[o].animations;
      if (c)
        for (let u = 0; u < c.length; u++)
          B.MakeAnimationAdditive(c[u], t, i);
    }
    return n && (n.isAdditive = !0), e;
  }
  /** @internal */
  _markAsDirty() {
    this._isDirty = !0, this._absoluteTransformIsDirty = !0;
  }
  /**
   * @internal
   */
  _registerMeshWithPoseMatrix(e) {
    this._meshesWithPoseMatrix.push(e);
  }
  /**
   * @internal
   */
  _unregisterMeshWithPoseMatrix(e) {
    const t = this._meshesWithPoseMatrix.indexOf(e);
    t > -1 && this._meshesWithPoseMatrix.splice(t, 1);
  }
  _computeTransformMatrices(e, t) {
    this.onBeforeComputeObservable.notifyObservers(this);
    for (let i = 0; i < this.bones.length; i++) {
      const s = this.bones[i];
      s._childUpdateId++;
      const r = s.getParent();
      if (r ? s.getLocalMatrix().multiplyToRef(r.getFinalMatrix(), s.getFinalMatrix()) : t ? s.getLocalMatrix().multiplyToRef(t, s.getFinalMatrix()) : s.getFinalMatrix().copyFrom(s.getLocalMatrix()), s._index !== -1) {
        const n = s._index === null ? i : s._index;
        s.getAbsoluteInverseBindMatrix().multiplyToArray(s.getFinalMatrix(), e, n * 16);
      }
    }
    this._identity.copyToArray(e, this.bones.length * 16);
  }
  /**
   * Build all resources required to render a skeleton
   */
  prepare() {
    if (this._numBonesWithLinkedTransformNode > 0) {
      for (const e of this.bones)
        if (e._linkedTransformNode) {
          const t = e._linkedTransformNode;
          e.position = t.position, t.rotationQuaternion ? e.rotationQuaternion = t.rotationQuaternion : e.rotation = t.rotation, e.scaling = t.scaling;
        }
    }
    if (this.needInitialSkinMatrix)
      for (const e of this._meshesWithPoseMatrix) {
        const t = e.getPoseMatrix();
        let i = this._isDirty;
        if ((!e._bonesTransformMatrices || e._bonesTransformMatrices.length !== 16 * (this.bones.length + 1)) && (e._bonesTransformMatrices = new Float32Array(16 * (this.bones.length + 1)), i = !0), !!i) {
          if (this._synchronizedWithMesh !== e) {
            this._synchronizedWithMesh = e;
            for (const s of this.bones)
              s.getParent() || (s.getBindMatrix().multiplyToRef(t, C.Matrix[1]), s._updateAbsoluteBindMatrices(C.Matrix[1]));
            if (this.isUsingTextureForMatrices) {
              const s = (this.bones.length + 1) * 4;
              (!e._transformMatrixTexture || e._transformMatrixTexture.getSize().width !== s) && (e._transformMatrixTexture && e._transformMatrixTexture.dispose(), e._transformMatrixTexture = qt.CreateRGBATexture(e._bonesTransformMatrices, (this.bones.length + 1) * 4, 1, this._scene, !1, !1, 1, 1));
            }
          }
          this._computeTransformMatrices(e._bonesTransformMatrices, t), this.isUsingTextureForMatrices && e._transformMatrixTexture && e._transformMatrixTexture.update(e._bonesTransformMatrices);
        }
      }
    else {
      if (!this._isDirty)
        return;
      (!this._transformMatrices || this._transformMatrices.length !== 16 * (this.bones.length + 1)) && (this._transformMatrices = new Float32Array(16 * (this.bones.length + 1)), this.isUsingTextureForMatrices && (this._transformMatrixTexture && this._transformMatrixTexture.dispose(), this._transformMatrixTexture = qt.CreateRGBATexture(this._transformMatrices, (this.bones.length + 1) * 4, 1, this._scene, !1, !1, 1, 1))), this._computeTransformMatrices(this._transformMatrices, null), this.isUsingTextureForMatrices && this._transformMatrixTexture && this._transformMatrixTexture.update(this._transformMatrices);
    }
    this._isDirty = !1;
  }
  /**
   * Gets the list of animatables currently running for this skeleton
   * @returns an array of animatables
   */
  getAnimatables() {
    if (!this._animatables || this._animatables.length !== this.bones.length) {
      this._animatables = [];
      for (let e = 0; e < this.bones.length; e++)
        this._animatables.push(this.bones[e]);
    }
    return this._animatables;
  }
  /**
   * Clone the current skeleton
   * @param name defines the name of the new skeleton
   * @param id defines the id of the new skeleton
   * @returns the new skeleton
   */
  clone(e, t) {
    const i = new Ws(e, t || e, this._scene);
    i.needInitialSkinMatrix = this.needInitialSkinMatrix;
    for (let s = 0; s < this.bones.length; s++) {
      const r = this.bones[s];
      let n = null;
      const a = r.getParent();
      if (a) {
        const l = this.bones.indexOf(a);
        n = i.bones[l];
      }
      const o = new We(r.name, i, n, r.getBindMatrix().clone(), r.getRestMatrix().clone());
      o._index = r._index, r._linkedTransformNode && o.linkTransformNode(r._linkedTransformNode), js.DeepCopy(r.animations, o.animations);
    }
    if (this._ranges) {
      i._ranges = {};
      for (const s in this._ranges) {
        const r = this._ranges[s];
        r && (i._ranges[s] = r.clone());
      }
    }
    return this._isDirty = !0, i.prepare(), i;
  }
  /**
   * Enable animation blending for this skeleton
   * @param blendingSpeed defines the blending speed to apply
   * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#animation-blending
   */
  enableBlending(e = 0.01) {
    this.bones.forEach((t) => {
      t.animations.forEach((i) => {
        i.enableBlending = !0, i.blendingSpeed = e;
      });
    });
  }
  /**
   * Releases all resources associated with the current skeleton
   */
  dispose() {
    if (this._meshesWithPoseMatrix.length = 0, this.getScene().stopAnimation(this), this.getScene().removeSkeleton(this), this._parentContainer) {
      const e = this._parentContainer.skeletons.indexOf(this);
      e > -1 && this._parentContainer.skeletons.splice(e, 1), this._parentContainer = null;
    }
    this._transformMatrixTexture && (this._transformMatrixTexture.dispose(), this._transformMatrixTexture = null);
  }
  /**
   * Serialize the skeleton in a JSON object
   * @returns a JSON object
   */
  serialize() {
    var e;
    const t = {};
    t.name = this.name, t.id = this.id, this.dimensionsAtRest && (t.dimensionsAtRest = this.dimensionsAtRest.asArray()), t.bones = [], t.needInitialSkinMatrix = this.needInitialSkinMatrix;
    for (let i = 0; i < this.bones.length; i++) {
      const s = this.bones[i], r = s.getParent(), n = {
        parentBoneIndex: r ? this.bones.indexOf(r) : -1,
        index: s.getIndex(),
        name: s.name,
        id: s.id,
        matrix: s.getBindMatrix().toArray(),
        rest: s.getRestMatrix().toArray(),
        linkedTransformNodeId: (e = s.getTransformNode()) === null || e === void 0 ? void 0 : e.id
      };
      t.bones.push(n), s.length && (n.length = s.length), s.metadata && (n.metadata = s.metadata), s.animations && s.animations.length > 0 && (n.animation = s.animations[0].serialize()), t.ranges = [];
      for (const a in this._ranges) {
        const o = this._ranges[a];
        if (!o)
          continue;
        const l = {};
        l.name = a, l.from = o.from, l.to = o.to, t.ranges.push(l);
      }
    }
    return t;
  }
  /**
   * Creates a new skeleton from serialized data
   * @param parsedSkeleton defines the serialized data
   * @param scene defines the hosting scene
   * @returns a new skeleton
   */
  static Parse(e, t) {
    const i = new Ws(e.name, e.id, t);
    e.dimensionsAtRest && (i.dimensionsAtRest = p.FromArray(e.dimensionsAtRest)), i.needInitialSkinMatrix = e.needInitialSkinMatrix;
    let s;
    for (s = 0; s < e.bones.length; s++) {
      const r = e.bones[s], n = e.bones[s].index;
      let a = null;
      r.parentBoneIndex > -1 && (a = i.bones[r.parentBoneIndex]);
      const o = r.rest ? I.FromArray(r.rest) : null, l = new We(r.name, i, a, I.FromArray(r.matrix), o, null, n);
      r.id !== void 0 && r.id !== null && (l.id = r.id), r.length && (l.length = r.length), r.metadata && (l.metadata = r.metadata), r.animation && l.animations.push(B.Parse(r.animation)), r.linkedTransformNodeId !== void 0 && r.linkedTransformNodeId !== null && (i._hasWaitingData = !0, l._waitingTransformNodeId = r.linkedTransformNodeId);
    }
    if (e.ranges)
      for (s = 0; s < e.ranges.length; s++) {
        const r = e.ranges[s];
        i.createAnimationRange(r.name, r.from, r.to);
      }
    return i;
  }
  /**
   * Compute all node absolute matrices
   * @param forceUpdate defines if computation must be done even if cache is up to date
   */
  computeAbsoluteMatrices(e = !1) {
    (this._absoluteTransformIsDirty || e) && (this.bones[0].computeAbsoluteMatrices(), this._absoluteTransformIsDirty = !1);
  }
  /**
   * Compute all node absolute matrices
   * @param forceUpdate defines if computation must be done even if cache is up to date
   * @deprecated Please use computeAbsoluteMatrices instead
   */
  computeAbsoluteTransforms(e = !1) {
    this.computeAbsoluteMatrices(e);
  }
  /**
   * Gets the root pose matrix
   * @returns a matrix
   */
  getPoseMatrix() {
    let e = null;
    return this._meshesWithPoseMatrix.length > 0 && (e = this._meshesWithPoseMatrix[0].getPoseMatrix()), e;
  }
  /**
   * Sorts bones per internal index
   */
  sortBones() {
    const e = new Array(), t = new Array(this.bones.length);
    for (let i = 0; i < this.bones.length; i++)
      this._sortBones(i, e, t);
    this.bones = e;
  }
  _sortBones(e, t, i) {
    if (i[e])
      return;
    i[e] = !0;
    const s = this.bones[e];
    if (!s)
      return;
    s._index === void 0 && (s._index = e);
    const r = s.getParent();
    r && this._sortBones(this.bones.indexOf(r), t, i), t.push(s);
  }
  /**
   * Set the current local matrix as the restPose for all bones in the skeleton.
   */
  setCurrentPoseAsRest() {
    this.bones.forEach((e) => {
      e.setCurrentPoseAsRest();
    });
  }
}
class fs {
  /**
   * Gets or sets the influence of this target (ie. its weight in the overall morphing)
   */
  get influence() {
    return this._influence;
  }
  set influence(e) {
    if (this._influence === e)
      return;
    const t = this._influence;
    this._influence = e, this.onInfluenceChanged.hasObservers() && this.onInfluenceChanged.notifyObservers(t === 0 || e === 0);
  }
  /**
   * Gets or sets the animation properties override
   */
  get animationPropertiesOverride() {
    return !this._animationPropertiesOverride && this._scene ? this._scene.animationPropertiesOverride : this._animationPropertiesOverride;
  }
  set animationPropertiesOverride(e) {
    this._animationPropertiesOverride = e;
  }
  /**
   * Creates a new MorphTarget
   * @param name defines the name of the target
   * @param influence defines the influence to use
   * @param scene defines the scene the morphtarget belongs to
   */
  constructor(e, t = 0, i = null) {
    this.name = e, this.animations = new Array(), this._positions = null, this._normals = null, this._tangents = null, this._uvs = null, this._uniqueId = 0, this.onInfluenceChanged = new N(), this._onDataLayoutChanged = new N(), this._animationPropertiesOverride = null, this._scene = i || de.LastCreatedScene, this.influence = t, this._scene && (this._uniqueId = this._scene.getUniqueId());
  }
  /**
   * Gets the unique ID of this manager
   */
  get uniqueId() {
    return this._uniqueId;
  }
  /**
   * Gets a boolean defining if the target contains position data
   */
  get hasPositions() {
    return !!this._positions;
  }
  /**
   * Gets a boolean defining if the target contains normal data
   */
  get hasNormals() {
    return !!this._normals;
  }
  /**
   * Gets a boolean defining if the target contains tangent data
   */
  get hasTangents() {
    return !!this._tangents;
  }
  /**
   * Gets a boolean defining if the target contains texture coordinates data
   */
  get hasUVs() {
    return !!this._uvs;
  }
  /**
   * Affects position data to this target
   * @param data defines the position data to use
   */
  setPositions(e) {
    const t = this.hasPositions;
    this._positions = e, t !== this.hasPositions && this._onDataLayoutChanged.notifyObservers(void 0);
  }
  /**
   * Gets the position data stored in this target
   * @returns a FloatArray containing the position data (or null if not present)
   */
  getPositions() {
    return this._positions;
  }
  /**
   * Affects normal data to this target
   * @param data defines the normal data to use
   */
  setNormals(e) {
    const t = this.hasNormals;
    this._normals = e, t !== this.hasNormals && this._onDataLayoutChanged.notifyObservers(void 0);
  }
  /**
   * Gets the normal data stored in this target
   * @returns a FloatArray containing the normal data (or null if not present)
   */
  getNormals() {
    return this._normals;
  }
  /**
   * Affects tangent data to this target
   * @param data defines the tangent data to use
   */
  setTangents(e) {
    const t = this.hasTangents;
    this._tangents = e, t !== this.hasTangents && this._onDataLayoutChanged.notifyObservers(void 0);
  }
  /**
   * Gets the tangent data stored in this target
   * @returns a FloatArray containing the tangent data (or null if not present)
   */
  getTangents() {
    return this._tangents;
  }
  /**
   * Affects texture coordinates data to this target
   * @param data defines the texture coordinates data to use
   */
  setUVs(e) {
    const t = this.hasUVs;
    this._uvs = e, t !== this.hasUVs && this._onDataLayoutChanged.notifyObservers(void 0);
  }
  /**
   * Gets the texture coordinates data stored in this target
   * @returns a FloatArray containing the texture coordinates data (or null if not present)
   */
  getUVs() {
    return this._uvs;
  }
  /**
   * Clone the current target
   * @returns a new MorphTarget
   */
  clone() {
    const e = le.Clone(() => new fs(this.name, this.influence, this._scene), this);
    return e._positions = this._positions, e._normals = this._normals, e._tangents = this._tangents, e._uvs = this._uvs, e;
  }
  /**
   * Serializes the current target into a Serialization object
   * @returns the serialized object
   */
  serialize() {
    const e = {};
    return e.name = this.name, e.influence = this.influence, e.positions = Array.prototype.slice.call(this.getPositions()), this.id != null && (e.id = this.id), this.hasNormals && (e.normals = Array.prototype.slice.call(this.getNormals())), this.hasTangents && (e.tangents = Array.prototype.slice.call(this.getTangents())), this.hasUVs && (e.uvs = Array.prototype.slice.call(this.getUVs())), le.AppendSerializedAnimations(this, e), e;
  }
  /**
   * Returns the string "MorphTarget"
   * @returns "MorphTarget"
   */
  getClassName() {
    return "MorphTarget";
  }
  // Statics
  /**
   * Creates a new target from serialized data
   * @param serializationObject defines the serialized data to use
   * @param scene defines the hosting scene
   * @returns a new MorphTarget
   */
  static Parse(e, t) {
    const i = new fs(e.name, e.influence);
    if (i.setPositions(e.positions), e.id != null && (i.id = e.id), e.normals && i.setNormals(e.normals), e.tangents && i.setTangents(e.tangents), e.uvs && i.setUVs(e.uvs), e.animations) {
      for (let s = 0; s < e.animations.length; s++) {
        const r = e.animations[s], n = si("BABYLON.Animation");
        n && i.animations.push(n.Parse(r));
      }
      e.autoAnimate && t && t.beginAnimation(i, e.autoAnimateFrom, e.autoAnimateTo, e.autoAnimateLoop, e.autoAnimateSpeed || 1);
    }
    return i;
  }
  /**
   * Creates a MorphTarget from mesh data
   * @param mesh defines the source mesh
   * @param name defines the name to use for the new target
   * @param influence defines the influence to attach to the target
   * @returns a new MorphTarget
   */
  static FromMesh(e, t, i) {
    t || (t = e.name);
    const s = new fs(t, i, e.getScene());
    return s.setPositions(e.getVerticesData(v.PositionKind)), e.isVerticesDataPresent(v.NormalKind) && s.setNormals(e.getVerticesData(v.NormalKind)), e.isVerticesDataPresent(v.TangentKind) && s.setTangents(e.getVerticesData(v.TangentKind)), e.isVerticesDataPresent(v.UVKind) && s.setUVs(e.getVerticesData(v.UVKind)), s;
  }
}
E([
  R()
], fs.prototype, "id", void 0);
class Bn extends W {
  /**
   * Gets the number of layers of the texture
   */
  get depth() {
    return this._depth;
  }
  /**
   * Create a new RawTexture2DArray
   * @param data defines the data of the texture
   * @param width defines the width of the texture
   * @param height defines the height of the texture
   * @param depth defines the number of layers of the texture
   * @param format defines the texture format to use
   * @param scene defines the hosting scene
   * @param generateMipMaps defines a boolean indicating if mip levels should be generated (true by default)
   * @param invertY defines if texture must be stored with Y axis inverted
   * @param samplingMode defines the sampling mode to use (Texture.TRILINEAR_SAMPLINGMODE by default)
   * @param textureType defines the texture Type (Engine.TEXTURETYPE_UNSIGNED_INT, Engine.TEXTURETYPE_FLOAT...)
   * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
   */
  constructor(e, t, i, s, r, n, a = !0, o = !1, l = W.TRILINEAR_SAMPLINGMODE, c = 0, u) {
    super(null, n, !a, o), this.format = r, this._texture = n.getEngine().createRawTexture2DArray(e, t, i, s, r, a, o, l, null, c, u), this._depth = s, this.is2DArray = !0;
  }
  /**
   * Update the texture with new data
   * @param data defines the data to store in the texture
   */
  update(e) {
    this._texture && this._getEngine().updateRawTexture2DArray(this._texture, e, this._texture.format, this._texture.invertY, null, this._texture.type);
  }
  /**
   * Creates a RGBA texture from some data.
   * @param data Define the texture data
   * @param width Define the width of the texture
   * @param height Define the height of the texture
   * @param depth defines the number of layers of the texture
   * @param scene defines the scene the texture will belong to
   * @param generateMipMaps Define whether or not to create mip maps for the texture
   * @param invertY define if the data should be flipped on Y when uploaded to the GPU
   * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
   * @param type define the format of the data (int, float... Engine.TEXTURETYPE_xxx)
   * @returns the RGBA texture
   */
  static CreateRGBATexture(e, t, i, s, r, n = !0, a = !1, o = 3, l = 0) {
    return new Bn(e, t, i, s, 5, r, n, a, o, l);
  }
}
class bi {
  /**
   * Sets a boolean indicating that adding new target or updating an existing target will not update the underlying data buffers
   */
  set areUpdatesFrozen(e) {
    e ? this._blockCounter++ : (this._blockCounter--, this._blockCounter <= 0 && (this._blockCounter = 0, this._syncActiveTargets(!0)));
  }
  get areUpdatesFrozen() {
    return this._blockCounter > 0;
  }
  /**
   * Creates a new MorphTargetManager
   * @param scene defines the current scene
   */
  constructor(e = null) {
    if (this._targets = new Array(), this._targetInfluenceChangedObservers = new Array(), this._targetDataLayoutChangedObservers = new Array(), this._activeTargets = new At(16), this._supportsNormals = !1, this._supportsTangents = !1, this._supportsUVs = !1, this._vertexCount = 0, this._textureVertexStride = 0, this._textureWidth = 0, this._textureHeight = 1, this._uniqueId = 0, this._tempInfluences = new Array(), this._canUseTextureForTargets = !1, this._blockCounter = 0, this._parentContainer = null, this.optimizeInfluencers = !0, this.enableNormalMorphing = !0, this.enableTangentMorphing = !0, this.enableUVMorphing = !0, this._useTextureToStoreTargets = !0, e || (e = de.LastCreatedScene), this._scene = e, this._scene) {
      this._scene.addMorphTargetManager(this), this._uniqueId = this._scene.getUniqueId();
      const t = this._scene.getEngine().getCaps();
      this._canUseTextureForTargets = t.canUseGLVertexID && t.textureFloat && t.maxVertexTextureImageUnits > 0 && t.texture2DArrayMaxLayerCount > 1;
    }
  }
  /**
   * Gets the unique ID of this manager
   */
  get uniqueId() {
    return this._uniqueId;
  }
  /**
   * Gets the number of vertices handled by this manager
   */
  get vertexCount() {
    return this._vertexCount;
  }
  /**
   * Gets a boolean indicating if this manager supports morphing of normals
   */
  get supportsNormals() {
    return this._supportsNormals && this.enableNormalMorphing;
  }
  /**
   * Gets a boolean indicating if this manager supports morphing of tangents
   */
  get supportsTangents() {
    return this._supportsTangents && this.enableTangentMorphing;
  }
  /**
   * Gets a boolean indicating if this manager supports morphing of texture coordinates
   */
  get supportsUVs() {
    return this._supportsUVs && this.enableUVMorphing;
  }
  /**
   * Gets the number of targets stored in this manager
   */
  get numTargets() {
    return this._targets.length;
  }
  /**
   * Gets the number of influencers (ie. the number of targets with influences > 0)
   */
  get numInfluencers() {
    return this._activeTargets.length;
  }
  /**
   * Gets the list of influences (one per target)
   */
  get influences() {
    return this._influences;
  }
  /**
   * Gets or sets a boolean indicating that targets should be stored as a texture instead of using vertex attributes (default is true).
   * Please note that this option is not available if the hardware does not support it
   */
  get useTextureToStoreTargets() {
    return this._useTextureToStoreTargets;
  }
  set useTextureToStoreTargets(e) {
    this._useTextureToStoreTargets = e;
  }
  /**
   * Gets a boolean indicating that the targets are stored into a texture (instead of as attributes)
   */
  get isUsingTextureForTargets() {
    var e;
    return bi.EnableTextureStorage && this.useTextureToStoreTargets && this._canUseTextureForTargets && !(!((e = this._scene) === null || e === void 0) && e.getEngine().getCaps().disableMorphTargetTexture);
  }
  /**
   * Gets the active target at specified index. An active target is a target with an influence > 0
   * @param index defines the index to check
   * @returns the requested target
   */
  getActiveTarget(e) {
    return this._activeTargets.data[e];
  }
  /**
   * Gets the target at specified index
   * @param index defines the index to check
   * @returns the requested target
   */
  getTarget(e) {
    return this._targets[e];
  }
  /**
   * Add a new target to this manager
   * @param target defines the target to add
   */
  addTarget(e) {
    this._targets.push(e), this._targetInfluenceChangedObservers.push(e.onInfluenceChanged.add((t) => {
      this._syncActiveTargets(t);
    })), this._targetDataLayoutChangedObservers.push(e._onDataLayoutChanged.add(() => {
      this._syncActiveTargets(!0);
    })), this._syncActiveTargets(!0);
  }
  /**
   * Removes a target from the manager
   * @param target defines the target to remove
   */
  removeTarget(e) {
    const t = this._targets.indexOf(e);
    t >= 0 && (this._targets.splice(t, 1), e.onInfluenceChanged.remove(this._targetInfluenceChangedObservers.splice(t, 1)[0]), e._onDataLayoutChanged.remove(this._targetDataLayoutChangedObservers.splice(t, 1)[0]), this._syncActiveTargets(!0)), this._scene && this._scene.stopAnimation(e);
  }
  /**
   * @internal
   */
  _bind(e) {
    e.setFloat3("morphTargetTextureInfo", this._textureVertexStride, this._textureWidth, this._textureHeight), e.setFloatArray("morphTargetTextureIndices", this._morphTargetTextureIndices), e.setTexture("morphTargets", this._targetStoreTexture);
  }
  /**
   * Clone the current manager
   * @returns a new MorphTargetManager
   */
  clone() {
    const e = new bi(this._scene);
    for (const t of this._targets)
      e.addTarget(t.clone());
    return e.enableNormalMorphing = this.enableNormalMorphing, e.enableTangentMorphing = this.enableTangentMorphing, e.enableUVMorphing = this.enableUVMorphing, e;
  }
  /**
   * Serializes the current manager into a Serialization object
   * @returns the serialized object
   */
  serialize() {
    const e = {};
    e.id = this.uniqueId, e.targets = [];
    for (const t of this._targets)
      e.targets.push(t.serialize());
    return e;
  }
  _syncActiveTargets(e) {
    if (this.areUpdatesFrozen)
      return;
    let t = 0;
    this._activeTargets.reset(), this._supportsNormals = !0, this._supportsTangents = !0, this._supportsUVs = !0, this._vertexCount = 0, this._scene && this._targets.length > this._scene.getEngine().getCaps().texture2DArrayMaxLayerCount && (this.useTextureToStoreTargets = !1), (!this._morphTargetTextureIndices || this._morphTargetTextureIndices.length !== this._targets.length) && (this._morphTargetTextureIndices = new Float32Array(this._targets.length));
    let i = -1;
    for (const s of this._targets) {
      if (i++, s.influence === 0 && this.optimizeInfluencers)
        continue;
      if (this._activeTargets.length >= bi.MaxActiveMorphTargetsInVertexAttributeMode && !this.isUsingTextureForTargets)
        break;
      this._activeTargets.push(s), this._morphTargetTextureIndices[t] = i, this._tempInfluences[t++] = s.influence, this._supportsNormals = this._supportsNormals && s.hasNormals, this._supportsTangents = this._supportsTangents && s.hasTangents, this._supportsUVs = this._supportsUVs && s.hasUVs;
      const r = s.getPositions();
      if (r) {
        const n = r.length / 3;
        if (this._vertexCount === 0)
          this._vertexCount = n;
        else if (this._vertexCount !== n) {
          w.Error("Incompatible target. Targets must all have the same vertices count.");
          return;
        }
      }
    }
    this._morphTargetTextureIndices.length !== t && (this._morphTargetTextureIndices = this._morphTargetTextureIndices.slice(0, t)), (!this._influences || this._influences.length !== t) && (this._influences = new Float32Array(t));
    for (let s = 0; s < t; s++)
      this._influences[s] = this._tempInfluences[s];
    e && this.synchronize();
  }
  /**
   * Synchronize the targets with all the meshes using this morph target manager
   */
  synchronize() {
    if (!(!this._scene || this.areUpdatesFrozen)) {
      if (this.isUsingTextureForTargets && this._vertexCount) {
        this._textureVertexStride = 1, this._supportsNormals && this._textureVertexStride++, this._supportsTangents && this._textureVertexStride++, this._supportsUVs && this._textureVertexStride++, this._textureWidth = this._vertexCount * this._textureVertexStride, this._textureHeight = 1;
        const e = this._scene.getEngine().getCaps().maxTextureSize;
        this._textureWidth > e && (this._textureHeight = Math.ceil(this._textureWidth / e), this._textureWidth = e);
        let t = !0;
        if (this._targetStoreTexture) {
          const i = this._targetStoreTexture.getSize();
          i.width === this._textureWidth && i.height === this._textureHeight && this._targetStoreTexture.depth === this._targets.length && (t = !1);
        }
        if (t) {
          this._targetStoreTexture && this._targetStoreTexture.dispose();
          const i = this._targets.length, s = new Float32Array(i * this._textureWidth * this._textureHeight * 4);
          let r = 0;
          for (let n = 0; n < i; n++) {
            const a = this._targets[n], o = a.getPositions(), l = a.getNormals(), c = a.getUVs(), u = a.getTangents();
            if (!o) {
              n === 0 && w.Error("Invalid morph target. Target must have positions.");
              return;
            }
            r = n * this._textureWidth * this._textureHeight * 4;
            for (let d = 0; d < this._vertexCount; d++)
              s[r] = o[d * 3], s[r + 1] = o[d * 3 + 1], s[r + 2] = o[d * 3 + 2], r += 4, this._supportsNormals && l && (s[r] = l[d * 3], s[r + 1] = l[d * 3 + 1], s[r + 2] = l[d * 3 + 2], r += 4), this._supportsUVs && c && (s[r] = c[d * 2], s[r + 1] = c[d * 2 + 1], r += 4), this._supportsTangents && u && (s[r] = u[d * 3], s[r + 1] = u[d * 3 + 1], s[r + 2] = u[d * 3 + 2], r += 4);
          }
          this._targetStoreTexture = Bn.CreateRGBATexture(s, this._textureWidth, this._textureHeight, i, this._scene, !1, !1, 1, 1);
        }
      }
      for (const e of this._scene.meshes)
        e.morphTargetManager === this && e._syncGeometryWithMorphTargetManager();
    }
  }
  /**
   * Release all resources
   */
  dispose() {
    if (this._targetStoreTexture && this._targetStoreTexture.dispose(), this._targetStoreTexture = null, this._scene) {
      if (this._scene.removeMorphTargetManager(this), this._parentContainer) {
        const e = this._parentContainer.morphTargetManagers.indexOf(this);
        e > -1 && this._parentContainer.morphTargetManagers.splice(e, 1), this._parentContainer = null;
      }
      for (const e of this._targets)
        this._scene.stopAnimation(e);
    }
  }
  // Statics
  /**
   * Creates a new MorphTargetManager from serialized data
   * @param serializationObject defines the serialized data
   * @param scene defines the hosting scene
   * @returns the new MorphTargetManager
   */
  static Parse(e, t) {
    const i = new bi(t);
    i._uniqueId = e.id;
    for (const s of e.targets)
      i.addTarget(fs.Parse(s, t));
    return i;
  }
}
bi.EnableTextureStorage = !0;
bi.MaxActiveMorphTargetsInVertexAttributeMode = 8;
class Ge {
  /**
   * Initializes the physics joint
   * @param type The type of the physics joint
   * @param jointData The data for the physics joint
   */
  constructor(e, t) {
    this.type = e, this.jointData = t, t.nativeParams = t.nativeParams || {};
  }
  /**
   * Gets the physics joint
   */
  get physicsJoint() {
    return this._physicsJoint;
  }
  /**
   * Sets the physics joint
   */
  set physicsJoint(e) {
    this._physicsJoint, this._physicsJoint = e;
  }
  /**
   * Sets the physics plugin
   */
  set physicsPlugin(e) {
    this._physicsPlugin = e;
  }
  /**
   * Execute a function that is physics-plugin specific.
   * @param {Function} func the function that will be executed.
   *                        It accepts two parameters: the physics world and the physics joint
   */
  executeNativeFunction(e) {
    e(this._physicsPlugin.world, this._physicsJoint);
  }
}
Ge.DistanceJoint = 0;
Ge.HingeJoint = 1;
Ge.BallAndSocketJoint = 2;
Ge.WheelJoint = 3;
Ge.SliderJoint = 4;
Ge.PrismaticJoint = 5;
Ge.UniversalJoint = 6;
Ge.Hinge2Joint = Ge.WheelJoint;
Ge.PointToPointJoint = 8;
Ge.SpringJoint = 9;
Ge.LockJoint = 10;
K._PhysicsImpostorParser = function(h, e, t) {
  return new re(e, t.physicsImpostor, {
    mass: t.physicsMass,
    friction: t.physicsFriction,
    restitution: t.physicsRestitution
  }, h);
};
class re {
  /**
   * Specifies if the physics imposter is disposed
   */
  get isDisposed() {
    return this._isDisposed;
  }
  /**
   * Gets the mass of the physics imposter
   */
  get mass() {
    return this._physicsEngine ? this._physicsEngine.getPhysicsPlugin().getBodyMass(this) : 0;
  }
  set mass(e) {
    this.setMass(e);
  }
  /**
   * Gets the coefficient of friction
   */
  get friction() {
    return this._physicsEngine ? this._physicsEngine.getPhysicsPlugin().getBodyFriction(this) : 0;
  }
  /**
   * Sets the coefficient of friction
   */
  set friction(e) {
    this._physicsEngine && this._physicsEngine.getPhysicsPlugin().setBodyFriction(this, e);
  }
  /**
   * Gets the coefficient of restitution
   */
  get restitution() {
    return this._physicsEngine ? this._physicsEngine.getPhysicsPlugin().getBodyRestitution(this) : 0;
  }
  /**
   * Sets the coefficient of restitution
   */
  set restitution(e) {
    this._physicsEngine && this._physicsEngine.getPhysicsPlugin().setBodyRestitution(this, e);
  }
  /**
   * Gets the pressure of a soft body; only supported by the AmmoJSPlugin
   */
  get pressure() {
    if (!this._physicsEngine)
      return 0;
    const e = this._physicsEngine.getPhysicsPlugin();
    return e.setBodyPressure ? e.getBodyPressure(this) : 0;
  }
  /**
   * Sets the pressure of a soft body; only supported by the AmmoJSPlugin
   */
  set pressure(e) {
    if (!this._physicsEngine)
      return;
    const t = this._physicsEngine.getPhysicsPlugin();
    t.setBodyPressure && t.setBodyPressure(this, e);
  }
  /**
   * Gets the stiffness of a soft body; only supported by the AmmoJSPlugin
   */
  get stiffness() {
    if (!this._physicsEngine)
      return 0;
    const e = this._physicsEngine.getPhysicsPlugin();
    return e.getBodyStiffness ? e.getBodyStiffness(this) : 0;
  }
  /**
   * Sets the stiffness of a soft body; only supported by the AmmoJSPlugin
   */
  set stiffness(e) {
    if (!this._physicsEngine)
      return;
    const t = this._physicsEngine.getPhysicsPlugin();
    t.setBodyStiffness && t.setBodyStiffness(this, e);
  }
  /**
   * Gets the velocityIterations of a soft body; only supported by the AmmoJSPlugin
   */
  get velocityIterations() {
    if (!this._physicsEngine)
      return 0;
    const e = this._physicsEngine.getPhysicsPlugin();
    return e.getBodyVelocityIterations ? e.getBodyVelocityIterations(this) : 0;
  }
  /**
   * Sets the velocityIterations of a soft body; only supported by the AmmoJSPlugin
   */
  set velocityIterations(e) {
    if (!this._physicsEngine)
      return;
    const t = this._physicsEngine.getPhysicsPlugin();
    t.setBodyVelocityIterations && t.setBodyVelocityIterations(this, e);
  }
  /**
   * Gets the positionIterations of a soft body; only supported by the AmmoJSPlugin
   */
  get positionIterations() {
    if (!this._physicsEngine)
      return 0;
    const e = this._physicsEngine.getPhysicsPlugin();
    return e.getBodyPositionIterations ? e.getBodyPositionIterations(this) : 0;
  }
  /**
   * Sets the positionIterations of a soft body; only supported by the AmmoJSPlugin
   */
  set positionIterations(e) {
    if (!this._physicsEngine)
      return;
    const t = this._physicsEngine.getPhysicsPlugin();
    t.setBodyPositionIterations && t.setBodyPositionIterations(this, e);
  }
  /**
   * Initializes the physics imposter
   * @param object The physics-enabled object used as the physics imposter
   * @param type The type of the physics imposter. Types are available as static members of this class.
   * @param _options The options for the physics imposter
   * @param _scene The Babylon scene
   */
  constructor(e, t, i = { mass: 0 }, s) {
    if (this.object = e, this.type = t, this._options = i, this._scene = s, this._pluginData = {}, this._bodyUpdateRequired = !1, this._onBeforePhysicsStepCallbacks = new Array(), this._onAfterPhysicsStepCallbacks = new Array(), this._onPhysicsCollideCallbacks = [], this._deltaPosition = p.Zero(), this._isDisposed = !1, this.soft = !1, this.segments = 0, this._tmpQuat = new U(), this._tmpQuat2 = new U(), this.beforeStep = () => {
      this._physicsEngine && (this.object.translate(this._deltaPosition, -1), this._deltaRotationConjugated && this.object.rotationQuaternion && this.object.rotationQuaternion.multiplyToRef(this._deltaRotationConjugated, this.object.rotationQuaternion), this.object.computeWorldMatrix(!1), this.object.parent && this.object.rotationQuaternion ? (this.getParentsRotation(), this._tmpQuat.multiplyToRef(this.object.rotationQuaternion, this._tmpQuat)) : this._tmpQuat.copyFrom(this.object.rotationQuaternion || new U()), this._options.disableBidirectionalTransformation || this.object.rotationQuaternion && this._physicsEngine.getPhysicsPlugin().setPhysicsBodyTransformation(
        this,
        /*bInfo.boundingBox.centerWorld*/
        this.object.getAbsolutePosition(),
        this._tmpQuat
      ), this._onBeforePhysicsStepCallbacks.forEach((r) => {
        r(this);
      }));
    }, this.afterStep = () => {
      this._physicsEngine && (this._onAfterPhysicsStepCallbacks.forEach((r) => {
        r(this);
      }), this._physicsEngine.getPhysicsPlugin().setTransformationFromPhysicsBody(this), this.object.parent && this.object.rotationQuaternion && (this.getParentsRotation(), this._tmpQuat.conjugateInPlace(), this._tmpQuat.multiplyToRef(this.object.rotationQuaternion, this.object.rotationQuaternion)), this.object.setAbsolutePosition(this.object.position), this._deltaRotation ? (this.object.rotationQuaternion && this.object.rotationQuaternion.multiplyToRef(this._deltaRotation, this.object.rotationQuaternion), this._deltaPosition.applyRotationQuaternionToRef(this._deltaRotation, re._TmpVecs[0]), this.object.translate(re._TmpVecs[0], 1)) : this.object.translate(this._deltaPosition, 1), this.object.computeWorldMatrix(!0));
    }, this.onCollideEvent = null, this.onCollide = (r) => {
      if (!this._onPhysicsCollideCallbacks.length && !this.onCollideEvent || !this._physicsEngine)
        return;
      const n = this._physicsEngine.getImpostorWithPhysicsBody(r.body);
      n && (this.onCollideEvent && this.onCollideEvent(this, n), this._onPhysicsCollideCallbacks.filter((a) => a.otherImpostors.indexOf(n) !== -1).forEach((a) => {
        a.callback(this, n, r.point, r.distance, r.impulse, r.normal);
      }));
    }, !this.object) {
      w.Error("No object was provided. A physics object is obligatory");
      return;
    }
    this.object.parent && i.mass !== 0 && w.Warn("A physics impostor has been created for an object which has a parent. Babylon physics currently works in local space so unexpected issues may occur."), !this._scene && e.getScene && (this._scene = e.getScene()), this._scene && (this.type > 100 && (this.soft = !0), this._physicsEngine = this._scene.getPhysicsEngine(), this._physicsEngine ? (this.object.rotationQuaternion || (this.object.rotation ? this.object.rotationQuaternion = U.RotationYawPitchRoll(this.object.rotation.y, this.object.rotation.x, this.object.rotation.z) : this.object.rotationQuaternion = new U()), this._options.mass = i.mass === void 0 ? 0 : i.mass, this._options.friction = i.friction === void 0 ? 0.2 : i.friction, this._options.restitution = i.restitution === void 0 ? 0.2 : i.restitution, this.soft && (this._options.mass = this._options.mass > 0 ? this._options.mass : 1, this._options.pressure = i.pressure === void 0 ? 200 : i.pressure, this._options.stiffness = i.stiffness === void 0 ? 1 : i.stiffness, this._options.velocityIterations = i.velocityIterations === void 0 ? 20 : i.velocityIterations, this._options.positionIterations = i.positionIterations === void 0 ? 20 : i.positionIterations, this._options.fixedPoints = i.fixedPoints === void 0 ? 0 : i.fixedPoints, this._options.margin = i.margin === void 0 ? 0 : i.margin, this._options.damping = i.damping === void 0 ? 0 : i.damping, this._options.path = i.path === void 0 ? null : i.path, this._options.shape = i.shape === void 0 ? null : i.shape), this._joints = [], !this.object.parent || this._options.ignoreParent ? this._init() : this.object.parent.physicsImpostor && w.Warn("You must affect impostors to children before affecting impostor to parent.")) : w.Error("Physics not enabled. Please use scene.enablePhysics(...) before creating impostors."));
  }
  /**
   * This function will completely initialize this impostor.
   * It will create a new body - but only if this mesh has no parent.
   * If it has, this impostor will not be used other than to define the impostor
   * of the child mesh.
   * @internal
   */
  _init() {
    this._physicsEngine && (this._physicsEngine.removeImpostor(this), this.physicsBody = null, this._parent = this._parent || this._getPhysicsParent(), !this._isDisposed && (!this.parent || this._options.ignoreParent) && this._physicsEngine.addImpostor(this));
  }
  _getPhysicsParent() {
    return this.object.parent instanceof Ut ? this.object.parent.physicsImpostor : null;
  }
  /**
   * Should a new body be generated.
   * @returns boolean specifying if body initialization is required
   */
  isBodyInitRequired() {
    return this._bodyUpdateRequired || !this._physicsBody && (!this._parent || !!this._options.ignoreParent);
  }
  /**
   * Sets the updated scaling
   */
  setScalingUpdated() {
    this.forceUpdate();
  }
  /**
   * Force a regeneration of this or the parent's impostor's body.
   * Use with caution - This will remove all previously-instantiated joints.
   */
  forceUpdate() {
    this._init(), this.parent && !this._options.ignoreParent && this.parent.forceUpdate();
  }
  /*public get mesh(): AbstractMesh {
      return this._mesh;
  }*/
  /**
   * Gets the body that holds this impostor. Either its own, or its parent.
   */
  get physicsBody() {
    return this._parent && !this._options.ignoreParent ? this._parent.physicsBody : this._physicsBody;
  }
  /**
   * Get the parent of the physics imposter
   * @returns Physics imposter or null
   */
  get parent() {
    return !this._options.ignoreParent && this._parent ? this._parent : null;
  }
  /**
   * Sets the parent of the physics imposter
   */
  set parent(e) {
    this._parent = e;
  }
  /**
   * Set the physics body. Used mainly by the physics engine/plugin
   */
  set physicsBody(e) {
    this._physicsBody && this._physicsEngine && this._physicsEngine.getPhysicsPlugin().removePhysicsBody(this), this._physicsBody = e, this.resetUpdateFlags();
  }
  /**
   * Resets the update flags
   */
  resetUpdateFlags() {
    this._bodyUpdateRequired = !1;
  }
  /**
   * Gets the object extents
   * @returns the object extents
   */
  getObjectExtents() {
    if (this.object.getBoundingInfo) {
      const e = this.object.rotationQuaternion, t = this.object.scaling.clone();
      this.object.rotationQuaternion = re.IDENTITY_QUATERNION;
      const i = this.object.computeWorldMatrix && this.object.computeWorldMatrix(!0);
      i && i.decompose(t, void 0, void 0);
      const r = this.object.getBoundingInfo().boundingBox.extendSize.scale(2).multiplyInPlace(t);
      return r.x = Math.abs(r.x), r.y = Math.abs(r.y), r.z = Math.abs(r.z), this.object.rotationQuaternion = e, this.object.computeWorldMatrix && this.object.computeWorldMatrix(!0), r;
    } else
      return re.DEFAULT_OBJECT_SIZE;
  }
  /**
   * Gets the object center
   * @returns The object center
   */
  getObjectCenter() {
    return this.object.getBoundingInfo ? this.object.getBoundingInfo().boundingBox.centerWorld : this.object.position;
  }
  /**
   * Get a specific parameter from the options parameters
   * @param paramName The object parameter name
   * @returns The object parameter
   */
  getParam(e) {
    return this._options[e];
  }
  /**
   * Sets a specific parameter in the options given to the physics plugin
   * @param paramName The parameter name
   * @param value The value of the parameter
   */
  setParam(e, t) {
    this._options[e] = t, this._bodyUpdateRequired = !0;
  }
  /**
   * Specifically change the body's mass. Won't recreate the physics body object
   * @param mass The mass of the physics imposter
   */
  setMass(e) {
    this.getParam("mass") !== e && this.setParam("mass", e), this._physicsEngine && this._physicsEngine.getPhysicsPlugin().setBodyMass(this, e);
  }
  /**
   * Gets the linear velocity
   * @returns  linear velocity or null
   */
  getLinearVelocity() {
    return this._physicsEngine ? this._physicsEngine.getPhysicsPlugin().getLinearVelocity(this) : p.Zero();
  }
  /**
   * Sets the linear velocity
   * @param velocity  linear velocity or null
   */
  setLinearVelocity(e) {
    this._physicsEngine && this._physicsEngine.getPhysicsPlugin().setLinearVelocity(this, e);
  }
  /**
   * Gets the angular velocity
   * @returns angular velocity or null
   */
  getAngularVelocity() {
    return this._physicsEngine ? this._physicsEngine.getPhysicsPlugin().getAngularVelocity(this) : p.Zero();
  }
  /**
   * Sets the angular velocity
   * @param velocity The velocity or null
   */
  setAngularVelocity(e) {
    this._physicsEngine && this._physicsEngine.getPhysicsPlugin().setAngularVelocity(this, e);
  }
  /**
   * Execute a function with the physics plugin native code
   * Provide a function the will have two variables - the world object and the physics body object
   * @param func The function to execute with the physics plugin native code
   */
  executeNativeFunction(e) {
    this._physicsEngine && e(this._physicsEngine.getPhysicsPlugin().world, this.physicsBody);
  }
  /**
   * Register a function that will be executed before the physics world is stepping forward
   * @param func The function to execute before the physics world is stepped forward
   */
  registerBeforePhysicsStep(e) {
    this._onBeforePhysicsStepCallbacks.push(e);
  }
  /**
   * Unregister a function that will be executed before the physics world is stepping forward
   * @param func The function to execute before the physics world is stepped forward
   */
  unregisterBeforePhysicsStep(e) {
    const t = this._onBeforePhysicsStepCallbacks.indexOf(e);
    t > -1 ? this._onBeforePhysicsStepCallbacks.splice(t, 1) : w.Warn("Function to remove was not found");
  }
  /**
   * Register a function that will be executed after the physics step
   * @param func The function to execute after physics step
   */
  registerAfterPhysicsStep(e) {
    this._onAfterPhysicsStepCallbacks.push(e);
  }
  /**
   * Unregisters a function that will be executed after the physics step
   * @param func The function to execute after physics step
   */
  unregisterAfterPhysicsStep(e) {
    const t = this._onAfterPhysicsStepCallbacks.indexOf(e);
    t > -1 ? this._onAfterPhysicsStepCallbacks.splice(t, 1) : w.Warn("Function to remove was not found");
  }
  /**
   * register a function that will be executed when this impostor collides against a different body
   * @param collideAgainst Physics imposter, or array of physics imposters to collide against
   * @param func Callback that is executed on collision
   */
  registerOnPhysicsCollide(e, t) {
    const i = e instanceof Array ? e : [e];
    this._onPhysicsCollideCallbacks.push({ callback: t, otherImpostors: i });
  }
  /**
   * Unregisters the physics imposter's collision callback
   * @param collideAgainst The physics object to collide against
   * @param func Callback to execute on collision
   */
  unregisterOnPhysicsCollide(e, t) {
    const i = e instanceof Array ? e : [e];
    let s = -1;
    this._onPhysicsCollideCallbacks.some((n, a) => {
      if (n.callback === t && n.otherImpostors.length === i.length) {
        const o = n.otherImpostors.every((l) => i.indexOf(l) > -1);
        return o && (s = a), o;
      }
      return !1;
    }) ? this._onPhysicsCollideCallbacks.splice(s, 1) : w.Warn("Function to remove was not found");
  }
  /**
   * Get the parent rotation
   * @returns The parent rotation
   */
  getParentsRotation() {
    let e = this.object.parent;
    for (this._tmpQuat.copyFromFloats(0, 0, 0, 1); e; )
      e.rotationQuaternion ? this._tmpQuat2.copyFrom(e.rotationQuaternion) : U.RotationYawPitchRollToRef(e.rotation.y, e.rotation.x, e.rotation.z, this._tmpQuat2), this._tmpQuat.multiplyToRef(this._tmpQuat2, this._tmpQuat), e = e.parent;
    return this._tmpQuat;
  }
  /**
   * Apply a force
   * @param force The force to apply
   * @param contactPoint The contact point for the force
   * @returns The physics imposter
   */
  applyForce(e, t) {
    return this._physicsEngine && this._physicsEngine.getPhysicsPlugin().applyForce(this, e, t), this;
  }
  /**
   * Apply an impulse
   * @param force The impulse force
   * @param contactPoint The contact point for the impulse force
   * @returns The physics imposter
   */
  applyImpulse(e, t) {
    return this._physicsEngine && this._physicsEngine.getPhysicsPlugin().applyImpulse(this, e, t), this;
  }
  /**
   * A help function to create a joint
   * @param otherImpostor A physics imposter used to create a joint
   * @param jointType The type of joint
   * @param jointData The data for the joint
   * @returns The physics imposter
   */
  createJoint(e, t, i) {
    const s = new Ge(t, i);
    return this.addJoint(e, s), this;
  }
  /**
   * Add a joint to this impostor with a different impostor
   * @param otherImpostor A physics imposter used to add a joint
   * @param joint The joint to add
   * @returns The physics imposter
   */
  addJoint(e, t) {
    return this._joints.push({
      otherImpostor: e,
      joint: t
    }), this._physicsEngine && this._physicsEngine.addJoint(this, e, t), this;
  }
  /**
   * Add an anchor to a cloth impostor
   * @param otherImpostor rigid impostor to anchor to
   * @param width ratio across width from 0 to 1
   * @param height ratio up height from 0 to 1
   * @param influence the elasticity between cloth impostor and anchor from 0, very stretchy to 1, little stretch
   * @param noCollisionBetweenLinkedBodies when true collisions between cloth impostor and anchor are ignored; default false
   * @returns impostor the soft imposter
   */
  addAnchor(e, t, i, s, r) {
    if (!this._physicsEngine)
      return this;
    const n = this._physicsEngine.getPhysicsPlugin();
    return n.appendAnchor ? (this._physicsEngine && n.appendAnchor(this, e, t, i, s, r), this) : this;
  }
  /**
   * Add a hook to a rope impostor
   * @param otherImpostor rigid impostor to anchor to
   * @param length ratio across rope from 0 to 1
   * @param influence the elasticity between rope impostor and anchor from 0, very stretchy to 1, little stretch
   * @param noCollisionBetweenLinkedBodies when true collisions between soft impostor and anchor are ignored; default false
   * @returns impostor the rope imposter
   */
  addHook(e, t, i, s) {
    if (!this._physicsEngine)
      return this;
    const r = this._physicsEngine.getPhysicsPlugin();
    return r.appendAnchor ? (this._physicsEngine && r.appendHook(this, e, t, i, s), this) : this;
  }
  /**
   * Will keep this body still, in a sleep mode.
   * @returns the physics imposter
   */
  sleep() {
    return this._physicsEngine && this._physicsEngine.getPhysicsPlugin().sleepBody(this), this;
  }
  /**
   * Wake the body up.
   * @returns The physics imposter
   */
  wakeUp() {
    return this._physicsEngine && this._physicsEngine.getPhysicsPlugin().wakeUpBody(this), this;
  }
  /**
   * Clones the physics imposter
   * @param newObject The physics imposter clones to this physics-enabled object
   * @returns A nullable physics imposter
   */
  clone(e) {
    return e ? new re(e, this.type, this._options, this._scene) : null;
  }
  /**
   * Disposes the physics imposter
   */
  dispose() {
    this._physicsEngine && (this._joints.forEach((e) => {
      this._physicsEngine && this._physicsEngine.removeJoint(this, e.otherImpostor, e.joint);
    }), this._physicsEngine.removeImpostor(this), this.parent && this.parent.forceUpdate(), this._isDisposed = !0);
  }
  /**
   * Sets the delta position
   * @param position The delta position amount
   */
  setDeltaPosition(e) {
    this._deltaPosition.copyFrom(e);
  }
  /**
   * Sets the delta rotation
   * @param rotation The delta rotation amount
   */
  setDeltaRotation(e) {
    this._deltaRotation || (this._deltaRotation = new U()), this._deltaRotation.copyFrom(e), this._deltaRotationConjugated = this._deltaRotation.conjugate();
  }
  /**
   * Gets the box size of the physics imposter and stores the result in the input parameter
   * @param result Stores the box size
   * @returns The physics imposter
   */
  getBoxSizeToRef(e) {
    return this._physicsEngine && this._physicsEngine.getPhysicsPlugin().getBoxSizeToRef(this, e), this;
  }
  /**
   * Gets the radius of the physics imposter
   * @returns Radius of the physics imposter
   */
  getRadius() {
    return this._physicsEngine ? this._physicsEngine.getPhysicsPlugin().getRadius(this) : 0;
  }
  /**
   * Sync a bone with this impostor
   * @param bone The bone to sync to the impostor.
   * @param boneMesh The mesh that the bone is influencing.
   * @param jointPivot The pivot of the joint / bone in local space.
   * @param distToJoint Optional distance from the impostor to the joint.
   * @param adjustRotation Optional quaternion for adjusting the local rotation of the bone.
   */
  syncBoneWithImpostor(e, t, i, s, r) {
    const n = re._TmpVecs[0], a = this.object;
    if (a.rotationQuaternion)
      if (r) {
        const o = re._TmpQuat;
        a.rotationQuaternion.multiplyToRef(r, o), e.setRotationQuaternion(o, Pe.WORLD, t);
      } else
        e.setRotationQuaternion(a.rotationQuaternion, Pe.WORLD, t);
    n.x = 0, n.y = 0, n.z = 0, i && (n.x = i.x, n.y = i.y, n.z = i.z, e.getDirectionToRef(n, t, n), s == null && (s = i.length()), n.x *= s, n.y *= s, n.z *= s), e.getParent() ? (n.addInPlace(a.getAbsolutePosition()), e.setAbsolutePosition(n, t)) : (t.setAbsolutePosition(a.getAbsolutePosition()), t.position.x -= n.x, t.position.y -= n.y, t.position.z -= n.z);
  }
  /**
   * Sync impostor to a bone
   * @param bone The bone that the impostor will be synced to.
   * @param boneMesh The mesh that the bone is influencing.
   * @param jointPivot The pivot of the joint / bone in local space.
   * @param distToJoint Optional distance from the impostor to the joint.
   * @param adjustRotation Optional quaternion for adjusting the local rotation of the bone.
   * @param boneAxis Optional vector3 axis the bone is aligned with
   */
  syncImpostorWithBone(e, t, i, s, r, n) {
    const a = this.object;
    if (a.rotationQuaternion)
      if (r) {
        const c = re._TmpQuat;
        e.getRotationQuaternionToRef(Pe.WORLD, t, c), c.multiplyToRef(r, a.rotationQuaternion);
      } else
        e.getRotationQuaternionToRef(Pe.WORLD, t, a.rotationQuaternion);
    const o = re._TmpVecs[0], l = re._TmpVecs[1];
    n || (n = re._TmpVecs[2], n.x = 0, n.y = 1, n.z = 0), e.getDirectionToRef(n, t, l), e.getAbsolutePositionToRef(t, o), s == null && i && (s = i.length()), s != null && (o.x += l.x * s, o.y += l.y * s, o.z += l.z * s), a.setAbsolutePosition(o);
  }
}
re.DEFAULT_OBJECT_SIZE = new p(1, 1, 1);
re.IDENTITY_QUATERNION = U.Identity();
re._TmpVecs = ot.BuildArray(3, p.Zero);
re._TmpQuat = U.Identity();
re.NoImpostor = 0;
re.SphereImpostor = 1;
re.BoxImpostor = 2;
re.PlaneImpostor = 3;
re.MeshImpostor = 4;
re.CapsuleImpostor = 6;
re.CylinderImpostor = 7;
re.ParticleImpostor = 8;
re.HeightmapImpostor = 9;
re.ConvexHullImpostor = 10;
re.CustomImpostor = 100;
re.RopeImpostor = 101;
re.ClothImpostor = 102;
re.SoftbodyImpostor = 103;
class Un {
  constructor() {
    this._hasHit = !1, this._hitDistance = 0, this._hitNormalWorld = p.Zero(), this._hitPointWorld = p.Zero(), this._rayFromWorld = p.Zero(), this._rayToWorld = p.Zero(), this._triangleIndex = -1;
  }
  /**
   * Gets if there was a hit
   */
  get hasHit() {
    return this._hasHit;
  }
  /**
   * Gets the distance from the hit
   */
  get hitDistance() {
    return this._hitDistance;
  }
  /**
   * Gets the hit normal/direction in the world
   */
  get hitNormalWorld() {
    return this._hitNormalWorld;
  }
  /**
   * Gets the hit point in the world
   */
  get hitPointWorld() {
    return this._hitPointWorld;
  }
  /**
   * Gets the ray "start point" of the ray in the world
   */
  get rayFromWorld() {
    return this._rayFromWorld;
  }
  /**
   * Gets the ray "end point" of the ray in the world
   */
  get rayToWorld() {
    return this._rayToWorld;
  }
  /*
   * The index of the original triangle which was hit. Will be -1 if contact point is not on a mesh shape
   */
  get triangleIndex() {
    return this._triangleIndex;
  }
  /**
   * Sets the hit data (normal & point in world space)
   * @param hitNormalWorld defines the normal in world space
   * @param hitPointWorld defines the point in world space
   */
  setHitData(e, t, i) {
    this._hasHit = !0, this._hitNormalWorld.set(e.x, e.y, e.z), this._hitPointWorld.set(t.x, t.y, t.z), this._triangleIndex = i ?? -1;
  }
  /**
   * Sets the distance from the start point to the hit point
   * @param distance
   */
  setHitDistance(e) {
    this._hitDistance = e;
  }
  /**
   * Calculates the distance manually
   */
  calculateHitDistance() {
    this._hitDistance = p.Distance(this._rayFromWorld, this._hitPointWorld);
  }
  /**
   * Resets all the values to default
   * @param from The from point on world space
   * @param to The to point on world space
   */
  reset(e = p.Zero(), t = p.Zero()) {
    this._rayFromWorld.copyFrom(e), this._rayToWorld.copyFrom(t), this._hasHit = !1, this._hitDistance = 0, this._hitNormalWorld.setAll(0), this._hitPointWorld.setAll(0), this._triangleIndex = -1, this.body = void 0, this.bodyIndex = void 0;
  }
}
class la {
  constructor(e = !0, t = 10, i = CANNON) {
    if (this._useDeltaForWorldStep = e, this.name = "CannonJSPlugin", this._physicsMaterials = new Array(), this._fixedTimeStep = 1 / 60, this._physicsBodiesToRemoveAfterStep = new Array(), this._firstFrame = !0, this._tmpQuaternion = new U(), this._minus90X = new U(-0.7071067811865475, 0, 0, 0.7071067811865475), this._plus90X = new U(0.7071067811865475, 0, 0, 0.7071067811865475), this._tmpPosition = p.Zero(), this._tmpDeltaPosition = p.Zero(), this._tmpUnityRotation = new U(), this.BJSCANNON = i, !this.isSupported()) {
      w.Error("CannonJS is not available. Please make sure you included the js file.");
      return;
    }
    this._extendNamespace(), this.world = new this.BJSCANNON.World(), this.world.broadphase = new this.BJSCANNON.NaiveBroadphase(), this.world.solver.iterations = t, this._cannonRaycastResult = new this.BJSCANNON.RaycastResult(), this._raycastResult = new Un();
  }
  /**
   *
   * @returns plugin version
   */
  getPluginVersion() {
    return 1;
  }
  setGravity(e) {
    const t = e;
    this.world.gravity.set(t.x, t.y, t.z);
  }
  setTimeStep(e) {
    this._fixedTimeStep = e;
  }
  getTimeStep() {
    return this._fixedTimeStep;
  }
  executeStep(e, t) {
    if (this._firstFrame) {
      this._firstFrame = !1;
      for (const i of t)
        i.type == re.HeightmapImpostor || i.type === re.PlaneImpostor || i.beforeStep();
    }
    this.world.step(this._useDeltaForWorldStep ? e : this._fixedTimeStep), this._removeMarkedPhysicsBodiesFromWorld();
  }
  _removeMarkedPhysicsBodiesFromWorld() {
    this._physicsBodiesToRemoveAfterStep.length > 0 && (this._physicsBodiesToRemoveAfterStep.forEach((e) => {
      typeof this.world.removeBody == "function" ? this.world.removeBody(e) : this.world.remove(e);
    }), this._physicsBodiesToRemoveAfterStep.length = 0);
  }
  applyImpulse(e, t, i) {
    const s = new this.BJSCANNON.Vec3(i.x, i.y, i.z), r = new this.BJSCANNON.Vec3(t.x, t.y, t.z);
    e.physicsBody.applyImpulse(r, s);
  }
  applyForce(e, t, i) {
    const s = new this.BJSCANNON.Vec3(i.x, i.y, i.z), r = new this.BJSCANNON.Vec3(t.x, t.y, t.z);
    e.physicsBody.applyForce(r, s);
  }
  generatePhysicsBody(e) {
    if (this._removeMarkedPhysicsBodiesFromWorld(), e.parent) {
      e.physicsBody && (this.removePhysicsBody(e), e.forceUpdate());
      return;
    }
    if (e.isBodyInitRequired()) {
      const t = this._createShape(e);
      if (!t) {
        w.Warn("It was not possible to create a physics body for this object.");
        return;
      }
      const i = e.physicsBody;
      i && this.removePhysicsBody(e);
      const s = this._addMaterial("mat-" + e.uniqueId, e.getParam("friction"), e.getParam("restitution")), r = {
        mass: e.getParam("mass"),
        material: s
      }, n = e.getParam("nativeOptions");
      for (const a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (r[a] = n[a]);
      e.physicsBody = new this.BJSCANNON.Body(r), e.physicsBody.addEventListener("collide", e.onCollide), this.world.addEventListener("preStep", e.beforeStep), this.world.addEventListener("postStep", e.afterStep), e.physicsBody.addShape(t), typeof this.world.addBody == "function" ? this.world.addBody(e.physicsBody) : this.world.add(e.physicsBody), i && ["force", "torque", "velocity", "angularVelocity"].forEach(function(a) {
        const o = i[a];
        e.physicsBody[a].set(o.x, o.y, o.z);
      }), this._processChildMeshes(e);
    }
    this._updatePhysicsBodyTransformation(e);
  }
  _processChildMeshes(e) {
    const t = e.object.getChildMeshes ? e.object.getChildMeshes(!0) : [], i = e.object.rotationQuaternion;
    if (i ? i.conjugateToRef(this._tmpQuaternion) : this._tmpQuaternion.set(0, 0, 0, 1), t.length) {
      const s = (r) => {
        if (!r.rotationQuaternion)
          return;
        const n = r.getPhysicsImpostor();
        if (n && n.parent !== e && r.parent) {
          const o = r.getAbsolutePosition().subtract(r.parent.getAbsolutePosition()), l = r.rotationQuaternion.multiply(this._tmpQuaternion);
          n.physicsBody && (this.removePhysicsBody(n), n.physicsBody = null), n.parent = e, n.resetUpdateFlags(), e.physicsBody.addShape(this._createShape(n), new this.BJSCANNON.Vec3(o.x, o.y, o.z), new this.BJSCANNON.Quaternion(l.x, l.y, l.z, l.w)), e.physicsBody.mass += n.getParam("mass");
        }
        r.getChildMeshes(!0).filter((a) => !!a.physicsImpostor).forEach(s);
      };
      t.filter((r) => !!r.physicsImpostor).forEach(s);
    }
  }
  removePhysicsBody(e) {
    e.physicsBody.removeEventListener("collide", e.onCollide), this.world.removeEventListener("preStep", e.beforeStep), this.world.removeEventListener("postStep", e.afterStep), this._physicsBodiesToRemoveAfterStep.indexOf(e.physicsBody) === -1 && this._physicsBodiesToRemoveAfterStep.push(e.physicsBody);
  }
  generateJoint(e) {
    const t = e.mainImpostor.physicsBody, i = e.connectedImpostor.physicsBody;
    if (!t || !i)
      return;
    let s;
    const r = e.joint.jointData, n = {
      pivotA: r.mainPivot ? new this.BJSCANNON.Vec3().set(r.mainPivot.x, r.mainPivot.y, r.mainPivot.z) : null,
      pivotB: r.connectedPivot ? new this.BJSCANNON.Vec3().set(r.connectedPivot.x, r.connectedPivot.y, r.connectedPivot.z) : null,
      axisA: r.mainAxis ? new this.BJSCANNON.Vec3().set(r.mainAxis.x, r.mainAxis.y, r.mainAxis.z) : null,
      axisB: r.connectedAxis ? new this.BJSCANNON.Vec3().set(r.connectedAxis.x, r.connectedAxis.y, r.connectedAxis.z) : null,
      maxForce: r.nativeParams.maxForce,
      collideConnected: !!r.collision
    };
    switch (e.joint.type) {
      case Ge.HingeJoint:
      case Ge.Hinge2Joint:
        s = new this.BJSCANNON.HingeConstraint(t, i, n);
        break;
      case Ge.DistanceJoint:
        s = new this.BJSCANNON.DistanceConstraint(t, i, r.maxDistance || 2);
        break;
      case Ge.SpringJoint: {
        const a = r;
        s = new this.BJSCANNON.Spring(t, i, {
          restLength: a.length,
          stiffness: a.stiffness,
          damping: a.damping,
          localAnchorA: n.pivotA,
          localAnchorB: n.pivotB
        });
        break;
      }
      case Ge.LockJoint:
        s = new this.BJSCANNON.LockConstraint(t, i, n);
        break;
      case Ge.PointToPointJoint:
      case Ge.BallAndSocketJoint:
      default:
        s = new this.BJSCANNON.PointToPointConstraint(t, n.pivotA, i, n.pivotB, n.maxForce);
        break;
    }
    s.collideConnected = !!r.collision, e.joint.physicsJoint = s, e.joint.type !== Ge.SpringJoint ? this.world.addConstraint(s) : (e.joint.jointData.forceApplicationCallback = e.joint.jointData.forceApplicationCallback || function() {
      s.applyForce();
    }, e.mainImpostor.registerAfterPhysicsStep(e.joint.jointData.forceApplicationCallback));
  }
  removeJoint(e) {
    e.joint.type !== Ge.SpringJoint ? this.world.removeConstraint(e.joint.physicsJoint) : e.mainImpostor.unregisterAfterPhysicsStep(e.joint.jointData.forceApplicationCallback);
  }
  _addMaterial(e, t, i) {
    let s, r;
    for (s = 0; s < this._physicsMaterials.length; s++)
      if (r = this._physicsMaterials[s], r.friction === t && r.restitution === i)
        return r;
    const n = new this.BJSCANNON.Material(e);
    return n.friction = t, n.restitution = i, this._physicsMaterials.push(n), n;
  }
  _checkWithEpsilon(e) {
    return e < pe ? pe : e;
  }
  _createShape(e) {
    const t = e.object;
    let i;
    const s = e.getObjectExtents();
    switch (e.type) {
      case re.SphereImpostor: {
        const r = s.x, n = s.y, a = s.z;
        i = new this.BJSCANNON.Sphere(Math.max(this._checkWithEpsilon(r), this._checkWithEpsilon(n), this._checkWithEpsilon(a)) / 2);
        break;
      }
      case re.CylinderImpostor: {
        let r = e.getParam("nativeOptions");
        r || (r = {});
        const n = r.radiusTop !== void 0 ? r.radiusTop : this._checkWithEpsilon(s.x) / 2, a = r.radiusBottom !== void 0 ? r.radiusBottom : this._checkWithEpsilon(s.x) / 2, o = r.height !== void 0 ? r.height : this._checkWithEpsilon(s.y), l = r.numSegments !== void 0 ? r.numSegments : 16;
        i = new this.BJSCANNON.Cylinder(n, a, o, l);
        const c = new this.BJSCANNON.Quaternion();
        c.setFromAxisAngle(new this.BJSCANNON.Vec3(1, 0, 0), -Math.PI / 2);
        const u = new this.BJSCANNON.Vec3(0, 0, 0);
        i.transformAllPoints(u, c);
        break;
      }
      case re.BoxImpostor: {
        const r = s.scale(0.5);
        i = new this.BJSCANNON.Box(new this.BJSCANNON.Vec3(this._checkWithEpsilon(r.x), this._checkWithEpsilon(r.y), this._checkWithEpsilon(r.z)));
        break;
      }
      case re.PlaneImpostor:
        w.Warn("Attention, PlaneImposter might not behave as you expect. Consider using BoxImposter instead"), i = new this.BJSCANNON.Plane();
        break;
      case re.MeshImpostor: {
        const r = t.getVerticesData ? t.getVerticesData(v.PositionKind) : [], n = t.getIndices ? t.getIndices() : [];
        if (!r) {
          w.Warn("Tried to create a MeshImpostor for an object without vertices. This will fail.");
          return;
        }
        const a = t.position.clone(), o = t.rotation && t.rotation.clone(), l = t.rotationQuaternion && t.rotationQuaternion.clone();
        t.position.copyFromFloats(0, 0, 0), t.rotation && t.rotation.copyFromFloats(0, 0, 0), t.rotationQuaternion && t.rotationQuaternion.copyFrom(e.getParentsRotation()), t.rotationQuaternion && t.parent && t.rotationQuaternion.conjugateInPlace();
        const c = t.computeWorldMatrix(!0), u = new Array();
        let d;
        for (d = 0; d < r.length; d += 3)
          p.TransformCoordinates(p.FromArray(r, d), c).toArray(u, d);
        w.Warn("MeshImpostor only collides against spheres."), i = new this.BJSCANNON.Trimesh(u, n), t.position.copyFrom(a), o && t.rotation && t.rotation.copyFrom(o), l && t.rotationQuaternion && t.rotationQuaternion.copyFrom(l);
        break;
      }
      case re.HeightmapImpostor: {
        const r = t.position.clone(), n = t.rotation && t.rotation.clone(), a = t.rotationQuaternion && t.rotationQuaternion.clone();
        t.position.copyFromFloats(0, 0, 0), t.rotation && t.rotation.copyFromFloats(0, 0, 0), t.rotationQuaternion && t.rotationQuaternion.copyFrom(e.getParentsRotation()), t.rotationQuaternion && t.parent && t.rotationQuaternion.conjugateInPlace(), t.rotationQuaternion && t.rotationQuaternion.multiplyInPlace(this._minus90X), i = this._createHeightmap(t), t.position.copyFrom(r), n && t.rotation && t.rotation.copyFrom(n), a && t.rotationQuaternion && t.rotationQuaternion.copyFrom(a), t.computeWorldMatrix(!0);
        break;
      }
      case re.ParticleImpostor:
        i = new this.BJSCANNON.Particle();
        break;
      case re.NoImpostor:
        i = new this.BJSCANNON.Box(new this.BJSCANNON.Vec3(0, 0, 0));
        break;
    }
    return i;
  }
  _createHeightmap(e, t) {
    let i = e.getVerticesData(v.PositionKind);
    const s = e.computeWorldMatrix(!0), r = new Array();
    let n;
    for (n = 0; n < i.length; n += 3)
      p.TransformCoordinates(p.FromArray(i, n), s).toArray(r, n);
    i = r;
    const a = new Array(), o = t || ~~(Math.sqrt(i.length / 3) - 1), l = e.getBoundingInfo(), c = Math.min(l.boundingBox.extendSizeWorld.x, l.boundingBox.extendSizeWorld.y), u = l.boundingBox.extendSizeWorld.z, d = c * 2 / o;
    for (let _ = 0; _ < i.length; _ = _ + 3) {
      const g = Math.round(i[_ + 0] / d + o / 2), m = Math.round((i[_ + 1] / d - o / 2) * -1), y = -i[_ + 2] + u;
      a[g] || (a[g] = []), a[g][m] || (a[g][m] = y), a[g][m] = Math.max(y, a[g][m]);
    }
    for (let _ = 0; _ <= o; ++_) {
      if (!a[_]) {
        let g = 1;
        for (; !a[(_ + g) % o]; )
          g++;
        a[_] = a[(_ + g) % o].slice();
      }
      for (let g = 0; g <= o; ++g)
        if (!a[_][g]) {
          let m = 1, y;
          for (; y === void 0; )
            y = a[_][(g + m++) % o];
          a[_][g] = y;
        }
    }
    const f = new this.BJSCANNON.Heightfield(a, {
      elementSize: d
    });
    return f.minY = u, f;
  }
  _updatePhysicsBodyTransformation(e) {
    const t = e.object;
    if (t.computeWorldMatrix && t.computeWorldMatrix(!0), !t.getBoundingInfo())
      return;
    const i = e.getObjectCenter();
    this._tmpDeltaPosition.copyFrom(t.getAbsolutePivotPoint().subtract(i)), this._tmpDeltaPosition.divideInPlace(e.object.scaling), this._tmpPosition.copyFrom(i);
    let s = t.rotationQuaternion;
    if (s) {
      if ((e.type === re.PlaneImpostor || e.type === re.HeightmapImpostor) && (s = s.multiply(this._minus90X), e.setDeltaRotation(this._plus90X)), e.type === re.HeightmapImpostor) {
        const r = t;
        let n = r.getBoundingInfo();
        const a = r.rotationQuaternion;
        r.rotationQuaternion = this._tmpUnityRotation, r.computeWorldMatrix(!0);
        const o = i.clone();
        let l = r.getPivotMatrix();
        l ? l = l.clone() : l = I.Identity();
        const c = I.Translation(n.boundingBox.extendSizeWorld.x, 0, -n.boundingBox.extendSizeWorld.z);
        r.setPreTransformMatrix(c), r.computeWorldMatrix(!0), n = r.getBoundingInfo();
        const u = n.boundingBox.centerWorld.subtract(i).subtract(r.position).negate();
        this._tmpPosition.copyFromFloats(u.x, u.y - n.boundingBox.extendSizeWorld.y, u.z), this._tmpDeltaPosition.copyFrom(n.boundingBox.centerWorld.subtract(o)), this._tmpDeltaPosition.y += n.boundingBox.extendSizeWorld.y, r.rotationQuaternion = a, r.setPreTransformMatrix(l), r.computeWorldMatrix(!0);
      } else e.type === re.MeshImpostor && this._tmpDeltaPosition.copyFromFloats(0, 0, 0);
      e.setDeltaPosition(this._tmpDeltaPosition), e.physicsBody.position.set(this._tmpPosition.x, this._tmpPosition.y, this._tmpPosition.z), e.physicsBody.quaternion.set(s.x, s.y, s.z, s.w);
    }
  }
  setTransformationFromPhysicsBody(e) {
    if (e.object.position.set(e.physicsBody.position.x, e.physicsBody.position.y, e.physicsBody.position.z), e.object.rotationQuaternion) {
      const t = e.physicsBody.quaternion;
      e.object.rotationQuaternion.set(t.x, t.y, t.z, t.w);
    }
  }
  setPhysicsBodyTransformation(e, t, i) {
    e.physicsBody.position.set(t.x, t.y, t.z), e.physicsBody.quaternion.set(i.x, i.y, i.z, i.w);
  }
  isSupported() {
    return this.BJSCANNON !== void 0;
  }
  setLinearVelocity(e, t) {
    e.physicsBody.velocity.set(t.x, t.y, t.z);
  }
  setAngularVelocity(e, t) {
    e.physicsBody.angularVelocity.set(t.x, t.y, t.z);
  }
  getLinearVelocity(e) {
    const t = e.physicsBody.velocity;
    return t ? new p(t.x, t.y, t.z) : null;
  }
  getAngularVelocity(e) {
    const t = e.physicsBody.angularVelocity;
    return t ? new p(t.x, t.y, t.z) : null;
  }
  setBodyMass(e, t) {
    e.physicsBody.mass = t, e.physicsBody.updateMassProperties();
  }
  getBodyMass(e) {
    return e.physicsBody.mass;
  }
  getBodyFriction(e) {
    return e.physicsBody.material.friction;
  }
  setBodyFriction(e, t) {
    e.physicsBody.material.friction = t;
  }
  getBodyRestitution(e) {
    return e.physicsBody.material.restitution;
  }
  setBodyRestitution(e, t) {
    e.physicsBody.material.restitution = t;
  }
  sleepBody(e) {
    e.physicsBody.sleep();
  }
  wakeUpBody(e) {
    e.physicsBody.wakeUp();
  }
  updateDistanceJoint(e, t) {
    e.physicsJoint.distance = t;
  }
  setMotor(e, t, i, s) {
    s || (e.physicsJoint.enableMotor(), e.physicsJoint.setMotorSpeed(t), i && this.setLimit(e, i));
  }
  setLimit(e, t, i) {
    e.physicsJoint.motorEquation.maxForce = i, e.physicsJoint.motorEquation.minForce = t === void 0 ? -t : t;
  }
  syncMeshWithImpostor(e, t) {
    const i = t.physicsBody;
    e.position.x = i.position.x, e.position.y = i.position.y, e.position.z = i.position.z, e.rotationQuaternion && (e.rotationQuaternion.x = i.quaternion.x, e.rotationQuaternion.y = i.quaternion.y, e.rotationQuaternion.z = i.quaternion.z, e.rotationQuaternion.w = i.quaternion.w);
  }
  getRadius(e) {
    return e.physicsBody.shapes[0].boundingSphereRadius;
  }
  getBoxSizeToRef(e, t) {
    const i = e.physicsBody.shapes[0];
    t.x = i.halfExtents.x * 2, t.y = i.halfExtents.y * 2, t.z = i.halfExtents.z * 2;
  }
  dispose() {
  }
  _extendNamespace() {
    const e = new this.BJSCANNON.Vec3(), t = this.BJSCANNON;
    this.BJSCANNON.World.prototype.step = function(i, s, r) {
      if (r = r || 10, s = s || 0, s === 0)
        this.internalStep(i), this.time += i;
      else {
        let n = Math.floor((this.time + s) / i) - Math.floor(this.time / i);
        n = Math.min(n, r) || 1;
        const a = performance.now();
        for (let d = 0; d !== n && (this.internalStep(i), !(performance.now() - a > i * 1e3)); d++)
          ;
        this.time += s;
        const l = this.time % i / i, c = e, u = this.bodies;
        for (let d = 0; d !== u.length; d++) {
          const f = u[d];
          f.type !== t.Body.STATIC && f.sleepState !== t.Body.SLEEPING ? (f.position.vsub(f.previousPosition, c), c.scale(l, c), f.position.vadd(c, f.interpolatedPosition)) : (f.interpolatedPosition.set(f.position.x, f.position.y, f.position.z), f.interpolatedQuaternion.set(f.quaternion.x, f.quaternion.y, f.quaternion.z, f.quaternion.w));
        }
      }
    };
  }
  /**
   * Does a raycast in the physics world
   * @param from when should the ray start?
   * @param to when should the ray end?
   * @returns PhysicsRaycastResult
   */
  raycast(e, t) {
    return this._raycastResult.reset(e, t), this.raycastToRef(e, t, this._raycastResult), this._raycastResult;
  }
  /**
   * Does a raycast in the physics world
   * @param from when should the ray start?
   * @param to when should the ray end?
   * @param result resulting PhysicsRaycastResult
   */
  raycastToRef(e, t, i) {
    this._cannonRaycastResult.reset(), this.world.raycastClosest(e, t, {}, this._cannonRaycastResult), i.reset(e, t), this._cannonRaycastResult.hasHit && (i.setHitData({
      x: this._cannonRaycastResult.hitNormalWorld.x,
      y: this._cannonRaycastResult.hitNormalWorld.y,
      z: this._cannonRaycastResult.hitNormalWorld.z
    }, {
      x: this._cannonRaycastResult.hitPointWorld.x,
      y: this._cannonRaycastResult.hitPointWorld.y,
      z: this._cannonRaycastResult.hitPointWorld.z
    }), i.setHitDistance(this._cannonRaycastResult.distance));
  }
}
class ha {
  constructor(e = !0, t, i = OIMO) {
    this._useDeltaForWorldStep = e, this.name = "OimoJSPlugin", this._fixedTimeStep = 1 / 60, this._tmpImpostorsArray = [], this._tmpPositionVector = p.Zero(), this.BJSOIMO = i, this.world = new this.BJSOIMO.World({
      iterations: t
    }), this.world.clear(), this._raycastResult = new Un();
  }
  /**
   *
   * @returns plugin version
   */
  getPluginVersion() {
    return 1;
  }
  setGravity(e) {
    this.world.gravity.set(e.x, e.y, e.z);
  }
  setTimeStep(e) {
    this.world.timeStep = e;
  }
  getTimeStep() {
    return this.world.timeStep;
  }
  executeStep(e, t) {
    t.forEach(function(s) {
      s.beforeStep();
    }), this.world.timeStep = this._useDeltaForWorldStep ? e : this._fixedTimeStep, this.world.step(), t.forEach((s) => {
      s.afterStep(), this._tmpImpostorsArray[s.uniqueId] = s;
    });
    let i = this.world.contacts;
    for (; i !== null; ) {
      if (i.touching && !i.body1.sleeping && !i.body2.sleeping) {
        i = i.next;
        continue;
      }
      const s = this._tmpImpostorsArray[+i.body1.name], r = this._tmpImpostorsArray[+i.body2.name];
      if (!s || !r) {
        i = i.next;
        continue;
      }
      s.onCollide({ body: r.physicsBody, point: null, distance: 0, impulse: 0, normal: null }), r.onCollide({ body: s.physicsBody, point: null, distance: 0, impulse: 0, normal: null }), i = i.next;
    }
  }
  applyImpulse(e, t, i) {
    const s = e.physicsBody.mass;
    e.physicsBody.applyImpulse(i.scale(this.world.invScale), t.scale(this.world.invScale * s));
  }
  applyForce(e, t, i) {
    w.Warn("Oimo doesn't support applying force. Using impulse instead."), this.applyImpulse(e, t, i);
  }
  generatePhysicsBody(e) {
    if (e.parent) {
      e.physicsBody && (this.removePhysicsBody(e), e.forceUpdate());
      return;
    }
    if (e.isBodyInitRequired()) {
      const t = {
        name: e.uniqueId,
        //Oimo must have mass, also for static objects.
        config: [e.getParam("mass") || 1e-3, e.getParam("friction"), e.getParam("restitution")],
        size: [],
        type: [],
        pos: [],
        posShape: [],
        rot: [],
        rotShape: [],
        move: e.getParam("mass") !== 0,
        density: e.getParam("mass"),
        friction: e.getParam("friction"),
        restitution: e.getParam("restitution"),
        //Supporting older versions of Oimo
        world: this.world
      }, i = [e];
      ((a) => {
        a.getChildMeshes && a.getChildMeshes().forEach(function(o) {
          o.physicsImpostor && i.push(o.physicsImpostor);
        });
      })(e.object);
      const r = (a) => Math.max(a, pe), n = new U();
      i.forEach((a) => {
        if (!a.object.rotationQuaternion)
          return;
        const o = a.object.rotationQuaternion;
        n.copyFrom(o), a.object.rotationQuaternion.set(0, 0, 0, 1), a.object.computeWorldMatrix(!0);
        const l = n.toEulerAngles(), c = a.getObjectExtents(), u = 57.29577951308232;
        if (a === e) {
          const d = e.getObjectCenter();
          e.object.getAbsolutePivotPoint().subtractToRef(d, this._tmpPositionVector), this._tmpPositionVector.divideInPlace(e.object.scaling), t.pos.push(d.x), t.pos.push(d.y), t.pos.push(d.z), t.posShape.push(0, 0, 0), t.rotShape.push(0, 0, 0);
        } else {
          const d = a.object.position.clone();
          t.posShape.push(d.x), t.posShape.push(d.y), t.posShape.push(d.z), t.rotShape.push(l.x * u, l.y * u, l.z * u);
        }
        switch (a.object.rotationQuaternion.copyFrom(n), a.type) {
          case re.ParticleImpostor:
            w.Warn("No Particle support in OIMO.js. using SphereImpostor instead");
          case re.SphereImpostor: {
            const d = c.x, f = c.y, _ = c.z, g = Math.max(r(d), r(f), r(_)) / 2;
            t.type.push("sphere"), t.size.push(g), t.size.push(g), t.size.push(g);
            break;
          }
          case re.CylinderImpostor: {
            const d = r(c.x) / 2, f = r(c.y);
            t.type.push("cylinder"), t.size.push(d), t.size.push(f), t.size.push(f);
            break;
          }
          case re.PlaneImpostor:
          case re.BoxImpostor:
          default: {
            const d = r(c.x), f = r(c.y), _ = r(c.z);
            t.type.push("box"), t.size.push(d), t.size.push(f), t.size.push(_);
            break;
          }
        }
        a.object.rotationQuaternion = o;
      }), e.physicsBody = this.world.add(t), e.physicsBody.resetQuaternion(n), e.physicsBody.updatePosition(0);
    } else
      this._tmpPositionVector.copyFromFloats(0, 0, 0);
    e.setDeltaPosition(this._tmpPositionVector);
  }
  removePhysicsBody(e) {
    this.world.removeRigidBody(e.physicsBody);
  }
  generateJoint(e) {
    const t = e.mainImpostor.physicsBody, i = e.connectedImpostor.physicsBody;
    if (!t || !i)
      return;
    const s = e.joint.jointData, r = s.nativeParams || {};
    let n;
    const a = {
      body1: t,
      body2: i,
      axe1: r.axe1 || (s.mainAxis ? s.mainAxis.asArray() : null),
      axe2: r.axe2 || (s.connectedAxis ? s.connectedAxis.asArray() : null),
      pos1: r.pos1 || (s.mainPivot ? s.mainPivot.asArray() : null),
      pos2: r.pos2 || (s.connectedPivot ? s.connectedPivot.asArray() : null),
      min: r.min,
      max: r.max,
      collision: r.collision || s.collision,
      spring: r.spring,
      //supporting older version of Oimo
      world: this.world
    };
    switch (e.joint.type) {
      case Ge.BallAndSocketJoint:
        n = "jointBall";
        break;
      case Ge.SpringJoint: {
        w.Warn("OIMO.js doesn't support Spring Constraint. Simulating using DistanceJoint instead");
        const o = s;
        a.min = o.length || a.min, a.max = Math.max(a.min, a.max);
      }
      case Ge.DistanceJoint:
        n = "jointDistance", a.max = s.maxDistance;
        break;
      case Ge.PrismaticJoint:
        n = "jointPrisme";
        break;
      case Ge.SliderJoint:
        n = "jointSlide";
        break;
      case Ge.WheelJoint:
        n = "jointWheel";
        break;
      case Ge.HingeJoint:
      default:
        n = "jointHinge";
        break;
    }
    a.type = n, e.joint.physicsJoint = this.world.add(a);
  }
  removeJoint(e) {
    try {
      this.world.removeJoint(e.joint.physicsJoint);
    } catch (t) {
      w.Warn(t);
    }
  }
  isSupported() {
    return this.BJSOIMO !== void 0;
  }
  setTransformationFromPhysicsBody(e) {
    if (!e.physicsBody.sleeping) {
      if (e.physicsBody.shapes.next) {
        let t = e.physicsBody.shapes;
        for (; t.next; )
          t = t.next;
        e.object.position.set(t.position.x, t.position.y, t.position.z);
      } else {
        const t = e.physicsBody.getPosition();
        e.object.position.set(t.x, t.y, t.z);
      }
      if (e.object.rotationQuaternion) {
        const t = e.physicsBody.getQuaternion();
        e.object.rotationQuaternion.set(t.x, t.y, t.z, t.w);
      }
    }
  }
  setPhysicsBodyTransformation(e, t, i) {
    const s = e.physicsBody;
    e.physicsBody.shapes.next || (s.position.set(t.x, t.y, t.z), s.orientation.set(i.x, i.y, i.z, i.w), s.syncShapes(), s.awake());
  }
  /*private _getLastShape(body: any): any {
      var lastShape = body.shapes;
      while (lastShape.next) {
          lastShape = lastShape.next;
      }
      return lastShape;
  }*/
  setLinearVelocity(e, t) {
    e.physicsBody.linearVelocity.set(t.x, t.y, t.z);
  }
  setAngularVelocity(e, t) {
    e.physicsBody.angularVelocity.set(t.x, t.y, t.z);
  }
  getLinearVelocity(e) {
    const t = e.physicsBody.linearVelocity;
    return t ? new p(t.x, t.y, t.z) : null;
  }
  getAngularVelocity(e) {
    const t = e.physicsBody.angularVelocity;
    return t ? new p(t.x, t.y, t.z) : null;
  }
  setBodyMass(e, t) {
    const i = t === 0;
    e.physicsBody.shapes.density = i ? 1 : t, e.physicsBody.setupMass(i ? 2 : 1);
  }
  getBodyMass(e) {
    return e.physicsBody.shapes.density;
  }
  getBodyFriction(e) {
    return e.physicsBody.shapes.friction;
  }
  setBodyFriction(e, t) {
    e.physicsBody.shapes.friction = t;
  }
  getBodyRestitution(e) {
    return e.physicsBody.shapes.restitution;
  }
  setBodyRestitution(e, t) {
    e.physicsBody.shapes.restitution = t;
  }
  sleepBody(e) {
    e.physicsBody.sleep();
  }
  wakeUpBody(e) {
    e.physicsBody.awake();
  }
  updateDistanceJoint(e, t, i) {
    e.physicsJoint.limitMotor.upperLimit = t, i !== void 0 && (e.physicsJoint.limitMotor.lowerLimit = i);
  }
  setMotor(e, t, i, s) {
    i !== void 0 ? w.Warn("OimoJS plugin currently has unexpected behavior when using setMotor with force parameter") : i = 1e6, t *= -1;
    const r = s ? e.physicsJoint.rotationalLimitMotor2 : e.physicsJoint.rotationalLimitMotor1 || e.physicsJoint.rotationalLimitMotor || e.physicsJoint.limitMotor;
    r && r.setMotor(t, i);
  }
  setLimit(e, t, i, s) {
    const r = s ? e.physicsJoint.rotationalLimitMotor2 : e.physicsJoint.rotationalLimitMotor1 || e.physicsJoint.rotationalLimitMotor || e.physicsJoint.limitMotor;
    r && r.setLimit(t, i === void 0 ? -t : i);
  }
  syncMeshWithImpostor(e, t) {
    const i = t.physicsBody;
    e.position.x = i.position.x, e.position.y = i.position.y, e.position.z = i.position.z, e.rotationQuaternion && (e.rotationQuaternion.x = i.orientation.x, e.rotationQuaternion.y = i.orientation.y, e.rotationQuaternion.z = i.orientation.z, e.rotationQuaternion.w = i.orientation.w);
  }
  getRadius(e) {
    return e.physicsBody.shapes.radius;
  }
  getBoxSizeToRef(e, t) {
    const i = e.physicsBody.shapes;
    t.x = i.halfWidth * 2, t.y = i.halfHeight * 2, t.z = i.halfDepth * 2;
  }
  dispose() {
    this.world.clear();
  }
  /**
   * Does a raycast in the physics world
   * @param from when should the ray start?
   * @param to when should the ray end?
   * @returns PhysicsRaycastResult
   */
  raycast(e, t) {
    return w.Warn("raycast is not currently supported by the Oimo physics plugin"), this._raycastResult.reset(e, t), this._raycastResult;
  }
  /**
   * Does a raycast in the physics world
   * @param from when should the ray start?
   * @param to when should the ray end?
   * @param result resulting PhysicsRaycastResult
   */
  raycastToRef(e, t, i) {
    w.Warn("raycast is not currently supported by the Oimo physics plugin"), i.reset(e, t);
  }
}
function so(h) {
  let e = h.pathArray;
  const t = h.closeArray || !1, i = h.closePath || !1, s = h.invertUV || !1, r = Math.floor(e[0].length / 2);
  let n = h.offset || r;
  n = n > r ? r : Math.floor(n);
  const a = h.sideOrientation === 0 ? 0 : h.sideOrientation || q.DEFAULTSIDE, o = h.uvs, l = h.colors, c = [], u = [], d = [], f = [], _ = [], g = [], m = [], y = [];
  let x;
  const A = [], T = [];
  let M, b, S;
  if (e.length < 2) {
    const Fe = [], ce = [];
    for (b = 0; b < e[0].length - n; b++)
      Fe.push(e[0][b]), ce.push(e[0][b + n]);
    e = [Fe, ce];
  }
  let P = 0;
  const D = i ? 1 : 0;
  let O, X;
  x = e[0].length;
  let k, Y;
  for (M = 0; M < e.length; M++) {
    for (m[M] = 0, _[M] = [0], O = e[M], X = O.length, x = x < X ? x : X, S = 0; S < X; )
      c.push(O[S].x, O[S].y, O[S].z), S > 0 && (k = O[S].subtract(O[S - 1]).length(), Y = k + m[M], _[M].push(Y), m[M] = Y), S++;
    i && (S--, c.push(O[0].x, O[0].y, O[0].z), k = O[S].subtract(O[0]).length(), Y = k + m[M], _[M].push(Y), m[M] = Y), A[M] = X + D, T[M] = P, P += X + D;
  }
  let se, Te, ve = null, Oe = null;
  for (b = 0; b < x + D; b++) {
    for (y[b] = 0, g[b] = [0], M = 0; M < e.length - 1; M++)
      se = e[M], Te = e[M + 1], b === x ? (ve = se[0], Oe = Te[0]) : (ve = se[b], Oe = Te[b]), k = Oe.subtract(ve).length(), Y = k + y[b], g[b].push(Y), y[b] = Y;
    t && Oe && ve && (se = e[M], Te = e[0], b === x && (Oe = Te[0]), k = Oe.subtract(ve).length(), Y = k + y[b], y[b] = Y);
  }
  let Ne, ke;
  if (o)
    for (M = 0; M < o.length; M++)
      f.push(o[M].x, ct.UseOpenGLOrientationForUV ? 1 - o[M].y : o[M].y);
  else
    for (M = 0; M < e.length; M++)
      for (b = 0; b < x + D; b++)
        Ne = m[M] != 0 ? _[M][b] / m[M] : 0, ke = y[b] != 0 ? g[b][M] / y[b] : 0, s ? f.push(ke, Ne) : f.push(Ne, ct.UseOpenGLOrientationForUV ? 1 - ke : ke);
  M = 0;
  let Se = 0, Be = A[M] - 1, Me = A[M + 1] - 1, je = Be < Me ? Be : Me, Rt = T[1] - T[0];
  const oi = t ? A.length : A.length - 1;
  for (; Se <= je && M < oi; )
    u.push(Se, Se + Rt, Se + 1), u.push(Se + Rt + 1, Se + 1, Se + Rt), Se += 1, Se === je && (M++, M === A.length - 1 ? (Rt = T[0] - T[M], Be = A[M] - 1, Me = A[0] - 1) : (Rt = T[M + 1] - T[M], Be = A[M] - 1, Me = A[M + 1] - 1), Se = T[M], je = Be < Me ? Be + Se : Me + Se);
  if (q.ComputeNormals(c, u, d), i) {
    let Fe = 0, ce = 0;
    for (M = 0; M < e.length; M++)
      Fe = T[M] * 3, M + 1 < e.length ? ce = (T[M + 1] - 1) * 3 : ce = d.length - 3, d[Fe] = (d[Fe] + d[ce]) * 0.5, d[Fe + 1] = (d[Fe + 1] + d[ce + 1]) * 0.5, d[Fe + 2] = (d[Fe + 2] + d[ce + 2]) * 0.5, d[ce] = d[Fe], d[ce + 1] = d[Fe + 1], d[ce + 2] = d[Fe + 2];
  }
  q._ComputeSides(a, c, u, d, f, h.frontUVs, h.backUVs);
  let Mt = null;
  if (l) {
    Mt = new Float32Array(l.length * 4);
    for (let Fe = 0; Fe < l.length; Fe++)
      Mt[Fe * 4] = l[Fe].r, Mt[Fe * 4 + 1] = l[Fe].g, Mt[Fe * 4 + 2] = l[Fe].b, Mt[Fe * 4 + 3] = l[Fe].a;
  }
  const it = new q(), Xt = new Float32Array(c), xt = new Float32Array(d), Ht = new Float32Array(f);
  return it.indices = u, it.positions = Xt, it.normals = xt, it.uvs = Ht, Mt && it.set(Mt, v.ColorKind), i && (it._idx = T), it;
}
function hn(h, e, t = null) {
  const i = e.pathArray, s = e.closeArray, r = e.closePath, n = K._GetDefaultSideOrientation(e.sideOrientation), a = e.instance, o = e.updatable;
  if (a) {
    const l = C.Vector3[0].setAll(Number.MAX_VALUE), c = C.Vector3[1].setAll(-Number.MAX_VALUE), u = (f) => {
      let _ = i[0].length;
      const g = a;
      let m = 0;
      const y = g._originalBuilderSideOrientation === K.DOUBLESIDE ? 2 : 1;
      for (let x = 1; x <= y; ++x)
        for (let A = 0; A < i.length; ++A) {
          const T = i[A], M = T.length;
          _ = _ < M ? _ : M;
          for (let b = 0; b < _; ++b) {
            const S = T[b];
            f[m] = S.x, f[m + 1] = S.y, f[m + 2] = S.z, l.minimizeInPlaceFromFloats(S.x, S.y, S.z), c.maximizeInPlaceFromFloats(S.x, S.y, S.z), m += 3;
          }
          if (g._creationDataStorage && g._creationDataStorage.closePath) {
            const b = T[0];
            f[m] = b.x, f[m + 1] = b.y, f[m + 2] = b.z, m += 3;
          }
        }
    }, d = a.getVerticesData(v.PositionKind);
    if (u(d), a.hasBoundingInfo ? a.getBoundingInfo().reConstruct(l, c, a._worldMatrix) : a.buildBoundingInfo(l, c, a._worldMatrix), a.updateVerticesData(v.PositionKind, d, !1, !1), e.colors) {
      const f = a.getVerticesData(v.ColorKind);
      for (let _ = 0, g = 0; _ < e.colors.length; _++, g += 4) {
        const m = e.colors[_];
        f[g] = m.r, f[g + 1] = m.g, f[g + 2] = m.b, f[g + 3] = m.a;
      }
      a.updateVerticesData(v.ColorKind, f, !1, !1);
    }
    if (e.uvs) {
      const f = a.getVerticesData(v.UVKind);
      for (let _ = 0; _ < e.uvs.length; _++)
        f[_ * 2] = e.uvs[_].x, f[_ * 2 + 1] = ct.UseOpenGLOrientationForUV ? 1 - e.uvs[_].y : e.uvs[_].y;
      a.updateVerticesData(v.UVKind, f, !1, !1);
    }
    if (!a.areNormalsFrozen || a.isFacetDataEnabled) {
      const f = a.getIndices(), _ = a.getVerticesData(v.NormalKind), g = a.isFacetDataEnabled ? a.getFacetDataParameters() : null;
      if (q.ComputeNormals(d, f, _, g), a._creationDataStorage && a._creationDataStorage.closePath) {
        let m = 0, y = 0;
        for (let x = 0; x < i.length; x++)
          m = a._creationDataStorage.idx[x] * 3, x + 1 < i.length ? y = (a._creationDataStorage.idx[x + 1] - 1) * 3 : y = _.length - 3, _[m] = (_[m] + _[y]) * 0.5, _[m + 1] = (_[m + 1] + _[y + 1]) * 0.5, _[m + 2] = (_[m + 2] + _[y + 2]) * 0.5, _[y] = _[m], _[y + 1] = _[m + 1], _[y + 2] = _[m + 2];
      }
      a.areNormalsFrozen || a.updateVerticesData(v.NormalKind, _, !1, !1);
    }
    return a;
  } else {
    const l = new K(h, t);
    l._originalBuilderSideOrientation = n, l._creationDataStorage = new Ka();
    const c = so(e);
    return r && (l._creationDataStorage.idx = c._idx), l._creationDataStorage.closePath = r, l._creationDataStorage.closeArray = s, c.applyToMesh(l, o), l;
  }
}
q.CreateRibbon = so;
K.CreateRibbon = (h, e, t = !1, i, s, r, n = !1, a, o) => hn(h, {
  pathArray: e,
  closeArray: t,
  closePath: i,
  offset: s,
  updatable: n,
  sideOrientation: a,
  instance: o
}, r);
function ro(h, e, t = null) {
  const i = e.path, s = e.shape, r = e.scale || 1, n = e.rotation || 0, a = e.cap === 0 ? 0 : e.cap || K.NO_CAP, o = e.updatable, l = K._GetDefaultSideOrientation(e.sideOrientation), c = e.instance || null, u = e.invertUV || !1, d = e.closeShape || !1, f = e.closePath || !1;
  return no(h, s, i, r, n, null, null, f, d, a, !1, t, !!o, l, c, u, e.frontUVs || null, e.backUVs || null, e.firstNormal || null, !!e.adjustFrame);
}
function Ch(h, e, t = null) {
  const i = e.path, s = e.shape, r = e.scaleFunction || (() => 1), n = e.rotationFunction || (() => 0), a = e.closePath || e.ribbonCloseArray || !1, o = e.closeShape || e.ribbonClosePath || !1, l = e.cap === 0 ? 0 : e.cap || K.NO_CAP, c = e.updatable, u = e.firstNormal || null, d = e.adjustFrame || !1, f = K._GetDefaultSideOrientation(e.sideOrientation), _ = e.instance, g = e.invertUV || !1;
  return no(h, s, i, null, null, r, n, a, o, l, !0, t, !!c, f, _ || null, g, e.frontUVs || null, e.backUVs || null, u, d);
}
function no(h, e, t, i, s, r, n, a, o, l, c, u, d, f, _, g, m, y, x, A) {
  const T = (D, O, X, k, Y, se, Te, ve, Oe, Ne, ke) => {
    const Se = X.getTangents(), Be = X.getNormals(), Me = X.getBinormals(), je = X.getDistances();
    if (ke) {
      for (let ce = 0; ce < Se.length; ce++)
        if (Se[ce].x == 0 && Se[ce].y == 0 && Se[ce].z == 0 && Se[ce].copyFrom(Se[ce - 1]), Be[ce].x == 0 && Be[ce].y == 0 && Be[ce].z == 0 && Be[ce].copyFrom(Be[ce - 1]), Me[ce].x == 0 && Me[ce].y == 0 && Me[ce].z == 0 && Me[ce].copyFrom(Me[ce - 1]), ce > 0) {
          let tt = Se[ce - 1];
          p.Dot(tt, Se[ce]) < 0 && Se[ce].scaleInPlace(-1), tt = Be[ce - 1], p.Dot(tt, Be[ce]) < 0 && Be[ce].scaleInPlace(-1), tt = Me[ce - 1], p.Dot(tt, Me[ce]) < 0 && Me[ce].scaleInPlace(-1);
        }
    }
    let Rt = 0;
    const oi = () => Y !== null ? Y : 1, it = Ne && ve ? ve : () => se !== null ? se : 0, Xt = Ne && Te ? Te : oi;
    let xt = Oe === K.NO_CAP || Oe === K.CAP_END ? 0 : 2;
    const Ht = C.Matrix[0];
    for (let ce = 0; ce < O.length; ce++) {
      const tt = new Array(), Ot = it(ce, je[ce]), ft = Xt(ce, je[ce]);
      I.RotationAxisToRef(Se[ce], Rt, Ht);
      for (let It = 0; It < D.length; It++) {
        const kr = Se[ce].scale(D[It].z).add(Be[ce].scale(D[It].x)).add(Me[ce].scale(D[It].y)), bs = p.Zero();
        p.TransformCoordinatesToRef(kr, Ht, bs), bs.scaleInPlace(ft).addInPlace(O[ce]), tt[It] = bs;
      }
      k[xt] = tt, Rt += Ot, xt++;
    }
    const Fe = (ce) => {
      const tt = Array(), Ot = p.Zero();
      let ft;
      for (ft = 0; ft < ce.length; ft++)
        Ot.addInPlace(ce[ft]);
      for (Ot.scaleInPlace(1 / ce.length), ft = 0; ft < ce.length; ft++)
        tt.push(Ot);
      return tt;
    };
    switch (Oe) {
      case K.NO_CAP:
        break;
      case K.CAP_START:
        k[0] = Fe(k[2]), k[1] = k[2];
        break;
      case K.CAP_END:
        k[xt] = k[xt - 1], k[xt + 1] = Fe(k[xt - 1]);
        break;
      case K.CAP_ALL:
        k[0] = Fe(k[2]), k[1] = k[2], k[xt] = k[xt - 1], k[xt + 1] = Fe(k[xt - 1]);
        break;
    }
    return k;
  };
  let M, b;
  if (_) {
    const D = _._creationDataStorage;
    return M = x ? D.path3D.update(t, x) : D.path3D.update(t), b = T(e, t, D.path3D, D.pathArray, i, s, r, n, D.cap, c, A), _ = hn("", { pathArray: b, closeArray: !1, closePath: !1, offset: 0, updatable: !1, sideOrientation: 0, instance: _ }, u || void 0), _;
  }
  M = x ? new Us(t, x) : new Us(t);
  const S = new Array();
  l = l < 0 || l > 3 ? 0 : l, b = T(e, t, M, S, i, s, r, n, l, c, A);
  const P = hn(h, {
    pathArray: b,
    closeArray: a,
    closePath: o,
    updatable: d,
    sideOrientation: f,
    invertUV: g,
    frontUVs: m || void 0,
    backUVs: y || void 0
  }, u);
  return P._creationDataStorage.pathArray = b, P._creationDataStorage.path3D = M, P._creationDataStorage.cap = l, P;
}
K.ExtrudeShape = (h, e, t, i, s, r, n = null, a, o, l) => {
  const c = {
    shape: e,
    path: t,
    scale: i,
    rotation: s,
    cap: r === 0 ? 0 : r || K.NO_CAP,
    sideOrientation: o,
    instance: l,
    updatable: a
  };
  return ro(h, c, n);
};
K.ExtrudeShapeCustom = (h, e, t, i, s, r, n, a, o, l, c, u) => {
  const d = {
    shape: e,
    path: t,
    scaleFunction: i,
    rotationFunction: s,
    ribbonCloseArray: r,
    ribbonClosePath: n,
    cap: a === 0 ? 0 : a || K.NO_CAP,
    sideOrientation: c,
    instance: u,
    updatable: l
  };
  return Ch(h, d, o);
};
class ao {
  constructor() {
    this._defines = {}, this._currentRank = 32, this._maxRank = -1, this._mesh = null;
  }
  /**
   * Removes the fallback from the bound mesh.
   */
  unBindMesh() {
    this._mesh = null;
  }
  /**
   * Adds a fallback on the specified property.
   * @param rank The rank of the fallback (Lower ranks will be fallbacked to first)
   * @param define The name of the define in the shader
   */
  addFallback(e, t) {
    this._defines[e] || (e < this._currentRank && (this._currentRank = e), e > this._maxRank && (this._maxRank = e), this._defines[e] = new Array()), this._defines[e].push(t);
  }
  /**
   * Sets the mesh to use CPU skinning when needing to fallback.
   * @param rank The rank of the fallback (Lower ranks will be fallbacked to first)
   * @param mesh The mesh to use the fallbacks.
   */
  addCPUSkinningFallback(e, t) {
    this._mesh = t, e < this._currentRank && (this._currentRank = e), e > this._maxRank && (this._maxRank = e);
  }
  /**
   * Checks to see if more fallbacks are still available.
   */
  get hasMoreFallbacks() {
    return this._currentRank <= this._maxRank;
  }
  /**
   * Removes the defines that should be removed when falling back.
   * @param currentDefines defines the current define statements for the shader.
   * @param effect defines the current effect we try to compile
   * @returns The resulting defines with defines of the current rank removed.
   */
  reduce(e, t) {
    if (this._mesh && this._mesh.computeBonesUsingShaders && this._mesh.numBoneInfluencers > 0) {
      this._mesh.computeBonesUsingShaders = !1, e = e.replace("#define NUM_BONE_INFLUENCERS " + this._mesh.numBoneInfluencers, "#define NUM_BONE_INFLUENCERS 0"), t._bonesComputationForcedToCPU = !0;
      const i = this._mesh.getScene();
      for (let s = 0; s < i.meshes.length; s++) {
        const r = i.meshes[s];
        if (!r.material) {
          !this._mesh.material && r.computeBonesUsingShaders && r.numBoneInfluencers > 0 && (r.computeBonesUsingShaders = !1);
          continue;
        }
        if (!(!r.computeBonesUsingShaders || r.numBoneInfluencers === 0)) {
          if (r.material.getEffect() === t)
            r.computeBonesUsingShaders = !1;
          else if (r.subMeshes) {
            for (const n of r.subMeshes)
              if (n.effect === t) {
                r.computeBonesUsingShaders = !1;
                break;
              }
          }
        }
      }
    } else {
      const i = this._defines[this._currentRank];
      if (i)
        for (let s = 0; s < i.length; s++)
          e = e.replace("#define " + i[s], "");
      this._currentRank++;
    }
    return e;
  }
}
class oo extends F {
  constructor(e, t, i = !0) {
    super(e, t), this._normalMatrix = new I(), this._storeEffectOnSubMeshes = i;
  }
  getEffect() {
    return this._storeEffectOnSubMeshes ? this._activeEffect : super.getEffect();
  }
  isReady(e, t) {
    return e ? !this._storeEffectOnSubMeshes || !e.subMeshes || e.subMeshes.length === 0 ? !0 : this.isReadyForSubMesh(e, e.subMeshes[0], t) : !1;
  }
  _isReadyForSubMesh(e) {
    const t = e.materialDefines;
    return !!(!this.checkReadyOnEveryCall && e.effect && t && t._renderId === this.getScene().getRenderId());
  }
  /**
   * Binds the given world matrix to the active effect
   *
   * @param world the matrix to bind
   */
  bindOnlyWorldMatrix(e) {
    this._activeEffect.setMatrix("world", e);
  }
  /**
   * Binds the given normal matrix to the active effect
   *
   * @param normalMatrix the matrix to bind
   */
  bindOnlyNormalMatrix(e) {
    this._activeEffect.setMatrix("normalMatrix", e);
  }
  bind(e, t) {
    t && this.bindForSubMesh(e, t, t.subMeshes[0]);
  }
  _afterBind(e, t = null) {
    super._afterBind(e, t), this.getScene()._cachedEffect = t, t && (t._forceRebindOnNextCall = !1);
  }
  _mustRebind(e, t, i = 1) {
    return e.isCachedMaterialInvalid(this, t, i);
  }
  dispose(e, t, i) {
    this._activeEffect = void 0, super.dispose(e, t, i);
  }
}
const Yr = { effect: null, subMesh: null };
class Ri extends oo {
  /**
   * Instantiate a new shader material.
   * The ShaderMaterial object has the necessary methods to pass data from your scene to the Vertex and Fragment Shaders and returns a material that can be applied to any mesh.
   * This returned material effects how the mesh will look based on the code in the shaders.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/shaders/shaderMaterial
   * @param name Define the name of the material in the scene
   * @param scene Define the scene the material belongs to
   * @param shaderPath Defines  the route to the shader code in one of three ways:
   *  * object: \{ vertex: "custom", fragment: "custom" \}, used with Effect.ShadersStore["customVertexShader"] and Effect.ShadersStore["customFragmentShader"]
   *  * object: \{ vertexElement: "vertexShaderCode", fragmentElement: "fragmentShaderCode" \}, used with shader code in script tags
   *  * object: \{ vertexSource: "vertex shader code string", fragmentSource: "fragment shader code string" \} using with strings containing the shaders code
   *  * string: "./COMMON_NAME", used with external files COMMON_NAME.vertex.fx and COMMON_NAME.fragment.fx in index.html folder.
   * @param options Define the options used to create the shader
   * @param storeEffectOnSubMeshes true to store effect on submeshes, false to store the effect directly in the material class.
   */
  constructor(e, t, i, s = {}, r = !0) {
    super(e, t, r), this._textures = {}, this._textureArrays = {}, this._externalTextures = {}, this._floats = {}, this._ints = {}, this._uints = {}, this._floatsArrays = {}, this._colors3 = {}, this._colors3Arrays = {}, this._colors4 = {}, this._colors4Arrays = {}, this._vectors2 = {}, this._vectors3 = {}, this._vectors4 = {}, this._quaternions = {}, this._quaternionsArrays = {}, this._matrices = {}, this._matrixArrays = {}, this._matrices3x3 = {}, this._matrices2x2 = {}, this._vectors2Arrays = {}, this._vectors3Arrays = {}, this._vectors4Arrays = {}, this._uniformBuffers = {}, this._textureSamplers = {}, this._storageBuffers = {}, this._cachedWorldViewMatrix = new I(), this._cachedWorldViewProjectionMatrix = new I(), this._multiview = !1, this._materialHelperNeedsPreviousMatrices = !1, this._shaderPath = i, this._options = Object.assign({ needAlphaBlending: !1, needAlphaTesting: !1, attributes: ["position", "normal", "uv"], uniforms: ["worldViewProjection"], uniformBuffers: [], samplers: [], externalTextures: [], samplerObjects: [], storageBuffers: [], defines: [], useClipPlane: !1 }, s);
  }
  /**
   * Gets the shader path used to define the shader code
   * It can be modified to trigger a new compilation
   */
  get shaderPath() {
    return this._shaderPath;
  }
  /**
   * Sets the shader path used to define the shader code
   * It can be modified to trigger a new compilation
   */
  set shaderPath(e) {
    this._shaderPath = e;
  }
  /**
   * Gets the options used to compile the shader.
   * They can be modified to trigger a new compilation
   */
  get options() {
    return this._options;
  }
  /**
   * is multiview set to true?
   */
  get isMultiview() {
    return this._multiview;
  }
  /**
   * Gets the current class name of the material e.g. "ShaderMaterial"
   * Mainly use in serialization.
   * @returns the class name
   */
  getClassName() {
    return "ShaderMaterial";
  }
  /**
   * Specifies if the material will require alpha blending
   * @returns a boolean specifying if alpha blending is needed
   */
  needAlphaBlending() {
    return this.alpha < 1 || this._options.needAlphaBlending;
  }
  /**
   * Specifies if this material should be rendered in alpha test mode
   * @returns a boolean specifying if an alpha test is needed.
   */
  needAlphaTesting() {
    return this._options.needAlphaTesting;
  }
  _checkUniform(e) {
    this._options.uniforms.indexOf(e) === -1 && this._options.uniforms.push(e);
  }
  /**
   * Set a texture in the shader.
   * @param name Define the name of the uniform samplers as defined in the shader
   * @param texture Define the texture to bind to this sampler
   * @returns the material itself allowing "fluent" like uniform updates
   */
  setTexture(e, t) {
    return this._options.samplers.indexOf(e) === -1 && this._options.samplers.push(e), this._textures[e] = t, this;
  }
  /**
   * Set a texture array in the shader.
   * @param name Define the name of the uniform sampler array as defined in the shader
   * @param textures Define the list of textures to bind to this sampler
   * @returns the material itself allowing "fluent" like uniform updates
   */
  setTextureArray(e, t) {
    return this._options.samplers.indexOf(e) === -1 && this._options.samplers.push(e), this._checkUniform(e), this._textureArrays[e] = t, this;
  }
  /**
   * Set an internal texture in the shader.
   * @param name Define the name of the uniform samplers as defined in the shader
   * @param texture Define the texture to bind to this sampler
   * @returns the material itself allowing "fluent" like uniform updates
   */
  setExternalTexture(e, t) {
    return this._options.externalTextures.indexOf(e) === -1 && this._options.externalTextures.push(e), this._externalTextures[e] = t, this;
  }
  /**
   * Set a float in the shader.
   * @param name Define the name of the uniform as defined in the shader
   * @param value Define the value to give to the uniform
   * @returns the material itself allowing "fluent" like uniform updates
   */
  setFloat(e, t) {
    return this._checkUniform(e), this._floats[e] = t, this;
  }
  /**
   * Set a int in the shader.
   * @param name Define the name of the uniform as defined in the shader
   * @param value Define the value to give to the uniform
   * @returns the material itself allowing "fluent" like uniform updates
   */
  setInt(e, t) {
    return this._checkUniform(e), this._ints[e] = t, this;
  }
  /**
   * Set a unsigned int in the shader.
   * @param name Define the name of the uniform as defined in the shader
   * @param value Define the value to give to the uniform
   * @returns the material itself allowing "fluent" like uniform updates
   */
  setUInt(e, t) {
    return this._checkUniform(e), this._uints[e] = t, this;
  }
  /**
   * Set an array of floats in the shader.
   * @param name Define the name of the uniform as defined in the shader
   * @param value Define the value to give to the uniform
   * @returns the material itself allowing "fluent" like uniform updates
   */
  setFloats(e, t) {
    return this._checkUniform(e), this._floatsArrays[e] = t, this;
  }
  /**
   * Set a vec3 in the shader from a Color3.
   * @param name Define the name of the uniform as defined in the shader
   * @param value Define the value to give to the uniform
   * @returns the material itself allowing "fluent" like uniform updates
   */
  setColor3(e, t) {
    return this._checkUniform(e), this._colors3[e] = t, this;
  }
  /**
   * Set a vec3 array in the shader from a Color3 array.
   * @param name Define the name of the uniform as defined in the shader
   * @param value Define the value to give to the uniform
   * @returns the material itself allowing "fluent" like uniform updates
   */
  setColor3Array(e, t) {
    return this._checkUniform(e), this._colors3Arrays[e] = t.reduce((i, s) => (s.toArray(i, i.length), i), []), this;
  }
  /**
   * Set a vec4 in the shader from a Color4.
   * @param name Define the name of the uniform as defined in the shader
   * @param value Define the value to give to the uniform
   * @returns the material itself allowing "fluent" like uniform updates
   */
  setColor4(e, t) {
    return this._checkUniform(e), this._colors4[e] = t, this;
  }
  /**
   * Set a vec4 array in the shader from a Color4 array.
   * @param name Define the name of the uniform as defined in the shader
   * @param value Define the value to give to the uniform
   * @returns the material itself allowing "fluent" like uniform updates
   */
  setColor4Array(e, t) {
    return this._checkUniform(e), this._colors4Arrays[e] = t.reduce((i, s) => (s.toArray(i, i.length), i), []), this;
  }
  /**
   * Set a vec2 in the shader from a Vector2.
   * @param name Define the name of the uniform as defined in the shader
   * @param value Define the value to give to the uniform
   * @returns the material itself allowing "fluent" like uniform updates
   */
  setVector2(e, t) {
    return this._checkUniform(e), this._vectors2[e] = t, this;
  }
  /**
   * Set a vec3 in the shader from a Vector3.
   * @param name Define the name of the uniform as defined in the shader
   * @param value Define the value to give to the uniform
   * @returns the material itself allowing "fluent" like uniform updates
   */
  setVector3(e, t) {
    return this._checkUniform(e), this._vectors3[e] = t, this;
  }
  /**
   * Set a vec4 in the shader from a Vector4.
   * @param name Define the name of the uniform as defined in the shader
   * @param value Define the value to give to the uniform
   * @returns the material itself allowing "fluent" like uniform updates
   */
  setVector4(e, t) {
    return this._checkUniform(e), this._vectors4[e] = t, this;
  }
  /**
   * Set a vec4 in the shader from a Quaternion.
   * @param name Define the name of the uniform as defined in the shader
   * @param value Define the value to give to the uniform
   * @returns the material itself allowing "fluent" like uniform updates
   */
  setQuaternion(e, t) {
    return this._checkUniform(e), this._quaternions[e] = t, this;
  }
  /**
   * Set a vec4 array in the shader from a Quaternion array.
   * @param name Define the name of the uniform as defined in the shader
   * @param value Define the value to give to the uniform
   * @returns the material itself allowing "fluent" like uniform updates
   */
  setQuaternionArray(e, t) {
    return this._checkUniform(e), this._quaternionsArrays[e] = t.reduce((i, s) => (s.toArray(i, i.length), i), []), this;
  }
  /**
   * Set a mat4 in the shader from a Matrix.
   * @param name Define the name of the uniform as defined in the shader
   * @param value Define the value to give to the uniform
   * @returns the material itself allowing "fluent" like uniform updates
   */
  setMatrix(e, t) {
    return this._checkUniform(e), this._matrices[e] = t, this;
  }
  /**
   * Set a float32Array in the shader from a matrix array.
   * @param name Define the name of the uniform as defined in the shader
   * @param value Define the value to give to the uniform
   * @returns the material itself allowing "fluent" like uniform updates
   */
  setMatrices(e, t) {
    this._checkUniform(e);
    const i = new Float32Array(t.length * 16);
    for (let s = 0; s < t.length; s++)
      t[s].copyToArray(i, s * 16);
    return this._matrixArrays[e] = i, this;
  }
  /**
   * Set a mat3 in the shader from a Float32Array.
   * @param name Define the name of the uniform as defined in the shader
   * @param value Define the value to give to the uniform
   * @returns the material itself allowing "fluent" like uniform updates
   */
  setMatrix3x3(e, t) {
    return this._checkUniform(e), this._matrices3x3[e] = t, this;
  }
  /**
   * Set a mat2 in the shader from a Float32Array.
   * @param name Define the name of the uniform as defined in the shader
   * @param value Define the value to give to the uniform
   * @returns the material itself allowing "fluent" like uniform updates
   */
  setMatrix2x2(e, t) {
    return this._checkUniform(e), this._matrices2x2[e] = t, this;
  }
  /**
   * Set a vec2 array in the shader from a number array.
   * @param name Define the name of the uniform as defined in the shader
   * @param value Define the value to give to the uniform
   * @returns the material itself allowing "fluent" like uniform updates
   */
  setArray2(e, t) {
    return this._checkUniform(e), this._vectors2Arrays[e] = t, this;
  }
  /**
   * Set a vec3 array in the shader from a number array.
   * @param name Define the name of the uniform as defined in the shader
   * @param value Define the value to give to the uniform
   * @returns the material itself allowing "fluent" like uniform updates
   */
  setArray3(e, t) {
    return this._checkUniform(e), this._vectors3Arrays[e] = t, this;
  }
  /**
   * Set a vec4 array in the shader from a number array.
   * @param name Define the name of the uniform as defined in the shader
   * @param value Define the value to give to the uniform
   * @returns the material itself allowing "fluent" like uniform updates
   */
  setArray4(e, t) {
    return this._checkUniform(e), this._vectors4Arrays[e] = t, this;
  }
  /**
   * Set a uniform buffer in the shader
   * @param name Define the name of the uniform as defined in the shader
   * @param buffer Define the value to give to the uniform
   * @returns the material itself allowing "fluent" like uniform updates
   */
  setUniformBuffer(e, t) {
    return this._options.uniformBuffers.indexOf(e) === -1 && this._options.uniformBuffers.push(e), this._uniformBuffers[e] = t, this;
  }
  /**
   * Set a texture sampler in the shader
   * @param name Define the name of the uniform as defined in the shader
   * @param sampler Define the value to give to the uniform
   * @returns the material itself allowing "fluent" like uniform updates
   */
  setTextureSampler(e, t) {
    return this._options.samplerObjects.indexOf(e) === -1 && this._options.samplerObjects.push(e), this._textureSamplers[e] = t, this;
  }
  /**
   * Set a storage buffer in the shader
   * @param name Define the name of the storage buffer as defined in the shader
   * @param buffer Define the value to give to the uniform
   * @returns the material itself allowing "fluent" like uniform updates
   */
  setStorageBuffer(e, t) {
    return this._options.storageBuffers.indexOf(e) === -1 && this._options.storageBuffers.push(e), this._storageBuffers[e] = t, this;
  }
  /**
   * Adds, removes, or replaces the specified shader define and value.
   * * setDefine("MY_DEFINE", true); // enables a boolean define
   * * setDefine("MY_DEFINE", "0.5"); // adds "#define MY_DEFINE 0.5" to the shader (or sets and replaces the value of any existing define with that name)
   * * setDefine("MY_DEFINE", false); // disables and removes the define
   * Note if the active defines do change, the shader will be recompiled and this can be expensive.
   * @param define the define name e.g., "OUTPUT_TO_SRGB" or "#define OUTPUT_TO_SRGB". If the define was passed into the constructor already, the version used should match that, and in either case, it should not include any appended value.
   * @param value either the value of the define (e.g. a numerical value) or for booleans, true if the define should be enabled or false if it should be disabled
   * @returns the material itself allowing "fluent" like uniform updates
   */
  setDefine(e, t) {
    const i = e.trimEnd() + " ", s = this.options.defines.findIndex((r) => r === e || r.startsWith(i));
    return s >= 0 && this.options.defines.splice(s, 1), (typeof t != "boolean" || t) && this.options.defines.push(i + t), this;
  }
  /**
   * Specifies that the submesh is ready to be used
   * @param mesh defines the mesh to check
   * @param subMesh defines which submesh to check
   * @param useInstances specifies that instances should be used
   * @returns a boolean indicating that the submesh is ready or not
   */
  isReadyForSubMesh(e, t, i) {
    return this.isReady(e, i, t);
  }
  /**
   * Checks if the material is ready to render the requested mesh
   * @param mesh Define the mesh to render
   * @param useInstances Define whether or not the material is used with instances
   * @param subMesh defines which submesh to render
   * @returns true if ready, otherwise false
   */
  isReady(e, t, i) {
    var s, r, n, a;
    const o = i && this._storeEffectOnSubMeshes;
    if (this.isFrozen)
      if (o) {
        if (i.effect && i.effect._wasPreviouslyReady)
          return !0;
      } else {
        const D = this._drawWrapper.effect;
        if (D && D._wasPreviouslyReady && D._wasPreviouslyUsingInstances === t)
          return !0;
      }
    const l = this.getScene(), c = l.getEngine(), u = [], d = [], f = new ao();
    let _ = this._shaderPath, g = this._options.uniforms, m = this._options.uniformBuffers, y = this._options.samplers;
    c.getCaps().multiview && l.activeCamera && l.activeCamera.outputRenderTarget && l.activeCamera.outputRenderTarget.getViewCount() > 1 && (this._multiview = !0, u.push("#define MULTIVIEW"), this._options.uniforms.indexOf("viewProjection") !== -1 && this._options.uniforms.indexOf("viewProjectionR") === -1 && this._options.uniforms.push("viewProjectionR"));
    for (let D = 0; D < this._options.defines.length; D++) {
      const O = this._options.defines[D].indexOf("#define") === 0 ? this._options.defines[D] : `#define ${this._options.defines[D]}`;
      u.push(O);
    }
    for (let D = 0; D < this._options.attributes.length; D++)
      d.push(this._options.attributes[D]);
    if (e && e.isVerticesDataPresent(v.ColorKind) && (d.push(v.ColorKind), u.push("#define VERTEXCOLOR")), t && (u.push("#define INSTANCES"), Re.PushAttributesForInstances(d, this._materialHelperNeedsPreviousMatrices), e != null && e.hasThinInstances && (u.push("#define THIN_INSTANCES"), e && e.isVerticesDataPresent(v.ColorInstanceKind) && (d.push(v.ColorInstanceKind), u.push("#define INSTANCESCOLOR")))), e && e.useBones && e.computeBonesUsingShaders && e.skeleton) {
      d.push(v.MatricesIndicesKind), d.push(v.MatricesWeightsKind), e.numBoneInfluencers > 4 && (d.push(v.MatricesIndicesExtraKind), d.push(v.MatricesWeightsExtraKind));
      const D = e.skeleton;
      u.push("#define NUM_BONE_INFLUENCERS " + e.numBoneInfluencers), f.addCPUSkinningFallback(0, e), D.isUsingTextureForMatrices ? (u.push("#define BONETEXTURE"), this._options.uniforms.indexOf("boneTextureWidth") === -1 && this._options.uniforms.push("boneTextureWidth"), this._options.samplers.indexOf("boneSampler") === -1 && this._options.samplers.push("boneSampler")) : (u.push("#define BonesPerMesh " + (D.bones.length + 1)), this._options.uniforms.indexOf("mBones") === -1 && this._options.uniforms.push("mBones"));
    } else
      u.push("#define NUM_BONE_INFLUENCERS 0");
    let x = 0;
    const A = e ? e.morphTargetManager : null;
    if (A) {
      const D = A.supportsUVs && u.indexOf("#define UV1") !== -1, O = A.supportsTangents && u.indexOf("#define TANGENT") !== -1, X = A.supportsNormals && u.indexOf("#define NORMAL") !== -1;
      x = A.numInfluencers, D && u.push("#define MORPHTARGETS_UV"), O && u.push("#define MORPHTARGETS_TANGENT"), X && u.push("#define MORPHTARGETS_NORMAL"), x > 0 && u.push("#define MORPHTARGETS"), A.isUsingTextureForTargets && (u.push("#define MORPHTARGETS_TEXTURE"), this._options.uniforms.indexOf("morphTargetTextureIndices") === -1 && this._options.uniforms.push("morphTargetTextureIndices"), this._options.samplers.indexOf("morphTargets") === -1 && this._options.samplers.push("morphTargets")), u.push("#define NUM_MORPH_INFLUENCERS " + x);
      for (let k = 0; k < x; k++)
        d.push(v.PositionKind + k), X && d.push(v.NormalKind + k), O && d.push(v.TangentKind + k), D && d.push(v.UVKind + "_" + k);
      x > 0 && (g = g.slice(), g.push("morphTargetInfluences"), g.push("morphTargetTextureInfo"), g.push("morphTargetTextureIndices"));
    } else
      u.push("#define NUM_MORPH_INFLUENCERS 0");
    if (e) {
      const D = e.bakedVertexAnimationManager;
      D && D.isEnabled && (u.push("#define BAKED_VERTEX_ANIMATION_TEXTURE"), this._options.uniforms.indexOf("bakedVertexAnimationSettings") === -1 && this._options.uniforms.push("bakedVertexAnimationSettings"), this._options.uniforms.indexOf("bakedVertexAnimationTextureSizeInverted") === -1 && this._options.uniforms.push("bakedVertexAnimationTextureSizeInverted"), this._options.uniforms.indexOf("bakedVertexAnimationTime") === -1 && this._options.uniforms.push("bakedVertexAnimationTime"), this._options.samplers.indexOf("bakedVertexAnimationTexture") === -1 && this._options.samplers.push("bakedVertexAnimationTexture")), Re.PrepareAttributesForBakedVertexAnimation(d, e, u);
    }
    for (const D in this._textures)
      if (!this._textures[D].isReady())
        return !1;
    e && this._shouldTurnAlphaTestOn(e) && u.push("#define ALPHATEST"), this._options.useClipPlane !== !1 && (Xa(g), kl(this, l, u)), this.customShaderNameResolve && (g = g.slice(), m = m.slice(), y = y.slice(), _ = this.customShaderNameResolve(_, g, m, y, u, d));
    const T = o ? i._getDrawWrapper() : this._drawWrapper, M = (s = T == null ? void 0 : T.effect) !== null && s !== void 0 ? s : null, b = (r = T == null ? void 0 : T.defines) !== null && r !== void 0 ? r : null, S = u.join(`
`);
    let P = M;
    return b !== S && (P = c.createEffect(_, {
      attributes: d,
      uniformsNames: g,
      uniformBuffersNames: m,
      samplers: y,
      defines: S,
      fallbacks: f,
      onCompiled: this.onCompiled,
      onError: this.onError,
      indexParameters: { maxSimultaneousMorphTargets: x },
      shaderLanguage: this._options.shaderLanguage
    }, c), o ? i.setEffect(P, S, this._materialContext) : T && T.setEffect(P, S), this._onEffectCreatedObservable && (Yr.effect = P, Yr.subMesh = (n = i ?? (e == null ? void 0 : e.subMeshes[0])) !== null && n !== void 0 ? n : null, this._onEffectCreatedObservable.notifyObservers(Yr))), P._wasPreviouslyUsingInstances = !!t, !((a = !(P != null && P.isReady())) !== null && a !== void 0) || a ? !1 : (M !== P && l.resetCachedMaterial(), P._wasPreviouslyReady = !0, !0);
  }
  /**
   * Binds the world matrix to the material
   * @param world defines the world transformation matrix
   * @param effectOverride - If provided, use this effect instead of internal effect
   */
  bindOnlyWorldMatrix(e, t) {
    const i = this.getScene(), s = t ?? this.getEffect();
    s && (this._options.uniforms.indexOf("world") !== -1 && s.setMatrix("world", e), this._options.uniforms.indexOf("worldView") !== -1 && (e.multiplyToRef(i.getViewMatrix(), this._cachedWorldViewMatrix), s.setMatrix("worldView", this._cachedWorldViewMatrix)), this._options.uniforms.indexOf("worldViewProjection") !== -1 && (e.multiplyToRef(i.getTransformMatrix(), this._cachedWorldViewProjectionMatrix), s.setMatrix("worldViewProjection", this._cachedWorldViewProjectionMatrix)));
  }
  /**
   * Binds the submesh to this material by preparing the effect and shader to draw
   * @param world defines the world transformation matrix
   * @param mesh defines the mesh containing the submesh
   * @param subMesh defines the submesh to bind the material to
   */
  bindForSubMesh(e, t, i) {
    var s;
    this.bind(e, t, (s = i._drawWrapperOverride) === null || s === void 0 ? void 0 : s.effect, i);
  }
  /**
   * Binds the material to the mesh
   * @param world defines the world transformation matrix
   * @param mesh defines the mesh to bind the material to
   * @param effectOverride - If provided, use this effect instead of internal effect
   * @param subMesh defines the submesh to bind the material to
   */
  bind(e, t, i, s) {
    var r;
    const n = s && this._storeEffectOnSubMeshes, a = i ?? (n ? s.effect : this.getEffect());
    if (!a)
      return;
    this._activeEffect = a, this.bindOnlyWorldMatrix(e, i);
    const o = this._options.uniformBuffers;
    let l = !1;
    if (a && o && o.length > 0 && this.getScene().getEngine().supportsUniformBuffers)
      for (let u = 0; u < o.length; ++u)
        switch (o[u]) {
          case "Mesh":
            t && (t.getMeshUniformBuffer().bindToEffect(a, "Mesh"), t.transferToEffect(e));
            break;
          case "Scene":
            Re.BindSceneUniformBuffer(a, this.getScene().getSceneUniformBuffer()), this.getScene().finalizeSceneUbo(), l = !0;
            break;
        }
    const c = t && n ? this._mustRebind(this.getScene(), a, t.visibility) : this.getScene().getCachedMaterial() !== this;
    if (a && c) {
      !l && this._options.uniforms.indexOf("view") !== -1 && a.setMatrix("view", this.getScene().getViewMatrix()), !l && this._options.uniforms.indexOf("projection") !== -1 && a.setMatrix("projection", this.getScene().getProjectionMatrix()), !l && this._options.uniforms.indexOf("viewProjection") !== -1 && (a.setMatrix("viewProjection", this.getScene().getTransformMatrix()), this._multiview && a.setMatrix("viewProjectionR", this.getScene()._transformMatrixR)), this.getScene().activeCamera && this._options.uniforms.indexOf("cameraPosition") !== -1 && a.setVector3("cameraPosition", this.getScene().activeCamera.globalPosition), Re.BindBonesParameters(t, a), Ha(a, this, this.getScene());
      let u;
      for (u in this._textures)
        a.setTexture(u, this._textures[u]);
      for (u in this._textureArrays)
        a.setTextureArray(u, this._textureArrays[u]);
      for (u in this._externalTextures)
        a.setExternalTexture(u, this._externalTextures[u]);
      for (u in this._ints)
        a.setInt(u, this._ints[u]);
      for (u in this._uints)
        a.setUInt(u, this._uints[u]);
      for (u in this._floats)
        a.setFloat(u, this._floats[u]);
      for (u in this._floatsArrays)
        a.setArray(u, this._floatsArrays[u]);
      for (u in this._colors3)
        a.setColor3(u, this._colors3[u]);
      for (u in this._colors3Arrays)
        a.setArray3(u, this._colors3Arrays[u]);
      for (u in this._colors4) {
        const d = this._colors4[u];
        a.setFloat4(u, d.r, d.g, d.b, d.a);
      }
      for (u in this._colors4Arrays)
        a.setArray4(u, this._colors4Arrays[u]);
      for (u in this._vectors2)
        a.setVector2(u, this._vectors2[u]);
      for (u in this._vectors3)
        a.setVector3(u, this._vectors3[u]);
      for (u in this._vectors4)
        a.setVector4(u, this._vectors4[u]);
      for (u in this._quaternions)
        a.setQuaternion(u, this._quaternions[u]);
      for (u in this._matrices)
        a.setMatrix(u, this._matrices[u]);
      for (u in this._matrixArrays)
        a.setMatrices(u, this._matrixArrays[u]);
      for (u in this._matrices3x3)
        a.setMatrix3x3(u, this._matrices3x3[u]);
      for (u in this._matrices2x2)
        a.setMatrix2x2(u, this._matrices2x2[u]);
      for (u in this._vectors2Arrays)
        a.setArray2(u, this._vectors2Arrays[u]);
      for (u in this._vectors3Arrays)
        a.setArray3(u, this._vectors3Arrays[u]);
      for (u in this._vectors4Arrays)
        a.setArray4(u, this._vectors4Arrays[u]);
      for (u in this._quaternionsArrays)
        a.setArray4(u, this._quaternionsArrays[u]);
      for (u in this._uniformBuffers) {
        const d = this._uniformBuffers[u].getBuffer();
        d && a.bindUniformBuffer(d, u);
      }
      for (u in this._textureSamplers)
        a.setTextureSampler(u, this._textureSamplers[u]);
      for (u in this._storageBuffers)
        a.setStorageBuffer(u, this._storageBuffers[u]);
    }
    if (a && t && (c || !this.isFrozen)) {
      const u = t.morphTargetManager;
      u && u.numInfluencers > 0 && Re.BindMorphTargetParameters(t, a);
      const d = t.bakedVertexAnimationManager;
      d && d.isEnabled && ((r = t.bakedVertexAnimationManager) === null || r === void 0 || r.bind(a, !!a._wasPreviouslyUsingInstances));
    }
    this._afterBind(t, a);
  }
  /**
   * Gets the active textures from the material
   * @returns an array of textures
   */
  getActiveTextures() {
    const e = super.getActiveTextures();
    for (const t in this._textures)
      e.push(this._textures[t]);
    for (const t in this._textureArrays) {
      const i = this._textureArrays[t];
      for (let s = 0; s < i.length; s++)
        e.push(i[s]);
    }
    return e;
  }
  /**
   * Specifies if the material uses a texture
   * @param texture defines the texture to check against the material
   * @returns a boolean specifying if the material uses the texture
   */
  hasTexture(e) {
    if (super.hasTexture(e))
      return !0;
    for (const t in this._textures)
      if (this._textures[t] === e)
        return !0;
    for (const t in this._textureArrays) {
      const i = this._textureArrays[t];
      for (let s = 0; s < i.length; s++)
        if (i[s] === e)
          return !0;
    }
    return !1;
  }
  /**
   * Makes a duplicate of the material, and gives it a new name
   * @param name defines the new name for the duplicated material
   * @returns the cloned material
   */
  clone(e) {
    const t = le.Clone(() => new Ri(e, this.getScene(), this._shaderPath, this._options, this._storeEffectOnSubMeshes), this);
    t.name = e, t.id = e, typeof t._shaderPath == "object" && (t._shaderPath = Object.assign({}, t._shaderPath)), this._options = Object.assign({}, this._options), Object.keys(this._options).forEach((i) => {
      const s = this._options[i];
      Array.isArray(s) && (this._options[i] = s.slice(0));
    }), this.stencil.copyTo(t.stencil);
    for (const i in this._textures)
      t.setTexture(i, this._textures[i]);
    for (const i in this._textureArrays)
      t.setTextureArray(i, this._textureArrays[i]);
    for (const i in this._externalTextures)
      t.setExternalTexture(i, this._externalTextures[i]);
    for (const i in this._ints)
      t.setInt(i, this._ints[i]);
    for (const i in this._uints)
      t.setUInt(i, this._uints[i]);
    for (const i in this._floats)
      t.setFloat(i, this._floats[i]);
    for (const i in this._floatsArrays)
      t.setFloats(i, this._floatsArrays[i]);
    for (const i in this._colors3)
      t.setColor3(i, this._colors3[i]);
    for (const i in this._colors3Arrays)
      t._colors3Arrays[i] = this._colors3Arrays[i];
    for (const i in this._colors4)
      t.setColor4(i, this._colors4[i]);
    for (const i in this._colors4Arrays)
      t._colors4Arrays[i] = this._colors4Arrays[i];
    for (const i in this._vectors2)
      t.setVector2(i, this._vectors2[i]);
    for (const i in this._vectors3)
      t.setVector3(i, this._vectors3[i]);
    for (const i in this._vectors4)
      t.setVector4(i, this._vectors4[i]);
    for (const i in this._quaternions)
      t.setQuaternion(i, this._quaternions[i]);
    for (const i in this._quaternionsArrays)
      t._quaternionsArrays[i] = this._quaternionsArrays[i];
    for (const i in this._matrices)
      t.setMatrix(i, this._matrices[i]);
    for (const i in this._matrixArrays)
      t._matrixArrays[i] = this._matrixArrays[i].slice();
    for (const i in this._matrices3x3)
      t.setMatrix3x3(i, this._matrices3x3[i]);
    for (const i in this._matrices2x2)
      t.setMatrix2x2(i, this._matrices2x2[i]);
    for (const i in this._vectors2Arrays)
      t.setArray2(i, this._vectors2Arrays[i]);
    for (const i in this._vectors3Arrays)
      t.setArray3(i, this._vectors3Arrays[i]);
    for (const i in this._vectors4Arrays)
      t.setArray4(i, this._vectors4Arrays[i]);
    for (const i in this._uniformBuffers)
      t.setUniformBuffer(i, this._uniformBuffers[i]);
    for (const i in this._textureSamplers)
      t.setTextureSampler(i, this._textureSamplers[i]);
    for (const i in this._storageBuffers)
      t.setStorageBuffer(i, this._storageBuffers[i]);
    return t;
  }
  /**
   * Disposes the material
   * @param forceDisposeEffect specifies if effects should be forcefully disposed
   * @param forceDisposeTextures specifies if textures should be forcefully disposed
   * @param notBoundToMesh specifies if the material that is being disposed is known to be not bound to any mesh
   */
  dispose(e, t, i) {
    if (t) {
      let s;
      for (s in this._textures)
        this._textures[s].dispose();
      for (s in this._textureArrays) {
        const r = this._textureArrays[s];
        for (let n = 0; n < r.length; n++)
          r[n].dispose();
      }
    }
    this._textures = {}, super.dispose(e, t, i);
  }
  /**
   * Serializes this material in a JSON representation
   * @returns the serialized material object
   */
  serialize() {
    const e = le.Serialize(this);
    e.customType = "BABYLON.ShaderMaterial", e.uniqueId = this.uniqueId, e.options = this._options, e.shaderPath = this._shaderPath, e.storeEffectOnSubMeshes = this._storeEffectOnSubMeshes;
    let t;
    e.stencil = this.stencil.serialize(), e.textures = {};
    for (t in this._textures)
      e.textures[t] = this._textures[t].serialize();
    e.textureArrays = {};
    for (t in this._textureArrays) {
      e.textureArrays[t] = [];
      const i = this._textureArrays[t];
      for (let s = 0; s < i.length; s++)
        e.textureArrays[t].push(i[s].serialize());
    }
    e.ints = {};
    for (t in this._ints)
      e.ints[t] = this._ints[t];
    e.uints = {};
    for (t in this._uints)
      e.uints[t] = this._uints[t];
    e.floats = {};
    for (t in this._floats)
      e.floats[t] = this._floats[t];
    e.FloatArrays = {};
    for (t in this._floatsArrays)
      e.FloatArrays[t] = this._floatsArrays[t];
    e.colors3 = {};
    for (t in this._colors3)
      e.colors3[t] = this._colors3[t].asArray();
    e.colors3Arrays = {};
    for (t in this._colors3Arrays)
      e.colors3Arrays[t] = this._colors3Arrays[t];
    e.colors4 = {};
    for (t in this._colors4)
      e.colors4[t] = this._colors4[t].asArray();
    e.colors4Arrays = {};
    for (t in this._colors4Arrays)
      e.colors4Arrays[t] = this._colors4Arrays[t];
    e.vectors2 = {};
    for (t in this._vectors2)
      e.vectors2[t] = this._vectors2[t].asArray();
    e.vectors3 = {};
    for (t in this._vectors3)
      e.vectors3[t] = this._vectors3[t].asArray();
    e.vectors4 = {};
    for (t in this._vectors4)
      e.vectors4[t] = this._vectors4[t].asArray();
    e.quaternions = {};
    for (t in this._quaternions)
      e.quaternions[t] = this._quaternions[t].asArray();
    e.matrices = {};
    for (t in this._matrices)
      e.matrices[t] = this._matrices[t].asArray();
    e.matrixArray = {};
    for (t in this._matrixArrays)
      e.matrixArray[t] = this._matrixArrays[t];
    e.matrices3x3 = {};
    for (t in this._matrices3x3)
      e.matrices3x3[t] = this._matrices3x3[t];
    e.matrices2x2 = {};
    for (t in this._matrices2x2)
      e.matrices2x2[t] = this._matrices2x2[t];
    e.vectors2Arrays = {};
    for (t in this._vectors2Arrays)
      e.vectors2Arrays[t] = this._vectors2Arrays[t];
    e.vectors3Arrays = {};
    for (t in this._vectors3Arrays)
      e.vectors3Arrays[t] = this._vectors3Arrays[t];
    e.vectors4Arrays = {};
    for (t in this._vectors4Arrays)
      e.vectors4Arrays[t] = this._vectors4Arrays[t];
    e.quaternionsArrays = {};
    for (t in this._quaternionsArrays)
      e.quaternionsArrays[t] = this._quaternionsArrays[t];
    return e;
  }
  /**
   * Creates a shader material from parsed shader material data
   * @param source defines the JSON representation of the material
   * @param scene defines the hosting scene
   * @param rootUrl defines the root URL to use to load textures and relative dependencies
   * @returns a new material
   */
  static Parse(e, t, i) {
    const s = le.Parse(() => new Ri(e.name, t, e.shaderPath, e.options, e.storeEffectOnSubMeshes), e, t, i);
    let r;
    e.stencil && s.stencil.parse(e.stencil, t, i);
    for (r in e.textures)
      s.setTexture(r, W.Parse(e.textures[r], t, i));
    for (r in e.textureArrays) {
      const n = e.textureArrays[r], a = new Array();
      for (let o = 0; o < n.length; o++)
        a.push(W.Parse(n[o], t, i));
      s.setTextureArray(r, a);
    }
    for (r in e.ints)
      s.setInt(r, e.ints[r]);
    for (r in e.uints)
      s.setUInt(r, e.uints[r]);
    for (r in e.floats)
      s.setFloat(r, e.floats[r]);
    for (r in e.floatsArrays)
      s.setFloats(r, e.floatsArrays[r]);
    for (r in e.colors3)
      s.setColor3(r, ie.FromArray(e.colors3[r]));
    for (r in e.colors3Arrays) {
      const n = e.colors3Arrays[r].reduce((a, o, l) => (l % 3 === 0 ? a.push([o]) : a[a.length - 1].push(o), a), []).map((a) => ie.FromArray(a));
      s.setColor3Array(r, n);
    }
    for (r in e.colors4)
      s.setColor4(r, ye.FromArray(e.colors4[r]));
    for (r in e.colors4Arrays) {
      const n = e.colors4Arrays[r].reduce((a, o, l) => (l % 4 === 0 ? a.push([o]) : a[a.length - 1].push(o), a), []).map((a) => ye.FromArray(a));
      s.setColor4Array(r, n);
    }
    for (r in e.vectors2)
      s.setVector2(r, ue.FromArray(e.vectors2[r]));
    for (r in e.vectors3)
      s.setVector3(r, p.FromArray(e.vectors3[r]));
    for (r in e.vectors4)
      s.setVector4(r, ze.FromArray(e.vectors4[r]));
    for (r in e.quaternions)
      s.setQuaternion(r, U.FromArray(e.quaternions[r]));
    for (r in e.matrices)
      s.setMatrix(r, I.FromArray(e.matrices[r]));
    for (r in e.matrixArray)
      s._matrixArrays[r] = new Float32Array(e.matrixArray[r]);
    for (r in e.matrices3x3)
      s.setMatrix3x3(r, e.matrices3x3[r]);
    for (r in e.matrices2x2)
      s.setMatrix2x2(r, e.matrices2x2[r]);
    for (r in e.vectors2Arrays)
      s.setArray2(r, e.vectors2Arrays[r]);
    for (r in e.vectors3Arrays)
      s.setArray3(r, e.vectors3Arrays[r]);
    for (r in e.vectors4Arrays)
      s.setArray4(r, e.vectors4Arrays[r]);
    for (r in e.quaternionsArrays)
      s.setArray4(r, e.quaternionsArrays[r]);
    return s;
  }
  /**
   * Creates a new ShaderMaterial from a snippet saved in a remote file
   * @param name defines the name of the ShaderMaterial to create (can be null or empty to use the one from the json data)
   * @param url defines the url to load from
   * @param scene defines the hosting scene
   * @param rootUrl defines the root URL to use to load textures and relative dependencies
   * @returns a promise that will resolve to the new ShaderMaterial
   */
  static ParseFromFileAsync(e, t, i, s = "") {
    return new Promise((r, n) => {
      const a = new mt();
      a.addEventListener("readystatechange", () => {
        if (a.readyState == 4)
          if (a.status == 200) {
            const o = JSON.parse(a.responseText), l = this.Parse(o, i || de.LastCreatedScene, s);
            e && (l.name = e), r(l);
          } else
            n("Unable to load the ShaderMaterial");
      }), a.open("GET", t), a.send();
    });
  }
  /**
   * Creates a ShaderMaterial from a snippet saved by the Inspector
   * @param snippetId defines the snippet to load
   * @param scene defines the hosting scene
   * @param rootUrl defines the root URL to use to load textures and relative dependencies
   * @returns a promise that will resolve to the new ShaderMaterial
   */
  static ParseFromSnippetAsync(e, t, i = "") {
    return new Promise((s, r) => {
      const n = new mt();
      n.addEventListener("readystatechange", () => {
        if (n.readyState == 4)
          if (n.status == 200) {
            const a = JSON.parse(JSON.parse(n.responseText).jsonPayload), o = JSON.parse(a.shaderMaterial), l = this.Parse(o, t || de.LastCreatedScene, i);
            l.snippetId = e, s(l);
          } else
            r("Unable to load the snippet " + e);
      }), n.open("GET", this.SnippetUrl + "/" + e.replace(/#/g, "/")), n.send();
    });
  }
}
Ri.SnippetUrl = "https://snippet.babylonjs.com";
Ri.CreateFromSnippetAsync = Ri.ParseFromSnippetAsync;
Xe("BABYLON.ShaderMaterial", Ri);
const Dh = "clipPlaneFragmentDeclaration", wh = `#ifdef CLIPPLANE
varying float fClipDistance;
#endif
#ifdef CLIPPLANE2
varying float fClipDistance2;
#endif
#ifdef CLIPPLANE3
varying float fClipDistance3;
#endif
#ifdef CLIPPLANE4
varying float fClipDistance4;
#endif
#ifdef CLIPPLANE5
varying float fClipDistance5;
#endif
#ifdef CLIPPLANE6
varying float fClipDistance6;
#endif
`;
G.IncludesShadersStore[Dh] = wh;
const Oh = "clipPlaneFragment", Fh = `#if defined(CLIPPLANE) || defined(CLIPPLANE2) || defined(CLIPPLANE3) || defined(CLIPPLANE4) || defined(CLIPPLANE5) || defined(CLIPPLANE6)
if (false) {}
#endif
#ifdef CLIPPLANE
else if (fClipDistance>0.0)
{discard;}
#endif
#ifdef CLIPPLANE2
else if (fClipDistance2>0.0)
{discard;}
#endif
#ifdef CLIPPLANE3
else if (fClipDistance3>0.0)
{discard;}
#endif
#ifdef CLIPPLANE4
else if (fClipDistance4>0.0)
{discard;}
#endif
#ifdef CLIPPLANE5
else if (fClipDistance5>0.0)
{discard;}
#endif
#ifdef CLIPPLANE6
else if (fClipDistance6>0.0)
{discard;}
#endif
`;
G.IncludesShadersStore[Oh] = Fh;
const Lh = "colorPixelShader", Nh = `#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
#define VERTEXCOLOR
varying vec4 vColor;
#else
uniform vec4 color;
#endif
#include<clipPlaneFragmentDeclaration>
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
#include<clipPlaneFragment>
#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
gl_FragColor=vColor;
#else
gl_FragColor=color;
#endif
#define CUSTOM_FRAGMENT_MAIN_END
}`;
G.ShadersStore[Lh] = Nh;
const Bh = "bonesDeclaration", Uh = `#if NUM_BONE_INFLUENCERS>0
attribute vec4 matricesIndices;attribute vec4 matricesWeights;
#if NUM_BONE_INFLUENCERS>4
attribute vec4 matricesIndicesExtra;attribute vec4 matricesWeightsExtra;
#endif
#ifndef BAKED_VERTEX_ANIMATION_TEXTURE
#ifdef BONETEXTURE
uniform sampler2D boneSampler;uniform float boneTextureWidth;
#else
uniform mat4 mBones[BonesPerMesh];
#ifdef BONES_VELOCITY_ENABLED
uniform mat4 mPreviousBones[BonesPerMesh];
#endif
#endif
#ifdef BONETEXTURE
#define inline
mat4 readMatrixFromRawSampler(sampler2D smp,float index)
{float offset=index *4.0;float dx=1.0/boneTextureWidth;vec4 m0=texture2D(smp,vec2(dx*(offset+0.5),0.));vec4 m1=texture2D(smp,vec2(dx*(offset+1.5),0.));vec4 m2=texture2D(smp,vec2(dx*(offset+2.5),0.));vec4 m3=texture2D(smp,vec2(dx*(offset+3.5),0.));return mat4(m0,m1,m2,m3);}
#endif
#endif
#endif
`;
G.IncludesShadersStore[Bh] = Uh;
const kh = "bakedVertexAnimationDeclaration", Vh = `#ifdef BAKED_VERTEX_ANIMATION_TEXTURE
uniform float bakedVertexAnimationTime;uniform vec2 bakedVertexAnimationTextureSizeInverted;uniform vec4 bakedVertexAnimationSettings;uniform sampler2D bakedVertexAnimationTexture;
#ifdef INSTANCES
attribute vec4 bakedVertexAnimationSettingsInstanced;
#endif
#define inline
mat4 readMatrixFromRawSamplerVAT(sampler2D smp,float index,float frame)
{float offset=index*4.0;float frameUV=(frame+0.5)*bakedVertexAnimationTextureSizeInverted.y;float dx=bakedVertexAnimationTextureSizeInverted.x;vec4 m0=texture2D(smp,vec2(dx*(offset+0.5),frameUV));vec4 m1=texture2D(smp,vec2(dx*(offset+1.5),frameUV));vec4 m2=texture2D(smp,vec2(dx*(offset+2.5),frameUV));vec4 m3=texture2D(smp,vec2(dx*(offset+3.5),frameUV));return mat4(m0,m1,m2,m3);}
#endif
`;
G.IncludesShadersStore[kh] = Vh;
const Wh = "clipPlaneVertexDeclaration", zh = `#ifdef CLIPPLANE
uniform vec4 vClipPlane;varying float fClipDistance;
#endif
#ifdef CLIPPLANE2
uniform vec4 vClipPlane2;varying float fClipDistance2;
#endif
#ifdef CLIPPLANE3
uniform vec4 vClipPlane3;varying float fClipDistance3;
#endif
#ifdef CLIPPLANE4
uniform vec4 vClipPlane4;varying float fClipDistance4;
#endif
#ifdef CLIPPLANE5
uniform vec4 vClipPlane5;varying float fClipDistance5;
#endif
#ifdef CLIPPLANE6
uniform vec4 vClipPlane6;varying float fClipDistance6;
#endif
`;
G.IncludesShadersStore[Wh] = zh;
const Gh = "instancesDeclaration", Xh = `#ifdef INSTANCES
attribute vec4 world0;attribute vec4 world1;attribute vec4 world2;attribute vec4 world3;
#ifdef INSTANCESCOLOR
attribute vec4 instanceColor;
#endif
#if defined(THIN_INSTANCES) && !defined(WORLD_UBO)
uniform mat4 world;
#endif
#if defined(VELOCITY) || defined(PREPASS_VELOCITY)
attribute vec4 previousWorld0;attribute vec4 previousWorld1;attribute vec4 previousWorld2;attribute vec4 previousWorld3;
#ifdef THIN_INSTANCES
uniform mat4 previousWorld;
#endif
#endif
#else
#if !defined(WORLD_UBO)
uniform mat4 world;
#endif
#if defined(VELOCITY) || defined(PREPASS_VELOCITY)
uniform mat4 previousWorld;
#endif
#endif
`;
G.IncludesShadersStore[Gh] = Xh;
const Hh = "instancesVertex", Kh = `#ifdef INSTANCES
mat4 finalWorld=mat4(world0,world1,world2,world3);
#if defined(PREPASS_VELOCITY) || defined(VELOCITY)
mat4 finalPreviousWorld=mat4(previousWorld0,previousWorld1,previousWorld2,previousWorld3);
#endif
#ifdef THIN_INSTANCES
finalWorld=world*finalWorld;
#if defined(PREPASS_VELOCITY) || defined(VELOCITY)
finalPreviousWorld=previousWorld*finalPreviousWorld;
#endif
#endif
#else
mat4 finalWorld=world;
#if defined(PREPASS_VELOCITY) || defined(VELOCITY)
mat4 finalPreviousWorld=previousWorld;
#endif
#endif
`;
G.IncludesShadersStore[Hh] = Kh;
const Yh = "bonesVertex", qh = `#ifndef BAKED_VERTEX_ANIMATION_TEXTURE
#if NUM_BONE_INFLUENCERS>0
mat4 influence;
#ifdef BONETEXTURE
influence=readMatrixFromRawSampler(boneSampler,matricesIndices[0])*matricesWeights[0];
#if NUM_BONE_INFLUENCERS>1
influence+=readMatrixFromRawSampler(boneSampler,matricesIndices[1])*matricesWeights[1];
#endif
#if NUM_BONE_INFLUENCERS>2
influence+=readMatrixFromRawSampler(boneSampler,matricesIndices[2])*matricesWeights[2];
#endif
#if NUM_BONE_INFLUENCERS>3
influence+=readMatrixFromRawSampler(boneSampler,matricesIndices[3])*matricesWeights[3];
#endif
#if NUM_BONE_INFLUENCERS>4
influence+=readMatrixFromRawSampler(boneSampler,matricesIndicesExtra[0])*matricesWeightsExtra[0];
#endif
#if NUM_BONE_INFLUENCERS>5
influence+=readMatrixFromRawSampler(boneSampler,matricesIndicesExtra[1])*matricesWeightsExtra[1];
#endif
#if NUM_BONE_INFLUENCERS>6
influence+=readMatrixFromRawSampler(boneSampler,matricesIndicesExtra[2])*matricesWeightsExtra[2];
#endif
#if NUM_BONE_INFLUENCERS>7
influence+=readMatrixFromRawSampler(boneSampler,matricesIndicesExtra[3])*matricesWeightsExtra[3];
#endif
#else
influence=mBones[int(matricesIndices[0])]*matricesWeights[0];
#if NUM_BONE_INFLUENCERS>1
influence+=mBones[int(matricesIndices[1])]*matricesWeights[1];
#endif
#if NUM_BONE_INFLUENCERS>2
influence+=mBones[int(matricesIndices[2])]*matricesWeights[2];
#endif
#if NUM_BONE_INFLUENCERS>3
influence+=mBones[int(matricesIndices[3])]*matricesWeights[3];
#endif
#if NUM_BONE_INFLUENCERS>4
influence+=mBones[int(matricesIndicesExtra[0])]*matricesWeightsExtra[0];
#endif
#if NUM_BONE_INFLUENCERS>5
influence+=mBones[int(matricesIndicesExtra[1])]*matricesWeightsExtra[1];
#endif
#if NUM_BONE_INFLUENCERS>6
influence+=mBones[int(matricesIndicesExtra[2])]*matricesWeightsExtra[2];
#endif
#if NUM_BONE_INFLUENCERS>7
influence+=mBones[int(matricesIndicesExtra[3])]*matricesWeightsExtra[3];
#endif
#endif
finalWorld=finalWorld*influence;
#endif
#endif
`;
G.IncludesShadersStore[Yh] = qh;
const jh = "bakedVertexAnimation", Zh = `#ifdef BAKED_VERTEX_ANIMATION_TEXTURE
{
#ifdef INSTANCES
#define BVASNAME bakedVertexAnimationSettingsInstanced
#else
#define BVASNAME bakedVertexAnimationSettings
#endif
float VATStartFrame=BVASNAME.x;float VATEndFrame=BVASNAME.y;float VATOffsetFrame=BVASNAME.z;float VATSpeed=BVASNAME.w;float totalFrames=VATEndFrame-VATStartFrame+1.0;float time=bakedVertexAnimationTime*VATSpeed/totalFrames;float frameCorrection=time<1.0 ? 0.0 : 1.0;float numOfFrames=totalFrames-frameCorrection;float VATFrameNum=fract(time)*numOfFrames;VATFrameNum=mod(VATFrameNum+VATOffsetFrame,numOfFrames);VATFrameNum=floor(VATFrameNum);VATFrameNum+=VATStartFrame+frameCorrection;mat4 VATInfluence;VATInfluence=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndices[0],VATFrameNum)*matricesWeights[0];
#if NUM_BONE_INFLUENCERS>1
VATInfluence+=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndices[1],VATFrameNum)*matricesWeights[1];
#endif
#if NUM_BONE_INFLUENCERS>2
VATInfluence+=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndices[2],VATFrameNum)*matricesWeights[2];
#endif
#if NUM_BONE_INFLUENCERS>3
VATInfluence+=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndices[3],VATFrameNum)*matricesWeights[3];
#endif
#if NUM_BONE_INFLUENCERS>4
VATInfluence+=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndicesExtra[0],VATFrameNum)*matricesWeightsExtra[0];
#endif
#if NUM_BONE_INFLUENCERS>5
VATInfluence+=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndicesExtra[1],VATFrameNum)*matricesWeightsExtra[1];
#endif
#if NUM_BONE_INFLUENCERS>6
VATInfluence+=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndicesExtra[2],VATFrameNum)*matricesWeightsExtra[2];
#endif
#if NUM_BONE_INFLUENCERS>7
VATInfluence+=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndicesExtra[3],VATFrameNum)*matricesWeightsExtra[3];
#endif
finalWorld=finalWorld*VATInfluence;}
#endif
`;
G.IncludesShadersStore[jh] = Zh;
const Qh = "clipPlaneVertex", $h = `#ifdef CLIPPLANE
fClipDistance=dot(worldPos,vClipPlane);
#endif
#ifdef CLIPPLANE2
fClipDistance2=dot(worldPos,vClipPlane2);
#endif
#ifdef CLIPPLANE3
fClipDistance3=dot(worldPos,vClipPlane3);
#endif
#ifdef CLIPPLANE4
fClipDistance4=dot(worldPos,vClipPlane4);
#endif
#ifdef CLIPPLANE5
fClipDistance5=dot(worldPos,vClipPlane5);
#endif
#ifdef CLIPPLANE6
fClipDistance6=dot(worldPos,vClipPlane6);
#endif
`;
G.IncludesShadersStore[Qh] = $h;
const Jh = "vertexColorMixing", ec = `#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
vColor=vec4(1.0);
#ifdef VERTEXCOLOR
#ifdef VERTEXALPHA
vColor*=color;
#else
vColor.rgb*=color.rgb;
#endif
#endif
#ifdef INSTANCESCOLOR
vColor*=instanceColor;
#endif
#endif
`;
G.IncludesShadersStore[Jh] = ec;
const tc = "colorVertexShader", ic = `attribute vec3 position;
#ifdef VERTEXCOLOR
attribute vec4 color;
#endif
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<clipPlaneVertexDeclaration>
#include<instancesDeclaration>
uniform mat4 viewProjection;
#ifdef MULTIVIEW
uniform mat4 viewProjectionR;
#endif
#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
varying vec4 vColor;
#endif
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
#include<instancesVertex>
#include<bonesVertex>
#include<bakedVertexAnimation>
vec4 worldPos=finalWorld*vec4(position,1.0);
#ifdef MULTIVIEW
if (gl_ViewID_OVR==0u) {gl_Position=viewProjection*worldPos;} else {gl_Position=viewProjectionR*worldPos;}
#else
gl_Position=viewProjection*worldPos;
#endif
#include<clipPlaneVertex>
#include<vertexColorMixing>
#define CUSTOM_VERTEX_MAIN_END
}`;
G.ShadersStore[tc] = ic;
K._LinesMeshParser = (h, e) => vs.Parse(h, e);
class vs extends K {
  _isShaderMaterial(e) {
    return e.getClassName() === "ShaderMaterial";
  }
  /**
   * Creates a new LinesMesh
   * @param name defines the name
   * @param scene defines the hosting scene
   * @param parent defines the parent mesh if any
   * @param source defines the optional source LinesMesh used to clone data from
   * @param doNotCloneChildren When cloning, skip cloning child meshes of source, default False.
   * When false, achieved by calling a clone(), also passing False.
   * This will make creation of children, recursive.
   * @param useVertexColor defines if this LinesMesh supports vertex color
   * @param useVertexAlpha defines if this LinesMesh supports vertex alpha
   * @param material material to use to draw the line. If not provided, will create a new one
   */
  constructor(e, t = null, i = null, s = null, r, n, a, o) {
    super(e, t, i, s, r), this.useVertexColor = n, this.useVertexAlpha = a, this.color = new ie(1, 1, 1), this.alpha = 1, s && (this.color = s.color.clone(), this.alpha = s.alpha, this.useVertexColor = s.useVertexColor, this.useVertexAlpha = s.useVertexAlpha), this.intersectionThreshold = 0.1;
    const l = [], c = {
      attributes: [v.PositionKind],
      uniforms: ["world", "viewProjection"],
      needAlphaBlending: !0,
      defines: l,
      useClipPlane: null
    };
    a === !1 ? c.needAlphaBlending = !1 : c.defines.push("#define VERTEXALPHA"), n ? (c.defines.push("#define VERTEXCOLOR"), c.attributes.push(v.ColorKind)) : (c.uniforms.push("color"), this._color4 = new ye()), o ? this.material = o : (this.material = new Ri("colorShader", this.getScene(), "color", c, !1), this.material.doNotSerialize = !0);
  }
  isReady() {
    return this._lineMaterial.isReady(this, !!this._userInstancedBuffersStorage) ? super.isReady() : !1;
  }
  /**
   * Returns the string "LineMesh"
   */
  getClassName() {
    return "LinesMesh";
  }
  /**
   * @internal
   */
  get material() {
    return this._lineMaterial;
  }
  /**
   * @internal
   */
  set material(e) {
    this._lineMaterial = e, this._lineMaterial.fillMode = F.LineListDrawMode;
  }
  /**
   * @internal
   */
  get checkCollisions() {
    return !1;
  }
  set checkCollisions(e) {
  }
  /**
   * @internal
   */
  _bind(e, t) {
    if (!this._geometry)
      return this;
    const i = this.isUnIndexed ? null : this._geometry.getIndexBuffer();
    if (this._userInstancedBuffersStorage ? this._geometry._bind(t, i, this._userInstancedBuffersStorage.vertexBuffers, this._userInstancedBuffersStorage.vertexArrayObjects) : this._geometry._bind(t, i), !this.useVertexColor && this._isShaderMaterial(this._lineMaterial)) {
      const { r: s, g: r, b: n } = this.color;
      this._color4.set(s, r, n, this.alpha), this._lineMaterial.setColor4("color", this._color4);
    }
    return this;
  }
  /**
   * @internal
   */
  _draw(e, t, i) {
    if (!this._geometry || !this._geometry.getVertexBuffers() || !this._unIndexed && !this._geometry.getIndexBuffer())
      return this;
    const s = this.getScene().getEngine();
    return this._unIndexed ? s.drawArraysType(F.LineListDrawMode, e.verticesStart, e.verticesCount, i) : s.drawElementsType(F.LineListDrawMode, e.indexStart, e.indexCount, i), this;
  }
  /**
   * Disposes of the line mesh
   * @param doNotRecurse If children should be disposed
   * @param disposeMaterialAndTextures This parameter is not used by the LineMesh class
   * @param doNotDisposeMaterial If the material should not be disposed (default: false, meaning the material is disposed)
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  dispose(e, t = !1, i) {
    i || this._lineMaterial.dispose(!1, !1, !0), super.dispose(e);
  }
  /**
   * Returns a new LineMesh object cloned from the current one.
   * @param name
   * @param newParent
   * @param doNotCloneChildren
   */
  clone(e, t = null, i) {
    return new vs(e, this.getScene(), t, this, i);
  }
  /**
   * Creates a new InstancedLinesMesh object from the mesh model.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/copies/instances
   * @param name defines the name of the new instance
   * @returns a new InstancedLinesMesh
   */
  createInstance(e) {
    const t = new sc(e, this);
    if (this.instancedBuffers) {
      t.instancedBuffers = {};
      for (const i in this.instancedBuffers)
        t.instancedBuffers[i] = this.instancedBuffers[i];
    }
    return t;
  }
  /**
   * Serializes this ground mesh
   * @param serializationObject object to write serialization to
   */
  serialize(e) {
    super.serialize(e), e.color = this.color.asArray(), e.alpha = this.alpha;
  }
  /**
   * Parses a serialized ground mesh
   * @param parsedMesh the serialized mesh
   * @param scene the scene to create the ground mesh in
   * @returns the created ground mesh
   */
  static Parse(e, t) {
    const i = new vs(e.name, t);
    return i.color = ie.FromArray(e.color), i.alpha = e.alpha, i;
  }
}
class sc extends Nn {
  constructor(e, t) {
    super(e, t), this.intersectionThreshold = t.intersectionThreshold;
  }
  /**
   * Returns the string "InstancedLinesMesh".
   */
  getClassName() {
    return "InstancedLinesMesh";
  }
}
function lo(h) {
  const e = [], t = [], i = h.lines, s = h.colors, r = [];
  let n = 0;
  for (let o = 0; o < i.length; o++) {
    const l = i[o];
    for (let c = 0; c < l.length; c++) {
      if (t.push(l[c].x, l[c].y, l[c].z), s) {
        const u = s[o];
        r.push(u[c].r, u[c].g, u[c].b, u[c].a);
      }
      c > 0 && (e.push(n - 1), e.push(n)), n++;
    }
  }
  const a = new q();
  return a.indices = e, a.positions = t, s && (a.colors = r), a;
}
function ho(h) {
  const e = h.dashSize || 3, t = h.gapSize || 1, i = h.dashNb || 200, s = h.points, r = new Array(), n = new Array(), a = p.Zero();
  let o = 0, l = 0, c = 0, u = 0, d = 0, f = 0, _ = 0;
  for (_ = 0; _ < s.length - 1; _++)
    s[_ + 1].subtractToRef(s[_], a), o += a.length();
  for (c = o / i, u = e * c / (e + t), _ = 0; _ < s.length - 1; _++) {
    s[_ + 1].subtractToRef(s[_], a), l = Math.floor(a.length() / c), a.normalize();
    for (let m = 0; m < l; m++)
      d = c * m, r.push(s[_].x + d * a.x, s[_].y + d * a.y, s[_].z + d * a.z), r.push(s[_].x + (d + u) * a.x, s[_].y + (d + u) * a.y, s[_].z + (d + u) * a.z), n.push(f, f + 1), f += 2;
  }
  const g = new q();
  return g.positions = r, g.indices = n, g;
}
function rc(h, e, t = null) {
  const i = e.instance, s = e.lines, r = e.colors;
  if (i) {
    const l = i.getVerticesData(v.PositionKind);
    let c, u;
    r && (c = i.getVerticesData(v.ColorKind));
    let d = 0, f = 0;
    for (let _ = 0; _ < s.length; _++) {
      const g = s[_];
      for (let m = 0; m < g.length; m++)
        l[d] = g[m].x, l[d + 1] = g[m].y, l[d + 2] = g[m].z, r && c && (u = r[_], c[f] = u[m].r, c[f + 1] = u[m].g, c[f + 2] = u[m].b, c[f + 3] = u[m].a, f += 4), d += 3;
    }
    return i.updateVerticesData(v.PositionKind, l, !1, !1), r && c && i.updateVerticesData(v.ColorKind, c, !1, !1), i;
  }
  const n = !!r, a = new vs(h, t, null, void 0, void 0, n, e.useVertexAlpha, e.material);
  return lo(e).applyToMesh(a, e.updatable), a;
}
function co(h, e, t = null) {
  const i = e.colors ? [e.colors] : null;
  return rc(h, { lines: [e.points], updatable: e.updatable, instance: e.instance, colors: i, useVertexAlpha: e.useVertexAlpha, material: e.material }, t);
}
function nc(h, e, t = null) {
  const i = e.points, s = e.instance, r = e.gapSize || 1, n = e.dashSize || 3;
  if (s) {
    const l = (c) => {
      const u = p.Zero(), d = c.length / 6;
      let f = 0, _ = 0, g = 0, m = 0, y = 0, x = 0, A = 0, T = 0;
      for (A = 0; A < i.length - 1; A++)
        i[A + 1].subtractToRef(i[A], u), f += u.length();
      g = f / d;
      const M = s._creationDataStorage.dashSize, b = s._creationDataStorage.gapSize;
      for (m = M * g / (M + b), A = 0; A < i.length - 1; A++)
        for (i[A + 1].subtractToRef(i[A], u), _ = Math.floor(u.length() / g), u.normalize(), T = 0; T < _ && x < c.length; )
          y = g * T, c[x] = i[A].x + y * u.x, c[x + 1] = i[A].y + y * u.y, c[x + 2] = i[A].z + y * u.z, c[x + 3] = i[A].x + (y + m) * u.x, c[x + 4] = i[A].y + (y + m) * u.y, c[x + 5] = i[A].z + (y + m) * u.z, x += 6, T++;
      for (; x < c.length; )
        c[x] = i[A].x, c[x + 1] = i[A].y, c[x + 2] = i[A].z, x += 3;
    };
    return (e.dashNb || e.dashSize || e.gapSize || e.useVertexAlpha || e.material) && w.Warn("You have used an option other than points with the instance option. Please be aware that these other options will be ignored."), s.updateMeshPositions(l, !1), s;
  }
  const a = new vs(h, t, null, void 0, void 0, void 0, e.useVertexAlpha, e.material);
  return ho(e).applyToMesh(a, e.updatable), a._creationDataStorage = new Ka(), a._creationDataStorage.dashSize = n, a._creationDataStorage.gapSize = r, a;
}
q.CreateLineSystem = lo;
q.CreateDashedLines = ho;
K.CreateLines = (h, e, t = null, i = !1, s = null) => co(h, {
  points: e,
  updatable: i,
  instance: s
}, t);
K.CreateDashedLines = (h, e, t, i, s, r = null, n, a) => nc(h, {
  points: e,
  dashSize: t,
  gapSize: i,
  dashNb: s,
  updatable: n,
  instance: a
}, r);
class di {
  /**
   * Initializes the ammoJS plugin
   * @param _useDeltaForWorldStep if the time between frames should be used when calculating physics steps (Default: true)
   * @param ammoInjection can be used to inject your own ammo reference
   * @param overlappingPairCache can be used to specify your own overlapping pair cache
   */
  constructor(e = !0, t = Ammo, i = null) {
    if (this._useDeltaForWorldStep = e, this.bjsAMMO = {}, this.name = "AmmoJSPlugin", this._timeStep = 1 / 60, this._fixedTimeStep = 1 / 60, this._maxSteps = 5, this._tmpQuaternion = new U(), this._tmpContactCallbackResult = !1, this._tmpContactPoint = new p(), this._tmpContactNormal = new p(), this._tmpVec3 = new p(), this._tmpMatrix = new I(), typeof t == "function") {
      w.Error("AmmoJS is not ready. Please make sure you await Ammo() before using the plugin.");
      return;
    } else
      this.bjsAMMO = t;
    if (!this.isSupported()) {
      w.Error("AmmoJS is not available. Please make sure you included the js file.");
      return;
    }
    this._collisionConfiguration = new this.bjsAMMO.btSoftBodyRigidBodyCollisionConfiguration(), this._dispatcher = new this.bjsAMMO.btCollisionDispatcher(this._collisionConfiguration), this._overlappingPairCache = i || new this.bjsAMMO.btDbvtBroadphase(), this._solver = new this.bjsAMMO.btSequentialImpulseConstraintSolver(), this._softBodySolver = new this.bjsAMMO.btDefaultSoftBodySolver(), this.world = new this.bjsAMMO.btSoftRigidDynamicsWorld(this._dispatcher, this._overlappingPairCache, this._solver, this._collisionConfiguration, this._softBodySolver), this._tmpAmmoConcreteContactResultCallback = new this.bjsAMMO.ConcreteContactResultCallback(), this._tmpAmmoConcreteContactResultCallback.addSingleResult = (s) => {
      s = this.bjsAMMO.wrapPointer(s, this.bjsAMMO.btManifoldPoint);
      const r = s.getPositionWorldOnA(), n = s.m_normalWorldOnB;
      this._tmpContactPoint.x = r.x(), this._tmpContactPoint.y = r.y(), this._tmpContactPoint.z = r.z(), this._tmpContactNormal.x = n.x(), this._tmpContactNormal.y = n.y(), this._tmpContactNormal.z = n.z(), this._tmpContactImpulse = s.getAppliedImpulse(), this._tmpContactDistance = s.getDistance(), this._tmpContactCallbackResult = !0;
    }, this._raycastResult = new Un(), this._tmpAmmoTransform = new this.bjsAMMO.btTransform(), this._tmpAmmoTransform.setIdentity(), this._tmpAmmoQuaternion = new this.bjsAMMO.btQuaternion(0, 0, 0, 1), this._tmpAmmoVectorA = new this.bjsAMMO.btVector3(0, 0, 0), this._tmpAmmoVectorB = new this.bjsAMMO.btVector3(0, 0, 0), this._tmpAmmoVectorC = new this.bjsAMMO.btVector3(0, 0, 0), this._tmpAmmoVectorD = new this.bjsAMMO.btVector3(0, 0, 0);
  }
  /**
   *
   * @returns plugin version
   */
  getPluginVersion() {
    return 1;
  }
  /**
   * Sets the gravity of the physics world (m/(s^2))
   * @param gravity Gravity to set
   */
  setGravity(e) {
    this._tmpAmmoVectorA.setValue(e.x, e.y, e.z), this.world.setGravity(this._tmpAmmoVectorA), this.world.getWorldInfo().set_m_gravity(this._tmpAmmoVectorA);
  }
  /**
   * Amount of time to step forward on each frame (only used if useDeltaForWorldStep is false in the constructor)
   * @param timeStep timestep to use in seconds
   */
  setTimeStep(e) {
    this._timeStep = e;
  }
  /**
   * Increment to step forward in the physics engine (If timeStep is set to 1/60 and fixedTimeStep is set to 1/120 the physics engine should run 2 steps per frame) (Default: 1/60)
   * @param fixedTimeStep fixedTimeStep to use in seconds
   */
  setFixedTimeStep(e) {
    this._fixedTimeStep = e;
  }
  /**
   * Sets the maximum number of steps by the physics engine per frame (Default: 5)
   * @param maxSteps the maximum number of steps by the physics engine per frame
   */
  setMaxSteps(e) {
    this._maxSteps = e;
  }
  /**
   * Gets the current timestep (only used if useDeltaForWorldStep is false in the constructor)
   * @returns the current timestep in seconds
   */
  getTimeStep() {
    return this._timeStep;
  }
  // Ammo's contactTest and contactPairTest take a callback that runs synchronously, wrap them so that they are easier to consume
  _isImpostorInContact(e) {
    return this._tmpContactCallbackResult = !1, this.world.contactTest(e.physicsBody, this._tmpAmmoConcreteContactResultCallback), this._tmpContactCallbackResult;
  }
  // Ammo's collision events have some weird quirks
  // contactPairTest fires too many events as it fires events even when objects are close together but contactTest does not
  // so only fire event if both contactTest and contactPairTest have a hit
  _isImpostorPairInContact(e, t) {
    return this._tmpContactCallbackResult = !1, this.world.contactPairTest(e.physicsBody, t.physicsBody, this._tmpAmmoConcreteContactResultCallback), this._tmpContactCallbackResult;
  }
  // Ammo's behavior when maxSteps > 0 does not behave as described in docs
  // @see http://www.bulletphysics.org/mediawiki-1.5.8/index.php/Stepping_The_World
  //
  // When maxSteps is 0 do the entire simulation in one step
  // When maxSteps is > 0, run up to maxStep times, if on the last step the (remaining step - fixedTimeStep) is < fixedTimeStep, the remainder will be used for the step. (eg. if remainder is 1.001 and fixedTimeStep is 1 the last step will be 1.001, if instead it did 2 steps (1, 0.001) issues occuered when having a tiny step in ammo)
  // Note: To get deterministic physics, timeStep would always need to be divisible by fixedTimeStep
  _stepSimulation(e = 1 / 60, t = 10, i = 1 / 60) {
    if (t == 0)
      this.world.stepSimulation(e, 0);
    else
      for (; t > 0 && e > 0; )
        e - i < i ? (this.world.stepSimulation(e, 0), e = 0) : (e -= i, this.world.stepSimulation(i, 0)), t--;
  }
  /**
   * Moves the physics simulation forward delta seconds and updates the given physics imposters
   * Prior to the step the imposters physics location is set to the position of the babylon meshes
   * After the step the babylon meshes are set to the position of the physics imposters
   * @param delta amount of time to step forward
   * @param impostors array of imposters to update before/after the step
   */
  executeStep(e, t) {
    for (const i of t)
      i.soft || i.beforeStep();
    this._stepSimulation(this._useDeltaForWorldStep ? e : this._timeStep, this._maxSteps, this._fixedTimeStep);
    for (const i of t)
      if (i.soft ? this._afterSoftStep(i) : i.afterStep(), i._onPhysicsCollideCallbacks.length > 0 && this._isImpostorInContact(i))
        for (const s of i._onPhysicsCollideCallbacks)
          for (const r of s.otherImpostors)
            (i.physicsBody.isActive() || r.physicsBody.isActive()) && this._isImpostorPairInContact(i, r) && (i.onCollide({
              body: r.physicsBody,
              point: this._tmpContactPoint,
              distance: this._tmpContactDistance,
              impulse: this._tmpContactImpulse,
              normal: this._tmpContactNormal
            }), r.onCollide({
              body: i.physicsBody,
              point: this._tmpContactPoint,
              distance: this._tmpContactDistance,
              impulse: this._tmpContactImpulse,
              normal: this._tmpContactNormal
            }));
  }
  /**
   * Update babylon mesh to match physics world object
   * @param impostor imposter to match
   */
  _afterSoftStep(e) {
    e.type === re.RopeImpostor ? this._ropeStep(e) : this._softbodyOrClothStep(e);
  }
  /**
   * Update babylon mesh vertices vertices to match physics world softbody or cloth
   * @param impostor imposter to match
   */
  _ropeStep(e) {
    const t = e.physicsBody.get_m_nodes(), i = t.size();
    let s, r, n, a, o;
    const l = new Array();
    for (let d = 0; d < i; d++)
      s = t.at(d), r = s.get_m_x(), n = r.x(), a = r.y(), o = r.z(), l.push(new p(n, a, o));
    const c = e.object, u = e.getParam("shape");
    e._isFromLine ? e.object = co("lines", { points: l, instance: c }) : e.object = ro("ext", { shape: u, path: l, instance: c });
  }
  /**
   * Update babylon mesh vertices vertices to match physics world softbody or cloth
   * @param impostor imposter to match
   */
  _softbodyOrClothStep(e) {
    const t = e.type === re.ClothImpostor ? 1 : -1, i = e.object;
    let s = i.getVerticesData(v.PositionKind);
    s || (s = []);
    let r = i.getVerticesData(v.NormalKind);
    r || (r = []);
    const n = s.length / 3, a = e.physicsBody.get_m_nodes();
    let o, l, c, u, d, f, _, g;
    for (let y = 0; y < n; y++) {
      o = a.at(y), l = o.get_m_x(), c = l.x(), u = l.y(), d = l.z() * t;
      const x = o.get_m_n();
      f = x.x(), _ = x.y(), g = x.z() * t, s[3 * y] = c, s[3 * y + 1] = u, s[3 * y + 2] = d, r[3 * y] = f, r[3 * y + 1] = _, r[3 * y + 2] = g;
    }
    const m = new q();
    m.positions = s, m.normals = r, m.uvs = i.getVerticesData(v.UVKind), m.colors = i.getVerticesData(v.ColorKind), i && i.getIndices && (m.indices = i.getIndices()), m.applyToMesh(i);
  }
  /**
   * Applies an impulse on the imposter
   * @param impostor imposter to apply impulse to
   * @param force amount of force to be applied to the imposter
   * @param contactPoint the location to apply the impulse on the imposter
   */
  applyImpulse(e, t, i) {
    if (e.soft)
      w.Warn("Cannot be applied to a soft body");
    else {
      e.physicsBody.activate();
      const s = this._tmpAmmoVectorA, r = this._tmpAmmoVectorB;
      e.object && e.object.getWorldMatrix && i.subtractInPlace(e.object.getWorldMatrix().getTranslation()), s.setValue(i.x, i.y, i.z), r.setValue(t.x, t.y, t.z), e.physicsBody.applyImpulse(r, s);
    }
  }
  /**
   * Applies a force on the imposter
   * @param impostor imposter to apply force
   * @param force amount of force to be applied to the imposter
   * @param contactPoint the location to apply the force on the imposter
   */
  applyForce(e, t, i) {
    if (e.soft)
      w.Warn("Cannot be applied to a soft body");
    else {
      e.physicsBody.activate();
      const s = this._tmpAmmoVectorA, r = this._tmpAmmoVectorB;
      if (e.object && e.object.getWorldMatrix) {
        const n = e.object.getWorldMatrix().getTranslation();
        s.setValue(i.x - n.x, i.y - n.y, i.z - n.z);
      } else
        s.setValue(i.x, i.y, i.z);
      r.setValue(t.x, t.y, t.z), e.physicsBody.applyForce(r, s);
    }
  }
  /**
   * Creates a physics body using the plugin
   * @param impostor the imposter to create the physics body on
   */
  generatePhysicsBody(e) {
    if (e._pluginData.toDispose = [], e.parent) {
      e.physicsBody && (this.removePhysicsBody(e), e.forceUpdate());
      return;
    }
    if (e.isBodyInitRequired()) {
      const t = this._createShape(e), i = e.getParam("mass");
      if (e._pluginData.mass = i, e.soft)
        t.get_m_cfg().set_collisions(17), t.get_m_cfg().set_kDP(e.getParam("damping")), this.bjsAMMO.castObject(t, this.bjsAMMO.btCollisionObject).getCollisionShape().setMargin(e.getParam("margin")), t.setActivationState(di._DISABLE_DEACTIVATION_FLAG), this.world.addSoftBody(t, 1, -1), e.physicsBody = t, e._pluginData.toDispose.push(t), this.setBodyPressure(e, 0), e.type === re.SoftbodyImpostor && this.setBodyPressure(e, e.getParam("pressure")), this.setBodyStiffness(e, e.getParam("stiffness")), this.setBodyVelocityIterations(e, e.getParam("velocityIterations")), this.setBodyPositionIterations(e, e.getParam("positionIterations"));
      else {
        const s = new this.bjsAMMO.btVector3(0, 0, 0), r = new this.bjsAMMO.btTransform();
        e.object.computeWorldMatrix(!0), r.setIdentity(), i !== 0 && t.calculateLocalInertia(i, s), this._tmpAmmoVectorA.setValue(e.object.position.x, e.object.position.y, e.object.position.z), this._tmpAmmoQuaternion.setValue(e.object.rotationQuaternion.x, e.object.rotationQuaternion.y, e.object.rotationQuaternion.z, e.object.rotationQuaternion.w), r.setOrigin(this._tmpAmmoVectorA), r.setRotation(this._tmpAmmoQuaternion);
        const n = new this.bjsAMMO.btDefaultMotionState(r), a = new this.bjsAMMO.btRigidBodyConstructionInfo(i, n, t, s), o = new this.bjsAMMO.btRigidBody(a);
        if (i === 0 && (o.setCollisionFlags(o.getCollisionFlags() | di._KINEMATIC_FLAG), o.setActivationState(di._DISABLE_DEACTIVATION_FLAG)), e.type == re.NoImpostor && !t.getChildShape && o.setCollisionFlags(o.getCollisionFlags() | di._DISABLE_COLLISION_FLAG), e.type !== re.MeshImpostor && e.type !== re.NoImpostor) {
          const u = e.object.getBoundingInfo();
          this._tmpVec3.copyFrom(e.object.getAbsolutePosition()), this._tmpVec3.subtractInPlace(u.boundingBox.centerWorld), this._tmpVec3.x /= e.object.scaling.x, this._tmpVec3.y /= e.object.scaling.y, this._tmpVec3.z /= e.object.scaling.z, e.setDeltaPosition(this._tmpVec3);
        }
        const l = e.getParam("group"), c = e.getParam("mask");
        l && c ? this.world.addRigidBody(o, l, c) : this.world.addRigidBody(o), e.physicsBody = o, e._pluginData.toDispose = e._pluginData.toDispose.concat([o, a, n, r, s, t]);
      }
      this.setBodyRestitution(e, e.getParam("restitution")), this.setBodyFriction(e, e.getParam("friction"));
    }
  }
  /**
   * Removes the physics body from the imposter and disposes of the body's memory
   * @param impostor imposter to remove the physics body from
   */
  removePhysicsBody(e) {
    this.world && (e.soft ? this.world.removeSoftBody(e.physicsBody) : this.world.removeRigidBody(e.physicsBody), e._pluginData && (e._pluginData.toDispose.forEach((t) => {
      this.bjsAMMO.destroy(t);
    }), e._pluginData.toDispose = []));
  }
  /**
   * Generates a joint
   * @param impostorJoint the imposter joint to create the joint with
   */
  generateJoint(e) {
    const t = e.mainImpostor.physicsBody, i = e.connectedImpostor.physicsBody;
    if (!t || !i)
      return;
    const s = e.joint.jointData;
    s.mainPivot || (s.mainPivot = new p(0, 0, 0)), s.connectedPivot || (s.connectedPivot = new p(0, 0, 0));
    let r;
    switch (e.joint.type) {
      case Ge.DistanceJoint: {
        const n = s.maxDistance;
        n && (s.mainPivot = new p(0, -n / 2, 0), s.connectedPivot = new p(0, n / 2, 0)), r = new this.bjsAMMO.btPoint2PointConstraint(t, i, new this.bjsAMMO.btVector3(s.mainPivot.x, s.mainPivot.y, s.mainPivot.z), new this.bjsAMMO.btVector3(s.connectedPivot.x, s.connectedPivot.y, s.connectedPivot.z));
        break;
      }
      case Ge.HingeJoint: {
        s.mainAxis || (s.mainAxis = new p(0, 0, 0)), s.connectedAxis || (s.connectedAxis = new p(0, 0, 0));
        const n = new this.bjsAMMO.btVector3(s.mainAxis.x, s.mainAxis.y, s.mainAxis.z), a = new this.bjsAMMO.btVector3(s.connectedAxis.x, s.connectedAxis.y, s.connectedAxis.z);
        r = new this.bjsAMMO.btHingeConstraint(t, i, new this.bjsAMMO.btVector3(s.mainPivot.x, s.mainPivot.y, s.mainPivot.z), new this.bjsAMMO.btVector3(s.connectedPivot.x, s.connectedPivot.y, s.connectedPivot.z), n, a);
        break;
      }
      case Ge.BallAndSocketJoint:
        r = new this.bjsAMMO.btPoint2PointConstraint(t, i, new this.bjsAMMO.btVector3(s.mainPivot.x, s.mainPivot.y, s.mainPivot.z), new this.bjsAMMO.btVector3(s.connectedPivot.x, s.connectedPivot.y, s.connectedPivot.z));
        break;
      default:
        w.Warn("JointType not currently supported by the Ammo plugin, falling back to PhysicsJoint.BallAndSocketJoint"), r = new this.bjsAMMO.btPoint2PointConstraint(t, i, new this.bjsAMMO.btVector3(s.mainPivot.x, s.mainPivot.y, s.mainPivot.z), new this.bjsAMMO.btVector3(s.connectedPivot.x, s.connectedPivot.y, s.connectedPivot.z));
        break;
    }
    this.world.addConstraint(r, !e.joint.jointData.collision), e.joint.physicsJoint = r;
  }
  /**
   * Removes a joint
   * @param impostorJoint the imposter joint to remove the joint from
   */
  removeJoint(e) {
    this.world && this.world.removeConstraint(e.joint.physicsJoint);
  }
  // adds all verticies (including child verticies) to the triangle mesh
  _addMeshVerts(e, t, i) {
    let s = 0;
    if (i && i.getIndices && i.getWorldMatrix && i.getChildMeshes) {
      let r = i.getIndices();
      r || (r = []);
      let n = i.getVerticesData(v.PositionKind);
      n || (n = []);
      let a;
      if (t && t !== i) {
        let l;
        t.rotationQuaternion ? l = t.rotationQuaternion : t.rotation ? l = U.FromEulerAngles(t.rotation.x, t.rotation.y, t.rotation.z) : l = U.Identity(), I.Compose(p.One(), l, t.position).invertToRef(this._tmpMatrix), a = i.computeWorldMatrix(!1).multiply(this._tmpMatrix);
      } else
        I.ScalingToRef(i.scaling.x, i.scaling.y, i.scaling.z, this._tmpMatrix), a = this._tmpMatrix;
      const o = r.length / 3;
      for (let l = 0; l < o; l++) {
        const c = [];
        for (let u = 0; u < 3; u++) {
          let d = new p(n[r[l * 3 + u] * 3 + 0], n[r[l * 3 + u] * 3 + 1], n[r[l * 3 + u] * 3 + 2]);
          d = p.TransformCoordinates(d, a);
          let f;
          u == 0 ? f = this._tmpAmmoVectorA : u == 1 ? f = this._tmpAmmoVectorB : f = this._tmpAmmoVectorC, f.setValue(d.x, d.y, d.z), c.push(f);
        }
        e.addTriangle(c[0], c[1], c[2]), s++;
      }
      i.getChildMeshes().forEach((l) => {
        s += this._addMeshVerts(e, t, l);
      });
    }
    return s;
  }
  /**
   * Initialise the soft body vertices to match its object's (mesh) vertices
   * Softbody vertices (nodes) are in world space and to match this
   * The object's position and rotation is set to zero and so its vertices are also then set in world space
   * @param impostor to create the softbody for
   */
  _softVertexData(e) {
    const t = e.object;
    if (t && t.getIndices && t.getWorldMatrix && t.getChildMeshes) {
      t.getIndices();
      let i = t.getVerticesData(v.PositionKind);
      i || (i = []);
      let s = t.getVerticesData(v.NormalKind);
      s || (s = []), t.computeWorldMatrix(!1);
      const r = [], n = [];
      for (let o = 0; o < i.length; o += 3) {
        let l = new p(i[o], i[o + 1], i[o + 2]), c = new p(s[o], s[o + 1], s[o + 2]);
        l = p.TransformCoordinates(l, t.getWorldMatrix()), c = p.TransformNormal(c, t.getWorldMatrix()), r.push(l.x, l.y, l.z), n.push(c.x, c.y, c.z);
      }
      const a = new q();
      return a.positions = r, a.normals = n, a.uvs = t.getVerticesData(v.UVKind), a.colors = t.getVerticesData(v.ColorKind), t && t.getIndices && (a.indices = t.getIndices()), a.applyToMesh(t), t.position = p.Zero(), t.rotationQuaternion = null, t.rotation = p.Zero(), t.computeWorldMatrix(!0), a;
    }
    return q.ExtractFromMesh(t);
  }
  /**
   * Create an impostor's soft body
   * @param impostor to create the softbody for
   */
  _createSoftbody(e) {
    const t = e.object;
    if (t && t.getIndices) {
      let i = t.getIndices();
      i || (i = []);
      const s = this._softVertexData(e), r = s.positions, n = s.normals;
      if (r === null || n === null)
        return new this.bjsAMMO.btCompoundShape();
      {
        const a = [], o = [];
        for (let _ = 0; _ < r.length; _ += 3) {
          const g = new p(r[_], r[_ + 1], r[_ + 2]), m = new p(n[_], n[_ + 1], n[_ + 2]);
          a.push(g.x, g.y, -g.z), o.push(m.x, m.y, -m.z);
        }
        const l = new this.bjsAMMO.btSoftBodyHelpers().CreateFromTriMesh(this.world.getWorldInfo(), a, t.getIndices(), i.length / 3, !0), c = r.length / 3, u = l.get_m_nodes();
        let d, f;
        for (let _ = 0; _ < c; _++)
          d = u.at(_), f = d.get_m_n(), f.setX(o[3 * _]), f.setY(o[3 * _ + 1]), f.setZ(o[3 * _ + 2]);
        return l;
      }
    }
  }
  /**
   * Create cloth for an impostor
   * @param impostor to create the softbody for
   */
  _createCloth(e) {
    const t = e.object;
    if (t && t.getIndices) {
      t.getIndices();
      const i = this._softVertexData(e), s = i.positions, r = i.normals;
      if (s === null || r === null)
        return new this.bjsAMMO.btCompoundShape();
      {
        const n = s.length, a = Math.sqrt(n / 3);
        e.segments = a;
        const o = a - 1;
        return this._tmpAmmoVectorA.setValue(s[0], s[1], s[2]), this._tmpAmmoVectorB.setValue(s[3 * o], s[3 * o + 1], s[3 * o + 2]), this._tmpAmmoVectorD.setValue(s[n - 3], s[n - 2], s[n - 1]), this._tmpAmmoVectorC.setValue(s[n - 3 - 3 * o], s[n - 2 - 3 * o], s[n - 1 - 3 * o]), new this.bjsAMMO.btSoftBodyHelpers().CreatePatch(this.world.getWorldInfo(), this._tmpAmmoVectorA, this._tmpAmmoVectorB, this._tmpAmmoVectorC, this._tmpAmmoVectorD, a, a, e.getParam("fixedPoints"), !0);
      }
    }
  }
  /**
   * Create rope for an impostor
   * @param impostor to create the softbody for
   */
  _createRope(e) {
    let t, i;
    const s = this._softVertexData(e), r = s.positions, n = s.normals;
    if (r === null || n === null)
      return new this.bjsAMMO.btCompoundShape();
    s.applyToMesh(e.object, !0), e._isFromLine = !0;
    const a = n.map((d) => d * d), o = (d, f) => d + f;
    if (a.reduce(o) === 0)
      t = r.length, i = t / 3 - 1, this._tmpAmmoVectorA.setValue(r[0], r[1], r[2]), this._tmpAmmoVectorB.setValue(r[t - 3], r[t - 2], r[t - 1]);
    else {
      e._isFromLine = !1;
      const d = e.getParam("path");
      if (e.getParam("shape") === null)
        return w.Warn("No shape available for extruded mesh"), new this.bjsAMMO.btCompoundShape();
      t = d.length, i = t - 1, this._tmpAmmoVectorA.setValue(d[0].x, d[0].y, d[0].z), this._tmpAmmoVectorB.setValue(d[t - 1].x, d[t - 1].y, d[t - 1].z);
    }
    e.segments = i;
    let c = e.getParam("fixedPoints");
    c = c > 3 ? 3 : c;
    const u = new this.bjsAMMO.btSoftBodyHelpers().CreateRope(this.world.getWorldInfo(), this._tmpAmmoVectorA, this._tmpAmmoVectorB, i - 1, c);
    return u.get_m_cfg().set_collisions(17), u;
  }
  /**
   * Create a custom physics impostor shape using the plugin's onCreateCustomShape handler
   * @param impostor to create the custom physics shape for
   */
  _createCustom(e) {
    let t = null;
    return this.onCreateCustomShape && (t = this.onCreateCustomShape(e)), t == null && (t = new this.bjsAMMO.btCompoundShape()), t;
  }
  // adds all verticies (including child verticies) to the convex hull shape
  _addHullVerts(e, t, i) {
    let s = 0;
    if (i && i.getIndices && i.getWorldMatrix && i.getChildMeshes) {
      let r = i.getIndices();
      r || (r = []);
      let n = i.getVerticesData(v.PositionKind);
      n || (n = []), i.computeWorldMatrix(!1);
      const a = r.length / 3;
      for (let o = 0; o < a; o++) {
        const l = [];
        for (let c = 0; c < 3; c++) {
          let u = new p(n[r[o * 3 + c] * 3 + 0], n[r[o * 3 + c] * 3 + 1], n[r[o * 3 + c] * 3 + 2]);
          I.ScalingToRef(i.scaling.x, i.scaling.y, i.scaling.z, this._tmpMatrix), u = p.TransformCoordinates(u, this._tmpMatrix);
          let d;
          c == 0 ? d = this._tmpAmmoVectorA : c == 1 ? d = this._tmpAmmoVectorB : d = this._tmpAmmoVectorC, d.setValue(u.x, u.y, u.z), l.push(d);
        }
        e.addPoint(l[0], !0), e.addPoint(l[1], !0), e.addPoint(l[2], !0), s++;
      }
      i.getChildMeshes().forEach((o) => {
        s += this._addHullVerts(e, t, o);
      });
    }
    return s;
  }
  _createShape(e, t = !1) {
    const i = e.object;
    let s;
    const r = e.getObjectExtents();
    if (!t) {
      const n = e.object.getChildMeshes ? e.object.getChildMeshes(!0) : [];
      s = new this.bjsAMMO.btCompoundShape();
      let a = 0;
      if (n.forEach((o) => {
        const l = o.getPhysicsImpostor();
        if (l) {
          if (l.type == re.MeshImpostor)
            throw "A child MeshImpostor is not supported. Only primitive impostors are supported as children (eg. box or sphere)";
          const c = this._createShape(l), u = o.parent.getWorldMatrix().clone(), d = new p();
          u.decompose(d), this._tmpAmmoTransform.getOrigin().setValue(o.position.x * d.x, o.position.y * d.y, o.position.z * d.z), this._tmpAmmoQuaternion.setValue(o.rotationQuaternion.x, o.rotationQuaternion.y, o.rotationQuaternion.z, o.rotationQuaternion.w), this._tmpAmmoTransform.setRotation(this._tmpAmmoQuaternion), s.addChildShape(this._tmpAmmoTransform, c), l.dispose(), a++;
        }
      }), a > 0) {
        if (e.type != re.NoImpostor) {
          const o = this._createShape(e, !0);
          o && (this._tmpAmmoTransform.getOrigin().setValue(0, 0, 0), this._tmpAmmoQuaternion.setValue(0, 0, 0, 1), this._tmpAmmoTransform.setRotation(this._tmpAmmoQuaternion), s.addChildShape(this._tmpAmmoTransform, o));
        }
        return s;
      } else
        this.bjsAMMO.destroy(s), s = null;
    }
    switch (e.type) {
      case re.SphereImpostor:
        if (J.WithinEpsilon(r.x, r.y, 1e-4) && J.WithinEpsilon(r.x, r.z, 1e-4))
          s = new this.bjsAMMO.btSphereShape(r.x / 2);
        else {
          const n = [new this.bjsAMMO.btVector3(0, 0, 0)], a = [1];
          s = new this.bjsAMMO.btMultiSphereShape(n, a, 1), s.setLocalScaling(new this.bjsAMMO.btVector3(r.x / 2, r.y / 2, r.z / 2));
        }
        break;
      case re.CapsuleImpostor:
        {
          const n = r.x / 2;
          s = new this.bjsAMMO.btCapsuleShape(n, r.y - n * 2);
        }
        break;
      case re.CylinderImpostor:
        this._tmpAmmoVectorA.setValue(r.x / 2, r.y / 2, r.z / 2), s = new this.bjsAMMO.btCylinderShape(this._tmpAmmoVectorA);
        break;
      case re.PlaneImpostor:
      case re.BoxImpostor:
        this._tmpAmmoVectorA.setValue(r.x / 2, r.y / 2, r.z / 2), s = new this.bjsAMMO.btBoxShape(this._tmpAmmoVectorA);
        break;
      case re.MeshImpostor:
        if (e.getParam("mass") == 0) {
          if (this.onCreateCustomMeshImpostor)
            s = this.onCreateCustomMeshImpostor(e);
          else {
            const n = new this.bjsAMMO.btTriangleMesh();
            e._pluginData.toDispose.push(n), this._addMeshVerts(n, i, i) == 0 ? s = new this.bjsAMMO.btCompoundShape() : s = new this.bjsAMMO.btBvhTriangleMeshShape(n);
          }
          break;
        }
      case re.ConvexHullImpostor: {
        if (this.onCreateCustomConvexHullImpostor)
          s = this.onCreateCustomConvexHullImpostor(e);
        else {
          const n = new this.bjsAMMO.btConvexHullShape();
          this._addHullVerts(n, i, i) == 0 ? (e._pluginData.toDispose.push(n), s = new this.bjsAMMO.btCompoundShape()) : s = n;
        }
        break;
      }
      case re.NoImpostor:
        s = new this.bjsAMMO.btSphereShape(r.x / 2);
        break;
      case re.CustomImpostor:
        s = this._createCustom(e);
        break;
      case re.SoftbodyImpostor:
        s = this._createSoftbody(e);
        break;
      case re.ClothImpostor:
        s = this._createCloth(e);
        break;
      case re.RopeImpostor:
        s = this._createRope(e);
        break;
      default:
        w.Warn("The impostor type is not currently supported by the ammo plugin.");
        break;
    }
    return s;
  }
  /**
   * Sets the mesh body position/rotation from the babylon impostor
   * @param impostor imposter containing the physics body and babylon object
   */
  setTransformationFromPhysicsBody(e) {
    e.physicsBody.getMotionState().getWorldTransform(this._tmpAmmoTransform), e.object.position.set(this._tmpAmmoTransform.getOrigin().x(), this._tmpAmmoTransform.getOrigin().y(), this._tmpAmmoTransform.getOrigin().z()), e.object.rotationQuaternion ? e.object.rotationQuaternion.set(this._tmpAmmoTransform.getRotation().x(), this._tmpAmmoTransform.getRotation().y(), this._tmpAmmoTransform.getRotation().z(), this._tmpAmmoTransform.getRotation().w()) : e.object.rotation && (this._tmpQuaternion.set(this._tmpAmmoTransform.getRotation().x(), this._tmpAmmoTransform.getRotation().y(), this._tmpAmmoTransform.getRotation().z(), this._tmpAmmoTransform.getRotation().w()), this._tmpQuaternion.toEulerAnglesToRef(e.object.rotation));
  }
  /**
   * Sets the babylon object's position/rotation from the physics body's position/rotation
   * @param impostor imposter containing the physics body and babylon object
   * @param newPosition new position
   * @param newRotation new rotation
   */
  setPhysicsBodyTransformation(e, t, i) {
    const s = e.physicsBody.getWorldTransform();
    if (Math.abs(s.getOrigin().x() - t.x) > pe || Math.abs(s.getOrigin().y() - t.y) > pe || Math.abs(s.getOrigin().z() - t.z) > pe || Math.abs(s.getRotation().x() - i.x) > pe || Math.abs(s.getRotation().y() - i.y) > pe || Math.abs(s.getRotation().z() - i.z) > pe || Math.abs(s.getRotation().w() - i.w) > pe)
      if (this._tmpAmmoVectorA.setValue(t.x, t.y, t.z), s.setOrigin(this._tmpAmmoVectorA), this._tmpAmmoQuaternion.setValue(i.x, i.y, i.z, i.w), s.setRotation(this._tmpAmmoQuaternion), e.physicsBody.setWorldTransform(s), e.mass == 0) {
        const r = e.physicsBody.getMotionState();
        r && r.setWorldTransform(s);
      } else
        e.physicsBody.activate();
  }
  /**
   * If this plugin is supported
   * @returns true if its supported
   */
  isSupported() {
    return this.bjsAMMO !== void 0;
  }
  /**
   * Sets the linear velocity of the physics body
   * @param impostor imposter to set the velocity on
   * @param velocity velocity to set
   */
  setLinearVelocity(e, t) {
    this._tmpAmmoVectorA.setValue(t.x, t.y, t.z), e.soft ? e.physicsBody.linearVelocity(this._tmpAmmoVectorA) : e.physicsBody.setLinearVelocity(this._tmpAmmoVectorA);
  }
  /**
   * Sets the angular velocity of the physics body
   * @param impostor imposter to set the velocity on
   * @param velocity velocity to set
   */
  setAngularVelocity(e, t) {
    this._tmpAmmoVectorA.setValue(t.x, t.y, t.z), e.soft ? e.physicsBody.angularVelocity(this._tmpAmmoVectorA) : e.physicsBody.setAngularVelocity(this._tmpAmmoVectorA);
  }
  /**
   * gets the linear velocity
   * @param impostor imposter to get linear velocity from
   * @returns linear velocity
   */
  getLinearVelocity(e) {
    let t;
    if (e.soft ? t = e.physicsBody.linearVelocity() : t = e.physicsBody.getLinearVelocity(), !t)
      return null;
    const i = new p(t.x(), t.y(), t.z());
    return this.bjsAMMO.destroy(t), i;
  }
  /**
   * gets the angular velocity
   * @param impostor imposter to get angular velocity from
   * @returns angular velocity
   */
  getAngularVelocity(e) {
    let t;
    if (e.soft ? t = e.physicsBody.angularVelocity() : t = e.physicsBody.getAngularVelocity(), !t)
      return null;
    const i = new p(t.x(), t.y(), t.z());
    return this.bjsAMMO.destroy(t), i;
  }
  /**
   * Sets the mass of physics body
   * @param impostor imposter to set the mass on
   * @param mass mass to set
   */
  setBodyMass(e, t) {
    e.soft ? e.physicsBody.setTotalMass(t, !1) : e.physicsBody.setMassProps(t), e._pluginData.mass = t;
  }
  /**
   * Gets the mass of the physics body
   * @param impostor imposter to get the mass from
   * @returns mass
   */
  getBodyMass(e) {
    return e._pluginData.mass || 0;
  }
  /**
   * Gets friction of the impostor
   * @param impostor impostor to get friction from
   * @returns friction value
   */
  getBodyFriction(e) {
    return e._pluginData.friction || 0;
  }
  /**
   * Sets friction of the impostor
   * @param impostor impostor to set friction on
   * @param friction friction value
   */
  setBodyFriction(e, t) {
    e.soft ? e.physicsBody.get_m_cfg().set_kDF(t) : e.physicsBody.setFriction(t), e._pluginData.friction = t;
  }
  /**
   * Gets restitution of the impostor
   * @param impostor impostor to get restitution from
   * @returns restitution value
   */
  getBodyRestitution(e) {
    return e._pluginData.restitution || 0;
  }
  /**
   * Sets restitution of the impostor
   * @param impostor impostor to set resitution on
   * @param restitution resitution value
   */
  setBodyRestitution(e, t) {
    e.physicsBody.setRestitution(t), e._pluginData.restitution = t;
  }
  /**
   * Gets pressure inside the impostor
   * @param impostor impostor to get pressure from
   * @returns pressure value
   */
  getBodyPressure(e) {
    return e.soft ? e._pluginData.pressure || 0 : (w.Warn("Pressure is not a property of a rigid body"), 0);
  }
  /**
   * Sets pressure inside a soft body impostor
   * Cloth and rope must remain 0 pressure
   * @param impostor impostor to set pressure on
   * @param pressure pressure value
   */
  setBodyPressure(e, t) {
    e.soft ? e.type === re.SoftbodyImpostor ? (e.physicsBody.get_m_cfg().set_kPR(t), e._pluginData.pressure = t) : (e.physicsBody.get_m_cfg().set_kPR(0), e._pluginData.pressure = 0) : w.Warn("Pressure can only be applied to a softbody");
  }
  /**
   * Gets stiffness of the impostor
   * @param impostor impostor to get stiffness from
   * @returns pressure value
   */
  getBodyStiffness(e) {
    return e.soft ? e._pluginData.stiffness || 0 : (w.Warn("Stiffness is not a property of a rigid body"), 0);
  }
  /**
   * Sets stiffness of the impostor
   * @param impostor impostor to set stiffness on
   * @param stiffness stiffness value from 0 to 1
   */
  setBodyStiffness(e, t) {
    e.soft ? (t = t < 0 ? 0 : t, t = t > 1 ? 1 : t, e.physicsBody.get_m_materials().at(0).set_m_kLST(t), e._pluginData.stiffness = t) : w.Warn("Stiffness cannot be applied to a rigid body");
  }
  /**
   * Gets velocityIterations of the impostor
   * @param impostor impostor to get velocity iterations from
   * @returns velocityIterations value
   */
  getBodyVelocityIterations(e) {
    return e.soft ? e._pluginData.velocityIterations || 0 : (w.Warn("Velocity iterations is not a property of a rigid body"), 0);
  }
  /**
   * Sets velocityIterations of the impostor
   * @param impostor impostor to set velocity iterations on
   * @param velocityIterations velocityIterations value
   */
  setBodyVelocityIterations(e, t) {
    e.soft ? (t = t < 0 ? 0 : t, e.physicsBody.get_m_cfg().set_viterations(t), e._pluginData.velocityIterations = t) : w.Warn("Velocity iterations cannot be applied to a rigid body");
  }
  /**
   * Gets positionIterations of the impostor
   * @param impostor impostor to get position iterations from
   * @returns positionIterations value
   */
  getBodyPositionIterations(e) {
    return e.soft ? e._pluginData.positionIterations || 0 : (w.Warn("Position iterations is not a property of a rigid body"), 0);
  }
  /**
   * Sets positionIterations of the impostor
   * @param impostor impostor to set position on
   * @param positionIterations positionIterations value
   */
  setBodyPositionIterations(e, t) {
    e.soft ? (t = t < 0 ? 0 : t, e.physicsBody.get_m_cfg().set_piterations(t), e._pluginData.positionIterations = t) : w.Warn("Position iterations cannot be applied to a rigid body");
  }
  /**
   * Append an anchor to a cloth object
   * @param impostor is the cloth impostor to add anchor to
   * @param otherImpostor is the rigid impostor to anchor to
   * @param width ratio across width from 0 to 1
   * @param height ratio up height from 0 to 1
   * @param influence the elasticity between cloth impostor and anchor from 0, very stretchy to 1, little stretch
   * @param noCollisionBetweenLinkedBodies when true collisions between soft impostor and anchor are ignored; default false
   */
  appendAnchor(e, t, i, s, r = 1, n = !1) {
    const a = e.segments, o = Math.round((a - 1) * i), l = Math.round((a - 1) * s), c = a - 1 - l, u = o + a * c;
    e.physicsBody.appendAnchor(u, t.physicsBody, n, r);
  }
  /**
   * Append an hook to a rope object
   * @param impostor is the rope impostor to add hook to
   * @param otherImpostor is the rigid impostor to hook to
   * @param length ratio along the rope from 0 to 1
   * @param influence the elasticity between soft impostor and anchor from 0, very stretchy to 1, little stretch
   * @param noCollisionBetweenLinkedBodies when true collisions between soft impostor and anchor are ignored; default false
   */
  appendHook(e, t, i, s = 1, r = !1) {
    const n = Math.round(e.segments * i);
    e.physicsBody.appendAnchor(n, t.physicsBody, r, s);
  }
  /**
   * Sleeps the physics body and stops it from being active
   * @param impostor impostor to sleep
   */
  sleepBody(e) {
    e.physicsBody.forceActivationState(0);
  }
  /**
   * Activates the physics body
   * @param impostor impostor to activate
   */
  wakeUpBody(e) {
    e.physicsBody.activate();
  }
  /**
   * Updates the distance parameters of the joint
   */
  updateDistanceJoint() {
    w.Warn("updateDistanceJoint is not currently supported by the Ammo physics plugin");
  }
  /**
   * Sets a motor on the joint
   * @param joint joint to set motor on
   * @param speed speed of the motor
   * @param maxForce maximum force of the motor
   */
  setMotor(e, t, i) {
    e.physicsJoint.enableAngularMotor(!0, t, i);
  }
  /**
   * Sets the motors limit
   */
  setLimit() {
    w.Warn("setLimit is not currently supported by the Ammo physics plugin");
  }
  /**
   * Syncs the position and rotation of a mesh with the impostor
   * @param mesh mesh to sync
   * @param impostor impostor to update the mesh with
   */
  syncMeshWithImpostor(e, t) {
    t.physicsBody.getMotionState().getWorldTransform(this._tmpAmmoTransform), e.position.x = this._tmpAmmoTransform.getOrigin().x(), e.position.y = this._tmpAmmoTransform.getOrigin().y(), e.position.z = this._tmpAmmoTransform.getOrigin().z(), e.rotationQuaternion && (e.rotationQuaternion.x = this._tmpAmmoTransform.getRotation().x(), e.rotationQuaternion.y = this._tmpAmmoTransform.getRotation().y(), e.rotationQuaternion.z = this._tmpAmmoTransform.getRotation().z(), e.rotationQuaternion.w = this._tmpAmmoTransform.getRotation().w());
  }
  /**
   * Gets the radius of the impostor
   * @param impostor impostor to get radius from
   * @returns the radius
   */
  getRadius(e) {
    return e.getObjectExtents().x / 2;
  }
  /**
   * Gets the box size of the impostor
   * @param impostor impostor to get box size from
   * @param result the resulting box size
   */
  getBoxSizeToRef(e, t) {
    const i = e.getObjectExtents();
    t.x = i.x, t.y = i.y, t.z = i.z;
  }
  /**
   * Disposes of the impostor
   */
  dispose() {
    this.bjsAMMO.destroy(this.world), this.bjsAMMO.destroy(this._solver), this.bjsAMMO.destroy(this._overlappingPairCache), this.bjsAMMO.destroy(this._dispatcher), this.bjsAMMO.destroy(this._collisionConfiguration), this.bjsAMMO.destroy(this._tmpAmmoVectorA), this.bjsAMMO.destroy(this._tmpAmmoVectorB), this.bjsAMMO.destroy(this._tmpAmmoVectorC), this.bjsAMMO.destroy(this._tmpAmmoTransform), this.bjsAMMO.destroy(this._tmpAmmoQuaternion), this.bjsAMMO.destroy(this._tmpAmmoConcreteContactResultCallback), this.world = null;
  }
  /**
   * Does a raycast in the physics world
   * @param from where should the ray start?
   * @param to where should the ray end?
   * @returns PhysicsRaycastResult
   */
  raycast(e, t) {
    return this.raycastToRef(e, t, this._raycastResult), this._raycastResult;
  }
  /**
   * Does a raycast in the physics world
   * @param from when should the ray start?
   * @param to when should the ray end?
   * @param result resulting PhysicsRaycastResult
   */
  raycastToRef(e, t, i) {
    this._tmpAmmoVectorRCA = new this.bjsAMMO.btVector3(e.x, e.y, e.z), this._tmpAmmoVectorRCB = new this.bjsAMMO.btVector3(t.x, t.y, t.z);
    const s = new this.bjsAMMO.ClosestRayResultCallback(this._tmpAmmoVectorRCA, this._tmpAmmoVectorRCB);
    this.world.rayTest(this._tmpAmmoVectorRCA, this._tmpAmmoVectorRCB, s), i.reset(e, t), s.hasHit() && (i.setHitData({
      x: s.get_m_hitNormalWorld().x(),
      y: s.get_m_hitNormalWorld().y(),
      z: s.get_m_hitNormalWorld().z()
    }, {
      x: s.get_m_hitPointWorld().x(),
      y: s.get_m_hitPointWorld().y(),
      z: s.get_m_hitPointWorld().z()
    }), i.calculateHitDistance()), this.bjsAMMO.destroy(s), this.bjsAMMO.destroy(this._tmpAmmoVectorRCA), this.bjsAMMO.destroy(this._tmpAmmoVectorRCB);
  }
}
di._DISABLE_COLLISION_FLAG = 4;
di._KINEMATIC_FLAG = 2;
di._DISABLE_DEACTIVATION_FLAG = 4;
Pi.prototype.removeReflectionProbe = function(h) {
  if (!this.reflectionProbes)
    return -1;
  const e = this.reflectionProbes.indexOf(h);
  return e !== -1 && this.reflectionProbes.splice(e, 1), e;
};
Pi.prototype.addReflectionProbe = function(h) {
  this.reflectionProbes || (this.reflectionProbes = []), this.reflectionProbes.push(h);
};
class $s {
  /**
   * Creates a new reflection probe
   * @param name defines the name of the probe
   * @param size defines the texture resolution (for each face)
   * @param scene defines the hosting scene
   * @param generateMipMaps defines if mip maps should be generated automatically (true by default)
   * @param useFloat defines if HDR data (float data) should be used to store colors (false by default)
   * @param linearSpace defines if the probe should be generated in linear space or not (false by default)
   */
  constructor(e, t, i, s = !0, r = !1, n = !1) {
    if (this.name = e, this._viewMatrix = I.Identity(), this._target = p.Zero(), this._add = p.Zero(), this._invertYAxis = !1, this.position = p.Zero(), this.metadata = null, this._parentContainer = null, this._scene = i, i.getEngine().supportsUniformBuffers) {
      this._sceneUBOs = [];
      for (let c = 0; c < 6; ++c)
        this._sceneUBOs.push(i.createSceneUniformBuffer(`Scene for Reflection Probe (name "${e}") face #${c}`));
    }
    this._scene.reflectionProbes || (this._scene.reflectionProbes = new Array()), this._scene.reflectionProbes.push(this);
    let a = 0;
    if (r) {
      const c = this._scene.getEngine().getCaps();
      c.textureHalfFloatRender ? a = 2 : c.textureFloatRender && (a = 1);
    }
    this._renderTargetTexture = new Mi(e, t, i, s, !0, a, !0), this._renderTargetTexture.gammaSpace = !n, this._renderTargetTexture.invertZ = i.useRightHandedSystem;
    const o = i.getEngine().useReverseDepthBuffer;
    this._renderTargetTexture.onBeforeRenderObservable.add((c) => {
      switch (this._sceneUBOs && (i.setSceneUniformBuffer(this._sceneUBOs[c]), i.getSceneUniformBuffer().unbindEffect()), c) {
        case 0:
          this._add.copyFromFloats(1, 0, 0);
          break;
        case 1:
          this._add.copyFromFloats(-1, 0, 0);
          break;
        case 2:
          this._add.copyFromFloats(0, this._invertYAxis ? 1 : -1, 0);
          break;
        case 3:
          this._add.copyFromFloats(0, this._invertYAxis ? -1 : 1, 0);
          break;
        case 4:
          this._add.copyFromFloats(0, 0, i.useRightHandedSystem ? -1 : 1);
          break;
        case 5:
          this._add.copyFromFloats(0, 0, i.useRightHandedSystem ? 1 : -1);
          break;
      }
      this._attachedMesh && this.position.copyFrom(this._attachedMesh.getAbsolutePosition()), this.position.addToRef(this._add, this._target);
      const u = i.useRightHandedSystem ? I.LookAtRHToRef : I.LookAtLHToRef, d = i.useRightHandedSystem ? I.PerspectiveFovRH : I.PerspectiveFovLH;
      u(this.position, this._target, p.Up(), this._viewMatrix), i.activeCamera && (this._projectionMatrix = d(Math.PI / 2, 1, o ? i.activeCamera.maxZ : i.activeCamera.minZ, o ? i.activeCamera.minZ : i.activeCamera.maxZ, this._scene.getEngine().isNDCHalfZRange), i.setTransformMatrix(this._viewMatrix, this._projectionMatrix), i.activeCamera.isRigCamera && !this._renderTargetTexture.activeCamera && (this._renderTargetTexture.activeCamera = i.activeCamera.rigParent || null)), i._forcedViewPosition = this.position;
    });
    let l;
    this._renderTargetTexture.onBeforeBindObservable.add(() => {
      var c, u;
      this._currentSceneUBO = i.getSceneUniformBuffer(), (u = (c = i.getEngine())._debugPushGroup) === null || u === void 0 || u.call(c, `reflection probe generation for ${e}`, 1), l = this._scene.imageProcessingConfiguration.applyByPostProcess, n && (i.imageProcessingConfiguration.applyByPostProcess = !0);
    }), this._renderTargetTexture.onAfterUnbindObservable.add(() => {
      var c, u;
      i.imageProcessingConfiguration.applyByPostProcess = l, i._forcedViewPosition = null, this._sceneUBOs && i.setSceneUniformBuffer(this._currentSceneUBO), i.updateTransformMatrix(!0), (u = (c = i.getEngine())._debugPopGroup) === null || u === void 0 || u.call(c, 1);
    });
  }
  /** Gets or sets the number of samples to use for multi-sampling (0 by default). Required WebGL2 */
  get samples() {
    return this._renderTargetTexture.samples;
  }
  set samples(e) {
    this._renderTargetTexture.samples = e;
  }
  /** Gets or sets the refresh rate to use (on every frame by default) */
  get refreshRate() {
    return this._renderTargetTexture.refreshRate;
  }
  set refreshRate(e) {
    this._renderTargetTexture.refreshRate = e;
  }
  /**
   * Gets the hosting scene
   * @returns a Scene
   */
  getScene() {
    return this._scene;
  }
  /** Gets the internal CubeTexture used to render to */
  get cubeTexture() {
    return this._renderTargetTexture;
  }
  /** Gets the list of meshes to render */
  get renderList() {
    return this._renderTargetTexture.renderList;
  }
  /**
   * Attach the probe to a specific mesh (Rendering will be done from attached mesh's position)
   * @param mesh defines the mesh to attach to
   */
  attachToMesh(e) {
    this._attachedMesh = e;
  }
  /**
   * Specifies whether or not the stencil and depth buffer are cleared between two rendering groups
   * @param renderingGroupId The rendering group id corresponding to its index
   * @param autoClearDepthStencil Automatically clears depth and stencil between groups if true.
   */
  setRenderingAutoClearDepthStencil(e, t) {
    this._renderTargetTexture.setRenderingAutoClearDepthStencil(e, t);
  }
  /**
   * Clean all associated resources
   */
  dispose() {
    const e = this._scene.reflectionProbes.indexOf(this);
    if (e !== -1 && this._scene.reflectionProbes.splice(e, 1), this._parentContainer) {
      const t = this._parentContainer.reflectionProbes.indexOf(this);
      t > -1 && this._parentContainer.reflectionProbes.splice(t, 1), this._parentContainer = null;
    }
    if (this._renderTargetTexture && (this._renderTargetTexture.dispose(), this._renderTargetTexture = null), this._sceneUBOs) {
      for (const t of this._sceneUBOs)
        t.dispose();
      this._sceneUBOs = [];
    }
  }
  /**
   * Converts the reflection probe information to a readable string for debug purpose.
   * @param fullDetails Supports for multiple levels of logging within scene loading
   * @returns the human readable reflection probe info
   */
  toString(e) {
    let t = "Name: " + this.name;
    return e && (t += ", position: " + this.position.toString(), this._attachedMesh && (t += ", attached mesh: " + this._attachedMesh.name)), t;
  }
  /**
   * Get the class name of the refection probe.
   * @returns "ReflectionProbe"
   */
  getClassName() {
    return "ReflectionProbe";
  }
  /**
   * Serialize the reflection probe to a JSON representation we can easily use in the respective Parse function.
   * @returns The JSON representation of the texture
   */
  serialize() {
    const e = le.Serialize(this, this._renderTargetTexture.serialize());
    return e.isReflectionProbe = !0, e.metadata = this.metadata, e;
  }
  /**
   * Parse the JSON representation of a reflection probe in order to recreate the reflection probe in the given scene.
   * @param parsedReflectionProbe Define the JSON representation of the reflection probe
   * @param scene Define the scene the parsed reflection probe should be instantiated in
   * @param rootUrl Define the root url of the parsing sequence in the case of relative dependencies
   * @returns The parsed reflection probe if successful
   */
  static Parse(e, t, i) {
    let s = null;
    if (t.reflectionProbes)
      for (let r = 0; r < t.reflectionProbes.length; r++) {
        const n = t.reflectionProbes[r];
        if (n.name === e.name) {
          s = n;
          break;
        }
      }
    return s = le.Parse(() => s || new $s(e.name, e.renderTargetSize, t, e._generateMipMaps), e, t, i), s.cubeTexture._waitingRenderList = e.renderList, e._attachedMesh && s.attachToMesh(t.getMeshById(e._attachedMesh)), e.metadata && (s.metadata = e.metadata), s;
  }
}
E([
  Sn()
], $s.prototype, "_attachedMesh", void 0);
E([
  wt()
], $s.prototype, "position", void 0);
class pr {
}
pr.LoaderInjectedPhysicsEngine = void 0;
let rs = {}, Ni = {};
const ca = (h, e, t, i) => {
  if (!e.materials)
    return null;
  for (let s = 0, r = e.materials.length; s < r; s++) {
    const n = e.materials[s];
    if (h(n))
      return { parsedMaterial: n, material: F.Parse(n, t, i) };
  }
  return null;
}, ac = (h, e, t) => {
  for (const i in e)
    if (h.name === e[i])
      return t.push(h.id), !0;
  return h.parentId !== void 0 && t.indexOf(h.parentId) !== -1 ? (t.push(h.id), !0) : !1;
}, as = (h, e) => h + " of " + (e ? e.file + " from " + e.name + " version: " + e.version + ", exporter version: " + e.exporter_version : "unknown"), uo = (h, e) => {
  const t = e;
  if (e._waitingData.lods) {
    if (e._waitingData.lods.ids && e._waitingData.lods.ids.length > 0) {
      const i = e._waitingData.lods.ids, s = t.isEnabled(!1);
      if (e._waitingData.lods.distances) {
        const r = e._waitingData.lods.distances;
        if (r.length >= i.length) {
          const n = r.length > i.length ? r[r.length - 1] : 0;
          t.setEnabled(!1);
          for (let a = 0; a < i.length; a++) {
            const o = i[a], l = h.getMeshById(o);
            l != null && t.addLODLevel(r[a], l);
          }
          n > 0 && t.addLODLevel(n, null), s === !0 && t.setEnabled(!0);
        } else
          z.Warn("Invalid level of detail distances for " + e.name);
      }
    }
    e._waitingData.lods = null;
  }
}, or = (h, e, t) => {
  if (typeof h != "number") {
    const s = t.getLastEntryById(h);
    return s && e !== void 0 && e !== null ? s.instances[parseInt(e)] : s;
  }
  const i = rs[h];
  return i && e !== void 0 && e !== null ? i.instances[parseInt(e)] : i;
}, Sr = (h, e) => typeof h != "number" ? e.getLastMaterialById(h, !0) : Ni[h], ua = (h, e, t, i, s = !1) => {
  const r = new vh(h);
  let n = "importScene has failed JSON parse";
  try {
    var a = JSON.parse(e);
    n = "";
    const o = fe.loggingLevel === fe.DETAILED_LOGGING;
    let l, c;
    if (a.environmentTexture !== void 0 && a.environmentTexture !== null) {
      const d = a.isPBR !== void 0 ? a.isPBR : !0;
      if (a.environmentTextureType && a.environmentTextureType === "BABYLON.HDRCubeTexture") {
        const f = a.environmentTextureSize ? a.environmentTextureSize : 128, _ = new ji((a.environmentTexture.match(/https?:\/\//g) ? "" : t) + a.environmentTexture, h, f, !0, !d, void 0, a.environmentTexturePrefilterOnLoad);
        a.environmentTextureRotationY && (_.rotationY = a.environmentTextureRotationY), h.environmentTexture = _;
      } else if (typeof a.environmentTexture == "object") {
        const f = vt.Parse(a.environmentTexture, h, t);
        h.environmentTexture = f;
      } else if (a.environmentTexture.endsWith(".env")) {
        const f = new vt((a.environmentTexture.match(/https?:\/\//g) ? "" : t) + a.environmentTexture, h, a.environmentTextureForcedExtension);
        a.environmentTextureRotationY && (f.rotationY = a.environmentTextureRotationY), h.environmentTexture = f;
      } else {
        const f = vt.CreateFromPrefilteredData((a.environmentTexture.match(/https?:\/\//g) ? "" : t) + a.environmentTexture, h, a.environmentTextureForcedExtension);
        a.environmentTextureRotationY && (f.rotationY = a.environmentTextureRotationY), h.environmentTexture = f;
      }
      if (a.createDefaultSkybox === !0) {
        const f = h.activeCamera !== void 0 && h.activeCamera !== null ? (h.activeCamera.maxZ - h.activeCamera.minZ) / 2 : 1e3, _ = a.skyboxBlurLevel || 0;
        h.createDefaultSkybox(h.environmentTexture, d, f, _);
      }
      r.environmentTexture = h.environmentTexture;
    }
    if (a.environmentIntensity !== void 0 && a.environmentIntensity !== null && (h.environmentIntensity = a.environmentIntensity), a.lights !== void 0 && a.lights !== null)
      for (l = 0, c = a.lights.length; l < c; l++) {
        const d = a.lights[l], f = me.Parse(d, h);
        f && (rs[d.uniqueId] = f, r.lights.push(f), f._parentContainer = r, n += l === 0 ? `
	Lights:` : "", n += `
		` + f.toString(o));
      }
    if (a.reflectionProbes !== void 0 && a.reflectionProbes !== null)
      for (l = 0, c = a.reflectionProbes.length; l < c; l++) {
        const d = a.reflectionProbes[l], f = $s.Parse(d, h, t);
        f && (r.reflectionProbes.push(f), f._parentContainer = r, n += l === 0 ? `
	Reflection Probes:` : "", n += `
		` + f.toString(o));
      }
    if (a.animations !== void 0 && a.animations !== null)
      for (l = 0, c = a.animations.length; l < c; l++) {
        const d = a.animations[l], f = si("BABYLON.Animation");
        if (f) {
          const _ = f.Parse(d);
          h.animations.push(_), r.animations.push(_), n += l === 0 ? `
	Animations:` : "", n += `
		` + _.toString(o);
        }
      }
    if (a.materials !== void 0 && a.materials !== null)
      for (l = 0, c = a.materials.length; l < c; l++) {
        const d = a.materials[l], f = F.Parse(d, h, t);
        f && (Ni[d.uniqueId || d.id] = f, r.materials.push(f), f._parentContainer = r, n += l === 0 ? `
	Materials:` : "", n += `
		` + f.toString(o), f.getActiveTextures().forEach((g) => {
          r.textures.indexOf(g) == -1 && (r.textures.push(g), g._parentContainer = r);
        }));
      }
    if (a.multiMaterials !== void 0 && a.multiMaterials !== null)
      for (l = 0, c = a.multiMaterials.length; l < c; l++) {
        const d = a.multiMaterials[l], f = Vi.ParseMultiMaterial(d, h);
        Ni[d.uniqueId || d.id] = f, r.multiMaterials.push(f), f._parentContainer = r, n += l === 0 ? `
	MultiMaterials:` : "", n += `
		` + f.toString(o), f.getActiveTextures().forEach((g) => {
          r.textures.indexOf(g) == -1 && (r.textures.push(g), g._parentContainer = r);
        });
      }
    if (a.morphTargetManagers !== void 0 && a.morphTargetManagers !== null)
      for (const d of a.morphTargetManagers) {
        const f = bi.Parse(d, h);
        r.morphTargetManagers.push(f), f._parentContainer = r;
      }
    if (a.skeletons !== void 0 && a.skeletons !== null)
      for (l = 0, c = a.skeletons.length; l < c; l++) {
        const d = a.skeletons[l], f = Ws.Parse(d, h);
        r.skeletons.push(f), f._parentContainer = r, n += l === 0 ? `
	Skeletons:` : "", n += `
		` + f.toString(o);
      }
    const u = a.geometries;
    if (u != null) {
      const d = new Array(), f = u.vertexData;
      if (f != null)
        for (l = 0, c = f.length; l < c; l++) {
          const _ = f[l];
          d.push(Ct.Parse(_, h, t));
        }
      d.forEach((_) => {
        _ && (r.geometries.push(_), _._parentContainer = r);
      });
    }
    if (a.transformNodes !== void 0 && a.transformNodes !== null)
      for (l = 0, c = a.transformNodes.length; l < c; l++) {
        const d = a.transformNodes[l], f = oe.Parse(d, h, t);
        rs[d.uniqueId] = f, r.transformNodes.push(f), f._parentContainer = r;
      }
    if (a.meshes !== void 0 && a.meshes !== null)
      for (l = 0, c = a.meshes.length; l < c; l++) {
        const d = a.meshes[l], f = K.Parse(d, h, t);
        if (rs[d.uniqueId] = f, r.meshes.push(f), f._parentContainer = r, f.hasInstances)
          for (const _ of f.instances)
            r.meshes.push(_), _._parentContainer = r;
        n += l === 0 ? `
	Meshes:` : "", n += `
		` + f.toString(o);
      }
    if (a.cameras !== void 0 && a.cameras !== null)
      for (l = 0, c = a.cameras.length; l < c; l++) {
        const d = a.cameras[l], f = Q.Parse(d, h);
        rs[d.uniqueId] = f, r.cameras.push(f), f._parentContainer = r, n += l === 0 ? `
	Cameras:` : "", n += `
		` + f.toString(o);
      }
    if (a.postProcesses !== void 0 && a.postProcesses !== null)
      for (l = 0, c = a.postProcesses.length; l < c; l++) {
        const d = a.postProcesses[l], f = qe.Parse(d, h, t);
        f && (r.postProcesses.push(f), f._parentContainer = r, n += l === 0 ? `
Postprocesses:` : "", n += `
		` + f.toString());
      }
    if (a.animationGroups !== void 0 && a.animationGroups !== null)
      for (l = 0, c = a.animationGroups.length; l < c; l++) {
        const d = a.animationGroups[l], f = Ds.Parse(d, h);
        r.animationGroups.push(f), f._parentContainer = r, n += l === 0 ? `
	AnimationGroups:` : "", n += `
		` + f.toString(o);
      }
    for (l = 0, c = h.cameras.length; l < c; l++) {
      const d = h.cameras[l];
      d._waitingParentId !== null && (d.parent = or(d._waitingParentId, d._waitingParentInstanceIndex, h), d._waitingParentId = null, d._waitingParentInstanceIndex = null);
    }
    for (l = 0, c = h.lights.length; l < c; l++) {
      const d = h.lights[l];
      d && d._waitingParentId !== null && (d.parent = or(d._waitingParentId, d._waitingParentInstanceIndex, h), d._waitingParentId = null, d._waitingParentInstanceIndex = null);
    }
    for (l = 0, c = h.transformNodes.length; l < c; l++) {
      const d = h.transformNodes[l];
      d._waitingParentId !== null && (d.parent = or(d._waitingParentId, d._waitingParentInstanceIndex, h), d._waitingParentId = null, d._waitingParentInstanceIndex = null);
    }
    for (l = 0, c = h.meshes.length; l < c; l++) {
      const d = h.meshes[l];
      d._waitingParentId !== null && (d.parent = or(d._waitingParentId, d._waitingParentInstanceIndex, h), d._waitingParentId = null, d._waitingParentInstanceIndex = null), d._waitingData.lods && uo(h, d);
    }
    for (h.multiMaterials.forEach((d) => {
      d._waitingSubMaterialsUniqueIds.forEach((f) => {
        d.subMaterials.push(Sr(f, h));
      }), d._waitingSubMaterialsUniqueIds = [];
    }), h.meshes.forEach((d) => {
      d._waitingMaterialId !== null && (d.material = Sr(d._waitingMaterialId, h), d._waitingMaterialId = null);
    }), l = 0, c = h.skeletons.length; l < c; l++) {
      const d = h.skeletons[l];
      d._hasWaitingData && (d.bones != null && d.bones.forEach((f) => {
        if (f._waitingTransformNodeId) {
          const _ = h.getLastEntryById(f._waitingTransformNodeId);
          _ && f.linkTransformNode(_), f._waitingTransformNodeId = null;
        }
      }), d._hasWaitingData = null);
    }
    for (l = 0, c = h.meshes.length; l < c; l++) {
      const d = h.meshes[l];
      d._waitingData.freezeWorldMatrix ? (d.freezeWorldMatrix(), d._waitingData.freezeWorldMatrix = null) : d.computeWorldMatrix(!0);
    }
    for (l = 0, c = h.lights.length; l < c; l++) {
      const d = h.lights[l];
      if (d._excludedMeshesIds.length > 0) {
        for (let f = 0; f < d._excludedMeshesIds.length; f++) {
          const _ = h.getMeshById(d._excludedMeshesIds[f]);
          _ && d.excludedMeshes.push(_);
        }
        d._excludedMeshesIds = [];
      }
      if (d._includedOnlyMeshesIds.length > 0) {
        for (let f = 0; f < d._includedOnlyMeshesIds.length; f++) {
          const _ = h.getMeshById(d._includedOnlyMeshesIds[f]);
          _ && d.includedOnlyMeshes.push(_);
        }
        d._includedOnlyMeshesIds = [];
      }
    }
    for (h.geometries.forEach((d) => {
      d._loadedUniqueId = "";
    }), Pi.Parse(a, h, r, t), l = 0, c = h.meshes.length; l < c; l++) {
      const d = h.meshes[l];
      d._waitingData.actions && (Ce.Parse(d._waitingData.actions, d, h), d._waitingData.actions = null);
    }
    a.actions !== void 0 && a.actions !== null && Ce.Parse(a.actions, null, h);
  } catch (o) {
    const l = as("loadAssets", a ? a.producer : "Unknown") + n;
    if (i)
      i(l, o);
    else
      throw w.Log(l), o;
  } finally {
    rs = {}, Ni = {}, s || r.removeAllFromScene(), n !== null && fe.loggingLevel !== fe.NO_LOGGING && w.Log(as("loadAssets", a ? a.producer : "Unknown") + (fe.loggingLevel !== fe.MINIMAL_LOGGING ? n : ""));
  }
  return r;
};
fe.RegisterPlugin({
  name: "babylon.js",
  extensions: ".babylon",
  canDirectLoad: (h) => h.indexOf("babylon") !== -1,
  importMesh: (h, e, t, i, s, r, n, a) => {
    var o;
    let l = "importMesh has failed JSON parse";
    try {
      var c = JSON.parse(t);
      l = "";
      const u = fe.loggingLevel === fe.DETAILED_LOGGING;
      h ? Array.isArray(h) || (h = [h]) : h = null;
      const d = new Array(), f = /* @__PURE__ */ new Map(), _ = [];
      if (c.transformNodes !== void 0 && c.transformNodes !== null)
        for (let g = 0, m = c.transformNodes.length; g < m; g++) {
          const y = c.transformNodes[g], x = oe.Parse(y, e, i);
          _.push(x), f.set(x._waitingParsedUniqueId, x), x._waitingParsedUniqueId = null;
        }
      if (c.meshes !== void 0 && c.meshes !== null) {
        const g = [], m = [], y = [], x = [];
        for (let T = 0, M = c.meshes.length; T < M; T++) {
          const b = c.meshes[T];
          if (h === null || ac(b, h, d)) {
            if (h !== null && delete h[h.indexOf(b.name)], b.geometryId !== void 0 && b.geometryId !== null && c.geometries !== void 0 && c.geometries !== null) {
              let P = !1;
              ["boxes", "spheres", "cylinders", "toruses", "grounds", "planes", "torusKnots", "vertexData"].forEach((D) => {
                P === !0 || !c.geometries[D] || !Array.isArray(c.geometries[D]) || c.geometries[D].forEach((O) => {
                  if (O.id === b.geometryId) {
                    switch (D) {
                      case "vertexData":
                        Ct.Parse(O, e, i);
                        break;
                    }
                    P = !0;
                  }
                });
              }), P === !1 && w.Warn("Geometry not found for mesh " + b.id);
            }
            if (b.materialUniqueId || b.materialId) {
              const P = b.materialUniqueId ? y : m;
              let D = P.indexOf(b.materialUniqueId || b.materialId) !== -1;
              if (D === !1 && c.multiMaterials !== void 0 && c.multiMaterials !== null) {
                const O = (X, k) => {
                  P.push(X);
                  const Y = ca(k, c, e, i);
                  Y && Y.material && (Ni[Y.parsedMaterial.uniqueId || Y.parsedMaterial.id] = Y.material, l += `
	Material ` + Y.material.toString(u));
                };
                for (let X = 0, k = c.multiMaterials.length; X < k; X++) {
                  const Y = c.multiMaterials[X];
                  if (b.materialUniqueId && Y.uniqueId === b.materialUniqueId || Y.id === b.materialId) {
                    Y.materialsUniqueIds ? Y.materialsUniqueIds.forEach((Te) => O(Te, (ve) => ve.uniqueId === Te)) : Y.materials.forEach((Te) => O(Te, (ve) => ve.id === Te)), P.push(Y.uniqueId || Y.id);
                    const se = Vi.ParseMultiMaterial(Y, e);
                    Ni[Y.uniqueId || Y.id] = se, se && (D = !0, l += `
	Multi-Material ` + se.toString(u));
                    break;
                  }
                }
              }
              if (D === !1) {
                P.push(b.materialUniqueId || b.materialId);
                const O = ca((X) => b.materialUniqueId && X.uniqueId === b.materialUniqueId || X.id === b.materialId, c, e, i);
                !O || !O.material ? w.Warn("Material not found for mesh " + b.id) : (Ni[O.parsedMaterial.uniqueId || O.parsedMaterial.id] = O.material, l += `
	Material ` + O.material.toString(u));
              }
            }
            if (b.skeletonId !== null && b.skeletonId !== void 0 && c.skeletonId !== -1 && c.skeletons !== void 0 && c.skeletons !== null && !(g.indexOf(b.skeletonId) > -1))
              for (let D = 0, O = c.skeletons.length; D < O; D++) {
                const X = c.skeletons[D];
                if (X.id === b.skeletonId) {
                  const k = Ws.Parse(X, e);
                  n.push(k), g.push(X.id), l += `
	Skeleton ` + k.toString(u);
                }
              }
            if (b.morphTargetManagerId > -1 && c.morphTargetManagers !== void 0 && c.morphTargetManagers !== null && !(x.indexOf(b.morphTargetManagerId) > -1))
              for (let D = 0, O = c.morphTargetManagers.length; D < O; D++) {
                const X = c.morphTargetManagers[D];
                if (X.id === b.morphTargetManagerId) {
                  const k = bi.Parse(X, e);
                  x.push(k.uniqueId), l += `
Morph target ` + k.toString();
                }
              }
            const S = K.Parse(b, e, i);
            s.push(S), f.set(S._waitingParsedUniqueId, S), S._waitingParsedUniqueId = null, l += `
	Mesh ` + S.toString(u);
          }
        }
        e.multiMaterials.forEach((T) => {
          T._waitingSubMaterialsUniqueIds.forEach((M) => {
            T.subMaterials.push(Sr(M, e));
          }), T._waitingSubMaterialsUniqueIds = [];
        }), e.meshes.forEach((T) => {
          T._waitingMaterialId !== null && (T.material = Sr(T._waitingMaterialId, e), T._waitingMaterialId = null);
        });
        for (let T = 0, M = e.transformNodes.length; T < M; T++) {
          const b = e.transformNodes[T];
          if (b._waitingParentId !== null) {
            let S = f.get(parseInt(b._waitingParentId)) || null;
            S === null && (S = e.getLastEntryById(b._waitingParentId));
            let P = S;
            b._waitingParentInstanceIndex && (P = S.instances[parseInt(b._waitingParentInstanceIndex)], b._waitingParentInstanceIndex = null), b.parent = P, b._waitingParentId = null;
          }
        }
        let A;
        for (let T = 0, M = e.meshes.length; T < M; T++) {
          if (A = e.meshes[T], A._waitingParentId) {
            let b = f.get(parseInt(A._waitingParentId)) || null;
            b === null && (b = e.getLastEntryById(A._waitingParentId));
            let S = b;
            if (A._waitingParentInstanceIndex && (S = b.instances[parseInt(A._waitingParentInstanceIndex)], A._waitingParentInstanceIndex = null), A.parent = S, ((o = A.parent) === null || o === void 0 ? void 0 : o.getClassName()) === "TransformNode") {
              const P = _.indexOf(A.parent);
              P > -1 && _.splice(P, 1);
            }
            A._waitingParentId = null;
          }
          A._waitingData.lods && uo(e, A);
        }
        for (const T of _)
          T.dispose();
        for (let T = 0, M = e.skeletons.length; T < M; T++) {
          const b = e.skeletons[T];
          b._hasWaitingData && (b.bones != null && b.bones.forEach((S) => {
            if (S._waitingTransformNodeId) {
              const P = e.getLastEntryById(S._waitingTransformNodeId);
              P && S.linkTransformNode(P), S._waitingTransformNodeId = null;
            }
          }), b._hasWaitingData = null);
        }
        for (let T = 0, M = e.meshes.length; T < M; T++)
          A = e.meshes[T], A._waitingData.freezeWorldMatrix ? (A.freezeWorldMatrix(), A._waitingData.freezeWorldMatrix = null) : A.computeWorldMatrix(!0);
      }
      if (c.particleSystems !== void 0 && c.particleSystems !== null) {
        const g = Pi.GetIndividualParser(ne.NAME_PARTICLESYSTEM);
        if (g)
          for (let m = 0, y = c.particleSystems.length; m < y; m++) {
            const x = c.particleSystems[m];
            d.indexOf(x.emitterId) !== -1 && r.push(g(x, e, i));
          }
      }
      return e.geometries.forEach((g) => {
        g._loadedUniqueId = "";
      }), !0;
    } catch (u) {
      const d = as("importMesh", c ? c.producer : "Unknown") + l;
      if (a)
        a(d, u);
      else
        throw w.Log(d), u;
    } finally {
      l !== null && fe.loggingLevel !== fe.NO_LOGGING && w.Log(as("importMesh", c ? c.producer : "Unknown") + (fe.loggingLevel !== fe.MINIMAL_LOGGING ? l : "")), Ni = {};
    }
    return !1;
  },
  load: (h, e, t, i) => {
    let s = "importScene has failed JSON parse";
    try {
      var r = JSON.parse(e);
      if (s = "", r.useDelayedTextureLoading !== void 0 && r.useDelayedTextureLoading !== null && (h.useDelayedTextureLoading = r.useDelayedTextureLoading && !fe.ForceFullSceneLoadingForIncremental), r.autoClear !== void 0 && r.autoClear !== null && (h.autoClear = r.autoClear), r.clearColor !== void 0 && r.clearColor !== null && (h.clearColor = ye.FromArray(r.clearColor)), r.ambientColor !== void 0 && r.ambientColor !== null && (h.ambientColor = ie.FromArray(r.ambientColor)), r.gravity !== void 0 && r.gravity !== null && (h.gravity = p.FromArray(r.gravity)), r.useRightHandedSystem !== void 0 && (h.useRightHandedSystem = !!r.useRightHandedSystem), r.fogMode && r.fogMode !== 0)
        switch (h.fogMode = r.fogMode, h.fogColor = ie.FromArray(r.fogColor), h.fogStart = r.fogStart, h.fogEnd = r.fogEnd, h.fogDensity = r.fogDensity, s += "	Fog mode for scene:  ", h.fogMode) {
          case 1:
            s += `exp
`;
            break;
          case 2:
            s += `exp2
`;
            break;
          case 3:
            s += `linear
`;
            break;
        }
      if (r.physicsEnabled) {
        let a;
        r.physicsEngine === "cannon" || r.physicsEngine === la.name ? a = new la(void 0, void 0, pr.LoaderInjectedPhysicsEngine) : r.physicsEngine === "oimo" || r.physicsEngine === ha.name ? a = new ha(void 0, pr.LoaderInjectedPhysicsEngine) : (r.physicsEngine === "ammo" || r.physicsEngine === di.name) && (a = new di(void 0, pr.LoaderInjectedPhysicsEngine, void 0)), s = "	Physics engine " + (r.physicsEngine ? r.physicsEngine : "oimo") + ` enabled
`;
        const o = r.physicsGravity ? p.FromArray(r.physicsGravity) : null;
        h.enablePhysics(o, a);
      }
      return r.metadata !== void 0 && r.metadata !== null && (h.metadata = r.metadata), r.collisionsEnabled !== void 0 && r.collisionsEnabled !== null && (h.collisionsEnabled = r.collisionsEnabled), ua(h, e, t, i, !0) ? (r.autoAnimate && h.beginAnimation(h, r.autoAnimateFrom, r.autoAnimateTo, r.autoAnimateLoop, r.autoAnimateSpeed || 1), r.activeCameraID !== void 0 && r.activeCameraID !== null && h.setActiveCameraById(r.activeCameraID), !0) : !1;
    } catch (n) {
      const a = as("importScene", r ? r.producer : "Unknown") + s;
      if (i)
        i(a, n);
      else
        throw w.Log(a), n;
    } finally {
      s !== null && fe.loggingLevel !== fe.NO_LOGGING && w.Log(as("importScene", r ? r.producer : "Unknown") + (fe.loggingLevel !== fe.MINIMAL_LOGGING ? s : ""));
    }
    return !1;
  },
  loadAssetContainer: (h, e, t, i) => ua(h, e, t, i)
});
function fo(h) {
  const e = new Array(), t = new Array(), i = new Array(), s = new Array(), r = h.radius || 0.5, n = h.tessellation || 64, a = h.arc && (h.arc <= 0 || h.arc > 1) ? 1 : h.arc || 1, o = h.sideOrientation === 0 ? 0 : h.sideOrientation || q.DEFAULTSIDE;
  e.push(0, 0, 0), s.push(0.5, 0.5);
  const l = Math.PI * 2 * a, c = a === 1 ? l / n : l / (n - 1);
  let u = 0;
  for (let _ = 0; _ < n; _++) {
    const g = Math.cos(u), m = Math.sin(u), y = (g + 1) / 2, x = (1 - m) / 2;
    e.push(r * g, r * m, 0), s.push(y, ct.UseOpenGLOrientationForUV ? 1 - x : x), u += c;
  }
  a === 1 && (e.push(e[3], e[4], e[5]), s.push(s[2], ct.UseOpenGLOrientationForUV ? 1 - s[3] : s[3]));
  const d = e.length / 3;
  for (let _ = 1; _ < d - 1; _++)
    t.push(_ + 1, 0, _);
  q.ComputeNormals(e, t, i), q._ComputeSides(o, e, t, i, s, h.frontUVs, h.backUVs);
  const f = new q();
  return f.indices = t, f.positions = e, f.normals = i, f.uvs = s, f;
}
function Es(h, e = {}, t = null) {
  const i = new K(h, t);
  return e.sideOrientation = K._GetDefaultSideOrientation(e.sideOrientation), i._originalBuilderSideOrientation = e.sideOrientation, fo(e).applyToMesh(i, e.updatable), i;
}
q.CreateDisc = fo;
K.CreateDisc = (h, e, t, i = null, s, r) => Es(h, {
  radius: e,
  tessellation: t,
  sideOrientation: r,
  updatable: s
}, i);
class Ae {
  /**
   * Creates a new ray
   * @param origin origin point
   * @param direction direction
   * @param length length of the ray
   */
  constructor(e, t, i = Number.MAX_VALUE) {
    this.origin = e, this.direction = t, this.length = i;
  }
  // Methods
  /**
   * Clone the current ray
   * @returns a new ray
   */
  clone() {
    return new Ae(this.origin.clone(), this.direction.clone(), this.length);
  }
  /**
   * Checks if the ray intersects a box
   * This does not account for the ray length by design to improve perfs.
   * @param minimum bound of the box
   * @param maximum bound of the box
   * @param intersectionTreshold extra extend to be added to the box in all direction
   * @returns if the box was hit
   */
  intersectsBoxMinMax(e, t, i = 0) {
    const s = Ae._TmpVector3[0].copyFromFloats(e.x - i, e.y - i, e.z - i), r = Ae._TmpVector3[1].copyFromFloats(t.x + i, t.y + i, t.z + i);
    let n = 0, a = Number.MAX_VALUE, o, l, c, u;
    if (Math.abs(this.direction.x) < 1e-7) {
      if (this.origin.x < s.x || this.origin.x > r.x)
        return !1;
    } else if (o = 1 / this.direction.x, l = (s.x - this.origin.x) * o, c = (r.x - this.origin.x) * o, c === -1 / 0 && (c = 1 / 0), l > c && (u = l, l = c, c = u), n = Math.max(l, n), a = Math.min(c, a), n > a)
      return !1;
    if (Math.abs(this.direction.y) < 1e-7) {
      if (this.origin.y < s.y || this.origin.y > r.y)
        return !1;
    } else if (o = 1 / this.direction.y, l = (s.y - this.origin.y) * o, c = (r.y - this.origin.y) * o, c === -1 / 0 && (c = 1 / 0), l > c && (u = l, l = c, c = u), n = Math.max(l, n), a = Math.min(c, a), n > a)
      return !1;
    if (Math.abs(this.direction.z) < 1e-7) {
      if (this.origin.z < s.z || this.origin.z > r.z)
        return !1;
    } else if (o = 1 / this.direction.z, l = (s.z - this.origin.z) * o, c = (r.z - this.origin.z) * o, c === -1 / 0 && (c = 1 / 0), l > c && (u = l, l = c, c = u), n = Math.max(l, n), a = Math.min(c, a), n > a)
      return !1;
    return !0;
  }
  /**
   * Checks if the ray intersects a box
   * This does not account for the ray lenght by design to improve perfs.
   * @param box the bounding box to check
   * @param intersectionTreshold extra extend to be added to the BoundingBox in all direction
   * @returns if the box was hit
   */
  intersectsBox(e, t = 0) {
    return this.intersectsBoxMinMax(e.minimum, e.maximum, t);
  }
  /**
   * If the ray hits a sphere
   * @param sphere the bounding sphere to check
   * @param intersectionTreshold extra extend to be added to the BoundingSphere in all direction
   * @returns true if it hits the sphere
   */
  intersectsSphere(e, t = 0) {
    const i = e.center.x - this.origin.x, s = e.center.y - this.origin.y, r = e.center.z - this.origin.z, n = i * i + s * s + r * r, a = e.radius + t, o = a * a;
    if (n <= o)
      return !0;
    const l = i * this.direction.x + s * this.direction.y + r * this.direction.z;
    return l < 0 ? !1 : n - l * l <= o;
  }
  /**
   * If the ray hits a triange
   * @param vertex0 triangle vertex
   * @param vertex1 triangle vertex
   * @param vertex2 triangle vertex
   * @returns intersection information if hit
   */
  intersectsTriangle(e, t, i) {
    const s = Ae._TmpVector3[0], r = Ae._TmpVector3[1], n = Ae._TmpVector3[2], a = Ae._TmpVector3[3], o = Ae._TmpVector3[4];
    t.subtractToRef(e, s), i.subtractToRef(e, r), p.CrossToRef(this.direction, r, n);
    const l = p.Dot(s, n);
    if (l === 0)
      return null;
    const c = 1 / l;
    this.origin.subtractToRef(e, a);
    const u = p.Dot(a, n) * c;
    if (u < 0 || u > 1)
      return null;
    p.CrossToRef(a, s, o);
    const d = p.Dot(this.direction, o) * c;
    if (d < 0 || u + d > 1)
      return null;
    const f = p.Dot(r, o) * c;
    return f > this.length ? null : new on(1 - u - d, u, f);
  }
  /**
   * Checks if ray intersects a plane
   * @param plane the plane to check
   * @returns the distance away it was hit
   */
  intersectsPlane(e) {
    let t;
    const i = p.Dot(e.normal, this.direction);
    if (Math.abs(i) < 999999997475243e-21)
      return null;
    {
      const s = p.Dot(e.normal, this.origin);
      return t = (-e.d - s) / i, t < 0 ? t < -999999997475243e-21 ? null : 0 : t;
    }
  }
  /**
   * Calculate the intercept of a ray on a given axis
   * @param axis to check 'x' | 'y' | 'z'
   * @param offset from axis interception (i.e. an offset of 1y is intercepted above ground)
   * @returns a vector containing the coordinates where 'axis' is equal to zero (else offset), or null if there is no intercept.
   */
  intersectsAxis(e, t = 0) {
    switch (e) {
      case "y": {
        const i = (this.origin.y - t) / this.direction.y;
        return i > 0 ? null : new p(this.origin.x + this.direction.x * -i, t, this.origin.z + this.direction.z * -i);
      }
      case "x": {
        const i = (this.origin.x - t) / this.direction.x;
        return i > 0 ? null : new p(t, this.origin.y + this.direction.y * -i, this.origin.z + this.direction.z * -i);
      }
      case "z": {
        const i = (this.origin.z - t) / this.direction.z;
        return i > 0 ? null : new p(this.origin.x + this.direction.x * -i, this.origin.y + this.direction.y * -i, t);
      }
      default:
        return null;
    }
  }
  /**
   * Checks if ray intersects a mesh. The ray is defined in WORLD space. A mesh triangle can be picked both from its front and back sides,
   * irrespective of orientation.
   * @param mesh the mesh to check
   * @param fastCheck defines if the first intersection will be used (and not the closest)
   * @param trianglePredicate defines an optional predicate used to select faces when a mesh intersection is detected
   * @param onlyBoundingInfo defines a boolean indicating if picking should only happen using bounding info (false by default)
   * @param worldToUse defines the world matrix to use to get the world coordinate of the intersection point
   * @param skipBoundingInfo a boolean indicating if we should skip the bounding info check
   * @returns picking info of the intersection
   */
  intersectsMesh(e, t, i, s = !1, r, n = !1) {
    const a = C.Matrix[0];
    return e.getWorldMatrix().invertToRef(a), this._tmpRay ? Ae.TransformToRef(this, a, this._tmpRay) : this._tmpRay = Ae.Transform(this, a), e.intersects(this._tmpRay, t, i, s, r, n);
  }
  /**
   * Checks if ray intersects a mesh
   * @param meshes the meshes to check
   * @param fastCheck defines if the first intersection will be used (and not the closest)
   * @param results array to store result in
   * @returns Array of picking infos
   */
  intersectsMeshes(e, t, i) {
    i ? i.length = 0 : i = [];
    for (let s = 0; s < e.length; s++) {
      const r = this.intersectsMesh(e[s], t);
      r.hit && i.push(r);
    }
    return i.sort(this._comparePickingInfo), i;
  }
  _comparePickingInfo(e, t) {
    return e.distance < t.distance ? -1 : e.distance > t.distance ? 1 : 0;
  }
  /**
   * Intersection test between the ray and a given segment within a given tolerance (threshold)
   * @param sega the first point of the segment to test the intersection against
   * @param segb the second point of the segment to test the intersection against
   * @param threshold the tolerance margin, if the ray doesn't intersect the segment but is close to the given threshold, the intersection is successful
   * @returns the distance from the ray origin to the intersection point if there's intersection, or -1 if there's no intersection
   */
  intersectionSegment(e, t, i) {
    const s = this.origin, r = C.Vector3[0], n = C.Vector3[1], a = C.Vector3[2], o = C.Vector3[3];
    t.subtractToRef(e, r), this.direction.scaleToRef(Ae._Rayl, a), s.addToRef(a, n), e.subtractToRef(s, o);
    const l = p.Dot(r, r), c = p.Dot(r, a), u = p.Dot(a, a), d = p.Dot(r, o), f = p.Dot(a, o), _ = l * u - c * c;
    let g, m = _, y, x = _;
    _ < Ae._Smallnum ? (g = 0, m = 1, y = f, x = u) : (g = c * f - u * d, y = l * f - c * d, g < 0 ? (g = 0, y = f, x = u) : g > m && (g = m, y = f + c, x = u)), y < 0 ? (y = 0, -d < 0 ? g = 0 : -d > l ? g = m : (g = -d, m = l)) : y > x && (y = x, -d + c < 0 ? g = 0 : -d + c > l ? g = m : (g = -d + c, m = l));
    const A = Math.abs(g) < Ae._Smallnum ? 0 : g / m, T = Math.abs(y) < Ae._Smallnum ? 0 : y / x, M = C.Vector3[4];
    a.scaleToRef(T, M);
    const b = C.Vector3[5];
    r.scaleToRef(A, b), b.addInPlace(o);
    const S = C.Vector3[6];
    return b.subtractToRef(M, S), T > 0 && T <= this.length && S.lengthSquared() < i * i ? b.length() : -1;
  }
  /**
   * Update the ray from viewport position
   * @param x position
   * @param y y position
   * @param viewportWidth viewport width
   * @param viewportHeight viewport height
   * @param world world matrix
   * @param view view matrix
   * @param projection projection matrix
   * @param enableDistantPicking defines if picking should handle large values for mesh position/scaling (false by default)
   * @returns this ray updated
   */
  update(e, t, i, s, r, n, a, o = !1) {
    if (o) {
      Ae._RayDistant || (Ae._RayDistant = Ae.Zero()), Ae._RayDistant.unprojectRayToRef(e, t, i, s, I.IdentityReadOnly, n, a);
      const l = C.Matrix[0];
      r.invertToRef(l), Ae.TransformToRef(Ae._RayDistant, l, this);
    } else
      this.unprojectRayToRef(e, t, i, s, r, n, a);
    return this;
  }
  // Statics
  /**
   * Creates a ray with origin and direction of 0,0,0
   * @returns the new ray
   */
  static Zero() {
    return new Ae(p.Zero(), p.Zero());
  }
  /**
   * Creates a new ray from screen space and viewport
   * @param x position
   * @param y y position
   * @param viewportWidth viewport width
   * @param viewportHeight viewport height
   * @param world world matrix
   * @param view view matrix
   * @param projection projection matrix
   * @returns new ray
   */
  static CreateNew(e, t, i, s, r, n, a) {
    return Ae.Zero().update(e, t, i, s, r, n, a);
  }
  /**
   * Function will create a new transformed ray starting from origin and ending at the end point. Ray's length will be set, and ray will be
   * transformed to the given world matrix.
   * @param origin The origin point
   * @param end The end point
   * @param world a matrix to transform the ray to. Default is the identity matrix.
   * @returns the new ray
   */
  static CreateNewFromTo(e, t, i = I.IdentityReadOnly) {
    const s = t.subtract(e), r = Math.sqrt(s.x * s.x + s.y * s.y + s.z * s.z);
    return s.normalize(), Ae.Transform(new Ae(e, s, r), i);
  }
  /**
   * Transforms a ray by a matrix
   * @param ray ray to transform
   * @param matrix matrix to apply
   * @returns the resulting new ray
   */
  static Transform(e, t) {
    const i = new Ae(new p(0, 0, 0), new p(0, 0, 0));
    return Ae.TransformToRef(e, t, i), i;
  }
  /**
   * Transforms a ray by a matrix
   * @param ray ray to transform
   * @param matrix matrix to apply
   * @param result ray to store result in
   */
  static TransformToRef(e, t, i) {
    p.TransformCoordinatesToRef(e.origin, t, i.origin), p.TransformNormalToRef(e.direction, t, i.direction), i.length = e.length;
    const s = i.direction, r = s.length();
    if (!(r === 0 || r === 1)) {
      const n = 1 / r;
      s.x *= n, s.y *= n, s.z *= n, i.length *= r;
    }
  }
  /**
   * Unproject a ray from screen space to object space
   * @param sourceX defines the screen space x coordinate to use
   * @param sourceY defines the screen space y coordinate to use
   * @param viewportWidth defines the current width of the viewport
   * @param viewportHeight defines the current height of the viewport
   * @param world defines the world matrix to use (can be set to Identity to go to world space)
   * @param view defines the view matrix to use
   * @param projection defines the projection matrix to use
   */
  unprojectRayToRef(e, t, i, s, r, n, a) {
    const o = C.Matrix[0];
    r.multiplyToRef(n, o), o.multiplyToRef(a, o), o.invert();
    const l = de.LastCreatedEngine, c = C.Vector3[0];
    c.x = e / i * 2 - 1, c.y = -(t / s * 2 - 1), c.z = l != null && l.useReverseDepthBuffer ? 1 : l != null && l.isNDCHalfZRange ? 0 : -1;
    const u = C.Vector3[1].copyFromFloats(c.x, c.y, 1 - 1e-8), d = C.Vector3[2], f = C.Vector3[3];
    p._UnprojectFromInvertedMatrixToRef(c, o, d), p._UnprojectFromInvertedMatrixToRef(u, o, f), this.origin.copyFrom(d), f.subtractToRef(d, this.direction), this.direction.normalize();
  }
}
Ae._TmpVector3 = ot.BuildArray(6, p.Zero);
Ae._RayDistant = Ae.Zero();
Ae._Smallnum = 1e-8;
Ae._Rayl = 1e9;
ge.prototype.createPickingRay = function(h, e, t, i, s = !1) {
  const r = Ae.Zero();
  return this.createPickingRayToRef(h, e, t, r, i, s), r;
};
ge.prototype.createPickingRayToRef = function(h, e, t, i, s, r = !1, n = !1) {
  const a = this.getEngine();
  if (!s) {
    if (!this.activeCamera)
      return this;
    s = this.activeCamera;
  }
  const l = s.viewport.toGlobal(a.getRenderWidth(), a.getRenderHeight());
  return h = h / a.getHardwareScalingLevel() - l.x, e = e / a.getHardwareScalingLevel() - (a.getRenderHeight() - l.y - l.height), i.update(h, e, l.width, l.height, t || I.IdentityReadOnly, r ? I.IdentityReadOnly : s.getViewMatrix(), s.getProjectionMatrix(), n), this;
};
ge.prototype.createPickingRayInCameraSpace = function(h, e, t) {
  const i = Ae.Zero();
  return this.createPickingRayInCameraSpaceToRef(h, e, i, t), i;
};
ge.prototype.createPickingRayInCameraSpaceToRef = function(h, e, t, i) {
  if (!Gt)
    return this;
  const s = this.getEngine();
  if (!i) {
    if (!this.activeCamera)
      throw new Error("Active camera not set");
    i = this.activeCamera;
  }
  const n = i.viewport.toGlobal(s.getRenderWidth(), s.getRenderHeight()), a = I.Identity();
  return h = h / s.getHardwareScalingLevel() - n.x, e = e / s.getHardwareScalingLevel() - (s.getRenderHeight() - n.y - n.height), t.update(h, e, n.width, n.height, a, a, i.getProjectionMatrix()), this;
};
ge.prototype._internalPickForMesh = function(h, e, t, i, s, r, n, a) {
  const o = e(i, t.enableDistantPicking), l = t.intersects(o, s, n, r, i, a);
  return !l || !l.hit || !s && h != null && l.distance >= h.distance ? null : l;
};
ge.prototype._internalPick = function(h, e, t, i, s) {
  let r = null;
  const n = !!(this.activeCameras && this.activeCameras.length > 1 && this.cameraToUseForPointers !== this.activeCamera), a = this.cameraToUseForPointers || this.activeCamera;
  for (let o = 0; o < this.meshes.length; o++) {
    const l = this.meshes[o];
    if (e) {
      if (!e(l))
        continue;
    } else if (!l.isEnabled() || !l.isVisible || !l.isPickable)
      continue;
    const c = n && l.isWorldMatrixCameraDependent(), u = l.computeWorldMatrix(c, a);
    if (l.hasThinInstances && l.thinInstanceEnablePicking) {
      const d = this._internalPickForMesh(r, h, l, u, !0, !0, s);
      if (d) {
        if (i)
          return d;
        const f = C.Matrix[1], _ = l.thinInstanceGetWorldMatrices();
        for (let g = 0; g < _.length; g++) {
          _[g].multiplyToRef(u, f);
          const y = this._internalPickForMesh(r, h, l, f, t, i, s, !0);
          if (y && (r = y, r.thinInstanceIndex = g, t))
            return r;
        }
      }
    } else {
      const d = this._internalPickForMesh(r, h, l, u, t, i, s);
      if (d && (r = d, t))
        return r;
    }
  }
  return r || new Gt();
};
ge.prototype._internalMultiPick = function(h, e, t) {
  if (!Gt)
    return null;
  const i = new Array(), s = !!(this.activeCameras && this.activeCameras.length > 1 && this.cameraToUseForPointers !== this.activeCamera), r = this.cameraToUseForPointers || this.activeCamera;
  for (let n = 0; n < this.meshes.length; n++) {
    const a = this.meshes[n];
    if (e) {
      if (!e(a))
        continue;
    } else if (!a.isEnabled() || !a.isVisible || !a.isPickable)
      continue;
    const o = s && a.isWorldMatrixCameraDependent(), l = a.computeWorldMatrix(o, r);
    if (a.hasThinInstances && a.thinInstanceEnablePicking) {
      if (this._internalPickForMesh(null, h, a, l, !0, !0, t)) {
        const u = C.Matrix[1], d = a.thinInstanceGetWorldMatrices();
        for (let f = 0; f < d.length; f++) {
          d[f].multiplyToRef(l, u);
          const g = this._internalPickForMesh(null, h, a, u, !1, !1, t, !0);
          g && (g.thinInstanceIndex = f, i.push(g));
        }
      }
    } else {
      const c = this._internalPickForMesh(null, h, a, l, !1, !1, t);
      c && i.push(c);
    }
  }
  return i;
};
ge.prototype.pickWithBoundingInfo = function(h, e, t, i, s) {
  if (!Gt)
    return null;
  const r = this._internalPick((n) => (this._tempPickingRay || (this._tempPickingRay = Ae.Zero()), this.createPickingRayToRef(h, e, n, this._tempPickingRay, s || null), this._tempPickingRay), t, i, !0);
  return r && (r.ray = this.createPickingRay(h, e, I.Identity(), s || null)), r;
};
Object.defineProperty(ge.prototype, "_pickingAvailable", {
  get: () => !0,
  enumerable: !1,
  configurable: !1
});
ge.prototype.pick = function(h, e, t, i, s, r, n = !1) {
  const a = this._internalPick((o, l) => (this._tempPickingRay || (this._tempPickingRay = Ae.Zero()), this.createPickingRayToRef(h, e, o, this._tempPickingRay, s || null, !1, l), this._tempPickingRay), t, i, !1, r);
  return a && (a.ray = this.createPickingRay(h, e, I.Identity(), s || null)), a;
};
ge.prototype.pickWithRay = function(h, e, t, i) {
  const s = this._internalPick((r) => (this._pickWithRayInverseMatrix || (this._pickWithRayInverseMatrix = I.Identity()), r.invertToRef(this._pickWithRayInverseMatrix), this._cachedRayForTransform || (this._cachedRayForTransform = Ae.Zero()), Ae.TransformToRef(h, this._pickWithRayInverseMatrix, this._cachedRayForTransform), this._cachedRayForTransform), e, t, !1, i);
  return s && (s.ray = h), s;
};
ge.prototype.multiPick = function(h, e, t, i, s) {
  return this._internalMultiPick((r) => this.createPickingRay(h, e, r, i || null), t, s);
};
ge.prototype.multiPickWithRay = function(h, e, t) {
  return this._internalMultiPick((i) => (this._pickWithRayInverseMatrix || (this._pickWithRayInverseMatrix = I.Identity()), i.invertToRef(this._pickWithRayInverseMatrix), this._cachedRayForTransform || (this._cachedRayForTransform = Ae.Zero()), Ae.TransformToRef(h, this._pickWithRayInverseMatrix, this._cachedRayForTransform), this._cachedRayForTransform), e, t);
};
Q.prototype.getForwardRay = function(h = 100, e, t) {
  return this.getForwardRayToRef(new Ae(p.Zero(), p.Zero(), h), h, e, t);
};
Q.prototype.getForwardRayToRef = function(h, e = 100, t, i) {
  return t || (t = this.getWorldMatrix()), h.length = e, i ? h.origin.copyFrom(i) : h.origin.copyFrom(this.position), C.Vector3[2].set(0, 0, this._scene.useRightHandedSystem ? -1 : 1), p.TransformNormalToRef(C.Vector3[2], t, C.Vector3[3]), p.NormalizeToRef(C.Vector3[3], h.direction), h;
};
ge.prototype._internalPickSprites = function(h, e, t, i) {
  if (!Gt)
    return null;
  let s = null;
  if (!i) {
    if (!this.activeCamera)
      return null;
    i = this.activeCamera;
  }
  if (this.spriteManagers && this.spriteManagers.length > 0)
    for (let r = 0; r < this.spriteManagers.length; r++) {
      const n = this.spriteManagers[r];
      if (!n.isPickable)
        continue;
      const a = n.intersects(h, i, e, t);
      if (!(!a || !a.hit) && !(!t && s != null && a.distance >= s.distance) && (s = a, t))
        break;
    }
  return s || new Gt();
};
ge.prototype._internalMultiPickSprites = function(h, e, t) {
  if (!Gt)
    return null;
  let i = new Array();
  if (!t) {
    if (!this.activeCamera)
      return null;
    t = this.activeCamera;
  }
  if (this.spriteManagers && this.spriteManagers.length > 0)
    for (let s = 0; s < this.spriteManagers.length; s++) {
      const r = this.spriteManagers[s];
      if (!r.isPickable)
        continue;
      const n = r.multiIntersects(h, t, e);
      n !== null && (i = i.concat(n));
    }
  return i;
};
ge.prototype.pickSprite = function(h, e, t, i, s) {
  if (!this._tempSpritePickingRay)
    return null;
  this.createPickingRayInCameraSpaceToRef(h, e, this._tempSpritePickingRay, s);
  const r = this._internalPickSprites(this._tempSpritePickingRay, t, i, s);
  return r && (r.ray = this.createPickingRayInCameraSpace(h, e, s)), r;
};
ge.prototype.pickSpriteWithRay = function(h, e, t, i) {
  if (!this._tempSpritePickingRay)
    return null;
  if (!i) {
    if (!this.activeCamera)
      return null;
    i = this.activeCamera;
  }
  Ae.TransformToRef(h, i.getViewMatrix(), this._tempSpritePickingRay);
  const s = this._internalPickSprites(this._tempSpritePickingRay, e, t, i);
  return s && (s.ray = h), s;
};
ge.prototype.multiPickSprite = function(h, e, t, i) {
  return this.createPickingRayInCameraSpaceToRef(h, e, this._tempSpritePickingRay, i), this._internalMultiPickSprites(this._tempSpritePickingRay, t, i);
};
ge.prototype.multiPickSpriteWithRay = function(h, e, t) {
  if (!this._tempSpritePickingRay)
    return null;
  if (!t) {
    if (!this.activeCamera)
      return null;
    t = this.activeCamera;
  }
  return Ae.TransformToRef(h, t.getViewMatrix(), this._tempSpritePickingRay), this._internalMultiPickSprites(this._tempSpritePickingRay, e, t);
};
ge.prototype.setPointerOverSprite = function(h) {
  this._pointerOverSprite !== h && (this._pointerOverSprite && this._pointerOverSprite.actionManager && this._pointerOverSprite.actionManager.processTrigger(10, He.CreateNewFromSprite(this._pointerOverSprite, this)), this._pointerOverSprite = h, this._pointerOverSprite && this._pointerOverSprite.actionManager && this._pointerOverSprite.actionManager.processTrigger(9, He.CreateNewFromSprite(this._pointerOverSprite, this)));
};
ge.prototype.getPointerOverSprite = function() {
  return this._pointerOverSprite;
};
class oc {
  /**
   * Creates a new instance of the component for the given scene
   * @param scene Defines the scene to register the component in
   */
  constructor(e) {
    this.name = ne.NAME_SPRITE, this.scene = e, this.scene.spriteManagers = new Array(), this.scene._tempSpritePickingRay = Ae ? Ae.Zero() : null, this.scene.onBeforeSpritesRenderingObservable = new N(), this.scene.onAfterSpritesRenderingObservable = new N(), this._spritePredicate = (t) => t.actionManager ? t.isPickable && t.actionManager.hasPointerTriggers : !1;
  }
  /**
   * Registers the component in a given scene
   */
  register() {
    this.scene._pointerMoveStage.registerStep(ne.STEP_POINTERMOVE_SPRITE, this, this._pointerMove), this.scene._pointerDownStage.registerStep(ne.STEP_POINTERDOWN_SPRITE, this, this._pointerDown), this.scene._pointerUpStage.registerStep(ne.STEP_POINTERUP_SPRITE, this, this._pointerUp);
  }
  /**
   * Rebuilds the elements related to this component in case of
   * context lost for instance.
   */
  rebuild() {
  }
  /**
   * Disposes the component and the associated resources.
   */
  dispose() {
    this.scene.onBeforeSpritesRenderingObservable.clear(), this.scene.onAfterSpritesRenderingObservable.clear();
    const e = this.scene.spriteManagers;
    if (e)
      for (; e.length; )
        e[0].dispose();
  }
  _pickSpriteButKeepRay(e, t, i, s, r) {
    const n = this.scene.pickSprite(t, i, this._spritePredicate, s, r);
    return n && (n.ray = e ? e.ray : null), n;
  }
  _pointerMove(e, t, i, s, r) {
    const n = this.scene;
    return s ? n.setPointerOverSprite(null) : (i = this._pickSpriteButKeepRay(i, e, t, !1, n.cameraToUseForPointers || void 0), i && i.hit && i.pickedSprite ? (n.setPointerOverSprite(i.pickedSprite), !n.doNotHandleCursors && r && (n._pointerOverSprite && n._pointerOverSprite.actionManager && n._pointerOverSprite.actionManager.hoverCursor ? r.style.cursor = n._pointerOverSprite.actionManager.hoverCursor : r.style.cursor = n.hoverCursor)) : n.setPointerOverSprite(null)), i;
  }
  _pointerDown(e, t, i, s) {
    const r = this.scene;
    if (r._pickedDownSprite = null, r.spriteManagers && r.spriteManagers.length > 0 && (i = r.pickSprite(e, t, this._spritePredicate, !1, r.cameraToUseForPointers || void 0), i && i.hit && i.pickedSprite && i.pickedSprite.actionManager)) {
      switch (r._pickedDownSprite = i.pickedSprite, s.button) {
        case 0:
          i.pickedSprite.actionManager.processTrigger(2, He.CreateNewFromSprite(i.pickedSprite, r, s));
          break;
        case 1:
          i.pickedSprite.actionManager.processTrigger(4, He.CreateNewFromSprite(i.pickedSprite, r, s));
          break;
        case 2:
          i.pickedSprite.actionManager.processTrigger(3, He.CreateNewFromSprite(i.pickedSprite, r, s));
          break;
      }
      i.pickedSprite.actionManager && i.pickedSprite.actionManager.processTrigger(5, He.CreateNewFromSprite(i.pickedSprite, r, s));
    }
    return i;
  }
  _pointerUp(e, t, i, s, r) {
    const n = this.scene;
    if (n.spriteManagers && n.spriteManagers.length > 0) {
      const a = n.pickSprite(e, t, this._spritePredicate, !1, n.cameraToUseForPointers || void 0);
      a && (a.hit && a.pickedSprite && a.pickedSprite.actionManager && (a.pickedSprite.actionManager.processTrigger(7, He.CreateNewFromSprite(a.pickedSprite, n, s)), a.pickedSprite.actionManager && (this.scene._inputManager._isPointerSwiping() || a.pickedSprite.actionManager.processTrigger(1, He.CreateNewFromSprite(a.pickedSprite, n, s)), r && a.pickedSprite.actionManager.processTrigger(6, He.CreateNewFromSprite(a.pickedSprite, n, s)))), n._pickedDownSprite && n._pickedDownSprite.actionManager && n._pickedDownSprite !== a.pickedSprite && n._pickedDownSprite.actionManager.processTrigger(16, He.CreateNewFromSprite(n._pickedDownSprite, n, s)));
    }
    return i;
  }
}
function _o(h) {
  const e = [], t = [], i = [], s = [], r = h.width || h.size || 1, n = h.height || h.size || 1, a = h.sideOrientation === 0 ? 0 : h.sideOrientation || q.DEFAULTSIDE, o = r / 2, l = n / 2;
  t.push(-o, -l, 0), i.push(0, 0, -1), s.push(0, ct.UseOpenGLOrientationForUV ? 1 : 0), t.push(o, -l, 0), i.push(0, 0, -1), s.push(1, ct.UseOpenGLOrientationForUV ? 1 : 0), t.push(o, l, 0), i.push(0, 0, -1), s.push(1, ct.UseOpenGLOrientationForUV ? 0 : 1), t.push(-o, l, 0), i.push(0, 0, -1), s.push(0, ct.UseOpenGLOrientationForUV ? 0 : 1), e.push(0), e.push(1), e.push(2), e.push(0), e.push(2), e.push(3), q._ComputeSides(a, t, e, i, s, h.frontUVs, h.backUVs);
  const c = new q();
  return c.indices = e, c.positions = t, c.normals = i, c.uvs = s, c;
}
function po(h, e = {}, t = null) {
  const i = new K(h, t);
  return e.sideOrientation = K._GetDefaultSideOrientation(e.sideOrientation), i._originalBuilderSideOrientation = e.sideOrientation, _o(e).applyToMesh(i, e.updatable), e.sourcePlane && (i.translate(e.sourcePlane.normal, -e.sourcePlane.d), i.setDirection(e.sourcePlane.normal.scale(-1))), i;
}
q.CreatePlane = _o;
K.CreatePlane = (h, e, t, i, s) => po(h, {
  size: e,
  width: e,
  height: e,
  sideOrientation: s,
  updatable: i
}, t);
class lc extends ue {
  constructor(e, t) {
    super(e.x, e.y), this.index = t;
  }
}
class qr {
  constructor() {
    this.elements = new Array();
  }
  add(e) {
    const t = new Array();
    return e.forEach((i) => {
      const s = new lc(i, this.elements.length);
      t.push(s), this.elements.push(s);
    }), t;
  }
  computeBounds() {
    const e = new ue(this.elements[0].x, this.elements[0].y), t = new ue(this.elements[0].x, this.elements[0].y);
    return this.elements.forEach((i) => {
      i.x < e.x ? e.x = i.x : i.x > t.x && (t.x = i.x), i.y < e.y ? e.y = i.y : i.y > t.y && (t.y = i.y);
    }), {
      min: e,
      max: t,
      width: t.x - e.x,
      height: t.y - e.y
    };
  }
}
class hc {
  _addToepoint(e) {
    for (const t of e)
      this._epoints.push(t.x, t.y);
  }
  /**
   * Creates a PolygonMeshBuilder
   * @param name name of the builder
   * @param contours Path of the polygon
   * @param scene scene to add to when creating the mesh
   * @param earcutInjection can be used to inject your own earcut reference
   */
  constructor(e, t, i, s = earcut) {
    this._points = new qr(), this._outlinepoints = new qr(), this._holes = new Array(), this._epoints = new Array(), this._eholes = new Array(), this.bjsEarcut = s, this._name = e, this._scene = i || de.LastCreatedScene;
    let r;
    t instanceof Ln ? r = t.getPoints() : r = t, this._addToepoint(r), this._points.add(r), this._outlinepoints.add(r), typeof this.bjsEarcut > "u" && w.Warn("Earcut was not found, the polygon will not be built.");
  }
  /**
   * Adds a hole within the polygon
   * @param hole Array of points defining the hole
   * @returns this
   */
  addHole(e) {
    this._points.add(e);
    const t = new qr();
    return t.add(e), this._holes.push(t), this._eholes.push(this._epoints.length / 2), this._addToepoint(e), this;
  }
  /**
   * Creates the polygon
   * @param updatable If the mesh should be updatable
   * @param depth The depth of the mesh created
   * @param smoothingThreshold Dot product threshold for smoothed normals
   * @returns the created mesh
   */
  build(e = !1, t = 0, i = 2) {
    const s = new K(this._name, this._scene), r = this.buildVertexData(t, i);
    return s.setVerticesData(v.PositionKind, r.positions, e), s.setVerticesData(v.NormalKind, r.normals, e), s.setVerticesData(v.UVKind, r.uvs, e), s.setIndices(r.indices), s;
  }
  /**
   * Creates the polygon
   * @param depth The depth of the mesh created
   * @param smoothingThreshold Dot product threshold for smoothed normals
   * @returns the created VertexData
   */
  buildVertexData(e = 0, t = 2) {
    const i = new q(), s = new Array(), r = new Array(), n = new Array(), a = this._points.computeBounds();
    this._points.elements.forEach((c) => {
      s.push(0, 1, 0), r.push(c.x, 0, c.y), n.push((c.x - a.min.x) / a.width, (c.y - a.min.y) / a.height);
    });
    const o = new Array(), l = this.bjsEarcut(this._epoints, this._eholes, 2);
    for (let c = 0; c < l.length; c++)
      o.push(l[c]);
    if (e > 0) {
      const c = r.length / 3;
      this._points.elements.forEach((d) => {
        s.push(0, -1, 0), r.push(d.x, -e, d.y), n.push(1 - (d.x - a.min.x) / a.width, 1 - (d.y - a.min.y) / a.height);
      });
      const u = o.length;
      for (let d = 0; d < u; d += 3) {
        const f = o[d + 0], _ = o[d + 1], g = o[d + 2];
        o.push(g + c), o.push(_ + c), o.push(f + c);
      }
      this._addSide(r, s, n, o, a, this._outlinepoints, e, !1, t), this._holes.forEach((d) => {
        this._addSide(r, s, n, o, a, d, e, !0, t);
      });
    }
    return i.indices = o, i.positions = r, i.normals = s, i.uvs = n, i;
  }
  /**
   * Adds a side to the polygon
   * @param positions points that make the polygon
   * @param normals normals of the polygon
   * @param uvs uvs of the polygon
   * @param indices indices of the polygon
   * @param bounds bounds of the polygon
   * @param points points of the polygon
   * @param depth depth of the polygon
   * @param flip flip of the polygon
   * @param smoothingThreshold
   */
  _addSide(e, t, i, s, r, n, a, o, l) {
    let c = e.length / 3, u = 0;
    for (let d = 0; d < n.elements.length; d++) {
      const f = n.elements[d], _ = n.elements[(d + 1) % n.elements.length];
      e.push(f.x, 0, f.y), e.push(f.x, -a, f.y), e.push(_.x, 0, _.y), e.push(_.x, -a, _.y);
      const g = n.elements[(d + n.elements.length - 1) % n.elements.length], m = n.elements[(d + 2) % n.elements.length];
      let y = new p(-(_.y - f.y), 0, _.x - f.x), x = new p(-(f.y - g.y), 0, f.x - g.x), A = new p(-(m.y - _.y), 0, m.x - _.x);
      o || (y = y.scale(-1), x = x.scale(-1), A = A.scale(-1));
      const T = y.normalizeToNew();
      let M = x.normalizeToNew(), b = A.normalizeToNew();
      const S = p.Dot(M, T);
      S > l ? S < pe - 1 ? M = new p(f.x, 0, f.y).subtract(new p(_.x, 0, _.y)).normalize() : M = x.add(y).normalize() : M = T;
      const P = p.Dot(A, y);
      P > l ? P < pe - 1 ? b = new p(_.x, 0, _.y).subtract(new p(f.x, 0, f.y)).normalize() : b = A.add(y).normalize() : b = T, i.push(u / r.width, 0), i.push(u / r.width, 1), u += y.length(), i.push(u / r.width, 0), i.push(u / r.width, 1), t.push(M.x, M.y, M.z), t.push(M.x, M.y, M.z), t.push(b.x, b.y, b.z), t.push(b.x, b.y, b.z), o ? (s.push(c), s.push(c + 2), s.push(c + 1), s.push(c + 1), s.push(c + 2), s.push(c + 3)) : (s.push(c), s.push(c + 1), s.push(c + 2), s.push(c + 1), s.push(c + 3), s.push(c + 2)), c += 4;
    }
  }
}
function go(h, e, t, i, s, r, n) {
  const a = t || new Array(3), o = i, l = [], c = n || !1;
  for (let D = 0; D < 3; D++)
    a[D] === void 0 && (a[D] = new ze(0, 0, 1, 1)), o && o[D] === void 0 && (o[D] = new ye(1, 1, 1, 1));
  const u = h.getVerticesData(v.PositionKind), d = h.getVerticesData(v.NormalKind), f = h.getVerticesData(v.UVKind), _ = h.getIndices(), g = u.length / 9;
  let m = 0, y = 0, x = 0, A = 0, T = 0;
  const M = [0];
  if (c)
    for (let D = g; D < u.length / 3; D += 4)
      y = u[3 * (D + 2)] - u[3 * D], x = u[3 * (D + 2) + 2] - u[3 * D + 2], A = Math.sqrt(y * y + x * x), T += A, M.push(T);
  let b = 0, S = 0;
  for (let D = 0; D < d.length; D += 3)
    Math.abs(d[D + 1]) < 1e-3 && (S = 1), Math.abs(d[D + 1] - 1) < 1e-3 && (S = 0), Math.abs(d[D + 1] + 1) < 1e-3 && (S = 2), b = D / 3, S === 1 ? (m = b - g, m % 4 < 1.5 ? c ? f[2 * b] = a[S].x + (a[S].z - a[S].x) * M[Math.floor(m / 4)] / T : f[2 * b] = a[S].x : c ? f[2 * b] = a[S].x + (a[S].z - a[S].x) * M[Math.floor(m / 4) + 1] / T : f[2 * b] = a[S].z, m % 2 === 0 ? f[2 * b + 1] = ct.UseOpenGLOrientationForUV ? 1 - a[S].w : a[S].w : f[2 * b + 1] = ct.UseOpenGLOrientationForUV ? 1 - a[S].y : a[S].y) : (f[2 * b] = (1 - f[2 * b]) * a[S].x + f[2 * b] * a[S].z, f[2 * b + 1] = (1 - f[2 * b + 1]) * a[S].y + f[2 * b + 1] * a[S].w, ct.UseOpenGLOrientationForUV && (f[2 * b + 1] = 1 - f[2 * b + 1])), o && l.push(o[S].r, o[S].g, o[S].b, o[S].a);
  q._ComputeSides(e, u, _, d, f, s, r);
  const P = new q();
  if (P.indices = _, P.positions = u, P.normals = d, P.uvs = f, o) {
    const D = e === q.DOUBLESIDE ? l.concat(l) : l;
    P.colors = D;
  }
  return P;
}
function wr(h, e, t = null, i = earcut) {
  e.sideOrientation = K._GetDefaultSideOrientation(e.sideOrientation);
  const s = e.shape, r = e.holes || [], n = e.depth || 0, a = e.smoothingThreshold || 2, o = [];
  let l = [];
  for (let _ = 0; _ < s.length; _++)
    o[_] = new ue(s[_].x, s[_].z);
  o[0].equalsWithEpsilon(o[o.length - 1], 1e-8) && o.pop();
  const u = new hc(h, o, t || de.LastCreatedScene, i);
  for (let _ = 0; _ < r.length; _++) {
    l = [];
    for (let g = 0; g < r[_].length; g++)
      l.push(new ue(r[_][g].x, r[_][g].z));
    u.addHole(l);
  }
  const d = u.build(!1, n, a);
  return d._originalBuilderSideOrientation = e.sideOrientation, go(d, e.sideOrientation, e.faceUV, e.faceColors, e.frontUVs, e.backUVs, e.wrap).applyToMesh(d, e.updatable), d;
}
function cc(h, e, t = null, i = earcut) {
  return wr(h, e, t, i);
}
q.CreatePolygon = go;
K.CreatePolygon = (h, e, t, i, s, r, n = earcut) => wr(h, {
  shape: e,
  holes: i,
  updatable: s,
  sideOrientation: r
}, t, n);
K.ExtrudePolygon = (h, e, t, i, s, r, n, a = earcut) => cc(h, {
  shape: e,
  holes: s,
  depth: t,
  updatable: r,
  sideOrientation: n
}, i, a);
class uc {
  /**
   * Returns a boolean indicating if the animation is started
   */
  get animationStarted() {
    return this._animationStarted;
  }
  /** Gets the initial key for the animation (setting it will restart the animation)  */
  get fromIndex() {
    return this._fromIndex;
  }
  /** Gets or sets the end key for the animation (setting it will restart the animation)  */
  get toIndex() {
    return this._toIndex;
  }
  /** Gets or sets a boolean indicating if the animation is looping (setting it will restart the animation)  */
  get loopAnimation() {
    return this._loopAnimation;
  }
  /** Gets or sets the delay between cell changes (setting it will restart the animation)  */
  get delay() {
    return Math.max(this._delay, 1);
  }
  /**
   * Creates a new Thin Sprite
   */
  constructor() {
    this.width = 1, this.height = 1, this.angle = 0, this.invertU = !1, this.invertV = !1, this.isVisible = !0, this._animationStarted = !1, this._loopAnimation = !1, this._fromIndex = 0, this._toIndex = 0, this._delay = 0, this._direction = 1, this._time = 0, this._onBaseAnimationEnd = null, this.position = { x: 1, y: 1, z: 1 }, this.color = { r: 1, g: 1, b: 1, a: 1 };
  }
  /**
   * Starts an animation
   * @param from defines the initial key
   * @param to defines the end key
   * @param loop defines if the animation must loop
   * @param delay defines the start delay (in ms)
   * @param onAnimationEnd defines a callback for when the animation ends
   */
  playAnimation(e, t, i, s, r) {
    this._fromIndex = e, this._toIndex = t, this._loopAnimation = i, this._delay = s || 1, this._animationStarted = !0, this._onBaseAnimationEnd = r, e < t ? this._direction = 1 : (this._direction = -1, this._toIndex = e, this._fromIndex = t), this.cellIndex = e, this._time = 0;
  }
  /** Stops current animation (if any) */
  stopAnimation() {
    this._animationStarted = !1;
  }
  /**
   * @internal
   */
  _animate(e) {
    this._animationStarted && (this._time += e, this._time > this._delay && (this._time = this._time % this._delay, this.cellIndex += this._direction, (this._direction > 0 && this.cellIndex > this._toIndex || this._direction < 0 && this.cellIndex < this._fromIndex) && (this._loopAnimation ? this.cellIndex = this._direction > 0 ? this._fromIndex : this._toIndex : (this.cellIndex = this._toIndex, this._animationStarted = !1, this._onBaseAnimationEnd && this._onBaseAnimationEnd()))));
  }
}
class _s extends uc {
  /**
   * Gets or sets the sprite size
   */
  get size() {
    return this.width;
  }
  set size(e) {
    this.width = e, this.height = e;
  }
  /**
   * Gets the manager of this sprite
   */
  get manager() {
    return this._manager;
  }
  /**
   * Creates a new Sprite
   * @param name defines the name
   * @param manager defines the manager
   */
  constructor(e, t) {
    super(), this.name = e, this.animations = new Array(), this.isPickable = !1, this.useAlphaForPicking = !1, this.onDisposeObservable = new N(), this._onAnimationEnd = null, this._endAnimation = () => {
      this._onAnimationEnd && this._onAnimationEnd(), this.disposeWhenFinishedAnimating && this.dispose();
    }, this.color = new ye(1, 1, 1, 1), this.position = p.Zero(), this._manager = t, this._manager.sprites.push(this), this.uniqueId = this._manager.scene.getUniqueId();
  }
  /**
   * Returns the string "Sprite"
   * @returns "Sprite"
   */
  getClassName() {
    return "Sprite";
  }
  /** Gets or sets the initial key for the animation (setting it will restart the animation)  */
  get fromIndex() {
    return this._fromIndex;
  }
  set fromIndex(e) {
    this.playAnimation(e, this._toIndex, this._loopAnimation, this._delay, this._onAnimationEnd);
  }
  /** Gets or sets the end key for the animation (setting it will restart the animation)  */
  get toIndex() {
    return this._toIndex;
  }
  set toIndex(e) {
    this.playAnimation(this._fromIndex, e, this._loopAnimation, this._delay, this._onAnimationEnd);
  }
  /** Gets or sets a boolean indicating if the animation is looping (setting it will restart the animation)  */
  get loopAnimation() {
    return this._loopAnimation;
  }
  set loopAnimation(e) {
    this.playAnimation(this._fromIndex, this._toIndex, e, this._delay, this._onAnimationEnd);
  }
  /** Gets or sets the delay between cell changes (setting it will restart the animation)  */
  get delay() {
    return Math.max(this._delay, 1);
  }
  set delay(e) {
    this.playAnimation(this._fromIndex, this._toIndex, this._loopAnimation, e, this._onAnimationEnd);
  }
  /**
   * Starts an animation
   * @param from defines the initial key
   * @param to defines the end key
   * @param loop defines if the animation must loop
   * @param delay defines the start delay (in ms)
   * @param onAnimationEnd defines a callback to call when animation ends
   */
  playAnimation(e, t, i, s, r = null) {
    this._onAnimationEnd = r, super.playAnimation(e, t, i, s, this._endAnimation);
  }
  /** Release associated resources */
  dispose() {
    for (let e = 0; e < this._manager.sprites.length; e++)
      this._manager.sprites[e] == this && this._manager.sprites.splice(e, 1);
    this.onDisposeObservable.notifyObservers(this), this.onDisposeObservable.clear();
  }
  /**
   * Serializes the sprite to a JSON object
   * @returns the JSON object
   */
  serialize() {
    const e = {};
    return e.name = this.name, e.position = this.position.asArray(), e.color = this.color.asArray(), e.width = this.width, e.height = this.height, e.angle = this.angle, e.cellIndex = this.cellIndex, e.cellRef = this.cellRef, e.invertU = this.invertU, e.invertV = this.invertV, e.disposeWhenFinishedAnimating = this.disposeWhenFinishedAnimating, e.isPickable = this.isPickable, e.isVisible = this.isVisible, e.useAlphaForPicking = this.useAlphaForPicking, e.animationStarted = this.animationStarted, e.fromIndex = this.fromIndex, e.toIndex = this.toIndex, e.loopAnimation = this.loopAnimation, e.delay = this.delay, e;
  }
  /**
   * Parses a JSON object to create a new sprite
   * @param parsedSprite The JSON object to parse
   * @param manager defines the hosting manager
   * @returns the new sprite
   */
  static Parse(e, t) {
    const i = new _s(e.name, t);
    return i.position = p.FromArray(e.position), i.color = ye.FromArray(e.color), i.width = e.width, i.height = e.height, i.angle = e.angle, i.cellIndex = e.cellIndex, i.cellRef = e.cellRef, i.invertU = e.invertU, i.invertV = e.invertV, i.disposeWhenFinishedAnimating = e.disposeWhenFinishedAnimating, i.isPickable = e.isPickable, i.isVisible = e.isVisible, i.useAlphaForPicking = e.useAlphaForPicking, i.fromIndex = e.fromIndex, i.toIndex = e.toIndex, i.loopAnimation = e.loopAnimation, i.delay = e.delay, e.animationStarted && i.playAnimation(i.fromIndex, i.toIndex, i.loopAnimation, i.delay), i;
  }
}
const dc = "fogFragmentDeclaration", fc = `#ifdef FOG
#define FOGMODE_NONE 0.
#define FOGMODE_EXP 1.
#define FOGMODE_EXP2 2.
#define FOGMODE_LINEAR 3.
#define E 2.71828
uniform vec4 vFogInfos;uniform vec3 vFogColor;varying vec3 vFogDistance;float CalcFogFactor()
{float fogCoeff=1.0;float fogStart=vFogInfos.y;float fogEnd=vFogInfos.z;float fogDensity=vFogInfos.w;float fogDistance=length(vFogDistance);if (FOGMODE_LINEAR==vFogInfos.x)
{fogCoeff=(fogEnd-fogDistance)/(fogEnd-fogStart);}
else if (FOGMODE_EXP==vFogInfos.x)
{fogCoeff=1.0/pow(E,fogDistance*fogDensity);}
else if (FOGMODE_EXP2==vFogInfos.x)
{fogCoeff=1.0/pow(E,fogDistance*fogDistance*fogDensity*fogDensity);}
return clamp(fogCoeff,0.0,1.0);}
#endif
`;
G.IncludesShadersStore[dc] = fc;
const _c = "fogFragment", pc = `#ifdef FOG
float fog=CalcFogFactor();
#ifdef PBR
fog=toLinearSpace(fog);
#endif
color.rgb=mix(vFogColor,color.rgb,fog);
#endif
`;
G.IncludesShadersStore[_c] = pc;
const gc = "imageProcessingCompatibility", mc = `#ifdef IMAGEPROCESSINGPOSTPROCESS
gl_FragColor.rgb=pow(gl_FragColor.rgb,vec3(2.2));
#endif
`;
G.IncludesShadersStore[gc] = mc;
const yc = "spritesPixelShader", vc = `uniform bool alphaTest;varying vec4 vColor;varying vec2 vUV;uniform sampler2D diffuseSampler;
#include<fogFragmentDeclaration>
#define CUSTOM_FRAGMENT_DEFINITIONS
#ifdef PIXEL_PERFECT
vec2 uvPixelPerfect(vec2 uv) {vec2 res=vec2(textureSize(diffuseSampler,0));uv=uv*res;vec2 seam=floor(uv+0.5);uv=seam+clamp((uv-seam)/fwidth(uv),-0.5,0.5);return uv/res;}
#endif
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
#ifdef PIXEL_PERFECT
vec2 uv=uvPixelPerfect(vUV);
#else
vec2 uv=vUV;
#endif
vec4 color=texture2D(diffuseSampler,uv);float fAlphaTest=float(alphaTest);if (fAlphaTest != 0.)
{if (color.a<0.95)
discard;}
color*=vColor;
#include<fogFragment>
gl_FragColor=color;
#include<imageProcessingCompatibility>
#define CUSTOM_FRAGMENT_MAIN_END
}`;
G.ShadersStore[yc] = vc;
const xc = "fogVertexDeclaration", bc = `#ifdef FOG
varying vec3 vFogDistance;
#endif
`;
G.IncludesShadersStore[xc] = bc;
const Tc = "spritesVertexShader", Ac = `attribute vec4 position;attribute vec2 options;attribute vec2 offsets;attribute vec2 inverts;attribute vec4 cellInfo;attribute vec4 color;uniform mat4 view;uniform mat4 projection;varying vec2 vUV;varying vec4 vColor;
#include<fogVertexDeclaration>
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
vec3 viewPos=(view*vec4(position.xyz,1.0)).xyz; 
vec2 cornerPos;float angle=position.w;vec2 size=vec2(options.x,options.y);vec2 offset=offsets.xy;cornerPos=vec2(offset.x-0.5,offset.y -0.5)*size;vec3 rotatedCorner;rotatedCorner.x=cornerPos.x*cos(angle)-cornerPos.y*sin(angle);rotatedCorner.y=cornerPos.x*sin(angle)+cornerPos.y*cos(angle);rotatedCorner.z=0.;viewPos+=rotatedCorner;gl_Position=projection*vec4(viewPos,1.0); 
vColor=color;vec2 uvOffset=vec2(abs(offset.x-inverts.x),abs(1.0-offset.y-inverts.y));vec2 uvPlace=cellInfo.xy;vec2 uvSize=cellInfo.zw;vUV.x=uvPlace.x+uvSize.x*uvOffset.x;vUV.y=uvPlace.y+uvSize.y*uvOffset.y;
#ifdef FOG
vFogDistance=viewPos;
#endif
#define CUSTOM_VERTEX_MAIN_END
}`;
G.ShadersStore[Tc] = Ac;
class Ec {
  /**
   * Gets the capacity of the manager
   */
  get capacity() {
    return this._capacity;
  }
  /**
   * Gets or sets a boolean indicating if the renderer must render sprites with pixel perfect rendering
   * Note that pixel perfect mode is not supported in WebGL 1
   */
  get pixelPerfect() {
    return this._pixelPerfect;
  }
  set pixelPerfect(e) {
    this._pixelPerfect !== e && (this._pixelPerfect = e, this._createEffects());
  }
  /**
   * Creates a new sprite Renderer
   * @param engine defines the engine the renderer works with
   * @param capacity defines the maximum allowed number of sprites
   * @param epsilon defines the epsilon value to align texture (0.01 by default)
   * @param scene defines the hosting scene
   */
  constructor(e, t, i = 0.01, s = null) {
    this.blendMode = 2, this.autoResetAlpha = !0, this.disableDepthWrite = !1, this.fogEnabled = !0, this._pixelPerfect = !1, this._useVAO = !1, this._useInstancing = !1, this._vertexBuffers = {}, this._capacity = t, this._epsilon = i, this._engine = e, this._useInstancing = e.getCaps().instancedArrays && e._features.supportSpriteInstancing, this._useVAO = e.getCaps().vertexArrayObject && !e.disableVertexArrayObjects, this._scene = s, this._useInstancing || this._buildIndexBuffer(), this._vertexBufferSize = this._useInstancing ? 16 : 18, this._vertexData = new Float32Array(t * this._vertexBufferSize * (this._useInstancing ? 1 : 4)), this._buffer = new gs(e, this._vertexData, !0, this._vertexBufferSize);
    const r = this._buffer.createVertexBuffer(v.PositionKind, 0, 4, this._vertexBufferSize, this._useInstancing), n = this._buffer.createVertexBuffer("options", 4, 2, this._vertexBufferSize, this._useInstancing);
    let a = 6, o;
    if (this._useInstancing) {
      const d = new Float32Array([0, 0, 1, 0, 0, 1, 1, 1]);
      this._spriteBuffer = new gs(e, d, !1, 2), o = this._spriteBuffer.createVertexBuffer("offsets", 0, 2);
    } else
      o = this._buffer.createVertexBuffer("offsets", a, 2, this._vertexBufferSize, this._useInstancing), a += 2;
    const l = this._buffer.createVertexBuffer("inverts", a, 2, this._vertexBufferSize, this._useInstancing), c = this._buffer.createVertexBuffer("cellInfo", a + 2, 4, this._vertexBufferSize, this._useInstancing), u = this._buffer.createVertexBuffer(v.ColorKind, a + 6, 4, this._vertexBufferSize, this._useInstancing);
    this._vertexBuffers[v.PositionKind] = r, this._vertexBuffers.options = n, this._vertexBuffers.offsets = o, this._vertexBuffers.inverts = l, this._vertexBuffers.cellInfo = c, this._vertexBuffers[v.ColorKind] = u, this._createEffects();
  }
  _createEffects() {
    var e, t, i, s;
    (e = this._drawWrapperBase) === null || e === void 0 || e.dispose(), (t = this._drawWrapperFog) === null || t === void 0 || t.dispose(), (i = this._drawWrapperDepth) === null || i === void 0 || i.dispose(), (s = this._drawWrapperFogDepth) === null || s === void 0 || s.dispose(), this._drawWrapperBase = new xi(this._engine), this._drawWrapperFog = new xi(this._engine), this._drawWrapperDepth = new xi(this._engine, !1), this._drawWrapperFogDepth = new xi(this._engine, !1), this._drawWrapperBase.drawContext && (this._drawWrapperBase.drawContext.useInstancing = this._useInstancing), this._drawWrapperFog.drawContext && (this._drawWrapperFog.drawContext.useInstancing = this._useInstancing), this._drawWrapperDepth.drawContext && (this._drawWrapperDepth.drawContext.useInstancing = this._useInstancing), this._drawWrapperFogDepth.drawContext && (this._drawWrapperFogDepth.drawContext.useInstancing = this._useInstancing);
    const r = this._pixelPerfect ? `#define PIXEL_PERFECT
` : "";
    this._drawWrapperBase.effect = this._engine.createEffect("sprites", [v.PositionKind, "options", "offsets", "inverts", "cellInfo", v.ColorKind], ["view", "projection", "textureInfos", "alphaTest"], ["diffuseSampler"], r), this._drawWrapperDepth.effect = this._drawWrapperBase.effect, this._drawWrapperDepth.materialContext = this._drawWrapperBase.materialContext, this._scene && (this._drawWrapperFog.effect = this._scene.getEngine().createEffect("sprites", [v.PositionKind, "options", "offsets", "inverts", "cellInfo", v.ColorKind], ["view", "projection", "textureInfos", "alphaTest", "vFogInfos", "vFogColor"], ["diffuseSampler"], r + "#define FOG"), this._drawWrapperFogDepth.effect = this._drawWrapperFog.effect, this._drawWrapperFogDepth.materialContext = this._drawWrapperFog.materialContext);
  }
  /**
   * Render all child sprites
   * @param sprites defines the list of sprites to render
   * @param deltaTime defines the time since last frame
   * @param viewMatrix defines the viewMatrix to use to render the sprites
   * @param projectionMatrix defines the projectionMatrix to use to render the sprites
   * @param customSpriteUpdate defines a custom function to update the sprites data before they render
   */
  render(e, t, i, s, r = null) {
    if (!this.texture || !this.texture.isReady() || !e.length)
      return;
    let n = this._drawWrapperBase, a = this._drawWrapperDepth, o = !1;
    this.fogEnabled && this._scene && this._scene.fogEnabled && this._scene.fogMode !== 0 && (n = this._drawWrapperFog, a = this._drawWrapperFogDepth, o = !0);
    const l = n.effect;
    if (!l.isReady())
      return;
    const c = this._engine, u = !!(this._scene && this._scene.useRightHandedSystem), d = this.texture.getBaseSize(), f = Math.min(this._capacity, e.length);
    let _ = 0, g = !0;
    for (let A = 0; A < f; A++) {
      const T = e[A];
      !T || !T.isVisible || (g = !1, T._animate(t), this._appendSpriteVertex(_++, T, 0, 0, d, u, r), this._useInstancing || (this._appendSpriteVertex(_++, T, 1, 0, d, u, r), this._appendSpriteVertex(_++, T, 1, 1, d, u, r), this._appendSpriteVertex(_++, T, 0, 1, d, u, r)));
    }
    if (g)
      return;
    this._buffer.update(this._vertexData);
    const m = !!c.depthCullingState.cull, y = c.depthCullingState.zOffset, x = c.depthCullingState.zOffsetUnits;
    if (c.setState(m, y, !1, !1, void 0, void 0, x), c.enableEffect(n), l.setTexture("diffuseSampler", this.texture), l.setMatrix("view", i), l.setMatrix("projection", s), o) {
      const A = this._scene;
      l.setFloat4("vFogInfos", A.fogMode, A.fogStart, A.fogEnd, A.fogDensity), l.setColor3("vFogColor", A.fogColor);
    }
    this._useVAO ? (this._vertexArrayObject || (this._vertexArrayObject = c.recordVertexArrayObject(this._vertexBuffers, this._indexBuffer, l)), c.bindVertexArrayObject(this._vertexArrayObject, this._indexBuffer)) : c.bindBuffers(this._vertexBuffers, this._indexBuffer, l), c.depthCullingState.depthFunc = c.useReverseDepthBuffer ? 518 : 515, this.disableDepthWrite || (l.setBool("alphaTest", !0), c.setColorWrite(!1), c.enableEffect(a), this._useInstancing ? c.drawArraysType(7, 0, 4, _) : c.drawElementsType(0, 0, _ / 4 * 6), c.enableEffect(n), c.setColorWrite(!0), l.setBool("alphaTest", !1)), c.setAlphaMode(this.blendMode), this._useInstancing ? c.drawArraysType(7, 0, 4, _) : c.drawElementsType(0, 0, _ / 4 * 6), this.autoResetAlpha && c.setAlphaMode(0), u && this._scene.getEngine().setState(m, y, !1, !0, void 0, void 0, x), c.unbindInstanceAttributes();
  }
  _appendSpriteVertex(e, t, i, s, r, n, a) {
    let o = e * this._vertexBufferSize;
    if (i === 0 ? i = this._epsilon : i === 1 && (i = 1 - this._epsilon), s === 0 ? s = this._epsilon : s === 1 && (s = 1 - this._epsilon), a)
      a(t, r);
    else {
      t.cellIndex || (t.cellIndex = 0);
      const l = r.width / this.cellWidth, c = t.cellIndex / l >> 0;
      t._xOffset = (t.cellIndex - c * l) * this.cellWidth / r.width, t._yOffset = c * this.cellHeight / r.height, t._xSize = this.cellWidth, t._ySize = this.cellHeight;
    }
    this._vertexData[o] = t.position.x, this._vertexData[o + 1] = t.position.y, this._vertexData[o + 2] = t.position.z, this._vertexData[o + 3] = t.angle, this._vertexData[o + 4] = t.width, this._vertexData[o + 5] = t.height, this._useInstancing ? o -= 2 : (this._vertexData[o + 6] = i, this._vertexData[o + 7] = s), n ? this._vertexData[o + 8] = t.invertU ? 0 : 1 : this._vertexData[o + 8] = t.invertU ? 1 : 0, this._vertexData[o + 9] = t.invertV ? 1 : 0, this._vertexData[o + 10] = t._xOffset, this._vertexData[o + 11] = t._yOffset, this._vertexData[o + 12] = t._xSize / r.width, this._vertexData[o + 13] = t._ySize / r.height, this._vertexData[o + 14] = t.color.r, this._vertexData[o + 15] = t.color.g, this._vertexData[o + 16] = t.color.b, this._vertexData[o + 17] = t.color.a;
  }
  _buildIndexBuffer() {
    const e = [];
    let t = 0;
    for (let i = 0; i < this._capacity; i++)
      e.push(t), e.push(t + 1), e.push(t + 2), e.push(t), e.push(t + 2), e.push(t + 3), t += 4;
    this._indexBuffer = this._engine.createIndexBuffer(e);
  }
  /**
   * Rebuilds the renderer (after a context lost, for eg)
   */
  rebuild() {
    var e;
    this._indexBuffer && this._buildIndexBuffer(), this._useVAO && (this._vertexArrayObject = void 0), this._buffer._rebuild();
    for (const t in this._vertexBuffers)
      this._vertexBuffers[t]._rebuild();
    (e = this._spriteBuffer) === null || e === void 0 || e._rebuild();
  }
  /**
   * Release associated resources
   */
  dispose() {
    this._buffer && (this._buffer.dispose(), this._buffer = null), this._spriteBuffer && (this._spriteBuffer.dispose(), this._spriteBuffer = null), this._indexBuffer && (this._engine._releaseBuffer(this._indexBuffer), this._indexBuffer = null), this._vertexArrayObject && (this._engine.releaseVertexArrayObject(this._vertexArrayObject), this._vertexArrayObject = null), this.texture && (this.texture.dispose(), this.texture = null), this._drawWrapperBase.dispose(), this._drawWrapperFog.dispose(), this._drawWrapperDepth.dispose(), this._drawWrapperFogDepth.dispose();
  }
}
class Ti {
  /**
   * Callback called when the manager is disposed
   */
  set onDispose(e) {
    this._onDisposeObserver && this.onDisposeObservable.remove(this._onDisposeObserver), this._onDisposeObserver = this.onDisposeObservable.add(e);
  }
  /**
   * Gets the array of sprites
   */
  get children() {
    return this.sprites;
  }
  /**
   * Gets the hosting scene
   */
  get scene() {
    return this._scene;
  }
  /**
   * Gets the capacity of the manager
   */
  get capacity() {
    return this._spriteRenderer.capacity;
  }
  /**
   * Gets or sets the spritesheet texture
   */
  get texture() {
    return this._spriteRenderer.texture;
  }
  set texture(e) {
    e.wrapU = W.CLAMP_ADDRESSMODE, e.wrapV = W.CLAMP_ADDRESSMODE, this._spriteRenderer.texture = e, this._textureContent = null;
  }
  /** Defines the default width of a cell in the spritesheet */
  get cellWidth() {
    return this._spriteRenderer.cellWidth;
  }
  set cellWidth(e) {
    this._spriteRenderer.cellWidth = e;
  }
  /** Defines the default height of a cell in the spritesheet */
  get cellHeight() {
    return this._spriteRenderer.cellHeight;
  }
  set cellHeight(e) {
    this._spriteRenderer.cellHeight = e;
  }
  /** Gets or sets a boolean indicating if the manager must consider scene fog when rendering */
  get fogEnabled() {
    return this._spriteRenderer.fogEnabled;
  }
  set fogEnabled(e) {
    this._spriteRenderer.fogEnabled = e;
  }
  /**
   * Blend mode use to render the particle, it can be any of
   * the static undefined properties provided in this class.
   * Default value is 2
   */
  get blendMode() {
    return this._spriteRenderer.blendMode;
  }
  set blendMode(e) {
    this._spriteRenderer.blendMode = e;
  }
  /** Disables writing to the depth buffer when rendering the sprites.
   *  It can be handy to disable depth writing when using textures without alpha channel
   *  and setting some specific blend modes.
   */
  get disableDepthWrite() {
    return this._disableDepthWrite;
  }
  set disableDepthWrite(e) {
    this._disableDepthWrite = e, this._spriteRenderer.disableDepthWrite = e;
  }
  /**
   * Gets or sets a boolean indicating if the renderer must render sprites with pixel perfect rendering
   * In this mode, sprites are rendered as "pixel art", which means that they appear as pixelated but remain stable when moving or when rotated or scaled.
   * Note that for this mode to work as expected, the sprite texture must use the BILINEAR sampling mode, not NEAREST!
   */
  get pixelPerfect() {
    return this._spriteRenderer.pixelPerfect;
  }
  set pixelPerfect(e) {
    this._spriteRenderer.pixelPerfect = e, e && this.texture.samplingMode !== 3 && this.texture.updateSamplingMode(3);
  }
  /**
   * Creates a new sprite manager
   * @param name defines the manager's name
   * @param imgUrl defines the sprite sheet url
   * @param capacity defines the maximum allowed number of sprites
   * @param cellSize defines the size of a sprite cell
   * @param scene defines the hosting scene
   * @param epsilon defines the epsilon value to align texture (0.01 by default)
   * @param samplingMode defines the sampling mode to use with spritesheet
   * @param fromPacked set to false; do not alter
   * @param spriteJSON null otherwise a JSON object defining sprite sheet data; do not alter
   */
  constructor(e, t, i, s, r, n = 0.01, a = W.TRILINEAR_SAMPLINGMODE, o = !1, l = null) {
    this.name = e, this.sprites = new Array(), this.renderingGroupId = 0, this.layerMask = 268435455, this.isPickable = !1, this.metadata = null, this._wasDispatched = !1, this.onDisposeObservable = new N(), this._disableDepthWrite = !1, this._packedAndReady = !1, this._customUpdate = (u, d) => {
      u.cellRef || (u.cellIndex = 0);
      const f = u.cellIndex;
      typeof f == "number" && isFinite(f) && Math.floor(f) === f && (u.cellRef = this._spriteMap[u.cellIndex]), u._xOffset = this._cellData[u.cellRef].frame.x / d.width, u._yOffset = this._cellData[u.cellRef].frame.y / d.height, u._xSize = this._cellData[u.cellRef].frame.w, u._ySize = this._cellData[u.cellRef].frame.h;
    }, r || (r = de.LastCreatedScene), r._getComponent(ne.NAME_SPRITE) || r._addComponent(new oc(r)), this._fromPacked = o, this._scene = r;
    const c = this._scene.getEngine();
    if (this._spriteRenderer = new Ec(c, i, n, r), s.width && s.height)
      this.cellWidth = s.width, this.cellHeight = s.height;
    else if (s !== void 0)
      this.cellWidth = s, this.cellHeight = s;
    else {
      this._spriteRenderer = null;
      return;
    }
    this._scene.spriteManagers && this._scene.spriteManagers.push(this), this.uniqueId = this.scene.getUniqueId(), t && (this.texture = new W(t, r, !0, !1, a)), this._fromPacked && this._makePacked(t, l);
  }
  /**
   * Returns the string "SpriteManager"
   * @returns "SpriteManager"
   */
  getClassName() {
    return "SpriteManager";
  }
  _makePacked(e, t) {
    if (t !== null)
      try {
        let i;
        if (typeof t == "string" ? i = JSON.parse(t) : i = t, i.frames.length) {
          const r = {};
          for (let n = 0; n < i.frames.length; n++) {
            const a = i.frames[n];
            if (typeof Object.keys(a)[0] != "string")
              throw new Error("Invalid JSON Format.  Check the frame values and make sure the name is the first parameter.");
            const o = a[Object.keys(a)[0]];
            r[o] = a;
          }
          i.frames = r;
        }
        const s = Reflect.ownKeys(i.frames);
        this._spriteMap = s, this._packedAndReady = !0, this._cellData = i.frames;
      } catch {
        throw this._fromPacked = !1, this._packedAndReady = !1, new Error("Invalid JSON from string. Spritesheet managed with constant cell size.");
      }
    else {
      const i = /\./g;
      let s;
      do
        s = i.lastIndex, i.test(e);
      while (i.lastIndex > 0);
      const r = e.substring(0, s - 1) + ".json", n = () => {
        w.Error("JSON ERROR: Unable to load JSON file."), this._fromPacked = !1, this._packedAndReady = !1;
      }, a = (o) => {
        try {
          const l = JSON.parse(o), c = Reflect.ownKeys(l.frames);
          this._spriteMap = c, this._packedAndReady = !0, this._cellData = l.frames;
        } catch {
          throw this._fromPacked = !1, this._packedAndReady = !1, new Error("Invalid JSON format. Please check documentation for format specifications.");
        }
      };
      z.LoadFile(r, a, void 0, void 0, !1, n);
    }
  }
  _checkTextureAlpha(e, t, i, s, r) {
    if (!e.useAlphaForPicking || !this.texture)
      return !0;
    const n = this.texture.getSize();
    this._textureContent || (this._textureContent = new Uint8Array(n.width * n.height * 4), this.texture.readPixels(0, 0, this._textureContent));
    const a = C.Vector3[0];
    a.copyFrom(t.direction), a.normalize(), a.scaleInPlace(i), a.addInPlace(t.origin);
    const o = (a.x - s.x) / (r.x - s.x), l = 1 - (a.y - s.y) / (r.y - s.y), c = e._xOffset * n.width + o * e._xSize | 0, u = e._yOffset * n.height + l * e._ySize | 0;
    return this._textureContent[(c + u * n.width) * 4 + 3] > 0.5;
  }
  /**
   * Intersects the sprites with a ray
   * @param ray defines the ray to intersect with
   * @param camera defines the current active camera
   * @param predicate defines a predicate used to select candidate sprites
   * @param fastCheck defines if a fast check only must be done (the first potential sprite is will be used and not the closer)
   * @returns null if no hit or a PickingInfo
   */
  intersects(e, t, i, s) {
    const r = Math.min(this.capacity, this.sprites.length), n = p.Zero(), a = p.Zero();
    let o = Number.MAX_VALUE, l = null;
    const c = C.Vector3[0], u = C.Vector3[1], d = t.getViewMatrix();
    let f = e, _ = e;
    for (let g = 0; g < r; g++) {
      const m = this.sprites[g];
      if (m) {
        if (i) {
          if (!i(m))
            continue;
        } else if (!m.isPickable)
          continue;
        if (p.TransformCoordinatesToRef(m.position, d, u), m.angle ? (I.TranslationToRef(-u.x, -u.y, 0, C.Matrix[1]), I.TranslationToRef(u.x, u.y, 0, C.Matrix[2]), I.RotationZToRef(-m.angle, C.Matrix[3]), C.Matrix[1].multiplyToRef(C.Matrix[3], C.Matrix[4]), C.Matrix[4].multiplyToRef(C.Matrix[2], C.Matrix[0]), f = e.clone(), p.TransformCoordinatesToRef(e.origin, C.Matrix[0], f.origin), p.TransformNormalToRef(e.direction, C.Matrix[0], f.direction)) : f = e, n.copyFromFloats(u.x - m.width / 2, u.y - m.height / 2, u.z), a.copyFromFloats(u.x + m.width / 2, u.y + m.height / 2, u.z), f.intersectsBoxMinMax(n, a)) {
          const y = p.Distance(u, f.origin);
          if (o > y) {
            if (!this._checkTextureAlpha(m, f, y, n, a))
              continue;
            if (_ = f, o = y, l = m, s)
              break;
          }
        }
      }
    }
    if (l) {
      const g = new Gt();
      d.invertToRef(C.Matrix[0]), g.hit = !0, g.pickedSprite = l, g.distance = o;
      const m = C.Vector3[2];
      return m.copyFrom(_.direction), m.normalize(), m.scaleInPlace(o), _.origin.addToRef(m, c), g.pickedPoint = p.TransformCoordinates(c, C.Matrix[0]), g;
    }
    return null;
  }
  /**
   * Intersects the sprites with a ray
   * @param ray defines the ray to intersect with
   * @param camera defines the current active camera
   * @param predicate defines a predicate used to select candidate sprites
   * @returns null if no hit or a PickingInfo array
   */
  multiIntersects(e, t, i) {
    const s = Math.min(this.capacity, this.sprites.length), r = p.Zero(), n = p.Zero();
    let a;
    const o = [], l = C.Vector3[0].copyFromFloats(0, 0, 0), c = C.Vector3[1].copyFromFloats(0, 0, 0), u = t.getViewMatrix();
    for (let d = 0; d < s; d++) {
      const f = this.sprites[d];
      if (f) {
        if (i) {
          if (!i(f))
            continue;
        } else if (!f.isPickable)
          continue;
        if (p.TransformCoordinatesToRef(f.position, u, c), r.copyFromFloats(c.x - f.width / 2, c.y - f.height / 2, c.z), n.copyFromFloats(c.x + f.width / 2, c.y + f.height / 2, c.z), e.intersectsBoxMinMax(r, n)) {
          if (a = p.Distance(c, e.origin), !this._checkTextureAlpha(f, e, a, r, n))
            continue;
          const _ = new Gt();
          o.push(_), u.invertToRef(C.Matrix[0]), _.hit = !0, _.pickedSprite = f, _.distance = a;
          const g = C.Vector3[2];
          g.copyFrom(e.direction), g.normalize(), g.scaleInPlace(a), e.origin.addToRef(g, l), _.pickedPoint = p.TransformCoordinates(l, C.Matrix[0]);
        }
      }
    }
    return o;
  }
  /**
   * Render all child sprites
   */
  render() {
    if (this._fromPacked && (!this._packedAndReady || !this._spriteMap || !this._cellData))
      return;
    const t = this._scene.getEngine().getDeltaTime();
    this._packedAndReady ? this._spriteRenderer.render(this.sprites, t, this._scene.getViewMatrix(), this._scene.getProjectionMatrix(), this._customUpdate) : this._spriteRenderer.render(this.sprites, t, this._scene.getViewMatrix(), this._scene.getProjectionMatrix());
  }
  /**
   * Rebuilds the manager (after a context lost, for eg)
   */
  rebuild() {
    var e;
    (e = this._spriteRenderer) === null || e === void 0 || e.rebuild();
  }
  /**
   * Release associated resources
   */
  dispose() {
    if (this._spriteRenderer && (this._spriteRenderer.dispose(), this._spriteRenderer = null), this._textureContent = null, this._scene.spriteManagers) {
      const e = this._scene.spriteManagers.indexOf(this);
      this._scene.spriteManagers.splice(e, 1);
    }
    this.onDisposeObservable.notifyObservers(this), this.onDisposeObservable.clear(), this.metadata = null;
  }
  /**
   * Serializes the sprite manager to a JSON object
   * @param serializeTexture defines if the texture must be serialized as well
   * @returns the JSON object
   */
  serialize(e = !1) {
    const t = {};
    t.name = this.name, t.capacity = this.capacity, t.cellWidth = this.cellWidth, t.cellHeight = this.cellHeight, t.fogEnabled = this.fogEnabled, t.blendMode = this.blendMode, t.disableDepthWrite = this.disableDepthWrite, t.pixelPerfect = this.pixelPerfect, this.texture && (e ? t.texture = this.texture.serialize() : (t.textureUrl = this.texture.name, t.invertY = this.texture._invertY)), t.sprites = [];
    for (const i of this.sprites)
      t.sprites.push(i.serialize());
    return t.metadata = this.metadata, t;
  }
  /**
   * Parses a JSON object to create a new sprite manager.
   * @param parsedManager The JSON object to parse
   * @param scene The scene to create the sprite manager
   * @param rootUrl The root url to use to load external dependencies like texture
   * @returns the new sprite manager
   */
  static Parse(e, t, i) {
    const s = new Ti(e.name, "", e.capacity, {
      width: e.cellWidth,
      height: e.cellHeight
    }, t);
    e.fogEnabled !== void 0 && (s.fogEnabled = e.fogEnabled), e.blendMode !== void 0 && (s.blendMode = e.blendMode), e.disableDepthWrite !== void 0 && (s.disableDepthWrite = e.disableDepthWrite), e.pixelPerfect !== void 0 && (s.pixelPerfect = e.pixelPerfect), e.metadata !== void 0 && (s.metadata = e.metadata), e.texture ? s.texture = W.Parse(e.texture, t, i) : e.textureName && (s.texture = new W(i + e.textureUrl, t, !1, e.invertY !== void 0 ? e.invertY : !0));
    for (const r of e.sprites)
      _s.Parse(r, s);
    return s;
  }
  /**
   * Creates a sprite manager from a snippet saved in a remote file
   * @param name defines the name of the sprite manager to create (can be null or empty to use the one from the json data)
   * @param url defines the url to load from
   * @param scene defines the hosting scene
   * @param rootUrl defines the root URL to use to load textures and relative dependencies
   * @returns a promise that will resolve to the new sprite manager
   */
  static ParseFromFileAsync(e, t, i, s = "") {
    return new Promise((r, n) => {
      const a = new mt();
      a.addEventListener("readystatechange", () => {
        if (a.readyState == 4)
          if (a.status == 200) {
            const o = JSON.parse(a.responseText), l = Ti.Parse(o, i || de.LastCreatedScene, s);
            e && (l.name = e), r(l);
          } else
            n("Unable to load the sprite manager");
      }), a.open("GET", t), a.send();
    });
  }
  /**
   * Creates a sprite manager from a snippet saved by the sprite editor
   * @param snippetId defines the snippet to load (can be set to _BLANK to create a default one)
   * @param scene defines the hosting scene
   * @param rootUrl defines the root URL to use to load textures and relative dependencies
   * @returns a promise that will resolve to the new sprite manager
   */
  static ParseFromSnippetAsync(e, t, i = "") {
    return e === "_BLANK" ? Promise.resolve(new Ti("Default sprite manager", "//playground.babylonjs.com/textures/player.png", 500, 64, t)) : new Promise((s, r) => {
      const n = new mt();
      n.addEventListener("readystatechange", () => {
        if (n.readyState == 4)
          if (n.status == 200) {
            const a = JSON.parse(JSON.parse(n.responseText).jsonPayload), o = JSON.parse(a.spriteManager), l = Ti.Parse(o, t || de.LastCreatedScene, i);
            l.snippetId = e, s(l);
          } else
            r("Unable to load the snippet " + e);
      }), n.open("GET", this.SnippetUrl + "/" + e.replace(/#/g, "/")), n.send();
    });
  }
}
Ti.SnippetUrl = "https://snippet.babylonjs.com";
Ti.CreateFromSnippetAsync = Ti.ParseFromSnippetAsync;
const Mc = Object.freeze(new U(0, 0, 0, 0)), Sc = Object.freeze(p.Zero()), Rc = Object.freeze(ue.Zero()), Ic = Object.freeze(Zt.Zero()), Pc = Object.freeze(ie.Black());
class Cc {
  /**
   * Gets the current frame of the runtime animation
   */
  get currentFrame() {
    return this._currentFrame;
  }
  /**
   * Gets the weight of the runtime animation
   */
  get weight() {
    return this._weight;
  }
  /**
   * Gets the current value of the runtime animation
   */
  get currentValue() {
    return this._currentValue;
  }
  /**
   * Gets or sets the target path of the runtime animation
   */
  get targetPath() {
    return this._targetPath;
  }
  /**
   * Gets the actual target of the runtime animation
   */
  get target() {
    return this._currentActiveTarget;
  }
  /**
   * Gets the additive state of the runtime animation
   */
  get isAdditive() {
    return this._host && this._host.isAdditive;
  }
  /**
   * Create a new RuntimeAnimation object
   * @param target defines the target of the animation
   * @param animation defines the source animation object
   * @param scene defines the hosting scene
   * @param host defines the initiating Animatable
   */
  constructor(e, t, i, s) {
    if (this._events = new Array(), this._currentFrame = 0, this._originalValue = new Array(), this._originalBlendValue = null, this._offsetsCache = {}, this._highLimitsCache = {}, this._stopped = !1, this._blendingFactor = 0, this._currentValue = null, this._currentActiveTarget = null, this._directTarget = null, this._targetPath = "", this._weight = 1, this._absoluteFrameOffset = 0, this._previousElapsedTime = 0, this._previousAbsoluteFrame = 0, this._targetIsArray = !1, this._animation = t, this._target = e, this._scene = i, this._host = s, this._activeTargets = [], t._runtimeAnimations.push(this), this._animationState = {
      key: 0,
      repeatCount: 0,
      loopMode: this._getCorrectLoopMode()
    }, this._animation.dataType === B.ANIMATIONTYPE_MATRIX && (this._animationState.workValue = I.Zero()), this._keys = this._animation.getKeys(), this._minFrame = this._keys[0].frame, this._maxFrame = this._keys[this._keys.length - 1].frame, this._minValue = this._keys[0].value, this._maxValue = this._keys[this._keys.length - 1].value, this._minFrame !== 0) {
      const n = { frame: 0, value: this._minValue };
      this._keys.splice(0, 0, n);
    }
    if (this._target instanceof Array) {
      let n = 0;
      for (const a of this._target)
        this._preparePath(a, n), this._getOriginalValues(n), n++;
      this._targetIsArray = !0;
    } else
      this._preparePath(this._target), this._getOriginalValues(), this._targetIsArray = !1, this._directTarget = this._activeTargets[0];
    const r = t.getEvents();
    r && r.length > 0 && r.forEach((n) => {
      this._events.push(n._clone());
    }), this._enableBlending = e && e.animationPropertiesOverride ? e.animationPropertiesOverride.enableBlending : this._animation.enableBlending;
  }
  _preparePath(e, t = 0) {
    const i = this._animation.targetPropertyPath;
    if (i.length > 1) {
      let s = e[i[0]];
      for (let r = 1; r < i.length - 1; r++)
        s = s[i[r]];
      this._targetPath = i[i.length - 1], this._activeTargets[t] = s;
    } else
      this._targetPath = i[0], this._activeTargets[t] = e;
  }
  /**
   * Gets the animation from the runtime animation
   */
  get animation() {
    return this._animation;
  }
  /**
   * Resets the runtime animation to the beginning
   * @param restoreOriginal defines whether to restore the target property to the original value
   */
  reset(e = !1) {
    if (e)
      if (this._target instanceof Array) {
        let t = 0;
        for (const i of this._target)
          this._originalValue[t] !== void 0 && this._setValue(i, this._activeTargets[t], this._originalValue[t], -1, t), t++;
      } else
        this._originalValue[0] !== void 0 && this._setValue(this._target, this._directTarget, this._originalValue[0], -1, 0);
    this._offsetsCache = {}, this._highLimitsCache = {}, this._currentFrame = 0, this._blendingFactor = 0;
    for (let t = 0; t < this._events.length; t++)
      this._events[t].isDone = !1;
  }
  /**
   * Specifies if the runtime animation is stopped
   * @returns Boolean specifying if the runtime animation is stopped
   */
  isStopped() {
    return this._stopped;
  }
  /**
   * Disposes of the runtime animation
   */
  dispose() {
    const e = this._animation.runtimeAnimations.indexOf(this);
    e > -1 && this._animation.runtimeAnimations.splice(e, 1);
  }
  /**
   * Apply the interpolated value to the target
   * @param currentValue defines the value computed by the animation
   * @param weight defines the weight to apply to this value (Defaults to 1.0)
   */
  setValue(e, t) {
    if (this._targetIsArray) {
      for (let i = 0; i < this._target.length; i++) {
        const s = this._target[i];
        this._setValue(s, this._activeTargets[i], e, t, i);
      }
      return;
    }
    this._setValue(this._target, this._directTarget, e, t, 0);
  }
  _getOriginalValues(e = 0) {
    let t;
    const i = this._activeTargets[e];
    i.getRestPose && this._targetPath === "_matrix" ? t = i.getRestPose() : t = i[this._targetPath], t && t.clone ? this._originalValue[e] = t.clone() : this._originalValue[e] = t;
  }
  _setValue(e, t, i, s, r) {
    if (this._currentActiveTarget = t, this._weight = s, this._enableBlending && this._blendingFactor <= 1) {
      if (!this._originalBlendValue) {
        const a = t[this._targetPath];
        a.clone ? this._originalBlendValue = a.clone() : this._originalBlendValue = a;
      }
      this._originalBlendValue.m ? B.AllowMatrixDecomposeForInterpolation ? this._currentValue ? I.DecomposeLerpToRef(this._originalBlendValue, i, this._blendingFactor, this._currentValue) : this._currentValue = I.DecomposeLerp(this._originalBlendValue, i, this._blendingFactor) : this._currentValue ? I.LerpToRef(this._originalBlendValue, i, this._blendingFactor, this._currentValue) : this._currentValue = I.Lerp(this._originalBlendValue, i, this._blendingFactor) : this._currentValue = B._UniversalLerp(this._originalBlendValue, i, this._blendingFactor);
      const n = e && e.animationPropertiesOverride ? e.animationPropertiesOverride.blendingSpeed : this._animation.blendingSpeed;
      this._blendingFactor += n;
    } else
      this._currentValue ? this._currentValue.copyFrom ? this._currentValue.copyFrom(i) : this._currentValue = i : i != null && i.clone ? this._currentValue = i.clone() : this._currentValue = i;
    s !== -1 ? this._scene._registerTargetForLateAnimationBinding(this, this._originalValue[r]) : t[this._targetPath] = this._currentValue, e.markAsDirty && e.markAsDirty(this._animation.targetProperty);
  }
  /**
   * Gets the loop pmode of the runtime animation
   * @returns Loop Mode
   */
  _getCorrectLoopMode() {
    return this._target && this._target.animationPropertiesOverride ? this._target.animationPropertiesOverride.loopMode : this._animation.loopMode;
  }
  /**
   * Move the current animation to a given frame
   * @param frame defines the frame to move to
   */
  goToFrame(e) {
    const t = this._animation.getKeys();
    e < t[0].frame ? e = t[0].frame : e > t[t.length - 1].frame && (e = t[t.length - 1].frame);
    const i = this._events;
    if (i.length)
      for (let r = 0; r < i.length; r++)
        i[r].onlyOnce || (i[r].isDone = i[r].frame < e);
    this._currentFrame = e;
    const s = this._animation._interpolate(e, this._animationState);
    this.setValue(s, -1);
  }
  /**
   * @internal Internal use only
   */
  _prepareForSpeedRatioChange(e) {
    const t = this._previousElapsedTime * (this._animation.framePerSecond * e) / 1e3;
    this._absoluteFrameOffset = this._previousAbsoluteFrame - t;
  }
  /**
   * Execute the current animation
   * @param elapsedTimeSinceAnimationStart defines the elapsed time (in milliseconds) since the animation was started
   * @param from defines the lower frame of the animation range
   * @param to defines the upper frame of the animation range
   * @param loop defines if the current animation must loop
   * @param speedRatio defines the current speed ratio
   * @param weight defines the weight of the animation (default is -1 so no weight)
   * @returns a boolean indicating if the animation is running
   */
  animate(e, t, i, s, r, n = -1) {
    const a = this._animation, o = a.targetPropertyPath;
    if (!o || o.length < 1)
      return this._stopped = !0, !1;
    let l = !0;
    (t < this._minFrame || t > this._maxFrame) && (t = this._minFrame), (i < this._minFrame || i > this._maxFrame) && (i = this._maxFrame);
    const c = i - t;
    let u, d = e * (a.framePerSecond * r) / 1e3 + this._absoluteFrameOffset, f = 0;
    if (s && this._animationState.loopMode === B.ANIMATIONLOOPMODE_YOYO) {
      const y = (d - t) / c;
      d = Math.abs(Math.sin(y * Math.PI)) * c + t;
    }
    if (this._previousElapsedTime = e, this._previousAbsoluteFrame = d, !s && i >= t && d >= c)
      l = !1, f = a._getKeyValue(this._maxValue);
    else if (!s && t >= i && d <= c)
      l = !1, f = a._getKeyValue(this._minValue);
    else if (this._animationState.loopMode !== B.ANIMATIONLOOPMODE_CYCLE) {
      const y = i.toString() + t.toString();
      if (!this._offsetsCache[y]) {
        this._animationState.repeatCount = 0, this._animationState.loopMode = B.ANIMATIONLOOPMODE_CYCLE;
        const x = a._interpolate(t, this._animationState), A = a._interpolate(i, this._animationState);
        switch (this._animationState.loopMode = this._getCorrectLoopMode(), a.dataType) {
          case B.ANIMATIONTYPE_FLOAT:
            this._offsetsCache[y] = A - x;
            break;
          case B.ANIMATIONTYPE_QUATERNION:
            this._offsetsCache[y] = A.subtract(x);
            break;
          case B.ANIMATIONTYPE_VECTOR3:
            this._offsetsCache[y] = A.subtract(x);
            break;
          case B.ANIMATIONTYPE_VECTOR2:
            this._offsetsCache[y] = A.subtract(x);
            break;
          case B.ANIMATIONTYPE_SIZE:
            this._offsetsCache[y] = A.subtract(x);
            break;
          case B.ANIMATIONTYPE_COLOR3:
            this._offsetsCache[y] = A.subtract(x);
            break;
        }
        this._highLimitsCache[y] = A;
      }
      f = this._highLimitsCache[y], u = this._offsetsCache[y];
    }
    if (u === void 0)
      switch (a.dataType) {
        case B.ANIMATIONTYPE_FLOAT:
          u = 0;
          break;
        case B.ANIMATIONTYPE_QUATERNION:
          u = Mc;
          break;
        case B.ANIMATIONTYPE_VECTOR3:
          u = Sc;
          break;
        case B.ANIMATIONTYPE_VECTOR2:
          u = Rc;
          break;
        case B.ANIMATIONTYPE_SIZE:
          u = Ic;
          break;
        case B.ANIMATIONTYPE_COLOR3:
          u = Pc;
      }
    let _;
    if (this._host && this._host.syncRoot) {
      const y = this._host.syncRoot, x = (y.masterFrame - y.fromFrame) / (y.toFrame - y.fromFrame);
      _ = t + c * x;
    } else
      d > 0 && t > i || d < 0 && t < i ? _ = l && c !== 0 ? i + d % c : t : _ = l && c !== 0 ? t + d % c : i;
    const g = this._events;
    if (r > 0 && this.currentFrame > _ || r < 0 && this.currentFrame < _) {
      this._onLoop();
      for (let y = 0; y < g.length; y++)
        g[y].onlyOnce || (g[y].isDone = !1);
      this._animationState.key = r > 0 ? 0 : a.getKeys().length - 1;
    }
    this._currentFrame = _, this._animationState.repeatCount = c === 0 ? 0 : d / c >> 0, this._animationState.highLimitValue = f, this._animationState.offsetValue = u;
    const m = a._interpolate(_, this._animationState);
    if (this.setValue(m, n), g.length) {
      for (let y = 0; y < g.length; y++)
        if (c > 0 && _ >= g[y].frame && g[y].frame >= t || c < 0 && _ <= g[y].frame && g[y].frame <= t) {
          const x = g[y];
          x.isDone || (x.onlyOnce && (g.splice(y, 1), y--), x.isDone = !0, x.action(_));
        }
    }
    return l || (this._stopped = !0), l;
  }
}
class mo {
  /**
   * Gets the root Animatable used to synchronize and normalize animations
   */
  get syncRoot() {
    return this._syncRoot;
  }
  /**
   * Gets the current frame of the first RuntimeAnimation
   * Used to synchronize Animatables
   */
  get masterFrame() {
    return this._runtimeAnimations.length === 0 ? 0 : this._runtimeAnimations[0].currentFrame;
  }
  /**
   * Gets or sets the animatable weight (-1.0 by default meaning not weighted)
   */
  get weight() {
    return this._weight;
  }
  set weight(e) {
    if (e === -1) {
      this._weight = -1;
      return;
    }
    this._weight = Math.min(Math.max(e, 0), 1);
  }
  /**
   * Gets or sets the speed ratio to apply to the animatable (1.0 by default)
   */
  get speedRatio() {
    return this._speedRatio;
  }
  set speedRatio(e) {
    for (let t = 0; t < this._runtimeAnimations.length; t++)
      this._runtimeAnimations[t]._prepareForSpeedRatioChange(e);
    this._speedRatio = e, this._goToFrame !== null && this.goToFrame(this._goToFrame);
  }
  /**
   * Creates a new Animatable
   * @param scene defines the hosting scene
   * @param target defines the target object
   * @param fromFrame defines the starting frame number (default is 0)
   * @param toFrame defines the ending frame number (default is 100)
   * @param loopAnimation defines if the animation must loop (default is false)
   * @param speedRatio defines the factor to apply to animation speed (default is 1)
   * @param onAnimationEnd defines a callback to call when animation ends if it is not looping
   * @param animations defines a group of animation to add to the new Animatable
   * @param onAnimationLoop defines a callback to call when animation loops
   * @param isAdditive defines whether the animation should be evaluated additively
   * @param playOrder defines the order in which this animatable should be processed in the list of active animatables (default: 0)
   */
  constructor(e, t, i = 0, s = 100, r = !1, n = 1, a, o, l, c = !1, u = 0) {
    this.target = t, this.fromFrame = i, this.toFrame = s, this.loopAnimation = r, this.onAnimationEnd = a, this.onAnimationLoop = l, this.isAdditive = c, this.playOrder = u, this._localDelayOffset = null, this._pausedDelay = null, this._manualJumpDelay = null, this._runtimeAnimations = new Array(), this._paused = !1, this._speedRatio = 1, this._weight = -1, this._syncRoot = null, this._frameToSyncFromJump = null, this._goToFrame = null, this.disposeOnEnd = !0, this.animationStarted = !1, this.onAnimationEndObservable = new N(), this.onAnimationLoopObservable = new N(), this._scene = e, o && this.appendAnimations(t, o), this._speedRatio = n, e._activeAnimatables.push(this);
  }
  // Methods
  /**
   * Synchronize and normalize current Animatable with a source Animatable
   * This is useful when using animation weights and when animations are not of the same length
   * @param root defines the root Animatable to synchronize with (null to stop synchronizing)
   * @returns the current Animatable
   */
  syncWith(e) {
    if (this._syncRoot = e, e) {
      const t = this._scene._activeAnimatables.indexOf(this);
      t > -1 && (this._scene._activeAnimatables.splice(t, 1), this._scene._activeAnimatables.push(this));
    }
    return this;
  }
  /**
   * Gets the list of runtime animations
   * @returns an array of RuntimeAnimation
   */
  getAnimations() {
    return this._runtimeAnimations;
  }
  /**
   * Adds more animations to the current animatable
   * @param target defines the target of the animations
   * @param animations defines the new animations to add
   */
  appendAnimations(e, t) {
    for (let i = 0; i < t.length; i++) {
      const s = t[i], r = new Cc(e, s, this._scene, this);
      r._onLoop = () => {
        this.onAnimationLoopObservable.notifyObservers(this), this.onAnimationLoop && this.onAnimationLoop();
      }, this._runtimeAnimations.push(r);
    }
  }
  /**
   * Gets the source animation for a specific property
   * @param property defines the property to look for
   * @returns null or the source animation for the given property
   */
  getAnimationByTargetProperty(e) {
    const t = this._runtimeAnimations;
    for (let i = 0; i < t.length; i++)
      if (t[i].animation.targetProperty === e)
        return t[i].animation;
    return null;
  }
  /**
   * Gets the runtime animation for a specific property
   * @param property defines the property to look for
   * @returns null or the runtime animation for the given property
   */
  getRuntimeAnimationByTargetProperty(e) {
    const t = this._runtimeAnimations;
    for (let i = 0; i < t.length; i++)
      if (t[i].animation.targetProperty === e)
        return t[i];
    return null;
  }
  /**
   * Resets the animatable to its original state
   */
  reset() {
    const e = this._runtimeAnimations;
    for (let t = 0; t < e.length; t++)
      e[t].reset(!0);
    this._localDelayOffset = null, this._pausedDelay = null;
  }
  /**
   * Allows the animatable to blend with current running animations
   * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#animation-blending
   * @param blendingSpeed defines the blending speed to use
   */
  enableBlending(e) {
    const t = this._runtimeAnimations;
    for (let i = 0; i < t.length; i++)
      t[i].animation.enableBlending = !0, t[i].animation.blendingSpeed = e;
  }
  /**
   * Disable animation blending
   * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#animation-blending
   */
  disableBlending() {
    const e = this._runtimeAnimations;
    for (let t = 0; t < e.length; t++)
      e[t].animation.enableBlending = !1;
  }
  /**
   * Jump directly to a given frame
   * @param frame defines the frame to jump to
   */
  goToFrame(e) {
    var t;
    const i = this._runtimeAnimations;
    if (i[0]) {
      const s = i[0].animation.framePerSecond;
      this._frameToSyncFromJump = (t = this._frameToSyncFromJump) !== null && t !== void 0 ? t : i[0].currentFrame;
      const r = this.speedRatio === 0 ? 0 : (e - this._frameToSyncFromJump) / s * 1e3 / this.speedRatio;
      this._manualJumpDelay = -r;
    }
    for (let s = 0; s < i.length; s++)
      i[s].goToFrame(e);
    this._goToFrame = e;
  }
  /**
   * Returns true if the animations for this animatable are paused
   */
  get paused() {
    return this._paused;
  }
  /**
   * Pause the animation
   */
  pause() {
    this._paused || (this._paused = !0);
  }
  /**
   * Restart the animation
   */
  restart() {
    this._paused = !1;
  }
  _raiseOnAnimationEnd() {
    this.onAnimationEnd && this.onAnimationEnd(), this.onAnimationEndObservable.notifyObservers(this);
  }
  /**
   * Stop and delete the current animation
   * @param animationName defines a string used to only stop some of the runtime animations instead of all
   * @param targetMask a function that determines if the animation should be stopped based on its target (all animations will be stopped if both this and animationName are empty)
   * @param useGlobalSplice if true, the animatables will be removed by the caller of this function (false by default)
   */
  stop(e, t, i = !1) {
    if (e || t) {
      const s = this._scene._activeAnimatables.indexOf(this);
      if (s > -1) {
        const r = this._runtimeAnimations;
        for (let n = r.length - 1; n >= 0; n--) {
          const a = r[n];
          e && a.animation.name != e || t && !t(a.target) || (a.dispose(), r.splice(n, 1));
        }
        r.length == 0 && (i || this._scene._activeAnimatables.splice(s, 1), this._raiseOnAnimationEnd());
      }
    } else {
      const s = this._scene._activeAnimatables.indexOf(this);
      if (s > -1) {
        i || this._scene._activeAnimatables.splice(s, 1);
        const r = this._runtimeAnimations;
        for (let n = 0; n < r.length; n++)
          r[n].dispose();
        this._runtimeAnimations.length = 0, this._raiseOnAnimationEnd();
      }
    }
  }
  /**
   * Wait asynchronously for the animation to end
   * @returns a promise which will be fulfilled when the animation ends
   */
  waitAsync() {
    return new Promise((e) => {
      this.onAnimationEndObservable.add(() => {
        e(this);
      }, void 0, void 0, this, !0);
    });
  }
  /**
   * @internal
   */
  _animate(e) {
    if (this._paused)
      return this.animationStarted = !1, this._pausedDelay === null && (this._pausedDelay = e), !0;
    if (this._localDelayOffset === null ? (this._localDelayOffset = e, this._pausedDelay = null) : this._pausedDelay !== null && (this._localDelayOffset += e - this._pausedDelay, this._pausedDelay = null), this._manualJumpDelay !== null && (this._localDelayOffset += this._manualJumpDelay, this._manualJumpDelay = null, this._frameToSyncFromJump = null), this._goToFrame = null, this._weight === 0)
      return !0;
    let t = !1;
    const i = this._runtimeAnimations;
    let s;
    for (s = 0; s < i.length; s++) {
      const n = i[s].animate(e - this._localDelayOffset, this.fromFrame, this.toFrame, this.loopAnimation, this._speedRatio, this._weight);
      t = t || n;
    }
    if (this.animationStarted = t, !t) {
      if (this.disposeOnEnd)
        for (s = this._scene._activeAnimatables.indexOf(this), this._scene._activeAnimatables.splice(s, 1), s = 0; s < i.length; s++)
          i[s].dispose();
      this._raiseOnAnimationEnd(), this.disposeOnEnd && (this.onAnimationEnd = null, this.onAnimationLoop = null, this.onAnimationLoopObservable.clear(), this.onAnimationEndObservable.clear());
    }
    return t;
  }
}
ge.prototype._animate = function() {
  if (!this.animationsEnabled)
    return;
  const h = Kt.Now;
  if (!this._animationTimeLast) {
    if (this._pendingData.length > 0)
      return;
    this._animationTimeLast = h;
  }
  this.deltaTime = this.useConstantAnimationDeltaTime ? 16 : (h - this._animationTimeLast) * this.animationTimeScale, this._animationTimeLast = h;
  const e = this._activeAnimatables;
  if (e.length === 0)
    return;
  this._animationTime += this.deltaTime;
  const t = this._animationTime;
  for (let i = 0; i < e.length; i++) {
    const s = e[i];
    !s._animate(t) && s.disposeOnEnd && i--;
  }
  this._processLateAnimationBindings();
};
ge.prototype.sortActiveAnimatables = function() {
  this._activeAnimatables.sort((h, e) => h.playOrder - e.playOrder);
};
ge.prototype.beginWeightedAnimation = function(h, e, t, i = 1, s, r = 1, n, a, o, l, c = !1) {
  const u = this.beginAnimation(h, e, t, s, r, n, a, !1, o, l, c);
  return u.weight = i, u;
};
ge.prototype.beginAnimation = function(h, e, t, i, s = 1, r, n, a = !0, o, l, c = !1) {
  e > t && s > 0 && (s *= -1), a && this.stopAnimation(h, void 0, o), n || (n = new mo(this, h, e, t, i, s, r, void 0, l, c));
  const u = o ? o(h) : !0;
  if (h.animations && u && n.appendAnimations(h, h.animations), h.getAnimatables) {
    const d = h.getAnimatables();
    for (let f = 0; f < d.length; f++)
      this.beginAnimation(d[f], e, t, i, s, r, n, a, o, l);
  }
  return n.reset(), n;
};
ge.prototype.beginHierarchyAnimation = function(h, e, t, i, s, r = 1, n, a, o = !0, l, c, u = !1) {
  const d = h.getDescendants(e), f = [];
  f.push(this.beginAnimation(h, t, i, s, r, n, a, o, l, void 0, u));
  for (const _ of d)
    f.push(this.beginAnimation(_, t, i, s, r, n, a, o, l, void 0, u));
  return f;
};
ge.prototype.beginDirectAnimation = function(h, e, t, i, s, r, n, a, o = !1) {
  if (r === void 0 && (r = 1), t > i && r > 0)
    r *= -1;
  else if (i > t && r < 0) {
    const c = i;
    i = t, t = c;
  }
  return new mo(this, h, t, i, s, r, n, e, a, o);
};
ge.prototype.beginDirectHierarchyAnimation = function(h, e, t, i, s, r, n, a, o, l = !1) {
  const c = h.getDescendants(e), u = [];
  u.push(this.beginDirectAnimation(h, t, i, s, r, n, a, o, l));
  for (const d of c)
    u.push(this.beginDirectAnimation(d, t, i, s, r, n, a, o, l));
  return u;
};
ge.prototype.getAnimatableByTarget = function(h) {
  for (let e = 0; e < this._activeAnimatables.length; e++)
    if (this._activeAnimatables[e].target === h)
      return this._activeAnimatables[e];
  return null;
};
ge.prototype.getAllAnimatablesByTarget = function(h) {
  const e = [];
  for (let t = 0; t < this._activeAnimatables.length; t++)
    this._activeAnimatables[t].target === h && e.push(this._activeAnimatables[t]);
  return e;
};
ge.prototype.stopAnimation = function(h, e, t) {
  const i = this.getAllAnimatablesByTarget(h);
  for (const s of i)
    s.stop(e, t);
};
ge.prototype.stopAllAnimations = function() {
  if (this._activeAnimatables) {
    for (let h = 0; h < this._activeAnimatables.length; h++)
      this._activeAnimatables[h].stop(void 0, void 0, !0);
    this._activeAnimatables.length = 0;
  }
  for (const h of this.animationGroups)
    h.stop();
};
ge.prototype._registerTargetForLateAnimationBinding = function(h, e) {
  const t = h.target;
  this._registeredForLateAnimationBindings.pushNoDuplicate(t), t._lateAnimationHolders || (t._lateAnimationHolders = {}), t._lateAnimationHolders[h.targetPath] || (t._lateAnimationHolders[h.targetPath] = {
    totalWeight: 0,
    totalAdditiveWeight: 0,
    animations: [],
    additiveAnimations: [],
    originalValue: e
  }), h.isAdditive ? (t._lateAnimationHolders[h.targetPath].additiveAnimations.push(h), t._lateAnimationHolders[h.targetPath].totalAdditiveWeight += h.weight) : (t._lateAnimationHolders[h.targetPath].animations.push(h), t._lateAnimationHolders[h.targetPath].totalWeight += h.weight);
};
ge.prototype._processLateAnimationBindingsForMatrices = function(h) {
  if (h.totalWeight === 0 && h.totalAdditiveWeight === 0)
    return h.originalValue;
  let e = 1;
  const t = C.Vector3[0], i = C.Vector3[1], s = C.Quaternion[0];
  let r = 0;
  const n = h.animations[0], a = h.originalValue;
  let o = 1, l = !1;
  if (h.totalWeight < 1)
    o = 1 - h.totalWeight, a.decompose(i, s, t);
  else {
    if (r = 1, e = h.totalWeight, o = n.weight / e, o == 1)
      if (h.totalAdditiveWeight)
        l = !0;
      else
        return n.currentValue;
    n.currentValue.decompose(i, s, t);
  }
  if (!l) {
    i.scaleInPlace(o), t.scaleInPlace(o), s.scaleInPlace(o);
    for (let u = r; u < h.animations.length; u++) {
      const d = h.animations[u];
      if (d.weight === 0)
        continue;
      o = d.weight / e;
      const f = C.Vector3[2], _ = C.Vector3[3], g = C.Quaternion[1];
      d.currentValue.decompose(_, g, f), _.scaleAndAddToRef(o, i), g.scaleAndAddToRef(U.Dot(s, g) > 0 ? o : -o, s), f.scaleAndAddToRef(o, t);
    }
    s.normalize();
  }
  for (let u = 0; u < h.additiveAnimations.length; u++) {
    const d = h.additiveAnimations[u];
    if (d.weight === 0)
      continue;
    const f = C.Vector3[2], _ = C.Vector3[3], g = C.Quaternion[1];
    d.currentValue.decompose(_, g, f), _.multiplyToRef(i, _), p.LerpToRef(i, _, d.weight, i), s.multiplyToRef(g, g), U.SlerpToRef(s, g, d.weight, s), f.scaleAndAddToRef(d.weight, t);
  }
  const c = n ? n._animationState.workValue : C.Matrix[0].clone();
  return I.ComposeToRef(i, s, t, c), c;
};
ge.prototype._processLateAnimationBindingsForQuaternions = function(h, e) {
  if (h.totalWeight === 0 && h.totalAdditiveWeight === 0)
    return e;
  const t = h.animations[0], i = h.originalValue;
  let s = e;
  if (h.totalWeight === 0 && h.totalAdditiveWeight > 0)
    s.copyFrom(i);
  else if (h.animations.length === 1) {
    if (U.SlerpToRef(i, t.currentValue, Math.min(1, h.totalWeight), s), h.totalAdditiveWeight === 0)
      return s;
  } else if (h.animations.length > 1) {
    let r = 1, n, a;
    if (h.totalWeight < 1) {
      const l = 1 - h.totalWeight;
      n = [], a = [], n.push(i), a.push(l);
    } else {
      if (h.animations.length === 2 && (U.SlerpToRef(h.animations[0].currentValue, h.animations[1].currentValue, h.animations[1].weight / h.totalWeight, e), h.totalAdditiveWeight === 0))
        return e;
      n = [], a = [], r = h.totalWeight;
    }
    for (let l = 0; l < h.animations.length; l++) {
      const c = h.animations[l];
      n.push(c.currentValue), a.push(c.weight / r);
    }
    let o = 0;
    for (let l = 0; l < n.length; ) {
      if (!l) {
        U.SlerpToRef(n[l], n[l + 1], a[l + 1] / (a[l] + a[l + 1]), e), s = e, o = a[l] + a[l + 1], l += 2;
        continue;
      }
      o += a[l], U.SlerpToRef(s, n[l], a[l] / o, s), l++;
    }
  }
  for (let r = 0; r < h.additiveAnimations.length; r++) {
    const n = h.additiveAnimations[r];
    n.weight !== 0 && (s.multiplyToRef(n.currentValue, C.Quaternion[0]), U.SlerpToRef(s, C.Quaternion[0], n.weight, s));
  }
  return s;
};
ge.prototype._processLateAnimationBindings = function() {
  if (this._registeredForLateAnimationBindings.length) {
    for (let h = 0; h < this._registeredForLateAnimationBindings.length; h++) {
      const e = this._registeredForLateAnimationBindings.data[h];
      for (const t in e._lateAnimationHolders) {
        const i = e._lateAnimationHolders[t], s = i.animations[0], r = i.originalValue;
        if (r == null)
          continue;
        const n = B.AllowMatrixDecomposeForInterpolation && r.m;
        let a = e[t];
        if (n)
          a = this._processLateAnimationBindingsForMatrices(i);
        else if (r.w !== void 0)
          a = this._processLateAnimationBindingsForQuaternions(i, a || U.Identity());
        else {
          let l = 0, c = 1;
          if (i.totalWeight < 1)
            s && r.scale ? a = r.scale(1 - i.totalWeight) : s ? a = r * (1 - i.totalWeight) : r.clone ? a = r.clone() : a = r;
          else if (s) {
            c = i.totalWeight;
            const u = s.weight / c;
            u !== 1 ? s.currentValue.scale ? a = s.currentValue.scale(u) : a = s.currentValue * u : a = s.currentValue, l = 1;
          }
          for (let u = l; u < i.animations.length; u++) {
            const d = i.animations[u], f = d.weight / c;
            if (f)
              d.currentValue.scaleAndAddToRef ? d.currentValue.scaleAndAddToRef(f, a) : a += d.currentValue * f;
            else continue;
          }
          for (let u = 0; u < i.additiveAnimations.length; u++) {
            const d = i.additiveAnimations[u], f = d.weight;
            if (f)
              d.currentValue.scaleAndAddToRef ? d.currentValue.scaleAndAddToRef(f, a) : a += d.currentValue * f;
            else continue;
          }
        }
        e[t] = a;
      }
      e._lateAnimationHolders = {};
    }
    this._registeredForLateAnimationBindings.reset();
  }
};
We.prototype.copyAnimationRange = function(h, e, t, i = !1, s = null) {
  this.animations.length === 0 && (this.animations.push(new B(this.name, "_matrix", h.animations[0].framePerSecond, B.ANIMATIONTYPE_MATRIX, 0)), this.animations[0].setKeys([]));
  const r = h.animations[0].getRange(e);
  if (!r)
    return !1;
  const n = r.from, a = r.to, o = h.animations[0].getKeys(), l = h.length, c = h.getParent(), u = this.getParent(), d = i && c && l && this.length && l !== this.length, f = d && u && c ? u.length / c.length : 1, _ = i && !u && s && (s.x !== 1 || s.y !== 1 || s.z !== 1), g = this.animations[0].getKeys();
  let m, y, x;
  for (let A = 0, T = o.length; A < T; A++)
    m = o[A], m.frame >= n && m.frame <= a && (i ? (x = m.value.clone(), d ? (y = x.getTranslation(), x.setTranslation(y.scaleInPlace(f))) : _ && s ? (y = x.getTranslation(), x.setTranslation(y.multiplyInPlace(s))) : x = m.value) : x = m.value, g.push({ frame: m.frame + t, value: x }));
  return this.animations[0].createRange(e, n + t, a + t), !0;
};
class ii {
  constructor() {
    this._easingMode = ii.EASINGMODE_EASEIN;
  }
  /**
   * Sets the easing mode of the current function.
   * @param easingMode Defines the willing mode (EASINGMODE_EASEIN, EASINGMODE_EASEOUT or EASINGMODE_EASEINOUT)
   */
  setEasingMode(e) {
    const t = Math.min(Math.max(e, 0), 2);
    this._easingMode = t;
  }
  /**
   * Gets the current easing mode.
   * @returns the easing mode
   */
  getEasingMode() {
    return this._easingMode;
  }
  /**
   * @internal
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  easeInCore(e) {
    throw new Error("You must implement this method");
  }
  /**
   * Given an input gradient between 0 and 1, this returns the corresponding value
   * of the easing function.
   * @param gradient Defines the value between 0 and 1 we want the easing value for
   * @returns the corresponding value on the curve defined by the easing function
   */
  ease(e) {
    switch (this._easingMode) {
      case ii.EASINGMODE_EASEIN:
        return this.easeInCore(e);
      case ii.EASINGMODE_EASEOUT:
        return 1 - this.easeInCore(1 - e);
    }
    return e >= 0.5 ? (1 - this.easeInCore((1 - e) * 2)) * 0.5 + 0.5 : this.easeInCore(e * 2) * 0.5;
  }
}
ii.EASINGMODE_EASEIN = 0;
ii.EASINGMODE_EASEOUT = 1;
ii.EASINGMODE_EASEINOUT = 2;
class Dc extends ii {
  /**
   * Instantiates a back ease easing
   * @see https://easings.net/#easeInBack
   * @param amplitude Defines the amplitude of the function
   */
  constructor(e = 1) {
    super(), this.amplitude = e;
  }
  /**
   * @internal
   */
  easeInCore(e) {
    const t = Math.max(0, this.amplitude);
    return Math.pow(e, 3) - e * t * Math.sin(3.141592653589793 * e);
  }
}
class wc extends ii {
  /**
   * Instantiates an exponential easing function
   * @see https://easings.net/#easeInExpo
   * @param exponent Defines the exponent of the function
   */
  constructor(e = 2) {
    super(), this.exponent = e;
  }
  /**
   * @internal
   */
  easeInCore(e) {
    return this.exponent <= 0 ? e : (Math.exp(this.exponent * e) - 1) / (Math.exp(this.exponent) - 1);
  }
}
class Oc {
  constructor() {
    this._zoomStopsAnimation = !1, this._idleRotationSpeed = 0.05, this._idleRotationWaitTime = 2e3, this._idleRotationSpinupTime = 2e3, this.targetAlpha = null, this._isPointerDown = !1, this._lastFrameTime = null, this._lastInteractionTime = -1 / 0, this._cameraRotationSpeed = 0, this._lastFrameRadius = 0;
  }
  /**
   * Gets the name of the behavior.
   */
  get name() {
    return "AutoRotation";
  }
  /**
   * Sets the flag that indicates if user zooming should stop animation.
   */
  set zoomStopsAnimation(e) {
    this._zoomStopsAnimation = e;
  }
  /**
   * Gets the flag that indicates if user zooming should stop animation.
   */
  get zoomStopsAnimation() {
    return this._zoomStopsAnimation;
  }
  /**
   * Sets the default speed at which the camera rotates around the model.
   */
  set idleRotationSpeed(e) {
    this._idleRotationSpeed = e;
  }
  /**
   * Gets the default speed at which the camera rotates around the model.
   */
  get idleRotationSpeed() {
    return this._idleRotationSpeed;
  }
  /**
   * Sets the time (in milliseconds) to wait after user interaction before the camera starts rotating.
   */
  set idleRotationWaitTime(e) {
    this._idleRotationWaitTime = e;
  }
  /**
   * Gets the time (milliseconds) to wait after user interaction before the camera starts rotating.
   */
  get idleRotationWaitTime() {
    return this._idleRotationWaitTime;
  }
  /**
   * Sets the time (milliseconds) to take to spin up to the full idle rotation speed.
   */
  set idleRotationSpinupTime(e) {
    this._idleRotationSpinupTime = e;
  }
  /**
   * Gets the time (milliseconds) to take to spin up to the full idle rotation speed.
   */
  get idleRotationSpinupTime() {
    return this._idleRotationSpinupTime;
  }
  /**
   * Gets a value indicating if the camera is currently rotating because of this behavior
   */
  get rotationInProgress() {
    return Math.abs(this._cameraRotationSpeed) > 0;
  }
  /**
   * Initializes the behavior.
   */
  init() {
  }
  /**
   * Attaches the behavior to its arc rotate camera.
   * @param camera Defines the camera to attach the behavior to
   */
  attach(e) {
    this._attachedCamera = e;
    const t = this._attachedCamera.getScene();
    this._onPrePointerObservableObserver = t.onPrePointerObservable.add((i) => {
      if (i.type === $.POINTERDOWN) {
        this._isPointerDown = !0;
        return;
      }
      i.type === $.POINTERUP && (this._isPointerDown = !1);
    }), this._onAfterCheckInputsObserver = e.onAfterCheckInputsObservable.add(() => {
      if (this._reachTargetAlpha())
        return;
      const i = Kt.Now;
      let s = 0;
      this._lastFrameTime != null && (s = i - this._lastFrameTime), this._lastFrameTime = i, this._applyUserInteraction();
      const r = i - this._lastInteractionTime - this._idleRotationWaitTime, n = Math.max(Math.min(r / this._idleRotationSpinupTime, 1), 0);
      this._cameraRotationSpeed = this._idleRotationSpeed * n, this._attachedCamera && (this._attachedCamera.alpha -= this._cameraRotationSpeed * (s / 1e3));
    });
  }
  /**
   * Detaches the behavior from its current arc rotate camera.
   */
  detach() {
    if (!this._attachedCamera)
      return;
    const e = this._attachedCamera.getScene();
    this._onPrePointerObservableObserver && e.onPrePointerObservable.remove(this._onPrePointerObservableObserver), this._attachedCamera.onAfterCheckInputsObservable.remove(this._onAfterCheckInputsObserver), this._attachedCamera = null;
  }
  /**
   * Force-reset the last interaction time
   * @param customTime an optional time that will be used instead of the current last interaction time. For example `Date.now()`
   */
  resetLastInteractionTime(e) {
    this._lastInteractionTime = e ?? Kt.Now;
  }
  /**
   * Returns true if camera alpha reaches the target alpha
   * @returns true if camera alpha reaches the target alpha
   */
  _reachTargetAlpha() {
    return this._attachedCamera && this.targetAlpha ? Math.abs(this._attachedCamera.alpha - this.targetAlpha) < pe : !1;
  }
  /**
   * Returns true if user is scrolling.
   * @returns true if user is scrolling.
   */
  _userIsZooming() {
    return this._attachedCamera ? this._attachedCamera.inertialRadiusOffset !== 0 : !1;
  }
  _shouldAnimationStopForInteraction() {
    if (!this._attachedCamera)
      return !1;
    let e = !1;
    return this._lastFrameRadius === this._attachedCamera.radius && this._attachedCamera.inertialRadiusOffset !== 0 && (e = !0), this._lastFrameRadius = this._attachedCamera.radius, this._zoomStopsAnimation ? e : this._userIsZooming();
  }
  /**
   *  Applies any current user interaction to the camera. Takes into account maximum alpha rotation.
   */
  _applyUserInteraction() {
    this._userIsMoving() && !this._shouldAnimationStopForInteraction() && (this._lastInteractionTime = Kt.Now);
  }
  // Tools
  _userIsMoving() {
    return this._attachedCamera ? this._attachedCamera.inertialAlphaOffset !== 0 || this._attachedCamera.inertialBetaOffset !== 0 || this._attachedCamera.inertialRadiusOffset !== 0 || this._attachedCamera.inertialPanningX !== 0 || this._attachedCamera.inertialPanningY !== 0 || this._isPointerDown : !1;
  }
}
class Zi {
  constructor() {
    this.transitionDuration = 450, this.lowerRadiusTransitionRange = 2, this.upperRadiusTransitionRange = -2, this._autoTransitionRange = !1, this._radiusIsAnimating = !1, this._radiusBounceTransition = null, this._animatables = new Array();
  }
  /**
   * Gets the name of the behavior.
   */
  get name() {
    return "Bouncing";
  }
  /**
   * Gets a value indicating if the lowerRadiusTransitionRange and upperRadiusTransitionRange are defined automatically
   */
  get autoTransitionRange() {
    return this._autoTransitionRange;
  }
  /**
   * Sets a value indicating if the lowerRadiusTransitionRange and upperRadiusTransitionRange are defined automatically
   * Transition ranges will be set to 5% of the bounding box diagonal in world space
   */
  set autoTransitionRange(e) {
    if (this._autoTransitionRange === e)
      return;
    this._autoTransitionRange = e;
    const t = this._attachedCamera;
    t && (e ? this._onMeshTargetChangedObserver = t.onMeshTargetChangedObservable.add((i) => {
      if (!i)
        return;
      i.computeWorldMatrix(!0);
      const s = i.getBoundingInfo().diagonalLength;
      this.lowerRadiusTransitionRange = s * 0.05, this.upperRadiusTransitionRange = s * 0.05;
    }) : this._onMeshTargetChangedObserver && t.onMeshTargetChangedObservable.remove(this._onMeshTargetChangedObserver));
  }
  /**
   * Initializes the behavior.
   */
  init() {
  }
  /**
   * Attaches the behavior to its arc rotate camera.
   * @param camera Defines the camera to attach the behavior to
   */
  attach(e) {
    this._attachedCamera = e, this._onAfterCheckInputsObserver = e.onAfterCheckInputsObservable.add(() => {
      this._attachedCamera && (this._isRadiusAtLimit(this._attachedCamera.lowerRadiusLimit) && this._applyBoundRadiusAnimation(this.lowerRadiusTransitionRange), this._isRadiusAtLimit(this._attachedCamera.upperRadiusLimit) && this._applyBoundRadiusAnimation(this.upperRadiusTransitionRange));
    });
  }
  /**
   * Detaches the behavior from its current arc rotate camera.
   */
  detach() {
    this._attachedCamera && (this._onAfterCheckInputsObserver && this._attachedCamera.onAfterCheckInputsObservable.remove(this._onAfterCheckInputsObserver), this._onMeshTargetChangedObserver && this._attachedCamera.onMeshTargetChangedObservable.remove(this._onMeshTargetChangedObserver), this._attachedCamera = null);
  }
  /**
   * Checks if the camera radius is at the specified limit. Takes into account animation locks.
   * @param radiusLimit The limit to check against.
   * @returns Bool to indicate if at limit.
   */
  _isRadiusAtLimit(e) {
    return this._attachedCamera ? this._attachedCamera.radius === e && !this._radiusIsAnimating : !1;
  }
  /**
   * Applies an animation to the radius of the camera, extending by the radiusDelta.
   * @param radiusDelta The delta by which to animate to. Can be negative.
   */
  _applyBoundRadiusAnimation(e) {
    if (!this._attachedCamera)
      return;
    this._radiusBounceTransition || (Zi.EasingFunction.setEasingMode(Zi.EasingMode), this._radiusBounceTransition = B.CreateAnimation("radius", B.ANIMATIONTYPE_FLOAT, 60, Zi.EasingFunction)), this._cachedWheelPrecision = this._attachedCamera.wheelPrecision, this._attachedCamera.wheelPrecision = 1 / 0, this._attachedCamera.inertialRadiusOffset = 0, this.stopAllAnimations(), this._radiusIsAnimating = !0;
    const t = B.TransitionTo("radius", this._attachedCamera.radius + e, this._attachedCamera, this._attachedCamera.getScene(), 60, this._radiusBounceTransition, this.transitionDuration, () => this._clearAnimationLocks());
    t && this._animatables.push(t);
  }
  /**
   * Removes all animation locks. Allows new animations to be added to any of the camera properties.
   */
  _clearAnimationLocks() {
    this._radiusIsAnimating = !1, this._attachedCamera && (this._attachedCamera.wheelPrecision = this._cachedWheelPrecision);
  }
  /**
   * Stops and removes all animations that have been applied to the camera
   */
  stopAllAnimations() {
    for (this._attachedCamera && (this._attachedCamera.animations = []); this._animatables.length; )
      this._animatables[0].onAnimationEnd = null, this._animatables[0].stop(), this._animatables.shift();
  }
}
Zi.EasingFunction = new Dc(0.3);
Zi.EasingMode = ii.EASINGMODE_EASEOUT;
class Lt {
  constructor() {
    this.onTargetFramingAnimationEndObservable = new N(), this._mode = Lt.FitFrustumSidesMode, this._radiusScale = 1, this._positionScale = 0.5, this._defaultElevation = 0.3, this._elevationReturnTime = 1500, this._elevationReturnWaitTime = 1e3, this._zoomStopsAnimation = !1, this._framingTime = 1500, this.autoCorrectCameraLimitsAndSensibility = !0, this._isPointerDown = !1, this._lastInteractionTime = -1 / 0, this._animatables = new Array(), this._betaIsAnimating = !1;
  }
  /**
   * Gets the name of the behavior.
   */
  get name() {
    return "Framing";
  }
  /**
   * Sets the current mode used by the behavior
   */
  set mode(e) {
    this._mode = e;
  }
  /**
   * Gets current mode used by the behavior.
   */
  get mode() {
    return this._mode;
  }
  /**
   * Sets the scale applied to the radius (1 by default)
   */
  set radiusScale(e) {
    this._radiusScale = e;
  }
  /**
   * Gets the scale applied to the radius
   */
  get radiusScale() {
    return this._radiusScale;
  }
  /**
   * Sets the scale to apply on Y axis to position camera focus. 0.5 by default which means the center of the bounding box.
   */
  set positionScale(e) {
    this._positionScale = e;
  }
  /**
   * Gets the scale to apply on Y axis to position camera focus. 0.5 by default which means the center of the bounding box.
   */
  get positionScale() {
    return this._positionScale;
  }
  /**
   * Sets the angle above/below the horizontal plane to return to when the return to default elevation idle
   * behaviour is triggered, in radians.
   */
  set defaultElevation(e) {
    this._defaultElevation = e;
  }
  /**
   * Gets the angle above/below the horizontal plane to return to when the return to default elevation idle
   * behaviour is triggered, in radians.
   */
  get defaultElevation() {
    return this._defaultElevation;
  }
  /**
   * Sets the time (in milliseconds) taken to return to the default beta position.
   * Negative value indicates camera should not return to default.
   */
  set elevationReturnTime(e) {
    this._elevationReturnTime = e;
  }
  /**
   * Gets the time (in milliseconds) taken to return to the default beta position.
   * Negative value indicates camera should not return to default.
   */
  get elevationReturnTime() {
    return this._elevationReturnTime;
  }
  /**
   * Sets the delay (in milliseconds) taken before the camera returns to the default beta position.
   */
  set elevationReturnWaitTime(e) {
    this._elevationReturnWaitTime = e;
  }
  /**
   * Gets the delay (in milliseconds) taken before the camera returns to the default beta position.
   */
  get elevationReturnWaitTime() {
    return this._elevationReturnWaitTime;
  }
  /**
   * Sets the flag that indicates if user zooming should stop animation.
   */
  set zoomStopsAnimation(e) {
    this._zoomStopsAnimation = e;
  }
  /**
   * Gets the flag that indicates if user zooming should stop animation.
   */
  get zoomStopsAnimation() {
    return this._zoomStopsAnimation;
  }
  /**
   * Sets the transition time when framing the mesh, in milliseconds
   */
  set framingTime(e) {
    this._framingTime = e;
  }
  /**
   * Gets the transition time when framing the mesh, in milliseconds
   */
  get framingTime() {
    return this._framingTime;
  }
  /**
   * Initializes the behavior.
   */
  init() {
  }
  /**
   * Attaches the behavior to its arc rotate camera.
   * @param camera Defines the camera to attach the behavior to
   */
  attach(e) {
    this._attachedCamera = e;
    const t = this._attachedCamera.getScene();
    Lt.EasingFunction.setEasingMode(Lt.EasingMode), this._onPrePointerObservableObserver = t.onPrePointerObservable.add((i) => {
      if (i.type === $.POINTERDOWN) {
        this._isPointerDown = !0;
        return;
      }
      i.type === $.POINTERUP && (this._isPointerDown = !1);
    }), this._onMeshTargetChangedObserver = e.onMeshTargetChangedObservable.add((i) => {
      i && this.zoomOnMesh(i, void 0, () => {
        this.onTargetFramingAnimationEndObservable.notifyObservers();
      });
    }), this._onAfterCheckInputsObserver = e.onAfterCheckInputsObservable.add(() => {
      this._applyUserInteraction(), this._maintainCameraAboveGround();
    });
  }
  /**
   * Detaches the behavior from its current arc rotate camera.
   */
  detach() {
    if (!this._attachedCamera)
      return;
    const e = this._attachedCamera.getScene();
    this._onPrePointerObservableObserver && e.onPrePointerObservable.remove(this._onPrePointerObservableObserver), this._onAfterCheckInputsObserver && this._attachedCamera.onAfterCheckInputsObservable.remove(this._onAfterCheckInputsObserver), this._onMeshTargetChangedObserver && this._attachedCamera.onMeshTargetChangedObservable.remove(this._onMeshTargetChangedObserver), this._attachedCamera = null;
  }
  /**
   * Targets the given mesh and updates zoom level accordingly.
   * @param mesh  The mesh to target.
   * @param focusOnOriginXZ Determines if the camera should focus on 0 in the X and Z axis instead of the mesh
   * @param onAnimationEnd Callback triggered at the end of the framing animation
   */
  zoomOnMesh(e, t = !1, i = null) {
    e.computeWorldMatrix(!0);
    const s = e.getBoundingInfo().boundingBox;
    this.zoomOnBoundingInfo(s.minimumWorld, s.maximumWorld, t, i);
  }
  /**
   * Targets the given mesh with its children and updates zoom level accordingly.
   * @param mesh  The mesh to target.
   * @param focusOnOriginXZ Determines if the camera should focus on 0 in the X and Z axis instead of the mesh
   * @param onAnimationEnd Callback triggered at the end of the framing animation
   */
  zoomOnMeshHierarchy(e, t = !1, i = null) {
    e.computeWorldMatrix(!0);
    const s = e.getHierarchyBoundingVectors(!0);
    this.zoomOnBoundingInfo(s.min, s.max, t, i);
  }
  /**
   * Targets the given meshes with their children and updates zoom level accordingly.
   * @param meshes  The mesh to target.
   * @param focusOnOriginXZ Determines if the camera should focus on 0 in the X and Z axis instead of the mesh
   * @param onAnimationEnd Callback triggered at the end of the framing animation
   */
  zoomOnMeshesHierarchy(e, t = !1, i = null) {
    const s = new p(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE), r = new p(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
    for (let n = 0; n < e.length; n++) {
      const a = e[n].getHierarchyBoundingVectors(!0);
      p.CheckExtends(a.min, s, r), p.CheckExtends(a.max, s, r);
    }
    this.zoomOnBoundingInfo(s, r, t, i);
  }
  /**
   * Targets the bounding box info defined by its extends and updates zoom level accordingly.
   * @param minimumWorld Determines the smaller position of the bounding box extend
   * @param maximumWorld Determines the bigger position of the bounding box extend
   * @param focusOnOriginXZ Determines if the camera should focus on 0 in the X and Z axis instead of the mesh
   * @param onAnimationEnd Callback triggered at the end of the framing animation
   * @returns true if the zoom was done
   */
  zoomOnBoundingInfo(e, t, i = !1, s = null) {
    let r;
    if (!this._attachedCamera)
      return !1;
    const n = e.y, a = t.y, o = n + (a - n) * this._positionScale, l = t.subtract(e).scale(0.5);
    if (i)
      r = new p(0, o, 0);
    else {
      const d = e.add(l);
      r = new p(d.x, o, d.z);
    }
    this._vectorTransition || (this._vectorTransition = B.CreateAnimation("target", B.ANIMATIONTYPE_VECTOR3, 60, Lt.EasingFunction)), this._betaIsAnimating = !0;
    let c = B.TransitionTo("target", r, this._attachedCamera, this._attachedCamera.getScene(), 60, this._vectorTransition, this._framingTime);
    c && this._animatables.push(c);
    let u = 0;
    if (this._mode === Lt.FitFrustumSidesMode) {
      const d = this._calculateLowerRadiusFromModelBoundingSphere(e, t);
      this.autoCorrectCameraLimitsAndSensibility && (this._attachedCamera.lowerRadiusLimit = l.length() + this._attachedCamera.minZ), u = d;
    } else this._mode === Lt.IgnoreBoundsSizeMode && (u = this._calculateLowerRadiusFromModelBoundingSphere(e, t), this.autoCorrectCameraLimitsAndSensibility && this._attachedCamera.lowerRadiusLimit === null && (this._attachedCamera.lowerRadiusLimit = this._attachedCamera.minZ));
    if (this.autoCorrectCameraLimitsAndSensibility) {
      const d = t.subtract(e).length();
      this._attachedCamera.panningSensibility = 5e3 / d, this._attachedCamera.wheelPrecision = 100 / u;
    }
    return this._radiusTransition || (this._radiusTransition = B.CreateAnimation("radius", B.ANIMATIONTYPE_FLOAT, 60, Lt.EasingFunction)), c = B.TransitionTo("radius", u, this._attachedCamera, this._attachedCamera.getScene(), 60, this._radiusTransition, this._framingTime, () => {
      this.stopAllAnimations(), s && s(), this._attachedCamera && this._attachedCamera.useInputToRestoreState && this._attachedCamera.storeState();
    }), c && this._animatables.push(c), !0;
  }
  /**
   * Calculates the lowest radius for the camera based on the bounding box of the mesh.
   * @param minimumWorld
   * @param maximumWorld
   * @returns The minimum distance from the primary mesh's center point at which the camera must be kept in order
   *		 to fully enclose the mesh in the viewing frustum.
   */
  _calculateLowerRadiusFromModelBoundingSphere(e, t) {
    const s = t.subtract(e).length(), r = this._getFrustumSlope(), a = s * 0.5 * this._radiusScale, o = a * Math.sqrt(1 + 1 / (r.x * r.x)), l = a * Math.sqrt(1 + 1 / (r.y * r.y));
    let c = Math.max(o, l);
    const u = this._attachedCamera;
    return u ? (u.lowerRadiusLimit && this._mode === Lt.IgnoreBoundsSizeMode && (c = c < u.lowerRadiusLimit ? u.lowerRadiusLimit : c), u.upperRadiusLimit && (c = c > u.upperRadiusLimit ? u.upperRadiusLimit : c), c) : 0;
  }
  /**
   * Keeps the camera above the ground plane. If the user pulls the camera below the ground plane, the camera
   * is automatically returned to its default position (expected to be above ground plane).
   */
  _maintainCameraAboveGround() {
    if (this._elevationReturnTime < 0)
      return;
    const e = Kt.Now - this._lastInteractionTime, t = Math.PI * 0.5 - this._defaultElevation, i = Math.PI * 0.5;
    if (this._attachedCamera && !this._betaIsAnimating && this._attachedCamera.beta > i && e >= this._elevationReturnWaitTime) {
      this._betaIsAnimating = !0, this.stopAllAnimations(), this._betaTransition || (this._betaTransition = B.CreateAnimation("beta", B.ANIMATIONTYPE_FLOAT, 60, Lt.EasingFunction));
      const s = B.TransitionTo("beta", t, this._attachedCamera, this._attachedCamera.getScene(), 60, this._betaTransition, this._elevationReturnTime, () => {
        this._clearAnimationLocks(), this.stopAllAnimations();
      });
      s && this._animatables.push(s);
    }
  }
  /**
   * Returns the frustum slope based on the canvas ratio and camera FOV
   * @returns The frustum slope represented as a Vector2 with X and Y slopes
   */
  _getFrustumSlope() {
    const e = this._attachedCamera;
    if (!e)
      return ue.Zero();
    const i = e.getScene().getEngine().getAspectRatio(e), s = Math.tan(e.fov / 2), r = s * i;
    return new ue(r, s);
  }
  /**
   * Removes all animation locks. Allows new animations to be added to any of the arcCamera properties.
   */
  _clearAnimationLocks() {
    this._betaIsAnimating = !1;
  }
  /**
   *  Applies any current user interaction to the camera. Takes into account maximum alpha rotation.
   */
  _applyUserInteraction() {
    this.isUserIsMoving && (this._lastInteractionTime = Kt.Now, this.stopAllAnimations(), this._clearAnimationLocks());
  }
  /**
   * Stops and removes all animations that have been applied to the camera
   */
  stopAllAnimations() {
    for (this._attachedCamera && (this._attachedCamera.animations = []); this._animatables.length; )
      this._animatables[0] && (this._animatables[0].onAnimationEnd = null, this._animatables[0].stop()), this._animatables.shift();
  }
  /**
   * Gets a value indicating if the user is moving the camera
   */
  get isUserIsMoving() {
    return this._attachedCamera ? this._attachedCamera.inertialAlphaOffset !== 0 || this._attachedCamera.inertialBetaOffset !== 0 || this._attachedCamera.inertialRadiusOffset !== 0 || this._attachedCamera.inertialPanningX !== 0 || this._attachedCamera.inertialPanningY !== 0 || this._isPointerDown : !1;
  }
}
Lt.EasingFunction = new wc();
Lt.EasingMode = ii.EASINGMODE_EASEINOUT;
Lt.IgnoreBoundsSizeMode = 0;
Lt.FitFrustumSidesMode = 1;
class lt extends Q {
  /**
   * Instantiates a target camera that takes a mesh or position as a target and continues to look at it while it moves.
   * This is the base of the follow, arc rotate cameras and Free camera
   * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras
   * @param name Defines the name of the camera in the scene
   * @param position Defines the start position of the camera in the scene
   * @param scene Defines the scene the camera belongs to
   * @param setActiveOnSceneIfNoneActive Defines whether the camera should be marked as active if not other active cameras have been defined
   */
  constructor(e, t, i, s = !0) {
    super(e, t, i, s), this._tmpUpVector = p.Zero(), this._tmpTargetVector = p.Zero(), this.cameraDirection = new p(0, 0, 0), this.cameraRotation = new ue(0, 0), this.ignoreParentScaling = !1, this.updateUpVectorFromRotation = !1, this._tmpQuaternion = new U(), this.rotation = new p(0, 0, 0), this.speed = 2, this.noRotationConstraint = !1, this.invertRotation = !1, this.inverseRotationSpeed = 0.2, this.lockedTarget = null, this._currentTarget = p.Zero(), this._initialFocalDistance = 1, this._viewMatrix = I.Zero(), this._camMatrix = I.Zero(), this._cameraTransformMatrix = I.Zero(), this._cameraRotationMatrix = I.Zero(), this._referencePoint = new p(0, 0, 1), this._transformedReferencePoint = p.Zero(), this._deferredPositionUpdate = new p(), this._deferredRotationQuaternionUpdate = new U(), this._deferredRotationUpdate = new p(), this._deferredUpdated = !1, this._deferOnly = !1, this._defaultUp = p.Up(), this._cachedRotationZ = 0, this._cachedQuaternionRotationZ = 0;
  }
  /**
   * Gets the position in front of the camera at a given distance.
   * @param distance The distance from the camera we want the position to be
   * @returns the position
   */
  getFrontPosition(e) {
    this.getWorldMatrix();
    const t = this.getTarget().subtract(this.position);
    return t.normalize(), t.scaleInPlace(e), this.globalPosition.add(t);
  }
  /** @internal */
  _getLockedTargetPosition() {
    if (!this.lockedTarget)
      return null;
    if (this.lockedTarget.absolutePosition) {
      const e = this.lockedTarget;
      e.computeWorldMatrix().getTranslationToRef(e.absolutePosition);
    }
    return this.lockedTarget.absolutePosition || this.lockedTarget;
  }
  /**
   * Store current camera state of the camera (fov, position, rotation, etc..)
   * @returns the camera
   */
  storeState() {
    return this._storedPosition = this.position.clone(), this._storedRotation = this.rotation.clone(), this.rotationQuaternion && (this._storedRotationQuaternion = this.rotationQuaternion.clone()), super.storeState();
  }
  /**
   * Restored camera state. You must call storeState() first
   * @returns whether it was successful or not
   * @internal
   */
  _restoreStateValues() {
    return super._restoreStateValues() ? (this.position = this._storedPosition.clone(), this.rotation = this._storedRotation.clone(), this.rotationQuaternion && (this.rotationQuaternion = this._storedRotationQuaternion.clone()), this.cameraDirection.copyFromFloats(0, 0, 0), this.cameraRotation.copyFromFloats(0, 0), !0) : !1;
  }
  /** @internal */
  _initCache() {
    super._initCache(), this._cache.lockedTarget = new p(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE), this._cache.rotation = new p(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE), this._cache.rotationQuaternion = new U(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
  }
  /**
   * @internal
   */
  _updateCache(e) {
    e || super._updateCache();
    const t = this._getLockedTargetPosition();
    t ? this._cache.lockedTarget ? this._cache.lockedTarget.copyFrom(t) : this._cache.lockedTarget = t.clone() : this._cache.lockedTarget = null, this._cache.rotation.copyFrom(this.rotation), this.rotationQuaternion && this._cache.rotationQuaternion.copyFrom(this.rotationQuaternion);
  }
  // Synchronized
  /** @internal */
  _isSynchronizedViewMatrix() {
    if (!super._isSynchronizedViewMatrix())
      return !1;
    const e = this._getLockedTargetPosition();
    return (this._cache.lockedTarget ? this._cache.lockedTarget.equals(e) : !e) && (this.rotationQuaternion ? this.rotationQuaternion.equals(this._cache.rotationQuaternion) : this._cache.rotation.equals(this.rotation));
  }
  // Methods
  /** @internal */
  _computeLocalCameraSpeed() {
    const e = this.getEngine();
    return this.speed * Math.sqrt(e.getDeltaTime() / (e.getFps() * 100));
  }
  // Target
  /**
   * Defines the target the camera should look at.
   * @param target Defines the new target as a Vector
   */
  setTarget(e) {
    this.upVector.normalize(), this._initialFocalDistance = e.subtract(this.position).length(), this.position.z === e.z && (this.position.z += pe), this._referencePoint.normalize().scaleInPlace(this._initialFocalDistance), I.LookAtLHToRef(this.position, e, this._defaultUp, this._camMatrix), this._camMatrix.invert(), this.rotation.x = Math.atan(this._camMatrix.m[6] / this._camMatrix.m[10]);
    const t = e.subtract(this.position);
    t.x >= 0 ? this.rotation.y = -Math.atan(t.z / t.x) + Math.PI / 2 : this.rotation.y = -Math.atan(t.z / t.x) - Math.PI / 2, this.rotation.z = 0, isNaN(this.rotation.x) && (this.rotation.x = 0), isNaN(this.rotation.y) && (this.rotation.y = 0), isNaN(this.rotation.z) && (this.rotation.z = 0), this.rotationQuaternion && U.RotationYawPitchRollToRef(this.rotation.y, this.rotation.x, this.rotation.z, this.rotationQuaternion);
  }
  /**
   * Defines the target point of the camera.
   * The camera looks towards it form the radius distance.
   */
  get target() {
    return this.getTarget();
  }
  set target(e) {
    this.setTarget(e);
  }
  /**
   * Return the current target position of the camera. This value is expressed in local space.
   * @returns the target position
   */
  getTarget() {
    return this._currentTarget;
  }
  /** @internal */
  _decideIfNeedsToMove() {
    return Math.abs(this.cameraDirection.x) > 0 || Math.abs(this.cameraDirection.y) > 0 || Math.abs(this.cameraDirection.z) > 0;
  }
  /** @internal */
  _updatePosition() {
    if (this.parent) {
      this.parent.getWorldMatrix().invertToRef(C.Matrix[0]), p.TransformNormalToRef(this.cameraDirection, C.Matrix[0], C.Vector3[0]), this._deferredPositionUpdate.addInPlace(C.Vector3[0]), this._deferOnly ? this._deferredUpdated = !0 : this.position.copyFrom(this._deferredPositionUpdate);
      return;
    }
    this._deferredPositionUpdate.addInPlace(this.cameraDirection), this._deferOnly ? this._deferredUpdated = !0 : this.position.copyFrom(this._deferredPositionUpdate);
  }
  /** @internal */
  _checkInputs() {
    const e = this.invertRotation ? -this.inverseRotationSpeed : 1, t = this._decideIfNeedsToMove(), i = this.cameraRotation.x || this.cameraRotation.y;
    this._deferredUpdated = !1, this._deferredRotationUpdate.copyFrom(this.rotation), this._deferredPositionUpdate.copyFrom(this.position), this.rotationQuaternion && this._deferredRotationQuaternionUpdate.copyFrom(this.rotationQuaternion), t && this._updatePosition(), i && (this.rotationQuaternion && this.rotationQuaternion.toEulerAnglesToRef(this._deferredRotationUpdate), this._deferredRotationUpdate.x += this.cameraRotation.x * e, this._deferredRotationUpdate.y += this.cameraRotation.y * e, this.noRotationConstraint || (this._deferredRotationUpdate.x > 1.570796 && (this._deferredRotationUpdate.x = 1.570796), this._deferredRotationUpdate.x < -1.570796 && (this._deferredRotationUpdate.x = -1.570796)), this._deferOnly ? this._deferredUpdated = !0 : this.rotation.copyFrom(this._deferredRotationUpdate), this.rotationQuaternion && this._deferredRotationUpdate.lengthSquared() && (U.RotationYawPitchRollToRef(this._deferredRotationUpdate.y, this._deferredRotationUpdate.x, this._deferredRotationUpdate.z, this._deferredRotationQuaternionUpdate), this._deferOnly ? this._deferredUpdated = !0 : this.rotationQuaternion.copyFrom(this._deferredRotationQuaternionUpdate))), t && (Math.abs(this.cameraDirection.x) < this.speed * pe && (this.cameraDirection.x = 0), Math.abs(this.cameraDirection.y) < this.speed * pe && (this.cameraDirection.y = 0), Math.abs(this.cameraDirection.z) < this.speed * pe && (this.cameraDirection.z = 0), this.cameraDirection.scaleInPlace(this.inertia)), i && (Math.abs(this.cameraRotation.x) < this.speed * pe && (this.cameraRotation.x = 0), Math.abs(this.cameraRotation.y) < this.speed * pe && (this.cameraRotation.y = 0), this.cameraRotation.scaleInPlace(this.inertia)), super._checkInputs();
  }
  _updateCameraRotationMatrix() {
    this.rotationQuaternion ? this.rotationQuaternion.toRotationMatrix(this._cameraRotationMatrix) : I.RotationYawPitchRollToRef(this.rotation.y, this.rotation.x, this.rotation.z, this._cameraRotationMatrix);
  }
  /**
   * Update the up vector to apply the rotation of the camera (So if you changed the camera rotation.z this will let you update the up vector as well)
   * @returns the current camera
   */
  _rotateUpVectorWithCameraRotationMatrix() {
    return p.TransformNormalToRef(this._defaultUp, this._cameraRotationMatrix, this.upVector), this;
  }
  /** @internal */
  _getViewMatrix() {
    return this.lockedTarget && this.setTarget(this._getLockedTargetPosition()), this._updateCameraRotationMatrix(), this.rotationQuaternion && this._cachedQuaternionRotationZ != this.rotationQuaternion.z ? (this._rotateUpVectorWithCameraRotationMatrix(), this._cachedQuaternionRotationZ = this.rotationQuaternion.z) : this._cachedRotationZ !== this.rotation.z && (this._rotateUpVectorWithCameraRotationMatrix(), this._cachedRotationZ = this.rotation.z), p.TransformCoordinatesToRef(this._referencePoint, this._cameraRotationMatrix, this._transformedReferencePoint), this.position.addToRef(this._transformedReferencePoint, this._currentTarget), this.updateUpVectorFromRotation && (this.rotationQuaternion ? Et.Y.rotateByQuaternionToRef(this.rotationQuaternion, this.upVector) : (U.FromEulerVectorToRef(this.rotation, this._tmpQuaternion), Et.Y.rotateByQuaternionToRef(this._tmpQuaternion, this.upVector))), this._computeViewMatrix(this.position, this._currentTarget, this.upVector), this._viewMatrix;
  }
  _computeViewMatrix(e, t, i) {
    if (this.ignoreParentScaling) {
      if (this.parent) {
        const s = this.parent.getWorldMatrix();
        p.TransformCoordinatesToRef(e, s, this._globalPosition), p.TransformCoordinatesToRef(t, s, this._tmpTargetVector), p.TransformNormalToRef(i, s, this._tmpUpVector), this._markSyncedWithParent();
      } else
        this._globalPosition.copyFrom(e), this._tmpTargetVector.copyFrom(t), this._tmpUpVector.copyFrom(i);
      this.getScene().useRightHandedSystem ? I.LookAtRHToRef(this._globalPosition, this._tmpTargetVector, this._tmpUpVector, this._viewMatrix) : I.LookAtLHToRef(this._globalPosition, this._tmpTargetVector, this._tmpUpVector, this._viewMatrix);
      return;
    }
    if (this.getScene().useRightHandedSystem ? I.LookAtRHToRef(e, t, i, this._viewMatrix) : I.LookAtLHToRef(e, t, i, this._viewMatrix), this.parent) {
      const s = this.parent.getWorldMatrix();
      this._viewMatrix.invert(), this._viewMatrix.multiplyToRef(s, this._viewMatrix), this._viewMatrix.getTranslationToRef(this._globalPosition), this._viewMatrix.invert(), this._markSyncedWithParent();
    } else
      this._globalPosition.copyFrom(e);
  }
  /**
   * @internal
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  createRigCamera(e, t) {
    if (this.cameraRigMode !== Q.RIG_MODE_NONE) {
      const i = new lt(e, this.position.clone(), this.getScene());
      return i.isRigCamera = !0, i.rigParent = this, (this.cameraRigMode === Q.RIG_MODE_VR || this.cameraRigMode === Q.RIG_MODE_WEBVR) && (this.rotationQuaternion || (this.rotationQuaternion = new U()), i._cameraRigParams = {}, i.rotationQuaternion = new U()), i.mode = this.mode, i.orthoLeft = this.orthoLeft, i.orthoRight = this.orthoRight, i.orthoTop = this.orthoTop, i.orthoBottom = this.orthoBottom, i;
    }
    return null;
  }
  /**
   * @internal
   */
  _updateRigCameras() {
    const e = this._rigCameras[0], t = this._rigCameras[1];
    switch (this.computeWorldMatrix(), this.cameraRigMode) {
      case Q.RIG_MODE_STEREOSCOPIC_ANAGLYPH:
      case Q.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_PARALLEL:
      case Q.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED:
      case Q.RIG_MODE_STEREOSCOPIC_OVERUNDER:
      case Q.RIG_MODE_STEREOSCOPIC_INTERLACED: {
        const i = this.cameraRigMode === Q.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED ? 1 : -1, s = this.cameraRigMode === Q.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED ? -1 : 1;
        this._getRigCamPositionAndTarget(this._cameraRigParams.stereoHalfAngle * i, e), this._getRigCamPositionAndTarget(this._cameraRigParams.stereoHalfAngle * s, t);
        break;
      }
      case Q.RIG_MODE_VR:
        e.rotationQuaternion ? (e.rotationQuaternion.copyFrom(this.rotationQuaternion), t.rotationQuaternion.copyFrom(this.rotationQuaternion)) : (e.rotation.copyFrom(this.rotation), t.rotation.copyFrom(this.rotation)), e.position.copyFrom(this.position), t.position.copyFrom(this.position);
        break;
    }
    super._updateRigCameras();
  }
  _getRigCamPositionAndTarget(e, t) {
    this.getTarget().subtractToRef(this.position, lt._TargetFocalPoint), lt._TargetFocalPoint.normalize().scaleInPlace(this._initialFocalDistance);
    const s = lt._TargetFocalPoint.addInPlace(this.position);
    I.TranslationToRef(-s.x, -s.y, -s.z, lt._TargetTransformMatrix), lt._TargetTransformMatrix.multiplyToRef(I.RotationAxis(t.upVector, e), lt._RigCamTransformMatrix), I.TranslationToRef(s.x, s.y, s.z, lt._TargetTransformMatrix), lt._RigCamTransformMatrix.multiplyToRef(lt._TargetTransformMatrix, lt._RigCamTransformMatrix), p.TransformCoordinatesToRef(this.position, lt._RigCamTransformMatrix, t.position), t.setTarget(s);
  }
  /**
   * Gets the current object class name.
   * @returns the class name
   */
  getClassName() {
    return "TargetCamera";
  }
}
lt._RigCamTransformMatrix = new I();
lt._TargetTransformMatrix = new I();
lt._TargetFocalPoint = new p();
E([
  wt()
], lt.prototype, "rotation", void 0);
E([
  R()
], lt.prototype, "speed", void 0);
E([
  Sn("lockedTargetId")
], lt.prototype, "lockedTarget", void 0);
var Ii = {};
class yo {
  /**
   * Instantiate a new Camera Input Manager.
   * @param camera Defines the camera the input manager belongs to
   */
  constructor(e) {
    this.attachedToElement = !1, this.attached = {}, this.camera = e, this.checkInputs = () => {
    };
  }
  /**
   * Add an input method to a camera
   * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/customizingCameraInputs
   * @param input Camera input method
   */
  add(e) {
    const t = e.getSimpleName();
    if (this.attached[t]) {
      w.Warn("camera input of type " + t + " already exists on camera");
      return;
    }
    this.attached[t] = e, e.camera = this.camera, e.checkInputs && (this.checkInputs = this._addCheckInputs(e.checkInputs.bind(e))), this.attachedToElement && e.attachControl(this.noPreventDefault);
  }
  /**
   * Remove a specific input method from a camera
   * example: camera.inputs.remove(camera.inputs.attached.mouse);
   * @param inputToRemove camera input method
   */
  remove(e) {
    for (const t in this.attached) {
      const i = this.attached[t];
      if (i === e) {
        i.detachControl(), i.camera = null, delete this.attached[t], this.rebuildInputCheck();
        return;
      }
    }
  }
  /**
   * Remove a specific input type from a camera
   * example: camera.inputs.remove("ArcRotateCameraGamepadInput");
   * @param inputType the type of the input to remove
   */
  removeByType(e) {
    for (const t in this.attached) {
      const i = this.attached[t];
      i.getClassName() === e && (i.detachControl(), i.camera = null, delete this.attached[t], this.rebuildInputCheck());
    }
  }
  _addCheckInputs(e) {
    const t = this.checkInputs;
    return () => {
      t(), e();
    };
  }
  /**
   * Attach the input controls to the currently attached dom element to listen the events from.
   * @param input Defines the input to attach
   */
  attachInput(e) {
    this.attachedToElement && e.attachControl(this.noPreventDefault);
  }
  /**
   * Attach the current manager inputs controls to a specific dom element to listen the events from.
   * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
   */
  attachElement(e = !1) {
    if (!this.attachedToElement) {
      e = Q.ForceAttachControlToAlwaysPreventDefault ? !1 : e, this.attachedToElement = !0, this.noPreventDefault = e;
      for (const t in this.attached)
        this.attached[t].attachControl(e);
    }
  }
  /**
   * Detach the current manager inputs controls from a specific dom element.
   * @param disconnect Defines whether the input should be removed from the current list of attached inputs
   */
  detachElement(e = !1) {
    for (const t in this.attached)
      this.attached[t].detachControl(), e && (this.attached[t].camera = null);
    this.attachedToElement = !1;
  }
  /**
   * Rebuild the dynamic inputCheck function from the current list of
   * defined inputs in the manager.
   */
  rebuildInputCheck() {
    this.checkInputs = () => {
    };
    for (const e in this.attached) {
      const t = this.attached[e];
      t.checkInputs && (this.checkInputs = this._addCheckInputs(t.checkInputs.bind(t)));
    }
  }
  /**
   * Remove all attached input methods from a camera
   */
  clear() {
    this.attachedToElement && this.detachElement(!0), this.attached = {}, this.attachedToElement = !1, this.checkInputs = () => {
    };
  }
  /**
   * Serialize the current input manager attached to a camera.
   * This ensures than once parsed,
   * the input associated to the camera will be identical to the current ones
   * @param serializedCamera Defines the camera serialization JSON the input serialization should write to
   */
  serialize(e) {
    const t = {};
    for (const i in this.attached) {
      const s = this.attached[i], r = le.Serialize(s);
      t[s.getClassName()] = r;
    }
    e.inputsmgr = t;
  }
  /**
   * Parses an input manager serialized JSON to restore the previous list of inputs
   * and states associated to a camera.
   * @param parsedCamera Defines the JSON to parse
   */
  parse(e) {
    const t = e.inputsmgr;
    if (t) {
      this.clear();
      for (const i in t) {
        const s = Ii[i];
        if (s) {
          const r = t[i], n = le.Parse(() => new s(), r, null);
          this.add(n);
        }
      }
    } else
      for (const i in this.attached) {
        const s = Ii[this.attached[i].getClassName()];
        if (s) {
          const r = le.Parse(() => new s(), e, null);
          this.remove(this.attached[i]), this.add(r);
        }
      }
  }
}
class vo {
  constructor() {
    this._currentActiveButton = -1, this.buttons = [0, 1, 2];
  }
  /**
   * Attach the input controls to a specific dom element to get the input from.
   * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
   */
  attachControl(e) {
    e = z.BackCompatCameraNoPreventDefault(arguments);
    const t = this.camera.getEngine(), i = t.getInputElement();
    let s = 0, r = null;
    this._pointA = null, this._pointB = null, this._altKey = !1, this._ctrlKey = !1, this._metaKey = !1, this._shiftKey = !1, this._buttonsPressed = 0, this._pointerInput = (a) => {
      var o, l;
      const c = a.event, u = c.pointerType === "touch";
      if (t.isInVRExclusivePointerMode || a.type !== $.POINTERMOVE && this.buttons.indexOf(c.button) === -1)
        return;
      const d = c.target;
      if (this._altKey = c.altKey, this._ctrlKey = c.ctrlKey, this._metaKey = c.metaKey, this._shiftKey = c.shiftKey, this._buttonsPressed = c.buttons, t.isPointerLock) {
        const f = c.movementX, _ = c.movementY;
        this.onTouch(null, f, _), this._pointA = null, this._pointB = null;
      } else {
        if (a.type !== $.POINTERDOWN && u && ((o = this._pointA) === null || o === void 0 ? void 0 : o.pointerId) !== c.pointerId && ((l = this._pointB) === null || l === void 0 ? void 0 : l.pointerId) !== c.pointerId)
          return;
        if (a.type === $.POINTERDOWN && (this._currentActiveButton === -1 || u)) {
          try {
            d == null || d.setPointerCapture(c.pointerId);
          } catch {
          }
          if (this._pointA === null)
            this._pointA = {
              x: c.clientX,
              y: c.clientY,
              pointerId: c.pointerId,
              type: c.pointerType
            };
          else if (this._pointB === null)
            this._pointB = {
              x: c.clientX,
              y: c.clientY,
              pointerId: c.pointerId,
              type: c.pointerType
            };
          else
            return;
          this._currentActiveButton === -1 && !u && (this._currentActiveButton = c.button), this.onButtonDown(c), e || (c.preventDefault(), i && i.focus());
        } else if (a.type === $.POINTERDOUBLETAP)
          this.onDoubleTap(c.pointerType);
        else if (a.type === $.POINTERUP && (this._currentActiveButton === c.button || u)) {
          try {
            d == null || d.releasePointerCapture(c.pointerId);
          } catch {
          }
          u || (this._pointB = null), t._badOS ? this._pointA = this._pointB = null : this._pointB && this._pointA && this._pointA.pointerId == c.pointerId ? (this._pointA = this._pointB, this._pointB = null) : this._pointA && this._pointB && this._pointB.pointerId == c.pointerId ? this._pointB = null : this._pointA = this._pointB = null, (s !== 0 || r) && (this.onMultiTouch(
            this._pointA,
            this._pointB,
            s,
            0,
            // pinchSquaredDistance
            r,
            null
            // multiTouchPanPosition
          ), s = 0, r = null), this._currentActiveButton = -1, this.onButtonUp(c), e || c.preventDefault();
        } else if (a.type === $.POINTERMOVE) {
          if (e || c.preventDefault(), this._pointA && this._pointB === null) {
            const f = c.clientX - this._pointA.x, _ = c.clientY - this._pointA.y;
            this.onTouch(this._pointA, f, _), this._pointA.x = c.clientX, this._pointA.y = c.clientY;
          } else if (this._pointA && this._pointB) {
            const f = this._pointA.pointerId === c.pointerId ? this._pointA : this._pointB;
            f.x = c.clientX, f.y = c.clientY;
            const _ = this._pointA.x - this._pointB.x, g = this._pointA.y - this._pointB.y, m = _ * _ + g * g, y = {
              x: (this._pointA.x + this._pointB.x) / 2,
              y: (this._pointA.y + this._pointB.y) / 2,
              pointerId: c.pointerId,
              type: a.type
            };
            this.onMultiTouch(this._pointA, this._pointB, s, m, r, y), r = y, s = m;
          }
        }
      }
    }, this._observer = this.camera.getScene()._inputManager._addCameraPointerObserver(this._pointerInput, $.POINTERDOWN | $.POINTERUP | $.POINTERMOVE | $.POINTERDOUBLETAP), this._onLostFocus = () => {
      this._pointA = this._pointB = null, s = 0, r = null, this.onLostFocus();
    }, this._contextMenuBind = this.onContextMenu.bind(this), i && i.addEventListener("contextmenu", this._contextMenuBind, !1);
    const n = this.camera.getScene().getEngine().getHostWindow();
    n && z.RegisterTopRootEvents(n, [{ name: "blur", handler: this._onLostFocus }]);
  }
  /**
   * Detach the current controls from the specified dom element.
   */
  detachControl() {
    if (this._onLostFocus) {
      const e = this.camera.getScene().getEngine().getHostWindow();
      e && z.UnregisterTopRootEvents(e, [{ name: "blur", handler: this._onLostFocus }]);
    }
    if (this._observer) {
      if (this.camera.getScene()._inputManager._removeCameraPointerObserver(this._observer), this._observer = null, this._contextMenuBind) {
        const e = this.camera.getScene().getEngine().getInputElement();
        e && e.removeEventListener("contextmenu", this._contextMenuBind);
      }
      this._onLostFocus = null;
    }
    this._altKey = !1, this._ctrlKey = !1, this._metaKey = !1, this._shiftKey = !1, this._buttonsPressed = 0, this._currentActiveButton = -1;
  }
  /**
   * Gets the class name of the current input.
   * @returns the class name
   */
  getClassName() {
    return "BaseCameraPointersInput";
  }
  /**
   * Get the friendly name associated with the input class.
   * @returns the input friendly name
   */
  getSimpleName() {
    return "pointers";
  }
  /**
   * Called on pointer POINTERDOUBLETAP event.
   * Override this method to provide functionality on POINTERDOUBLETAP event.
   * @param type
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onDoubleTap(e) {
  }
  /**
   * Called on pointer POINTERMOVE event if only a single touch is active.
   * Override this method to provide functionality.
   * @param point
   * @param offsetX
   * @param offsetY
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onTouch(e, t, i) {
  }
  /**
   * Called on pointer POINTERMOVE event if multiple touches are active.
   * Override this method to provide functionality.
   * @param _pointA
   * @param _pointB
   * @param previousPinchSquaredDistance
   * @param pinchSquaredDistance
   * @param previousMultiTouchPanPosition
   * @param multiTouchPanPosition
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onMultiTouch(e, t, i, s, r, n) {
  }
  /**
   * Called on JS contextmenu event.
   * Override this method to provide functionality.
   * @param evt
   */
  onContextMenu(e) {
    e.preventDefault();
  }
  /**
   * Called each time a new POINTERDOWN event occurs. Ie, for each button
   * press.
   * Override this method to provide functionality.
   * @param evt
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onButtonDown(e) {
  }
  /**
   * Called each time a new POINTERUP event occurs. Ie, for each button
   * release.
   * Override this method to provide functionality.
   * @param evt
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onButtonUp(e) {
  }
  /**
   * Called when window becomes inactive.
   * Override this method to provide functionality.
   */
  onLostFocus() {
  }
}
E([
  R()
], vo.prototype, "buttons", void 0);
class kt extends vo {
  constructor() {
    super(...arguments), this.buttons = [0, 1, 2], this.angularSensibilityX = 1e3, this.angularSensibilityY = 1e3, this.pinchPrecision = 12, this.pinchDeltaPercentage = 0, this.useNaturalPinchZoom = !1, this.pinchZoom = !0, this.panningSensibility = 1e3, this.multiTouchPanning = !0, this.multiTouchPanAndZoom = !0, this.pinchInwards = !0, this._isPanClick = !1, this._twoFingerActivityCount = 0, this._isPinching = !1;
  }
  /**
   * Gets the class name of the current input.
   * @returns the class name
   */
  getClassName() {
    return "ArcRotateCameraPointersInput";
  }
  /**
   * Move camera from multi touch panning positions.
   * @param previousMultiTouchPanPosition
   * @param multiTouchPanPosition
   */
  _computeMultiTouchPanning(e, t) {
    if (this.panningSensibility !== 0 && e && t) {
      const i = t.x - e.x, s = t.y - e.y;
      this.camera.inertialPanningX += -i / this.panningSensibility, this.camera.inertialPanningY += s / this.panningSensibility;
    }
  }
  /**
   * Move camera from pinch zoom distances.
   * @param previousPinchSquaredDistance
   * @param pinchSquaredDistance
   */
  _computePinchZoom(e, t) {
    const i = this.camera.radius || kt.MinimumRadiusForPinch;
    this.useNaturalPinchZoom ? this.camera.radius = i * Math.sqrt(e) / Math.sqrt(t) : this.pinchDeltaPercentage ? this.camera.inertialRadiusOffset += (t - e) * 1e-3 * i * this.pinchDeltaPercentage : this.camera.inertialRadiusOffset += (t - e) / (this.pinchPrecision * (this.pinchInwards ? 1 : -1) * (this.angularSensibilityX + this.angularSensibilityY) / 2);
  }
  /**
   * Called on pointer POINTERMOVE event if only a single touch is active.
   * @param point
   * @param offsetX
   * @param offsetY
   */
  onTouch(e, t, i) {
    this.panningSensibility !== 0 && (this._ctrlKey && this.camera._useCtrlForPanning || this._isPanClick) ? (this.camera.inertialPanningX += -t / this.panningSensibility, this.camera.inertialPanningY += i / this.panningSensibility) : (this.camera.inertialAlphaOffset -= t / this.angularSensibilityX, this.camera.inertialBetaOffset -= i / this.angularSensibilityY);
  }
  /**
   * Called on pointer POINTERDOUBLETAP event.
   */
  onDoubleTap() {
    this.camera.useInputToRestoreState && this.camera.restoreState();
  }
  /**
   * Called on pointer POINTERMOVE event if multiple touches are active.
   * @param pointA
   * @param pointB
   * @param previousPinchSquaredDistance
   * @param pinchSquaredDistance
   * @param previousMultiTouchPanPosition
   * @param multiTouchPanPosition
   */
  onMultiTouch(e, t, i, s, r, n) {
    i === 0 && r === null || s === 0 && n === null || (this.multiTouchPanAndZoom ? (this._computePinchZoom(i, s), this._computeMultiTouchPanning(r, n)) : this.multiTouchPanning && this.pinchZoom ? (this._twoFingerActivityCount++, this._isPinching || this._twoFingerActivityCount < 20 && Math.abs(Math.sqrt(s) - Math.sqrt(i)) > this.camera.pinchToPanMaxDistance ? (this._computePinchZoom(i, s), this._isPinching = !0) : this._computeMultiTouchPanning(r, n)) : this.multiTouchPanning ? this._computeMultiTouchPanning(r, n) : this.pinchZoom && this._computePinchZoom(i, s));
  }
  /**
   * Called each time a new POINTERDOWN event occurs. Ie, for each button
   * press.
   * @param evt
   */
  onButtonDown(e) {
    this._isPanClick = e.button === this.camera._panningMouseButton;
  }
  /**
   * Called each time a new POINTERUP event occurs. Ie, for each button
   * release.
   */
  onButtonUp() {
    this._twoFingerActivityCount = 0, this._isPinching = !1;
  }
  /**
   * Called when window becomes inactive.
   */
  onLostFocus() {
    this._isPanClick = !1, this._twoFingerActivityCount = 0, this._isPinching = !1;
  }
}
kt.MinimumRadiusForPinch = 1e-3;
E([
  R()
], kt.prototype, "buttons", void 0);
E([
  R()
], kt.prototype, "angularSensibilityX", void 0);
E([
  R()
], kt.prototype, "angularSensibilityY", void 0);
E([
  R()
], kt.prototype, "pinchPrecision", void 0);
E([
  R()
], kt.prototype, "pinchDeltaPercentage", void 0);
E([
  R()
], kt.prototype, "useNaturalPinchZoom", void 0);
E([
  R()
], kt.prototype, "pinchZoom", void 0);
E([
  R()
], kt.prototype, "panningSensibility", void 0);
E([
  R()
], kt.prototype, "multiTouchPanning", void 0);
E([
  R()
], kt.prototype, "multiTouchPanAndZoom", void 0);
Ii.ArcRotateCameraPointersInput = kt;
class ni {
  constructor() {
    this.keysUp = [38], this.keysDown = [40], this.keysLeft = [37], this.keysRight = [39], this.keysReset = [220], this.panningSensibility = 50, this.zoomingSensibility = 25, this.useAltToZoom = !0, this.angularSpeed = 0.01, this._keys = new Array();
  }
  /**
   * Attach the input controls to a specific dom element to get the input from.
   * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
   */
  attachControl(e) {
    e = z.BackCompatCameraNoPreventDefault(arguments), !this._onCanvasBlurObserver && (this._scene = this.camera.getScene(), this._engine = this._scene.getEngine(), this._onCanvasBlurObserver = this._engine.onCanvasBlurObservable.add(() => {
      this._keys.length = 0;
    }), this._onKeyboardObserver = this._scene.onKeyboardObservable.add((t) => {
      const i = t.event;
      if (!i.metaKey) {
        if (t.type === ms.KEYDOWN)
          this._ctrlPressed = i.ctrlKey, this._altPressed = i.altKey, (this.keysUp.indexOf(i.keyCode) !== -1 || this.keysDown.indexOf(i.keyCode) !== -1 || this.keysLeft.indexOf(i.keyCode) !== -1 || this.keysRight.indexOf(i.keyCode) !== -1 || this.keysReset.indexOf(i.keyCode) !== -1) && (this._keys.indexOf(i.keyCode) === -1 && this._keys.push(i.keyCode), i.preventDefault && (e || i.preventDefault()));
        else if (this.keysUp.indexOf(i.keyCode) !== -1 || this.keysDown.indexOf(i.keyCode) !== -1 || this.keysLeft.indexOf(i.keyCode) !== -1 || this.keysRight.indexOf(i.keyCode) !== -1 || this.keysReset.indexOf(i.keyCode) !== -1) {
          const s = this._keys.indexOf(i.keyCode);
          s >= 0 && this._keys.splice(s, 1), i.preventDefault && (e || i.preventDefault());
        }
      }
    }));
  }
  /**
   * Detach the current controls from the specified dom element.
   */
  detachControl() {
    this._scene && (this._onKeyboardObserver && this._scene.onKeyboardObservable.remove(this._onKeyboardObserver), this._onCanvasBlurObserver && this._engine.onCanvasBlurObservable.remove(this._onCanvasBlurObserver), this._onKeyboardObserver = null, this._onCanvasBlurObserver = null), this._keys.length = 0;
  }
  /**
   * Update the current camera state depending on the inputs that have been used this frame.
   * This is a dynamically created lambda to avoid the performance penalty of looping for inputs in the render loop.
   */
  checkInputs() {
    if (this._onKeyboardObserver) {
      const e = this.camera;
      for (let t = 0; t < this._keys.length; t++) {
        const i = this._keys[t];
        this.keysLeft.indexOf(i) !== -1 ? this._ctrlPressed && this.camera._useCtrlForPanning ? e.inertialPanningX -= 1 / this.panningSensibility : e.inertialAlphaOffset -= this.angularSpeed : this.keysUp.indexOf(i) !== -1 ? this._ctrlPressed && this.camera._useCtrlForPanning ? e.inertialPanningY += 1 / this.panningSensibility : this._altPressed && this.useAltToZoom ? e.inertialRadiusOffset += 1 / this.zoomingSensibility : e.inertialBetaOffset -= this.angularSpeed : this.keysRight.indexOf(i) !== -1 ? this._ctrlPressed && this.camera._useCtrlForPanning ? e.inertialPanningX += 1 / this.panningSensibility : e.inertialAlphaOffset += this.angularSpeed : this.keysDown.indexOf(i) !== -1 ? this._ctrlPressed && this.camera._useCtrlForPanning ? e.inertialPanningY -= 1 / this.panningSensibility : this._altPressed && this.useAltToZoom ? e.inertialRadiusOffset -= 1 / this.zoomingSensibility : e.inertialBetaOffset += this.angularSpeed : this.keysReset.indexOf(i) !== -1 && e.useInputToRestoreState && e.restoreState();
      }
    }
  }
  /**
   * Gets the class name of the current input.
   * @returns the class name
   */
  getClassName() {
    return "ArcRotateCameraKeyboardMoveInput";
  }
  /**
   * Get the friendly name associated with the input class.
   * @returns the input friendly name
   */
  getSimpleName() {
    return "keyboard";
  }
}
E([
  R()
], ni.prototype, "keysUp", void 0);
E([
  R()
], ni.prototype, "keysDown", void 0);
E([
  R()
], ni.prototype, "keysLeft", void 0);
E([
  R()
], ni.prototype, "keysRight", void 0);
E([
  R()
], ni.prototype, "keysReset", void 0);
E([
  R()
], ni.prototype, "panningSensibility", void 0);
E([
  R()
], ni.prototype, "zoomingSensibility", void 0);
E([
  R()
], ni.prototype, "useAltToZoom", void 0);
E([
  R()
], ni.prototype, "angularSpeed", void 0);
Ii.ArcRotateCameraKeyboardMoveInput = ni;
const Fc = 40;
class Js {
  constructor() {
    this.wheelPrecision = 3, this.zoomToMouseLocation = !1, this.wheelDeltaPercentage = 0, this.customComputeDeltaFromMouseWheel = null, this._inertialPanning = p.Zero();
  }
  _computeDeltaFromMouseWheelLegacyEvent(e, t) {
    let i = 0;
    const s = e * 0.01 * this.wheelDeltaPercentage * t;
    return e > 0 ? i = s / (1 + this.wheelDeltaPercentage) : i = s * (1 + this.wheelDeltaPercentage), i;
  }
  /**
   * Attach the input controls to a specific dom element to get the input from.
   * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
   */
  attachControl(e) {
    e = z.BackCompatCameraNoPreventDefault(arguments), this._wheel = (t) => {
      if (t.type !== $.POINTERWHEEL)
        return;
      const i = t.event;
      let s = 0;
      const r = i.deltaMode === xs.DOM_DELTA_LINE ? Fc : 1, n = -(i.deltaY * r);
      if (this.customComputeDeltaFromMouseWheel)
        s = this.customComputeDeltaFromMouseWheel(n, this, i);
      else if (this.wheelDeltaPercentage) {
        if (s = this._computeDeltaFromMouseWheelLegacyEvent(n, this.camera.radius), s > 0) {
          let a = this.camera.radius, o = this.camera.inertialRadiusOffset + s;
          for (let l = 0; l < 20 && Math.abs(o) > 1e-3; l++)
            a -= o, o *= this.camera.inertia;
          a = J.Clamp(a, 0, Number.MAX_VALUE), s = this._computeDeltaFromMouseWheelLegacyEvent(n, a);
        }
      } else
        s = n / (this.wheelPrecision * 40);
      s && (this.zoomToMouseLocation ? (this._hitPlane || this._updateHitPlane(), this._zoomToMouse(s)) : this.camera.inertialRadiusOffset += s), i.preventDefault && (e || i.preventDefault());
    }, this._observer = this.camera.getScene()._inputManager._addCameraPointerObserver(this._wheel, $.POINTERWHEEL), this.zoomToMouseLocation && this._inertialPanning.setAll(0);
  }
  /**
   * Detach the current controls from the specified dom element.
   */
  detachControl() {
    this._observer && (this.camera.getScene()._inputManager._removeCameraPointerObserver(this._observer), this._observer = null, this._wheel = null);
  }
  /**
   * Update the current camera state depending on the inputs that have been used this frame.
   * This is a dynamically created lambda to avoid the performance penalty of looping for inputs in the render loop.
   */
  checkInputs() {
    if (!this.zoomToMouseLocation)
      return;
    const e = this.camera;
    0 + e.inertialAlphaOffset + e.inertialBetaOffset + e.inertialRadiusOffset && (this._updateHitPlane(), e.target.addInPlace(this._inertialPanning), this._inertialPanning.scaleInPlace(e.inertia), this._zeroIfClose(this._inertialPanning));
  }
  /**
   * Gets the class name of the current input.
   * @returns the class name
   */
  getClassName() {
    return "ArcRotateCameraMouseWheelInput";
  }
  /**
   * Get the friendly name associated with the input class.
   * @returns the input friendly name
   */
  getSimpleName() {
    return "mousewheel";
  }
  _updateHitPlane() {
    const e = this.camera, t = e.target.subtract(e.position);
    this._hitPlane = Dt.FromPositionAndNormal(e.target, t);
  }
  // Get position on the hit plane
  _getPosition() {
    var e;
    const t = this.camera, i = t.getScene(), s = i.createPickingRay(i.pointerX, i.pointerY, I.Identity(), t, !1);
    s.origin.x -= t.targetScreenOffset.x, s.origin.y -= t.targetScreenOffset.y;
    let r = 0;
    return this._hitPlane && (r = (e = s.intersectsPlane(this._hitPlane)) !== null && e !== void 0 ? e : 0), s.origin.addInPlace(s.direction.scaleInPlace(r));
  }
  _zoomToMouse(e) {
    var t, i;
    const s = this.camera, r = 1 - s.inertia;
    if (s.lowerRadiusLimit) {
      const c = (t = s.lowerRadiusLimit) !== null && t !== void 0 ? t : 0;
      s.radius - (s.inertialRadiusOffset + e) / r < c && (e = (s.radius - c) * r - s.inertialRadiusOffset);
    }
    if (s.upperRadiusLimit) {
      const c = (i = s.upperRadiusLimit) !== null && i !== void 0 ? i : 0;
      s.radius - (s.inertialRadiusOffset + e) / r > c && (e = (s.radius - c) * r - s.inertialRadiusOffset);
    }
    const a = e / r / s.radius, o = this._getPosition(), l = C.Vector3[6];
    o.subtractToRef(s.target, l), l.scaleInPlace(a), l.scaleInPlace(r), this._inertialPanning.addInPlace(l), s.inertialRadiusOffset += e;
  }
  // Sets x y or z of passed in vector to zero if less than Epsilon.
  _zeroIfClose(e) {
    Math.abs(e.x) < pe && (e.x = 0), Math.abs(e.y) < pe && (e.y = 0), Math.abs(e.z) < pe && (e.z = 0);
  }
}
E([
  R()
], Js.prototype, "wheelPrecision", void 0);
E([
  R()
], Js.prototype, "zoomToMouseLocation", void 0);
E([
  R()
], Js.prototype, "wheelDeltaPercentage", void 0);
Ii.ArcRotateCameraMouseWheelInput = Js;
class Lc extends yo {
  /**
   * Instantiates a new ArcRotateCameraInputsManager.
   * @param camera Defines the camera the inputs belong to
   */
  constructor(e) {
    super(e);
  }
  /**
   * Add mouse wheel input support to the input manager.
   * @returns the current input manager
   */
  addMouseWheel() {
    return this.add(new Js()), this;
  }
  /**
   * Add pointers input support to the input manager.
   * @returns the current input manager
   */
  addPointers() {
    return this.add(new kt()), this;
  }
  /**
   * Add keyboard input support to the input manager.
   * @returns the current input manager
   */
  addKeyboard() {
    return this.add(new ni()), this;
  }
}
ut.AddNodeConstructor("ArcRotateCamera", (h, e) => () => new Ke(h, 0, 0, 1, p.Zero(), e));
class Ke extends lt {
  /**
   * Defines the target point of the camera.
   * The camera looks towards it from the radius distance.
   */
  get target() {
    return this._target;
  }
  set target(e) {
    this.setTarget(e);
  }
  /**
   * Defines the target mesh of the camera.
   * The camera looks towards it from the radius distance.
   * Please note that setting a target host will disable panning.
   */
  get targetHost() {
    return this._targetHost;
  }
  set targetHost(e) {
    e && this.setTarget(e);
  }
  /**
   * Return the current target position of the camera. This value is expressed in local space.
   * @returns the target position
   */
  getTarget() {
    return this.target;
  }
  /**
   * Define the current local position of the camera in the scene
   */
  get position() {
    return this._position;
  }
  set position(e) {
    this.setPosition(e);
  }
  /**
   * The vector the camera should consider as up. (default is Vector3(0, 1, 0) as returned by Vector3.Up())
   * Setting this will copy the given vector to the camera's upVector, and set rotation matrices to and from Y up.
   * DO NOT set the up vector using copyFrom or copyFromFloats, as this bypasses setting the above matrices.
   */
  set upVector(e) {
    this._upToYMatrix || (this._yToUpMatrix = new I(), this._upToYMatrix = new I(), this._upVector = p.Zero()), e.normalize(), this._upVector.copyFrom(e), this.setMatUp();
  }
  get upVector() {
    return this._upVector;
  }
  /**
   * Sets the Y-up to camera up-vector rotation matrix, and the up-vector to Y-up rotation matrix.
   */
  setMatUp() {
    I.RotationAlignToRef(p.UpReadOnly, this._upVector, this._yToUpMatrix), I.RotationAlignToRef(this._upVector, p.UpReadOnly, this._upToYMatrix);
  }
  //-- begin properties for backward compatibility for inputs
  /**
   * Gets or Set the pointer angular sensibility  along the X axis or how fast is the camera rotating.
   */
  get angularSensibilityX() {
    const e = this.inputs.attached.pointers;
    return e ? e.angularSensibilityX : 0;
  }
  set angularSensibilityX(e) {
    const t = this.inputs.attached.pointers;
    t && (t.angularSensibilityX = e);
  }
  /**
   * Gets or Set the pointer angular sensibility along the Y axis or how fast is the camera rotating.
   */
  get angularSensibilityY() {
    const e = this.inputs.attached.pointers;
    return e ? e.angularSensibilityY : 0;
  }
  set angularSensibilityY(e) {
    const t = this.inputs.attached.pointers;
    t && (t.angularSensibilityY = e);
  }
  /**
   * Gets or Set the pointer pinch precision or how fast is the camera zooming.
   */
  get pinchPrecision() {
    const e = this.inputs.attached.pointers;
    return e ? e.pinchPrecision : 0;
  }
  set pinchPrecision(e) {
    const t = this.inputs.attached.pointers;
    t && (t.pinchPrecision = e);
  }
  /**
   * Gets or Set the pointer pinch delta percentage or how fast is the camera zooming.
   * It will be used instead of pinchDeltaPrecision if different from 0.
   * It defines the percentage of current camera.radius to use as delta when pinch zoom is used.
   */
  get pinchDeltaPercentage() {
    const e = this.inputs.attached.pointers;
    return e ? e.pinchDeltaPercentage : 0;
  }
  set pinchDeltaPercentage(e) {
    const t = this.inputs.attached.pointers;
    t && (t.pinchDeltaPercentage = e);
  }
  /**
   * Gets or Set the pointer use natural pinch zoom to override the pinch precision
   * and pinch delta percentage.
   * When useNaturalPinchZoom is true, multi touch zoom will zoom in such
   * that any object in the plane at the camera's target point will scale
   * perfectly with finger motion.
   */
  get useNaturalPinchZoom() {
    const e = this.inputs.attached.pointers;
    return e ? e.useNaturalPinchZoom : !1;
  }
  set useNaturalPinchZoom(e) {
    const t = this.inputs.attached.pointers;
    t && (t.useNaturalPinchZoom = e);
  }
  /**
   * Gets or Set the pointer panning sensibility or how fast is the camera moving.
   */
  get panningSensibility() {
    const e = this.inputs.attached.pointers;
    return e ? e.panningSensibility : 0;
  }
  set panningSensibility(e) {
    const t = this.inputs.attached.pointers;
    t && (t.panningSensibility = e);
  }
  /**
   * Gets or Set the list of keyboard keys used to control beta angle in a positive direction.
   */
  get keysUp() {
    const e = this.inputs.attached.keyboard;
    return e ? e.keysUp : [];
  }
  set keysUp(e) {
    const t = this.inputs.attached.keyboard;
    t && (t.keysUp = e);
  }
  /**
   * Gets or Set the list of keyboard keys used to control beta angle in a negative direction.
   */
  get keysDown() {
    const e = this.inputs.attached.keyboard;
    return e ? e.keysDown : [];
  }
  set keysDown(e) {
    const t = this.inputs.attached.keyboard;
    t && (t.keysDown = e);
  }
  /**
   * Gets or Set the list of keyboard keys used to control alpha angle in a negative direction.
   */
  get keysLeft() {
    const e = this.inputs.attached.keyboard;
    return e ? e.keysLeft : [];
  }
  set keysLeft(e) {
    const t = this.inputs.attached.keyboard;
    t && (t.keysLeft = e);
  }
  /**
   * Gets or Set the list of keyboard keys used to control alpha angle in a positive direction.
   */
  get keysRight() {
    const e = this.inputs.attached.keyboard;
    return e ? e.keysRight : [];
  }
  set keysRight(e) {
    const t = this.inputs.attached.keyboard;
    t && (t.keysRight = e);
  }
  /**
   * Gets or Set the mouse wheel precision or how fast is the camera zooming.
   */
  get wheelPrecision() {
    const e = this.inputs.attached.mousewheel;
    return e ? e.wheelPrecision : 0;
  }
  set wheelPrecision(e) {
    const t = this.inputs.attached.mousewheel;
    t && (t.wheelPrecision = e);
  }
  /**
   * Gets or Set the boolean value that controls whether or not the mouse wheel
   * zooms to the location of the mouse pointer or not.  The default is false.
   */
  get zoomToMouseLocation() {
    const e = this.inputs.attached.mousewheel;
    return e ? e.zoomToMouseLocation : !1;
  }
  set zoomToMouseLocation(e) {
    const t = this.inputs.attached.mousewheel;
    t && (t.zoomToMouseLocation = e);
  }
  /**
   * Gets or Set the mouse wheel delta percentage or how fast is the camera zooming.
   * It will be used instead of pinchDeltaPrecision if different from 0.
   * It defines the percentage of current camera.radius to use as delta when pinch zoom is used.
   */
  get wheelDeltaPercentage() {
    const e = this.inputs.attached.mousewheel;
    return e ? e.wheelDeltaPercentage : 0;
  }
  set wheelDeltaPercentage(e) {
    const t = this.inputs.attached.mousewheel;
    t && (t.wheelDeltaPercentage = e);
  }
  /**
   * Gets the bouncing behavior of the camera if it has been enabled.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors/cameraBehaviors#bouncing-behavior
   */
  get bouncingBehavior() {
    return this._bouncingBehavior;
  }
  /**
   * Defines if the bouncing behavior of the camera is enabled on the camera.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors/cameraBehaviors#bouncing-behavior
   */
  get useBouncingBehavior() {
    return this._bouncingBehavior != null;
  }
  set useBouncingBehavior(e) {
    e !== this.useBouncingBehavior && (e ? (this._bouncingBehavior = new Zi(), this.addBehavior(this._bouncingBehavior)) : this._bouncingBehavior && (this.removeBehavior(this._bouncingBehavior), this._bouncingBehavior = null));
  }
  /**
   * Gets the framing behavior of the camera if it has been enabled.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors/cameraBehaviors#framing-behavior
   */
  get framingBehavior() {
    return this._framingBehavior;
  }
  /**
   * Defines if the framing behavior of the camera is enabled on the camera.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors/cameraBehaviors#framing-behavior
   */
  get useFramingBehavior() {
    return this._framingBehavior != null;
  }
  set useFramingBehavior(e) {
    e !== this.useFramingBehavior && (e ? (this._framingBehavior = new Lt(), this.addBehavior(this._framingBehavior)) : this._framingBehavior && (this.removeBehavior(this._framingBehavior), this._framingBehavior = null));
  }
  /**
   * Gets the auto rotation behavior of the camera if it has been enabled.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors/cameraBehaviors#autorotation-behavior
   */
  get autoRotationBehavior() {
    return this._autoRotationBehavior;
  }
  /**
   * Defines if the auto rotation behavior of the camera is enabled on the camera.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors/cameraBehaviors#autorotation-behavior
   */
  get useAutoRotationBehavior() {
    return this._autoRotationBehavior != null;
  }
  set useAutoRotationBehavior(e) {
    e !== this.useAutoRotationBehavior && (e ? (this._autoRotationBehavior = new Oc(), this.addBehavior(this._autoRotationBehavior)) : this._autoRotationBehavior && (this.removeBehavior(this._autoRotationBehavior), this._autoRotationBehavior = null));
  }
  /**
   * Instantiates a new ArcRotateCamera in a given scene
   * @param name Defines the name of the camera
   * @param alpha Defines the camera rotation along the longitudinal axis
   * @param beta Defines the camera rotation along the latitudinal axis
   * @param radius Defines the camera distance from its target
   * @param target Defines the camera target
   * @param scene Defines the scene the camera belongs to
   * @param setActiveOnSceneIfNoneActive Defines whether the camera should be marked as active if not other active cameras have been defined
   */
  constructor(e, t, i, s, r, n, a = !0) {
    super(e, p.Zero(), n, a), this.inertialAlphaOffset = 0, this.inertialBetaOffset = 0, this.inertialRadiusOffset = 0, this.lowerAlphaLimit = null, this.upperAlphaLimit = null, this.lowerBetaLimit = 0.01, this.upperBetaLimit = Math.PI - 0.01, this.lowerRadiusLimit = null, this.upperRadiusLimit = null, this.inertialPanningX = 0, this.inertialPanningY = 0, this.pinchToPanMaxDistance = 20, this.panningDistanceLimit = null, this.panningOriginTarget = p.Zero(), this.panningInertia = 0.9, this.zoomOnFactor = 1, this.targetScreenOffset = ue.Zero(), this.allowUpsideDown = !0, this.useInputToRestoreState = !0, this._viewMatrix = new I(), this.panningAxis = new p(1, 1, 0), this._transformedDirection = new p(), this.mapPanning = !1, this.onMeshTargetChangedObservable = new N(), this.checkCollisions = !1, this.collisionRadius = new p(0.5, 0.5, 0.5), this._previousPosition = p.Zero(), this._collisionVelocity = p.Zero(), this._newPosition = p.Zero(), this._computationVector = p.Zero(), this._onCollisionPositionChange = (o, l, c = null) => {
      c ? (this.setPosition(l), this.onCollide && this.onCollide(c)) : this._previousPosition.copyFrom(this._position);
      const u = Math.cos(this.alpha), d = Math.sin(this.alpha), f = Math.cos(this.beta);
      let _ = Math.sin(this.beta);
      _ === 0 && (_ = 1e-4);
      const g = this._getTargetPosition();
      this._computationVector.copyFromFloats(this.radius * u * _, this.radius * f, this.radius * d * _), g.addToRef(this._computationVector, this._newPosition), this._position.copyFrom(this._newPosition);
      let m = this.upVector;
      this.allowUpsideDown && this.beta < 0 && (m = m.clone(), m = m.negate()), this._computeViewMatrix(this._position, g, m), this._viewMatrix.addAtIndex(12, this.targetScreenOffset.x), this._viewMatrix.addAtIndex(13, this.targetScreenOffset.y), this._collisionTriggered = !1;
    }, this._target = p.Zero(), r && this.setTarget(r), this.alpha = t, this.beta = i, this.radius = s, this.getViewMatrix(), this.inputs = new Lc(this), this.inputs.addKeyboard().addMouseWheel().addPointers();
  }
  // Cache
  /** @internal */
  _initCache() {
    super._initCache(), this._cache._target = new p(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE), this._cache.alpha = void 0, this._cache.beta = void 0, this._cache.radius = void 0, this._cache.targetScreenOffset = ue.Zero();
  }
  /**
   * @internal
   */
  _updateCache(e) {
    e || super._updateCache(), this._cache._target.copyFrom(this._getTargetPosition()), this._cache.alpha = this.alpha, this._cache.beta = this.beta, this._cache.radius = this.radius, this._cache.targetScreenOffset.copyFrom(this.targetScreenOffset);
  }
  _getTargetPosition() {
    if (this._targetHost && this._targetHost.getAbsolutePosition) {
      const t = this._targetHost.getAbsolutePosition();
      this._targetBoundingCenter ? t.addToRef(this._targetBoundingCenter, this._target) : this._target.copyFrom(t);
    }
    const e = this._getLockedTargetPosition();
    return e || this._target;
  }
  /**
   * Stores the current state of the camera (alpha, beta, radius and target)
   * @returns the camera itself
   */
  storeState() {
    return this._storedAlpha = this.alpha, this._storedBeta = this.beta, this._storedRadius = this.radius, this._storedTarget = this._getTargetPosition().clone(), this._storedTargetScreenOffset = this.targetScreenOffset.clone(), super.storeState();
  }
  /**
   * @internal
   * Restored camera state. You must call storeState() first
   */
  _restoreStateValues() {
    return super._restoreStateValues() ? (this.setTarget(this._storedTarget.clone()), this.alpha = this._storedAlpha, this.beta = this._storedBeta, this.radius = this._storedRadius, this.targetScreenOffset = this._storedTargetScreenOffset.clone(), this.inertialAlphaOffset = 0, this.inertialBetaOffset = 0, this.inertialRadiusOffset = 0, this.inertialPanningX = 0, this.inertialPanningY = 0, !0) : !1;
  }
  // Synchronized
  /** @internal */
  _isSynchronizedViewMatrix() {
    return super._isSynchronizedViewMatrix() ? this._cache._target.equals(this._getTargetPosition()) && this._cache.alpha === this.alpha && this._cache.beta === this.beta && this._cache.radius === this.radius && this._cache.targetScreenOffset.equals(this.targetScreenOffset) : !1;
  }
  /**
   * Attached controls to the current camera.
   * @param ignored defines an ignored parameter kept for backward compatibility.
   * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
   * @param useCtrlForPanning  Defines whether ctrl is used for panning within the controls
   * @param panningMouseButton Defines whether panning is allowed through mouse click button
   */
  attachControl(e, t, i = !0, s = 2) {
    const r = arguments;
    t = z.BackCompatCameraNoPreventDefault(r), this._useCtrlForPanning = i, this._panningMouseButton = s, typeof r[0] == "boolean" && (r.length > 1 && (this._useCtrlForPanning = r[1]), r.length > 2 && (this._panningMouseButton = r[2])), this.inputs.attachElement(t), this._reset = () => {
      this.inertialAlphaOffset = 0, this.inertialBetaOffset = 0, this.inertialRadiusOffset = 0, this.inertialPanningX = 0, this.inertialPanningY = 0;
    };
  }
  /**
   * Detach the current controls from the specified dom element.
   */
  detachControl() {
    this.inputs.detachElement(), this._reset && this._reset();
  }
  /** @internal */
  _checkInputs() {
    if (!this._collisionTriggered) {
      if (this.inputs.checkInputs(), this.inertialAlphaOffset !== 0 || this.inertialBetaOffset !== 0 || this.inertialRadiusOffset !== 0) {
        const e = this.invertRotation ? -1 : 1;
        let t = this.inertialAlphaOffset;
        this.beta <= 0 && (t *= -1), this.getScene().useRightHandedSystem && (t *= -1), this.parent && this.parent._getWorldMatrixDeterminant() < 0 && (t *= -1), this.alpha += t * e, this.beta += this.inertialBetaOffset * e, this.radius -= this.inertialRadiusOffset, this.inertialAlphaOffset *= this.inertia, this.inertialBetaOffset *= this.inertia, this.inertialRadiusOffset *= this.inertia, Math.abs(this.inertialAlphaOffset) < pe && (this.inertialAlphaOffset = 0), Math.abs(this.inertialBetaOffset) < pe && (this.inertialBetaOffset = 0), Math.abs(this.inertialRadiusOffset) < this.speed * pe && (this.inertialRadiusOffset = 0);
      }
      if (this.inertialPanningX !== 0 || this.inertialPanningY !== 0) {
        const e = new p(this.inertialPanningX, this.inertialPanningY, this.inertialPanningY);
        this._viewMatrix.invertToRef(this._cameraTransformMatrix), e.multiplyInPlace(this.panningAxis), p.TransformNormalToRef(e, this._cameraTransformMatrix, this._transformedDirection), (this.mapPanning || !this.panningAxis.y) && (this._transformedDirection.y = 0), this._targetHost || (this.panningDistanceLimit ? (this._transformedDirection.addInPlace(this._target), p.DistanceSquared(this._transformedDirection, this.panningOriginTarget) <= this.panningDistanceLimit * this.panningDistanceLimit && this._target.copyFrom(this._transformedDirection)) : this._target.addInPlace(this._transformedDirection)), this.inertialPanningX *= this.panningInertia, this.inertialPanningY *= this.panningInertia, Math.abs(this.inertialPanningX) < this.speed * pe && (this.inertialPanningX = 0), Math.abs(this.inertialPanningY) < this.speed * pe && (this.inertialPanningY = 0);
      }
      this._checkLimits(), super._checkInputs();
    }
  }
  _checkLimits() {
    this.lowerBetaLimit === null || this.lowerBetaLimit === void 0 ? this.allowUpsideDown && this.beta > Math.PI && (this.beta = this.beta - 2 * Math.PI) : this.beta < this.lowerBetaLimit && (this.beta = this.lowerBetaLimit), this.upperBetaLimit === null || this.upperBetaLimit === void 0 ? this.allowUpsideDown && this.beta < -Math.PI && (this.beta = this.beta + 2 * Math.PI) : this.beta > this.upperBetaLimit && (this.beta = this.upperBetaLimit), this.lowerAlphaLimit !== null && this.alpha < this.lowerAlphaLimit && (this.alpha = this.lowerAlphaLimit), this.upperAlphaLimit !== null && this.alpha > this.upperAlphaLimit && (this.alpha = this.upperAlphaLimit), this.lowerRadiusLimit !== null && this.radius < this.lowerRadiusLimit && (this.radius = this.lowerRadiusLimit, this.inertialRadiusOffset = 0), this.upperRadiusLimit !== null && this.radius > this.upperRadiusLimit && (this.radius = this.upperRadiusLimit, this.inertialRadiusOffset = 0);
  }
  /**
   * Rebuilds angles (alpha, beta) and radius from the give position and target
   */
  rebuildAnglesAndRadius() {
    this._position.subtractToRef(this._getTargetPosition(), this._computationVector), (this._upVector.x !== 0 || this._upVector.y !== 1 || this._upVector.z !== 0) && p.TransformCoordinatesToRef(this._computationVector, this._upToYMatrix, this._computationVector), this.radius = this._computationVector.length(), this.radius === 0 && (this.radius = 1e-4);
    const e = this.alpha;
    this._computationVector.x === 0 && this._computationVector.z === 0 ? this.alpha = Math.PI / 2 : this.alpha = Math.acos(this._computationVector.x / Math.sqrt(Math.pow(this._computationVector.x, 2) + Math.pow(this._computationVector.z, 2))), this._computationVector.z < 0 && (this.alpha = 2 * Math.PI - this.alpha);
    const t = Math.round((e - this.alpha) / (2 * Math.PI));
    this.alpha += t * 2 * Math.PI, this.beta = Math.acos(this._computationVector.y / this.radius), this._checkLimits();
  }
  /**
   * Use a position to define the current camera related information like alpha, beta and radius
   * @param position Defines the position to set the camera at
   */
  setPosition(e) {
    this._position.equals(e) || (this._position.copyFrom(e), this.rebuildAnglesAndRadius());
  }
  /**
   * Defines the target the camera should look at.
   * This will automatically adapt alpha beta and radius to fit within the new target.
   * Please note that setting a target as a mesh will disable panning.
   * @param target Defines the new target as a Vector or a mesh
   * @param toBoundingCenter In case of a mesh target, defines whether to target the mesh position or its bounding information center
   * @param allowSamePosition If false, prevents reapplying the new computed position if it is identical to the current one (optim)
   * @param cloneAlphaBetaRadius If true, replicate the current setup (alpha, beta, radius) on the new target
   */
  setTarget(e, t = !1, i = !1, s = !1) {
    var r;
    if (s = (r = this.overrideCloneAlphaBetaRadius) !== null && r !== void 0 ? r : s, e.getBoundingInfo)
      t ? this._targetBoundingCenter = e.getBoundingInfo().boundingBox.centerWorld.clone() : this._targetBoundingCenter = null, e.computeWorldMatrix(), this._targetHost = e, this._target = this._getTargetPosition(), this.onMeshTargetChangedObservable.notifyObservers(this._targetHost);
    else {
      const n = e, a = this._getTargetPosition();
      if (a && !i && a.equals(n))
        return;
      this._targetHost = null, this._target = n, this._targetBoundingCenter = null, this.onMeshTargetChangedObservable.notifyObservers(null);
    }
    s || this.rebuildAnglesAndRadius();
  }
  /** @internal */
  _getViewMatrix() {
    const e = Math.cos(this.alpha), t = Math.sin(this.alpha), i = Math.cos(this.beta);
    let s = Math.sin(this.beta);
    s === 0 && (s = 1e-4), this.radius === 0 && (this.radius = 1e-4);
    const r = this._getTargetPosition();
    if (this._computationVector.copyFromFloats(this.radius * e * s, this.radius * i, this.radius * t * s), (this._upVector.x !== 0 || this._upVector.y !== 1 || this._upVector.z !== 0) && p.TransformCoordinatesToRef(this._computationVector, this._yToUpMatrix, this._computationVector), r.addToRef(this._computationVector, this._newPosition), this.getScene().collisionsEnabled && this.checkCollisions) {
      const n = this.getScene().collisionCoordinator;
      this._collider || (this._collider = n.createCollider()), this._collider._radius = this.collisionRadius, this._newPosition.subtractToRef(this._position, this._collisionVelocity), this._collisionTriggered = !0, n.getNewPosition(this._position, this._collisionVelocity, this._collider, 3, null, this._onCollisionPositionChange, this.uniqueId);
    } else {
      this._position.copyFrom(this._newPosition);
      let n = this.upVector;
      this.allowUpsideDown && s < 0 && (n = n.negate()), this._computeViewMatrix(this._position, r, n), this._viewMatrix.addAtIndex(12, this.targetScreenOffset.x), this._viewMatrix.addAtIndex(13, this.targetScreenOffset.y);
    }
    return this._currentTarget = r, this._viewMatrix;
  }
  /**
   * Zooms on a mesh to be at the min distance where we could see it fully in the current viewport.
   * @param meshes Defines the mesh to zoom on
   * @param doNotUpdateMaxZ Defines whether or not maxZ should be updated whilst zooming on the mesh (this can happen if the mesh is big and the maxradius pretty small for instance)
   */
  zoomOn(e, t = !1) {
    e = e || this.getScene().meshes;
    const i = K.MinMax(e), s = p.Distance(i.min, i.max);
    this.radius = s * this.zoomOnFactor, this.focusOn({ min: i.min, max: i.max, distance: s }, t);
  }
  /**
   * Focus on a mesh or a bounding box. This adapts the target and maxRadius if necessary but does not update the current radius.
   * The target will be changed but the radius
   * @param meshesOrMinMaxVectorAndDistance Defines the mesh or bounding info to focus on
   * @param doNotUpdateMaxZ Defines whether or not maxZ should be updated whilst zooming on the mesh (this can happen if the mesh is big and the maxradius pretty small for instance)
   */
  focusOn(e, t = !1) {
    let i, s;
    if (e.min === void 0) {
      const r = e || this.getScene().meshes;
      i = K.MinMax(r), s = p.Distance(i.min, i.max);
    } else {
      const r = e;
      i = r, s = r.distance;
    }
    this._target = K.Center(i), t || (this.maxZ = s * 2);
  }
  /**
   * @override
   * Override Camera.createRigCamera
   */
  createRigCamera(e, t) {
    let i = 0;
    switch (this.cameraRigMode) {
      case Q.RIG_MODE_STEREOSCOPIC_ANAGLYPH:
      case Q.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_PARALLEL:
      case Q.RIG_MODE_STEREOSCOPIC_OVERUNDER:
      case Q.RIG_MODE_STEREOSCOPIC_INTERLACED:
      case Q.RIG_MODE_VR:
        i = this._cameraRigParams.stereoHalfAngle * (t === 0 ? 1 : -1);
        break;
      case Q.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED:
        i = this._cameraRigParams.stereoHalfAngle * (t === 0 ? -1 : 1);
        break;
    }
    const s = new Ke(e, this.alpha + i, this.beta, this.radius, this._target, this.getScene());
    return s._cameraRigParams = {}, s.isRigCamera = !0, s.rigParent = this, s.upVector = this.upVector, s.mode = this.mode, s.orthoLeft = this.orthoLeft, s.orthoRight = this.orthoRight, s.orthoBottom = this.orthoBottom, s.orthoTop = this.orthoTop, s;
  }
  /**
   * @internal
   * @override
   * Override Camera._updateRigCameras
   */
  _updateRigCameras() {
    const e = this._rigCameras[0], t = this._rigCameras[1];
    switch (e.beta = t.beta = this.beta, this.cameraRigMode) {
      case Q.RIG_MODE_STEREOSCOPIC_ANAGLYPH:
      case Q.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_PARALLEL:
      case Q.RIG_MODE_STEREOSCOPIC_OVERUNDER:
      case Q.RIG_MODE_STEREOSCOPIC_INTERLACED:
      case Q.RIG_MODE_VR:
        e.alpha = this.alpha - this._cameraRigParams.stereoHalfAngle, t.alpha = this.alpha + this._cameraRigParams.stereoHalfAngle;
        break;
      case Q.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED:
        e.alpha = this.alpha + this._cameraRigParams.stereoHalfAngle, t.alpha = this.alpha - this._cameraRigParams.stereoHalfAngle;
        break;
    }
    super._updateRigCameras();
  }
  /**
   * Destroy the camera and release the current resources hold by it.
   */
  dispose() {
    this.inputs.clear(), super.dispose();
  }
  /**
   * Gets the current object class name.
   * @returns the class name
   */
  getClassName() {
    return "ArcRotateCamera";
  }
}
E([
  R()
], Ke.prototype, "alpha", void 0);
E([
  R()
], Ke.prototype, "beta", void 0);
E([
  R()
], Ke.prototype, "radius", void 0);
E([
  R()
], Ke.prototype, "overrideCloneAlphaBetaRadius", void 0);
E([
  wt("target")
], Ke.prototype, "_target", void 0);
E([
  Sn("targetHost")
], Ke.prototype, "_targetHost", void 0);
E([
  R()
], Ke.prototype, "inertialAlphaOffset", void 0);
E([
  R()
], Ke.prototype, "inertialBetaOffset", void 0);
E([
  R()
], Ke.prototype, "inertialRadiusOffset", void 0);
E([
  R()
], Ke.prototype, "lowerAlphaLimit", void 0);
E([
  R()
], Ke.prototype, "upperAlphaLimit", void 0);
E([
  R()
], Ke.prototype, "lowerBetaLimit", void 0);
E([
  R()
], Ke.prototype, "upperBetaLimit", void 0);
E([
  R()
], Ke.prototype, "lowerRadiusLimit", void 0);
E([
  R()
], Ke.prototype, "upperRadiusLimit", void 0);
E([
  R()
], Ke.prototype, "inertialPanningX", void 0);
E([
  R()
], Ke.prototype, "inertialPanningY", void 0);
E([
  R()
], Ke.prototype, "pinchToPanMaxDistance", void 0);
E([
  R()
], Ke.prototype, "panningDistanceLimit", void 0);
E([
  wt()
], Ke.prototype, "panningOriginTarget", void 0);
E([
  R()
], Ke.prototype, "panningInertia", void 0);
E([
  R()
], Ke.prototype, "zoomToMouseLocation", null);
E([
  R()
], Ke.prototype, "zoomOnFactor", void 0);
E([
  Ho()
], Ke.prototype, "targetScreenOffset", void 0);
E([
  R()
], Ke.prototype, "allowUpsideDown", void 0);
E([
  R()
], Ke.prototype, "useInputToRestoreState", void 0);
class Yt {
  constructor() {
    this.keysUp = [38], this.keysUpward = [33], this.keysDown = [40], this.keysDownward = [34], this.keysLeft = [37], this.keysRight = [39], this.rotationSpeed = 0.5, this.keysRotateLeft = [], this.keysRotateRight = [], this.keysRotateUp = [], this.keysRotateDown = [], this._keys = new Array();
  }
  /**
   * Attach the input controls to a specific dom element to get the input from.
   * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
   */
  attachControl(e) {
    e = z.BackCompatCameraNoPreventDefault(arguments), !this._onCanvasBlurObserver && (this._scene = this.camera.getScene(), this._engine = this._scene.getEngine(), this._onCanvasBlurObserver = this._engine.onCanvasBlurObservable.add(() => {
      this._keys.length = 0;
    }), this._onKeyboardObserver = this._scene.onKeyboardObservable.add((t) => {
      const i = t.event;
      if (!i.metaKey) {
        if (t.type === ms.KEYDOWN)
          (this.keysUp.indexOf(i.keyCode) !== -1 || this.keysDown.indexOf(i.keyCode) !== -1 || this.keysLeft.indexOf(i.keyCode) !== -1 || this.keysRight.indexOf(i.keyCode) !== -1 || this.keysUpward.indexOf(i.keyCode) !== -1 || this.keysDownward.indexOf(i.keyCode) !== -1 || this.keysRotateLeft.indexOf(i.keyCode) !== -1 || this.keysRotateRight.indexOf(i.keyCode) !== -1 || this.keysRotateUp.indexOf(i.keyCode) !== -1 || this.keysRotateDown.indexOf(i.keyCode) !== -1) && (this._keys.indexOf(i.keyCode) === -1 && this._keys.push(i.keyCode), e || i.preventDefault());
        else if (this.keysUp.indexOf(i.keyCode) !== -1 || this.keysDown.indexOf(i.keyCode) !== -1 || this.keysLeft.indexOf(i.keyCode) !== -1 || this.keysRight.indexOf(i.keyCode) !== -1 || this.keysUpward.indexOf(i.keyCode) !== -1 || this.keysDownward.indexOf(i.keyCode) !== -1 || this.keysRotateLeft.indexOf(i.keyCode) !== -1 || this.keysRotateRight.indexOf(i.keyCode) !== -1 || this.keysRotateUp.indexOf(i.keyCode) !== -1 || this.keysRotateDown.indexOf(i.keyCode) !== -1) {
          const s = this._keys.indexOf(i.keyCode);
          s >= 0 && this._keys.splice(s, 1), e || i.preventDefault();
        }
      }
    }));
  }
  /**
   * Detach the current controls from the specified dom element.
   */
  detachControl() {
    this._scene && (this._onKeyboardObserver && this._scene.onKeyboardObservable.remove(this._onKeyboardObserver), this._onCanvasBlurObserver && this._engine.onCanvasBlurObservable.remove(this._onCanvasBlurObserver), this._onKeyboardObserver = null, this._onCanvasBlurObserver = null), this._keys.length = 0;
  }
  /**
   * Update the current camera state depending on the inputs that have been used this frame.
   * This is a dynamically created lambda to avoid the performance penalty of looping for inputs in the render loop.
   */
  checkInputs() {
    if (this._onKeyboardObserver) {
      const e = this.camera;
      for (let t = 0; t < this._keys.length; t++) {
        const i = this._keys[t], s = e._computeLocalCameraSpeed();
        this.keysLeft.indexOf(i) !== -1 ? e._localDirection.copyFromFloats(-s, 0, 0) : this.keysUp.indexOf(i) !== -1 ? e._localDirection.copyFromFloats(0, 0, s) : this.keysRight.indexOf(i) !== -1 ? e._localDirection.copyFromFloats(s, 0, 0) : this.keysDown.indexOf(i) !== -1 ? e._localDirection.copyFromFloats(0, 0, -s) : this.keysUpward.indexOf(i) !== -1 ? e._localDirection.copyFromFloats(0, s, 0) : this.keysDownward.indexOf(i) !== -1 ? e._localDirection.copyFromFloats(0, -s, 0) : this.keysRotateLeft.indexOf(i) !== -1 ? (e._localDirection.copyFromFloats(0, 0, 0), e.cameraRotation.y -= this._getLocalRotation()) : this.keysRotateRight.indexOf(i) !== -1 ? (e._localDirection.copyFromFloats(0, 0, 0), e.cameraRotation.y += this._getLocalRotation()) : this.keysRotateUp.indexOf(i) !== -1 ? (e._localDirection.copyFromFloats(0, 0, 0), e.cameraRotation.x -= this._getLocalRotation()) : this.keysRotateDown.indexOf(i) !== -1 && (e._localDirection.copyFromFloats(0, 0, 0), e.cameraRotation.x += this._getLocalRotation()), e.getScene().useRightHandedSystem && (e._localDirection.z *= -1), e.getViewMatrix().invertToRef(e._cameraTransformMatrix), p.TransformNormalToRef(e._localDirection, e._cameraTransformMatrix, e._transformedDirection), e.cameraDirection.addInPlace(e._transformedDirection);
      }
    }
  }
  /**
   * Gets the class name of the current input.
   * @returns the class name
   */
  getClassName() {
    return "FreeCameraKeyboardMoveInput";
  }
  /** @internal */
  _onLostFocus() {
    this._keys.length = 0;
  }
  /**
   * Get the friendly name associated with the input class.
   * @returns the input friendly name
   */
  getSimpleName() {
    return "keyboard";
  }
  _getLocalRotation() {
    let e = this.rotationSpeed * this._engine.getDeltaTime() / 1e3;
    return this.camera.getScene().useRightHandedSystem && (e *= -1), this.camera.parent && this.camera.parent._getWorldMatrixDeterminant() < 0 && (e *= -1), e;
  }
}
E([
  R()
], Yt.prototype, "keysUp", void 0);
E([
  R()
], Yt.prototype, "keysUpward", void 0);
E([
  R()
], Yt.prototype, "keysDown", void 0);
E([
  R()
], Yt.prototype, "keysDownward", void 0);
E([
  R()
], Yt.prototype, "keysLeft", void 0);
E([
  R()
], Yt.prototype, "keysRight", void 0);
E([
  R()
], Yt.prototype, "rotationSpeed", void 0);
E([
  R()
], Yt.prototype, "keysRotateLeft", void 0);
E([
  R()
], Yt.prototype, "keysRotateRight", void 0);
E([
  R()
], Yt.prototype, "keysRotateUp", void 0);
E([
  R()
], Yt.prototype, "keysRotateDown", void 0);
Ii.FreeCameraKeyboardMoveInput = Yt;
class Or {
  /**
   * Manage the mouse inputs to control the movement of a free camera.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/customizingCameraInputs
   * @param touchEnabled Defines if touch is enabled or not
   */
  constructor(e = !0) {
    this.touchEnabled = e, this.buttons = [0, 1, 2], this.angularSensibility = 2e3, this._previousPosition = null, this.onPointerMovedObservable = new N(), this._allowCameraRotation = !0, this._currentActiveButton = -1, this._activePointerId = -1;
  }
  /**
   * Attach the input controls to a specific dom element to get the input from.
   * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
   */
  attachControl(e) {
    e = z.BackCompatCameraNoPreventDefault(arguments);
    const t = this.camera.getEngine(), i = t.getInputElement();
    this._pointerInput || (this._pointerInput = (s) => {
      const r = s.event, n = r.pointerType === "touch";
      if (t.isInVRExclusivePointerMode || !this.touchEnabled && n || s.type !== $.POINTERMOVE && this.buttons.indexOf(r.button) === -1)
        return;
      const a = r.target;
      if (s.type === $.POINTERDOWN) {
        if (n && this._activePointerId !== -1 || !n && this._currentActiveButton !== -1)
          return;
        this._activePointerId = r.pointerId;
        try {
          a == null || a.setPointerCapture(r.pointerId);
        } catch {
        }
        this._currentActiveButton === -1 && (this._currentActiveButton = r.button), this._previousPosition = {
          x: r.clientX,
          y: r.clientY
        }, e || (r.preventDefault(), i && i.focus()), t.isPointerLock && this._onMouseMove && this._onMouseMove(s.event);
      } else if (s.type === $.POINTERUP) {
        if (n && this._activePointerId !== r.pointerId || !n && this._currentActiveButton !== r.button)
          return;
        try {
          a == null || a.releasePointerCapture(r.pointerId);
        } catch {
        }
        this._currentActiveButton = -1, this._previousPosition = null, e || r.preventDefault(), this._activePointerId = -1;
      } else if (s.type === $.POINTERMOVE && (this._activePointerId === r.pointerId || !n)) {
        if (t.isPointerLock && this._onMouseMove)
          this._onMouseMove(s.event);
        else if (this._previousPosition) {
          let o = r.clientX - this._previousPosition.x;
          const l = r.clientY - this._previousPosition.y;
          this.camera.getScene().useRightHandedSystem && (o *= -1), this.camera.parent && this.camera.parent._getWorldMatrixDeterminant() < 0 && (o *= -1), this._allowCameraRotation && (this.camera.cameraRotation.y += o / this.angularSensibility, this.camera.cameraRotation.x += l / this.angularSensibility), this.onPointerMovedObservable.notifyObservers({ offsetX: o, offsetY: l }), this._previousPosition = {
            x: r.clientX,
            y: r.clientY
          }, e || r.preventDefault();
        }
      }
    }), this._onMouseMove = (s) => {
      if (!t.isPointerLock || t.isInVRExclusivePointerMode)
        return;
      let r = s.movementX;
      this.camera.getScene().useRightHandedSystem && (r *= -1), this.camera.parent && this.camera.parent._getWorldMatrixDeterminant() < 0 && (r *= -1), this.camera.cameraRotation.y += r / this.angularSensibility;
      const n = s.movementY;
      this.camera.cameraRotation.x += n / this.angularSensibility, this._previousPosition = null, e || s.preventDefault();
    }, this._observer = this.camera.getScene()._inputManager._addCameraPointerObserver(this._pointerInput, $.POINTERDOWN | $.POINTERUP | $.POINTERMOVE), i && (this._contextMenuBind = this.onContextMenu.bind(this), i.addEventListener("contextmenu", this._contextMenuBind, !1));
  }
  /**
   * Called on JS contextmenu event.
   * Override this method to provide functionality.
   * @param evt
   */
  onContextMenu(e) {
    e.preventDefault();
  }
  /**
   * Detach the current controls from the specified dom element.
   */
  detachControl() {
    if (this._observer) {
      if (this.camera.getScene()._inputManager._removeCameraPointerObserver(this._observer), this._contextMenuBind) {
        const t = this.camera.getEngine().getInputElement();
        t && t.removeEventListener("contextmenu", this._contextMenuBind);
      }
      this.onPointerMovedObservable && this.onPointerMovedObservable.clear(), this._observer = null, this._onMouseMove = null, this._previousPosition = null;
    }
    this._activePointerId = -1, this._currentActiveButton = -1;
  }
  /**
   * Gets the class name of the current input.
   * @returns the class name
   */
  getClassName() {
    return "FreeCameraMouseInput";
  }
  /**
   * Get the friendly name associated with the input class.
   * @returns the input friendly name
   */
  getSimpleName() {
    return "mouse";
  }
}
E([
  R()
], Or.prototype, "buttons", void 0);
E([
  R()
], Or.prototype, "angularSensibility", void 0);
Ii.FreeCameraMouseInput = Or;
class Fr {
  constructor() {
    this.wheelPrecisionX = 3, this.wheelPrecisionY = 3, this.wheelPrecisionZ = 3, this.onChangedObservable = new N(), this._wheelDeltaX = 0, this._wheelDeltaY = 0, this._wheelDeltaZ = 0, this._ffMultiplier = 12, this._normalize = 120;
  }
  /**
   * Attach the input controls to a specific dom element to get the input from.
   * @param noPreventDefault Defines whether event caught by the controls
   *   should call preventdefault().
   *   (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
   */
  attachControl(e) {
    e = z.BackCompatCameraNoPreventDefault(arguments), this._wheel = (t) => {
      if (t.type !== $.POINTERWHEEL)
        return;
      const i = t.event, s = i.deltaMode === xs.DOM_DELTA_LINE ? this._ffMultiplier : 1;
      this._wheelDeltaX += this.wheelPrecisionX * s * i.deltaX / this._normalize, this._wheelDeltaY -= this.wheelPrecisionY * s * i.deltaY / this._normalize, this._wheelDeltaZ += this.wheelPrecisionZ * s * i.deltaZ / this._normalize, i.preventDefault && (e || i.preventDefault());
    }, this._observer = this.camera.getScene()._inputManager._addCameraPointerObserver(this._wheel, $.POINTERWHEEL);
  }
  /**
   * Detach the current controls from the specified dom element.
   */
  detachControl() {
    this._observer && (this.camera.getScene()._inputManager._removeCameraPointerObserver(this._observer), this._observer = null, this._wheel = null), this.onChangedObservable && this.onChangedObservable.clear();
  }
  /**
   * Called for each rendered frame.
   */
  checkInputs() {
    this.onChangedObservable.notifyObservers({
      wheelDeltaX: this._wheelDeltaX,
      wheelDeltaY: this._wheelDeltaY,
      wheelDeltaZ: this._wheelDeltaZ
    }), this._wheelDeltaX = 0, this._wheelDeltaY = 0, this._wheelDeltaZ = 0;
  }
  /**
   * Gets the class name of the current input.
   * @returns the class name
   */
  getClassName() {
    return "BaseCameraMouseWheelInput";
  }
  /**
   * Get the friendly name associated with the input class.
   * @returns the input friendly name
   */
  getSimpleName() {
    return "mousewheel";
  }
}
E([
  R()
], Fr.prototype, "wheelPrecisionX", void 0);
E([
  R()
], Fr.prototype, "wheelPrecisionY", void 0);
E([
  R()
], Fr.prototype, "wheelPrecisionZ", void 0);
var Ue;
(function(h) {
  h[h.MoveRelative = 0] = "MoveRelative", h[h.RotateRelative = 1] = "RotateRelative", h[h.MoveScene = 2] = "MoveScene";
})(Ue || (Ue = {}));
class ai extends Fr {
  constructor() {
    super(...arguments), this._moveRelative = p.Zero(), this._rotateRelative = p.Zero(), this._moveScene = p.Zero(), this._wheelXAction = Ue.MoveRelative, this._wheelXActionCoordinate = Xi.X, this._wheelYAction = Ue.MoveRelative, this._wheelYActionCoordinate = Xi.Z, this._wheelZAction = null, this._wheelZActionCoordinate = null;
  }
  /**
   * Gets the class name of the current input.
   * @returns the class name
   */
  getClassName() {
    return "FreeCameraMouseWheelInput";
  }
  /**
   * Set which movement axis (relative to camera's orientation) the mouse
   * wheel's X axis controls.
   * @param axis The axis to be moved. Set null to clear.
   */
  set wheelXMoveRelative(e) {
    e === null && this._wheelXAction !== Ue.MoveRelative || (this._wheelXAction = Ue.MoveRelative, this._wheelXActionCoordinate = e);
  }
  /**
   * Get the configured movement axis (relative to camera's orientation) the
   * mouse wheel's X axis controls.
   * @returns The configured axis or null if none.
   */
  get wheelXMoveRelative() {
    return this._wheelXAction !== Ue.MoveRelative ? null : this._wheelXActionCoordinate;
  }
  /**
   * Set which movement axis (relative to camera's orientation) the mouse
   * wheel's Y axis controls.
   * @param axis The axis to be moved. Set null to clear.
   */
  set wheelYMoveRelative(e) {
    e === null && this._wheelYAction !== Ue.MoveRelative || (this._wheelYAction = Ue.MoveRelative, this._wheelYActionCoordinate = e);
  }
  /**
   * Get the configured movement axis (relative to camera's orientation) the
   * mouse wheel's Y axis controls.
   * @returns The configured axis or null if none.
   */
  get wheelYMoveRelative() {
    return this._wheelYAction !== Ue.MoveRelative ? null : this._wheelYActionCoordinate;
  }
  /**
   * Set which movement axis (relative to camera's orientation) the mouse
   * wheel's Z axis controls.
   * @param axis The axis to be moved. Set null to clear.
   */
  set wheelZMoveRelative(e) {
    e === null && this._wheelZAction !== Ue.MoveRelative || (this._wheelZAction = Ue.MoveRelative, this._wheelZActionCoordinate = e);
  }
  /**
   * Get the configured movement axis (relative to camera's orientation) the
   * mouse wheel's Z axis controls.
   * @returns The configured axis or null if none.
   */
  get wheelZMoveRelative() {
    return this._wheelZAction !== Ue.MoveRelative ? null : this._wheelZActionCoordinate;
  }
  /**
   * Set which rotation axis (relative to camera's orientation) the mouse
   * wheel's X axis controls.
   * @param axis The axis to be moved. Set null to clear.
   */
  set wheelXRotateRelative(e) {
    e === null && this._wheelXAction !== Ue.RotateRelative || (this._wheelXAction = Ue.RotateRelative, this._wheelXActionCoordinate = e);
  }
  /**
   * Get the configured rotation axis (relative to camera's orientation) the
   * mouse wheel's X axis controls.
   * @returns The configured axis or null if none.
   */
  get wheelXRotateRelative() {
    return this._wheelXAction !== Ue.RotateRelative ? null : this._wheelXActionCoordinate;
  }
  /**
   * Set which rotation axis (relative to camera's orientation) the mouse
   * wheel's Y axis controls.
   * @param axis The axis to be moved. Set null to clear.
   */
  set wheelYRotateRelative(e) {
    e === null && this._wheelYAction !== Ue.RotateRelative || (this._wheelYAction = Ue.RotateRelative, this._wheelYActionCoordinate = e);
  }
  /**
   * Get the configured rotation axis (relative to camera's orientation) the
   * mouse wheel's Y axis controls.
   * @returns The configured axis or null if none.
   */
  get wheelYRotateRelative() {
    return this._wheelYAction !== Ue.RotateRelative ? null : this._wheelYActionCoordinate;
  }
  /**
   * Set which rotation axis (relative to camera's orientation) the mouse
   * wheel's Z axis controls.
   * @param axis The axis to be moved. Set null to clear.
   */
  set wheelZRotateRelative(e) {
    e === null && this._wheelZAction !== Ue.RotateRelative || (this._wheelZAction = Ue.RotateRelative, this._wheelZActionCoordinate = e);
  }
  /**
   * Get the configured rotation axis (relative to camera's orientation) the
   * mouse wheel's Z axis controls.
   * @returns The configured axis or null if none.
   */
  get wheelZRotateRelative() {
    return this._wheelZAction !== Ue.RotateRelative ? null : this._wheelZActionCoordinate;
  }
  /**
   * Set which movement axis (relative to the scene) the mouse wheel's X axis
   * controls.
   * @param axis The axis to be moved. Set null to clear.
   */
  set wheelXMoveScene(e) {
    e === null && this._wheelXAction !== Ue.MoveScene || (this._wheelXAction = Ue.MoveScene, this._wheelXActionCoordinate = e);
  }
  /**
   * Get the configured movement axis (relative to the scene) the mouse wheel's
   * X axis controls.
   * @returns The configured axis or null if none.
   */
  get wheelXMoveScene() {
    return this._wheelXAction !== Ue.MoveScene ? null : this._wheelXActionCoordinate;
  }
  /**
   * Set which movement axis (relative to the scene) the mouse wheel's Y axis
   * controls.
   * @param axis The axis to be moved. Set null to clear.
   */
  set wheelYMoveScene(e) {
    e === null && this._wheelYAction !== Ue.MoveScene || (this._wheelYAction = Ue.MoveScene, this._wheelYActionCoordinate = e);
  }
  /**
   * Get the configured movement axis (relative to the scene) the mouse wheel's
   * Y axis controls.
   * @returns The configured axis or null if none.
   */
  get wheelYMoveScene() {
    return this._wheelYAction !== Ue.MoveScene ? null : this._wheelYActionCoordinate;
  }
  /**
   * Set which movement axis (relative to the scene) the mouse wheel's Z axis
   * controls.
   * @param axis The axis to be moved. Set null to clear.
   */
  set wheelZMoveScene(e) {
    e === null && this._wheelZAction !== Ue.MoveScene || (this._wheelZAction = Ue.MoveScene, this._wheelZActionCoordinate = e);
  }
  /**
   * Get the configured movement axis (relative to the scene) the mouse wheel's
   * Z axis controls.
   * @returns The configured axis or null if none.
   */
  get wheelZMoveScene() {
    return this._wheelZAction !== Ue.MoveScene ? null : this._wheelZActionCoordinate;
  }
  /**
   * Called for each rendered frame.
   */
  checkInputs() {
    if (this._wheelDeltaX === 0 && this._wheelDeltaY === 0 && this._wheelDeltaZ == 0)
      return;
    this._moveRelative.setAll(0), this._rotateRelative.setAll(0), this._moveScene.setAll(0), this._updateCamera(), this.camera.getScene().useRightHandedSystem && (this._moveRelative.z *= -1);
    const e = I.Zero();
    this.camera.getViewMatrix().invertToRef(e);
    const t = p.Zero();
    p.TransformNormalToRef(this._moveRelative, e, t), this.camera.cameraRotation.x += this._rotateRelative.x / 200, this.camera.cameraRotation.y += this._rotateRelative.y / 200, this.camera.cameraDirection.addInPlace(t), this.camera.cameraDirection.addInPlace(this._moveScene), super.checkInputs();
  }
  /**
   * Update the camera according to any configured properties for the 3
   * mouse-wheel axis.
   */
  _updateCamera() {
    this._updateCameraProperty(this._wheelDeltaX, this._wheelXAction, this._wheelXActionCoordinate), this._updateCameraProperty(this._wheelDeltaY, this._wheelYAction, this._wheelYActionCoordinate), this._updateCameraProperty(this._wheelDeltaZ, this._wheelZAction, this._wheelZActionCoordinate);
  }
  /**
   * Update one property of the camera.
   * @param value
   * @param cameraProperty
   * @param coordinate
   */
  _updateCameraProperty(e, t, i) {
    if (e === 0 || t === null || i === null)
      return;
    let s = null;
    switch (t) {
      case Ue.MoveRelative:
        s = this._moveRelative;
        break;
      case Ue.RotateRelative:
        s = this._rotateRelative;
        break;
      case Ue.MoveScene:
        s = this._moveScene;
        break;
    }
    switch (i) {
      case Xi.X:
        s.set(e, 0, 0);
        break;
      case Xi.Y:
        s.set(0, e, 0);
        break;
      case Xi.Z:
        s.set(0, 0, e);
        break;
    }
  }
}
E([
  R()
], ai.prototype, "wheelXMoveRelative", null);
E([
  R()
], ai.prototype, "wheelYMoveRelative", null);
E([
  R()
], ai.prototype, "wheelZMoveRelative", null);
E([
  R()
], ai.prototype, "wheelXRotateRelative", null);
E([
  R()
], ai.prototype, "wheelYRotateRelative", null);
E([
  R()
], ai.prototype, "wheelZRotateRelative", null);
E([
  R()
], ai.prototype, "wheelXMoveScene", null);
E([
  R()
], ai.prototype, "wheelYMoveScene", null);
E([
  R()
], ai.prototype, "wheelZMoveScene", null);
Ii.FreeCameraMouseWheelInput = ai;
class Lr {
  /**
   * Manage the touch inputs to control the movement of a free camera.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/customizingCameraInputs
   * @param allowMouse Defines if mouse events can be treated as touch events
   */
  constructor(e = !1) {
    this.allowMouse = e, this.touchAngularSensibility = 2e5, this.touchMoveSensibility = 250, this.singleFingerRotate = !1, this._offsetX = null, this._offsetY = null, this._pointerPressed = new Array(), this._isSafari = z.IsSafari();
  }
  /**
   * Attach the input controls to a specific dom element to get the input from.
   * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
   */
  attachControl(e) {
    e = z.BackCompatCameraNoPreventDefault(arguments);
    let t = null;
    if (this._pointerInput === void 0 && (this._onLostFocus = () => {
      this._offsetX = null, this._offsetY = null;
    }, this._pointerInput = (i) => {
      const s = i.event, r = s.pointerType === "mouse" || this._isSafari && typeof s.pointerType > "u";
      if (!(!this.allowMouse && r)) {
        if (i.type === $.POINTERDOWN) {
          if (e || s.preventDefault(), this._pointerPressed.push(s.pointerId), this._pointerPressed.length !== 1)
            return;
          t = {
            x: s.clientX,
            y: s.clientY
          };
        } else if (i.type === $.POINTERUP) {
          e || s.preventDefault();
          const n = this._pointerPressed.indexOf(s.pointerId);
          if (n === -1 || (this._pointerPressed.splice(n, 1), n != 0))
            return;
          t = null, this._offsetX = null, this._offsetY = null;
        } else if (i.type === $.POINTERMOVE) {
          if (e || s.preventDefault(), !t || this._pointerPressed.indexOf(s.pointerId) != 0)
            return;
          this._offsetX = s.clientX - t.x, this._offsetY = -(s.clientY - t.y);
        }
      }
    }), this._observer = this.camera.getScene()._inputManager._addCameraPointerObserver(this._pointerInput, $.POINTERDOWN | $.POINTERUP | $.POINTERMOVE), this._onLostFocus) {
      const s = this.camera.getEngine().getInputElement();
      s && s.addEventListener("blur", this._onLostFocus);
    }
  }
  /**
   * Detach the current controls from the specified dom element.
   */
  detachControl() {
    if (this._pointerInput) {
      if (this._observer && (this.camera.getScene()._inputManager._removeCameraPointerObserver(this._observer), this._observer = null), this._onLostFocus) {
        const t = this.camera.getEngine().getInputElement();
        t && t.removeEventListener("blur", this._onLostFocus), this._onLostFocus = null;
      }
      this._pointerPressed.length = 0, this._offsetX = null, this._offsetY = null;
    }
  }
  /**
   * Update the current camera state depending on the inputs that have been used this frame.
   * This is a dynamically created lambda to avoid the performance penalty of looping for inputs in the render loop.
   */
  checkInputs() {
    if (this._offsetX === null || this._offsetY === null || this._offsetX === 0 && this._offsetY === 0)
      return;
    const e = this.camera;
    if (e.cameraRotation.y = this._offsetX / this.touchAngularSensibility, this.singleFingerRotate && this._pointerPressed.length === 1 || !this.singleFingerRotate && this._pointerPressed.length > 1)
      e.cameraRotation.x = -this._offsetY / this.touchAngularSensibility;
    else {
      const i = e._computeLocalCameraSpeed(), s = new p(0, 0, this.touchMoveSensibility !== 0 ? i * this._offsetY / this.touchMoveSensibility : 0);
      I.RotationYawPitchRollToRef(e.rotation.y, e.rotation.x, 0, e._cameraRotationMatrix), e.cameraDirection.addInPlace(p.TransformCoordinates(s, e._cameraRotationMatrix));
    }
  }
  /**
   * Gets the class name of the current input.
   * @returns the class name
   */
  getClassName() {
    return "FreeCameraTouchInput";
  }
  /**
   * Get the friendly name associated with the input class.
   * @returns the input friendly name
   */
  getSimpleName() {
    return "touch";
  }
}
E([
  R()
], Lr.prototype, "touchAngularSensibility", void 0);
E([
  R()
], Lr.prototype, "touchMoveSensibility", void 0);
Ii.FreeCameraTouchInput = Lr;
class Nc extends yo {
  /**
   * Instantiates a new FreeCameraInputsManager.
   * @param camera Defines the camera the inputs belong to
   */
  constructor(e) {
    super(e), this._mouseInput = null, this._mouseWheelInput = null;
  }
  /**
   * Add keyboard input support to the input manager.
   * @returns the current input manager
   */
  addKeyboard() {
    return this.add(new Yt()), this;
  }
  /**
   * Add mouse input support to the input manager.
   * @param touchEnabled if the FreeCameraMouseInput should support touch (default: true)
   * @returns the current input manager
   */
  addMouse(e = !0) {
    return this._mouseInput || (this._mouseInput = new Or(e), this.add(this._mouseInput)), this;
  }
  /**
   * Removes the mouse input support from the manager
   * @returns the current input manager
   */
  removeMouse() {
    return this._mouseInput && this.remove(this._mouseInput), this;
  }
  /**
   * Add mouse wheel input support to the input manager.
   * @returns the current input manager
   */
  addMouseWheel() {
    return this._mouseWheelInput || (this._mouseWheelInput = new ai(), this.add(this._mouseWheelInput)), this;
  }
  /**
   * Removes the mouse wheel input support from the manager
   * @returns the current input manager
   */
  removeMouseWheel() {
    return this._mouseWheelInput && this.remove(this._mouseWheelInput), this;
  }
  /**
   * Add touch input support to the input manager.
   * @returns the current input manager
   */
  addTouch() {
    return this.add(new Lr()), this;
  }
  /**
   * Remove all attached input methods from a camera
   */
  clear() {
    super.clear(), this._mouseInput = null;
  }
}
class Nr extends lt {
  /**
   * Gets the input sensibility for a mouse input. (default is 2000.0)
   * Higher values reduce sensitivity.
   */
  get angularSensibility() {
    const e = this.inputs.attached.mouse;
    return e ? e.angularSensibility : 0;
  }
  /**
   * Sets the input sensibility for a mouse input. (default is 2000.0)
   * Higher values reduce sensitivity.
   */
  set angularSensibility(e) {
    const t = this.inputs.attached.mouse;
    t && (t.angularSensibility = e);
  }
  /**
   * Gets or Set the list of keyboard keys used to control the forward move of the camera.
   */
  get keysUp() {
    const e = this.inputs.attached.keyboard;
    return e ? e.keysUp : [];
  }
  set keysUp(e) {
    const t = this.inputs.attached.keyboard;
    t && (t.keysUp = e);
  }
  /**
   * Gets or Set the list of keyboard keys used to control the upward move of the camera.
   */
  get keysUpward() {
    const e = this.inputs.attached.keyboard;
    return e ? e.keysUpward : [];
  }
  set keysUpward(e) {
    const t = this.inputs.attached.keyboard;
    t && (t.keysUpward = e);
  }
  /**
   * Gets or Set the list of keyboard keys used to control the backward move of the camera.
   */
  get keysDown() {
    const e = this.inputs.attached.keyboard;
    return e ? e.keysDown : [];
  }
  set keysDown(e) {
    const t = this.inputs.attached.keyboard;
    t && (t.keysDown = e);
  }
  /**
   * Gets or Set the list of keyboard keys used to control the downward move of the camera.
   */
  get keysDownward() {
    const e = this.inputs.attached.keyboard;
    return e ? e.keysDownward : [];
  }
  set keysDownward(e) {
    const t = this.inputs.attached.keyboard;
    t && (t.keysDownward = e);
  }
  /**
   * Gets or Set the list of keyboard keys used to control the left strafe move of the camera.
   */
  get keysLeft() {
    const e = this.inputs.attached.keyboard;
    return e ? e.keysLeft : [];
  }
  set keysLeft(e) {
    const t = this.inputs.attached.keyboard;
    t && (t.keysLeft = e);
  }
  /**
   * Gets or Set the list of keyboard keys used to control the right strafe move of the camera.
   */
  get keysRight() {
    const e = this.inputs.attached.keyboard;
    return e ? e.keysRight : [];
  }
  set keysRight(e) {
    const t = this.inputs.attached.keyboard;
    t && (t.keysRight = e);
  }
  /**
   * Gets or Set the list of keyboard keys used to control the left rotation move of the camera.
   */
  get keysRotateLeft() {
    const e = this.inputs.attached.keyboard;
    return e ? e.keysRotateLeft : [];
  }
  set keysRotateLeft(e) {
    const t = this.inputs.attached.keyboard;
    t && (t.keysRotateLeft = e);
  }
  /**
   * Gets or Set the list of keyboard keys used to control the right rotation move of the camera.
   */
  get keysRotateRight() {
    const e = this.inputs.attached.keyboard;
    return e ? e.keysRotateRight : [];
  }
  set keysRotateRight(e) {
    const t = this.inputs.attached.keyboard;
    t && (t.keysRotateRight = e);
  }
  /**
   * Gets or Set the list of keyboard keys used to control the up rotation move of the camera.
   */
  get keysRotateUp() {
    const e = this.inputs.attached.keyboard;
    return e ? e.keysRotateUp : [];
  }
  set keysRotateUp(e) {
    const t = this.inputs.attached.keyboard;
    t && (t.keysRotateUp = e);
  }
  /**
   * Gets or Set the list of keyboard keys used to control the down rotation move of the camera.
   */
  get keysRotateDown() {
    const e = this.inputs.attached.keyboard;
    return e ? e.keysRotateDown : [];
  }
  set keysRotateDown(e) {
    const t = this.inputs.attached.keyboard;
    t && (t.keysRotateDown = e);
  }
  /**
   * Instantiates a Free Camera.
   * This represents a free type of camera. It can be useful in First Person Shooter game for instance.
   * Please consider using the new UniversalCamera instead as it adds more functionality like touch to this camera.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_introduction#universal-camera
   * @param name Define the name of the camera in the scene
   * @param position Define the start position of the camera in the scene
   * @param scene Define the scene the camera belongs to
   * @param setActiveOnSceneIfNoneActive Defines whether the camera should be marked as active if not other active cameras have been defined
   */
  constructor(e, t, i, s = !0) {
    super(e, t, i, s), this.ellipsoid = new p(0.5, 1, 0.5), this.ellipsoidOffset = new p(0, 0, 0), this.checkCollisions = !1, this.applyGravity = !1, this._needMoveForGravity = !1, this._oldPosition = p.Zero(), this._diffPosition = p.Zero(), this._newPosition = p.Zero(), this._collisionMask = -1, this._onCollisionPositionChange = (r, n, a = null) => {
      this._newPosition.copyFrom(n), this._newPosition.subtractToRef(this._oldPosition, this._diffPosition), this._diffPosition.length() > L.CollisionsEpsilon && (this.position.addToRef(this._diffPosition, this._deferredPositionUpdate), this._deferOnly ? this._deferredUpdated = !0 : this.position.copyFrom(this._deferredPositionUpdate), this.onCollide && a && this.onCollide(a));
    }, this.inputs = new Nc(this), this.inputs.addKeyboard().addMouse();
  }
  /**
   * Attached controls to the current camera.
   * @param ignored defines an ignored parameter kept for backward compatibility.
   * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
   */
  attachControl(e, t) {
    t = z.BackCompatCameraNoPreventDefault(arguments), this.inputs.attachElement(t);
  }
  /**
   * Detach the current controls from the specified dom element.
   */
  detachControl() {
    this.inputs.detachElement(), this.cameraDirection = new p(0, 0, 0), this.cameraRotation = new ue(0, 0);
  }
  /**
   * Define a collision mask to limit the list of object the camera can collide with
   */
  get collisionMask() {
    return this._collisionMask;
  }
  set collisionMask(e) {
    this._collisionMask = isNaN(e) ? -1 : e;
  }
  /**
   * @internal
   */
  _collideWithWorld(e) {
    let t;
    this.parent ? t = p.TransformCoordinates(this.position, this.parent.getWorldMatrix()) : t = this.position, t.subtractFromFloatsToRef(0, this.ellipsoid.y, 0, this._oldPosition), this._oldPosition.addInPlace(this.ellipsoidOffset);
    const i = this.getScene().collisionCoordinator;
    this._collider || (this._collider = i.createCollider()), this._collider._radius = this.ellipsoid, this._collider.collisionMask = this._collisionMask;
    let s = e;
    this.applyGravity && (s = e.add(this.getScene().gravity)), i.getNewPosition(this._oldPosition, s, this._collider, 3, null, this._onCollisionPositionChange, this.uniqueId);
  }
  /** @internal */
  _checkInputs() {
    this._localDirection || (this._localDirection = p.Zero(), this._transformedDirection = p.Zero()), this.inputs.checkInputs(), super._checkInputs();
  }
  /**
   * Enable movement without a user input. This allows gravity to always be applied.
   */
  set needMoveForGravity(e) {
    this._needMoveForGravity = e;
  }
  /**
   * When true, gravity is applied whether there is user input or not.
   */
  get needMoveForGravity() {
    return this._needMoveForGravity;
  }
  /** @internal */
  _decideIfNeedsToMove() {
    return this._needMoveForGravity || Math.abs(this.cameraDirection.x) > 0 || Math.abs(this.cameraDirection.y) > 0 || Math.abs(this.cameraDirection.z) > 0;
  }
  /** @internal */
  _updatePosition() {
    this.checkCollisions && this.getScene().collisionsEnabled ? this._collideWithWorld(this.cameraDirection) : super._updatePosition();
  }
  /**
   * Destroy the camera and release the current resources hold by it.
   */
  dispose() {
    this.inputs.clear(), super.dispose();
  }
  /**
   * Gets the current object class name.
   * @returns the class name
   */
  getClassName() {
    return "FreeCamera";
  }
}
E([
  wt()
], Nr.prototype, "ellipsoid", void 0);
E([
  wt()
], Nr.prototype, "ellipsoidOffset", void 0);
E([
  R()
], Nr.prototype, "checkCollisions", void 0);
E([
  R()
], Nr.prototype, "applyGravity", void 0);
ut.AddNodeConstructor("Light_Type_3", (h, e) => () => new Br(h, p.Zero(), e));
class Br extends me {
  /**
   * Creates a HemisphericLight object in the scene according to the passed direction (Vector3).
   * The HemisphericLight simulates the ambient environment light, so the passed direction is the light reflection direction, not the incoming direction.
   * The HemisphericLight can't cast shadows.
   * Documentation : https://doc.babylonjs.com/features/featuresDeepDive/lights/lights_introduction
   * @param name The friendly name of the light
   * @param direction The direction of the light reflection
   * @param scene The scene the light belongs to
   */
  constructor(e, t, i) {
    super(e, i), this.groundColor = new ie(0, 0, 0), this.direction = t || p.Up();
  }
  _buildUniformLayout() {
    this._uniformBuffer.addUniform("vLightData", 4), this._uniformBuffer.addUniform("vLightDiffuse", 4), this._uniformBuffer.addUniform("vLightSpecular", 4), this._uniformBuffer.addUniform("vLightGround", 3), this._uniformBuffer.addUniform("shadowsInfo", 3), this._uniformBuffer.addUniform("depthValues", 2), this._uniformBuffer.create();
  }
  /**
   * Returns the string "HemisphericLight".
   * @returns The class name
   */
  getClassName() {
    return "HemisphericLight";
  }
  /**
   * Sets the HemisphericLight direction towards the passed target (Vector3).
   * Returns the updated direction.
   * @param target The target the direction should point to
   * @returns The computed direction
   */
  setDirectionToTarget(e) {
    return this.direction = p.Normalize(e.subtract(p.Zero())), this.direction;
  }
  /**
   * Returns the shadow generator associated to the light.
   * @returns Always null for hemispheric lights because it does not support shadows.
   */
  getShadowGenerator() {
    return null;
  }
  /**
   * Sets the passed Effect object with the HemisphericLight normalized direction and color and the passed name (string).
   * @param _effect The effect to update
   * @param lightIndex The index of the light in the effect to update
   * @returns The hemispheric light
   */
  transferToEffect(e, t) {
    const i = p.Normalize(this.direction);
    return this._uniformBuffer.updateFloat4("vLightData", i.x, i.y, i.z, 0, t), this._uniformBuffer.updateColor3("vLightGround", this.groundColor.scale(this.intensity), t), this;
  }
  transferToNodeMaterialEffect(e, t) {
    const i = p.Normalize(this.direction);
    return e.setFloat3(t, i.x, i.y, i.z), this;
  }
  /**
   * Computes the world matrix of the node
   * @returns the world matrix
   */
  computeWorldMatrix() {
    return this._worldMatrix || (this._worldMatrix = I.Identity()), this._worldMatrix;
  }
  /**
   * Returns the integer 3.
   * @returns The light Type id as a constant defines in Light.LIGHTTYPEID_x
   */
  getTypeID() {
    return me.LIGHTTYPEID_HEMISPHERICLIGHT;
  }
  /**
   * Prepares the list of defines specific to the light type.
   * @param defines the list of defines
   * @param lightIndex defines the index of the light for the effect
   */
  prepareLightSpecificDefines(e, t) {
    e["HEMILIGHT" + t] = !0;
  }
}
E([
  Ji()
], Br.prototype, "groundColor", void 0);
E([
  wt()
], Br.prototype, "direction", void 0);
class er extends me {
  constructor() {
    super(...arguments), this._needProjectionMatrixCompute = !0;
  }
  _setPosition(e) {
    this._position = e;
  }
  /**
   * Sets the position the shadow will be casted from. Also use as the light position for both
   * point and spot lights.
   */
  get position() {
    return this._position;
  }
  /**
   * Sets the position the shadow will be casted from. Also use as the light position for both
   * point and spot lights.
   */
  set position(e) {
    this._setPosition(e);
  }
  _setDirection(e) {
    this._direction = e;
  }
  /**
   * In 2d mode (needCube being false), gets the direction used to cast the shadow.
   * Also use as the light direction on spot and directional lights.
   */
  get direction() {
    return this._direction;
  }
  /**
   * In 2d mode (needCube being false), sets the direction used to cast the shadow.
   * Also use as the light direction on spot and directional lights.
   */
  set direction(e) {
    this._setDirection(e);
  }
  /**
   * Gets the shadow projection clipping minimum z value.
   */
  get shadowMinZ() {
    return this._shadowMinZ;
  }
  /**
   * Sets the shadow projection clipping minimum z value.
   */
  set shadowMinZ(e) {
    this._shadowMinZ = e, this.forceProjectionMatrixCompute();
  }
  /**
   * Sets the shadow projection clipping maximum z value.
   */
  get shadowMaxZ() {
    return this._shadowMaxZ;
  }
  /**
   * Gets the shadow projection clipping maximum z value.
   */
  set shadowMaxZ(e) {
    this._shadowMaxZ = e, this.forceProjectionMatrixCompute();
  }
  /**
   * Computes the transformed information (transformedPosition and transformedDirection in World space) of the current light
   * @returns true if the information has been computed, false if it does not need to (no parenting)
   */
  computeTransformedInformation() {
    return this.parent && this.parent.getWorldMatrix ? (this.transformedPosition || (this.transformedPosition = p.Zero()), p.TransformCoordinatesToRef(this.position, this.parent.getWorldMatrix(), this.transformedPosition), this.direction && (this.transformedDirection || (this.transformedDirection = p.Zero()), p.TransformNormalToRef(this.direction, this.parent.getWorldMatrix(), this.transformedDirection)), !0) : !1;
  }
  /**
   * Return the depth scale used for the shadow map.
   * @returns the depth scale.
   */
  getDepthScale() {
    return 50;
  }
  /**
   * Get the direction to use to render the shadow map. In case of cube texture, the face index can be passed.
   * @param faceIndex The index of the face we are computed the direction to generate shadow
   * @returns The set direction in 2d mode otherwise the direction to the cubemap face if needCube() is true
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getShadowDirection(e) {
    return this.transformedDirection ? this.transformedDirection : this.direction;
  }
  /**
   * Returns the ShadowLight absolute position in the World.
   * @returns the position vector in world space
   */
  getAbsolutePosition() {
    return this.transformedPosition ? this.transformedPosition : this.position;
  }
  /**
   * Sets the ShadowLight direction toward the passed target.
   * @param target The point to target in local space
   * @returns the updated ShadowLight direction
   */
  setDirectionToTarget(e) {
    return this.direction = p.Normalize(e.subtract(this.position)), this.direction;
  }
  /**
   * Returns the light rotation in euler definition.
   * @returns the x y z rotation in local space.
   */
  getRotation() {
    this.direction.normalize();
    const e = p.Cross(this.direction, Et.Y), t = p.Cross(e, this.direction);
    return p.RotationFromAxis(e, t, this.direction);
  }
  /**
   * Returns whether or not the shadow generation require a cube texture or a 2d texture.
   * @returns true if a cube texture needs to be use
   */
  needCube() {
    return !1;
  }
  /**
   * Detects if the projection matrix requires to be recomputed this frame.
   * @returns true if it requires to be recomputed otherwise, false.
   */
  needProjectionMatrixCompute() {
    return this._needProjectionMatrixCompute;
  }
  /**
   * Forces the shadow generator to recompute the projection matrix even if position and direction did not changed.
   */
  forceProjectionMatrixCompute() {
    this._needProjectionMatrixCompute = !0;
  }
  /** @internal */
  _initCache() {
    super._initCache(), this._cache.position = p.Zero();
  }
  /** @internal */
  _isSynchronized() {
    return !!this._cache.position.equals(this.position);
  }
  /**
   * Computes the world matrix of the node
   * @param force defines if the cache version should be invalidated forcing the world matrix to be created from scratch
   * @returns the world matrix
   */
  computeWorldMatrix(e) {
    return !e && this.isSynchronized() ? (this._currentRenderId = this.getScene().getRenderId(), this._worldMatrix) : (this._updateCache(), this._cache.position.copyFrom(this.position), this._worldMatrix || (this._worldMatrix = I.Identity()), I.TranslationToRef(this.position.x, this.position.y, this.position.z, this._worldMatrix), this.parent && this.parent.getWorldMatrix && (this._worldMatrix.multiplyToRef(this.parent.getWorldMatrix(), this._worldMatrix), this._markSyncedWithParent()), this._worldMatrixDeterminantIsDirty = !0, this._worldMatrix);
  }
  /**
   * Gets the minZ used for shadow according to both the scene and the light.
   * @param activeCamera The camera we are returning the min for
   * @returns the depth min z
   */
  getDepthMinZ(e) {
    return this.shadowMinZ !== void 0 ? this.shadowMinZ : e.minZ;
  }
  /**
   * Gets the maxZ used for shadow according to both the scene and the light.
   * @param activeCamera The camera we are returning the max for
   * @returns the depth max z
   */
  getDepthMaxZ(e) {
    return this.shadowMaxZ !== void 0 ? this.shadowMaxZ : e.maxZ;
  }
  /**
   * Sets the shadow projection matrix in parameter to the generated projection matrix.
   * @param matrix The matrix to updated with the projection information
   * @param viewMatrix The transform matrix of the light
   * @param renderList The list of mesh to render in the map
   * @returns The current light
   */
  setShadowProjectionMatrix(e, t, i) {
    return this.customProjectionMatrixBuilder ? this.customProjectionMatrixBuilder(t, i, e) : this._setDefaultShadowProjectionMatrix(e, t, i), this;
  }
  /** @internal */
  _syncParentEnabledState() {
    super._syncParentEnabledState(), (!this.parent || !this.parent.getWorldMatrix) && (this.transformedPosition = null, this.transformedDirection = null);
  }
}
E([
  wt()
], er.prototype, "position", null);
E([
  wt()
], er.prototype, "direction", null);
E([
  R()
], er.prototype, "shadowMinZ", null);
E([
  R()
], er.prototype, "shadowMaxZ", null);
ut.AddNodeConstructor("Light_Type_0", (h, e) => () => new xo(h, p.Zero(), e));
class xo extends er {
  /**
   * Getter: In case of direction provided, the shadow will not use a cube texture but simulate a spot shadow as a fallback
   * This specifies what angle the shadow will use to be created.
   *
   * It default to 90 degrees to work nicely with the cube texture generation for point lights shadow maps.
   */
  get shadowAngle() {
    return this._shadowAngle;
  }
  /**
   * Setter: In case of direction provided, the shadow will not use a cube texture but simulate a spot shadow as a fallback
   * This specifies what angle the shadow will use to be created.
   *
   * It default to 90 degrees to work nicely with the cube texture generation for point lights shadow maps.
   */
  set shadowAngle(e) {
    this._shadowAngle = e, this.forceProjectionMatrixCompute();
  }
  /**
   * Gets the direction if it has been set.
   * In case of direction provided, the shadow will not use a cube texture but simulate a spot shadow as a fallback
   */
  get direction() {
    return this._direction;
  }
  /**
   * In case of direction provided, the shadow will not use a cube texture but simulate a spot shadow as a fallback
   */
  set direction(e) {
    const t = this.needCube();
    if (this._direction = e, this.needCube() !== t && this._shadowGenerators) {
      const i = this._shadowGenerators.values();
      for (let s = i.next(); s.done !== !0; s = i.next())
        s.value.recreateShadowMap();
    }
  }
  /**
   * Creates a PointLight object from the passed name and position (Vector3) and adds it in the scene.
   * A PointLight emits the light in every direction.
   * It can cast shadows.
   * If the scene camera is already defined and you want to set your PointLight at the camera position, just set it :
   * ```javascript
   * var pointLight = new PointLight("pl", camera.position, scene);
   * ```
   * Documentation : https://doc.babylonjs.com/features/featuresDeepDive/lights/lights_introduction
   * @param name The light friendly name
   * @param position The position of the point light in the scene
   * @param scene The scene the lights belongs to
   */
  constructor(e, t, i) {
    super(e, i), this._shadowAngle = Math.PI / 2, this.position = t;
  }
  /**
   * Returns the string "PointLight"
   * @returns the class name
   */
  getClassName() {
    return "PointLight";
  }
  /**
   * Returns the integer 0.
   * @returns The light Type id as a constant defines in Light.LIGHTTYPEID_x
   */
  getTypeID() {
    return me.LIGHTTYPEID_POINTLIGHT;
  }
  /**
   * Specifies whether or not the shadowmap should be a cube texture.
   * @returns true if the shadowmap needs to be a cube texture.
   */
  needCube() {
    return !this.direction;
  }
  /**
   * Returns a new Vector3 aligned with the PointLight cube system according to the passed cube face index (integer).
   * @param faceIndex The index of the face we are computed the direction to generate shadow
   * @returns The set direction in 2d mode otherwise the direction to the cubemap face if needCube() is true
   */
  getShadowDirection(e) {
    if (this.direction)
      return super.getShadowDirection(e);
    switch (e) {
      case 0:
        return new p(1, 0, 0);
      case 1:
        return new p(-1, 0, 0);
      case 2:
        return new p(0, -1, 0);
      case 3:
        return new p(0, 1, 0);
      case 4:
        return new p(0, 0, 1);
      case 5:
        return new p(0, 0, -1);
    }
    return p.Zero();
  }
  /**
   * Sets the passed matrix "matrix" as a left-handed perspective projection matrix with the following settings :
   * - fov = PI / 2
   * - aspect ratio : 1.0
   * - z-near and far equal to the active camera minZ and maxZ.
   * Returns the PointLight.
   * @param matrix
   * @param viewMatrix
   * @param renderList
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _setDefaultShadowProjectionMatrix(e, t, i) {
    const s = this.getScene().activeCamera;
    if (!s)
      return;
    const r = this.shadowMinZ !== void 0 ? this.shadowMinZ : s.minZ, n = this.shadowMaxZ !== void 0 ? this.shadowMaxZ : s.maxZ, a = this.getScene().getEngine().useReverseDepthBuffer;
    I.PerspectiveFovLHToRef(this.shadowAngle, 1, a ? n : r, a ? r : n, e, !0, this._scene.getEngine().isNDCHalfZRange, void 0, a);
  }
  _buildUniformLayout() {
    this._uniformBuffer.addUniform("vLightData", 4), this._uniformBuffer.addUniform("vLightDiffuse", 4), this._uniformBuffer.addUniform("vLightSpecular", 4), this._uniformBuffer.addUniform("vLightFalloff", 4), this._uniformBuffer.addUniform("shadowsInfo", 3), this._uniformBuffer.addUniform("depthValues", 2), this._uniformBuffer.create();
  }
  /**
   * Sets the passed Effect "effect" with the PointLight transformed position (or position, if none) and passed name (string).
   * @param effect The effect to update
   * @param lightIndex The index of the light in the effect to update
   * @returns The point light
   */
  transferToEffect(e, t) {
    return this.computeTransformedInformation() ? this._uniformBuffer.updateFloat4("vLightData", this.transformedPosition.x, this.transformedPosition.y, this.transformedPosition.z, 0, t) : this._uniformBuffer.updateFloat4("vLightData", this.position.x, this.position.y, this.position.z, 0, t), this._uniformBuffer.updateFloat4("vLightFalloff", this.range, this._inverseSquaredRange, 0, 0, t), this;
  }
  transferToNodeMaterialEffect(e, t) {
    return this.computeTransformedInformation() ? e.setFloat3(t, this.transformedPosition.x, this.transformedPosition.y, this.transformedPosition.z) : e.setFloat3(t, this.position.x, this.position.y, this.position.z), this;
  }
  /**
   * Prepares the list of defines specific to the light type.
   * @param defines the list of defines
   * @param lightIndex defines the index of the light for the effect
   */
  prepareLightSpecificDefines(e, t) {
    e["POINTLIGHT" + t] = !0;
  }
}
E([
  R()
], xo.prototype, "shadowAngle", null);
class da {
  constructor() {
    this.previousWorldMatrices = {}, this.previousBones = {};
  }
  /**
   * Add the required uniforms to the current list.
   * @param uniforms defines the current uniform list.
   */
  static AddUniforms(e) {
    e.push("previousWorld", "previousViewProjection", "mPreviousBones");
  }
  /**
   * Add the required samplers to the current list.
   * @param samplers defines the current sampler list.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static AddSamplers(e) {
  }
  /**
   * Binds the material data.
   * @param effect defines the effect to update
   * @param scene defines the scene the material belongs to.
   * @param mesh The mesh
   * @param world World matrix of this mesh
   * @param isFrozen Is the material frozen
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  bindForSubMesh(e, t, i, s, r) {
    if (t.prePassRenderer && t.prePassRenderer.enabled && t.prePassRenderer.currentRTisSceneRT && t.prePassRenderer.getIndex(2) !== -1) {
      this.previousWorldMatrices[i.uniqueId] || (this.previousWorldMatrices[i.uniqueId] = s.clone()), this.previousViewProjection || (this.previousViewProjection = t.getTransformMatrix().clone(), this.currentViewProjection = t.getTransformMatrix().clone());
      const n = t.getEngine();
      this.currentViewProjection.updateFlag !== t.getTransformMatrix().updateFlag ? (this._lastUpdateFrameId = n.frameId, this.previousViewProjection.copyFrom(this.currentViewProjection), this.currentViewProjection.copyFrom(t.getTransformMatrix())) : this._lastUpdateFrameId !== n.frameId && (this._lastUpdateFrameId = n.frameId, this.previousViewProjection.copyFrom(this.currentViewProjection)), e.setMatrix("previousWorld", this.previousWorldMatrices[i.uniqueId]), e.setMatrix("previousViewProjection", this.previousViewProjection), this.previousWorldMatrices[i.uniqueId] = s.clone();
    }
  }
}
class be {
  /**
   * Are diffuse textures enabled in the application.
   */
  static get DiffuseTextureEnabled() {
    return this._DiffuseTextureEnabled;
  }
  static set DiffuseTextureEnabled(e) {
    this._DiffuseTextureEnabled !== e && (this._DiffuseTextureEnabled = e, L.MarkAllMaterialsAsDirty(1));
  }
  /**
   * Are detail textures enabled in the application.
   */
  static get DetailTextureEnabled() {
    return this._DetailTextureEnabled;
  }
  static set DetailTextureEnabled(e) {
    this._DetailTextureEnabled !== e && (this._DetailTextureEnabled = e, L.MarkAllMaterialsAsDirty(1));
  }
  /**
   * Are decal maps enabled in the application.
   */
  static get DecalMapEnabled() {
    return this._DecalMapEnabled;
  }
  static set DecalMapEnabled(e) {
    this._DecalMapEnabled !== e && (this._DecalMapEnabled = e, L.MarkAllMaterialsAsDirty(1));
  }
  /**
   * Are ambient textures enabled in the application.
   */
  static get AmbientTextureEnabled() {
    return this._AmbientTextureEnabled;
  }
  static set AmbientTextureEnabled(e) {
    this._AmbientTextureEnabled !== e && (this._AmbientTextureEnabled = e, L.MarkAllMaterialsAsDirty(1));
  }
  /**
   * Are opacity textures enabled in the application.
   */
  static get OpacityTextureEnabled() {
    return this._OpacityTextureEnabled;
  }
  static set OpacityTextureEnabled(e) {
    this._OpacityTextureEnabled !== e && (this._OpacityTextureEnabled = e, L.MarkAllMaterialsAsDirty(1));
  }
  /**
   * Are reflection textures enabled in the application.
   */
  static get ReflectionTextureEnabled() {
    return this._ReflectionTextureEnabled;
  }
  static set ReflectionTextureEnabled(e) {
    this._ReflectionTextureEnabled !== e && (this._ReflectionTextureEnabled = e, L.MarkAllMaterialsAsDirty(1));
  }
  /**
   * Are emissive textures enabled in the application.
   */
  static get EmissiveTextureEnabled() {
    return this._EmissiveTextureEnabled;
  }
  static set EmissiveTextureEnabled(e) {
    this._EmissiveTextureEnabled !== e && (this._EmissiveTextureEnabled = e, L.MarkAllMaterialsAsDirty(1));
  }
  /**
   * Are specular textures enabled in the application.
   */
  static get SpecularTextureEnabled() {
    return this._SpecularTextureEnabled;
  }
  static set SpecularTextureEnabled(e) {
    this._SpecularTextureEnabled !== e && (this._SpecularTextureEnabled = e, L.MarkAllMaterialsAsDirty(1));
  }
  /**
   * Are bump textures enabled in the application.
   */
  static get BumpTextureEnabled() {
    return this._BumpTextureEnabled;
  }
  static set BumpTextureEnabled(e) {
    this._BumpTextureEnabled !== e && (this._BumpTextureEnabled = e, L.MarkAllMaterialsAsDirty(1));
  }
  /**
   * Are lightmap textures enabled in the application.
   */
  static get LightmapTextureEnabled() {
    return this._LightmapTextureEnabled;
  }
  static set LightmapTextureEnabled(e) {
    this._LightmapTextureEnabled !== e && (this._LightmapTextureEnabled = e, L.MarkAllMaterialsAsDirty(1));
  }
  /**
   * Are refraction textures enabled in the application.
   */
  static get RefractionTextureEnabled() {
    return this._RefractionTextureEnabled;
  }
  static set RefractionTextureEnabled(e) {
    this._RefractionTextureEnabled !== e && (this._RefractionTextureEnabled = e, L.MarkAllMaterialsAsDirty(1));
  }
  /**
   * Are color grading textures enabled in the application.
   */
  static get ColorGradingTextureEnabled() {
    return this._ColorGradingTextureEnabled;
  }
  static set ColorGradingTextureEnabled(e) {
    this._ColorGradingTextureEnabled !== e && (this._ColorGradingTextureEnabled = e, L.MarkAllMaterialsAsDirty(1));
  }
  /**
   * Are fresnels enabled in the application.
   */
  static get FresnelEnabled() {
    return this._FresnelEnabled;
  }
  static set FresnelEnabled(e) {
    this._FresnelEnabled !== e && (this._FresnelEnabled = e, L.MarkAllMaterialsAsDirty(4));
  }
  /**
   * Are clear coat textures enabled in the application.
   */
  static get ClearCoatTextureEnabled() {
    return this._ClearCoatTextureEnabled;
  }
  static set ClearCoatTextureEnabled(e) {
    this._ClearCoatTextureEnabled !== e && (this._ClearCoatTextureEnabled = e, L.MarkAllMaterialsAsDirty(1));
  }
  /**
   * Are clear coat bump textures enabled in the application.
   */
  static get ClearCoatBumpTextureEnabled() {
    return this._ClearCoatBumpTextureEnabled;
  }
  static set ClearCoatBumpTextureEnabled(e) {
    this._ClearCoatBumpTextureEnabled !== e && (this._ClearCoatBumpTextureEnabled = e, L.MarkAllMaterialsAsDirty(1));
  }
  /**
   * Are clear coat tint textures enabled in the application.
   */
  static get ClearCoatTintTextureEnabled() {
    return this._ClearCoatTintTextureEnabled;
  }
  static set ClearCoatTintTextureEnabled(e) {
    this._ClearCoatTintTextureEnabled !== e && (this._ClearCoatTintTextureEnabled = e, L.MarkAllMaterialsAsDirty(1));
  }
  /**
   * Are sheen textures enabled in the application.
   */
  static get SheenTextureEnabled() {
    return this._SheenTextureEnabled;
  }
  static set SheenTextureEnabled(e) {
    this._SheenTextureEnabled !== e && (this._SheenTextureEnabled = e, L.MarkAllMaterialsAsDirty(1));
  }
  /**
   * Are anisotropic textures enabled in the application.
   */
  static get AnisotropicTextureEnabled() {
    return this._AnisotropicTextureEnabled;
  }
  static set AnisotropicTextureEnabled(e) {
    this._AnisotropicTextureEnabled !== e && (this._AnisotropicTextureEnabled = e, L.MarkAllMaterialsAsDirty(1));
  }
  /**
   * Are thickness textures enabled in the application.
   */
  static get ThicknessTextureEnabled() {
    return this._ThicknessTextureEnabled;
  }
  static set ThicknessTextureEnabled(e) {
    this._ThicknessTextureEnabled !== e && (this._ThicknessTextureEnabled = e, L.MarkAllMaterialsAsDirty(1));
  }
  /**
   * Are refraction intensity textures enabled in the application.
   */
  static get RefractionIntensityTextureEnabled() {
    return this._ThicknessTextureEnabled;
  }
  static set RefractionIntensityTextureEnabled(e) {
    this._RefractionIntensityTextureEnabled !== e && (this._RefractionIntensityTextureEnabled = e, L.MarkAllMaterialsAsDirty(1));
  }
  /**
   * Are translucency intensity textures enabled in the application.
   */
  static get TranslucencyIntensityTextureEnabled() {
    return this._ThicknessTextureEnabled;
  }
  static set TranslucencyIntensityTextureEnabled(e) {
    this._TranslucencyIntensityTextureEnabled !== e && (this._TranslucencyIntensityTextureEnabled = e, L.MarkAllMaterialsAsDirty(1));
  }
  /**
   * Are translucency intensity textures enabled in the application.
   */
  static get IridescenceTextureEnabled() {
    return this._IridescenceTextureEnabled;
  }
  static set IridescenceTextureEnabled(e) {
    this._IridescenceTextureEnabled !== e && (this._IridescenceTextureEnabled = e, L.MarkAllMaterialsAsDirty(1));
  }
}
be._DiffuseTextureEnabled = !0;
be._DetailTextureEnabled = !0;
be._DecalMapEnabled = !0;
be._AmbientTextureEnabled = !0;
be._OpacityTextureEnabled = !0;
be._ReflectionTextureEnabled = !0;
be._EmissiveTextureEnabled = !0;
be._SpecularTextureEnabled = !0;
be._BumpTextureEnabled = !0;
be._LightmapTextureEnabled = !0;
be._RefractionTextureEnabled = !0;
be._ColorGradingTextureEnabled = !0;
be._FresnelEnabled = !0;
be._ClearCoatTextureEnabled = !0;
be._ClearCoatBumpTextureEnabled = !0;
be._ClearCoatTintTextureEnabled = !0;
be._SheenTextureEnabled = !0;
be._AnisotropicTextureEnabled = !0;
be._ThicknessTextureEnabled = !0;
be._RefractionIntensityTextureEnabled = !0;
be._TranslucencyIntensityTextureEnabled = !0;
be._IridescenceTextureEnabled = !0;
const Bc = "decalFragmentDeclaration", Uc = `#ifdef DECAL
uniform vec4 vDecalInfos;
#endif
`;
G.IncludesShadersStore[Bc] = Uc;
const kc = "defaultFragmentDeclaration", Vc = `uniform vec4 vEyePosition;uniform vec4 vDiffuseColor;
#ifdef SPECULARTERM
uniform vec4 vSpecularColor;
#endif
uniform vec3 vEmissiveColor;uniform vec3 vAmbientColor;uniform float visibility;
#ifdef DIFFUSE
uniform vec2 vDiffuseInfos;
#endif
#ifdef AMBIENT
uniform vec2 vAmbientInfos;
#endif
#ifdef OPACITY 
uniform vec2 vOpacityInfos;
#endif
#ifdef EMISSIVE
uniform vec2 vEmissiveInfos;
#endif
#ifdef LIGHTMAP
uniform vec2 vLightmapInfos;
#endif
#ifdef BUMP
uniform vec3 vBumpInfos;uniform vec2 vTangentSpaceParams;
#endif
#ifdef ALPHATEST
uniform float alphaCutOff;
#endif
#if defined(REFLECTIONMAP_SPHERICAL) || defined(REFLECTIONMAP_PROJECTION) || defined(REFRACTION) || defined(PREPASS)
uniform mat4 view;
#endif
#ifdef REFRACTION
uniform vec4 vRefractionInfos;
#ifndef REFRACTIONMAP_3D
uniform mat4 refractionMatrix;
#endif
#ifdef REFRACTIONFRESNEL
uniform vec4 refractionLeftColor;uniform vec4 refractionRightColor;
#endif
#if defined(USE_LOCAL_REFRACTIONMAP_CUBIC) && defined(REFRACTIONMAP_3D)
uniform vec3 vRefractionPosition;uniform vec3 vRefractionSize; 
#endif
#endif
#if defined(SPECULAR) && defined(SPECULARTERM)
uniform vec2 vSpecularInfos;
#endif
#ifdef DIFFUSEFRESNEL
uniform vec4 diffuseLeftColor;uniform vec4 diffuseRightColor;
#endif
#ifdef OPACITYFRESNEL
uniform vec4 opacityParts;
#endif
#ifdef EMISSIVEFRESNEL
uniform vec4 emissiveLeftColor;uniform vec4 emissiveRightColor;
#endif
#ifdef REFLECTION
uniform vec2 vReflectionInfos;
#if defined(REFLECTIONMAP_PLANAR) || defined(REFLECTIONMAP_CUBIC) || defined(REFLECTIONMAP_PROJECTION) || defined(REFLECTIONMAP_EQUIRECTANGULAR) || defined(REFLECTIONMAP_SPHERICAL) || defined(REFLECTIONMAP_SKYBOX)
uniform mat4 reflectionMatrix;
#endif
#ifndef REFLECTIONMAP_SKYBOX
#if defined(USE_LOCAL_REFLECTIONMAP_CUBIC) && defined(REFLECTIONMAP_CUBIC)
uniform vec3 vReflectionPosition;uniform vec3 vReflectionSize; 
#endif
#endif
#ifdef REFLECTIONFRESNEL
uniform vec4 reflectionLeftColor;uniform vec4 reflectionRightColor;
#endif
#endif
#ifdef DETAIL
uniform vec4 vDetailInfos;
#endif
#include<decalFragmentDeclaration>
#define ADDITIONAL_FRAGMENT_DECLARATION
`;
G.IncludesShadersStore[kc] = Vc;
const Wc = "sceneUboDeclaration", zc = `layout(std140,column_major) uniform;uniform Scene {mat4 viewProjection;
#ifdef MULTIVIEW
mat4 viewProjectionR;
#endif 
mat4 view;mat4 projection;vec4 vEyePosition;};
`;
G.IncludesShadersStore[Wc] = zc;
const Gc = "meshUboDeclaration", Xc = `#ifdef WEBGL2
uniform mat4 world;uniform float visibility;
#else
layout(std140,column_major) uniform;uniform Mesh
{mat4 world;float visibility;};
#endif
#define WORLD_UBO
`;
G.IncludesShadersStore[Gc] = Xc;
const Hc = "defaultUboDeclaration", Kc = `layout(std140,column_major) uniform;uniform Material
{vec4 diffuseLeftColor;vec4 diffuseRightColor;vec4 opacityParts;vec4 reflectionLeftColor;vec4 reflectionRightColor;vec4 refractionLeftColor;vec4 refractionRightColor;vec4 emissiveLeftColor;vec4 emissiveRightColor;vec2 vDiffuseInfos;vec2 vAmbientInfos;vec2 vOpacityInfos;vec2 vReflectionInfos;vec3 vReflectionPosition;vec3 vReflectionSize;vec2 vEmissiveInfos;vec2 vLightmapInfos;vec2 vSpecularInfos;vec3 vBumpInfos;mat4 diffuseMatrix;mat4 ambientMatrix;mat4 opacityMatrix;mat4 reflectionMatrix;mat4 emissiveMatrix;mat4 lightmapMatrix;mat4 specularMatrix;mat4 bumpMatrix;vec2 vTangentSpaceParams;float pointSize;float alphaCutOff;mat4 refractionMatrix;vec4 vRefractionInfos;vec3 vRefractionPosition;vec3 vRefractionSize;vec4 vSpecularColor;vec3 vEmissiveColor;vec4 vDiffuseColor;vec3 vAmbientColor;
#define ADDITIONAL_UBO_DECLARATION
};
#include<sceneUboDeclaration>
#include<meshUboDeclaration>
`;
G.IncludesShadersStore[Hc] = Kc;
const Yc = "prePassDeclaration", qc = `#ifdef PREPASS
#extension GL_EXT_draw_buffers : require
layout(location=0) out highp vec4 glFragData[{X}];highp vec4 gl_FragColor;
#ifdef PREPASS_DEPTH
varying highp vec3 vViewPos;
#endif
#ifdef PREPASS_VELOCITY
varying highp vec4 vCurrentPosition;varying highp vec4 vPreviousPosition;
#endif
#endif
`;
G.IncludesShadersStore[Yc] = qc;
const jc = "oitDeclaration", Zc = `#ifdef ORDER_INDEPENDENT_TRANSPARENCY
#extension GL_EXT_draw_buffers : require
layout(location=0) out vec2 depth; 
layout(location=1) out vec4 frontColor;layout(location=2) out vec4 backColor;
#define MAX_DEPTH 99999.0
highp vec4 gl_FragColor;uniform sampler2D oitDepthSampler;uniform sampler2D oitFrontColorSampler;
#endif
`;
G.IncludesShadersStore[jc] = Zc;
const Qc = "mainUVVaryingDeclaration", $c = `#ifdef MAINUV{X}
varying vec2 vMainUV{X};
#endif
`;
G.IncludesShadersStore[Qc] = $c;
const Jc = "lightFragmentDeclaration", eu = `#ifdef LIGHT{X}
uniform vec4 vLightData{X};uniform vec4 vLightDiffuse{X};
#ifdef SPECULARTERM
uniform vec4 vLightSpecular{X};
#else
vec4 vLightSpecular{X}=vec4(0.);
#endif
#ifdef SHADOW{X}
#ifdef SHADOWCSM{X}
uniform mat4 lightMatrix{X}[SHADOWCSMNUM_CASCADES{X}];uniform float viewFrustumZ{X}[SHADOWCSMNUM_CASCADES{X}];uniform float frustumLengths{X}[SHADOWCSMNUM_CASCADES{X}];uniform float cascadeBlendFactor{X};varying vec4 vPositionFromLight{X}[SHADOWCSMNUM_CASCADES{X}];varying float vDepthMetric{X}[SHADOWCSMNUM_CASCADES{X}];varying vec4 vPositionFromCamera{X};
#if defined(SHADOWPCSS{X})
uniform highp sampler2DArrayShadow shadowSampler{X};uniform highp sampler2DArray depthSampler{X};uniform vec2 lightSizeUVCorrection{X}[SHADOWCSMNUM_CASCADES{X}];uniform float depthCorrection{X}[SHADOWCSMNUM_CASCADES{X}];uniform float penumbraDarkness{X};
#elif defined(SHADOWPCF{X})
uniform highp sampler2DArrayShadow shadowSampler{X};
#else
uniform highp sampler2DArray shadowSampler{X};
#endif
#ifdef SHADOWCSMDEBUG{X}
const vec3 vCascadeColorsMultiplier{X}[8]=vec3[8]
(
vec3 ( 1.5,0.0,0.0 ),
vec3 ( 0.0,1.5,0.0 ),
vec3 ( 0.0,0.0,5.5 ),
vec3 ( 1.5,0.0,5.5 ),
vec3 ( 1.5,1.5,0.0 ),
vec3 ( 1.0,1.0,1.0 ),
vec3 ( 0.0,1.0,5.5 ),
vec3 ( 0.5,3.5,0.75 )
);vec3 shadowDebug{X};
#endif
#ifdef SHADOWCSMUSESHADOWMAXZ{X}
int index{X}=-1;
#else
int index{X}=SHADOWCSMNUM_CASCADES{X}-1;
#endif
float diff{X}=0.;
#elif defined(SHADOWCUBE{X})
uniform samplerCube shadowSampler{X};
#else
varying vec4 vPositionFromLight{X};varying float vDepthMetric{X};
#if defined(SHADOWPCSS{X})
uniform highp sampler2DShadow shadowSampler{X};uniform highp sampler2D depthSampler{X};
#elif defined(SHADOWPCF{X})
uniform highp sampler2DShadow shadowSampler{X};
#else
uniform sampler2D shadowSampler{X};
#endif
uniform mat4 lightMatrix{X};
#endif
uniform vec4 shadowsInfo{X};uniform vec2 depthValues{X};
#endif
#ifdef SPOTLIGHT{X}
uniform vec4 vLightDirection{X};uniform vec4 vLightFalloff{X};
#elif defined(POINTLIGHT{X})
uniform vec4 vLightFalloff{X};
#elif defined(HEMILIGHT{X})
uniform vec3 vLightGround{X};
#endif
#ifdef PROJECTEDLIGHTTEXTURE{X}
uniform mat4 textureProjectionMatrix{X};uniform sampler2D projectionLightSampler{X};
#endif
#endif
`;
G.IncludesShadersStore[Jc] = eu;
const tu = "lightUboDeclaration", iu = `#ifdef LIGHT{X}
uniform Light{X}
{vec4 vLightData;vec4 vLightDiffuse;vec4 vLightSpecular;
#ifdef SPOTLIGHT{X}
vec4 vLightDirection;vec4 vLightFalloff;
#elif defined(POINTLIGHT{X})
vec4 vLightFalloff;
#elif defined(HEMILIGHT{X})
vec3 vLightGround;
#endif
vec4 shadowsInfo;vec2 depthValues;} light{X};
#ifdef PROJECTEDLIGHTTEXTURE{X}
uniform mat4 textureProjectionMatrix{X};uniform sampler2D projectionLightSampler{X};
#endif
#ifdef SHADOW{X}
#ifdef SHADOWCSM{X}
uniform mat4 lightMatrix{X}[SHADOWCSMNUM_CASCADES{X}];uniform float viewFrustumZ{X}[SHADOWCSMNUM_CASCADES{X}];uniform float frustumLengths{X}[SHADOWCSMNUM_CASCADES{X}];uniform float cascadeBlendFactor{X};varying vec4 vPositionFromLight{X}[SHADOWCSMNUM_CASCADES{X}];varying float vDepthMetric{X}[SHADOWCSMNUM_CASCADES{X}];varying vec4 vPositionFromCamera{X};
#if defined(SHADOWPCSS{X})
uniform highp sampler2DArrayShadow shadowSampler{X};uniform highp sampler2DArray depthSampler{X};uniform vec2 lightSizeUVCorrection{X}[SHADOWCSMNUM_CASCADES{X}];uniform float depthCorrection{X}[SHADOWCSMNUM_CASCADES{X}];uniform float penumbraDarkness{X};
#elif defined(SHADOWPCF{X})
uniform highp sampler2DArrayShadow shadowSampler{X};
#else
uniform highp sampler2DArray shadowSampler{X};
#endif
#ifdef SHADOWCSMDEBUG{X}
const vec3 vCascadeColorsMultiplier{X}[8]=vec3[8]
(
vec3 ( 1.5,0.0,0.0 ),
vec3 ( 0.0,1.5,0.0 ),
vec3 ( 0.0,0.0,5.5 ),
vec3 ( 1.5,0.0,5.5 ),
vec3 ( 1.5,1.5,0.0 ),
vec3 ( 1.0,1.0,1.0 ),
vec3 ( 0.0,1.0,5.5 ),
vec3 ( 0.5,3.5,0.75 )
);vec3 shadowDebug{X};
#endif
#ifdef SHADOWCSMUSESHADOWMAXZ{X}
int index{X}=-1;
#else
int index{X}=SHADOWCSMNUM_CASCADES{X}-1;
#endif
float diff{X}=0.;
#elif defined(SHADOWCUBE{X})
uniform samplerCube shadowSampler{X}; 
#else
varying vec4 vPositionFromLight{X};varying float vDepthMetric{X};
#if defined(SHADOWPCSS{X})
uniform highp sampler2DShadow shadowSampler{X};uniform highp sampler2D depthSampler{X};
#elif defined(SHADOWPCF{X})
uniform highp sampler2DShadow shadowSampler{X};
#else
uniform sampler2D shadowSampler{X};
#endif
uniform mat4 lightMatrix{X};
#endif
#endif
#endif
`;
G.IncludesShadersStore[tu] = iu;
const su = "lightsFragmentFunctions", ru = `struct lightingInfo
{vec3 diffuse;
#ifdef SPECULARTERM
vec3 specular;
#endif
#ifdef NDOTL
float ndl;
#endif
};lightingInfo computeLighting(vec3 viewDirectionW,vec3 vNormal,vec4 lightData,vec3 diffuseColor,vec3 specularColor,float range,float glossiness) {lightingInfo result;vec3 lightVectorW;float attenuation=1.0;if (lightData.w==0.)
{vec3 direction=lightData.xyz-vPositionW;attenuation=max(0.,1.0-length(direction)/range);lightVectorW=normalize(direction);}
else
{lightVectorW=normalize(-lightData.xyz);}
float ndl=max(0.,dot(vNormal,lightVectorW));
#ifdef NDOTL
result.ndl=ndl;
#endif
result.diffuse=ndl*diffuseColor*attenuation;
#ifdef SPECULARTERM
vec3 angleW=normalize(viewDirectionW+lightVectorW);float specComp=max(0.,dot(vNormal,angleW));specComp=pow(specComp,max(1.,glossiness));result.specular=specComp*specularColor*attenuation;
#endif
return result;}
lightingInfo computeSpotLighting(vec3 viewDirectionW,vec3 vNormal,vec4 lightData,vec4 lightDirection,vec3 diffuseColor,vec3 specularColor,float range,float glossiness) {lightingInfo result;vec3 direction=lightData.xyz-vPositionW;vec3 lightVectorW=normalize(direction);float attenuation=max(0.,1.0-length(direction)/range);float cosAngle=max(0.,dot(lightDirection.xyz,-lightVectorW));if (cosAngle>=lightDirection.w)
{cosAngle=max(0.,pow(cosAngle,lightData.w));attenuation*=cosAngle;float ndl=max(0.,dot(vNormal,lightVectorW));
#ifdef NDOTL
result.ndl=ndl;
#endif
result.diffuse=ndl*diffuseColor*attenuation;
#ifdef SPECULARTERM
vec3 angleW=normalize(viewDirectionW+lightVectorW);float specComp=max(0.,dot(vNormal,angleW));specComp=pow(specComp,max(1.,glossiness));result.specular=specComp*specularColor*attenuation;
#endif
return result;}
result.diffuse=vec3(0.);
#ifdef SPECULARTERM
result.specular=vec3(0.);
#endif
#ifdef NDOTL
result.ndl=0.;
#endif
return result;}
lightingInfo computeHemisphericLighting(vec3 viewDirectionW,vec3 vNormal,vec4 lightData,vec3 diffuseColor,vec3 specularColor,vec3 groundColor,float glossiness) {lightingInfo result;float ndl=dot(vNormal,lightData.xyz)*0.5+0.5;
#ifdef NDOTL
result.ndl=ndl;
#endif
result.diffuse=mix(groundColor,diffuseColor,ndl);
#ifdef SPECULARTERM
vec3 angleW=normalize(viewDirectionW+lightData.xyz);float specComp=max(0.,dot(vNormal,angleW));specComp=pow(specComp,max(1.,glossiness));result.specular=specComp*specularColor;
#endif
return result;}
#define inline
vec3 computeProjectionTextureDiffuseLighting(sampler2D projectionLightSampler,mat4 textureProjectionMatrix){vec4 strq=textureProjectionMatrix*vec4(vPositionW,1.0);strq/=strq.w;vec3 textureColor=texture2D(projectionLightSampler,strq.xy).rgb;return textureColor;}`;
G.IncludesShadersStore[su] = ru;
const nu = "shadowsFragmentFunctions", au = `#ifdef SHADOWS
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
#define TEXTUREFUNC(s,c,l) texture2DLodEXT(s,c,l)
#else
#define TEXTUREFUNC(s,c,b) texture2D(s,c,b)
#endif
#ifndef SHADOWFLOAT
float unpack(vec4 color)
{const vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(color,bit_shift);}
#endif
float computeFallOff(float value,vec2 clipSpace,float frustumEdgeFalloff)
{float mask=smoothstep(1.0-frustumEdgeFalloff,1.00000012,clamp(dot(clipSpace,clipSpace),0.,1.));return mix(value,1.0,mask);}
#define inline
float computeShadowCube(vec3 lightPosition,samplerCube shadowSampler,float darkness,vec2 depthValues)
{vec3 directionToLight=vPositionW-lightPosition;float depth=length(directionToLight);depth=(depth+depthValues.x)/(depthValues.y);depth=clamp(depth,0.,1.0);directionToLight=normalize(directionToLight);directionToLight.y=-directionToLight.y;
#ifndef SHADOWFLOAT
float shadow=unpack(textureCube(shadowSampler,directionToLight));
#else
float shadow=textureCube(shadowSampler,directionToLight).x;
#endif
return depth>shadow ? darkness : 1.0;}
#define inline
float computeShadowWithPoissonSamplingCube(vec3 lightPosition,samplerCube shadowSampler,float mapSize,float darkness,vec2 depthValues)
{vec3 directionToLight=vPositionW-lightPosition;float depth=length(directionToLight);depth=(depth+depthValues.x)/(depthValues.y);depth=clamp(depth,0.,1.0);directionToLight=normalize(directionToLight);directionToLight.y=-directionToLight.y;float visibility=1.;vec3 poissonDisk[4];poissonDisk[0]=vec3(-1.0,1.0,-1.0);poissonDisk[1]=vec3(1.0,-1.0,-1.0);poissonDisk[2]=vec3(-1.0,-1.0,-1.0);poissonDisk[3]=vec3(1.0,-1.0,1.0);
#ifndef SHADOWFLOAT
if (unpack(textureCube(shadowSampler,directionToLight+poissonDisk[0]*mapSize))<depth) visibility-=0.25;if (unpack(textureCube(shadowSampler,directionToLight+poissonDisk[1]*mapSize))<depth) visibility-=0.25;if (unpack(textureCube(shadowSampler,directionToLight+poissonDisk[2]*mapSize))<depth) visibility-=0.25;if (unpack(textureCube(shadowSampler,directionToLight+poissonDisk[3]*mapSize))<depth) visibility-=0.25;
#else
if (textureCube(shadowSampler,directionToLight+poissonDisk[0]*mapSize).x<depth) visibility-=0.25;if (textureCube(shadowSampler,directionToLight+poissonDisk[1]*mapSize).x<depth) visibility-=0.25;if (textureCube(shadowSampler,directionToLight+poissonDisk[2]*mapSize).x<depth) visibility-=0.25;if (textureCube(shadowSampler,directionToLight+poissonDisk[3]*mapSize).x<depth) visibility-=0.25;
#endif
return min(1.0,visibility+darkness);}
#define inline
float computeShadowWithESMCube(vec3 lightPosition,samplerCube shadowSampler,float darkness,float depthScale,vec2 depthValues)
{vec3 directionToLight=vPositionW-lightPosition;float depth=length(directionToLight);depth=(depth+depthValues.x)/(depthValues.y);float shadowPixelDepth=clamp(depth,0.,1.0);directionToLight=normalize(directionToLight);directionToLight.y=-directionToLight.y;
#ifndef SHADOWFLOAT
float shadowMapSample=unpack(textureCube(shadowSampler,directionToLight));
#else
float shadowMapSample=textureCube(shadowSampler,directionToLight).x;
#endif
float esm=1.0-clamp(exp(min(87.,depthScale*shadowPixelDepth))*shadowMapSample,0.,1.-darkness); 
return esm;}
#define inline
float computeShadowWithCloseESMCube(vec3 lightPosition,samplerCube shadowSampler,float darkness,float depthScale,vec2 depthValues)
{vec3 directionToLight=vPositionW-lightPosition;float depth=length(directionToLight);depth=(depth+depthValues.x)/(depthValues.y);float shadowPixelDepth=clamp(depth,0.,1.0);directionToLight=normalize(directionToLight);directionToLight.y=-directionToLight.y;
#ifndef SHADOWFLOAT
float shadowMapSample=unpack(textureCube(shadowSampler,directionToLight));
#else
float shadowMapSample=textureCube(shadowSampler,directionToLight).x;
#endif
float esm=clamp(exp(min(87.,-depthScale*(shadowPixelDepth-shadowMapSample))),darkness,1.);return esm;}
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
#define inline
float computeShadowCSM(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArray shadowSampler,float darkness,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec2 uv=0.5*clipSpace.xy+vec2(0.5);vec3 uvLayer=vec3(uv.x,uv.y,layer);float shadowPixelDepth=clamp(depthMetric,0.,1.0);
#ifndef SHADOWFLOAT
float shadow=unpack(texture2D(shadowSampler,uvLayer));
#else
float shadow=texture2D(shadowSampler,uvLayer).x;
#endif
return shadowPixelDepth>shadow ? computeFallOff(darkness,clipSpace.xy,frustumEdgeFalloff) : 1.;}
#endif
#define inline
float computeShadow(vec4 vPositionFromLight,float depthMetric,sampler2D shadowSampler,float darkness,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec2 uv=0.5*clipSpace.xy+vec2(0.5);if (uv.x<0. || uv.x>1.0 || uv.y<0. || uv.y>1.0)
{return 1.0;}
else
{float shadowPixelDepth=clamp(depthMetric,0.,1.0);
#ifndef SHADOWFLOAT
float shadow=unpack(TEXTUREFUNC(shadowSampler,uv,0.));
#else
float shadow=TEXTUREFUNC(shadowSampler,uv,0.).x;
#endif
return shadowPixelDepth>shadow ? computeFallOff(darkness,clipSpace.xy,frustumEdgeFalloff) : 1.;}}
#define inline
float computeShadowWithPoissonSampling(vec4 vPositionFromLight,float depthMetric,sampler2D shadowSampler,float mapSize,float darkness,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec2 uv=0.5*clipSpace.xy+vec2(0.5);if (uv.x<0. || uv.x>1.0 || uv.y<0. || uv.y>1.0)
{return 1.0;}
else
{float shadowPixelDepth=clamp(depthMetric,0.,1.0);float visibility=1.;vec2 poissonDisk[4];poissonDisk[0]=vec2(-0.94201624,-0.39906216);poissonDisk[1]=vec2(0.94558609,-0.76890725);poissonDisk[2]=vec2(-0.094184101,-0.92938870);poissonDisk[3]=vec2(0.34495938,0.29387760);
#ifndef SHADOWFLOAT
if (unpack(TEXTUREFUNC(shadowSampler,uv+poissonDisk[0]*mapSize,0.))<shadowPixelDepth) visibility-=0.25;if (unpack(TEXTUREFUNC(shadowSampler,uv+poissonDisk[1]*mapSize,0.))<shadowPixelDepth) visibility-=0.25;if (unpack(TEXTUREFUNC(shadowSampler,uv+poissonDisk[2]*mapSize,0.))<shadowPixelDepth) visibility-=0.25;if (unpack(TEXTUREFUNC(shadowSampler,uv+poissonDisk[3]*mapSize,0.))<shadowPixelDepth) visibility-=0.25;
#else
if (TEXTUREFUNC(shadowSampler,uv+poissonDisk[0]*mapSize,0.).x<shadowPixelDepth) visibility-=0.25;if (TEXTUREFUNC(shadowSampler,uv+poissonDisk[1]*mapSize,0.).x<shadowPixelDepth) visibility-=0.25;if (TEXTUREFUNC(shadowSampler,uv+poissonDisk[2]*mapSize,0.).x<shadowPixelDepth) visibility-=0.25;if (TEXTUREFUNC(shadowSampler,uv+poissonDisk[3]*mapSize,0.).x<shadowPixelDepth) visibility-=0.25;
#endif
return computeFallOff(min(1.0,visibility+darkness),clipSpace.xy,frustumEdgeFalloff);}}
#define inline
float computeShadowWithESM(vec4 vPositionFromLight,float depthMetric,sampler2D shadowSampler,float darkness,float depthScale,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec2 uv=0.5*clipSpace.xy+vec2(0.5);if (uv.x<0. || uv.x>1.0 || uv.y<0. || uv.y>1.0)
{return 1.0;}
else
{float shadowPixelDepth=clamp(depthMetric,0.,1.0);
#ifndef SHADOWFLOAT
float shadowMapSample=unpack(TEXTUREFUNC(shadowSampler,uv,0.));
#else
float shadowMapSample=TEXTUREFUNC(shadowSampler,uv,0.).x;
#endif
float esm=1.0-clamp(exp(min(87.,depthScale*shadowPixelDepth))*shadowMapSample,0.,1.-darkness);return computeFallOff(esm,clipSpace.xy,frustumEdgeFalloff);}}
#define inline
float computeShadowWithCloseESM(vec4 vPositionFromLight,float depthMetric,sampler2D shadowSampler,float darkness,float depthScale,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec2 uv=0.5*clipSpace.xy+vec2(0.5);if (uv.x<0. || uv.x>1.0 || uv.y<0. || uv.y>1.0)
{return 1.0;}
else
{float shadowPixelDepth=clamp(depthMetric,0.,1.0); 
#ifndef SHADOWFLOAT
float shadowMapSample=unpack(TEXTUREFUNC(shadowSampler,uv,0.));
#else
float shadowMapSample=TEXTUREFUNC(shadowSampler,uv,0.).x;
#endif
float esm=clamp(exp(min(87.,-depthScale*(shadowPixelDepth-shadowMapSample))),darkness,1.);return computeFallOff(esm,clipSpace.xy,frustumEdgeFalloff);}}
#ifdef IS_NDC_HALF_ZRANGE
#define ZINCLIP clipSpace.z
#else
#define ZINCLIP uvDepth.z
#endif
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
#define GREATEST_LESS_THAN_ONE 0.99999994
#define inline
float computeShadowWithCSMPCF1(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArrayShadow shadowSampler,float darkness,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=clamp(ZINCLIP,0.,GREATEST_LESS_THAN_ONE);vec4 uvDepthLayer=vec4(uvDepth.x,uvDepth.y,layer,uvDepth.z);float shadow=texture2D(shadowSampler,uvDepthLayer);shadow=mix(darkness,1.,shadow);return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}
#define inline
float computeShadowWithCSMPCF3(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArrayShadow shadowSampler,vec2 shadowMapSizeAndInverse,float darkness,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=clamp(ZINCLIP,0.,GREATEST_LESS_THAN_ONE);vec2 uv=uvDepth.xy*shadowMapSizeAndInverse.x; 
uv+=0.5; 
vec2 st=fract(uv); 
vec2 base_uv=floor(uv)-0.5; 
base_uv*=shadowMapSizeAndInverse.y; 
vec2 uvw0=3.-2.*st;vec2 uvw1=1.+2.*st;vec2 u=vec2((2.-st.x)/uvw0.x-1.,st.x/uvw1.x+1.)*shadowMapSizeAndInverse.y;vec2 v=vec2((2.-st.y)/uvw0.y-1.,st.y/uvw1.y+1.)*shadowMapSizeAndInverse.y;float shadow=0.;shadow+=uvw0.x*uvw0.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[0],v[0]),layer,uvDepth.z));shadow+=uvw1.x*uvw0.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[1],v[0]),layer,uvDepth.z));shadow+=uvw0.x*uvw1.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[0],v[1]),layer,uvDepth.z));shadow+=uvw1.x*uvw1.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[1],v[1]),layer,uvDepth.z));shadow=shadow/16.;shadow=mix(darkness,1.,shadow);return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}
#define inline
float computeShadowWithCSMPCF5(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArrayShadow shadowSampler,vec2 shadowMapSizeAndInverse,float darkness,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=clamp(ZINCLIP,0.,GREATEST_LESS_THAN_ONE);vec2 uv=uvDepth.xy*shadowMapSizeAndInverse.x; 
uv+=0.5; 
vec2 st=fract(uv); 
vec2 base_uv=floor(uv)-0.5; 
base_uv*=shadowMapSizeAndInverse.y; 
vec2 uvw0=4.-3.*st;vec2 uvw1=vec2(7.);vec2 uvw2=1.+3.*st;vec3 u=vec3((3.-2.*st.x)/uvw0.x-2.,(3.+st.x)/uvw1.x,st.x/uvw2.x+2.)*shadowMapSizeAndInverse.y;vec3 v=vec3((3.-2.*st.y)/uvw0.y-2.,(3.+st.y)/uvw1.y,st.y/uvw2.y+2.)*shadowMapSizeAndInverse.y;float shadow=0.;shadow+=uvw0.x*uvw0.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[0],v[0]),layer,uvDepth.z));shadow+=uvw1.x*uvw0.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[1],v[0]),layer,uvDepth.z));shadow+=uvw2.x*uvw0.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[2],v[0]),layer,uvDepth.z));shadow+=uvw0.x*uvw1.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[0],v[1]),layer,uvDepth.z));shadow+=uvw1.x*uvw1.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[1],v[1]),layer,uvDepth.z));shadow+=uvw2.x*uvw1.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[2],v[1]),layer,uvDepth.z));shadow+=uvw0.x*uvw2.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[0],v[2]),layer,uvDepth.z));shadow+=uvw1.x*uvw2.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[1],v[2]),layer,uvDepth.z));shadow+=uvw2.x*uvw2.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[2],v[2]),layer,uvDepth.z));shadow=shadow/144.;shadow=mix(darkness,1.,shadow);return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}
#define inline
float computeShadowWithPCF1(vec4 vPositionFromLight,float depthMetric,highp sampler2DShadow shadowSampler,float darkness,float frustumEdgeFalloff)
{if (depthMetric>1.0 || depthMetric<0.0) {return 1.0;}
else
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=ZINCLIP;float shadow=TEXTUREFUNC(shadowSampler,uvDepth,0.);shadow=mix(darkness,1.,shadow);return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}}
#define inline
float computeShadowWithPCF3(vec4 vPositionFromLight,float depthMetric,highp sampler2DShadow shadowSampler,vec2 shadowMapSizeAndInverse,float darkness,float frustumEdgeFalloff)
{if (depthMetric>1.0 || depthMetric<0.0) {return 1.0;}
else
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=ZINCLIP;vec2 uv=uvDepth.xy*shadowMapSizeAndInverse.x; 
uv+=0.5; 
vec2 st=fract(uv); 
vec2 base_uv=floor(uv)-0.5; 
base_uv*=shadowMapSizeAndInverse.y; 
vec2 uvw0=3.-2.*st;vec2 uvw1=1.+2.*st;vec2 u=vec2((2.-st.x)/uvw0.x-1.,st.x/uvw1.x+1.)*shadowMapSizeAndInverse.y;vec2 v=vec2((2.-st.y)/uvw0.y-1.,st.y/uvw1.y+1.)*shadowMapSizeAndInverse.y;float shadow=0.;shadow+=uvw0.x*uvw0.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[0],v[0]),uvDepth.z),0.);shadow+=uvw1.x*uvw0.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[1],v[0]),uvDepth.z),0.);shadow+=uvw0.x*uvw1.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[0],v[1]),uvDepth.z),0.);shadow+=uvw1.x*uvw1.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[1],v[1]),uvDepth.z),0.);shadow=shadow/16.;shadow=mix(darkness,1.,shadow);return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}}
#define inline
float computeShadowWithPCF5(vec4 vPositionFromLight,float depthMetric,highp sampler2DShadow shadowSampler,vec2 shadowMapSizeAndInverse,float darkness,float frustumEdgeFalloff)
{if (depthMetric>1.0 || depthMetric<0.0) {return 1.0;}
else
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=ZINCLIP;vec2 uv=uvDepth.xy*shadowMapSizeAndInverse.x; 
uv+=0.5; 
vec2 st=fract(uv); 
vec2 base_uv=floor(uv)-0.5; 
base_uv*=shadowMapSizeAndInverse.y; 
vec2 uvw0=4.-3.*st;vec2 uvw1=vec2(7.);vec2 uvw2=1.+3.*st;vec3 u=vec3((3.-2.*st.x)/uvw0.x-2.,(3.+st.x)/uvw1.x,st.x/uvw2.x+2.)*shadowMapSizeAndInverse.y;vec3 v=vec3((3.-2.*st.y)/uvw0.y-2.,(3.+st.y)/uvw1.y,st.y/uvw2.y+2.)*shadowMapSizeAndInverse.y;float shadow=0.;shadow+=uvw0.x*uvw0.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[0],v[0]),uvDepth.z),0.);shadow+=uvw1.x*uvw0.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[1],v[0]),uvDepth.z),0.);shadow+=uvw2.x*uvw0.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[2],v[0]),uvDepth.z),0.);shadow+=uvw0.x*uvw1.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[0],v[1]),uvDepth.z),0.);shadow+=uvw1.x*uvw1.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[1],v[1]),uvDepth.z),0.);shadow+=uvw2.x*uvw1.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[2],v[1]),uvDepth.z),0.);shadow+=uvw0.x*uvw2.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[0],v[2]),uvDepth.z),0.);shadow+=uvw1.x*uvw2.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[1],v[2]),uvDepth.z),0.);shadow+=uvw2.x*uvw2.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[2],v[2]),uvDepth.z),0.);shadow=shadow/144.;shadow=mix(darkness,1.,shadow);return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}}
const vec3 PoissonSamplers32[64]=vec3[64](
vec3(0.06407013,0.05409927,0.),
vec3(0.7366577,0.5789394,0.),
vec3(-0.6270542,-0.5320278,0.),
vec3(-0.4096107,0.8411095,0.),
vec3(0.6849564,-0.4990818,0.),
vec3(-0.874181,-0.04579735,0.),
vec3(0.9989998,0.0009880066,0.),
vec3(-0.004920578,-0.9151649,0.),
vec3(0.1805763,0.9747483,0.),
vec3(-0.2138451,0.2635818,0.),
vec3(0.109845,0.3884785,0.),
vec3(0.06876755,-0.3581074,0.),
vec3(0.374073,-0.7661266,0.),
vec3(0.3079132,-0.1216763,0.),
vec3(-0.3794335,-0.8271583,0.),
vec3(-0.203878,-0.07715034,0.),
vec3(0.5912697,0.1469799,0.),
vec3(-0.88069,0.3031784,0.),
vec3(0.5040108,0.8283722,0.),
vec3(-0.5844124,0.5494877,0.),
vec3(0.6017799,-0.1726654,0.),
vec3(-0.5554981,0.1559997,0.),
vec3(-0.3016369,-0.3900928,0.),
vec3(-0.5550632,-0.1723762,0.),
vec3(0.925029,0.2995041,0.),
vec3(-0.2473137,0.5538505,0.),
vec3(0.9183037,-0.2862392,0.),
vec3(0.2469421,0.6718712,0.),
vec3(0.3916397,-0.4328209,0.),
vec3(-0.03576927,-0.6220032,0.),
vec3(-0.04661255,0.7995201,0.),
vec3(0.4402924,0.3640312,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.),
vec3(0.,0.,0.)
);const vec3 PoissonSamplers64[64]=vec3[64](
vec3(-0.613392,0.617481,0.),
vec3(0.170019,-0.040254,0.),
vec3(-0.299417,0.791925,0.),
vec3(0.645680,0.493210,0.),
vec3(-0.651784,0.717887,0.),
vec3(0.421003,0.027070,0.),
vec3(-0.817194,-0.271096,0.),
vec3(-0.705374,-0.668203,0.),
vec3(0.977050,-0.108615,0.),
vec3(0.063326,0.142369,0.),
vec3(0.203528,0.214331,0.),
vec3(-0.667531,0.326090,0.),
vec3(-0.098422,-0.295755,0.),
vec3(-0.885922,0.215369,0.),
vec3(0.566637,0.605213,0.),
vec3(0.039766,-0.396100,0.),
vec3(0.751946,0.453352,0.),
vec3(0.078707,-0.715323,0.),
vec3(-0.075838,-0.529344,0.),
vec3(0.724479,-0.580798,0.),
vec3(0.222999,-0.215125,0.),
vec3(-0.467574,-0.405438,0.),
vec3(-0.248268,-0.814753,0.),
vec3(0.354411,-0.887570,0.),
vec3(0.175817,0.382366,0.),
vec3(0.487472,-0.063082,0.),
vec3(-0.084078,0.898312,0.),
vec3(0.488876,-0.783441,0.),
vec3(0.470016,0.217933,0.),
vec3(-0.696890,-0.549791,0.),
vec3(-0.149693,0.605762,0.),
vec3(0.034211,0.979980,0.),
vec3(0.503098,-0.308878,0.),
vec3(-0.016205,-0.872921,0.),
vec3(0.385784,-0.393902,0.),
vec3(-0.146886,-0.859249,0.),
vec3(0.643361,0.164098,0.),
vec3(0.634388,-0.049471,0.),
vec3(-0.688894,0.007843,0.),
vec3(0.464034,-0.188818,0.),
vec3(-0.440840,0.137486,0.),
vec3(0.364483,0.511704,0.),
vec3(0.034028,0.325968,0.),
vec3(0.099094,-0.308023,0.),
vec3(0.693960,-0.366253,0.),
vec3(0.678884,-0.204688,0.),
vec3(0.001801,0.780328,0.),
vec3(0.145177,-0.898984,0.),
vec3(0.062655,-0.611866,0.),
vec3(0.315226,-0.604297,0.),
vec3(-0.780145,0.486251,0.),
vec3(-0.371868,0.882138,0.),
vec3(0.200476,0.494430,0.),
vec3(-0.494552,-0.711051,0.),
vec3(0.612476,0.705252,0.),
vec3(-0.578845,-0.768792,0.),
vec3(-0.772454,-0.090976,0.),
vec3(0.504440,0.372295,0.),
vec3(0.155736,0.065157,0.),
vec3(0.391522,0.849605,0.),
vec3(-0.620106,-0.328104,0.),
vec3(0.789239,-0.419965,0.),
vec3(-0.545396,0.538133,0.),
vec3(-0.178564,-0.596057,0.)
);
#define inline
float computeShadowWithCSMPCSS(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArray depthSampler,highp sampler2DArrayShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff,int searchTapCount,int pcfTapCount,vec3[64] poissonSamplers,vec2 lightSizeUVCorrection,float depthCorrection,float penumbraDarkness)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=clamp(ZINCLIP,0.,GREATEST_LESS_THAN_ONE);vec4 uvDepthLayer=vec4(uvDepth.x,uvDepth.y,layer,uvDepth.z);float blockerDepth=0.0;float sumBlockerDepth=0.0;float numBlocker=0.0;for (int i=0; i<searchTapCount; i ++) {blockerDepth=texture2D(depthSampler,vec3(uvDepth.xy+(lightSizeUV*lightSizeUVCorrection*shadowMapSizeInverse*PoissonSamplers32[i].xy),layer)).r;if (blockerDepth<depthMetric) {sumBlockerDepth+=blockerDepth;numBlocker++;}}
float avgBlockerDepth=sumBlockerDepth/numBlocker;float AAOffset=shadowMapSizeInverse*10.;float penumbraRatio=((depthMetric-avgBlockerDepth)*depthCorrection+AAOffset);vec4 filterRadius=vec4(penumbraRatio*lightSizeUV*lightSizeUVCorrection*shadowMapSizeInverse,0.,0.);float random=getRand(vPositionFromLight.xy);float rotationAngle=random*3.1415926;vec2 rotationVector=vec2(cos(rotationAngle),sin(rotationAngle));float shadow=0.;for (int i=0; i<pcfTapCount; i++) {vec4 offset=vec4(poissonSamplers[i],0.);offset=vec4(offset.x*rotationVector.x-offset.y*rotationVector.y,offset.y*rotationVector.x+offset.x*rotationVector.y,0.,0.);shadow+=texture2D(shadowSampler,uvDepthLayer+offset*filterRadius);}
shadow/=float(pcfTapCount);shadow=mix(shadow,1.,min((depthMetric-avgBlockerDepth)*depthCorrection*penumbraDarkness,1.));shadow=mix(darkness,1.,shadow);if (numBlocker<1.0) {return 1.0;}
else
{return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}}
#define inline
float computeShadowWithPCSS(vec4 vPositionFromLight,float depthMetric,sampler2D depthSampler,highp sampler2DShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff,int searchTapCount,int pcfTapCount,vec3[64] poissonSamplers)
{if (depthMetric>1.0 || depthMetric<0.0) {return 1.0;}
else
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=ZINCLIP;float blockerDepth=0.0;float sumBlockerDepth=0.0;float numBlocker=0.0;for (int i=0; i<searchTapCount; i ++) {blockerDepth=TEXTUREFUNC(depthSampler,uvDepth.xy+(lightSizeUV*shadowMapSizeInverse*PoissonSamplers32[i].xy),0.).r;if (blockerDepth<depthMetric) {sumBlockerDepth+=blockerDepth;numBlocker++;}}
if (numBlocker<1.0) {return 1.0;}
else
{float avgBlockerDepth=sumBlockerDepth/numBlocker;float AAOffset=shadowMapSizeInverse*10.;float penumbraRatio=((depthMetric-avgBlockerDepth)+AAOffset);float filterRadius=penumbraRatio*lightSizeUV*shadowMapSizeInverse;float random=getRand(vPositionFromLight.xy);float rotationAngle=random*3.1415926;vec2 rotationVector=vec2(cos(rotationAngle),sin(rotationAngle));float shadow=0.;for (int i=0; i<pcfTapCount; i++) {vec3 offset=poissonSamplers[i];offset=vec3(offset.x*rotationVector.x-offset.y*rotationVector.y,offset.y*rotationVector.x+offset.x*rotationVector.y,0.);shadow+=TEXTUREFUNC(shadowSampler,uvDepth+offset*filterRadius,0.);}
shadow/=float(pcfTapCount);shadow=mix(shadow,1.,depthMetric-avgBlockerDepth);shadow=mix(darkness,1.,shadow);return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}}}
#define inline
float computeShadowWithPCSS16(vec4 vPositionFromLight,float depthMetric,sampler2D depthSampler,highp sampler2DShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff)
{return computeShadowWithPCSS(vPositionFromLight,depthMetric,depthSampler,shadowSampler,shadowMapSizeInverse,lightSizeUV,darkness,frustumEdgeFalloff,16,16,PoissonSamplers32);}
#define inline
float computeShadowWithPCSS32(vec4 vPositionFromLight,float depthMetric,sampler2D depthSampler,highp sampler2DShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff)
{return computeShadowWithPCSS(vPositionFromLight,depthMetric,depthSampler,shadowSampler,shadowMapSizeInverse,lightSizeUV,darkness,frustumEdgeFalloff,16,32,PoissonSamplers32);}
#define inline
float computeShadowWithPCSS64(vec4 vPositionFromLight,float depthMetric,sampler2D depthSampler,highp sampler2DShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff)
{return computeShadowWithPCSS(vPositionFromLight,depthMetric,depthSampler,shadowSampler,shadowMapSizeInverse,lightSizeUV,darkness,frustumEdgeFalloff,32,64,PoissonSamplers64);}
#define inline
float computeShadowWithCSMPCSS16(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArray depthSampler,highp sampler2DArrayShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff,vec2 lightSizeUVCorrection,float depthCorrection,float penumbraDarkness)
{return computeShadowWithCSMPCSS(layer,vPositionFromLight,depthMetric,depthSampler,shadowSampler,shadowMapSizeInverse,lightSizeUV,darkness,frustumEdgeFalloff,16,16,PoissonSamplers32,lightSizeUVCorrection,depthCorrection,penumbraDarkness);}
#define inline
float computeShadowWithCSMPCSS32(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArray depthSampler,highp sampler2DArrayShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff,vec2 lightSizeUVCorrection,float depthCorrection,float penumbraDarkness)
{return computeShadowWithCSMPCSS(layer,vPositionFromLight,depthMetric,depthSampler,shadowSampler,shadowMapSizeInverse,lightSizeUV,darkness,frustumEdgeFalloff,16,32,PoissonSamplers32,lightSizeUVCorrection,depthCorrection,penumbraDarkness);}
#define inline
float computeShadowWithCSMPCSS64(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArray depthSampler,highp sampler2DArrayShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff,vec2 lightSizeUVCorrection,float depthCorrection,float penumbraDarkness)
{return computeShadowWithCSMPCSS(layer,vPositionFromLight,depthMetric,depthSampler,shadowSampler,shadowMapSizeInverse,lightSizeUV,darkness,frustumEdgeFalloff,32,64,PoissonSamplers64,lightSizeUVCorrection,depthCorrection,penumbraDarkness);}
#endif
#endif
`;
G.IncludesShadersStore[nu] = au;
const ou = "samplerFragmentDeclaration", lu = `#ifdef _DEFINENAME_
#if _DEFINENAME_DIRECTUV==1
#define v_VARYINGNAME_UV vMainUV1
#elif _DEFINENAME_DIRECTUV==2
#define v_VARYINGNAME_UV vMainUV2
#elif _DEFINENAME_DIRECTUV==3
#define v_VARYINGNAME_UV vMainUV3
#elif _DEFINENAME_DIRECTUV==4
#define v_VARYINGNAME_UV vMainUV4
#elif _DEFINENAME_DIRECTUV==5
#define v_VARYINGNAME_UV vMainUV5
#elif _DEFINENAME_DIRECTUV==6
#define v_VARYINGNAME_UV vMainUV6
#else
varying vec2 v_VARYINGNAME_UV;
#endif
uniform sampler2D _SAMPLERNAME_Sampler;
#endif
`;
G.IncludesShadersStore[ou] = lu;
const hu = "fresnelFunction", cu = `#ifdef FRESNEL
float computeFresnelTerm(vec3 viewDirection,vec3 worldNormal,float bias,float power)
{float fresnelTerm=pow(bias+abs(dot(viewDirection,worldNormal)),power);return clamp(fresnelTerm,0.,1.);}
#endif
`;
G.IncludesShadersStore[hu] = cu;
const uu = "reflectionFunction", du = `vec3 computeFixedEquirectangularCoords(vec4 worldPos,vec3 worldNormal,vec3 direction)
{float lon=atan(direction.z,direction.x);float lat=acos(direction.y);vec2 sphereCoords=vec2(lon,lat)*RECIPROCAL_PI2*2.0;float s=sphereCoords.x*0.5+0.5;float t=sphereCoords.y;return vec3(s,t,0); }
vec3 computeMirroredFixedEquirectangularCoords(vec4 worldPos,vec3 worldNormal,vec3 direction)
{float lon=atan(direction.z,direction.x);float lat=acos(direction.y);vec2 sphereCoords=vec2(lon,lat)*RECIPROCAL_PI2*2.0;float s=sphereCoords.x*0.5+0.5;float t=sphereCoords.y;return vec3(1.0-s,t,0); }
vec3 computeEquirectangularCoords(vec4 worldPos,vec3 worldNormal,vec3 eyePosition,mat4 reflectionMatrix)
{vec3 cameraToVertex=normalize(worldPos.xyz-eyePosition);vec3 r=normalize(reflect(cameraToVertex,worldNormal));r=vec3(reflectionMatrix*vec4(r,0));float lon=atan(r.z,r.x);float lat=acos(r.y);vec2 sphereCoords=vec2(lon,lat)*RECIPROCAL_PI2*2.0;float s=sphereCoords.x*0.5+0.5;float t=sphereCoords.y;return vec3(s,t,0);}
vec3 computeSphericalCoords(vec4 worldPos,vec3 worldNormal,mat4 view,mat4 reflectionMatrix)
{vec3 viewDir=normalize(vec3(view*worldPos));vec3 viewNormal=normalize(vec3(view*vec4(worldNormal,0.0)));vec3 r=reflect(viewDir,viewNormal);r=vec3(reflectionMatrix*vec4(r,0));r.z=r.z-1.0;float m=2.0*length(r);return vec3(r.x/m+0.5,1.0-r.y/m-0.5,0);}
vec3 computePlanarCoords(vec4 worldPos,vec3 worldNormal,vec3 eyePosition,mat4 reflectionMatrix)
{vec3 viewDir=worldPos.xyz-eyePosition;vec3 coords=normalize(reflect(viewDir,worldNormal));return vec3(reflectionMatrix*vec4(coords,1));}
vec3 computeCubicCoords(vec4 worldPos,vec3 worldNormal,vec3 eyePosition,mat4 reflectionMatrix)
{vec3 viewDir=normalize(worldPos.xyz-eyePosition);vec3 coords=reflect(viewDir,worldNormal);coords=vec3(reflectionMatrix*vec4(coords,0));
#ifdef INVERTCUBICMAP
coords.y*=-1.0;
#endif
return coords;}
vec3 computeCubicLocalCoords(vec4 worldPos,vec3 worldNormal,vec3 eyePosition,mat4 reflectionMatrix,vec3 reflectionSize,vec3 reflectionPosition)
{vec3 viewDir=normalize(worldPos.xyz-eyePosition);vec3 coords=reflect(viewDir,worldNormal);coords=parallaxCorrectNormal(worldPos.xyz,coords,reflectionSize,reflectionPosition);coords=vec3(reflectionMatrix*vec4(coords,0));
#ifdef INVERTCUBICMAP
coords.y*=-1.0;
#endif
return coords;}
vec3 computeProjectionCoords(vec4 worldPos,mat4 view,mat4 reflectionMatrix)
{return vec3(reflectionMatrix*(view*worldPos));}
vec3 computeSkyBoxCoords(vec3 positionW,mat4 reflectionMatrix)
{return vec3(reflectionMatrix*vec4(positionW,1.));}
#ifdef REFLECTION
vec3 computeReflectionCoords(vec4 worldPos,vec3 worldNormal)
{
#ifdef REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED
vec3 direction=normalize(vDirectionW);return computeMirroredFixedEquirectangularCoords(worldPos,worldNormal,direction);
#endif
#ifdef REFLECTIONMAP_EQUIRECTANGULAR_FIXED
vec3 direction=normalize(vDirectionW);return computeFixedEquirectangularCoords(worldPos,worldNormal,direction);
#endif
#ifdef REFLECTIONMAP_EQUIRECTANGULAR
return computeEquirectangularCoords(worldPos,worldNormal,vEyePosition.xyz,reflectionMatrix);
#endif
#ifdef REFLECTIONMAP_SPHERICAL
return computeSphericalCoords(worldPos,worldNormal,view,reflectionMatrix);
#endif
#ifdef REFLECTIONMAP_PLANAR
return computePlanarCoords(worldPos,worldNormal,vEyePosition.xyz,reflectionMatrix);
#endif
#ifdef REFLECTIONMAP_CUBIC
#ifdef USE_LOCAL_REFLECTIONMAP_CUBIC
return computeCubicLocalCoords(worldPos,worldNormal,vEyePosition.xyz,reflectionMatrix,vReflectionSize,vReflectionPosition);
#else
return computeCubicCoords(worldPos,worldNormal,vEyePosition.xyz,reflectionMatrix);
#endif
#endif
#ifdef REFLECTIONMAP_PROJECTION
return computeProjectionCoords(worldPos,view,reflectionMatrix);
#endif
#ifdef REFLECTIONMAP_SKYBOX
return computeSkyBoxCoords(vPositionUVW,reflectionMatrix);
#endif
#ifdef REFLECTIONMAP_EXPLICIT
return vec3(0,0,0);
#endif
}
#endif
`;
G.IncludesShadersStore[uu] = du;
const fu = "imageProcessingDeclaration", _u = `#ifdef EXPOSURE
uniform float exposureLinear;
#endif
#ifdef CONTRAST
uniform float contrast;
#endif
#if defined(VIGNETTE) || defined(DITHER)
uniform vec2 vInverseScreenSize;
#endif
#ifdef VIGNETTE
uniform vec4 vignetteSettings1;uniform vec4 vignetteSettings2;
#endif
#ifdef COLORCURVES
uniform vec4 vCameraColorCurveNegative;uniform vec4 vCameraColorCurveNeutral;uniform vec4 vCameraColorCurvePositive;
#endif
#ifdef COLORGRADING
#ifdef COLORGRADING3D
uniform highp sampler3D txColorTransform;
#else
uniform sampler2D txColorTransform;
#endif
uniform vec4 colorTransformSettings;
#endif
#ifdef DITHER
uniform float ditherIntensity;
#endif
`;
G.IncludesShadersStore[fu] = _u;
const pu = "imageProcessingFunctions", gu = `#if defined(COLORGRADING) && !defined(COLORGRADING3D)
/** 
* Polyfill for SAMPLE_TEXTURE_3D,which is unsupported in WebGL.
* sampler3dSetting.x=textureOffset (0.5/textureSize).
* sampler3dSetting.y=textureSize.
*/
#define inline
vec3 sampleTexture3D(sampler2D colorTransform,vec3 color,vec2 sampler3dSetting)
{float sliceSize=2.0*sampler3dSetting.x; 
#ifdef SAMPLER3DGREENDEPTH
float sliceContinuous=(color.g-sampler3dSetting.x)*sampler3dSetting.y;
#else
float sliceContinuous=(color.b-sampler3dSetting.x)*sampler3dSetting.y;
#endif
float sliceInteger=floor(sliceContinuous);float sliceFraction=sliceContinuous-sliceInteger;
#ifdef SAMPLER3DGREENDEPTH
vec2 sliceUV=color.rb;
#else
vec2 sliceUV=color.rg;
#endif
sliceUV.x*=sliceSize;sliceUV.x+=sliceInteger*sliceSize;sliceUV=saturate(sliceUV);vec4 slice0Color=texture2D(colorTransform,sliceUV);sliceUV.x+=sliceSize;sliceUV=saturate(sliceUV);vec4 slice1Color=texture2D(colorTransform,sliceUV);vec3 result=mix(slice0Color.rgb,slice1Color.rgb,sliceFraction);
#ifdef SAMPLER3DBGRMAP
color.rgb=result.rgb;
#else
color.rgb=result.bgr;
#endif
return color;}
#endif
#ifdef TONEMAPPING_ACES
const mat3 ACESInputMat=mat3(
vec3(0.59719,0.07600,0.02840),
vec3(0.35458,0.90834,0.13383),
vec3(0.04823,0.01566,0.83777)
);const mat3 ACESOutputMat=mat3(
vec3( 1.60475,-0.10208,-0.00327),
vec3(-0.53108, 1.10813,-0.07276),
vec3(-0.07367,-0.00605, 1.07602)
);vec3 RRTAndODTFit(vec3 v)
{vec3 a=v*(v+0.0245786)-0.000090537;vec3 b=v*(0.983729*v+0.4329510)+0.238081;return a/b;}
vec3 ACESFitted(vec3 color)
{color=ACESInputMat*color;color=RRTAndODTFit(color);color=ACESOutputMat*color;color=saturate(color);return color;}
#endif
#define CUSTOM_IMAGEPROCESSINGFUNCTIONS_DEFINITIONS
vec4 applyImageProcessing(vec4 result) {
#define CUSTOM_IMAGEPROCESSINGFUNCTIONS_UPDATERESULT_ATSTART
#ifdef EXPOSURE
result.rgb*=exposureLinear;
#endif
#ifdef VIGNETTE
vec2 viewportXY=gl_FragCoord.xy*vInverseScreenSize;viewportXY=viewportXY*2.0-1.0;vec3 vignetteXY1=vec3(viewportXY*vignetteSettings1.xy+vignetteSettings1.zw,1.0);float vignetteTerm=dot(vignetteXY1,vignetteXY1);float vignette=pow(vignetteTerm,vignetteSettings2.w);vec3 vignetteColor=vignetteSettings2.rgb;
#ifdef VIGNETTEBLENDMODEMULTIPLY
vec3 vignetteColorMultiplier=mix(vignetteColor,vec3(1,1,1),vignette);result.rgb*=vignetteColorMultiplier;
#endif
#ifdef VIGNETTEBLENDMODEOPAQUE
result.rgb=mix(vignetteColor,result.rgb,vignette);
#endif
#endif
#ifdef TONEMAPPING
#ifdef TONEMAPPING_ACES
result.rgb=ACESFitted(result.rgb);
#else
const float tonemappingCalibration=1.590579;result.rgb=1.0-exp2(-tonemappingCalibration*result.rgb);
#endif
#endif
result.rgb=toGammaSpace(result.rgb);result.rgb=saturate(result.rgb);
#ifdef CONTRAST
vec3 resultHighContrast=result.rgb*result.rgb*(3.0-2.0*result.rgb);if (contrast<1.0) {result.rgb=mix(vec3(0.5,0.5,0.5),result.rgb,contrast);} else {result.rgb=mix(result.rgb,resultHighContrast,contrast-1.0);}
#endif
#ifdef COLORGRADING
vec3 colorTransformInput=result.rgb*colorTransformSettings.xxx+colorTransformSettings.yyy;
#ifdef COLORGRADING3D
vec3 colorTransformOutput=texture(txColorTransform,colorTransformInput).rgb;
#else
vec3 colorTransformOutput=sampleTexture3D(txColorTransform,colorTransformInput,colorTransformSettings.yz).rgb;
#endif
result.rgb=mix(result.rgb,colorTransformOutput,colorTransformSettings.www);
#endif
#ifdef COLORCURVES
float luma=getLuminance(result.rgb);vec2 curveMix=clamp(vec2(luma*3.0-1.5,luma*-3.0+1.5),vec2(0.0),vec2(1.0));vec4 colorCurve=vCameraColorCurveNeutral+curveMix.x*vCameraColorCurvePositive-curveMix.y*vCameraColorCurveNegative;result.rgb*=colorCurve.rgb;result.rgb=mix(vec3(luma),result.rgb,colorCurve.a);
#endif
#ifdef DITHER
float rand=getRand(gl_FragCoord.xy*vInverseScreenSize);float dither=mix(-ditherIntensity,ditherIntensity,rand);result.rgb=saturate(result.rgb+vec3(dither));
#endif
#define CUSTOM_IMAGEPROCESSINGFUNCTIONS_UPDATERESULT_ATEND
return result;}`;
G.IncludesShadersStore[pu] = gu;
const mu = "bumpFragmentMainFunctions", yu = `#if defined(BUMP) || defined(CLEARCOAT_BUMP) || defined(ANISOTROPIC) || defined(DETAIL)
#if defined(TANGENT) && defined(NORMAL) 
varying mat3 vTBN;
#endif
#ifdef OBJECTSPACE_NORMALMAP
uniform mat4 normalMatrix;
#if defined(WEBGL2) || defined(WEBGPU)
mat4 toNormalMatrix(mat4 wMatrix)
{mat4 ret=inverse(wMatrix);ret=transpose(ret);ret[0][3]=0.;ret[1][3]=0.;ret[2][3]=0.;ret[3]=vec4(0.,0.,0.,1.);return ret;}
#else
mat4 toNormalMatrix(mat4 m)
{float
a00=m[0][0],a01=m[0][1],a02=m[0][2],a03=m[0][3],
a10=m[1][0],a11=m[1][1],a12=m[1][2],a13=m[1][3],
a20=m[2][0],a21=m[2][1],a22=m[2][2],a23=m[2][3],
a30=m[3][0],a31=m[3][1],a32=m[3][2],a33=m[3][3],
b00=a00*a11-a01*a10,
b01=a00*a12-a02*a10,
b02=a00*a13-a03*a10,
b03=a01*a12-a02*a11,
b04=a01*a13-a03*a11,
b05=a02*a13-a03*a12,
b06=a20*a31-a21*a30,
b07=a20*a32-a22*a30,
b08=a20*a33-a23*a30,
b09=a21*a32-a22*a31,
b10=a21*a33-a23*a31,
b11=a22*a33-a23*a32,
det=b00*b11-b01*b10+b02*b09+b03*b08-b04*b07+b05*b06;mat4 mi=mat4(
a11*b11-a12*b10+a13*b09,
a02*b10-a01*b11-a03*b09,
a31*b05-a32*b04+a33*b03,
a22*b04-a21*b05-a23*b03,
a12*b08-a10*b11-a13*b07,
a00*b11-a02*b08+a03*b07,
a32*b02-a30*b05-a33*b01,
a20*b05-a22*b02+a23*b01,
a10*b10-a11*b08+a13*b06,
a01*b08-a00*b10-a03*b06,
a30*b04-a31*b02+a33*b00,
a21*b02-a20*b04-a23*b00,
a11*b07-a10*b09-a12*b06,
a00*b09-a01*b07+a02*b06,
a31*b01-a30*b03-a32*b00,
a20*b03-a21*b01+a22*b00)/det;return mat4(mi[0][0],mi[1][0],mi[2][0],mi[3][0],
mi[0][1],mi[1][1],mi[2][1],mi[3][1],
mi[0][2],mi[1][2],mi[2][2],mi[3][2],
mi[0][3],mi[1][3],mi[2][3],mi[3][3]);}
#endif
#endif
vec3 perturbNormalBase(mat3 cotangentFrame,vec3 normal,float scale)
{
#ifdef NORMALXYSCALE
normal=normalize(normal*vec3(scale,scale,1.0));
#endif
return normalize(cotangentFrame*normal);}
vec3 perturbNormal(mat3 cotangentFrame,vec3 textureSample,float scale)
{return perturbNormalBase(cotangentFrame,textureSample*2.0-1.0,scale);}
mat3 cotangent_frame(vec3 normal,vec3 p,vec2 uv,vec2 tangentSpaceParams)
{vec3 dp1=dFdx(p);vec3 dp2=dFdy(p);vec2 duv1=dFdx(uv);vec2 duv2=dFdy(uv);vec3 dp2perp=cross(dp2,normal);vec3 dp1perp=cross(normal,dp1);vec3 tangent=dp2perp*duv1.x+dp1perp*duv2.x;vec3 bitangent=dp2perp*duv1.y+dp1perp*duv2.y;tangent*=tangentSpaceParams.x;bitangent*=tangentSpaceParams.y;float det=max(dot(tangent,tangent),dot(bitangent,bitangent));float invmax=det==0.0 ? 0.0 : inversesqrt(det);return mat3(tangent*invmax,bitangent*invmax,normal);}
#endif
`;
G.IncludesShadersStore[mu] = yu;
const vu = "bumpFragmentFunctions", xu = `#if defined(BUMP)
#include<samplerFragmentDeclaration>(_DEFINENAME_,BUMP,_VARYINGNAME_,Bump,_SAMPLERNAME_,bump)
#endif
#if defined(DETAIL)
#include<samplerFragmentDeclaration>(_DEFINENAME_,DETAIL,_VARYINGNAME_,Detail,_SAMPLERNAME_,detail)
#endif
#if defined(BUMP) && defined(PARALLAX)
const float minSamples=4.;const float maxSamples=15.;const int iMaxSamples=15;vec2 parallaxOcclusion(vec3 vViewDirCoT,vec3 vNormalCoT,vec2 texCoord,float parallaxScale) {float parallaxLimit=length(vViewDirCoT.xy)/vViewDirCoT.z;parallaxLimit*=parallaxScale;vec2 vOffsetDir=normalize(vViewDirCoT.xy);vec2 vMaxOffset=vOffsetDir*parallaxLimit;float numSamples=maxSamples+(dot(vViewDirCoT,vNormalCoT)*(minSamples-maxSamples));float stepSize=1.0/numSamples;float currRayHeight=1.0;vec2 vCurrOffset=vec2(0,0);vec2 vLastOffset=vec2(0,0);float lastSampledHeight=1.0;float currSampledHeight=1.0;bool keepWorking=true;for (int i=0; i<iMaxSamples; i++)
{currSampledHeight=texture2D(bumpSampler,texCoord+vCurrOffset).w;if (!keepWorking)
{}
else if (currSampledHeight>currRayHeight)
{float delta1=currSampledHeight-currRayHeight;float delta2=(currRayHeight+stepSize)-lastSampledHeight;float ratio=delta1/(delta1+delta2);vCurrOffset=(ratio)* vLastOffset+(1.0-ratio)*vCurrOffset;keepWorking=false;}
else
{currRayHeight-=stepSize;vLastOffset=vCurrOffset;vCurrOffset+=stepSize*vMaxOffset;lastSampledHeight=currSampledHeight;}}
return vCurrOffset;}
vec2 parallaxOffset(vec3 viewDir,float heightScale)
{float height=texture2D(bumpSampler,vBumpUV).w;vec2 texCoordOffset=heightScale*viewDir.xy*height;return -texCoordOffset;}
#endif
`;
G.IncludesShadersStore[vu] = xu;
const bu = "logDepthDeclaration", Tu = `#ifdef LOGARITHMICDEPTH
uniform float logarithmicDepthConstant;varying float vFragmentDepth;
#endif
`;
G.IncludesShadersStore[bu] = Tu;
const Au = "bumpFragment", Eu = `vec2 uvOffset=vec2(0.0,0.0);
#if defined(BUMP) || defined(PARALLAX) || defined(DETAIL)
#ifdef NORMALXYSCALE
float normalScale=1.0;
#elif defined(BUMP)
float normalScale=vBumpInfos.y;
#else
float normalScale=1.0;
#endif
#if defined(TANGENT) && defined(NORMAL)
mat3 TBN=vTBN;
#elif defined(BUMP)
vec2 TBNUV=gl_FrontFacing ? vBumpUV : -vBumpUV;mat3 TBN=cotangent_frame(normalW*normalScale,vPositionW,TBNUV,vTangentSpaceParams);
#else
vec2 TBNUV=gl_FrontFacing ? vDetailUV : -vDetailUV;mat3 TBN=cotangent_frame(normalW*normalScale,vPositionW,TBNUV,vec2(1.,1.));
#endif
#elif defined(ANISOTROPIC)
#if defined(TANGENT) && defined(NORMAL)
mat3 TBN=vTBN;
#else
vec2 TBNUV=gl_FrontFacing ? vMainUV1 : -vMainUV1;mat3 TBN=cotangent_frame(normalW,vPositionW,TBNUV,vec2(1.,1.));
#endif
#endif
#ifdef PARALLAX
mat3 invTBN=transposeMat3(TBN);
#ifdef PARALLAXOCCLUSION
uvOffset=parallaxOcclusion(invTBN*-viewDirectionW,invTBN*normalW,vBumpUV,vBumpInfos.z);
#else
uvOffset=parallaxOffset(invTBN*viewDirectionW,vBumpInfos.z);
#endif
#endif
#ifdef DETAIL
vec4 detailColor=texture2D(detailSampler,vDetailUV+uvOffset);vec2 detailNormalRG=detailColor.wy*2.0-1.0;float detailNormalB=sqrt(1.-saturate(dot(detailNormalRG,detailNormalRG)));vec3 detailNormal=vec3(detailNormalRG,detailNormalB);
#endif
#ifdef BUMP
#ifdef OBJECTSPACE_NORMALMAP
#define CUSTOM_FRAGMENT_BUMP_FRAGMENT
normalW=normalize(texture2D(bumpSampler,vBumpUV).xyz *2.0-1.0);normalW=normalize(mat3(normalMatrix)*normalW);
#elif !defined(DETAIL)
normalW=perturbNormal(TBN,texture2D(bumpSampler,vBumpUV+uvOffset).xyz,vBumpInfos.y);
#else
vec3 bumpNormal=texture2D(bumpSampler,vBumpUV+uvOffset).xyz*2.0-1.0;
#if DETAIL_NORMALBLENDMETHOD==0 
detailNormal.xy*=vDetailInfos.z;vec3 blendedNormal=normalize(vec3(bumpNormal.xy+detailNormal.xy,bumpNormal.z*detailNormal.z));
#elif DETAIL_NORMALBLENDMETHOD==1 
detailNormal.xy*=vDetailInfos.z;bumpNormal+=vec3(0.0,0.0,1.0);detailNormal*=vec3(-1.0,-1.0,1.0);vec3 blendedNormal=bumpNormal*dot(bumpNormal,detailNormal)/bumpNormal.z-detailNormal;
#endif
normalW=perturbNormalBase(TBN,blendedNormal,vBumpInfos.y);
#endif
#elif defined(DETAIL)
detailNormal.xy*=vDetailInfos.z;normalW=perturbNormalBase(TBN,detailNormal,vDetailInfos.z);
#endif
`;
G.IncludesShadersStore[Au] = Eu;
const Mu = "decalFragment", Su = `#ifdef DECAL
#ifdef GAMMADECAL
decalColor.rgb=toLinearSpace(decalColor.rgb);
#endif
#ifdef DECAL_SMOOTHALPHA
decalColor.a*=decalColor.a;
#endif
surfaceAlbedo.rgb=mix(surfaceAlbedo.rgb,decalColor.rgb,decalColor.a);
#endif
`;
G.IncludesShadersStore[Mu] = Su;
const Ru = "depthPrePass", Iu = `#ifdef DEPTHPREPASS
gl_FragColor=vec4(0.,0.,0.,1.0);return;
#endif
`;
G.IncludesShadersStore[Ru] = Iu;
const Pu = "lightFragment", Cu = `#ifdef LIGHT{X}
#if defined(SHADOWONLY) || defined(LIGHTMAP) && defined(LIGHTMAPEXCLUDED{X}) && defined(LIGHTMAPNOSPECULAR{X})
#else
#ifdef PBR
#ifdef SPOTLIGHT{X}
preInfo=computePointAndSpotPreLightingInfo(light{X}.vLightData,viewDirectionW,normalW);
#elif defined(POINTLIGHT{X})
preInfo=computePointAndSpotPreLightingInfo(light{X}.vLightData,viewDirectionW,normalW);
#elif defined(HEMILIGHT{X})
preInfo=computeHemisphericPreLightingInfo(light{X}.vLightData,viewDirectionW,normalW);
#elif defined(DIRLIGHT{X})
preInfo=computeDirectionalPreLightingInfo(light{X}.vLightData,viewDirectionW,normalW);
#endif
preInfo.NdotV=NdotV;
#ifdef SPOTLIGHT{X}
#ifdef LIGHT_FALLOFF_GLTF{X}
preInfo.attenuation=computeDistanceLightFalloff_GLTF(preInfo.lightDistanceSquared,light{X}.vLightFalloff.y);preInfo.attenuation*=computeDirectionalLightFalloff_GLTF(light{X}.vLightDirection.xyz,preInfo.L,light{X}.vLightFalloff.z,light{X}.vLightFalloff.w);
#elif defined(LIGHT_FALLOFF_PHYSICAL{X})
preInfo.attenuation=computeDistanceLightFalloff_Physical(preInfo.lightDistanceSquared);preInfo.attenuation*=computeDirectionalLightFalloff_Physical(light{X}.vLightDirection.xyz,preInfo.L,light{X}.vLightDirection.w);
#elif defined(LIGHT_FALLOFF_STANDARD{X})
preInfo.attenuation=computeDistanceLightFalloff_Standard(preInfo.lightOffset,light{X}.vLightFalloff.x);preInfo.attenuation*=computeDirectionalLightFalloff_Standard(light{X}.vLightDirection.xyz,preInfo.L,light{X}.vLightDirection.w,light{X}.vLightData.w);
#else
preInfo.attenuation=computeDistanceLightFalloff(preInfo.lightOffset,preInfo.lightDistanceSquared,light{X}.vLightFalloff.x,light{X}.vLightFalloff.y);preInfo.attenuation*=computeDirectionalLightFalloff(light{X}.vLightDirection.xyz,preInfo.L,light{X}.vLightDirection.w,light{X}.vLightData.w,light{X}.vLightFalloff.z,light{X}.vLightFalloff.w);
#endif
#elif defined(POINTLIGHT{X})
#ifdef LIGHT_FALLOFF_GLTF{X}
preInfo.attenuation=computeDistanceLightFalloff_GLTF(preInfo.lightDistanceSquared,light{X}.vLightFalloff.y);
#elif defined(LIGHT_FALLOFF_PHYSICAL{X})
preInfo.attenuation=computeDistanceLightFalloff_Physical(preInfo.lightDistanceSquared);
#elif defined(LIGHT_FALLOFF_STANDARD{X})
preInfo.attenuation=computeDistanceLightFalloff_Standard(preInfo.lightOffset,light{X}.vLightFalloff.x);
#else
preInfo.attenuation=computeDistanceLightFalloff(preInfo.lightOffset,preInfo.lightDistanceSquared,light{X}.vLightFalloff.x,light{X}.vLightFalloff.y);
#endif
#else
preInfo.attenuation=1.0;
#endif
#ifdef HEMILIGHT{X}
preInfo.roughness=roughness;
#else
preInfo.roughness=adjustRoughnessFromLightProperties(roughness,light{X}.vLightSpecular.a,preInfo.lightDistance);
#endif
#ifdef IRIDESCENCE
preInfo.iridescenceIntensity=iridescenceIntensity;
#endif
#ifdef HEMILIGHT{X}
info.diffuse=computeHemisphericDiffuseLighting(preInfo,light{X}.vLightDiffuse.rgb,light{X}.vLightGround);
#elif defined(SS_TRANSLUCENCY)
info.diffuse=computeDiffuseAndTransmittedLighting(preInfo,light{X}.vLightDiffuse.rgb,subSurfaceOut.transmittance);
#else
info.diffuse=computeDiffuseLighting(preInfo,light{X}.vLightDiffuse.rgb);
#endif
#ifdef SPECULARTERM
#ifdef ANISOTROPIC
info.specular=computeAnisotropicSpecularLighting(preInfo,viewDirectionW,normalW,anisotropicOut.anisotropicTangent,anisotropicOut.anisotropicBitangent,anisotropicOut.anisotropy,clearcoatOut.specularEnvironmentR0,specularEnvironmentR90,AARoughnessFactors.x,light{X}.vLightDiffuse.rgb);
#else
info.specular=computeSpecularLighting(preInfo,normalW,clearcoatOut.specularEnvironmentR0,specularEnvironmentR90,AARoughnessFactors.x,light{X}.vLightDiffuse.rgb);
#endif
#endif
#ifdef SHEEN
#ifdef SHEEN_LINKWITHALBEDO
preInfo.roughness=sheenOut.sheenIntensity;
#else
#ifdef HEMILIGHT{X}
preInfo.roughness=sheenOut.sheenRoughness;
#else
preInfo.roughness=adjustRoughnessFromLightProperties(sheenOut.sheenRoughness,light{X}.vLightSpecular.a,preInfo.lightDistance);
#endif
#endif
info.sheen=computeSheenLighting(preInfo,normalW,sheenOut.sheenColor,specularEnvironmentR90,AARoughnessFactors.x,light{X}.vLightDiffuse.rgb);
#endif
#ifdef CLEARCOAT
#ifdef HEMILIGHT{X}
preInfo.roughness=clearcoatOut.clearCoatRoughness;
#else
preInfo.roughness=adjustRoughnessFromLightProperties(clearcoatOut.clearCoatRoughness,light{X}.vLightSpecular.a,preInfo.lightDistance);
#endif
info.clearCoat=computeClearCoatLighting(preInfo,clearcoatOut.clearCoatNormalW,clearcoatOut.clearCoatAARoughnessFactors.x,clearcoatOut.clearCoatIntensity,light{X}.vLightDiffuse.rgb);
#ifdef CLEARCOAT_TINT
absorption=computeClearCoatLightingAbsorption(clearcoatOut.clearCoatNdotVRefract,preInfo.L,clearcoatOut.clearCoatNormalW,clearcoatOut.clearCoatColor,clearcoatOut.clearCoatThickness,clearcoatOut.clearCoatIntensity);info.diffuse*=absorption;
#ifdef SPECULARTERM
info.specular*=absorption;
#endif
#endif
info.diffuse*=info.clearCoat.w;
#ifdef SPECULARTERM
info.specular*=info.clearCoat.w;
#endif
#ifdef SHEEN
info.sheen*=info.clearCoat.w;
#endif
#endif
#else
#ifdef SPOTLIGHT{X}
info=computeSpotLighting(viewDirectionW,normalW,light{X}.vLightData,light{X}.vLightDirection,light{X}.vLightDiffuse.rgb,light{X}.vLightSpecular.rgb,light{X}.vLightDiffuse.a,glossiness);
#elif defined(HEMILIGHT{X})
info=computeHemisphericLighting(viewDirectionW,normalW,light{X}.vLightData,light{X}.vLightDiffuse.rgb,light{X}.vLightSpecular.rgb,light{X}.vLightGround,glossiness);
#elif defined(POINTLIGHT{X}) || defined(DIRLIGHT{X})
info=computeLighting(viewDirectionW,normalW,light{X}.vLightData,light{X}.vLightDiffuse.rgb,light{X}.vLightSpecular.rgb,light{X}.vLightDiffuse.a,glossiness);
#endif
#endif
#ifdef PROJECTEDLIGHTTEXTURE{X}
info.diffuse*=computeProjectionTextureDiffuseLighting(projectionLightSampler{X},textureProjectionMatrix{X});
#endif
#endif
#ifdef SHADOW{X}
#ifdef SHADOWCSM{X}
for (int i=0; i<SHADOWCSMNUM_CASCADES{X}; i++) 
{
#ifdef SHADOWCSM_RIGHTHANDED{X}
diff{X}=viewFrustumZ{X}[i]+vPositionFromCamera{X}.z;
#else
diff{X}=viewFrustumZ{X}[i]-vPositionFromCamera{X}.z;
#endif
if (diff{X}>=0.) {index{X}=i;break;}}
#ifdef SHADOWCSMUSESHADOWMAXZ{X}
if (index{X}>=0)
#endif
{
#if defined(SHADOWPCF{X})
#if defined(SHADOWLOWQUALITY{X})
shadow=computeShadowWithCSMPCF1(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#elif defined(SHADOWMEDIUMQUALITY{X})
shadow=computeShadowWithCSMPCF3(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowSampler{X},light{X}.shadowsInfo.yz,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#else
shadow=computeShadowWithCSMPCF5(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowSampler{X},light{X}.shadowsInfo.yz,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWPCSS{X})
#if defined(SHADOWLOWQUALITY{X})
shadow=computeShadowWithCSMPCSS16(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],depthSampler{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w,lightSizeUVCorrection{X}[index{X}],depthCorrection{X}[index{X}],penumbraDarkness{X});
#elif defined(SHADOWMEDIUMQUALITY{X})
shadow=computeShadowWithCSMPCSS32(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],depthSampler{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w,lightSizeUVCorrection{X}[index{X}],depthCorrection{X}[index{X}],penumbraDarkness{X});
#else
shadow=computeShadowWithCSMPCSS64(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],depthSampler{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w,lightSizeUVCorrection{X}[index{X}],depthCorrection{X}[index{X}],penumbraDarkness{X});
#endif
#else
shadow=computeShadowCSM(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
#ifdef SHADOWCSMDEBUG{X}
shadowDebug{X}=vec3(shadow)*vCascadeColorsMultiplier{X}[index{X}];
#endif
#ifndef SHADOWCSMNOBLEND{X}
float frustumLength=frustumLengths{X}[index{X}];float diffRatio=clamp(diff{X}/frustumLength,0.,1.)*cascadeBlendFactor{X};if (index{X}<(SHADOWCSMNUM_CASCADES{X}-1) && diffRatio<1.)
{index{X}+=1;float nextShadow=0.;
#if defined(SHADOWPCF{X})
#if defined(SHADOWLOWQUALITY{X})
nextShadow=computeShadowWithCSMPCF1(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#elif defined(SHADOWMEDIUMQUALITY{X})
nextShadow=computeShadowWithCSMPCF3(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowSampler{X},light{X}.shadowsInfo.yz,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#else
nextShadow=computeShadowWithCSMPCF5(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowSampler{X},light{X}.shadowsInfo.yz,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWPCSS{X})
#if defined(SHADOWLOWQUALITY{X})
nextShadow=computeShadowWithCSMPCSS16(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],depthSampler{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w,lightSizeUVCorrection{X}[index{X}],depthCorrection{X}[index{X}],penumbraDarkness{X});
#elif defined(SHADOWMEDIUMQUALITY{X})
nextShadow=computeShadowWithCSMPCSS32(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],depthSampler{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w,lightSizeUVCorrection{X}[index{X}],depthCorrection{X}[index{X}],penumbraDarkness{X});
#else
nextShadow=computeShadowWithCSMPCSS64(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],depthSampler{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w,lightSizeUVCorrection{X}[index{X}],depthCorrection{X}[index{X}],penumbraDarkness{X});
#endif
#else
nextShadow=computeShadowCSM(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
shadow=mix(nextShadow,shadow,diffRatio);
#ifdef SHADOWCSMDEBUG{X}
shadowDebug{X}=mix(vec3(nextShadow)*vCascadeColorsMultiplier{X}[index{X}],shadowDebug{X},diffRatio);
#endif
}
#endif
}
#elif defined(SHADOWCLOSEESM{X})
#if defined(SHADOWCUBE{X})
shadow=computeShadowWithCloseESMCube(light{X}.vLightData.xyz,shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.z,light{X}.depthValues);
#else
shadow=computeShadowWithCloseESM(vPositionFromLight{X},vDepthMetric{X},shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.z,light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWESM{X})
#if defined(SHADOWCUBE{X})
shadow=computeShadowWithESMCube(light{X}.vLightData.xyz,shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.z,light{X}.depthValues);
#else
shadow=computeShadowWithESM(vPositionFromLight{X},vDepthMetric{X},shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.z,light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWPOISSON{X})
#if defined(SHADOWCUBE{X})
shadow=computeShadowWithPoissonSamplingCube(light{X}.vLightData.xyz,shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.x,light{X}.depthValues);
#else
shadow=computeShadowWithPoissonSampling(vPositionFromLight{X},vDepthMetric{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWPCF{X})
#if defined(SHADOWLOWQUALITY{X})
shadow=computeShadowWithPCF1(vPositionFromLight{X},vDepthMetric{X},shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#elif defined(SHADOWMEDIUMQUALITY{X})
shadow=computeShadowWithPCF3(vPositionFromLight{X},vDepthMetric{X},shadowSampler{X},light{X}.shadowsInfo.yz,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#else
shadow=computeShadowWithPCF5(vPositionFromLight{X},vDepthMetric{X},shadowSampler{X},light{X}.shadowsInfo.yz,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWPCSS{X})
#if defined(SHADOWLOWQUALITY{X})
shadow=computeShadowWithPCSS16(vPositionFromLight{X},vDepthMetric{X},depthSampler{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#elif defined(SHADOWMEDIUMQUALITY{X})
shadow=computeShadowWithPCSS32(vPositionFromLight{X},vDepthMetric{X},depthSampler{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#else
shadow=computeShadowWithPCSS64(vPositionFromLight{X},vDepthMetric{X},depthSampler{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
#else
#if defined(SHADOWCUBE{X})
shadow=computeShadowCube(light{X}.vLightData.xyz,shadowSampler{X},light{X}.shadowsInfo.x,light{X}.depthValues);
#else
shadow=computeShadow(vPositionFromLight{X},vDepthMetric{X},shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
#endif
#ifdef SHADOWONLY
#ifndef SHADOWINUSE
#define SHADOWINUSE
#endif
globalShadow+=shadow;shadowLightCount+=1.0;
#endif
#else
shadow=1.;
#endif
#ifndef SHADOWONLY
#ifdef CUSTOMUSERLIGHTING
diffuseBase+=computeCustomDiffuseLighting(info,diffuseBase,shadow);
#ifdef SPECULARTERM
specularBase+=computeCustomSpecularLighting(info,specularBase,shadow);
#endif
#elif defined(LIGHTMAP) && defined(LIGHTMAPEXCLUDED{X})
diffuseBase+=lightmapColor.rgb*shadow;
#ifdef SPECULARTERM
#ifndef LIGHTMAPNOSPECULAR{X}
specularBase+=info.specular*shadow*lightmapColor.rgb;
#endif
#endif
#ifdef CLEARCOAT
#ifndef LIGHTMAPNOSPECULAR{X}
clearCoatBase+=info.clearCoat.rgb*shadow*lightmapColor.rgb;
#endif
#endif
#ifdef SHEEN
#ifndef LIGHTMAPNOSPECULAR{X}
sheenBase+=info.sheen.rgb*shadow;
#endif
#endif
#else
#ifdef SHADOWCSMDEBUG{X}
diffuseBase+=info.diffuse*shadowDebug{X};
#else 
diffuseBase+=info.diffuse*shadow;
#endif
#ifdef SPECULARTERM
specularBase+=info.specular*shadow;
#endif
#ifdef CLEARCOAT
clearCoatBase+=info.clearCoat.rgb*shadow;
#endif
#ifdef SHEEN
sheenBase+=info.sheen.rgb*shadow;
#endif
#endif
#endif
#endif
`;
G.IncludesShadersStore[Pu] = Cu;
const Du = "logDepthFragment", wu = `#ifdef LOGARITHMICDEPTH
gl_FragDepthEXT=log2(vFragmentDepth)*logarithmicDepthConstant*0.5;
#endif
`;
G.IncludesShadersStore[Du] = wu;
const Ou = "oitFragment", Fu = `#ifdef ORDER_INDEPENDENT_TRANSPARENCY
float fragDepth=gl_FragCoord.z; 
#ifdef ORDER_INDEPENDENT_TRANSPARENCY_16BITS
uint halfFloat=packHalf2x16(vec2(fragDepth));vec2 full=unpackHalf2x16(halfFloat);fragDepth=full.x;
#endif
ivec2 fragCoord=ivec2(gl_FragCoord.xy);vec2 lastDepth=texelFetch(oitDepthSampler,fragCoord,0).rg;vec4 lastFrontColor=texelFetch(oitFrontColorSampler,fragCoord,0);depth.rg=vec2(-MAX_DEPTH);frontColor=lastFrontColor;backColor=vec4(0.0);
#ifdef USE_REVERSE_DEPTHBUFFER
float furthestDepth=-lastDepth.x;float nearestDepth=lastDepth.y;
#else
float nearestDepth=-lastDepth.x;float furthestDepth=lastDepth.y;
#endif
float alphaMultiplier=1.0-lastFrontColor.a;
#ifdef USE_REVERSE_DEPTHBUFFER
if (fragDepth>nearestDepth || fragDepth<furthestDepth) {
#else
if (fragDepth<nearestDepth || fragDepth>furthestDepth) {
#endif
return;}
#ifdef USE_REVERSE_DEPTHBUFFER
if (fragDepth<nearestDepth && fragDepth>furthestDepth) {
#else
if (fragDepth>nearestDepth && fragDepth<furthestDepth) {
#endif
depth.rg=vec2(-fragDepth,fragDepth);return;}
#endif
`;
G.IncludesShadersStore[Ou] = Fu;
const Lu = "defaultPixelShader", Nu = `#include<__decl__defaultFragment>
#if defined(BUMP) || !defined(NORMAL)
#extension GL_OES_standard_derivatives : enable
#endif
#include<prePassDeclaration>[SCENE_MRT_COUNT]
#include<oitDeclaration>
#define CUSTOM_FRAGMENT_BEGIN
#ifdef LOGARITHMICDEPTH
#extension GL_EXT_frag_depth : enable
#endif
#define RECIPROCAL_PI2 0.15915494
varying vec3 vPositionW;
#ifdef NORMAL
varying vec3 vNormalW;
#endif
#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
varying vec4 vColor;
#endif
#include<mainUVVaryingDeclaration>[1..7]
#include<helperFunctions>
#include<__decl__lightFragment>[0..maxSimultaneousLights]
#include<lightsFragmentFunctions>
#include<shadowsFragmentFunctions>
#include<samplerFragmentDeclaration>(_DEFINENAME_,DIFFUSE,_VARYINGNAME_,Diffuse,_SAMPLERNAME_,diffuse)
#include<samplerFragmentDeclaration>(_DEFINENAME_,AMBIENT,_VARYINGNAME_,Ambient,_SAMPLERNAME_,ambient)
#include<samplerFragmentDeclaration>(_DEFINENAME_,OPACITY,_VARYINGNAME_,Opacity,_SAMPLERNAME_,opacity)
#include<samplerFragmentDeclaration>(_DEFINENAME_,EMISSIVE,_VARYINGNAME_,Emissive,_SAMPLERNAME_,emissive)
#include<samplerFragmentDeclaration>(_DEFINENAME_,LIGHTMAP,_VARYINGNAME_,Lightmap,_SAMPLERNAME_,lightmap)
#include<samplerFragmentDeclaration>(_DEFINENAME_,DECAL,_VARYINGNAME_,Decal,_SAMPLERNAME_,decal)
#ifdef REFRACTION
#ifdef REFRACTIONMAP_3D
uniform samplerCube refractionCubeSampler;
#else
uniform sampler2D refraction2DSampler;
#endif
#endif
#if defined(SPECULARTERM)
#include<samplerFragmentDeclaration>(_DEFINENAME_,SPECULAR,_VARYINGNAME_,Specular,_SAMPLERNAME_,specular)
#endif
#include<fresnelFunction>
#ifdef REFLECTION
#ifdef REFLECTIONMAP_3D
uniform samplerCube reflectionCubeSampler;
#else
uniform sampler2D reflection2DSampler;
#endif
#ifdef REFLECTIONMAP_SKYBOX
varying vec3 vPositionUVW;
#else
#if defined(REFLECTIONMAP_EQUIRECTANGULAR_FIXED) || defined(REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED)
varying vec3 vDirectionW;
#endif
#endif
#include<reflectionFunction>
#endif
#include<imageProcessingDeclaration>
#include<imageProcessingFunctions>
#include<bumpFragmentMainFunctions>
#include<bumpFragmentFunctions>
#include<clipPlaneFragmentDeclaration>
#include<logDepthDeclaration>
#include<fogFragmentDeclaration>
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
#include<clipPlaneFragment>
vec3 viewDirectionW=normalize(vEyePosition.xyz-vPositionW);vec4 baseColor=vec4(1.,1.,1.,1.);vec3 diffuseColor=vDiffuseColor.rgb;float alpha=vDiffuseColor.a;
#ifdef NORMAL
vec3 normalW=normalize(vNormalW);
#else
vec3 normalW=normalize(-cross(dFdx(vPositionW),dFdy(vPositionW)));
#endif
#include<bumpFragment>
#ifdef TWOSIDEDLIGHTING
normalW=gl_FrontFacing ? normalW : -normalW;
#endif
#ifdef DIFFUSE
baseColor=texture2D(diffuseSampler,vDiffuseUV+uvOffset);
#if defined(ALPHATEST) && !defined(ALPHATEST_AFTERALLALPHACOMPUTATIONS)
if (baseColor.a<alphaCutOff)
discard;
#endif
#ifdef ALPHAFROMDIFFUSE
alpha*=baseColor.a;
#endif
#define CUSTOM_FRAGMENT_UPDATE_ALPHA
baseColor.rgb*=vDiffuseInfos.y;
#endif
#if defined(DECAL) && !defined(DECAL_AFTER_DETAIL)
vec4 decalColor=texture2D(decalSampler,vDecalUV+uvOffset);
#include<decalFragment>(surfaceAlbedo,baseColor,GAMMADECAL,_GAMMADECAL_NOTUSED_)
#endif
#include<depthPrePass>
#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
baseColor.rgb*=vColor.rgb;
#endif
#ifdef DETAIL
baseColor.rgb=baseColor.rgb*2.0*mix(0.5,detailColor.r,vDetailInfos.y);
#endif
#if defined(DECAL) && defined(DECAL_AFTER_DETAIL)
vec4 decalColor=texture2D(decalSampler,vDecalUV+uvOffset);
#include<decalFragment>(surfaceAlbedo,baseColor,GAMMADECAL,_GAMMADECAL_NOTUSED_)
#endif
#define CUSTOM_FRAGMENT_UPDATE_DIFFUSE
vec3 baseAmbientColor=vec3(1.,1.,1.);
#ifdef AMBIENT
baseAmbientColor=texture2D(ambientSampler,vAmbientUV+uvOffset).rgb*vAmbientInfos.y;
#endif
#define CUSTOM_FRAGMENT_BEFORE_LIGHTS
#ifdef SPECULARTERM
float glossiness=vSpecularColor.a;vec3 specularColor=vSpecularColor.rgb;
#ifdef SPECULAR
vec4 specularMapColor=texture2D(specularSampler,vSpecularUV+uvOffset);specularColor=specularMapColor.rgb;
#ifdef GLOSSINESS
glossiness=glossiness*specularMapColor.a;
#endif
#endif
#else
float glossiness=0.;
#endif
vec3 diffuseBase=vec3(0.,0.,0.);lightingInfo info;
#ifdef SPECULARTERM
vec3 specularBase=vec3(0.,0.,0.);
#endif
float shadow=1.;
#ifdef LIGHTMAP
vec4 lightmapColor=texture2D(lightmapSampler,vLightmapUV+uvOffset);
#ifdef RGBDLIGHTMAP
lightmapColor.rgb=fromRGBD(lightmapColor);
#endif
lightmapColor.rgb*=vLightmapInfos.y;
#endif
#include<lightFragment>[0..maxSimultaneousLights]
vec4 refractionColor=vec4(0.,0.,0.,1.);
#ifdef REFRACTION
vec3 refractionVector=normalize(refract(-viewDirectionW,normalW,vRefractionInfos.y));
#ifdef REFRACTIONMAP_3D
#ifdef USE_LOCAL_REFRACTIONMAP_CUBIC
refractionVector=parallaxCorrectNormal(vPositionW,refractionVector,vRefractionSize,vRefractionPosition);
#endif
refractionVector.y=refractionVector.y*vRefractionInfos.w;vec4 refractionLookup=textureCube(refractionCubeSampler,refractionVector);if (dot(refractionVector,viewDirectionW)<1.0) {refractionColor=refractionLookup;}
#else
vec3 vRefractionUVW=vec3(refractionMatrix*(view*vec4(vPositionW+refractionVector*vRefractionInfos.z,1.0)));vec2 refractionCoords=vRefractionUVW.xy/vRefractionUVW.z;refractionCoords.y=1.0-refractionCoords.y;refractionColor=texture2D(refraction2DSampler,refractionCoords);
#endif
#ifdef RGBDREFRACTION
refractionColor.rgb=fromRGBD(refractionColor);
#endif
#ifdef IS_REFRACTION_LINEAR
refractionColor.rgb=toGammaSpace(refractionColor.rgb);
#endif
refractionColor.rgb*=vRefractionInfos.x;
#endif
vec4 reflectionColor=vec4(0.,0.,0.,1.);
#ifdef REFLECTION
vec3 vReflectionUVW=computeReflectionCoords(vec4(vPositionW,1.0),normalW);
#ifdef REFLECTIONMAP_OPPOSITEZ
vReflectionUVW.z*=-1.0;
#endif
#ifdef REFLECTIONMAP_3D
#ifdef ROUGHNESS
float bias=vReflectionInfos.y;
#ifdef SPECULARTERM
#ifdef SPECULAR
#ifdef GLOSSINESS
bias*=(1.0-specularMapColor.a);
#endif
#endif
#endif
reflectionColor=textureCube(reflectionCubeSampler,vReflectionUVW,bias);
#else
reflectionColor=textureCube(reflectionCubeSampler,vReflectionUVW);
#endif
#else
vec2 coords=vReflectionUVW.xy;
#ifdef REFLECTIONMAP_PROJECTION
coords/=vReflectionUVW.z;
#endif
coords.y=1.0-coords.y;reflectionColor=texture2D(reflection2DSampler,coords);
#endif
#ifdef RGBDREFLECTION
reflectionColor.rgb=fromRGBD(reflectionColor);
#endif
#ifdef IS_REFLECTION_LINEAR
reflectionColor.rgb=toGammaSpace(reflectionColor.rgb);
#endif
reflectionColor.rgb*=vReflectionInfos.x;
#ifdef REFLECTIONFRESNEL
float reflectionFresnelTerm=computeFresnelTerm(viewDirectionW,normalW,reflectionRightColor.a,reflectionLeftColor.a);
#ifdef REFLECTIONFRESNELFROMSPECULAR
#ifdef SPECULARTERM
reflectionColor.rgb*=specularColor.rgb*(1.0-reflectionFresnelTerm)+reflectionFresnelTerm*reflectionRightColor.rgb;
#else
reflectionColor.rgb*=reflectionLeftColor.rgb*(1.0-reflectionFresnelTerm)+reflectionFresnelTerm*reflectionRightColor.rgb;
#endif
#else
reflectionColor.rgb*=reflectionLeftColor.rgb*(1.0-reflectionFresnelTerm)+reflectionFresnelTerm*reflectionRightColor.rgb;
#endif
#endif
#endif
#ifdef REFRACTIONFRESNEL
float refractionFresnelTerm=computeFresnelTerm(viewDirectionW,normalW,refractionRightColor.a,refractionLeftColor.a);refractionColor.rgb*=refractionLeftColor.rgb*(1.0-refractionFresnelTerm)+refractionFresnelTerm*refractionRightColor.rgb;
#endif
#ifdef OPACITY
vec4 opacityMap=texture2D(opacitySampler,vOpacityUV+uvOffset);
#ifdef OPACITYRGB
opacityMap.rgb=opacityMap.rgb*vec3(0.3,0.59,0.11);alpha*=(opacityMap.x+opacityMap.y+opacityMap.z)* vOpacityInfos.y;
#else
alpha*=opacityMap.a*vOpacityInfos.y;
#endif
#endif
#if defined(VERTEXALPHA) || defined(INSTANCESCOLOR) && defined(INSTANCES)
alpha*=vColor.a;
#endif
#ifdef OPACITYFRESNEL
float opacityFresnelTerm=computeFresnelTerm(viewDirectionW,normalW,opacityParts.z,opacityParts.w);alpha+=opacityParts.x*(1.0-opacityFresnelTerm)+opacityFresnelTerm*opacityParts.y;
#endif
#ifdef ALPHATEST
#ifdef ALPHATEST_AFTERALLALPHACOMPUTATIONS
if (alpha<alphaCutOff)
discard;
#endif
#ifndef ALPHABLEND
alpha=1.0;
#endif
#endif
vec3 emissiveColor=vEmissiveColor;
#ifdef EMISSIVE
emissiveColor+=texture2D(emissiveSampler,vEmissiveUV+uvOffset).rgb*vEmissiveInfos.y;
#endif
#ifdef EMISSIVEFRESNEL
float emissiveFresnelTerm=computeFresnelTerm(viewDirectionW,normalW,emissiveRightColor.a,emissiveLeftColor.a);emissiveColor*=emissiveLeftColor.rgb*(1.0-emissiveFresnelTerm)+emissiveFresnelTerm*emissiveRightColor.rgb;
#endif
#ifdef DIFFUSEFRESNEL
float diffuseFresnelTerm=computeFresnelTerm(viewDirectionW,normalW,diffuseRightColor.a,diffuseLeftColor.a);diffuseBase*=diffuseLeftColor.rgb*(1.0-diffuseFresnelTerm)+diffuseFresnelTerm*diffuseRightColor.rgb;
#endif
#ifdef EMISSIVEASILLUMINATION
vec3 finalDiffuse=clamp(diffuseBase*diffuseColor+vAmbientColor,0.0,1.0)*baseColor.rgb;
#else
#ifdef LINKEMISSIVEWITHDIFFUSE
vec3 finalDiffuse=clamp((diffuseBase+emissiveColor)*diffuseColor+vAmbientColor,0.0,1.0)*baseColor.rgb;
#else
vec3 finalDiffuse=clamp(diffuseBase*diffuseColor+emissiveColor+vAmbientColor,0.0,1.0)*baseColor.rgb;
#endif
#endif
#ifdef SPECULARTERM
vec3 finalSpecular=specularBase*specularColor;
#ifdef SPECULAROVERALPHA
alpha=clamp(alpha+dot(finalSpecular,vec3(0.3,0.59,0.11)),0.,1.);
#endif
#else
vec3 finalSpecular=vec3(0.0);
#endif
#ifdef REFLECTIONOVERALPHA
alpha=clamp(alpha+dot(reflectionColor.rgb,vec3(0.3,0.59,0.11)),0.,1.);
#endif
#ifdef EMISSIVEASILLUMINATION
vec4 color=vec4(clamp(finalDiffuse*baseAmbientColor+finalSpecular+reflectionColor.rgb+emissiveColor+refractionColor.rgb,0.0,1.0),alpha);
#else
vec4 color=vec4(finalDiffuse*baseAmbientColor+finalSpecular+reflectionColor.rgb+refractionColor.rgb,alpha);
#endif
#ifdef LIGHTMAP
#ifndef LIGHTMAPEXCLUDED
#ifdef USELIGHTMAPASSHADOWMAP
color.rgb*=lightmapColor.rgb;
#else
color.rgb+=lightmapColor.rgb;
#endif
#endif
#endif
#define CUSTOM_FRAGMENT_BEFORE_FOG
color.rgb=max(color.rgb,0.);
#include<logDepthFragment>
#include<fogFragment>
#ifdef IMAGEPROCESSINGPOSTPROCESS
color.rgb=toLinearSpace(color.rgb);
#else
#ifdef IMAGEPROCESSING
color.rgb=toLinearSpace(color.rgb);color=applyImageProcessing(color);
#endif
#endif
color.a*=visibility;
#ifdef PREMULTIPLYALPHA
color.rgb*=color.a;
#endif
#define CUSTOM_FRAGMENT_BEFORE_FRAGCOLOR
#ifdef PREPASS
float writeGeometryInfo=color.a>0.4 ? 1.0 : 0.0;gl_FragData[0]=color; 
#ifdef PREPASS_POSITION
gl_FragData[PREPASS_POSITION_INDEX]=vec4(vPositionW,writeGeometryInfo);
#endif
#ifdef PREPASS_VELOCITY
vec2 a=(vCurrentPosition.xy/vCurrentPosition.w)*0.5+0.5;vec2 b=(vPreviousPosition.xy/vPreviousPosition.w)*0.5+0.5;vec2 velocity=abs(a-b);velocity=vec2(pow(velocity.x,1.0/3.0),pow(velocity.y,1.0/3.0))*sign(a-b)*0.5+0.5;gl_FragData[PREPASS_VELOCITY_INDEX]=vec4(velocity,0.0,writeGeometryInfo);
#endif
#ifdef PREPASS_IRRADIANCE
gl_FragData[PREPASS_IRRADIANCE_INDEX]=vec4(0.0,0.0,0.0,writeGeometryInfo); 
#endif
#ifdef PREPASS_DEPTH
gl_FragData[PREPASS_DEPTH_INDEX]=vec4(vViewPos.z,0.0,0.0,writeGeometryInfo); 
#endif
#ifdef PREPASS_NORMAL
gl_FragData[PREPASS_NORMAL_INDEX]=vec4(normalize((view*vec4(normalW,0.0)).rgb),writeGeometryInfo); 
#endif
#ifdef PREPASS_ALBEDO_SQRT
gl_FragData[PREPASS_ALBEDO_SQRT_INDEX]=vec4(0.0,0.0,0.0,writeGeometryInfo); 
#endif
#ifdef PREPASS_REFLECTIVITY
#if defined(SPECULARTERM)
#if defined(SPECULAR)
gl_FragData[PREPASS_REFLECTIVITY_INDEX]=vec4(toLinearSpace(specularMapColor))*writeGeometryInfo; 
#else
gl_FragData[PREPASS_REFLECTIVITY_INDEX]=vec4(toLinearSpace(specularColor),1.0)*writeGeometryInfo;
#endif
#else
gl_FragData[PREPASS_REFLECTIVITY_INDEX]=vec4(0.0,0.0,0.0,1.0)*writeGeometryInfo;
#endif
#endif
#endif
#if !defined(PREPASS) || defined(WEBGL2)
gl_FragColor=color;
#endif
#include<oitFragment>
#if ORDER_INDEPENDENT_TRANSPARENCY
if (fragDepth==nearestDepth) {frontColor.rgb+=color.rgb*color.a*alphaMultiplier;frontColor.a=1.0-alphaMultiplier*(1.0-color.a);} else {backColor+=color;}
#endif
#define CUSTOM_FRAGMENT_MAIN_END
}
`;
G.ShadersStore[Lu] = Nu;
const Bu = "decalVertexDeclaration", Uu = `#ifdef DECAL
uniform vec4 vDecalInfos;uniform mat4 decalMatrix;
#endif
`;
G.IncludesShadersStore[Bu] = Uu;
const ku = "defaultVertexDeclaration", Vu = `uniform mat4 viewProjection;uniform mat4 view;
#ifdef DIFFUSE
uniform mat4 diffuseMatrix;uniform vec2 vDiffuseInfos;
#endif
#ifdef AMBIENT
uniform mat4 ambientMatrix;uniform vec2 vAmbientInfos;
#endif
#ifdef OPACITY
uniform mat4 opacityMatrix;uniform vec2 vOpacityInfos;
#endif
#ifdef EMISSIVE
uniform vec2 vEmissiveInfos;uniform mat4 emissiveMatrix;
#endif
#ifdef LIGHTMAP
uniform vec2 vLightmapInfos;uniform mat4 lightmapMatrix;
#endif
#if defined(SPECULAR) && defined(SPECULARTERM)
uniform vec2 vSpecularInfos;uniform mat4 specularMatrix;
#endif
#ifdef BUMP
uniform vec3 vBumpInfos;uniform mat4 bumpMatrix;
#endif
#ifdef REFLECTION
uniform mat4 reflectionMatrix;
#endif
#ifdef POINTSIZE
uniform float pointSize;
#endif
#ifdef DETAIL
uniform vec4 vDetailInfos;uniform mat4 detailMatrix;
#endif
#include<decalVertexDeclaration>
#define ADDITIONAL_VERTEX_DECLARATION
`;
G.IncludesShadersStore[ku] = Vu;
const Wu = "uvAttributeDeclaration", zu = `#ifdef UV{X}
attribute vec2 uv{X};
#endif
`;
G.IncludesShadersStore[Wu] = zu;
const Gu = "prePassVertexDeclaration", Xu = `#ifdef PREPASS
#ifdef PREPASS_DEPTH
varying vec3 vViewPos;
#endif
#ifdef PREPASS_VELOCITY
uniform mat4 previousViewProjection;varying vec4 vCurrentPosition;varying vec4 vPreviousPosition;
#endif
#endif
`;
G.IncludesShadersStore[Gu] = Xu;
const Hu = "samplerVertexDeclaration", Ku = `#if defined(_DEFINENAME_) && _DEFINENAME_DIRECTUV==0
varying vec2 v_VARYINGNAME_UV;
#endif
`;
G.IncludesShadersStore[Hu] = Ku;
const Yu = "bumpVertexDeclaration", qu = `#if defined(BUMP) || defined(PARALLAX) || defined(CLEARCOAT_BUMP) || defined(ANISOTROPIC)
#if defined(TANGENT) && defined(NORMAL) 
varying mat3 vTBN;
#endif
#endif
`;
G.IncludesShadersStore[Yu] = qu;
const ju = "lightVxFragmentDeclaration", Zu = `#ifdef LIGHT{X}
uniform vec4 vLightData{X};uniform vec4 vLightDiffuse{X};
#ifdef SPECULARTERM
uniform vec4 vLightSpecular{X};
#else
vec4 vLightSpecular{X}=vec4(0.);
#endif
#ifdef SHADOW{X}
#ifdef SHADOWCSM{X}
uniform mat4 lightMatrix{X}[SHADOWCSMNUM_CASCADES{X}];varying vec4 vPositionFromLight{X}[SHADOWCSMNUM_CASCADES{X}];varying float vDepthMetric{X}[SHADOWCSMNUM_CASCADES{X}];varying vec4 vPositionFromCamera{X};
#elif defined(SHADOWCUBE{X})
#else
varying vec4 vPositionFromLight{X};varying float vDepthMetric{X};uniform mat4 lightMatrix{X};
#endif
uniform vec4 shadowsInfo{X};uniform vec2 depthValues{X};
#endif
#ifdef SPOTLIGHT{X}
uniform vec4 vLightDirection{X};uniform vec4 vLightFalloff{X};
#elif defined(POINTLIGHT{X})
uniform vec4 vLightFalloff{X};
#elif defined(HEMILIGHT{X})
uniform vec3 vLightGround{X};
#endif
#endif
`;
G.IncludesShadersStore[ju] = Zu;
const Qu = "lightVxUboDeclaration", $u = `#ifdef LIGHT{X}
uniform Light{X}
{vec4 vLightData;vec4 vLightDiffuse;vec4 vLightSpecular;
#ifdef SPOTLIGHT{X}
vec4 vLightDirection;vec4 vLightFalloff;
#elif defined(POINTLIGHT{X})
vec4 vLightFalloff;
#elif defined(HEMILIGHT{X})
vec3 vLightGround;
#endif
vec4 shadowsInfo;vec2 depthValues;} light{X};
#ifdef SHADOW{X}
#ifdef SHADOWCSM{X}
uniform mat4 lightMatrix{X}[SHADOWCSMNUM_CASCADES{X}];varying vec4 vPositionFromLight{X}[SHADOWCSMNUM_CASCADES{X}];varying float vDepthMetric{X}[SHADOWCSMNUM_CASCADES{X}];varying vec4 vPositionFromCamera{X};
#elif defined(SHADOWCUBE{X})
#else
varying vec4 vPositionFromLight{X};varying float vDepthMetric{X};uniform mat4 lightMatrix{X};
#endif
#endif
#endif
`;
G.IncludesShadersStore[Qu] = $u;
const Ju = "morphTargetsVertexGlobalDeclaration", ed = `#ifdef MORPHTARGETS
uniform float morphTargetInfluences[NUM_MORPH_INFLUENCERS];
#ifdef MORPHTARGETS_TEXTURE 
precision mediump sampler2DArray; 
uniform float morphTargetTextureIndices[NUM_MORPH_INFLUENCERS];uniform vec3 morphTargetTextureInfo;uniform sampler2DArray morphTargets;vec3 readVector3FromRawSampler(int targetIndex,float vertexIndex)
{ 
float y=floor(vertexIndex/morphTargetTextureInfo.y);float x=vertexIndex-y*morphTargetTextureInfo.y;vec3 textureUV=vec3((x+0.5)/morphTargetTextureInfo.y,(y+0.5)/morphTargetTextureInfo.z,morphTargetTextureIndices[targetIndex]);return texture(morphTargets,textureUV).xyz;}
#endif
#endif
`;
G.IncludesShadersStore[Ju] = ed;
const td = "morphTargetsVertexDeclaration", id = `#ifdef MORPHTARGETS
#ifndef MORPHTARGETS_TEXTURE
attribute vec3 position{X};
#ifdef MORPHTARGETS_NORMAL
attribute vec3 normal{X};
#endif
#ifdef MORPHTARGETS_TANGENT
attribute vec3 tangent{X};
#endif
#ifdef MORPHTARGETS_UV
attribute vec2 uv_{X};
#endif
#endif
#endif
`;
G.IncludesShadersStore[td] = id;
const sd = "morphTargetsVertexGlobal", rd = `#ifdef MORPHTARGETS
#ifdef MORPHTARGETS_TEXTURE
float vertexID;
#endif
#endif
`;
G.IncludesShadersStore[sd] = rd;
const nd = "morphTargetsVertex", ad = `#ifdef MORPHTARGETS
#ifdef MORPHTARGETS_TEXTURE 
vertexID=float(gl_VertexID)*morphTargetTextureInfo.x;positionUpdated+=(readVector3FromRawSampler({X},vertexID)-position)*morphTargetInfluences[{X}];vertexID+=1.0;
#ifdef MORPHTARGETS_NORMAL
normalUpdated+=(readVector3FromRawSampler({X},vertexID) -normal)*morphTargetInfluences[{X}];vertexID+=1.0;
#endif
#ifdef MORPHTARGETS_UV
uvUpdated+=(readVector3FromRawSampler({X},vertexID).xy-uv)*morphTargetInfluences[{X}];vertexID+=1.0;
#endif
#ifdef MORPHTARGETS_TANGENT
tangentUpdated.xyz+=(readVector3FromRawSampler({X},vertexID) -tangent.xyz)*morphTargetInfluences[{X}];
#endif
#else
positionUpdated+=(position{X}-position)*morphTargetInfluences[{X}];
#ifdef MORPHTARGETS_NORMAL
normalUpdated+=(normal{X}-normal)*morphTargetInfluences[{X}];
#endif
#ifdef MORPHTARGETS_TANGENT
tangentUpdated.xyz+=(tangent{X}-tangent.xyz)*morphTargetInfluences[{X}];
#endif
#ifdef MORPHTARGETS_UV
uvUpdated+=(uv_{X}-uv)*morphTargetInfluences[{X}];
#endif
#endif
#endif
`;
G.IncludesShadersStore[nd] = ad;
const od = "prePassVertex", ld = `#ifdef PREPASS_DEPTH
vViewPos=(view*worldPos).rgb;
#endif
#if defined(PREPASS_VELOCITY) && defined(BONES_VELOCITY_ENABLED)
vCurrentPosition=viewProjection*worldPos;
#if NUM_BONE_INFLUENCERS>0
mat4 previousInfluence;previousInfluence=mPreviousBones[int(matricesIndices[0])]*matricesWeights[0];
#if NUM_BONE_INFLUENCERS>1
previousInfluence+=mPreviousBones[int(matricesIndices[1])]*matricesWeights[1];
#endif 
#if NUM_BONE_INFLUENCERS>2
previousInfluence+=mPreviousBones[int(matricesIndices[2])]*matricesWeights[2];
#endif 
#if NUM_BONE_INFLUENCERS>3
previousInfluence+=mPreviousBones[int(matricesIndices[3])]*matricesWeights[3];
#endif
#if NUM_BONE_INFLUENCERS>4
previousInfluence+=mPreviousBones[int(matricesIndicesExtra[0])]*matricesWeightsExtra[0];
#endif 
#if NUM_BONE_INFLUENCERS>5
previousInfluence+=mPreviousBones[int(matricesIndicesExtra[1])]*matricesWeightsExtra[1];
#endif 
#if NUM_BONE_INFLUENCERS>6
previousInfluence+=mPreviousBones[int(matricesIndicesExtra[2])]*matricesWeightsExtra[2];
#endif 
#if NUM_BONE_INFLUENCERS>7
previousInfluence+=mPreviousBones[int(matricesIndicesExtra[3])]*matricesWeightsExtra[3];
#endif
vPreviousPosition=previousViewProjection*finalPreviousWorld*previousInfluence*vec4(positionUpdated,1.0);
#else
vPreviousPosition=previousViewProjection*finalPreviousWorld*vec4(positionUpdated,1.0);
#endif
#endif
`;
G.IncludesShadersStore[od] = ld;
const hd = "uvVariableDeclaration", cd = `#if !defined(UV{X}) && defined(MAINUV{X})
vec2 uv{X}=vec2(0.,0.);
#endif
#ifdef MAINUV{X}
vMainUV{X}=uv{X};
#endif
`;
G.IncludesShadersStore[hd] = cd;
const ud = "samplerVertexImplementation", dd = `#if defined(_DEFINENAME_) && _DEFINENAME_DIRECTUV==0
if (v_INFONAME_==0.)
{v_VARYINGNAME_UV=vec2(_MATRIXNAME_Matrix*vec4(uvUpdated,1.0,0.0));}
#ifdef UV2
else if (v_INFONAME_==1.)
{v_VARYINGNAME_UV=vec2(_MATRIXNAME_Matrix*vec4(uv2,1.0,0.0));}
#endif
#ifdef UV3
else if (v_INFONAME_==2.)
{v_VARYINGNAME_UV=vec2(_MATRIXNAME_Matrix*vec4(uv3,1.0,0.0));}
#endif
#ifdef UV4
else if (v_INFONAME_==3.)
{v_VARYINGNAME_UV=vec2(_MATRIXNAME_Matrix*vec4(uv4,1.0,0.0));}
#endif
#ifdef UV5
else if (v_INFONAME_==4.)
{v_VARYINGNAME_UV=vec2(_MATRIXNAME_Matrix*vec4(uv5,1.0,0.0));}
#endif
#ifdef UV6
else if (v_INFONAME_==5.)
{v_VARYINGNAME_UV=vec2(_MATRIXNAME_Matrix*vec4(uv6,1.0,0.0));}
#endif
#endif
`;
G.IncludesShadersStore[ud] = dd;
const fd = "bumpVertex", _d = `#if defined(BUMP) || defined(PARALLAX) || defined(CLEARCOAT_BUMP) || defined(ANISOTROPIC)
#if defined(TANGENT) && defined(NORMAL)
vec3 tbnNormal=normalize(normalUpdated);vec3 tbnTangent=normalize(tangentUpdated.xyz);vec3 tbnBitangent=cross(tbnNormal,tbnTangent)*tangentUpdated.w;vTBN=mat3(finalWorld)*mat3(tbnTangent,tbnBitangent,tbnNormal);
#endif
#endif
`;
G.IncludesShadersStore[fd] = _d;
const pd = "fogVertex", gd = `#ifdef FOG
vFogDistance=(view*worldPos).xyz;
#endif
`;
G.IncludesShadersStore[pd] = gd;
const md = "shadowsVertex", yd = `#ifdef SHADOWS
#if defined(SHADOWCSM{X})
vPositionFromCamera{X}=view*worldPos;for (int i=0; i<SHADOWCSMNUM_CASCADES{X}; i++) {vPositionFromLight{X}[i]=lightMatrix{X}[i]*worldPos;
#ifdef USE_REVERSE_DEPTHBUFFER
vDepthMetric{X}[i]=(-vPositionFromLight{X}[i].z+light{X}.depthValues.x)/light{X}.depthValues.y;
#else
vDepthMetric{X}[i]=(vPositionFromLight{X}[i].z+light{X}.depthValues.x)/light{X}.depthValues.y;
#endif
}
#elif defined(SHADOW{X}) && !defined(SHADOWCUBE{X})
vPositionFromLight{X}=lightMatrix{X}*worldPos;
#ifdef USE_REVERSE_DEPTHBUFFER
vDepthMetric{X}=(-vPositionFromLight{X}.z+light{X}.depthValues.x)/light{X}.depthValues.y;
#else
vDepthMetric{X}=(vPositionFromLight{X}.z+light{X}.depthValues.x)/light{X}.depthValues.y;
#endif
#endif
#endif
`;
G.IncludesShadersStore[md] = yd;
const vd = "pointCloudVertex", xd = `#if defined(POINTSIZE) && !defined(WEBGPU)
gl_PointSize=pointSize;
#endif
`;
G.IncludesShadersStore[vd] = xd;
const bd = "logDepthVertex", Td = `#ifdef LOGARITHMICDEPTH
vFragmentDepth=1.0+gl_Position.w;gl_Position.z=log2(max(0.000001,vFragmentDepth))*logarithmicDepthConstant;
#endif
`;
G.IncludesShadersStore[bd] = Td;
const Ad = "defaultVertexShader", Ed = `#include<__decl__defaultVertex>
#define CUSTOM_VERTEX_BEGIN
attribute vec3 position;
#ifdef NORMAL
attribute vec3 normal;
#endif
#ifdef TANGENT
attribute vec4 tangent;
#endif
#ifdef UV1
attribute vec2 uv;
#endif
#include<uvAttributeDeclaration>[2..7]
#ifdef VERTEXCOLOR
attribute vec4 color;
#endif
#include<helperFunctions>
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<instancesDeclaration>
#include<prePassVertexDeclaration>
#include<mainUVVaryingDeclaration>[1..7]
#include<samplerVertexDeclaration>(_DEFINENAME_,DIFFUSE,_VARYINGNAME_,Diffuse)
#include<samplerVertexDeclaration>(_DEFINENAME_,DETAIL,_VARYINGNAME_,Detail)
#include<samplerVertexDeclaration>(_DEFINENAME_,AMBIENT,_VARYINGNAME_,Ambient)
#include<samplerVertexDeclaration>(_DEFINENAME_,OPACITY,_VARYINGNAME_,Opacity)
#include<samplerVertexDeclaration>(_DEFINENAME_,EMISSIVE,_VARYINGNAME_,Emissive)
#include<samplerVertexDeclaration>(_DEFINENAME_,LIGHTMAP,_VARYINGNAME_,Lightmap)
#if defined(SPECULARTERM)
#include<samplerVertexDeclaration>(_DEFINENAME_,SPECULAR,_VARYINGNAME_,Specular)
#endif
#include<samplerVertexDeclaration>(_DEFINENAME_,BUMP,_VARYINGNAME_,Bump)
#include<samplerVertexDeclaration>(_DEFINENAME_,DECAL,_VARYINGNAME_,Decal)
varying vec3 vPositionW;
#ifdef NORMAL
varying vec3 vNormalW;
#endif
#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
varying vec4 vColor;
#endif
#include<bumpVertexDeclaration>
#include<clipPlaneVertexDeclaration>
#include<fogVertexDeclaration>
#include<__decl__lightVxFragment>[0..maxSimultaneousLights]
#include<morphTargetsVertexGlobalDeclaration>
#include<morphTargetsVertexDeclaration>[0..maxSimultaneousMorphTargets]
#ifdef REFLECTIONMAP_SKYBOX
varying vec3 vPositionUVW;
#endif
#if defined(REFLECTIONMAP_EQUIRECTANGULAR_FIXED) || defined(REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED)
varying vec3 vDirectionW;
#endif
#include<logDepthDeclaration>
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
vec3 positionUpdated=position;
#ifdef NORMAL
vec3 normalUpdated=normal;
#endif
#ifdef TANGENT
vec4 tangentUpdated=tangent;
#endif
#ifdef UV1
vec2 uvUpdated=uv;
#endif
#include<morphTargetsVertexGlobal>
#include<morphTargetsVertex>[0..maxSimultaneousMorphTargets]
#ifdef REFLECTIONMAP_SKYBOX
vPositionUVW=positionUpdated;
#endif
#define CUSTOM_VERTEX_UPDATE_POSITION
#define CUSTOM_VERTEX_UPDATE_NORMAL
#include<instancesVertex>
#if defined(PREPASS) && defined(PREPASS_VELOCITY) && !defined(BONES_VELOCITY_ENABLED)
vCurrentPosition=viewProjection*finalWorld*vec4(positionUpdated,1.0);vPreviousPosition=previousViewProjection*finalPreviousWorld*vec4(positionUpdated,1.0);
#endif
#include<bonesVertex>
#include<bakedVertexAnimation>
vec4 worldPos=finalWorld*vec4(positionUpdated,1.0);
#ifdef NORMAL
mat3 normalWorld=mat3(finalWorld);
#if defined(INSTANCES) && defined(THIN_INSTANCES)
vNormalW=normalUpdated/vec3(dot(normalWorld[0],normalWorld[0]),dot(normalWorld[1],normalWorld[1]),dot(normalWorld[2],normalWorld[2]));vNormalW=normalize(normalWorld*vNormalW);
#else
#ifdef NONUNIFORMSCALING
normalWorld=transposeMat3(inverseMat3(normalWorld));
#endif
vNormalW=normalize(normalWorld*normalUpdated);
#endif
#endif
#define CUSTOM_VERTEX_UPDATE_WORLDPOS
#ifdef MULTIVIEW
if (gl_ViewID_OVR==0u) {gl_Position=viewProjection*worldPos;} else {gl_Position=viewProjectionR*worldPos;}
#else
gl_Position=viewProjection*worldPos;
#endif
vPositionW=vec3(worldPos);
#include<prePassVertex>
#if defined(REFLECTIONMAP_EQUIRECTANGULAR_FIXED) || defined(REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED)
vDirectionW=normalize(vec3(finalWorld*vec4(positionUpdated,0.0)));
#endif
#ifndef UV1
vec2 uvUpdated=vec2(0.,0.);
#endif
#ifdef MAINUV1
vMainUV1=uvUpdated;
#endif
#include<uvVariableDeclaration>[2..7]
#include<samplerVertexImplementation>(_DEFINENAME_,DIFFUSE,_VARYINGNAME_,Diffuse,_MATRIXNAME_,diffuse,_INFONAME_,DiffuseInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,DETAIL,_VARYINGNAME_,Detail,_MATRIXNAME_,detail,_INFONAME_,DetailInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,AMBIENT,_VARYINGNAME_,Ambient,_MATRIXNAME_,ambient,_INFONAME_,AmbientInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,OPACITY,_VARYINGNAME_,Opacity,_MATRIXNAME_,opacity,_INFONAME_,OpacityInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,EMISSIVE,_VARYINGNAME_,Emissive,_MATRIXNAME_,emissive,_INFONAME_,EmissiveInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,LIGHTMAP,_VARYINGNAME_,Lightmap,_MATRIXNAME_,lightmap,_INFONAME_,LightmapInfos.x)
#if defined(SPECULARTERM)
#include<samplerVertexImplementation>(_DEFINENAME_,SPECULAR,_VARYINGNAME_,Specular,_MATRIXNAME_,specular,_INFONAME_,SpecularInfos.x)
#endif
#include<samplerVertexImplementation>(_DEFINENAME_,BUMP,_VARYINGNAME_,Bump,_MATRIXNAME_,bump,_INFONAME_,BumpInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,DECAL,_VARYINGNAME_,Decal,_MATRIXNAME_,decal,_INFONAME_,DecalInfos.x)
#include<bumpVertex>
#include<clipPlaneVertex>
#include<fogVertex>
#include<shadowsVertex>[0..maxSimultaneousLights]
#include<vertexColorMixing>
#include<pointCloudVertex>
#include<logDepthVertex>
#define CUSTOM_VERTEX_MAIN_END
}
`;
G.ShadersStore[Ad] = Ed;
const Md = new RegExp("^([gimus]+)!");
class Bi {
  /**
   * Creates a new instance of the plugin manager
   * @param material material that this manager will manage the plugins for
   */
  constructor(e) {
    this._plugins = [], this._activePlugins = [], this._activePluginsForExtraEvents = [], this._material = e, this._scene = e.getScene(), this._engine = this._scene.getEngine();
  }
  /**
   * @internal
   */
  _addPlugin(e) {
    for (let s = 0; s < this._plugins.length; ++s)
      if (this._plugins[s].name === e.name)
        return !1;
    if (this._material._uniformBufferLayoutBuilt)
      throw `The plugin "${e.name}" can't be added to the material "${this._material.name}" because this material has already been used for rendering! Please add plugins to materials before any rendering with this material occurs.`;
    const t = e.getClassName();
    Bi._MaterialPluginClassToMainDefine[t] || (Bi._MaterialPluginClassToMainDefine[t] = "MATERIALPLUGIN_" + ++Bi._MaterialPluginCounter), this._material._callbackPluginEventGeneric = this._handlePluginEvent.bind(this), this._plugins.push(e), this._plugins.sort((s, r) => s.priority - r.priority), this._codeInjectionPoints = {};
    const i = {};
    i[Bi._MaterialPluginClassToMainDefine[t]] = {
      type: "boolean",
      default: !0
    };
    for (const s of this._plugins)
      s.collectDefines(i), this._collectPointNames("vertex", s.getCustomCode("vertex")), this._collectPointNames("fragment", s.getCustomCode("fragment"));
    return this._defineNamesFromPlugins = i, !0;
  }
  /**
   * @internal
   */
  _activatePlugin(e) {
    this._activePlugins.indexOf(e) === -1 && (this._activePlugins.push(e), this._activePlugins.sort((t, i) => t.priority - i.priority), this._material._callbackPluginEventIsReadyForSubMesh = this._handlePluginEventIsReadyForSubMesh.bind(this), this._material._callbackPluginEventPrepareDefinesBeforeAttributes = this._handlePluginEventPrepareDefinesBeforeAttributes.bind(this), this._material._callbackPluginEventPrepareDefines = this._handlePluginEventPrepareDefines.bind(this), this._material._callbackPluginEventBindForSubMesh = this._handlePluginEventBindForSubMesh.bind(this), e.registerForExtraEvents && (this._activePluginsForExtraEvents.push(e), this._activePluginsForExtraEvents.sort((t, i) => t.priority - i.priority), this._material._callbackPluginEventHasRenderTargetTextures = this._handlePluginEventHasRenderTargetTextures.bind(this), this._material._callbackPluginEventFillRenderTargetTextures = this._handlePluginEventFillRenderTargetTextures.bind(this), this._material._callbackPluginEventHardBindForSubMesh = this._handlePluginEventHardBindForSubMesh.bind(this)));
  }
  /**
   * Gets a plugin from the list of plugins managed by this manager
   * @param name name of the plugin
   * @returns the plugin if found, else null
   */
  getPlugin(e) {
    for (let t = 0; t < this._plugins.length; ++t)
      if (this._plugins[t].name === e)
        return this._plugins[t];
    return null;
  }
  _handlePluginEventIsReadyForSubMesh(e) {
    let t = !0;
    for (const i of this._activePlugins)
      t = t && i.isReadyForSubMesh(e.defines, this._scene, this._engine, e.subMesh);
    e.isReadyForSubMesh = t;
  }
  _handlePluginEventPrepareDefinesBeforeAttributes(e) {
    for (const t of this._activePlugins)
      t.prepareDefinesBeforeAttributes(e.defines, this._scene, e.mesh);
  }
  _handlePluginEventPrepareDefines(e) {
    for (const t of this._activePlugins)
      t.prepareDefines(e.defines, this._scene, e.mesh);
  }
  _handlePluginEventHardBindForSubMesh(e) {
    for (const t of this._activePluginsForExtraEvents)
      t.hardBindForSubMesh(this._material._uniformBuffer, this._scene, this._engine, e.subMesh);
  }
  _handlePluginEventBindForSubMesh(e) {
    for (const t of this._activePlugins)
      t.bindForSubMesh(this._material._uniformBuffer, this._scene, this._engine, e.subMesh);
  }
  _handlePluginEventHasRenderTargetTextures(e) {
    let t = !1;
    for (const i of this._activePluginsForExtraEvents)
      if (t = i.hasRenderTargetTextures(), t)
        break;
    e.hasRenderTargetTextures = t;
  }
  _handlePluginEventFillRenderTargetTextures(e) {
    for (const t of this._activePluginsForExtraEvents)
      t.fillRenderTargetTextures(e.renderTargets);
  }
  _handlePluginEvent(e, t) {
    var i;
    switch (e) {
      case St.GetActiveTextures: {
        const s = t;
        for (const r of this._activePlugins)
          r.getActiveTextures(s.activeTextures);
        break;
      }
      case St.GetAnimatables: {
        const s = t;
        for (const r of this._activePlugins)
          r.getAnimatables(s.animatables);
        break;
      }
      case St.HasTexture: {
        const s = t;
        let r = !1;
        for (const n of this._activePlugins)
          if (r = n.hasTexture(s.texture), r)
            break;
        s.hasTexture = r;
        break;
      }
      case St.Disposed: {
        const s = t;
        for (const r of this._plugins)
          r.dispose(s.forceDisposeTextures);
        break;
      }
      case St.GetDefineNames: {
        const s = t;
        s.defineNames = this._defineNamesFromPlugins;
        break;
      }
      case St.PrepareEffect: {
        const s = t;
        for (const r of this._activePlugins)
          s.fallbackRank = r.addFallbacks(s.defines, s.fallbacks, s.fallbackRank), r.getAttributes(s.attributes, this._scene, s.mesh);
        this._uniformList.length > 0 && s.uniforms.push(...this._uniformList), this._samplerList.length > 0 && s.samplers.push(...this._samplerList), this._uboList.length > 0 && s.uniformBuffersNames.push(...this._uboList), s.customCode = this._injectCustomCode(s, s.customCode);
        break;
      }
      case St.PrepareUniformBuffer: {
        const s = t;
        this._uboDeclaration = "", this._vertexDeclaration = "", this._fragmentDeclaration = "", this._uniformList = [], this._samplerList = [], this._uboList = [];
        for (const r of this._plugins) {
          const n = r.getUniforms();
          if (n) {
            if (n.ubo)
              for (const a of n.ubo) {
                if (a.size && a.type) {
                  const o = (i = a.arraySize) !== null && i !== void 0 ? i : 0;
                  s.ubo.addUniform(a.name, a.size, o), this._uboDeclaration += `${a.type} ${a.name}${o > 0 ? `[${o}]` : ""};
`;
                }
                this._uniformList.push(a.name);
              }
            n.vertex && (this._vertexDeclaration += n.vertex + `
`), n.fragment && (this._fragmentDeclaration += n.fragment + `
`);
          }
          r.getSamplers(this._samplerList), r.getUniformBuffersNames(this._uboList);
        }
        break;
      }
    }
  }
  _collectPointNames(e, t) {
    if (t)
      for (const i in t)
        this._codeInjectionPoints[e] || (this._codeInjectionPoints[e] = {}), this._codeInjectionPoints[e][i] = !0;
  }
  _injectCustomCode(e, t) {
    return (i, s) => {
      var r, n;
      t && (s = t(i, s)), this._uboDeclaration && (s = s.replace("#define ADDITIONAL_UBO_DECLARATION", this._uboDeclaration)), this._vertexDeclaration && (s = s.replace("#define ADDITIONAL_VERTEX_DECLARATION", this._vertexDeclaration)), this._fragmentDeclaration && (s = s.replace("#define ADDITIONAL_FRAGMENT_DECLARATION", this._fragmentDeclaration));
      const a = (r = this._codeInjectionPoints) === null || r === void 0 ? void 0 : r[i];
      if (!a)
        return s;
      let o = null;
      for (let l in a) {
        let c = "";
        for (const u of this._activePlugins) {
          let d = (n = u.getCustomCode(i)) === null || n === void 0 ? void 0 : n[l];
          if (d) {
            if (u.resolveIncludes) {
              if (o === null) {
                const f = dt.GLSL;
                o = {
                  defines: [],
                  indexParameters: e.indexParameters,
                  isFragment: !1,
                  shouldUseHighPrecisionShader: this._engine._shouldUseHighPrecisionShader,
                  processor: void 0,
                  supportsUniformBuffers: this._engine.supportsUniformBuffers,
                  shadersRepository: G.GetShadersRepository(f),
                  includesShadersStore: G.GetIncludesShadersStore(f),
                  version: void 0,
                  platformName: this._engine.shaderPlatformName,
                  processingContext: void 0,
                  isNDCHalfZRange: this._engine.isNDCHalfZRange,
                  useReverseDepthBuffer: this._engine.useReverseDepthBuffer,
                  processCodeAfterIncludes: void 0
                  // not used by _ProcessIncludes
                };
              }
              o.isFragment = i === "fragment", hi._ProcessIncludes(d, o, (f) => d = f);
            }
            c += d + `
`;
          }
        }
        if (c.length > 0)
          if (l.charAt(0) === "!") {
            l = l.substring(1);
            let u = "g";
            if (l.charAt(0) === "!")
              u = "", l = l.substring(1);
            else {
              const g = Md.exec(l);
              g && g.length >= 2 && (u = g[1], l = l.substring(u.length + 1));
            }
            u.indexOf("g") < 0 && (u += "g");
            const d = s, f = new RegExp(l, u);
            let _ = f.exec(d);
            for (; _ !== null; ) {
              let g = c;
              for (let m = 0; m < _.length; ++m)
                g = g.replace("$" + m, _[m]);
              s = s.replace(_[0], g), _ = f.exec(d);
            }
          } else {
            const u = "#define " + l;
            s = s.replace(u, `
` + c + `
` + u);
          }
      }
      return s;
    };
  }
}
Bi._MaterialPluginClassToMainDefine = {};
Bi._MaterialPluginCounter = 0;
de.OnEnginesDisposedObservable.add(() => {
  Rd();
});
const Sd = [];
let fa = null;
function Rd() {
  Sd.length = 0, F.OnEventObservable.remove(fa), fa = null;
}
class tr {
  _enable(e) {
    e && this._pluginManager._activatePlugin(this);
  }
  /**
   * Creates a new material plugin
   * @param material parent material of the plugin
   * @param name name of the plugin
   * @param priority priority of the plugin
   * @param defines list of defines used by the plugin. The value of the property is the default value for this property
   * @param addToPluginList true to add the plugin to the list of plugins managed by the material plugin manager of the material (default: true)
   * @param enable true to enable the plugin (it is handy if the plugin does not handle properties to switch its current activation)
   * @param resolveIncludes Indicates that any #include directive in the plugin code must be replaced by the corresponding code (default: false)
   */
  constructor(e, t, i, s, r = !0, n = !1, a = !1) {
    this.priority = 500, this.resolveIncludes = !1, this.registerForExtraEvents = !1, this._material = e, this.name = t, this.priority = i, this.resolveIncludes = a, e.pluginManager || (e.pluginManager = new Bi(e), e.onDisposeObservable.add(() => {
      e.pluginManager = void 0;
    })), this._pluginDefineNames = s, this._pluginManager = e.pluginManager, r && this._pluginManager._addPlugin(this), n && this._enable(!0), this.markAllDefinesAsDirty = e._dirtyCallbacks[63];
  }
  /**
   * Gets the current class name useful for serialization or dynamic coding.
   * @returns The class name.
   */
  getClassName() {
    return "MaterialPluginBase";
  }
  /**
   * Specifies that the submesh is ready to be used.
   * @param defines the list of "defines" to update.
   * @param scene defines the scene the material belongs to.
   * @param engine the engine this scene belongs to.
   * @param subMesh the submesh to check for readiness
   * @returns - boolean indicating that the submesh is ready or not.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  isReadyForSubMesh(e, t, i, s) {
    return !0;
  }
  /**
   * Binds the material data (this function is called even if mustRebind() returns false)
   * @param uniformBuffer defines the Uniform buffer to fill in.
   * @param scene defines the scene the material belongs to.
   * @param engine defines the engine the material belongs to.
   * @param subMesh the submesh to bind data for
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  hardBindForSubMesh(e, t, i, s) {
  }
  /**
   * Binds the material data.
   * @param uniformBuffer defines the Uniform buffer to fill in.
   * @param scene defines the scene the material belongs to.
   * @param engine the engine this scene belongs to.
   * @param subMesh the submesh to bind data for
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  bindForSubMesh(e, t, i, s) {
  }
  /**
   * Disposes the resources of the material.
   * @param forceDisposeTextures - Forces the disposal of all textures.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  dispose(e) {
  }
  /**
   * Returns a list of custom shader code fragments to customize the shader.
   * @param shaderType "vertex" or "fragment"
   * @returns null if no code to be added, or a list of pointName =\> code.
   * Note that `pointName` can also be a regular expression if it starts with a `!`.
   * In that case, the string found by the regular expression (if any) will be
   * replaced by the code provided.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getCustomCode(e) {
    return null;
  }
  /**
   * Collects all defines.
   * @param defines The object to append to.
   */
  collectDefines(e) {
    if (this._pluginDefineNames)
      for (const t of Object.keys(this._pluginDefineNames)) {
        if (t[0] === "_")
          continue;
        const i = typeof this._pluginDefineNames[t];
        e[t] = {
          type: i === "number" ? "number" : i === "string" ? "string" : i === "boolean" ? "boolean" : "object",
          default: this._pluginDefineNames[t]
        };
      }
  }
  /**
   * Sets the defines for the next rendering. Called before MaterialHelper.PrepareDefinesForAttributes is called.
   * @param defines the list of "defines" to update.
   * @param scene defines the scene to the material belongs to.
   * @param mesh the mesh being rendered
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  prepareDefinesBeforeAttributes(e, t, i) {
  }
  /**
   * Sets the defines for the next rendering
   * @param defines the list of "defines" to update.
   * @param scene defines the scene to the material belongs to.
   * @param mesh the mesh being rendered
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  prepareDefines(e, t, i) {
  }
  /**
   * Checks to see if a texture is used in the material.
   * @param texture - Base texture to use.
   * @returns - Boolean specifying if a texture is used in the material.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  hasTexture(e) {
    return !1;
  }
  /**
   * Gets a boolean indicating that current material needs to register RTT
   * @returns true if this uses a render target otherwise false.
   */
  hasRenderTargetTextures() {
    return !1;
  }
  /**
   * Fills the list of render target textures.
   * @param renderTargets the list of render targets to update
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  fillRenderTargetTextures(e) {
  }
  /**
   * Returns an array of the actively used textures.
   * @param activeTextures Array of BaseTextures
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getActiveTextures(e) {
  }
  /**
   * Returns the animatable textures.
   * @param animatables Array of animatable textures.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getAnimatables(e) {
  }
  /**
   * Add fallbacks to the effect fallbacks list.
   * @param defines defines the Base texture to use.
   * @param fallbacks defines the current fallback list.
   * @param currentRank defines the current fallback rank.
   * @returns the new fallback rank.
   */
  addFallbacks(e, t, i) {
    return i;
  }
  /**
   * Gets the samplers used by the plugin.
   * @param samplers list that the sampler names should be added to.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getSamplers(e) {
  }
  /**
   * Gets the attributes used by the plugin.
   * @param attributes list that the attribute names should be added to.
   * @param scene the scene that the material belongs to.
   * @param mesh the mesh being rendered.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getAttributes(e, t, i) {
  }
  /**
   * Gets the uniform buffers names added by the plugin.
   * @param ubos list that the ubo names should be added to.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getUniformBuffersNames(e) {
  }
  /**
   * Gets the description of the uniforms to add to the ubo (if engine supports ubos) or to inject directly in the vertex/fragment shaders (if engine does not support ubos)
   * @returns the description of the uniforms
   */
  getUniforms() {
    return {};
  }
  /**
   * Makes a duplicate of the current configuration into another one.
   * @param plugin define the config where to copy the info
   */
  copyTo(e) {
    le.Clone(() => e, this);
  }
  /**
   * Serializes this plugin configuration.
   * @returns - An object with the serialized config.
   */
  serialize() {
    return le.Serialize(this);
  }
  /**
   * Parses a plugin configuration from a serialized object.
   * @param source - Serialized object.
   * @param scene Defines the scene we are parsing for
   * @param rootUrl Defines the rootUrl to load from
   */
  parse(e, t, i) {
    le.Parse(() => this, e, t, i);
  }
}
E([
  R()
], tr.prototype, "name", void 0);
E([
  R()
], tr.prototype, "priority", void 0);
E([
  R()
], tr.prototype, "resolveIncludes", void 0);
E([
  R()
], tr.prototype, "registerForExtraEvents", void 0);
class Id extends Va {
  constructor() {
    super(...arguments), this.DETAIL = !1, this.DETAILDIRECTUV = 0, this.DETAIL_NORMALBLENDMETHOD = 0;
  }
}
class ts extends tr {
  /** @internal */
  _markAllSubMeshesAsTexturesDirty() {
    this._enable(this._isEnabled), this._internalMarkAllSubMeshesAsTexturesDirty();
  }
  constructor(e, t = !0) {
    super(e, "DetailMap", 140, new Id(), t), this._texture = null, this.diffuseBlendLevel = 1, this.roughnessBlendLevel = 1, this.bumpLevel = 1, this._normalBlendMethod = F.MATERIAL_NORMALBLENDMETHOD_WHITEOUT, this._isEnabled = !1, this.isEnabled = !1, this._internalMarkAllSubMeshesAsTexturesDirty = e._dirtyCallbacks[1];
  }
  isReadyForSubMesh(e, t, i) {
    return this._isEnabled ? !(e._areTexturesDirty && t.texturesEnabled && i.getCaps().standardDerivatives && this._texture && be.DetailTextureEnabled && !this._texture.isReady()) : !0;
  }
  prepareDefines(e, t) {
    if (this._isEnabled) {
      e.DETAIL_NORMALBLENDMETHOD = this._normalBlendMethod;
      const i = t.getEngine();
      e._areTexturesDirty && (i.getCaps().standardDerivatives && this._texture && be.DetailTextureEnabled && this._isEnabled ? (Re.PrepareDefinesForMergedUV(this._texture, e, "DETAIL"), e.DETAIL_NORMALBLENDMETHOD = this._normalBlendMethod) : e.DETAIL = !1);
    } else
      e.DETAIL = !1;
  }
  bindForSubMesh(e, t) {
    if (!this._isEnabled)
      return;
    const i = this._material.isFrozen;
    (!e.useUbo || !i || !e.isSync) && this._texture && be.DetailTextureEnabled && (e.updateFloat4("vDetailInfos", this._texture.coordinatesIndex, this.diffuseBlendLevel, this.bumpLevel, this.roughnessBlendLevel), Re.BindTextureMatrix(this._texture, e, "detail")), t.texturesEnabled && this._texture && be.DetailTextureEnabled && e.setTexture("detailSampler", this._texture);
  }
  hasTexture(e) {
    return this._texture === e;
  }
  getActiveTextures(e) {
    this._texture && e.push(this._texture);
  }
  getAnimatables(e) {
    this._texture && this._texture.animations && this._texture.animations.length > 0 && e.push(this._texture);
  }
  dispose(e) {
    var t;
    e && ((t = this._texture) === null || t === void 0 || t.dispose());
  }
  getClassName() {
    return "DetailMapConfiguration";
  }
  getSamplers(e) {
    e.push("detailSampler");
  }
  getUniforms() {
    return {
      ubo: [
        { name: "vDetailInfos", size: 4, type: "vec4" },
        { name: "detailMatrix", size: 16, type: "mat4" }
      ]
    };
  }
}
E([
  Jt("detailTexture"),
  Le("_markAllSubMeshesAsTexturesDirty")
], ts.prototype, "texture", void 0);
E([
  R()
], ts.prototype, "diffuseBlendLevel", void 0);
E([
  R()
], ts.prototype, "roughnessBlendLevel", void 0);
E([
  R()
], ts.prototype, "bumpLevel", void 0);
E([
  R(),
  Le("_markAllSubMeshesAsTexturesDirty")
], ts.prototype, "normalBlendMethod", void 0);
E([
  R(),
  Le("_markAllSubMeshesAsTexturesDirty")
], ts.prototype, "isEnabled", void 0);
const jr = { effect: null, subMesh: null };
class Pd extends Va {
  /**
   * Initializes the Standard Material defines.
   * @param externalProperties The external properties
   */
  constructor(e) {
    super(e), this.MAINUV1 = !1, this.MAINUV2 = !1, this.MAINUV3 = !1, this.MAINUV4 = !1, this.MAINUV5 = !1, this.MAINUV6 = !1, this.DIFFUSE = !1, this.DIFFUSEDIRECTUV = 0, this.BAKED_VERTEX_ANIMATION_TEXTURE = !1, this.AMBIENT = !1, this.AMBIENTDIRECTUV = 0, this.OPACITY = !1, this.OPACITYDIRECTUV = 0, this.OPACITYRGB = !1, this.REFLECTION = !1, this.EMISSIVE = !1, this.EMISSIVEDIRECTUV = 0, this.SPECULAR = !1, this.SPECULARDIRECTUV = 0, this.BUMP = !1, this.BUMPDIRECTUV = 0, this.PARALLAX = !1, this.PARALLAXOCCLUSION = !1, this.SPECULAROVERALPHA = !1, this.CLIPPLANE = !1, this.CLIPPLANE2 = !1, this.CLIPPLANE3 = !1, this.CLIPPLANE4 = !1, this.CLIPPLANE5 = !1, this.CLIPPLANE6 = !1, this.ALPHATEST = !1, this.DEPTHPREPASS = !1, this.ALPHAFROMDIFFUSE = !1, this.POINTSIZE = !1, this.FOG = !1, this.SPECULARTERM = !1, this.DIFFUSEFRESNEL = !1, this.OPACITYFRESNEL = !1, this.REFLECTIONFRESNEL = !1, this.REFRACTIONFRESNEL = !1, this.EMISSIVEFRESNEL = !1, this.FRESNEL = !1, this.NORMAL = !1, this.TANGENT = !1, this.UV1 = !1, this.UV2 = !1, this.UV3 = !1, this.UV4 = !1, this.UV5 = !1, this.UV6 = !1, this.VERTEXCOLOR = !1, this.VERTEXALPHA = !1, this.NUM_BONE_INFLUENCERS = 0, this.BonesPerMesh = 0, this.BONETEXTURE = !1, this.BONES_VELOCITY_ENABLED = !1, this.INSTANCES = !1, this.THIN_INSTANCES = !1, this.INSTANCESCOLOR = !1, this.GLOSSINESS = !1, this.ROUGHNESS = !1, this.EMISSIVEASILLUMINATION = !1, this.LINKEMISSIVEWITHDIFFUSE = !1, this.REFLECTIONFRESNELFROMSPECULAR = !1, this.LIGHTMAP = !1, this.LIGHTMAPDIRECTUV = 0, this.OBJECTSPACE_NORMALMAP = !1, this.USELIGHTMAPASSHADOWMAP = !1, this.REFLECTIONMAP_3D = !1, this.REFLECTIONMAP_SPHERICAL = !1, this.REFLECTIONMAP_PLANAR = !1, this.REFLECTIONMAP_CUBIC = !1, this.USE_LOCAL_REFLECTIONMAP_CUBIC = !1, this.USE_LOCAL_REFRACTIONMAP_CUBIC = !1, this.REFLECTIONMAP_PROJECTION = !1, this.REFLECTIONMAP_SKYBOX = !1, this.REFLECTIONMAP_EXPLICIT = !1, this.REFLECTIONMAP_EQUIRECTANGULAR = !1, this.REFLECTIONMAP_EQUIRECTANGULAR_FIXED = !1, this.REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED = !1, this.REFLECTIONMAP_OPPOSITEZ = !1, this.INVERTCUBICMAP = !1, this.LOGARITHMICDEPTH = !1, this.REFRACTION = !1, this.REFRACTIONMAP_3D = !1, this.REFLECTIONOVERALPHA = !1, this.TWOSIDEDLIGHTING = !1, this.SHADOWFLOAT = !1, this.MORPHTARGETS = !1, this.MORPHTARGETS_NORMAL = !1, this.MORPHTARGETS_TANGENT = !1, this.MORPHTARGETS_UV = !1, this.NUM_MORPH_INFLUENCERS = 0, this.MORPHTARGETS_TEXTURE = !1, this.NONUNIFORMSCALING = !1, this.PREMULTIPLYALPHA = !1, this.ALPHATEST_AFTERALLALPHACOMPUTATIONS = !1, this.ALPHABLEND = !0, this.PREPASS = !1, this.PREPASS_IRRADIANCE = !1, this.PREPASS_IRRADIANCE_INDEX = -1, this.PREPASS_ALBEDO_SQRT = !1, this.PREPASS_ALBEDO_SQRT_INDEX = -1, this.PREPASS_DEPTH = !1, this.PREPASS_DEPTH_INDEX = -1, this.PREPASS_NORMAL = !1, this.PREPASS_NORMAL_INDEX = -1, this.PREPASS_POSITION = !1, this.PREPASS_POSITION_INDEX = -1, this.PREPASS_VELOCITY = !1, this.PREPASS_VELOCITY_INDEX = -1, this.PREPASS_REFLECTIVITY = !1, this.PREPASS_REFLECTIVITY_INDEX = -1, this.SCENE_MRT_COUNT = 0, this.RGBDLIGHTMAP = !1, this.RGBDREFLECTION = !1, this.RGBDREFRACTION = !1, this.IMAGEPROCESSING = !1, this.VIGNETTE = !1, this.VIGNETTEBLENDMODEMULTIPLY = !1, this.VIGNETTEBLENDMODEOPAQUE = !1, this.TONEMAPPING = !1, this.TONEMAPPING_ACES = !1, this.CONTRAST = !1, this.COLORCURVES = !1, this.COLORGRADING = !1, this.COLORGRADING3D = !1, this.SAMPLER3DGREENDEPTH = !1, this.SAMPLER3DBGRMAP = !1, this.DITHER = !1, this.IMAGEPROCESSINGPOSTPROCESS = !1, this.SKIPFINALCOLORCLAMP = !1, this.MULTIVIEW = !1, this.ORDER_INDEPENDENT_TRANSPARENCY = !1, this.ORDER_INDEPENDENT_TRANSPARENCY_16BITS = !1, this.CAMERA_ORTHOGRAPHIC = !1, this.CAMERA_PERSPECTIVE = !1, this.IS_REFLECTION_LINEAR = !1, this.IS_REFRACTION_LINEAR = !1, this.EXPOSURE = !1, this.DECAL_AFTER_DETAIL = !1, this.rebuild();
  }
  setReflectionMode(e) {
    const t = [
      "REFLECTIONMAP_CUBIC",
      "REFLECTIONMAP_EXPLICIT",
      "REFLECTIONMAP_PLANAR",
      "REFLECTIONMAP_PROJECTION",
      "REFLECTIONMAP_PROJECTION",
      "REFLECTIONMAP_SKYBOX",
      "REFLECTIONMAP_SPHERICAL",
      "REFLECTIONMAP_EQUIRECTANGULAR",
      "REFLECTIONMAP_EQUIRECTANGULAR_FIXED",
      "REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED"
    ];
    for (const i of t)
      this[i] = i === e;
  }
}
class V extends oo {
  /**
   * Gets the image processing configuration used either in this material.
   */
  get imageProcessingConfiguration() {
    return this._imageProcessingConfiguration;
  }
  /**
   * Sets the Default image processing configuration used either in the this material.
   *
   * If sets to null, the scene one is in use.
   */
  set imageProcessingConfiguration(e) {
    this._attachImageProcessingConfiguration(e), this._markAllSubMeshesAsTexturesDirty();
  }
  /**
   * Attaches a new image processing configuration to the Standard Material.
   * @param configuration
   */
  _attachImageProcessingConfiguration(e) {
    e !== this._imageProcessingConfiguration && (this._imageProcessingConfiguration && this._imageProcessingObserver && this._imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingObserver), e ? this._imageProcessingConfiguration = e : this._imageProcessingConfiguration = this.getScene().imageProcessingConfiguration, this._imageProcessingConfiguration && (this._imageProcessingObserver = this._imageProcessingConfiguration.onUpdateParameters.add(() => {
      this._markAllSubMeshesAsImageProcessingDirty();
    })));
  }
  /**
   * Can this material render to prepass
   */
  get isPrePassCapable() {
    return !this.disableDepthWrite;
  }
  /**
   * Gets whether the color curves effect is enabled.
   */
  get cameraColorCurvesEnabled() {
    return this.imageProcessingConfiguration.colorCurvesEnabled;
  }
  /**
   * Sets whether the color curves effect is enabled.
   */
  set cameraColorCurvesEnabled(e) {
    this.imageProcessingConfiguration.colorCurvesEnabled = e;
  }
  /**
   * Gets whether the color grading effect is enabled.
   */
  get cameraColorGradingEnabled() {
    return this.imageProcessingConfiguration.colorGradingEnabled;
  }
  /**
   * Gets whether the color grading effect is enabled.
   */
  set cameraColorGradingEnabled(e) {
    this.imageProcessingConfiguration.colorGradingEnabled = e;
  }
  /**
   * Gets whether tonemapping is enabled or not.
   */
  get cameraToneMappingEnabled() {
    return this._imageProcessingConfiguration.toneMappingEnabled;
  }
  /**
   * Sets whether tonemapping is enabled or not
   */
  set cameraToneMappingEnabled(e) {
    this._imageProcessingConfiguration.toneMappingEnabled = e;
  }
  /**
   * The camera exposure used on this material.
   * This property is here and not in the camera to allow controlling exposure without full screen post process.
   * This corresponds to a photographic exposure.
   */
  get cameraExposure() {
    return this._imageProcessingConfiguration.exposure;
  }
  /**
   * The camera exposure used on this material.
   * This property is here and not in the camera to allow controlling exposure without full screen post process.
   * This corresponds to a photographic exposure.
   */
  set cameraExposure(e) {
    this._imageProcessingConfiguration.exposure = e;
  }
  /**
   * Gets The camera contrast used on this material.
   */
  get cameraContrast() {
    return this._imageProcessingConfiguration.contrast;
  }
  /**
   * Sets The camera contrast used on this material.
   */
  set cameraContrast(e) {
    this._imageProcessingConfiguration.contrast = e;
  }
  /**
   * Gets the Color Grading 2D Lookup Texture.
   */
  get cameraColorGradingTexture() {
    return this._imageProcessingConfiguration.colorGradingTexture;
  }
  /**
   * Sets the Color Grading 2D Lookup Texture.
   */
  set cameraColorGradingTexture(e) {
    this._imageProcessingConfiguration.colorGradingTexture = e;
  }
  /**
   * The color grading curves provide additional color adjustmnent that is applied after any color grading transform (3D LUT).
   * They allow basic adjustment of saturation and small exposure adjustments, along with color filter tinting to provide white balance adjustment or more stylistic effects.
   * These are similar to controls found in many professional imaging or colorist software. The global controls are applied to the entire image. For advanced tuning, extra controls are provided to adjust the shadow, midtone and highlight areas of the image;
   * corresponding to low luminance, medium luminance, and high luminance areas respectively.
   */
  get cameraColorCurves() {
    return this._imageProcessingConfiguration.colorCurves;
  }
  /**
   * The color grading curves provide additional color adjustment that is applied after any color grading transform (3D LUT).
   * They allow basic adjustment of saturation and small exposure adjustments, along with color filter tinting to provide white balance adjustment or more stylistic effects.
   * These are similar to controls found in many professional imaging or colorist software. The global controls are applied to the entire image. For advanced tuning, extra controls are provided to adjust the shadow, midtone and highlight areas of the image;
   * corresponding to low luminance, medium luminance, and high luminance areas respectively.
   */
  set cameraColorCurves(e) {
    this._imageProcessingConfiguration.colorCurves = e;
  }
  /**
   * Can this material render to several textures at once
   */
  get canRenderToMRT() {
    return !0;
  }
  /**
   * Instantiates a new standard material.
   * This is the default material used in Babylon. It is the best trade off between quality
   * and performances.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/materials_introduction
   * @param name Define the name of the material in the scene
   * @param scene Define the scene the material belong to
   */
  constructor(e, t) {
    super(e, t), this._diffuseTexture = null, this._ambientTexture = null, this._opacityTexture = null, this._reflectionTexture = null, this._emissiveTexture = null, this._specularTexture = null, this._bumpTexture = null, this._lightmapTexture = null, this._refractionTexture = null, this.ambientColor = new ie(0, 0, 0), this.diffuseColor = new ie(1, 1, 1), this.specularColor = new ie(1, 1, 1), this.emissiveColor = new ie(0, 0, 0), this.specularPower = 64, this._useAlphaFromDiffuseTexture = !1, this._useEmissiveAsIllumination = !1, this._linkEmissiveWithDiffuse = !1, this._useSpecularOverAlpha = !1, this._useReflectionOverAlpha = !1, this._disableLighting = !1, this._useObjectSpaceNormalMap = !1, this._useParallax = !1, this._useParallaxOcclusion = !1, this.parallaxScaleBias = 0.05, this._roughness = 0, this.indexOfRefraction = 0.98, this.invertRefractionY = !0, this.alphaCutOff = 0.4, this._useLightmapAsShadowmap = !1, this._useReflectionFresnelFromSpecular = !1, this._useGlossinessFromSpecularMapAlpha = !1, this._maxSimultaneousLights = 4, this._invertNormalMapX = !1, this._invertNormalMapY = !1, this._twoSidedLighting = !1, this._applyDecalMapAfterDetailMap = !1, this._renderTargets = new At(16), this._worldViewProjectionMatrix = I.Zero(), this._globalAmbientColor = new ie(0, 0, 0), this._cacheHasRenderTargetTextures = !1, this.detailMap = new ts(this), this._attachImageProcessingConfiguration(null), this.prePassConfiguration = new da(), this.getRenderTargetTextures = () => (this._renderTargets.reset(), V.ReflectionTextureEnabled && this._reflectionTexture && this._reflectionTexture.isRenderTarget && this._renderTargets.push(this._reflectionTexture), V.RefractionTextureEnabled && this._refractionTexture && this._refractionTexture.isRenderTarget && this._renderTargets.push(this._refractionTexture), this._eventInfo.renderTargets = this._renderTargets, this._callbackPluginEventFillRenderTargetTextures(this._eventInfo), this._renderTargets);
  }
  /**
   * Gets a boolean indicating that current material needs to register RTT
   */
  get hasRenderTargetTextures() {
    return V.ReflectionTextureEnabled && this._reflectionTexture && this._reflectionTexture.isRenderTarget || V.RefractionTextureEnabled && this._refractionTexture && this._refractionTexture.isRenderTarget ? !0 : this._cacheHasRenderTargetTextures;
  }
  /**
   * Gets the current class name of the material e.g. "StandardMaterial"
   * Mainly use in serialization.
   * @returns the class name
   */
  getClassName() {
    return "StandardMaterial";
  }
  /**
   * In case the depth buffer does not allow enough depth precision for your scene (might be the case in large scenes)
   * You can try switching to logarithmic depth.
   * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/advanced/logarithmicDepthBuffer
   */
  get useLogarithmicDepth() {
    return this._useLogarithmicDepth;
  }
  set useLogarithmicDepth(e) {
    this._useLogarithmicDepth = e && this.getScene().getEngine().getCaps().fragmentDepthSupported, this._markAllSubMeshesAsMiscDirty();
  }
  /**
   * Specifies if the material will require alpha blending
   * @returns a boolean specifying if alpha blending is needed
   */
  needAlphaBlending() {
    return this._disableAlphaBlending ? !1 : this.alpha < 1 || this._opacityTexture != null || this._shouldUseAlphaFromDiffuseTexture() || this._opacityFresnelParameters && this._opacityFresnelParameters.isEnabled;
  }
  /**
   * Specifies if this material should be rendered in alpha test mode
   * @returns a boolean specifying if an alpha test is needed.
   */
  needAlphaTesting() {
    return this._forceAlphaTest ? !0 : this._hasAlphaChannel() && (this._transparencyMode == null || this._transparencyMode === F.MATERIAL_ALPHATEST);
  }
  /**
   * Specifies whether or not the alpha value of the diffuse texture should be used for alpha blending.
   */
  _shouldUseAlphaFromDiffuseTexture() {
    return this._diffuseTexture != null && this._diffuseTexture.hasAlpha && this._useAlphaFromDiffuseTexture && this._transparencyMode !== F.MATERIAL_OPAQUE;
  }
  /**
   * Specifies whether or not there is a usable alpha channel for transparency.
   */
  _hasAlphaChannel() {
    return this._diffuseTexture != null && this._diffuseTexture.hasAlpha || this._opacityTexture != null;
  }
  /**
   * Get the texture used for alpha test purpose.
   * @returns the diffuse texture in case of the standard material.
   */
  getAlphaTestTexture() {
    return this._diffuseTexture;
  }
  /**
   * Get if the submesh is ready to be used and all its information available.
   * Child classes can use it to update shaders
   * @param mesh defines the mesh to check
   * @param subMesh defines which submesh to check
   * @param useInstances specifies that instances should be used
   * @returns a boolean indicating that the submesh is ready or not
   */
  isReadyForSubMesh(e, t, i = !1) {
    if (this._uniformBufferLayoutBuilt || this.buildUniformLayout(), t.effect && this.isFrozen && t.effect._wasPreviouslyReady && t.effect._wasPreviouslyUsingInstances === i)
      return !0;
    t.materialDefines || (this._callbackPluginEventGeneric(St.GetDefineNames, this._eventInfo), t.materialDefines = new Pd(this._eventInfo.defineNames));
    const s = this.getScene(), r = t.materialDefines;
    if (this._isReadyForSubMesh(t))
      return !0;
    const n = s.getEngine();
    r._needNormals = Re.PrepareDefinesForLights(s, e, r, !0, this._maxSimultaneousLights, this._disableLighting), Re.PrepareDefinesForMultiview(s, r);
    const a = this.needAlphaBlendingForMesh(e) && this.getScene().useOrderIndependentTransparency;
    if (Re.PrepareDefinesForPrePass(s, r, this.canRenderToMRT && !a), Re.PrepareDefinesForOIT(s, r, a), r._areTexturesDirty) {
      this._eventInfo.hasRenderTargetTextures = !1, this._callbackPluginEventHasRenderTargetTextures(this._eventInfo), this._cacheHasRenderTargetTextures = this._eventInfo.hasRenderTargetTextures, r._needUVs = !1;
      for (let l = 1; l <= 6; ++l)
        r["MAINUV" + l] = !1;
      if (s.texturesEnabled) {
        if (r.DIFFUSEDIRECTUV = 0, r.BUMPDIRECTUV = 0, r.AMBIENTDIRECTUV = 0, r.OPACITYDIRECTUV = 0, r.EMISSIVEDIRECTUV = 0, r.SPECULARDIRECTUV = 0, r.LIGHTMAPDIRECTUV = 0, this._diffuseTexture && V.DiffuseTextureEnabled)
          if (this._diffuseTexture.isReadyOrNotBlocking())
            Re.PrepareDefinesForMergedUV(this._diffuseTexture, r, "DIFFUSE");
          else
            return !1;
        else
          r.DIFFUSE = !1;
        if (this._ambientTexture && V.AmbientTextureEnabled)
          if (this._ambientTexture.isReadyOrNotBlocking())
            Re.PrepareDefinesForMergedUV(this._ambientTexture, r, "AMBIENT");
          else
            return !1;
        else
          r.AMBIENT = !1;
        if (this._opacityTexture && V.OpacityTextureEnabled)
          if (this._opacityTexture.isReadyOrNotBlocking())
            Re.PrepareDefinesForMergedUV(this._opacityTexture, r, "OPACITY"), r.OPACITYRGB = this._opacityTexture.getAlphaFromRGB;
          else
            return !1;
        else
          r.OPACITY = !1;
        if (this._reflectionTexture && V.ReflectionTextureEnabled)
          if (this._reflectionTexture.isReadyOrNotBlocking()) {
            switch (r._needNormals = !0, r.REFLECTION = !0, r.ROUGHNESS = this._roughness > 0, r.REFLECTIONOVERALPHA = this._useReflectionOverAlpha, r.INVERTCUBICMAP = this._reflectionTexture.coordinatesMode === W.INVCUBIC_MODE, r.REFLECTIONMAP_3D = this._reflectionTexture.isCube, r.REFLECTIONMAP_OPPOSITEZ = r.REFLECTIONMAP_3D && this.getScene().useRightHandedSystem ? !this._reflectionTexture.invertZ : this._reflectionTexture.invertZ, r.RGBDREFLECTION = this._reflectionTexture.isRGBD, this._reflectionTexture.coordinatesMode) {
              case W.EXPLICIT_MODE:
                r.setReflectionMode("REFLECTIONMAP_EXPLICIT");
                break;
              case W.PLANAR_MODE:
                r.setReflectionMode("REFLECTIONMAP_PLANAR");
                break;
              case W.PROJECTION_MODE:
                r.setReflectionMode("REFLECTIONMAP_PROJECTION");
                break;
              case W.SKYBOX_MODE:
                r.setReflectionMode("REFLECTIONMAP_SKYBOX");
                break;
              case W.SPHERICAL_MODE:
                r.setReflectionMode("REFLECTIONMAP_SPHERICAL");
                break;
              case W.EQUIRECTANGULAR_MODE:
                r.setReflectionMode("REFLECTIONMAP_EQUIRECTANGULAR");
                break;
              case W.FIXED_EQUIRECTANGULAR_MODE:
                r.setReflectionMode("REFLECTIONMAP_EQUIRECTANGULAR_FIXED");
                break;
              case W.FIXED_EQUIRECTANGULAR_MIRRORED_MODE:
                r.setReflectionMode("REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED");
                break;
              case W.CUBIC_MODE:
              case W.INVCUBIC_MODE:
              default:
                r.setReflectionMode("REFLECTIONMAP_CUBIC");
                break;
            }
            r.USE_LOCAL_REFLECTIONMAP_CUBIC = !!this._reflectionTexture.boundingBoxSize;
          } else
            return !1;
        else
          r.REFLECTION = !1, r.REFLECTIONMAP_OPPOSITEZ = !1;
        if (this._emissiveTexture && V.EmissiveTextureEnabled)
          if (this._emissiveTexture.isReadyOrNotBlocking())
            Re.PrepareDefinesForMergedUV(this._emissiveTexture, r, "EMISSIVE");
          else
            return !1;
        else
          r.EMISSIVE = !1;
        if (this._lightmapTexture && V.LightmapTextureEnabled)
          if (this._lightmapTexture.isReadyOrNotBlocking())
            Re.PrepareDefinesForMergedUV(this._lightmapTexture, r, "LIGHTMAP"), r.USELIGHTMAPASSHADOWMAP = this._useLightmapAsShadowmap, r.RGBDLIGHTMAP = this._lightmapTexture.isRGBD;
          else
            return !1;
        else
          r.LIGHTMAP = !1;
        if (this._specularTexture && V.SpecularTextureEnabled)
          if (this._specularTexture.isReadyOrNotBlocking())
            Re.PrepareDefinesForMergedUV(this._specularTexture, r, "SPECULAR"), r.GLOSSINESS = this._useGlossinessFromSpecularMapAlpha;
          else
            return !1;
        else
          r.SPECULAR = !1;
        if (s.getEngine().getCaps().standardDerivatives && this._bumpTexture && V.BumpTextureEnabled) {
          if (this._bumpTexture.isReady())
            Re.PrepareDefinesForMergedUV(this._bumpTexture, r, "BUMP"), r.PARALLAX = this._useParallax, r.PARALLAXOCCLUSION = this._useParallaxOcclusion;
          else
            return !1;
          r.OBJECTSPACE_NORMALMAP = this._useObjectSpaceNormalMap;
        } else
          r.BUMP = !1, r.PARALLAX = !1, r.PARALLAXOCCLUSION = !1;
        if (this._refractionTexture && V.RefractionTextureEnabled)
          if (this._refractionTexture.isReadyOrNotBlocking())
            r._needUVs = !0, r.REFRACTION = !0, r.REFRACTIONMAP_3D = this._refractionTexture.isCube, r.RGBDREFRACTION = this._refractionTexture.isRGBD, r.USE_LOCAL_REFRACTIONMAP_CUBIC = !!this._refractionTexture.boundingBoxSize;
          else
            return !1;
        else
          r.REFRACTION = !1;
        r.TWOSIDEDLIGHTING = !this._backFaceCulling && this._twoSidedLighting;
      } else
        r.DIFFUSE = !1, r.AMBIENT = !1, r.OPACITY = !1, r.REFLECTION = !1, r.EMISSIVE = !1, r.LIGHTMAP = !1, r.BUMP = !1, r.REFRACTION = !1;
      r.ALPHAFROMDIFFUSE = this._shouldUseAlphaFromDiffuseTexture(), r.EMISSIVEASILLUMINATION = this._useEmissiveAsIllumination, r.LINKEMISSIVEWITHDIFFUSE = this._linkEmissiveWithDiffuse, r.SPECULAROVERALPHA = this._useSpecularOverAlpha, r.PREMULTIPLYALPHA = this.alphaMode === 7 || this.alphaMode === 8, r.ALPHATEST_AFTERALLALPHACOMPUTATIONS = this.transparencyMode !== null, r.ALPHABLEND = this.transparencyMode === null || this.needAlphaBlendingForMesh(e);
    }
    if (this._eventInfo.isReadyForSubMesh = !0, this._eventInfo.defines = r, this._eventInfo.subMesh = t, this._callbackPluginEventIsReadyForSubMesh(this._eventInfo), !this._eventInfo.isReadyForSubMesh)
      return !1;
    if (r._areImageProcessingDirty && this._imageProcessingConfiguration) {
      if (!this._imageProcessingConfiguration.isReady())
        return !1;
      this._imageProcessingConfiguration.prepareDefines(r), r.IS_REFLECTION_LINEAR = this.reflectionTexture != null && !this.reflectionTexture.gammaSpace, r.IS_REFRACTION_LINEAR = this.refractionTexture != null && !this.refractionTexture.gammaSpace;
    }
    r._areFresnelDirty && (V.FresnelEnabled ? (this._diffuseFresnelParameters || this._opacityFresnelParameters || this._emissiveFresnelParameters || this._refractionFresnelParameters || this._reflectionFresnelParameters) && (r.DIFFUSEFRESNEL = this._diffuseFresnelParameters && this._diffuseFresnelParameters.isEnabled, r.OPACITYFRESNEL = this._opacityFresnelParameters && this._opacityFresnelParameters.isEnabled, r.REFLECTIONFRESNEL = this._reflectionFresnelParameters && this._reflectionFresnelParameters.isEnabled, r.REFLECTIONFRESNELFROMSPECULAR = this._useReflectionFresnelFromSpecular, r.REFRACTIONFRESNEL = this._refractionFresnelParameters && this._refractionFresnelParameters.isEnabled, r.EMISSIVEFRESNEL = this._emissiveFresnelParameters && this._emissiveFresnelParameters.isEnabled, r._needNormals = !0, r.FRESNEL = !0) : r.FRESNEL = !1), Re.PrepareDefinesForMisc(e, s, this._useLogarithmicDepth, this.pointsCloud, this.fogEnabled, this._shouldTurnAlphaTestOn(e) || this._forceAlphaTest, r, this._applyDecalMapAfterDetailMap), Re.PrepareDefinesForFrameBoundValues(s, n, this, r, i, null, t.getRenderingMesh().hasThinInstances), this._eventInfo.defines = r, this._eventInfo.mesh = e, this._callbackPluginEventPrepareDefinesBeforeAttributes(this._eventInfo), Re.PrepareDefinesForAttributes(e, r, !0, !0, !0), this._callbackPluginEventPrepareDefines(this._eventInfo);
    let o = !1;
    if (r.isDirty) {
      const l = r._areLightsDisposed;
      r.markAsProcessed();
      const c = new ao();
      r.REFLECTION && c.addFallback(0, "REFLECTION"), r.SPECULAR && c.addFallback(0, "SPECULAR"), r.BUMP && c.addFallback(0, "BUMP"), r.PARALLAX && c.addFallback(1, "PARALLAX"), r.PARALLAXOCCLUSION && c.addFallback(0, "PARALLAXOCCLUSION"), r.SPECULAROVERALPHA && c.addFallback(0, "SPECULAROVERALPHA"), r.FOG && c.addFallback(1, "FOG"), r.POINTSIZE && c.addFallback(0, "POINTSIZE"), r.LOGARITHMICDEPTH && c.addFallback(0, "LOGARITHMICDEPTH"), Re.HandleFallbacksForShadows(r, c, this._maxSimultaneousLights), r.SPECULARTERM && c.addFallback(0, "SPECULARTERM"), r.DIFFUSEFRESNEL && c.addFallback(1, "DIFFUSEFRESNEL"), r.OPACITYFRESNEL && c.addFallback(2, "OPACITYFRESNEL"), r.REFLECTIONFRESNEL && c.addFallback(3, "REFLECTIONFRESNEL"), r.EMISSIVEFRESNEL && c.addFallback(4, "EMISSIVEFRESNEL"), r.FRESNEL && c.addFallback(4, "FRESNEL"), r.MULTIVIEW && c.addFallback(0, "MULTIVIEW");
      const u = [v.PositionKind];
      r.NORMAL && u.push(v.NormalKind), r.TANGENT && u.push(v.TangentKind);
      for (let M = 1; M <= 6; ++M)
        r["UV" + M] && u.push(`uv${M === 1 ? "" : M}`);
      r.VERTEXCOLOR && u.push(v.ColorKind), Re.PrepareAttributesForBones(u, e, r, c), Re.PrepareAttributesForInstances(u, r), Re.PrepareAttributesForMorphTargets(u, e, r), Re.PrepareAttributesForBakedVertexAnimation(u, e, r);
      let d = "default";
      const f = [
        "world",
        "view",
        "viewProjection",
        "vEyePosition",
        "vLightsType",
        "vAmbientColor",
        "vDiffuseColor",
        "vSpecularColor",
        "vEmissiveColor",
        "visibility",
        "vFogInfos",
        "vFogColor",
        "pointSize",
        "vDiffuseInfos",
        "vAmbientInfos",
        "vOpacityInfos",
        "vReflectionInfos",
        "vEmissiveInfos",
        "vSpecularInfos",
        "vBumpInfos",
        "vLightmapInfos",
        "vRefractionInfos",
        "mBones",
        "diffuseMatrix",
        "ambientMatrix",
        "opacityMatrix",
        "reflectionMatrix",
        "emissiveMatrix",
        "specularMatrix",
        "bumpMatrix",
        "normalMatrix",
        "lightmapMatrix",
        "refractionMatrix",
        "diffuseLeftColor",
        "diffuseRightColor",
        "opacityParts",
        "reflectionLeftColor",
        "reflectionRightColor",
        "emissiveLeftColor",
        "emissiveRightColor",
        "refractionLeftColor",
        "refractionRightColor",
        "vReflectionPosition",
        "vReflectionSize",
        "vRefractionPosition",
        "vRefractionSize",
        "logarithmicDepthConstant",
        "vTangentSpaceParams",
        "alphaCutOff",
        "boneTextureWidth",
        "morphTargetTextureInfo",
        "morphTargetTextureIndices"
      ], _ = [
        "diffuseSampler",
        "ambientSampler",
        "opacitySampler",
        "reflectionCubeSampler",
        "reflection2DSampler",
        "emissiveSampler",
        "specularSampler",
        "bumpSampler",
        "lightmapSampler",
        "refractionCubeSampler",
        "refraction2DSampler",
        "boneSampler",
        "morphTargets",
        "oitDepthSampler",
        "oitFrontColorSampler"
      ], g = ["Material", "Scene", "Mesh"], m = { maxSimultaneousLights: this._maxSimultaneousLights, maxSimultaneousMorphTargets: r.NUM_MORPH_INFLUENCERS };
      this._eventInfo.fallbacks = c, this._eventInfo.fallbackRank = 0, this._eventInfo.defines = r, this._eventInfo.uniforms = f, this._eventInfo.attributes = u, this._eventInfo.samplers = _, this._eventInfo.uniformBuffersNames = g, this._eventInfo.customCode = void 0, this._eventInfo.mesh = e, this._eventInfo.indexParameters = m, this._callbackPluginEventGeneric(St.PrepareEffect, this._eventInfo), da.AddUniforms(f), De && (De.PrepareUniforms(f, r), De.PrepareSamplers(_, r)), Re.PrepareUniformsAndSamplersList({
        uniformsNames: f,
        uniformBuffersNames: g,
        samplers: _,
        defines: r,
        maxSimultaneousLights: this._maxSimultaneousLights
      }), Xa(f);
      const y = {};
      this.customShaderNameResolve && (d = this.customShaderNameResolve(d, f, g, _, r, u, y));
      const x = r.toString(), A = t.effect;
      let T = s.getEngine().createEffect(d, {
        attributes: u,
        uniformsNames: f,
        uniformBuffersNames: g,
        samplers: _,
        defines: x,
        fallbacks: c,
        onCompiled: this.onCompiled,
        onError: this.onError,
        indexParameters: m,
        processFinalCode: y.processFinalCode,
        processCodeAfterIncludes: this._eventInfo.customCode,
        multiTarget: r.PREPASS
      }, n);
      if (this._eventInfo.customCode = void 0, T)
        if (this._onEffectCreatedObservable && (jr.effect = T, jr.subMesh = t, this._onEffectCreatedObservable.notifyObservers(jr)), this.allowShaderHotSwapping && A && !T.isReady()) {
          if (T = A, r.markAsUnprocessed(), o = this.isFrozen, l)
            return r._areLightsDisposed = !0, !1;
        } else
          s.resetCachedMaterial(), t.setEffect(T, r, this._materialContext);
    }
    return !t.effect || !t.effect.isReady() ? !1 : (r._renderId = s.getRenderId(), t.effect._wasPreviouslyReady = !o, t.effect._wasPreviouslyUsingInstances = i, this._checkScenePerformancePriority(), !0);
  }
  /**
   * Builds the material UBO layouts.
   * Used internally during the effect preparation.
   */
  buildUniformLayout() {
    const e = this._uniformBuffer;
    e.addUniform("diffuseLeftColor", 4), e.addUniform("diffuseRightColor", 4), e.addUniform("opacityParts", 4), e.addUniform("reflectionLeftColor", 4), e.addUniform("reflectionRightColor", 4), e.addUniform("refractionLeftColor", 4), e.addUniform("refractionRightColor", 4), e.addUniform("emissiveLeftColor", 4), e.addUniform("emissiveRightColor", 4), e.addUniform("vDiffuseInfos", 2), e.addUniform("vAmbientInfos", 2), e.addUniform("vOpacityInfos", 2), e.addUniform("vReflectionInfos", 2), e.addUniform("vReflectionPosition", 3), e.addUniform("vReflectionSize", 3), e.addUniform("vEmissiveInfos", 2), e.addUniform("vLightmapInfos", 2), e.addUniform("vSpecularInfos", 2), e.addUniform("vBumpInfos", 3), e.addUniform("diffuseMatrix", 16), e.addUniform("ambientMatrix", 16), e.addUniform("opacityMatrix", 16), e.addUniform("reflectionMatrix", 16), e.addUniform("emissiveMatrix", 16), e.addUniform("lightmapMatrix", 16), e.addUniform("specularMatrix", 16), e.addUniform("bumpMatrix", 16), e.addUniform("vTangentSpaceParams", 2), e.addUniform("pointSize", 1), e.addUniform("alphaCutOff", 1), e.addUniform("refractionMatrix", 16), e.addUniform("vRefractionInfos", 4), e.addUniform("vRefractionPosition", 3), e.addUniform("vRefractionSize", 3), e.addUniform("vSpecularColor", 4), e.addUniform("vEmissiveColor", 3), e.addUniform("vDiffuseColor", 4), e.addUniform("vAmbientColor", 3), super.buildUniformLayout();
  }
  /**
   * Binds the submesh to this material by preparing the effect and shader to draw
   * @param world defines the world transformation matrix
   * @param mesh defines the mesh containing the submesh
   * @param subMesh defines the submesh to bind the material to
   */
  bindForSubMesh(e, t, i) {
    var s;
    const r = this.getScene(), n = i.materialDefines;
    if (!n)
      return;
    const a = i.effect;
    if (!a)
      return;
    this._activeEffect = a, t.getMeshUniformBuffer().bindToEffect(a, "Mesh"), t.transferToEffect(e), this._uniformBuffer.bindToEffect(a, "Material"), this.prePassConfiguration.bindForSubMesh(this._activeEffect, r, t, e, this.isFrozen), this._eventInfo.subMesh = i, this._callbackPluginEventHardBindForSubMesh(this._eventInfo), n.OBJECTSPACE_NORMALMAP && (e.toNormalMatrix(this._normalMatrix), this.bindOnlyNormalMatrix(this._normalMatrix));
    const o = a._forceRebindOnNextCall || this._mustRebind(r, a, t.visibility);
    Re.BindBonesParameters(t, a);
    const l = this._uniformBuffer;
    if (o) {
      if (this.bindViewProjection(a), !l.useUbo || !this.isFrozen || !l.isSync || a._forceRebindOnNextCall) {
        if (V.FresnelEnabled && n.FRESNEL && (this.diffuseFresnelParameters && this.diffuseFresnelParameters.isEnabled && (l.updateColor4("diffuseLeftColor", this.diffuseFresnelParameters.leftColor, this.diffuseFresnelParameters.power), l.updateColor4("diffuseRightColor", this.diffuseFresnelParameters.rightColor, this.diffuseFresnelParameters.bias)), this.opacityFresnelParameters && this.opacityFresnelParameters.isEnabled && l.updateColor4("opacityParts", new ie(this.opacityFresnelParameters.leftColor.toLuminance(), this.opacityFresnelParameters.rightColor.toLuminance(), this.opacityFresnelParameters.bias), this.opacityFresnelParameters.power), this.reflectionFresnelParameters && this.reflectionFresnelParameters.isEnabled && (l.updateColor4("reflectionLeftColor", this.reflectionFresnelParameters.leftColor, this.reflectionFresnelParameters.power), l.updateColor4("reflectionRightColor", this.reflectionFresnelParameters.rightColor, this.reflectionFresnelParameters.bias)), this.refractionFresnelParameters && this.refractionFresnelParameters.isEnabled && (l.updateColor4("refractionLeftColor", this.refractionFresnelParameters.leftColor, this.refractionFresnelParameters.power), l.updateColor4("refractionRightColor", this.refractionFresnelParameters.rightColor, this.refractionFresnelParameters.bias)), this.emissiveFresnelParameters && this.emissiveFresnelParameters.isEnabled && (l.updateColor4("emissiveLeftColor", this.emissiveFresnelParameters.leftColor, this.emissiveFresnelParameters.power), l.updateColor4("emissiveRightColor", this.emissiveFresnelParameters.rightColor, this.emissiveFresnelParameters.bias))), r.texturesEnabled) {
          if (this._diffuseTexture && V.DiffuseTextureEnabled && (l.updateFloat2("vDiffuseInfos", this._diffuseTexture.coordinatesIndex, this._diffuseTexture.level), Re.BindTextureMatrix(this._diffuseTexture, l, "diffuse")), this._ambientTexture && V.AmbientTextureEnabled && (l.updateFloat2("vAmbientInfos", this._ambientTexture.coordinatesIndex, this._ambientTexture.level), Re.BindTextureMatrix(this._ambientTexture, l, "ambient")), this._opacityTexture && V.OpacityTextureEnabled && (l.updateFloat2("vOpacityInfos", this._opacityTexture.coordinatesIndex, this._opacityTexture.level), Re.BindTextureMatrix(this._opacityTexture, l, "opacity")), this._hasAlphaChannel() && l.updateFloat("alphaCutOff", this.alphaCutOff), this._reflectionTexture && V.ReflectionTextureEnabled && (l.updateFloat2("vReflectionInfos", this._reflectionTexture.level, this.roughness), l.updateMatrix("reflectionMatrix", this._reflectionTexture.getReflectionTextureMatrix()), this._reflectionTexture.boundingBoxSize)) {
            const c = this._reflectionTexture;
            l.updateVector3("vReflectionPosition", c.boundingBoxPosition), l.updateVector3("vReflectionSize", c.boundingBoxSize);
          }
          if (this._emissiveTexture && V.EmissiveTextureEnabled && (l.updateFloat2("vEmissiveInfos", this._emissiveTexture.coordinatesIndex, this._emissiveTexture.level), Re.BindTextureMatrix(this._emissiveTexture, l, "emissive")), this._lightmapTexture && V.LightmapTextureEnabled && (l.updateFloat2("vLightmapInfos", this._lightmapTexture.coordinatesIndex, this._lightmapTexture.level), Re.BindTextureMatrix(this._lightmapTexture, l, "lightmap")), this._specularTexture && V.SpecularTextureEnabled && (l.updateFloat2("vSpecularInfos", this._specularTexture.coordinatesIndex, this._specularTexture.level), Re.BindTextureMatrix(this._specularTexture, l, "specular")), this._bumpTexture && r.getEngine().getCaps().standardDerivatives && V.BumpTextureEnabled && (l.updateFloat3("vBumpInfos", this._bumpTexture.coordinatesIndex, 1 / this._bumpTexture.level, this.parallaxScaleBias), Re.BindTextureMatrix(this._bumpTexture, l, "bump"), r._mirroredCameraPosition ? l.updateFloat2("vTangentSpaceParams", this._invertNormalMapX ? 1 : -1, this._invertNormalMapY ? 1 : -1) : l.updateFloat2("vTangentSpaceParams", this._invertNormalMapX ? -1 : 1, this._invertNormalMapY ? -1 : 1)), this._refractionTexture && V.RefractionTextureEnabled) {
            let c = 1;
            if (this._refractionTexture.isCube || (l.updateMatrix("refractionMatrix", this._refractionTexture.getReflectionTextureMatrix()), this._refractionTexture.depth && (c = this._refractionTexture.depth)), l.updateFloat4("vRefractionInfos", this._refractionTexture.level, this.indexOfRefraction, c, this.invertRefractionY ? -1 : 1), this._refractionTexture.boundingBoxSize) {
              const u = this._refractionTexture;
              l.updateVector3("vRefractionPosition", u.boundingBoxPosition), l.updateVector3("vRefractionSize", u.boundingBoxSize);
            }
          }
        }
        this.pointsCloud && l.updateFloat("pointSize", this.pointSize), n.SPECULARTERM && l.updateColor4("vSpecularColor", this.specularColor, this.specularPower), l.updateColor3("vEmissiveColor", V.EmissiveTextureEnabled ? this.emissiveColor : ie.BlackReadOnly), l.updateColor4("vDiffuseColor", this.diffuseColor, this.alpha), r.ambientColor.multiplyToRef(this.ambientColor, this._globalAmbientColor), l.updateColor3("vAmbientColor", this._globalAmbientColor);
      }
      r.texturesEnabled && (this._diffuseTexture && V.DiffuseTextureEnabled && a.setTexture("diffuseSampler", this._diffuseTexture), this._ambientTexture && V.AmbientTextureEnabled && a.setTexture("ambientSampler", this._ambientTexture), this._opacityTexture && V.OpacityTextureEnabled && a.setTexture("opacitySampler", this._opacityTexture), this._reflectionTexture && V.ReflectionTextureEnabled && (this._reflectionTexture.isCube ? a.setTexture("reflectionCubeSampler", this._reflectionTexture) : a.setTexture("reflection2DSampler", this._reflectionTexture)), this._emissiveTexture && V.EmissiveTextureEnabled && a.setTexture("emissiveSampler", this._emissiveTexture), this._lightmapTexture && V.LightmapTextureEnabled && a.setTexture("lightmapSampler", this._lightmapTexture), this._specularTexture && V.SpecularTextureEnabled && a.setTexture("specularSampler", this._specularTexture), this._bumpTexture && r.getEngine().getCaps().standardDerivatives && V.BumpTextureEnabled && a.setTexture("bumpSampler", this._bumpTexture), this._refractionTexture && V.RefractionTextureEnabled && (this._refractionTexture.isCube ? a.setTexture("refractionCubeSampler", this._refractionTexture) : a.setTexture("refraction2DSampler", this._refractionTexture))), this.getScene().useOrderIndependentTransparency && this.needAlphaBlendingForMesh(t) && this.getScene().depthPeelingRenderer.bind(a), this._eventInfo.subMesh = i, this._callbackPluginEventBindForSubMesh(this._eventInfo), Ha(a, this, r), this.bindEyePosition(a);
    } else r.getEngine()._features.needToAlwaysBindUniformBuffers && (this._needToBindSceneUbo = !0);
    (o || !this.isFrozen) && (r.lightsEnabled && !this._disableLighting && Re.BindLights(r, t, a, n, this._maxSimultaneousLights), (r.fogEnabled && t.applyFog && r.fogMode !== ge.FOGMODE_NONE || this._reflectionTexture || this._refractionTexture || t.receiveShadows || n.PREPASS) && this.bindView(a), Re.BindFogParameters(r, t, a), n.NUM_MORPH_INFLUENCERS && Re.BindMorphTargetParameters(t, a), n.BAKED_VERTEX_ANIMATION_TEXTURE && ((s = t.bakedVertexAnimationManager) === null || s === void 0 || s.bind(a, n.INSTANCES)), this.useLogarithmicDepth && Re.BindLogDepth(n, a, r), this._imageProcessingConfiguration && !this._imageProcessingConfiguration.applyByPostProcess && this._imageProcessingConfiguration.bind(this._activeEffect)), this._afterBind(t, this._activeEffect), l.update();
  }
  /**
   * Get the list of animatables in the material.
   * @returns the list of animatables object used in the material
   */
  getAnimatables() {
    const e = super.getAnimatables();
    return this._diffuseTexture && this._diffuseTexture.animations && this._diffuseTexture.animations.length > 0 && e.push(this._diffuseTexture), this._ambientTexture && this._ambientTexture.animations && this._ambientTexture.animations.length > 0 && e.push(this._ambientTexture), this._opacityTexture && this._opacityTexture.animations && this._opacityTexture.animations.length > 0 && e.push(this._opacityTexture), this._reflectionTexture && this._reflectionTexture.animations && this._reflectionTexture.animations.length > 0 && e.push(this._reflectionTexture), this._emissiveTexture && this._emissiveTexture.animations && this._emissiveTexture.animations.length > 0 && e.push(this._emissiveTexture), this._specularTexture && this._specularTexture.animations && this._specularTexture.animations.length > 0 && e.push(this._specularTexture), this._bumpTexture && this._bumpTexture.animations && this._bumpTexture.animations.length > 0 && e.push(this._bumpTexture), this._lightmapTexture && this._lightmapTexture.animations && this._lightmapTexture.animations.length > 0 && e.push(this._lightmapTexture), this._refractionTexture && this._refractionTexture.animations && this._refractionTexture.animations.length > 0 && e.push(this._refractionTexture), e;
  }
  /**
   * Gets the active textures from the material
   * @returns an array of textures
   */
  getActiveTextures() {
    const e = super.getActiveTextures();
    return this._diffuseTexture && e.push(this._diffuseTexture), this._ambientTexture && e.push(this._ambientTexture), this._opacityTexture && e.push(this._opacityTexture), this._reflectionTexture && e.push(this._reflectionTexture), this._emissiveTexture && e.push(this._emissiveTexture), this._specularTexture && e.push(this._specularTexture), this._bumpTexture && e.push(this._bumpTexture), this._lightmapTexture && e.push(this._lightmapTexture), this._refractionTexture && e.push(this._refractionTexture), e;
  }
  /**
   * Specifies if the material uses a texture
   * @param texture defines the texture to check against the material
   * @returns a boolean specifying if the material uses the texture
   */
  hasTexture(e) {
    return !!(super.hasTexture(e) || this._diffuseTexture === e || this._ambientTexture === e || this._opacityTexture === e || this._reflectionTexture === e || this._emissiveTexture === e || this._specularTexture === e || this._bumpTexture === e || this._lightmapTexture === e || this._refractionTexture === e);
  }
  /**
   * Disposes the material
   * @param forceDisposeEffect specifies if effects should be forcefully disposed
   * @param forceDisposeTextures specifies if textures should be forcefully disposed
   */
  dispose(e, t) {
    var i, s, r, n, a, o, l, c, u;
    t && ((i = this._diffuseTexture) === null || i === void 0 || i.dispose(), (s = this._ambientTexture) === null || s === void 0 || s.dispose(), (r = this._opacityTexture) === null || r === void 0 || r.dispose(), (n = this._reflectionTexture) === null || n === void 0 || n.dispose(), (a = this._emissiveTexture) === null || a === void 0 || a.dispose(), (o = this._specularTexture) === null || o === void 0 || o.dispose(), (l = this._bumpTexture) === null || l === void 0 || l.dispose(), (c = this._lightmapTexture) === null || c === void 0 || c.dispose(), (u = this._refractionTexture) === null || u === void 0 || u.dispose()), this._imageProcessingConfiguration && this._imageProcessingObserver && this._imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingObserver), super.dispose(e, t);
  }
  /**
   * Makes a duplicate of the material, and gives it a new name
   * @param name defines the new name for the duplicated material
   * @param cloneTexturesOnlyOnce - if a texture is used in more than one channel (e.g diffuse and opacity), only clone it once and reuse it on the other channels. Default false.
   * @param rootUrl defines the root URL to use to load textures
   * @returns the cloned material
   */
  clone(e, t = !0, i = "") {
    const s = le.Clone(() => new V(e, this.getScene()), this, { cloneTexturesOnlyOnce: t });
    return s.name = e, s.id = e, this.stencil.copyTo(s.stencil), this._clonePlugins(s, i), s;
  }
  /**
   * Creates a standard material from parsed material data
   * @param source defines the JSON representation of the material
   * @param scene defines the hosting scene
   * @param rootUrl defines the root URL to use to load textures and relative dependencies
   * @returns a new standard material
   */
  static Parse(e, t, i) {
    const s = le.Parse(() => new V(e.name, t), e, t, i);
    return e.stencil && s.stencil.parse(e.stencil, t, i), F._parsePlugins(e, s, t, i), s;
  }
  // Flags used to enable or disable a type of texture for all Standard Materials
  /**
   * Are diffuse textures enabled in the application.
   */
  static get DiffuseTextureEnabled() {
    return be.DiffuseTextureEnabled;
  }
  static set DiffuseTextureEnabled(e) {
    be.DiffuseTextureEnabled = e;
  }
  /**
   * Are detail textures enabled in the application.
   */
  static get DetailTextureEnabled() {
    return be.DetailTextureEnabled;
  }
  static set DetailTextureEnabled(e) {
    be.DetailTextureEnabled = e;
  }
  /**
   * Are ambient textures enabled in the application.
   */
  static get AmbientTextureEnabled() {
    return be.AmbientTextureEnabled;
  }
  static set AmbientTextureEnabled(e) {
    be.AmbientTextureEnabled = e;
  }
  /**
   * Are opacity textures enabled in the application.
   */
  static get OpacityTextureEnabled() {
    return be.OpacityTextureEnabled;
  }
  static set OpacityTextureEnabled(e) {
    be.OpacityTextureEnabled = e;
  }
  /**
   * Are reflection textures enabled in the application.
   */
  static get ReflectionTextureEnabled() {
    return be.ReflectionTextureEnabled;
  }
  static set ReflectionTextureEnabled(e) {
    be.ReflectionTextureEnabled = e;
  }
  /**
   * Are emissive textures enabled in the application.
   */
  static get EmissiveTextureEnabled() {
    return be.EmissiveTextureEnabled;
  }
  static set EmissiveTextureEnabled(e) {
    be.EmissiveTextureEnabled = e;
  }
  /**
   * Are specular textures enabled in the application.
   */
  static get SpecularTextureEnabled() {
    return be.SpecularTextureEnabled;
  }
  static set SpecularTextureEnabled(e) {
    be.SpecularTextureEnabled = e;
  }
  /**
   * Are bump textures enabled in the application.
   */
  static get BumpTextureEnabled() {
    return be.BumpTextureEnabled;
  }
  static set BumpTextureEnabled(e) {
    be.BumpTextureEnabled = e;
  }
  /**
   * Are lightmap textures enabled in the application.
   */
  static get LightmapTextureEnabled() {
    return be.LightmapTextureEnabled;
  }
  static set LightmapTextureEnabled(e) {
    be.LightmapTextureEnabled = e;
  }
  /**
   * Are refraction textures enabled in the application.
   */
  static get RefractionTextureEnabled() {
    return be.RefractionTextureEnabled;
  }
  static set RefractionTextureEnabled(e) {
    be.RefractionTextureEnabled = e;
  }
  /**
   * Are color grading textures enabled in the application.
   */
  static get ColorGradingTextureEnabled() {
    return be.ColorGradingTextureEnabled;
  }
  static set ColorGradingTextureEnabled(e) {
    be.ColorGradingTextureEnabled = e;
  }
  /**
   * Are fresnels enabled in the application.
   */
  static get FresnelEnabled() {
    return be.FresnelEnabled;
  }
  static set FresnelEnabled(e) {
    be.FresnelEnabled = e;
  }
}
E([
  Jt("diffuseTexture")
], V.prototype, "_diffuseTexture", void 0);
E([
  Le("_markAllSubMeshesAsTexturesAndMiscDirty")
], V.prototype, "diffuseTexture", void 0);
E([
  Jt("ambientTexture")
], V.prototype, "_ambientTexture", void 0);
E([
  Le("_markAllSubMeshesAsTexturesDirty")
], V.prototype, "ambientTexture", void 0);
E([
  Jt("opacityTexture")
], V.prototype, "_opacityTexture", void 0);
E([
  Le("_markAllSubMeshesAsTexturesAndMiscDirty")
], V.prototype, "opacityTexture", void 0);
E([
  Jt("reflectionTexture")
], V.prototype, "_reflectionTexture", void 0);
E([
  Le("_markAllSubMeshesAsTexturesDirty")
], V.prototype, "reflectionTexture", void 0);
E([
  Jt("emissiveTexture")
], V.prototype, "_emissiveTexture", void 0);
E([
  Le("_markAllSubMeshesAsTexturesDirty")
], V.prototype, "emissiveTexture", void 0);
E([
  Jt("specularTexture")
], V.prototype, "_specularTexture", void 0);
E([
  Le("_markAllSubMeshesAsTexturesDirty")
], V.prototype, "specularTexture", void 0);
E([
  Jt("bumpTexture")
], V.prototype, "_bumpTexture", void 0);
E([
  Le("_markAllSubMeshesAsTexturesDirty")
], V.prototype, "bumpTexture", void 0);
E([
  Jt("lightmapTexture")
], V.prototype, "_lightmapTexture", void 0);
E([
  Le("_markAllSubMeshesAsTexturesDirty")
], V.prototype, "lightmapTexture", void 0);
E([
  Jt("refractionTexture")
], V.prototype, "_refractionTexture", void 0);
E([
  Le("_markAllSubMeshesAsTexturesDirty")
], V.prototype, "refractionTexture", void 0);
E([
  Ji("ambient")
], V.prototype, "ambientColor", void 0);
E([
  Ji("diffuse")
], V.prototype, "diffuseColor", void 0);
E([
  Ji("specular")
], V.prototype, "specularColor", void 0);
E([
  Ji("emissive")
], V.prototype, "emissiveColor", void 0);
E([
  R()
], V.prototype, "specularPower", void 0);
E([
  R("useAlphaFromDiffuseTexture")
], V.prototype, "_useAlphaFromDiffuseTexture", void 0);
E([
  Le("_markAllSubMeshesAsTexturesAndMiscDirty")
], V.prototype, "useAlphaFromDiffuseTexture", void 0);
E([
  R("useEmissiveAsIllumination")
], V.prototype, "_useEmissiveAsIllumination", void 0);
E([
  Le("_markAllSubMeshesAsTexturesDirty")
], V.prototype, "useEmissiveAsIllumination", void 0);
E([
  R("linkEmissiveWithDiffuse")
], V.prototype, "_linkEmissiveWithDiffuse", void 0);
E([
  Le("_markAllSubMeshesAsTexturesDirty")
], V.prototype, "linkEmissiveWithDiffuse", void 0);
E([
  R("useSpecularOverAlpha")
], V.prototype, "_useSpecularOverAlpha", void 0);
E([
  Le("_markAllSubMeshesAsTexturesDirty")
], V.prototype, "useSpecularOverAlpha", void 0);
E([
  R("useReflectionOverAlpha")
], V.prototype, "_useReflectionOverAlpha", void 0);
E([
  Le("_markAllSubMeshesAsTexturesDirty")
], V.prototype, "useReflectionOverAlpha", void 0);
E([
  R("disableLighting")
], V.prototype, "_disableLighting", void 0);
E([
  Le("_markAllSubMeshesAsLightsDirty")
], V.prototype, "disableLighting", void 0);
E([
  R("useObjectSpaceNormalMap")
], V.prototype, "_useObjectSpaceNormalMap", void 0);
E([
  Le("_markAllSubMeshesAsTexturesDirty")
], V.prototype, "useObjectSpaceNormalMap", void 0);
E([
  R("useParallax")
], V.prototype, "_useParallax", void 0);
E([
  Le("_markAllSubMeshesAsTexturesDirty")
], V.prototype, "useParallax", void 0);
E([
  R("useParallaxOcclusion")
], V.prototype, "_useParallaxOcclusion", void 0);
E([
  Le("_markAllSubMeshesAsTexturesDirty")
], V.prototype, "useParallaxOcclusion", void 0);
E([
  R()
], V.prototype, "parallaxScaleBias", void 0);
E([
  R("roughness")
], V.prototype, "_roughness", void 0);
E([
  Le("_markAllSubMeshesAsTexturesDirty")
], V.prototype, "roughness", void 0);
E([
  R()
], V.prototype, "indexOfRefraction", void 0);
E([
  R()
], V.prototype, "invertRefractionY", void 0);
E([
  R()
], V.prototype, "alphaCutOff", void 0);
E([
  R("useLightmapAsShadowmap")
], V.prototype, "_useLightmapAsShadowmap", void 0);
E([
  Le("_markAllSubMeshesAsTexturesDirty")
], V.prototype, "useLightmapAsShadowmap", void 0);
E([
  qs("diffuseFresnelParameters")
], V.prototype, "_diffuseFresnelParameters", void 0);
E([
  Le("_markAllSubMeshesAsFresnelDirty")
], V.prototype, "diffuseFresnelParameters", void 0);
E([
  qs("opacityFresnelParameters")
], V.prototype, "_opacityFresnelParameters", void 0);
E([
  Le("_markAllSubMeshesAsFresnelAndMiscDirty")
], V.prototype, "opacityFresnelParameters", void 0);
E([
  qs("reflectionFresnelParameters")
], V.prototype, "_reflectionFresnelParameters", void 0);
E([
  Le("_markAllSubMeshesAsFresnelDirty")
], V.prototype, "reflectionFresnelParameters", void 0);
E([
  qs("refractionFresnelParameters")
], V.prototype, "_refractionFresnelParameters", void 0);
E([
  Le("_markAllSubMeshesAsFresnelDirty")
], V.prototype, "refractionFresnelParameters", void 0);
E([
  qs("emissiveFresnelParameters")
], V.prototype, "_emissiveFresnelParameters", void 0);
E([
  Le("_markAllSubMeshesAsFresnelDirty")
], V.prototype, "emissiveFresnelParameters", void 0);
E([
  R("useReflectionFresnelFromSpecular")
], V.prototype, "_useReflectionFresnelFromSpecular", void 0);
E([
  Le("_markAllSubMeshesAsFresnelDirty")
], V.prototype, "useReflectionFresnelFromSpecular", void 0);
E([
  R("useGlossinessFromSpecularMapAlpha")
], V.prototype, "_useGlossinessFromSpecularMapAlpha", void 0);
E([
  Le("_markAllSubMeshesAsTexturesDirty")
], V.prototype, "useGlossinessFromSpecularMapAlpha", void 0);
E([
  R("maxSimultaneousLights")
], V.prototype, "_maxSimultaneousLights", void 0);
E([
  Le("_markAllSubMeshesAsLightsDirty")
], V.prototype, "maxSimultaneousLights", void 0);
E([
  R("invertNormalMapX")
], V.prototype, "_invertNormalMapX", void 0);
E([
  Le("_markAllSubMeshesAsTexturesDirty")
], V.prototype, "invertNormalMapX", void 0);
E([
  R("invertNormalMapY")
], V.prototype, "_invertNormalMapY", void 0);
E([
  Le("_markAllSubMeshesAsTexturesDirty")
], V.prototype, "invertNormalMapY", void 0);
E([
  R("twoSidedLighting")
], V.prototype, "_twoSidedLighting", void 0);
E([
  Le("_markAllSubMeshesAsTexturesDirty")
], V.prototype, "twoSidedLighting", void 0);
E([
  R("applyDecalMapAfterDetailMap")
], V.prototype, "_applyDecalMapAfterDetailMap", void 0);
E([
  Le("_markAllSubMeshesAsMiscDirty")
], V.prototype, "applyDecalMapAfterDetailMap", void 0);
E([
  R()
], V.prototype, "useLogarithmicDepth", null);
Xe("BABYLON.StandardMaterial", V);
ge.DefaultMaterialFactory = (h) => new V("default material", h);
const Rr = 30;
let Ms = Rr, cn = !0;
function fi(h) {
  return Ms = Rr, h._renderingQueueLaunched ? !1 : (Dd(h.scenes[0]), !kn);
}
function Cd(h, e) {
  const t = h.activeCamera, i = fi.bind(void 0, e);
  t.onViewMatrixChangedObservable.add(i), t.onMarkedDirtyObservable.add(i), e.onResizeObservable.add(i), h.onNewTextureAddedObservable.add(i), h.onNewGeometryAddedObservable.add(i);
  const s = h.removePendingData.bind(h);
  h.removePendingData = (r) => {
    fi(e), s(r);
  }, cn = !1;
}
function bo(h, e) {
  cn && (Cd(h, e), e.onDisposeObservable.add(() => {
    cn = !0, Ms = Rr;
  })), e.runRenderLoop(() => {
    document.visibilityState === "visible" && (h.animatables.length !== 0 && (Ms = Rr), h.render(), Ms--, Ms <= 0 && e.stopRenderLoop());
  });
}
function Dd(h) {
  kn || bo(h, h.getEngine());
}
let kn = !0;
function wd(h) {
  h.activeCamera.reset();
  const e = h.getEngine();
  e.stopRenderLoop();
  const t = e.getRenderingCanvas(), i = e.getHardwareScalingLevel(), s = t.clientWidth / i | 0, r = t.clientHeight / i | 0;
  (s !== t.width || r !== t.height) && s > 10 && r > 10 && e.resize(), bo(h, e), kn = !1;
}
const Od = {
  x: 1,
  y: 1,
  fixedWidthScaleX: 1,
  fixedWidthScaleY: 1
}, Fd = {}, Tt = {
  currentPan: !1,
  actuallyPanned: !1,
  currentRotation: !1
};
class Ld {
  constructor(e) {
    /** The pointerid, from event.pointerId */
    _e(this, "id");
    /** Current screen position */
    _e(this, "curP");
    /** Previous or initial screen position */
    _e(this, "prvP");
    _e(this, "prvPlane");
    _e(this, "prvGPS");
    _e(this, "centerDist", -1);
    this.id = e, this.curP = p.Zero(), this.prvP = p.Zero(), this.prvPlane = p.Zero(), this.prvGPS = p.Zero();
  }
  reset() {
    this.curP.copyFromFloats(0, 0, 0), this.prvP.copyFromFloats(0, 0, 0), this.prvPlane.copyFromFloats(0, 0, 0), this.prvGPS.copyFromFloats(0, 0, 0), this.centerDist = -1;
  }
}
let Ie, Vt, Si, _i;
const _a = {
  definedFocus: () => !1,
  // (dataModule.clickedBoat || dataModule.selectedBoat);
  definedFocusCb: () => p.Zero(),
  // getFocusPosition(dataModule)
  panWhenZoom: () => !0
  // !(dataModule.playing && (dataModule.fleetView || dataModule.selectedBoat || dataModule.clickedBoat));
};
let To, Zr = !0;
function Nd(h, e, t, i) {
  Si = e, _i = t, Vt = _i.getRenderingCanvas(), Ie = h, To = Ie.softLowerRadiusLimit || 0, Zr && (Zr = !1, zn = Dt.FromPositionAndNormal(p.Zero(), Et.Z), Ai = new Ae(p.Zero(), p.Zero()), Si.onPrePointerObservable.add(Vd, $.POINTERWHEEL, !0), Vt.addEventListener("pointerup", pa), Vt.addEventListener("pointerdown", kd), Vt.addEventListener("pointercancel", (s) => {
    pa(s);
  }), Vt.onselectstart = () => !1, Fd.__DEBUG__ && (Vt.addEventListener("pointerleave", () => {
  }), Vt.addEventListener("pointerout", () => {
  }), Vt.addEventListener("pointerenter", () => {
  })), Vt.oncontextmenu = (s) => {
    s.preventDefault();
  }, _i.onDisposeObservable.add(() => {
    Zr = !0, Vt = void 0, Ie = void 0, Si = void 0;
  }));
}
function gr(...h) {
  for (const e of h)
    Vt.addEventListener("pointermove", e);
}
function ws(...h) {
  for (const e of h)
    Vt.removeEventListener("pointermove", e);
}
function un(h) {
  Eo();
  const e = ir();
  return e !== null ? (h.prvPlane.copyFrom(e), !0) : !1;
}
function ir() {
  Si.createPickingRayToRef(Si.pointerX, Si.pointerY, I.Identity(), Ai, Ie);
  let h = Ai.intersectsPlane(zn);
  return h !== null ? Ai.origin.add(Ai.direction.scale(h)) : null;
}
function Ao() {
  const h = 0.5 * _i.getHardwareScalingLevel();
  Si.createPickingRayToRef(_i.getRenderWidth() * h, _i.getRenderHeight() * h, I.Identity(), Ai, Ie);
  let e = Ai.intersectsPlane(zn);
  return e !== null ? Ai.origin.add(Ai.direction.scale(e)) : null;
}
function Eo() {
  ir();
}
function Bd(h = !1) {
  0.5 * _i.getHardwareScalingLevel();
  const e = Ao();
  if (e) {
    const t = p.Distance(Ie.position, Ie.target), i = p.Distance(Ie.position, e);
    Ie.target.copyFrom(e), Ie.radius += i - t, h && (Ie.target, void 0);
  }
}
function Ud(h, e) {
  Eo();
  let t = Ao();
  if (t) {
    const i = p.Distance(Ie.position, Ie.target), s = p.Distance(Ie.position, t);
    Ie.target.copyFrom(t), Ie.radius += s - i;
  }
}
function Mo(h) {
  let e = 0;
  for (; e < gt.length; e++)
    if (gt[e].id === h)
      return e;
  return -1;
}
const mr = [], gt = [];
let Vn = !1, dn = !1, Wn = !1, Ki = 0, zn, Ai;
function kd(h) {
  Ki === 0 && (dn = !1), Ki++;
  let e;
  if (h.isPrimary && gt.length > 0) {
    for (const t of gt) {
      const i = gt.pop();
      i.reset(), mr.push(i);
    }
    Ki = 1;
  }
  if (mr.length === 0 ? (e = new Ld(h.pointerId), gt.push(e)) : (e = mr.pop(), e.id = h.pointerId, gt.push(e)), e.curP.copyFromFloats(h.clientX, h.clientY, 0), !(dn || Wn))
    if (Ie.inertia = 0.8, Bd(), Ki === 1)
      if (Ie.reset(), h.target.setPointerCapture(h.pointerId), h.button === 0) {
        if (!un(e))
          return;
        Tt.currentPan = !0, gr(Gs);
      } else h.button === 2 && (Tt.currentRotation = !0, gr(Ir));
    else
      Tt.currentRotation = Tt.actuallyPanned = Tt.currentPan = !1, zs(h, !0), Vn || (ws(Gs, Ir), gr(zs));
}
function pa(h) {
  const e = Mo(h.pointerId);
  if (e === -1)
    return;
  Ki--;
  const t = gt.splice(e, 1)[0];
  mr.push(t), h.target.releasePointerCapture(t.id), t.reset(), Ki === 0 ? (Tt.currentPan && (Tt.currentPan = !1, Tt.actuallyPanned = !1, ws(Gs)), Tt.currentRotation && (Tt.currentRotation = !1, ws(Ir)), Ie.inertia = 0.9, Wd(Ie, To), dn = !1) : Ki === 1 ? (ws(zs), gr(Gs), Tt.currentPan = !0, Tt.actuallyPanned = !1, pn = !0, gn = !0, Vn = !1, fn = !1, _n = !1) : zs(h, !0);
}
let ga = -1, Qr = -1, Ss = -1;
const ma = p.Zero(), lr = p.Zero(), Oi = p.Zero();
let fn = !1, _n = !1;
function zs(h, e = !1) {
  if (e) {
    ya(), ga = Qr = Ss, ma.copyFrom(Oi), lr.copyFrom(Oi);
    return;
  }
  const t = Mo(h.pointerId);
  if (t === -1)
    return;
  if (gt[t].curP.copyFromFloats(h.clientX, h.clientY, 0), ya(), fn) {
    const s = (Ss - Qr) / Ie.wheelPrecision;
    Ro(s);
  } else if (_n) {
    const s = Oi.x - lr.x, r = Oi.y - lr.y;
    So(s * 2, r);
  } else {
    const s = Ss - ga;
    Math.abs(s) > 20 ? fn = !0 : p.Distance(ma, Oi) > 30 && (_n = !0);
  }
  Qr = Ss, lr.copyFrom(Oi);
}
function ya() {
  let h, e, t, i;
  for (h = e = t = 0, i = 0; i < gt.length; i++)
    h += gt[i].curP.x, e += gt[i].curP.y;
  for (Oi.copyFromFloats(h / gt.length, e / gt.length, 0), i = 0; i < gt.length; i++)
    t += p.Distance(Oi, gt[i].curP);
  Ss = t / gt.length;
}
p.Zero();
let pn = !1, gn = !1;
function Gs(h) {
  if (!Tt.currentPan)
    return;
  const e = gt[0];
  if (e.curP.copyFromFloats(h.clientX, h.clientY, 0), pn) {
    e.prvP.copyFromFloats(h.clientX, h.clientY, 0), un(e), pn = !1;
    return;
  }
  if (gn) {
    p.Distance(e.prvP, e.curP) > 10 && (e.prvP.copyFromFloats(h.clientX, h.clientY, 0), un(e), gn = !1);
    return;
  }
  Ie.inertialRadiusOffset = 0;
  const t = ir();
  if (t === null)
    return;
  const i = e.prvPlane.subtract(t), s = i.x * (1 - Ie.inertia), r = i.y * (1 - Ie.inertia);
  Ie.inertialPanningX = s === 0 ? Ie.inertialPanningX : s, Ie.inertialPanningY = r === 0 ? Ie.inertialPanningY : r, fi(_i), Tt.actuallyPanned = !0;
}
function Ir(h) {
  if (!Tt.currentRotation)
    return;
  const e = gt[0], t = h.clientX - e.curP.x, i = h.clientY - e.curP.y;
  e.curP.copyFromFloats(h.clientX, h.clientY, 0), So(t, i), fi(_i);
}
function So(h, e) {
  const t = h / Ie.angularSensibilityX, i = e / Ie.angularSensibilityY;
  Ie.inertialAlphaOffset -= t, Ie.inertialBetaOffset -= i;
}
let va = -1;
function Vd(h, e) {
  const t = h.event;
  t.preventDefault();
  let i = t.wheelDelta;
  i ? i = i / (Ie.wheelPrecision * 40) : i = (-t.deltaY || -t.detail) / Ie.wheelPrecision, Ro(i * 2, Si.pointerX, Si.pointerY), clearTimeout(va), va = window.setTimeout(() => {
  }, 500), fi(_i);
}
function Wd(h, e) {
  const t = h.inertialRadiusOffset / (1 - h.inertia);
  h.radius - t < e && (h.radius < e ? h.inertialRadiusOffset = 0 : h.inertialRadiusOffset = (h.radius - e) * (1 - h.inertia));
}
let xa = -1, ba = -1;
const Ta = p.Zero();
function Ro(h, e, t) {
  if (h = Xd(h, Ie.lowerRadiusLimit, Ie), h === 0)
    return;
  const i = h / (1 - Ie.inertia);
  if (e !== void 0 && t !== void 0) {
    const s = i / Ie.radius;
    let r;
    if (h > 0 && _a.definedFocus() && (r = _a.definedFocusCb()), r === void 0 && (Math.abs(e - xa) > 1 || Math.abs(t - ba) > 1 ? (xa = e, ba = t, Ud(), r = ir(), r === null && (r = Ie.target.clone()), Ta.copyFrom(r)) : r = Ta), r === null) return;
    r.subtractToRef(Ie.target, C.Vector3[0]);
    const n = C.Vector3[0].scaleInPlace(s);
    Ie.inertialPanningX += n.x * (1 - Ie.inertia), Ie.inertialPanningY += n.y * (1 - Ie.inertia);
  }
  Ie.inertialRadiusOffset += h;
}
function zd(h = !0) {
  Tt.currentPan = Tt.actuallyPanned = Tt.currentRotation = Vn = !1, ws(Gs, Ir, zs), h && (Vt.style.pointerEvents = "none"), Wn = !0;
}
function Gd() {
  Vt.style.removeProperty("pointer-events"), setTimeout(() => {
    Wn = !1;
  }, 0);
}
function Xd(h, e, t) {
  const i = t.radius - e;
  return i < 1 && h > 0 ? 0 : t.upperRadiusLimit === null ? h : t.upperRadiusLimit - t.radius < 1 && h < 0 ? 0 : (h > 0 && t.radius - (t.inertialRadiusOffset + h) / (1 - t.inertia) < e ? h = i * (1 - t.inertia) - t.inertialRadiusOffset : h < 0 && t.radius - (t.inertialRadiusOffset + h) / (1 - t.inertia) > t.upperRadiusLimit && (h = (t.radius - t.upperRadiusLimit) * (1 - t.inertia) - t.inertialRadiusOffset), h);
}
let xe, at;
function Hd(h) {
  if (xe !== void 0) throw "Scene should only be set once";
  xe = h, xe.getEngine().onDisposeObservable.add(() => {
    xe = void 0;
  }), window.scene = xe;
}
function Kd(h) {
  if (at !== void 0) throw "Engine should only be set once";
  at = h, at.onDisposeObservable.add(() => {
    at = void 0;
  }), window.engine = at;
}
var Io = /* @__PURE__ */ ((h) => (h[h.HIDDEN = 0] = "HIDDEN", h[h.DASHED = 1] = "DASHED", h[h.SOLID = 2] = "SOLID", h))(Io || {});
class Yd extends K {
  constructor(e, t, i, s, r) {
    super(e, t);
  }
}
const qd = {
  lineWidth: 4,
  initialLineStyle: Io.SOLID,
  softEdges: !1,
  zOffset: 0,
  ownMaterial: !1,
  dashOptions: {
    dashMeters: 1,
    gapMeters: 2.5,
    minimumDashes: 5,
    solidCorners: []
  },
  baseColor: ie.Black()
};
function $r(h, e, t, i = new p()) {
  h.createPickingRayToRef(h.pointerX, h.pointerY, I.Identity(), t, h.activeCamera);
  const s = t.intersectsPlane(e);
  return s === null ? null : (i.copyFrom(t.direction), i.scaleInPlace(s), i.addInPlace(t.origin), i);
}
ue.Zero();
ue.Zero();
ue.Zero();
function jd(h, e, t) {
  return h + (e - h) * t;
}
const Zd = `#define MAX_LINE_GROUPS 16\r
precision highp float;\r
\r
// Attributes\r
attribute vec4 position; // w is gap, true or false\r
attribute vec4 normal_index;\r
attribute vec4 colour_proportion;\r
\r
// Uniforms\r
uniform mat4 worldViewProjection;\r
uniform mat4 invWVP;\r
uniform float lerpArray[MAX_LINE_GROUPS];\r
uniform float renderWidth;\r
/*\r
    rgba for each line  \r
    r -> Line style  \r
    ---> Lower 3 bits for line style\r
        ---> 0 = hidden, 1 = dashed, 2 = solid\r
    ---> Upper 5 bits for line width (so max width of 32px (1 is added to value))\r
    g -> animation index  \r
    ---> 0 for no animation, 1-255 for animation n - 1  \r
    b -> pickId high bits  \r
    a -> pickId low bits  \r
*/\r
uniform sampler2D textureSampler;\r
uniform vec2 texelWidths;\r
uniform float heightOffset;\r
uniform float pickRenderPass;\r
uniform float fade;\r
\r
// Varyings\r
varying vec3 vColor;\r
varying float vAnimProgress;\r
varying float vCut;\r
varying float vProportion;\r
\r
void main(void) {\r
\r
  vec4 lineInfoTex = texture2D(\r
      textureSampler, vec2(normal_index.w * texelWidths.x + texelWidths.y, 0)\r
  );\r
  float lineStyleAndWidth = floor(lineInfoTex.r * 255.0 + 0.5);\r
  float lineWidth = floor(lineStyleAndWidth / 8.);\r
  float lineStyle = floor(lineStyleAndWidth + 0.5 - lineWidth * 8.);\r
  lineWidth += 1.0; // to make range 1-32 instead of 0-31\r
  lineWidth *= (1.0 - fade);\r
\r
  vec3 pos = position.xyz;\r
  pos.z += heightOffset; // lines slightly above ground\r
  vec3 normal = normal_index.xyz;\r
\r
  // expand to get desired width (should be a uniform)\r
  float width = lineWidth * (1. - pickRenderPass) + pickRenderPass * (lineWidth * 2. + 3.);\r
  vec4 glPos = worldViewProjection * vec4(pos, 1.0);\r
  vec4 ndc = glPos / glPos.w;\r
  ndc.x += 100. / renderWidth; // 1, not 2 as want half a pixel | Precision issue,\r
  vec4 inv = invWVP * ndc;                                   // | so need to multiply\r
  inv.xyz /= inv.w;                                          // | by 100 then divide\r
  float dist = length(inv.xyz - pos) / 100.;                 // | by 100, else size varies greatly\r
\r
  // Previously using:\r
  //   float camDist = length(cameraPosition - pos) / 1800.0;\r
  // which seemed to approximate pixel width. This however did depend on the\r
  // vertical resolution being around 1000px.\r
\r
  gl_Position = worldViewProjection * vec4(pos + normal * dist * width, 1.0);\r
\r
  int animIdx = int(lineInfoTex.g * 255.0 + 0.5);\r
  vAnimProgress = lerpArray[animIdx];\r
\r
  float hideLine = step(lineStyle, 0.9); // 0 if lineStyle > 0\r
  float solidLine = step(1.5, lineStyle); // 1 if lineStyle > 1\r
  float animProgressZero = 1. - ceil(vAnimProgress); // so whole line cut if animProgress is zero\r
  vCut = (position.w + hideLine) * (1. - solidLine) + animProgressZero;\r
\r
  vProportion = colour_proportion.w;\r
\r
  // Either line colour, or pickColour, depending on renderpass\r
  vColor = colour_proportion.xyz * (1. - pickRenderPass) + pickRenderPass * vec3(0., lineInfoTex.b, lineInfoTex.a);\r
}\r
`, Qd = `precision mediump float;\r
\r
uniform vec3 baseColor;\r
\r
varying vec3 vColor;\r
varying float vProportion;\r
varying float vAnimProgress;\r
varying float vCut;\r
\r
void main(void) {\r
    // hide if cut (hidden or dashed), or not yet animated in\r
    if (vCut != 0. || vProportion > vAnimProgress) {\r
        discard;\r
    }\r
\r
    gl_FragColor = vec4(vColor + baseColor, 1.0);\r
}\r
`, $d = 15, Jr = -8, Fi = class Fi extends Yd {
  // public set material(value: Nullable<Material>) {
  /** For now just have a single colour per line (if possible).  
   *  Soft edges is quite expensive (GPU wise) because of the resultant overdraw, and isn't noticeable for thinner lines.  
   *  Should visually test if worthwhile for each case.  
   */
  constructor(t, i, s, r, n, a) {
    super(t, i, s, r, n);
    _e(this, "posDashArr");
    // buffer
    _e(this, "normIdxArr");
    // buffer
    _e(this, "colPropArr");
    // buffer
    _e(this, "indexArr");
    // index buffer
    _e(this, "lineIndexOffsets", []);
    // start offsets into the above buffers for each line
    _e(this, "lerpValues", Array($d + 1).fill(1));
    // uniform array. Add 1 as index 0 preserved as default lerp lookup of 1.
    _e(this, "_softEdges");
    _e(this, "numLines");
    /**
    16x16x4 length of array (so can address 16*16 lines)  
    rgba for each line  
    - r: Line style and width
        - Lower 3 bits for line style
            - 0 = hidden, 1 = dashed, 2 = solid
        - Upper 5 bits for line width (so max width of 32px (1 is added to value))
    - g: animation index
        - 0 for no animation, 1-255 for animation n - 1
    - b: pickId high bits
    - a: pickId low bits
    */
    _e(this, "_dataTextureArray");
    _e(this, "_dataTexture");
    _e(this, "renderPickColours", !1);
    _e(this, "fb");
    _e(this, "pickingRenderTexture");
    _e(this, "inverseWorldMatrix", new I());
    _e(this, "worldMatrixFlag", -1);
    _e(this, "inverseTransformFlag", -1);
    _e(this, "invertedWorldViewProj", new I());
    _e(this, "resolvedOptions");
    /** [Lerp index, duration, cb] */
    _e(this, "pendingAnimations", []);
    _e(this, "_activeAnimations", /* @__PURE__ */ new Map());
    _e(this, "anCallback");
    _e(this, "animEndEvent", new CustomEvent("animationFinished"));
    const o = { ...qd, ...n || {} };
    o.dashOptions === null && (o.dashOptions = { dashMeters: 0, gapMeters: 0, minimumDashes: 0, solidCorners: [] }), this.resolvedOptions = o, this.numLines = s.length;
    const l = Math.max(Math.pow(2, Math.ceil(Math.log2(Math.sqrt(this.numLines)))), 16);
    this._dataTextureArray = new Uint8Array(l * l * 4), this._softEdges = o.softEdges;
    let c;
    o.ownMaterial ? typeof o.ownMaterial == "boolean" ? (this.initShaders(), c = this.makeMaterial()) : c = o.ownMaterial : (Fi.lineMat || (this.initShaders(), Fi.lineMat = this.makeMaterial()), c = Fi.lineMat), this.material = c;
    const u = 1 / (l * l);
    if (c.setVector2("texelWidths", new ue(u, u / 2)), this.constructVertexData(s, r, 5, o.dashOptions), this.setIndices(this.indexArr), this.setVerticesData(v.PositionKind, this.posDashArr, !1, 4), this.setVerticesData("normal_index", this.normIdxArr, !1, 4), this.setVerticesData("colour_proportion", this.colPropArr, !1, 4), c.setFloats("lerpArray", this.lerpValues), c.setFloat("heightOffset", o.zOffset), c.setColor3("baseColor", o.baseColor), c.setFloat("fade", 0), a) {
      const _ = a.idColours;
      this.renderPickColours = !0;
      for (let g = 0; g < _.length; g++)
        this.setPickColour(g, _[g]);
      this.fb = a.fb, this.pickingRenderTexture = a.renderTex;
    }
    this.initialiseWidthAndStyle(s, o);
    const f = new qt(
      this._dataTextureArray,
      l * l,
      1,
      L.TEXTUREFORMAT_RGBA,
      i,
      !1,
      !1,
      W.LINEAR_LINEAR,
      L.TEXTURETYPE_UNSIGNED_BYTE
    );
    f.name = "tubeLineDataTex", c.setTexture("textureSampler", f), this._dataTexture = f, this.onAfterWorldMatrixUpdateObservable.add(() => {
      this._worldMatrix.invertToRef(this.inverseWorldMatrix);
    }), this.freezeWorldMatrix(), c.freeze(), this.isPickable = !1, this.alwaysSelectAsActiveMesh = !0;
  }
  constructVertexData(t, i, s, r) {
    const n = t.reduce((D, O) => D + O.length, 0), o = t.map((D) => {
      let O = 0;
      for (let X = 1; X < D.length; X++)
        O += p.Distance(D[X], D[X - 1]);
      return O;
    }).map(
      (D) => this.getDashGapDistance(D, r.dashMeters, r.gapMeters, r.minimumDashes)
    ), l = o.reduce((D, O) => D + O.numDashes * 2 - 2 + O.numGaps, 0), c = (n + l) * s * 4, u = new Float32Array(c), d = new Float32Array(c), f = new Float32Array(c);
    let _ = 0, g;
    const m = n + l, y = l + t.length * 2, x = (m - t.length) * 6 * s + y * 3 * (s - 2);
    let A;
    c / 4 >= 65535 ? A = new Uint32Array(x) : A = new Uint16Array(x);
    let T = 0;
    const M = new p(), b = C.Matrix[0], S = Math.PI * 2 / s, P = 4 * s;
    for (let D = 0; D < t.length; D++) {
      this.lineIndexOffsets.push(_);
      const O = t[D], X = new Us(O), k = X.getDistances(), Y = X.getNormals(), se = X.getTangents(), Te = k[k.length - 1], { dash: ve, gap: Oe } = o[D];
      let Ne = 0, ke = ve;
      g = O[0];
      const Se = i[D];
      T = this.constructClosedFaceForRing(A, T, _ / P, s, !0);
      const Be = [];
      for (let Me = 0; Me < O.length; Me++) {
        const je = O[Me], Rt = se[Me], oi = Y[Me];
        if (r.solidCorners[D] && Me < O.length - 1) {
          const it = se[Me + 1];
          p.Dot(Rt, it) < 0.95 && Be.push(_);
        }
        const Mt = k[Me];
        for (; ke < Mt && Te - ve / 2 > ke; ) {
          T = this.constructIndicesForRing(A, T, _ / P, s), Ne !== 0.5 && (T = this.constructClosedFaceForRing(A, T, _ / P, s, !!Ne));
          const it = k[Me - 1], Xt = (ke - it) / (Mt - it), xt = jd(it, Mt, Xt), Ht = C.Vector3[0], Fe = C.Vector3[1], ce = C.Vector3[2];
          p.LerpToRef(g, je, Xt, Ht), p.LerpToRef(Y[Me - 1], Y[Me], Xt, Fe), p.LerpToRef(se[Me - 1], se[Me], Xt, ce), Fe.normalize(), ce.normalize();
          for (let tt = 0; tt < s; tt++)
            u[_] = Ht.x, u[_ + 1] = Ht.y, u[_ + 2] = Ht.z, u[_ + 3] = Ne % 1, I.RotationAxisToRef(ce, S * tt, b), p.TransformCoordinatesToRef(Fe, b, M), d[_] = M.x, d[_ + 1] = M.y, d[_ + 2] = M.z, d[_ + 3] = D, f[_] = Se.r, f[_ + 1] = Se.g, f[_ + 2] = Se.b, f[_ + 3] = xt / Te, _ += 4;
          Ne < 1 ? (Ne += 0.5, ke += Oe / 2) : (Ne = 0, ke += ve);
        }
        Me < O.length - 1 && (T = this.constructIndicesForRing(A, T, _ / P, s));
        for (let it = 0; it < s; it++)
          u[_] = je.x, u[_ + 1] = je.y, u[_ + 2] = je.z, u[_ + 3] = Ne, I.RotationAxisToRef(Rt, S * it, b), p.TransformCoordinatesToRef(oi, b, M), d[_] = M.x, d[_ + 1] = M.y, d[_ + 2] = M.z, d[_ + 3] = D, f[_] = Se.r, f[_ + 1] = Se.g, f[_ + 2] = Se.b, f[_ + 3] = k[Me] / Te, _ += 4;
        g = je;
      }
      if (r.solidCorners[D])
        for (let Me of Be) {
          let je = Me + 3 - 4 * s;
          for (je; je < Me + 5 * 4 * s; je += 4)
            je > 0 && je < u.length && (u[je] = 0);
        }
      T = this.constructClosedFaceForRing(A, T, (_ - P) / P, s, !1);
    }
    this.posDashArr = u, this.normIdxArr = d, this.colPropArr = f, this.indexArr = A;
  }
  /** Get take and drop distance based on desired dash ang gap distance,
   *  adjusting those distances so that the line starts and ends with a dash,
   *  and has at least the specified number of dashes
   *  @returns A vec3 of (dashLength, gapLength, numDashes)
   */
  getDashGapDistance(t, i, s, r, n = { dash: 0, gap: 0, numDashes: 0, numGaps: 0 }) {
    let a = s / i;
    (i === 0 || s === 0) && (i = 1 / 0, s = 1 / 0, a = 1);
    const o = Math.max(t / (i + s), r - 1) | 0, l = t / (1 + (1 + a) * o), c = a * l;
    return n.dash = l, n.gap = c, n.numDashes = o + 1, n.numGaps = o, n;
  }
  /** Get indices to construct ring triangles from point to next point */
  constructIndicesForRing(t, i, s, r) {
    const n = s;
    let a = i;
    for (let l = 0; l < r - 1; l++)
      t[a + 0] = l + r * n, t[a + 1] = l + r * (n + 1), t[a + 2] = l + r * (n + 1) + 1, t[a + 3] = l + r * n, t[a + 4] = l + r * (n + 1) + 1, t[a + 5] = l + r * n + 1, a += 6;
    const o = r - 1;
    return t[a + 0] = o + r * n, t[a + 1] = o + r * (n + 1), t[a + 2] = r * (n + 1), t[a + 3] = o + r * n, t[a + 4] = r * (n + 1), t[a + 5] = r * n, a += 6, a;
  }
  constructClosedFaceForRing(t, i, s, r, n) {
    const a = s;
    let o = i;
    const l = 2 - +n, c = 1 + +n;
    for (let u = 0; u < r - 2; u++)
      t[o + 0] = 0 + r * a, t[o + l] = u + r * a + 1, t[o + c] = u + r * a + 2, o += 3;
    return o;
  }
  setPickColour(t, i) {
    const s = t * 4 + 2;
    this._dataTextureArray[s] = i.x, this._dataTextureArray[s + 1] = i.y;
  }
  initialiseWidthAndStyle(t, i) {
    const { lineWidth: s, initialLineStyle: r } = i, n = this._dataTextureArray;
    if (typeof s == "number")
      if (Array.isArray(r)) {
        const a = s - 1 << 3;
        for (let o = 0, l = 0; o < t.length * 4; o += 4, l++)
          n[o] = a + r[l];
      } else {
        const a = (s - 1 << 3) + r;
        for (let o = 0; o < t.length * 4; o += 4)
          n[o] = a;
      }
    else if (Array.isArray(r))
      for (let a = 0, o = 0; a < t.length * 4; a += 4, o++)
        n[a] = (s[o] - 1 << 3) + r[o];
    else
      for (let a = 0, o = 0; a < t.length * 4; a += 4, o++)
        n[a] = (s[o] - 1 << 3) + r;
  }
  setLineSize(t, i) {
    const s = t * 4;
    this._dataTextureArray[s] &= 7, this.setClearedLineSize(s, i);
  }
  setClearedLineSize(t, i) {
    this._dataTextureArray[t] += i - 1 << 3;
  }
  setLineColour(t, i) {
    const s = this.lineIndexOffsets[t], r = t < this.numLines - 1 ? this.lineIndexOffsets[t + 1] : this.posDashArr.length;
    for (let n = s; n < r; n += 4)
      this.colPropArr[n] = i.r, this.colPropArr[n + 1] = i.g, this.colPropArr[n + 2] = i.b;
  }
  setBaseColour(t) {
    this.resolvedOptions.baseColor = t, this.material.setColor3("baseColor", t);
  }
  /** Separate function so can batch colour updates */
  updateColorVertexData() {
    this.setVerticesData("colour_proportion", this.colPropArr, !1, 4);
  }
  updateTextureData() {
    this._dataTexture.update(this._dataTextureArray);
  }
  setSolidLine(t) {
    const i = t * 4;
    this._dataTextureArray[i] &= Jr, this._dataTextureArray[i] += 2;
  }
  setDashedLine(t) {
    const i = t * 4;
    this._dataTextureArray[i] &= Jr, this._dataTextureArray[i] += 1;
  }
  setHiddenLine(t) {
    const i = t * 4;
    this._dataTextureArray[i] &= Jr;
  }
  setAllDashed() {
    for (let t = 0; t < this.numLines; t++)
      this.setDashedLine(t);
  }
  setAllSolid() {
    for (let t = 0; t < this.numLines; t++)
      this.setSolidLine(t);
  }
  setAnimatedLine(t, i, s, r) {
    const n = t * 4 + 1;
    let a = this._dataTextureArray[n];
    if (!a)
      for (a = 1; a < this.lerpValues.length && this.lerpValues[a] !== 1; a++)
        ;
    if (a >= this.lerpValues.length) {
      console.log("Too many animations. Only the first 15 will animate.");
      return;
    }
    this.disposeAnimation(a, !0), this.lerpValues[a] = 0, this._dataTextureArray[n] = a, this.pendingAnimations.push({ lerpIdx: a, lineIdx: t, duration: i, cb: s, easeFn: r });
  }
  resetAnimationData() {
    for (let t = 0; t < this.numLines; t++) {
      const i = t * 4 + 1;
      this._dataTextureArray[i] = 0;
    }
  }
  /** Dispose animation of lerp index - will do nothing if no animation for that index. */
  disposeAnimation(t, i) {
    const s = this._activeAnimations.get(t);
    s && (i || s.onAnimationEndObservable.notifyObservers(void 0), s.onAnimationEndObservable.clear(), s.stop());
  }
  clearAnimations(t) {
    xe.onBeforeRenderObservable.removeCallback(this.anCallback);
    for (let i of this._activeAnimations.keys())
      this.disposeAnimation(i, t);
    this.lerpValues.fill(1), this.pendingAnimations.length = 0, this.resetAnimationData();
  }
  animateSection() {
    this.lerpValues.reduce((t, i) => t + i, 0) === this.lerpValues.length && this.stopAnimation();
  }
  addRenderObservable() {
    xe.onBeforeRenderObservable.removeCallback(this.anCallback), this.anCallback = this.animateSection.bind(this);
    const t = xe.onBeforeRenderObservable.add(this.anCallback);
    t.name = "lineAnimCallback";
  }
  startPendingAnimations() {
    if (this.updateTextureData(), this.pendingAnimations.length !== 0) {
      this.addRenderObservable();
      for (let t of this.pendingAnimations) {
        const { lerpIdx: i, lineIdx: s, duration: r, cb: n, easeFn: a } = t, o = `arcAnim${this.uniqueId}${i}`;
        let l = B.CreateAndStartAnimation(
          o,
          this,
          `lerpValues.${i}`,
          60,
          60 * r / 1e3,
          0,
          1,
          B.ANIMATIONLOOPMODE_CONSTANT,
          a,
          () => {
            this._dataTextureArray[s * 4 + 1] = 0, this._activeAnimations.delete(i);
          }
        );
        l.onAnimationEndObservable.add(n), this._activeAnimations.set(i, l);
      }
      this.pendingAnimations.length = 0, fi(at);
    }
  }
  stopAnimation() {
    xe.onBeforeRenderObservable.removeCallback(this.anCallback), document.dispatchEvent(this.animEndEvent);
  }
  /**
   * Overrides mesh._draw().
   * Doing this so can draw twice, once with depth write enabled, and once
   * without. This is so that we get nice smoothing of the edges, but the bulk
   * of the line renders in the correct order.
  */
  _draw(t, i, s) {
    this.onBeforeDrawObservable.notifyObservers(this);
    const r = this.material.getEffect(), n = Jd(), a = this.inverseTransformFlag !== n.updateFlag;
    if ((this.worldMatrixFlag !== this._worldMatrix.updateFlag || a) && (this.worldMatrixFlag = this._worldMatrix.updateFlag, this.inverseTransformFlag = n.updateFlag, n.multiplyToRef(this.inverseWorldMatrix, this.invertedWorldViewProj)), r.setMatrix("invWVP", this.invertedWorldViewProj), r.setFloat("renderWidth", at.getRenderWidth() * Od.x), this._unIndexed || i == F.PointFillMode ? at.drawArraysType(i, t.verticesStart, t.verticesCount, s) : i == F.WireFrameFillMode ? at.drawElementsType(i, 0, t._linesIndexCount, s) : at.drawElementsType(i, t.indexStart, t.indexCount, s), !this.renderPickColours) return this;
    r.setFloat("pickRenderPass", 1);
    const l = at._gl;
    l.bindFramebuffer(l.FRAMEBUFFER, this.fb);
    const c = l.COLOR_ATTACHMENT0;
    l.framebufferTexture2D(l.FRAMEBUFFER, c, l.TEXTURE_2D, this.pickingRenderTexture, 0);
    const u = at._uintIndicesCurrentlySet ? l.UNSIGNED_INT : l.UNSIGNED_SHORT, d = at._uintIndicesCurrentlySet ? 4 : 2;
    return l.drawElements(at._drawMode(i), t.indexCount, u, t.indexStart * d), l.bindFramebuffer(l.FRAMEBUFFER, null), r.setFloat("pickRenderPass", 0), this;
  }
  makeMaterial() {
    const t = "tubeLines";
    return new Ri("tubeLinesMat", xe, {
      vertex: t,
      fragment: t
    }, {
      attributes: ["position", "normal_index", "colour_proportion"],
      uniforms: [
        "worldViewProjection",
        "invWVP",
        "lerpArray",
        "textureSampler",
        "heightOffset",
        "pickRenderPass",
        "renderWidth",
        "texelWidths",
        "baseColor",
        "fade"
      ],
      needAlphaBlending: !1
      //this._softEdges
    });
  }
  initShaders() {
    const t = "tubeLines";
    yt.ShadersStore[`${t}VertexShader`] = Zd, yt.ShadersStore[`${t}FragmentShader`] = Qd;
  }
  dispose(t, i = !1) {
    this.clearAnimations(!0), super.dispose(t, i || this.material !== Fi.lineMat), this._dataTexture.dispose();
  }
};
_e(Fi, "lineMat");
let mn = Fi;
const Aa = new I();
let Ea = -1;
function Jd() {
  const h = xe.getTransformMatrix();
  return h.updateFlag !== Ea && (Ea = h.updateFlag, h.invertToRef(Aa)), Aa;
}
function Po(h, e, t = 2) {
  const i = e && e.length, s = i ? e[0] * t : h.length;
  let r = Co(h, 0, s, t, !0);
  const n = [];
  if (!r || r.next === r.prev) return n;
  let a, o, l;
  if (i && (r = nf(h, e, r, t)), h.length > 80 * t) {
    a = 1 / 0, o = 1 / 0;
    let c = -1 / 0, u = -1 / 0;
    for (let d = t; d < s; d += t) {
      const f = h[d], _ = h[d + 1];
      f < a && (a = f), _ < o && (o = _), f > c && (c = f), _ > u && (u = _);
    }
    l = Math.max(c - a, u - o), l = l !== 0 ? 32767 / l : 0;
  }
  return Xs(r, n, t, a, o, l, 0), n;
}
function Co(h, e, t, i, s) {
  let r;
  if (s === gf(h, e, t, i) > 0)
    for (let n = e; n < t; n += i) r = Ma(n / i | 0, h[n], h[n + 1], r);
  else
    for (let n = t - i; n >= e; n -= i) r = Ma(n / i | 0, h[n], h[n + 1], r);
  return r && Ur(r, r.next) && (Ks(r), r = r.next), r;
}
function $i(h, e) {
  if (!h) return h;
  e || (e = h);
  let t = h, i;
  do
    if (i = !1, !t.steiner && (Ur(t, t.next) || rt(t.prev, t, t.next) === 0)) {
      if (Ks(t), t = e = t.prev, t === t.next) break;
      i = !0;
    } else
      t = t.next;
  while (i || t !== e);
  return e;
}
function Xs(h, e, t, i, s, r, n) {
  if (!h) return;
  !n && r && cf(h, i, s, r);
  let a = h;
  for (; h.prev !== h.next; ) {
    const o = h.prev, l = h.next;
    if (r ? tf(h, i, s, r) : ef(h)) {
      e.push(o.i, h.i, l.i), Ks(h), h = l.next, a = l.next;
      continue;
    }
    if (h = l, h === a) {
      n ? n === 1 ? (h = sf($i(h), e), Xs(h, e, t, i, s, r, 2)) : n === 2 && rf(h, e, t, i, s, r) : Xs($i(h), e, t, i, s, r, 1);
      break;
    }
  }
}
function ef(h) {
  const e = h.prev, t = h, i = h.next;
  if (rt(e, t, i) >= 0) return !1;
  const s = e.x, r = t.x, n = i.x, a = e.y, o = t.y, l = i.y, c = s < r ? s < n ? s : n : r < n ? r : n, u = a < o ? a < l ? a : l : o < l ? o : l, d = s > r ? s > n ? s : n : r > n ? r : n, f = a > o ? a > l ? a : l : o > l ? o : l;
  let _ = i.next;
  for (; _ !== e; ) {
    if (_.x >= c && _.x <= d && _.y >= u && _.y <= f && os(s, a, r, o, n, l, _.x, _.y) && rt(_.prev, _, _.next) >= 0) return !1;
    _ = _.next;
  }
  return !0;
}
function tf(h, e, t, i) {
  const s = h.prev, r = h, n = h.next;
  if (rt(s, r, n) >= 0) return !1;
  const a = s.x, o = r.x, l = n.x, c = s.y, u = r.y, d = n.y, f = a < o ? a < l ? a : l : o < l ? o : l, _ = c < u ? c < d ? c : d : u < d ? u : d, g = a > o ? a > l ? a : l : o > l ? o : l, m = c > u ? c > d ? c : d : u > d ? u : d, y = yn(f, _, e, t, i), x = yn(g, m, e, t, i);
  let A = h.prevZ, T = h.nextZ;
  for (; A && A.z >= y && T && T.z <= x; ) {
    if (A.x >= f && A.x <= g && A.y >= _ && A.y <= m && A !== s && A !== n && os(a, c, o, u, l, d, A.x, A.y) && rt(A.prev, A, A.next) >= 0 || (A = A.prevZ, T.x >= f && T.x <= g && T.y >= _ && T.y <= m && T !== s && T !== n && os(a, c, o, u, l, d, T.x, T.y) && rt(T.prev, T, T.next) >= 0)) return !1;
    T = T.nextZ;
  }
  for (; A && A.z >= y; ) {
    if (A.x >= f && A.x <= g && A.y >= _ && A.y <= m && A !== s && A !== n && os(a, c, o, u, l, d, A.x, A.y) && rt(A.prev, A, A.next) >= 0) return !1;
    A = A.prevZ;
  }
  for (; T && T.z <= x; ) {
    if (T.x >= f && T.x <= g && T.y >= _ && T.y <= m && T !== s && T !== n && os(a, c, o, u, l, d, T.x, T.y) && rt(T.prev, T, T.next) >= 0) return !1;
    T = T.nextZ;
  }
  return !0;
}
function sf(h, e) {
  let t = h;
  do {
    const i = t.prev, s = t.next.next;
    !Ur(i, s) && Do(i, t, t.next, s) && Hs(i, s) && Hs(s, i) && (e.push(i.i, t.i, s.i), Ks(t), Ks(t.next), t = h = s), t = t.next;
  } while (t !== h);
  return $i(t);
}
function rf(h, e, t, i, s, r) {
  let n = h;
  do {
    let a = n.next.next;
    for (; a !== n.prev; ) {
      if (n.i !== a.i && ff(n, a)) {
        let o = wo(n, a);
        n = $i(n, n.next), o = $i(o, o.next), Xs(n, e, t, i, s, r, 0), Xs(o, e, t, i, s, r, 0);
        return;
      }
      a = a.next;
    }
    n = n.next;
  } while (n !== h);
}
function nf(h, e, t, i) {
  const s = [];
  for (let r = 0, n = e.length; r < n; r++) {
    const a = e[r] * i, o = r < n - 1 ? e[r + 1] * i : h.length, l = Co(h, a, o, i, !1);
    l === l.next && (l.steiner = !0), s.push(df(l));
  }
  s.sort(af);
  for (let r = 0; r < s.length; r++)
    t = of(s[r], t);
  return t;
}
function af(h, e) {
  return h.x - e.x;
}
function of(h, e) {
  const t = lf(h, e);
  if (!t)
    return e;
  const i = wo(t, h);
  return $i(i, i.next), $i(t, t.next);
}
function lf(h, e) {
  let t = e;
  const i = h.x, s = h.y;
  let r = -1 / 0, n;
  do {
    if (s <= t.y && s >= t.next.y && t.next.y !== t.y) {
      const u = t.x + (s - t.y) * (t.next.x - t.x) / (t.next.y - t.y);
      if (u <= i && u > r && (r = u, n = t.x < t.next.x ? t : t.next, u === i))
        return n;
    }
    t = t.next;
  } while (t !== e);
  if (!n) return null;
  const a = n, o = n.x, l = n.y;
  let c = 1 / 0;
  t = n;
  do {
    if (i >= t.x && t.x >= o && i !== t.x && os(s < l ? i : r, s, o, l, s < l ? r : i, s, t.x, t.y)) {
      const u = Math.abs(s - t.y) / (i - t.x);
      Hs(t, h) && (u < c || u === c && (t.x > n.x || t.x === n.x && hf(n, t))) && (n = t, c = u);
    }
    t = t.next;
  } while (t !== a);
  return n;
}
function hf(h, e) {
  return rt(h.prev, h, e.prev) < 0 && rt(e.next, h, h.next) < 0;
}
function cf(h, e, t, i) {
  let s = h;
  do
    s.z === 0 && (s.z = yn(s.x, s.y, e, t, i)), s.prevZ = s.prev, s.nextZ = s.next, s = s.next;
  while (s !== h);
  s.prevZ.nextZ = null, s.prevZ = null, uf(s);
}
function uf(h) {
  let e, t = 1;
  do {
    let i = h, s;
    h = null;
    let r = null;
    for (e = 0; i; ) {
      e++;
      let n = i, a = 0;
      for (let l = 0; l < t && (a++, n = n.nextZ, !!n); l++)
        ;
      let o = t;
      for (; a > 0 || o > 0 && n; )
        a !== 0 && (o === 0 || !n || i.z <= n.z) ? (s = i, i = i.nextZ, a--) : (s = n, n = n.nextZ, o--), r ? r.nextZ = s : h = s, s.prevZ = r, r = s;
      i = n;
    }
    r.nextZ = null, t *= 2;
  } while (e > 1);
  return h;
}
function yn(h, e, t, i, s) {
  return h = (h - t) * s | 0, e = (e - i) * s | 0, h = (h | h << 8) & 16711935, h = (h | h << 4) & 252645135, h = (h | h << 2) & 858993459, h = (h | h << 1) & 1431655765, e = (e | e << 8) & 16711935, e = (e | e << 4) & 252645135, e = (e | e << 2) & 858993459, e = (e | e << 1) & 1431655765, h | e << 1;
}
function df(h) {
  let e = h, t = h;
  do
    (e.x < t.x || e.x === t.x && e.y < t.y) && (t = e), e = e.next;
  while (e !== h);
  return t;
}
function os(h, e, t, i, s, r, n, a) {
  return (s - n) * (e - a) >= (h - n) * (r - a) && (h - n) * (i - a) >= (t - n) * (e - a) && (t - n) * (r - a) >= (s - n) * (i - a);
}
function ff(h, e) {
  return h.next.i !== e.i && h.prev.i !== e.i && !_f(h, e) && // dones't intersect other edges
  (Hs(h, e) && Hs(e, h) && pf(h, e) && // locally visible
  (rt(h.prev, h, e.prev) || rt(h, e.prev, e)) || // does not create opposite-facing sectors
  Ur(h, e) && rt(h.prev, h, h.next) > 0 && rt(e.prev, e, e.next) > 0);
}
function rt(h, e, t) {
  return (e.y - h.y) * (t.x - e.x) - (e.x - h.x) * (t.y - e.y);
}
function Ur(h, e) {
  return h.x === e.x && h.y === e.y;
}
function Do(h, e, t, i) {
  const s = cr(rt(h, e, t)), r = cr(rt(h, e, i)), n = cr(rt(t, i, h)), a = cr(rt(t, i, e));
  return !!(s !== r && n !== a || s === 0 && hr(h, t, e) || r === 0 && hr(h, i, e) || n === 0 && hr(t, h, i) || a === 0 && hr(t, e, i));
}
function hr(h, e, t) {
  return e.x <= Math.max(h.x, t.x) && e.x >= Math.min(h.x, t.x) && e.y <= Math.max(h.y, t.y) && e.y >= Math.min(h.y, t.y);
}
function cr(h) {
  return h > 0 ? 1 : h < 0 ? -1 : 0;
}
function _f(h, e) {
  let t = h;
  do {
    if (t.i !== h.i && t.next.i !== h.i && t.i !== e.i && t.next.i !== e.i && Do(t, t.next, h, e)) return !0;
    t = t.next;
  } while (t !== h);
  return !1;
}
function Hs(h, e) {
  return rt(h.prev, h, h.next) < 0 ? rt(h, e, h.next) >= 0 && rt(h, h.prev, e) >= 0 : rt(h, e, h.prev) < 0 || rt(h, h.next, e) < 0;
}
function pf(h, e) {
  let t = h, i = !1;
  const s = (h.x + e.x) / 2, r = (h.y + e.y) / 2;
  do
    t.y > r != t.next.y > r && t.next.y !== t.y && s < (t.next.x - t.x) * (r - t.y) / (t.next.y - t.y) + t.x && (i = !i), t = t.next;
  while (t !== h);
  return i;
}
function wo(h, e) {
  const t = vn(h.i, h.x, h.y), i = vn(e.i, e.x, e.y), s = h.next, r = e.prev;
  return h.next = e, e.prev = h, t.next = s, s.prev = t, i.next = t, t.prev = i, r.next = i, i.prev = r, i;
}
function Ma(h, e, t, i) {
  const s = vn(h, e, t);
  return i ? (s.next = i.next, s.prev = i, i.next.prev = s, i.next = s) : (s.prev = s, s.next = s), s;
}
function Ks(h) {
  h.next.prev = h.prev, h.prev.next = h.next, h.prevZ && (h.prevZ.nextZ = h.nextZ), h.nextZ && (h.nextZ.prevZ = h.prevZ);
}
function vn(h, e, t) {
  return {
    i: h,
    // vertex index in coordinates array
    x: e,
    y: t,
    // vertex coordinates
    prev: null,
    // previous and next vertex nodes in a polygon ring
    next: null,
    z: 0,
    // z-order curve value
    prevZ: null,
    // previous and next nodes in z-order
    nextZ: null,
    steiner: !1
    // indicates whether this is a steiner point
  };
}
function gf(h, e, t, i) {
  let s = 0;
  for (let r = e, n = t - i; r < t; r += i)
    s += (h[n] - h[r]) * (h[r + 1] + h[n + 1]), n = r;
  return s;
}
const As = Math.PI, Qi = Math.PI / 2, xn = [];
function Oo() {
  for (const h of xn)
    h();
  xn.length = 0;
}
function mf(h) {
  Oo();
  const { n: e, e: t, s: i, w: s } = h, r = Es("SE", { radius: 1, tessellation: 64, arc: 0.25 }, xe);
  r.rotation.x = As, r.scaling.x = i, r.scaling.y = s;
  const n = Es("SE", { radius: 1, tessellation: 64, arc: 0.25 }, xe);
  n.rotation.x = As, n.rotate(Et.Z, As), n.scaling.x = e, n.scaling.y = t;
  const a = Es("SE", { radius: 1, tessellation: 64, arc: 0.25 }, xe);
  a.rotation.x = As, a.rotate(Et.Z, 3 * Qi), a.scaling.x = t, a.scaling.y = i;
  const o = Es("SE", { radius: 1, tessellation: 64, arc: 0.25 }, xe);
  o.rotation.x = Math.PI, o.rotate(Et.Z, Qi), o.scaling.x = s, o.scaling.y = e;
  const l = new V("groundMat", xe);
  l.diffuseColor = ie.FromInts(136, 193, 62), l.specularColor = ie.BlackReadOnly, n.material = o.material = a.material = r.material = l;
  const c = po("pitch", { width: 3.05, height: 22 }, xe);
  c.rotation.x = As, c.rotate(Et.Z, Qi);
  const u = new V("pitchMat", xe);
  u.diffuseColor = ie.FromInts(194, 178, 128), u.specularColor = ie.BlackReadOnly, c.material = u, c.renderingGroupId = 1;
  const d = yf(xe), f = bf(xe);
  Hi = f, xn.push(() => {
    n.dispose(), a.dispose(), r.dispose(), o.dispose(), d.dispose(), f.dispose(), Hi = void 0, c.dispose(), l.dispose(), u.dispose();
  });
}
function yf(h) {
  let i = [];
  const s = Nt.ArcThru3Points(new p(10.0584, 0, 30), new p(40.0584, 0, 0), new p(10.0584, 0, -30));
  i = i.concat(s.getPoints()), i.push(
    new p(10.0584, 0, 30),
    new p(10.0584, 0, -30),
    new p(-10.0584, 0, -30),
    new p(-10.0584, 0, 30)
  );
  const r = Nt.ArcThru3Points(new p(-10.0584, 0, -30), new p(-30 - 10.0584, 0, 0), new p(-10.0584, 0, 30));
  i = i.concat(r.getPoints());
  const n = 30 - 0.2, a = 10.0584;
  let o = [];
  const l = Nt.ArcThru3Points(new p(a, 0, n), new p(n + a, 0, 0), new p(a, 0, -n));
  o = o.concat(l.getPoints()), o.push(
    new p(a, 0, n),
    new p(a, 0, -n),
    new p(-a, 0, -n),
    new p(-a, 0, n)
  );
  const c = Nt.ArcThru3Points(new p(-a, 0, -n), new p(-n - a, 0, 0), new p(-a, 0, n));
  o = o.concat(c.getPoints());
  const u = wr("circle30m", {
    shape: i,
    holes: [o],
    sideOrientation: K.FRONTSIDE
  }, h, Po);
  return u.rotation.x = Math.PI / 2, u.renderingGroupId = 1, u;
}
const Fo = U.FromEulerAngles(Qi, 0, 0).multiplyInPlace(
  U.FromEulerAngles(0, -Qi, 0)
), vf = U.FromEulerAngles(Qi, 0, 0).multiplyInPlace(
  U.FromEulerAngles(0, Qi, 0)
);
let Hi;
function xf(h) {
  Hi && (h === "N" ? (Hi.position.x = 20, Hi.rotationQuaternion = Fo) : (Hi.position.x = -20, Hi.rotationQuaternion = vf));
}
function bf(h) {
  const e = [
    new p(0.5, 0, -8),
    new p(0.5, 0, 0),
    new p(1, 0, 0),
    new p(0, 0, 4),
    new p(-1, 0, 0),
    new p(-0.5, 0, 0),
    new p(-0.5, 0, -8)
  ], t = wr("circle30m", {
    shape: e,
    sideOrientation: K.FRONTSIDE
  }, h, Po);
  return t.rotationQuaternion = Fo, t.position.x = 20, t.renderingGroupId = 1, t;
}
const ee = [];
let yr;
const Ys = [];
function Tf() {
  for (const h of Ys)
    h();
  Ys.length = 0;
}
function Af() {
  function h(e) {
    switch (ee.length) {
      case 0: {
        ee.push(An), ee.push(e);
        break;
      }
      case 2: {
        const t = p.Lerp(ee[0], ee[1], 0.5);
        t.z = t.length(), ee.push(t);
        break;
      }
      case 3: {
        const t = p.Distance(ee[1], e), s = ee[1].subtract(ee[0]).normalize().scaleInPlace(t).addInPlace(ee[1]);
        ee.push(s);
        break;
      }
      default: {
        ee.length = 0;
        break;
      }
    }
    Tn(), Os();
  }
  xe.onPointerObservable.add((e) => {
    if (e.event.shiftKey) {
      const t = ir();
      if (!t) return;
      h(t);
      return;
    }
  }, $.POINTERTAP), Ef(), If(), Ys.push(() => {
    Lo(), ee.length = 0;
  });
}
function Lo() {
  yr && (yr.dispose(), yr = void 0);
}
function Os() {
  if (Lo(), ee.length === 2)
    var h = [ee];
  else if (ee.length === 3) {
    const e = new p(ee[2].x, ee[2].y, ee[2].z * 2);
    var h = [Nt.CreateQuadraticBezier(ee[0], e, ee[1], 100).getPoints()];
  } else if (ee.length === 4) {
    const e = new p(ee[2].x, ee[2].y, ee[2].z * 2), t = Nt.CreateQuadraticBezier(ee[0], e, ee[1], 100), i = p.Lerp(ee[1], ee[3], 0.3), s = p.Lerp(ee[1], i, 0.5);
    s.z = Math.min(e.z / 8, p.Distance(s, i));
    const r = Nt.CreateQuadraticBezier(ee[1], s, i, 50);
    var h = [t.getPoints(), r.getPoints(), [i, ee[3]]];
  }
  if (ee.length > 0) {
    const e = h.map(() => ie.Blue()), t = new mn("MeasureLine", xe, h, e, { ownMaterial: !0 });
    t.setAllSolid(), t.updateTextureData(), t.renderingGroupId = 2, yr = t;
  }
  Mf(), Pf();
}
let ti = [];
function Ef() {
  const h = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII=", e = new Ti("handles", h, 3, 1, xe);
  e.renderingGroupId = 3, e.isPickable = !0;
  const t = new _s("arc", e), i = new _s("mid", e), s = new _s("end", e);
  ti.push(t, i, s);
  for (const S of ti)
    S.isPickable = !0, S.isVisible = !1, S.color = new ye(0, 0, 0, 0.5);
  const r = xe.activeCamera;
  xe.onBeforeRenderObservable.add(() => {
    const S = r.position;
    for (let P of ti) {
      const D = p.Distance(S, P.position);
      P.width = P.height = D * 0.05;
    }
  });
  let n;
  xe.onPointerObservable.add((S) => {
    x(!1);
    const P = xe.pickSprite(
      xe.pointerX,
      xe.pointerY,
      (D) => D.isPickable && D.isVisible
    );
    if (P.hit) {
      const D = P.pickedSprite;
      switch (n = P.pickedSprite.name, zd(!1), b = !0, en("grabbing"), n) {
        case "arc": {
          o = Dt.FromPositionAndNormal(D.position.clone(), Et.X.clone()), xe.onPointerObservable.add(c, $.POINTERMOVE), xe.onPointerObservable.add(u, $.POINTERUP);
          break;
        }
        case "mid": {
          o = Dt.FromPositionAndNormal(p.Zero(), Et.Z.clone()), xe.onPointerObservable.add(f, $.POINTERMOVE), xe.onPointerObservable.add(_, $.POINTERUP);
          break;
        }
        case "end": {
          o = Dt.FromPositionAndNormal(p.Zero(), Et.Z.clone()), xe.onPointerObservable.add(m, $.POINTERMOVE), xe.onPointerObservable.add(y, $.POINTERUP);
          break;
        }
      }
    }
  }, $.POINTERDOWN);
  const a = new Ae(p.Zero(), Et.Z.clone());
  let o;
  const l = () => {
    const S = $r(xe, o, a);
    S !== null && (ee[2].z = Math.max(0, S.z), Os());
  }, c = () => {
    A = !0, fi(at);
  }, u = () => {
    l(), x();
  }, d = () => {
    const S = $r(xe, o, a);
    if (S !== null) {
      if (ee.length < 4) {
        if (S.subtract(ee[0]).length() > 200) return;
        ee[1].copyFrom(S);
      } else {
        const P = ee[3].subtract(ee[0]), D = P.length(), O = S.subtract(ee[0]), X = P.normalize();
        let k = p.Dot(O, X);
        k < 0 && (k = 0), k > D - 0.1 && (k = D - 0.1);
        const Y = X.scaleInPlace(k);
        ee[1] = Y.addInPlace(ee[0]);
      }
      if (ee[2]) {
        const P = p.Lerp(ee[0], ee[1], 0.5);
        P.z = ee[2].z, ee[2] = P;
      }
      Os();
    }
  }, f = () => {
    T = !0, fi(at);
  }, _ = () => {
    d(), x();
  }, g = () => {
    const S = $r(xe, o, a);
    if (S === null || S.length() > 200) return;
    const D = ee[3].subtract(ee[0]).length(), X = ee[1].subtract(ee[0]).length() / D;
    ee[3].copyFrom(S);
    const k = p.Lerp(ee[0], ee[3], X);
    ee[1] = k;
    const Y = p.Lerp(ee[0], ee[1], 0.5);
    Y.z = ee[2].z, ee[2] = Y, Os();
  }, m = () => {
    M = !0, fi(at);
  }, y = () => {
    g(), x();
  }, x = (S = !0) => {
    A = T = M = !1, xe.onPointerObservable.removeCallback(c), xe.onPointerObservable.removeCallback(u), xe.onPointerObservable.removeCallback(f), xe.onPointerObservable.removeCallback(_), xe.onPointerObservable.removeCallback(m), xe.onPointerObservable.removeCallback(y), S && Gd(), b = !1, Tn(), fi(at);
  };
  let A = !1, T = !1, M = !1, b = !1;
  xe.onPointerObservable.add((S) => {
    b || Tn();
  }, $.POINTERMOVE), bn = () => {
    if (Fs = 1 / 0, b) return;
    xe.pickSprite(
      xe.pointerX,
      xe.pointerY,
      (P) => P.isPickable && P.isVisible
    ).hit ? en("pointer") : en("");
  }, xe.onBeforeRenderObservable.add(() => {
    A ? l() : T ? d() : M && g();
  }, void 0, !0), Ys.push(() => {
    x(!1), cancelAnimationFrame(Fs), Fs = 1 / 0, bn = void 0, e.dispose(), ti.length = 0;
  });
}
let Fs = 1 / 0, bn;
function Tn() {
  Fs === 1 / 0 && (Fs = requestAnimationFrame(bn));
}
function en(h) {
  xe.defaultCursor = h, at._renderingCanvas.style.cursor = xe.defaultCursor;
}
function Mf() {
  for (const h of ti)
    h.isVisible = !1;
  switch (ee.length) {
    case 0:
      break;
    case 4:
      ti[2].position.copyFrom(ee[3]), ti[2].isVisible = !0;
    case 3:
      ti[0].position.copyFrom(ee[2]), ti[0].isVisible = !0;
    case 2: {
      ti[1].position.copyFrom(ee[1]), ti[1].isVisible = !0;
      break;
    }
    default:
      return;
  }
}
let No = new p(-11 * 0.9144, 0, 0), Sf = new p(11 * 0.9144, 0, 0), An = No;
function Rf(h) {
  if (An = h === "N" ? No : Sf, xf(h), ee[0]) {
    if (ee[0] = An, ee[2]) {
      const e = p.Lerp(ee[0], ee[1], 0.5);
      e.z = ee[2].z, ee[2] = e;
    }
    Os();
  }
}
let vr, En;
function If() {
  const h = document.createElement("template");
  h.innerHTML = /*html*/
  `
        <div style="position:absolute;top:0;color:white;display:grid;grid-template-columns: auto auto; gap: 0 1em; margin-left: 0.5em; margin-top: 0.5em;">
            <div>Height:</div>
            <div id="__arcHeight">0</div>
            <div>Distance:</div>
            <div id="__shotDist">0</div>
        </div>
    `, at.getRenderingCanvas().parentElement.appendChild(h.content), vr = document.getElementById("__arcHeight"), En = document.getElementById("__shotDist"), Ys.push(() => {
    vr.parentElement.remove(), vr = void 0, En = void 0;
  });
}
function Pf() {
  vr.textContent = ee.length > 2 ? ee[2].z.toFixed(0) : "0", En.textContent = ee.length < 2 ? "0" : ee.length === 4 ? ee[3].subtract(ee[0]).length().toFixed(0) : ee[1].subtract(ee[0]).length().toFixed(0);
}
class Cf extends Ke {
  constructor(t, i, s, r, n, a) {
    super(t, i, s, r, n, a);
    _e(this, "_is3d", !1);
    _e(this, "_pRadius", 0);
    _e(this, "oAlpha");
    _e(this, "oBeta");
    _e(this, "oUpperAlphaLimit");
    _e(this, "oLowerAlphaLimit");
    _e(this, "oUpperBetaLimit");
    _e(this, "oLowerBetaLimit");
    _e(this, "oInertialAlphaOffset");
    _e(this, "oInertialBetaOffset");
    _e(this, "softLowerRadiusLimit", 0);
    _e(this, "hardMinZLimit");
    /** vec4(minX, minY, maxX, maxY)  */
    _e(this, "panningLimits");
    /** Four vec2s, that describe the outline of an area to soft limit panning to. */
    _e(this, "onMoveEndObservable", new N());
    _e(this, "onStrictMoveStartObservable", new N());
    _e(this, "onStrictMoveEndObservable", new N());
    _e(this, "onBeforeCheckInputsWhileMovingObservable", new N());
    _e(this, "onAfterCheckInputsWhileMovingObservable", new N());
    _e(this, "onCameraJumpObservable", new N());
    _e(this, "onMarkedDirtyObservable", new N());
    _e(this, "currentlyMoving");
    _e(this, "currentlyMovingStrict");
    /** Multiple of Epsilon at which point inertial panning X & Y are bumped down to zero at an accelerated rate */
    _e(this, "panningCutOffMultiplier", 1);
    /** Multiple of Epsilon at which point inertial alpha & beta are set to 0 */
    _e(this, "abCutOffMultiplier", 1);
    /** Multiple of Epsilon at which point orbital inertial alpha & beta are set to 0 */
    _e(this, "oabCutOffMultiplier", 1);
    _e(this, "_dirtyObservable", !1);
    _e(this, "_previousState", {
      alpha: NaN,
      beta: NaN,
      radius: NaN,
      target: new p()
    });
    this.oUpperAlphaLimit = 1 / 0, this.oLowerAlphaLimit = -1 / 0, this.oUpperBetaLimit = Math.PI / 2 - 0.5, this.oLowerBetaLimit = 0.01, this.oAlpha = 0, this.oBeta = 0, this.oInertialAlphaOffset = 0, this.oInertialBetaOffset = 0, this.currentlyMoving = !1, this.currentlyMovingStrict = !1, this.hardMinZLimit = 1, a.onBeforeRenderTargetsRenderObservable.add(() => {
    }), this._reset = () => {
      this.reset();
    };
  }
  /** Call to notify the observers of the dirty observable that the camera needs to render.  
   *  Will only fire notify observers once per frame, and is reset in the ```_checkInputs()``` method.  
   *  Primarily for use where the scene is not constantly rendering.  
   *  The other option here was to only set camera properties through a proxy object, but this seemed cleaner.
   */
  markInputsDirty() {
    this._dirtyObservable || (this.onMarkedDirtyObservable.notifyObservers(this), this._dirtyObservable = !0);
  }
  reset() {
    this.inertialAlphaOffset = 0, this.inertialBetaOffset = 0, this.inertialRadiusOffset = 0, this.inertialPanningX = 0, this.inertialPanningY = 0, this.oInertialAlphaOffset = 0, this.oInertialBetaOffset = 0;
  }
  makePlanetary(t) {
    this._is3d = !0, this._pRadius = t, this.oAlpha = 0, this.oBeta = 0, this.upperBetaLimit = Math.PI - 0.01, this.lowerRadiusLimit = t + 3, this._getViewMatrix();
  }
  makePlanar() {
    this._is3d = !1, this.upVector = Et.Y, this.upperBetaLimit = 1, this.lowerRadiusLimit = 3, this._getViewMatrix();
  }
  setTarget(t) {
    this.target.copyFrom(t);
  }
  _getViewMatrix() {
    let t = Math.cos(this.alpha), i = Math.sin(this.alpha), s = Math.cos(this.beta), r = Math.sin(this.beta);
    r === 0 && (r = 1e-4);
    let n = this._getTargetPosition();
    const a = this._computationVector;
    let o;
    if (this._is3d) {
      o = new p(this._pRadius * t * r, this._pRadius * s, this._pRadius * i * r), n.copyFrom(o);
      const l = this.radius - this._pRadius;
      t = Math.cos(this.oAlpha + this.alpha), i = Math.sin(this.oAlpha + this.alpha), s = Math.cos(this.oBeta), r = Math.sin(this.oBeta), r = r === 0 ? 1e-4 : r, a.copyFromFloats(l * t * r, l * s, l * i * r), this.upVector = n.clone().normalize();
    } else
      a.copyFromFloats(this.radius * t * r, this.radius * s, this.radius * i * r);
    if ((this._upVector.x !== 0 || this._upVector.y !== 1 || this._upVector.z !== 0) && p.TransformCoordinatesToRef(a, this._yToUpMatrix, a), n.addToRef(a, this._newPosition), this.getScene().collisionsEnabled && this.checkCollisions)
      console.error("Not implemented");
    else {
      this.position.copyFrom(this._newPosition);
      let l = this.upVector;
      this.allowUpsideDown && r < 0 && (l = l.clone(), l = l.negate()), this._computeViewMatrix(this.position, n, l), this._viewMatrix.m[12] += this.targetScreenOffset.x, this._viewMatrix.m[13] += this.targetScreenOffset.y;
    }
    return this._currentTarget = n, this._viewMatrix;
  }
  // from http://www.iquilezles.org/www/articles/noacos/noacos.htm
  /** Takes normalised vectors and returns a rotation matrix to align "from" with "to" */
  rotationAlignToRef(t, i, s) {
    const r = p.Cross(i, t), n = p.Dot(i, t), a = 1 / (1 + n), o = s._m;
    return o[0] = r.x * r.x * a + n, o[1] = r.y * r.x * a - r.z, o[2] = r.z * r.x * a + r.y, o[3] = 0, o[4] = r.x * r.y * a + r.z, o[5] = r.y * r.y * a + n, o[6] = r.z * r.y * a - r.x, o[7] = 0, o[8] = r.x * r.z * a - r.y, o[9] = r.y * r.z * a + r.x, o[10] = r.z * r.z * a + n, o[11] = 0, o[12] = 0, o[13] = 0, o[14] = 0, o[15] = 1, s;
  }
  _isSynchronizedViewMatrix() {
    return super._isSynchronizedViewMatrix() ? this._cache.oAlpha === this.oAlpha && this._cache.oBeta === this.oBeta && this._cache.pRadius === this._pRadius : !1;
  }
  _initCache() {
    super._initCache(), this._cache.oAlpha = void 0, this._cache.oBeta = void 0, this._cache.pRadius = void 0, this._cache._vecCache = p.Zero();
  }
  _updateCache(t) {
    t || super._updateCache(), this._cache.oAlpha = this.oAlpha, this._cache.oBeta = this.oBeta, this._cache.pRadius = this._pRadius;
  }
  _checkInputs() {
    if (this._dirtyObservable = !1, this._collisionTriggered)
      return;
    const t = this.currentlyMovingStrict;
    if (this._checkMoveStartEndStrict(), (this.currentlyMovingStrict || t) && this.onBeforeCheckInputsWhileMovingObservable.notifyObservers(this), this.inputs.checkInputs(), (this.inertialAlphaOffset !== 0 || this.inertialBetaOffset !== 0) && (this.getScene().useRightHandedSystem ? this.alpha -= this.beta <= 0 ? -this.inertialAlphaOffset : this.inertialAlphaOffset : this.alpha += this.beta <= 0 ? -this.inertialAlphaOffset : this.inertialAlphaOffset, this.beta += this.inertialBetaOffset, this.inertialAlphaOffset *= this.inertia, this.inertialBetaOffset *= this.inertia, Math.abs(this.inertialAlphaOffset) < pe * this.abCutOffMultiplier && (this.inertialAlphaOffset = 0), Math.abs(this.inertialBetaOffset) < pe * this.abCutOffMultiplier && (this.inertialBetaOffset = 0)), (this.oInertialAlphaOffset !== 0 || this.oInertialBetaOffset !== 0) && (this.getScene().useRightHandedSystem ? this.oAlpha -= this.oBeta <= 0 ? -this.oInertialAlphaOffset : this.oInertialAlphaOffset : this.oAlpha += this.oBeta <= 0 ? -this.oInertialAlphaOffset : this.oInertialAlphaOffset, this.oBeta += this.oInertialBetaOffset, this.oInertialAlphaOffset *= this.inertia, this.oInertialBetaOffset *= this.inertia, Math.abs(this.oInertialAlphaOffset) < pe * this.oabCutOffMultiplier && (this.oInertialAlphaOffset = 0), Math.abs(this.oInertialBetaOffset) < pe * this.oabCutOffMultiplier && (this.oInertialBetaOffset = 0)), !this._is3d && (this.inertialPanningX !== 0 || this.inertialPanningY !== 0 || this.inertialRadiusOffset !== 0) && (this.panningLimits !== void 0 && (this._cache._vecCache.copyFromFloats(this.inertialPanningX, this.inertialPanningY, 0), this._enforcePanningLimits(this._cache._vecCache)), this.target.x += this.inertialPanningX, this.target.y += this.inertialPanningY, this.radius -= this.inertialRadiusOffset, this.inertialPanningX *= this.inertia, this.inertialPanningY *= this.inertia, this.inertialRadiusOffset *= this.inertia, Math.abs(this.inertialPanningX) < pe * this.panningCutOffMultiplier && Math.abs(this.inertialPanningY) < pe * this.panningCutOffMultiplier)) {
      const i = this.inertialPanningX / (1 - this.inertia), s = this.inertialPanningY / (1 - this.inertia), r = this.inertialRadiusOffset / (1 - this.inertia), n = i < 0 ? -1 : 1, a = s < 0 ? -1 : 1, o = r < 0 ? -1 : 1, l = i * n, c = s * a, u = r * o;
      let d = Math.max(l, c, u);
      if (d !== 0) {
        const f = l / d, _ = c / d, g = u / d, m = 0.01 * this.radius / 40, y = Math.min(m * f, l) * n, x = Math.min(m * _, c) * a, A = Math.min(m * g, u) * o;
        this.target.x += y, this.target.y += x, this.radius -= A, this.inertialPanningX = (i - y) * (1 - this.inertia), this.inertialPanningY = (s - x) * (1 - this.inertia), this.inertialRadiusOffset = (r - A) * (1 - this.inertia);
      }
    }
    (this.currentlyMovingStrict || t) && this.onAfterCheckInputsWhileMovingObservable.notifyObservers(this), this._checkLimits(), this._checkMoveStartEnd(), this._checkMoveStartEndStrict();
  }
  _enforcePanningLimits(t) {
    let i = this.target.x + t.x, s = this.target.y + t.y;
    const r = this.panningLimits;
    i < r.x && i < this.target.x ? this.inertialPanningX = 0 : i > r.z && i > this.target.x && (this.inertialPanningX = 0), s < r.y && s < this.target.y ? this.inertialPanningY = 0 : s > r.w && s > this.target.y && (this.inertialPanningY = 0);
  }
  _checkLimits() {
    super._checkLimits();
    const t = this.oLowerBetaLimit !== null && this.oLowerBetaLimit !== void 0, i = this.oUpperBetaLimit !== null && this.oUpperBetaLimit !== void 0, s = this.oLowerAlphaLimit !== null && this.oLowerAlphaLimit !== void 0, r = this.oUpperAlphaLimit !== null && this.oUpperAlphaLimit !== void 0;
    t && this.oBeta < this.oLowerBetaLimit && (this.oBeta = this.oLowerBetaLimit), i && this.oBeta > this.oUpperBetaLimit && (this.oBeta = this.oUpperBetaLimit), s && this.alpha < this.oLowerAlphaLimit && (this.oAlpha = this.oLowerAlphaLimit), r && this.oAlpha > this.oUpperAlphaLimit && (this.oAlpha = this.oUpperAlphaLimit);
  }
  cameraJumped() {
    this.onCameraJumpObservable.notifyObservers(this);
  }
  _checkMoveStartEnd(t = !1) {
    const i = (this._is3d ? this.radius - this._pRadius : this.radius) * 1e-3, s = 2, r = 2e-5;
    !this.currentlyMoving && (Math.abs(this.inertialPanningX) > i || Math.abs(this.inertialPanningY) > i || Math.abs(this.inertialRadiusOffset) > s || Math.abs(this.inertialAlphaOffset) > r || Math.abs(this.inertialBetaOffset) > r || Math.abs(this.oInertialAlphaOffset) > r || Math.abs(this.oInertialBetaOffset) > r) && (this.currentlyMoving = !0), this.currentlyMoving && Math.abs(this.inertialPanningX) < i && Math.abs(this.inertialPanningY) < i && Math.abs(this.inertialRadiusOffset) < s && Math.abs(this.inertialAlphaOffset) < r && Math.abs(this.inertialBetaOffset) < r && Math.abs(this.oInertialAlphaOffset) < r && Math.abs(this.oInertialBetaOffset) < r && (this.currentlyMoving = !1, this.onMoveEndObservable.notifyObservers(this));
  }
  _checkMoveStartEndStrict() {
    const t = this.inertialPanningX || this.inertialPanningY || this.inertialRadiusOffset || this.inertialAlphaOffset || Math.abs(this.inertialBetaOffset) || this.oInertialAlphaOffset || Math.abs(this.oInertialBetaOffset);
    !this.currentlyMovingStrict && t && (this.currentlyMovingStrict = !0, this.onStrictMoveStartObservable.notifyObservers(this)), this.currentlyMovingStrict && !t && (this.currentlyMovingStrict = !1, this.onStrictMoveEndObservable.notifyObservers(this));
  }
}
function Df(h, e) {
  let t = -1, i = 0;
  return function() {
    const s = this, r = arguments, n = Date.now();
    clearTimeout(t);
    const a = e - (n - i);
    if (a <= 0)
      h.apply(s, r), i = n;
    else {
      const o = function() {
        i = Date.now(), h.apply(s, r);
      };
      t = window.setTimeout(o, a);
    }
  };
}
function wf(h) {
  const e = document.createElement("div");
  e.id = "canvasContainer", e.style.width = "100%", e.style.height = "100%", e.style.position = "relative", e.style.overflow = "hidden";
  const t = document.createElement("canvas");
  t.id = "renderCanvas", t.setAttribute("touch-action", "none"), t.style.height = "100%", t.style.width = "100%", t.tabIndex = 0, e.appendChild(t), h.appendChild(e);
  let i = screen.width, s = screen.height, r = Math.max(i, s);
  const a = { disableWebGL2Support: !1, limitDeviceRatio: Math.max(1280 / r, 1.3), stencil: !0 }, o = new L(t, !0, a, !0), l = new ge(o);
  l.autoClear = !0, l.autoClearDepthAndStencil = !1, l.useRightHandedSystem = !0;
  const c = new Cf("cam", 0, 0.7, 220, p.Zero(), l);
  c.panningLimits = new ze(-100, -100, 100, 100), c.upperRadiusLimit = 600, c.panningCutOffMultiplier = 64, c.upVector = Et.Z.clone(), c.lowerRadiusLimit = 0.01, c.upperBetaLimit = Math.PI / 2 - 0.3, l.skipPointerDownPicking = !0, l.skipPointerMovePicking = !0, l.skipPointerUpPicking = !0, Nd(c, l, o), l.onBeforeRenderObservable.add(() => {
    c.wheelPrecision = 1 / c.radius * 500, c.panningSensibility = 1 / c.radius * 1e3;
  });
  var u = new Br("hLight", new p(0, 0, 1), l);
  u.intensity = 1, l.preventDefaultOnPointerDown = !1, l.getEngine().enableOfflineSupport = !1, l.disableOfflineSupportExceptionRules = [];
  const d = Of.bind(void 0, o, t);
  return window.addEventListener("resize", Df(d, 15)), setInterval(d, 500), [l, o];
}
function Of(h, e) {
  const t = h.getHardwareScalingLevel(), i = e.clientWidth / t | 0, s = e.clientHeight / t | 0;
  (i !== e.width || s !== e.height) && i > 10 && s > 10 && h.resize();
}
function Ff() {
  const e = at.getRenderingCanvas().parentElement;
  Oo(), Tf(), at.dispose(), e.remove();
}
let Mn = !0;
function Lf(h, e = {
  n: 70,
  e: 70,
  s: 70,
  w: 70
}, t = !1) {
  Mn && console.warn("Can't initialise already initialised viewer");
  const [i, s] = wf(h);
  Hd(i), Kd(s), Sa(e), Mn = !0, t && (window.viewer = {
    setData: Bf,
    setBoundaries: Sa,
    disposeViewer: Nf,
    initialiseViewer: Lf,
    scene: i,
    cam: i.activeCamera
  }), wd(i), Af();
}
function Nf() {
  Ff(), Mn = !1;
}
function Sa(h) {
  mf(h);
}
function Bf(h, e) {
  Rf(h);
}
export {
  Nf as disposeViewer,
  Lf as initialiseViewer,
  Sa as setBoundaries,
  Bf as setData
};
